
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8ZIj6", function(module, exports) {
$parcel$export(module.exports, "ConfigurableChildIssuesPanelWithEntryPoint", () => $553a96af1d8115e5$export$4bfb54bbc3bb5cd1);

var $1SWVv = parcelRequire("1SWVv");

var $7EAmY = parcelRequire("7EAmY");

var $4DSIX = parcelRequire("4DSIX");

var $bipQa = parcelRequire("bipQa");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $arvNk = parcelRequire("arvNk");

var $iiRWr = parcelRequire("iiRWr");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $iS1VO = parcelRequire("iS1VO");

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $bmoS1 = parcelRequire("bmoS1");

var $cFxTI = parcelRequire("cFxTI");

var $ibQsy = parcelRequire("ibQsy");

var $bJscI = parcelRequire("bJscI");

var $8c3Yt = parcelRequire("8c3Yt");


var $PETi0 = parcelRequire("PETi0");

var $cs58I = parcelRequire("cs58I");

var $8jOO7 = parcelRequire("8jOO7");

var $3CqQm = parcelRequire("3CqQm");

var $6d9QY = parcelRequire("6d9QY");

var $dyOHn = parcelRequire("dyOHn");

var $j1S2m = parcelRequire("j1S2m");

var $cHtIB = parcelRequire("cHtIB");

var $kh7bJ = parcelRequire("kh7bJ");

var $4cTDP = parcelRequire("4cTDP");

var $kNAZ7 = parcelRequire("kNAZ7");

var $6o2hR = parcelRequire("6o2hR");

var $3sRyW = parcelRequire("3sRyW");

var $4j9Ge = parcelRequire("4j9Ge");

var $iYP2H = parcelRequire("iYP2H");

var $20xMJ = parcelRequire("20xMJ");

var $1B1bw = parcelRequire("1B1bw");

var $cxKOj = parcelRequire("cxKOj");

var $4X4Xr = parcelRequire("4X4Xr");

var $coXKe = parcelRequire("coXKe");

var $8F6GJ = parcelRequire("8F6GJ");

var $a9mo4 = parcelRequire("a9mo4");

var $4U53A = parcelRequire("4U53A");

var $eNZEQ = parcelRequire("eNZEQ");

var $fZChZ = parcelRequire("fZChZ");

var $9huH6 = parcelRequire("9huH6");

var $1ekG6 = parcelRequire("1ekG6");

var $8iUvG = parcelRequire("8iUvG");

var $fdPuf = parcelRequire("fdPuf");

const $553a96af1d8115e5$export$4bfb54bbc3bb5cd1 = ({ props: props, queries: { childIssuesData: childIssuesData } })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $bipQa.default), childIssuesData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($553a96af1d8115e5$export$321a483c0ddbdd37, {
        ...props,
        data: data
    });
};
const $553a96af1d8115e5$export$a29ffc422b978674 = ({ data: data, filterSubtasks: filterSubtasks, rankFieldJql: rankFieldJql, containerWidth: containerWidth, columnPickerRef: columnPickerRef, isHideDoneFilterEnabled: isHideDoneFilterEnabled, projectId: projectId, childIssuesPanelType: childIssuesPanelType })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [reduxHideDone] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$4c9f7f9f8a4000e1));
    const hideDone = (0, $4cTDP.fg)('key-chin-hide-done-relay-migration') || (0, $4cTDP.fg)('relay_migration_children_issues_section') ? isHideDoneFilterEnabled?.toString() ?? 'false' : reduxHideDone;
    const [sortByValueRedux] = (0, $a9mo4.useChildIssuesSortBy)();
    const [sortByValueRelay] = (0, $8F6GJ.useChildIssuesSortBy)();
    const sortByValue = (0, $4cTDP.fg)('relay_migration_children_issues_section') ? sortByValueRelay : sortByValueRedux;
    const [columnNames, setColumnNames] = (0, $eJOHy.useState)([]);
    const [sortDirection, setSortDirection] = (0, $eJOHy.useState)((0, $8jOO7.SORT_ASC));
    const [sortColumn, setSortColumn] = (0, $eJOHy.useState)(rankFieldJql); // using projectId as we aim to use this sorting across all the work items in the project since
    // storing work item level sorting will fill up the storage
    const STORAGE_PREFIX = `${projectId}_${(0, $c32bc4329b87a2e9$export$bea1131dd3bdbd86)}`;
    const { setSortConfig: setSortConfig, getSortConfig: getSortConfig } = (0, $fdPuf.useTableColumnSortConfigsFromLS)(STORAGE_PREFIX);
    const firstUpdate = (0, $eJOHy.useRef)(true);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const dispatch = (0, $dyOHn.useDispatch)();
    const isFullPageIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const containerRef = (0, $eJOHy.useRef)(null);
    const eventHandlers = (0, $1ekG6.useEventHandlers)(issueKey);
    const columnPickerApi = (0, $eJOHy.useRef)(null);
    const [isTableFocused, setIsTableFocused] = (0, $eJOHy.useState)(false);
    const handleTableFocus = (event)=>{
        if (containerRef.current && containerRef.current.contains(event.target)) setIsTableFocused(true);
    };
    const handleTableBlur = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) setIsTableFocused(false);
    };
    const newJQL = (0, $eJOHy.useMemo)(()=>(0, $8iUvG.JQLBuilder)({
            issueKey: issueKey,
            hideDone: hideDone,
            sortColumn: sortColumn,
            sortDirection: sortDirection,
            filterSubtasks: filterSubtasks
        }), [
        issueKey,
        hideDone,
        sortColumn,
        sortDirection,
        filterSubtasks
    ]);
    const queryVariables = (0, $eJOHy.useMemo)(()=>(0, $8iUvG.createConfigurableChildIssuesPanelQueryVariables)({
            cloudId: cloudId,
            jql: newJQL,
            fieldSetIds: columnNames,
            issueKey: issueKey
        }), // Don't update attributes when newJQL changes
    // The refetch is triggered manually and without suspense
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cloudId,
        columnNames,
        issueKey
    ]);
    const [childIssuesPanelData, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $4DSIX.default), data);
    const { data: issueSearchPaginatedData, hasNext: hasNext, hasPrevious: hasPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, loadNext: loadNext, loadPrevious: loadPrevious } = (0, $j4oe4.usePaginationFragment)((0, $7EAmY.default), childIssuesPanelData);
    const { issueByKey: issueByKey, fieldSetViewQueryByProject: fieldSetViewQueryByProject, issueSearch: issueSearchNonPaginated } = childIssuesPanelData.jira;
    const fieldSetViewMetadata = (0, $j4oe4.useFragment)((0, $1SWVv.default), fieldSetViewQueryByProject?.__typename === 'JiraFieldSetView' ? fieldSetViewQueryByProject : null);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        showFlag((0, $8iUvG.onChildIssueLoadErrorFlag));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'loadConfigurableChildIssueTableError',
                packageName: 'jiraIssueViewCommonViews',
                teamName: 'bento'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
    }, [
        showFlag
    ]);
    const issues = (0, $4cTDP.fg)('jira-issue-view-child-issues-panel-pagination') ? issueSearchPaginatedData.jira.issueSearch : issueSearchNonPaginated;
    if (issues?.issueSearchError || fieldSetViewQueryByProject?.__typename === 'QueryError') {
        if (!(0, $4cTDP.fg)('tnt-3111-ttm-error-handling')) onError(new Error('child issue search GET API error'));
        const error = new Error('child issue search GET API error'); // Fire specific analytics for this error scenario
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'childIssueSearchApiError',
                packageName: 'jiraIssueViewCommonViews',
                teamName: 'Team Managed - TNT'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        onError(error);
    }
    const fieldSetViewIdOld = fieldSetViewQueryByProject?.__typename === 'JiraFieldSetView' ? fieldSetViewQueryByProject?.id : null;
    const fieldSetViewId = (0, $4cTDP.fg)('issue-jiv-20390-column-picker-disappearing-fix') ? fieldSetViewMetadata?.id ?? null : fieldSetViewIdOld;
    const fieldSetsOld = fieldSetViewQueryByProject?.__typename === 'JiraFieldSetView' ? fieldSetViewQueryByProject?.fieldSets : null;
    const fieldSets = (0, $4cTDP.fg)('issue-jiv-20390-column-picker-disappearing-fix') ? fieldSetViewMetadata?.fieldSets ?? null : fieldSetsOld;
    const hasDefaultFieldSets = fieldSetViewQueryByProject?.__typename === 'JiraFieldSetView' ? fieldSetViewQueryByProject?.hasDefaultFieldSets : null; /**
                                                                                                                                                       * By default, refetching a Relay refetchable fragment will suspend a component,
                                                                                                                                                       * so we have a hook tied in with the loading state that fetches without suspending
                                                                                                                                                       * and disable interactivity with the old result set. In React 18 the workaround
                                                                                                                                                       * will no longer be needed as any refetch operation inside a transition will not suspend the component.
                                                                                                                                                       */ 
    // TODO: Remove when React18 is here
    const { isLoading: isLoading, refetchWithoutSuspending: refetchWithoutSuspending } = (0, $9huH6.useRefetchWithoutSuspend)({
        defaultVariables: queryVariables,
        refetch: refetch,
        query: (0, $j1S2m.default),
        onError: onError
    });
    const refetchChildIssues = (0, $eJOHy.useCallback)(()=>{
        refetchWithoutSuspending({
            issueSearchInput: {
                jql: newJQL
            }
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        newJQL,
        refetchWithoutSuspending
    ]); /**
                                           * When the JQL changes (except for the first update) then refetch data
                                           */ 
    (0, $eJOHy.useEffect)(()=>{
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        refetchChildIssues();
    }, [
        newJQL,
        refetchChildIssues
    ]);
    const recentlyCreatedIssue = (0, $dyOHn.useSelector)((0, $eNZEQ.getRecentlyCreatedIssue)); // Issue Create
    const previousCreatedIssueKey = (0, $6d9QY.usePrevious)(recentlyCreatedIssue?.issueKey);
    const recentlyLinkedChildIssue = (0, $dyOHn.useSelector)((0, $eNZEQ.getRecentlyLinkedChildIssue)); // Issue Link
    const previousLinkedChildIssueKey = (0, $6d9QY.usePrevious)(recentlyLinkedChildIssue?.issueKey);
    const onRecentlyIssueCreationSuccess = (0, $eJOHy.useCallback)((issue)=>{
        if (issue.usedGlobalCreateDialog || issue.usedAiWorkBreakdown) return;
        const flagId = (0, $jn1Cb.toFlagId)((0, $aXKmr.v4)());
        const issueList = [
            {
                issueId: Number(issue.issueId),
                issueKey: issue.issueKey
            }
        ];
        const issueDiscoveryUrl = (0, $cFxTI.getIssueDiscoveryUrl)(issueList);
        showFlag({
            id: flagId,
            render: (flagProps)=>{
                const successFlagProps = {
                    key: flagProps.key,
                    flagKey: flagProps.key,
                    id: flagId,
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibQsy.default), successFlagProps);
            }
        });
    }, [
        showFlag
    ]); /**
                   * When a newly created/linked child issue is detected, refetch the table
                   * and if the issue is successfully created show a success flag
                   */ 
    (0, $eJOHy.useEffect)(()=>{
        const hasRecentlyCreatedIssue = previousCreatedIssueKey !== recentlyCreatedIssue?.issueKey;
        const hasRecentlyLinkedIssue = previousLinkedChildIssueKey !== recentlyLinkedChildIssue?.issueKey;
        if (hasRecentlyCreatedIssue || hasRecentlyLinkedIssue) {
            if (hasRecentlyCreatedIssue && recentlyCreatedIssue) onRecentlyIssueCreationSuccess(recentlyCreatedIssue);
            refetchChildIssues();
        }
    }, [
        previousCreatedIssueKey,
        previousLinkedChildIssueKey,
        recentlyCreatedIssue?.issueKey,
        recentlyLinkedChildIssue?.issueKey,
        refetchChildIssues,
        onRecentlyIssueCreationSuccess,
        recentlyCreatedIssue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const hasRecentlyCreatedIssue = previousCreatedIssueKey !== recentlyCreatedIssue?.issueKey;
        return ()=>{
            if (isFullPageIssueView && (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate')) {
                if (hasRecentlyCreatedIssue && recentlyCreatedIssue) /*
          		When component unmounts in case of collapsable section
          		we want to set, previousCreatedIssueKey to undefined so that
          		the success toaster does not appear again
          	*/ dispatch((0, $fZChZ.updateRecentCreatedChildIssueOnUnMount)());
            }
        };
    }, [
        previousCreatedIssueKey,
        dispatch,
        recentlyCreatedIssue,
        isFullPageIssueView
    ]); /**
                                                                                       * When the OrderBy value (sortByValue) changes
                                                                                       * then set the sorting accordingly
                                                                                       */ 
    (0, $eJOHy.useEffect)(()=>{
        setSortDirection((0, $8jOO7.SORT_ASC));
        if (!sortByValue || sortByValue === (0, $4X4Xr.SORT_OPTION).RANKING) // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setSortColumn(rankFieldJql);
        else setSortColumn(sortByValue);
    }, [
        sortByValue,
        rankFieldJql
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('preserve_column_sort_configuration')) {
            // the hook retrieves the value from LS
            // if return value !-== null, then we set the newDirection and sortColumn
            const { sortColumnFromLS: sortColumnFromLS, sortDirectionFromLS: sortDirectionFromLS } = getSortConfig();
            if (sortColumnFromLS && sortDirectionFromLS) {
                setSortColumn(sortColumnFromLS);
                setSortDirection(sortDirectionFromLS);
            }
        }
    }, [
        getSortConfig
    ]); /**
                        * Establish context for this panel based on the data
                        */ 
    const hasMultipleIssues = Number(issues?.totalCount ?? 0) > 1;
    const isSimplifiedProject = (0, $dyOHn.useSelector)((0, $4U53A.getIsSimplifiedProject)); // TODO: Remove on cleanup of relay_migration_children_issues_section
    const isChildrenIssuesPanel = (0, $dyOHn.useSelector)((0, $4U53A.getIsChildrenIssuesPanel)); // TODO: Remove on cleanup of relay_migration_children_issues_section
    const isClassicSubtaskPanel = (0, $dyOHn.useSelector)((0, $4U53A.getIsClassicSubtaskPanel)); /**
                                                                        * onSortChange is invoked when the sorting criteria is updated by the user
                                                                        * The issue table will display sorting indicators and tooltips when hovering over a table header (i.e. column name)
                                                                        */ 
    const onSortChange = (0, $eJOHy.useCallback)((field, direction)=>{
        if (direction === (0, $8jOO7.SORT_NONE) && (0, $4cTDP.fg)('jira_child_issues_clear_sorting_fix')) {
            // Resets the sorting to the default sorting
            setSortDirection((0, $8jOO7.SORT_ASC));
            setSortColumn(rankFieldJql);
        } else {
            setSortDirection(direction === (0, $8jOO7.SORT_ASC) ? (0, $8jOO7.SORT_ASC) : (0, $8jOO7.SORT_DESC));
            setSortColumn(field);
        }
        if ((0, $4cTDP.fg)('preserve_column_sort_configuration')) // store new sort value in local storage
        setSortConfig(field, direction);
    }, [
        setSortConfig,
        rankFieldJql
    ]); /**
                                      * Determines whether a field set view has already been created
                                      * i.e., user has changed column configuration (resize, reorder) in a project
                                      */ 
    const isFieldSetViewCreated = fieldSetViewId != null && // Should be okay to parse since `fieldSetViewId` from the ARI is a number
    // See https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Afield-set-view
    Number((0, $iS1VO.JiraFieldSetViewAri).parse(fieldSetViewId).fieldSetViewId) !== (0, $4X4Xr.DEFAULT_FIELD_SET_VIEW_ID);
    const [onColumnsChange, isColumnsChangeInFlight] = (0, $3sRyW.useColumnsChange)({
        fieldSetViewId: fieldSetViewId,
        fieldSetsConnectionId: fieldSets?.__id ?? '',
        onCompleted: (changeType, success, columnIds)=>{
            if (success && changeType !== (0, $8jOO7.REORDER_COLUMNS)) setColumnNames(columnIds);
        }
    });
    const onRestoreDefaultColumns = (0, $4j9Ge.useColumnReset)({
        fieldSetViewId: fieldSetViewId,
        onSuccess: ()=>{
            columnPickerApi.current?.close();
            refetchChildIssues();
        }
    }); /**
       * onColumnResize is invoked after a user has completed a resize interaction with a column
       */ 
    const [onColumnResize, isColumnResizeInFlight] = (0, $6o2hR.useColumnResize)({
        fieldSetsId: fieldSets?.__id ?? ''
    }); /**
       * onRowReorder is invoked after a user reorders issues via a drag-and-drop operation.
       *
       * This callback will only be passed if `canRankIssues` is true
       *
       * TODO: Remove on jsc-2065-unify-onrowreorder cleanup
       */ 
    const onRowReorder = (0, $iYP2H.useIssuesRanker)(issues?.__id || ''); /**
                                                             * Determines whether a user can reorder issues
                                                             */ 
    const canRankIssues = (0, $4cTDP.fg)('relay_migration_children_issues_section') ? // Issue ranking is only supported in CMP Subtasks and TMP Child Issues
    (childIssuesPanelType === (0, $4X4Xr.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS || isSimplifiedProject && childIssuesPanelType === (0, $4X4Xr.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL) && // All issues should be visible
    hideDone !== 'true' && // Should be at least 2 issues
    hasMultipleIssues && // Rank field should be the sort option
    sortColumn === rankFieldJql : // Issue ranking is only supported in CMP Subtasks and TMP Child Issues
    (isClassicSubtaskPanel || isSimplifiedProject && isChildrenIssuesPanel) && // All issues should be visible
    hideDone !== 'true' && // Should be at least 2 issues
    hasMultipleIssues && // Rank field should be the sort option
    sortColumn === rankFieldJql; /**
                                * useColumnLoaderFromIssueKey is invoked when options need to be retrieved for the column picker
                                */ 
    const useColumnLoaderFromIssueKey = (selectedColumns)=>{
        return (0, $kNAZ7.useColumnLoader)({
            issueKey: issueKey,
            selectedColumns: selectedColumns
        });
    };
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)(); /**
                                         * Blocks the usage of the column picker
                                         */ 
    const isColumnPickerLoading = // When column size and column change mutation is in flight
    (isColumnResizeInFlight || isColumnsChangeInFlight) && // and the field set view is NOT yet created
    !isFieldSetViewCreated && (0, $4cTDP.fg)('issue-jiv-20390-column-picker-disappearing-fix');
    if (!fieldSets) return null;
    if (!issues || !issues.totalCount && !isHideDoneFilterEnabled) (0, $eSnSE.default).unsafeErrorWithCustomerData('issue.child-issue-panel', `issue total count is 0 for issue $${issueKey}, has issues: ${!!issues}`);
    const checkContainerWidthPass = (0, $4cTDP.fg)('issue-jiv-20891-move-container-width-up') ? true : !!(containerWidth && containerWidth > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, columnPickerRef.current != null && !isAnonymous && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20xMJ.ColumnPicker), {
        columns: fieldSets,
        isLoading: isColumnPickerLoading,
        ref: columnPickerApi,
        onColumnsChange: onColumnsChange,
        onRestoreDefaultColumns: !hasDefaultFieldSets ? onRestoreDefaultColumns : undefined,
        useColumnLoaderProp: useColumnLoaderFromIssueKey,
        ...(0, $4cTDP.fg)('jira_list_merged_column_gate') && {
            isMergedColumnEnabled: true
        }
    })), columnPickerRef.current), checkContainerWidthPass && !!issues?.totalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8c3Yt.IssueContext).Provider, {
        value: "localStateMode"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($553a96af1d8115e5$var$MaybeIssueTableScrollViewport, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($553a96af1d8115e5$var$IssueTableContainer, {
        ref: containerRef,
        onFocus: handleTableFocus,
        onBlur: handleTableBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1B1bw.ChildIssuesPanelErrorBoundaryWrapper), {
        componentName: "issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CqQm.default), {
        project: (0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update') ? issueByKey?.projectField?.project : undefined,
        issues: issues,
        sortField: sortColumn,
        sortDirection: sortDirection,
        columns: fieldSets,
        columnConfigOverrides: (0, $8iUvG.getColumnConfigOverrides)(containerWidth, userPreferredLayout),
        onRowReorder: canRankIssues && !(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? onRowReorder : undefined,
        onSortChange: onSortChange,
        loading: isLoading,
        ...!isAnonymous && {
            onColumnResize: onColumnResize,
            onColumnsChange: onColumnsChange
        },
        ...!isAnonymous && !hasDefaultFieldSets && {
            onRestoreDefaultColumns: onRestoreDefaultColumns
        },
        isColumnPickerLoading: isColumnPickerLoading,
        isIssueOperationMeatballMenuEnabled: false,
        isIssueRankingEnabled: canRankIssues && (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder'),
        isCompactColumnEnabled: true,
        isEntireRowDraggable: true,
        ...(0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update') && {
            isStatusTrackingEnabled: true
        },
        ...(0, $4cTDP.fg)('jira-issue-view-child-issues-panel-pagination') && {
            // TODO: Smarter threshold https://jplat.atlassian.net/browse/JIV-20800
            activationThreshold: (0, $8jOO7.ROW_HEIGHT) * 2,
            onLoadNext: ()=>loadNext((0, $4X4Xr.CHILD_ISSUES_PAGE_SIZE)),
            onLoadPrevious: ()=>loadPrevious((0, $4X4Xr.CHILD_ISSUES_PAGE_SIZE)),
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        },
        ...(0, $4cTDP.fg)('jira_list_merged_column_gate') && {
            isMergedColumnEnabled: true
        },
        ...(0, $cxKOj.expVal)('visual_uplift_for_child_issues_table', 'isEnabled', false) && {
            isChildIssuesTableVisualUpliftEnabled: true
        },
        components: {
            columnPicker: {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iiRWr)))
            }
        },
        eventHandlers: eventHandlers,
        ...((0, $4cTDP.fg)('ken-2879_is_child_issue_table') || (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate')) && {
            isChildIssuesTable: true
        },
        areShortcutsEnabled: isTableFocused,
        ...(0, $4cTDP.fg)('jira_timeline_cell_border_style') ? {
            cellBorderStyle: 'NO_COLUMN_BORDER'
        } : {
            isColumnBordersEnabled: false
        }
    }))))));
};
const $553a96af1d8115e5$export$321a483c0ddbdd37 = (0, $bJscI.componentWithFG)('issue-jiv-20891-move-container-width-up', $553a96af1d8115e5$export$a29ffc422b978674, (0, $arvNk.default)($553a96af1d8115e5$export$a29ffc422b978674));
const $553a96af1d8115e5$var$IssueTableScrollViewport = ({ children: children })=>{
    const maxHeight = (0, $8jOO7.HEADER_HEIGHT) + (0, $8jOO7.ROW_HEIGHT) * (0, $4X4Xr.CHILD_ISSUES_PAGE_SIZE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $553a96af1d8115e5$var$scrollViewportStyles,
        style: {
            maxHeight: `${maxHeight}px`
        }
    }, children);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $553a96af1d8115e5$var$IssueTableViewPort = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});
const $553a96af1d8115e5$var$MaybeIssueTableScrollViewport = (0, $bJscI.componentWithFG)('jira-issue-view-child-issues-panel-pagination', $553a96af1d8115e5$var$IssueTableScrollViewport, $553a96af1d8115e5$var$IssueTableViewPort);
const $553a96af1d8115e5$var$BasicIssueTableContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onFocus: onFocus, onBlur: onBlur }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        onFocus: onFocus,
        onBlur: onBlur
    }, children));
const $553a96af1d8115e5$var$IssueTableContainer = $553a96af1d8115e5$var$BasicIssueTableContainer;
const $553a96af1d8115e5$var$scrollViewportStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexBasis: 0,
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden'
});

});
parcelRegister("1SWVv", function(module, exports) {
$parcel$export(module.exports, "default", () => $68d1318909313bd3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72b4a944f6f75e0783f031b418957151>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $68d1318909313bd3$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NativeIssueTableWithSelectedIssuesProvider_columns"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "columnPicker_issueViewChildIssuesPanel"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraFieldSetView"
};
$68d1318909313bd3$var$node.hash = "5ba77c541d52856d8be1d9d8f1079187";
var $68d1318909313bd3$export$2e2bcd8739ae039 = $68d1318909313bd3$var$node;

});

parcelRegister("7EAmY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6655d4e49d934650$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33129ba978fb1cc2ba327ea45db4c082>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hG55b = parcelRequire("hG55b");
const $6655d4e49d934650$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $hG55b.default)
            }
        },
        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "issueSearch",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "__ChildIssuesPanelIssueSearchPagination__issueSearch_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "NativeIssueTableWithSelectedIssuesProvider_issues"
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$6655d4e49d934650$var$node.hash = "7acd999bfc296fc3a31013de60123402";
var $6655d4e49d934650$export$2e2bcd8739ae039 = $6655d4e49d934650$var$node;

});
parcelRegister("hG55b", function(module, exports) {
$parcel$export(module.exports, "default", () => $99ac9228601c1294$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a9a3e9ee63dc2217dcee43d2d3e96ea3>>
 * @relayHash 319232fe258b9af86148a7438491c6f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 093023e45b0e05f18671f222a7d2cc90f16053b2f923975529e07fa7e6e462ea

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $j2Uha = parcelRequire("j2Uha");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $99ac9228601c1294$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v15 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v16 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v20 = {
        "kind": "ScalarField",
        "name": "type"
    }, v21 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v22 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = [
        v23 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v26 = {
        "kind": "ClientExtension",
        "selections": [
            v25 /*: any*/ 
        ]
    }, v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v28 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v29 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v30 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "text"
    }, v32 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v10 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v35 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v36 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v37 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v38 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            v19 /*: any*/ 
        ]
    }, v41 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v42 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v43 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            v10 /*: any*/ 
        ]
    }, v44 = {
        "kind": "ScalarField",
        "name": "href"
    }, v45 = [
        v8 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_IssueSearchPaginationQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_IssueSearchPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraStatusField",
                                                    "kind": "LinkedField",
                                                    "name": "statusField",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 500
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldSetId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        v22 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v24 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v24 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v27 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "date"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v31 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v15 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v27 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v32 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v18 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v32 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                v31 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v33 /*: any*/ ,
                                                                                                                                                        v13 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v10 /*: any*/ ,
                                                                                                                                                                v15 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v13 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ ,
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v16 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v10 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v14 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "relationName"
                                                                                                                        },
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v32 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v39 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v40 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v9 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v41 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v41 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v10 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v27 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "versionId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v27 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v40 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v18 /*: any*/ ,
                                                                                                        v43 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v27 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v44 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v44 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        v40 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v40 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        v40 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        }
                                    ]
                                },
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v45 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v45 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v45 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                v40 /*: any*/ 
                            ]
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "issueSearchInput"
                            ],
                            "handle": "connection",
                            "key": "ChildIssuesPanelIssueSearchPagination__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "093023e45b0e05f18671f222a7d2cc90f16053b2f923975529e07fa7e6e462ea",
            "metadata": {},
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_IssueSearchPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$99ac9228601c1294$var$node.hash = "7acd999bfc296fc3a31013de60123402";
var $99ac9228601c1294$export$2e2bcd8739ae039 = $99ac9228601c1294$var$node;

});


parcelRegister("4DSIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $5546c98279fb7461$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<406dae71c3366811bf7a3a7272bdbdf5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $j1S2m = parcelRequire("j1S2m");
const $5546c98279fb7461$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueKey"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $j1S2m.default)
            }
        },
        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "NativeIssueTableWithSelectedIssuesProvider_project"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "before",
                                    "variableName": "before"
                                },
                                v0 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "NativeIssueTableWithSelectedIssuesProvider_issues"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "issueKey",
                                    "variableName": "issueKey"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "fieldSetViewQueryByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasDefaultFieldSets"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "fieldSetSelectedState": "SELECTED"
                                                    }
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "amountOfColumns"
                                                }
                                            ],
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "NativeIssueTableWithSelectedIssuesProvider_columns"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "columnPicker_issueViewChildIssuesPanel"
                                                },
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "amountOfColumns",
                                                    "variableName": "amountOfColumns"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject"
                                        }
                                    ],
                                    "type": "JiraFieldSetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v2 /*: any*/ ,
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData"
            }
        ],
        "type": "Query"
    };
}();
$5546c98279fb7461$var$node.hash = "e7032ab1284723136830a35f9a1d6ac0";
var $5546c98279fb7461$export$2e2bcd8739ae039 = $5546c98279fb7461$var$node;

});
parcelRegister("j1S2m", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9122b4e04339fd8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5bbd092531708fcb46ed59dcb52a474f>>
 * @relayHash f266ecb7d6fad13d0acdbfbd47cfec7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36aae8aaef2f7628bbaaf0ebf59db1f559f16829efd109a46ecd328e6e9a20cc

var $3Bt2F = parcelRequire("3Bt2F");

var $cqxuo = parcelRequire("cqxuo");

var $3jVIX = parcelRequire("3jVIX");

var $l6otE = parcelRequire("l6otE");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $alrjx = parcelRequire("alrjx");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $ePJhs = parcelRequire("ePJhs");

var $j2Uha = parcelRequire("j2Uha");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $8Qoc7 = parcelRequire("8Qoc7");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $c9122b4e04339fd8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRealtimeUpdateEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v20 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v24 = {
        "kind": "ScalarField",
        "name": "type"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "value"
    }, v28 = [
        v27 /*: any*/ ,
        v14 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v30 = {
        "kind": "ClientExtension",
        "selections": [
            v29 /*: any*/ 
        ]
    }, v31 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v32 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v33 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v34 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "text"
    }, v36 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v14 /*: any*/ 
        ]
    }, v37 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v39 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v40 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v41 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v42 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v43 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v44 = {
        "kind": "ClientExtension",
        "selections": [
            v23 /*: any*/ 
        ]
    }, v45 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v46 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v47 = [
        v14 /*: any*/ 
    ], v48 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v47 /*: any*/ 
    }, v49 = {
        "kind": "ScalarField",
        "name": "href"
    }, v50 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v51 = [
        v50 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v52 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v53 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraStatusField",
                                                    "kind": "LinkedField",
                                                    "name": "statusField",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 500
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        v13 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v24 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v14 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v28 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v28 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v31 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v14 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "date"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v22 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v20 /*: any*/ ,
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v31 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v36 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ ,
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v36 /*: any*/ ,
                                                                                                                v14 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v14 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v14 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v35 /*: any*/ ,
                                                                                                                v14 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v15 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                        v14 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                v35 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v14 /*: any*/ ,
                                                                                                                                                        v39 /*: any*/ ,
                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        v17 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v14 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v14 /*: any*/ ,
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        v42 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v34 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v14 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v12 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v20 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v14 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v18 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v14 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "relationName"
                                                                                                                        },
                                                                                                                        v14 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        v43 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v43 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v27 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v44 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v41 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v45 /*: any*/ ,
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v30 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v14 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v45 /*: any*/ ,
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v14 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v30 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v14 /*: any*/ ,
                                                                                                        v32 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v31 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "versionId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                v48 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v31 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v44 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v29 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v48 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v14 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v30 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v31 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v49 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v49 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v30 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        v44 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v44 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        v50 /*: any*/ ,
                                        v44 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v51 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v51 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v51 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        }
                                    ]
                                },
                                v44 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "issueSearchInput"
                            ],
                            "handle": "connection",
                            "key": "ChildIssuesPanelIssueSearchPagination__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        },
                        {
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "issueKey",
                                    "variableName": "issueKey"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "fieldSetViewQueryByProject",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasDefaultFieldSets"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "fieldSetSelectedState": "SELECTED"
                                                    }
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "amountOfColumns"
                                                }
                                            ],
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "aliases"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSortable"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "width"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canBeConfigured"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isPlaceHolderField"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldType",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v52 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v12 /*: any*/ ,
                                                v44 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraFieldSetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v47 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": "createIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "CREATE_ISSUES"
                                                                }
                                                            ],
                                                            "concreteType": "JiraProjectAction",
                                                            "kind": "LinkedField",
                                                            "name": "action",
                                                            "plural": false,
                                                            "selections": v53 /*: any*/ ,
                                                            "storageKey": "action(type:\"CREATE_ISSUES\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "editIssues",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "type",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraProjectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "action",
                                                                    "plural": false,
                                                                    "selections": v53 /*: any*/ ,
                                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "36aae8aaef2f7628bbaaf0ebf59db1f559f16829efd109a46ecd328e6e9a20cc",
            "metadata": {},
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragmentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isRealtimeUpdateEnabled": (0, $ePJhs.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": (0, $alrjx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider": (0, $cqxuo.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": (0, $l6otE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider": (0, $j2Uha.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$c9122b4e04339fd8$var$node.hash = "e7032ab1284723136830a35f9a1d6ac0";
var $c9122b4e04339fd8$export$2e2bcd8739ae039 = $c9122b4e04339fd8$var$node;

});
parcelRegister("ePJhs", function(module, exports) {
$parcel$export(module.exports, "default", () => $92292d3add361cda$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $92292d3add361cda$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});



parcelRegister("iS1VO", function(module, exports) {
$parcel$export(module.exports, "JiraFieldSetViewAri", () => $dbcec4b6407f5017$export$fed950768c732342);

var $4hw0T = parcelRequire("4hw0T");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/field-set-view/manifest.ts
var $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4hw0T.JiraFieldSetViewAriResourceOwner),
    resourceType: (0, $4hw0T.JiraFieldSetViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldSetViewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldSetViewId: /[0-9]+/
    }
};
// src/jira/field-set-view/index.ts
var $dbcec4b6407f5017$export$fed950768c732342 = class _JiraFieldSetViewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldSetViewId = opts.resourceIdSegmentValues.fieldSetViewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldSetViewId() {
        return this._fieldSetViewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts.qualifier,
            platformQualifier: $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts.resourceOwner,
            resourceType: $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldSetViewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldSetViewId: opts.fieldSetViewId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts);
        return new _JiraFieldSetViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $dbcec4b6407f5017$var$jiraFieldSetViewAriStaticOpts);
        return new _JiraFieldSetViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldSetViewId: this.fieldSetViewId
        };
    }
};

});
parcelRegister("4hw0T", function(module, exports) {
$parcel$export(module.exports, "JiraFieldSetViewAriResourceOwner", () => $31e1952be202a94b$export$4f475bbce90f7161);
$parcel$export(module.exports, "JiraFieldSetViewAriResourceType", () => $31e1952be202a94b$export$8d12f0a16a0dde41);
// src/jira/field-set-view/types.ts
var $31e1952be202a94b$export$4f475bbce90f7161 = "jira", $31e1952be202a94b$export$8d12f0a16a0dde41 = "field-set-view";

});


parcelRegister("cFxTI", function(module, exports) {
$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $6f5eb32ca668450c$export$852450339fdb3b37);
const $6f5eb32ca668450c$export$852450339fdb3b37 = (createdIssues)=>{
    if (createdIssues.length > 1) {
        const issueKeys = createdIssues.map((issue)=>issue.issueKey).join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${createdIssues[0].issueKey}`;
};

});

parcelRegister("ibQsy", function(module, exports) {
$parcel$export(module.exports, "default", () => $32718d67de54821e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3wl9L = parcelRequire("3wl9L");


var $cxKOj = parcelRequire("cxKOj");

var $ymEZt = parcelRequire("ymEZt");
var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $1CdfO = parcelRequire("1CdfO");

var $m2eL4 = parcelRequire("m2eL4");


var $5ddsi = parcelRequire("5ddsi");
const $32718d67de54821e$export$93bd4963a1d00fd5 = (props)=>{
    const { flagKey: flagKey, id: id, issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, successFlagParams: successFlagParams } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const issueType = issueList[0].issueType;
    const getDynamicFlagType = ()=>{
        if (successFlagParams) {
            const { isRankable: isRankable, isWorkMode: isWorkMode, canManageSprints: canManageSprints, boardType: boardType } = successFlagParams;
            if (isRankable && isWorkMode) {
                if (boardType === (0, $561748b7f70ecc76$export$4498412e32a31fb6) && canManageSprints) return 0, $1f39b704bd4e1e17$export$407f3b8bfd90ad8d;
                if (boardType === (0, $561748b7f70ecc76$export$b4e9cdb19cfa0abb)) return 0, $1f39b704bd4e1e17$export$256b368007db542a;
            }
        }
        return 0, $1f39b704bd4e1e17$export$858ff9c1b12e1d84;
    };
    const getDefaultFlagTitle = ()=>{
        const areMultipleIssuesCreated = issueList.length > 1;
        const successTitle = ()=>{
            if (issueType && (0, $cxKOj.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $5ddsi.default).createSuccessFlagTitleIssueTerminologyRefreshM4;
            return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).createSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).createSuccessFlagTitle;
        };
        return areMultipleIssuesCreated ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueList.length
        }) : formatMessage(successTitle(), {
            issueKey: issueList[0].issueKey,
            issueType: issueType
        });
    };
    const FlagConfigs = {
        Default: ()=>({
                flagTitle: getDefaultFlagTitle(),
                flagDescription: '',
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        IssuesNotInSprint: (issuesWithNoSprint, issuesExcludingEpics, sprints)=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $m2eL4.getNewScrumIssuesWithNoSprintsActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    issuesWithNoSprint: issuesWithNoSprint,
                    sprints: sprints
                })
            }),
        IssuesNotInSprintMoreThanTwoActiveSprints: (issuesWithNoSprint, issuesExcludingEpics)=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeNoSprint: ()=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenScrumIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).scrumCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $m2eL4.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            }),
        IssuesInBacklog: (issues)=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).issueCreatedInBacklogSuccessFlagDescription, {
                    issueKey: issues[0].issueKey,
                    issueCount: issues.length
                }),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeInBacklog: ()=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenKanbanIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).kanbanCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $m2eL4.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            })
    };
    const getFlagContent = ()=>{
        if (successFlagParams) {
            if (getDynamicFlagType() === (0, $1f39b704bd4e1e17$export$407f3b8bfd90ad8d)) {
                const { issues: issues, isFiltered: isFiltered, invalidIssuesKeys: invalidIssuesKeys, issuesWithNoSprint: issuesWithNoSprint, issuesExcludingEpics: issuesExcludingEpics, sprints: sprints } = successFlagParams;
                if (issuesWithNoSprint.length > 0) {
                    if (issuesWithNoSprint.length === issuesExcludingEpics.length) {
                        if (sprints.length > 2) return FlagConfigs.IssuesNotInSprintMoreThanTwoActiveSprints(issuesWithNoSprint, issuesExcludingEpics);
                        return FlagConfigs.IssuesNotInSprint(issuesWithNoSprint, issuesExcludingEpics, sprints);
                    }
                    return FlagConfigs.MultipleIssuesSomeNoSprint();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenScrumIssues(issues, isFiltered);
            } else if (getDynamicFlagType() === (0, $1f39b704bd4e1e17$export$256b368007db542a)) {
                const { kanbanIssuesInBacklog: kanbanIssuesInBacklog, invalidIssuesKeys: invalidIssuesKeys, issues: issues, isFiltered: isFiltered } = successFlagParams;
                if (kanbanIssuesInBacklog.length > 0) {
                    if (kanbanIssuesInBacklog.length === issues.length) return FlagConfigs.IssuesInBacklog(issues);
                    return FlagConfigs.MultipleIssuesSomeInBacklog();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenKanbanIssues(issues, isFiltered);
            }
        }
        return FlagConfigs.Default();
    };
    const { flagTitle: flagTitle, flagDescription: flagDescription, flagActions: flagActions } = getFlagContent();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-issue-key": issueList.map((issue)=>issue.issueKey).join(','),
        "data-testid": (0, $1f39b704bd4e1e17$export$2e4c8b336846b593)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ymEZt.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #22A06B)",
            label: "Success"
        }),
        id: (0, $jn1Cb.fromFlagId)(id),
        key: flagKey,
        title: flagTitle,
        description: flagDescription,
        actions: flagActions,
        onDismissed: ()=>{
            dismissFlag(id);
        },
        messageId: `issue-create.ui.modal.success-flag.ak-flag.${id}`,
        messageType: "transactional"
    }));
};
const $32718d67de54821e$var$SuccessFlagWithContext = (props)=>{
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1CdfO.AddToSprintActionStatesContainer), {
        scope: id.valueOf(),
        key: id.valueOf()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32718d67de54821e$export$93bd4963a1d00fd5, props));
};
var $32718d67de54821e$export$2e2bcd8739ae039 = $32718d67de54821e$var$SuccessFlagWithContext;

});
// Backend types
const $561748b7f70ecc76$export$9a958daafd9a03ed = 'agility-board';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $561748b7f70ecc76$var$CORE_BOARD = 'core-board';
const $561748b7f70ecc76$export$b4e9cdb19cfa0abb = 'kanban';
const $561748b7f70ecc76$export$4498412e32a31fb6 = 'scrum';

parcelRegister("1CdfO", function(module, exports) {
$parcel$export(module.exports, "AddToSprintActionStatesContainer", () => $5ba6e4c7a5fc16dc$export$4ae31d89b87a513);
$parcel$export(module.exports, "useAddToSprintFlagActionStateController", () => $5ba6e4c7a5fc16dc$export$dc7fffa2c4559368);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $5ba6e4c7a5fc16dc$var$initialState = {
    addToSprintCTAsEnabled: true
};
const $5ba6e4c7a5fc16dc$var$actions = {
    disableOtherAddToSprintCTAs: ()=>({ setState: setState })=>{
            setState({
                addToSprintCTAsEnabled: false
            });
        }
};
const $5ba6e4c7a5fc16dc$var$Store = (0, $GtRbT.createStore)({
    initialState: $5ba6e4c7a5fc16dc$var$initialState,
    actions: $5ba6e4c7a5fc16dc$var$actions,
    name: 'SuccessFlagAddToSprintActionStateController'
});
const $5ba6e4c7a5fc16dc$export$4ae31d89b87a513 = (0, $6E16M.createContainer)($5ba6e4c7a5fc16dc$var$Store);
const $5ba6e4c7a5fc16dc$export$dc7fffa2c4559368 = (0, $iJq0l.createHook)($5ba6e4c7a5fc16dc$var$Store);

});

parcelRegister("m2eL4", function(module, exports) {
$parcel$export(module.exports, "getDefaultFlagActions", () => $6721f9cbb1d879cb$export$6de10317e135f24);
$parcel$export(module.exports, "getNewScrumIssuesWithNoSprintsActions", () => $6721f9cbb1d879cb$export$882355824d3fc905);
$parcel$export(module.exports, "getHiddenIssuesActions", () => $6721f9cbb1d879cb$export$f5c2849658ba2a03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eDBhy = parcelRequire("eDBhy");

var $cxKOj = parcelRequire("cxKOj");

var $dTocu = parcelRequire("dTocu");

var $bVObd = parcelRequire("bVObd");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $zF9L8 = parcelRequire("zF9L8");

var $1CdfO = parcelRequire("1CdfO");


var $fY0Nc = parcelRequire("fY0Nc");
const $6721f9cbb1d879cb$export$f2011725fe81878a = (issueList, issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireViewIssueAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$71ce489a3b20fc93), {
            isNewGIC: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const issueType = issueList[0].issueType;
    const getContent = ()=>{
        if (issueType && (0, $zF9L8.isWorkTypeAvgLength)(issueType) && (0, $cxKOj.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $fY0Nc.default).viewIssueCtaIssueTerminologyRefreshM4;
        return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fY0Nc.default).viewIssueCtaIssueTermRefresh : (0, $fY0Nc.default).viewIssueCta;
    };
    return {
        content: formatMessage(getContent(), {
            issueCount: issueList.length,
            issueType: issueType
        }),
        href: issueDiscoveryUrl,
        onClick: fireViewIssueAnalyticsEvent
    };
};
const $6721f9cbb1d879cb$var$CopyLinkCta = (issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isCopied, setCopied] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eJOHy.useCallback)(async ()=>{
        try {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            await globalThis.navigator.clipboard.writeText(`${globalThis.location.origin}${issueDiscoveryUrl}`);
            setCopied(true);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$3a43d61edae693a9)); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        issueDiscoveryUrl
    ]);
    return {
        content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6721f9cbb1d879cb$var$ActionSuccess, null, formatMessage((0, $fY0Nc.default).linkCopied)) : formatMessage((0, $fY0Nc.default).copyLinkCta),
        onClick: copyToClipboard
    };
};
const $6721f9cbb1d879cb$var$ClearFiltersCta = ()=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eJOHy.useState)(false);
    const clearFiltersAction = (0, $eJOHy.useCallback)(()=>{
        (0, $bVObd.successFlagClearFiltersAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        setIsLoading(true);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$bc715896f18417a3), {
            isNewGIC: true
        });
        GH.WorkController.clearFilters().done(()=>{
            (0, $bVObd.successFlagClearFiltersAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $bVObd.successFlagClearFiltersAction).stop();
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'clearFilters',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    if (isLoading) return {
        content: formatMessage((0, $fY0Nc.default).clearFiltersCtaLoading)
    };
    if (isCompleted) return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6721f9cbb1d879cb$var$ActionSuccess, null, formatMessage((0, $fY0Nc.default).clearFiltersCtaCompleted))
    };
    return {
        content: formatMessage((0, $fY0Nc.default).clearFiltersCta),
        onClick: clearFiltersAction
    };
};
const $6721f9cbb1d879cb$export$54ce82bbc60a8f6e = (issuesWithNoSprint, totalCreatedIssuesCount, sprint)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ addToSprintCTAsEnabled: addToSprintCTAsEnabled }, { disableOtherAddToSprintCTAs: disableOtherAddToSprintCTAs }] = (0, $1CdfO.useAddToSprintFlagActionStateController)();
    const addToSprintAction = (0, $eJOHy.useCallback)(()=>{
        (0, $bVObd.successFlagAddToSprintAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        disableOtherAddToSprintCTAs();
        setIsLoading(true);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$31bef7c6ffa89efa), {
            isNewGIC: true
        });
        GH.WorkController.addNewIssuesToSprintFromJFE(sprint, issuesWithNoSprint).done(()=>{
            (0, $bVObd.successFlagAddToSprintAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $bVObd.successFlagAddToSprintAction).stop();
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'addToSprint',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent,
        sprint,
        issuesWithNoSprint,
        disableOtherAddToSprintCTAs
    ]);
    if (isLoading) return [
        {
            content: formatMessage((0, $fY0Nc.default).addIssuesToSprintCtaLoading)
        }
    ];
    if (isCompleted) return [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6721f9cbb1d879cb$var$ActionSuccess, null, formatMessage((0, $fY0Nc.default).addIssuesToSprintCtaCompleted))
        }
    ];
    if (addToSprintCTAsEnabled) return [
        {
            content: formatMessage((0, $fY0Nc.default).addAllIssuesToSprintCta, {
                sprintName: sprint.name
            }),
            onClick: addToSprintAction
        }
    ];
    return [];
};
const $6721f9cbb1d879cb$var$getAddToSprintsCtas = (issuesWithNoSprint, issueList, sprints)=>{
    const editableSprints = sprints.filter((sprint)=>sprint.canUpdateSprint);
    const totalCreatedIssuesCount = issueList.length;
    let ctaList = [];
    editableSprints.forEach((sprint)=>{
        ctaList = ctaList.concat($6721f9cbb1d879cb$export$54ce82bbc60a8f6e(issuesWithNoSprint, totalCreatedIssuesCount, sprint));
    });
    return ctaList;
};
const $6721f9cbb1d879cb$export$6de10317e135f24 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl })=>[
        $6721f9cbb1d879cb$export$f2011725fe81878a(issueList, issueDiscoveryUrl),
        $6721f9cbb1d879cb$var$CopyLinkCta(issueDiscoveryUrl)
    ];
const $6721f9cbb1d879cb$export$882355824d3fc905 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, issuesWithNoSprint: issuesWithNoSprint, sprints: sprints })=>{
    const ctaList = $6721f9cbb1d879cb$var$getAddToSprintsCtas(issuesWithNoSprint, issueList, sprints);
    ctaList.push($6721f9cbb1d879cb$export$f2011725fe81878a(issueList, issueDiscoveryUrl));
    return ctaList;
};
const $6721f9cbb1d879cb$export$f5c2849658ba2a03 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, isFiltered: isFiltered })=>{
    const ctaList = [
        $6721f9cbb1d879cb$export$f2011725fe81878a(issueList, issueDiscoveryUrl)
    ];
    if (isFiltered) ctaList.push($6721f9cbb1d879cb$var$ClearFiltersCta());
    return ctaList;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6721f9cbb1d879cb$var$ActionSuccess = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazy73q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eDBhy", function(module, exports) {
$parcel$export(module.exports, "fireIssueCreateErrorAnalytics", () => $7521412fa2e04cd6$export$fffbd8c0e67dbb84);

var $eezJL = parcelRequire("eezJL");

var $bguQO = parcelRequire("bguQO");

var $dqT1s = parcelRequire("dqT1s");
const $7521412fa2e04cd6$export$fffbd8c0e67dbb84 = (payload)=>{
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $bguQO.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...error && (0, $eezJL.isApolloError)(error) ? {
                errorType: (0, $dqT1s.handleApolloError)(error)
            } : {}
        },
        error: error
    });
};

});
parcelRegister("dqT1s", function(module, exports) {
$parcel$export(module.exports, "handleApolloError", () => $66011c8af62c00c5$export$31b755cdc25616f2);
const $66011c8af62c00c5$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});


parcelRegister("zF9L8", function(module, exports) {
$parcel$export(module.exports, "isWorkTypeAvgLength", () => $68d226678b5dc1ce$export$cc4247ae0afa23ac);
const $68d226678b5dc1ce$var$WORK_TYPE_AVG_LENGTH = 30;
const $68d226678b5dc1ce$export$cc4247ae0afa23ac = (workType)=>workType.length < $68d226678b5dc1ce$var$WORK_TYPE_AVG_LENGTH;

});

const $5a6210241e29c567$export$71ce489a3b20fc93 = 'viewIssues';
const $5a6210241e29c567$export$3a43d61edae693a9 = 'copyLink';
const $5a6210241e29c567$export$31bef7c6ffa89efa = 'addToSprint';
const $5a6210241e29c567$export$bc715896f18417a3 = 'clearFilters';

parcelRegister("fY0Nc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ac5bd071736413f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3ac5bd071736413f$var$messages = (0, $7qGN1.defineMessages)({
    viewIssueCta: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta",
        "defaultMessage": "View {issueCount, plural, one {issue} other {issues}}"
    },
    copyLinkCta: {
        "id": "issue-create.modal.success-flag.actions.copy-link-cta",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "issue-create.modal.success-flag.actions.link-copied",
        "defaultMessage": "Copied"
    },
    addAllIssuesToSprintCta: {
        "id": "issue-create.modal.success-flag.actions.add-all-issues-to-sprint-cta",
        "defaultMessage": "Add to {sprintName}"
    },
    clearFiltersCta: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta",
        "defaultMessage": "Clear filters"
    },
    clearFiltersCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-loading",
        "defaultMessage": "Clearing..."
    },
    clearFiltersCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-completed",
        "defaultMessage": "Filters cleared"
    },
    addIssuesToSprintCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-loading",
        "defaultMessage": "Adding..."
    },
    addIssuesToSprintCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-completed",
        "defaultMessage": "Added to sprint"
    },
    viewIssueCtaIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-term-refresh",
        "defaultMessage": "View{issueCount, plural, one {} other { work items}}"
    },
    viewIssueCtaIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-terminology-refresh-m4",
        "defaultMessage": "View{issueCount, plural, one { {issueType}} other { work items}}"
    }
});
var $3ac5bd071736413f$export$2e2bcd8739ae039 = $3ac5bd071736413f$var$messages;

});


const $1f39b704bd4e1e17$export$2e4c8b336846b593 = 'jira-issue-create.modal.create-form.success-flag';
const $1f39b704bd4e1e17$export$407f3b8bfd90ad8d = 'cmp-scrum-flag';
const $1f39b704bd4e1e17$export$256b368007db542a = 'cmp-kanban-flag';
const $1f39b704bd4e1e17$export$858ff9c1b12e1d84 = 'default-success-flag';

parcelRegister("5ddsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdc601f48fda8478$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cdc601f48fda8478$var$messages = (0, $7qGN1.defineMessages)({
    createSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has} other {Your issues have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title",
        "defaultMessage": "Issues added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description",
        "defaultMessage": "Some of your issues weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue was added to a different sprint, it may not be visible} other {If the board has active filters, or the issues were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has been created, but isn't on the board} other {Your issues have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title",
        "defaultMessage": "Issues added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description",
        "defaultMessage": "Your issues have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue wasn't added to the board, it may not be visible} other {If the board has active filters, or the issues weren't added to the board, they may not be visible}}."
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" work item"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# work items}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has} other {Your work items have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description-issue-term-refresh",
        "defaultMessage": "Some of your work items weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item was added to a different sprint, it may not be visible} other {If the board has active filters, or the work items were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has been created, but isn't on the board} other {Your work items have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description-issue-term-refresh",
        "defaultMessage": "Your work items have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item wasn't added to the board, it may not be visible} other {If the board has active filters, or the work items weren't added to the board, they may not be visible}}."
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {issueType} {issueKey}"
    }
});
var $cdc601f48fda8478$export$2e2bcd8739ae039 = $cdc601f48fda8478$var$messages;

});


parcelRegister("8c3Yt", function(module, exports) {
$parcel$export(module.exports, "IssueContext", () => $d33da18a7f7219ac$export$c436e295255cfd98);
$parcel$export(module.exports, "IssueFieldEditingContextProvider", () => $d33da18a7f7219ac$export$4bdcf555c5e0921f);
$parcel$export(module.exports, "useOptionallyControlledEditingState", () => $d33da18a7f7219ac$export$db1e18c2e86e1a50);

var $eJOHy = parcelRequire("eJOHy");

var $bGobh = parcelRequire("bGobh");
const $d33da18a7f7219ac$export$c436e295255cfd98 = /*#__PURE__*/ (0, $eJOHy.createContext)('localStateMode');
const $d33da18a7f7219ac$export$4bdcf555c5e0921f = ({ children: children, scope: scope })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d33da18a7f7219ac$export$c436e295255cfd98.Provider, {
        value: "sharedStateMode"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bGobh.FieldEditingContainer), {
        scope: scope
    }, children));
const $d33da18a7f7219ac$export$db1e18c2e86e1a50 = (initialState, fieldId, { onLocalChange: onLocalChange, onChange: onChange, onSharedChange: onSharedChange } = {})=>{
    const editingContext = (0, $eJOHy.useContext)($d33da18a7f7219ac$export$c436e295255cfd98);
    const isLocalStateMode = editingContext !== 'sharedStateMode';
    const [sharedState, { setFieldEditingState: setFieldEditingState }] = (0, $bGobh.useFieldIsEditing)(fieldId);
    const [localState, setLocalState] = (0, $eJOHy.useState)(isLocalStateMode ? initialState : sharedState);
    const unifiedOnChange = (0, $eJOHy.useCallback)((newValue)=>{
        onLocalChange?.(newValue, localState);
        onChange?.(newValue, localState);
        setLocalState(newValue);
        if (!isLocalStateMode) setFieldEditingState(fieldId, newValue);
    }, [
        onLocalChange,
        localState,
        onChange,
        isLocalStateMode,
        setFieldEditingState,
        fieldId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // If sharedState updates to a value that is different from localState, it's a shared state update.
        // Otherwise, it's just the shared state following a locally triggered state update
        if (!isLocalStateMode && sharedState !== localState) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onSharedChange?.(sharedState, !sharedState);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onChange?.(sharedState, !sharedState);
            setLocalState(sharedState);
        }
    // We want to ensure this useEffect is only called when the sharedState changes, not when any other dependencies change
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sharedState
    ]);
    const resultState = isLocalStateMode ? localState : sharedState;
    return [
        resultState,
        unifiedOnChange
    ];
};

});
parcelRegister("bGobh", function(module, exports) {
$parcel$export(module.exports, "useFieldIsEditing", () => $c643e2de6411b40d$export$3734a1b20e979e6e);
$parcel$export(module.exports, "useFieldIsEditingActions", () => $c643e2de6411b40d$export$a4850d650526df2e);
$parcel$export(module.exports, "FieldEditingContainer", () => $c643e2de6411b40d$export$4301025b8d3e0255);

var $huH03 = parcelRequire("huH03");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $c643e2de6411b40d$var$Store = (0, $GtRbT.createStore)({
    initialState: {},
    actions: {
        setFieldEditingState: (fieldId, isEditing)=>({ setState: setState })=>{
                setState({
                    [fieldId]: isEditing
                });
            },
        toggleFieldEditingState: (fieldId)=>({ setState: setState, getState: getState })=>{
                if (getState()[fieldId] == null) return undefined;
                const toggledValue = !getState()[fieldId];
                setState({
                    [fieldId]: toggledValue
                });
                return toggledValue;
            },
        getFieldEditingState: (fieldId)=>({ getState: getState })=>getState()[fieldId],
        resetFieldEditingStateStore: ()=>({ setState: setState, getState: getState })=>{
                setState((0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(getState(), ()=>false));
            }
    },
    name: 'FieldEditingState'
});
const $c643e2de6411b40d$export$3734a1b20e979e6e = (0, $iJq0l.createHook)($c643e2de6411b40d$var$Store, {
    selector: (state, arg)=>state[arg] != null ? state[arg] : false
});
const $c643e2de6411b40d$export$a4850d650526df2e = (0, $iJq0l.createActionsHook)($c643e2de6411b40d$var$Store);
const $c643e2de6411b40d$export$4301025b8d3e0255 = (0, $6E16M.createContainer)($c643e2de6411b40d$var$Store);

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});



const $e8c5fe022e7e442a$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $e8c5fe022e7e442a$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $e8c5fe022e7e442a$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $e8c5fe022e7e442a$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $e8c5fe022e7e442a$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $e8c5fe022e7e442a$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $e8c5fe022e7e442a$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $e8c5fe022e7e442a$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("PETi0", function(module, exports) {
$parcel$export(module.exports, "ColumnPickerContainer", () => $3bc985482a1599b5$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $3bc985482a1599b5$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3bc985482a1599b5$export$e1286e1cb3fa0dec = (0, $6E16M.createContainer)();
const $3bc985482a1599b5$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $3bc985482a1599b5$export$e1286e1cb3fa0dec
});
const $3bc985482a1599b5$export$81588ffe8d9d4add = (0, $iJq0l.createHook)($3bc985482a1599b5$var$Store);

});

parcelRegister("cs58I", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    // As part of an experiment (jiv-21227_dev_panel_collapsibility_exp) we are introducing collapsibility to the dev panel
    // However, we need to iterate on the backend change that would see the userPreference for our collapsed state of the dev panel
    // come through Relay/Agg.
    // This fetchUserPreferenceValue is a temporary measure to be able to run our initial experiment - if successful, we will remove the below and implement the backend change
    // Please don't use this for anything else except this experiment. Reach out to https://atlassian.enterprise.slack.com/archives/C093S7Q436E
    // Please see the JIRA ticket https://jplat.atlassian.net/browse/JIV-21315 for more details.
    const fetchValue = (0, $eJOHy.useCallback)(async ()=>{
        try {
            if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
                const serverValue = await (0, $etbP7.fetchUserPreferenceValue)(userPreferenceKey);
                if (serverValue !== null) {
                    const parsedValue = typeof serverValue === 'string' ? JSON.parse(serverValue) : serverValue;
                    setUserPreferenceValue(userPreferenceKey, parsedValue);
                    return parsedValue;
                }
            }
            return null;
        } catch (error) {
            return null;
        }
    }, [
        userPreferenceKey,
        setUserPreferenceValue
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue,
            fetchValue: fetchValue
        }), [
        setValue,
        deleteValue,
        fetchValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$var$store = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$var$store, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {
$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$var$getUserPreferenceValue = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$var$getUserPreferenceValue
};

});


parcelRegister("etbP7", function(module, exports) {
$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "fetchUserPreferenceValue", () => $a9cf1c440643deff$export$a3e5f8cedb0374ad);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");

var $cxKOj = parcelRequire("cxKOj");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a3e5f8cedb0374ad = async (userPreferenceKey)=>{
    try {
        if ((0, $cxKOj.expVal)('jiv-21227_dev_panel_collapsibility_exp', 'isEnabled', false)) {
            const response = await (0, $keOPi.performIssueGetRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');
            return response;
        }
        return null;
    } catch (error) {
        // If the preference doesn't exist, return null
        return null;
    }
};
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});
parcelRegister("keOPi", function(module, exports) {
$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);
// Stryker disable all

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPostRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performPutRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performDeleteRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $3ugTQ.performGetRequest), url, options, path);
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performGetRequest)(url, options);
};

});
parcelRegister("biGll", function(module, exports) {
$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $14RSn = parcelRequire("14RSn");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $14RSn.default) || error instanceof (0, $14RSn.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});




parcelRegister("3CqQm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "MaybeInlineCreateActiveIndexContainer", () => $f198d0139942408f$export$88c9e8ba5ac9f501);
$parcel$export(module.exports, "MaybeHoverPopoverProvider", () => $f198d0139942408f$export$a75161c82cc84af1);
$parcel$export(module.exports, "default", () => $f198d0139942408f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NativeIssueTableEntryPoint", () => $f198d0139942408f$export$1c6b4acc188098eb);

var $gbt4B = parcelRequire("gbt4B");

var $ae4IK = parcelRequire("ae4IK");

var $4irx0 = parcelRequire("4irx0");

var $lfOpX = parcelRequire("lfOpX");

var $8hGsL = parcelRequire("8hGsL");

var $huVH2 = parcelRequire("huVH2");

var $cp0ys = parcelRequire("cp0ys");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $2gvG4 = parcelRequire("2gvG4");

var $9cbmy = parcelRequire("9cbmy");

var $cxKOj = parcelRequire("cxKOj");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $88wTt = parcelRequire("88wTt");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $3cJQz = parcelRequire("3cJQz");

var $dLXgn = parcelRequire("dLXgn");

var $j8Km1 = parcelRequire("j8Km1");

var $bYhG9 = parcelRequire("bYhG9");

var $9RE4U = parcelRequire("9RE4U");

var $8jOO7 = parcelRequire("8jOO7");

var $f4DUY = parcelRequire("f4DUY");

var $lqvgs = parcelRequire("lqvgs");

var $kmIYY = parcelRequire("kmIYY");

var $dmolI = parcelRequire("dmolI");

var $l7qKV = parcelRequire("l7qKV");

var $P01So = parcelRequire("P01So");

var $kbYhH = parcelRequire("kbYhH");

var $4hsdx = parcelRequire("4hsdx");

var $jKV5x = parcelRequire("jKV5x");

var $6LwYU = parcelRequire("6LwYU");

var $6KVf0 = parcelRequire("6KVf0");

var $3F6xT = parcelRequire("3F6xT");

var $eqbO4 = parcelRequire("eqbO4");

var $jZFgr = parcelRequire("jZFgr");

var $kfIml = parcelRequire("kfIml");

var $7XD6x = parcelRequire("7XD6x");

var $9r0oq = parcelRequire("9r0oq");

var $8SzGK = parcelRequire("8SzGK");

var $91XFx = parcelRequire("91XFx");

var $sJrIm = parcelRequire("sJrIm");

var $7t30r = parcelRequire("7t30r");

var $4jaZO = parcelRequire("4jaZO");

var $8Cpk9 = parcelRequire("8Cpk9");

var $4aaY3 = parcelRequire("4aaY3");

var $aUa0f = parcelRequire("aUa0f");

var $12O1M = parcelRequire("12O1M");

var $clZvH = parcelRequire("clZvH");

var $dawqX = parcelRequire("dawqX");

var $9VBAD = parcelRequire("9VBAD");

var $eiAn5 = parcelRequire("eiAn5");

var $bUOjV = parcelRequire("bUOjV");

var $cyJHb = parcelRequire("cyJHb");

var $1GzaA = parcelRequire("1GzaA");

var $5CeML = parcelRequire("5CeML");

var $1PY5i = parcelRequire("1PY5i");

var $jyos0 = parcelRequire("jyos0");
const $f198d0139942408f$export$88c9e8ba5ac9f501 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), (0, $6KVf0.InlineCreateActiveIndexContainer), ({ children: children })=>children);
const $f198d0139942408f$export$a75161c82cc84af1 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator'), (0, $bYhG9.HoverPopoverStateProvider), ({ children: children })=>children);
const $f198d0139942408f$var$NativeIssueTable = ({ view: view, issues: issues, groups: groups, columns: columns, project: project, rankField: rankField, columnWidthOverrides: columnWidthOverrides, columnConfigOverrides: columnConfigOverrides, components: components, loading: loading = false, selectedRow: selectedRow = null, eventHandlers: eventHandlers, isInlineEditingEnabled: isInlineEditingEnabled = true, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled = false, onSelectedRowChange: onSelectedRowChange, sortField: sortField, sortDirection: sortDirection = (0, $8jOO7.SORT_ASC), onReady: onReady, onSortChange: onSortChange, onColumnsChange: onColumnsChange, onColumnResize: onColumnResize, onColumnFreeze: onColumnFreeze, onRestoreDefaultColumns: onRestoreDefaultColumns, issueSearchBaseUrl: issueSearchBaseUrl = '/issues', useColumnLoader: useColumnLoader, isColumnPickerLoading: isColumnPickerLoading, projectContext: projectContext, density: density = (0, $8jOO7.DENSITY_COMPACT), isIssueHierarchyEnabled: isIssueHierarchyEnabled = false, isHideDoneItemsEnabled: isHideDoneItemsEnabled = false, areShortcutsEnabled: areShortcutsEnabled = true, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled = false, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, isIssueCreateEnabled: isIssueCreateEnabled = false, enableMultiSelect: enableMultiSelect = false, tableBorderRadius: tableBorderRadius, onIssueFlatListUpdated: onIssueFlatListUpdated, jql: jql, isStatusTrackingEnabled: isStatusTrackingEnabled = false, isMergedColumnEnabled: isMergedColumnEnabled = false, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled = false, isChildIssuesTable: isChildIssuesTable = false, isIssueRankingEnabled: isIssueRankingEnabled = false, isTimelineEnabled: isTimelineEnabled = false, isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled = false, onPageChange: // Discrete pagination props
onPageChange, onLoadNext: // Infinite scroll pagination props
onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold, isGroupingSupported: // Experiment value props
isGroupingSupported = false, isOpenIssueLinkEnabled: isOpenIssueLinkEnabled = true, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled = true, isCompactColumnEnabled: isCompactColumnEnabled = false, isReparentingEnabled: isReparentingEnabled = false, isColumnBordersEnabled: isColumnBordersEnabled = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled = false, isGridNavigationEnabled: isGridNavigationEnabled = false, onRowReorder: // Row reordering props
onRowReorder, isEntireRowDraggable: // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
isEntireRowDraggable = false, ifcConfig: ifcConfig, onRefetch: onRefetch, isStickyColumnsEnabled: isStickyColumnsEnabled = false, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, stickyColumnIds: stickyColumnIds, enableAutoUnstickyOnSmallScreen: enableAutoUnstickyOnSmallScreen = false, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn = false, cellBorderStyle: cellBorderStyle = 'FULL_BORDER', isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled = false, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled = false, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled = false, isEditableSyncLoaded: isEditableSyncLoaded = false, isDraggingRowFaded: isDraggingRowFaded = true, footerInlineCreateCanShowAdditionalFields: footerInlineCreateCanShowAdditionalFields = true, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields = true, mergedColumnMinWidth: mergedColumnMinWidth = (0, $4cTDP.fg)('refactor_issue_table_for_timline') ? (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH) : undefined, tableRole: tableRole, formattingRules: formattingRules, footerBorderRadius: footerBorderRadius, resizeHandleType: resizeHandleType, isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled = false, isColumnConfigColumnEnabled: isColumnConfigColumnEnabled = true, isRemoveColumnEnabled: isRemoveColumnEnabled = true, topLevelIssueCreateConfig: topLevelIssueCreateConfig })=>{
    const tableRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (isGridNavigationEnabled) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7t30r.useKeyboardNavigation)(tableRef, isStickyColumnsEnabled);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const viewData = (0, $j4oe4.useFragment)((0, $cp0ys.default), view ?? null);
    const issuesData = (0, $j4oe4.useFragment)((0, $huVH2.default), issues ?? null);
    const groupData = (0, $j4oe4.useFragment)((0, $8hGsL.default), groups ?? null);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const columnsData = (0, $j4oe4.useFragment)((0, $lfOpX.default), columns);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ const projectData = (0, $j4oe4.useFragment)((0, $4irx0.default), project ?? null);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $ae4IK.default), rankField ?? null);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $gbt4B.default), formattingRules ?? null);
    const isInitialDataLoaded = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && !isInitialDataLoaded.current) isInitialDataLoaded.current = true;
    }, [
        loading
    ]);
    // initialPopulateConnectionArgs is used to initialise the hierarchy store container on initial load for root connections.
    const [initialisePopulateConnectionArgs] = (0, $eJOHy.useState)(()=>{
        if (!(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store')) return undefined;
        const connections = [];
        // Rows.tsx pattern with root parent
        if (issuesData && issuesData.edges) {
            const issueItems = issuesData.edges.map((edge)=>edge?.node && {
                    key: edge.node.key,
                    itemId: edge.node.issueId,
                    groupId: undefined
                }).filter(Boolean) ?? [];
            connections.push({
                parentItemId: 'root',
                itemsConnectionId: issuesData.__id,
                parentConnectionId: issuesData.__id,
                list: issueItems
            });
            return connections;
        }
        return undefined;
    });
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>{
        const issueTableNumberOfColumns = columnsData.totalCount;
        if ((0, $4cTDP.fg)('add-fields-enabled-attribute-to-nin-screen-event')) {
            const issueTableFieldTypes = columnsData.edges.map((edge)=>edge?.node.type);
            const issueTableFieldTypesWithCount = issueTableFieldTypes.filter((0, $P01So.isNonNullish)).sort().reduce((acc, type)=>{
                acc[type] = (acc[type] || 0) + 1;
                return acc;
            }, {});
            return {
                issueTableNumberOfColumns: issueTableNumberOfColumns,
                issueTableFieldTypes: issueTableFieldTypes,
                issueTableFieldTypesWithCount: issueTableFieldTypesWithCount
            };
        }
        const issueTableFieldTypesWithCount = columnsData.edges.map((edge)=>edge?.node.type).filter((0, $P01So.isNonNullish)).sort().reduce((acc, type)=>{
            acc[type] = (acc[type] || 0) + 1;
            return acc;
        }, {});
        const issueTableFieldTypes = Object.keys(issueTableFieldTypesWithCount);
        return {
            issueTableNumberOfColumns: issueTableNumberOfColumns,
            issueTableFieldTypes: issueTableFieldTypes,
            issueTableFieldTypesWithCount: issueTableFieldTypesWithCount
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const canViewColumnConfiguration = useColumnLoader !== undefined;
    const canEditColumnConfiguration = onColumnsChange !== undefined;
    const isColumnResizingEnabled = onColumnResize != null;
    // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
    const isRowReorderingEnabled = onRowReorder != null;
    const isInfiniteScrollEnabled = onLoadNext != null && onLoadPrevious != null;
    const userHasEditIssuePermission = projectData?.editIssues?.canPerform === true;
    const userHasCreateIssuePermission = projectData?.createIssues?.canPerform === true;
    if (isInfiniteScrollEnabled && density === (0, $8jOO7.DENSITY_FULL)) throw new Error(`Infinite scroll is not allowed when density=${density}`);
    const onColumnPickerChange = (0, $eJOHy.useCallback)((pickerArgs)=>{
        if (Array.isArray(pickerArgs)) onColumnsChange && onColumnsChange(pickerArgs, (0, $8jOO7.MODIFY_COLUMNS));
        else if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
            const { columnIds: columnIds, isHorizontalAutoScrollNeeded: isHorizontalAutoScrollNeeded, isHorizontalAutoScrollLeftNeeded: isHorizontalAutoScrollLeftNeeded, onSuccessCallback: onSuccessCallback, onErrorCallback: onErrorCallback, retries: retries, analyticsAttributes: attributes, skipRefetch: skipRefetch = false } = pickerArgs;
            if (isHorizontalAutoScrollLeftNeeded && isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) tableRef?.current?.parentElement?.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
            else if (isHorizontalAutoScrollNeeded) tableRef?.current?.parentElement?.scrollTo({
                left: tableRef?.current.scrollWidth,
                behavior: 'smooth'
            });
            onColumnsChange && onColumnsChange(columnIds, (0, $8jOO7.MODIFY_COLUMNS), undefined, onSuccessCallback, onErrorCallback, retries, attributes, skipRefetch);
        }
    }, [
        isMergedColumnEnabled,
        onColumnsChange
    ]);
    const isMergedColumnVisible = (0, $eJOHy.useMemo)(()=>{
        if (isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) return columnsData.edges.some((edge)=>edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY || edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE || edge?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY);
        return false;
    }, [
        isMergedColumnEnabled,
        columnsData
    ]);
    const mappedColumnConfig = (0, $eJOHy.useMemo)(()=>{
        const columnConfig = (0, $dmolI.getColumnConfig)(formatMessage);
        const columnsWithConfig = [];
        const types = columnsData.edges.filter((0, $P01So.isNonNullish)).map((edge)=>edge.node.type);
        if (isIssueHierarchyEnabled && !(isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'))) columnsWithConfig.push({
            id: (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            aliases: [],
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: "expand-column-header"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f4DUY.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cJQz.HierarchyOnboarding), null)),
            ...columnConfig[(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](),
            ...columnConfigOverrides?.[(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON](types)
        });
        const unsanitizedSortField = (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? sortField && (0, $P01So.desanitizeField)(sortField) : null;
        columnsData.edges.map((edge)=>edge?.node).filter((0, $P01So.isNonNullish)).forEach((node)=>{
            const { fieldSetId: fieldSetId, type: type, displayName: displayName, jqlTerm: jqlTerm, aliases: aliases, isSortable: isSortable, fieldSetPreferences: fieldSetPreferences, isPlaceHolderField: isPlaceHolderField, fieldsMetadata: fieldsMetadata } = node;
            let configureableFieldId;
            if (fieldsMetadata && (0, $4cTDP.fg)('jira_inline_field_config_gate')) {
                const configureableField = fieldsMetadata?.edges?.find((edge)=>edge?.node?.canBeConfigured);
                if (configureableField != null) configureableFieldId = configureableField?.node?.fieldId;
            }
            const mutableAliases = [
                ...aliases ?? []
            ];
            let currentSorting = (0, $8jOO7.SORT_NONE);
            if ((0, $4cTDP.fg)('jsc_list_reranking_ast_refactor')) {
                if (unsanitizedSortField && (jqlTerm.toLowerCase() === unsanitizedSortField || mutableAliases.includes(unsanitizedSortField))) currentSorting = sortDirection;
            } else if (jqlTerm === sortField) currentSorting = sortDirection;
            const baseConfig = {
                id: fieldSetId,
                type: type,
                title: displayName ?? '',
                jqlTerm: jqlTerm,
                aliases: mutableAliases,
                fieldTypeDisplayName: '',
                isSortable: isSortable ?? undefined,
                currentSorting: currentSorting,
                onSortOrderChanged: onSortChange,
                customWidth: columnWidthOverrides?.[fieldSetId] ?? fieldSetPreferences?.width ?? undefined,
                ...type === (0, $8jOO7.COLUMN_TYPE_PARENT_LINK) && {
                    warningText: formatMessage((0, $clZvH.default).deprecatedParentLinkMessage, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                                color: "color.text.inverse",
                                as: "strong"
                            }, chunks)
                    })
                },
                configureableFieldId: configureableFieldId
            };
            if ((0, $P01So.isKnownColumnType)(type)) {
                const getColumnTypeConfig = columnConfig[type];
                const knownColumnTypeConfig = getColumnTypeConfig();
                const getColumnConfigOverride = columnConfigOverrides?.[type];
                const columnConfigOverride = getColumnConfigOverride?.(types);
                columnsWithConfig.push({
                    ...baseConfig,
                    ...knownColumnTypeConfig,
                    ...columnConfigOverride,
                    isSortable: knownColumnTypeConfig.isSortable ?? true,
                    isPlaceHolderField: !!isPlaceHolderField
                });
            } else columnsWithConfig.push({
                ...baseConfig,
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                isPlaceHolderField: !!isPlaceHolderField
            });
        });
        const shouldShowColumnConfigColumn = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? canViewColumnConfiguration && isColumnConfigColumnEnabled || isIssueOperationMeatballMenuEnabled : canViewColumnConfiguration || isIssueOperationMeatballMenuEnabled;
        if (shouldShowColumnConfigColumn) {
            const emptyFooter = (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? {} : {
                Footer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
            };
            columnsWithConfig.push({
                id: (0, $8jOO7.COLUMN_ID_MEATBALL_MENU),
                type: (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS,
                title: '',
                fieldTypeDisplayName: '',
                jqlTerm: '',
                customHeader: canViewColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                    alignInline: "end"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88wTt.default), {
                    view: viewData,
                    columns: columnsData,
                    components: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
                        ...components?.columnPicker,
                        ...isInlineFieldConfigEnabled ? {
                            Footer: (0, $7XD6x.IFCFooter)
                        } : emptyFooter
                    } : components?.columnPicker,
                    onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
                    onRestoreDefaultColumns: onRestoreDefaultColumns,
                    useColumnLoader: useColumnLoader,
                    isLoading: isColumnPickerLoading || loading,
                    isMergedColumnEnabled: isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'),
                    isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                    projectContext: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? projectContext : undefined
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, formatMessage((0, $clZvH.default).columnHeaderIssueActions)),
                ...columnConfig[(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS](),
                ...columnConfigOverrides?.[(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]?.(types)
            });
        }
        return columnsWithConfig;
    }, [
        formatMessage,
        columnsData,
        isIssueHierarchyEnabled,
        isMergedColumnEnabled,
        canViewColumnConfiguration,
        isIssueOperationMeatballMenuEnabled,
        columnConfigOverrides,
        sortField,
        onSortChange,
        columnWidthOverrides,
        sortDirection,
        components?.columnPicker,
        isInlineFieldConfigEnabled,
        canEditColumnConfiguration,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader,
        isColumnPickerLoading,
        loading,
        projectContext,
        viewData,
        isColumnConfigColumnEnabled
    ]);
    const checkboxColumnConfig = (0, $eJOHy.useMemo)(()=>{
        const checkboxConfig = (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]();
        return {
            id: (0, $8jOO7.COLUMN_ID_CHECKBOX),
            type: (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX,
            title: '',
            fieldTypeDisplayName: '',
            jqlTerm: '',
            customHeader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqvgs.HeaderCheckboxCell), {
                groupByFieldId: groupData?.groupByField ?? null,
                totalIssueSearchResultCount: (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? issuesData?.totalIssueSearchResultCount ?? null : undefined
            }),
            ...checkboxConfig
        };
    }, [
        formatMessage,
        groupData?.groupByField,
        issuesData?.totalIssueSearchResultCount
    ]);
    const mappedColumns = (0, $eJOHy.useMemo)(()=>{
        // Step 1: get columnConfigs based on bulk ops gate (when enabled)
        let computedMappedColumns = mappedColumnConfig;
        if (enableMultiSelect) computedMappedColumns = [
            checkboxColumnConfig,
            ...mappedColumnConfig
        ];
        // Step 2: get columnConfigs with merged column when enabled.
        if (isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
            if ((0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) computedMappedColumns = (0, $91XFx.getMergedColumnConfigWithDynamicOrder)(computedMappedColumns, isIssueHierarchyEnabled, formatMessage, enableDynamicOrderForMergedColumn);
            else computedMappedColumns = (0, $91XFx.getMergedColumnConfig)(computedMappedColumns, isIssueHierarchyEnabled, formatMessage);
        }
        // Step 3: get columnConfigs with sticky attributes when frozen columns enabled.
        if (isStickyColumnsEnabled && (0, $4cTDP.fg)('issue_table_frozen_columns')) computedMappedColumns = (0, $l7qKV.getColumnsWithStickyOffsets)(computedMappedColumns, stickyColumnIds);
        return computedMappedColumns;
    }, [
        checkboxColumnConfig,
        enableMultiSelect,
        formatMessage,
        isMergedColumnEnabled,
        isIssueHierarchyEnabled,
        isStickyColumnsEnabled,
        mappedColumnConfig,
        stickyColumnIds,
        enableDynamicOrderForMergedColumn
    ]);
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) {
        const lastStickyColumn = mappedColumns.find((col)=>col.isLastStickyColumn);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $eJOHy.useMemo)(()=>{
            if (!isStickyColumnsEnabled) return false;
            if (!lastStickyColumn) return false;
            // Check if lastStickyColumn's id is not COLUMN_ID_CHECKBOX or COLUMN_ID_EXPAND_BUTTON
            return ![
                (0, $8jOO7.COLUMN_ID_CHECKBOX),
                (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)
            ].includes(lastStickyColumn.id);
        }, [
            lastStickyColumn,
            isStickyColumnsEnabled
        ]);
    }
    const handleOnColumnsChange = (0, $eJOHy.useCallback)((newColumns)=>{
        if (onColumnsChange) {
            let columnsWithIssueData = newColumns.filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
            // make sure merged fields (key, type, summary) are passed to the onColumnsChange
            if (isMergedColumnVisible && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
                // If re-ordering is enabled for merged column then update columns before merged column with correct order
                if (enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) {
                    const mergedColumnIndex = newColumns.findIndex((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN));
                    if (mergedColumnIndex !== -1) {
                        const columnsOnLeft = newColumns.slice(0, mergedColumnIndex).filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
                        const columnsOnRight = newColumns.slice(mergedColumnIndex + 1).filter(({ id: id })=>id ? !(0, $8jOO7.ACTION_COLUMNS).includes(id) : id !== (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
                        const mergedColumns = newColumns[mergedColumnIndex].mergedColumns ?? [];
                        columnsWithIssueData = [
                            ...columnsOnLeft,
                            ...mergedColumns,
                            ...columnsOnRight
                        ];
                    }
                } else {
                    const mergedColumns = newColumns.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns;
                    if (mergedColumns?.length) columnsWithIssueData = [
                        ...mergedColumns,
                        ...columnsWithIssueData
                    ];
                }
            }
            const columnIds = columnsWithIssueData.map(({ id: id })=>id);
            const edges = columnsWithIssueData.map(({ id: id, type: type, title: title, jqlTerm: jqlTerm, aliases: aliases, isSortable: isSortable, fieldTypeDisplayName: fieldTypeDisplayName, customWidth: customWidth })=>({
                    node: {
                        fieldSetId: id,
                        type: type ?? null,
                        displayName: title,
                        jqlTerm: jqlTerm ?? null,
                        aliases: aliases ?? [],
                        isSortable: isSortable ?? null,
                        fieldType: fieldTypeDisplayName ? {
                            displayName: fieldTypeDisplayName
                        } : null,
                        fieldSetPreferences: customWidth ? {
                            width: customWidth
                        } : null,
                        fieldsMetadata: null
                    }
                }));
            const optimisticFieldSets = {
                totalCount: columnsData.totalCount,
                edges: edges
            };
            onColumnsChange(columnIds, (0, $8jOO7.REORDER_COLUMNS), optimisticFieldSets);
        }
    }, [
        columnsData.totalCount,
        isMergedColumnVisible,
        onColumnsChange,
        enableDynamicOrderForMergedColumn
    ]);
    const tableInjectedProps = (0, $eJOHy.useMemo)(()=>({
            ...eventHandlers,
            issueSearchBaseUrl: issueSearchBaseUrl
        }), [
        eventHandlers,
        issueSearchBaseUrl
    ]);
    const columnPickerProps = (0, $eJOHy.useMemo)(()=>isInBetweenColumnPickerEnabled && canViewColumnConfiguration ? {
            columns: columnsData,
            components: components?.columnPicker,
            onChange: canEditColumnConfiguration ? onColumnPickerChange : undefined,
            onRestoreDefaultColumns: onRestoreDefaultColumns,
            useColumnLoader: useColumnLoader,
            isLoading: isColumnPickerLoading || loading
        } : undefined, [
        canEditColumnConfiguration,
        canViewColumnConfiguration,
        columnsData,
        components?.columnPicker,
        isColumnPickerLoading,
        isInBetweenColumnPickerEnabled,
        loading,
        onColumnPickerChange,
        onRestoreDefaultColumns,
        useColumnLoader
    ]);
    (0, $2gvG4.addUFOCustomData)({
        numberOfColumns: mappedColumns.length
    });
    (0, $eJOHy.useEffect)(()=>{
        onReady && (0, $4cTDP.fg)('endeavour_nin_filter_results_gadget') && onReady();
    }, [
        onReady
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isChildIssuesTable && (0, $4cTDP.fg)('ken-2879_is_child_issue_table')) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'columnsCount updated', 'childIssuesTable', {
            numberOfColumns: mappedColumns.length
        });
    }, [
        createAnalyticsEvent,
        isChildIssuesTable,
        mappedColumns.length
    ]);
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    const conditionalOnColumnsChange = canEditColumnConfiguration ? handleOnColumnsChange : undefined;
    // Show the skeleton if we are loading on initial render as we may only have partial row data
    if (loading && !isInitialDataLoaded.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null);
    const footer = issuesData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Cpk9.default), {
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        Footer: components?.Footer,
        rankField: rankFieldData ?? null,
        IssueCount: components?.IssueCount,
        issues: issuesData,
        onPageChange: onPageChange,
        ...(0, $4cTDP.fg)('refactor_issue_table_for_timline') && {
            canShowAdditionalFields: footerInlineCreateCanShowAdditionalFields,
            footerBorderRadius: footerBorderRadius
        }
    }) : null;
    const connectionsSubscriber = components?.ConnectionsSubscriber && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1GzaA.ConnectionsSubscriberContainer), {
        ConnectionsSubscriber: components.ConnectionsSubscriber
    });
    const hierarchyRemountKey = `${isIssueHierarchyEnabled}-${isGroupingSupported ? groupData?.jql || issuesData?.jql : ''}-${groupData?.groupByField}`;
    const ScrollContainer = components?.ScrollContainer ?? (0, $9VBAD.ScrollContainer);
    const MainContainer = (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? components?.MainContainer ?? (0, $eiAn5.MainContainer) : (0, $eiAn5.MainContainer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "nativeIssueTable",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hsdx.FeaturesContainer), {
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && userHasCreateIssuePermission,
        projectContext: projectContext,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled,
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? false : isRowReorderingEnabled,
        isEntireRowDraggable: (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? isEntireRowDraggable : isRowReorderingEnabled && isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled && isIssueHierarchyEnabled && (!groupData || !groupData?.groupByField) && userHasEditIssuePermission,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql ?? '',
        isColumnBordersEnabled: isColumnBordersEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: enableAutoUnstickyOnSmallScreen,
        isConditionalFormattingEnabled: (0, $4cTDP.fg)('jira_list_conditional_formatting') ? isConditionalFormattingEnabled : undefined,
        isTimelineEnabled: isTimelineEnabled,
        isOpenIssueLinkEnabled: isOpenIssueLinkEnabled,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        cellBorderStyle: (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? cellBorderStyle : 'FULL_BORDER',
        isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded,
        isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled,
        isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled,
        isColumnConfigColumnEnabled: isColumnConfigColumnEnabled,
        isRemoveColumnEnabled: isRemoveColumnEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8SzGK.MaybeEventHandlersProvider), {
        eventHandlers: eventHandlers ?? {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9r0oq.TimelineCustomComponentsProvider), {
        components: components?.timeline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3F6xT.TableIntersectionObserverContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4aaY3.IssueFetchQueryVariables), {
        columns: columnsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f198d0139942408f$export$88c9e8ba5ac9f501, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6LwYU.SiblingCreateActiveIndexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jaZO.ShouldUseSSRVirtualizerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jE8Tu.HierarchyContainer), {
        // Key used to reset the container store when the hierarchy settings change
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey,
        ...(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && {
            populateConnectionArgs: initialisePopulateConnectionArgs
        },
        ...(0, $4cTDP.fg)('jsc_highlight_selected_row') && {
            selectedRowIndex: selectedRow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f198d0139942408f$export$a75161c82cc84af1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
        issueConnectionId: issuesData?.__id || '',
        instanceId: issuesData?.__id,
        ...(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? {} : {
            onRowReorder: onRowReorder
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MainContainer, {
        tableBorderRadius: isChildIssuesTableVisualUpliftEnabled && (0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table') ? "var(--ds-space-0, 0px)" : tableBorderRadius,
        tableBorderWidth: isChildIssuesTableVisualUpliftEnabled && (0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table') ? '0px' : (0, $8jOO7.BORDER_WIDTH),
        "data-vc": `issue-table-main-container${false && !isPageHydrating ? '-ssr' : ''}`,
        ...false && !isPageHydrating && {
            'data-ssr-placeholder': 'issue-table-main-container-placeholder'
        },
        ...!false && !isPageHydrating && {
            'data-ssr-placeholder-replace': 'issue-table-main-container-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbYhH.ElementSizeProvider), {
        elementRef: tableRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLXgn.ConnectionsListContainer), {
        // Key used to reset the container store when the hierarchy settings change
        // Without it there may be flickering when Concurrent Mode is enabled
        key: hierarchyRemountKey
    }, connectionsSubscriber, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sJrIm.SortChangeContextProvider), {
        value: {
            onSortChange: onSortChange
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ScrollContainer, {
        footer: footer,
        onLoadNext: onLoadNext,
        onLoadPrevious: onLoadPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        activationThreshold: activationThreshold,
        loading: loading,
        isGrouping: isGroupingSupported && !!groupData,
        ...(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && {
            columnCount: mappedColumns.length
        },
        ...((0, $4cTDP.fg)('ken-2879_is_child_issue_table') || (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate')) && {
            isChildIssuesTable: isChildIssuesTable
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eqbO4.LazyEditabilityLoaderContainer), {
        scope: (0, $8jOO7.LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZFgr.LazyMediaViewContextLoaderContainer), {
        scope: (0, $8jOO7.LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jKV5x.SelectedRowContainer), {
        selectedRowIndex: selectedRow,
        amountOfRows: issuesData?.edges?.length ?? 0,
        onRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        issues: issuesData ?? null
    }, areShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $12O1M.default), {
        onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), isInBetweenColumnPickerEnabled && {
        scope: (0, $8jOO7.COLUMN_PICKER_CONFIGURATION_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cyJHb.CopyPasteContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aUa0f.default), {
        view: viewData ?? null,
        columnPickerProps: columnPickerProps,
        issueResults: issuesData ?? null,
        groupResults: groupData ?? null,
        project: projectData ?? null,
        rankField: rankFieldData ?? null,
        columns: mappedColumns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        loading: loading,
        tableInjectedProps: tableInjectedProps,
        onColumnsChange: conditionalOnColumnsChange,
        onResizeColumn: onColumnResize,
        onFreezeColumn: onColumnFreeze,
        NoColumns: components?.NoColumns,
        NoIssues: components?.NoIssues,
        tableRef: tableRef,
        isGroupingSupported: isGroupingSupported,
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: isChildIssuesTableVisualUpliftEnabled && (0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table') ? "var(--ds-space-0, 0px)" : tableBorderRadius,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ifcConfig: ifcConfig,
        columnsQueryRef: columnsData,
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        isDraggingRowFaded: isDraggingRowFaded,
        mergedColumnMinWidth: mergedColumnMinWidth,
        tableRole: tableRole,
        formattingRules: formattingRulesData,
        rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
        resizeHandleType: resizeHandleType,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        ...(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && {
            initialPopulateConnectionArgs: initialisePopulateConnectionArgs
        }
    })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CeML.RootConnectionRegister), {
        issues: issuesData
    }), (0, $4cTDP.fg)('jira_list_reduce_re_renders') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyos0.FlatListUpdateHandler), {
        onIssueFlatListUpdated: onIssueFlatListUpdated
    }), projectData && (0, $cxKOj.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) && ((0, $4cTDP.fg)('jira_platform_issue_realtime_updates_used_in_nin') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PY5i.IssueRealtimeUpdater), {
        project: projectData,
        issues: issuesData,
        groups: groupData,
        isHierarchyEnabled: isIssueHierarchyEnabled,
        isStatusTrackingEnabled: isStatusTrackingEnabled,
        onRefetch: onRefetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dawqX.RealtimeUpdater), {
        project: projectData,
        issues: issuesData,
        groups: groupData,
        isHierarchyEnabled: isIssueHierarchyEnabled,
        isStatusTrackingEnabled: isStatusTrackingEnabled,
        onRefetch: onRefetch
    })))))))))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTable"
    }));
};
const $f198d0139942408f$var$NativeIssueTableWithSelectedIssuesProvider = (0, $bUOjV.IssueTableSelectedIssuesProvider)($f198d0139942408f$var$NativeIssueTable);
var $f198d0139942408f$export$2e2bcd8739ae039 = $f198d0139942408f$var$NativeIssueTableWithSelectedIssuesProvider;
const $f198d0139942408f$export$1c6b4acc188098eb = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f198d0139942408f$var$NativeIssueTableWithSelectedIssuesProvider, props);

});
parcelRegister("gbt4B", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cda63694851124c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6985c07e30668bf0a3137d89e31c7ce8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1cda63694851124c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueTable_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$1cda63694851124c$var$node.hash = "bee4ee6b4e3b0de62d9a8d49cc6ce0f7";
var $1cda63694851124c$export$2e2bcd8739ae039 = $1cda63694851124c$var$node;

});

parcelRegister("ae4IK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a86863e276a178b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d05b0e3dbaccaeeae8e3e0b8e436ca48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6a86863e276a178b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueTable_rankField"
        },
        {
            "kind": "FragmentSpread",
            "name": "FooterRenderer_rank"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$6a86863e276a178b$var$node.hash = "82614f163ab491b25be4a02199e7de19";
var $6a86863e276a178b$export$2e2bcd8739ae039 = $6a86863e276a178b$var$node;

});

parcelRegister("4irx0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf12e98fe2da99c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e97651fedafb0e9a74788ce9ad411c5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bf12e98fe2da99c2$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "NativeIssueTableWithSelectedIssuesProvider_project",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "editIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v0 /*: any*/ ,
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                    }
                ]
            },
            {
                "alias": "createIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": v0 /*: any*/ ,
                "storageKey": "action(type:\"CREATE_ISSUES\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "RealtimeUpdater_project"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "IssueRealtimeUpdater_project"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "IssueTable_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$bf12e98fe2da99c2$var$node.hash = "7b0393810323937021c9cae8eb31d10f";
var $bf12e98fe2da99c2$export$2e2bcd8739ae039 = $bf12e98fe2da99c2$var$node;

});

parcelRegister("lfOpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fa998f535e2cbbb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10a524d8a265b2ef146dd954ec86f385>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8fa998f535e2cbbb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_columns",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueFetchQueryVariables"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.fieldSetId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.type"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.displayName"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "jqlTerm"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.jqlTerm"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "aliases"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                },
                                {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canBeConfigured"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPlaceHolderField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        },
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef"
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$8fa998f535e2cbbb$var$node.hash = "1b4c38bed9d29dd542d8e29a16f86aeb";
var $8fa998f535e2cbbb$export$2e2bcd8739ae039 = $8fa998f535e2cbbb$var$node;

});

parcelRegister("8hGsL", function(module, exports) {
$parcel$export(module.exports, "default", () => $21cde8a6a54adb79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cc291cb89eb2203f3ddcff39710f8d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21cde8a6a54adb79$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }
    ],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider_group",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "viewConfigInput",
                    "variableName": "viewConfigInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueTable_spreadsheetGroupConnection"
        },
        {
            "kind": "FragmentSpread",
            "name": "RealtimeUpdater_spreadsheetGroupConnection"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "IssueRealtimeUpdater_spreadsheetGroupConnection"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$21cde8a6a54adb79$var$node.hash = "039f7c73593af4d9cfc18e095801e270";
var $21cde8a6a54adb79$export$2e2bcd8739ae039 = $21cde8a6a54adb79$var$node;

});

parcelRegister("huVH2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8524d2f4a23dc462$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0210d4439a64717a93d88968b335cca7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8524d2f4a23dc462$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "NativeIssueTableWithSelectedIssuesProvider_issues",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isDensityFull",
                        "variableName": "isDensityFull"
                    },
                    {
                        "kind": "Variable",
                        "name": "isEditableSyncLoaded",
                        "variableName": "isEditableSyncLoaded"
                    },
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isLinkRelationshipFieldEnabled",
                        "variableName": "isLinkRelationshipFieldEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isRemoteLinkedIssuesEnabled",
                        "variableName": "isRemoteLinkedIssuesEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isReparentingEnabled",
                        "variableName": "isReparentingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    {
                        "kind": "Variable",
                        "name": "shouldQueryHasChildren",
                        "variableName": "shouldQueryHasChildren"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "IssueTable_issueConnection"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "FooterRenderer"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "SelectedRowContainer"
            },
            {
                "kind": "FragmentSpread",
                "name": "RealtimeUpdater"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "IssueRealtimeUpdater"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "RootConnectionRegister"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalIssueSearchResultCount"
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$8524d2f4a23dc462$var$node.hash = "fe2a2cf073487bc0a178813664a092c9";
var $8524d2f4a23dc462$export$2e2bcd8739ae039 = $8524d2f4a23dc462$var$node;

});

parcelRegister("cp0ys", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a0956aeb29fe06d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e823476b84c438a45771a4dc39ab805e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a0956aeb29fe06d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NativeIssueTableWithSelectedIssuesProvider",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer_savedViewId"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueTableIssueTable"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$7a0956aeb29fe06d$var$node.hash = "187425a6602b2816d5481a2bd973ae1d";
var $7a0956aeb29fe06d$export$2e2bcd8739ae039 = $7a0956aeb29fe06d$var$node;

});

parcelRegister("88wTt", function(module, exports) {
$parcel$export(module.exports, "default", () => $54e03d97ba1f3fd3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $dyvFQ = parcelRequire("dyvFQ");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $cWT2N = parcelRequire("cWT2N");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $54e03d97ba1f3fd3$var$ColumnConfig = (0, $bQWwW.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("9NBLG"))), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/issue-table/column-picker/src/ui/ColumnConfigWithContainer.tsx"
});
const $54e03d97ba1f3fd3$var$ErrorFallback = ({ onRetry: onRetry, customIcon: customIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.default), {
                ...props,
                ref: triggerRef,
                customIcon: customIcon
            }),
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        onRetry: onRetry,
        pageAction: "columnPicker"
    }));
const $54e03d97ba1f3fd3$var$AsyncColumnConfig = (props)=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueTableColumnPicker",
        id: "unhandled",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54e03d97ba1f3fd3$var$ErrorFallback, {
                onRetry: ()=>setResetCaughtError(error),
                customIcon: props.components?.Icon
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-column-config",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.PickerButtonFallback), {
            customIcon: props.components?.Icon,
            isInBetweenColumnPickerEnabled: props.isInBetweenColumnPickerEnabled
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54e03d97ba1f3fd3$var$ColumnConfig, props)));
};
var $54e03d97ba1f3fd3$export$2e2bcd8739ae039 = $54e03d97ba1f3fd3$var$AsyncColumnConfig;

});
parcelRegister("dyvFQ", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $147eb7ee5e3e0a78$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $ivs94 = parcelRequire("ivs94");

var $1m9Wj = parcelRequire("1m9Wj");
const $147eb7ee5e3e0a78$var$BOX_HEIGHT = 144;
const $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = 72;
const $147eb7ee5e3e0a78$var$ICON_SIZE = 72;
const $147eb7ee5e3e0a78$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = ()=>{
        onRetry?.();
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $147eb7ee5e3e0a78$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1m9Wj.StyledText), null, description !== undefined ? description : formatMessage((0, $ivs94.default).errorMessage)), (onRetry || !(0, $4cTDP.fg)('nin_filter_details_popup_entrypoint_migration')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $ivs94.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $147eb7ee5e3e0a78$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ivs94", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc2779f4954708a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7fc2779f4954708a$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $7fc2779f4954708a$export$2e2bcd8739ae039 = $7fc2779f4954708a$var$messages;

});

parcelRegister("1m9Wj", function(module, exports) {
$parcel$export(module.exports, "StyledText", () => $fe5d3814363465dc$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $fe5d3814363465dc$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe5d3814363465dc$var$StyledTextComponent, props));

});


parcelRegister("cWT2N", function(module, exports) {
$parcel$export(module.exports, "PickerButtonFallback", () => $19f27efe9b61f432$export$d2ed0044a1cffec6);
$parcel$export(module.exports, "default", () => $19f27efe9b61f432$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $2a3IQ = parcelRequire("2a3IQ");

var $iiRWr = parcelRequire("iiRWr");

var $k71qx = parcelRequire("k71qx");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $fbuFM = parcelRequire("fbuFM");
const $19f27efe9b61f432$var$PickerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isLoading: isLoading = false, isSelected: isSelected = false, customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const iconColor = isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $fbuFM.default).addColumnTooltipText : (0, $fbuFM.default).tooltipText);
    const tooltipOptions = {
        position: 'bottom',
        content: tooltipContent,
        delay: 0
    };
    const isDisabled = !isSelected && isLoading;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'ninColumnPickerButton', {
            isInline: !!isInBetweenColumnPickerEnabled
        });
        onClick?.(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isInBetweenColumnPickerEnabled,
        onClick
    ]);
    if (isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $19f27efe9b61f432$var$pressableStyles,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.pressable-add-column",
        isDisabled: isDisabled,
        onClick: handleOnClick,
        onMouseEnter: onPickerMouseEnter,
        onMouseLeave: onPickerMouseLeave,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($2a3IQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: icon,
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: isDisabled,
        onClick: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? handleOnClick : onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected,
        tooltip: tooltipOptions,
        isTooltipDisabled: false,
        ...(0, $4cTDP.fg)('relay_migration_children_issues_section') ? {
            spacing: 'compact'
        } : {}
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        testId: "issue-table-column-picker.ui.column-picker.picker-button.picker-button",
        "aria-label": tooltipContent,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iiRWr))), {
            label: "",
            spacing: "spacious",
            color: iconColor
        }),
        isDisabled: isDisabled,
        onClick: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? handleOnClick : onClick,
        ref: ref,
        "aria-haspopup": "true",
        "aria-expanded": isSelected,
        isSelected: isSelected,
        ...(0, $4cTDP.fg)('relay_migration_children_issues_section') ? {
            spacing: 'compact'
        } : {}
    }));
});
const $19f27efe9b61f432$export$d2ed0044a1cffec6 = ({ customIcon: customIcon, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = formatMessage(isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $fbuFM.default).addColumnTooltipText : (0, $fbuFM.default).tooltipText);
    if (isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: tooltipContent,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $19f27efe9b61f432$var$pressableStyles,
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
        label: tooltipContent
    })));
    const icon = customIcon ?? ((0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, (/*@__PURE__*/$parcel$interopDefault($2a3IQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: icon,
        label: tooltipContent,
        appearance: "subtle",
        isDisabled: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        "aria-label": formatMessage((0, $fbuFM.default).tooltipText),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iiRWr))), {
            color: "currentColor",
            label: ""
        }),
        isDisabled: true
    });
};
const $19f27efe9b61f432$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    borderRadius: "var(--ds-radius-small, 4px)",
    position: 'relative',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $19f27efe9b61f432$export$2e2bcd8739ae039 = $19f27efe9b61f432$var$PickerButton;

});
parcelRegister("2a3IQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cda528f9679d716d7f767e6ce4137c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192f672196aef77f$var$_react = $192f672196aef77f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $192f672196aef77f$var$_baseNew = $192f672196aef77f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $192f672196aef77f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $192f672196aef77f$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $192f672196aef77f$var$_react.default.createElement($192f672196aef77f$var$_baseNew.default, Object.assign({
        name: "TableColumnsDistributeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$192f672196aef77f$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $192f672196aef77f$var$_default = module.exports.default = $192f672196aef77f$var$TableColumnsDistributeIcon;

});

parcelRegister("fbuFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $066cf44b88090e47$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $066cf44b88090e47$var$messages = (0, $7qGN1.defineMessages)({
    tooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.tooltip-text",
        "defaultMessage": "Configure columns"
    },
    addColumnTooltipText: {
        "id": "issue-table-column-picker.column-picker.picker-button.add-column-tooltip-text",
        "defaultMessage": "Add column"
    },
    columnPickerButtonText: {
        "id": "issue-table-column-picker.column-picker.picker-button.column-picker-button-text",
        "defaultMessage": "Column picker menu"
    },
    chevronDownIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.chevron-down-icon-text",
        "defaultMessage": "Chevron down icon"
    },
    boardIconText: {
        "id": "issue-table-column-picker.column-picker.picker-button.board-icon-text",
        "defaultMessage": "board icon"
    }
});
var $066cf44b88090e47$export$2e2bcd8739ae039 = $066cf44b88090e47$var$messages;

});


parcelRegister("9NBLG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $40052367dcb6c307$export$2e2bcd8739ae039);

var $aJm6o = parcelRequire("aJm6o");

var $hMe0a = parcelRequire("hMe0a");

var $eJOHy = parcelRequire("eJOHy");

var $f0K4l = parcelRequire("f0K4l");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $99mLG = parcelRequire("99mLG");

var $fwzaq = parcelRequire("fwzaq");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $d9b92 = parcelRequire("d9b92");

var $cjRWP = parcelRequire("cjRWP");

var $o3Hdn = parcelRequire("o3Hdn");

var $gMbEk = parcelRequire("gMbEk");

var $6d9QY = parcelRequire("6d9QY");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $j8Km1 = parcelRequire("j8Km1");

var $d8Dow = parcelRequire("d8Dow");

var $5NRap = parcelRequire("5NRap");

var $PETi0 = parcelRequire("PETi0");

var $itmi8 = parcelRequire("itmi8");

var $ft2LQ = parcelRequire("ft2LQ");

var $fpyg5 = parcelRequire("fpyg5");
const $40052367dcb6c307$var$mapSelectedColumns = (0, $LFmXM.default)((fieldSets, canEditColumnConfiguration, formatMessage)=>fieldSets.edges.filter(Boolean).map((edge)=>{
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99mLG.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        return {
            optionType: 'option',
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            isDisabled: !canEditColumnConfiguration,
            isOnlyUnselectable: (0, $fpyg5.isOnlyUnselectableField)(edge.node.type, canEditColumnConfiguration),
            disabledMessage: (0, $fpyg5.getFieldDisabledMessage)(edge.node.type, formatMessage),
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                type: edge.node.type
            }
        };
    }));
const $40052367dcb6c307$var$ColumnConfig = ({ view: view, columns: columns, components: components, onChange: onChangeProp, onRestoreDefaultColumns: onRestoreDefaultColumnsProp, useColumnLoader: useColumnLoader, isLoading: isLoading = false, columnInsertIndex: columnInsertIndex, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isMergedColumnEnabled: isMergedColumnEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave, projectContext: projectContext })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isColumnUpdateInProgress = (0, $eJOHy.useRef)(false);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // This fragment should be moved to a different file whose responsibility is to provide the savedViewId
    const viewData = (0, $j4oe4.useFragment)((0, $hMe0a.default), view ?? null);
    const columnsData = (0, $j4oe4.useFragment)((0, $aJm6o.default), columns);
    const canEditColumnConfiguration = onChangeProp !== undefined;
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>{
        const columnPickerNumberOfColumns = columnsData.totalCount;
        const columnPickerFieldTypesSet = new Set();
        columnsData.edges.map((edge)=>edge?.node.type).filter(Boolean).forEach(columnPickerFieldTypesSet.add, columnPickerFieldTypesSet);
        const columnPickerFieldTypes = Array.from(columnPickerFieldTypesSet).sort();
        return {
            columnPickerNumberOfColumns: columnPickerNumberOfColumns,
            columnPickerFieldTypes: columnPickerFieldTypes,
            pickerType: 'columnConfiguration'
        };
    }, [
        columnsData.edges,
        columnsData.totalCount
    ]);
    const [selectedColumns, setSelectedColumns] = (0, $eJOHy.useState)(()=>$40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage));
    const mappedColumnsDataRef = (0, $eJOHy.useRef)($40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage));
    const prevColumnsDataRef = (0, $eJOHy.useRef)(columnsData);
    if (prevColumnsDataRef.current !== columnsData && (0, $4cTDP.fg)('jira_inline_field_config_gate')) {
        mappedColumnsDataRef.current = $40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage);
        prevColumnsDataRef.current = columnsData;
    }
    const selectedColumnsBeforeUpdateRef = (0, $eJOHy.useRef)(mappedColumnsDataRef.current);
    let backupFieldsRef;
    if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    backupFieldsRef = (0, $eJOHy.useRef)((0, $fpyg5.getRollbackFields)({
        environment: environment,
        fieldConfigId: columnsData.__id
    }));
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $PETi0.useColumnPickerOpenState)();
    const prevIsOpen = (0, $6d9QY.usePreviousWithInitial)(isOpen);
    (0, $eJOHy.useEffect)(()=>{
        // Recompute selected columns when picker renders in open state as config data may have changed
        if (!prevIsOpen && isOpen) setSelectedColumns($40052367dcb6c307$var$mapSelectedColumns(columnsData, canEditColumnConfiguration, formatMessage));
    }, [
        canEditColumnConfiguration,
        columnsData,
        formatMessage,
        isOpen,
        prevIsOpen
    ]);
    const [debouncedSetSelectedColumns] = (0, $fwzaq.default)((options, isHorizontalAutoScrollNeeded, onSuccessCallback, onErrorCallback, isHorizontalAutoScrollLeftNeeded)=>{
        const columnIds = options.map((option)=>(0, $gMbEk.isSingleValueOption)(option) ? option.value : undefined).filter(Boolean);
        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
            const attributes = {
                isInline: columnInsertIndex !== undefined,
                actionType: options.length < selectedColumnsBeforeUpdateRef.current.length ? (0, $d8Dow.REMOVE_COLUMNS) : (0, $d8Dow.ADD_COLUMNS)
            };
            onChangeProp && onChangeProp({
                columnIds: columnIds,
                onSuccessCallback: ()=>{
                    onSuccessCallback?.();
                    selectedColumnsBeforeUpdateRef.current = mappedColumnsDataRef.current;
                    if (backupFieldsRef) backupFieldsRef.current = (0, $fpyg5.getRollbackFields)({
                        environment: environment,
                        fieldConfigId: columnsData.__id
                    });
                },
                onErrorCallback: ()=>{
                    onErrorCallback?.();
                    if (backupFieldsRef) (0, $fpyg5.rollbackOptimisticFieldConfig)({
                        environment: environment,
                        fieldConfigId: columnsData.__id,
                        fields: backupFieldsRef?.current
                    });
                    setSelectedColumns(selectedColumnsBeforeUpdateRef.current);
                },
                isHorizontalAutoScrollNeeded: isHorizontalAutoScrollNeeded,
                isHorizontalAutoScrollLeftNeeded: isHorizontalAutoScrollLeftNeeded,
                analyticsAttributes: attributes
            });
        } else onChangeProp && onChangeProp(columnIds);
        isColumnUpdateInProgress.current = false;
    }, 1000);
    const handleOnChangeOld = (0, $eJOHy.useCallback)((options)=>{
        if ((0, $o3Hdn.isSelectOptionArray)(options)) {
            setSelectedColumns(options);
            debouncedSetSelectedColumns(options);
        }
    }, [
        debouncedSetSelectedColumns,
        setSelectedColumns
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((options, onSuccessCallback, onErrorCallback)=>{
        isColumnUpdateInProgress.current = true;
        if (!(0, $o3Hdn.isSelectOptionArray)(options)) return;
        if (mappedColumnsDataRef.current.length >= options.length) {
            const removedFields = (0, $fpyg5.findRemovedFields)(options, mappedColumnsDataRef.current);
            (0, $fpyg5.deleteOptimisticFieldConfig)({
                environment: environment,
                fieldConfigId: columnsData.__id,
                fields: removedFields
            });
            const newOptions = isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (0, $fpyg5.sortMergedColumnOptions)(options) : options;
            setSelectedColumns(newOptions);
            debouncedSetSelectedColumns(newOptions, false, onSuccessCallback, onErrorCallback, false);
            return;
        }
        const insertFields = (0, $fpyg5.findNewInsertFields)(options, mappedColumnsDataRef.current);
        const fields = [];
        insertFields.forEach((option)=>{
            if ((0, $gMbEk.isSingleValueOption)(option)) {
                const { label: label, value: value, type: type } = option;
                fields.push({
                    fieldSetId: value,
                    name: label,
                    type: type,
                    customWidth: option.customWidth
                });
            }
        });
        (0, $fpyg5.createOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsData.__id,
            fields: fields,
            createIndex: columnInsertIndex
        });
        let isHorizontalAutoScrollLeftNeeded = false;
        let updatedOptions = (0, $fpyg5.getUpdatedOptions)(mappedColumnsDataRef.current, insertFields, columnInsertIndex);
        if (isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
            updatedOptions = (0, $fpyg5.sortMergedColumnOptions)(updatedOptions);
            isHorizontalAutoScrollLeftNeeded = !!fields.find(({ fieldSetId: fieldSetId })=>(0, $j8Km1.MERGED_COLUMN_IDS).includes(fieldSetId));
        }
        setSelectedColumns(updatedOptions);
        debouncedSetSelectedColumns(updatedOptions, columnInsertIndex === undefined && !isHorizontalAutoScrollLeftNeeded, onSuccessCallback, onErrorCallback, isHorizontalAutoScrollLeftNeeded);
    }, [
        columnInsertIndex,
        columnsData.__id,
        debouncedSetSelectedColumns,
        environment,
        isMergedColumnEnabled
    ]);
    const handleOnOpen = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        const attributes = {
            actionType: 'open'
        };
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'ninDefaultsColumnPickerDialog', attributes);
        open();
    }, [
        createAnalyticsEvent,
        open
    ]);
    const onChange = (0, $eJOHy.useCallback)((options, meta, _, onSuccessCallback, onErrorCallback)=>{
        if (meta.action === (0, $d9b92.MetaActions).selectOption && (0, $o3Hdn.isSelectOptionArray)(options) && options.length > (0, $d8Dow.MAX_COLUMNS)) return;
        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) handleOnChange(options, onSuccessCallback, onErrorCallback);
        else handleOnChangeOld(options);
        let mergedFieldsCount = 0;
        if (Array.isArray(options) && (0, $4cTDP.fg)('jira_list_merged_column_gate')) options?.forEach((option)=>{
            if ('value' in option && (0, $j8Km1.MERGED_COLUMN_IDS).includes(option.value)) mergedFieldsCount += 1;
        });
        if (meta.action === (0, $d9b92.MetaActions).selectOption || meta.action === (0, $d9b92.MetaActions).deselectOption) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox changed', 'columnPickerField', {
            checkboxChecked: meta.action === (0, $d9b92.MetaActions).selectOption,
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                isInline: !!isInBetweenColumnPickerEnabled
            },
            ...meta.option && 'value' in meta.option && (0, $4cTDP.fg)('jira_list_merged_column_gate') && {
                fieldType: meta.option?.value
            },
            ...(0, $4cTDP.fg)('jira_list_merged_column_gate') && {
                isMergedColumnVisible: mergedFieldsCount > 1
            }
        });
    }, [
        createAnalyticsEvent,
        handleOnChange,
        handleOnChangeOld,
        isInBetweenColumnPickerEnabled
    ]);
    const loadOptions = useColumnLoader(selectedColumns, isInlineFieldConfigEnabled, projectContext, viewData?.savedViewId);
    const onRestoreDefaults = (0, $eJOHy.useCallback)(()=>{
        onRestoreDefaultColumnsProp && onRestoreDefaultColumnsProp();
        return [];
    }, [
        onRestoreDefaultColumnsProp
    ]);
    // Compute a set of all fieldSetIds that have been selected/deselected and not yet committed in the BE
    // Remove memoised data when cleaning up jira_inline_field_config_gate
    const nonCommittedFieldSetIds = (0, $eJOHy.useMemo)(()=>{
        const localFieldSetIds = selectedColumns.map((option)=>'value' in option ? option.value : undefined).filter((0, $5NRap.isNonNullish));
        const remoteFieldSetIds = columnsData.edges.filter((0, $5NRap.isNonNullish)).map((edge)=>edge.node.fieldSetId);
        return (0, $4cTDP.fg)('jira_inline_field_config_gate') ? new Set() : new Set((0, (/*@__PURE__*/$parcel$interopDefault($f0K4l)))(localFieldSetIds, remoteFieldSetIds));
    }, [
        columnsData.edges,
        selectedColumns
    ]);
    const formatOptionLabel = (0, $ft2LQ.useFormatOptionLabelWithShimmer)(nonCommittedFieldSetIds);
    const conditionalOnrestoreDefaults = onRestoreDefaultColumnsProp !== undefined ? onRestoreDefaults : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "fieldSearch",
        sourceType: (0, $aa42ce8e355d58fa$export$cae2783c9279926),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itmi8.default), {
        components: components,
        formatOptionLabel: formatOptionLabel,
        onLoadOptions: loadOptions,
        onChange: onChange,
        onSortOptions: isMergedColumnEnabled ? (0, $fpyg5.sortMergedColumnOptions) : undefined,
        onRestoreDefaults: conditionalOnrestoreDefaults,
        selectedColumns: selectedColumns,
        isOpen: isOpen,
        onOpen: handleOnOpen,
        onClose: close,
        isLoading: isLoading,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        ...(0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
            columnsDataId: columnsData.__id,
            columnInsertIndex: columnInsertIndex
        } : {},
        showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding,
        onPickerMouseEnter: onPickerMouseEnter,
        onPickerMouseLeave: onPickerMouseLeave
    }));
};
const $40052367dcb6c307$var$ColumnConfigWithContainer = (props)=>{
    const Container = props.components?.Container ?? (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40052367dcb6c307$var$ColumnConfig, props));
};
var $40052367dcb6c307$export$2e2bcd8739ae039 = $40052367dcb6c307$var$ColumnConfigWithContainer;

});
parcelRegister("aJm6o", function(module, exports) {
$parcel$export(module.exports, "default", () => $88e1ad27c9c858bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4457a7ce1b37b60bd16542e6e54badaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $88e1ad27c9c858bd$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ColumnConfigWithContainer",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                "action": "THROW",
                "path": "totalCount"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "fieldSetId"
                                        },
                                        "action": "THROW",
                                        "path": "edges.node.fieldSetId"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        "action": "THROW",
                                        "path": "edges.node.type"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v0 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "edges.node.displayName"
                                    },
                                    {
                                        "concreteType": "JiraFieldType",
                                        "kind": "LinkedField",
                                        "name": "fieldType",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "edges.node"
                        }
                    ]
                },
                "action": "THROW",
                "path": "edges"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueSearchFieldSetConnection"
    };
}();
$88e1ad27c9c858bd$var$node.hash = "3ae1385f88e17b8e9d2dda509c942a08";
var $88e1ad27c9c858bd$export$2e2bcd8739ae039 = $88e1ad27c9c858bd$var$node;

});

parcelRegister("hMe0a", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4c3320b880d0124$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<907e4fea993562414a0211669e4610ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d4c3320b880d0124$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ColumnConfigWithContainer_savedViewId",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$d4c3320b880d0124$var$node.hash = "afbf244a6fb59419cd38207a8d27060a";
var $d4c3320b880d0124$export$2e2bcd8739ae039 = $d4c3320b880d0124$var$node;

});

parcelRegister("f0K4l", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $l76qh = parcelRequire("l76qh");

var $hm1zt = parcelRequire("hm1zt");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $aeda977b669045b0$var$xor = $l76qh(function(arrays) {
    return $hm1zt($821Ou(arrays, $d1ShJ));
});
module.exports = $aeda977b669045b0$var$xor;

});
parcelRegister("hm1zt", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $1txRh = parcelRequire("1txRh");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $ca25b5c1c14f707f$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $1txRh(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $leN9Q(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $1txRh($72Qfa(result, 1), iteratee, comparator);
}
module.exports = $ca25b5c1c14f707f$var$baseXor;

});


parcelRegister("99mLG", function(module, exports) {
$parcel$export(module.exports, "fieldTypesIcons", () => $fdaf5e373b76ddd5$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $fdaf5e373b76ddd5$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $fdaf5e373b76ddd5$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $fdaf5e373b76ddd5$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $fdaf5e373b76ddd5$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $fdaf5e373b76ddd5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $leHbU = parcelRequire("leHbU");

var $fL0In = parcelRequire("fL0In");

var $9qes7 = parcelRequire("9qes7");

var $lmJ87 = parcelRequire("lmJ87");

var $awZZu = parcelRequire("awZZu");

var $1x1T9 = parcelRequire("1x1T9");

var $eALjj = parcelRequire("eALjj");

var $6F4i5 = parcelRequire("6F4i5");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $itRkB = parcelRequire("itRkB");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
const $fdaf5e373b76ddd5$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $fdaf5e373b76ddd5$var$TeamCfTypeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)));
const $fdaf5e373b76ddd5$var$checkedFieldTypesIcons = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    }),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    }),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    [(0, $3mZMJ.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.radioGlyph)
    }),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.doubleDropdownGlyph)
    }),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    [(0, $3mZMJ.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$TeamCfTypeIcon, {
        spacing: "spacious",
        label: ""
    }),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shipGlyph)
    }),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGroupGlyph)
    }),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.officeBuildingGlyph)
    }),
    [(0, $3mZMJ.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.attachmentGlyph)
    }),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    [(0, $3mZMJ.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    [(0, $3mZMJ.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.priorityGlyph)
    }),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeTrackingGlyph)
    }),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.originalTimeEstimateGlyph)
    }),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.screenGlyph)
    }),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    [(0, $3mZMJ.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.arrowRightGlyph)
    }),
    [(0, $3mZMJ.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shortTextGlyph)
    }),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.shortTextGlyph)
    }),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.checkboxGlyph)
    }),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.commentGlyph)
    }),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.appAccessGlyph)
    }),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.appAccessGlyph)
    }),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.folderGlyph)
    }),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    [(0, $3mZMJ.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.jwmCategoryGlyph)
    }),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    }),
    [(0, $3mZMJ.FORMULA_NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6F4i5))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$fdaf5e373b76ddd5$var$checkedFieldTypesIcons
});
const $fdaf5e373b76ddd5$export$67f993f3bbfb364d = $fdaf5e373b76ddd5$var$checkedFieldTypesIcons;
const $fdaf5e373b76ddd5$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
        label: "",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
        label: "",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1x1T9))), {
        label: "",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $fdaf5e373b76ddd5$var$allIcons = {
    ...$fdaf5e373b76ddd5$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdaf5e373b76ddd5$var$ResizedIcon, {
        glyph: (0, $itRkB.customFieldGlyph)
    })
};
const $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs = {
    [(0, $3mZMJ.NUMBER_CF_TYPE)]: (0, $itRkB.numberGlyph),
    [(0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $itRkB.numberGlyph),
    [(0, $3mZMJ.LABELS_CF_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.DATE_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.DATETIME_CF_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)]: (0, $itRkB.radioGlyph),
    [(0, $3mZMJ.SELECT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.MULTI_SELECT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.CASCADING_SELECT_CF_TYPE)]: (0, $itRkB.doubleDropdownGlyph),
    [(0, $3mZMJ.MULTI_VERSION_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.VERSION_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.GROUP_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.MULTI_GROUP_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.USER_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $leHbU.USERPICKER_FIELD_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.MULTI_USER_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $leHbU.MULTIUSERPICKER_FIELD_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.PEOPLE_CF_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.FLAGGED_CF_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.URL_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.TEAM_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.PARENT_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.BASELINE_START_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.BASELINE_END_CF_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.SPRINT_TYPE)]: (0, $itRkB.shipGlyph),
    [(0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $itRkB.peopleGroupGlyph),
    [(0, $3mZMJ.ORGANIZATIONS_CF_TYPE)]: (0, $itRkB.officeBuildingGlyph),
    [(0, $3mZMJ.REPORTER_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.ATTACHMENT_TYPE)]: (0, $itRkB.attachmentGlyph),
    [(0, $3mZMJ.ASSIGNEE_TYPE)]: (0, $itRkB.peopleGlyph),
    [(0, $3mZMJ.LABELS_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.PRIORITY_TYPE)]: (0, $itRkB.priorityGlyph),
    [(0, $3mZMJ.DUE_DATE_TYPE)]: (0, $itRkB.dateGlyph),
    [(0, $3mZMJ.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $itRkB.timeStampGlyph),
    [(0, $3mZMJ.TIME_TRACKING_TYPE)]: (0, $itRkB.timeTrackingGlyph),
    [(0, $3mZMJ.TIME_ESTIMATE_TYPE)]: (0, $itRkB.originalTimeEstimateGlyph),
    [(0, $3mZMJ.ASSETS_CF_TYPE)]: (0, $itRkB.screenGlyph),
    [(0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)]: (0, $itRkB.labelGlyph),
    [(0, $3mZMJ.STATUS_TYPE)]: (0, $itRkB.arrowRightGlyph),
    [(0, $3mZMJ.SUMMARY_TYPE)]: (0, $itRkB.shortTextGlyph),
    [(0, $leHbU.DESCRIPTION_FIELD_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.TEXT_CF_TYPE)]: (0, $itRkB.shortTextGlyph),
    [(0, $leHbU.TEXT_AREA_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)]: (0, $itRkB.checkboxGlyph),
    [(0, $3mZMJ.ISSUE_LINKS_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $leHbU.ENVIRONMENT_FIELD_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.FIX_VERSIONS_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.COMMENT_TYPE)]: (0, $itRkB.commentGlyph),
    [(0, $3mZMJ.APPROVERS_LIST_CF_TYPE)]: (0, $itRkB.appAccessGlyph),
    [(0, $3mZMJ.APPROVALS_CF_TYPE)]: (0, $itRkB.appAccessGlyph),
    [(0, $3mZMJ.PROJECT_PICKER_CF_TYPE)]: (0, $itRkB.folderGlyph),
    [(0, $3mZMJ.MESSAGE_EDIT_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.MESSAGE_VIEW_CF_TYPE)]: (0, $itRkB.paragraphGlyph),
    [(0, $3mZMJ.CATEGORY_TYPE)]: (0, $itRkB.jwmCategoryGlyph),
    [(0, $3mZMJ.ENTITLEMENT_CF_TYPE)]: (0, $itRkB.dropdownGlyph),
    [(0, $3mZMJ.SENTIMENT_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.ORGANIZATION_CF_TYPE)]: (0, $itRkB.customFieldGlyph),
    [(0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)]: (0, $itRkB.customFieldGlyph)
};
const $fdaf5e373b76ddd5$export$14355977bfae6aaa = {
    ...$fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs,
    text: (0, $itRkB.paragraphGlyph),
    number: (0, $itRkB.numberGlyph),
    date: (0, $itRkB.dateGlyph),
    datetime: (0, $itRkB.timeStampGlyph),
    dropdown: (0, $itRkB.dropdownGlyph),
    addon: (0, $itRkB.addonGlyph),
    checkbox: (0, $itRkB.checkboxGlyph),
    user: (0, $itRkB.peopleGlyph),
    radio: (0, $itRkB.radioGlyph),
    time: (0, $itRkB.timeStampGlyph),
    message: (0, $itRkB.commentGlyph),
    bulletList: (0, $itRkB.bulletListGlyph),
    label: (0, $itRkB.labelGlyph),
    labelpicker: (0, $itRkB.labelGlyph),
    close: (0, $itRkB.closeGlyph),
    assetspicker: (0, $itRkB.screenGlyph),
    select: (0, $itRkB.dropdownGlyph),
    multiselect: (0, $itRkB.dropdownGlyph),
    cascadingselect: (0, $itRkB.doubleDropdownGlyph),
    multigrouppicker: (0, $itRkB.dropdownGlyph),
    grouppicker: (0, $itRkB.dropdownGlyph),
    multiversion: (0, $itRkB.dropdownGlyph),
    version: (0, $itRkB.dropdownGlyph),
    projectpicker: (0, $itRkB.dropdownGlyph),
    customField: (0, $itRkB.customFieldGlyph)
};
const $fdaf5e373b76ddd5$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
        label: "",
        size: size,
        spacing: "spacious",
        testId: testId
    });
    if (type === (0, $3mZMJ.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    if (type === (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE) && (0, $4cTDP.fg)('atlassian_projects_admin_icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs[type] || $fdaf5e373b76ddd5$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    }));
});
const $fdaf5e373b76ddd5$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) {
        const iconSpacing = size === 'small' ? 'compact' : 'spacious';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
            label: "",
            size: size,
            spacing: iconSpacing,
            testId: testId
        });
    }
    if (type === (0, $3mZMJ.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    if (type === (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE) && (0, $4cTDP.fg)('atlassian_projects_admin_icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lmJ87))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $fdaf5e373b76ddd5$export$14355977bfae6aaa[type] || $fdaf5e373b76ddd5$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    }));
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $fdaf5e373b76ddd5$export$2e2bcd8739ae039 = $fdaf5e373b76ddd5$var$allIcons;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("1x1T9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151fe33e88b0ee8f745faaf0f04d86d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11da568a8257a9ac$var$_react = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11da568a8257a9ac$var$_baseNew = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11da568a8257a9ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11da568a8257a9ac$var$StopwatchIcon = (props)=>/*#__PURE__*/ $11da568a8257a9ac$var$_react.default.createElement($11da568a8257a9ac$var$_baseNew.default, Object.assign({
        name: "StopwatchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$11da568a8257a9ac$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $11da568a8257a9ac$var$_default = module.exports.default = $11da568a8257a9ac$var$StopwatchIcon;

});

parcelRegister("6F4i5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32871a9e1205ad83473907533912c2d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d99e67988431e9e$var$_react = $4d99e67988431e9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4d99e67988431e9e$var$_baseNew = $4d99e67988431e9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4d99e67988431e9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFormula".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for data formulas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d99e67988431e9e$var$DataFormulaIcon = (props)=>/*#__PURE__*/ $4d99e67988431e9e$var$_react.default.createElement($4d99e67988431e9e$var$_baseNew.default, Object.assign({
        name: "DataFormulaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9 0a2.5 2.5 0 0 1 2.5 2.5H10a1 1 0 0 0-1-1h-.12a1.12 1.12 0 0 0-1.11.967L7.354 5.5H10V7H7.146l-.93 6.738A2.62 2.62 0 0 1 1 13.38V13h1.5v.38a1.12 1.12 0 0 0 2.23.153L5.63 7H4V5.5h1.838l.446-3.238A2.62 2.62 0 0 1 8.88 0z"/><path fill="currentcolor" d="m15.052 9.008-2.392 2.598 1.948 2.706-1.216.877-1.768-2.456-2.322 2.525-1.104-1.016 2.53-2.752-1.836-2.552 1.216-.876 1.658 2.301 2.182-2.37z"/>`
    }, props));
$4d99e67988431e9e$var$DataFormulaIcon.displayName = 'DataFormulaIcon';
var $4d99e67988431e9e$var$_default = module.exports.default = $4d99e67988431e9e$var$DataFormulaIcon;

});

parcelRegister("itRkB", function(module, exports) {
$parcel$export(module.exports, "numberGlyph", () => $c548f0a472b13f77$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $c548f0a472b13f77$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $c548f0a472b13f77$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $c548f0a472b13f77$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $c548f0a472b13f77$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $c548f0a472b13f77$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $c548f0a472b13f77$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $c548f0a472b13f77$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $c548f0a472b13f77$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $c548f0a472b13f77$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $c548f0a472b13f77$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $c548f0a472b13f77$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $c548f0a472b13f77$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $c548f0a472b13f77$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $c548f0a472b13f77$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $c548f0a472b13f77$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $c548f0a472b13f77$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $c548f0a472b13f77$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $c548f0a472b13f77$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $c548f0a472b13f77$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $c548f0a472b13f77$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $c548f0a472b13f77$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $c548f0a472b13f77$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $c548f0a472b13f77$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $c548f0a472b13f77$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $c548f0a472b13f77$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $c548f0a472b13f77$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $c548f0a472b13f77$export$88453606d7da6ff7);

var $eJOHy = parcelRequire("eJOHy");
const $c548f0a472b13f77$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $c548f0a472b13f77$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $c548f0a472b13f77$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $c548f0a472b13f77$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("fwzaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    const callbackRef = (0, $eJOHy.useRef)(callback);
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("d9b92", function(module, exports) {
$parcel$export(module.exports, "MetaActions", () => $5ca44d217725f710$export$50531cf3046c5956);
const $5ca44d217725f710$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("cjRWP", function(module, exports) {
$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $fe2515622481ebd0$export$de24d837eb50c435);

var $eJOHy = parcelRequire("eJOHy");
const $fe2515622481ebd0$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("o3Hdn", function(module, exports) {
$parcel$export(module.exports, "isSelectOptionArray", () => $ca4870fcc6b451a8$export$4be42473522c84f6);
const $ca4870fcc6b451a8$export$4be42473522c84f6 = (options)=>options != null && Array.isArray(options);

});

parcelRegister("gMbEk", function(module, exports) {
$parcel$export(module.exports, "isSingleValueOption", () => $282a6706fedd463a$export$35faed52a6bc243e);
const $282a6706fedd463a$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("d8Dow", function(module, exports) {
$parcel$export(module.exports, "MAX_COLUMNS", () => $0ea88860b9e82601$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $0ea88860b9e82601$export$a6cff24b97727de1);
$parcel$export(module.exports, "REMOVE_COLUMNS", () => $0ea88860b9e82601$export$191e3e934175a609);
$parcel$export(module.exports, "ADD_COLUMNS", () => $0ea88860b9e82601$export$ccf17692f1fc979a);

var $3Zpjn = parcelRequire("3Zpjn");

const $0ea88860b9e82601$export$7ec4af037f372df4 = 500;
const $0ea88860b9e82601$export$a6cff24b97727de1 = (0, $3Zpjn.createGenericDebouncableDataLoader);
const $0ea88860b9e82601$export$191e3e934175a609 = 'REMOVE_COLUMNS';
const $0ea88860b9e82601$export$ccf17692f1fc979a = 'ADD_COLUMNS';

});
parcelRegister("3Zpjn", function(module, exports) {
$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});


parcelRegister("5NRap", function(module, exports) {
$parcel$export(module.exports, "isNonNullish", () => $4a6b75787dcaf92b$export$70573498ee17fe1d);
/**
 * Type predicate to determine that a value is not `null` or `undefined`.
 */ function $4a6b75787dcaf92b$export$70573498ee17fe1d(value) {
    return value != null;
}

});

parcelRegister("itmi8", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d34faeba17d9896$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1jVV7 = parcelRequire("1jVV7");

var $guChT = parcelRequire("guChT");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $lHHP1 = parcelRequire("lHHP1");

var $6sTi7 = parcelRequire("6sTi7");

var $fNOMn = parcelRequire("fNOMn");

var $437hw = parcelRequire("437hw");

var $ixh2S = parcelRequire("ixh2S");

var $7JbAM = parcelRequire("7JbAM");

var $eo5xA = parcelRequire("eo5xA");

var $cWT2N = parcelRequire("cWT2N");
const $8d34faeba17d9896$var$ColumnPicker = ({ components: components, selectedColumns: selectedColumns = [], isOpen: isOpen, onOpen: onOpen, onClose: onClose, zIndex: zIndex, isLoading: isLoading, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, columnsDataId: columnsDataId, showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding = false, columnInsertIndex: columnInsertIndex, onPickerMouseEnter: onPickerMouseEnter, onPickerMouseLeave: onPickerMouseLeave, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingMessages = (0, $eJOHy.useMemo)(()=>({
            paginationStart: formatMessage((0, $eo5xA.default).loadingMessageStart),
            paginationEnd: formatMessage((0, $eo5xA.default).loadingMessageEnd)
        }), [
        formatMessage
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]); // Define a CustomNoOptionsMessage component that supports rendering of custom help actions
    const CustomNoOptionsMessage = (0, $eJOHy.useCallback)(()=>components?.EmptyState !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(components.EmptyState, {
            closeColumnPicker: onClose
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7JbAM.default), null), [
        components,
        onClose
    ]); // Remove all the changeboarding on clean up of 'remove_nin_changeboarding_rll_usages', should be showing as empty fragments already
    const onTrigger = (0, $eJOHy.useCallback)(({ ref: ref })=>{
        const renderSpotlightCard = ({ onEndTour: onEndTour })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
                cardKey: (0, $6sTi7.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER,
                dialogWidth: 272,
                dialogPlacement: "left middle",
                actions: [
                    {
                        onClick: ()=>{
                            onEndTour();
                        },
                        text: formatMessage((0, $eo5xA.default).done)
                    }
                ],
                heading: formatMessage((0, $eo5xA.default).tourHeading),
                target: "nin.spotlight.column-picker",
                targetRadius: 3,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                messageId: "issue-table-column-picker.ui.column-picker.spotlight-tour-card.nin.spotlight.column-picker.spotlight",
                messageType: "transactional"
            }, formatMessage((0, $eo5xA.default).tourBody));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $437hw.default), {
            name: "nin.spotlight.column-picker",
            renderSpotlightCard: renderSpotlightCard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
            engagementId: "nin.native-issue-table.column-picker"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cWT2N.default), {
            isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
            onClick: onClick,
            ref: ref,
            isSelected: isOpen,
            customIcon: components?.Icon,
            isLoading: isLoading,
            onPickerMouseEnter: onPickerMouseEnter,
            onPickerMouseLeave: onPickerMouseLeave
        })));
    }, [
        isInBetweenColumnPickerEnabled,
        onClick,
        isOpen,
        components?.Icon,
        isLoading,
        formatMessage,
        onPickerMouseEnter,
        onPickerMouseLeave
    ]);
    const zIndexChangeEnabled = zIndex ?? (0, $1jVV7.layers).modal;
    const pickerComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8d34faeba17d9896$var$PickerContainer, {
        "data-testid": "issue-table-column-picker.ui.column-picker.column-picker-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        ...restProps,
        fallbackPlacements: isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? [
            'bottom-start'
        ] : [
            'left',
            'top-end'
        ],
        id: "column-picker",
        isOpen: isOpen,
        onClose: onClose,
        value: selectedColumns,
        zIndex: zIndexChangeEnabled,
        PopupComponent: components?.PopupComponent,
        placement: "bottom-end",
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        enableFullList: false,
        onTrigger: onTrigger,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        searchInputPlaceholder: (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $eo5xA.default).searchColumnPlaceholderNew) : formatMessage((0, $eo5xA.default).searchColumnPlaceholder),
        // bug where overflowing content with fixed positioning inside a sticky container can be cut off –
        // as a mitigation, we need to portal the popup component outside the table boundaries
        // @see https://jplat.jira.atlassian.cloud/browse/EM-7679
        // @see https://stackoverflow.com/q/70939616
        shouldRenderToParent: false,
        CustomFooter: // eslint-disable-next-line jira/ff/no-preconditioning
        components?.Footer && (0, $4cTDP.fg)('jira_inline_field_config_gate') && !(0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(components.Footer, {
            onPickerClose: onClose,
            columnsDataId: columnsDataId,
            columnInsertIndex: columnInsertIndex
        }) : undefined,
        renderFooter: // eslint-disable-next-line jira/ff/no-preconditioning
        components?.Footer && (0, $4cTDP.fg)('jira_inline_field_config_gate') && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? (rightSideComponent)=>{
            return components?.Footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(components.Footer, {
                onPickerClose: onClose,
                columnsDataId: columnsDataId,
                columnInsertIndex: columnInsertIndex,
                rightSideComponent: rightSideComponent
            }) : null;
        } : undefined,
        loadingMessages: loadingMessages
    }));
    return (showInlineFieldCreateOnboarding || !isInBetweenColumnPickerEnabled) && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: `inline-field-create-onboarding-column-picker-button.${isInBetweenColumnPickerEnabled ? 'in-between' : 'default'}`
    }, pickerComponent) : pickerComponent;
};
var $8d34faeba17d9896$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($8d34faeba17d9896$var$ColumnPicker);
const $8d34faeba17d9896$var$PickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pi7a9 _o5724jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lHHP1", function(module, exports) {
$parcel$export(module.exports, "NinChangeboardingContext", () => $c026bf20b22e170d$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $c026bf20b22e170d$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $c026bf20b22e170d$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $c026bf20b22e170d$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $c026bf20b22e170d$export$9e9f507adee88e58);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $cSXp8 = parcelRequire("cSXp8");

var $ezJEv = parcelRequire("ezJEv");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");

var $9ncIL = parcelRequire("9ncIL");

var $5Rrlj = parcelRequire("5Rrlj");

var $hqX3Z = parcelRequire("hqX3Z");

var $5gIAR = parcelRequire("5gIAR");
const $c026bf20b22e170d$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
const $c026bf20b22e170d$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c026bf20b22e170d$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c026bf20b22e170d$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $c026bf20b22e170d$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled || (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqX3Z.default), {
        engagementId: engagementId
    }, children);
};
const $c026bf20b22e170d$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    return !isTourEnabled || (0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrlj.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $c026bf20b22e170d$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $ezJEv.useHelpPanelLink)();
    const onLearnMore = (0, $eJOHy.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $9ncIL.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInTitleIssueTermRefresh : (0, $5gIAR.default).successOptInTitle,
                description: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInDescIssueTermRefresh : (0, $5gIAR.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $5gIAR.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("ezJEv", function(module, exports) {
$parcel$export(module.exports, "useHelpPanelLink", () => $906804a52fd3782f$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $906804a52fd3782f$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $906804a52fd3782f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $cxKOj = parcelRequire("cxKOj");
const $906804a52fd3782f$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $906804a52fd3782f$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $906804a52fd3782f$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $906804a52fd3782f$export$2e2bcd8739ae039 = $906804a52fd3782f$export$5a09250ffddd7fd1;
const $906804a52fd3782f$var$buttonWrapperStyles = null;
const $906804a52fd3782f$var$buttonWrapperSubtleStyles = null;

});
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;


parcelRegister("9ncIL", function(module, exports) {
$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $1b1bba2c09c1943d$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $1b1bba2c09c1943d$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $1b1bba2c09c1943d$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $1b1bba2c09c1943d$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $1b1bba2c09c1943d$export$d0079916fe6800ac);
const $1b1bba2c09c1943d$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $1b1bba2c09c1943d$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $1b1bba2c09c1943d$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $1b1bba2c09c1943d$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $1b1bba2c09c1943d$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $1b1bba2c09c1943d$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("5Rrlj", function(module, exports) {
$parcel$export(module.exports, "AsyncSpotlightCard", () => $09a720f6524e2b48$export$40e85aa59c198f98);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $09a720f6524e2b48$var$SpotlightCard = (0, $bQWwW.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("ePPqq")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $09a720f6524e2b48$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09a720f6524e2b48$var$SpotlightCard, props)));

});
parcelRegister("ePPqq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2ymnl").then(()=>parcelRequire('knqHM'));

});


parcelRegister("hqX3Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $a165742ed253731e$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a165742ed253731e$var$EngagementSpotlightAsync = (0, $bQWwW.lazy)(()=>(parcelRequire("fbCP6")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $a165742ed253731e$var$OldSpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a165742ed253731e$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
const $a165742ed253731e$var$SpotlightTourTarget = (0, $bJscI.componentWithFG)('remove_nin_changeboarding_rll_usages', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), $a165742ed253731e$var$OldSpotlightTourTarget);
var $a165742ed253731e$export$2e2bcd8739ae039 = $a165742ed253731e$var$SpotlightTourTarget;

});
parcelRegister("fbCP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("66OvY")
]).then(()=>parcelRequire('cf0I9'));

});


parcelRegister("5gIAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b48b63ba324164d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b48b63ba324164d9$var$messages = (0, $7qGN1.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $b48b63ba324164d9$export$2e2bcd8739ae039 = $b48b63ba324164d9$var$messages;

});


parcelRegister("6sTi7", function(module, exports) {
$parcel$export(module.exports, "cardKeys", () => $fe025dbff69a9482$export$79399c5778983d77);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $fe025dbff69a9482$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("fNOMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b9bd65aec627275$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b9bd65aec627275$var$SpotlightTourCardAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("aOhkZ")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $5b9bd65aec627275$var$SpotlightTourCardBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b9bd65aec627275$var$SpotlightTourCardAsync, props)));
const $5b9bd65aec627275$var$SpotlightTourCard = (0, $bJscI.componentWithFG)('remove_nin_changeboarding_rll_usages', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), $5b9bd65aec627275$var$SpotlightTourCardBase);
var $5b9bd65aec627275$export$2e2bcd8739ae039 = $5b9bd65aec627275$var$SpotlightTourCard;

});
parcelRegister("aOhkZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3L085").then(()=>parcelRequire('966Nd'));

});


parcelRegister("437hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7042db8e62785d$export$2e2bcd8739ae039);
// Remove this file on clean up of 'remove_nin_changeboarding_rll_usages'

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $gokBr = parcelRequire("gokBr");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $cb7042db8e62785d$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $gokBr.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $cb7042db8e62785d$export$2e2bcd8739ae039 = $cb7042db8e62785d$var$SpotlightTourTarget;

});
parcelRegister("gokBr", function(module, exports) {
$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $afabf68402b50fe5$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $afabf68402b50fe5$export$d0297e733168e478);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

const $afabf68402b50fe5$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $afabf68402b50fe5$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $afabf68402b50fe5$var$Store = (0, $GtRbT.createStore)({
    initialState: $afabf68402b50fe5$var$initialState,
    actions: $afabf68402b50fe5$var$actions
});
/**
 * Return `true` if the provided `cardKey` should be displayed as an active spotlight card.
 */ const $afabf68402b50fe5$var$useIsActiveSpotlightCardOld = (0, $iJq0l.createHook)($afabf68402b50fe5$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $afabf68402b50fe5$export$ac706a6842f43035 = (...args)=>{
    const oldResult = $afabf68402b50fe5$var$useIsActiveSpotlightCardOld(...args);
    if ((0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) return [
        false,
        {
            onSetActiveCard: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onEndTour: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }
    ];
    return oldResult;
};
const $afabf68402b50fe5$var$useSpotlightCoordinationActionsOld = (0, $iJq0l.createActionsHook)($afabf68402b50fe5$var$Store);
const $afabf68402b50fe5$export$d0297e733168e478 = (...args)=>{
    const oldResult = $afabf68402b50fe5$var$useSpotlightCoordinationActionsOld(...args);
    if ((0, $4cTDP.fg)('remove_nin_changeboarding_rll_usages')) return {
        onSetActiveCard: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEndTour: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    return oldResult;
};

});


parcelRegister("ixh2S", function(module, exports) {
$parcel$export(module.exports, "Picker", () => $e80b57c94adae16a$export$ba25329847403e11);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $6qaBj = parcelRequire("6qaBj");

var $4cTDP = parcelRequire("4cTDP");

var $d0VAM = parcelRequire("d0VAM");

var $hEe9x = parcelRequire("hEe9x");

var $5LwVz = parcelRequire("5LwVz");
const $e80b57c94adae16a$export$ba25329847403e11 = ({ isOpen: isPickerOpen, value: value, onClose: onClose, onClearValues: onClearValues, onRestoreDefaults: onRestoreDefaults, id: id, invalidLabel: invalidLabel, onChange: onChange, onSortOptions: onSortOptions, formatOptionLabel: formatOptionLabel = (0, $hEe9x.default), onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, PopupComponent: PopupComponent, onTrigger: onTrigger, placement: placement = 'bottom-start', zIndex: zIndex, CustomNoOptionsMessage: CustomNoOptionsMessage, pickerComponents: pickerComponents, fallbackPlacements: fallbackPlacements, showOperatorSelect: showOperatorSelect = false, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchInputPlaceholder: searchInputPlaceholder, shouldRenderToParent: shouldRenderToParent = false, experienceAnalyticsAttributes: experienceAnalyticsAttributes, isLoading: isLoading = false, CustomFooter: CustomFooter, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, loadingMessages: loadingMessages, renderFooter: renderFooter, verticalMode: verticalMode = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        role: "presentation",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') {
                // avoid closing a modal on closing a picker with esc key
                isPickerOpen && event.stopPropagation();
                onClose && onClose(event);
            }
        },
        xcss: (0, $6qaBj.cx)(verticalMode && $e80b57c94adae16a$var$styles.vertical)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        key: id,
        zIndex: zIndex,
        placement: placement,
        isOpen: isPickerOpen,
        onClose: onClose,
        popupComponent: PopupComponent ?? (0, $5LwVz.FixedWidthPopupComponent),
        trigger: onTrigger,
        autoFocus: false,
        fallbackPlacements: fallbackPlacements,
        testId: `jql-builder-basic-picker-${id}`,
        shouldRenderToParent: shouldRenderToParent,
        /* Our default popup component supports resizing to fit the viewport. */ shouldFitViewport: PopupComponent === undefined,
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d0VAM.default), {
                id: id,
                invalidLabel: invalidLabel,
                enableFullList: enableFullList,
                operandDisplayValues: operandDisplayValues,
                showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
                loadOptions: onLoadOptions,
                onChange: onChange,
                onSortOptions: onSortOptions,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                onRestoreDefaults: onRestoreDefaults,
                NoOptionsMessage: CustomNoOptionsMessage,
                components: pickerComponents,
                showOperatorSelect: showOperatorSelect,
                onChangeOperator: onChangeOperator,
                allowedOperators: allowedOperators,
                selectedOperator: selectedOperator,
                isMulti: isMulti,
                placeholder: searchInputPlaceholder,
                setInitialFocusRef: setInitialFocusRef,
                experienceAnalyticsAttributes: experienceAnalyticsAttributes,
                isLoading: isLoading,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                CustomFooter: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $4cTDP.fg)('jira_inline_field_config_gate') && !(0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? CustomFooter : undefined,
                loadingMessages: loadingMessages,
                renderFooter: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $4cTDP.fg)('jira_inline_field_config_gate') && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? renderFooter : undefined
            })
    }));
$e80b57c94adae16a$export$ba25329847403e11.whyDidYouRender = {
    customName: 'Picker'
};
const $e80b57c94adae16a$var$styles = {
    vertical: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc"
};

});
parcelRegister("d0VAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bc6c8c7998de8b9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gyBpf = parcelRequire("gyBpf");

var $cSmYj = parcelRequire("cSmYj");

var $4B7rn = parcelRequire("4B7rn");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $9cbmy = parcelRequire("9cbmy");

var $gMbEk = parcelRequire("gMbEk");

var $j8m5Z = parcelRequire("j8m5Z");

var $f3ko0 = parcelRequire("f3ko0");

var $f1iCr = parcelRequire("f1iCr");

var $1fUys = parcelRequire("1fUys");

var $5lNLi = parcelRequire("5lNLi");

var $j7wtI = parcelRequire("j7wtI");

var $fSowc = parcelRequire("fSowc");

var $icknm = parcelRequire("icknm");

var $bWslp = parcelRequire("bWslp");

var $7XraK = parcelRequire("7XraK");
const $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $8bc6c8c7998de8b9$var$selectStyles = {
    container: (baseStyles)=>({
            ...baseStyles,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        })
};
const $8bc6c8c7998de8b9$var$getLoadingMessage = ({ isLoadingPaginationStart: isLoadingPaginationStart, isLoadingPaginationEnd: isLoadingPaginationEnd, loadingMessages: loadingMessages, formatMessage: formatMessage })=>{
    if (isLoadingPaginationStart) return loadingMessages?.paginationStart || formatMessage((0, $7XraK.default).loadingStart);
    if (isLoadingPaginationEnd) return loadingMessages?.paginationEnd || formatMessage((0, $7XraK.default).loadingEnd);
    return undefined;
};
const $8bc6c8c7998de8b9$export$f2aa4c50966ce803 = ()=>(0, $eJOHy.useState)(false);
const $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView = ({ id: id, onMenuScrollToBottom: onMenuScrollToBottom, onMenuScrollToTop: onMenuScrollToTop, placeholder: placeholder, invalidLabel: invalidLabel, enableFullList: enableFullListProp, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, loadOptions: loadOptions, onInputChange: onInputChange, value: value, onChange: onChange, onChangeOperator: onChangeOperator, onSortOptions: onSortOptions, onClear: onClear, onRestoreDefaults: onRestoreDefaults, components: customComponents, showOperatorSelect: showOperatorSelect, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, isLoading: isLoadingExternal, CustomFooter: CustomFooter, onKeyDown: onKeyDown, loadingMessages: loadingMessages, renderFooter: renderFooter, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const paginatedComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.selectComponents),
            MenuList: $f3ko0.MenuList
        }), []);
    const paginatedSingleSelectComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.singleSelectComponents),
            Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fSowc.default), {
                    ...props,
                    isMulti: false
                }),
            MenuList: $f3ko0.MenuList
        }), []);
    const [isLoadingInternal, setIsLoading] = (0, $eJOHy.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = $8bc6c8c7998de8b9$export$f2aa4c50966ce803();
    const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $eJOHy.useState)([]);
    const rollbackOptionsRef = (0, $eJOHy.useRef)(loadedOptions);
    const [enableFullList, setEnableFullList] = (0, $eJOHy.useState)(enableFullListProp || false);
    const [totalCount, setTotalCount] = (0, $eJOHy.useState)(null);
    const [endCursor, setEndCursor] = (0, $eJOHy.useState)(undefined);
    const loadingScreenMessage = (0, $eJOHy.useRef)(undefined);
    const [error, setError] = (0, $eJOHy.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const isLoading = isLoadingInternal || isLoadingExternal;
    const prevIsPaginationLoading = (0, $6d9QY.usePreviousWithInitial)(isPaginationLoading);
    const hasFinishedPaginationLoading = prevIsPaginationLoading && !isPaginationLoading;
    loadingScreenMessage.current = $8bc6c8c7998de8b9$var$getLoadingMessage({
        isLoadingPaginationStart: Boolean(isPaginationLoading && !prevIsPaginationLoading),
        isLoadingPaginationEnd: hasFinishedPaginationLoading,
        loadingMessages: loadingMessages,
        formatMessage: formatMessage
    });
    const searchRef = (0, $eJOHy.useRef)('');
    const isColumnChangeInProgress = (0, $eJOHy.useRef)(false);
    const itemCount = (0, $eJOHy.useMemo)(()=>loadedOptions.flatMap((option)=>option.optionType === 'group' ? option.options : option).length, [
        loadedOptions
    ]);
    const getTotalCountWithFunctions = (0, $eJOHy.useCallback)((newTotalCount)=>{
        if (newTotalCount === null || !operandDisplayValues?.length) return newTotalCount;
        let newTotalCountWithKeywords;
        if (showOperandDisplayValuesInFullList === true) newTotalCountWithKeywords = newTotalCount + operandDisplayValues.length;
        else newTotalCountWithKeywords = newTotalCount + value.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && operandDisplayValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT;
    }, [
        operandDisplayValues,
        showOperandDisplayValuesInFullList,
        value
    ]);
    const checkIfError = (0, $eJOHy.useCallback)((search, options, onRetry)=>{
        const errorOption = options.find((option)=>option.optionType === 'error' && option.error instanceof Error);
        if (errorOption && errorOption.optionType === 'error') {
            setError({
                isError: true,
                error: errorOption.error,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $eJOHy.useCallback)((search, overridenValue, renderInitialValues = enableFullList)=>{
        if (!loadOptions) return;
        searchRef.current = search;
        setIsLoading(true);
        loadOptions(search, renderInitialValues, undefined, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            // Handle error
            if (checkIfError(search, options, ()=>{
                handleLoadOptions(search);
            })) return; // This is to prevent outdated options/results from overriding if a race condition occurs
            if (searchRef.current !== search) return;
            if (search) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, options)) {
                    setLoadedOptions(options);
                    setTotalCount(newTotalCount);
                }
            } else {
                const newLoadedOptions = (0, $bWslp.generateOptions)([
                    ...overridenValue ?? value
                ], options);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, newLoadedOptions)) {
                    setLoadedOptions(newLoadedOptions);
                    setTotalCount(getTotalCountWithFunctions(newTotalCount));
                }
            }
            setEndCursor(newEndCursor);
            setIsLoading(false);
        });
    }, [
        loadOptions,
        enableFullList,
        checkIfError,
        value,
        loadedOptions,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $eJOHy.useCallback)((firstLoad = false, isRetry = false)=>{
        if (!loadOptions || !loadedOptions) return;
        let originalLoadedOptions;
        if (firstLoad) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, endCursor, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(firstLoad, true);
            })) return;
            const newLoadedOptions = inputValue ? originalLoadedOptions.concat(options) : (0, $bWslp.generateOptions)(value, options, originalLoadedOptions, firstLoad);
            setEnableFullList(false);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setLoadedOptions(newLoadedOptions);
            setIsPaginationLoading(false);
            setIsLoading(false);
            setEndCursor(newEndCursor);
        });
    }, [
        loadOptions,
        loadedOptions,
        inputValue,
        endCursor,
        checkIfError,
        value,
        getTotalCountWithFunctions,
        setIsPaginationLoading
    ]);
    const handleShowFullList = (0, $eJOHy.useCallback)(()=>{
        handleShowMore(true);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $eJOHy.useCallback)((newInputValue)=>{
        // on empty search: reset to default state for pickers where enableFullListProp==true
        if (newInputValue.length === 0 && enableFullListProp) {
            setEnableFullList(true);
            handleLoadOptions(newInputValue, undefined, true);
        } else {
            setEnableFullList(false);
            handleLoadOptions(newInputValue);
        }
        setInputValue(newInputValue);
        onInputChange && onInputChange();
    }, [
        enableFullListProp,
        handleLoadOptions,
        onInputChange
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((options, meta)=>{
        if (!isColumnChangeInProgress.current && (0, $4cTDP.fg)('jira_inline_field_config_gate')) {
            isColumnChangeInProgress.current = true;
            rollbackOptionsRef.current = loadedOptions;
        }
        if ('option' in meta && meta.option) {
            const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(loadedOptions, (option)=>(0, $gMbEk.isSingleValueOption)(option) && meta.option !== undefined && (0, $gMbEk.isSingleValueOption)(meta.option) && option.value === meta.option.value);
            onChange && onChange(options, meta, {
                selectedIndex: selectedIndex
            }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
                isColumnChangeInProgress.current = false;
            } : undefined, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
                setLoadedOptions(rollbackOptionsRef.current);
                isColumnChangeInProgress.current = false;
            } : undefined);
        } else onChange && onChange(options, meta, undefined, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
            isColumnChangeInProgress.current = false;
        } : undefined, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? ()=>{
            setLoadedOptions(rollbackOptionsRef.current);
            isColumnChangeInProgress.current = false;
        } : undefined);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleOnRestoreDefaults = (0, $eJOHy.useCallback)(()=>{
        if (typeof onRestoreDefaults === 'function') {
            const defaultOptions = onRestoreDefaults(); // Reset picker input and force update of options to go back to an initial-like state where selected options are on top
            setInputValue('');
            handleLoadOptions('', defaultOptions);
        }
    }, [
        handleLoadOptions,
        onRestoreDefaults
    ]); // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        handleLoadOptions(''); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsWithFullList = (0, $eJOHy.useMemo)(()=>{
        let newLoadedOptions = loadedOptions;
        if (onSortOptions && !(0, $4cTDP.fg)('jira_inline_field_config_gate') && (0, $4cTDP.fg)('jira_list_merged_column_gate')) newLoadedOptions = onSortOptions(newLoadedOptions);
        return (0, $bWslp.addFullListToOptions)(newLoadedOptions, !enableFullList, onSortOptions);
    }, [
        loadedOptions,
        enableFullList,
        onSortOptions
    ]);
    const components = (0, $eJOHy.useMemo)(()=>isMulti ? {
            ...paginatedComponents,
            ...customComponents
        } : {
            ...paginatedSingleSelectComponents,
            ...customComponents
        }, [
        customComponents,
        isMulti,
        paginatedComponents,
        paginatedSingleSelectComponents
    ]);
    const selectedValue = (0, $eJOHy.useMemo)(/**
   * This method is to form the value from loadedOptionsWithFullList Array so that the 'Options' and 'Value' props of
   * select component will have same object references, This is a workaround to meet the below condition in the '@atlaskit/select'
   * component's ariaFocused method
   * var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));.
   * This condition must work to announce the state of selection.
   *
   * The below method can be removed if the above condition is improved to check just the value instead of reference.
   */ ()=>(0, $bWslp.getValueFromOptions)(loadedOptionsWithFullList, value), [
        loadedOptionsWithFullList,
        value
    ]);
    const showFooterType = (0, $eJOHy.useMemo)(()=>{
        const showFooter = !isLoading && loadedOptions && Boolean(loadedOptions.length) && !error.isError;
        if (showFooter) {
            if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) {
                if (CustomFooter != null || renderFooter != null && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return 'custom';
            }
            return 'default';
        }
    }, [
        CustomFooter,
        error.isError,
        isLoading,
        loadedOptions,
        renderFooter
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (isPaginationLoading && event.key === 'ArrowUp' || isPaginationLoading && event.key === 'ArrowDown' || isLoading && event.key === 'ArrowUp' || isLoading && event.key === 'ArrowDown') {
            // prevent focusing first option when loading of more options
            event.preventDefault();
            return;
        }
        onKeyDown?.(event);
    }, [
        isLoading,
        isPaginationLoading,
        onKeyDown
    ]);
    const footerComponent = (0, $eJOHy.useMemo)(()=>{
        if (renderFooter && (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return renderFooter(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.SimplePaginationDetails), {
            itemsCount: itemCount,
            totalCount: totalCount
        }));
        return CustomFooter;
    }, [
        renderFooter,
        CustomFooter,
        itemCount,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOperatorSelect && onChangeOperator && allowedOperators && Boolean(allowedOperators.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f1iCr.OperatorsSelect), {
        onChange: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7wtI.BaseSelect), {
        components: components,
        inputValue: inputValue,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: onMenuScrollToBottom,
        onMenuScrollToTop: onMenuScrollToTop,
        placeholder: placeholder,
        id: id,
        invalidLabel: invalidLabel,
        options: loadedOptionsWithFullList,
        setInitialFocusRef: setInitialFocusRef,
        menuListProps: {
            error: error,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            isShowMoreEnabled: totalCount !== null && itemCount < totalCount
        },
        onChange: handleOnChange,
        value: selectedValue,
        styles: $8bc6c8c7998de8b9$var$selectStyles,
        ...restProps,
        isMulti: isMulti,
        totalCount: totalCount,
        onKeyDown: handleOnKeyDown
    }), showFooterType === 'default' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bc6c8c7998de8b9$var$Footer, null, onRestoreDefaults !== undefined ? typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5lNLi.default), {
        onRestoreDefaults: handleOnRestoreDefaults
    }) : Boolean(value.length) && isMulti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j8m5Z.default), {
        onClear: onClear
    }), (!value.length || !isMulti) && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icknm.default), {
        onShowFullList: handleShowFullList
    }), !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.PaginationDetails), {
        itemsCount: itemCount,
        totalCount: totalCount
    })), showFooterType === 'custom' && footerComponent, loadingScreenMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, loadingScreenMessage.current), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
var $8bc6c8c7998de8b9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView;
const $8bc6c8c7998de8b9$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dog0l8 _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gyBpf", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0dcd66d5aa7faa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c0dcd66d5aa7faa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c9FP3(fromIndex);
    if (index < 0) index = $c0dcd66d5aa7faa7$var$nativeMax(length + index, 0);
    return $9gUEB(array, $1lM9j(predicate, 3), index);
}
module.exports = $c0dcd66d5aa7faa7$var$findIndex;

});

parcelRegister("j8m5Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ce8dc8742c8663f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $aFyWG = parcelRequire("aFyWG");

var $6vNSg = parcelRequire("6vNSg");
const $4ce8dc8742c8663f$export$1d4b7cda9e589b53 = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClearSelectedItems = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'filterSearchClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    const message = formatMessage((0, $6vNSg.default).clearAllSelectedItemsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.clear-selection-button.clear-selected-items",
        hasTooltip: true
    });
};
var $4ce8dc8742c8663f$export$2e2bcd8739ae039 = $4ce8dc8742c8663f$export$1d4b7cda9e589b53;

});
parcelRegister("aFyWG", function(module, exports) {
$parcel$export(module.exports, "LeftFooterButton", () => $0affafe94b46ba2e$export$edc8e1365283b1f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $6XJko = parcelRequire("6XJko");
const $0affafe94b46ba2e$export$edc8e1365283b1f0 = ({ message: message, onClick: onClick, testId: testId, appearance: appearance, hasTooltip: hasTooltip, label: label })=>{
    const shouldApplyVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId
    }, message);
    if (!hasTooltip) {
        if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            padding: "space.050",
            xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: appearance,
            onClick: onClick,
            testId: testId
        }, message));
    }
    if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.050",
        xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId,
        ...label && {
            'aria-label': label
        }
    }, message)));
};
const $0affafe94b46ba2e$var$leftFooterButtonContainerStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    marginInlineStart: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0affafe94b46ba2e$var$LeftFooterButtonContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _ahbqu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6vNSg", function(module, exports) {
$parcel$export(module.exports, "default", () => $069e3a8465402294$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $069e3a8465402294$var$messages = (0, $7qGN1.defineMessages)({
    clearAllSelectedItemsButtonText: {
        "id": "jql-builder-basic-picker.async-select.clear-selection-button.clear-all-selected-items-button-text",
        "defaultMessage": "Clear selection"
    }
});
var $069e3a8465402294$export$2e2bcd8739ae039 = $069e3a8465402294$var$messages;

});


parcelRegister("f3ko0", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $810d101605fb454f$export$d4c4e98c5044dc8);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $6XEne = parcelRequire("6XEne");

var $kRgKj = parcelRequire("kRgKj");

var $4P0pd = parcelRequire("4P0pd");

var $9LD2u = parcelRequire("9LD2u");

var $lhCeH = parcelRequire("lhCeH");
const $810d101605fb454f$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, isShowMoreEnabled: isShowMoreEnabled } } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnShowMore = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'options',
            action: 'scrolled'
        }), 'filterSearchShowMore');
        handleShowMore();
    }, [
        handleShowMore,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LD2u.default), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P0pd.default), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children, isShowMoreEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhCeH.default), {
        onShowMore: handleOnShowMore,
        isPaginationLoading: isPaginationLoading
    }))));
};
var $810d101605fb454f$export$2e2bcd8739ae039 = $810d101605fb454f$export$d4c4e98c5044dc8;

});
parcelRegister("4P0pd", function(module, exports) {
$parcel$export(module.exports, "default", () => $068e9aea02769269$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cb8jR = parcelRequire("cb8jR");

var $ipK0z = parcelRequire("ipK0z");
const $068e9aea02769269$var$ErrorMessage = ({ onRetry: onRetry })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        onRetry?.();
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'refinementBarSelectRetry clicked');
    }, [
        onRetry,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 144,
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, formatMessage((0, $ipK0z.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "jql-builder-basic-picker.ui.async-select.menu-list.error-message.retry-button"
    }, formatMessage((0, $ipK0z.default).retryMessage)));
};
var $068e9aea02769269$export$2e2bcd8739ae039 = $068e9aea02769269$var$ErrorMessage;

});
parcelRegister("cb8jR", function(module, exports) {
$parcel$export(module.exports, "StyledBox", () => $965991b8073d69d7$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $965991b8073d69d7$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $965991b8073d69d7$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $965991b8073d69d7$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $965991b8073d69d7$export$6833d6d22987ee7f);
$parcel$export(module.exports, "CustomOptionStyles", () => $965991b8073d69d7$export$fa3694617a82202b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $965991b8073d69d7$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1qr7",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($965991b8073d69d7$var$StyledTextComponent, props));
const $965991b8073d69d7$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1pvm _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$94756becb802e330 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80omtlke _30l31bsc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { displayFlag: displayFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.displayFlag ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$fa3694617a82202b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasIconAfter: hasIconAfter, isSingleSelect: isSingleSelect, isFocused: isFocused, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfm9xv": (0, $awdRS.default)(__cmplp.isFocused ? `inset 2px 0px 0px ${"var(--ds-border-focused, #388BFF)"}` : 'none'),
            "--_1p23kyf": (0, $awdRS.default)(__cmplp.isDisabled ? 'color.text.disabled' : 'color.text')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _dzc2v2br _m3zku2gc",
            __cmplp.hasIconAfter ? "_sktr1ejb" : "_sktrze3t",
            __cmplp.isSingleSelect && "_bp7o1fcu _ngc03plq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ipK0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0214a23e274561c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c0214a23e274561c$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $c0214a23e274561c$export$2e2bcd8739ae039 = $c0214a23e274561c$var$messages;

});


parcelRegister("9LD2u", function(module, exports) {
$parcel$export(module.exports, "default", () => $da95119f1df2e865$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $kDaaB = parcelRequire("kDaaB");

var $cb8jR = parcelRequire("cb8jR");

var $dyWxb = parcelRequire("dyWxb");
const $da95119f1df2e865$export$e928a71d039d3102 = ()=>// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-@atlassian/a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $da95119f1df2e865$var$listItemStyle,
        role: "option",
        "aria-selected": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.loading-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dyWxb.default).loadingMessage))));
var $da95119f1df2e865$export$2e2bcd8739ae039 = $da95119f1df2e865$export$e928a71d039d3102;
const $da95119f1df2e865$var$listItemStyle = (0, $1DXK0.xcss)({
    listStyle: 'none'
});

});
parcelRegister("dyWxb", function(module, exports) {
$parcel$export(module.exports, "default", () => $9012dc4eef88d2fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9012dc4eef88d2fd$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message",
        "defaultMessage": "Loading..."
    }
});
var $9012dc4eef88d2fd$export$2e2bcd8739ae039 = $9012dc4eef88d2fd$var$messages;

});


parcelRegister("lhCeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $553b58ca6b88f3b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $1R4YX = parcelRequire("1R4YX");

var $aJkOP = parcelRequire("aJkOP");
const $553b58ca6b88f3b1$var$LoadMoreTrigger = ({ onShowMore: onShowMore, isPaginationLoading: isPaginationLoading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    const loadMoreRef = (0, $1R4YX.useIntersectionObserver)({
        margin: 0,
        onIntersection: ()=>{
            if (!isPaginationLoading) {
                loadingRef?.current?.scrollIntoView();
                onShowMore();
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "option",
        "aria-hidden": "true",
        "aria-selected": false,
        ref: loadingRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $553b58ca6b88f3b1$var$loadingContainerStyles,
        justifyContent: "center",
        alignItems: "center",
        ref: loadMoreRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        label: formatMessage((0, $aJkOP.default).loadingLabel)
    })));
};
const $553b58ca6b88f3b1$var$loadingContainerStyles = (0, $1DXK0.xcss)({
    height: '56px'
});
var $553b58ca6b88f3b1$export$2e2bcd8739ae039 = $553b58ca6b88f3b1$var$LoadMoreTrigger;

});
parcelRegister("1R4YX", function(module, exports) {
$parcel$export(module.exports, "useIntersectionObserver", () => $01379305a4b54492$export$a7395f9832c00176);

var $eJOHy = parcelRequire("eJOHy");
const $01379305a4b54492$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});

parcelRegister("aJkOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c10a5a4e92317e0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9c10a5a4e92317e0$var$messages = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        "id": "jql-builder-basic-picker.async-select.menu-list.load-more-trigger.loading-label",
        "defaultMessage": "Loading"
    }
});
var $9c10a5a4e92317e0$export$2e2bcd8739ae039 = $9c10a5a4e92317e0$var$messages;

});



parcelRegister("f1iCr", function(module, exports) {
$parcel$export(module.exports, "OperatorsSelect", () => $45891c3f91875637$export$72ded8b112fe0b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $8nu6j = parcelRequire("8nu6j");

var $c4OV1 = parcelRequire("c4OV1");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cO6Ov = parcelRequire("cO6Ov");
const $45891c3f91875637$var$selectStyles = {
    control: (baseStyles)=>({
            ...baseStyles,
            backgroundColor: "var(--ds-background-neutral, #091E420F)"
        })
};
const $45891c3f91875637$var$styles = {
    operatorsSelectOld: "_u5f3utpp _19bvutpp _ca0qu2gc",
    operatorsSelect: "_u5f3utpp _19bvutpp _ca0qze3t _n3tdu2gc"
};
const $45891c3f91875637$var$getOptionLabel = (option)=>option.ariaLabel;
const $45891c3f91875637$var$formatOptionLabel = (option)=>option.label;
const $45891c3f91875637$export$72ded8b112fe0b1 = ({ onChange: onChange, allowedOperators: allowedOperators, selectedOperator: selectedOperator })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeWithAnalytics = (0, $eJOHy.useCallback)((option)=>{
        onChange && onChange(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const onMenuOpenAnalytics = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $k0ahr.cx)((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? $45891c3f91875637$var$styles.operatorsSelect : $45891c3f91875637$var$styles.operatorsSelectOld)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $cO6Ov.default).operatorLabel),
        value: selectedOperator || allowedOperators[0],
        options: allowedOperators,
        onChange: onChangeWithAnalytics,
        spacing: "compact",
        appearance: "subtle",
        styles: $45891c3f91875637$var$selectStyles,
        onKeyDown: onKeyDown,
        onMenuOpen: onMenuOpenAnalytics,
        isSearchable: false,
        getOptionLabel: $45891c3f91875637$var$getOptionLabel,
        formatOptionLabel: $45891c3f91875637$var$formatOptionLabel
    }));
};

});
parcelRegister("cO6Ov", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c4c55cc3aef0b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b1c4c55cc3aef0b4$var$messages = (0, $7qGN1.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic-picker.async-select.operator-select.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $b1c4c55cc3aef0b4$export$2e2bcd8739ae039 = $b1c4c55cc3aef0b4$var$messages;

});


parcelRegister("1fUys", function(module, exports) {
$parcel$export(module.exports, "PaginationDetails", () => $60bd543addf3cb57$export$33eb0288c0936a84);
$parcel$export(module.exports, "SimplePaginationDetails", () => $60bd543addf3cb57$export$b7935720442eff68);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kCiis = parcelRequire("kCiis");
const $60bd543addf3cb57$var$styles = {
    paginationDetails: "_11c82smr _y3gnusic _syaz131l _16jlkb7n _1o9zidpf _i0dl1wug _19pkze3t _2hwxutpp _otyrze3t _18u0utpp",
    fontMedium: "_k48p1wq8"
};
const $60bd543addf3cb57$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (totalCount == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details",
        className: (0, $hcewu.default)([
            $60bd543addf3cb57$var$styles.paginationDetails,
            (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') && $60bd543addf3cb57$var$styles.fontMedium
        ])
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};
const $60bd543addf3cb57$export$b7935720442eff68 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};

});
parcelRegister("kCiis", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ca9967a4a24ae17$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6ca9967a4a24ae17$var$messages = (0, $7qGN1.defineMessages)({
    ofTotalCount: {
        "id": "jql-builder-basic-picker.async-select.pagination-details.of-total-count",
        "defaultMessage": "{itemsCount} of {totalCount}"
    }
});
var $6ca9967a4a24ae17$export$2e2bcd8739ae039 = $6ca9967a4a24ae17$var$messages;

});


parcelRegister("5lNLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce6429fb8860ba26$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $aFyWG = parcelRequire("aFyWG");

var $5HR61 = parcelRequire("5HR61");
const $ce6429fb8860ba26$export$2543cc45221bf5bc = ({ onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleRestoreDefaults = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    const message = formatMessage((0, $5HR61.default).restoreDefaultsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleRestoreDefaults,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.restore-defaults-button",
        hasTooltip: true
    });
};
var $ce6429fb8860ba26$export$2e2bcd8739ae039 = $ce6429fb8860ba26$export$2543cc45221bf5bc;

});
parcelRegister("5HR61", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f7feca5c1b3e4c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1f7feca5c1b3e4c8$var$messages = (0, $7qGN1.defineMessages)({
    restoreDefaultsButtonText: {
        "id": "jql-builder-basic-picker.async-select.restore-defaults-button.restore-defaults-button-text",
        "defaultMessage": "Restore defaults"
    }
});
var $1f7feca5c1b3e4c8$export$2e2bcd8739ae039 = $1f7feca5c1b3e4c8$var$messages;

});


parcelRegister("j7wtI", function(module, exports) {
$parcel$export(module.exports, "selectComponents", () => $952582033f9b0a69$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "singleSelectComponents", () => $952582033f9b0a69$export$6161e15c6859b0c9);
$parcel$export(module.exports, "BaseSelect", () => $952582033f9b0a69$export$dcee1aa94a106d27);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $mjinE = parcelRequire("mjinE");

var $dMM78 = parcelRequire("dMM78");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $d9b92 = parcelRequire("d9b92");

var $gMbEk = parcelRequire("gMbEk");


var $gWVN2 = parcelRequire("gWVN2");

var $62EHB = parcelRequire("62EHB");

var $aeAJB = parcelRequire("aeAJB");

var $35vKc = parcelRequire("35vKc");

var $3UBK2 = parcelRequire("3UBK2");

var $fSowc = parcelRequire("fSowc");

var $j1sv5 = parcelRequire("j1sv5");
const $952582033f9b0a69$export$c34d65c0f5a1c617 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: ()=>null,
    Menu: $aeAJB.default,
    Option: $fSowc.default
};
const $952582033f9b0a69$export$6161e15c6859b0c9 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: undefined,
    Menu: $aeAJB.default
};
const $952582033f9b0a69$var$onIsOptionDisabled = (option, value)=>{
    if (option.optionType === 'error') return true;
    // if an option is only unselectable and currently selected, it should not be a disabled option
    if ('isOnlyUnselectable' in option && option.isOnlyUnselectable) {
        const isSelectedOption = (0, $gMbEk.isSingleValueOption)(option) && value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) && v.value).includes(option.value);
        return !(isSelectedOption && option.isOnlyUnselectable);
    }
    if ('isDisabled' in option && option.isDisabled) return option.isDisabled;
    return false;
};
// Needed to disable filtering from react-select
const $952582033f9b0a69$var$noFilterOptions = ()=>true;
const $952582033f9b0a69$export$dcee1aa94a106d27 = ({ onReload: onReload, placeholder: placeholder, NoOptionsMessage: NoOptionsMessage = (0, $3UBK2.default), isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, totalCount: totalCount, components: componentsSelect, options: options, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, ...restProps })=>{
    const { onInputChange: onInputChangeProp, inputValue: inputValueProp, id: id, menuListProps: { isLoading: isLoading, error: { isError: isError, error: error } }, experienceAnalyticsAttributes: experienceAnalyticsAttributes, value: value } = restProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)(); // use any type for react-select ref
    const [inputValue, setInputValue] = (0, $eJOHy.useState)(inputValueProp ?? '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        // only set once when the component mounted
        if (selectRef.current && setInitialFocusRef) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        setInitialFocusRef(selectRef.current.select.inputRef);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (options && !(isLoading ?? false)) {
            let errorType = 'unknown';
            if (error != null && (0, $dMM78.isClientFetchError)(error)) errorType = 'networkError';
            const errorAttributes = error ? {
                errorType: errorType,
                message: error.message
            } : null;
            (0, $mjinE.default)({
                analyticsSource: 'refinement-bar-select',
                wasExperienceSuccesful: error == null,
                experience: 'showOptions',
                application: null,
                edition: null,
                additionalAttributes: {
                    filter: id ?? 'unknown',
                    ...experienceAnalyticsAttributes,
                    ...errorAttributes
                }
            });
        }
    }, [
        isError,
        error,
        isLoading,
        options,
        id,
        experienceAnalyticsAttributes
    ]);
    const hasEnabledOption = (0, $eJOHy.useMemo)(()=>options?.some((option)=>!$952582033f9b0a69$var$onIsOptionDisabled(option, value)), [
        options,
        value
    ]);
    const onInputChange = (0, $eJOHy.useCallback)((newInputValue, meta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blured.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if (Array.from([
            (0, $d9b92.MetaActions).setValue,
            (0, $d9b92.MetaActions).inputBlur,
            (0, $d9b92.MetaActions).menuClose
        ]).includes(meta.action) && !newInputValue.length) return;
        // Reload defaultOptions in case of potential error by changing key on AsyncSelect
        if (meta.action === (0, $d9b92.MetaActions).inputChange && !newInputValue.length) onReload?.('');
        onInputChangeProp && onInputChangeProp(newInputValue, meta);
        setInputValue(newInputValue);
    }, [
        onInputChangeProp,
        onReload
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setInputValue(inputValueProp);
    }, [
        inputValueProp
    ]);
    const getOptionLabel = (0, $eJOHy.useCallback)((option)=>{
        if ((0, $gMbEk.isSingleValueOption)(option)) {
            if (typeof option.secondaryLabel === 'string') return `${option.label}, ${option.secondaryLabel}`;
            if (// remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
            typeof option.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option.secondaryLabel)) return `${option.label}, ${option.secondaryLabel.label}`;
            return option.label;
        }
        return option.optionType === 'group' ? option?.label ?? '' : '';
    }, []);
    // placeholder type is reactNode and aria-label won't allow, for safe side checking the type and empty value
    const ariaLabel = typeof placeholder === 'string' && placeholder ? placeholder : formatMessage((0, $35vKc.default).searchPlaceholder);
    const OriginalOptionComponent = componentsSelect?.Option || undefined;
    // Note: this is a workaround to not visually focus any option, when there are only disabled options in the list
    // react-select autofocuses the first option, see more here: https://github.com/JedWatson/react-select/pull/4080
    // tracked bug ticket: https://product-fabric.atlassian.net/browse/DSP-17138
    const OptionComponentExtended = (0, $eJOHy.useCallback)((props)=>OriginalOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OriginalOptionComponent, {
            ...props,
            isFocused: hasEnabledOption ? props.isFocused : false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), [
        OriginalOptionComponent,
        hasEnabledOption
    ]);
    const unselectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!isInBetweenColumnPickerEnabled) return [];
        if (!inputValue) return (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? options?.filter((option)=>option.optionType === 'group' && option.id !== (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) || [] : options?.filter((option)=>option.optionType === 'group') || [];
        const selectedOptions = new Set(value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) ? v.value : ''));
        return options?.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && !selectedOptions.has(option.value)) || [];
    }, [
        isInBetweenColumnPickerEnabled,
        inputValue,
        options,
        value
    ]);
    const memoizedComponents = (0, $eJOHy.useMemo)(()=>{
        const totalCountOfUnselectedFields = totalCount ? totalCount - value.length : null;
        let groupComponents = {};
        if ((0, $4cTDP.fg)('jira_inline_field_config_gate')) groupComponents = {
            GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeading), {
                    ...props,
                    totalCount: totalCountOfUnselectedFields
                })
        };
        // this changes should override the IFC changes
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) groupComponents = {
            GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeadingNew), props),
            Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.Group), props)
        };
        return {
            ...componentsSelect,
            ...groupComponents,
            ...OriginalOptionComponent !== undefined ? {
                Option: OptionComponentExtended
            } : {}
        };
    }, [
        componentsSelect,
        OriginalOptionComponent,
        OptionComponentExtended,
        totalCount,
        value.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        ...restProps,
        options: isInBetweenColumnPickerEnabled && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? unselectedOptions : options,
        // Using classNamePrefix to identify the select component in cypress test, testId doesn't work (doc https://atlassian.design/components/select/testing)
        classNamePrefix: "jql-builder-basic-picker-atlaskit-select",
        components: memoizedComponents,
        cacheOptions: false,
        ref: selectRef,
        autoFocus: !setInitialFocusRef,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: isMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        onInputChange: onInputChange,
        isOptionDisabled: $952582033f9b0a69$var$onIsOptionDisabled,
        reload: onReload,
        filterOption: $952582033f9b0a69$var$noFilterOptions,
        placeholder: placeholder ?? formatMessage((0, $35vKc.default).searchPlaceholder),
        label: ariaLabel,
        noOptionsMessage: NoOptionsMessage,
        getOptionLabel: getOptionLabel
    });
};

});
const $398aa02f7b594968$export$eb85a4c9b5d9ce7b = 'all-columns';
const $398aa02f7b594968$export$bfd1c05c2e5a5a01 = 'selected-columns';

parcelRegister("gWVN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c50f99a84b41b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $cb8jR = parcelRequire("cb8jR");
const $0c50f99a84b41b08$var$styles = {
    control: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1elr _1e0c1txw _syaz131l _19pkze3t _2hwxutpp _otyrze3t _18u0utpp _jyzf1p6i _1u6lq049",
    wrapper: "_1e0c1txw _4cvr1h6o _19bvu2gc"
};
const $0c50f99a84b41b08$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: innerRef ?? undefined,
        ...innerProps,
        className: (0, $hcewu.default)([
            $0c50f99a84b41b08$var$styles.control
        ])
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $0c50f99a84b41b08$var$styles.wrapper
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    })), children);
    return /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.StyledControl), {
        ref: innerRef ?? undefined,
        ...innerProps
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $0c50f99a84b41b08$var$styles.wrapper
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    })), children);
};
var $0c50f99a84b41b08$export$2e2bcd8739ae039 = $0c50f99a84b41b08$export$7a7fa4424cb20976;

});

parcelRegister("62EHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $54055c12a318bc3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $a03qM = parcelRequire("a03qM");

var $bQP4O = parcelRequire("bQP4O");

var $dt3aG = parcelRequire("dt3aG");

var $6XEne = parcelRequire("6XEne");

var $4cTDP = parcelRequire("4cTDP");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");
const $54055c12a318bc3b$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o",
    dropdownIndicatorWrapperOld: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    iconWrapper: "_2rko1rr0 _1e0c1txw _80omtlke _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz131l _30l31dyx"
};
const $54055c12a318bc3b$export$ec98719d3db7f2e4 = (props)=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $6XEne.components).DropdownIndicator, props, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? $54055c12a318bc3b$var$styles.dropdownIndicatorWrapper : $54055c12a318bc3b$var$styles.dropdownIndicatorWrapperOld
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: props.selectProps.inputValue
    }, (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? /*#__PURE__*/ $eJOHy.createElement((0, $bQP4O.default), {
        xcss: $54055c12a318bc3b$var$styles.iconWrapper,
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        },
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.CloseIconWrapper), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon",
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    }))), !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    }))));
};
var $54055c12a318bc3b$export$2e2bcd8739ae039 = $54055c12a318bc3b$export$ec98719d3db7f2e4;

});

parcelRegister("aeAJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b7f34fee106459a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4b7f34fee106459a$var$Menu = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b7f34fee106459a$var$MenuBox, {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);
var $4b7f34fee106459a$export$2e2bcd8739ae039 = $4b7f34fee106459a$var$Menu;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4b7f34fee106459a$var$MenuBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("35vKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6409cd14587ac6e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b6409cd14587ac6e$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic-picker.async-select.select.search-placeholder",
        "defaultMessage": "Search"
    }
});
var $b6409cd14587ac6e$export$2e2bcd8739ae039 = $b6409cd14587ac6e$var$messages;

});

parcelRegister("3UBK2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba06491bbd0f20a1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $kDaaB = parcelRequire("kDaaB");

var $eS29z = parcelRequire("eS29z");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");

var $lWJ0U = parcelRequire("lWJ0U");
const $ba06491bbd0f20a1$var$NoOptionsMessageContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.150",
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsMessage)));
};
const $ba06491bbd0f20a1$export$d58b72b7d3c4072c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.select.no-options-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba06491bbd0f20a1$var$NoOptionsMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "noMatches"
    }));
var $ba06491bbd0f20a1$export$2e2bcd8739ae039 = $ba06491bbd0f20a1$export$d58b72b7d3c4072c;

});
parcelRegister("lWJ0U", function(module, exports) {
$parcel$export(module.exports, "default", () => $43e390d646017ea1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $43e390d646017ea1$var$messages = (0, $7qGN1.defineMessages)({
    noOptionsMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-message",
        "defaultMessage": "No matches found"
    },
    noOptionsPrimaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});
var $43e390d646017ea1$export$2e2bcd8739ae039 = $43e390d646017ea1$var$messages;

});


parcelRegister("fSowc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c802979ef0e97e4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $2R0ne = parcelRequire("2R0ne");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $jzkyh = parcelRequire("jzkyh");
var $6XEne = parcelRequire("6XEne");

var $k71qx = parcelRequire("k71qx");

var $8cv11 = parcelRequire("8cv11");

var $cb8jR = parcelRequire("cb8jR");

var $1MOGE = parcelRequire("1MOGE");
const $9c802979ef0e97e4$var$tooltipStyles = null;
const $9c802979ef0e97e4$var$ConditionalTooltip = ({ condition: condition, content: content, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: content
    }, children) : children;
const $9c802979ef0e97e4$export$36d18380658d5d20 = ({ isMulti: isMulti = true, ...props })=>{
    const iconRef = (0, $eJOHy.useRef)(null);
    const { isOnlyUnselectable: isOnlyUnselectable, disabledMessage: disabledMessage, invalid: invalid } = props.data?.optionType === 'option' || props.data?.optionType === 'avatar' || props.data?.optionType === 'lozenge' || props.data?.optionType === 'field' ? props.data : {
        isOnlyUnselectable: undefined,
        disabledMessage: undefined,
        invalid: undefined
    };
    // Only disable checkbox for an only unselectable option when it is not a selected option
    const optionState = (0, $1MOGE.getOptionState)(props.isDisabled, Boolean(isOnlyUnselectable), props.isSelected, Boolean(invalid));
    const hasIconAfter = ()=>{
        switch(optionState){
            case 'only-unselectable-unselected':
            case 'only-unselectable-selected':
            case 'disabled':
                return Boolean(disabledMessage);
            case 'invalid':
                return true;
            default:
                return undefined;
        }
    };
    const OptionInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $9c802979ef0e97e4$export$d318e19053d98641[optionState].xcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.CustomOptionStyles), {
        hasIconAfter: hasIconAfter(),
        isFocused: props.isFocused,
        isDisabled: props.isDisabled,
        isSingleSelect: true
    }, isMulti ? /* @ts-expect-error - This component has stricter OptionType args which isn't compatible with ErrorOption in SelectOption. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jzkyh.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...props,
        isMulti: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$TooltipContainer, {
        ref: iconRef
    }, optionState !== 'invalid' && Boolean(disabledMessage) && // Show a tooltip for mouse users, since option.isFocused is not triggered for disabled options on mouse over
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$ConditionalTooltip, {
        content: disabledMessage,
        condition: props.isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.info-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    })), optionState === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.invalid-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": $9c802979ef0e97e4$export$d318e19053d98641[optionState].testid
    }, optionState === 'only-unselectable-unselected' || optionState === 'disabled' || optionState === 'invalid' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$UnsafeStyledCheckboxOption, null, OptionInner) : OptionInner), (disabledMessage || props.selectProps?.invalidLabel && optionState === 'invalid') && props.isFocused && iconRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        referenceElement: iconRef.current,
        placement: "bottom",
        messageType: "transactional",
        messageId: "jql-builder-basic-picker.ui.async-select.select.option.popper"
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            style: style,
            className: (0, $hcewu.default)([
                "_2rko12b0 _11c8dcr7 _vchhusvi _p12fp3fh _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
            ])
        }, optionState === 'invalid' ? props.selectProps?.invalidLabel : disabledMessage))));
};
var $9c802979ef0e97e4$export$2e2bcd8739ae039 = $9c802979ef0e97e4$export$36d18380658d5d20;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c802979ef0e97e4$var$UnsafeStyledCheckboxOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nrk9jdj5",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0p1rm _u5f3utpp _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles = (0, $1DXK0.xcss)({
    color: 'color.text.disabled'
});
const $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9c802979ef0e97e4$export$d318e19053d98641 = {
    disabled: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.disabled-option',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    invalid: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.invalid-option',
        xcss: [
            $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles
        ]
    },
    selected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option',
        xcss: []
    },
    unselected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option',
        xcss: []
    },
    'only-unselectable-unselected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.only-unselectable',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    'only-unselectable-selected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option.only-unselectable',
        xcss: []
    }
};

});
parcelRegister("jzkyh", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $c59673c02b42adcb$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $c59673c02b42adcb$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dwm7g = parcelRequire("dwm7g");

var $279SN = parcelRequire("279SN");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
const $c59673c02b42adcb$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112e126o",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $c59673c02b42adcb$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $c59673c02b42adcb$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c59673c02b42adcb$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $c59673c02b42adcb$var$baseIconStyles = null;
const $c59673c02b42adcb$var$baseOptionStyles = null;
const $c59673c02b42adcb$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $c59673c02b42adcb$var$optionStyles.default,
            isFocused && $c59673c02b42adcb$var$optionStyles.focused,
            isDisabled && $c59673c02b42adcb$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $c59673c02b42adcb$var$iconStyles.inherit : $c59673c02b42adcb$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $c59673c02b42adcb$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c59673c02b42adcb$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $c59673c02b42adcb$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($dwm7g))),
        ...props
    });
const $c59673c02b42adcb$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($279SN))),
        ...props
    });

});
parcelRegister("dwm7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7f6b5a4b54b43d$var$_react = $9d7f6b5a4b54b43d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9d7f6b5a4b54b43d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7f6b5a4b54b43d$var$CheckboxIcon = (props)=>/*#__PURE__*/ $9d7f6b5a4b54b43d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$9d7f6b5a4b54b43d$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $9d7f6b5a4b54b43d$var$_default = module.exports.default = $9d7f6b5a4b54b43d$var$CheckboxIcon;

});

parcelRegister("279SN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18a3e6b70b5fecb4$var$_react = $18a3e6b70b5fecb4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $18a3e6b70b5fecb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $18a3e6b70b5fecb4$var$RadioIcon = (props)=>/*#__PURE__*/ $18a3e6b70b5fecb4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$18a3e6b70b5fecb4$var$RadioIcon.displayName = 'RadioIcon';
var $18a3e6b70b5fecb4$var$_default = module.exports.default = $18a3e6b70b5fecb4$var$RadioIcon;

});


parcelRegister("8cv11", function(module, exports) {
$parcel$export(module.exports, "JiraPopper", () => $7c774b4266762c6b$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8qmYl = parcelRequire("8qmYl");

var $bRMVI = parcelRequire("bRMVI");

var $k3Xbr = parcelRequire("k3Xbr");
const $7c774b4266762c6b$export$23789575ac361b5d = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3Xbr.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), rest);
};

});
parcelRegister("k3Xbr", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPopper", () => $035f7c874f3f3baa$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $8qmYl = parcelRequire("8qmYl");

var $5hQBi = parcelRequire("5hQBi");
const $035f7c874f3f3baa$export$6077de4a190b560c = (0, $5hQBi.withChoreographedRender)((0, $8qmYl.Popper));

});


parcelRegister("1MOGE", function(module, exports) {
$parcel$export(module.exports, "getOptionState", () => $af5121b5036d97d9$export$e651787bf17e8335);
const $af5121b5036d97d9$export$e651787bf17e8335 = (isDisabled, isOnlyUnselectable, isSelected, isInvalid)=>{
    if (isDisabled) return 'disabled';
    if (isOnlyUnselectable && !isSelected) return 'only-unselectable-unselected';
    if (isInvalid) return 'invalid';
    if (isOnlyUnselectable && isSelected) return 'only-unselectable-selected';
    if (isSelected) return 'selected';
    return 'unselected';
};

});


parcelRegister("j1sv5", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $f8d83750115807b5$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "GroupHeadingNew", () => $f8d83750115807b5$export$68d21e17c31e791a);
$parcel$export(module.exports, "Group", () => $f8d83750115807b5$export$eb2fcfdbd7ba97d4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");

var $6XEne = parcelRequire("6XEne");

const $f8d83750115807b5$var$styles = {
    groupHeading: "_1e0c1txw _4cvr1h6o _1bah1yb4",
    borderGroup: "_n7zl7r9e _ca0qze3t _otyru2gc",
    allColumnsGroup: "_ca0qze3t"
};
const $f8d83750115807b5$var$HeadingContent = ({ label: label, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f8d83750115807b5$var$styles.groupHeading,
        paddingBlockEnd: "space.075",
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, label?.toLocaleUpperCase()), totalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle"
    }, totalCount));
};
const $f8d83750115807b5$export$85c8b41a3cd87edc = ({ data: data, totalCount: totalCount, ...restProps })=>{
    const { id: id, label: label } = data;
    switch(id){
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83750115807b5$var$HeadingContent, {
                label: label,
                totalCount: totalCount
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).GroupHeading, {
                ...restProps,
                data: data
            });
    }
};
const $f8d83750115807b5$export$68d21e17c31e791a = ({ data: data, ...props })=>{
    const { id: id } = data;
    switch(id){
        // no heading for these groups
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
        case 0, $398aa02f7b594968$export$bfd1c05c2e5a5a01:
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).GroupHeading, {
                ...props,
                data: data
            });
    }
};
const $f8d83750115807b5$export$eb2fcfdbd7ba97d4 = ({ data: data, ...props })=>{
    const { id: id } = data;
    // selected columns group should have a border bottom divider
    if (id === (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...props,
        data: data,
        xcss: $f8d83750115807b5$var$styles.borderGroup
    });
    if (id === (0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...props,
        data: data,
        xcss: $f8d83750115807b5$var$styles.allColumnsGroup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...props,
        data: data
    });
};

});


parcelRegister("icknm", function(module, exports) {
$parcel$export(module.exports, "default", () => $295f45065da2298c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $aFyWG = parcelRequire("aFyWG");

var $8quwH = parcelRequire("8quwH");
const $295f45065da2298c$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleShowFullList = (0, $eJOHy.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'expanded',
            actionSubject: 'filterSearch',
            actionSubjectId: 'refinementBarFilterSearch'
        });
        const attributes = {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: e.detail === 0
        };
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        createAnalyticsEvent,
        onShowFullList
    ]);
    const message = formatMessage((0, $8quwH.default).showFullListButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.show-full-list-button.show-full-list-button",
        hasTooltip: true
    });
};
var $295f45065da2298c$export$2e2bcd8739ae039 = $295f45065da2298c$export$bf0956d66cd7566b;

});
parcelRegister("8quwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa637fe2306205e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $aa637fe2306205e4$var$messages = (0, $7qGN1.defineMessages)({
    showFullListButtonText: {
        "id": "jql-builder-basic-picker.async-select.show-full-list-button.show-full-list-button-text",
        "defaultMessage": "Show full list"
    }
});
var $aa637fe2306205e4$export$2e2bcd8739ae039 = $aa637fe2306205e4$var$messages;

});


parcelRegister("bWslp", function(module, exports) {
$parcel$export(module.exports, "addFullListToOptions", () => $c7a0e88bf351185c$export$f3b09dca68236b3);
$parcel$export(module.exports, "generateOptions", () => $c7a0e88bf351185c$export$c21133b4499f5374);
$parcel$export(module.exports, "getValueFromOptions", () => $c7a0e88bf351185c$export$cc4ee748665ecf20);

var $4cTDP = parcelRequire("4cTDP");

var $gMbEk = parcelRequire("gMbEk");

const $c7a0e88bf351185c$export$17aec06b00a4043e = (keys, options, option)=>{
    if ((0, $gMbEk.isSingleValueOption)(option) && !keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
    // If the option is a group, we either append to an existing group or add a new group
    if (option.optionType === 'group') {
        const foundDuplicateGroup = options.some((o)=>'label' in o && o.label === option.label);
        if (foundDuplicateGroup) option.options.forEach((groupVal)=>{
            const existingGroup = options.find((o)=>'label' in o && o.label === option.label);
            if (existingGroup && existingGroup.optionType === 'group') {
                const newOptions = [
                    ...existingGroup?.options,
                    groupVal
                ];
                existingGroup.options = newOptions;
            }
        });
        else options.push(option);
    }
};
const $c7a0e88bf351185c$export$f3b09dca68236b3 = (options, fullList, onSortOptions)=>options.map((option)=>{
        switch(option.optionType){
            case 'group':
                {
                    const newOptions = $c7a0e88bf351185c$export$f3b09dca68236b3(option.options, fullList, onSortOptions);
                    return {
                        ...option,
                        options: onSortOptions && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? onSortOptions(newOptions) : newOptions
                    };
                }
            case 'avatar':
            case 'lozenge':
            case 'option':
                {
                    // keep same object reference to keep focus on same option on pagination
                    const optionRef = option;
                    optionRef.fullList = fullList;
                    return optionRef;
                }
            default:
                return option;
        }
    });
const $c7a0e88bf351185c$export$c21133b4499f5374 = (selected, data, previousData, addSelectedFirst = true)=>{
    // Handle currently selected
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) {
        // add selected options as a group
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) {
            const groupSelectedOptions = [];
            selected && selected.forEach((val)=>{
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupSelectedOptions, val);
            });
            if (groupSelectedOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                id: (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01),
                optionType: 'group',
                options: groupSelectedOptions,
                label: 'Selected columns'
            });
        } else selected && selected.forEach((val)=>{
            $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
        });
    }
    if (previousData) // add previous loaded options
    previousData.forEach((val)=>{
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    data && data.forEach((val)=>{
        // Add group options
        if (val && val.optionType === 'group') {
            const groupOptions = [];
            val.options.forEach((groupVal)=>{
                // removing values from the group that are already in the options list (e.g. selected values, values from previousData)
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupOptions, groupVal);
            });
            if (groupOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                ...val,
                options: groupOptions,
                optionType: 'group'
            });
            return;
        }
        // add individual options
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    return options;
};
const $c7a0e88bf351185c$export$cc4ee748665ecf20 = (loadedOptionsWithFullList, value)=>{
    if (loadedOptionsWithFullList.length === 0) return value;
    const loadedOptionsWithFullListFlat = loadedOptionsWithFullList.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    return value.map((selectedValue)=>loadedOptionsWithFullListFlat.find((option)=>(0, $gMbEk.isSingleValueOption)(option) && (0, $gMbEk.isSingleValueOption)(selectedValue) && selectedValue.value === option.value) || selectedValue);
};

});

parcelRegister("7XraK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6bbce5e4b9b1a0a$var$messages = (0, $7qGN1.defineMessages)({
    loadingStart: {
        "id": "jql-builder-basic-picker.async-select.loading-start",
        "defaultMessage": "Loading more"
    },
    loadingEnd: {
        "id": "jql-builder-basic-picker.async-select.loading-end",
        "defaultMessage": "Finished loading"
    }
});
var $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039 = $e6bbce5e4b9b1a0a$var$messages;

});


parcelRegister("hEe9x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d51a2057bdff96c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g5nWu = parcelRequire("g5nWu");

var $7PBuN = parcelRequire("7PBuN");

var $5xIBb = parcelRequire("5xIBb");
const $9d51a2057bdff96c$var$formatOptionLabel = (data)=>{
    switch(data.optionType){
        case 'avatar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5nWu.default), {
                data: data
            });
        case 'lozenge':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xIBb.default), {
                data: data
            });
        case 'option':
        case 'field':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PBuN.default), {
                data: data
            });
        default:
            return null;
    }
};
var $9d51a2057bdff96c$export$2e2bcd8739ae039 = $9d51a2057bdff96c$var$formatOptionLabel;

});
parcelRegister("g5nWu", function(module, exports) {
$parcel$export(module.exports, "default", () => $53de91e06cefcdc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $hxN6p = parcelRequire("hxN6p");

var $lRq8t = parcelRequire("lRq8t");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");

var $lCwqw = parcelRequire("lCwqw");
const $53de91e06cefcdc0$export$fe00f602c942368a = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.hideAvatar !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, data.isGroup === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StylesGroupIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.group-icon",
        label: formatMessage((0, $lCwqw.default).groupIcon)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: typeof data.avatar !== 'string' ? undefined : data.avatar,
        size: "xsmall",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.avatar",
        appearance: typeof data.square === 'boolean' && data.square === true ? 'square' : 'circle'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage)));
};
var $53de91e06cefcdc0$export$2e2bcd8739ae039 = $53de91e06cefcdc0$export$fe00f602c942368a;

});
parcelRegister("buJG5", function(module, exports) {
$parcel$export(module.exports, "ConditionalTooltip", () => $f134232f4e230d4e$export$d8abb7a1cfbd4b6b);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $f134232f4e230d4e$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("jMiTg", function(module, exports) {
$parcel$export(module.exports, "PICKER_DROPDOWN_WIDTH", () => $53e13f8b42d31da6$export$ca493ca2aa631e47);
$parcel$export(module.exports, "StyledOption", () => $53e13f8b42d31da6$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledLabel", () => $53e13f8b42d31da6$export$eea83358d9434634);
$parcel$export(module.exports, "StyledLabelIcon", () => $53e13f8b42d31da6$export$282e0b7f297acea7);
$parcel$export(module.exports, "StyledIcon", () => $53e13f8b42d31da6$export$7c8f159da0dc916);
$parcel$export(module.exports, "StyledLabelText", () => $53e13f8b42d31da6$export$601dc5d21f1e8182);
$parcel$export(module.exports, "StyledLozenge", () => $53e13f8b42d31da6$export$fb418b53e6535057);
$parcel$export(module.exports, "StyledLozengeLabel", () => $53e13f8b42d31da6$export$cd2803f359bf9865);
$parcel$export(module.exports, "StyledSecondaryLabel", () => $53e13f8b42d31da6$export$385a11497793b305);
$parcel$export(module.exports, "StylesGroupIconContainer", () => $53e13f8b42d31da6$export$56cfb14c006d4229);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $53e13f8b42d31da6$export$ca493ca2aa631e47 = 300;
const $53e13f8b42d31da6$export$844bee7de236d7ec = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$282e0b7f297acea7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$7c8f159da0dc916 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$601dc5d21f1e8182 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _18u01b66",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$fb418b53e6535057 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u01b66 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$cd2803f359bf9865 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bsb1osq _1bto1l2s _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$385a11497793b305 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c81o8v _zulpv77o _1bto1l2s _syaz131l _19pk1i6y _18u01b66 _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$56cfb14c006d4229 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lCwqw", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dbf9dc996adfbbc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8dbf9dc996adfbbc$var$messages = (0, $7qGN1.defineMessages)({
    groupIcon: {
        "id": "jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon",
        "defaultMessage": "Group Icon"
    }
});
var $8dbf9dc996adfbbc$export$2e2bcd8739ae039 = $8dbf9dc996adfbbc$var$messages;

});


parcelRegister("7PBuN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0e2fe81e1bf76c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
const $9c0e2fe81e1bf76c$export$914fa095fc1e0a45 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const [secondaryLabelOverflows, setSecondaryLabelOverflows] = (0, $eJOHy.useState)(false);
    const showSecondaryLabel = (input)=>typeof input.secondaryLabel === 'string' && input.secondaryLabel.length > 0 || // remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
        typeof input.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel) && /*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel.element);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const onSecondaryLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setSecondaryLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const tooltipContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, data.label), typeof data.secondaryLabel === 'string' && data.secondaryLabel.length > 0 && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx, @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, "(", data.secondaryLabel, ")")), [
        data
    ]);
    const getSecondaryLabelComponent = (option)=>{
        if (typeof option === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option)) return option.element;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows || secondaryLabelOverflows,
        content: tooltipContent,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledIcon), {
        src: data.icon,
        alt: data.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), showSecondaryLabel(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledSecondaryLabel), {
        ref: onSecondaryLabelRef,
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.icon-option-label.secondary-label"
    }, data.secondaryLabel && getSecondaryLabelComponent(data.secondaryLabel))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $9c0e2fe81e1bf76c$export$2e2bcd8739ae039 = $9c0e2fe81e1bf76c$export$914fa095fc1e0a45;

});

parcelRegister("5xIBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba51567c14d8e757$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
// Checkbox icon width = 24
// Margins and paddings around checkbox icon = 16
// Option right padding = (3 / 2) * 8
const $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH = (0, $jMiTg.PICKER_DROPDOWN_WIDTH) - 24 - 16 - 12;
const $ba51567c14d8e757$export$5f70fe304106fcb1 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozenge), {
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: data.appearance,
        isBold: data.isBold,
        maxWidth: data.maxWidth ?? $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozengeLabel), {
        ref: onLabelRef
    }, data.label))))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $ba51567c14d8e757$export$2e2bcd8739ae039 = $ba51567c14d8e757$export$5f70fe304106fcb1;

});


parcelRegister("5LwVz", function(module, exports) {
$parcel$export(module.exports, "DefaultPopupComponent", () => $4e7f80d8c92d0b45$export$5038854ec49970e4);
$parcel$export(module.exports, "FixedWidthPopupComponent", () => $4e7f80d8c92d0b45$export$84690c88a5faffa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $jMiTg = parcelRequire("jMiTg");
const $4e7f80d8c92d0b45$var$getPopupComponent = (width)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e7f80d8c92d0b45$var$PopupComponentContainer, {
            ...props,
            ref: ref,
            width: width
        }));
const $4e7f80d8c92d0b45$export$5038854ec49970e4 = $4e7f80d8c92d0b45$var$getPopupComponent();
const $4e7f80d8c92d0b45$export$84690c88a5faffa0 = $4e7f80d8c92d0b45$var$getPopupComponent((0, $jMiTg.PICKER_DROPDOWN_WIDTH));
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $4e7f80d8c92d0b45$var$layerValue = (0, $IW7jS.layers).layer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e7f80d8c92d0b45$var$PopupComponentContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1cd0 _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});
const $4e7f80d8c92d0b45$var$PopupComponentContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1cd0 _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _ca0qutpp _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});
const $4e7f80d8c92d0b45$var$PopupComponentContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates'), $4e7f80d8c92d0b45$var$PopupComponentContainerNew, $4e7f80d8c92d0b45$var$PopupComponentContainerOld);

});


parcelRegister("7JbAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bae9d594d2745981$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $6XJko = parcelRequire("6XJko");

var $3ycj9 = parcelRequire("3ycj9");
const $bae9d594d2745981$var$IconContainerConditional = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$IconContainer, null, children);
};
const $bae9d594d2745981$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $bae9d594d2745981$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text"
    }, formatMessage((0, $3ycj9.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $3ycj9.default).noOptionsSecondaryMessage)), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$Container, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$StyledTitle, null, formatMessage((0, $3ycj9.default).title)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $bae9d594d2745981$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$IconContainerConditional, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            LEGACY_primaryColor: "currentColor"
        }))
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $bae9d594d2745981$export$2e2bcd8739ae039 = $bae9d594d2745981$var$NoOptionsMessage;
const $bae9d594d2745981$var$stackStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bae9d594d2745981$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l _1e0c1txw _2lx21bp4 _4cvr1h6o _19pku2gc _2hwxv47k _otyr120g _18u0v47k",
            __cmplp.className
        ])
    });
});
const $bae9d594d2745981$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $bae9d594d2745981$var$StyledTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ycj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd552da9271bc32$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6bd552da9271bc32$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});
var $6bd552da9271bc32$export$2e2bcd8739ae039 = $6bd552da9271bc32$var$messages;

});


parcelRegister("eo5xA", function(module, exports) {
$parcel$export(module.exports, "default", () => $576bc32fb33dfcac$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $576bc32fb33dfcac$var$messages = (0, $7qGN1.defineMessages)({
    done: {
        "id": "issue-table-column-picker.column-picker.done",
        "defaultMessage": "Done"
    },
    tourHeading: {
        "id": "issue-table-column-picker.column-picker.tour-heading",
        "defaultMessage": "Column picker"
    },
    tourBody: {
        "id": "issue-table-column-picker.column-picker.tour-body",
        "defaultMessage": "Add or remove columns to see your most important fields."
    },
    searchColumnPlaceholder: {
        "id": "issue-table-column-picker.column-picker.search-column-placeholder",
        "defaultMessage": "Search column options"
    },
    searchColumnPlaceholderNew: {
        "id": "issue-table-column-picker.column-picker.search-column-placeholder-new",
        "defaultMessage": "Search columns"
    },
    loadingMessageStart: {
        "id": "issue-table-column-picker.column-picker.loading-message-start",
        "defaultMessage": "Loading more columns"
    },
    loadingMessageEnd: {
        "id": "issue-table-column-picker.column-picker.loading-message-end",
        "defaultMessage": "Finished loading columns"
    }
});
var $576bc32fb33dfcac$export$2e2bcd8739ae039 = $576bc32fb33dfcac$var$messages;

});


parcelRegister("ft2LQ", function(module, exports) {
$parcel$export(module.exports, "useFormatOptionLabelWithShimmer", () => $38946615baebed1a$export$e3c9f09c60e50c3e);

var $eJOHy = parcelRequire("eJOHy");

var $gMbEk = parcelRequire("gMbEk");

var $hEe9x = parcelRequire("hEe9x");

var $c9Mpl = parcelRequire("c9Mpl");
const $38946615baebed1a$var$ANIMATION_INTERVAL_MS = 1000;
const $38946615baebed1a$export$87328f5dc0b3b4c3 = ({ data: data, isShimmering: isShimmering, onAnimateStart: onAnimateStart, onAnimateEnd: onAnimateEnd })=>{
    const element = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (element.current && isShimmering) {
            const el = element.current;
            onAnimateStart(el);
            // Clean up animations when the component is unmounted or isShimmering changes
            return ()=>onAnimateEnd(el);
        }
        return undefined;
    }, [
        isShimmering,
        onAnimateEnd,
        onAnimateStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: element
    }, (0, $hEe9x.default)(data));
};
const $38946615baebed1a$export$e3c9f09c60e50c3e = (nonCommittedFieldSetIds)=>{
    // We use state instead of constructing the object at the module level to prevent errors being thrown during tests
    const [shimmerEffect] = (0, $eJOHy.useState)(()=>// KeyframeEffect is available in all supported browsers but we'll check anyway so the app doesn't crash.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.KeyframeEffect ? new KeyframeEffect(null, [
            {
                color: "var(--ds-text, #172B4D)"
            },
            {
                color: "var(--ds-text-disabled, #091E424F)"
            },
            {
                color: "var(--ds-text, #172B4D)"
            }
        ], {
            duration: $38946615baebed1a$var$ANIMATION_INTERVAL_MS
        }) : null);
    const { onAnimateStart: onAnimateStart, onAnimateEnd: onAnimateEnd } = (0, $c9Mpl.useSynchronisedAnimation)(shimmerEffect, $38946615baebed1a$var$ANIMATION_INTERVAL_MS);
    return (0, $eJOHy.useCallback)((data)=>(0, $gMbEk.isSingleValueOption)(data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($38946615baebed1a$export$87328f5dc0b3b4c3, {
            data: data,
            isShimmering: nonCommittedFieldSetIds.has(data.value),
            onAnimateStart: onAnimateStart,
            onAnimateEnd: onAnimateEnd
        }) : null, [
        nonCommittedFieldSetIds,
        onAnimateEnd,
        onAnimateStart
    ]);
};

});
parcelRegister("c9Mpl", function(module, exports) {
$parcel$export(module.exports, "useSynchronisedAnimation", () => $c0f2ad01be021cb4$export$5ca53ad8be1d6630);

var $eJOHy = parcelRequire("eJOHy");
const $c0f2ad01be021cb4$export$5ca53ad8be1d6630 = (baseKeyframeEffect, interval)=>{
    const animationMap = (0, $eJOHy.useRef)(new Map());
    const intervalRef = (0, $eJOHy.useRef)(undefined);
    const playAnimations = (0, $eJOHy.useCallback)(()=>{
        // Restart all animations in our map
        animationMap.current.forEach((animation)=>{
            // eslint-disable-next-line no-param-reassign
            animation.currentTime = 0;
            animation.play();
        });
    }, []);
    const onAnimateStart = (0, $eJOHy.useCallback)((element)=>{
        // Silently exit if KeyframeEffect is not available. It is available in all supported browsers but we'll
        // check anyway so the app doesn't crash.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!baseKeyframeEffect || !window.KeyframeEffect) return;
        // Clone our keyframe effect and set it onto the new target
        const keyframe = new KeyframeEffect(baseKeyframeEffect);
        keyframe.target = element;
        // Create a new animation for our element
        animationMap.current.set(element, new Animation(keyframe));
        if (intervalRef.current === undefined) {
            intervalRef.current = setInterval(playAnimations, interval);
            // Ensure initial group of animations are started at the same time, e.g. when clicking restore defaults.
            queueMicrotask(playAnimations);
        }
    }, [
        baseKeyframeEffect,
        interval,
        playAnimations
    ]);
    const onAnimateEnd = (0, $eJOHy.useCallback)((element)=>{
        if (!animationMap.current.has(element)) return;
        // Cancel the element animation and remove it from the map
        animationMap.current.get(element).cancel();
        animationMap.current.delete(element);
        // Clear our animation interval when there are no elements to be animated
        if (animationMap.current.size === 0) {
            clearInterval(intervalRef.current);
            intervalRef.current = undefined;
        }
    }, []);
    // End all pending animations on unmount
    (0, $eJOHy.useEffect)(()=>()=>{
            animationMap.current.forEach((_, element)=>onAnimateEnd(element));
        }, [
        onAnimateEnd
    ]);
    return {
        onAnimateStart: onAnimateStart,
        onAnimateEnd: onAnimateEnd
    };
};

});


parcelRegister("fpyg5", function(module, exports) {
$parcel$export(module.exports, "isOnlyUnselectableField", () => $608fafa198ebf130$export$bf5bbd6344a5f1aa);
$parcel$export(module.exports, "getFieldDisabledMessage", () => $608fafa198ebf130$export$b547e1f9b04ac0ef);
$parcel$export(module.exports, "findNewInsertFields", () => $608fafa198ebf130$export$60fa8135877879de);
$parcel$export(module.exports, "findRemovedFields", () => $608fafa198ebf130$export$bcbd9324b737d43e);
$parcel$export(module.exports, "getUpdatedOptions", () => $608fafa198ebf130$export$f35b98a37123c93f);
$parcel$export(module.exports, "sortMergedColumnOptions", () => $608fafa198ebf130$export$9c9602c008ed572e);
$parcel$export(module.exports, "createOptimisticFieldConfig", () => $608fafa198ebf130$export$156c6a7908536c2c);
$parcel$export(module.exports, "deleteOptimisticFieldConfig", () => $608fafa198ebf130$export$c2b4d8461d595052);
$parcel$export(module.exports, "getRollbackFields", () => $608fafa198ebf130$export$f07a9aef49bee569);
$parcel$export(module.exports, "rollbackOptimisticFieldConfig", () => $608fafa198ebf130$export$4b8e679985e2412d);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $3cMgR = parcelRequire("3cMgR");

var $j8Km1 = parcelRequire("j8Km1");

var $lWeUb = parcelRequire("lWeUb");
const $608fafa198ebf130$export$bf5bbd6344a5f1aa = (fieldType, canEditColumnConfiguration)=>{
    // Epic Link can only be unselected
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return canEditColumnConfiguration;
    // Parent Link can only be unselected
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return canEditColumnConfiguration;
    return false;
};
const $608fafa198ebf130$export$b547e1f9b04ac0ef = (fieldType, formatMessage)=>{
    // Epic Link deprecation message
    if (fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link') return formatMessage((0, $lWeUb.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    });
    // Parent Link deprecation message
    if (fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') return formatMessage((0, $lWeUb.default).deprecatedParentLinkMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    });
    return undefined;
};
const $608fafa198ebf130$export$60fa8135877879de = (options, selectedColumns)=>{
    return options.filter((option)=>!selectedColumns.some((prevOption)=>{
            if ('value' in prevOption && 'value' in option) return prevOption.value === option.value;
            return false;
        }));
};
const $608fafa198ebf130$export$bcbd9324b737d43e = (options, selectedColumns)=>{
    const removedFields = [];
    const existingValues = new Set(options.map((opt)=>'value' in opt ? opt.value : ''));
    selectedColumns.forEach((option)=>{
        if ('value' in option && !existingValues.has(option.value)) removedFields.push({
            name: option.label,
            fieldSetId: option.value
        });
    });
    return removedFields;
};
const $608fafa198ebf130$export$f35b98a37123c93f = (options, insertFields, insertIndex)=>{
    if (insertIndex !== undefined) {
        const updatedOptions = [
            ...options
        ];
        updatedOptions.splice(insertIndex, 0, ...insertFields);
        return updatedOptions;
    }
    return [
        ...options,
        ...insertFields
    ];
};
const $608fafa198ebf130$export$9c9602c008ed572e = (options)=>{
    let issuekey;
    let issuetype;
    let summary;
    const otherOptions = [];
    options.forEach((option)=>{
        if ('value' in option) {
            if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issuetype = option;
            else if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issuekey = option;
            else if (option.value === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) summary = option;
            else otherOptions.push(option);
        } else otherOptions.push(option);
    });
    return [
        issuetype,
        issuekey,
        summary,
        ...otherOptions
    ].filter(Boolean);
};
const $608fafa198ebf130$export$156c6a7908536c2c = ({ environment: environment, fieldConfigId: fieldConfigId, fields: newFields, createIndex: createIndex })=>{
    if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const createdFields = [];
            newFields.forEach((field)=>{
                const exists = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === field.fieldSetId);
                if (!exists) createdFields.push($608fafa198ebf130$var$createFieldInStore(field, store));
            });
            if (fields) {
                if (createIndex !== undefined && createIndex >= 0 && createIndex <= fields.length) {
                    const updatedFields = [
                        ...fields
                    ];
                    updatedFields.splice(createIndex, 0, ...createdFields);
                    store.get(fieldConfigId)?.setLinkedRecords(updatedFields, 'edges');
                } else store.get(fieldConfigId)?.setLinkedRecords([
                    ...fields,
                    ...createdFields
                ], 'edges');
                store.get(fieldConfigId)?.setValue(fields.length + createdFields.length, 'totalCount');
            }
        }
    });
    const rollback = ()=>{
        if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const fieldSetsConnection = store.get(fieldConfigId);
            if (fieldConfigId) {
                fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                    const node = edge.getLinkedRecord('node');
                    const exists = newFields?.find((field)=>node?.getValue('fieldSetId') === field.fieldSetId);
                    if (exists) {
                        const nodeId = node?.getDataID();
                        nodeId && (0, $37Ewn.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
                    }
                });
                const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
                store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
            }
        });
    };
    return rollback;
};
const $608fafa198ebf130$export$c2b4d8461d595052 = ({ environment: environment, fieldConfigId: fieldConfigId, fields: deletedFields })=>{
    if (fieldConfigId) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        const deletedFieldsSetIds = new Set(deletedFields.map((field)=>field.fieldSetId));
        fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            const fieldSetId = node?.getValue('fieldSetId')?.toString();
            if (fieldSetId && deletedFieldsSetIds.has(fieldSetId)) {
                const nodeId = node?.getDataID();
                nodeId && (0, $37Ewn.ConnectionHandler).deleteNode(fieldSetsConnection, nodeId);
            }
        });
        const newTotalCount = fieldSetsConnection?.getLinkedRecords('edges')?.length;
        store.get(fieldConfigId)?.setValue(newTotalCount, 'totalCount');
    });
};
const $608fafa198ebf130$export$f07a9aef49bee569 = ({ environment: environment, fieldConfigId: fieldConfigId })=>{
    const backupFields = [];
    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fieldSetsConnection = store.get(fieldConfigId);
            fieldSetsConnection?.getLinkedRecords('edges')?.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                const fieldSetPreferences = node?.getLinkedRecord('fieldSetPreferences');
                const width = fieldSetPreferences?.getValue('width')?.toString();
                const field = {
                    fieldSetId: node?.getValue('fieldSetId')?.toString() || '',
                    jqlTerm: node?.getValue('jqlTerm')?.toString() || '',
                    type: node?.getValue('type')?.toString() || '',
                    name: node?.getValue('displayName')?.toString() || '',
                    customWidth: width ? Number(width) : undefined
                };
                backupFields.push(field);
            });
        }
    });
    return backupFields;
};
const $608fafa198ebf130$export$4b8e679985e2412d = ({ environment: environment, fieldConfigId: fieldConfigId, fields: backupFields })=>{
    if (fieldConfigId && backupFields.length > 0) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        const fieldSetsConnection = store.get(fieldConfigId);
        // Create new edges for each backup node and completely replace the current edges
        const restoredEdges = backupFields.map((field)=>$608fafa198ebf130$var$createFieldInStore(field, store));
        if (fieldSetsConnection) {
            fieldSetsConnection.setLinkedRecords(restoredEdges, 'edges');
            fieldSetsConnection.setValue(restoredEdges.length, 'totalCount');
        }
    });
};
const $608fafa198ebf130$var$createFieldInStore = (newField, store)=>{
    const fieldJqlTerm = 'jql-placeholder-only';
    const edge = store.create((0, $aXKmr.v4)(), 'JiraIssueSearchFieldSetEdge');
    const aField = store.create((0, $aXKmr.v4)(), 'JiraIssueSearchFieldSet');
    aField.setValue(newField.fieldSetId, 'fieldSetId');
    aField.setValue(newField.jqlTerm ?? fieldJqlTerm, 'jqlTerm');
    aField.setValue(newField.type, 'type');
    aField.setValue(newField.name, 'displayName');
    if (!newField.jqlTerm) aField.setValue(true, 'isPlaceHolderField');
    if (newField.customWidth) {
        const preferences = store.create((0, $aXKmr.v4)(), 'FieldSetPreferences');
        preferences.setValue(newField.customWidth, 'width');
        aField.setLinkedRecord(preferences, 'fieldSetPreferences');
    }
    edge.setLinkedRecord(aField, 'node');
    return edge;
};

});
parcelRegister("lWeUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d35255bd661bd8f4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d35255bd661bd8f4$var$messages = (0, $7qGN1.defineMessages)({
    issuetype: {
        "id": "issue-table-column-picker.issuetype",
        "defaultMessage": "Issue Type"
    },
    issuekey: {
        "id": "issue-table-column-picker.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "issue-table-column-picker.summary",
        "defaultMessage": "Summary"
    },
    assignee: {
        "id": "issue-table-column-picker.assignee",
        "defaultMessage": "Assignee"
    },
    reporter: {
        "id": "issue-table-column-picker.reporter",
        "defaultMessage": "Reporter"
    },
    priority: {
        "id": "issue-table-column-picker.priority",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue-table-column-picker.status",
        "defaultMessage": "Status"
    },
    resolution: {
        "id": "issue-table-column-picker.resolution",
        "defaultMessage": "Resolution"
    },
    created: {
        "id": "issue-table-column-picker.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-table-column-picker.updated",
        "defaultMessage": "Updated"
    },
    duedate: {
        "id": "issue-table-column-picker.duedate",
        "defaultMessage": "Due date"
    },
    deprecatedParentLinkMessage: {
        "id": "issue-table-column-picker.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    deprecatedEpicMessage: {
        "id": "issue-table-column-picker.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    issuetypeIssueTerminologyRefreshM4: {
        "id": "issue-table-column-picker.issuetype-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});
var $d35255bd661bd8f4$export$2e2bcd8739ae039 = $d35255bd661bd8f4$var$messages;

});




parcelRegister("jE8Tu", function(module, exports) {
$parcel$export(module.exports, "filterNonIssueItems", () => $8416c949b39a62cd$export$3bf3427e3d5241d1);
$parcel$export(module.exports, "getItemKey", () => $8416c949b39a62cd$export$424834ba1b0663bc);
$parcel$export(module.exports, "getChildIssueCreateItemKey", () => $8416c949b39a62cd$export$5dbc02cdc002848d);
$parcel$export(module.exports, "getShowMoreItemKey", () => $8416c949b39a62cd$export$b262bb2cd2ab9f00);
$parcel$export(module.exports, "HierarchyContainer", () => $8416c949b39a62cd$export$4666215eda1bff58);
$parcel$export(module.exports, "useHierarchyStore", () => $8416c949b39a62cd$export$2fc259d06066fab6);
$parcel$export(module.exports, "useHierarchyActions", () => $8416c949b39a62cd$export$4fd9d94900cdff43);
$parcel$export(module.exports, "useIsItemExpanded", () => $8416c949b39a62cd$export$d11bf3cdf2aca60f);
$parcel$export(module.exports, "useIsItemVisuallyExpanded", () => $8416c949b39a62cd$export$d553a4716051e682);
$parcel$export(module.exports, "useIsSelected", () => $8416c949b39a62cd$export$fb40a80c530e5f2b);
$parcel$export(module.exports, "useIsFocused", () => $8416c949b39a62cd$export$a774b9356e1b793);
$parcel$export(module.exports, "useIsItemLoading", () => $8416c949b39a62cd$export$d169440ae865c511);
$parcel$export(module.exports, "useSelectedRow", () => $8416c949b39a62cd$export$11a86b67953bcc50);
$parcel$export(module.exports, "useVisibleDepth", () => $8416c949b39a62cd$export$ebb5be32d1c1b3ea);
$parcel$export(module.exports, "useFlatList", () => $8416c949b39a62cd$export$e8de618a961e45f5);
$parcel$export(module.exports, "useIssueIds", () => $8416c949b39a62cd$export$85c95ca9de9161bf);
$parcel$export(module.exports, "useChildIssueIds", () => $8416c949b39a62cd$export$785805018de3f0fe);
$parcel$export(module.exports, "useFlatListIssueKeys", () => $8416c949b39a62cd$export$9f91dbe98f60bbaa);
$parcel$export(module.exports, "useHasExpandedItems", () => $8416c949b39a62cd$export$d77963246cf4131);
$parcel$export(module.exports, "useSelectedIssueKey", () => $8416c949b39a62cd$export$7cedcbfb2da7e49d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");

var $jBNts = parcelRequire("jBNts");
const $8416c949b39a62cd$var$initialState = {
    selectedItem: null,
    selectedItemIndex: null,
    focusedItem: null,
    expandedItems: {},
    rootConnectionId: null,
    connectionMap: {},
    connectionItems: {},
    loadingItems: {},
    /**
	 * Indicates the maximum expanded hierarhcy level:
	 * - Starts with 0 on initial load (flat list)
	 * - Expanding each level increments the value
	 */ visibleDepth: 0,
    flatList: [],
    issueKeys: [],
    listMetadata: [],
    amountOfRows: 0,
    itemsWithSiblingCreate: {}
};
const $8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX = 'CHILD_ISSUE_CREATE';
const $8416c949b39a62cd$var$SIBLING_ISSUE_CREATE_PREFIX = 'SIBLING_ISSUE_CREATE';
const $8416c949b39a62cd$var$SHOW_MORE_PREFIX = 'SHOW_MORE';
const $8416c949b39a62cd$var$LOADING_ROW_PREFIX = 'LOADING_ROW';
const $8416c949b39a62cd$var$isSpecialItem = (id)=>id?.startsWith($8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX) || id?.startsWith($8416c949b39a62cd$var$SHOW_MORE_PREFIX) || id?.startsWith($8416c949b39a62cd$var$LOADING_ROW_PREFIX);
const $8416c949b39a62cd$export$3bf3427e3d5241d1 = (list)=>list.filter(Boolean).filter((item)=>!$8416c949b39a62cd$var$isSpecialItem(item));
const $8416c949b39a62cd$export$424834ba1b0663bc = (itemsConnectionId, itemId, groupId)=>`${itemsConnectionId}::${itemId}${groupId ? `::${groupId}` : ''}`;
const $8416c949b39a62cd$export$5dbc02cdc002848d = (siblingItemId)=>`${$8416c949b39a62cd$var$CHILD_ISSUE_CREATE_PREFIX}_${siblingItemId}`;
const $8416c949b39a62cd$export$65582958b69a9e4c = (parentItemId)=>`${$8416c949b39a62cd$var$SIBLING_ISSUE_CREATE_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$b262bb2cd2ab9f00 = (parentItemId)=>`${$8416c949b39a62cd$var$SHOW_MORE_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$4db25121b2596d32 = (parentItemId)=>`${$8416c949b39a62cd$var$LOADING_ROW_PREFIX}_${parentItemId}`;
const $8416c949b39a62cd$export$4aad0fc50e1251e4 = (key)=>{
    if (typeof key !== 'string') return {
        connectionId: null,
        itemId: null
    };
    const [connectionId, itemId] = key.split('::');
    return {
        connectionId: connectionId,
        itemId: itemId
    };
};
const $8416c949b39a62cd$var$actions = {
    populateConnection: ({ parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentConnectionId: parentConnectionId, list: list, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, groupId: groupId })=>{
        return ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (parentItemId === 'root') setState({
                rootConnectionId: itemsConnectionId
            });
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, parentItemId, groupId);
            const state = getState();
            let nextList = list?.slice() ?? null;
            // adding [Show more] button to flat list so that virtualiser recognizes it
            if (hasNext && nextList) {
                const showMoreRowKey = $8416c949b39a62cd$export$b262bb2cd2ab9f00(parentItemId);
                nextList = nextList.concat({
                    key: showMoreRowKey,
                    itemId: showMoreRowKey,
                    groupId: groupId
                });
            }
            if (isChildIssueCreateRowVisible && nextList) {
                const childIssueCreateRowKey = $8416c949b39a62cd$export$5dbc02cdc002848d(parentItemId);
                nextList.unshift({
                    key: childIssueCreateRowKey,
                    itemId: childIssueCreateRowKey,
                    groupId: groupId
                });
            }
            const parentKey = $8416c949b39a62cd$export$424834ba1b0663bc(parentConnectionId, parentItemId, // root doesn't have a groupId
            parentItemId === 'root' ? undefined : groupId);
            setState({
                connectionMap: {
                    ...state.connectionMap,
                    [parentKey]: key
                },
                connectionItems: {
                    ...state.connectionItems,
                    [key]: nextList
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        };
    },
    setItemIsLoading: ({ itemId: itemId, groupId: groupId, isLoading: isLoading })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { loadingItems: loadingItems, listMetadata: listMetadata, connectionItems: connectionItems } = getState();
            const loadingItemKey = $8416c949b39a62cd$export$4db25121b2596d32(itemId);
            const metadataItem = listMetadata.find((metadata)=>metadata.itemId === itemId);
            const key = metadataItem ? $8416c949b39a62cd$export$424834ba1b0663bc(metadataItem.connectionId, metadataItem.parentId, metadataItem.groupId) : null;
            if (!key || !connectionItems) return;
            let nextList = (connectionItems?.[key] ?? []).slice();
            if (isLoading) {
                const itemIndex = nextList.findIndex((item)=>item.itemId === itemId);
                if (itemIndex > -1) // insert loading row right after the expanded item
                nextList.splice(itemIndex + 1, 0, {
                    key: loadingItemKey,
                    itemId: loadingItemKey,
                    groupId: groupId
                });
            } else nextList = nextList.filter((item)=>item.itemId !== loadingItemKey);
            setState({
                loadingItems: {
                    ...loadingItems,
                    [itemId]: isLoading
                },
                connectionItems: {
                    ...connectionItems,
                    [key]: nextList
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        },
    setIsSiblingCreateVisible: (itemDetails, isSiblingCreateVisible)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { itemsWithSiblingCreate: itemsWithSiblingCreate } = getState();
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            setState({
                itemsWithSiblingCreate: {
                    ...itemsWithSiblingCreate,
                    [key]: isSiblingCreateVisible
                }
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
        },
    toggleIsItemExpanded: (itemDetails, issueDepth)=>({ getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            const isExpanded = !state.expandedItems[key];
            dispatch($8416c949b39a62cd$var$actions.setIsItemExpanded(itemDetails, isExpanded, issueDepth));
        },
    setIsItemExpanded: (itemDetails, isItemExpanded, issueDepth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (!itemDetails) return;
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            const state = getState();
            /*
				Update visibleDepth with the new depth if is expanded an item
				traverseTreeAndUpdateState function would update the visibleDepth when collapse
			*/ const optimisticVisibleDepth = issueDepth + 1;
            const currentVisibleDepth = state.visibleDepth;
            const newVisibleDepth = isItemExpanded && optimisticVisibleDepth > currentVisibleDepth ? optimisticVisibleDepth : state.visibleDepth;
            setState({
                expandedItems: {
                    ...state.expandedItems,
                    [key]: isItemExpanded
                },
                ...isItemExpanded === false ? {
                    connectionItems: {
                        ...state.connectionItems,
                        [key]: null
                    }
                } : {},
                visibleDepth: newVisibleDepth
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
            dispatch($8416c949b39a62cd$var$actions.clearSelectionIfItemIsNotInList());
        },
    traverseTreeAndUpdateState: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const result = $8416c949b39a62cd$export$dc56145edcd15e3e(getState());
            setState({
                flatList: result.flatlist,
                issueKeys: result.issueKeys,
                listMetadata: result.listMetadata,
                visibleDepth: result.hierarchyLevels[result.hierarchyLevels.length - 1]
            });
            dispatch($8416c949b39a62cd$var$actions.setAmountOfRows(result.flatlist.length));
        },
    setSelectedRow: (itemDetails)=>({ setState: setState })=>{
            if (!itemDetails) {
                setState({
                    selectedItem: null,
                    focusedItem: null
                });
                return;
            }
            const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
            const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
            setState({
                selectedItem: key,
                focusedItem: key
            });
        },
    // Sets the selected row based on the index provided when returning from the full page issue app. Clean up with issue app removal
    setSelectedRowByIndex: (rowIndex)=>({ getState: getState, setState: setState })=>{
            const { listMetadata: listMetadata } = getState();
            if (rowIndex >= 0 && rowIndex < listMetadata.length) {
                const formattedKey = listMetadata[rowIndex].key;
                setState({
                    selectedItem: formattedKey,
                    selectedItemIndex: rowIndex,
                    focusedItem: formattedKey
                });
            }
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const nextIndex = currentIndex + 1;
            if (nextIndex < listMetadata.length) dispatch($8416c949b39a62cd$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[nextIndex].connectionId,
                itemId: listMetadata[nextIndex].itemId,
                groupId: listMetadata[nextIndex].groupId
            }));
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { listMetadata: listMetadata, selectedItem: selectedItem } = state;
            if (!selectedItem) return;
            const currentIndex = listMetadata.findIndex((item)=>item.key === selectedItem);
            const previousIndex = currentIndex - 1;
            if (previousIndex >= 0) dispatch($8416c949b39a62cd$var$actions.setSelectedRow({
                itemsConnectionId: listMetadata[previousIndex].connectionId,
                itemId: listMetadata[previousIndex].itemId,
                groupId: listMetadata[previousIndex].groupId
            }));
        },
    clearSelectionIfItemIsNotInList: ()=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { selectedItem: selectedItem } = state;
            if (!selectedItem || state.listMetadata.find((item)=>item.key === selectedItem)) return;
            dispatch($8416c949b39a62cd$var$actions.setSelectedRow(null));
        },
    setAmountOfRows: (newAmountOfRows)=>({ getState: getState, setState: setState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedItem: focusedItem } = getState();
            focusedItem !== null && setState({
                focusedItem: null
            });
        },
    resetHierarchyKeepingFirstGroupExpanded: ({ firstGroupId: firstGroupId, itemsConnectionId: itemsConnectionId })=>({ setState: setState, dispatch: dispatch })=>{
            if (firstGroupId && itemsConnectionId) {
                const firstGroupKey = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, firstGroupId, firstGroupId);
                // First group is always expanded by default
                setState({
                    expandedItems: {
                        [firstGroupKey]: true
                    }
                });
            } else setState({
                expandedItems: {}
            });
            dispatch($8416c949b39a62cd$var$actions.traverseTreeAndUpdateState());
        }
};
const $8416c949b39a62cd$export$4666215eda1bff58 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store')
});
const $8416c949b39a62cd$var$Store = (0, $GtRbT.createStore)({
    initialState: $8416c949b39a62cd$var$initialState,
    actions: $8416c949b39a62cd$var$actions,
    name: 'hierarchy',
    containedBy: $8416c949b39a62cd$export$4666215eda1bff58,
    handlers: {
        onInit: ()=>({ dispatch: dispatch }, { populateConnectionArgs: populateConnectionArgs })=>{
                // eslint-disable-next-line jira/ff/no-preconditioning
                if ((0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && populateConnectionArgs) populateConnectionArgs.forEach((args)=>{
                    dispatch($8416c949b39a62cd$var$actions.populateConnection(args));
                });
            },
        // Only used when returning from the full page issue app. Clean up with issue app removal
        onUpdate: ()=>({ getState: getState, dispatch: dispatch }, { selectedRowIndex: selectedRowIndex })=>{
                const { selectedItemIndex: selectedItemIndex } = getState();
                if (selectedRowIndex && selectedItemIndex !== selectedRowIndex && (0, $4cTDP.fg)('jsc_highlight_selected_row')) dispatch($8416c949b39a62cd$var$actions.setSelectedRowByIndex(selectedRowIndex));
            }
    }
});
const $8416c949b39a62cd$export$2fc259d06066fab6 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store);
const $8416c949b39a62cd$export$4fd9d94900cdff43 = (0, $iJq0l.createActionsHook)($8416c949b39a62cd$var$Store);
const $8416c949b39a62cd$var$getIsItemExpandedSelector = (state, itemDetails)=>{
    if (!itemDetails) return false;
    const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
    const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    return state.expandedItems[key] ?? false;
};
const $8416c949b39a62cd$export$d11bf3cdf2aca60f = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIsItemExpandedSelector
});
const $8416c949b39a62cd$var$getIsItemVisuallyExpandedSelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getIsItemExpandedSelector, (state, itemDetails)=>{
    if (!itemDetails) return false;
    const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
    const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    const childrenConnection = state.connectionMap[key];
    return !!childrenConnection && !!state.connectionItems[childrenConnection]?.length || state.loadingItems[itemId] || false;
}, (isExpanded, canBeExpanded)=>isExpanded && canBeExpanded);
const $8416c949b39a62cd$export$d553a4716051e682 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIsItemVisuallyExpandedSelector
});
const $8416c949b39a62cd$export$fb40a80c530e5f2b = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.selectedItem === $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $8416c949b39a62cd$export$a774b9356e1b793 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemDetails)=>{
        if (!itemDetails) return false;
        const { itemsConnectionId: itemsConnectionId, itemId: itemId, groupId: groupId } = itemDetails;
        return state.focusedItem === $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, itemId, groupId);
    }
});
const $8416c949b39a62cd$var$getSelectedIndexSelector = (state)=>{
    const index = state.listMetadata.findIndex((item)=>item.key === state.selectedItem);
    if (index === -1) return null;
    return index;
};
const $8416c949b39a62cd$export$d169440ae865c511 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: (state, itemId)=>Boolean(itemId && state.loadingItems[itemId])
});
const $8416c949b39a62cd$export$11a86b67953bcc50 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getSelectedIndexSelector
});
const $8416c949b39a62cd$export$dc56145edcd15e3e = (state)=>{
    const traverse = ({ itemsConnectionId: itemsConnectionId, parentId: parentId, flatlist: flatlist, issueKeys: issueKeys, listMetadata: listMetadata, hierarchyLevels: hierarchyLevels, depth: depth, groupId: groupId })=>{
        const key = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, parentId, groupId);
        const connectionItem = state.connectionItems[key];
        if (!connectionItem) return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
        // itemGroupId is different from groupId at the root level
        connectionItem.forEach(({ itemId: id, key: issueKey, groupId: itemGroupId })=>{
            const childConnectionKey = $8416c949b39a62cd$export$424834ba1b0663bc(itemsConnectionId, id, itemGroupId);
            if (state.itemsWithSiblingCreate[childConnectionKey] && (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) {
                const siblingIssueCreateKey = $8416c949b39a62cd$export$65582958b69a9e4c(id);
                const siblingIssueCreateFlatListKey = (0, $jBNts.getFlatListKey)({
                    itemId: siblingIssueCreateKey,
                    groupId: itemGroupId
                });
                flatlist.push(siblingIssueCreateFlatListKey);
            }
            // groupId is needed in flatlist to make the issueId unique across multiple groups
            flatlist.push((0, $jBNts.getFlatListKey)({
                itemId: id,
                groupId: itemGroupId
            }));
            issueKeys.push(issueKey);
            listMetadata.push({
                itemId: id,
                parentId: parentId,
                key: childConnectionKey,
                connectionId: itemsConnectionId,
                groupId: itemGroupId
            });
            const isExpanded = state.expandedItems[childConnectionKey];
            if (isExpanded) {
                const currentDepth = depth + 1;
                if (!hierarchyLevels.includes(currentDepth)) hierarchyLevels.push(currentDepth);
                const childrenConnection = state.connectionMap[childConnectionKey];
                const { connectionId: childrenConnectionId } = $8416c949b39a62cd$export$4aad0fc50e1251e4(childrenConnection);
                if (childrenConnectionId) traverse({
                    itemsConnectionId: childrenConnectionId,
                    parentId: id,
                    flatlist: flatlist,
                    issueKeys: issueKeys,
                    listMetadata: listMetadata,
                    hierarchyLevels: hierarchyLevels,
                    depth: currentDepth,
                    groupId: itemGroupId
                });
            }
        });
        return {
            flatlist: flatlist,
            issueKeys: issueKeys,
            listMetadata: listMetadata,
            hierarchyLevels: hierarchyLevels
        };
    };
    const depth = 0;
    const flatlist = [];
    const issueKeys = [];
    const listMetadata = [];
    const hierarchyLevels = [
        depth
    ];
    if (!state.rootConnectionId) return {
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels
    };
    return traverse({
        itemsConnectionId: state.rootConnectionId,
        parentId: 'root',
        flatlist: flatlist,
        issueKeys: issueKeys,
        listMetadata: listMetadata,
        hierarchyLevels: hierarchyLevels,
        depth: depth
    });
};
const $8416c949b39a62cd$export$ebb5be32d1c1b3ea = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>state.visibleDepth
});
const $8416c949b39a62cd$export$e8de618a961e45f5 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>state.flatList
});
const $8416c949b39a62cd$var$getIssueIdsSelector = (0, $4MchI.createSelector)((state)=>state.listMetadata, (listMetadata)=>listMetadata// filtering group headers out
    .filter(({ itemId: itemId, groupId: groupId })=>itemId !== groupId && !$8416c949b39a62cd$var$isSpecialItem(itemId)).map(({ itemId: itemId })=>itemId));
const $8416c949b39a62cd$export$85c95ca9de9161bf = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIssueIdsSelector
});
const $8416c949b39a62cd$var$getChildIssueIdsSelector = (0, $4MchI.createSelector)((state)=>state.listMetadata, (listMetadata)=>listMetadata// filtering group headers out
    .filter(({ itemId: itemId, groupId: groupId })=>itemId !== groupId && !$8416c949b39a62cd$var$isSpecialItem(itemId)).filter(({ parentId: parentId })=>parentId !== 'root').map(({ itemId: itemId })=>itemId));
const $8416c949b39a62cd$export$785805018de3f0fe = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getChildIssueIdsSelector
});
const $8416c949b39a62cd$var$getIssueKeysSelector = (state)=>state.issueKeys;
const $8416c949b39a62cd$var$getFlatListIssueKeysSelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getIssueKeysSelector, (issueKeys)=>$8416c949b39a62cd$export$3bf3427e3d5241d1(issueKeys));
const $8416c949b39a62cd$export$9f91dbe98f60bbaa = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getFlatListIssueKeysSelector
});
const $8416c949b39a62cd$export$a5d72277eb099991 = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getIssueKeysSelector
});
const $8416c949b39a62cd$var$getSelectedIssueKeySelector = (0, $4MchI.createSelector)($8416c949b39a62cd$var$getSelectedIndexSelector, $8416c949b39a62cd$var$getIssueKeysSelector, (selectedIndex, issueKeys)=>{
    if (selectedIndex === null) return null;
    return issueKeys[selectedIndex];
});
const $8416c949b39a62cd$export$d77963246cf4131 = (0, $iJq0l.createStateHook)($8416c949b39a62cd$var$Store, {
    selector: (state)=>Object.values(state.expandedItems).some((isExpanded)=>isExpanded)
});
const $8416c949b39a62cd$export$7cedcbfb2da7e49d = (0, $iJq0l.createHook)($8416c949b39a62cd$var$Store, {
    selector: $8416c949b39a62cd$var$getSelectedIssueKeySelector
});

});
parcelRegister("jBNts", function(module, exports) {
$parcel$export(module.exports, "getFlatListKey", () => $53a9450db45372ed$export$c15cfc620819beb5);
const $53a9450db45372ed$export$c15cfc620819beb5 = ({ itemId: itemId, groupId: groupId })=>`${itemId}${groupId ? `::${groupId}` : ''}`;

});


parcelRegister("3cJQz", function(module, exports) {
$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $e4b1171d87a4cba5$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $e4b1171d87a4cba5$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $e4b1171d87a4cba5$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $e4b1171d87a4cba5$export$e350c43a524c2f15);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $d2s5v = parcelRequire("d2s5v");

var $6zxfT = parcelRequire("6zxfT");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $cxKOj = parcelRequire("cxKOj");

var $domHz = parcelRequire("domHz");
const $e4b1171d87a4cba5$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $e4b1171d87a4cba5$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $e4b1171d87a4cba5$var$ENV_STAGING = 'staging';
const $e4b1171d87a4cba5$var$STARGATE_URL = '/gateway/api';
const $e4b1171d87a4cba5$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $e4b1171d87a4cba5$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4b1171d87a4cba5$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $e4b1171d87a4cba5$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $eJOHy.useContext)($e4b1171d87a4cba5$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $e4b1171d87a4cba5$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $kyq27.useEnvironment)() === $e4b1171d87a4cba5$var$ENV_STAGING ? $e4b1171d87a4cba5$export$2d29273a16589c02 : $e4b1171d87a4cba5$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $e4b1171d87a4cba5$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $e4b1171d87a4cba5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $domHz.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $domHz.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).onboardingHeadingIssueTermRefresh : (0, $domHz.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).onboardingDescriptionIssueTermRefresh : (0, $domHz.default).onboardingDescription))));
};
const $e4b1171d87a4cba5$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $e4b1171d87a4cba5$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $domHz.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).toggleOnboardingIssueTermRefresh : (0, $domHz.default).toggleOnboarding)));
};

});
parcelRegister("domHz", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb46e101bc25a0ef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eb46e101bc25a0ef$var$messages = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $eb46e101bc25a0ef$export$2e2bcd8739ae039 = $eb46e101bc25a0ef$var$messages;

});


parcelRegister("dLXgn", function(module, exports) {
$parcel$export(module.exports, "ConnectionsListContainer", () => $281e5150464a3bb6$export$ba73231554574611);
$parcel$export(module.exports, "useConnectionsList", () => $281e5150464a3bb6$export$8d76c2ce1bf0921e);
$parcel$export(module.exports, "useConnectionsListActions", () => $281e5150464a3bb6$export$d656d29a379d1749);
$parcel$export(module.exports, "useRegisterConnection", () => $281e5150464a3bb6$export$f9bef9773768341d);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $7zZ4w = parcelRequire("7zZ4w");
const $281e5150464a3bb6$var$INITIAL_CONNECTIONS_LIST_STATE = {
    connections: {}
};
const $281e5150464a3bb6$export$ba73231554574611 = (0, $6E16M.createContainer)();
const $281e5150464a3bb6$var$getKeyForConnection = (connection)=>{
    let key = connection.connectionId;
    if (connection.type === 'PARENT_CHILDREN') key = connection.parentId;
    if (connection.type === 'GROUP_CHILDREN') key = connection.groupId;
    // add some formatting to ensure it is not used for another purpose
    return `KEY_${key}`;
};
const $281e5150464a3bb6$var$actions = {
    addConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $281e5150464a3bb6$var$getKeyForConnection(connection);
            setState({
                connections: {
                    ...connections,
                    [key]: connection
                }
            });
        },
    removeConnection: (connection)=>({ setState: setState, getState: getState })=>{
            const { connections: connections } = getState();
            const key = $281e5150464a3bb6$var$getKeyForConnection(connection);
            const { [key]: _, ...newConnections } = connections;
            setState({
                connections: newConnections
            });
        }
};
const $281e5150464a3bb6$var$Store = (0, $GtRbT.createStore)({
    initialState: $281e5150464a3bb6$var$INITIAL_CONNECTIONS_LIST_STATE,
    name: 'ConnectionsListStore',
    containedBy: $281e5150464a3bb6$export$ba73231554574611,
    actions: $281e5150464a3bb6$var$actions,
    handlers: {
        onDestroy: ()=>({ getState: getState })=>{
                const { connections: connections } = getState();
                const environment = (0, $7zZ4w.default)();
                Object.values(connections).forEach((connection)=>{
                    environment.commitUpdate((store)=>{
                        const connectionToInvalidate = store.get(connection.connectionId);
                        if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                    });
                });
            }
    }
});
const $281e5150464a3bb6$export$8d76c2ce1bf0921e = (0, $iJq0l.createStateHook)($281e5150464a3bb6$var$Store);
const $281e5150464a3bb6$export$d656d29a379d1749 = (0, $iJq0l.createActionsHook)($281e5150464a3bb6$var$Store);
const $281e5150464a3bb6$export$f9bef9773768341d = (connection)=>{
    const { addConnection: addConnection } = $281e5150464a3bb6$export$d656d29a379d1749();
    (0, $eJOHy.useEffect)(()=>{
        if (connection) addConnection(connection);
    }, [
        addConnection,
        connection
    ]);
};

});

parcelRegister("bYhG9", function(module, exports) {
$parcel$export(module.exports, "useHoverPopoverState", () => $d736550e3de5add3$export$ecaed54879b49151);
$parcel$export(module.exports, "useHoverPopoverSetter", () => $d736550e3de5add3$export$3ced34cbab3dc9bf);
$parcel$export(module.exports, "HoverPopoverStateProvider", () => $d736550e3de5add3$export$3240cf68ec0b7d81);

var $eJOHy = parcelRequire("eJOHy");

var $3OT15 = parcelRequire("3OT15");
const $d736550e3de5add3$var$HoverPopoverStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $d736550e3de5add3$var$HoverPopoverSetterContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $d736550e3de5add3$var$defaultState = {
    content: null,
    contentElement: null,
    cellRef: null,
    isOpen: false
};
const $d736550e3de5add3$var$HoverPopoverProviderLocal = ({ children: children })=>{
    const [hoverPopoverState, setHoverPopoverState] = (0, $eJOHy.useState)($d736550e3de5add3$var$defaultState);
    const unsubscribeRef = (0, $eJOHy.useRef)(null);
    const { getHoverPopoverContentById: getHoverPopoverContentById, subscribeHoverPopoverContentDeleteById: subscribeHoverPopoverContentDeleteById } = (0, $3OT15.useHoverPopoverContent)();
    const setPopoverClosed = (0, $eJOHy.useCallback)(()=>{
        setHoverPopoverState($d736550e3de5add3$var$defaultState);
    }, [
        setHoverPopoverState
    ]);
    /**
	 * When a popoover is opened, we subscribe to whether the content ref is deleted (i.e user switches from read to edit mode).
	 * If the content ref is deleted, we close the popover.
	 */ const setPopoverOpen = (0, $eJOHy.useCallback)(({ fieldId: fieldId, cell: cell, clearHoverFocusState: clearHoverFocusState })=>{
        const content = getHoverPopoverContentById(fieldId);
        if (!content) return;
        setHoverPopoverState({
            ...content,
            isOpen: true,
            cellRef: cell
        });
        unsubscribeRef.current = subscribeHoverPopoverContentDeleteById(fieldId, clearHoverFocusState);
    }, [
        setHoverPopoverState,
        getHoverPopoverContentById,
        subscribeHoverPopoverContentDeleteById
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            unsubscribeRef.current?.();
        };
    }, []);
    const stateValue = (0, $eJOHy.useMemo)(()=>({
            hoverPopoverState: hoverPopoverState
        }), [
        hoverPopoverState
    ]);
    const setterValue = (0, $eJOHy.useMemo)(()=>({
            setPopoverClosed: setPopoverClosed,
            setPopoverOpen: setPopoverOpen
        }), [
        setPopoverClosed,
        setPopoverOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverStateContext.Provider, {
        value: stateValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverSetterContext.Provider, {
        value: setterValue
    }, children));
};
const $d736550e3de5add3$export$ecaed54879b49151 = ()=>{
    const context = (0, $eJOHy.useContext)($d736550e3de5add3$var$HoverPopoverStateContext);
    if (context === undefined) throw new Error('useHoverPopover must be used within a HoverPopoverProvider');
    return context;
};
const $d736550e3de5add3$export$3ced34cbab3dc9bf = ()=>{
    const context = (0, $eJOHy.useContext)($d736550e3de5add3$var$HoverPopoverSetterContext);
    if (context === undefined) throw new Error('useHoverPopover must be used within a HoverPopoverProvider');
    return context;
};
const $d736550e3de5add3$export$3240cf68ec0b7d81 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3OT15.HoverPopoverContentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d736550e3de5add3$var$HoverPopoverProviderLocal, null, children));
};

});
parcelRegister("3OT15", function(module, exports) {
$parcel$export(module.exports, "HoverPopoverContentProvider", () => $0eef00447d3c2884$export$ae46fde6067ae6a0);
$parcel$export(module.exports, "useHoverPopoverContent", () => $0eef00447d3c2884$export$b82953ec381ff123);
$parcel$export(module.exports, "useHoverPopoverContentRef", () => $0eef00447d3c2884$export$674a542a71639eb6);

var $eJOHy = parcelRequire("eJOHy");

var $hX7Ca = parcelRequire("hX7Ca");
const $0eef00447d3c2884$var$HoverPopoverContentContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $0eef00447d3c2884$export$ae46fde6067ae6a0 = ({ children: children })=>{
    /**
	 * cellRefFieldIdMap is a map of cell refs to field IDs. This is used by the
	 * event delegator to lookup which field is hovered by table cell ref.
	 */ const cellRefFieldIdMap = (0, $hX7Ca.useLazyRef)(()=>new Map());
    /**
	 * fieldIdPopoverContentMap is a map of ARI field IDs to hover popover content.
	 * This is used by the hover popover state provider to lookup what the content for a hover popover
	 * is by a given field ID. In conjunction with the cellRefFieldIdMap above, this allows us to
	 * lookup the content for a hover popover by a given table cell ref.
	 */ const fieldIdPopoverContentMap = (0, $hX7Ca.useLazyRef)(()=>new Map());
    /**
	 * deleteListeners is a map of ARI field IDs to a set of delete listeners. See comments below on deleteHoverPopoverContentById.
	 */ const deleteListeners = (0, $hX7Ca.useLazyRef)(()=>new Map());
    const setCellIdByRef = (0, $eJOHy.useCallback)((cell, fieldId)=>{
        cellRefFieldIdMap.current.set(cell, fieldId);
    }, [
        cellRefFieldIdMap
    ]);
    const getCellIdByRef = (0, $eJOHy.useCallback)((cell)=>{
        return cellRefFieldIdMap.current.get(cell);
    }, [
        cellRefFieldIdMap
    ]);
    const deleteCellIdByRef = (0, $eJOHy.useCallback)((cell)=>{
        cellRefFieldIdMap.current.delete(cell);
    }, [
        cellRefFieldIdMap
    ]);
    const setHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId, content)=>{
        fieldIdPopoverContentMap.current.set(fieldId, content);
    }, [
        fieldIdPopoverContentMap
    ]);
    const getHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId)=>{
        return fieldIdPopoverContentMap.current.get(fieldId);
    }, [
        fieldIdPopoverContentMap
    ]);
    /**
	 * When a user hovers on a cell a popover opens. Then if they open inline edit we need the popover to close.
	 *
	 * The popover is attached using the hoverPopoverContentRef. When the popup is mounted, subscribeHoverPopoverContentDeleteById
	 * is called which allows us to subscribe to calls to deleteHoverPopoverContentById. When the component unmounts, the hover popover content ref will call this
	 * delete method (i.e user switches from read to edit mode), which calls any listeners (e.g closePopup).
	 */ const deleteHoverPopoverContentById = (0, $eJOHy.useCallback)((fieldId)=>{
        const isDeleted = fieldIdPopoverContentMap.current.delete(fieldId);
        if (isDeleted && deleteListeners.current.has(fieldId)) {
            for (const listener of deleteListeners.current.get(fieldId) ?? [])listener(fieldId);
            deleteListeners.current.delete(fieldId);
        }
    }, [
        fieldIdPopoverContentMap,
        deleteListeners
    ]);
    const subscribeHoverPopoverContentDeleteById = (0, $eJOHy.useCallback)((fieldId, listener)=>{
        if (!deleteListeners.current.has(fieldId)) deleteListeners.current.set(fieldId, new Set());
        deleteListeners.current.get(fieldId)?.add(listener);
        return ()=>{
            const listeners = deleteListeners.current.get(fieldId);
            if (listeners) {
                listeners.delete(listener);
                if (listeners.size === 0) deleteListeners.current.delete(fieldId);
            }
        };
    }, [
        deleteListeners
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            setCellIdByRef: setCellIdByRef,
            deleteCellIdByRef: deleteCellIdByRef,
            getCellIdByRef: getCellIdByRef,
            setHoverPopoverContentById: setHoverPopoverContentById,
            deleteHoverPopoverContentById: deleteHoverPopoverContentById,
            getHoverPopoverContentById: getHoverPopoverContentById,
            subscribeHoverPopoverContentDeleteById: subscribeHoverPopoverContentDeleteById
        }), [
        setCellIdByRef,
        deleteCellIdByRef,
        getCellIdByRef,
        setHoverPopoverContentById,
        deleteHoverPopoverContentById,
        getHoverPopoverContentById,
        subscribeHoverPopoverContentDeleteById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eef00447d3c2884$var$HoverPopoverContentContext.Provider, {
        value: contextValue
    }, children);
};
const $0eef00447d3c2884$export$b82953ec381ff123 = ()=>{
    const context = (0, $eJOHy.useContext)($0eef00447d3c2884$var$HoverPopoverContentContext);
    if (context === undefined) throw new Error('useHoverPopoverContent must be used within a HoverPopoverContentProvider');
    return context;
};
const $0eef00447d3c2884$export$674a542a71639eb6 = (fieldId)=>{
    const lastNode = (0, $eJOHy.useRef)(null);
    const { setHoverPopoverContentById: setHoverPopoverContentById, deleteHoverPopoverContentById: deleteHoverPopoverContentById } = $0eef00447d3c2884$export$b82953ec381ff123();
    const hoverPopoverContentRefFactory = (0, $eJOHy.useCallback)((content)=>(node)=>{
            if (node && fieldId) {
                setHoverPopoverContentById(fieldId, {
                    ...content,
                    contentElement: node
                });
                lastNode.current = node;
            } else if (lastNode.current && fieldId) {
                deleteHoverPopoverContentById(fieldId);
                lastNode.current = null;
            }
        }, [
        fieldId,
        setHoverPopoverContentById,
        deleteHoverPopoverContentById
    ]);
    return hoverPopoverContentRefFactory;
};

});
parcelRegister("hX7Ca", function(module, exports) {
$parcel$export(module.exports, "getClosestTextElement", () => $d5817523e8234df4$export$a4c1c84a8efc2153);
$parcel$export(module.exports, "checkIsClamped", () => $d5817523e8234df4$export$63c32f0123c21b4d);
$parcel$export(module.exports, "useLazyRef", () => $d5817523e8234df4$export$fd27aa36f007ec3d);

var $eJOHy = parcelRequire("eJOHy");
const $d5817523e8234df4$export$a4c1c84a8efc2153 = (el)=>{
    if (!el || !el.children || el.children.length === 0) return el;
    const elements = [
        el
    ];
    for (const e of elements){
        if (e.clientWidth !== e.scrollWidth) return e;
        for (const child of e.children)elements.push(child);
    }
    return el;
};
const $d5817523e8234df4$export$63c32f0123c21b4d = (el)=>{
    if (!el) return false;
    if (!(el instanceof Element)) return false;
    const currentStyle = getComputedStyle(el);
    const lineClamp = parseInt(currentStyle.getPropertyValue('-webkit-line-clamp'), 10);
    if (lineClamp > 0 && currentStyle.getPropertyValue('overflow') === 'hidden') return el.scrollHeight > el.clientHeight;
    return false;
};
const $d5817523e8234df4$var$uniqueReferencedValue = {};
function $d5817523e8234df4$export$fd27aa36f007ec3d(initializer) {
    const ref = (0, $eJOHy.useRef)($d5817523e8234df4$var$uniqueReferencedValue);
    if (ref.current === $d5817523e8234df4$var$uniqueReferencedValue) ref.current = initializer();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref;
}

});



parcelRegister("f4DUY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f06e7986112c40eb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cQxBL = parcelRequire("cQxBL");

var $1OQKp = parcelRequire("1OQKp");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $jE8Tu = parcelRequire("jE8Tu");

var $1NtzV = parcelRequire("1NtzV");
const $f06e7986112c40eb$var$ExpandHeaderCell = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasExpandedItems = (0, $jE8Tu.useHasExpandedItems)();
    const getScreenReaderMessage = ()=>{
        if (hasExpandedItems) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderCollapseButton;
        return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderExpandButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderExpandButton;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        xcss: $f06e7986112c40eb$var$hierarchyHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $f06e7986112c40eb$var$headerIconStyles
    }, hasExpandedItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderCollapseButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderCollapseButton),
        color: "currentColor",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1NtzV.default).columnHeaderExpandButtonIssueTermRefresh : (0, $1NtzV.default).columnHeaderExpandButton),
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, formatMessage(getScreenReaderMessage()))));
};
/* TODO: remove after cleaning jsc_m2_hierarchy - style added for the onboarding spotlight  */ const $f06e7986112c40eb$var$hierarchyHeaderStyles = (0, $1DXK0.xcss)({
    height: 'size.300'
});
const $f06e7986112c40eb$var$headerIconStyles = (0, $1DXK0.xcss)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
var $f06e7986112c40eb$export$2e2bcd8739ae039 = $f06e7986112c40eb$var$ExpandHeaderCell;

});
parcelRegister("1NtzV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c95e471dc06941e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5c95e471dc06941e$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderExpandButton: {
        "id": "native-issue-table.column-header-expand-button",
        "defaultMessage": "Show all issues - expanded"
    },
    columnHeaderCollapseButton: {
        "id": "native-issue-table.column-header-collapse-button",
        "defaultMessage": "Show all issues - collapsed"
    },
    columnHeaderExpandButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-expand-button-issue-term-refresh",
        "defaultMessage": "Show all work items - expanded"
    },
    columnHeaderCollapseButtonIssueTermRefresh: {
        "id": "native-issue-table.column-header-collapse-button-issue-term-refresh",
        "defaultMessage": "Show all work items - collapsed"
    }
});
var $5c95e471dc06941e$export$2e2bcd8739ae039 = $5c95e471dc06941e$var$messages;

});


parcelRegister("lqvgs", function(module, exports) {
$parcel$export(module.exports, "CheckboxCell", () => $9bcf807234d52bfa$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $9bcf807234d52bfa$export$b9d19e1dc166efac);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $6djmC = parcelRequire("6djmC");

var $2QO3b = parcelRequire("2QO3b");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $bJscI = parcelRequire("bJscI");

var $4EKqI = parcelRequire("4EKqI");

var $da0uW = parcelRequire("da0uW");

var $bjHjL = parcelRequire("bjHjL");
const $9bcf807234d52bfa$var$MaybeCheckboxUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "checkbox-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "header-checkbox-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $9bcf807234d52bfa$export$e0722abfbf26acc0 = ({ issueId: issueId, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        onClick: ()=>(0, $2QO3b.abortAll)('new_interaction'),
        ...checkboxProps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $da0uW.CheckboxCell), {
        issueId: issueId,
        ...checkboxProps
    }));
};
const $9bcf807234d52bfa$export$b9d19e1dc166efac = ({ ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "header-checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        onClick: ()=>(0, $2QO3b.abortAll)('new_interaction'),
        ...checkboxProps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9bcf807234d52bfa$var$MaybeHeaderCheckboxUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $da0uW.HeaderCheckboxCell), checkboxProps));
};

});
parcelRegister("86tBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzg1nfn _1dk71nfn _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("da0uW", function(module, exports) {
$parcel$export(module.exports, "CheckboxCell", () => $c779eb0d2caf5c35$export$e0722abfbf26acc0);
$parcel$export(module.exports, "HeaderCheckboxCell", () => $c779eb0d2caf5c35$export$b9d19e1dc166efac);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $86tBw = parcelRequire("86tBw");

var $6djmC = parcelRequire("6djmC");

var $2QO3b = parcelRequire("2QO3b");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cxKOj = parcelRequire("cxKOj");


var $jE8Tu = parcelRequire("jE8Tu");

var $3TtKq = parcelRequire("3TtKq");

var $bjHjL = parcelRequire("bjHjL");
const $c779eb0d2caf5c35$var$EMPTY_ARRAY = [];
const $c779eb0d2caf5c35$export$e0722abfbf26acc0 = ({ issueId: issueId, rowIndex: rowIndex, depth: depth, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isIssueSelected = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelected)({
        rowIndex: rowIndex,
        issueId: issueId,
        depth: depth ?? 0
    }) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelectedOld)(issueId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const flatListIssueIds = (0, $jE8Tu.useIssueIds)();
    const { selectedOnlyIssueId: selectedOnlyIssueId, checkIssueRow: checkIssueRow } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const isShiftPressed = (0, $eJOHy.useRef)(false);
    const onCheckboxChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: toggleCheckboxChecked,
            selectionType: isShiftPressed.current ? 'shift' : 'default'
        });
        checkIssueRow(issueId, toggleCheckboxChecked, isShiftPressed.current, flatListIssueIds, (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? depth : undefined);
    }, [
        checkIssueRow,
        issueId,
        flatListIssueIds,
        depth
    ]);
    const handleSelectedOnlyIssueId = (0, $eJOHy.useCallback)((ev)=>{
        ev.preventDefault();
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'checkbox',
            action: 'changed'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'newIssueNavigatorTableRow', {
            isCheckboxChecked: true,
            selectionType: 'ctrl'
        });
        selectedOnlyIssueId(issueId);
    }, [
        createAnalyticsEvent,
        selectedOnlyIssueId,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bjHjL.messages).checkboxAriaLabelIssueTermRefresh : (0, $bjHjL.messages).checkboxAriaLabel),
        isChecked: isIssueSelected,
        onChange: onCheckboxChange,
        onClick: (ev)=>{
            isShiftPressed.current = ev.shiftKey;
            (0, $2QO3b.abortAll)('new_interaction');
        },
        onKeyDown: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey && ev.code === 'Space') handleSelectedOnlyIssueId(ev);
        },
        onContextMenu: (ev)=>{
            if (!isIssueSelected && ev.ctrlKey) handleSelectedOnlyIssueId(ev);
        }
    }));
};
const $c779eb0d2caf5c35$export$b9d19e1dc166efac = ({ groupByFieldId: groupByFieldId, totalIssueSearchResultCount: totalIssueSearchResultCount, ...checkboxProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedIssueIdsOld = (0, $3TtKq.useIssueTableSelectedIssues)();
    const { excludedIssueIds: excludedIssueIds, selectedIssueIds: selectedIssueIds } = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useSelectedIssuesState)() : {
        excludedIssueIds: new Set(),
        selectedIssueIds: []
    };
    const { insertSelectedIssueIds: insertSelectedIssueIds, reset: reset, selectAllIssues: selectAllIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const childIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jE8Tu.useChildIssueIds)() : $c779eb0d2caf5c35$var$EMPTY_ARRAY;
    const prevGroupByFieldId = (0, $eJOHy.useRef)(groupByFieldId);
    if (prevGroupByFieldId.current !== groupByFieldId) {
        prevGroupByFieldId.current = groupByFieldId;
        reset();
    }
    const issueIds = (0, $jE8Tu.useIssueIds)();
    const isChecked = (0, $3TtKq.useAreAllIssuesSelected)(issueIds);
    const allUnloadedOrLoadedChilds = (0, $eJOHy.useMemo)(()=>new Set([
            ...childIssueIds,
            ...selectedIssueIds
        ]), [
        childIssueIds,
        selectedIssueIds
    ]);
    const isIndeterminate = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsHeaderCheckboxIndeterminate)({
        isChecked: isChecked,
        allUnloadedOrLoadedChilds: allUnloadedOrLoadedChilds
    }) : !isChecked && selectedIssueIdsOld.length > 0;
    const onCheckboxChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const toggleCheckboxChecked = e.target.checked;
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'bulkSelectTableRows', {
            isCheckboxChecked: toggleCheckboxChecked
        });
        if (isIndeterminate || !isChecked) {
            if ((0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) {
                const exceedsLimit = totalIssueSearchResultCount && totalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
                const hasInteracted = excludedIssueIds.size > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedIssueIds, allUnloadedOrLoadedChilds);
                if (isIndeterminate && exceedsLimit && !hasInteracted) reset();
                else selectAllIssues({
                    childIds: childIssueIds,
                    visibleIds: issueIds,
                    count: totalIssueSearchResultCount
                });
            } else insertSelectedIssueIds(issueIds);
        } else if (isChecked) reset();
    }, [
        isIndeterminate,
        isChecked,
        totalIssueSearchResultCount,
        reset,
        selectAllIssues,
        insertSelectedIssueIds,
        issueIds,
        childIssueIds,
        excludedIssueIds,
        selectedIssueIds,
        allUnloadedOrLoadedChilds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "center",
        "data-vc": "header-checkbox-cell"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        ...checkboxProps,
        "aria-label": formatMessage((0, $bjHjL.messages).headerCheckboxAriaLabel),
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        onChange: onCheckboxChange,
        onClick: ()=>{
            (0, $2QO3b.abortAll)('new_interaction');
        }
    }));
};

});
const $ac0d9865d010f3a9$export$ed483e23b857a8f6 = 'edit-button';
const $ac0d9865d010f3a9$export$c9fe64c29742060e = 'sidebar-header';
const $ac0d9865d010f3a9$export$8789cbfc17809729 = 'sidebar-search';
const $ac0d9865d010f3a9$export$9d8014b892bf6344 = 'sidebar-field';
const $ac0d9865d010f3a9$export$f08be8cd81d9f623 = 382;
const $ac0d9865d010f3a9$export$3a2b34d7e17c7646 = 448;
const $ac0d9865d010f3a9$export$9c1c16e5827224e9 = 'bulkMenu';
const $ac0d9865d010f3a9$export$e9a6cdc6ca093f61 = 'bulkEdit';
const $ac0d9865d010f3a9$export$2de0d879ab3de42d = 'bulkTransition';
const $ac0d9865d010f3a9$export$bccea427639cacb7 = 1000;

parcelRegister("3TtKq", function(module, exports) {
$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $8531abba95832313$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $8531abba95832313$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $8531abba95832313$export$ad5f97924b14314b);
$parcel$export(module.exports, "useSelectedIssuesState", () => $8531abba95832313$export$b1fbb226d385face);
$parcel$export(module.exports, "useIssueTableSelectAllTotalSelected", () => $8531abba95832313$export$dc4b7e7d055a0e6c);
$parcel$export(module.exports, "useIsIssueSelectedOld", () => $8531abba95832313$export$f1f122caeb05df26);
$parcel$export(module.exports, "useIsIssueSelected", () => $8531abba95832313$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $8531abba95832313$export$949e47631f4a60a5);
$parcel$export(module.exports, "useIsHeaderCheckboxIndeterminate", () => $8531abba95832313$export$c5603c18b2a7ed7a);
$parcel$export(module.exports, "useIsSelectingAll", () => $8531abba95832313$export$815cd134b5001b40);
$parcel$export(module.exports, "useExcludedIssueIds", () => $8531abba95832313$export$f8e8cd326aec0190);

var $cSmYj = parcelRequire("cSmYj");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $cxKOj = parcelRequire("cxKOj");


var $1hqwo = parcelRequire("1hqwo");
const $8531abba95832313$export$b11112517798dbed = (0, $6E16M.createContainer)();
const $8531abba95832313$var$Store = (0, $GtRbT.createStore)({
    initialState: $1hqwo.initialState,
    actions: $1hqwo.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $8531abba95832313$export$b11112517798dbed
});
const $8531abba95832313$export$b4602482fdfd31ed = (0, $iJq0l.createActionsHook)($8531abba95832313$var$Store);
const $8531abba95832313$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $8531abba95832313$export$ad5f97924b14314b = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedIssueIdsSelector
});
const $8531abba95832313$var$getSelectedState = (state)=>{
    return state;
};
const $8531abba95832313$export$b1fbb226d385face = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedState
});
const $8531abba95832313$var$getSelectAllTotalSelected = (state, totalIssueSearchResultCount)=>{
    return totalIssueSearchResultCount + state.selectedIssueIds.size - state.exclusionCount - state.excludedIssueIds.size;
};
const $8531abba95832313$export$dc4b7e7d055a0e6c = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectAllTotalSelected
});
const $8531abba95832313$var$getIsIssueIdSelectedSelector = (state, { rowIndex: rowIndex, issueId: issueId, depth: depth })=>{
    // issueId is a uuid when optimistically created via inline create and therefore NaN
    const isOptimisticIssueId = Number.isNaN(Number(issueId)) && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
    if (isOptimisticIssueId) return false;
    const selectLimit = (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - state.exclusionCount;
    if (state.isSelectingAll && (rowIndex > selectLimit - 1 || state.excludedIssueIds.has(issueId)) && !state.selectedIssueIds.has(issueId)) return false;
    return state.isSelectingAll && !depth || state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$var$getIsIssueIdSelectedSelectorOld = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$export$f1f122caeb05df26 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelectorOld
});
const $8531abba95832313$export$cfefd69fc8a5ac52 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelector
});
const $8531abba95832313$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    if (state.isSelectingAll && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) // everything is selected unless there are issues in excludedIssueIds
    return state.excludedIssueIds.size === 0;
    if (!issueIds) return false;
    return issueIds.length > 0 && issueIds.every((issueId)=>state.selectedIssueIds.has(issueId));
};
const $8531abba95832313$export$949e47631f4a60a5 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getAreAllIssuesSelectedSelector
});
const $8531abba95832313$var$getIsHeaderCheckboxIndeterminate = (state, { isChecked: isChecked, allUnloadedOrLoadedChilds: allUnloadedOrLoadedChilds })=>{
    const { isSelectingAll: isSelectingAll, totalIssueSearchResultCount: totalIssueSearchResultCount, excludedIssueIds: excludedIssueIds, selectedIssueIds: selectedIssueIds } = state;
    if (isSelectingAll) {
        const isOverSelectAllLimit = totalIssueSearchResultCount && totalIssueSearchResultCount >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
        const hasExcludedIssuesAndNotAllExcluded = excludedIssueIds.size > 0 && totalIssueSearchResultCount !== excludedIssueIds.size;
        const hasUnselectedExpandedChild = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(selectedIssueIds, allUnloadedOrLoadedChilds);
        return isOverSelectAllLimit || hasExcludedIssuesAndNotAllExcluded || hasUnselectedExpandedChild;
    }
    return !isChecked && selectedIssueIds.size > 0;
};
const $8531abba95832313$export$c5603c18b2a7ed7a = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsHeaderCheckboxIndeterminate
});
const $8531abba95832313$var$getIsSelectingAll = (state)=>{
    return state.isSelectingAll;
};
const $8531abba95832313$export$815cd134b5001b40 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsSelectingAll
});
const $8531abba95832313$var$getExcludedIssueIds = (state)=>{
    return Array.from(state.excludedIssueIds);
};
const $8531abba95832313$export$f8e8cd326aec0190 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getExcludedIssueIds
});

});
parcelRegister("1hqwo", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $d2b10d6e7ee3216e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state


var $cxKOj = parcelRequire("cxKOj");
const $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a = {
    isSelectingAll: false,
    exclusionCount: 0,
    selectedIssueIds: new Set([]),
    excludedIssueIds: new Set([]),
    lastSelectedRowIndex: null,
    totalIssueSearchResultCount: null
};
const $d2b10d6e7ee3216e$export$e324594224ef24da = {
    selectAllIssues: (data)=>({ dispatch: dispatch, setState: setState }, { onIssueSelected: onIssueSelected, shouldForceManualSelectAll: shouldForceManualSelectAll })=>{
            const { childIds: childIds, count: count, visibleIds: visibleIds } = data;
            const hasReachedLimit = (visibleIds.length ?? 0) >= (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
            const limitedVisibleIds = hasReachedLimit ? visibleIds.slice(0, (0, $ac0d9865d010f3a9$export$bccea427639cacb7)) : visibleIds;
            if (shouldForceManualSelectAll || hasReachedLimit) // when grouping is enabled or the first page is not loaded we should disable "true" select all functionality
            // and fallback to selecting all the loaded issue ids
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(limitedVisibleIds));
            else {
                // otherwise conditions are met for true select all
                onIssueSelected?.([]);
                setState({
                    isSelectingAll: true,
                    exclusionCount: childIds?.length ?? 0,
                    selectedIssueIds: new Set(childIds ?? []),
                    excludedIssueIds: new Set([]),
                    totalIssueSearchResultCount: count
                });
            }
        },
    checkIssueRowSelectAll: (selectedIssueIds, isChecked, isShiftPressed, flatList, currentCheckedIndex, depth)=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const beyondLimitIssueIds = selectedIssueIds.filter((id)=>{
                    const idx = flatList.findIndex((flatId)=>flatId === id);
                    return idx > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1;
                });
                const withinLimitIssueIds = selectedIssueIds.filter((id)=>{
                    const idx = flatList.findIndex((flatId)=>flatId === id);
                    return idx < (0, $ac0d9865d010f3a9$export$bccea427639cacb7);
                });
                if (isChecked) {
                    const updatedExcludedIssueIds = new Set(currentState.excludedIssueIds);
                    withinLimitIssueIds.forEach((id)=>updatedExcludedIssueIds.delete(id));
                    setState({
                        selectedIssueIds: new Set([
                            ...currentState.selectedIssueIds,
                            ...beyondLimitIssueIds
                        ]),
                        excludedIssueIds: updatedExcludedIssueIds
                    });
                } else {
                    const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
                    beyondLimitIssueIds.forEach((id)=>updatedSelectedIssueIds.delete(id));
                    const updatedExcludedIssueIds = new Set([
                        ...currentState.excludedIssueIds,
                        ...withinLimitIssueIds
                    ]);
                    setState({
                        selectedIssueIds: updatedSelectedIssueIds,
                        excludedIssueIds: updatedExcludedIssueIds
                    });
                    // if all issues have been excluded, we are not selecting all anymore
                    if (updatedExcludedIssueIds.size === currentState.totalIssueSearchResultCount) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.reset());
                }
                return;
            }
            if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.addToSelectAllIssues(selectedIssueIds, currentCheckedIndex, depth));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.excludeFromSelectAllIssues(selectedIssueIds, currentCheckedIndex, depth));
        },
    excludeFromSelectAllIssues: (issueIds, rowIndex, depth = 0)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const currentState = getState();
            if (rowIndex <= (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1 && depth === 0) {
                const updatedExcludedIssueIds = new Set([
                    ...currentState.excludedIssueIds,
                    ...issueIds
                ]);
                setState({
                    excludedIssueIds: updatedExcludedIssueIds
                });
                // if all issues have been excluded, we are not selecting all anymore
                if (updatedExcludedIssueIds.size === currentState.totalIssueSearchResultCount) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.reset());
            } else {
                const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
                issueIds.forEach((issueId)=>updatedSelectedIssueIds.delete(issueId));
                setState({
                    selectedIssueIds: updatedSelectedIssueIds
                });
            }
        },
    addToSelectAllIssues: (issueIds, rowIndex, depth = 0)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (rowIndex > (0, $ac0d9865d010f3a9$export$bccea427639cacb7) - 1 || depth > 0) setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...issueIds
                ])
            });
            else {
                const updatedExcludedIssueIds = new Set(currentState.excludedIssueIds);
                issueIds.forEach((issueId)=>updatedExcludedIssueIds.delete(issueId));
                setState({
                    excludedIssueIds: updatedExcludedIssueIds
                });
            }
        },
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList, depth)=>({ dispatch: dispatch, getState: getState })=>{
            // issueId is a uuid when optimistically created via inline create and therefore NaN
            const isOptimisticIssueId = Number.isNaN(Number(issueId)) && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
            if (isOptimisticIssueId) return;
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (currentState.isSelectingAll && (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.checkIssueRowSelectAll(selectedIssueIds, isChecked, isShiftPressed, flatList, currentCheckedIndex, depth));
            else if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("bjHjL", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b1f512fd4e489e96$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b1f512fd4e489e96$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    checkboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label",
        "defaultMessage": "Issue checkbox"
    },
    checkboxAriaLabelIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.checkbox.checkbox-aria-label-issue-term-refresh",
        "defaultMessage": "Work item checkbox"
    },
    headerCheckboxAriaLabel: {
        "id": "native-issue-table.common.issue-cells.checkbox.header-checkbox-aria-label",
        "defaultMessage": "Select all checkbox"
    }
});

});



parcelRegister("kmIYY", function(module, exports) {
$parcel$export(module.exports, "IssueTableSkeleton", () => $d01bd5b1473e1c91$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $d01bd5b1473e1c91$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d01bd5b1473e1c91$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d01bd5b1473e1c91$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coBPg", function(module, exports) {
$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $f004264ba9491c9c$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $9co9i = parcelRequire("9co9i");
const $f004264ba9491c9c$var$customCssStyles = null;
const $f004264ba9491c9c$var$containerStyles = {
    height: '448px'
};
const $f004264ba9491c9c$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9co9i))),
        containerStyles: $f004264ba9491c9c$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9co9i", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("dmolI", function(module, exports) {
$parcel$export(module.exports, "getColumnConfig", () => $7eb0a7a19768d5ff$export$38a3f9395eadb298);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $6XJko = parcelRequire("6XJko");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $kpvjE = parcelRequire("kpvjE");
const $7eb0a7a19768d5ff$export$47c53e05a89322a1 = (0, $LFmXM.default)((formatMessage)=>({
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jif_fixed_width_for_assignee_column_in_nin') ? (0, $8jOO7.COLUMN_WIDTH_ASSIGNEE) : (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 40,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TIMELINE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: formatMessage((0, $kpvjE.default).oldestToNewestOrderOld),
                descText: formatMessage((0, $kpvjE.default).newestToOldestOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? 140 : 96,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $kpvjE.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld),
                warningText: formatMessage((0, $kpvjE.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: 201
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: formatMessage((0, $kpvjE.default).aToZOrderOld),
                descText: formatMessage((0, $kpvjE.default).zToAOrderOld)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $j8Km1.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ATLAS_PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RELATIONSHIP]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            })
    }));
const $7eb0a7a19768d5ff$export$f7ea0b98861f6494 = (0, $LFmXM.default)((formatMessage)=>{
    const aToZOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_A_TO_Z) : formatMessage((0, $kpvjE.default).aToZOrder);
    const zToAOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_Z_TO_A) : formatMessage((0, $kpvjE.default).zToAOrder);
    const oldestToNewestOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_OLDEST_TO_NEWEST) : formatMessage((0, $kpvjE.default).oldestToNewestOrder);
    const newestToOldestOrder = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $8jOO7.SORT_NEWEST_TO_OLDEST) : formatMessage((0, $kpvjE.default).newestToOldestOrder);
    return {
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jif_fixed_width_for_assignee_column_in_nin') ? (0, $8jOO7.COLUMN_WIDTH_ASSIGNEE) : (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX]: ()=>({
                defaultWidth: 40,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED]: ()=>({
                defaultWidth: 201,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED]: ()=>({
                defaultWidth: 201,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TIMELINE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE]: ()=>({
                defaultWidth: 140,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION_DATE]: ()=>({
                defaultWidth: 106,
                ascText: oldestToNewestOrder,
                descText: newestToOldestOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 140,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? 140 : 96,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                } : {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EXPAND_BUTTON]: ()=>({
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                title: '',
                defaultWidth: 48,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                // Overrides title from the server's displayName from "Issue Type" to "Type" as per designs
                title: formatMessage((0, $kpvjE.default).columnHeaderIssueType),
                defaultWidth: 101,
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RESOLUTION]: ()=>({
                defaultWidth: 106,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REPORTER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CREATOR]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SPRINT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PARENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SUMMARY),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        // Labels renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
        // <Tag/> has a maxWidth of 180px with 4px of padding either side
        // And we need to accound for 5px & 8px for left and right padding on our cell respectively
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS]: ()=>({
                defaultWidth: 201,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).COMPONENTS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).FIX_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STATUS_CATEGORY]: ()=>({
                defaultWidth: 140
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).EPIC_LINK]: ()=>({
                // EpicLink renders using an Atlaskit Tag which doesn't respect its container, and there's no prop to override it...
                // <Tag/> has a maxWidth of 180px with 4px of padding either side
                // And we need to account for 5px & 8px for left and right padding on our cell respectively
                defaultWidth: 201,
                ascText: aToZOrder,
                descText: zToAOrder,
                warningText: formatMessage((0, $kpvjE.default).deprecatedEpicLinkMessage, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            color: "color.text.inverse",
                            as: "strong"
                        }, chunks)
                })
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DESCRIPTION]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ENVIRONMENT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT_AREA]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_LONG),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEXT]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).READ_ONLY]: ()=>({
                defaultWidth: (0, $8jOO7.COLUMN_WIDTH_TEXT_SHORT),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).AFFECTS_VERSIONS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).REQUEST_TYPE]: ()=>({
                defaultWidth: 251,
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CUSTOM_LABELS]: ()=>({
                defaultWidth: 201,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_TIME]: ()=>({
                defaultWidth: 201,
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).URL]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ascText: aToZOrder,
                descText: zToAOrder
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MULTI_USER_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).TEAM]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ORIGINAL_ESTIMATE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: (0, $8jOO7.SORT_LOWEST_TO_HIGHEST),
                    descText: (0, $8jOO7.SORT_HIGHEST_TO_LOWEST)
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).GOALS]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CASCADING_SELECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).CONFLUENCE_PAGES]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).PEOPLE]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: aToZOrder,
                    descText: zToAOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).DATE_PICKER]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH),
                ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                    ascText: oldestToNewestOrder,
                    descText: newestToOldestOrder
                }
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]: ()=>({
                defaultWidth: (0, $j8Km1.MERGED_COLUMN_DEFAULT_WIDTH),
                isSortable: false
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).ATLAS_PROJECT]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            }),
        [(0, $j8Km1.KNOWN_COLUMN_TYPES).RELATIONSHIP]: ()=>({
                defaultWidth: (0, $8jOO7.DEFAULT_COLUMN_WIDTH)
            })
    };
});
const $7eb0a7a19768d5ff$export$38a3f9395eadb298 = (formatMessage)=>{
    return (0, $6XJko.isVisualRefreshEnabled)() ? $7eb0a7a19768d5ff$export$f7ea0b98861f6494(formatMessage) : $7eb0a7a19768d5ff$export$47c53e05a89322a1(formatMessage);
};

});
parcelRegister("kpvjE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6783773279e9ee3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6783773279e9ee3$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.common.utils.get-column-config.column-header-issue-type",
        "defaultMessage": "Type"
    },
    aToZOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order-old",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order-old",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order-old",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrderOld: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order-old",
        "defaultMessage": "newest \u279E oldest"
    },
    deprecatedEpicLinkMessage: {
        "id": "native-issue-table.common.utils.get-column-config.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    },
    aToZOrder: {
        "id": "native-issue-table.common.utils.get-column-config.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "native-issue-table.common.utils.get-column-config.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.common.utils.get-column-config.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    }
});
var $e6783773279e9ee3$export$2e2bcd8739ae039 = $e6783773279e9ee3$var$messages;

});


parcelRegister("l7qKV", function(module, exports) {
$parcel$export(module.exports, "getColumnsWithStickyOffsets", () => $5ccab77fed5b6341$export$6e976bf0e5378347);

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");
const $5ccab77fed5b6341$var$calculateStickyOffsets = (orderedStickyColumns, nonStickyColumns)=>{
    let cumulativeStickyOffset = 0;
    const processedStickyColumns = orderedStickyColumns.map((column, i)=>{
        const { id: id, customWidth: customWidth, defaultWidth: defaultWidth } = column;
        const stickyOffsets = cumulativeStickyOffset;
        if (id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) cumulativeStickyOffset += defaultWidth + (0, $8jOO7.EXPAND_CELL_PADDING);
        else cumulativeStickyOffset += customWidth ?? defaultWidth;
        const isLastStickyColumn = id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) ? column.mergedColumns && column.mergedColumns.length > 0 && i === orderedStickyColumns.length - 1 : i === orderedStickyColumns.length - 1;
        return {
            ...column,
            isColumnSticky: true,
            stickyOffsets: stickyOffsets,
            isLastStickyColumn: isLastStickyColumn
        };
    });
    return [
        ...processedStickyColumns,
        ...nonStickyColumns
    ];
};
const $5ccab77fed5b6341$export$6e976bf0e5378347 = (columnConfig, stickyColumnIds)=>{
    const stickyColumnsById = {};
    const orderedStickyColumns = [];
    const nonStickyColumns = [];
    // if there are no sticky columns we don't calculate offsets and set any columns to sticky
    // this avoids a bug where checkbox is rendered as sticky before the stickyColumnIds are populated
    // due to concurrent rendering
    if (stickyColumnIds && stickyColumnIds.length === 0 && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) return columnConfig;
    columnConfig.forEach((column)=>{
        const { id: id } = column;
        if (id === (0, $8jOO7.COLUMN_ID_CHECKBOX) || id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) orderedStickyColumns.push(column);
        else if (id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) {
            const { mergedColumns: mergedColumns = [] } = column;
            const isMergedCellSticky = mergedColumns.some((mergedCol)=>stickyColumnIds?.includes(mergedCol.id));
            if (isMergedCellSticky) orderedStickyColumns.push(column);
            else nonStickyColumns.push(column);
        } else if (stickyColumnIds?.includes(id)) stickyColumnsById[id] = column;
        else nonStickyColumns.push(column);
    });
    stickyColumnIds?.forEach((columnId)=>{
        if (stickyColumnsById[columnId]) orderedStickyColumns.push(stickyColumnsById[columnId]);
    });
    return $5ccab77fed5b6341$var$calculateStickyOffsets(orderedStickyColumns, nonStickyColumns);
};

});

parcelRegister("P01So", function(module, exports) {
$parcel$export(module.exports, "isNonNullish", () => $a4f78649e91890cd$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $a4f78649e91890cd$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $a4f78649e91890cd$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $a4f78649e91890cd$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $a4f78649e91890cd$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "desanitizeField", () => $a4f78649e91890cd$export$261830fe943e88ac);

var $j8Km1 = parcelRequire("j8Km1");

function $a4f78649e91890cd$export$70573498ee17fe1d(value) {
    return value != null;
}
function $a4f78649e91890cd$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $j8Km1.KNOWN_COLUMN_TYPES)).includes(value);
}
function $a4f78649e91890cd$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $a4f78649e91890cd$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $a4f78649e91890cd$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $a4f78649e91890cd$export$261830fe943e88ac = (field)=>{
    const firstChar = field[0];
    const lastChar = field[field.length - 1];
    if ((firstChar === '"' || firstChar === "'") && firstChar === lastChar) return field.slice(1, -1).toLowerCase();
    return field.toLowerCase();
};

});

parcelRegister("kbYhH", function(module, exports) {
$parcel$export(module.exports, "useElementSizeSelector", () => $815a2426d7099138$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $815a2426d7099138$export$73bf76c50625186);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $815a2426d7099138$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $815a2426d7099138$export$638cf470f916deb7 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $815a2426d7099138$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $815a2426d7099138$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $815a2426d7099138$var$Store = (0, $GtRbT.createStore)({
    containedBy: $815a2426d7099138$export$638cf470f916deb7,
    initialState: $815a2426d7099138$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $815a2426d7099138$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $815a2426d7099138$export$6af5bd31f067d7e5 = (0, $iJq0l.createStateHook)($815a2426d7099138$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $815a2426d7099138$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eJOHy.useState)($815a2426d7099138$export$e4c0458e30711294);
    (0, $eJOHy.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $815a2426d7099138$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $815a2426d7099138$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($815a2426d7099138$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

parcelRegister("4hsdx", function(module, exports) {
$parcel$export(module.exports, "FeaturesContainer", () => $8decaf9559798f71$export$449fd4f36db88f87);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $iFFNS = parcelRequire("iFFNS");
const $8decaf9559798f71$var$ContextualFeatureAnalytics = ({ children: children })=>{
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    const isColumnResizingEnabled = (0, $34oCh.useIsColumnResizingEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const isIssueOperationMeatballMenuEnabled = (0, $34oCh.useIsIssueOperationMeatballMenuEnabled)();
    const isColumnBordersEnabled = (0, $34oCh.useIsColumnBordersEnabled)();
    const isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    let isConditionalFormattingEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_conditional_formatting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isOpenIssueLinkEnabled = (0, $4cTDP.fg)('jira_issue_table_open_issue_link_config') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsOpenIssueLinkEnabled)() : true;
    const isProjectQuickstartOnboardingEnabled = (0, $34oCh.useIsProjectQuickstartOnboardingEnabled)();
    const isSkipIssueCreateSuccessFlagEnabled = (0, $34oCh.useIsSkipIssueCreateSuccessFlagEnabled)();
    const isInBetweenStickyColumnPickerEnabled = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsInBetweenStickyColumnPickerEnabled)() : false;
    const isColumnConfigColumnEnabled = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsColumnConfigColumnEnabled)() : true;
    const isRemoveColumnEnabled = (0, $4cTDP.fg)('jira_issue_table_remove_column_check') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsRemoveColumnEnabled)() : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            issueTableFeatures: {
                isDensityFull: isDensityFull,
                isVirtualizationEnabled: isVirtualizationEnabled,
                isColumnResizingEnabled: isColumnResizingEnabled,
                isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isInfiniteScrollEnabled: isInfiniteScrollEnabled,
                isSiblingIssueCreateEnabled: isSiblingIssueCreateEnabled,
                isChildIssueCreateEnabled: isChildIssueCreateEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
                isColumnBordersEnabled: isColumnBordersEnabled,
                isRowReorderingEnabled: isRowReorderingEnabled,
                isEntireRowDraggable: isEntireRowDraggable,
                isGridNavigationEnabled: isGridNavigationEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isMergedColumnVisible: isMergedColumnVisible,
                isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
                isStickyColumnsEnabled: isStickyColumnsEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled,
                isOpenIssueLinkEnabled: isOpenIssueLinkEnabled,
                isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled,
                isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled,
                isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled,
                isColumnConfigColumnEnabled: isColumnConfigColumnEnabled,
                isRemoveColumnEnabled: isRemoveColumnEnabled
            }
        }
    }, children);
};
const $8decaf9559798f71$export$449fd4f36db88f87 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iFFNS.FeaturesContainerInternal), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8decaf9559798f71$var$ContextualFeatureAnalytics, null, children));
};

});
parcelRegister("34oCh", function(module, exports) {
$parcel$export(module.exports, "useIsDensityFull", () => $0a9c6aee69856176$export$f031d973e8f9ebd1);
$parcel$export(module.exports, "useIsVirtualizationEnabled", () => $0a9c6aee69856176$export$e8cb30aec148fb72);
$parcel$export(module.exports, "useIsColumnResizingEnabled", () => $0a9c6aee69856176$export$928fba01e945632a);
$parcel$export(module.exports, "useIsFixedTableLayoutEnabled", () => $0a9c6aee69856176$export$bce4f421d3fcab1b);
$parcel$export(module.exports, "useIsInlineEditingEnabled", () => $0a9c6aee69856176$export$3e66c03eddc15634);
$parcel$export(module.exports, "useIsInlineEditingExtendedFieldSupportEnabled", () => $0a9c6aee69856176$export$2763573a98b052ad);
$parcel$export(module.exports, "useIsIssueCreateEnabled", () => $0a9c6aee69856176$export$543273904a8063c6);
$parcel$export(module.exports, "useIsInfiniteScrollEnabled", () => $0a9c6aee69856176$export$de7fbee8ed52ae4);
$parcel$export(module.exports, "useIsSiblingIssueCreateEnabled", () => $0a9c6aee69856176$export$f1842b07a822e21a);
$parcel$export(module.exports, "useIsChildIssueCreateEnabled", () => $0a9c6aee69856176$export$1c15679efffd4e2b);
$parcel$export(module.exports, "useIsIssueRankDescending", () => $0a9c6aee69856176$export$82982f49a24a3a9b);
$parcel$export(module.exports, "useIsIssueHierarchyEnabled", () => $0a9c6aee69856176$export$4f04f80fe2006454);
$parcel$export(module.exports, "useIsIssueOperationMeatballMenuEnabled", () => $0a9c6aee69856176$export$a99d862d213ae04);
$parcel$export(module.exports, "useIsRowReorderingEnabled", () => $0a9c6aee69856176$export$3c2a1b4963d788c8);
$parcel$export(module.exports, "useIsEntireRowDraggable", () => $0a9c6aee69856176$export$40143afd2a4a7546);
$parcel$export(module.exports, "useIsReparentingEnabled", () => $0a9c6aee69856176$export$64a4c7b004e35cb6);
$parcel$export(module.exports, "useIsDragAndDropEnabled", () => $0a9c6aee69856176$export$b4fbf34545c95b8e);
$parcel$export(module.exports, "useProjectContext", () => $0a9c6aee69856176$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useSortField", () => $0a9c6aee69856176$export$f8f71fe8cdc658b6);
$parcel$export(module.exports, "useSortDirection", () => $0a9c6aee69856176$export$c88af24ce42b9b94);
$parcel$export(module.exports, "useJql", () => $0a9c6aee69856176$export$f813789488fdc0c7);
$parcel$export(module.exports, "useIsColumnBordersEnabled", () => $0a9c6aee69856176$export$8136b1ebbacf80ef);
$parcel$export(module.exports, "useIsInlineFieldConfigEnabled", () => $0a9c6aee69856176$export$edb9f869c9fd4d6e);
$parcel$export(module.exports, "useIsInBetweenColumnPickerEnabled", () => $0a9c6aee69856176$export$9e70cd1d138c2276);
$parcel$export(module.exports, "useIsSingleLineRowHeightEnabled", () => $0a9c6aee69856176$export$626f961c251cf22e);
$parcel$export(module.exports, "useIsHideDoneItemsEnabled", () => $0a9c6aee69856176$export$41bad204cf3bf31b);
$parcel$export(module.exports, "useIsMergedColumnEnabled", () => $0a9c6aee69856176$export$f6d8bbcfea5cc718);
$parcel$export(module.exports, "useIsMergedColumnVisible", () => $0a9c6aee69856176$export$28416a110952f775);
$parcel$export(module.exports, "useIsChildIssuesTableVisualUpliftEnabled", () => $0a9c6aee69856176$export$5e14421c97bdcf37);
$parcel$export(module.exports, "useIsIssueRankingEnabled", () => $0a9c6aee69856176$export$7fa8121781f45255);
$parcel$export(module.exports, "useIsStickyColumnsEnabled", () => $0a9c6aee69856176$export$6050cee0da5e731b);
$parcel$export(module.exports, "useIsStickyColumnsVisible", () => $0a9c6aee69856176$export$9cc19f3a611a61c0);
$parcel$export(module.exports, "useIsAutoUnstickyOnSmallScreenEnabled", () => $0a9c6aee69856176$export$ab0624efaf6f43c6);
$parcel$export(module.exports, "useIsConditionalFormattingEnabled", () => $0a9c6aee69856176$export$c799a83481d5936b);
$parcel$export(module.exports, "useIsTimelineEnabled", () => $0a9c6aee69856176$export$1a04536b4e3a55ba);
$parcel$export(module.exports, "useIsOpenIssueLinkEnabled", () => $0a9c6aee69856176$export$7923c1bfde5e54d8);
$parcel$export(module.exports, "useIsGridNavigationEnabled", () => $0a9c6aee69856176$export$2903dd9e444e3b01);
$parcel$export(module.exports, "useCellBorderStyle", () => $0a9c6aee69856176$export$1eb373d02f6c5617);
$parcel$export(module.exports, "useIsProjectQuickstartOnboardingEnabled", () => $0a9c6aee69856176$export$3fba142df85df85e);
$parcel$export(module.exports, "useIsRelationshipFieldEnabled", () => $0a9c6aee69856176$export$836cda5e064d5cca);
$parcel$export(module.exports, "useIsRemoteLinkedIssuesEnabled", () => $0a9c6aee69856176$export$a0b21d85bbf85b54);
$parcel$export(module.exports, "useIsEditableSyncLoaded", () => $0a9c6aee69856176$export$1b794ad90463ad6e);
$parcel$export(module.exports, "useIsSkipIssueCreateSuccessFlagEnabled", () => $0a9c6aee69856176$export$32da4d6adc350864);
$parcel$export(module.exports, "useIsInBetweenStickyColumnPickerEnabled", () => $0a9c6aee69856176$export$cc3d2b69eec92586);
$parcel$export(module.exports, "useIsColumnConfigColumnEnabled", () => $0a9c6aee69856176$export$2b72beca6275e92a);
$parcel$export(module.exports, "useIsRemoveColumnEnabled", () => $0a9c6aee69856176$export$108430cb09038e65);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $8jOO7 = parcelRequire("8jOO7");

var $iFFNS = parcelRequire("iFFNS");
const $0a9c6aee69856176$export$f031d973e8f9ebd1 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.density === (0, $8jOO7.DENSITY_FULL)
});
const $0a9c6aee69856176$export$e8cb30aec148fb72 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.density === (0, $8jOO7.DENSITY_COMPACT) && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$928fba01e945632a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnResizingEnabled
});
const $0a9c6aee69856176$export$bce4f421d3fcab1b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isFixedTableLayoutEnabled
});
const $0a9c6aee69856176$export$3e66c03eddc15634 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineEditingEnabled
});
const $0a9c6aee69856176$export$2763573a98b052ad = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineEditingExtendedFieldSupportEnabled
});
const $0a9c6aee69856176$export$543273904a8063c6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$de7fbee8ed52ae4 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$f1842b07a822e21a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$1c15679efffd4e2b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueCreateEnabled && state.isIssueHierarchyEnabled
});
const $0a9c6aee69856176$export$82982f49a24a3a9b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueRankDescending
});
const $0a9c6aee69856176$export$4f04f80fe2006454 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueHierarchyEnabled && state.isInfiniteScrollEnabled
});
const $0a9c6aee69856176$export$a99d862d213ae04 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueOperationMeatballMenuEnabled
});
const $0a9c6aee69856176$export$3c2a1b4963d788c8 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled
});
const $0a9c6aee69856176$export$40143afd2a4a7546 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isEntireRowDraggable
});
const $0a9c6aee69856176$export$64a4c7b004e35cb6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isReparentingEnabled
});
const $0a9c6aee69856176$export$b4fbf34545c95b8e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRowReorderingEnabled || state.isReparentingEnabled || state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$8f31c2503e1efa93 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.projectContext
});
const $0a9c6aee69856176$export$f8f71fe8cdc658b6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.sortField
});
const $0a9c6aee69856176$export$c88af24ce42b9b94 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.sortDirection
});
const $0a9c6aee69856176$export$f813789488fdc0c7 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.jql
});
const $0a9c6aee69856176$export$8136b1ebbacf80ef = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnBordersEnabled
});
const $0a9c6aee69856176$export$edb9f869c9fd4d6e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInlineFieldConfigEnabled
});
const $0a9c6aee69856176$export$9e70cd1d138c2276 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInBetweenColumnPickerEnabled
});
const $0a9c6aee69856176$export$626f961c251cf22e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isSingleLineRowHeightEnabled
});
const $0a9c6aee69856176$export$41bad204cf3bf31b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isHideDoneItemsEnabled
});
const $0a9c6aee69856176$export$f6d8bbcfea5cc718 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isMergedColumnEnabled
});
const $0a9c6aee69856176$export$28416a110952f775 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isMergedColumnVisible
});
const $0a9c6aee69856176$export$5e14421c97bdcf37 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isChildIssuesTableVisualUpliftEnabled
});
const $0a9c6aee69856176$export$7fa8121781f45255 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isIssueRankingEnabled
});
const $0a9c6aee69856176$export$6050cee0da5e731b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsEnabled
});
const $0a9c6aee69856176$export$9cc19f3a611a61c0 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isStickyColumnsVisible
});
const $0a9c6aee69856176$export$ab0624efaf6f43c6 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isAutoUnstickyOnSmallScreenEnabled
});
const $0a9c6aee69856176$export$c799a83481d5936b = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isConditionalFormattingEnabled
});
const $0a9c6aee69856176$export$1a04536b4e3a55ba = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isTimelineEnabled
});
const $0a9c6aee69856176$export$7923c1bfde5e54d8 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isOpenIssueLinkEnabled
});
const $0a9c6aee69856176$export$2903dd9e444e3b01 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isGridNavigationEnabled
});
const $0a9c6aee69856176$export$1eb373d02f6c5617 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.cellBorderStyle
});
const $0a9c6aee69856176$export$3fba142df85df85e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isProjectQuickstartOnboardingEnabled
});
const $0a9c6aee69856176$export$836cda5e064d5cca = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isLinkRelationshipFieldEnabled
});
const $0a9c6aee69856176$export$a0b21d85bbf85b54 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRemoteLinkedIssuesEnabled
});
const $0a9c6aee69856176$export$1b794ad90463ad6e = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isEditableSyncLoaded
});
const $0a9c6aee69856176$export$32da4d6adc350864 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isSkipIssueCreateSuccessFlagEnabled
});
const $0a9c6aee69856176$export$cc3d2b69eec92586 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isInBetweenStickyColumnPickerEnabled
});
const $0a9c6aee69856176$export$2b72beca6275e92a = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isColumnConfigColumnEnabled
});
const $0a9c6aee69856176$export$108430cb09038e65 = (0, $iJq0l.createStateHook)((0, $iFFNS.FeaturesStore), {
    selector: (state)=>state.isRemoveColumnEnabled
});

});
parcelRegister("iFFNS", function(module, exports) {
$parcel$export(module.exports, "FeaturesContainerInternal", () => $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec);
$parcel$export(module.exports, "FeaturesStore", () => $fec205bcdab5c4a8$export$b78abb146634afd0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");
const $fec205bcdab5c4a8$var$initialState = {
    density: (0, $8jOO7.DENSITY_COMPACT),
    isColumnResizingEnabled: true,
    isFixedTableLayoutEnabled: true,
    isInlineEditingEnabled: true,
    isInlineEditingExtendedFieldSupportEnabled: false,
    isIssueCreateEnabled: false,
    projectContext: null,
    isInfiniteScrollEnabled: false,
    isIssueRankingEnabled: false,
    isIssueRankDescending: false,
    isIssueHierarchyEnabled: false,
    isIssueOperationMeatballMenuEnabled: true,
    isRowReorderingEnabled: false,
    isEntireRowDraggable: false,
    isReparentingEnabled: false,
    isColumnBordersEnabled: true,
    isGridNavigationEnabled: false,
    isInlineFieldConfigEnabled: false,
    isInBetweenColumnPickerEnabled: false,
    isSingleLineRowHeightEnabled: false,
    isHideDoneItemsEnabled: false,
    isMergedColumnEnabled: false,
    isMergedColumnVisible: false,
    isChildIssuesTableVisualUpliftEnabled: false,
    isStickyColumnsEnabled: false,
    isStickyColumnsVisible: false,
    isAutoUnstickyOnSmallScreenEnabled: false,
    isConditionalFormattingEnabled: false,
    isTimelineEnabled: false,
    cellBorderStyle: 'FULL_BORDER',
    isProjectQuickstartOnboardingEnabled: false,
    isLinkRelationshipFieldEnabled: false,
    isRemoteLinkedIssuesEnabled: false,
    isEditableSyncLoaded: false,
    isOpenIssueLinkEnabled: true,
    isSkipIssueCreateSuccessFlagEnabled: false,
    isInBetweenStickyColumnPickerEnabled: false,
    isColumnConfigColumnEnabled: true,
    isRemoveColumnEnabled: true
};
const $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec = (0, $6E16M.createContainer)();
const $fec205bcdab5c4a8$var$updateStore = ({ setState: setState }, { density: density, isColumnResizingEnabled: isColumnResizingEnabled, isInlineEditingEnabled: isInlineEditingEnabled, isIssueCreateEnabled: isIssueCreateEnabled, isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled, projectContext: projectContext, isInfiniteScrollEnabled: isInfiniteScrollEnabled, sortDirection: sortDirection, sortField: sortField, isIssueHierarchyEnabled: isIssueHierarchyEnabled, isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled, isRowReorderingEnabled: isRowReorderingEnabled, isEntireRowDraggable: isEntireRowDraggable, isReparentingEnabled: isReparentingEnabled, jql: jql, isColumnBordersEnabled: isColumnBordersEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isMergedColumnEnabled: isMergedColumnEnabled, isMergedColumnVisible: isMergedColumnVisible, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isIssueRankingEnabled: isIssueRankingEnabled, isStickyColumnsEnabled: isStickyColumnsEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled = false, isTimelineEnabled: isTimelineEnabled, cellBorderStyle: cellBorderStyle, isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isOpenIssueLinkEnabled: isOpenIssueLinkEnabled, isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled, isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled, isColumnConfigColumnEnabled: isColumnConfigColumnEnabled, isRemoveColumnEnabled: isRemoveColumnEnabled })=>{
    setState({
        density: density,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFixedTableLayoutEnabled: isColumnResizingEnabled,
        isInlineEditingEnabled: isInlineEditingEnabled,
        isInlineEditingExtendedFieldSupportEnabled: isInlineEditingExtendedFieldSupportEnabled,
        isIssueCreateEnabled: isIssueCreateEnabled && Boolean(projectContext),
        projectContext: projectContext ?? null,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled,
        isIssueHierarchyEnabled: isIssueHierarchyEnabled && Boolean(projectContext),
        isIssueRankingEnabled: isIssueRankingEnabled,
        isIssueRankDescending: sortDirection === (0, $8jOO7.SORT_DESC),
        isIssueOperationMeatballMenuEnabled: isIssueOperationMeatballMenuEnabled,
        isRowReorderingEnabled: isRowReorderingEnabled,
        isEntireRowDraggable: isEntireRowDraggable,
        isReparentingEnabled: isReparentingEnabled,
        sortDirection: sortDirection,
        sortField: sortField,
        jql: jql,
        isColumnBordersEnabled: isColumnBordersEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        isHideDoneItemsEnabled: isHideDoneItemsEnabled,
        isMergedColumnEnabled: isMergedColumnEnabled,
        isMergedColumnVisible: isMergedColumnVisible,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isStickyColumnsEnabled: isStickyColumnsEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isTimelineEnabled: isTimelineEnabled,
        cellBorderStyle: cellBorderStyle,
        isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded,
        isOpenIssueLinkEnabled: isOpenIssueLinkEnabled,
        isSkipIssueCreateSuccessFlagEnabled: isSkipIssueCreateSuccessFlagEnabled,
        isInBetweenStickyColumnPickerEnabled: isInBetweenStickyColumnPickerEnabled,
        isColumnConfigColumnEnabled: isColumnConfigColumnEnabled,
        isRemoveColumnEnabled: isRemoveColumnEnabled
    });
};
const $fec205bcdab5c4a8$export$b78abb146634afd0 = (0, $GtRbT.createStore)({
    initialState: $fec205bcdab5c4a8$var$initialState,
    actions: {},
    containedBy: $fec205bcdab5c4a8$export$8a9f5b92d3cec1ec,
    handlers: {
        onInit: ()=>$fec205bcdab5c4a8$var$updateStore,
        onContainerUpdate: ()=>$fec205bcdab5c4a8$var$updateStore
    }
});

});



parcelRegister("jKV5x", function(module, exports) {
$parcel$export(module.exports, "SelectedRowContainer", () => $909ecdd45b96ffd4$export$613ab77d2c52b90d);

var $EveTi = parcelRequire("EveTi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $3TtKq = parcelRequire("3TtKq");

var $jILqm = parcelRequire("jILqm");
const $909ecdd45b96ffd4$var$initialState = {
    selectedRowIndex: null,
    amountOfRows: 0,
    focusedRowIndex: null
};
const $909ecdd45b96ffd4$var$Store = (0, $GtRbT.createStore)({
    initialState: $909ecdd45b96ffd4$var$initialState,
    actions: $jILqm.default,
    name: 'selectedRowState'
});
const $909ecdd45b96ffd4$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($909ecdd45b96ffd4$var$Store, {
    onInit: ()=>({ setState: setState }, { selectedRowIndex: selectedRowIndex = null, amountOfRows: amountOfRows = 0 })=>{
            setState({
                selectedRowIndex: selectedRowIndex,
                amountOfRows: amountOfRows
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState }, { selectedRowIndex: newRowIndex, amountOfRows: newAmountOfRows })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            selectedRowIndex !== newRowIndex && setState({
                selectedRowIndex: newRowIndex ?? null
            });
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows ?? 0
            });
        }
});
const $909ecdd45b96ffd4$export$613ab77d2c52b90d = ({ issues: issues, onPageChange: onPageChange, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $EveTi.default), issues);
    const { insertSelectedIssueIds: insertSelectedIssueIds, removeSelectedIssueIds: removeSelectedIssueIds } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const lastSelectedRow = (0, $eJOHy.useRef)(null);
    const cursors = data?.pageCursors?.around;
    const currentPageIndex = (0, $eJOHy.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const onNextPage = (0, $eJOHy.useCallback)(()=>{
        if (onPageChange && currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) onPageChange(nextPage.cursor, false);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onPreviousPage = (0, $eJOHy.useCallback)(()=>{
        if (onPageChange && currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) onPageChange(previousPage.cursor, true);
        }
    }, [
        currentPageIndex,
        cursors,
        onPageChange
    ]);
    const onCheckRow = (0, $eJOHy.useCallback)((rowIndex, isChecked, isShiftSelected)=>{
        const initialIssueId = data?.edges?.[rowIndex]?.node?.issueId;
        if (!initialIssueId) return;
        const selectedIssueIds = [
            initialIssueId
        ];
        if (isShiftSelected && lastSelectedRow.current !== null) {
            const start = Math.min(lastSelectedRow.current, rowIndex);
            const end = Math.max(lastSelectedRow.current, rowIndex);
            for(let i = start; i <= end; i++){
                const currentIssueId = data?.edges?.[i]?.node?.issueId;
                if (i !== rowIndex && currentIssueId) selectedIssueIds.push(currentIssueId);
            }
        }
        lastSelectedRow.current = rowIndex;
        if (isChecked) insertSelectedIssueIds(selectedIssueIds);
        else removeSelectedIssueIds(selectedIssueIds);
    }, [
        data?.edges,
        insertSelectedIssueIds,
        removeSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($909ecdd45b96ffd4$export$42a852a2b6b56249, {
        ...props,
        onNextPage: onNextPage,
        onPreviousPage: onPreviousPage,
        onCheckRow: onCheckRow
    });
};
const $909ecdd45b96ffd4$export$11a86b67953bcc50 = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state)=>state.selectedRowIndex
});
const $909ecdd45b96ffd4$export$fb40a80c530e5f2b = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.selectedRowIndex === selectedRowIndex
});
const $909ecdd45b96ffd4$export$a774b9356e1b793 = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state, { selectedRowIndex: selectedRowIndex })=>state.focusedRowIndex === selectedRowIndex
});
const $909ecdd45b96ffd4$export$7b16b18429291a5c = (0, $iJq0l.createActionsHook)($909ecdd45b96ffd4$var$Store);
const $909ecdd45b96ffd4$export$f8ee25964657042a = (0, $iJq0l.createHook)($909ecdd45b96ffd4$var$Store, {
    selector: (state)=>state.amountOfRows
});

});
parcelRegister("EveTi", function(module, exports) {
$parcel$export(module.exports, "default", () => $59dceb25da57e3f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a3fa6fd9898db324998b23e343f4083>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $59dceb25da57e3f8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "SelectedRowContainer",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$59dceb25da57e3f8$var$node.hash = "768571ad9e025ec88f84f83f5e4f5108";
var $59dceb25da57e3f8$export$2e2bcd8739ae039 = $59dceb25da57e3f8$var$node;

});

parcelRegister("jILqm", function(module, exports) {
$parcel$export(module.exports, "default", () => $496a7015da5426ec$export$2e2bcd8739ae039);
const $496a7015da5426ec$var$actions = {
    setSelectedRow: (rowIndex)=>({ getState: getState, setState: setState }, { onRowChange: onRowChange })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (selectedRowIndex !== rowIndex && amountOfRows > 0) {
                setState({
                    selectedRowIndex: rowIndex,
                    focusedRowIndex: rowIndex
                });
                onRowChange && onRowChange(rowIndex);
            }
        },
    resetFocus: ()=>({ getState: getState, setState: setState })=>{
            const { focusedRowIndex: focusedRowIndex } = getState();
            focusedRowIndex !== null && setState({
                focusedRowIndex: null
            });
        },
    setAmountOfRows: (newAmountOfRows)=>({ setState: setState, getState: getState })=>{
            const { amountOfRows: amountOfRows } = getState();
            amountOfRows !== newAmountOfRows && setState({
                amountOfRows: newAmountOfRows
            });
        },
    selectNextRow: ()=>({ getState: getState, dispatch: dispatch }, { onNextPage: onNextPage })=>{
            const { amountOfRows: amountOfRows, selectedRowIndex: selectedRowIndex } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($496a7015da5426ec$var$actions.setSelectedRow(0));
            else if (selectedRowIndex < amountOfRows - 1) dispatch($496a7015da5426ec$var$actions.setSelectedRow(selectedRowIndex + 1));
            else if (selectedRowIndex === amountOfRows - 1 && onNextPage) onNextPage();
        },
    selectPrevRow: ()=>({ getState: getState, dispatch: dispatch }, { onPreviousPage: onPreviousPage })=>{
            const { selectedRowIndex: selectedRowIndex, amountOfRows: amountOfRows } = getState();
            if (amountOfRows === 0) return;
            // edge case: we have only one blank issues in the list, we want to make it key accessible
            if (selectedRowIndex === null) dispatch($496a7015da5426ec$var$actions.setSelectedRow(0));
            else if (selectedRowIndex > 0) dispatch($496a7015da5426ec$var$actions.setSelectedRow(selectedRowIndex - 1));
            else if (selectedRowIndex === 0 && onPreviousPage) onPreviousPage();
        },
    checkRow: (rowIndex, isChecked, isShiftPressed)=>(_, { onCheckRow: onCheckRow })=>{
            onCheckRow && onCheckRow(rowIndex, isChecked, isShiftPressed);
        }
};
var $496a7015da5426ec$export$2e2bcd8739ae039 = $496a7015da5426ec$var$actions;

});


parcelRegister("6LwYU", function(module, exports) {
$parcel$export(module.exports, "SiblingCreateActiveIndexContainer", () => $cce11cf956429fbb$export$3bb3687dbfff2504);
$parcel$export(module.exports, "useIsSiblingIssueCreateActive", () => $cce11cf956429fbb$export$1e0d27763664702c);
$parcel$export(module.exports, "useSiblingCreateActiveIndexActions", () => $cce11cf956429fbb$export$c2ceb7cc1900ce28);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $cce11cf956429fbb$var$CLEAR_DELAY = 300;
const $cce11cf956429fbb$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $cce11cf956429fbb$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($cce11cf956429fbb$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($cce11cf956429fbb$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($cce11cf956429fbb$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $cce11cf956429fbb$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $cce11cf956429fbb$export$3bb3687dbfff2504 = (0, $6E16M.createContainer)();
const $cce11cf956429fbb$var$Store = (0, $GtRbT.createStore)({
    initialState: $cce11cf956429fbb$var$initialState,
    actions: $cce11cf956429fbb$var$actions,
    containedBy: $cce11cf956429fbb$export$3bb3687dbfff2504
});
const $cce11cf956429fbb$var$isIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $cce11cf956429fbb$export$1e0d27763664702c = (0, $iJq0l.createHook)($cce11cf956429fbb$var$Store, {
    selector: (state, index)=>$cce11cf956429fbb$var$isIndexEqual(state.issue.index, index)
});
const $cce11cf956429fbb$export$c2ceb7cc1900ce28 = (0, $iJq0l.createActionsHook)($cce11cf956429fbb$var$Store);
const $cce11cf956429fbb$export$7de76a106681e3b2 = (0, $iJq0l.createHook)($cce11cf956429fbb$var$Store);

});

parcelRegister("6KVf0", function(module, exports) {
$parcel$export(module.exports, "InlineCreateActiveIndexContainer", () => $27ce9003fc1e8500$export$293e9de3e94ac3e3);
$parcel$export(module.exports, "useInlineCreateActiveIndexActions", () => $27ce9003fc1e8500$export$109b1f65f6277f1f);
$parcel$export(module.exports, "useInlineFieldCreateActiveIndex", () => $27ce9003fc1e8500$export$b47f84449b2c30b5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $27ce9003fc1e8500$var$CLEAR_DELAY = 300;
const $27ce9003fc1e8500$export$3378d8ea7d02abd0 = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isHovered: false,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $27ce9003fc1e8500$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($27ce9003fc1e8500$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($27ce9003fc1e8500$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($27ce9003fc1e8500$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $27ce9003fc1e8500$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    setIsHovered: (key)=>({ getState: getState, setState: setState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: true
                }
            });
        },
    clearIsHovered: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isHovered: false
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $27ce9003fc1e8500$export$293e9de3e94ac3e3 = (0, $6E16M.createContainer)();
const $27ce9003fc1e8500$var$Store = (0, $GtRbT.createStore)({
    initialState: $27ce9003fc1e8500$export$3378d8ea7d02abd0,
    actions: $27ce9003fc1e8500$var$actions,
    containedBy: $27ce9003fc1e8500$export$293e9de3e94ac3e3
});
const $27ce9003fc1e8500$export$121b3ed4dfcef179 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store);
const $27ce9003fc1e8500$export$109b1f65f6277f1f = (0, $iJq0l.createActionsHook)($27ce9003fc1e8500$var$Store);
const $27ce9003fc1e8500$var$getInlineIssueCreate = (state)=>state.issue;
const $27ce9003fc1e8500$var$getInlineFieldCreate = (state)=>state.field;
const $27ce9003fc1e8500$var$isIssueIndexEqual = (a, b)=>a !== undefined && a[0] === b[0] && a[1] === b[1];
const $27ce9003fc1e8500$export$4e43a4c525201572 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: (state, index)=>$27ce9003fc1e8500$var$isIssueIndexEqual(state.issue.index, index)
});
const $27ce9003fc1e8500$export$72e323294e39f1e1 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: $27ce9003fc1e8500$var$getInlineIssueCreate
});
const $27ce9003fc1e8500$export$b47f84449b2c30b5 = (0, $iJq0l.createHook)($27ce9003fc1e8500$var$Store, {
    selector: $27ce9003fc1e8500$var$getInlineFieldCreate
});

});

parcelRegister("3F6xT", function(module, exports) {
$parcel$export(module.exports, "TableIntersectionObserverContainer", () => $38738d16686b0ed7$export$d70db3a85b45c17e);
$parcel$export(module.exports, "useIntersectionObserver", () => $38738d16686b0ed7$export$a7395f9832c00176);
$parcel$export(module.exports, "useObserveItem", () => $38738d16686b0ed7$export$323a1519def7418e);
$parcel$export(module.exports, "useCalculateIssueInsertionPoint", () => $38738d16686b0ed7$export$736db8d31780fc97);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");

var $dEwO3 = parcelRequire("dEwO3");
const $38738d16686b0ed7$export$d4c72bab9d6cc13a = {
    intersectionObserver: null,
    itemsObserved: new Map(),
    insertionPoint: null,
    isObserving: false
};
const $38738d16686b0ed7$export$d70db3a85b45c17e = (0, $6E16M.createContainer)();
const $38738d16686b0ed7$var$actions = {
    /**
	 * Starts the intersection observer to observer any stored item.
	 */ observeItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (isObserving) return;
            if (intersectionObserver != null) itemsObserved.forEach((_, element)=>{
                intersectionObserver.observe(element);
            });
            setState({
                isObserving: true
            });
        },
    /**
	 * Stops the intersection observer.
	 */ unobserveItems: ()=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving } = getState();
            if (!isObserving) return;
            if (intersectionObserver != null) intersectionObserver.disconnect();
            setState({
                isObserving: false
            });
        },
    /**
	 * Disconnect any previous intersection observer stored, if the stored is set to automatically observe,
	 * we start observing any stored item, finally we updated the stored with the new observer.
	 * @param {Object} config
	 * @param {IntersectionObserver} config.intersectionObserver - New IntersectionObserver to be added it
	 */ setIntersectionObserver: ({ intersectionObserver: newIntersectionObserver })=>({ setState: setState, getState: getState })=>{
            const { intersectionObserver: intersectionObserver, isObserving: isObserving, itemsObserved: itemsObserved } = getState();
            if (intersectionObserver != null) intersectionObserver.disconnect();
            if (isObserving) itemsObserved.forEach((_, element)=>{
                newIntersectionObserver.observe(element);
            });
            setState({
                intersectionObserver: newIntersectionObserver
            });
        },
    /**
	 * Add a HTML element ot the list of observed elements. It start's observing automatically
	 * if the stored is observing.
	 * @param {Object} config
	 * @param {HTMLElement} element - HTML Element to be observed
	 * @param {string} issueId - Id of the issue that is associated to the HTML Element that is been observed
	 */ observeItem: ({ element: element, issueId: issueId })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            setState({
                itemsObserved: new Map([
                    ...itemsObserved.entries(),
                    [
                        element,
                        issueId
                    ]
                ])
            });
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.observe(element);
        },
    /**
	 * Removes an element from been observed, I stop's observing the element automatically
	 * if the stored is observing
	 * @param {Object} config
	 * @param {HTMLElement} element - Element to be unobserved
	 */ unobserveItem: ({ element: element })=>({ getState: getState, setState: setState })=>{
            const { intersectionObserver: intersectionObserver, itemsObserved: itemsObserved, isObserving: isObserving } = getState();
            if (itemsObserved.has(element)) {
                const newItemsObserved = new Map(itemsObserved.entries());
                newItemsObserved.delete(element);
                setState({
                    itemsObserved: newItemsObserved
                });
            }
            if (intersectionObserver == null || !isObserving) return;
            intersectionObserver.unobserve(element);
        },
    /**
	 * It stored the insertion point in the stored
	 * @param {InsertionPoint} insertionPoint - Insertion point to be stored
	 */ setInsertionPoint: (insertionPoint)=>({ setState: setState })=>{
            setState({
                insertionPoint: insertionPoint
            });
        }
};
const $38738d16686b0ed7$export$bc23ad63575022d9 = (0, $GtRbT.createStore)({
    initialState: $38738d16686b0ed7$export$d4c72bab9d6cc13a,
    actions: $38738d16686b0ed7$var$actions,
    containedBy: $38738d16686b0ed7$export$d70db3a85b45c17e
});
const $38738d16686b0ed7$export$bfaae927f3082143 = (0, $iJq0l.createHook)($38738d16686b0ed7$export$bc23ad63575022d9);
const $38738d16686b0ed7$export$bc925ad7e18c9ef8 = (0, $iJq0l.createActionsHook)($38738d16686b0ed7$export$bc23ad63575022d9);
const $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER = (0, $8jOO7.ROW_HEIGHT) + 1;
const $38738d16686b0ed7$export$a7395f9832c00176 = ()=>{
    const { setIntersectionObserver: setObserver, setInsertionPoint: setInsertionPoint } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    return (0, $eJOHy.useCallback)((element)=>{
        if (element != null) {
            const observer = new IntersectionObserver((entries)=>{
                const isOverflow = element.scrollHeight > element.clientHeight;
                const mostRecentEntryCloseToFooter = entries.map((entry)=>{
                    if (entry.rootBounds == null) return;
                    const { top: top } = entry.boundingClientRect;
                    const { bottom: interceptLine } = entry.rootBounds;
                    /**
								 * When scrolling upward (mac), the top line of the item rect is
								 * passing from below to above the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * =========  -> Top of item
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Bottom of item (aka top + height )
								 */ const isBelow = top <= interceptLine && top + $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER >= interceptLine;
                    /**
								 * When scrolling downward (mac), the top line of the item rect is
								 * passing from above to below the intercept line. We identify this
								 * because the entry rectangle will look like:
								 *
								 *  --------  -> Top of root
								 * |        |
								 * |        |
								 * ---------  -> Bottom of root (aka intercept line)
								 * =========  -> Top of item
								 * |        |
								 * =========  -> Bottom of item (aka top + height )
								 * If top minus height is below that the intercept line, means that is
								 * rectangle fits
								 */ const isAbove = top >= interceptLine && top - $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER <= interceptLine;
                    // We prioritize below vs above when is possible.
                    if (isBelow) return {
                        position: 'below',
                        entry: entry
                    };
                    if (isAbove) return {
                        position: 'above',
                        entry: entry
                    };
                    // Otherwise; Is pass the intercept line ignored
                    return undefined;
                }).filter((a)=>a !== undefined)// put most recent entries on top, is possible that multiple
                // entries pass the intercept line
                .sort((a, b)=>{
                    if (b.entry.time !== a.entry.time) return b.entry.time - a.entry.time;
                    // Returns the closest to the bottom when the time is the same
                    if (b.entry.boundingClientRect.y > a.entry.boundingClientRect.y) return 1;
                    if (b.entry.boundingClientRect.y < a.entry.boundingClientRect.y) return -1;
                    return 0;
                })// get the most recent one
                .shift();
                if (mostRecentEntryCloseToFooter) setInsertionPoint({
                    element: mostRecentEntryCloseToFooter.entry.target,
                    // Always insert below when is not overflowing
                    position: isOverflow ? mostRecentEntryCloseToFooter.position : 'below'
                });
            }, {
                root: element,
                // We are placing the interceptor just below the header
                // and a row above the footer, as we want to insert the icon
                // at least a row above the footer to be visible
                rootMargin: `-40px 0px -${2 * $38738d16686b0ed7$var$ROW_HEIGHT_WITH_BORDER}px 0px`
            });
            setObserver({
                intersectionObserver: observer
            });
        }
    }, [
        setInsertionPoint,
        setObserver
    ]);
};
const $38738d16686b0ed7$export$323a1519def7418e = (issueId)=>{
    const { observeItem: observeItem, unobserveItem: unobserveItem } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    const itemRef = (0, $eJOHy.useRef)();
    const wasObserved = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>()=>{
            itemRef.current != null && unobserveItem({
                element: itemRef.current
            });
        }, [
        unobserveItem
    ]);
    return (0, $eJOHy.useCallback)((element)=>{
        if (element != null) {
            itemRef.current = element;
            if (issueId != null) {
                observeItem({
                    element: element,
                    issueId: issueId
                });
                wasObserved.current = true;
            }
        }
    }, [
        issueId,
        observeItem
    ]);
};
const $38738d16686b0ed7$export$935a9e0cb21f3923 = (0, $iJq0l.createStateHook)($38738d16686b0ed7$export$bc23ad63575022d9, {
    selector: (0, $dEwO3.getInsertionPointSelector)
});
const $38738d16686b0ed7$export$736db8d31780fc97 = ()=>{
    const { observeItems: observeItems, unobserveItems: unobserveItems } = $38738d16686b0ed7$export$bc925ad7e18c9ef8();
    (0, $eJOHy.useEffect)(()=>{
        observeItems();
        return ()=>{
            unobserveItems();
        };
    }, [
        observeItems,
        unobserveItems
    ]);
    return $38738d16686b0ed7$export$935a9e0cb21f3923();
};

});
parcelRegister("dEwO3", function(module, exports) {
$parcel$export(module.exports, "getInsertionPointSelector", () => $c3d64bf506bc2d61$export$74f2307c2f2b1be0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4MchI = parcelRequire("4MchI");
const $c3d64bf506bc2d61$var$getIssueIdSelector = (0, $4MchI.createSelector)((state)=>state.itemsObserved, (_, element)=>element, (items, element)=>{
    const issueId = items.get(element);
    if (issueId === undefined) return null;
    return issueId;
});
const $c3d64bf506bc2d61$export$74f2307c2f2b1be0 = (state)=>{
    const { insertionPoint: insertionPoint } = state;
    if (insertionPoint == null) return null;
    const { element: element, position: position } = insertionPoint;
    const issueId = $c3d64bf506bc2d61$var$getIssueIdSelector(state, element);
    if (issueId == null) return null;
    return {
        issueId: issueId,
        position: position
    };
};

});


parcelRegister("eqbO4", function(module, exports) {
$parcel$export(module.exports, "LazyEditabilityLoaderContainer", () => $8a9b205a24007018$export$9e924386fdd64f6e);
$parcel$export(module.exports, "useLazyLoadEditability", () => $8a9b205a24007018$export$9b127efb5c6c57e8);

var $eJOHy = parcelRequire("eJOHy");

var $79KwK = parcelRequire("79KwK");

var $j4oe4 = parcelRequire("j4oe4");

var $3pSHx = parcelRequire("3pSHx");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lMr7M = parcelRequire("lMr7M");

var $ehqRw = parcelRequire("ehqRw");

const $8a9b205a24007018$var$initialState = {
    loader: null,
    scheduler: null
};
const $8a9b205a24007018$var$Container = (0, $6E16M.createContainer)();
const $8a9b205a24007018$var$Store = (0, $GtRbT.createStore)({
    containedBy: $8a9b205a24007018$var$Container,
    initialState: $8a9b205a24007018$var$initialState,
    actions: $ehqRw.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment })=>{
                const scheduler = (0, $lMr7M.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((0, $ehqRw.batchIsEditableInIssueViewFactory)(environment), {
                    maxBatchSize: (0, $df5a5f20911361eb$export$fba142522eb62862),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $8a9b205a24007018$export$9e924386fdd64f6e = ({ children: children, scope: scope })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8a9b205a24007018$var$Container, {
        scope: scope,
        environment: environment
    }, children);
};
const $8a9b205a24007018$export$ceb1f4a193b695d1 = (0, $iJq0l.createActionsHook)($8a9b205a24007018$var$Store);
const $8a9b205a24007018$export$9b127efb5c6c57e8 = (id, isEditable)=>{
    const { load: load } = $8a9b205a24007018$export$ceb1f4a193b695d1();
    (0, $eJOHy.useEffect)(()=>{
        const executeLoad = async ()=>{
            // If there is no editability information for the issue field then queue a request to lazily fetch this data
            // We need to explicitly check the ID is an ARI to ignore fields for optimistically created issues, which
            // are initialised as a UUID.
            if (id != null && isEditable === undefined && (0, $3pSHx.JiraIssuefieldvalueAri).check(id)) load(id);
        };
        executeLoad();
    }, [
        isEditable,
        load,
        id
    ]);
};

});
parcelRegister("3pSHx", function(module, exports) {
$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $27ce236fe1a3184f$export$828c4931ae562af7);

var $caazz = parcelRequire("caazz");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issuefieldvalue/manifest.ts
var $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $caazz.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $caazz.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $27ce236fe1a3184f$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("caazz", function(module, exports) {
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $8dae9ec06e7b65f0$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $8dae9ec06e7b65f0$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $8dae9ec06e7b65f0$export$39e9358142fbbc64 = "jira", $8dae9ec06e7b65f0$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("lMr7M", function(module, exports) {
$parcel$export(module.exports, "createDataLoaderScheduler", () => $4339ad4fc34caffc$export$f3542fc7467ff455);

var $3s8bj = parcelRequire("3s8bj");
function $4339ad4fc34caffc$export$f3542fc7467ff455(delay) {
    let cb = [];
    return {
        schedule (callback) {
            cb.push(callback);
        },
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            cb.forEach((callback)=>callback());
            cb = [];
        }, delay)
    };
}

});

parcelRegister("ehqRw", function(module, exports) {
$parcel$export(module.exports, "batchIsEditableInIssueViewFactory", () => $7517476ac4a04208$export$781008fa22e0792);
$parcel$export(module.exports, "actions", () => $7517476ac4a04208$export$e324594224ef24da);

var $cKYG0 = parcelRequire("cKYG0");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $8jOO7 = parcelRequire("8jOO7");

const $7517476ac4a04208$export$781008fa22e0792 = (environment)=>async (fieldIds)=>{
        const isEditableMap = new Map();
        const promise = (0, $j4oe4.fetchQuery)(environment, (0, $cKYG0.default), {
            ids: fieldIds,
            first: (0, $df5a5f20911361eb$export$fba142522eb62862)
        }).toPromise();
        try {
            const data = await promise;
            (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
                data?.jira?.issueFieldsByIds?.edges?.map((edge)=>edge?.node).filter(Boolean).forEach(({ __id: __id, id: id, isEditableInIssueView: isEditableInIssueView })=>{
                    isEditableMap.set(id, isEditableInIssueView ?? null);
                    // Set whether issue fields are editable as a new client-only field on the matching node in the Relay
                    // store
                    store.get(__id)?.setValue(isEditableInIssueView ?? null, 'lazyIsEditableInIssueView');
                });
            });
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'lazyEditabilityLoader',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return fieldIds.map((id)=>isEditableMap.get(id) ?? null);
    };
const $7517476ac4a04208$export$e324594224ef24da = {
    load: (fieldId)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(fieldId) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("cKYG0", function(module, exports) {
$parcel$export(module.exports, "default", () => $15404f3aa4e2d66a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed8b5de75ebbeb144021c7c45b21dfd7>>
 * @relayHash f1b7f7b512da9e0aa08b55196721bc8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1442e789c5171157bf882e3c96a4fe1dbfaf4171cde4fc7ff6761b6ca4e0d511
const $15404f3aa4e2d66a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isEditableInIssueView"
    }, v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "batchIsEditableInIssueViewFactoryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "batchIsEditableInIssueViewFactoryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "issueFieldsByIds",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1442e789c5171157bf882e3c96a4fe1dbfaf4171cde4fc7ff6761b6ca4e0d511",
            "metadata": {},
            "name": "batchIsEditableInIssueViewFactoryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$15404f3aa4e2d66a$var$node.hash = "c26db256f9ee6c88ad5dbf683c6b0507";
var $15404f3aa4e2d66a$export$2e2bcd8739ae039 = $15404f3aa4e2d66a$var$node;

});

const $df5a5f20911361eb$export$fba142522eb62862 = 499;



parcelRegister("jZFgr", function(module, exports) {
$parcel$export(module.exports, "LazyMediaViewContextLoaderContainer", () => $4b1ddbdb2bf7672f$export$c268c26f941d1a5);
$parcel$export(module.exports, "useLazyMediaViewContext", () => $4b1ddbdb2bf7672f$export$5475aeba7ee80aa1);

var $eJOHy = parcelRequire("eJOHy");

var $79KwK = parcelRequire("79KwK");

var $j4oe4 = parcelRequire("j4oe4");

var $d7xa7 = parcelRequire("d7xa7");

var $cHtIB = parcelRequire("cHtIB");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lMr7M = parcelRequire("lMr7M");

var $aHvCt = parcelRequire("aHvCt");

var $93QIg = parcelRequire("93QIg");
const $4b1ddbdb2bf7672f$var$initialState = {
    loader: null,
    scheduler: null
};
const $4b1ddbdb2bf7672f$var$Container = (0, $6E16M.createContainer)();
const $4b1ddbdb2bf7672f$var$Store = (0, $GtRbT.createStore)({
    containedBy: $4b1ddbdb2bf7672f$var$Container,
    initialState: $4b1ddbdb2bf7672f$var$initialState,
    actions: $aHvCt.actions,
    handlers: {
        onInit: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId })=>{
                const scheduler = (0, $lMr7M.createDataLoaderScheduler)(100);
                const loader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((0, $aHvCt.batchMediaViewResponseFactory)(environment, cloudId), {
                    maxBatchSize: (0, $93QIg.MAX_BATCH_SIZE),
                    batchScheduleFn: scheduler.schedule
                });
                setState({
                    loader: loader,
                    scheduler: scheduler
                });
            }
    }
});
const $4b1ddbdb2bf7672f$export$c268c26f941d1a5 = ({ children: children, scope: scope })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b1ddbdb2bf7672f$var$Container, {
        scope: scope,
        environment: environment,
        cloudId: cloudId
    }, children);
};
const $4b1ddbdb2bf7672f$export$2ccec1e3fc6f5f = (0, $iJq0l.createActionsHook)($4b1ddbdb2bf7672f$var$Store);
const $4b1ddbdb2bf7672f$export$5475aeba7ee80aa1 = (issueKey)=>{
    const { load: load } = $4b1ddbdb2bf7672f$export$2ccec1e3fc6f5f();
    const [viewContext, setViewContext] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        const executeLoad = async ()=>{
            // We only want to fetch when viewContext's value hasn't been initialised yet
            if (viewContext === undefined) {
                const viewResponse = await load(issueKey);
                if (viewResponse) setViewContext((0, $d7xa7.viewContextTransformer)(viewResponse));
                else setViewContext(null);
            }
        };
        executeLoad();
    }, [
        viewContext,
        load,
        issueKey
    ]);
    return viewContext ?? null;
};

});
parcelRegister("d7xa7", function(module, exports) {
$parcel$export(module.exports, "getTokenDeltaProps", () => $16b06cb22c076d80$export$4d271852dd07ca26);
$parcel$export(module.exports, "isTokenValid", () => $16b06cb22c076d80$export$d1a8c8b605234fe8);
$parcel$export(module.exports, "viewContextTransformer", () => $16b06cb22c076d80$export$5fb65caa7eb9e932);
// This has TS defs, so when we move to TS let's enable them again
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'jwt-decode'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/jwt-decode/lib/index.js' implicitly has an 'any' type.

var $lNv8v = parcelRequire("lNv8v");
const $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER = 10000;
const $16b06cb22c076d80$export$e9df841c4c486a60 = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() + 0 : undefined;
const $16b06cb22c076d80$export$4d271852dd07ca26 = (token)=>{
    let decodedToken;
    try {
        decodedToken = (0, (/*@__PURE__*/$parcel$interopDefault($lNv8v)))(token);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // why would this be the case
        return {
            tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
            localTimeDelta: undefined,
            tokenExpiryTime: undefined
        };
    }
    // In my testing, sometimes issued at was missing
    const startTimestamp = decodedToken.iat || decodedToken.nbf;
    return {
        tokenDecodeError: undefined,
        localTimeDelta: $16b06cb22c076d80$export$e9df841c4c486a60(startTimestamp * 1000),
        tokenExpiryTime: decodedToken.exp * 1000
    };
};
function $16b06cb22c076d80$export$d1a8c8b605234fe8({ token: token, tokenExpiryTime: tokenExpiryTime, localTimeDelta: localTimeDelta }) {
    if (typeof token !== 'string' || token.length === 0) return false;
    if (typeof tokenExpiryTime !== 'number' || typeof localTimeDelta !== 'number') return false;
    const actualExpiryTime = tokenExpiryTime + localTimeDelta - $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER;
    const timeUntilExpiry = actualExpiryTime - Date.now();
    const isValid = timeUntilExpiry >= 0;
    return isValid;
}
const $16b06cb22c076d80$export$5fb65caa7eb9e932 = (viewResponse)=>{
    const token = viewResponse.tokensWithFiles[0]?.token || null;
    const tokenProps = typeof token === 'string' ? $16b06cb22c076d80$export$4d271852dd07ca26(token) : {};
    const issueId = viewResponse.tokensWithFiles[0]?.files?.[0]?.issueId;
    return {
        clientId: viewResponse.clientId,
        serviceHost: viewResponse.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: viewResponse.tokenLifespanInSeconds * 1000,
        collection: viewResponse.collection !== undefined && viewResponse.collection !== '' ? viewResponse.collection : null,
        tokenIssueTimestamp: Date.now() - $16b06cb22c076d80$var$TOKEN_NETWORK_BUFFER,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime,
        issueId: issueId === undefined ? undefined : String(issueId)
    };
};

});
parcelRegister("lNv8v", function(module, exports) {
'use strict';

var $6bURt = parcelRequire("6bURt");
function $fde6539338bf9ae7$var$InvalidTokenError(message) {
    this.message = message;
}
$fde6539338bf9ae7$var$InvalidTokenError.prototype = new Error();
$fde6539338bf9ae7$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
module.exports = function(token, options) {
    if (typeof token !== 'string') throw new $fde6539338bf9ae7$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($6bURt(token.split('.')[pos]));
    } catch (e) {
        throw new $fde6539338bf9ae7$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
module.exports.InvalidTokenError = $fde6539338bf9ae7$var$InvalidTokenError;

});
parcelRegister("6bURt", function(module, exports) {

var $1UChD = parcelRequire("1UChD");
function $481fe0ae33ee61a4$var$b64DecodeUnicode(str) {
    return decodeURIComponent($1UChD(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
module.exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $481fe0ae33ee61a4$var$b64DecodeUnicode(output);
    } catch (err) {
        return $1UChD(output);
    }
};

});
parcelRegister("1UChD", function(module, exports) {
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $1648b7b5b93c4620$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $1648b7b5b93c4620$var$InvalidCharacterError(message) {
    this.message = message;
}
$1648b7b5b93c4620$var$InvalidCharacterError.prototype = new Error();
$1648b7b5b93c4620$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $1648b7b5b93c4620$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $1648b7b5b93c4620$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $1648b7b5b93c4620$var$chars.indexOf(buffer);
    return output;
}
module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $1648b7b5b93c4620$var$polyfill;

});




parcelRegister("aHvCt", function(module, exports) {
$parcel$export(module.exports, "batchMediaViewResponseFactory", () => $f1d81eb8a0075a3d$export$eedff7e9aaf52da1);
$parcel$export(module.exports, "actions", () => $f1d81eb8a0075a3d$export$e324594224ef24da);

var $5eDz8 = parcelRequire("5eDz8");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $8jOO7 = parcelRequire("8jOO7");

var $93QIg = parcelRequire("93QIg");
const $f1d81eb8a0075a3d$export$eedff7e9aaf52da1 = (environment, cloudId)=>async (issueKeys)=>{
        const issueKeysMap = new Map();
        const uniqueIssueKeys = [
            ...new Set(issueKeys)
        ];
        const promise = (0, $j4oe4.fetchQuery)(environment, (0, $5eDz8.default), {
            issueKeys: uniqueIssueKeys,
            cloudId: cloudId,
            maxTokenLength: (0, $93QIg.MAX_TOKEN_LENGTH)
        }).toPromise();
        try {
            const result = await promise;
            const issues = result?.jira?.issuesByKey;
            issues?.forEach((issue)=>{
                if (issue?.mediaReadToken) {
                    const { clientId: clientId, endpointUrl: endpointUrl, tokenLifespanInSeconds: tokenLifespanInSeconds, tokensWithFiles: tokensWithFiles } = issue?.mediaReadToken;
                    const tokensWithFilesFlattened = tokensWithFiles?.edges?.map((edge)=>edge?.node?.token ? {
                            token: edge.node.token
                        } : null).filter(Boolean);
                    if (clientId && endpointUrl && tokenLifespanInSeconds && tokensWithFilesFlattened) {
                        const viewResponse = {
                            clientId: clientId,
                            endpointUrl: endpointUrl,
                            tokenLifespanInSeconds: tokenLifespanInSeconds,
                            tokensWithFiles: tokensWithFilesFlattened
                        };
                        issueKeysMap.set(issue.key, viewResponse);
                    }
                }
            });
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'lazyMediaViewResponseFactory',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        // Ensure input argument order is preserved when returning batch results as required by the dataloader
        return issueKeys.map((issueKey)=>issueKeysMap.get(issueKey) ?? null);
    };
const $f1d81eb8a0075a3d$export$e324594224ef24da = {
    load: (issueKey)=>({ getState: getState })=>{
            const { loader: loader, scheduler: scheduler } = getState();
            const loading = loader ? loader.load(issueKey) : Promise.resolve(null);
            scheduler?.dispatch();
            return loading;
        }
};

});
parcelRegister("5eDz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ede01961e427f39c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<038490e885f5ed59aebe309ed3d06370>>
 * @relayHash 88dc3fe18d2828d729fb2bf7929e7076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d
const $ede01961e427f39c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKeys"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxTokenLength"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "keys",
            "variableName": "issueKeys"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issuesByKey",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "878b3b6282e98d324c50ccd49dbaf8a07c889063b5efed0881fe239f64e5160d",
            "metadata": {},
            "name": "actions_LazyLoadMediaReadTokenQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ede01961e427f39c$var$node.hash = "a1b3499bc5d237db13d819b5abf7ce41";
var $ede01961e427f39c$export$2e2bcd8739ae039 = $ede01961e427f39c$var$node;

});

parcelRegister("93QIg", function(module, exports) {
$parcel$export(module.exports, "MAX_BATCH_SIZE", () => $161cf6e30dc5abb0$export$b79d95ee17a87a);
$parcel$export(module.exports, "MAX_TOKEN_LENGTH", () => $161cf6e30dc5abb0$export$525f5433a110000f);

var $cGVqS = parcelRequire("cGVqS");
const $161cf6e30dc5abb0$export$b79d95ee17a87a = 100;
const $161cf6e30dc5abb0$export$525f5433a110000f = (0, $cGVqS.getMaxTokenLength)();

});
parcelRegister("cGVqS", function(module, exports) {
$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});




parcelRegister("kfIml", function(module, exports) {
$parcel$export(module.exports, "DraggableRowsContainer", () => $5287baf143ef1bf7$export$d659f1efda86963d);
$parcel$export(module.exports, "Store", () => $5287baf143ef1bf7$export$390f32400eaf98c9);
$parcel$export(module.exports, "useDraggableRowsConnectionId", () => $5287baf143ef1bf7$export$ab74a8a2556419cd);

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4cTDP = parcelRequire("4cTDP");
const $5287baf143ef1bf7$export$d4c72bab9d6cc13a = {
    currentDropTarget: null,
    instanceId: 'pdnd-issue-table-rows',
    issueConnectionId: '',
    items: new Map(),
    // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
    /** @deprecated Use `useIssuesRanker` directly */ onRowReorder: undefined
};
const $5287baf143ef1bf7$var$actions = {
    setDropTarget: (dropTarget)=>({ setState: setState, getState: getState })=>{
            const currentDropTarget = getState().currentDropTarget;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(currentDropTarget, dropTarget)) setState({
                currentDropTarget: dropTarget
            });
        },
    /** @deprecated Use `useIssuesRanker` directly */ reorderRows: (sourceIndex, destinationIndex)=>({ getState: getState })=>{
            if ((0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) return;
            const { items: items, onRowReorder: onRowReorder } = getState();
            onRowReorder?.({
                source: {
                    issueIds: [
                        items.get(sourceIndex) ?? ''
                    ],
                    rowIndex: sourceIndex
                },
                destination: {
                    relativeToIssueId: items.get(destinationIndex) ?? '',
                    rowIndex: destinationIndex
                },
                edge: sourceIndex > destinationIndex ? 'top' : 'bottom'
            });
        },
    registerItem: (edgeIndex, issueId)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            setState({
                items: items.set(edgeIndex, issueId)
            });
        },
    unregisterItem: (edgeIndex)=>({ getState: getState, setState: setState })=>{
            const { items: items } = getState();
            if (items.delete(edgeIndex)) setState({
                items: items
            });
        }
};
const $5287baf143ef1bf7$export$d659f1efda86963d = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $5287baf143ef1bf7$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $5287baf143ef1bf7$export$d4c72bab9d6cc13a,
    actions: $5287baf143ef1bf7$var$actions,
    containedBy: $5287baf143ef1bf7$export$d659f1efda86963d,
    handlers: {
        onInit: ()=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if ((0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) setState({
                    instanceId: instanceId ?? $5287baf143ef1bf7$export$d4c72bab9d6cc13a.instanceId,
                    issueConnectionId: issueConnectionId
                });
                else setState({
                    instanceId: instanceId ?? $5287baf143ef1bf7$export$d4c72bab9d6cc13a.instanceId,
                    onRowReorder: onRowReorder,
                    issueConnectionId: issueConnectionId
                });
            },
        onContainerUpdate: (props, prevProps)=>({ setState: setState }, { instanceId: instanceId, onRowReorder: onRowReorder, issueConnectionId: issueConnectionId })=>{
                if (props.instanceId !== prevProps.instanceId || props.onRowReorder !== prevProps.onRowReorder || // TODO: Remove on jsc-2065-unify-onrowreorder cleanup
                props.issueConnectionId !== prevProps.issueConnectionId) setState({
                    instanceId: instanceId,
                    onRowReorder: onRowReorder,
                    issueConnectionId: issueConnectionId
                });
            }
    }
});
const $5287baf143ef1bf7$export$ab74a8a2556419cd = (0, $iJq0l.createHook)($5287baf143ef1bf7$export$390f32400eaf98c9, {
    selector: ({ issueConnectionId: issueConnectionId })=>issueConnectionId
});

});

parcelRegister("7XD6x", function(module, exports) {
$parcel$export(module.exports, "IFCFooter", () => $8b646a3a3d5430a0$export$7b0e717a6d1208a9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hx3Sa = parcelRequire("hx3Sa");

var $8nu6j = parcelRequire("8nu6j");

var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $5CSKW = parcelRequire("5CSKW");

var $dcLzM = parcelRequire("dcLzM");

var $2R0ne = parcelRequire("2R0ne");

var $lL4G9 = parcelRequire("lL4G9");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kAwwe = parcelRequire("kAwwe");

var $2aY2d = parcelRequire("2aY2d");

var $fpyg5 = parcelRequire("fpyg5");

var $cxKOj = parcelRequire("cxKOj");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6KVf0 = parcelRequire("6KVf0");


var $pZqvR = parcelRequire("pZqvR");

var $cEWre = parcelRequire("cEWre");

var $kompv = parcelRequire("kompv");

var $7lNJU = parcelRequire("7lNJU");
const $8b646a3a3d5430a0$var$useIsProjectAdmin = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};
const $8b646a3a3d5430a0$var$styles = {
    ifcFooter: "_1h6dmuej _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx2vrvc _15a5nqa1 _uwhke4h9 _1bah1h6o",
    footerContainer: "_1h6dmuej _15a5nqa1 _uwhke4h9 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1"
};
const $8b646a3a3d5430a0$export$7b0e717a6d1208a9 = ({ onPickerClose: onPickerClose, columnsDataId: columnsDataId, columnInsertIndex: columnInsertIndex, rightSideComponent: rightSideComponent })=>{
    const contactAdminGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $kompv.default).contactAdminGalaxia : (0, $kompv.default).contactAdmin;
    const { ifcConfig: ifcConfig, addFieldToColumns: addFieldToColumns } = (0, $pZqvR.useIFCConfigContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $kAwwe.useIsAdmin)();
    const isProjectAdmin = $8b646a3a3d5430a0$var$useIsProjectAdmin();
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isCMPAdmin = isAdmin && !isTMP;
    const isTMPAdmin = isAdmin && isTMP;
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const environment = (0, $hx3Sa.useRelayEnvironment)();
    const editField = (0, $cEWre.useIFCEditField)();
    const onStartFieldCreate = (0, $eJOHy.useCallback)(({ name: name, type: type })=>{
        const field = {
            fieldSetId: (0, $7lNJU.TEMP_CREATE_FIELDSET_ID),
            name: name,
            type: type
        };
        (0, $fpyg5.createOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                field
            ],
            createIndex: columnInsertIndex
        });
    }, [
        columnInsertIndex,
        columnsDataId,
        environment
    ]);
    const onFieldCreated = (0, $eJOHy.useCallback)((fieldId, fieldSetId)=>{
        if (fieldSetId) {
            (0, $7lNJU.updateTempOptimisticFieldSetId)({
                environment: environment,
                fieldConfigId: columnsDataId,
                fieldSetId: fieldSetId
            });
            addFieldToColumns?.(fieldSetId, columnInsertIndex, ()=>{
                (0, $fpyg5.deleteOptimisticFieldConfig)({
                    environment: environment,
                    fieldConfigId: columnsDataId,
                    fields: [
                        {
                            fieldSetId: fieldSetId,
                            name: ''
                        }
                    ]
                });
            });
            editField(fieldId, fieldSetId);
        }
    }, [
        environment,
        columnsDataId,
        addFieldToColumns,
        columnInsertIndex,
        editField
    ]);
    const onFieldCreateError = (0, $eJOHy.useCallback)(()=>{
        (0, $fpyg5.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: columnsDataId,
            fields: [
                {
                    fieldSetId: (0, $7lNJU.TEMP_CREATE_FIELDSET_ID),
                    name: ''
                }
            ]
        });
    }, [
        columnsDataId,
        environment
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const clickHandler = (0, $eJOHy.useCallback)((event)=>{
        onPickerClose?.(event);
        clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        ifcConfig?.onCreate({
            onFieldCreated: onFieldCreated,
            onStartFieldCreate: onStartFieldCreate,
            onFieldCreateError: onFieldCreateError
        });
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createFieldIFCFooterButton');
    }, [
        onPickerClose,
        clearIndex,
        ifcConfig,
        onFieldCreated,
        onStartFieldCreate,
        onFieldCreateError,
        createAnalyticsEvent
    ]);
    if (!isAdmin) {
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) {
            if (rightSideComponent == null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $8b646a3a3d5430a0$var$styles.footerContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
                justifyContent: "end"
            }, rightSideComponent));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
            label: "",
            color: "var(--ds-icon-accent-blue, #1D7AFC)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage(contactAdminGalaxia, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                    href: "/secure/ContactAdministrators!default.jspa",
                    target: "_blank",
                    onClick: ()=>{
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'link'
                        }), 'endUserIFCFooterLink');
                    }
                }, chunks)
        }))));
    }
    if (isTMPAdmin && ifcConfig && ((0, $4cTDP.fg)('jsc_list_category_editing_in_nin') ? ifcConfig.isEnabledForProject : ifcConfig.IFCTriggerRef)) {
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ref: triggerRef,
                onClick: clickHandler,
                spacing: "compact",
                appearance: "subtle",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM)))
            }, formatMessage((0, $kompv.default).createAnotherButton))), rightSideComponent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ref: triggerRef,
                onClick: clickHandler,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                space: "space.100",
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $kompv.default).createAnotherButton))))));
    }
    if (isCMPAdmin) {
        if ((0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.footerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            xcss: $8b646a3a3d5430a0$var$styles.anchor,
            href: (0, $cxKOj.expVal)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa',
            target: "_blank",
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'cmpAdminIFCFooterLink');
            }
        }, formatMessage((0, $kompv.default).createAFieldInConfig)), rightSideComponent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b646a3a3d5430a0$var$styles.ifcFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
            label: "",
            color: "var(--ds-icon-accent-blue, #1D7AFC)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $kompv.default).makeChangesInConfig, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                    href: (0, $cxKOj.expVal)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa',
                    target: "_blank",
                    onClick: ()=>{
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'link'
                        }), 'cmpAdminIFCFooterLink');
                    }
                }, chunks)
        }))));
    }
};

});
parcelRegister("hx3Sa", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("lBb6O"));

});
parcelRegister("lBb6O", function(module, exports) {
'use strict';

var $4E40D = parcelRequire("4E40D");

var $bdIJW = parcelRequire("bdIJW");

var $bQPKN = parcelRequire("bQPKN");
var $fb95aba886d4097a$var$loadQuery = $bQPKN.loadQuery;

var $83OIO = parcelRequire("83OIO");

var $1NoLa = parcelRequire("1NoLa");

var $iahTm = parcelRequire("iahTm");

var $kM8tH = parcelRequire("kM8tH");

var $cOk0k = parcelRequire("cOk0k");

var $dmpY4 = parcelRequire("dmpY4");

var $73jbJ = parcelRequire("73jbJ");

var $xo8pN = parcelRequire("xo8pN");

var $RjuBo = parcelRequire("RjuBo");

var $eyGnt = parcelRequire("eyGnt");

var $i764d = parcelRequire("i764d");

var $dEDMm = parcelRequire("dEDMm");

var $4Iwb3 = parcelRequire("4Iwb3");

var $37Ewn = parcelRequire("37Ewn");
module.exports = {
    ConnectionHandler: $37Ewn.ConnectionHandler,
    applyOptimisticMutation: $37Ewn.applyOptimisticMutation,
    commitLocalUpdate: $37Ewn.commitLocalUpdate,
    commitMutation: $37Ewn.commitMutation,
    graphql: $37Ewn.graphql,
    readInlineData: $37Ewn.readInlineData,
    requestSubscription: $37Ewn.requestSubscription,
    EntryPointContainer: $4E40D,
    RelayEnvironmentProvider: $1NoLa,
    ProfilerContext: $83OIO,
    fetchQuery: $37Ewn.fetchQuery,
    loadQuery: $fb95aba886d4097a$var$loadQuery,
    loadEntryPoint: $bdIJW,
    useFragment: $kM8tH,
    useLazyLoadQuery: $cOk0k,
    useEntryPointLoader: $iahTm,
    useQueryLoader: $RjuBo,
    useMutation: $dmpY4,
    usePaginationFragment: $73jbJ,
    usePreloadedQuery: $xo8pN,
    useRefetchableFragment: $eyGnt,
    useRelayEnvironment: $i764d,
    useSubscribeToInvalidationState: $dEDMm,
    useSubscription: $4Iwb3
};

});


const $7423e9894c2b8b23$export$76a449e52fa0e1e8 = 'issue';
const $7423e9894c2b8b23$export$d6f887e0c1be1b74 = 'field';

parcelRegister("pZqvR", function(module, exports) {
$parcel$export(module.exports, "useIFCConfigContext", () => $48ca4011692a630d$export$e3a7198c51d237d7);
$parcel$export(module.exports, "IFCConfigContextProviderComponent", () => $48ca4011692a630d$export$8df178a0d1abc310);

var $9RmXR = parcelRequire("9RmXR");

var $3hBQH = parcelRequire("3hBQH");

var $eJOHy = parcelRequire("eJOHy");

var $hx3Sa = parcelRequire("hx3Sa");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $fpyg5 = parcelRequire("fpyg5");

var $dLXgn = parcelRequire("dLXgn");

var $d8Dow = parcelRequire("d8Dow");

var $8jOO7 = parcelRequire("8jOO7");

var $7lNJU = parcelRequire("7lNJU");

var $1zGNP = parcelRequire("1zGNP");
const $48ca4011692a630d$export$be578a14685d978b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    ifcConfig: undefined
});
const $48ca4011692a630d$export$16276ffbd566ecbc = ({ children: children, ifcConfig: ifcConfig, columns: columns, onColumnsChange: onColumnsChange, queryRef: queryRef, columnsQueryRef: columnsQueryRef })=>{
    const columnRef = (0, $eJOHy.useRef)(columns);
    const currentIssuesRef = (0, $eJOHy.useRef)(null);
    const processedIssuesRef = (0, $eJOHy.useRef)({
        issuesRef: null,
        fieldId: null
    });
    const selectedOptions = (0, $eJOHy.useRef)(undefined);
    if (columnRef.current !== columns) columnRef.current = columns;
    const environment = (0, $hx3Sa.useRelayEnvironment)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const currentConnections = (0, $eJOHy.useRef)();
    const currentGroupsIssuesRef = (0, $eJOHy.useRef)([]);
    if (currentConnections.current !== connections) {
        currentGroupsIssuesRef.current = Object.values(connections).filter((connection)=>connection.type === 'GROUP_CHILDREN' || connection.type === 'PARENT_CHILDREN').map((connection)=>connection.type === 'GROUP_CHILDREN' || connection.type === 'PARENT_CHILDREN' ? connection.fieldSetsData : undefined);
        currentConnections.current = connections;
    }
    const issuesQueryRef = (0, $hx3Sa.useFragment)((0, $3hBQH.default), queryRef);
    const fieldConfig = (0, $hx3Sa.useFragment)((0, $9RmXR.default), columnsQueryRef);
    if (currentIssuesRef.current !== issuesQueryRef) currentIssuesRef.current = issuesQueryRef ?? null;
    const optimisticDeleteField = (0, $eJOHy.useCallback)((fieldSetId)=>{
        (0, $fpyg5.deleteOptimisticFieldConfig)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            fields: [
                {
                    fieldSetId: fieldSetId,
                    name: ''
                }
            ]
        });
    }, [
        environment,
        fieldConfig?.__id
    ]);
    const getColumnIds = (0, $eJOHy.useCallback)(()=>{
        const columnIds = columnRef.current?.map(({ id: id })=>id)?.filter((id)=>!id.startsWith((0, $8jOO7.COLUMN_ID_INTERNAL_COLUMN)) && id !== (0, $7lNJU.TEMP_CREATE_FIELDSET_ID));
        const mergedColumnsIds = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (columnRef.current.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
        return [
            ...mergedColumnsIds,
            ...columnIds
        ];
    }, []);
    const replaceFieldSetInColumns = (0, $eJOHy.useCallback)((fieldSetId, newfieldSetId, fieldId)=>{
        const columnIds = getColumnIds();
        let skipRefetch = true;
        // find out if a column of the same fieldsetid exists
        // if yes, the column will get merged when we refetch so we also don't skip refetch
        const duplicateFieldSetIndex = columnIds.findIndex((id)=>id === newfieldSetId);
        if (duplicateFieldSetIndex > -1) {
            optimisticDeleteField(newfieldSetId);
            skipRefetch = false;
            columnIds.splice(duplicateFieldSetIndex, 1);
        }
        (0, $7lNJU.optimisticUpdateColumnConfigFieldSetIdById)({
            environment: environment,
            fieldConfigId: fieldConfig?.__id,
            field: {
                fieldId: fieldId,
                fieldSetId: newfieldSetId
            }
        });
        (0, $1zGNP.optimisticUpdateIssuesFieldSetId)(environment, currentIssuesRef.current, fieldId, newfieldSetId);
        // for groups
        currentGroupsIssuesRef.current.forEach((groupIssuesRef)=>{
            if (groupIssuesRef != null) (0, $1zGNP.optimisticUpdateIssuesFieldSetId)(environment, groupIssuesRef, fieldId, newfieldSetId);
        });
        const insertIndex = columnIds.findIndex((id)=>id === fieldSetId);
        if (insertIndex > -1) {
            columnIds[insertIndex] = newfieldSetId;
            onColumnsChange?.({
                columnIds: columnIds,
                retries: 3,
                onErrorCallback: ()=>{
                    optimisticDeleteField(newfieldSetId);
                },
                isHorizontalAutoScrollNeeded: false,
                skipRefetch: skipRefetch,
                analyticsAttributes: {
                    fromIFCFieldUpdated: true,
                    changeType: (0, $d8Dow.ADD_COLUMNS)
                }
            });
        }
    }, [
        environment,
        fieldConfig?.__id,
        getColumnIds,
        onColumnsChange,
        optimisticDeleteField
    ]);
    const addFieldToColumns = (0, $eJOHy.useCallback)((fieldSetId, index, onErrorCallback)=>{
        const columnIds = getColumnIds();
        const insertIndex = index == null ? columnIds.length : index;
        columnIds.splice(insertIndex, 0, fieldSetId);
        onColumnsChange?.({
            columnIds: columnIds,
            retries: 3,
            onErrorCallback: onErrorCallback,
            isHorizontalAutoScrollNeeded: index === undefined,
            analyticsAttributes: {
                fromIFCFieldCreated: true,
                changeType: (0, $d8Dow.ADD_COLUMNS)
            }
        });
    }, [
        getColumnIds,
        onColumnsChange
    ]);
    const updateSelectedOptions = (0, $eJOHy.useCallback)((fieldId, type, options)=>{
        if (type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
        if (processedIssuesRef.current.issuesRef !== currentIssuesRef.current || processedIssuesRef.current.fieldId !== fieldId) {
            selectedOptions.current = (0, $1zGNP.getSelectedOptions)(currentIssuesRef.current, fieldId, type);
            processedIssuesRef.current.issuesRef = currentIssuesRef.current;
            processedIssuesRef.current.fieldId = fieldId;
        }
        // for groups
        currentGroupsIssuesRef.current.forEach((groupIssuesRef)=>{
            if (groupIssuesRef != null) selectedOptions.current = {
                ...selectedOptions.current,
                ...(0, $1zGNP.getSelectedOptions)(groupIssuesRef, fieldId, type)
            };
        });
        if (selectedOptions.current) return (0, $1zGNP.optimisticUpdatesSelectedOptions)(environment, type, selectedOptions.current, options);
    }, [
        environment
    ]);
    const optimisticUpdateField = (0, $eJOHy.useCallback)((fieldId, field)=>{
        if (fieldConfig?.__id) {
            const prevName = (0, $7lNJU.updateOptimisticFieldName)({
                environment: environment,
                fieldConfigId: fieldConfig?.__id,
                field: {
                    fieldId: fieldId,
                    name: field.name
                }
            });
            let prevOptions;
            if (field.options) prevOptions = updateSelectedOptions?.(fieldId, field.type, field.options);
            if (prevName) return {
                id: fieldId,
                field: {
                    name: prevName,
                    type: field.type,
                    options: prevOptions
                }
            };
        }
    }, [
        environment,
        fieldConfig?.__id,
        updateSelectedOptions
    ]);
    const value = (0, $eJOHy.useMemo)(()=>({
            ifcConfig: ifcConfig,
            addFieldToColumns: addFieldToColumns,
            updateSelectedOptions: updateSelectedOptions,
            replaceFieldSetInColumns: replaceFieldSetInColumns,
            optimisticUpdateField: optimisticUpdateField,
            optimisticDeleteField: optimisticDeleteField
        }), [
        ifcConfig,
        addFieldToColumns,
        updateSelectedOptions,
        replaceFieldSetInColumns,
        optimisticUpdateField,
        optimisticDeleteField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48ca4011692a630d$export$be578a14685d978b.Provider, {
        value: value
    }, children);
};
const $48ca4011692a630d$export$e3a7198c51d237d7 = ()=>{
    return (0, $eJOHy.useContext)($48ca4011692a630d$export$be578a14685d978b);
};
const $48ca4011692a630d$export$8df178a0d1abc310 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), $48ca4011692a630d$export$16276ffbd566ecbc, ({ children: children })=>children);

});
parcelRegister("9RmXR", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f7e946677098a43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab771d6d7f14313f1bf27206756b3ede>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f7e946677098a43$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$5f7e946677098a43$var$node.hash = "da9cc8f15ae8ed9e7e4b651383cc3495";
var $5f7e946677098a43$export$2e2bcd8739ae039 = $5f7e946677098a43$var$node;

});

parcelRegister("3hBQH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2933c390546b2df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18f187046e493bc63d953540bf4d6b3d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e2933c390546b2df$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef",
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "getSelectedOptions",
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 500
                                    }
                                ],
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSets",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "__typename"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "fieldId"
                                                                            },
                                                                            v0 /*: any*/ ,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOptionConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "selectedOptions",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraOption",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "id"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "value"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v1 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraCheckboxesField"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraOption",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "fieldOption",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "optionId"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraSingleSelectField"
                                                                            },
                                                                            v1 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldSets(first:500)"
                            }
                        ]
                    }
                ],
                "argumentDefinitions": []
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$e2933c390546b2df$var$node.hash = "0831223130cceb4db1fa0dc5958c658a";
var $e2933c390546b2df$export$2e2bcd8739ae039 = $e2933c390546b2df$var$node;

});

parcelRegister("7lNJU", function(module, exports) {
$parcel$export(module.exports, "TEMP_CREATE_FIELDSET_ID", () => $108bec5f55b27c19$export$6ec0f6605f2c959e);
$parcel$export(module.exports, "updateTempOptimisticFieldSetId", () => $108bec5f55b27c19$export$983fb13ccb9ab7e0);
$parcel$export(module.exports, "updateOptimisticFieldName", () => $108bec5f55b27c19$export$1ba75d43b01f9290);
$parcel$export(module.exports, "optimisticUpdateColumnConfigFieldSetIdById", () => $108bec5f55b27c19$export$28a743eeaeb242db);

var $hx3Sa = parcelRequire("hx3Sa");
const $108bec5f55b27c19$export$6ec0f6605f2c959e = 'temp_new_fieldset_id';
const $108bec5f55b27c19$export$983fb13ccb9ab7e0 = ({ environment: environment, fieldConfigId: fieldConfigId, fieldSetId: fieldSetId })=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>edge.getLinkedRecord('node')?.getValue('fieldSetId') === $108bec5f55b27c19$export$6ec0f6605f2c959e);
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};
const $108bec5f55b27c19$export$1ba75d43b01f9290 = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, name: name } })=>{
    let previousName;
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) {
                previousName = currentField.getLinkedRecord('node')?.getValue('displayName');
                currentField.getLinkedRecord('node')?.setValue(name, 'displayName');
            }
        }
    });
    return previousName;
};
const $108bec5f55b27c19$export$28a743eeaeb242db = ({ environment: environment, fieldConfigId: fieldConfigId, field: { fieldId: fieldId, fieldSetId: fieldSetId } })=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        if (fieldConfigId) {
            const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
            const currentField = fields?.find((edge)=>{
                const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
                const fsFields = metadata?.getLinkedRecords('edges');
                const fsField = fsFields?.find((fedge)=>fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId);
                return !!fsField;
            });
            if (currentField) currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
        }
    });
};

});

parcelRegister("1zGNP", function(module, exports) {
$parcel$export(module.exports, "getSelectedOptions", () => $349a280504733ccd$export$dd5cf00ceb58ef45);
$parcel$export(module.exports, "optimisticUpdatesSelectedOptions", () => $349a280504733ccd$export$b96cfa9b16d1cfb3);
$parcel$export(module.exports, "optimisticUpdateIssuesFieldSetId", () => $349a280504733ccd$export$6b82cef47b481f3a);

var $9eptN = parcelRequire("9eptN");

var $j4oe4 = parcelRequire("j4oe4");

var $hx3Sa = parcelRequire("hx3Sa");

var $wufAv = parcelRequire("wufAv");

var $j8Km1 = parcelRequire("j8Km1");
const $349a280504733ccd$var$readIssuesData = (queryRef)=>{
    return (0, $j4oe4.readInlineData)((0, $9eptN.default), queryRef);
};
const $349a280504733ccd$export$dd5cf00ceb58ef45 = (queryRef, fieldId, type)=>{
    if (!queryRef) return;
    const selectedOptions = $349a280504733ccd$var$readIssuesData(queryRef);
    const selectedOptionMap = {};
    switch(type){
        case (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                    field?.node?.selectedOptions?.edges?.forEach((option)=>{
                        if (option?.__id != null && option?.node?.id != null) {
                            const optionId = option?.__id ?? '';
                            selectedOptionMap[optionId] = option?.node?.id;
                        }
                    });
                });
            });
            break;
        case (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
            selectedOptions?.edges?.forEach((issue)=>{
                const fieldsets = issue?.fieldSets?.edges?.filter((fieldSet)=>fieldSet?.node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT);
                fieldsets?.forEach((fieldSet)=>{
                    const field = fieldSet?.node?.fields?.edges?.find((f)=>{
                        return f?.node?.fieldId === fieldId;
                    });
                    if (field?.node?.__id != null && field?.node?.fieldOption?.optionId) selectedOptionMap[field?.node?.__id ?? ''] = field?.node?.fieldOption?.optionId;
                });
            });
            break;
        default:
            break;
    }
    return selectedOptionMap;
};
const $349a280504733ccd$export$b96cfa9b16d1cfb3 = (environment, type, selectedOptionMap, options)=>{
    if (type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT && type !== (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT) return;
    const previousOptions = {};
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        const ids = Object.keys(selectedOptionMap);
        if (ids.length > 0) {
            const optionMap = {};
            options.forEach((opt)=>{
                optionMap[opt.id] = opt.value;
            });
            switch(type){
                case (0, $j8Km1.KNOWN_COLUMN_TYPES).CHECKBOX_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('node');
                        const optionId = (0, $wufAv.JiraIssueFieldOptionAri).parse(selectedOptionMap[id]).optionId;
                        // set return value
                        if (!previousOptions[optionId]) previousOptions[optionId] = option?.getValue('value')?.toString() ?? '';
                        if (optionMap[optionId]) option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                case (0, $j8Km1.KNOWN_COLUMN_TYPES).SINGLE_SELECT:
                    ids.forEach((id)=>{
                        const option = store.get(id)?.getLinkedRecord('fieldOption');
                        const optionId = selectedOptionMap[id];
                        // set return value
                        if (!previousOptions[optionId]) previousOptions[optionId] = option?.getValue('value')?.toString() ?? '';
                        if (optionMap[optionId]) option?.setValue(optionMap[optionId], 'value');
                    });
                    break;
                default:
                    break;
            }
        }
    });
    return Object.keys(previousOptions).map((id)=>({
            id: id,
            value: previousOptions[id]
        }));
};
const $349a280504733ccd$export$6b82cef47b481f3a = (environment, queryRef, fieldId, fieldSetId)=>{
    (0, $hx3Sa.commitLocalUpdate)(environment, (store)=>{
        const issues = $349a280504733ccd$var$readIssuesData(queryRef);
        issues?.edges?.forEach((issue)=>{
            const fieldsets = issue?.fieldSets?.edges;
            fieldsets?.forEach((fieldSet)=>{
                const field = fieldSet?.node?.fields?.edges?.find((f)=>f?.node?.fieldId === fieldId);
                if (field) {
                    const id = fieldSet?.node?.__id ?? '';
                    const fieldSetToUpdate = store.get(id);
                    fieldSetToUpdate?.setValue(fieldSetId, 'fieldSetId');
                }
            });
        });
    });
};

});
parcelRegister("9eptN", function(module, exports) {
$parcel$export(module.exports, "default", () => $841b73a06a2b0e7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00991a1eed811e83f9015c0764b0824d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $841b73a06a2b0e7d$var$node = {
    "kind": "InlineDataFragment",
    "name": "getSelectedOptions"
};
$841b73a06a2b0e7d$var$node.hash = "d834d874b11bf040e4a6fed6a2824cab";
var $841b73a06a2b0e7d$export$2e2bcd8739ae039 = $841b73a06a2b0e7d$var$node;

});

parcelRegister("wufAv", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $061a7460522c266a$export$e3bc1ec22f941fbe);

var $4gJvn = parcelRequire("4gJvn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue-field-option/manifest.ts
var $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4gJvn.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $4gJvn.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $061a7460522c266a$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("4gJvn", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $31bbf461f55c01f8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $31bbf461f55c01f8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $31bbf461f55c01f8$export$eb4f4cf0880fe5a8 = "jira", $31bbf461f55c01f8$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("cEWre", function(module, exports) {
$parcel$export(module.exports, "useIFCEditField", () => $0bd928140d605343$export$9e12f6c6c7e366bd);

var $eJOHy = parcelRequire("eJOHy");

var $fwzaq = parcelRequire("fwzaq");

var $pZqvR = parcelRequire("pZqvR");
const $0bd928140d605343$export$9e12f6c6c7e366bd = ()=>{
    const { ifcConfig: ifcConfig, optimisticUpdateField: optimisticUpdateField, replaceFieldSetInColumns: replaceFieldSetInColumns, optimisticDeleteField: optimisticDeleteField } = (0, $pZqvR.useIFCConfigContext)();
    const currentFieldSetId = (0, $eJOHy.useRef)();
    const currentField = (0, $eJOHy.useRef)(null);
    const isUpdateInProgress = (0, $eJOHy.useRef)();
    const onStartFieldUpdate = (0, $eJOHy.useCallback)((id, field)=>{
        isUpdateInProgress.current = true;
        const previousValue = optimisticUpdateField?.(id, field);
        // init the old value here
        if (currentField.current == null && previousValue) currentField.current = previousValue;
    }, [
        optimisticUpdateField
    ]);
    const [onDebouncedFieldUpdated] = (0, $fwzaq.default)((fieldId, field)=>{
        if (field?.collapsedName && currentFieldSetId.current && !isUpdateInProgress.current) {
            // skip saving fieldset config when there is no change in name
            if (field?.collapsedName !== currentFieldSetId.current) replaceFieldSetInColumns?.(currentFieldSetId.current, field.collapsedName, fieldId);
            currentFieldSetId.current = field?.collapsedName;
            // reset old value to null so it gets initialised on start update again
            currentField.current = null;
        }
    }, 1000);
    const onFieldUpdated = (0, $eJOHy.useCallback)((fieldId, field)=>{
        isUpdateInProgress.current = false;
        onDebouncedFieldUpdated(fieldId, field);
    }, [
        onDebouncedFieldUpdated
    ]);
    const onFieldUpdateError = (0, $eJOHy.useCallback)(()=>{
        if (currentField.current) {
            const { id: id, field: field } = currentField.current;
            optimisticUpdateField?.(id, field);
        }
    }, [
        optimisticUpdateField
    ]);
    const onFieldDeleted = (0, $eJOHy.useCallback)(()=>{
        if (currentFieldSetId.current) optimisticDeleteField?.(currentFieldSetId.current);
    }, [
        optimisticDeleteField
    ]);
    const onUpdate = (fieldId, fieldSetId)=>{
        currentFieldSetId.current = fieldSetId;
        ifcConfig?.onUpdate({
            fieldId: fieldId,
            onStartFieldUpdate: (field)=>onStartFieldUpdate(fieldId, field),
            onFieldUpdated: onFieldUpdated,
            onFieldDeleted: onFieldDeleted,
            onFieldUpdateError: onFieldUpdateError
        });
    };
    return onUpdate;
};

});

parcelRegister("kompv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d0bca35a7562312$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3d0bca35a7562312$var$messages = (0, $7qGN1.defineMessages)({
    createAnotherButton: {
        "id": "native-issue-table.inline-field-config-footer.create-another-button",
        "defaultMessage": "Create another"
    },
    contactAdmin: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text",
        "defaultMessage": "<link>Contact your project admin</link> to make changes"
    },
    makeChangesInConfig: {
        "id": "native-issue-table.inline-field-config-footer.make-config-changes-text",
        "defaultMessage": "Make changes in <link>configurations</link>"
    },
    contactAdminGalaxia: {
        "id": "native-issue-table.inline-field-config-footer.contact-admin-text-galaxia",
        "defaultMessage": "<link>Contact your space admin</link> to make changes"
    },
    totalCount: {
        "id": "native-issue-table.inline-field-config-footer.of-total-count",
        "defaultMessage": "{itemCount} of {totalCount}"
    },
    createAFieldInConfig: {
        "id": "native-issue-table.inline-field-config-footer.create-a-field-in-config",
        "defaultMessage": "Create a field"
    }
});
var $3d0bca35a7562312$export$2e2bcd8739ae039 = $3d0bca35a7562312$var$messages;

});


parcelRegister("9r0oq", function(module, exports) {
$parcel$export(module.exports, "TimelineCustomComponentsProvider", () => $59c3d16a0863ee6a$export$b40cbaf5e0e69a15);
$parcel$export(module.exports, "useTimelineCustomComponents", () => $59c3d16a0863ee6a$export$911a6abc1d3f8f05);

var $eJOHy = parcelRequire("eJOHy");

var $34oCh = parcelRequire("34oCh");
const $59c3d16a0863ee6a$var$TimelineCustomComponentsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $59c3d16a0863ee6a$export$b40cbaf5e0e69a15 = ({ children: children, components: components })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59c3d16a0863ee6a$var$TimelineCustomComponentsContext.Provider, {
        value: components ?? null
    }, children);
const $59c3d16a0863ee6a$export$911a6abc1d3f8f05 = ()=>{
    const context = (0, $eJOHy.useContext)($59c3d16a0863ee6a$var$TimelineCustomComponentsContext);
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    if (!isTimelineEnabled) return null;
    if (!context) throw new Error('useTimelineCustomComponents must be used within a TimelineCustomComponentsProvider');
    return context;
};

});

parcelRegister("8SzGK", function(module, exports) {
$parcel$export(module.exports, "useEventHandlers", () => $ca9d69e6c052c62b$export$8ce912bc34d0dbea);
$parcel$export(module.exports, "MaybeEventHandlersProvider", () => $ca9d69e6c052c62b$export$fef07f5f874e2160);

var $eJOHy = parcelRequire("eJOHy");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");
const $ca9d69e6c052c62b$var$EventHandlersContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ca9d69e6c052c62b$var$EventHandlersProvider = ({ children: children, eventHandlers: eventHandlers })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ca9d69e6c052c62b$var$EventHandlersContext.Provider, {
        value: eventHandlers
    }, children);
};
const $ca9d69e6c052c62b$export$8ce912bc34d0dbea = ()=>{
    const context = (0, $eJOHy.useContext)($ca9d69e6c052c62b$var$EventHandlersContext);
    if (context === null) return {};
    return context;
};
const $ca9d69e6c052c62b$export$fef07f5f874e2160 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('timeline_rollups_issue_table_callbacks'), $ca9d69e6c052c62b$var$EventHandlersProvider, ({ children: children })=>children);

});

parcelRegister("91XFx", function(module, exports) {
$parcel$export(module.exports, "getMergedColumnConfig", () => $cad9621c000691ac$export$9fce51f35317a690);
$parcel$export(module.exports, "getMergedColumnConfigWithDynamicOrder", () => $cad9621c000691ac$export$582ade26f0b65534);

var $eJOHy = parcelRequire("eJOHy");

var $j8Km1 = parcelRequire("j8Km1");

var $dmolI = parcelRequire("dmolI");

var $9vDhp = parcelRequire("9vDhp");
const $cad9621c000691ac$var$getColumnTitle = (mergedColumns, baseField, formatMessage)=>{
    if (mergedColumns.length === 0) return '';
    if (mergedColumns.length === 1 && baseField) return baseField.title;
    return formatMessage((0, $9vDhp.default).columnHeaderMergedColumn);
};
const $cad9621c000691ac$export$9fce51f35317a690 = (columns, isIssueHierarchyEnabled, formatMessage)=>{
    const filteredColumns = [];
    let mergedColumns = [];
    let issueKeyColumn = null;
    let issueTypeColumn = null;
    let summaryColumn = null;
    let isCheckboxColumnEnabled = false;
    // Filter out the issue key, issue type, and summary columns
    columns.forEach((column)=>{
        if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyColumn = column;
        else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) issueTypeColumn = column;
        else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) summaryColumn = column;
        else filteredColumns.push(column);
        if (column.id === (0, $j8Km1.COLUMN_ID_CHECKBOX)) isCheckboxColumnEnabled = true;
    });
    // Always preserve this order: issue type, key, summary
    mergedColumns = [
        issueTypeColumn,
        issueKeyColumn,
        summaryColumn
    ].filter(Boolean);
    // If there is no issue key, issue type, or summary column, we show only expand & child issue create icons
    const baseField = summaryColumn ?? issueKeyColumn ?? issueTypeColumn ?? null;
    // return original columns if hierarchy is OFF and merged fields are OFF
    if (!mergedColumns.length && !isIssueHierarchyEnabled) return columns;
    const columnConfig = baseField ?? (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const resizeColumnId = baseField ? baseField.id : undefined;
    const mergedColumn = {
        jqlTerm: '',
        aliases: [],
        fieldTypeDisplayName: '',
        ...columnConfig,
        id: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
        type: (0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN,
        title: $cad9621c000691ac$var$getColumnTitle(mergedColumns, baseField, formatMessage),
        // only show quick sort icon if there is a single merged field enabled
        isSortable: mergedColumns.length < 2,
        mergedColumns: mergedColumns,
        resizeColumnId: resizeColumnId,
        customHeader: baseField ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    };
    // insert the merged column after the checkbox column if it exists
    const mergedColumnIndex = isCheckboxColumnEnabled ? 1 : 0;
    return [
        ...filteredColumns.slice(0, mergedColumnIndex),
        mergedColumn,
        ...filteredColumns.slice(mergedColumnIndex)
    ];
};
const $cad9621c000691ac$export$582ade26f0b65534 = (columns, isIssueHierarchyEnabled, formatMessage, enableDynamicOrderForMergedColumn)=>{
    const filteredColumns = [];
    let mergedColumns = [];
    let issueKeyColumn = null;
    let issueKeyColumnIndex = null;
    let issueTypeColumn = null;
    let issueTypeColumnIndex = null;
    let summaryColumn = null;
    let summaryColumnIndex = null;
    let isCheckboxColumnEnabled = false;
    // Filter out the issue key, issue type, and summary columns
    columns.forEach((column, index)=>{
        if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
            issueKeyColumn = column;
            issueKeyColumnIndex = index;
        } else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_TYPE) {
            issueTypeColumn = column;
            issueTypeColumnIndex = index;
        } else if (column.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
            summaryColumn = column;
            summaryColumnIndex = index;
        } else filteredColumns.push(column);
        if (column.id === (0, $j8Km1.COLUMN_ID_CHECKBOX)) isCheckboxColumnEnabled = true;
    });
    // Always preserve this order: issue type, key, summary
    mergedColumns = [
        issueTypeColumn,
        issueKeyColumn,
        summaryColumn
    ].filter(Boolean);
    // If there is no issue key, issue type, or summary column, we show only expand & child issue create icons
    const baseField = summaryColumn ?? issueKeyColumn ?? issueTypeColumn ?? null;
    // return original columns if hierarchy is OFF and merged fields are OFF
    if (!mergedColumns.length && !isIssueHierarchyEnabled) return columns;
    const columnConfig = baseField ?? (0, $dmolI.getColumnConfig)(formatMessage)[(0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN]();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const resizeColumnId = baseField ? baseField.id : undefined;
    const mergedColumn = {
        jqlTerm: '',
        aliases: [],
        fieldTypeDisplayName: '',
        ...columnConfig,
        id: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
        type: (0, $j8Km1.KNOWN_COLUMN_TYPES).MERGED_COLUMN,
        title: $cad9621c000691ac$var$getColumnTitle(mergedColumns, baseField, formatMessage),
        // only show quick sort icon if there is a single merged field enabled
        isSortable: mergedColumns.length < 2,
        mergedColumns: mergedColumns,
        resizeColumnId: resizeColumnId,
        customHeader: baseField ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    };
    // choose the lowest order among issue type, issue key, and summary column
    let mergedColumnIndex = enableDynamicOrderForMergedColumn ? Math.min(issueTypeColumnIndex ?? Infinity, issueKeyColumnIndex ?? Infinity, summaryColumnIndex ?? Infinity) : 0;
    // insert the merged column after the checkbox column if it exists
    mergedColumnIndex = isCheckboxColumnEnabled ? mergedColumnIndex + 1 : mergedColumnIndex;
    return [
        ...filteredColumns.slice(0, mergedColumnIndex),
        mergedColumn,
        ...filteredColumns.slice(mergedColumnIndex)
    ];
};

});
parcelRegister("9vDhp", function(module, exports) {
$parcel$export(module.exports, "default", () => $991d287fa52317bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $991d287fa52317bd$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderMergedColumn: {
        "id": "native-issue-table.common.utils.get-merged-column-config.column-header-merged-column",
        "defaultMessage": "Work"
    }
});
var $991d287fa52317bd$export$2e2bcd8739ae039 = $991d287fa52317bd$var$messages;

});


parcelRegister("sJrIm", function(module, exports) {
$parcel$export(module.exports, "SortChangeContextProvider", () => $9d128466cbfef453$export$61767aa5bd260064);
$parcel$export(module.exports, "useSortContext", () => $9d128466cbfef453$export$a3b9cb2711d4166);

var $eJOHy = parcelRequire("eJOHy");
const $9d128466cbfef453$var$SortChangeContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $9d128466cbfef453$export$61767aa5bd260064 = $9d128466cbfef453$var$SortChangeContext.Provider;
const $9d128466cbfef453$export$a3b9cb2711d4166 = ()=>{
    const context = (0, $eJOHy.useContext)($9d128466cbfef453$var$SortChangeContext);
    return context !== undefined ? context : {};
};

});

parcelRegister("7t30r", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $3e29ded337e90265$export$4da28cf324280418);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $5V25X = parcelRequire("5V25X");

var $ezJEv = parcelRequire("ezJEv");

var $8jOO7 = parcelRequire("8jOO7");
const $3e29ded337e90265$export$4da28cf324280418 = (ref, isStickyColumnsEnabled)=>{
    const lastFocusedElement = (0, $eJOHy.useRef)();
    const onboardingTriggered = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Post-office trigger handlers for grid navigation onboarding
    const { isActive: isMoreShortcutsClicked } = (0, $5V25X.useTrigger)((0, $8jOO7.GRID_NAVIGATION_ONBOARDING_TRIGGERS).MORE_SHORTCUTS_CLICKED);
    const { isActive: isOkClicked } = (0, $5V25X.useTrigger)((0, $8jOO7.GRID_NAVIGATION_ONBOARDING_TRIGGERS).OK_CLICKED);
    const openHelpPanelLink = (0, $ezJEv.useHelpPanelLink)();
    (0, $eJOHy.useEffect)(()=>{
        const table = ref.current;
        if (!table) return;
        const getCell = (ele)=>ele?.closest('td') ?? ele?.closest('th');
        const isCell = (ele)=>getCell(ele) === ele;
        const getFocusableElements = ()=>Array.from(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage
            document.querySelectorAll([
                'a[href]:not([tabindex="-1"]):not([href=""]):not([href="javascript:;"])',
                'button:not([tabindex="-1"])',
                'input:not([tabindex="-1"], [type="hidden"])',
                'select:not([tabindex="-1"])',
                'textarea:not([tabindex="-1"])',
                "[tabindex]:not([tabindex='-1'])"
            ].join(',')));
        const getCellDepth = (ele, count = 0)=>{
            if (ele instanceof HTMLTableCellElement || !ele?.parentElement) return count;
            return getCellDepth(ele?.parentElement, count + 1);
        };
        // Ensure the target cell is fully visible horizontally, taking frozen columns into account
        const ensureCellFullyVisible = (cell)=>{
            const scroller = getScrollableContainer();
            if (!scroller) {
                // Fallback: if there is no scrollable container, scroll the cell into view centered horizontally
                cell.scrollIntoView({
                    behavior: 'auto',
                    block: 'nearest',
                    inline: 'center'
                });
                return;
            }
            const scrollerRect = scroller.getBoundingClientRect();
            const cellRect = cell.getBoundingClientRect();
            // Estimate the right edge of the frozen columns (look at the first row or table header with sticky position)
            const measureFrozenRight = ()=>{
                // Prefer the thead row; if not present, use the first row in tbody or the first tr
                const headerRow = table.querySelector('thead tr') ?? table.querySelector('tbody tr') ?? table.querySelector('tr');
                if (!headerRow) return scrollerRect.left;
                let maxRight = scrollerRect.left;
                for (const el of Array.from(headerRow.children)){
                    if (!(el instanceof HTMLElement)) return null;
                    // Check if the element is sticky and visible
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const cs = window.getComputedStyle(el);
                    const isSticky = cs.position === 'sticky' && cs.left !== 'auto';
                    if (isSticky && el.getAttribute('aria-hidden') !== 'true') {
                        const r = el.getBoundingClientRect();
                        if (r.right > maxRight) maxRight = r.right;
                    }
                }
                return maxRight;
            };
            const frozenRight = measureFrozenRight();
            // Compute the left boundary of the visible area: the larger of the scroller left or the frozen columns right edge
            const visibleLeft = Math.max(scrollerRect.left, frozenRight ?? 0);
            const visibleRight = scrollerRect.right;
            // Add a small margin for better visual spacing
            const margin = 8;
            // If the cell is partially hidden on the left, scroll left
            if (cellRect.left < visibleLeft + margin) scroller.scrollLeft -= visibleLeft + margin - cellRect.left;
            else if (cellRect.right > visibleRight - margin) scroller.scrollLeft += cellRect.right - (visibleRight - margin);
        };
        const getScrollableContainer = (node = table)=>{
            // Goes up the DOM tree until we encounter a scrollable element.
            if (!(node instanceof HTMLElement)) return null;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const styles = window.getComputedStyle(node);
            if (styles?.overflowY === 'scroll' || styles?.overflowY === 'auto') return node;
            return getScrollableContainer(node.parentElement);
        };
        const onKeyDown = (event)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @atlaskit/platform/no-direct-document-usage
            const activeElement = document.activeElement;
            const currentTr = activeElement?.closest('tr');
            if (event.key === 'Escape') {
                event.preventDefault();
                const cell = getCell(activeElement);
                const cellButton = cell?.querySelector('button[aria-hidden="false"]');
                if (cellButton instanceof HTMLElement && getCellDepth(cellButton) < 4) return cellButton.focus();
                return cell?.focus();
            }
            if (event.key === 'Tab' && event.shiftKey && activeElement instanceof Element) {
                /*
					If focus would move from our cell to another cell when pressing shift+tab;
					Prevent default and focus last element before the table.
				*/ const isCurrentCellFocused = isCell(activeElement);
                const index = activeElement.getAttribute('tabindex');
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) - 1]);
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', index ?? '-1');
                if (!isCurrentCellFocused) {
                    // go back to grid navigation
                    event.preventDefault();
                    return currentFocusableElementsCell?.focus();
                }
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                lastFocusedElement.current = getCell(activeElement);
                // Find the last element before the table in the document
                const lastElementBeforeTable = focusable.slice(0, focusable.findIndex((ele)=>table.contains(ele))).at(-1);
                event.preventDefault();
                if (lastElementBeforeTable instanceof HTMLElement) lastElementBeforeTable.focus();
                return;
            }
            if (event.key === 'Tab' && activeElement) {
                /*
					If focus would move from our cell to another cell when pressing tab;
					Prevent default and focus first interactable thing outside the table. (probably create button but not always)
					If we're inside a dialog; don't programmatically control focus.
				*/ if (activeElement.closest('[role="dialog"]')) return;
                const isCurrentCellFocused = isCell(activeElement);
                const index = activeElement.getAttribute('tabindex');
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', '0');
                const focusable = getFocusableElements();
                const currentFocusableElementsCell = getCell(activeElement);
                const nextFocusableElementsCell = getCell(focusable[focusable.indexOf(activeElement) + 1]);
                if (isCurrentCellFocused) activeElement.setAttribute('tabindex', index ?? '-1');
                if (currentFocusableElementsCell === nextFocusableElementsCell || !nextFocusableElementsCell) return;
                const nextFocusableElementOutsideTable = focusable.slice(focusable.indexOf(activeElement)).find((ele)=>!table.contains(ele));
                if (!nextFocusableElementOutsideTable) {
                    const lastInsideTable = focusable.slice(focusable.indexOf(activeElement)).at(-1);
                    if (!(lastInsideTable instanceof HTMLElement)) return;
                    lastInsideTable.focus({
                        preventScroll: true
                    });
                    return;
                }
                event.preventDefault();
                nextFocusableElementOutsideTable?.focus();
                return;
            }
            if (!activeElement || !(activeElement instanceof HTMLElement)) return;
            if (!currentTr || !(currentTr instanceof HTMLTableRowElement)) return;
            const currentTd = getCell(activeElement);
            if (!currentTd) return;
            const currentTds = Array.from(currentTr.children).filter((n)=>{
                return n.getAttribute('aria-hidden') !== 'true';
            });
            const currentTdIndex = currentTds.indexOf(currentTd);
            const rows = Array.from(table.querySelectorAll('tr:not([aria-hidden="true"])'));
            const currentTrIndex = rows.indexOf(currentTr);
            const isKeyboardNavigableElement = activeElement instanceof HTMLTableCellElement || activeElement instanceof HTMLButtonElement && activeElement.getAttribute('aria-hidden') === 'false';
            if (!isKeyboardNavigableElement) return;
            const next = (()=>{
                switch(event.code){
                    case 'ArrowUp':
                    case 'KeyJ':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateUp', {
                                keyPressed: event.key
                            });
                            // Firing track metric to measure nin_grid_navigation_experiment, clean up when cleaning up experiment
                            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'KeyboardShortcut', {
                                action: 'pressed',
                                key: 'arrowup'
                            });
                            if (currentTrIndex === 0) return;
                            /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex - 1]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            return children[currentTdIndex] ?? rows[currentTrIndex - 1].children[0];
                        }
                    case 'ArrowDown':
                    case 'KeyK':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateDown', {
                                keyPressed: event.key
                            });
                            // Firing track metric to measure nin_grid_navigation_experiment, clean up when cleaning up experiment
                            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'keyboardShortcut pressed', 'KeyboardShortcut', {
                                action: 'pressed',
                                key: 'arrowdown'
                            });
                            if (currentTrIndex === rows.length - 1) return;
                            /* same index, in next row or first index in next row [grouped] */ const children = Array.from(rows[currentTrIndex + 1]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            return children[currentTdIndex] ?? rows[currentTrIndex + 1].children[0];
                        }
                    case 'ArrowLeft':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateLeft', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTdIndex - 1];
                    case 'ArrowRight':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateRight', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTdIndex + 1];
                    case 'End':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateEnd', {
                            keyPressed: event.key
                        });
                        return currentTds[currentTds.length - 1];
                    case 'Home':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateHome', {
                            keyPressed: event.key
                        });
                        return currentTds[0];
                    case 'Enter':
                    case 'Space':
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigateEdit', {
                            keyPressed: event.key
                        });
                        if (activeElement instanceof HTMLTableCellElement) {
                            if (event.code === 'Space') event.preventDefault();
                            if (currentTd.children.length !== 1) return currentTd.click();
                            const interactiveElements = Array.from(currentTd.querySelectorAll('button:not([aria-hidden="true"]), a:not([aria-hidden="true"]), input:not([aria-hidden="true"]), select:not([aria-hidden="true"]), textarea:not([aria-hidden="true"]), [role="button"]:not([aria-hidden="true"])'));
                            if (interactiveElements.length === 1) {
                                const element = interactiveElements[0];
                                if (element instanceof HTMLElement) {
                                    element.click();
                                    return;
                                }
                            }
                        }
                        return currentTd.click();
                    case 'PageDown':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigatePageDown', {
                                keyPressed: event.key
                            });
                            /* Get last visible index in scrollable area, then focus the cell at the same index */ const scrollable = getScrollableContainer();
                            const rowsReversed = [
                                ...rows
                            ].reverse();
                            if (!scrollable) return null;
                            const scrollableRect = scrollable.getBoundingClientRect();
                            const lastVisibleIndex = rowsReversed.findIndex((row)=>{
                                const rowRect = row.getBoundingClientRect();
                                const isVisible = rowRect.bottom > scrollableRect.top && rowRect.top < scrollableRect.bottom;
                                return isVisible;
                            }) - 1;
                            const children = Array.from(rowsReversed[Math.max(0, lastVisibleIndex)]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            if (children.length === 0) return;
                            return children[currentTdIndex] ?? rowsReversed[Math.max(0, lastVisibleIndex)].children[0];
                        }
                    case 'PageUp':
                        {
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTable navigated', 'navigatePageUp', {
                                keyPressed: event.key
                            });
                            /* Get first visible index in scrollable area, then focus the cell at the same index */ const scrollable = getScrollableContainer();
                            const rowsExcludingHeader = rows.filter((row)=>!row.closest('thead'));
                            if (!scrollable) return null;
                            const scrollableRect = scrollable.getBoundingClientRect();
                            const firstVisibleIndex = rowsExcludingHeader.findIndex((row)=>{
                                const rowRect = row.getBoundingClientRect();
                                const isVisible = rowRect.bottom > scrollableRect.top && rowRect.top < scrollableRect.bottom;
                                return isVisible;
                            });
                            const children = Array.from(rowsExcludingHeader[Math.max(0, firstVisibleIndex)]?.children ?? []).filter((ele)=>{
                                return ele.getAttribute('aria-hidden') !== 'true';
                            });
                            if (children.length === 0) return;
                            return children[currentTdIndex] ?? rowsExcludingHeader[Math.max(0, firstVisibleIndex)].children[0];
                        }
                    default:
                        return null;
                }
            })();
            if (!(next instanceof HTMLElement)) return;
            event.stopImmediatePropagation(); // Stop meatball menu onKeyDown hijacking focus
            event.preventDefault();
            if (isStickyColumnsEnabled && (event.code === 'ArrowRight' || event.code === 'ArrowLeft') && (0, $4cTDP.fg)('issue_table_frozen_columns')) ensureCellFullyVisible(next);
            const button = next.querySelector('button[aria-hidden="false"]');
            const depth = getCellDepth(button);
            if (button && button instanceof HTMLElement && depth < 4) return button.focus();
            return next.focus();
        };
        const onFocusIn = (e)=>{
            /*
				Focus on last focused cell if we're moving focus from inside the table to outside the table
				and lastFocusedElement is defined. (tab into table), otherwise focus on the first cell in the table.
			*/ if (e.target instanceof HTMLElement && e.relatedTarget instanceof Element && lastFocusedElement.current) {
                if (table.contains(e.target) && !table.contains(e.relatedTarget)) return lastFocusedElement.current.focus();
            }
            /* Focus first element inside table, if we've referred focus from outside table (shift+tab back into table) */ const target = e.target;
            if (!(target instanceof HTMLElement) || !(e.relatedTarget instanceof Element) || table.contains(e.relatedTarget)) {
                if (target instanceof HTMLElement) lastFocusedElement.current = getCell(target);
                return;
            }
            const focusable = getFocusableElements();
            const indexOfTable = focusable.findIndex((ele)=>table.contains(ele));
            const indexOfRelatedTarget = focusable.indexOf(e.relatedTarget);
            if (indexOfRelatedTarget < indexOfTable) lastFocusedElement.current = undefined;
        };
        const onKeyDownWindow = (e)=>{
            /*
				If focus is on the first element outside the table.
				prevent the default behaviour and move focus either to the last focuse element inside the table, or the first table cell.
			*/ if (e.key === 'Tab' && e.shiftKey) {
                const focusable = getFocusableElements();
                const elementOutsideTable = focusable.slice(focusable.findIndex((ele)=>table.contains(ele))).find((ele)=>!table.contains(ele));
                if (elementOutsideTable === e.target) {
                    e.preventDefault();
                    if (lastFocusedElement.current && table.contains(lastFocusedElement.current)) return lastFocusedElement.current.focus();
                    focusable.find((ele)=>table.contains(ele))?.focus();
                }
            }
        };
        table.addEventListener('keydown', onKeyDown);
        table.addEventListener('focusin', onFocusIn);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', onKeyDownWindow);
        return ()=>{
            table.removeEventListener('keydown', onKeyDown);
            table.removeEventListener('focusin', onFocusIn);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', onKeyDownWindow);
        };
    // RefObject is a constant reference.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref.current
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isMoreShortcutsClicked && !onboardingTriggered.current && (0, $4cTDP.fg)('jira_nin_navigation_onboarding')) {
            onboardingTriggered.current = true;
            openHelpPanelLink((0, $8jOO7.KEYBOARD_SHORTCUTS_HELP_ARTICLE_ID));
        }
    }, [
        isMoreShortcutsClicked,
        openHelpPanelLink
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOkClicked && !onboardingTriggered.current && (0, $4cTDP.fg)('jira_nin_navigation_onboarding')) {
            onboardingTriggered.current = true;
            const table = ref.current;
            if (table) {
                const firstThCell = table.querySelector('th');
                if (firstThCell instanceof HTMLElement) firstThCell.focus();
            }
        }
    }, [
        isOkClicked,
        ref
    ]);
};

});

parcelRegister("4jaZO", function(module, exports) {
$parcel$export(module.exports, "ShouldUseSSRVirtualizerProvider", () => $02fccf8bdbf5d1dd$export$d91019f71aae1e4a);
$parcel$export(module.exports, "useSSRSafeVirtualizer", () => $02fccf8bdbf5d1dd$export$e290ffcf7d3b6e02);

var $eJOHy = parcelRequire("eJOHy");

var $bVtHf = parcelRequire("bVtHf");
const $02fccf8bdbf5d1dd$var$ShouldUseSSRVirtualizerContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $02fccf8bdbf5d1dd$export$d91019f71aae1e4a = ({ children: children })=>{
    const value = (0, $eJOHy.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02fccf8bdbf5d1dd$var$ShouldUseSSRVirtualizerContext.Provider, {
        value: value
    }, children);
};
const $02fccf8bdbf5d1dd$var$useShouldUseSSRVirtualizer = ()=>{
    const context = (0, $eJOHy.useContext)($02fccf8bdbf5d1dd$var$ShouldUseSSRVirtualizerContext);
    if (!context) throw new Error('useShouldUseSSRVirtualizer must be used within a ShouldUseSSRVirtualizerProvider');
    return context;
};
const $02fccf8bdbf5d1dd$export$f4c0efb17365077d = (options)=>{
    const { count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const totalSize = count * estimateSize(0);
    let start = 0;
    const items = Array.from({
        length: count
    }).map((_, i)=>{
        const end = start + estimateSize(i);
        const item = {
            index: i,
            key: getItemKey?.(i) ?? i,
            start: start,
            end: end,
            lane: 0,
            size: estimateSize(i)
        };
        start = end;
        return item;
    });
    return {
        getTotalSize () {
            return totalSize;
        },
        getVirtualItems () {
            return items;
        }
    };
};
const $02fccf8bdbf5d1dd$var$dummyVirtualizer = {
    getTotalSize () {
        return 0;
    },
    getVirtualItems () {
        return [];
    }
};
const $02fccf8bdbf5d1dd$export$e290ffcf7d3b6e02 = (options)=>{
    const { getScrollElement: getScrollElement, count: count, estimateSize: estimateSize, getItemKey: getItemKey } = options;
    const [shouldUseSSRVirtualizer, setShouldUseSSRVirtualizer] = $02fccf8bdbf5d1dd$var$useShouldUseSSRVirtualizer();
    const serverVirtualizer = (0, $eJOHy.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) // only calculated when is going to be used
        return $02fccf8bdbf5d1dd$export$f4c0efb17365077d({
            count: count,
            estimateSize: estimateSize,
            getItemKey: getItemKey
        });
        return $02fccf8bdbf5d1dd$var$dummyVirtualizer;
    }, [
        count,
        estimateSize,
        getItemKey,
        shouldUseSSRVirtualizer
    ]);
    const originalVirtualizer = (0, $bVtHf.useVirtualizer)(options);
    /**
	 * We swap to real virtualization when we detect that the user has initiated a scroll
	 */ (0, $eJOHy.useEffect)(()=>{
        if (!shouldUseSSRVirtualizer) return;
        const element = getScrollElement();
        const onScroll = ()=>{
            if (!false) {
                setShouldUseSSRVirtualizer(false);
                element?.removeEventListener('scroll', onScroll);
            }
        };
        element?.addEventListener('scroll', onScroll);
        return ()=>{
            element?.removeEventListener('scroll', onScroll);
        };
    }, [
        shouldUseSSRVirtualizer,
        getScrollElement,
        setShouldUseSSRVirtualizer
    ]);
    /**
	 * We overwrite the methods to render the items and calculate size
	 * to assure that SSR renders the same as the frontend on the initial
	 * render
	 */ return (0, $eJOHy.useMemo)(()=>{
        if (shouldUseSSRVirtualizer) return {
            ...originalVirtualizer,
            ...serverVirtualizer
        };
        // Ensure we return a stable reference between renders when we stop using the SSR virtualizer
        return originalVirtualizer;
    }, [
        originalVirtualizer,
        serverVirtualizer,
        shouldUseSSRVirtualizer
    ]);
};

});
parcelRegister("bVtHf", function(module, exports) {
$parcel$export(module.exports, "defaultRangeExtractor", () => (parcelRequire("gMNDC")).defaultRangeExtractor);
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("gMNDC")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("8GBQp")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("gMNDC")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("gMNDC")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("gMNDC")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("gMNDC")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("gMNDC")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("gMNDC")).windowScroll);
$parcel$export(module.exports, "useVirtualizer", () => $8aec0db0c0df701a$export$dd6d526d88b5a137);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gMNDC = parcelRequire("gMNDC");
const $8aec0db0c0df701a$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;
function $8aec0db0c0df701a$var$useVirtualizerBase(options) {
    const rerender = $eJOHy.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $aQK2r.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eJOHy.useState(()=>new (0, $gMNDC.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eJOHy.useEffect(()=>{
        return instance._didMount();
    }, []);
    $8aec0db0c0df701a$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $8aec0db0c0df701a$export$dd6d526d88b5a137(options) {
    return $8aec0db0c0df701a$var$useVirtualizerBase({
        observeElementRect: $gMNDC.observeElementRect,
        observeElementOffset: $gMNDC.observeElementOffset,
        scrollToFn: (0, $gMNDC.elementScroll),
        ...options
    });
}
function $8aec0db0c0df701a$export$645722dcac657cb9(options) {
    return $8aec0db0c0df701a$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $gMNDC.observeWindowRect),
        observeElementOffset: (0, $gMNDC.observeWindowOffset),
        scrollToFn: (0, $gMNDC.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("gMNDC", function(module, exports) {
$parcel$export(module.exports, "defaultRangeExtractor", () => $c387a2210354f599$export$7eb7cb13fd21e5e1);
$parcel$export(module.exports, "observeElementRect", () => $c387a2210354f599$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $c387a2210354f599$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $c387a2210354f599$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $c387a2210354f599$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $c387a2210354f599$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $c387a2210354f599$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $c387a2210354f599$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("8GBQp")).notUndefined);

var $8GBQp = parcelRequire("8GBQp");
const $c387a2210354f599$export$76974b428a49f15b = (index)=>index;
const $c387a2210354f599$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $c387a2210354f599$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $c387a2210354f599$var$addEventListenerOptions = {
    passive: true
};
const $c387a2210354f599$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $c387a2210354f599$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $c387a2210354f599$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $c387a2210354f599$var$supportsScrollend ? ()=>void 0 : (0, $8GBQp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c387a2210354f599$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c387a2210354f599$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $c387a2210354f599$var$supportsScrollend ? ()=>void 0 : (0, $8GBQp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c387a2210354f599$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c387a2210354f599$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c387a2210354f599$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $c387a2210354f599$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $c387a2210354f599$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $c387a2210354f599$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $c387a2210354f599$export$76974b428a49f15b,
                rangeExtractor: $c387a2210354f599$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $c387a2210354f599$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $8GBQp.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $8GBQp.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $8GBQp.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $8GBQp.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $c387a2210354f599$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $8GBQp.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $8GBQp.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $8GBQp.notUndefined)(measurements[$c387a2210354f599$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $8GBQp.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $8GBQp.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $8GBQp.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $c387a2210354f599$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $c387a2210354f599$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $c387a2210354f599$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("8GBQp", function(module, exports) {
$parcel$export(module.exports, "memo", () => $652f9a140a44b154$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $652f9a140a44b154$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $652f9a140a44b154$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $652f9a140a44b154$export$61fc7d43ac8f84b0);
function $652f9a140a44b154$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $652f9a140a44b154$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $652f9a140a44b154$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $652f9a140a44b154$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});




parcelRegister("8Cpk9", function(module, exports) {
$parcel$export(module.exports, "default", () => $734acbe44f1f7d3b$export$2e2bcd8739ae039);

var $bDXbB = parcelRequire("bDXbB");

var $2J7Uf = parcelRequire("2J7Uf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $4ohGb = parcelRequire("4ohGb");

var $34oCh = parcelRequire("34oCh");

var $g212q = parcelRequire("g212q");

var $kmFBu = parcelRequire("kmFBu");

var $lfz0B = parcelRequire("lfz0B");
/**
 * Render the table footer, composing together the default IssueCount and Pagination UI elements.
 */ const $734acbe44f1f7d3b$var$FooterRenderer = ({ Footer: Footer, IssueCount: IssueCount, issues: issues, rankField: rankField, onPageChange: onPageChange, canShowAdditionalFields: canShowAdditionalFields, footerBorderRadius: footerBorderRadius, topLevelIssueCreateConfig: topLevelIssueCreateConfig })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $2J7Uf.default), issues);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $bDXbB.default), rankField ?? null);
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    // Use new Visual Refresh footer order if visual refresh or any m1 features are enabled to
    // simplfiy the number of cases we need to handle with the new features.
    const isNewFooterOrderEnabled = (0, $6XJko.isVisualRefreshEnabled)() || isIssueCreateEnabled || isInfiniteScrollEnabled;
    let start;
    let center;
    let end;
    // Show pagination controls only when discrete pagination is enabled
    if (onPageChange && !isInfiniteScrollEnabled) {
        const paginationControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfz0B.PaginationControls), {
            issues: issueData,
            onPageChange: (after)=>onPageChange(after, false),
            isNewFooterOrderEnabled: isNewFooterOrderEnabled
        });
        if (isNewFooterOrderEnabled) center = paginationControls;
        else end = paginationControls;
    }
    // Show issue count when either pagination or infinite scroll are enabled
    if (onPageChange || isInfiniteScrollEnabled) {
        const moveIssueCountToEnd = (0, $4cTDP.fg)('global_rovo_button_in_jira') ? center !== undefined : isNewFooterOrderEnabled;
        const issueCount = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g212q.default), {
            issues: issueData,
            IssueCount: IssueCount,
            isNewFooterOrderEnabled: moveIssueCountToEnd,
            isInfiniteScrollEnabled: isInfiniteScrollEnabled
        });
        if (moveIssueCountToEnd) end = issueCount;
        else center = issueCount;
    }
    const hasIssues = (issueData.totalIssueSearchResultCount ?? 0) > 0;
    const hasIssueConnectionControls = hasIssues && (!!onPageChange || isInfiniteScrollEnabled);
    const hasControlsToDisplay = hasIssueConnectionControls || isIssueCreateEnabled;
    // Hide the footer if we have no issues UNLESS the consumer has provided a custom footer component, in which case
    // the consumer becomes responsible for when the footer should be shown/hidden.
    if (!hasControlsToDisplay && !Footer) return null;
    const FooterToRender = Footer ?? (0, $4ohGb.Footer);
    if (isIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmFBu.IssueCreateFooter), {
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        Footer: FooterToRender,
        rankField: rankFieldData ?? null,
        start: start,
        center: center,
        end: end,
        issues: issueData,
        canShowAdditionalFields: canShowAdditionalFields,
        footerBorderRadius: footerBorderRadius,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FooterToRender, {
        start: start,
        center: center,
        end: end
    });
};
var $734acbe44f1f7d3b$export$2e2bcd8739ae039 = $734acbe44f1f7d3b$var$FooterRenderer;

});
parcelRegister("bDXbB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f551f7a3a1d1ef13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cca09b170ab2d2818122119c2cf83406>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f551f7a3a1d1ef13$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FooterRenderer_rank",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueCreateFooter_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$f551f7a3a1d1ef13$var$node.hash = "1a295e01caab47d2d434a50b4c74845e";
var $f551f7a3a1d1ef13$export$2e2bcd8739ae039 = $f551f7a3a1d1ef13$var$node;

});

parcelRegister("2J7Uf", function(module, exports) {
$parcel$export(module.exports, "default", () => $52236aceb308ce34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d47dafec3f3560d64fc18784e02d428>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52236aceb308ce34$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageSize"
        }
    ],
    "kind": "Fragment",
    "name": "FooterRenderer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IssueCountRenderer"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueCreateFooter"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                }
            ],
            "kind": "FragmentSpread",
            "name": "PaginationControls"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }
    ],
    "type": "JiraIssueConnection"
};
$52236aceb308ce34$var$node.hash = "3b4b5fcc961dfdfdc9948a5e19cf7228";
var $52236aceb308ce34$export$2e2bcd8739ae039 = $52236aceb308ce34$var$node;

});

parcelRegister("4ohGb", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $74e7263cd9d59bbd$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");
const $74e7263cd9d59bbd$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ start: start = $74e7263cd9d59bbd$var$SpacerElement, center: center = $74e7263cd9d59bbd$var$SpacerElement, end: end = $74e7263cd9d59bbd$var$SpacerElement }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterBase, {
        ref: ref
    }, start, center, end);
});
const $74e7263cd9d59bbd$var$FooterBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    const tableHeight = (0, $kbYhH.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return (0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterWrapper, null, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: false
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74e7263cd9d59bbd$var$FooterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _4t3i1y44 _lcxvglyw _16qs9g9j",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$export$d7a54cba636a8cd6, null);

});
parcelRegister("7n9BS", function(module, exports) {
$parcel$export(module.exports, "useScrollStateActions", () => $fb5e49bfa6da600b$export$f4fa046095d4d6af);
$parcel$export(module.exports, "useScrollStateSelector", () => $fb5e49bfa6da600b$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $fb5e49bfa6da600b$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8jOO7 = parcelRequire("8jOO7");
const $fb5e49bfa6da600b$export$50b6b7783d156e1b = 200;
const $fb5e49bfa6da600b$export$f9abcb6f103965a2 = (0, $6E16M.createContainer)();
const $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null,
    hasScrolled: false
};
const $fb5e49bfa6da600b$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        },
    getScrollInfo: ()=>({ getState: getState })=>{
            const { scrollElement: scrollElement, isScrolling: isScrolling, width: width } = getState();
            return {
                isScrolling: isScrolling,
                scrollElement: scrollElement,
                // Calculated by adding the scroll container’s left and right positions relative to the viewport to the table width to get the total horizontal space
                isSmallScreen: width + (scrollElement?.getBoundingClientRect().left ?? 0) + (scrollElement?.getBoundingClientRect().right ?? 0) < (0, $8jOO7.SMALL_SCREEN_WIDTH) && width !== 0
            };
        }
};
const $fb5e49bfa6da600b$var$Store = (0, $GtRbT.createStore)({
    containedBy: $fb5e49bfa6da600b$export$f9abcb6f103965a2,
    initialState: $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $fb5e49bfa6da600b$var$actions
});
const $fb5e49bfa6da600b$export$f4fa046095d4d6af = (0, $iJq0l.createActionsHook)($fb5e49bfa6da600b$var$Store);
const $fb5e49bfa6da600b$export$a2d79f83724ed591 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $fb5e49bfa6da600b$export$fae04c81b2201f65 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state)=>state.scrollElement
});
const $fb5e49bfa6da600b$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $fb5e49bfa6da600b$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $fb5e49bfa6da600b$export$f4fa046095d4d6af();
    (0, $eJOHy.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true,
                hasScrolled: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $fb5e49bfa6da600b$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $fb5e49bfa6da600b$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $fb5e49bfa6da600b$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$var$ScrollStateProviderInner, props));
};

});


parcelRegister("g212q", function(module, exports) {
$parcel$export(module.exports, "default", () => $84a76d68624b4129$export$2e2bcd8739ae039);

var $aI511 = parcelRequire("aI511");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bNYj = parcelRequire("2bNYj");
const $84a76d68624b4129$var$IssueCountRenderer = ({ issues: issues, IssueCount: IssueCount = (0, $2bNYj.IssueCount), isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $aI511.default), issues);
    const startIssueRange = data.issueNavigatorPageInfo?.firstIssuePosition ?? 0;
    const endIssueRange = data.issueNavigatorPageInfo?.lastIssuePosition ?? 0;
    const loadedIssuesCount = data.edges?.length ?? 0;
    const total = data.totalIssueSearchResultCount ?? 0;
    const countExceedsMaxResults = !!data.isCappingIssueSearchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueCount, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        loadedIssuesCount: loadedIssuesCount,
        total: total,
        countExceedsMaxResults: countExceedsMaxResults,
        isNewFooterOrderEnabled: isNewFooterOrderEnabled,
        isInfiniteScrollEnabled: isInfiniteScrollEnabled
    });
};
var $84a76d68624b4129$export$2e2bcd8739ae039 = $84a76d68624b4129$var$IssueCountRenderer;

});
parcelRegister("aI511", function(module, exports) {
$parcel$export(module.exports, "default", () => $11b136be358eaf79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d2de91d8ec54b88dc57599501ba85984>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $11b136be358eaf79$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueCountRenderer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$11b136be358eaf79$var$node.hash = "a7311216a2dbc3d7090b0f6d487ae3d3";
var $11b136be358eaf79$export$2e2bcd8739ae039 = $11b136be358eaf79$var$node;

});

parcelRegister("2bNYj", function(module, exports) {
$parcel$export(module.exports, "IssueCount", () => $efade5dddaf06e66$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $iIICj = parcelRequire("iIICj");
const $efade5dddaf06e66$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isNewFooterOrderEnabled: isNewFooterOrderEnabled, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalNumberIssues = countExceedsMaxResults ? `${total}+` : total;
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efade5dddaf06e66$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: true
    }, isTotalUnknown ? String(loadedIssuesCount) : formatMessage((0, $iIICj.default).loadedIssuesTotalKnown, {
        loadedIssuesCount: loadedIssuesCount,
        totalNumberIssues: totalNumberIssues
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efade5dddaf06e66$var$IssueCountContainer, {
        "data-testid": "native-issue-table.ui.footer-renderer.issue-count-renderer.issue-count.issue-count",
        isFlexEnd: isNewFooterOrderEnabled
    }, isTotalUnknown ? formatMessage((0, $iIICj.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }) : formatMessage((0, $iIICj.default).issueRangeKnown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        totalNumberIssues: totalNumberIssues
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efade5dddaf06e66$var$IssueCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iIICj", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb9f623cbed4390$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bfb9f623cbed4390$var$messages = (0, $7qGN1.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "native-issue-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});
var $bfb9f623cbed4390$export$2e2bcd8739ae039 = $bfb9f623cbed4390$var$messages;

});



parcelRegister("kmFBu", function(module, exports) {
$parcel$export(module.exports, "IssueCreateFooter", () => $190f8104c06ec555$export$e3ef2bbdafbe53d8);

var $2zhzj = parcelRequire("2zhzj");

var $9S8Ep = parcelRequire("9S8Ep");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $79KhM = parcelRequire("79KhM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $68iTT = parcelRequire("68iTT");

var $6xIZT = parcelRequire("6xIZT");

var $1cMAs = parcelRequire("1cMAs");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $64b9C = parcelRequire("64b9C");


var $4ohGb = parcelRequire("4ohGb");

var $34oCh = parcelRequire("34oCh");

var $3F6xT = parcelRequire("3F6xT");

var $aNnbk = parcelRequire("aNnbk");
const $190f8104c06ec555$var$FormWithInsertionPoint = ({ connectionId: connectionId, rankFieldId: rankFieldId, rankFieldTerms: rankFieldTerms, footerBorderRadius: footerBorderRadius, ...props })=>{
    const insertionPoint = (0, $3F6xT.useCalculateIssueInsertionPoint)();
    let jql;
    if ((0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    jql = (0, $34oCh.useJql)();
    const handleIssueCreate = (0, $aNnbk.useIssueCreateMutation)({
        issueConnectionId: connectionId,
        jql: jql,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            rankFieldTerms: rankFieldTerms
        },
        ...(0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') && {
            location: 'footerCreateForm'
        }
    });
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const formContextualFields = (0, $eJOHy.useMemo)(()=>{
        if (!isIssueRankingEnabled || !(0, $4cTDP.fg)('jsc_list_reranking_gate')) return undefined;
        if (isIssueRankDescending) return insertionPoint?.position === 'below' ? {
            rankBeforeIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        } : {
            rankAfterIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        };
        return insertionPoint?.position === 'below' ? {
            rankAfterIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: insertionPoint?.issueId,
            rankFieldId: rankFieldId
        };
    }, [
        insertionPoint?.issueId,
        insertionPoint?.position,
        isIssueRankDescending,
        isIssueRankingEnabled,
        rankFieldId
    ]);
    const handleIssueCreateWithInsertionPoint = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        if (insertionPoint == null) return handleIssueCreate(issueToCreate, contextualFields);
        return handleIssueCreate(issueToCreate, contextualFields, {
            insertAfter: insertionPoint.position === 'below',
            insertNodeId: insertionPoint.issueId
        });
    }, [
        handleIssueCreate,
        insertionPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $190f8104c06ec555$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        ...props,
        onCreateIssue: handleIssueCreateWithInsertionPoint,
        rankFieldId: rankFieldId,
        contextualFields: formContextualFields,
        isTimeline: isTimelineEnabled,
        footerBorderRadius: footerBorderRadius
    }));
};
const $190f8104c06ec555$var$nudgeRuntimeProps = {};
const $190f8104c06ec555$export$e3ef2bbdafbe53d8 = ({ Footer: // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
Footer = (0, $4ohGb.Footer), issues: issues, rankField: rankField, canShowAdditionalFields: canShowAdditionalFields, footerBorderRadius: footerBorderRadius, topLevelIssueCreateConfig: topLevelIssueCreateConfig, ...footerProps })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $9S8Ep.default), issues);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $2zhzj.default), rankField ?? null);
    const projectContext = (0, $34oCh.useProjectContext)();
    const isFormRendered = (0, $eJOHy.useRef)(false);
    const inlineCreateHandlersInput = (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting') ? {
        projectKey: projectContext,
        maxHierarchyLevel: topLevelIssueCreateConfig?.maxHierarchyLevel,
        minHierarchyLevel: topLevelIssueCreateConfig?.minHierarchyLevel ?? 0
    } : {
        projectKey: projectContext,
        minHierarchyLevel: 0
    };
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)(inlineCreateHandlersInput);
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const isProjectQuickstartOnboardingEnabled = (0, $34oCh.useIsProjectQuickstartOnboardingEnabled)();
    const isNudgeTargetEnabled = isProjectQuickstartOnboardingEnabled && (0, $4cTDP.fg)('jira_list_nin_merge');
    const { ref: gettingStartedListNudgeRef } = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$c6df9a2c7447e12d), isNudgeTargetEnabled);
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    if (isFormVisible) {
        isFormRendered.current = true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($190f8104c06ec555$var$FormWithInsertionPoint, {
            connectionId: issueData?.__id,
            rankFieldId: rankFieldData?.fieldId ?? null,
            rankFieldTerms: rankFieldTerms,
            ...formProps,
            appearance: "footer",
            depth: 0,
            ...(0, $4cTDP.fg)('refactor_issue_table_for_timline') ? {
                canShowAdditionalFields: canShowAdditionalFields
            } : {
                canShowAdditionalFields: !isTimelineEnabled
            },
            footerBorderRadius: footerBorderRadius
        });
    }
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, {
        ref: (0, $4cTDP.fg)('jira_list_nin_merge') ? gettingStartedListNudgeRef : undefined,
        ...footerProps,
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $190f8104c06ec555$var$triggerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cMAs.default), {
            ...triggerProps,
            isFormRendered: isFormRendered.current
        }))
    });
    if (isNudgeTargetEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $64b9C.GetStartedListNudge), {
        runtimeProps: $190f8104c06ec555$var$nudgeRuntimeProps
    }, footer);
    return footer;
};
const $190f8104c06ec555$var$BORDER_WIDTH = '1px';
const $190f8104c06ec555$var$formContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overflow',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: $190f8104c06ec555$var$BORDER_WIDTH,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopColor: 'color.border'
});
const $190f8104c06ec555$var$triggerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    minHeight: '32px'
});

});
parcelRegister("2zhzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb694d9c7cfbe6e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e642f5e9e155c4c7a57efe47d3149c5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfb694d9c7cfbe6e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueCreateFooter_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$bfb694d9c7cfbe6e$var$node.hash = "a4046922d80cd423f4205dcd4a424119";
var $bfb694d9c7cfbe6e$export$2e2bcd8739ae039 = $bfb694d9c7cfbe6e$var$node;

});

parcelRegister("9S8Ep", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6c981845d9475ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37ee5eaec597e35d55dbb7615ad2f6b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b6c981845d9475ed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueCreateFooter",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$b6c981845d9475ed$var$node.hash = "bb4169454bfd5537e0b923f7af0c8e7e";
var $b6c981845d9475ed$export$2e2bcd8739ae039 = $b6c981845d9475ed$var$node;

});

parcelRegister("68iTT", function(module, exports) {
$parcel$export(module.exports, "useInlineCreateHandlers", () => $f2e349346c4eb6b1$export$bec6eb88acc84895);

var $eJOHy = parcelRequire("eJOHy");

var $dZ3jN = parcelRequire("dZ3jN");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $6xIZT = parcelRequire("6xIZT");

var $1Ob2L = parcelRequire("1Ob2L");

var $1cMAs = parcelRequire("1cMAs");
const $f2e349346c4eb6b1$export$bec6eb88acc84895 = ({ projectKey: projectKey, defaultAssigneeId: defaultAssigneeId, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>{
    const [isFormVisible, setIsFormVisible] = (0, $eJOHy.useState)(false);
    const formIssueDraftRef = (0, $eJOHy.useRef)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $1Ob2L.useInlineIssueCreateEntryPoint)(projectKey, minHierarchyLevel, maxHierarchyLevel);
    const ref = (0, $eJOHy.useRef)(null);
    const buttonRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    const merged = (0, $bzbsd.default)(ref, buttonRef);
    const handleTriggerClick = (0, $eJOHy.useCallback)(()=>{
        setIsFormVisible(true);
    }, []);
    const handleFormCancel = (0, $eJOHy.useCallback)(()=>{
        setIsFormVisible(false);
        ref.current?.focus();
    }, []);
    const onDraftUpdate = (0, $eJOHy.useCallback)((issueDraft)=>{
        formIssueDraftRef.current = issueDraft;
    }, []);
    if ((0, $4cTDP.fg)('jira_render_pic_in_nin')) {
        const { entryPointActions: additionalFieldsEntryPointActions, entryPointReferenceSubject: additionalFieldsEntryPointSubject } = (0, $1Ob2L.useInlineIssueCreateAdditionalFieldsEntryPoint)({
            projectKey: projectKey,
            defaultAssigneeId: defaultAssigneeId
        });
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const additionalFieldsRef = (0, $dZ3jN.useEntryPointButtonTrigger)(additionalFieldsEntryPointActions);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const mergedRefWithAdditionalFields = (0, $bzbsd.default)(ref, buttonRef, additionalFieldsRef);
        if ((0, $4cTDP.fg)('memoize_inline_create_handlers')) {
            // eslint-disable-next-line react-hooks/react-compiler
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const formProps = (0, $eJOHy.useMemo)(()=>({
                    initialIssueDraft: formIssueDraftRef.current,
                    getInitialIssueDraft: ()=>formIssueDraftRef.current,
                    onDraftUpdate: onDraftUpdate,
                    onCancel: handleFormCancel,
                    entryPointSubject: entryPointReferenceSubject,
                    additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject
                }), [
                additionalFieldsEntryPointSubject,
                entryPointReferenceSubject,
                handleFormCancel,
                onDraftUpdate
            ]);
            // eslint-disable-next-line react-hooks/react-compiler
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const triggerProps = (0, $eJOHy.useMemo)(()=>({
                    onClick: handleTriggerClick,
                    ref: mergedRefWithAdditionalFields
                }), [
                handleTriggerClick,
                mergedRefWithAdditionalFields
            ]);
            return {
                isFormVisible: isFormVisible,
                entryPointActions: entryPointActions,
                additionalFieldsEntryPointActions: additionalFieldsEntryPointActions,
                formProps: formProps,
                triggerProps: triggerProps
            };
        }
        return {
            isFormVisible: isFormVisible,
            entryPointActions: entryPointActions,
            additionalFieldsEntryPointActions: additionalFieldsEntryPointActions,
            formProps: {
                initialIssueDraft: formIssueDraftRef.current,
                onDraftUpdate: onDraftUpdate,
                onCancel: handleFormCancel,
                entryPointSubject: entryPointReferenceSubject,
                additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject
            },
            triggerProps: {
                onClick: handleTriggerClick,
                ref: mergedRefWithAdditionalFields
            }
        };
    }
    if ((0, $4cTDP.fg)('memoize_inline_create_handlers')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formProps = (0, $eJOHy.useMemo)(()=>({
                initialIssueDraft: formIssueDraftRef.current,
                getInitialIssueDraft: ()=>formIssueDraftRef.current,
                onDraftUpdate: onDraftUpdate,
                onCancel: handleFormCancel,
                entryPointSubject: entryPointReferenceSubject
            }), [
            entryPointReferenceSubject,
            handleFormCancel,
            onDraftUpdate
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const triggerProps = (0, $eJOHy.useMemo)(()=>({
                onClick: handleTriggerClick,
                ref: merged
            }), [
            handleTriggerClick,
            merged
        ]);
        return {
            isFormVisible: isFormVisible,
            entryPointActions: entryPointActions,
            formProps: formProps,
            triggerProps: triggerProps
        };
    }
    return {
        isFormVisible: isFormVisible,
        entryPointActions: entryPointActions,
        formProps: {
            initialIssueDraft: formIssueDraftRef.current,
            onDraftUpdate: onDraftUpdate,
            onCancel: handleFormCancel,
            entryPointSubject: entryPointReferenceSubject
        },
        triggerProps: {
            onClick: handleTriggerClick,
            ref: merged
        }
    };
};
const $f2e349346c4eb6b1$var$InlineCreate = ({ projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, ...formProps })=>{
    const { isFormVisible: isFormVisible, formProps: formPropsAdditional, triggerProps: triggerProps } = $f2e349346c4eb6b1$export$bec6eb88acc84895({
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel
    });
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        ...formProps,
        ...formPropsAdditional
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cMAs.default), triggerProps);
};
var $f2e349346c4eb6b1$export$2e2bcd8739ae039 = $f2e349346c4eb6b1$var$InlineCreate;

});
parcelRegister("6xIZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6479a1a8f48bc6cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $cBavF = parcelRequire("cBavF");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $cxKOj = parcelRequire("cxKOj");

var $bJscI = parcelRequire("bJscI");


var $gBHpC = parcelRequire("gBHpC");

var $ljpuj = parcelRequire("ljpuj");

var $eNuUB = parcelRequire("eNuUB");

var $ab4Fp = parcelRequire("ab4Fp");

const $6479a1a8f48bc6cf$var$ICON_WIDTH = 24;
const $6479a1a8f48bc6cf$var$PADDING = 8;
const $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING = 12;
const $6479a1a8f48bc6cf$var$ICC_ICON_PADDING = 6;
const $6479a1a8f48bc6cf$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $6479a1a8f48bc6cf$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $6479a1a8f48bc6cf$export$848553d86b9bee59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ljpuj.IssueTypeDropdown), {
        project: null,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onProjectChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        selectedType: null
    });
const $6479a1a8f48bc6cf$var$calledFromSource = 'issueTable';
const $6479a1a8f48bc6cf$var$InlineCreateForm = ({ initialIssueDraft: initialIssueDraftProp, getInitialIssueDraft: getInitialIssueDraft, onDraftUpdate: onDraftUpdate, onCreateIssue: onCreateIssue, onCancel: onCancel, entryPointSubject: entryPointSubject, appearance: appearance = 'row', depth: depth = 0, columns: columns, isGrouping: isGrouping, additionalFieldsEntryPointSubject: additionalFieldsEntryPointSubject, location: location, isTimeline: isTimeline, canShowAdditionalFields: canShowAdditionalFields, isSearchable: isSearchable, footerBorderRadius: footerBorderRadius })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isManageIssueTypesModalOpen, setIsManageIssueTypesModalOpen] = (0, $eJOHy.useState)(false);
    const initialIssueDraft = (0, $4cTDP.fg)('memoize_inline_create_handlers') ? getInitialIssueDraft?.() : initialIssueDraftProp;
    const [textContent, setTextContent] = (0, $eJOHy.useState)(initialIssueDraft?.summary ?? '');
    const [selectedType, setSelectedType] = (0, $eJOHy.useState)(initialIssueDraft?.issueType ?? null);
    const [selectedProject, setSelectedProject] = (0, $eJOHy.useState)(initialIssueDraft?.project ?? null); // assignee would be undefined initially, when user selects unassigned user from picker then it will be null
    // Default assignee is fetched from the entrypoint
    const initialAssignee = (0, $eJOHy.useMemo)(()=>initialIssueDraft?.assignee ? {
            accountId: initialIssueDraft.assignee.accountId,
            displayName: initialIssueDraft.assignee.name,
            avatarUrls: {
                '48x48': initialIssueDraft.assignee.picture
            }
        } : undefined, [
        initialIssueDraft?.assignee
    ]);
    const [assignee, setAssignee] = (0, $eJOHy.useState)(initialAssignee);
    const [dueDate, setDueDate] = (0, $eJOHy.useState)(initialIssueDraft?.dueDate ?? null);
    const [isUpdatingAdditionalFields, setIsUpdatingAdditionalFields] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        onDraftUpdate?.({
            summary: textContent,
            project: selectedProject ?? undefined,
            issueType: selectedType ?? undefined,
            ...assignee && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? {
                assignee: {
                    accountId: assignee.accountId ?? '',
                    name: assignee.displayName,
                    picture: assignee.avatarUrls['48x48'] ?? ''
                }
            } : {},
            ...dueDate != null && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? {
                dueDate: dueDate
            } : {}
        });
    }, [
        onDraftUpdate,
        selectedProject,
        selectedType,
        textContent,
        assignee,
        dueDate
    ]);
    const formRef = (0, $eJOHy.useRef)(null);
    const isEmptyRef = (0, $eJOHy.useRef)(true);
    const textAreaRef = (0, $eJOHy.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const contextualFields = (0, $gBHpC.useIssueCreateContextualFields)(); // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $6479a1a8f48bc6cf$export$35cad9398ceaeef0();
    const handleCreateIssue = (0, $eJOHy.useCallback)(()=>{
        if (!isEmptyRef.current && selectedType && selectedProject) {
            onCreateIssue({
                summary: textContent,
                project: selectedProject,
                issueType: selectedType,
                ...assignee && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? {
                    assignee: {
                        accountId: assignee.accountId ?? '',
                        name: assignee.displayName ?? '',
                        picture: assignee.avatarUrls['48x48'] ?? ''
                    }
                } : {},
                ...dueDate != null && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? {
                    dueDate: dueDate
                } : {}
            }, contextualFields);
            setTextContent('');
            setAssignee(undefined);
            setDueDate(null);
        }
    }, [
        contextualFields,
        onCreateIssue,
        selectedProject,
        selectedType,
        textContent,
        assignee,
        dueDate
    ]);
    const handleCreateIssueRef = (0, $eJOHy.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue;
    const handleBlur = (0, $eJOHy.useCallback)((event)=>{
        if (!isReadyRef.current || isManageIssueTypesModalOpen && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false; // Don't close ICC when additional fields (assignee/due date pickers) are active
        // This prevents the ICC from closing when users click outside the pickers in NIN for both Software and Business
        if (isUpdatingAdditionalFields && (0, $4cTDP.fg)('jira_render_pic_in_nin')) {
            if (!inForm) {
                setTimeout(()=>{
                    textAreaRef.current?.focus();
                }, 0);
                if ((0, $4cTDP.fg)('jifjam2_icc_fix')) setIsUpdatingAdditionalFields(false);
            }
            return;
        }
        if (!inForm) {
            onCancel?.();
            event.stopPropagation();
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        isManageIssueTypesModalOpen,
        isUpdatingAdditionalFields,
        onCancel,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const content = e.target.value.replace(/[\n\r]+/g, ' ');
        setTextContent(content);
    }, []);
    const handleIssueTypeChange = (0, $eJOHy.useCallback)((newType, isSelected)=>{
        setSelectedType(newType);
        if (isSelected) setTimeout(()=>{
            textAreaRef.current?.focus();
        }, 0);
    }, []);
    const handleKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (e.key === 'Enter' && !$6479a1a8f48bc6cf$var$isComposing(e)) {
            e.preventDefault();
            handleCreateIssue();
        }
    }, [
        handleCreateIssue
    ]);
    const handleFormKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (!isUpdatingAdditionalFields || !(0, $4cTDP.fg)('jira_render_pic_in_nin')) e.stopPropagation();
    }, [
        isUpdatingAdditionalFields
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        handleCreateIssue();
    }, [
        handleCreateIssue
    ]);
    const handleCreateButtonClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit');
    }, [
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        // TODO; Add test for this feature once we support pre-population of the summary
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    const handleEscape = (0, $eJOHy.useCallback)((e)=>{
        const isAdditionalFieldsPickersActive = isUpdatingAdditionalFields && (0, $4cTDP.fg)('jira_render_pic_in_nin');
        if (!isAdditionalFieldsPickersActive && !(isManageIssueTypesModalOpen && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg'))) {
            e.stopPropagation();
            if (e.key === 'Escape') {
                onCancel?.();
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    formEmpty: isEmptyRef.current,
                    escapeKeyPressed: true
                });
            }
        }
        if (e.key === 'Enter') {
            if ((0, $4cTDP.fg)('jira_render_pic_in_nin')) {
                if (e.target === textAreaRef.current) {
                    e.preventDefault();
                    handleCreateIssue();
                }
            } else {
                e.preventDefault();
                handleCreateIssue();
            }
        }
    }, [
        isUpdatingAdditionalFields,
        isManageIssueTypesModalOpen,
        onCancel,
        createAnalyticsEvent,
        handleCreateIssue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!false) {
            document.addEventListener('click', handleBlur, true);
            document.addEventListener('keydown', handleEscape, true); // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            document.addEventListener('dragstart', handleBlur, true);
            return ()=>{
                document.removeEventListener('click', handleBlur, true);
                document.removeEventListener('keydown', handleEscape, true);
                document.removeEventListener('dragstart', handleBlur, true);
            };
        }
    }, [
        handleBlur,
        handleEscape
    ]);
    const padding = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING : $6479a1a8f48bc6cf$var$PADDING;
    let paddingLeft = depth > 1 ? (depth - 1) * $6479a1a8f48bc6cf$var$ICON_WIDTH + padding : padding;
    const mergedColumn = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? columns?.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) : undefined;
    if (mergedColumn && !isGrouping) {
        // For merged columns, use the same padding calculation as MergedCell component:
        // paddingLeft: `${HIERARCHY_LEVEL_PADDING * depth + CELL_PADDING}px`
        // This matches the logic in MergedCell.tsx minus the ICC icon padding;
        paddingLeft = $6479a1a8f48bc6cf$var$HIERARCHY_LEVEL_PADDING * depth + $6479a1a8f48bc6cf$var$PADDING - $6479a1a8f48bc6cf$var$ICC_ICON_PADDING; // Add checkbox column width if present
        const checkboxColumnWidth = columns?.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_CHECKBOX))?.defaultWidth ?? 0;
        paddingLeft += checkboxColumnWidth; // Add expand icon width if there are merged fields (hierarchy chevron space)
        const hasMergedFields = Number(mergedColumn.mergedColumns?.length) > 0;
        if (hasMergedFields) paddingLeft += $6479a1a8f48bc6cf$var$ICON_WIDTH;
    }
    const shouldShowAdditionalFields = (0, $eJOHy.useCallback)(()=>(0, $cxKOj.expVal)('jira_powerful_inline_create_for_nin', 'isEnabled', false), []);
    return(// TODO: Check if we can catch the escape in a different level that removes below lint rule
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$FullContent, {
        ref: formRef,
        onKeyDown: handleFormKeyDown,
        onSubmit: handleSubmit,
        appearance: appearance,
        paddingLeft: paddingLeft,
        ...(0, $4cTDP.fg)('refactor_issue_table_for_timline') ? {
            footerBorderRadius: footerBorderRadius
        } : {
            isTimeline: isTimeline
        },
        isMakeSpaceForRovoEnabled: (0, $4cTDP.fg)('global_rovo_button_in_jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointSubject,
        id: "async-issue-create-issue-type-dropdown",
        packageName: (0, $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b),
        teamName: (0, $23b4218cfd94fe9f$export$d57b6b390e78d90f),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$export$848553d86b9bee59, null),
        runtimeProps: {
            onChange: (0, $4cTDP.fg)('yurree_jjj2_timeline') ? handleIssueTypeChange : setSelectedType,
            onProjectChange: setSelectedProject,
            setIsEditing: (0, $4cTDP.fg)('jifjam2_icc_fix') ? setIsUpdatingAdditionalFields : undefined,
            setIsManageIssueTypesModalOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? setIsManageIssueTypesModalOpen : undefined,
            isManageIssueTypesModalOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? isManageIssueTypesModalOpen : undefined,
            selectedType: selectedType,
            isSearchable: isSearchable
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-table-inline-issue-create.ui.inline-create-form.textarea",
        xcss: $6479a1a8f48bc6cf$var$TextAreaStyles,
        as: "textarea",
        autoFocus: true,
        "aria-label": formatMessage((0, $eNuUB.default).placeholderText),
        placeholder: formatMessage((0, $eNuUB.default).placeholderText),
        value: textContent,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: textAreaRef
    }), canShowAdditionalFields && additionalFieldsEntryPointSubject != null && selectedProject?.key && (0, $4cTDP.fg)('jira_render_pic_in_nin') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: additionalFieldsEntryPointSubject,
        id: "async-inline-create-additional-fields",
        packageName: "async-inline-create-additional-fields",
        teamName: "jira-werewolves",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            projectKey: selectedProject?.key,
            fullWidth: false,
            isCompactDueDatePicker: true,
            shouldRenderToParent: true,
            shouldShowNameLabel: false,
            strategy: 'fixed',
            onAssigneeUpdate: setAssignee,
            defaultAssignee: assignee,
            defaultDueDate: dueDate,
            onDateSelected: setDueDate,
            shouldShowAdditionalFields: shouldShowAdditionalFields,
            source: $6479a1a8f48bc6cf$var$calledFromSource,
            onUpdatingAssigneePicker: setIsUpdatingAdditionalFields,
            onUpdatingDueDatePicker: setIsUpdatingAdditionalFields,
            issueTypeId: selectedType?.issueTypeId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$StyledCreateButton, {
        appearance: "primary",
        ...!(0, $4cTDP.fg)('global_rovo_button_in_jira') && {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ab4Fp.default), null)
        },
        ...(0, $4cTDP.fg)('global_rovo_button_in_jira') && {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ab4Fp.default), null)
        },
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: handleCreateButtonClick
    }, formatMessage((0, $eNuUB.default).createButton)))));
};
const $6479a1a8f48bc6cf$var$InlineCreateFormWithContainer = ({ contextualFields: contextualFields, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "issue-table-inline-issue-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gBHpC.IssueCreateContextualFieldsData), {
        payload: contextualFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6479a1a8f48bc6cf$var$InlineCreateForm, props)));
var $6479a1a8f48bc6cf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($6479a1a8f48bc6cf$var$InlineCreateFormWithContainer);
const $6479a1a8f48bc6cf$var$FullContentNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMakeSpaceForRovoEnabled: isMakeSpaceForRovoEnabled, paddingLeft: paddingLeft, footerBorderRadius: footerBorderRadius, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_to5f02": (0, $awdRS.default)(`${__cmplp.paddingLeft}px`),
            "--_et7yx1": (0, $awdRS.default)(__cmplp.footerBorderRadius)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1wza _vchhusvi _1tke1ylp _2lx2vrvc _4cvr1h6o _4t3i1ylp _ca0q1b66 _n3td1b66 _19bvedk6",
            __cmplp.isMakeSpaceForRovoEnabled ? "_u5f31ejb" : "_u5f3u2gc",
            __cmplp.footerBorderRadius && "_2rko17r0",
            !__cmplp.footerBorderRadius && __cmplp.appearance === 'footer' && "_mrkb1mok _1o0z1mok",
            !__cmplp.footerBorderRadius && __cmplp.appearance !== 'footer' && "_2rko12b0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6479a1a8f48bc6cf$var$FullContentOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMakeSpaceForRovoEnabled: isMakeSpaceForRovoEnabled, paddingLeft: paddingLeft, isTimeline: isTimeline, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_to5f02": (0, $awdRS.default)(`${__cmplp.paddingLeft}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1wza _vchhusvi _1tke1ylp _2lx2vrvc _4cvr1h6o _4t3i1ylp _ca0q1b66 _n3td1b66 _19bvedk6",
            __cmplp.isMakeSpaceForRovoEnabled ? "_u5f31ejb" : "_u5f3u2gc",
            __cmplp.isTimeline && "_2rkoidpf",
            !__cmplp.isTimeline && __cmplp.appearance === 'footer' && "_mrkb1mok _1o0z1mok",
            !__cmplp.isTimeline && __cmplp.appearance !== 'footer' && "_2rko12b0",
            __cmplp.className
        ])
    });
});
const $6479a1a8f48bc6cf$var$FullContent = (0, $bJscI.componentWithFG)('refactor_issue_table_for_timline', $6479a1a8f48bc6cf$var$FullContentNew, $6479a1a8f48bc6cf$var$FullContentOld);
const $6479a1a8f48bc6cf$var$TextAreaStyles = (0, $1DXK0.xcss)({
    flex: '1',
    border: 'none',
    outline: 'none',
    margin: '0',
    padding: 'space.050',
    height: '20px',
    resize: 'none',
    backgroundColor: 'elevation.surface',
    color: 'color.text',
    font: 'font.body',
    scrollbarWidth: 'none',
    whiteSpace: 'pre',
    boxSizing: 'content-box',
    fontFamily: 'inherit'
}); // TODO: Maybe we can rewrite to pressable....
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6479a1a8f48bc6cf$var$StyledCreateButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
const $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b = 'jiraIssueTableInlineIssueCreate';
const $23b4218cfd94fe9f$export$d57b6b390e78d90f = 'empanada';
const $23b4218cfd94fe9f$export$e77c67bc8157f49 = 'jsc_onboarding_inline_create';
const $23b4218cfd94fe9f$export$c7e6a6b283196232 = '/gateway/api';

parcelRegister("gBHpC", function(module, exports) {
$parcel$export(module.exports, "IssueCreateContextualFieldsData", () => $ebc2e159f3e0305c$export$a4ac6f56634f61f4);
$parcel$export(module.exports, "useIssueCreateContextualFields", () => $ebc2e159f3e0305c$export$6bb8d4e3be0700f9);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $ebc2e159f3e0305c$var$initialState = {};
const $ebc2e159f3e0305c$var$Store = (0, $GtRbT.createStore)({
    initialState: $ebc2e159f3e0305c$var$initialState,
    actions: {}
});
const $ebc2e159f3e0305c$var$updateStore = ()=>({ setState: setState }, { payload: payload })=>setState(payload);
const $ebc2e159f3e0305c$var$Container = (0, $6E16M.createContainer)($ebc2e159f3e0305c$var$Store, {
    onInit: $ebc2e159f3e0305c$var$updateStore,
    onUpdate: $ebc2e159f3e0305c$var$updateStore
});
const $ebc2e159f3e0305c$export$a4ac6f56634f61f4 = ({ children: children, payload: payload })=>{
    const ancestorPayload = $ebc2e159f3e0305c$export$6bb8d4e3be0700f9();
    const nextPayload = (0, $eJOHy.useMemo)(()=>({
            ...ancestorPayload,
            ...payload
        }), [
        ancestorPayload,
        payload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ebc2e159f3e0305c$var$Container, {
        payload: nextPayload
    }, children);
};
const $ebc2e159f3e0305c$export$6bb8d4e3be0700f9 = (0, $iJq0l.createStateHook)($ebc2e159f3e0305c$var$Store);

});

parcelRegister("ljpuj", function(module, exports) {
$parcel$export(module.exports, "IssueTypeDropdown", () => $f618bd39dd67a3ad$export$16aea7aa4bac227f);
$parcel$export(module.exports, "IssueTypeDropdownEntryPoint", () => $f618bd39dd67a3ad$export$7b1e666ab7e366e1);

var $gaDzZ = parcelRequire("gaDzZ");

var $bbotp = parcelRequire("bbotp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $c24ZZ = parcelRequire("c24ZZ");

var $dIK9p = parcelRequire("dIK9p");

var $4cTDP = parcelRequire("4cTDP");

var $aB2Z6 = parcelRequire("aB2Z6");

var $l4kLF = parcelRequire("l4kLF");
const $f618bd39dd67a3ad$var$createIssueTypeOption = (id, name, avatar, issueTypeId)=>({
        label: name,
        value: id,
        avatar: {
            small: avatar
        },
        issueTypeId: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? issueTypeId || undefined : undefined
    });
const $f618bd39dd67a3ad$var$createIssueType = (id, issueTypeId, name, avatar, hierarchyLevel)=>({
        id: id,
        issueTypeId: issueTypeId,
        name: name,
        avatar: {
            small: avatar
        },
        ...typeof hierarchyLevel === 'number' ? {
            hierarchy: {
                level: hierarchyLevel
            }
        } : {}
    });
const $f618bd39dd67a3ad$var$placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
    size: "medium"
});
const $f618bd39dd67a3ad$export$16aea7aa4bac227f = ({ onChange: onChange, onProjectChange: onProjectChange, setIsEditing: setIsEditing, setIsManageIssueTypesModalOpen: setIsManageIssueTypesModalOpen, isManageIssueTypesModalOpen: isManageIssueTypesModalOpen, project: project, selectedType: selectedType, isSearchable: isSearchable, manageConfigSource: manageConfigSource, filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isPristine = (0, $eJOHy.useRef)(true);
    // TODO; JSC-36  We need to integrate hierarchy level filter once JSC-59 is implemented
    const { data: data, refetch: refetch } = (0, $j4oe4.usePaginationFragment)((0, $bbotp.default), project);
    const [defaultIssueTypeId, { setDefaultIssueType: setDefaultIssueType }] = (0, $aB2Z6.useDefaultIssueType)(data?.key ?? null);
    const selectedTypeOption = (0, $eJOHy.useMemo)(()=>{
        if (selectedType == null) return null;
        return $f618bd39dd67a3ad$var$createIssueTypeOption(selectedType.id, selectedType.name, selectedType.avatar?.small, selectedType.issueTypeId);
    }, [
        selectedType
    ]);
    const handleGetRefetchVariables = (0, $eJOHy.useCallback)(// @ts-expect-error - isInlineManageWorkTypesConfigNinIccEnabled is automatically injected at runtime by the Relay provider
    ()=>({
            id: data?.id || ''
        }), [
        data?.id
    ]);
    const handleIssueTypeChange = (0, $eJOHy.useCallback)((typeOption)=>{
        let newIssueType = null;
        if (typeOption != null) {
            const issueType = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.id === typeOption.value);
            if (issueType?.node != null && issueType.node.issueTypeId != null) newIssueType = $f618bd39dd67a3ad$var$createIssueType(issueType.node.id, issueType.node.issueTypeId, issueType.node.name, issueType.node.avatar?.small, issueType.node.hierarchy?.level);
        }
        isPristine.current = false;
        onChange(newIssueType, (0, $4cTDP.fg)('yurree_jjj2_timeline') ? true : undefined);
        if (newIssueType?.issueTypeId) setDefaultIssueType(data?.key ?? null, newIssueType?.issueTypeId);
    }, [
        data?.issueTypes?.edges,
        data?.key,
        onChange,
        setDefaultIssueType
    ]);
    // Initialize with the first default issue
    (0, $eJOHy.useEffect)(()=>{
        if (isPristine.current) {
            const defaultIssueTypeEdge = (data?.issueTypes?.edges || []).find((edge)=>edge?.node?.issueTypeId === defaultIssueTypeId);
            if (defaultIssueTypeEdge?.node != null && defaultIssueTypeEdge.node.issueTypeId != null) // Return default issue type if exists
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            return onChange($f618bd39dd67a3ad$var$createIssueType(defaultIssueTypeEdge.node.id, defaultIssueTypeEdge.node.issueTypeId, defaultIssueTypeEdge.node.name, defaultIssueTypeEdge.node.avatar?.small, defaultIssueTypeEdge.node.hierarchy?.level));
            const firstIssue = data?.issueTypes?.edges?.[0];
            if (firstIssue?.node != null && firstIssue.node.issueTypeId != null) // Return first issue type in the connection
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            return onChange($f618bd39dd67a3ad$var$createIssueType(firstIssue.node.id, firstIssue.node.issueTypeId, firstIssue.node.name, firstIssue.node.avatar?.small, firstIssue.node.hierarchy?.level));
        }
    }, [
        data?.issueTypes?.edges,
        defaultIssueTypeId,
        onChange
    ]);
    const prevProjectKey = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (data?.id != null && prevProjectKey.current !== data?.id && data.projectId != null) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onProjectChange({
                id: data.id,
                projectId: data.projectId,
                key: data.key,
                name: data.name,
                avatar: data.avatar ? {
                    large: data.avatar.large
                } : null
            });
            prevProjectKey.current = data?.id;
        }
    }, [
        data?.avatar,
        data?.id,
        data?.key,
        data?.name,
        data?.projectId,
        onProjectChange
    ]);
    const manageIssueTypeProps = (0, $eJOHy.useMemo)(()=>{
        if (!data?.key || !data?.projectId || !(0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return undefined;
        const { minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel } = filter || {};
        return {
            projectKey: data.key,
            projectId: data.projectId,
            manageConfigSource: manageConfigSource,
            // We don't allow issue type creation if level 0 issues are excluded from the dropdown
            allowIssueTypeCreation: (!minHierarchyLevel || minHierarchyLevel <= 0) && (!maxHierarchyLevel || maxHierarchyLevel >= 0),
            setIsManageIssueTypesModalOpen: setIsManageIssueTypesModalOpen
        };
    }, [
        data?.key,
        data?.projectId,
        filter,
        manageConfigSource,
        setIsManageIssueTypesModalOpen
    ]);
    // TODO: JSC-71 We need to updated below component styles to adapt more to JWM current design
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c24ZZ.IssueTypeEditViewWithIssueTypeConnection), {
        issueTypesFragmentRef: data?.issueTypes ?? null,
        projectFragmentRef: manageIssueTypeProps && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? data : undefined,
        menuPosition: "fixed",
        menuPlacement: "top",
        onChange: handleIssueTypeChange,
        onRefetch: refetch,
        onGetRefetchVariables: handleGetRefetchVariables,
        setIsEditing: setIsEditing,
        refetchQuery: (0, $dIK9p.default),
        value: selectedTypeOption,
        spacing: "compact",
        stopPropagationOfMenuEscape: true,
        label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $l4kLF.default).labelIssueTerminologyRefreshM4 : (0, $l4kLF.default).label),
        iconsOnly: true,
        appearance: "subtle",
        isSearchable: isSearchable,
        placeholder: (0, $4cTDP.fg)('jifjam_deliveroo_icc_changes') ? $f618bd39dd67a3ad$var$placeholder : undefined,
        manageIssueTypeProps: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? manageIssueTypeProps : undefined,
        isManageIssueTypesModalOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? isManageIssueTypesModalOpen : undefined,
        renderAsPopupSelect: (0, $4cTDP.fg)('jifjam2_icc_fix')
    });
};
const $f618bd39dd67a3ad$export$7b1e666ab7e366e1 = ({ queries: { projectData: projectData }, props: props })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $gaDzZ.default), projectData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f618bd39dd67a3ad$export$16aea7aa4bac227f, {
        ...props,
        project: data.jira.jiraProjectByKey ?? null,
        filter: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? projectData.variables.filter : undefined
    });
};
var $f618bd39dd67a3ad$export$2e2bcd8739ae039 = $f618bd39dd67a3ad$export$16aea7aa4bac227f;

});
parcelRegister("gaDzZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c9979524fef05b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d534cfee839bb8c50e63790ad40073ed>>
 * @relayHash 13d26172a26eb9fd9bc44e01c17b4a8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID baec945a329fbc351826d69fcacbce16a8c6b454eb1077de0cd2cda3bf67e8c2

var $g8m5l = parcelRequire("g8m5l");
const $25c9979524fef05b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasProjectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueTypeDropdownQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "hasProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "IssueTypeDropdown"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueTypeDropdownQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "hasProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "large"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "issueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "level"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "filters": [
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "inlineIssueCreate_IssueTable_issueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "issueTypes"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "admin",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "baec945a329fbc351826d69fcacbce16a8c6b454eb1077de0cd2cda3bf67e8c2",
            "metadata": {},
            "name": "IssueTypeDropdownQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$25c9979524fef05b$var$node.hash = "0238e0aca7edc4704b3aa7f61762f162";
var $25c9979524fef05b$export$2e2bcd8739ae039 = $25c9979524fef05b$var$node;

});
parcelRegister("g8m5l", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f8b50c4e7e6e6cf$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
const $5f8b50c4e7e6e6cf$var$inlineManageWorkTypesConfigNinIcc = {
    get () {
        return (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg');
    }
};
var $5f8b50c4e7e6e6cf$export$2e2bcd8739ae039 = $5f8b50c4e7e6e6cf$var$inlineManageWorkTypesConfigNinIcc;

});


parcelRegister("bbotp", function(module, exports) {
$parcel$export(module.exports, "default", () => $43826636b0546b3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d50dc7ee659af4a0155ac5d44f1e06c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $dIK9p = parcelRequire("dIK9p");
const $43826636b0546b3f$var$node = function() {
    var v0 = [
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filter"
            },
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $dIK9p.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "IssueTypeDropdown",
        "selections": [
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "projectId"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "large"
                    }
                ]
            },
            {
                "alias": "issueTypes",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filter",
                        "variableName": "filter"
                    }
                ],
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "__inlineIssueCreate_IssueTable_issueTypes_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "level"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef"
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$43826636b0546b3f$var$node.hash = "aec60961411e82d617f031c4c43f1516";
var $43826636b0546b3f$export$2e2bcd8739ae039 = $43826636b0546b3f$var$node;

});
parcelRegister("dIK9p", function(module, exports) {
$parcel$export(module.exports, "default", () => $e170485f93d3fbc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfb5e2a51a4355c1b778f617486d135f>>
 * @relayHash 8adf0afe91a8b76e78174f3a6ccbc56a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d3934c09943829fd1a6c1f597a5f5b6447de126c3ab2bdb486a699a10938f78

var $g8m5l = parcelRequire("g8m5l");
const $e170485f93d3fbc4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineManageWorkTypesConfigNinIccEnabled"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v7 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "IssueTypeDropdown"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "inlineIssueCreate_IssueTable_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "admin",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "EDIT_PROJECT_CONFIG"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPerform"
                                                }
                                            ],
                                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d3934c09943829fd1a6c1f597a5f5b6447de126c3ab2bdb486a699a10938f78",
            "metadata": {},
            "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isInlineManageWorkTypesConfigNinIccEnabled": (0, $g8m5l.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$e170485f93d3fbc4$var$node.hash = "aec60961411e82d617f031c4c43f1516";
var $e170485f93d3fbc4$export$2e2bcd8739ae039 = $e170485f93d3fbc4$var$node;

});


parcelRegister("c24ZZ", function(module, exports) {
$parcel$export(module.exports, "IssueTypeEditViewWithIssueTypeConnection", () => $657e3371d6260ec4$export$139e4bfeb055992c);
$parcel$export(module.exports, "IssueTypeEditView", () => $657e3371d6260ec4$export$83fe9ca9fdf41761);

var $3ATPW = parcelRequire("3ATPW");

var $lWzlU = parcelRequire("lWzlU");

var $7BW6r = parcelRequire("7BW6r");

var $5xS2c = parcelRequire("5xS2c");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $7XH79 = parcelRequire("7XH79");

var $FhXEJ = parcelRequire("FhXEJ");

var $1jVV7 = parcelRequire("1jVV7");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $c4OV1 = parcelRequire("c4OV1");
var $sl8jM = parcelRequire("sl8jM");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $jbtzi = parcelRequire("jbtzi");

var $f1FvV = parcelRequire("f1FvV");

var $aUMMA = parcelRequire("aUMMA");

var $fwzaq = parcelRequire("fwzaq");

var $QH4SF = parcelRequire("QH4SF");

var $bzbsd = parcelRequire("bzbsd");

var $bskNA = parcelRequire("bskNA");

var $5vQ2T = parcelRequire("5vQ2T");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4F1Zj = parcelRequire("4F1Zj");

var $3NHkq = parcelRequire("3NHkq");

var $hUVzR = parcelRequire("hUVzR");

var $lvadq = parcelRequire("lvadq");
const $657e3371d6260ec4$var$iconOnlySelectStyles = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $1jVV7.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $1jVV7.layers).modal,
            minWidth: '120px',
            maxWidth: '440px',
            width: 'auto',
            overflowY: 'auto'
        }),
    control: (base)=>({
            ...base,
            '&:hover': {
                borderColor: 'transparent'
            }
        })
};
const $657e3371d6260ec4$export$6a277fd8285f68cf = ({ queryFragmentRef: queryFragmentRef, fieldId: fieldId, filterOptionsById: filterOptionsById = null, ...props })=>{
    const { data: issueTypesSearchData, refetch: refetchSuggestions } = (0, $j4oe4.usePaginationFragment)((0, $5xS2c.default), queryFragmentRef);
    const onGetRefetchVariables = (0, $eJOHy.useCallback)((searchBy)=>({
            id: fieldId,
            searchBy: searchBy,
            filterById: filterOptionsById
        }), [
        fieldId,
        filterOptionsById
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$139e4bfeb055992c, {
        ...props,
        issueTypesFragmentRef: issueTypesSearchData.node?.issueTypes ?? null,
        onGetRefetchVariables: onGetRefetchVariables,
        refetchQuery: (0, $QH4SF.default),
        onRefetch: refetchSuggestions
    });
};
const $657e3371d6260ec4$export$139e4bfeb055992c = ({ autoFocus: autoFocus = false, issueTypesFragmentRef: issueTypesFragmentRef, onChange: onChangeProp, onGetRefetchVariables: onGetRefetchVariables, setIsEditing: setIsEditing, value: value, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, isInvalid: isInvalid, isDisabled: isDisabled = false, inputId: inputId, menuPosition: menuPosition, menuPlacement: menuPlacement, refetchQuery: refetchQuery, onRefetch: onRefetch, openMenuOnFocus: openMenuOnFocus, spacing: spacing, stopPropagationOfMenuEscape: stopPropagationOfMenuEscape, iconsOnly: iconsOnly = false, appearance: appearance = 'default', isSearchable: isSearchable = true, placeholder: placeholder, manageIssueTypeProps: manageIssueTypeProps, isManageIssueTypesModalOpen: isManageIssueTypesModalOpen, projectFragmentRef: projectFragmentRef, renderAsPopupSelect: renderAsPopupSelect = false })=>{
    const hasAutoFocus = autoFocus && (!renderAsPopupSelect || !(0, $4cTDP.fg)('jifjam2_icc_fix'));
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(hasAutoFocus);
    const triggerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>noOptionsMessage ?? formatMessage((0, $4F1Zj.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>loadingMessage ?? formatMessage((0, $4F1Zj.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const defaultPlaceholder = formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $4F1Zj.default).placeholderIssueTerminologyRefreshM4 : (0, $4F1Zj.default).placeholder); // #region Relay
    // suggestions fragment with pagination and refetch
    const data = (0, $j4oe4.useFragment)((0, $7BW6r.default), issueTypesFragmentRef); // manage issue types permission fragment
    const permissionsData = (0, $j4oe4.useFragment)((0, $lWzlU.default), projectFragmentRef ?? null); // Check if user has permission to manage issue types
    // If fragment wasn't spread by consumer, permissionsData will be null and we won't show the feature
    const canManageIssueTypes = permissionsData?.admin?.canPerform ?? false; // #endregion
    // #region Common state (might be handy for other components)
    const [searchByString, setSearchByString] = (0, $eJOHy.useState)(''); // #endregion
    // #region Debounced suspensless refetch helpers
    const [searchSuspenselessRefetch, isLoading, lastFetchError] = (0, $7XH79.useSuspenselessRefetch)(refetchQuery, onRefetch);
    const [searchDebouncedSuspenselessRefetch] = (0, $fwzaq.default)(searchSuspenselessRefetch, (0, $jbtzi.SEARCH_DEBOUNCE_TIMEOUT));
    (0, $eJOHy.useEffect)(()=>{
        if (hasAutoFocus) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        autoFocus,
        searchByString,
        onGetRefetchVariables,
        hasAutoFocus
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (stopPropagationOfMenuEscape && menuIsOpen && e.key === 'Escape') e.stopPropagation();
    }, [
        menuIsOpen,
        stopPropagationOfMenuEscape
    ]); // #region Common callbacks for the selector
    const openMenuOld = ()=>setMenuIsOpen(true);
    const openMenu = (0, $eJOHy.useCallback)(()=>{
        setIsEditing?.(true);
        setMenuIsOpen(true);
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'select clicked', 'issueTypeSelect', {
            numIssueTypes: data?.edges?.length ?? undefined
        });
    }, [
        setIsEditing,
        setMenuIsOpen,
        createAnalyticsEvent,
        data?.edges?.length
    ]);
    const closeMenuOld = ()=>setMenuIsOpen(false);
    const closeMenu = ()=>{
        setMenuIsOpen(false);
        if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'select closed', 'issueTypeSelect', {
            numIssueTypes: data?.edges?.length ?? undefined
        });
        setTimeout(()=>{
            setIsEditing?.(false);
            triggerRef.current?.focus();
        }, 0);
    };
    const onSelectFocus = (0, $eJOHy.useCallback)(()=>{
        searchSuspenselessRefetch(onGetRefetchVariables(searchByString));
    }, [
        searchSuspenselessRefetch,
        searchByString,
        onGetRefetchVariables
    ]);
    const onSearchByStringChangeFunction = (0, $eJOHy.useCallback)((newSearchByString)=>{
        setSearchByString(newSearchByString);
        searchDebouncedSuspenselessRefetch(onGetRefetchVariables(newSearchByString || ''));
    }, [
        onGetRefetchVariables,
        searchDebouncedSuspenselessRefetch
    ]);
    const onChange = (0, $eJOHy.useCallback)((newOption)=>{
        onChangeProp?.(newOption);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'select changed', 'issueTypeSelect', {
            numIssueTypes: data?.edges?.length ?? undefined
        });
    }, [
        createAnalyticsEvent,
        onChangeProp,
        data?.edges?.length
    ]); // #endregion
    // #region Transform options data from relay to AK Select
    const defaultFailedOption = (0, $eJOHy.useMemo)(()=>({
            label: formatMessage((0, $4F1Zj.default).failedFetch),
            value: '',
            avatar: {
                small: ''
            },
            issueTypeId: undefined,
            isDisabled: true
        }), [
        formatMessage
    ]);
    const renderIconOnlyOption = (option, formatOptionLabelMeta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: $657e3371d6260ec4$var$inlineIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.avatar?.small || '',
            alt: option.label,
            width: 16,
            height: 16
        })), formatOptionLabelMeta.context !== 'value' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, option.label));
    const renderIconWithTextOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$var$ImgSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.avatar?.small || '',
            alt: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? '' : option.label,
            width: 16,
            height: 16
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option.label));
    const selectFieldOptions = (0, $eJOHy.useMemo)(()=>{
        // checks for query errors
        if (lastFetchError != null) return [
            defaultFailedOption
        ];
        return data?.edges?.map((edge)=>edge?.node).filter(Boolean).map(({ label: optionLabel, value: optionValue, avatar: avatar, issueTypeId: issueTypeId })=>({
                label: optionLabel ?? '',
                value: optionValue,
                avatar: avatar,
                issueTypeId: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? issueTypeId ?? undefined : undefined
            })) ?? [];
    }, [
        lastFetchError,
        data,
        defaultFailedOption
    ]); // #endregion
    const { onIssueTypeUpdated: onIssueTypeUpdated, onIssueTypeCreated: onIssueTypeCreated } = (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $hUVzR.useManageIssueTypeCallbacks)({
        onRefetch: onRefetch,
        onGetRefetchVariables: onGetRefetchVariables,
        selectFieldOptions: selectFieldOptions,
        onChange: onChange
    }) : {
        onIssueTypeUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onIssueTypeCreated: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
    const selectedIssueTypeId = value?.issueTypeId;
    const shouldRenderFooter = manageIssueTypeProps && canManageIssueTypes && selectedIssueTypeId && lastFetchError == null;
    if (!renderAsPopupSelect || !(0, $4cTDP.fg)('jifjam2_icc_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $4F1Zj.default).labelIssueTerminologyRefreshM4 : (0, $4F1Zj.default).label),
        formatOptionLabel: iconsOnly ? renderIconOnlyOption : renderIconWithTextOption,
        styles: iconsOnly ? $657e3371d6260ec4$var$iconOnlySelectStyles : (0, $aUMMA.defaultSelectStyles),
        value: value,
        options: selectFieldOptions,
        menuIsOpen: menuIsOpen,
        placeholder: placeholder && (0, $4cTDP.fg)('jifjam_deliveroo_icc_changes') ? placeholder : defaultPlaceholder,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $f1FvV.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onChange: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? onChange : onChangeProp,
        openMenuOnFocus: openMenuOnFocus,
        onFocus: onSelectFocus,
        onKeyDown: onKeyDown,
        autoFocus: autoFocus,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        menuPosition: menuPosition,
        menuPlacement: menuPlacement,
        onMenuOpen: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? openMenu : openMenuOld,
        onMenuClose: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? closeMenu : closeMenuOld,
        spacing: spacing,
        appearance: appearance,
        isSearchable: isSearchable
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sl8jM.default), {
        formatOptionLabel: renderIconWithTextOption,
        styles: (0, $aUMMA.defaultSelectStyles),
        value: value,
        options: selectFieldOptions,
        isOpen: isManageIssueTypesModalOpen ? false : undefined,
        noOptionsMessage: getNoOptionsMessage,
        loadingMessage: getLoadingMessage,
        filterOption: (0, $f1FvV.filterOptionByLabelAndFilterValues),
        onInputChange: onSearchByStringChangeFunction,
        onFocus: onSelectFocus,
        onChange: (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? onChange : onChangeProp,
        onKeyDown: onKeyDown,
        isDisabled: isDisabled,
        isLoading: isLoading && menuIsOpen,
        inputId: inputId,
        onMenuOpen: openMenu,
        onMenuClose: closeMenu,
        spacing: spacing,
        appearance: appearance,
        target: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvadq.Trigger), {
                ...triggerProps,
                value: value,
                triggerRef: (0, $bzbsd.mergeRefs)(ref, triggerRef),
                isOpen: menuIsOpen,
                isDisabled: isDisabled
            }),
        footer: shouldRenderFooter && (0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NHkq.MenuFooter), {
            ...manageIssueTypeProps,
            selectedIssueTypeId: selectedIssueTypeId,
            onIssueTypeUpdated: onIssueTypeUpdated,
            onIssueTypeCreated: onIssueTypeCreated,
            options: selectFieldOptions,
            menuIsOpen: menuIsOpen,
            isSimplifiedProject: permissionsData?.projectStyle === (0, $FhXEJ.TEAM_MANAGED_PROJECT),
            projectType: permissionsData?.projectType
        }) : undefined,
        popperProps: {
            strategy: menuPosition,
            modifiers: [
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        shouldCloseMenuOnTab: !shouldRenderFooter,
        closeMenuOnSelect: true,
        isSearchable: false
    });
};
const $657e3371d6260ec4$export$83fe9ca9fdf41761 = (props)=>{
    const suggestionsData = (0, $j4oe4.useLazyLoadQuery)((0, $3ATPW.default), {
        id: props.fieldId,
        filterById: props.filterOptionsById
    }, {
        fetchPolicy: 'store-only'
    });
    if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraPlatformIssueTypeEditView",
        id: "jira-platform-issue-type-edit-view",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bskNA.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($657e3371d6260ec4$export$6a277fd8285f68cf, {
        ...props,
        queryFragmentRef: suggestionsData
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $657e3371d6260ec4$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $657e3371d6260ec4$var$ImgSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $657e3371d6260ec4$var$inlineIconStyle = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("3ATPW", function(module, exports) {
$parcel$export(module.exports, "default", () => $c35b5261ea602541$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<876729a26dd060ef7a5c5e9b31808218>>
 * @relayHash 211a69c30b4f214a1cccdbd7dfc2fd9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54c1a073e9dd218421f63fef52aaa2d1b8e7e0c8707d4d24c135590a7068c68b

var $g8m5l = parcelRequire("g8m5l");
const $c35b5261ea602541$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "Literal",
        "name": "searchBy",
        "value": ""
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueType_issueTypeSearchQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "54c1a073e9dd218421f63fef52aaa2d1b8e7e0c8707d4d24c135590a7068c68b",
            "metadata": {},
            "name": "issueType_issueTypeSearchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$c35b5261ea602541$var$node.hash = "a9ae551cfa917838f44cb5ad82166383";
var $c35b5261ea602541$export$2e2bcd8739ae039 = $c35b5261ea602541$var$node;

});

parcelRegister("lWzlU", function(module, exports) {
$parcel$export(module.exports, "default", () => $636720dd3ff91fd7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2907a1d7a90ffd607149a9434adaf261>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $636720dd3ff91fd7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef",
    "selections": [
        {
            "alias": "admin",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$636720dd3ff91fd7$var$node.hash = "a379aab42f3391944eef1fd31015b8b1";
var $636720dd3ff91fd7$export$2e2bcd8739ae039 = $636720dd3ff91fd7$var$node;

});

parcelRegister("7BW6r", function(module, exports) {
$parcel$export(module.exports, "default", () => $6409f3ef4c1bc03b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d527ee74c6495d3b078a74f10a7750cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6409f3ef4c1bc03b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef",
    "selections": [
        {
            "concreteType": "JiraIssueTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueTypeConnection"
};
$6409f3ef4c1bc03b$var$node.hash = "39660377c07394b192f504658c1422f2";
var $6409f3ef4c1bc03b$export$2e2bcd8739ae039 = $6409f3ef4c1bc03b$var$node;

});

parcelRegister("5xS2c", function(module, exports) {
$parcel$export(module.exports, "default", () => $2088ea6e2d1ccbc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92d1e3360b2d69683e70b781460fce34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $QH4SF = parcelRequire("QH4SF");
const $2088ea6e2d1ccbc5$var$node = function() {
    var v0 = [
        "node",
        "issueTypes"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterById"
            },
            {
                "defaultValue": 1000,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $QH4SF.default)
            }
        },
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "id"
                    }
                ],
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": "issueTypes",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterById",
                                        "variableName": "filterById"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchBy",
                                        "variableName": "searchBy"
                                    }
                                ],
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "__issueType_issueFieldIssueTypeEditviewFull_issueTypes_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$2088ea6e2d1ccbc5$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $2088ea6e2d1ccbc5$export$2e2bcd8739ae039 = $2088ea6e2d1ccbc5$var$node;

});
parcelRegister("QH4SF", function(module, exports) {
$parcel$export(module.exports, "default", () => $979de82bb5a16211$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9612834897878e6e0e746b411ed2976f>>
 * @relayHash 591e5a64cd39c5711484ae5bf44555f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31597ee9b844f996baf7db704f197520752c0c643e5453dfab9e40d9fb175bd6

var $g8m5l = parcelRequire("g8m5l");
const $979de82bb5a16211$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v2 = {
        "defaultValue": 1000,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v5 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v6 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v7 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v8 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v9 = {
        "kind": "Variable",
        "name": "searchBy",
        "variableName": "searchBy"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v9 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueType_SearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "alias": "value",
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        },
                                                        {
                                                            "alias": "label",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                                    "kind": "LinkedHandle",
                                    "name": "issueTypes"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "31597ee9b844f996baf7db704f197520752c0c643e5453dfab9e40d9fb175bd6",
            "metadata": {},
            "name": "issueType_SearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": (0, $g8m5l.default)
            }
        }
    };
}();
$979de82bb5a16211$var$node.hash = "54c04d4f507b644a10ef1cc8b3c0fc09";
var $979de82bb5a16211$export$2e2bcd8739ae039 = $979de82bb5a16211$var$node;

});


parcelRegister("7XH79", function(module, exports) {
$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $a5387c0f4da0e3f5$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $a5387c0f4da0e3f5$export$c7ce5f64dc007896);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4im1M = parcelRequire("4im1M");
const $a5387c0f4da0e3f5$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eJOHy.useRef)([]);
    return (0, $eJOHy.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $a5387c0f4da0e3f5$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const isMounted = (0, $4im1M.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $a5387c0f4da0e3f5$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const [_, startTransition] = (0, $eJOHy.useTransition)();
    return (0, $eJOHy.useCallback)((variables, options)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $a5387c0f4da0e3f5$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eJOHy.useState)(null);
    const refetchFunction = $a5387c0f4da0e3f5$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("4im1M", function(module, exports) {
$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("jbtzi", function(module, exports) {
$parcel$export(module.exports, "FRAGMENT_FIELD_OPTIONS_FIRST", () => $d156ca0cd64e2913$export$971747fe11f2a6f4);
$parcel$export(module.exports, "FRAGMENT_SELECTABLE_FIELD_OPTIONS_FIRST", () => $d156ca0cd64e2913$export$1a6463c5895cff9e);
$parcel$export(module.exports, "SELECTABLE_FIELD_PAGE_OPTIONS", () => $d156ca0cd64e2913$export$d1beabd8dceb4469);
$parcel$export(module.exports, "MULTI_VERSIONS_FIELD_OPTIONS_FETCH_FIRST", () => $d156ca0cd64e2913$export$176e9e0c749f88b2);
$parcel$export(module.exports, "SEARCH_DEBOUNCE_TIMEOUT", () => $d156ca0cd64e2913$export$228cc37ca8dce73);
$parcel$export(module.exports, "versionStatus", () => $d156ca0cd64e2913$export$7fc41a408a0533d3);
/**
 * This will be used to set the default value for the number of options
 * to be fetched in the first request for the field options.
 */ const $d156ca0cd64e2913$export$971747fe11f2a6f4 = 100;
const $d156ca0cd64e2913$export$1a6463c5895cff9e = 55;
const $d156ca0cd64e2913$export$d1beabd8dceb4469 = 50;
const $d156ca0cd64e2913$export$176e9e0c749f88b2 = 1000;
const $d156ca0cd64e2913$export$228cc37ca8dce73 = 300;
const $d156ca0cd64e2913$export$b983f2cb1f658a55 = 'RELEASED';
const $d156ca0cd64e2913$export$cb459d726a8530a5 = 'UNRELEASED';
const $d156ca0cd64e2913$export$c936349447a77fe0 = 'ARCHIVED';
const $d156ca0cd64e2913$export$7fc41a408a0533d3 = {
    RELEASED: $d156ca0cd64e2913$export$b983f2cb1f658a55,
    UNRELEASED: $d156ca0cd64e2913$export$cb459d726a8530a5,
    ARCHIVED: $d156ca0cd64e2913$export$c936349447a77fe0
};

});

parcelRegister("f1FvV", function(module, exports) {
$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0b19d4706e6a94cf$export$58bb91b619b113f6);

var $LFmXM = parcelRequire("LFmXM");

var $1beam = parcelRequire("1beam");
const $0b19d4706e6a94cf$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal = (0, $LFmXM.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1beam.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues
    }));
const $0b19d4706e6a94cf$export$58bb91b619b113f6 = (option, inputValue)=>$0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("4F1Zj", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc03aeeb2a58dadd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $dc03aeeb2a58dadd$var$messages = (0, $7qGN1.defineMessages)({
    empty: {
        "id": "issue-field-issue-type-editview-full.issue-type.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-issue-type-editview-full.issue-type.failed-fetch",
        "defaultMessage": "Search failed."
    },
    loading: {
        "id": "issue-field-issue-type-editview-full.issue-type.loading",
        "defaultMessage": "Searching..."
    },
    placeholder: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder",
        "defaultMessage": "Select Issue Type"
    },
    label: {
        "id": "issue-field-issue-type-editview-full.issue-type.label",
        "defaultMessage": "Issue Type"
    },
    placeholderIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.placeholder-issue-terminology-refresh-m4",
        "defaultMessage": "Select work type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-field-issue-type-editview-full.issue-type.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work Type"
    }
});
var $dc03aeeb2a58dadd$export$2e2bcd8739ae039 = $dc03aeeb2a58dadd$var$messages;

});

parcelRegister("3NHkq", function(module, exports) {
$parcel$export(module.exports, "MenuFooter", () => $37a129e7c79bccb3$export$d6f87b6f250ab93e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

var $lRq8t = parcelRequire("lRq8t");

var $83DiZ = parcelRequire("83DiZ");

var $jMRoT = parcelRequire("jMRoT");

var $asoyU = parcelRequire("asoyU");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $llT4J = parcelRequire("llT4J");

var $cHtIB = parcelRequire("cHtIB");

var $eCVV2 = parcelRequire("eCVV2");


var $fGRYk = parcelRequire("fGRYk");

var $aaGSX = parcelRequire("aaGSX");

var $8HM6I = parcelRequire("8HM6I");
const $37a129e7c79bccb3$var$getIssueTypeEditExperience = (source)=>{
    return new (0, $f39LL.UFOExperience)(`${source ?? (0, $a9cbb8c64aa7f847$export$8f4fd516b77f8d43)}.edit-issue-type`, {
        type: (0, $2lxLk.ExperienceTypes).Operation,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
    });
};
const $37a129e7c79bccb3$export$a51de57a74d54dd1 = (options)=>{
    return options.filter((option)=>'issueTypeId' in option && typeof option.issueTypeId === 'string').map((option)=>option.issueTypeId);
};
const $37a129e7c79bccb3$export$d6f87b6f250ab93e = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { projectKey: projectKey, projectType: projectType, projectId: projectId, selectedIssueTypeId: selectedIssueTypeId, allowIssueTypeCreation: allowIssueTypeCreation = true, onIssueTypeUpdated: onIssueTypeUpdated, onIssueTypeCreated: onIssueTypeCreated, source: source, setIsManageIssueTypesModalOpen: setIsManageIssueTypesModalOpen, options: options, menuIsOpen: menuIsOpen, isSimplifiedProject: isSimplifiedProject } = props;
    const projectSettingsUrl = (0, $jMRoT.getProjectSettingsIssueTypesUrl)({
        projectKey: projectKey,
        projectType: projectType ?? '',
        isSimplifiedProject: isSimplifiedProject
    });
    const handleManageIssueTypesClick = (0, $eJOHy.useCallback)(()=>{
        push(projectSettingsUrl);
    }, [
        push,
        projectSettingsUrl
    ]);
    const handleAddIssueTypeClick = (0, $eJOHy.useCallback)(()=>{
        setIsManageIssueTypesModalOpen?.(true); // TODO:  Add analytics
    }, [
        setIsManageIssueTypesModalOpen
    ]);
    const handleEditIssueTypeClick = (0, $eJOHy.useCallback)(()=>{
        setIsManageIssueTypesModalOpen?.(true); // TODO:  Add analytics
    }, [
        setIsManageIssueTypesModalOpen
    ]);
    const ufoExperience = $37a129e7c79bccb3$var$getIssueTypeEditExperience(source);
    const createEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            projectId: Number(projectId),
            projectKey: projectKey,
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onOpen: handleAddIssueTypeClick,
            onOpenManageTypes: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            issueTypeId: selectedIssueTypeId,
            ufoExperience: ufoExperience,
            onIssueTypeCreated: onIssueTypeCreated ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            source: source ?? (0, $a9cbb8c64aa7f847$export$8f4fd516b77f8d43),
            showNewIssueTypeForm: true,
            isProjectAdmin: true,
            isWrappedInModal: true
        }), [
        projectId,
        projectKey,
        handleAddIssueTypeClick,
        selectedIssueTypeId,
        ufoExperience,
        onIssueTypeCreated,
        source
    ]);
    const editEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            projectId: Number(projectId),
            projectKey: projectKey,
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onOpen: handleEditIssueTypeClick,
            issueTypeId: selectedIssueTypeId,
            ufoExperience: ufoExperience,
            onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeUpdated ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            calledFrom: source ?? (0, $a9cbb8c64aa7f847$export$8f4fd516b77f8d43),
            shouldShowIssueTypeSelect: true,
            relevantIssueTypeIds: $37a129e7c79bccb3$export$a51de57a74d54dd1(options)
        }), [
        projectId,
        projectKey,
        handleEditIssueTypeClick,
        selectedIssueTypeId,
        ufoExperience,
        onIssueTypeUpdated,
        source,
        options
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            projectKey: projectKey,
            cloudId: cloudId
        }), [
        projectKey,
        cloudId
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            ...(0, $llT4J.defaultModalProps),
            onCloseComplete: ()=>{
                setIsManageIssueTypesModalOpen?.(false);
            }
        }), [
        setIsManageIssueTypesModalOpen
    ]);
    if (!menuIsOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, allowIssueTypeCreation && isSimplifiedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $fGRYk.asyncCreateIssueTypeModalEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: createEntryPointProps,
        modalProps: modalProps,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 1
            })
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            ref: ref
        }, formatMessage((0, $8HM6I.default).addIssueType))), isSimplifiedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $eCVV2.asyncEditIssueTypeModalEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: editEntryPointProps,
        modalProps: modalProps,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 1
            })
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            ref: ref
        }, formatMessage((0, $8HM6I.default).editIssueType))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: handleManageIssueTypesClick
    }, formatMessage((0, $8HM6I.default).manageIssueTypes)));
};

});
parcelRegister("jMRoT", function(module, exports) {
$parcel$export(module.exports, "getProjectSettingsIssueTypesUrl", () => $de0c8e134ff95356$export$e2e29d5bcfe97104);

var $4cTDP = parcelRequire("4cTDP");
const $de0c8e134ff95356$export$e2e29d5bcfe97104 = ({ projectKey: projectKey, projectType: projectType, isSimplifiedProject: isSimplifiedProject })=>{
    if ((0, $4cTDP.fg)('work_type_inline_config_nin_icc_fg')) return $de0c8e134ff95356$export$3f2a8a2b05ad3842({
        projectKey: projectKey,
        projectType: projectType,
        isSimplifiedProject: isSimplifiedProject
    });
    return $de0c8e134ff95356$export$10e2e08b7045ea91({
        projectKey: projectKey,
        projectType: projectType
    });
};
const $de0c8e134ff95356$export$10e2e08b7045ea91 = ({ projectKey: projectKey, projectType: projectType })=>{
    switch(projectType?.toLowerCase()){
        case 'customer_service':
        case 'service_desk':
            return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/issuetypes`;
        default:
            return `/jira/software/projects/${projectKey}/settings/issuetypes`;
    }
};
const $de0c8e134ff95356$export$3f2a8a2b05ad3842 = ({ projectKey: projectKey, projectType: projectType, isSimplifiedProject: isSimplifiedProject })=>{
    switch(projectType?.toLowerCase()){
        case 'customer_service':
        case 'service_desk':
            return `/plugins/servlet/project-config/${projectKey}/issuetypes`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/issuetypes`;
        case 'software':
            return $de0c8e134ff95356$var$getSoftwareProjectSettingsUrl({
                projectKey: projectKey,
                isSimplifiedProject: isSimplifiedProject
            });
        default:
            return `/jira/software/projects/${projectKey}/settings/issuetypes`;
    }
};
const $de0c8e134ff95356$var$getSoftwareProjectSettingsUrl = ({ projectKey: projectKey, isSimplifiedProject: isSimplifiedProject })=>isSimplifiedProject !== undefined && !isSimplifiedProject ? `/plugins/servlet/project-config/${projectKey}/issuetypes` : `/jira/software/projects/${projectKey}/settings/issuetypes`;

});

parcelRegister("llT4J", function(module, exports) {
$parcel$export(module.exports, "defaultModalProps", () => $38e5b01445975ac2$export$14c11acc66fd51b3);
const $38e5b01445975ac2$export$14c11acc66fd51b3 = {
    width: '395px'
};

});

parcelRegister("eCVV2", function(module, exports) {
$parcel$export(module.exports, "asyncEditIssueTypeModalEntrypoint", () => $09686e3af1a308a2$export$77154afa25455a57);

var $fdUv7 = parcelRequire("fdUv7");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $09686e3af1a308a2$export$77154afa25455a57 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8a7so")).then((module)=>module.AsyncEditIssueTypeModal), {
        moduleId: "22548b83",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>({
            queries: {
                editIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $fdUv7.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("fdUv7", function(module, exports) {
$parcel$export(module.exports, "default", () => $68bfd43b9dada7e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1192085c48690de29428a79c9d6d1b6>>
 * @relayHash e7bd81102c1dee96dbca11245e366952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696
const $68bfd43b9dada7e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v2 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.description"
                                                                            },
                                                                            v5 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraProjectByKey.issueTypes.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.issueTypes.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696",
            "metadata": {},
            "name": "srcAsyncEditIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$68bfd43b9dada7e5$var$node.hash = "95da41f0960685e3830143828659ecad";
var $68bfd43b9dada7e5$export$2e2bcd8739ae039 = $68bfd43b9dada7e5$var$node;

});

parcelRegister("8a7so", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("hvGrC")
]).then(()=>parcelRequire('d5kQ7'));

});


const $a9cbb8c64aa7f847$export$c766acff4513a976 = 'summaryView';
const $a9cbb8c64aa7f847$export$4edb790587638895 = 'listView';
const $a9cbb8c64aa7f847$export$cafb161c2b21b455 = 'issueView';
const $a9cbb8c64aa7f847$export$66397ed56abea4ca = 'gicView';
const $a9cbb8c64aa7f847$export$a1077f863a923e94 = 'gicViewNoResults';
const $a9cbb8c64aa7f847$export$7f04bd1df3763938 = 'jswBoard';
const $a9cbb8c64aa7f847$export$bd8f63529bb9357f = 'jswBacklog';
const $a9cbb8c64aa7f847$export$57eacdfdee901d4c = 'jswTimeline';
const $a9cbb8c64aa7f847$export$8f4fd516b77f8d43 = 'unknown';
const $a9cbb8c64aa7f847$export$334975a13cb19c35 = 'editIssueTypeButton';
const $a9cbb8c64aa7f847$export$e970abb363c8ec67 = 'deleteIssueTypeButton';

parcelRegister("fGRYk", function(module, exports) {
$parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", () => $017dfafefc3951e5$export$7f9428aac5b01dff);

var $TgM8I = parcelRequire("TgM8I");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $017dfafefc3951e5$export$7f9428aac5b01dff = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eRAye")), {
        moduleId: "0ca2b96c",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, shouldFetchProjectData: shouldFetchProjectData })=>({
            queries: {
                createIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $TgM8I.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        shouldFetchProjectData: shouldFetchProjectData
                    }
                }
            }
        })
});

});
parcelRegister("TgM8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $07adbcceea3befa7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36277921a8012e0702a65f1227cbbd1b>>
 * @relayHash 4a7b622560b3b3e20bb696680e8560ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76
const $07adbcceea3befa7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "shouldFetchProjectData"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_createIssueTypeFragmentRef"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        },
                                        {
                                            "condition": "shouldFetchProjectData",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_projectDataFragmentRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldFetchProjectData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "medium"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76",
            "metadata": {},
            "name": "srcAsyncCreateIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$07adbcceea3befa7$var$node.hash = "b50515a18d5488758aa762560868c40c";
var $07adbcceea3befa7$export$2e2bcd8739ae039 = $07adbcceea3befa7$var$node;

});

parcelRegister("eRAye", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("f5XY9")
]).then(()=>parcelRequire('bRzMj'));

});


parcelRegister("aaGSX", function(module, exports) {
$parcel$export(module.exports, "FormDialogSkeleton", () => $0b33aba420d5c901$export$3e5b4585c21ca29d);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");
const $0b33aba420d5c901$var$COMMON_SKELETON_PROPS = {
    borderRadius: "var(--ds-radius-large, 8px)",
    isShimmering: true
};
const $0b33aba420d5c901$export$3e5b4585c21ca29d = ({ numFormFields: numFormFields })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "40%",
        height: 24,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "35%",
        height: 16,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-subtitle"
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            space: "space.050",
            key: idx,
            xcss: $0b33aba420d5c901$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "30%",
            height: 16,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-label-${idx}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "100%",
            height: 40,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-input-${idx}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.cancel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.submit-button"
    }))));
const $0b33aba420d5c901$var$modalSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge',
    width: '394px',
    padding: 'space.300'
});
const $0b33aba420d5c901$var$headerSkeletonStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $0b33aba420d5c901$var$formFieldSkeletonStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});

parcelRegister("8HM6I", function(module, exports) {
$parcel$export(module.exports, "default", () => $df7c2167bd3906bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $df7c2167bd3906bd$var$messages = (0, $7qGN1.defineMessages)({
    addIssueType: {
        "id": "issue-field-issue-type-editview-full.issue-type.add-work-type",
        "defaultMessage": "Add work type"
    },
    editIssueType: {
        "id": "issue-field-issue-type-editview-full.issue-type.edit-work-type",
        "defaultMessage": "Edit work type"
    },
    manageIssueTypes: {
        "id": "issue-field-issue-type-editview-full.issue-type.manage-work-types",
        "defaultMessage": "Manage"
    }
});
var $df7c2167bd3906bd$export$2e2bcd8739ae039 = $df7c2167bd3906bd$var$messages;

});


parcelRegister("hUVzR", function(module, exports) {
$parcel$export(module.exports, "useManageIssueTypeCallbacks", () => $499f47d3098f6095$export$22b4f8796fd11f31);

var $eJOHy = parcelRequire("eJOHy");
const $499f47d3098f6095$var$PENDING_CREATED_ISSUE_TYPE_TIMEOUT_MS = 10000; // 10 seconds
function $499f47d3098f6095$export$22b4f8796fd11f31({ onRefetch: onRefetch, onGetRefetchVariables: onGetRefetchVariables, selectFieldOptions: selectFieldOptions, onChange: onChange }) {
    const [pendingCreatedIssueType, setPendingCreatedIssueType] = (0, $eJOHy.useState)(null);
    // Watch for created issue type to appear in options after refetch in order to select it
    (0, $eJOHy.useEffect)(()=>{
        if (!pendingCreatedIssueType) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        const foundOption = selectFieldOptions.find((option)=>option.issueTypeId === pendingCreatedIssueType.issueTypeId);
        if (foundOption) {
            onChange?.(foundOption);
            setPendingCreatedIssueType(null);
            return;
        }
        // Issue type not found yet - set timeout to clear pending state after 10 seconds
        // This handles the case where refetch fails or the issue type never appears
        const timeout = setTimeout(()=>{
            setPendingCreatedIssueType(null);
        }, $499f47d3098f6095$var$PENDING_CREATED_ISSUE_TYPE_TIMEOUT_MS);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        pendingCreatedIssueType,
        selectFieldOptions,
        onChange
    ]);
    const onIssueTypeUpdated = (0, $eJOHy.useCallback)((updatedIssueType)=>{
        onRefetch(onGetRefetchVariables(''), {
            fetchPolicy: 'network-only'
        });
        const issueTypeOptionToSelect = selectFieldOptions.find((option)=>option.issueTypeId === updatedIssueType?.issueTypeId);
        onChange?.(issueTypeOptionToSelect ?? null);
    }, [
        onRefetch,
        onGetRefetchVariables,
        selectFieldOptions,
        onChange
    ]);
    const onIssueTypeCreated = (0, $eJOHy.useCallback)((createdIssueType)=>{
        setPendingCreatedIssueType(createdIssueType);
        onRefetch(onGetRefetchVariables(''), {
            fetchPolicy: 'network-only'
        });
    }, [
        onGetRefetchVariables,
        onRefetch
    ]);
    return {
        onIssueTypeUpdated: onIssueTypeUpdated,
        onIssueTypeCreated: onIssueTypeCreated
    };
}

});

parcelRegister("lvadq", function(module, exports) {
$parcel$export(module.exports, "Trigger", () => $30cfd4265ea87fdf$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $5CSKW = parcelRequire("5CSKW");

var $1OQKp = parcelRequire("1OQKp");

var $1vA1E = parcelRequire("1vA1E");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kf5CR = parcelRequire("kf5CR");
const $30cfd4265ea87fdf$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
const $30cfd4265ea87fdf$export$41fb9f06171c75f4 = ({ isOpen: isOpen, triggerRef: triggerRef, value: value, ...triggerProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: value?.label ?? null,
        delay: 500,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        ...triggerProps,
        "aria-label": formatMessage((0, $kf5CR.default).label, {
            issueType: value?.label
        }),
        appearance: "subtle",
        isSelected: isOpen,
        ref: triggerRef,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: value?.avatar?.small || $30cfd4265ea87fdf$var$GENERIC_ICON_URL,
        alt: "",
        className: (0, $hcewu.default)([
            $30cfd4265ea87fdf$var$imgStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            $30cfd4265ea87fdf$var$wrapperStyles.root
        ])
    }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vA1E))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        size: "small"
    })))));
};
const $30cfd4265ea87fdf$var$imgStyles = {
    root: "_4t3i7vkz _1bsb7vkz _19pkv77o"
}; // Required for issue-table, as it adds an eventlistener that checks if the event target was part of the ICC form
// Therefore we need the event target to be the button so that it remains in the DOM
const $30cfd4265ea87fdf$var$wrapperStyles = {
    root: "_lcxvglyw"
};

});
parcelRegister("kf5CR", function(module, exports) {
$parcel$export(module.exports, "default", () => $fefb87dddd8a1010$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fefb87dddd8a1010$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-field-issue-type-editview-full.issue-type.label",
        "defaultMessage": "Select work type. {issueType} currently selected."
    }
});

});



parcelRegister("aB2Z6", function(module, exports) {
$parcel$export(module.exports, "useDefaultIssueType", () => $eafa7e0acaad2c22$export$9c7f64b201a937e7);

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");

var $1W85r = parcelRequire("1W85r");
const $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig = {
    defaultIssueType: null
};
const $eafa7e0acaad2c22$var$selectProjectConfig = (0, $4MchI.createSelector)((_, projectKey)=>projectKey, ({ projectConfigs: projectConfigs })=>projectConfigs, (projectKey, projectConfigs)=>{
    if (projectKey == null) return $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig;
    const config = projectConfigs[projectKey];
    if (config == null) return $eafa7e0acaad2c22$var$defaultProjectConfigProjectConfig;
    return config;
});
const $eafa7e0acaad2c22$var$selectIssueType = (0, $4MchI.createSelector)($eafa7e0acaad2c22$var$selectProjectConfig, (config)=>config.defaultIssueType);
const $eafa7e0acaad2c22$export$9c7f64b201a937e7 = (0, $iJq0l.createHook)((0, $1W85r.IICConfigStore), {
    selector: $eafa7e0acaad2c22$var$selectIssueType
});

});
parcelRegister("1W85r", function(module, exports) {
$parcel$export(module.exports, "IICConfigStore", () => $0b13d55531392d29$export$9bd138189628b8f1);
$parcel$export(module.exports, "useIICConfigActions", () => $0b13d55531392d29$export$d86349fef3b2869d);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $0b13d55531392d29$var$initialState = {
    projectConfigs: {}
};
const $0b13d55531392d29$var$actions = {
    setDefaultIssueType: (projectKey, issueType)=>({ setState: setState, getState: getState })=>{
            if (projectKey == null) return;
            const currentState = getState();
            let projectConfig = currentState.projectConfigs[projectKey];
            if (projectConfig == null) projectConfig = {
                defaultIssueType: null
            };
            projectConfig.defaultIssueType = issueType;
            setState({
                ...currentState,
                projectConfigs: {
                    ...currentState.projectConfigs,
                    [projectKey]: projectConfig
                }
            });
        }
};
const $0b13d55531392d29$export$9bd138189628b8f1 = (0, $GtRbT.createStore)({
    initialState: $0b13d55531392d29$var$initialState,
    actions: $0b13d55531392d29$var$actions
});
const $0b13d55531392d29$export$8b216441e8d7a953 = (0, $iJq0l.createHook)($0b13d55531392d29$export$9bd138189628b8f1);
const $0b13d55531392d29$export$d86349fef3b2869d = (0, $iJq0l.createActionsHook)($0b13d55531392d29$export$9bd138189628b8f1);

});


parcelRegister("l4kLF", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb1df118e16999d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cb1df118e16999d7$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label",
        "defaultMessage": "Issue type"
    },
    labelIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label-issue-terminology-refresh-m4",
        "defaultMessage": "Work type"
    }
});
var $cb1df118e16999d7$export$2e2bcd8739ae039 = $cb1df118e16999d7$var$messages;

});


parcelRegister("eNuUB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c7dd3f69b21f2c1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3c7dd3f69b21f2c1$var$messages = (0, $7qGN1.defineMessages)({
    createButton: {
        "id": "issue-table-inline-issue-create.inline-create-from.create-button",
        "defaultMessage": "Create"
    },
    placeholderText: {
        "id": "issue-table-inline-issue-create.inline-create-from.placeholder-text",
        "defaultMessage": "What needs to be done?"
    }
});
var $3c7dd3f69b21f2c1$export$2e2bcd8739ae039 = $3c7dd3f69b21f2c1$var$messages;

});

parcelRegister("ab4Fp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f79f07048da8f6ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f79f07048da8f6ae$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #00000029)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $f79f07048da8f6ae$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f79f07048da8f6ae$var$ReturnGlyph, null);
var $f79f07048da8f6ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f79f07048da8f6ae$var$ReturnIcon);

});


parcelRegister("1Ob2L", function(module, exports) {
$parcel$export(module.exports, "useInlineIssueCreateEntryPoint", () => $a59bff9a3ee71001$export$885248fb7870aaf0);
$parcel$export(module.exports, "useInlineIssueCreateAdditionalFieldsEntryPoint", () => $a59bff9a3ee71001$export$345c7d6ef1e7c79c);

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $bYsdT = parcelRequire("bYsdT");

var $63ryK = parcelRequire("63ryK");
const $a59bff9a3ee71001$export$885248fb7870aaf0 = (projectKey, minHierarchyLevel, maxHierarchyLevel)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $iWvkh.useEntryPoint)((0, $63ryK.default), {
        cloudId: cloudId,
        projectKey: projectKey,
        minHierarchyLevel: minHierarchyLevel ?? undefined,
        maxHierarchyLevel: maxHierarchyLevel ?? undefined
    });
};
const $a59bff9a3ee71001$export$345c7d6ef1e7c79c = ({ projectKey: projectKey, defaultAssigneeId: defaultAssigneeId })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $iWvkh.useEntryPoint)((0, $bYsdT.InlineCreateAdditionalFieldsEntrypoint), {
        cloudId: cloudId,
        projectKey: projectKey,
        defaultAssigneeId: defaultAssigneeId
    });
};

});
parcelRegister("bYsdT", function(module, exports) {
$parcel$export(module.exports, "InlineCreateAdditionalFieldsEntrypoint", () => $4dcf8b0cdfa91d90$export$19884e0312fcb420);

var $gY3Fs = parcelRequire("gY3Fs");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4dcf8b0cdfa91d90$export$19884e0312fcb420 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cW3ke")), {
        moduleId: "be327326",
        moduleName: "InlineCreateAdditionalFieldsEntrypoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, defaultAssigneeId: defaultAssigneeId })=>({
            queries: {
                rootData: {
                    parameters: $gY3Fs.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        defaultAssigneeId: defaultAssigneeId ?? '',
                        hasDefaultAssignee: !!defaultAssigneeId
                    }
                }
            }
        })
});

});
parcelRegister("gY3Fs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1a4247321fd47be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<083791ee8fe8ac629678816f5ad84129>>
 * @relayHash 18a79873a0d8adb8b564459d1e3933ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef
const $a1a4247321fd47be$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e912661cb90a2ca17e80283a3722471456baf4b4679e680954281ed13e4261ef",
        "metadata": {},
        "name": "InlineCreateAdditionalFieldsEntrypointQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a1a4247321fd47be$export$2e2bcd8739ae039 = $a1a4247321fd47be$var$node;

});

parcelRegister("cW3ke", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("jfnqE")
]).then(()=>parcelRequire('bwXPC'));

});


parcelRegister("63ryK", function(module, exports) {
$parcel$export(module.exports, "default", () => $00eae25319f329e7$export$2e2bcd8739ae039);

var $gaDzZ = parcelRequire("gaDzZ");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $00eae25319f329e7$var$IssueTypeDropdownEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("ljpuj"))).then((module)=>module.IssueTypeDropdownEntryPoint), {
        moduleId: "4b489ed2",
        moduleName: "IssueTypeDropdown",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey, minHierarchyLevel: minHierarchyLevel, maxHierarchyLevel: maxHierarchyLevel })=>({
            queries: {
                projectData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $gaDzZ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? '',
                        hasProjectKey: !!projectKey,
                        ...minHierarchyLevel != null ? {
                            filter: {
                                minHierarchyLevel: minHierarchyLevel,
                                maxHierarchyLevel: maxHierarchyLevel
                            }
                        } : {}
                    }
                }
            }
        })
});
var $00eae25319f329e7$export$2e2bcd8739ae039 = $00eae25319f329e7$var$IssueTypeDropdownEntryPoint;

});


parcelRegister("1cMAs", function(module, exports) {
$parcel$export(module.exports, "default", () => $979fa4e593532476$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $biF5G = parcelRequire("biF5G");

var $5CSKW = parcelRequire("5CSKW");

var $dcLzM = parcelRequire("dcLzM");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");


var $iTHfM = parcelRequire("iTHfM");

var $dCQmT = parcelRequire("dCQmT");
const $979fa4e593532476$var$InlineCreateTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isFormRendered: isFormRendered }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const [isStoplightVisible, setIsSpotlightVisible] = (0, $eJOHy.useState)(false);
    const { shouldShowYbrMessage: shouldShowYbrMessage } = (0, $biF5G.useYbrFeature)();
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, (0, $23b4218cfd94fe9f$export$c7e6a6b283196232), false, orgId), [
        cloudId,
        orgId
    ]);
    const startTour = (0, $eJOHy.useCallback)(async ()=>{
        const started = await coordinationClient?.start((0, $23b4218cfd94fe9f$export$e77c67bc8157f49));
        if (started) setIsSpotlightVisible(true);
    }, [
        coordinationClient
    ]);
    const endTour = (0, $eJOHy.useCallback)(()=>{
        setIsSpotlightVisible(false);
        coordinationClient?.stop?.((0, $23b4218cfd94fe9f$export$e77c67bc8157f49));
    }, [
        coordinationClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startTour();
    }, [
        startTour
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClickCallback = (0, $eJOHy.useCallback)(()=>{
        onClick?.();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'inlineIssueCreateButton');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "inline-create-trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default // autofocus enabled when the form is rendered to focus back into the `create` button
    ), {
        ...(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? {
            autoFocus: isFormRendered
        } : {},
        appearance: "subtle",
        onClick: onClickCallback,
        ref: ref,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))),
        testId: "issue-table-inline-issue-create.ui.inline-create-trigger.button"
    }, formatMessage((0, $iTHfM.default).createLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dCQmT.default), {
        showOnboarding: shouldShowYbrMessage({
            shouldDisplayMessage: isStoplightVisible
        }),
        onDismiss: endTour
    }));
});
var $979fa4e593532476$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($979fa4e593532476$var$InlineCreateTrigger);

});
parcelRegister("biF5G", function(module, exports) {
$parcel$export(module.exports, "useYbrFeature", () => $3964affdc2e6018d$export$f3013a905e8f3491);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $ea0Pc = parcelRequire("ea0Pc");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $58aKG = parcelRequire("58aKG");

var $4cTDP = parcelRequire("4cTDP");

var $fZP7i = parcelRequire("fZP7i");
const $3964affdc2e6018d$export$f3013a905e8f3491 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const { fetchTraits: fetchTraits } = (0, $ea0Pc.useTraitsActions)();
    (0, $eJOHy.useEffect)(()=>{
        // For productioniosation, we will target all users and not just new users so no need to fetch site_user trait to detect new users
        if (cloudId && accountId && !(0, $4cTDP.fg)('productionise_ybr_cleanup_non_xflow_messages')) fetchTraits([
            (0, $58aKG.SITE_USER)
        ], {
            cloudId: cloudId,
            accountId: accountId
        });
    }, [
        cloudId,
        accountId,
        fetchTraits
    ]);
    // For productioniosation, we will target all users and not just new users
    const [isTargetedUser] = (0, $4cTDP.fg)('productionise_ybr_cleanup_non_xflow_messages') ? [
        true
    ] : (0, $fZP7i.useIsJiraNewUserTraitSelector)();
    const shouldShowYbrMessage = (0, $eJOHy.useCallback)(({ shouldDisplayMessage: shouldDisplayMessage })=>{
        // Prevent SSR for showing the message first, and then hide it due to the experiment cohort
        if (false) return false;
        // If the user is not a targeted user or the message is not enabled, we should return the original condition of the message
        if (!shouldDisplayMessage || !isTargetedUser) return shouldDisplayMessage;
        (0, $cxKOj.expVal)('jira_ybr_first_batch_aa', 'isYBREnabled', false);
        (0, $cxKOj.expVal)('jira_ybr_first_batch_both_aa', 'isYBREnabled', false);
        // we should not show the message if the experiment is enabled
        return !(0, $cxKOj.expVal)('jira_ybr_first_batch', 'isYBREnabled', false);
    }, [
        isTargetedUser
    ]);
    const shouldShowYbrMessageForIssueView = (0, $eJOHy.useCallback)(({ shouldDisplayMessage: shouldDisplayMessage })=>{
        // Prevent SSR for showing the message first, and then hide it due to the experiment cohort
        if (false) return false;
        // If the user is not a targeted user or the message is not enabled, we should return the original condition of the message
        if (!shouldDisplayMessage || !isTargetedUser) return shouldDisplayMessage;
        (0, $cxKOj.expVal)('jira_ybr_first_batch_issue_view_aa', 'isYBREnabled', false);
        (0, $cxKOj.expVal)('jira_ybr_first_batch_both_aa', 'isYBREnabled', false);
        // we should not show the message if the experiment is enabled
        return !(0, $cxKOj.expVal)('jira_ybr_first_batch', 'isYBREnabled', false);
    }, [
        isTargetedUser
    ]);
    return {
        shouldShowYbrMessage: shouldShowYbrMessage,
        shouldShowYbrMessageForIssueView: shouldShowYbrMessageForIssueView
    };
};

});
parcelRegister("fZP7i", function(module, exports) {
$parcel$export(module.exports, "useIsJiraNewUserTraitSelector", () => $28517ba1f217338c$export$2dd2d5a960dc1ee6);

var $ibLUB = parcelRequire("ibLUB");

var $ea0Pc = parcelRequire("ea0Pc");

var $cxKOj = parcelRequire("cxKOj");

var $9pTd3 = parcelRequire("9pTd3");
const $28517ba1f217338c$export$2dd2d5a960dc1ee6 = ()=>(0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitValue: getTraitValue })=>{
        try {
            const firstActiveDate = getTraitValue('jira_first_active');
            if (!firstActiveDate || !(typeof firstActiveDate === 'string') || firstActiveDate.trim() === '') return false;
            return (0, $ibLUB.default)(new Date(firstActiveDate), // This is to get the target new user date from dynamic config jira-ybr-first-batch-new-users
            // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users
            // We confirm that this is a working way to get the value from the dynamic config
            // Other Jira teams are using this approach as well (filtered target app jira_web on dynamic config and confirmed)
            new Date((0, $cxKOj.expVal)('jira-ybr-first-batch-new-users', 'value', '2050-12-31T00:00:00Z')));
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'useIsJiraNewUserTraitSelector',
                    packageName: 'yellowBrickRoadUtils',
                    teamName: 'jira-werewolves'
                }
            });
            return false;
        }
    })();

});


parcelRegister("iTHfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $66695a78f0b2ab0e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $66695a78f0b2ab0e$var$messages = (0, $7qGN1.defineMessages)({
    createLabel: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});
var $66695a78f0b2ab0e$export$2e2bcd8739ae039 = $66695a78f0b2ab0e$var$messages;

});

parcelRegister("dCQmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $349f8bf77bb8cae2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d2s5v = parcelRequire("d2s5v");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $e625v = parcelRequire("e625v");
const $349f8bf77bb8cae2$var$InlineCreateOnboardingSpotlight = ({ showOnboarding: showOnboarding, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, showOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        actions: [
            {
                onClick: onDismiss,
                text: formatMessage((0, $e625v.default).onboardingDismiss)
            }
        ],
        heading: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingHeaderIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingHeader),
        target: "inline-create-trigger",
        key: "inline-create-trigger",
        messageType: "engagement",
        dialogPlacement: "top right",
        messageId: ((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingDescription).id,
        dialogWidth: 275
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $e625v.default).onboardingDescriptionIssueTerminologyRefreshM4 : (0, $e625v.default).onboardingDescription)));
};
var $349f8bf77bb8cae2$export$2e2bcd8739ae039 = $349f8bf77bb8cae2$var$InlineCreateOnboardingSpotlight;

});
parcelRegister("e625v", function(module, exports) {
$parcel$export(module.exports, "default", () => $5acc70d9685ac55c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5acc70d9685ac55c$var$messages = (0, $7qGN1.defineMessages)({
    onboardingDescription: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description",
        "defaultMessage": "Quickly create issues on this page by selecting + Create below"
    },
    onboardingHeader: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header",
        "defaultMessage": "Create issues in context"
    },
    onboardingDismiss: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-dismiss",
        "defaultMessage": "OK"
    },
    onboardingDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-description-issue-terminology-refresh-m4",
        "defaultMessage": "Quickly create work items on this page by selecting + Create below"
    },
    onboardingHeaderIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.inline-create-trigger.onboarding.onboarding-header-issue-terminology-refresh-m4",
        "defaultMessage": "Create work items in context"
    }
});
var $5acc70d9685ac55c$export$2e2bcd8739ae039 = $5acc70d9685ac55c$var$messages;

});




parcelRegister("64b9C", function(module, exports) {
$parcel$export(module.exports, "GetStartedListNudgeAsync", () => $18d4b0cafbd25f4b$export$668308feff224acf);
$parcel$export(module.exports, "GetStartedListNudge", () => $18d4b0cafbd25f4b$export$a25758cc5ad6c45a);

var $eJOHy = parcelRequire("eJOHy");

var $79KhM = parcelRequire("79KhM");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");


var $gxP9D = parcelRequire("gxP9D");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");


var $2Xsxh = parcelRequire("2Xsxh");

var $jqMdt = parcelRequire("jqMdt");
const $18d4b0cafbd25f4b$var$runtimeProps = {};
const $18d4b0cafbd25f4b$var$GetStartedListNudgeAsyncOld = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $jqMdt.getStartedListNudgeEntrypoint), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: getStartedListNudgeRef } = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$c6df9a2c7447e12d), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: getStartedListNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $44259bc988b99eaa$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: $18d4b0cafbd25f4b$var$runtimeProps
    }));
};
const $18d4b0cafbd25f4b$var$GetStartedListNudgeAsyncNew = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $jqMdt.getStartedListNudgeEntrypoint), {});
    const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
    const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
    const firstLoadRef = (0, $eJOHy.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $2b839a8453de5367$export$c6df9a2c7447e12d)) entryPointActions.load();
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    const { ref: getStartedListNudgeRef } = (0, $79KhM.useRegisterNudgeTarget)((0, $2b839a8453de5367$export$c6df9a2c7447e12d), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: getStartedListNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: (0, $44259bc988b99eaa$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: $18d4b0cafbd25f4b$var$runtimeProps
    }));
};
const $18d4b0cafbd25f4b$export$668308feff224acf = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('tailored_onboarding_m3_gate'), $18d4b0cafbd25f4b$var$GetStartedListNudgeAsyncNew, $18d4b0cafbd25f4b$var$GetStartedListNudgeAsyncOld);
const $18d4b0cafbd25f4b$export$a25758cc5ad6c45a = (0, $2Xsxh.withAsyncNudgeTarget)({
    entryPoint: (0, $jqMdt.getStartedListNudgeEntrypoint),
    entryPointParams: {},
    nudgeId: (0, $2b839a8453de5367$export$c6df9a2c7447e12d)
});

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $2b839a8453de5367$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$baf21119361ffad = 'planCreateMoreWorkItemsNudge';
const $2b839a8453de5367$export$7fac0b950c128b4b = 'planConnectRelatedWorkNudge';
const $2b839a8453de5367$export$9fac41c1d8941795 = 'planShareYourPlanWithTheWorldTeamNudge';
const $2b839a8453de5367$export$994f00a8ff485faf = 'planShareYourPlanWithTheWorldAddPeopleNudge';
const $2b839a8453de5367$export$fc1e19da8853ecdc = 'planBringInTheTeamNudge';
const $2b839a8453de5367$export$d0ece87d6f260877 = 'planConfirmScopeNudge';
const $2b839a8453de5367$export$cc93e7cb8dd884fe = 'planCheckYourSettingsNudge';
const $2b839a8453de5367$export$b579a6f09436e23e = 'asyncPlanOnboardingTourNudge';
const $2b839a8453de5367$export$c7f7837470493c6f = 'planAdjustDetailsFieldsMenuNudge';
const $2b839a8453de5367$export$8909317d0f73beab = 'planAdjustDetailsFieldCellsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("gxP9D", function(module, exports) {
$parcel$export(module.exports, "useJswOnboarding", () => $ef5cbf2537a08e24$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $ef5cbf2537a08e24$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $ef5cbf2537a08e24$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $ef5cbf2537a08e24$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $ef5cbf2537a08e24$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $ef5cbf2537a08e24$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $ef5cbf2537a08e24$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $ef5cbf2537a08e24$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $ef5cbf2537a08e24$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $ef5cbf2537a08e24$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $ef5cbf2537a08e24$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $ef5cbf2537a08e24$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $ef5cbf2537a08e24$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $ef5cbf2537a08e24$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $ef5cbf2537a08e24$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $ef5cbf2537a08e24$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $ef5cbf2537a08e24$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $ef5cbf2537a08e24$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $ef5cbf2537a08e24$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $ef5cbf2537a08e24$export$521909e3dc7ab811);
$parcel$export(module.exports, "useIsOpenedViaButton", () => $ef5cbf2537a08e24$export$2317d3c684b416ec);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("9ycBx")).QUICKSTART_UI_STATUS);

var $f4Iys = parcelRequire("f4Iys");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $9ycBx = parcelRequire("9ycBx");

var $4NsfZ = parcelRequire("4NsfZ");

var $1KmSm = parcelRequire("1KmSm");

var $6R6zv = parcelRequire("6R6zv");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");

const $ef5cbf2537a08e24$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $6R6zv.initialState,
    actions: $4NsfZ.actions
});
const $ef5cbf2537a08e24$export$1cbc60d8dd921852 = (0, $ht3nQ.createSubscriber)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$7d91c0af4772787a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$638bfcfce1254bb8 = (0, $6E16M.createContainer)($ef5cbf2537a08e24$export$390f32400eaf98c9, {});
const $ef5cbf2537a08e24$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $ef5cbf2537a08e24$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $ef5cbf2537a08e24$export$594f006fa6a1b2e5 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$ea14030920a5d8e6
});
const $ef5cbf2537a08e24$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $ef5cbf2537a08e24$export$c5e63e44ad178ae8 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$a943afa434e9487a
});
const $ef5cbf2537a08e24$export$2c3cd14fff9d6e43 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: null
});
const $ef5cbf2537a08e24$export$b0db7e46e369e1d9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$9d731f44f82af09f
});
const $ef5cbf2537a08e24$export$71de79653346a1ea = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $ef5cbf2537a08e24$export$61185a9266f1f57a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN || userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $ef5cbf2537a08e24$export$ef4747ba36826d6a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $ef5cbf2537a08e24$export$522993b46d9f8266 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $ef5cbf2537a08e24$export$aa4ba29241532382 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $ef5cbf2537a08e24$export$ed5c755b733bf2b1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $ef5cbf2537a08e24$export$35fe0366802512dd = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)];
        return visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $ef5cbf2537a08e24$export$a41ee0d3b6938099 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $ef5cbf2537a08e24$export$4ae7b465b076be9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $ef5cbf2537a08e24$export$bf6e646c0476acad = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $ef5cbf2537a08e24$export$6b706bff94798d11 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $ef5cbf2537a08e24$export$c98db656edc5b3e1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $ef5cbf2537a08e24$export$a823278ac9d1112b = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $f4Iys.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN)
});
const $ef5cbf2537a08e24$export$cb9e0e8fe4df8490 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $f4Iys.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $9ycBx.KANBAN_ONBOARDING_TASK)))
});
const $ef5cbf2537a08e24$export$521909e3dc7ab811 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $ef5cbf2537a08e24$export$f4a2be940259bf95 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $ef5cbf2537a08e24$export$6db1f59c8ab54061 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.quickstartButtonRef
});
const $ef5cbf2537a08e24$export$2317d3c684b416ec = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isOpenedViaButton
});
const $ef5cbf2537a08e24$export$a57f80e92714bb45 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.containerType
});

});
parcelRegister("9ycBx", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $9b4ef256583f1ea3$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $9b4ef256583f1ea3$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $9b4ef256583f1ea3$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $9b4ef256583f1ea3$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $9b4ef256583f1ea3$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $9b4ef256583f1ea3$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $9b4ef256583f1ea3$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $9b4ef256583f1ea3$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $9b4ef256583f1ea3$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $9b4ef256583f1ea3$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $9b4ef256583f1ea3$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $9b4ef256583f1ea3$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $9b4ef256583f1ea3$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $9b4ef256583f1ea3$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $9b4ef256583f1ea3$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $9b4ef256583f1ea3$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $9b4ef256583f1ea3$export$d97d31d934dbb194);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $9b4ef256583f1ea3$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $9b4ef256583f1ea3$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $9b4ef256583f1ea3$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $9b4ef256583f1ea3$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $9b4ef256583f1ea3$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "PLAN_CREATE_MORE_WORK_ITEMS_TASK", () => $9b4ef256583f1ea3$export$590dc845c98d57e5);
$parcel$export(module.exports, "PLAN_BRING_IN_THE_TEAM_TASK", () => $9b4ef256583f1ea3$export$833908c980d64374);
$parcel$export(module.exports, "PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK", () => $9b4ef256583f1ea3$export$30049c54ff5e06aa);
$parcel$export(module.exports, "PLAN_CONNECT_RELATED_WORK_TASK", () => $9b4ef256583f1ea3$export$ad20239966e8cce);
$parcel$export(module.exports, "PLAN_ADJUST_DETAILS_TASK", () => $9b4ef256583f1ea3$export$1800599ce91071b4);
$parcel$export(module.exports, "PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK", () => $9b4ef256583f1ea3$export$3ed330408d0583ad);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $9b4ef256583f1ea3$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $9b4ef256583f1ea3$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $9b4ef256583f1ea3$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $9b4ef256583f1ea3$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $9b4ef256583f1ea3$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $9b4ef256583f1ea3$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $9b4ef256583f1ea3$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $9b4ef256583f1ea3$export$3380e677209260fe);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $9b4ef256583f1ea3$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $9b4ef256583f1ea3$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $9b4ef256583f1ea3$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $9b4ef256583f1ea3$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $9b4ef256583f1ea3$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $9b4ef256583f1ea3$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $9b4ef256583f1ea3$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $9b4ef256583f1ea3$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $9b4ef256583f1ea3$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $9b4ef256583f1ea3$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $9b4ef256583f1ea3$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $9b4ef256583f1ea3$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $9b4ef256583f1ea3$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $9b4ef256583f1ea3$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $9b4ef256583f1ea3$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $9b4ef256583f1ea3$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $9b4ef256583f1ea3$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $9b4ef256583f1ea3$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $9b4ef256583f1ea3$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $9b4ef256583f1ea3$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $9b4ef256583f1ea3$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $9b4ef256583f1ea3$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $9b4ef256583f1ea3$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $9b4ef256583f1ea3$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $9b4ef256583f1ea3$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $9b4ef256583f1ea3$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $9b4ef256583f1ea3$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $9b4ef256583f1ea3$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $9b4ef256583f1ea3$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $9b4ef256583f1ea3$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $9b4ef256583f1ea3$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $9b4ef256583f1ea3$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $9b4ef256583f1ea3$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $9b4ef256583f1ea3$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $9b4ef256583f1ea3$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $9b4ef256583f1ea3$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $9b4ef256583f1ea3$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $9b4ef256583f1ea3$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $9b4ef256583f1ea3$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $9b4ef256583f1ea3$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $9b4ef256583f1ea3$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $9b4ef256583f1ea3$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $9b4ef256583f1ea3$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $9b4ef256583f1ea3$export$5980f41aa657f9c7);

var $2QZBX = parcelRequire("2QZBX");
const $9b4ef256583f1ea3$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completePlanTaskName = (taskId)=>`plan-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $9b4ef256583f1ea3$export$2b3151a089bc8780 = 'jlove-makkuro';
const $9b4ef256583f1ea3$export$6826d33e9a2c0119 = 320;
const $9b4ef256583f1ea3$export$b580da85daad7757 = 'root';
const $9b4ef256583f1ea3$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $9b4ef256583f1ea3$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $9b4ef256583f1ea3$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $9b4ef256583f1ea3$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $9b4ef256583f1ea3$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $9b4ef256583f1ea3$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $9b4ef256583f1ea3$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $9b4ef256583f1ea3$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $9b4ef256583f1ea3$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $9b4ef256583f1ea3$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $9b4ef256583f1ea3$export$63b0e55f9c6454ac = $9b4ef256583f1ea3$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $9b4ef256583f1ea3$export$d97d31d934dbb194 = $9b4ef256583f1ea3$var$completeJswTaskName('premium-reverse-trial-task');
const $9b4ef256583f1ea3$export$540b5c3c4b6ce459 = $9b4ef256583f1ea3$var$completeJswTaskName('advanced-roadmaps-task');
const $9b4ef256583f1ea3$export$6f71dff531ff592 = $9b4ef256583f1ea3$var$completeJswTaskName('change-control-task');
const $9b4ef256583f1ea3$export$83255ab79e45f34f = $9b4ef256583f1ea3$var$completeJswTaskName('automations-task');
const $9b4ef256583f1ea3$export$b57d172af9ad7647 = $9b4ef256583f1ea3$var$completeJswTaskName('site-administrations-task');
const $9b4ef256583f1ea3$export$ff4c933c1fe90b68 = $9b4ef256583f1ea3$var$completeJswTaskName('user-management-task');
const $9b4ef256583f1ea3$export$590dc845c98d57e5 = $9b4ef256583f1ea3$var$completePlanTaskName('create-work-items-task');
const $9b4ef256583f1ea3$export$833908c980d64374 = $9b4ef256583f1ea3$var$completePlanTaskName('bring-team-task');
const $9b4ef256583f1ea3$export$30049c54ff5e06aa = $9b4ef256583f1ea3$var$completePlanTaskName('confirm-scope-task');
const $9b4ef256583f1ea3$export$ad20239966e8cce = $9b4ef256583f1ea3$var$completePlanTaskName('connect-related-work-task');
const $9b4ef256583f1ea3$export$1800599ce91071b4 = $9b4ef256583f1ea3$var$completePlanTaskName('adjust-details-task');
const $9b4ef256583f1ea3$export$3ed330408d0583ad = $9b4ef256583f1ea3$var$completePlanTaskName('share-your-plan-task');
const $9b4ef256583f1ea3$export$501166b25f254aab = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-project-summary-task');
const $9b4ef256583f1ea3$export$94ad6507a703f4eb = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-sample-project-task');
const $9b4ef256583f1ea3$export$be1c522400a1bd7c = $9b4ef256583f1ea3$var$completeJwmTaskName('background-color-task');
const $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5 = $9b4ef256583f1ea3$var$completeJwmTaskName('calendar-task');
const $9b4ef256583f1ea3$export$f3b53199b07af2a1 = $9b4ef256583f1ea3$var$completeJwmTaskName('timeline-task');
const $9b4ef256583f1ea3$export$d37415ffddcf2142 = $9b4ef256583f1ea3$var$completeJwmTaskName('build-form-task');
const $9b4ef256583f1ea3$export$2ae00586da7cb606 = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-task');
const $9b4ef256583f1ea3$export$b86266e6594a97bb = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-sample-project-task');
const $9b4ef256583f1ea3$export$20bc3dc137ac1c38 = $9b4ef256583f1ea3$var$completeJwmTaskName('create-your-own-project-task');
const $9b4ef256583f1ea3$export$77071b77e2801b18 = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-project-task');
const $9b4ef256583f1ea3$export$9c89f946f05d884a = $9b4ef256583f1ea3$var$completeJwmTaskName('share-project-task');
const $9b4ef256583f1ea3$export$b52a7c936684cfc5 = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-import');
const $9b4ef256583f1ea3$export$b5555f24061f9fb = $9b4ef256583f1ea3$var$completeJwmTaskName('summary-and-reports-task');
const $9b4ef256583f1ea3$export$ff25449f34b8abf = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $9b4ef256583f1ea3$export$3380e677209260fe = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-key-differences');
const $9b4ef256583f1ea3$export$da23b72d32bfad9e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$4b064659282e0238 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $9b4ef256583f1ea3$export$3ab51851f6d823e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $9b4ef256583f1ea3$export$e4a1a37a9a1350ad = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $9b4ef256583f1ea3$export$b7f7da5e795f0327 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $9b4ef256583f1ea3$export$80a401c1aa47a377 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $9b4ef256583f1ea3$export$934ac7a251b26dc7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$4634f6395df3ebbe = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$768fb41107a1e8d7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $9b4ef256583f1ea3$export$d797a81bace17184 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $9b4ef256583f1ea3$export$746102c94db9df1f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$5f1efd797d65e349 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $9b4ef256583f1ea3$export$cccc812ccafbf11f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$64822db87abd8a47 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $9b4ef256583f1ea3$export$64f764d8be495c82 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $9b4ef256583f1ea3$export$24eae23dc1c68bbd = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $9b4ef256583f1ea3$export$50fa92eba6f82feb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $9b4ef256583f1ea3$export$4155d22fe3f14cd6 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$76813cbead887191 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$90aab2ff89daf770 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $9b4ef256583f1ea3$export$a2bc0cbad2e6e605 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$f90872a1280728bb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$bce644e96518cbd2 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$241aaebffac0a3e5 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $9b4ef256583f1ea3$export$79759e9e62fb9312 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $9b4ef256583f1ea3$export$992d1e0dce255d19 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $9b4ef256583f1ea3$export$d28c1b0e5b3e768 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $9b4ef256583f1ea3$export$ca714ee197bed4ec = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$faae55ceea4b6073 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $9b4ef256583f1ea3$export$200bc24cd120667e = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$a0d784a48b4e886c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$baf5bd09b4b33b8a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $9b4ef256583f1ea3$export$4702007eedbca8ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$aa9d2d635ea63898 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $9b4ef256583f1ea3$export$2ea449225c1f6cac = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $9b4ef256583f1ea3$export$deb8b557e735e26a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$d45754df44e4c309 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $9b4ef256583f1ea3$export$78b2913b550edbb = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$71243272608c58ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $9b4ef256583f1ea3$export$39a08f215c33bc39 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$d2377f6a6fa3b49c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$befa8f6533309779 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $9b4ef256583f1ea3$export$736b40db8701ba6c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$11eff6ae2f70b67b = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $9b4ef256583f1ea3$export$fb2d23e5315a67a9 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $9b4ef256583f1ea3$export$32e794bb49d60b6 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $9b4ef256583f1ea3$export$fed256238b27db06 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $9b4ef256583f1ea3$export$132eecb4d35a590d = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $9b4ef256583f1ea3$export$2579c51cadd45eca = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $9b4ef256583f1ea3$export$4b1a0cefa966ea0 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $9b4ef256583f1ea3$export$f6558daacc312a65 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $9b4ef256583f1ea3$export$925efa2e24e86b88 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $9b4ef256583f1ea3$export$40454d3e062dcd44 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $9b4ef256583f1ea3$export$99b0e09ff6f00490 = $9b4ef256583f1ea3$var$completeJsmTaskName('customize-your-request-types-task');
const $9b4ef256583f1ea3$export$2a82344eb273eeff = $9b4ef256583f1ea3$var$completeJsmTaskName('review-your-channels-task');
const $9b4ef256583f1ea3$export$1de5766b7e640d6b = $9b4ef256583f1ea3$var$completeJsmTaskName('invite-your-team-task');
const $9b4ef256583f1ea3$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $9b4ef256583f1ea3$export$c8ab6996f562d0db = (0, $2QZBX.toAccountId)('accountId');
const $9b4ef256583f1ea3$export$2b5f951ad8e70cfe = $9b4ef256583f1ea3$var$completeJswTaskName('kanban-onboarding-task');
const $9b4ef256583f1ea3$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $9b4ef256583f1ea3$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $9b4ef256583f1ea3$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $9b4ef256583f1ea3$export$38fbac7a5bf4aa33 = [
    $9b4ef256583f1ea3$export$2a82344eb273eeff,
    $9b4ef256583f1ea3$export$99b0e09ff6f00490,
    $9b4ef256583f1ea3$export$1de5766b7e640d6b
];
const $9b4ef256583f1ea3$export$7578902c7f420a3 = [
    $9b4ef256583f1ea3$export$63b0e55f9c6454ac,
    $9b4ef256583f1ea3$export$d97d31d934dbb194,
    $9b4ef256583f1ea3$export$540b5c3c4b6ce459,
    $9b4ef256583f1ea3$export$6f71dff531ff592,
    $9b4ef256583f1ea3$export$83255ab79e45f34f,
    $9b4ef256583f1ea3$export$b57d172af9ad7647,
    $9b4ef256583f1ea3$export$ff4c933c1fe90b68,
    $9b4ef256583f1ea3$export$77071b77e2801b18,
    $9b4ef256583f1ea3$export$94ad6507a703f4eb,
    $9b4ef256583f1ea3$export$501166b25f254aab,
    $9b4ef256583f1ea3$export$be1c522400a1bd7c,
    $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5,
    $9b4ef256583f1ea3$export$f3b53199b07af2a1,
    $9b4ef256583f1ea3$export$d37415ffddcf2142,
    $9b4ef256583f1ea3$export$2ae00586da7cb606,
    $9b4ef256583f1ea3$export$9c89f946f05d884a,
    $9b4ef256583f1ea3$export$20bc3dc137ac1c38,
    $9b4ef256583f1ea3$export$b52a7c936684cfc5,
    $9b4ef256583f1ea3$export$b5555f24061f9fb,
    $9b4ef256583f1ea3$export$ff25449f34b8abf,
    $9b4ef256583f1ea3$export$3380e677209260fe,
    $9b4ef256583f1ea3$export$b86266e6594a97bb,
    $9b4ef256583f1ea3$export$2b5f951ad8e70cfe,
    $9b4ef256583f1ea3$export$da23b72d32bfad9e,
    $9b4ef256583f1ea3$export$4b064659282e0238,
    $9b4ef256583f1ea3$export$3ab51851f6d823e,
    $9b4ef256583f1ea3$export$e4a1a37a9a1350ad,
    $9b4ef256583f1ea3$export$b7f7da5e795f0327,
    $9b4ef256583f1ea3$export$80a401c1aa47a377,
    $9b4ef256583f1ea3$export$934ac7a251b26dc7,
    $9b4ef256583f1ea3$export$4634f6395df3ebbe,
    $9b4ef256583f1ea3$export$768fb41107a1e8d7,
    $9b4ef256583f1ea3$export$d797a81bace17184,
    $9b4ef256583f1ea3$export$746102c94db9df1f,
    $9b4ef256583f1ea3$export$5f1efd797d65e349,
    $9b4ef256583f1ea3$export$cccc812ccafbf11f,
    $9b4ef256583f1ea3$export$64822db87abd8a47,
    $9b4ef256583f1ea3$export$64f764d8be495c82,
    $9b4ef256583f1ea3$export$24eae23dc1c68bbd,
    $9b4ef256583f1ea3$export$50fa92eba6f82feb,
    $9b4ef256583f1ea3$export$4155d22fe3f14cd6,
    $9b4ef256583f1ea3$export$76813cbead887191,
    $9b4ef256583f1ea3$export$90aab2ff89daf770,
    $9b4ef256583f1ea3$export$a2bc0cbad2e6e605,
    $9b4ef256583f1ea3$export$f90872a1280728bb,
    $9b4ef256583f1ea3$export$bce644e96518cbd2,
    $9b4ef256583f1ea3$export$241aaebffac0a3e5,
    $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7,
    $9b4ef256583f1ea3$export$79759e9e62fb9312,
    $9b4ef256583f1ea3$export$992d1e0dce255d19,
    $9b4ef256583f1ea3$export$d28c1b0e5b3e768,
    $9b4ef256583f1ea3$export$ca714ee197bed4ec,
    $9b4ef256583f1ea3$export$faae55ceea4b6073,
    $9b4ef256583f1ea3$export$200bc24cd120667e,
    $9b4ef256583f1ea3$export$a0d784a48b4e886c,
    $9b4ef256583f1ea3$export$baf5bd09b4b33b8a,
    $9b4ef256583f1ea3$export$4702007eedbca8ab,
    $9b4ef256583f1ea3$export$aa9d2d635ea63898,
    $9b4ef256583f1ea3$export$2ea449225c1f6cac,
    $9b4ef256583f1ea3$export$deb8b557e735e26a,
    $9b4ef256583f1ea3$export$d45754df44e4c309,
    $9b4ef256583f1ea3$export$78b2913b550edbb,
    $9b4ef256583f1ea3$export$71243272608c58ab,
    $9b4ef256583f1ea3$export$39a08f215c33bc39,
    $9b4ef256583f1ea3$export$d2377f6a6fa3b49c,
    $9b4ef256583f1ea3$export$befa8f6533309779,
    $9b4ef256583f1ea3$export$736b40db8701ba6c,
    // Plan tasks
    $9b4ef256583f1ea3$export$590dc845c98d57e5,
    $9b4ef256583f1ea3$export$833908c980d64374,
    $9b4ef256583f1ea3$export$30049c54ff5e06aa,
    $9b4ef256583f1ea3$export$ad20239966e8cce,
    $9b4ef256583f1ea3$export$1800599ce91071b4,
    $9b4ef256583f1ea3$export$3ed330408d0583ad,
    // Tailored onboarding M3
    $9b4ef256583f1ea3$export$11eff6ae2f70b67b,
    $9b4ef256583f1ea3$export$fb2d23e5315a67a9,
    $9b4ef256583f1ea3$export$32e794bb49d60b6,
    $9b4ef256583f1ea3$export$fed256238b27db06,
    $9b4ef256583f1ea3$export$132eecb4d35a590d,
    $9b4ef256583f1ea3$export$2579c51cadd45eca,
    $9b4ef256583f1ea3$export$4b1a0cefa966ea0,
    $9b4ef256583f1ea3$export$f6558daacc312a65,
    $9b4ef256583f1ea3$export$925efa2e24e86b88,
    $9b4ef256583f1ea3$export$40454d3e062dcd44
];
const $9b4ef256583f1ea3$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("4NsfZ", function(module, exports) {
$parcel$export(module.exports, "actions", () => $39220db316456429$export$e324594224ef24da);

var $9w2jV = parcelRequire("9w2jV");

var $9jCgU = parcelRequire("9jCgU");

var $bc2a8 = parcelRequire("bc2a8");

var $kpUPF = parcelRequire("kpUPF");

var $b6yo1 = parcelRequire("b6yo1");

var $iTkHr = parcelRequire("iTkHr");

var $VrLd0 = parcelRequire("VrLd0");

var $hc2fd = parcelRequire("hc2fd");

var $7BMTT = parcelRequire("7BMTT");

var $27SP3 = parcelRequire("27SP3");

var $DHvqm = parcelRequire("DHvqm");

var $gWAj1 = parcelRequire("gWAj1");

var $4u1bX = parcelRequire("4u1bX");

var $9Zwvs = parcelRequire("9Zwvs");

var $jIA25 = parcelRequire("jIA25");

var $4RIzA = parcelRequire("4RIzA");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $4AM50 = parcelRequire("4AM50");

var $b1NgJ = parcelRequire("b1NgJ");

var $75ZOj = parcelRequire("75ZOj");

var $4ewzp = parcelRequire("4ewzp");

var $STfOf = parcelRequire("STfOf");

var $6wCHd = parcelRequire("6wCHd");

var $d8p4f = parcelRequire("d8p4f");

var $8n02n = parcelRequire("8n02n");
const $39220db316456429$export$e324594224ef24da = {
    changeTaskGroupParent: $9w2jV.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $9w2jV.nextGoBackToPreviousTaskGroup,
    setIsOpen: $9jCgU.setIsOpen,
    refreshAppState: $bc2a8.refreshAppState,
    setNudgeStep: $kpUPF.setNudgeStep,
    addMountedNudge: $b6yo1.addMountedNudge,
    removeMountedNudge: $b6yo1.removeMountedNudge,
    setShouldRenderComponent: $iTkHr.setShouldRenderComponent,
    setProjectState: $VrLd0.setProjectState,
    setHasNudgeActive: $hc2fd.setHasNudgeActive,
    forceHideNudge: $7BMTT.forceHideNudge,
    setHasEverSeenRoute: $27SP3.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $DHvqm.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $DHvqm.setRoadmapIsListEmpty,
    openNextTask: $gWAj1.openNextTask,
    resetIsQuickstartLoaded: $4u1bX.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $9Zwvs.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $jIA25.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $4RIzA.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $1ntUB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $hcEqM.nextSetChecklistIsOpen,
    nextOpenTask: $4AM50.nextOpenTask,
    nextAutoExpand: $b1NgJ.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $75ZOj.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $4ewzp.nextGetTasks,
    syncVisibilityWithLocal: $STfOf.syncVisibilityWithLocal,
    universalDispatch: $6wCHd.universalDispatch,
    setContainerType: $d8p4f.setContainerType,
    setQuickstartButtonRef: $8n02n.setQuickstartButtonRef,
    setIsOpenedViaButton: $8n02n.setIsOpenedViaButton,
    focusQuickstartButton: $8n02n.focusQuickstartButton
};

});
parcelRegister("9w2jV", function(module, exports) {
$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $c67ac35b88465cb8$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $c67ac35b88465cb8$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $c67ac35b88465cb8$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $c67ac35b88465cb8$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
    };
const $c67ac35b88465cb8$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4cTDP.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("6d5N9", function(module, exports) {
$parcel$export(module.exports, "pushToBackend", () => $968fd65112be9cd3$export$583b2d2422a6757f);

var $9pTd3 = parcelRequire("9pTd3");

var $FppkK = parcelRequire("FppkK");

var $aYncF = parcelRequire("aYncF");

var $14RSn = parcelRequire("14RSn");
const $968fd65112be9cd3$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $968fd65112be9cd3$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $FppkK.setUserProperties)($968fd65112be9cd3$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $14RSn.default)(response.status, response.statusText);
    });
const $968fd65112be9cd3$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $968fd65112be9cd3$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $968fd65112be9cd3$export$583b2d2422a6757f = async (props)=>{
    const success = await $968fd65112be9cd3$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $968fd65112be9cd3$var$trySetUserProperties(props, 2);
};

});


parcelRegister("9jCgU", function(module, exports) {
$parcel$export(module.exports, "setIsOpen", () => $d6b89ce939fd1abc$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");
const $d6b89ce939fd1abc$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };
var $d6b89ce939fd1abc$export$2e2bcd8739ae039 = $d6b89ce939fd1abc$export$dcf23146e0a40195;

});
parcelRegister("3XHRA", function(module, exports) {
$parcel$export(module.exports, "getQuickstartTypeSelector", () => $5e767603cbb6a27b$export$eae834ce0286017a);

var $FhXEJ = parcelRequire("FhXEJ");

var $9ycBx = parcelRequire("9ycBx");
const $5e767603cbb6a27b$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
const $5e767603cbb6a27b$export$eae834ce0286017a = (state)=>{
    if ($5e767603cbb6a27b$export$6f17f2cb816105eb(state)) return (0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("bc2a8", function(module, exports) {
$parcel$export(module.exports, "refreshAppState", () => $f970723875566945$export$797c35e2e1d0d014);


var $kRgKj = parcelRequire("kRgKj");

var $31GRl = parcelRequire("31GRl");

var $cblKs = parcelRequire("cblKs");

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $6d5N9 = parcelRequire("6d5N9");

var $dELL6 = parcelRequire("dELL6");

var $8hqW7 = parcelRequire("8hqW7");

var $86LDA = parcelRequire("86LDA");

var $uMSsJ = parcelRequire("uMSsJ");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $jIA25 = parcelRequire("jIA25");

var $9w2jV = parcelRequire("9w2jV");
const $f970723875566945$var$allTasks = [
    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
    ...(0, $9ycBx.JSM_BUSINESS_TASKS)
];
const $f970723875566945$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $9ycBx.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_TASK_GROUP),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                ...$f970723875566945$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $uMSsJ.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if (updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $cblKs.PREMIUM_EDITION)) {
            dispatch((0, $9w2jV.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $8hqW7.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $cblKs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $31GRl.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name') && !isReverseTrialForJSW && appEditions.software === (0, $cblKs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $hcEqM.nextSetChecklistIsOpen)(true));
            dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK) : (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK);
            // Go to advanced roadmaps task
            dispatch((0, $jIA25.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $9w2jV.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $6d5N9.pushToBackend)({
                key: (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("31GRl", function(module, exports) {
$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $8ddabc55934459cc$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $8ddabc55934459cc$export$ef676f7f369f74fe);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $4cTDP = parcelRequire("4cTDP");

var $iCPdV = parcelRequire("iCPdV");
const $8ddabc55934459cc$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $8ddabc55934459cc$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $iCPdV.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $iCPdV.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $3ugTQ.performGetRequestWithRetry)($8ddabc55934459cc$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $iCPdV.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $iCPdV.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        if ((0, $4cTDP.fg)('jira_handle_undefined_reverse_trial_eligibility')) // Return undefined values instead of throwing error when response data is invalid
        return {
            premiumTrialOnSignup: undefined,
            reverseTrialCohort: undefined
        };
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $8ddabc55934459cc$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $8ddabc55934459cc$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("iCPdV", function(module, exports) {
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$f389f8ca168b4a3a);

var $3hRxq = parcelRequire("3hRxq");

var $9pTd3 = parcelRequire("9pTd3");
const $880bf1d3001e9a60$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $880bf1d3001e9a60$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $880bf1d3001e9a60$var$localStorage = (0, $3hRxq.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $880bf1d3001e9a60$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$c3378895d06b5528 = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $880bf1d3001e9a60$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("79a1F", function(module, exports) {
$parcel$export(module.exports, "pollBackend", () => $a820ac7275a95d77$export$8420ef0cee98de);

var $fnu0d = parcelRequire("fnu0d");

var $9ycBx = parcelRequire("9ycBx");
const $a820ac7275a95d77$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $fnu0d.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $9ycBx.PACKAGE_NAME),
            teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});

parcelRegister("dELL6", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $c95fada5ff0e59fd$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $c95fada5ff0e59fd$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $c95fada5ff0e59fd$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $c95fada5ff0e59fd$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $c95fada5ff0e59fd$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $c95fada5ff0e59fd$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $c95fada5ff0e59fd$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $c95fada5ff0e59fd$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $c95fada5ff0e59fd$export$6c39ca65ca354e59);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");

var $9ycBx = parcelRequire("9ycBx");

var $46NrI = parcelRequire("46NrI");
const $c95fada5ff0e59fd$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $9ycBx.ACTION_SUBJECT_ID), attributes);
};
const $c95fada5ff0e59fd$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $c95fada5ff0e59fd$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $c95fada5ff0e59fd$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $46NrI.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $c95fada5ff0e59fd$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $c95fada5ff0e59fd$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("46NrI", function(module, exports) {
$parcel$export(module.exports, "getProductType", () => $220645f5a7e2c3df$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $220645f5a7e2c3df$export$3b914201960fa7a6);

var $7mF43 = parcelRequire("7mF43");

var $FhXEJ = parcelRequire("FhXEJ");
const $220645f5a7e2c3df$export$d64a7dd8c7cd80e0 = {
    [(0, $FhXEJ.CORE_PROJECT)]: 'workManagement',
    [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'software',
    [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $220645f5a7e2c3df$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $220645f5a7e2c3df$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(projectType);
    return null;
};
const $220645f5a7e2c3df$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(taskId.split('.').pop());
};

});


parcelRegister("8hqW7", function(module, exports) {
$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $53b23fbdedb29316$export$7f2186c37a3d095d);

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $3ugTQ = parcelRequire("3ugTQ");

var $kRgKj = parcelRequire("kRgKj");

var $9ycBx = parcelRequire("9ycBx");

var $cCGZI = parcelRequire("cCGZI");
const $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $53b23fbdedb29316$var$ONE_DAY = 86400000;
const $53b23fbdedb29316$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $3ugTQ.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4cTDP.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4cTDP.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $53b23fbdedb29316$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $cCGZI.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $53b23fbdedb29316$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4cTDP.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $53b23fbdedb29316$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("cCGZI", function(module, exports) {
$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $c5da128a7c764253$export$99f3e48748c2a8c3);

var $8tIrO = parcelRequire("8tIrO");

const $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider = (0, $8tIrO.createSessionExpirableStorageProvider)((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
const $c5da128a7c764253$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.set((0, $70024ada6ee08235$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.get((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $70024ada6ee08235$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("86LDA", function(module, exports) {
$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $d056ac553c2189c1$export$980c26b6f100081d);

var $3ugTQ = parcelRequire("3ugTQ");
const $d056ac553c2189c1$export$980c26b6f100081d = ()=>(0, $3ugTQ.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("uMSsJ", function(module, exports) {
$parcel$export(module.exports, "getNextNonCompleteTask", () => $d41b9686fb79c7bc$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $d41b9686fb79c7bc$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $d41b9686fb79c7bc$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $d41b9686fb79c7bc$export$93d719890ad66653);

var $3hRxq = parcelRequire("3hRxq");

var $gZkaf = parcelRequire("gZkaf");
const $d41b9686fb79c7bc$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $d41b9686fb79c7bc$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $d41b9686fb79c7bc$var$store = (0, $3hRxq.createLocalStorageProvider)('quickstart');
const $d41b9686fb79c7bc$export$5aa524d86254b4f = (key, value)=>{
    $d41b9686fb79c7bc$var$store.set(key, value);
};
const $d41b9686fb79c7bc$export$93d719890ad66653 = (key)=>$d41b9686fb79c7bc$var$store.get(key);

});
parcelRegister("gZkaf", function(module, exports) {
$parcel$export(module.exports, "getTaskIndex", () => $e5e0a63f9d11b989$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $e5e0a63f9d11b989$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $e5e0a63f9d11b989$export$995248f3b43d8505);

var $46NrI = parcelRequire("46NrI");







const $e5e0a63f9d11b989$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $e5e0a63f9d11b989$export$9711f11998d5795c = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $e5e0a63f9d11b989$export$995248f3b43d8505 = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $e5e0a63f9d11b989$export$293f6b2affa6ea5a = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("1ntUB", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $90c4f819f308a0de$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $90c4f819f308a0de$export$ca9507f266fdd4e4 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED : (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: false
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_DISMISSED),
            value: isDismissed
        });
    };
const $90c4f819f308a0de$var$nextSetChecklistIsDismissedNew = (isDismissed)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED : (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        await (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
    };
const $90c4f819f308a0de$export$f24c05f83b880547 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_kuro-10551_fix_qs_flash'), $90c4f819f308a0de$var$nextSetChecklistIsDismissedNew, $90c4f819f308a0de$export$ca9507f266fdd4e4);

});

parcelRegister("hcEqM", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $4e92599f1808f020$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $4e92599f1808f020$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("jIA25", function(module, exports) {
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $53dc3dee14098ca0$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6d5N9 = parcelRequire("6d5N9");
const $53dc3dee14098ca0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $6d5N9.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("kpUPF", function(module, exports) {
$parcel$export(module.exports, "setNudgeStep", () => $4ac0db746ee3e19c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ac0db746ee3e19c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $4ac0db746ee3e19c$export$2e2bcd8739ae039 = $4ac0db746ee3e19c$export$4debc323813b6997;

});

parcelRegister("b6yo1", function(module, exports) {
$parcel$export(module.exports, "addMountedNudge", () => $a7896299b4c2538c$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $a7896299b4c2538c$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a7896299b4c2538c$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $a7896299b4c2538c$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("iTkHr", function(module, exports) {
$parcel$export(module.exports, "setShouldRenderComponent", () => $9e529cdb63511cc5$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9e529cdb63511cc5$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $9e529cdb63511cc5$export$2e2bcd8739ae039 = $9e529cdb63511cc5$export$1f9c6770ed938b6e;

});

parcelRegister("VrLd0", function(module, exports) {
$parcel$export(module.exports, "setProjectState", () => $fb6d4843482b7a21$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fb6d4843482b7a21$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $fb6d4843482b7a21$export$2e2bcd8739ae039 = $fb6d4843482b7a21$export$1ba498e440c0a1e4;

});

parcelRegister("hc2fd", function(module, exports) {
$parcel$export(module.exports, "setHasNudgeActive", () => $655ce5c27a1ef578$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $655ce5c27a1ef578$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $655ce5c27a1ef578$export$2e2bcd8739ae039 = $655ce5c27a1ef578$export$497c281e6eb0786e;

});

parcelRegister("7BMTT", function(module, exports) {
$parcel$export(module.exports, "forceHideNudge", () => $748cd7120d515b8c$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $748cd7120d515b8c$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("27SP3", function(module, exports) {
$parcel$export(module.exports, "setHasEverSeenRoute", () => $8cdbd8bb590a918c$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $8cdbd8bb590a918c$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $8cdbd8bb590a918c$export$2e2bcd8739ae039 = $8cdbd8bb590a918c$export$28e0a4314a1ce52f;

});

parcelRegister("DHvqm", function(module, exports) {
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f78d96b92dcbe1de$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f78d96b92dcbe1de$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f78d96b92dcbe1de$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f78d96b92dcbe1de$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gWAj1", function(module, exports) {
$parcel$export(module.exports, "openNextTask", () => $163de5e21e24ce13$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $163de5e21e24ce13$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $uMSsJ.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $4AM50.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("4AM50", function(module, exports) {
$parcel$export(module.exports, "nextOpenTask", () => $b3d3db0c7001002a$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $b3d3db0c7001002a$export$cc5f3544a6cb2922);


var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $kpUPF = parcelRequire("kpUPF");

var $hc2fd = parcelRequire("hc2fd");
const $b3d3db0c7001002a$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $b3d3db0c7001002a$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        else dispatch((0, $hc2fd.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // @todo: Cleanup for simplify kanban QS productionisation
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.KANBAN_ONBOARDING_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$3366ddefe77d5112)));
        else dispatch((0, $kpUPF.setNudgeStep)(''));
    };
const $b3d3db0c7001002a$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        dispatch((0, $kpUPF.setNudgeStep)(''));
    };

});


parcelRegister("4u1bX", function(module, exports) {
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $01d5b170ba597bd8$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $3XHRA = parcelRequire("3XHRA");
const $01d5b170ba597bd8$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("9Zwvs", function(module, exports) {
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $865d905b5ed9ce34$export$87fe8079a4ed9766);


var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $dELL6 = parcelRequire("dELL6");

var $86LDA = parcelRequire("86LDA");

var $1ntUB = parcelRequire("1ntUB");
const $865d905b5ed9ce34$export$87fe8079a4ed9766 = ({ taskList: taskList, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("4RIzA", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $d99f03d4977e428c$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $d99f03d4977e428c$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $9ycBx.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("b1NgJ", function(module, exports) {
$parcel$export(module.exports, "nextAutoExpand", () => $940a31066334aca1$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $940a31066334aca1$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $5JVW2.localStorageProvider)().get({
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $uMSsJ.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4cTDP.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $4AM50.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("5JVW2", function(module, exports) {
$parcel$export(module.exports, "localStorageProvider", () => $8f126aa766b95c06$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $8f126aa766b95c06$export$f2666fae743fa5f);

var $9pTd3 = parcelRequire("9pTd3");

var $8tIrO = parcelRequire("8tIrO");

var $9ycBx = parcelRequire("9ycBx");
const $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY = 1;
const $8f126aa766b95c06$var$DAY = 86400000;
const $8f126aa766b95c06$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $8f126aa766b95c06$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY * $8f126aa766b95c06$var$DAY;
};
let $8f126aa766b95c06$var$localStorage;
const $8f126aa766b95c06$export$aa821bfb3308a1f5 = ()=>{
    if ($8f126aa766b95c06$var$localStorage) return $8f126aa766b95c06$var$localStorage;
    const provider = (0, $8tIrO.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }), value, $8f126aa766b95c06$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    $8f126aa766b95c06$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $8f126aa766b95c06$var$localStorage;
};
const $8f126aa766b95c06$export$f2666fae743fa5f = (value)=>{
    $8f126aa766b95c06$export$aa821bfb3308a1f5().set({
        accountId: (0, $9ycBx.ACCOUNT_ID),
        key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("75ZOj", function(module, exports) {
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $ef47ceb0db6e67e3$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $hc2fd = parcelRequire("hc2fd");
const $ef47ceb0db6e67e3$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $5JVW2.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $hc2fd.setHasNudgeActive)(true));
            (0, $5JVW2.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("4ewzp", function(module, exports) {
$parcel$export(module.exports, "nextGetTasks", () => $58d7175ee2e35561$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $6P4lT = parcelRequire("6P4lT");

var $4AM50 = parcelRequire("4AM50");
const $58d7175ee2e35561$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { taskList: taskList, completedTaskList: completedTaskList, openTask: openTask, isQuickstartLoaded: isQuickstartLoaded } = getState();
        const tasks = (0, $6P4lT.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
        // Auto-open the first incomplete task if no task is currently open
        // Note: nextGetTasks and refreshAppState can in theory happen in any order
        // Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
        // This ensures backend state has been restored before we auto-open
        if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded && (0, $4cTDP.fg)('jira-fix-qs-first-card-opening-on-land')) {
            const firstIncompleteTask = tasks.items.find((taskId)=>!completedTaskList.includes(taskId));
            // If we found a first incomplete task and no task is currently open, open it
            if (firstIncompleteTask && !openTask) dispatch((0, $4AM50.nextOpenTask)(firstIncompleteTask));
        }
    };

});
parcelRegister("6P4lT", function(module, exports) {
$parcel$export(module.exports, "getAllTasks", () => $888e4567977ab846$export$d1f442602a91e7cc);

var $9pTd3 = parcelRequire("9pTd3");

var $cxKOj = parcelRequire("cxKOj");

var $lopBx = parcelRequire("lopBx");

var $4cTDP = parcelRequire("4cTDP");


var $cblKs = parcelRequire("cblKs");

var $LFsl3 = parcelRequire("LFsl3");

var $9ycBx = parcelRequire("9ycBx");

var $dt54n = parcelRequire("dt54n");

var $1KmSm = parcelRequire("1KmSm");

var $koyuo = parcelRequire("koyuo");

var $7y7co = parcelRequire("7y7co");

var $8rJAF = parcelRequire("8rJAF");

var $9228c = parcelRequire("9228c");

var $cYgSg = parcelRequire("cYgSg");

var $emLqf = parcelRequire("emLqf");

var $c4gw9 = parcelRequire("c4gw9");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");

var $7A9H8 = parcelRequire("7A9H8");
const $888e4567977ab846$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $cxKOj.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $7y7co.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $9ycBx.ROOT_TASK) ? (0, $9ycBx.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $9ycBx.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $9ycBx.ROOT_TASK];
    return {
        title: title,
        items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
    };
};
const $888e4567977ab846$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $9ycBx.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $2b839a8453de5367$export$3366ddefe77d5112));
    if ((0, $lopBx.isFedRamp)()) variants.add((0, $7y7co.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $7y7co.JSW).experiment.jswReverseTrial);
        (0, $cxKOj.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $7y7co.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $7y7co.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $7y7co.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $7y7co.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $7y7co.JSW).experience.kanbanOnboarding);
    if (canCreateProject === false) variants.add((0, $7y7co.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $7y7co.JSW).projectStyle.teamManaged);
    else variants.add((0, $7y7co.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $7y7co.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.jiraAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.siteAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $cblKs.FREE_EDITION)) variants.add((0, $7y7co.JSW).edition.free);
    else if (projectState?.edition === (0, $cblKs.STANDARD_EDITION)) variants.add((0, $7y7co.JSW).edition.standard);
    else if (projectState?.edition === (0, $cblKs.PREMIUM_EDITION)) variants.add((0, $7y7co.JSW).edition.premium);
    if ((0, $dt54n.isRoadmapRoute)(routeName)) variants.add((0, $7y7co.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $7y7co.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $7y7co.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $7y7co.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $7y7co.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $7y7co.JSW).route.issue);
    else variants.add((0, $7y7co.JSW).route.softwareCalendar);
    return $888e4567977ab846$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $7y7co.JSW).taskVariants,
        taskList: (0, $7y7co.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $8rJAF.JWM).experiments.projectTheming);
    // No longer reference isEligibleForTailoredOnboardingM2P5 before showing TO cards
    // isEligibleForTailoredOnboardingM2P5 has checks for trello/site admin and team type but these are now built into the config (admin check is removed)
    if ((0, $4cTDP.fg)('to-cleanup-release-business-cards-to-nth-users')) return $888e4567977ab846$export$568bd601466cd235({
        taskGroupParent: taskGroupParent,
        teamType: teamType,
        projectState: projectState,
        taskList: taskList
    });
    // TODO: Remove below logic when cleaning up to-cleanup-release-business-cards-to-nth-users
    // Old JWM config cards can also be removed
    // We have confirmation to remove old cards https://hello.atlassian.net/wiki/spaces/~620663553/pages/5628213263/Quickstart+cards+to+check
    if (isEligibleForTailoredOnboardingM2P5) return $888e4567977ab846$export$e21b96de210942({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $8rJAF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $8rJAF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $8rJAF.JWM).experiments.isSampleProject);
    else variants.push((0, $8rJAF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $8rJAF.JWM).taskVariants,
        taskList: taskList ?? (0, $8rJAF.JWM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $koyuo.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $koyuo.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $koyuo.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $koyuo.JSM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $koyuo.JSM).taskVariants,
        taskList: (0, $koyuo.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createPlanTasks = (taskGroupParent, features)=>{
    const variants = [];
    if (features?.hasPlanDependencies) variants.push((0, $feWch.Feature).hasPlanDependencies);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $9228c.PLAN).taskVariants,
        taskList: (0, $9228c.PLAN).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $feWch.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $feWch.Feature).hasSprint);
    if (features?.hasSummaryPage && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasSummaryPage);
    if (features?.hasRoadmap && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasRoadmap);
    if (features?.hasList && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasList);
    if (features?.hasCalendar && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCalendar);
    if (features?.hasCode && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCode);
    if (features?.hasForms && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasForms);
    if (features?.hasPages && (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasPages);
    if (!(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name') && isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
    if ((0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $eUvg6.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $LFsl3.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name') ? (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants : (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariantsOld,
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$568bd601466cd235 = ({ taskGroupParent: taskGroupParent, teamType: teamType, projectState: projectState, taskList: taskList })=>{
    const variants = [];
    // When cleaning up M2 and consolidating configs, this team type check should just be updated to include MKT & OPS
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $7A9H8.TAILORED_ONBOARDING_BUSINESS_CONFIG),
        // This should be cleaned up when M2 is cleaned up. Currently it's like this because M2 populates taskList via the BE
        // and then the FE uses it here, ideally M2 cards are in the business config following conventions so they don't get extra priority bypassing other stuff in the config
        // For now there is also an extra check here to show the trello task list for Trello Crossflow users over M2 https://atlassian.slack.com/archives/C082QR7B16Z/p1755066367960509?thread_ts=1755064885.015779&cid=C082QR7B16Z
        taskList: !projectState?.isTrelloCrossflow && taskList ? taskList : (0, $c4gw9.TAILORED_ONBOARDING_BUSINESS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: // can edit any plan
canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features, containerType: containerType })=>{
    if (containerType === 'plan' && (0, $4cTDP.fg)('quickstart_onboarding_in_jira_plans')) return $888e4567977ab846$var$createPlanTasks(taskGroupParent, features);
    if ((0, $emLqf.isJwmProject)(projectState)) return $888e4567977ab846$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $emLqf.isJsmProject)(projectState)) return $888e4567977ab846$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (!(0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) {
        if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    }
    if ((0, $4cTDP.fg)('to-cleanup-remove-initial-project-template-name')) {
        const tailoredOnboardingTasks = $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features);
        // TODO: Remove length check on cleanup of to-cleanup-remove-initial-project-template-name
        // It is just a safety fallback if tailored onboarding tasks are empty but this should never happen
        if (tailoredOnboardingTasks.items.length > 0) return tailoredOnboardingTasks;
        // TODO: Remove this error on cleanup of to-cleanup-remove-initial-project-template-name
        // This should never happen
        (0, $9pTd3.fireErrorAnalytics)({
            error: new Error('tailored onboarding tasks are empty'),
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: 'tailored onboarding tasks are empty',
                teamType: teamType,
                hasBacklog: features?.hasBacklog,
                hasSprint: features?.hasSprint,
                hasSummaryPage: features?.hasSummaryPage,
                hasRoadmap: features?.hasRoadmap,
                hasList: features?.hasList,
                hasCalendar: features?.hasCalendar,
                hasCode: features?.hasCode,
                hasForms: features?.hasForms,
                hasPages: features?.hasPages
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $888e4567977ab846$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("LFsl3", function(module, exports) {
$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $2b571464d35dbda4$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $2b571464d35dbda4$export$26c385918d734203);

var $8IjPx = parcelRequire("8IjPx");
const $2b571464d35dbda4$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredTeamTypes).includes(teamType);
};
const $2b571464d35dbda4$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("8IjPx", function(module, exports) {
$parcel$export(module.exports, "tailoredTeamTypes", () => $568d03b0884f9ed5$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $568d03b0884f9ed5$export$52c5394d6e6cfcf3);

const $568d03b0884f9ed5$export$a1fbb7d965e15a39 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$e4824f74b9879164),
    (0, $2b839a8453de5367$export$4f3cb0844009af52),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];
const $568d03b0884f9ed5$export$52c5394d6e6cfcf3 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];

});


parcelRegister("dt54n", function(module, exports) {
$parcel$export(module.exports, "isRoadmapRoute", () => $dbcd2c9ba5e49677$export$d1fa67c1ffb68871);
const $dbcd2c9ba5e49677$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("1KmSm", function(module, exports) {
$parcel$export(module.exports, "USER_ROLE", () => $2ef1b0f2207fd5ce$export$8eeb199b23203523);
const $2ef1b0f2207fd5ce$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("koyuo", function(module, exports) {
$parcel$export(module.exports, "JSM", () => $2c85504c5ef985eb$export$63f289f2da861d35);

var $dmVCq = parcelRequire("dmVCq");
const $2c85504c5ef985eb$export$63f289f2da861d35 = {
    taskList: (0, $dmVCq.JSM_TASK_LIST),
    taskVariants: (0, $dmVCq.JSM_TASK_VARIANTS),
    userRole: (0, $dmVCq.UserRole),
    experiments: (0, $dmVCq.Experiments)
};

});
parcelRegister("dmVCq", function(module, exports) {
$parcel$export(module.exports, "JSM_TASK_LIST", () => $39979c1b128d3c9a$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $39979c1b128d3c9a$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $39979c1b128d3c9a$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $39979c1b128d3c9a$export$5b68aef408c932d9);

var $9ycBx = parcelRequire("9ycBx");

var $8pEHr = parcelRequire("8pEHr");
const $39979c1b128d3c9a$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $8pEHr.messages).rootTitle,
        items: [
            (0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $39979c1b128d3c9a$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $39979c1b128d3c9a$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $39979c1b128d3c9a$export$5b68aef408c932d9 = {
    [(0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("8pEHr", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ffaf571352a2cc1d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ffaf571352a2cc1d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("7y7co", function(module, exports) {
$parcel$export(module.exports, "JSW", () => $69137b6bfd6791a4$export$4cfe6e52f2e72a54);

var $eUvg6 = parcelRequire("eUvg6");
const $69137b6bfd6791a4$export$4cfe6e52f2e72a54 = {
    taskList: (0, $eUvg6.TASK_LIST),
    taskVariants: (0, $eUvg6.TASK_VARIANTS),
    experiment: (0, $eUvg6.Experiment),
    experience: (0, $eUvg6.Experience),
    projectStyle: (0, $eUvg6.ProjectStyle),
    userRole: (0, $eUvg6.UserRole),
    edition: (0, $eUvg6.Edition),
    route: (0, $eUvg6.Route),
    permissions: (0, $eUvg6.Permissions),
    trait: (0, $eUvg6.Trait)
};

});
parcelRegister("eUvg6", function(module, exports) {
$parcel$export(module.exports, "FeatureGate", () => $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Experiment", () => $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $b0c17d2eb7065ae3$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $b0c17d2eb7065ae3$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $b0c17d2eb7065ae3$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $b0c17d2eb7065ae3$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $b0c17d2eb7065ae3$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $b0c17d2eb7065ae3$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $b0c17d2eb7065ae3$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $b0c17d2eb7065ae3$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $4J9Xs = parcelRequire("4J9Xs");
const $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $b0c17d2eb7065ae3$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $b0c17d2eb7065ae3$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $b0c17d2eb7065ae3$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $b0c17d2eb7065ae3$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $b0c17d2eb7065ae3$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $b0c17d2eb7065ae3$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $b0c17d2eb7065ae3$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST = [
    (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)
];
const $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $4J9Xs.messages).rootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $4J9Xs.messages).reverseTrialRootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $4J9Xs.messages).reverseTrialCardTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.CHANGE_CONTROL_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK)
        ]
    }
});
const $b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS = {
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $b0c17d2eb7065ae3$export$36f4d47dfe11b613 = $b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS;

});
parcelRegister("4J9Xs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3416e8428d224ccf$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3416e8428d224ccf$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("8rJAF", function(module, exports) {
$parcel$export(module.exports, "JWM", () => $77b9f961c5c24ac0$export$3ff26c80cb588e12);

var $4PmHv = parcelRequire("4PmHv");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");
const $77b9f961c5c24ac0$export$3ff26c80cb588e12 = {
    taskList: (0, $4PmHv.TASK_LIST),
    taskVariants: (0, $4PmHv.TASK_VARIANTS),
    userRole: (0, $5ImmZ.UserRole),
    experiments: (0, $7BHaP.Experiments)
};

});
parcelRegister("4PmHv", function(module, exports) {
$parcel$export(module.exports, "TASK_LIST", () => $a08aca66351aa30d$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "OPS_TAILORED_ONBOARDING_TASK_VARIANTS", () => $a08aca66351aa30d$export$db06b8e338ba9c65);
$parcel$export(module.exports, "MKT_TAILORED_ONBOARDING_TASK_VARIANTS", () => $a08aca66351aa30d$export$bda7075f98246874);
$parcel$export(module.exports, "TASK_VARIANTS", () => $a08aca66351aa30d$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $7BHaP = parcelRequire("7BHaP");

var $dj1vQ = parcelRequire("dj1vQ");

var $5ImmZ = parcelRequire("5ImmZ");
const $a08aca66351aa30d$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $dj1vQ.messages).rootTitle,
        items: [
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_PROJECT_SUMMARY_TASK),
            (0, $9ycBx.JWM_CALENDAR_TASK),
            (0, $9ycBx.JWM_TIMELINE_TASK),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_BACKGROUND_COLOR_TASK),
            (0, $9ycBx.JWM_FEEDBACK_TASK),
            (0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_SHARE_PROJECT_TASK),
            (0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $a08aca66351aa30d$export$db06b8e338ba9c65 = {
    [(0, $9ycBx.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $a08aca66351aa30d$export$bda7075f98246874 = {
    [(0, $9ycBx.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $a08aca66351aa30d$export$36f4d47dfe11b613 = {
    ...$a08aca66351aa30d$export$db06b8e338ba9c65,
    ...$a08aca66351aa30d$export$bda7075f98246874,
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("7BHaP", function(module, exports) {
$parcel$export(module.exports, "Experiments", () => $57326be2952b3617$export$c8d6ffd15214553a);
const $57326be2952b3617$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("dj1vQ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6ba3f21c8d7d2fe3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6ba3f21c8d7d2fe3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5ImmZ", function(module, exports) {
$parcel$export(module.exports, "UserRole", () => $0235b2ed52c10505$export$eb3485a690c2f0b8);
const $0235b2ed52c10505$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("9228c", function(module, exports) {
$parcel$export(module.exports, "PLAN", () => $aac3014bd1a505bf$export$c303e491e026ebc6);

var $glBlO = parcelRequire("glBlO");
const $aac3014bd1a505bf$export$c303e491e026ebc6 = {
    taskList: (0, $glBlO.PLAN_TASK_LIST),
    taskVariants: (0, $glBlO.PLAN_TASK_VARIANTS)
};

});
parcelRegister("glBlO", function(module, exports) {
$parcel$export(module.exports, "PLAN_TASK_LIST", () => $745411eac178e4e0$export$6ddf1195a65583de);
$parcel$export(module.exports, "PLAN_TASK_VARIANTS", () => $745411eac178e4e0$export$73c2f09f0994be4f);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");

var $ebg0D = parcelRequire("ebg0D");
const $745411eac178e4e0$export$6ddf1195a65583de = Object.freeze({
    root: {
        title: (0, $ebg0D.messages).rootTitle,
        items: [
            (0, $9ycBx.PLAN_CREATE_MORE_WORK_ITEMS_TASK),
            (0, $9ycBx.PLAN_BRING_IN_THE_TEAM_TASK),
            (0, $9ycBx.PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK),
            (0, $9ycBx.PLAN_CONNECT_RELATED_WORK_TASK),
            (0, $9ycBx.PLAN_ADJUST_DETAILS_TASK),
            (0, $9ycBx.PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK)
        ]
    }
});
const $745411eac178e4e0$export$73c2f09f0994be4f = {
    [(0, $9ycBx.PLAN_CREATE_MORE_WORK_ITEMS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_BRING_IN_THE_TEAM_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_CONFIRM_SCOPE_AND_SETTINGS_TASK)]: {
        position: {
            default: 20
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_CONNECT_RELATED_WORK_TASK)]: {
        position: {
            default: 30
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasPlanDependencies
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.PLAN_ADJUST_DETAILS_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.PLAN_SHARE_YOUR_PLAN_WITH_THE_WORLD_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("feWch", function(module, exports) {
$parcel$export(module.exports, "TeamType", () => $404e322e3706479c$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $404e322e3706479c$export$6e91cf7616333d5);

const $404e322e3706479c$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $2b839a8453de5367$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $2b839a8453de5367$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $2b839a8453de5367$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $2b839a8453de5367$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $2b839a8453de5367$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $2b839a8453de5367$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $2b839a8453de5367$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $2b839a8453de5367$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $404e322e3706479c$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages',
    hasPlanDependencies: 'feature.hasPlanDependencies'
};

});

parcelRegister("ebg0D", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f0fe29c52499f409$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f0fe29c52499f409$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.plan.root-title",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("cYgSg", function(module, exports) {
$parcel$export(module.exports, "getTasks", () => $298a0d20f3b1d08a$export$20b82b4a32771893);

var $iyRnt = parcelRequire("iyRnt");
const $298a0d20f3b1d08a$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $iyRnt.getConditional)(visibility, variants) : true;
const $298a0d20f3b1d08a$var$getTaskPosition = (variants, position)=>(0, $iyRnt.getConditional)(position, variants);
const $298a0d20f3b1d08a$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$298a0d20f3b1d08a$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskA].position) - $298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("iyRnt", function(module, exports) {
$parcel$export(module.exports, "getConditional", () => $80dfc494f4751e25$export$fe3161cde0106bba);
const $80dfc494f4751e25$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("emLqf", function(module, exports) {
$parcel$export(module.exports, "isJwmProject", () => $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $99044a2d2d5f79ec$export$a972ed853ed1d469);

var $FhXEJ = parcelRequire("FhXEJ");
const $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $FhXEJ.CORE_PROJECT);
const $99044a2d2d5f79ec$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);

});

parcelRegister("c4gw9", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $9c945d174f9c912a$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $9c945d174f9c912a$export$eb17ad7838835d2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS", () => $9c945d174f9c912a$export$fe6b8880a507b306);


var $9ycBx = parcelRequire("9ycBx");

var $iKhBT = parcelRequire("iKhBT");

var $8sWUb = parcelRequire("8sWUb");

var $5shRe = parcelRequire("5shRe");

var $a1b8c = parcelRequire("a1b8c");

var $mLM2w = parcelRequire("mLM2w");

var $i5ttL = parcelRequire("i5ttL");

var $e8Fhw = parcelRequire("e8Fhw");

var $fHbA0 = parcelRequire("fHbA0");

var $ifDp7 = parcelRequire("ifDp7");

var $7OyjZ = parcelRequire("7OyjZ");
const $9c945d174f9c912a$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_BACKLOG),
            (0, $9ycBx.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $9c945d174f9c912a$export$83849aa73c0a20db = {
    taskList: $9c945d174f9c912a$export$2757f7b23d120b9b,
    taskVariants: (0, $ifDp7.TAILORED_ONBOARDING_SINGLE_CONFIG),
    // todo: remove this on `to-cleanup-remove-initial-project-template-name` cleanup
    taskVariantsOld: (0, $7OyjZ.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $9c945d174f9c912a$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $9c945d174f9c912a$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $2b839a8453de5367$export$4f54a09a24fd1d74:
            return 0, $5shRe.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$79685802e8ff1098:
            return 0, $8sWUb.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$e5c438b7501b5a24:
            return 0, $a1b8c.DESIGN_VARIANTS;
        case 0, $2b839a8453de5367$export$d7de553940261eba:
            return 0, $mLM2w.IT_SUPPORT_VARIANTS;
        case 0, $2b839a8453de5367$export$cbc0e551d91a692d:
            return 0, $i5ttL.OTHER_PERSONAL_VARIANTS;
        case 0, $2b839a8453de5367$export$b8b1ac856ba1434b:
            return 0, $fHbA0.SOFTWARE_VARIANTS;
        default:
            return 0, $e8Fhw.EVERYTHING_ELSE_VARIANTS;
    }
};
const $9c945d174f9c912a$export$cb2285c4be67df48 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            // JWM Trello Crossflow Tasks
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            // JSW Tailored Onboarding Tasks
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE)
        ]
    }
});
const $9c945d174f9c912a$export$eb17ad7838835d2a = {
    taskList: $9c945d174f9c912a$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $9c945d174f9c912a$export$3c409334669aec75
};
const $9c945d174f9c912a$export$fe6b8880a507b306 = {
    taskList: $9c945d174f9c912a$export$cb2285c4be67df48
};

});
parcelRegister("iKhBT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $47efb1049993f4e6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $47efb1049993f4e6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("8sWUb", function(module, exports) {
$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $d1467d7397e68eff$export$bdd338c80f8962df);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $d1467d7397e68eff$export$bdd338c80f8962df = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("5shRe", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $443b90c91e3360e2$export$b07ea6a2d29f9c08);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $443b90c91e3360e2$export$b07ea6a2d29f9c08 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("a1b8c", function(module, exports) {
$parcel$export(module.exports, "DESIGN_VARIANTS", () => $4acbe4cfde2344f9$export$a3c4cd8e420f13a);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $4acbe4cfde2344f9$export$a3c4cd8e420f13a = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("mLM2w", function(module, exports) {
$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $cf156d50ed1f640d$export$a25e809b52945082);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $cf156d50ed1f640d$export$a25e809b52945082 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("i5ttL", function(module, exports) {
$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $120d7baa5e5f9d4d$export$916be3c140ae8c0);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $120d7baa5e5f9d4d$export$916be3c140ae8c0 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("e8Fhw", function(module, exports) {
$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $7c6363b0cc97119f$export$7a0daeb069f34de3);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $7c6363b0cc97119f$export$7a0daeb069f34de3 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("fHbA0", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $9fc06aa003a906e0$export$76a143792cc73994);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $9fc06aa003a906e0$export$76a143792cc73994 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("ifDp7", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $e8b95d7a0e5bd991$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $e8b95d7a0e5bd991$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("7OyjZ", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $a2f5344c5d0d5ba3$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");
const $a2f5344c5d0d5ba3$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("7A9H8", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $e3c54a7acd454a57$export$474323a35aa36586);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");

var $4PmHv = parcelRequire("4PmHv");
const $e3c54a7acd454a57$export$474323a35aa36586 = {
    ...(0, $4PmHv.OPS_TAILORED_ONBOARDING_TASK_VARIANTS),
    ...(0, $4PmHv.MKT_TAILORED_ONBOARDING_TASK_VARIANTS),
    // Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    // Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("STfOf", function(module, exports) {
$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f389d77cde532ebe$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $f389d77cde532ebe$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("6wCHd", function(module, exports) {
$parcel$export(module.exports, "universalDispatch", () => $2ed3eacefc81a47a$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2ed3eacefc81a47a$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});

parcelRegister("d8p4f", function(module, exports) {
$parcel$export(module.exports, "setContainerType", () => $5430da7673e540d1$export$24889c6c4e904da4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $5430da7673e540d1$export$24889c6c4e904da4 = (containerType)=>({ getState: getState, setState: setState })=>{
        const { containerType: currentContainerType } = getState();
        if (containerType === currentContainerType) // if state has not been updated we just return
        return;
        setState({
            containerType: containerType
        });
    };
var $5430da7673e540d1$export$2e2bcd8739ae039 = $5430da7673e540d1$export$24889c6c4e904da4;

});

parcelRegister("8n02n", function(module, exports) {
$parcel$export(module.exports, "setQuickstartButtonRef", () => $106f18c55aeeccf9$export$8119a14b79738a24);
$parcel$export(module.exports, "setIsOpenedViaButton", () => $106f18c55aeeccf9$export$8b7fa399fb8c07f);
$parcel$export(module.exports, "focusQuickstartButton", () => $106f18c55aeeccf9$export$8f1aa3f8d2941465);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $106f18c55aeeccf9$export$8119a14b79738a24 = (quickstartButtonRef)=>({ setState: setState })=>{
        setState({
            quickstartButtonRef: quickstartButtonRef
        });
    };
const $106f18c55aeeccf9$export$8b7fa399fb8c07f = (isOpenedViaButton)=>({ setState: setState })=>{
        setState({
            isOpenedViaButton: isOpenedViaButton
        });
    };
// Since the button is visible after 220ms and requestAnimationFrame is called 60 times per second,
// to be safe we can wait for 15 frames (220/1000 * 60)
const $106f18c55aeeccf9$var$MAX_FOCUS_RETRIES = 15;
const $106f18c55aeeccf9$export$8f1aa3f8d2941465 = ()=>({ setState: setState, getState: getState })=>{
        let retryCount = 0;
        const tryFocus = ()=>{
            const { quickstartButtonRef: quickstartButtonRef, isOpenedViaButton: isOpenedViaButton } = getState();
            if (quickstartButtonRef && isOpenedViaButton) {
                quickstartButtonRef.focus({
                    preventScroll: true
                });
                setState({
                    isOpenedViaButton: false
                });
            } else if (!quickstartButtonRef && retryCount < $106f18c55aeeccf9$var$MAX_FOCUS_RETRIES) {
                // If ref not available yet due to button animation delay, try again
                retryCount++;
                requestAnimationFrame(tryFocus);
            }
        };
        // Uses requestAnimationFrame to wait until the ref is available
        requestAnimationFrame(tryFocus);
    };

});


parcelRegister("6R6zv", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $59fafcb385977eac$export$d4c72bab9d6cc13a);

var $9ycBx = parcelRequire("9ycBx");
const $59fafcb385977eac$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $9ycBx.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
    },
    quickstartButtonRef: null,
    isOpenedViaButton: false
};

});


const $44259bc988b99eaa$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $44259bc988b99eaa$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $44259bc988b99eaa$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $44259bc988b99eaa$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $44259bc988b99eaa$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $44259bc988b99eaa$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $44259bc988b99eaa$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $44259bc988b99eaa$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $44259bc988b99eaa$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $44259bc988b99eaa$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $44259bc988b99eaa$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $44259bc988b99eaa$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $44259bc988b99eaa$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $44259bc988b99eaa$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $44259bc988b99eaa$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $44259bc988b99eaa$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $44259bc988b99eaa$export$f8bf435a6066832c = 'button clicked';
const $44259bc988b99eaa$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $44259bc988b99eaa$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $44259bc988b99eaa$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $44259bc988b99eaa$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $44259bc988b99eaa$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $44259bc988b99eaa$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $44259bc988b99eaa$export$5908fa8acd2c0739 = 'filterListNudge';
const $44259bc988b99eaa$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $44259bc988b99eaa$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $44259bc988b99eaa$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $44259bc988b99eaa$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $44259bc988b99eaa$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $44259bc988b99eaa$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $44259bc988b99eaa$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $44259bc988b99eaa$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $44259bc988b99eaa$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $44259bc988b99eaa$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $44259bc988b99eaa$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $44259bc988b99eaa$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $44259bc988b99eaa$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $44259bc988b99eaa$export$a1be34032ee24f78 = 'shareProjectNudge';
const $44259bc988b99eaa$export$29fe6611cc093756 = 'summaryTabNudge';
const $44259bc988b99eaa$export$f107c06c0830f09d = 'reportsTabNudge';
const $44259bc988b99eaa$export$9749a972a54ad7ba = 'boardContainerNudge';
const $44259bc988b99eaa$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$b7fd448c62b5fb97 = 'listview';
const $44259bc988b99eaa$export$10c63dc5c09466d2 = 'boardview';
const $44259bc988b99eaa$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $44259bc988b99eaa$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $44259bc988b99eaa$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $44259bc988b99eaa$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $44259bc988b99eaa$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $44259bc988b99eaa$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $44259bc988b99eaa$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $44259bc988b99eaa$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $44259bc988b99eaa$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $44259bc988b99eaa$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $44259bc988b99eaa$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $44259bc988b99eaa$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("2Xsxh", function(module, exports) {
$parcel$export(module.exports, "withAsyncNudgeTarget", () => $e38a9da8bab7189c$export$f45e05c2289b21a4);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $gxP9D = parcelRequire("gxP9D");

var $4bItR = parcelRequire("4bItR");

const $e38a9da8bab7189c$export$f45e05c2289b21a4 = ({ entryPoint: entryPoint, entryPointParams: entryPointParams, nudgeId: nudgeId })=>{
    return function AsyncNudgeTargetWithAsyncNudgeTarget({ children: children, runtimeProps: runtimeProps }) {
        // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(entryPoint, entryPointParams);
        (0, $4bItR.useTrackMountedNudgesController)(nudgeId);
        const [nudgeStep] = (0, $gxP9D.useNudgeStep)();
        const [hasNudgeActive] = (0, $gxP9D.useHasNudgeActive)();
        const entryPointLoaded = (0, $eJOHy.useRef)(false);
        if (!entryPointLoaded.current && hasNudgeActive && nudgeStep === nudgeId) {
            entryPointActions.load();
            entryPointLoaded.current = true;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            id: (0, $44259bc988b99eaa$export$501e36925fa10eef),
            packageName: "jiraListOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            runtimeProps: runtimeProps
        }));
    };
};

});
parcelRegister("4bItR", function(module, exports) {
$parcel$export(module.exports, "useTrackMountedNudgesController", () => $c38db5a434cfd377$export$b759b5124fe0d138);

var $eJOHy = parcelRequire("eJOHy");

var $gxP9D = parcelRequire("gxP9D");
const $c38db5a434cfd377$export$b759b5124fe0d138 = (nudgeId)=>{
    const [, { addMountedNudge: addMountedNudge, removeMountedNudge: removeMountedNudge }] = (0, $gxP9D.useQuickstartActions)();
    (0, $eJOHy.useEffect)(()=>{
        addMountedNudge(nudgeId);
        return ()=>{
            removeMountedNudge(nudgeId);
        };
    }, [
        addMountedNudge,
        nudgeId,
        removeMountedNudge
    ]);
};

});


parcelRegister("jqMdt", function(module, exports) {
$parcel$export(module.exports, "getStartedListNudgeEntrypoint", () => $e01c67701edc3180$export$69d80773367d872c);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e01c67701edc3180$export$69d80773367d872c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4kNZi")), {
        moduleId: "3b9fe78b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4kNZi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dX6yW").then(()=>parcelRequire('9qxUw'));

});



parcelRegister("aNnbk", function(module, exports) {
$parcel$export(module.exports, "useIssueCreateMutation", () => $0ac2d5a51eab7fff$export$2a4bb6ab1e983642);
$parcel$export(module.exports, "CreateIssueController", () => $0ac2d5a51eab7fff$export$dac3b0377215001c);

var $iAojs = parcelRequire("iAojs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $2ApNu = parcelRequire("2ApNu");

var $h1PFK = parcelRequire("h1PFK");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $6bbL3 = parcelRequire("6bbL3");

var $3ElzA = parcelRequire("3ElzA");

var $sJrIm = parcelRequire("sJrIm");

var $8SzGK = parcelRequire("8SzGK");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $d0yFI = parcelRequire("d0yFI");

var $5NEjg = parcelRequire("5NEjg");

var $fidcQ = parcelRequire("fidcQ");

var $dhVsI = parcelRequire("dhVsI");

var $4uses = parcelRequire("4uses");

var $5hgjg = parcelRequire("5hgjg");
const $0ac2d5a51eab7fff$var$ACTION_SUBJECT_ID = 'issueTableIssueCreate';
const $0ac2d5a51eab7fff$var$PACKAGE_LOCATION = 'jira-native-issue-table-inline-issue-create';
const $0ac2d5a51eab7fff$var$issueConnectionMutationUpdater = (store, response, issueConnectionId, insertionArgs, parentItemConnectionId, projectKey, groupId)=>{
    const issue = response?.jira?.createIssue?.issue;
    const issueId = issue?.__id; // it's always defined, but relay types it as nullable, relay sets this field whether it's there or not.
    if (!issue || !issueId) return;
    (0, $d0yFI.issueConnectionUpdater)(store, {
        ...insertionArgs,
        issue: issue,
        issueConnectionId: issueConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        issueRecordId: issueId,
        fieldSetsConnectionId: issue.fieldSetsById?.__id ?? '',
        projectKey: projectKey,
        groupId: groupId
    });
};
const $0ac2d5a51eab7fff$export$2a4bb6ab1e983642 = ({ issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql, location: location, rankFieldTerms: rankFieldTerms })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const handleErrorIIC = (0, $h1PFK.useIssueCreateOnError)();
    const shouldSkipIssuesConnectionUpdateAndShowFlag = (0, $6bbL3.useShouldSkipIssuesConnectionUpdate)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const isSkipIssueCreateSuccessFlagEnabled = (0, $34oCh.useIsSkipIssueCreateSuccessFlagEnabled)();
    const { onSortChange: onSortChange } = (0, $sJrIm.useSortContext)();
    const { onIssueCreated: onIssueCreated } = (0, $8SzGK.useEventHandlers)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const onIssueFetchAndAppend = (0, $fidcQ.useIssueFetchAndAppend)({
        issueConnectionId: issueConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql
    });
    const { generateOptimisticId: generateOptimisticId, getRealId: getRealId } = (0, $5hgjg.useOptimisticId)();
    let queuedCommit;
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const generateDeferredVariables = (0, $eJOHy.useCallback)((oldVariables)=>{
            const rank = oldVariables.issueCreateInput.rank;
            if (rank) return {
                ...oldVariables,
                issueCreateInput: {
                    ...oldVariables.issueCreateInput,
                    rank: {
                        ...rank,
                        afterIssueId: rank.afterIssueId ? getRealId(rank.afterIssueId) ?? rank.afterIssueId : rank.afterIssueId,
                        beforeIssueId: rank.beforeIssueId ? getRealId(rank.beforeIssueId) ?? rank.beforeIssueId : rank.beforeIssueId
                    }
                }
            };
            return oldVariables;
        }, [
            getRealId
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        queuedCommit = (0, $3ElzA.useQueuedMutationCommit)({
            generateDeferredVariables: generateDeferredVariables
        });
    }
    const [commit] = (0, $j4oe4.useMutation)((0, $iAojs.default), queuedCommit);
    const projectKey = (0, $34oCh.useProjectContext)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE),
        attributes: {
            isGroupIssueCreate: !!groupContextFieldInput
        }
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8jOO7.INLINE_ISSUE_CREATE_EXPERIENCE)
    });
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)((issueToCreate, contextualFields, insertionArgs)=>{
        const issueCreateInput = (0, $dhVsI.toIssueCreateInput)(issueToCreate, contextualFields, groupContextFieldInput, isIssueRankingEnabled);
        if (!issueCreateInput || issueConnectionId == null) return;
        const insertionArgsWithIdGetter = insertionArgs == null ? insertionArgs : {
            ...insertionArgs,
            getRealId: getRealId
        };
        const experienceExtraAttributes = location && (0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') ? {
            actionLocation: location
        } : undefined;
        const handleError = async (error)=>{
            const response = await handleErrorIIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput,
                error: error,
                onFail: (e)=>onExperienceFail($0ac2d5a51eab7fff$var$PACKAGE_LOCATION, e, experienceExtraAttributes)
            });
            if (response) {
                onIssueFetchAndAppend(response, insertionArgsWithIdGetter);
                onExperienceSuccess(experienceExtraAttributes);
            }
        };
        const { id: optimisticId, saveRealId: saveRealId } = generateOptimisticId();
        onExperienceStart();
        commit({
            variables: {
                issueCreateInput: issueCreateInput,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                isIdFieldEnabled: !(0, $4cTDP.fg)('nin-optimistic-flashing-fix'),
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isTimelineEnabled: isTimelineEnabled,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded,
                projectKey: projectKey,
                ...groupContextFieldInput ? {
                    shouldQueryFieldsByIdOrAlias: true,
                    fieldIdsOrAliases: [
                        groupContextFieldInput.fieldId
                    ]
                } : {
                    shouldQueryFieldsByIdOrAlias: false,
                    fieldIdsOrAliases: []
                },
                ...jql ? {
                    shouldQueryMatchesIssueSearch: true,
                    issueSearchInput: {
                        jql: jql
                    }
                } : {
                    shouldQueryMatchesIssueSearch: false,
                    issueSearchInput: {
                        jql: ''
                    }
                }
            },
            optimisticResponse: (0, $4uses.toOptimisticResponse)(issueToCreate, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput),
            optimisticUpdater: (store, response)=>$0ac2d5a51eab7fff$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey),
            updater: (store, response)=>{
                if (response != null && response?.jira?.createIssue?.issue?.id != null) saveRealId(response?.jira?.createIssue?.issue?.id);
                if (shouldSkipIssuesConnectionUpdateAndShowFlag(groupContextFieldInput, response?.jira?.createIssue?.issue, isIssueRankingEnabled, onSortChange, rankFieldTerms, isSkipIssueCreateSuccessFlagEnabled)) return;
                return $0ac2d5a51eab7fff$var$issueConnectionMutationUpdater(store, response, issueConnectionId, insertionArgsWithIdGetter, parentItemConnectionId, projectKey, groupContextFieldInput?.groupId);
            },
            onCompleted: (response)=>{
                const { errors: errors, issue: issue } = response?.jira?.createIssue ?? {};
                if (!issue) {
                    // Handle any GraphQL errors that occurred during issue create
                    errors && handleError(errors);
                    return;
                }
                // Event contributes towards Jira Monthly Core User, see https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition#%3Ajira%3A-Jira.
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', $0ac2d5a51eab7fff$var$ACTION_SUBJECT_ID, {
                    ...location && (0, $4cTDP.fg)('jsc_list_reranking_gate') && {
                        location: location
                    },
                    ...(0, $4cTDP.fg)('jira_render_pic_in_nin') && {
                        fields: {
                            hasAssignee: Boolean(issueToCreate.assignee),
                            hasDueDate: Boolean(issueToCreate.dueDate)
                        }
                    },
                    ...(0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') && {
                        issueHierarchy: issueToCreate.issueType.hierarchy?.level,
                        parentId: contextualFields.parentIssueAri ? (0, $2ApNu.JiraIssueAri).parse(contextualFields.parentIssueAri).issueId : undefined,
                        issueType: issueToCreate.issueType.name,
                        location: location
                    }
                });
                onExperienceSuccess(experienceExtraAttributes);
                (0, $d0yFI.removeHighlightAfterDelay)(environment, issue);
                if (onIssueCreated && (0, $4cTDP.fg)('timeline_rollups_issue_table_callbacks')) onIssueCreated(issue.issueId);
            },
            onError: (error)=>{
                // Handle any network errors that occurred during issue create
                handleError(error);
            }
        });
    }, [
        groupContextFieldInput,
        isIssueRankingEnabled,
        issueConnectionId,
        getRealId,
        generateOptimisticId,
        onExperienceStart,
        commit,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        projectKey,
        jql,
        handleErrorIIC,
        onExperienceFail,
        onIssueFetchAndAppend,
        onExperienceSuccess,
        parentItemConnectionId,
        shouldSkipIssuesConnectionUpdateAndShowFlag,
        onSortChange,
        rankFieldTerms,
        createAnalyticsEvent,
        location,
        environment,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isEditableSyncLoaded,
        isSkipIssueCreateSuccessFlagEnabled,
        onIssueCreated
    ]);
};
const $0ac2d5a51eab7fff$export$dac3b0377215001c = ({ childConnectionId: childConnectionId, parentItemConnectionId: parentItemConnectionId, groupContextFieldInput: groupContextFieldInput, setOnCreateIssue: setOnCreateIssue, jql: jql, location: location, rankFieldTerms: rankFieldTerms })=>{
    const onCreateIssue = $0ac2d5a51eab7fff$export$2a4bb6ab1e983642({
        issueConnectionId: childConnectionId,
        parentItemConnectionId: parentItemConnectionId,
        groupContextFieldInput: groupContextFieldInput,
        jql: jql,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            location: location,
            rankFieldTerms: rankFieldTerms
        }
    });
    setOnCreateIssue(onCreateIssue);
    return null;
};

});
parcelRegister("iAojs", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f5b2705fa486e2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1c5d6359dbad0d341d506ff7414a309>>
 * @relayHash 751cfcf3fd1ddf8776f7df66a461accf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d5bfd972fde66029f4613327f0f763b28fe23988fcf40528ed023963d9019f0

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $FU9UR = parcelRequire("FU9UR");
const $6f5b2705fa486e2d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIdFieldEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueHierarchyEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueCreateInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "issueCreateInput"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = {
        "condition": "isIdFieldEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = {
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v22 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v23 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v24 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v26 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "name"
    }, v29 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v29 /*: any*/ 
                ]
            }
        ],
        "type": "JiraPriorityField"
    }, v31 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v32 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v33 = [
        v32 /*: any*/ 
    ], v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v36 = {
        "kind": "ScalarField",
        "name": "number"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v28 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    }, v39 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v33 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ], v40 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v41 = [
        v40 /*: any*/ 
    ], v42 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v43 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = [
        v19 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "type"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "value"
    }, v48 = [
        v47 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v49 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v50 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v51 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v52 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v53 = {
        "kind": "ScalarField",
        "name": "date"
    }, v54 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "text"
    }, v56 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v58 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v57 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v19 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v62 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v63 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v58 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v65 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v66 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v67 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v68 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v69 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v44 /*: any*/ 
    }, v70 = {
        "kind": "ScalarField",
        "name": "href"
    }, v71 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v72 = [
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v53 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v19 /*: any*/ 
    ], v73 = [
        v40 /*: any*/ ,
        v19 /*: any*/ 
    ], v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v73 /*: any*/ 
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v75 = [
        v25 /*: any*/ ,
        v19 /*: any*/ 
    ], v76 = [
        v32 /*: any*/ ,
        v19 /*: any*/ 
    ], v77 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v76 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateIssueControllerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "highlightIssueRow"
                                        },
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v24 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        v30 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": v33 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v34 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": v33 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v39 /*: any*/ ,
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v39 /*: any*/ ,
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v41 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "version",
                                                                    "plural": false,
                                                                    "selections": v41 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleVersionPickerField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v42 /*: any*/ ,
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isConditionalFormattingEnabled",
                                                            "variableName": "isConditionalFormattingEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isDensityFull",
                                                            "variableName": "isDensityFull"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isEditableSyncLoaded",
                                                            "variableName": "isEditableSyncLoaded"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isInlineEditingEnabled",
                                                            "variableName": "isInlineEditingEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isLinkRelationshipFieldEnabled",
                                                            "variableName": "isLinkRelationshipFieldEnabled"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isTimelineEnabled",
                                                            "variableName": "isTimelineEnabled"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "IssueRow_fieldSets"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                v14 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "CreateIssueControllerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraIssueCreatePayload",
                            "kind": "LinkedField",
                            "name": "createIssue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v44 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldSetId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v48 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v48 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v53 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v55 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v57 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v59 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v60 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v19 /*: any*/ ,
                                                                                                        v21 /*: any*/ ,
                                                                                                        v61 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                v55 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                                        v22 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                                v57 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v63 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v54 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v19 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v34 /*: any*/ ,
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v58 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v19 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isResolved"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v66 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                v36 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v32 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v32 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v31 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v49 /*: any*/ ,
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v49 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v19 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v40 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                v69 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v69 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v49 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v50 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v70 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v70 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v49 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v66 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v44 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v56 /*: any*/ ,
                                                                                                        v49 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssueField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentIssue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v21 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v71 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v72 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v71 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v72 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v17 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v50 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                v30 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                v74 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v62 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v75 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v75 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "condition": "isIssueHierarchyEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v19 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v23 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldQueryFieldsByIdOrAlias",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v24 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraPriorityField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": v76 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v34 /*: any*/ ,
                                                                    "concreteType": "JiraSprintConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedSprintsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprintEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprint",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedSprintsConnection(first:1)"
                                                                }
                                                            ],
                                                            "type": "JiraSprintField"
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": v76 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v77 /*: any*/ ,
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v77 /*: any*/ ,
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v73 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        v74 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v42 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d5bfd972fde66029f4613327f0f763b28fe23988fcf40528ed023963d9019f0",
            "metadata": {},
            "name": "CreateIssueControllerMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$6f5b2705fa486e2d$var$node.hash = "2a101e882bc4ee8ec9c444bca45c2a46";
var $6f5b2705fa486e2d$export$2e2bcd8739ae039 = $6f5b2705fa486e2d$var$node;

});

parcelRegister("2ApNu", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAri", () => $1e22f45952f0c501$export$1da6808e89ee03e);

var $dhskT = parcelRequire("dhskT");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue/manifest.ts
var $1e22f45952f0c501$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dhskT.JiraIssueAriResourceOwner),
    resourceType: (0, $dhskT.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $1e22f45952f0c501$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dhskT", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $9ab2d7d34ec0a003$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $9ab2d7d34ec0a003$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $9ab2d7d34ec0a003$export$665a39f1b4e29e0a = "jira", $9ab2d7d34ec0a003$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("h1PFK", function(module, exports) {
$parcel$export(module.exports, "useIssueCreateOnError", () => $0e9105b7566f222f$export$5a42366aaf5bc501);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $5ppNC = parcelRequire("5ppNC");

var $dwCPn = parcelRequire("dwCPn");
const $0e9105b7566f222f$var$isMutationValidationError = (errors)=>errors.some((error)=>error.extensions?.statusCode === 400);
const $0e9105b7566f222f$var$toError = (errors)=>{
    const statusCodes = new Set();
    errors.forEach((err)=>{
        const sc = err.extensions?.statusCode;
        if (sc) statusCodes.add(String(sc));
    });
    return new Error(`Fail to fallback to GIC extension status codes: ${statusCodes.size > 0 ? Array.from(statusCodes.values()).join(',') : 'No status'}`);
};
const $0e9105b7566f222f$export$5a42366aaf5bc501 = ()=>{
    const onFallbackToGIC = (0, $5ppNC.useFallbackToGIC)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    return (0, $eJOHy.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput, error: error, onFail: onFail })=>{
        let shouldFallbackToGIC;
        if (error instanceof Error) shouldFallbackToGIC = error instanceof (0, $14RSn.ValidationError);
        else shouldFallbackToGIC = $0e9105b7566f222f$var$isMutationValidationError(error);
        if (shouldFallbackToGIC) {
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'globalIssueCreate fallback', 'inlineIssueCreate');
            return onFallbackToGIC({
                issueToCreate: issueToCreate,
                contextualFields: contextualFields,
                groupContextFieldInput: groupContextFieldInput
            });
        }
        // Fire error analytics event and display flag if we were unable to fallback to GIC
        (0, $9pTd3.fireErrorAnalytics)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'inlineIssueCreate',
                packageName: (0, $23b4218cfd94fe9f$export$b8b9d90f9e5bd72b),
                teamName: (0, $23b4218cfd94fe9f$export$d57b6b390e78d90f)
            },
            error: error instanceof Error ? error : undefined,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $dwCPn.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $dwCPn.default).errorFlagTitleNonFinal),
            description: formatMessage((0, $dwCPn.default).errorFlagDescriptionNonFinal),
            messageId: 'issue-table-inline-issue-create.controllers.use-issue-create-on-error.show-flag.error',
            messageType: 'transactional'
        });
        onFail?.(error instanceof Error ? error : $0e9105b7566f222f$var$toError(error));
        return Promise.resolve(null);
    }, [
        createAnalyticsEvent,
        formatMessage,
        onFallbackToGIC,
        showFlag
    ]);
};

});
parcelRegister("5ppNC", function(module, exports) {
$parcel$export(module.exports, "useFallbackToGIC", () => $8dac54862ef56e31$export$1682627434940303);

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $3T7mg = parcelRequire("3T7mg");

var $2ApNu = parcelRequire("2ApNu");

var $4cTDP = parcelRequire("4cTDP");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $8ntPR = parcelRequire("8ntPR");

var $3mZMJ = parcelRequire("3mZMJ");
const $8dac54862ef56e31$var$issueIdFromAri = (ari)=>(0, $2ApNu.JiraIssueAri).parse(ari).issueId;
const $8dac54862ef56e31$var$toGICAdditionalFields = ({ rankFieldId: rankFieldId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId }, groupContextFieldInput)=>{
    const additionalFields = {};
    if (rankFieldId && (rankBeforeIssueId || rankAfterIssueId)) {
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) additionalFields[rankFieldId] = {
            ...rankBeforeIssueId ? {
                rankBeforeIssue: $8dac54862ef56e31$var$issueIdFromAri(rankBeforeIssueId)
            } : {},
            ...rankAfterIssueId ? {
                rankAfterIssue: $8dac54862ef56e31$var$issueIdFromAri(rankAfterIssueId)
            } : {}
        };
        else additionalFields[rankFieldId] = {
            ...rankBeforeIssueId ? {
                rankBeforeIssue: rankBeforeIssueId
            } : {},
            ...rankAfterIssueId ? {
                rankAfterIssue: rankAfterIssueId
            } : {}
        };
    }
    if (groupContextFieldInput) return {
        ...additionalFields,
        ...(0, $8ntPR.convertFieldToGICAdditionalFieldsPayload)(groupContextFieldInput)
    };
    return additionalFields;
};
const $8dac54862ef56e31$export$1682627434940303 = ()=>{
    const openIssueCreateModal = (0, $jipjz.useOpenIssueCreateModal)();
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    return (0, $eJOHy.useCallback)(({ issueToCreate: issueToCreate, contextualFields: contextualFields, groupContextFieldInput: groupContextFieldInput })=>{
        const { project: { projectId: projectId }, issueType: { issueTypeId: issueTypeId }, summary: summary, assignee: assignee, dueDate: dueDate } = issueToCreate;
        const payload = {
            project: {
                projectId: projectId
            },
            issueType: {
                issueTypeId: issueTypeId
            },
            ...contextualFields.parentIssueAri ? {
                parentId: {
                    parentId: $8dac54862ef56e31$var$issueIdFromAri(contextualFields.parentIssueAri)
                }
            } : {},
            ...groupContextFieldInput?.fieldType === (0, $3mZMJ.STATUS_TYPE) ? (0, $8ntPR.convertFieldToStatusGICInput)(groupContextFieldInput) : {},
            defaultValues: {
                singleLineTextFields: [
                    {
                        fieldId: 'summary',
                        text: summary
                    }
                ],
                ...assignee && (0, $4cTDP.fg)('jira_render_pic_in_nin') && {
                    singleSelectUserPickerFields: [
                        {
                            fieldId: 'assignee',
                            user: {
                                accountId: assignee.accountId
                            }
                        }
                    ]
                },
                ...dueDate && (0, $4cTDP.fg)('jira_render_pic_in_nin') && {
                    datePickerFields: [
                        {
                            fieldId: 'duedate',
                            date: {
                                formattedDate: (0, $57raR.default)((0, $3T7mg.default)(dueDate), 'yyyy-MM-dd')
                            }
                        }
                    ]
                },
                ...contextualFields.parentIssueAri ? {
                    parentField: {
                        issueId: $8dac54862ef56e31$var$issueIdFromAri(contextualFields.parentIssueAri)
                    }
                } : {},
                ...groupContextFieldInput ? (0, $8ntPR.convertFieldToIssueCreateInput)(groupContextFieldInput) : {}
            }
        };
        return new Promise((resolve)=>{
            const unsubscribe = subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or cancelled
            const onClose = (data)=>{
                const result = data?.[0]?.issueKey ?? null;
                resolve(result);
                unsubscribe();
            };
            const isSubTaskCreationOpen = !!(issueToCreate.issueType?.hierarchy?.level === -1);
            openIssueCreateModal({
                payload: payload,
                context: {
                    projectId: projectId,
                    submitApiData: {
                        additionalFields: $8dac54862ef56e31$var$toGICAdditionalFields(contextualFields, groupContextFieldInput)
                    }
                },
                onClose: onClose,
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $84DOT.JIRA_ISSUE_TABLE_TRIGGER),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: false,
                disableCreationSuccessFlag: true,
                minimizableModalView: 'mini'
            });
        });
    }, [
        openIssueCreateModal,
        subscribe
    ]);
};

});
parcelRegister("xMjNG", function(module, exports) {
$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $6988db3fd722d63c$export$876003a5b887f37e);
const $6988db3fd722d63c$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("4PKlm", function(module, exports) {
$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8e36a2abc6a32ec2$export$e3ff72f196296fcc);

var $8Urkc = parcelRequire("8Urkc");
const $8e36a2abc6a32ec2$var$GICLifeCycleEventsService = new (0, $8Urkc.PubSubHub)();
const $8e36a2abc6a32ec2$export$e3ff72f196296fcc = ()=>({
        ...$8e36a2abc6a32ec2$var$GICLifeCycleEventsService
    });

});
parcelRegister("8Urkc", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $ef124bfbd3a417bb$export$e3607828f8f2c01e);
class $ef124bfbd3a417bb$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("8ntPR", function(module, exports) {
$parcel$export(module.exports, "isOptionFieldType", () => $1e3493a9d203145a$export$cdebdb13954c63c8);
$parcel$export(module.exports, "isVersionFieldType", () => $1e3493a9d203145a$export$3868397c63c76330);
$parcel$export(module.exports, "isUserFieldType", () => $1e3493a9d203145a$export$fe80a5e9db59a835);
$parcel$export(module.exports, "isGroupPickerFieldType", () => $1e3493a9d203145a$export$4f3a0ae044bc7de2);
$parcel$export(module.exports, "isLabelFieldType", () => $1e3493a9d203145a$export$fd0a45989264d2bb);
$parcel$export(module.exports, "isCreateIssueSupportedForFieldType", () => $1e3493a9d203145a$export$6a7d6e7c75a0955e);
$parcel$export(module.exports, "convertFieldToStatusGICInput", () => $1e3493a9d203145a$export$ff734d0b6c783fa9);
$parcel$export(module.exports, "convertFieldToGICAdditionalFieldsPayload", () => $1e3493a9d203145a$export$2bcbed170a89c245);
$parcel$export(module.exports, "convertFieldToIssueCreateInput", () => $1e3493a9d203145a$export$1492200cb52faf7c);
$parcel$export(module.exports, "toOptimisticField", () => $1e3493a9d203145a$export$4905b0508c306b7b);

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $gwBQn = parcelRequire("gwBQn");
const $1e3493a9d203145a$var$OPTION_FIELD_TYPES = new Set([
    (0, $3mZMJ.CATEGORY_TYPE),
    (0, $3mZMJ.SELECT_CF_TYPE),
    (0, $3mZMJ.MULTI_SELECT_CF_TYPE),
    (0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE),
    (0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)
]);
const $1e3493a9d203145a$var$VERSION_FIELD_TYPES = new Set([
    (0, $3mZMJ.VERSION_CF_TYPE),
    (0, $3mZMJ.MULTI_VERSION_CF_TYPE),
    (0, $3mZMJ.AFFECTS_VERSIONS_TYPE),
    (0, $3mZMJ.FIX_VERSIONS_TYPE)
]);
const $1e3493a9d203145a$var$LABEL_FIELD_TYPES = new Set([
    (0, $3mZMJ.LABELS_TYPE),
    (0, $3mZMJ.LABELS_CF_TYPE)
]);
const $1e3493a9d203145a$var$USER_FIELD_TYPES = new Set([
    (0, $3mZMJ.ASSIGNEE_TYPE),
    (0, $3mZMJ.REPORTER_TYPE),
    (0, $3mZMJ.USER_CF_TYPE)
]);
const $1e3493a9d203145a$var$GROUP_PICKER_FIELD_TYPES = new Set([
    (0, $3mZMJ.GROUP_CF_TYPE),
    (0, $3mZMJ.MULTI_GROUP_CF_TYPE)
]);
const $1e3493a9d203145a$export$f9c7798bde1b3073 = new Set([
    (0, $3mZMJ.PRIORITY_TYPE),
    (0, $3mZMJ.STATUS_TYPE),
    (0, $3mZMJ.LABELS_TYPE),
    (0, $3mZMJ.LABELS_CF_TYPE),
    (0, $3mZMJ.SPRINT_TYPE),
    (0, $3mZMJ.ISSUE_TYPE),
    ...$1e3493a9d203145a$var$OPTION_FIELD_TYPES,
    ...$1e3493a9d203145a$var$VERSION_FIELD_TYPES,
    ...$1e3493a9d203145a$var$USER_FIELD_TYPES,
    ...$1e3493a9d203145a$var$GROUP_PICKER_FIELD_TYPES
]);
const $1e3493a9d203145a$export$2ebdffdb7d794ccf = new Set([
    (0, $3mZMJ.NUMBER_CF_TYPE),
    (0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE)
]);
const $1e3493a9d203145a$export$8dd5b143c91a8104 = new Set([
    ...$1e3493a9d203145a$export$f9c7798bde1b3073,
    ...$1e3493a9d203145a$export$2ebdffdb7d794ccf
]);
const $1e3493a9d203145a$export$cdebdb13954c63c8 = (fieldType)=>$1e3493a9d203145a$var$OPTION_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$3868397c63c76330 = (fieldType)=>$1e3493a9d203145a$var$VERSION_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$fe80a5e9db59a835 = (fieldType)=>$1e3493a9d203145a$var$USER_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$4f3a0ae044bc7de2 = (fieldType)=>$1e3493a9d203145a$var$GROUP_PICKER_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$fd0a45989264d2bb = (fieldType)=>$1e3493a9d203145a$var$LABEL_FIELD_TYPES.has(fieldType);
const $1e3493a9d203145a$export$6a7d6e7c75a0955e = (fieldType)=>Boolean(fieldType && $1e3493a9d203145a$export$8dd5b143c91a8104.has(fieldType));
const $1e3493a9d203145a$export$ff734d0b6c783fa9 = ({ fieldValue: fieldValue })=>{
    if (fieldValue === null) return null;
    return {
        status: {
            statusId: fieldValue
        }
    };
};
const $1e3493a9d203145a$export$2bcbed170a89c245 = (groupContextFieldInput)=>{
    const { fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId } = groupContextFieldInput;
    if (fieldValue === null) return null;
    // Note: excluding status type and issue type as they're always shown in GIC
    switch(fieldType){
        case 0, $3mZMJ.PRIORITY_TYPE:
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue
                }
            };
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            if (typeof fieldValue === 'number') return {
                [fieldId]: fieldValue
            };
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $3mZMJ.SPRINT_TYPE:
            return {
                [fieldId]: {
                    id: fieldId,
                    value: fieldValue
                }
            };
        case 0, $3mZMJ.LABELS_CF_TYPE:
        case 0, $3mZMJ.LABELS_TYPE:
            return {
                [fieldId]: [
                    fieldValue
                ]
            };
        case 0, $3mZMJ.VERSION_CF_TYPE:
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
        case 0, $3mZMJ.CATEGORY_TYPE:
            return {
                [fieldId]: {
                    id: fieldValue,
                    value: fieldValue
                }
            };
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            return {
                [fieldId]: [
                    {
                        id: fieldValue
                    }
                ]
            };
        default:
            // note: this code path should never be reached as the typing on GroupContextField will only support supported field types
            return null;
    }
};
const $1e3493a9d203145a$export$1492200cb52faf7c = ({ fieldType: fieldType, fieldValue: fieldValue, fieldId: fieldId })=>{
    if (fieldValue === null) return null;
    // Note: excluding issue type as it's supported directly via inline issue create
    switch(fieldType){
        case 0, $3mZMJ.PRIORITY_TYPE:
            return {
                priority: {
                    priorityId: fieldValue
                }
            };
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
            return {
                singleSelectUserPickerFields: [
                    {
                        fieldId: fieldId,
                        user: {
                            accountId: fieldValue
                        }
                    }
                ]
            };
        case 0, $3mZMJ.STATUS_TYPE:
            return {
                status: {
                    statusId: fieldValue
                }
            };
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            return {
                numberFields: [
                    {
                        fieldId: fieldId,
                        value: fieldValue
                    }
                ]
            };
        case 0, $3mZMJ.CATEGORY_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
            return {
                singleSelectFields: [
                    {
                        fieldId: fieldId,
                        option: {
                            id: fieldValue,
                            optionId: fieldValue
                        }
                    }
                ]
            };
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            return {
                multipleSelectFields: [
                    {
                        fieldId: fieldId,
                        options: [
                            {
                                id: fieldValue,
                                optionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.VERSION_CF_TYPE:
            if ((0, $4cTDP.fg)('group_by_any_field_single_version_picker_fix')) return {
                singleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        version: {
                            versionId: fieldValue
                        }
                    }
                ]
            };
            return {
                multipleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        versions: [
                            {
                                versionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            return {
                multipleVersionPickerFields: [
                    {
                        fieldId: fieldId,
                        versions: [
                            {
                                versionId: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.SPRINT_TYPE:
            return {
                sprintsField: {
                    fieldId: fieldId,
                    sprints: [
                        {
                            sprintId: fieldValue
                        }
                    ]
                }
            };
        case 0, $3mZMJ.LABELS_CF_TYPE:
        case 0, $3mZMJ.LABELS_TYPE:
            return {
                labelsFields: [
                    {
                        fieldId: fieldId,
                        labels: [
                            {
                                name: fieldValue
                            }
                        ]
                    }
                ]
            };
        case 0, $3mZMJ.GROUP_CF_TYPE:
            return {
                singleGroupPickerFields: [
                    {
                        fieldId: fieldId,
                        group: {
                            groupName: fieldValue
                        }
                    }
                ]
            };
        case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
            return {
                multipleGroupPickerFields: [
                    {
                        fieldId: fieldId,
                        groups: [
                            {
                                groupName: fieldValue
                            }
                        ]
                    }
                ]
            };
        default:
            // note: this code path should never be reached as the typing on GroupContextField will only support supported field types
            return null;
    }
};
const $1e3493a9d203145a$export$4905b0508c306b7b = (issueId, { fieldId: fieldId, fieldType: fieldType, optimisticResponse: optimisticResponse })=>{
    // Note: excluding issue type as it's supported separately
    switch(optimisticResponse?.type){
        case 0, $3mZMJ.PRIORITY_TYPE:
            return (0, $gwBQn.toOptimisticPriority)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
            return (0, $gwBQn.toOptimisticUser)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.STATUS_TYPE:
            return (0, $gwBQn.toOptimisticStatus)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.CATEGORY_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
            return (0, $gwBQn.toOptimisticSingleSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
            return (0, $gwBQn.toOptimisticRadioSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
            return (0, $gwBQn.toOptimisticMultiSelect)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            return (0, $gwBQn.toOptimisticCheckbox)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.SPRINT_TYPE:
            return (0, $gwBQn.toOptimisticSprint)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            return (0, $gwBQn.toOptimisticNumber)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.LABELS_TYPE:
        case 0, $3mZMJ.LABELS_CF_TYPE:
            return (0, $gwBQn.toOptimisticLabels)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
            return (0, $gwBQn.toOptimisticMultiGroup)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        // Note: Excluding VERSION_CF_TYPE as it's a fallback field.
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
            return (0, $gwBQn.toOptimisticMultiVersion)({
                issueId: issueId,
                fieldId: fieldId,
                fieldType: fieldType,
                value: optimisticResponse
            });
        default:
            return null;
    }
};

});
parcelRegister("gwBQn", function(module, exports) {
$parcel$export(module.exports, "toOptimisticPriority", () => $bed603991fa02297$export$b0e8bb5f2ea51c4f);
$parcel$export(module.exports, "toOptimisticUser", () => $bed603991fa02297$export$afc99b621d72ef26);
$parcel$export(module.exports, "toOptimisticStatus", () => $bed603991fa02297$export$3e4b4b49e4ee4e20);
$parcel$export(module.exports, "toOptimisticSingleSelect", () => $bed603991fa02297$export$71ead0fa097cead6);
$parcel$export(module.exports, "toOptimisticRadioSelect", () => $bed603991fa02297$export$f32e937f8185cba6);
$parcel$export(module.exports, "toOptimisticMultiSelect", () => $bed603991fa02297$export$a0aeb0a088349a7f);
$parcel$export(module.exports, "toOptimisticCheckbox", () => $bed603991fa02297$export$bdb06cc2dd7fdd79);
$parcel$export(module.exports, "toOptimisticSprint", () => $bed603991fa02297$export$d9be65aae3a85c75);
$parcel$export(module.exports, "toOptimisticNumber", () => $bed603991fa02297$export$4b7137aed66177e0);
$parcel$export(module.exports, "toOptimisticLabels", () => $bed603991fa02297$export$deffb20716f51298);
$parcel$export(module.exports, "toOptimisticMultiGroup", () => $bed603991fa02297$export$da80edba1526dc1d);
$parcel$export(module.exports, "toOptimisticMultiVersion", () => $bed603991fa02297$export$32cb633741e0efe2);
const $bed603991fa02297$export$b0e8bb5f2ea51c4f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { priority: priority, fieldSetId: fieldSetId } })=>({
        node: {
            fieldSetId: fieldSetId,
            type: fieldId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraPriorityField',
                            __isJiraIssueField: 'JiraPriorityField',
                            fieldId: fieldId,
                            id: `${issueId}/${fieldId}`,
                            type: fieldType,
                            name: 'Priority',
                            priority: priority
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$afc99b621d72ef26 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { user: user, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'User',
                            user: user ? {
                                __typename: 'AtlassianAccountUser',
                                accountStatus: 'active',
                                id: user.id,
                                accountId: user.accountId,
                                picture: user.picture,
                                name: user.name
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$3e4b4b49e4ee4e20 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { status: status, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraStatusField',
                            __isJiraIssueField: 'JiraStatusField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            status: status
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$71ead0fa097cead6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectField',
                            __isJiraIssueField: 'JiraSingleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'SingleSelectCustomField',
                            fieldOption: option ? {
                                id: option.id,
                                optionId: option.optionId,
                                value: option.value,
                                color: option.color
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$f32e937f8185cba6 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraRadioSelectField',
                            __isJiraIssueField: 'JiraRadioSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'RadioSelectField',
                            selectedOption: option ? {
                                id: option.id,
                                // NOTE: For radio select fields, the value is the id of the option
                                value: option.id,
                                label: option.value
                            } : null
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$a0aeb0a088349a7f = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleSelectField',
                            __isJiraIssueField: 'JiraMultipleSelectField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'MultiSelectCustomField',
                            selectedOptions: {
                                edges: option ? [
                                    {
                                        node: {
                                            id: option.id,
                                            optionId: option.optionId,
                                            value: option.value
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$bdb06cc2dd7fdd79 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { option: option, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraCheckboxesField',
                            __isJiraIssueField: 'JiraCheckboxesField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'MultiSelectCustomField',
                            selectedOptions: {
                                edges: option ? [
                                    {
                                        node: {
                                            id: option.id,
                                            value: option.value
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$d9be65aae3a85c75 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { sprint: sprint, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSprintField',
                            __isJiraIssueField: 'JiraSprintField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Sprint',
                            selectedSprintsConnection: {
                                edges: sprint ? [
                                    {
                                        node: {
                                            id: sprint.id,
                                            sprintId: sprint.sprintId,
                                            name: sprint.name,
                                            state: sprint.state,
                                            endDate: sprint.endDate
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$4b7137aed66177e0 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId, isStoryPointField: isStoryPointField } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraNumberField',
                            __isJiraIssueField: 'JiraNumberField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Story point estimate',
                            number: value,
                            isStoryPointField: isStoryPointField
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$deffb20716f51298 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId } })=>{
    return {
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraLabelsField',
                            __isJiraIssueField: 'JiraLabelsField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Labels',
                            selectedLabelsConnection: {
                                totalCount: value ? 1 : 0,
                                edges: value ? [
                                    {
                                        node: {
                                            name: value,
                                            color: null
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    };
};
const $bed603991fa02297$export$da80edba1526dc1d = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { value: value, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleGroupPickerField',
                            __isJiraIssueField: 'JiraMultipleGroupPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Groups',
                            selectedGroupsConnection: {
                                edges: value ? [
                                    {
                                        node: value
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });
const $bed603991fa02297$export$32cb633741e0efe2 = ({ issueId: issueId, fieldId: fieldId, fieldType: fieldType, value: { version: version, fieldSetId: fieldSetId } })=>({
        node: {
            type: fieldType,
            fieldSetId: fieldSetId,
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraMultipleVersionPickerField',
                            __isJiraIssueField: 'JiraMultipleVersionPickerField',
                            fieldId: fieldId,
                            type: fieldType,
                            id: `${issueId}/${fieldId}`,
                            name: 'Versions',
                            selectedVersionsConnection: {
                                edges: version ? [
                                    {
                                        node: {
                                            id: version.id,
                                            value: version.id,
                                            name: version.name,
                                            label: version.name,
                                            versionId: version.versionId
                                        }
                                    }
                                ] : []
                            }
                        }
                    }
                ]
            }
        }
    });

});



parcelRegister("dwCPn", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f04f10d016508d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $10f04f10d016508d$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-non-final",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescriptionNonFinal: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-table-inline-issue-create.controllers.use-issue-create-on-error.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We weren't able to create a work item"
    }
});
var $10f04f10d016508d$export$2e2bcd8739ae039 = $10f04f10d016508d$var$messages;

});


parcelRegister("6bbL3", function(module, exports) {
$parcel$export(module.exports, "useShouldSkipIssuesConnectionUpdate", () => $586a076f65fa653e$export$39d39d16a578afb3);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $cSXp8 = parcelRequire("cSXp8");

var $3hRxq = parcelRequire("3hRxq");

var $3mZMJ = parcelRequire("3mZMJ");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $k9oyv = parcelRequire("k9oyv");
const $586a076f65fa653e$export$ce7751641b93537d = (0, $3hRxq.createLocalStorageProvider)('jira-native-issue-table-inline-issue-create');
const $586a076f65fa653e$export$39d39d16a578afb3 = ()=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireApplyRankingAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'applyRankingFromSuccessFlag');
    }, [
        createAnalyticsEvent
    ]);
    const fireViewWorkItemUIAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewWorkItemFromSuccessFlag');
    }, [
        createAnalyticsEvent
    ]);
    // TODO convert params into an object
    return (0, $eJOHy.useCallback)((groupContextField, createdIssue, isIssueRankingEnabled = false, onSortChange, rankFieldTerms, isSkipIssueCreateSuccessFlagEnabled = false)=>{
        if (!createdIssue) return false;
        // Determines whether to show the default success flag or the reranking prompt success flag
        const showDefaultSuccessFlag = (issueKey)=>{
            const issueCreatedCount = $586a076f65fa653e$export$ce7751641b93537d.get('issueCreatedCount') ?? 0;
            if (issueCreatedCount < 3) {
                $586a076f65fa653e$export$ce7751641b93537d.set('issueCreatedCount', issueCreatedCount + 1);
                showFlag((0, $k9oyv.getIssueCreateRerankingPromptSuccessFlag)({
                    issueKey: issueKey,
                    onSortChange: onSortChange,
                    rankFieldTerms: rankFieldTerms,
                    fireApplyRankingAnalytics: fireApplyRankingAnalytics,
                    fireViewWorkItemUIAnalytics: fireViewWorkItemUIAnalytics
                }));
            } else showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
        };
        const issueKey = createdIssue.key;
        const event = createAnalyticsEvent({});
        if ((0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
            const matchesIssueSearch = createdIssue.matchesIssueSearch !== false;
            const hasGroupValueChanged = !!groupContextField && !(0, $k9oyv.fieldValueContainsGroupContextValue)(createdIssue, groupContextField, groupContextField.fieldId);
            const shouldSkipIssueConnectionUpdate = hasGroupValueChanged || !matchesIssueSearch;
            if (isSkipIssueCreateSuccessFlagEnabled) return shouldSkipIssueConnectionUpdate;
            if (!matchesIssueSearch) issueKey && showFlag((0, $k9oyv.getIssueCreateHiddenFlag)({
                issueKey: issueKey
            }));
            else if (hasGroupValueChanged && groupContextField?.fieldType === (0, $3mZMJ.STATUS_TYPE)) issueKey && showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey,
                statusName: (0, $k9oyv.getStatusName)(createdIssue)
            }));
            else if (!isIssueRankingEnabled && (0, $4cTDP.fg)('jsc_list_reranking_gate')) issueKey && showDefaultSuccessFlag(issueKey);
            else issueKey && showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            }));
            (0, $kRgKj.fireUIAnalytics)(event, 'issueCreatedInListFlag shown', {
                matchesIssueSearch: matchesIssueSearch,
                groupIssueCreateFieldType: groupContextField?.fieldType || null,
                hasGroupValueChanged: hasGroupValueChanged
            });
            return shouldSkipIssueConnectionUpdate;
        }
        if (isSkipIssueCreateSuccessFlagEnabled) return false;
        if (issueKey && (0, $4cTDP.fg)('jsc_list_reranking_gate')) {
            isIssueRankingEnabled ? showFlag((0, $k9oyv.getIssueCreateSuccessFlag)({
                issueKey: issueKey
            })) : showDefaultSuccessFlag(issueKey);
            (0, $kRgKj.fireUIAnalytics)(event, 'issueCreatedInListFlagNoGrouping shown', {});
        }
        return false;
    }, [
        createAnalyticsEvent,
        showFlag,
        fireApplyRankingAnalytics,
        fireViewWorkItemUIAnalytics
    ]);
};

});
parcelRegister("k9oyv", function(module, exports) {
$parcel$export(module.exports, "fieldValueContainsGroupContextValue", () => $690b1b9780012057$export$a22b68ac49a3d37c);
$parcel$export(module.exports, "getStatusName", () => $690b1b9780012057$export$25a87d7a26b3901c);
$parcel$export(module.exports, "getIssueCreateSuccessFlag", () => $690b1b9780012057$export$d4c1d656d8898934);
$parcel$export(module.exports, "getIssueCreateRerankingPromptSuccessFlag", () => $690b1b9780012057$export$3b825da3d0425a10);
$parcel$export(module.exports, "getIssueCreateHiddenFlag", () => $690b1b9780012057$export$58532011dc58b882);

var $eJOHy = parcelRequire("eJOHy");

var $4sprp = parcelRequire("4sprp");

var $3cMgR = parcelRequire("3cMgR");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $lFP7n = parcelRequire("lFP7n");
const $690b1b9780012057$export$a22b68ac49a3d37c = (createdIssue, groupContextField, fieldId)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === fieldId);
    let fieldValue;
    switch(issueField?.__typename){
        case 'JiraStatusField':
            fieldValue = issueField.status?.statusId ?? null;
            break;
        case 'JiraPriorityField':
            fieldValue = issueField.priority?.priorityId ?? null;
            break;
        case 'JiraSingleSelectUserPickerField':
            fieldValue = issueField.user?.accountId ?? null;
            break;
        case 'JiraSingleSelectField':
            fieldValue = issueField.fieldOption?.optionId ?? null;
            break;
        case 'JiraRadioSelectField':
            fieldValue = issueField.selectedOption?.optionId ?? null;
            break;
        case 'JiraCheckboxesField':
        case 'JiraMultipleSelectField':
            fieldValue = issueField.selectedOptions?.edges?.map((edge)=>edge?.node?.optionId).filter((optionId)=>!!optionId) ?? null;
            break;
        case 'JiraSprintField':
            fieldValue = issueField.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>!!sprintId) ?? null;
            break;
        case 'JiraNumberField':
            fieldValue = issueField.number ?? null;
            break;
        case 'JiraLabelsField':
            fieldValue = issueField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>!!name) ?? null;
            break;
        case 'JiraMultipleVersionPickerField':
            fieldValue = issueField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>!!versionId) ?? null;
            break;
        case 'JiraSingleVersionPickerField':
            fieldValue = issueField.version?.versionId ?? null;
            break;
        default:
            fieldValue = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(fieldValue)) return fieldValue === groupContextField.fieldValue;
    if (fieldValue.length === 0) return groupContextField.fieldValue === null;
    return typeof groupContextField.fieldValue === 'string' && fieldValue?.includes(groupContextField.fieldValue);
};
const $690b1b9780012057$export$25a87d7a26b3901c = (createdIssue)=>{
    const issueField = createdIssue.fieldsByIdOrAlias?.find((field)=>field?.fieldId === (0, $3mZMJ.STATUS_TYPE));
    return issueField?.status?.name;
};
const $690b1b9780012057$var$Bold = (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, chunk);
const $690b1b9780012057$export$d4c1d656d8898934 = ({ issueKey: issueKey, statusName: statusName })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: statusName ? [
            (0, $lFP7n.default).workItemChangedStatusDescription,
            {
                issueKey: issueKey,
                statusName: statusName,
                Bold: $690b1b9780012057$var$Bold
            }
        ] : undefined,
        actions: [
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });
const $690b1b9780012057$export$3b825da3d0425a10 = ({ issueKey: issueKey, onSortChange: onSortChange, rankFieldTerms: rankFieldTerms, fireApplyRankingAnalytics: fireApplyRankingAnalytics, fireViewWorkItemUIAnalytics: fireViewWorkItemUIAnalytics })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-reranking-prompt-success',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $lFP7n.default).rerankingPromptDescription,
            {
                issueKey: issueKey,
                Bold: $690b1b9780012057$var$Bold
            }
        ],
        actions: [
            {
                content: (0, $lFP7n.default).applyRanking,
                onClick: ()=>{
                    fireApplyRankingAnalytics();
                    rankFieldTerms?.jqlTerm && onSortChange?.(rankFieldTerms.jqlTerm, 'ASC', rankFieldTerms.aliases && (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? rankFieldTerms.aliases : undefined);
                }
            },
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`,
                onClick: ()=>{
                    fireViewWorkItemUIAnalytics();
                }
            }
        ]
    });
const $690b1b9780012057$export$58532011dc58b882 = ({ issueKey: issueKey })=>({
        id: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        type: 'success',
        messageId: 'issue-table-grouping-issue-create-utils.use-should-skip-issues-connection-update.flag.success.show-flag.success.flag.success.issue-create-hidden',
        messageType: 'transactional',
        isAutoDismiss: true,
        title: [
            (0, $lFP7n.default).workItemCreatedSuccessfullyTitle,
            {
                issueKey: issueKey
            }
        ],
        description: [
            (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $lFP7n.default).workItemHiddenDescription : (0, $lFP7n.default).issueHiddenDescription,
            {
                issueKey: issueKey,
                Bold: $690b1b9780012057$var$Bold
            }
        ],
        actions: [
            {
                content: [
                    (0, $lFP7n.default).viewWorkItem,
                    {
                        issueKey: issueKey
                    }
                ],
                href: `/browse/${issueKey}`
            }
        ]
    });

});
parcelRegister("lFP7n", function(module, exports) {
$parcel$export(module.exports, "default", () => $20d9124b1f2da319$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $20d9124b1f2da319$var$messages = (0, $7qGN1.defineMessages)({
    workItemCreatedSuccessfullyTitle: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-created-successfully-title",
        "defaultMessage": "Created {issueKey}"
    },
    workItemChangedStatusDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-changed-status-description",
        "defaultMessage": "Created <Bold>{issueKey}</Bold> with <Bold>{statusName}</Bold> status"
    },
    workItemHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all work items."
    },
    rerankingPromptDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.reranking-prompt-description",
        "defaultMessage": "Select <Bold>apply ranking</Bold> to create and reorder work in specific positions."
    },
    applyRanking: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.apply-ranking",
        "defaultMessage": "Apply ranking"
    },
    viewWorkItem: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.view-work-item",
        "defaultMessage": "View {issueKey}"
    },
    issueHiddenDescription: {
        "id": "issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.issue-hidden-description",
        "defaultMessage": "<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all issues."
    }
});
var $20d9124b1f2da319$export$2e2bcd8739ae039 = $20d9124b1f2da319$var$messages;

});



parcelRegister("3ElzA", function(module, exports) {
$parcel$export(module.exports, "useQueuedMutationCommit", () => $13f1b54ac5fcbf64$export$4eb3ddef28ed9675);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $13f1b54ac5fcbf64$export$4eb3ddef28ed9675 = ({ generateDeferredVariables: generateDeferredVariables })=>{
    const running = (0, $eJOHy.useRef)(false);
    const queue = (0, $eJOHy.useRef)([]);
    /**
   * Dispose of any queued commits (in backwards order) and requeue each commit (which will execute the first commit
   * immediately). We need to explicitly dispose and requeue commits so optimistic updates are performed in the
   * correct order when the first queued commit is executed.
   */ const dequeue = (0, $eJOHy.useCallback)(()=>{
        running.current = false;
        const requeue = [];
        while(queue.current.length){
            const entry = queue.current.pop();
            if (entry) {
                entry.dispose();
                requeue.unshift(entry.requeue);
            }
        }
        requeue.forEach((fn)=>fn());
    }, []);
    const queuedCommit = (0, $eJOHy.useCallback)((environment, config)=>{
        const disposables = [];
        const requeue = ()=>{
            disposables.push(queuedCommit(environment, config));
        };
        const dispose = ()=>{
            while(disposables.length)disposables.pop()?.dispose();
        };
        const commit = ()=>{
            running.current = true;
            const disposable = (0, $j4oe4.commitMutation)(environment, {
                ...config,
                variables: generateDeferredVariables ? generateDeferredVariables(config.variables) : config.variables,
                onCompleted: (response, errors)=>{
                    // Run any queued commits after the mutation has completed
                    dequeue();
                    config.onCompleted?.(response, errors);
                },
                onError: (error)=>{
                    // Run any queued commits after the mutation has failed
                    dequeue();
                    config.onError?.(error);
                }
            });
            disposables.push(disposable);
        };
        if (!running.current) commit();
        else {
            const optimisticDisposable = (0, $j4oe4.applyOptimisticMutation)(environment, config);
            disposables.push(optimisticDisposable);
            queue.current.push({
                requeue: requeue,
                dispose: dispose
            });
        }
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: dispose
        };
    }, [
        dequeue,
        generateDeferredVariables
    ]);
    return queuedCommit;
};

});

parcelRegister("d0yFI", function(module, exports) {
$parcel$export(module.exports, "issueConnectionUpdater", () => $7fde21bc9a1cb8cc$export$340227f0fce3ad1b);
$parcel$export(module.exports, "removeHighlightAfterDelay", () => $7fde21bc9a1cb8cc$export$c6f131ddea3d52b7);

var $j4oe4 = parcelRequire("j4oe4");

var $afQ2l = parcelRequire("afQ2l");

var $8jOO7 = parcelRequire("8jOO7");

var $57Nys = parcelRequire("57Nys");

var $cf7fh = parcelRequire("cf7fh");
const $7fde21bc9a1cb8cc$export$340227f0fce3ad1b = (store, { issue: issue, issueConnectionId: issueConnectionId, parentItemConnectionId: parentItemConnectionId, issueRecordId: issueRecordId, fieldSetsConnectionId: fieldSetsConnectionId, insertAfter: insertAfter = true, insertNodeId: insertNodeId, getRealId: getRealId = (id)=>id, projectKey: projectKey, groupId: groupId })=>{
    (0, $afQ2l.highlightIssueRow)(store, issue, true);
    const issueRecord = store.get(issueRecordId);
    const connectionRecord = store.get(issueConnectionId);
    const fieldSetsRecord = store.get(fieldSetsConnectionId);
    if (!issueRecord || !connectionRecord || !fieldSetsRecord) return;
    if (parentItemConnectionId) {
        const updateArgs = projectKey ? {
            filterByProjectKeys: [
                projectKey
            ]
        } : undefined;
        store.get(parentItemConnectionId)?.setValue(true, 'hasChildren', updateArgs);
    }
    const edge = (0, $j4oe4.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    // don't insert the same edge in case optimisticUpdater gets called multiple times
    if ((0, $cf7fh.hasEdge)(connectionRecord, edge)) return;
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    let realNodeId = insertNodeId;
    if (insertNodeId != null) realNodeId = getRealId(insertNodeId) ?? insertNodeId;
    if (insertAfter) (0, $cf7fh.insertEdgeAfter)(connectionRecord, edge, realNodeId);
    else (0, $cf7fh.insertEdgeBefore)(connectionRecord, edge, realNodeId);
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + 1, 'totalIssueSearchResultCount');
    if (groupId) (0, $57Nys.updateGroupIssueCount)({
        store: store,
        groupId: groupId,
        netChangeInIssueCount: 1
    });
};
const $7fde21bc9a1cb8cc$export$c6f131ddea3d52b7 = (environment, issue)=>{
    setTimeout(()=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            (0, $afQ2l.highlightIssueRow)(store, issue, false);
        });
    }, (0, $8jOO7.HIGHLIGHT_LINGER_DURATION_MS));
};

});
parcelRegister("afQ2l", function(module, exports) {
$parcel$export(module.exports, "highlightIssueRow", () => $b2c45d2ca600a278$export$53e8a18b32fbb0d6);

var $h4uVA = parcelRequire("h4uVA");
const $b2c45d2ca600a278$export$53e8a18b32fbb0d6 = (store, issueRef, isHighlighted)=>{
    const { updatableData: updatableData } = store.readUpdatableFragment((0, $h4uVA.default), issueRef);
    updatableData.isHighlightedIssueRow = isHighlighted;
};

});
parcelRegister("h4uVA", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e72f79ee5962167$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<31b8657f09b7a729f0bb61efdd7b5bb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e72f79ee5962167$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "highlightIssueRow",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$4e72f79ee5962167$var$node.hash = "a9247a88904b4ab4be14f6ca46a6806e";
var $4e72f79ee5962167$export$2e2bcd8739ae039 = $4e72f79ee5962167$var$node;

});


parcelRegister("57Nys", function(module, exports) {
$parcel$export(module.exports, "getIssueIndexInConnection", () => $88b8327741a45694$export$fc68d8bf4e03e424);
$parcel$export(module.exports, "updateGroupIssueCount", () => $88b8327741a45694$export$9d5e7224bfc56344);
$parcel$export(module.exports, "updateParentHasChildren", () => $88b8327741a45694$export$49a0ddeeed46a5b);
$parcel$export(module.exports, "useUpdateConnectionDetails", () => $88b8327741a45694$export$8ce878b875ed1164);
$parcel$export(module.exports, "insertNewGroupInGroupsConnection", () => $88b8327741a45694$export$4369efd6760b11d0);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $4cTDP = parcelRequire("4cTDP");

var $dLXgn = parcelRequire("dLXgn");
const $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME = 'JiraSpreadsheetGroup';
const $88b8327741a45694$export$fc68d8bf4e03e424 = ({ issues: issues, issuesWithContext: issuesWithContext, context: context })=>{
    let foundMovedIssue = false;
    // There is a possible race condition where the bulk query for positions fires without all the issue subscriptions arriving (when an issue is created right as the timeout for the client finishes)
    // In those cases, we should use relative positioning instead of the absolute position where possible to prevent issues from being inserted at the wrong position
    const relativeIssueIndex = issues.findIndex((issue)=>{
        const issueId = issue.getLinkedRecord('node')?.getValue('issueId');
        if (issueId === context.sourceIssueId) foundMovedIssue = true;
        if (!issueId || typeof issueId === 'string' && issuesWithContext.has(issueId)) return false;
        return issueId === context.afterIssueId || issueId === context.beforeIssueId;
    });
    let relativePosition;
    if (relativeIssueIndex !== -1) {
        const relativeIssue = issues[relativeIssueIndex];
        const relativeIssueId = relativeIssue?.getLinkedRecord('node')?.getValue('issueId');
        if (relativeIssueId === context.afterIssueId) relativePosition = relativeIssueIndex;
        else if (relativeIssueId === context.beforeIssueId) relativePosition = relativeIssueIndex + 1;
        if (foundMovedIssue && relativePosition != null) // if we moved the issue down the list, we need to adjust the position otherwise its original position in the list impacts the index of all issues after
        relativePosition -= 1;
    }
    return relativePosition ?? context.position;
};
const $88b8327741a45694$var$removeGroupFromConnection = ({ store: store, groupId: groupId, connectionId: connectionId, groupConnectionId: groupConnectionId })=>{
    if (!groupConnectionId) return;
    if (connectionId) {
        // invalidate connection for next incoming updates.
        const connectionRecord = store.get(connectionId);
        connectionRecord?.invalidateRecord();
    }
    const relayId = (0, $kqd31.default)({
        id: groupId
    }, $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    const groupConnectionRecord = store.get(groupConnectionId);
    if (!groupConnectionRecord || !relayId) return;
    (0, $37Ewn.ConnectionHandler).deleteNode(groupConnectionRecord, relayId);
    // Remove the firstGroup reference if it's the same as the group being removed
    if (groupConnectionRecord.getLinkedRecord('firstGroup')?.getDataID() === relayId) groupConnectionRecord.setValue(null, 'firstGroup');
};
const $88b8327741a45694$export$9d5e7224bfc56344 = ({ store: store, groupId: groupId, netChangeInIssueCount: netChangeInIssueCount, groupConnectionId: groupConnectionId, connectionId: connectionId })=>{
    const relayId = (0, $kqd31.default)({
        id: groupId
    }, $88b8327741a45694$var$JIRA_SPREADSHEET_GROUP_TYPENAME);
    if (!relayId) return;
    const groupRecord = store.get(relayId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueCount = groupRecord?.getValue('issueCount') || 0;
    const newIssueCount = issueCount + netChangeInIssueCount;
    if (newIssueCount <= 0) $88b8327741a45694$var$removeGroupFromConnection({
        store: store,
        groupId: groupId,
        connectionId: connectionId,
        groupConnectionId: groupConnectionId
    });
    else groupRecord?.setValue(newIssueCount, 'issueCount');
};
const $88b8327741a45694$export$49a0ddeeed46a5b = ({ store: store, parentIssueEdgeRecordId: parentIssueEdgeRecordId, connectionId: connectionId, hasChildren: hasChildren, projectKey: projectKey })=>{
    // returns whether an update was performed
    const parentIssueRecord = store.get(parentIssueEdgeRecordId);
    const updateArgs = projectKey ? {
        filterByProjectKeys: [
            projectKey
        ]
    } : undefined;
    if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) !== hasChildren) {
        parentIssueRecord?.setValue(hasChildren, 'hasChildren', updateArgs);
        if (hasChildren === false && connectionId && (0, $4cTDP.fg)('jsc_list_reparenting')) {
            const connectionRecord = store.get(connectionId);
            connectionRecord?.invalidateRecord();
        }
        return true;
    }
    return false;
};
const $88b8327741a45694$export$8ce878b875ed1164 = ()=>{
    const { removeConnection: removeConnectionFromList } = (0, $dLXgn.useConnectionsListActions)();
    return (0, $eJOHy.useCallback)(({ store: store, connection: connection, netChangeInIssueCount: netChangeInIssueCount, remainingIssueCount: remainingIssueCount, groupConnectionId: groupConnectionId, projectKey: projectKey, hasAccurateGroupCounts: hasAccurateGroupCounts })=>{
        if (remainingIssueCount === undefined) return;
        switch(connection.type){
            case 'GROUP_CHILDREN':
                // we only want to manually update the group issue count if the group count is not accurate
                !hasAccurateGroupCounts && $88b8327741a45694$export$9d5e7224bfc56344({
                    store: store,
                    groupId: connection.groupId,
                    netChangeInIssueCount: netChangeInIssueCount,
                    groupConnectionId: groupConnectionId,
                    connectionId: connection.connectionId
                });
                break;
            case 'PARENT_CHILDREN':
                $88b8327741a45694$export$49a0ddeeed46a5b({
                    store: store,
                    parentIssueEdgeRecordId: connection.parentRelayId,
                    connectionId: connection.connectionId,
                    hasChildren: remainingIssueCount > 0,
                    projectKey: projectKey
                });
                break;
            case 'ROOT_ISSUES':
                {
                    const connectionRecord = store.get(connection.connectionId);
                    if (!connectionRecord) break;
                    const totalIssues = connectionRecord.getValue('totalIssueSearchResultCount');
                    if (totalIssues != null && typeof totalIssues === 'number') connectionRecord.setValue(totalIssues + netChangeInIssueCount, 'totalIssueSearchResultCount');
                    break;
                }
            default:
        }
        if (remainingIssueCount === 0) {
            if (connection.type !== 'PARENT_CHILDREN') removeConnectionFromList(connection);
        }
    }, [
        removeConnectionFromList
    ]);
};
function $88b8327741a45694$var$insertEdgeAtPosition(existingEdges, newEdge, index) {
    return [
        ...existingEdges.slice(0, index),
        newEdge,
        ...existingEdges.slice(index)
    ];
}
const $88b8327741a45694$export$4369efd6760b11d0 = ({ store: store, groupsConnection: groupsConnection, newGroup: newGroup, groupEdges: groupEdges, afterGroupId: afterGroupId })=>{
    const newGroupEdge = (0, $37Ewn.ConnectionHandler).createEdge(store, groupsConnection, newGroup, 'JiraSpreadsheetGroupEdge');
    if (afterGroupId === null) return $88b8327741a45694$var$insertEdgeAtPosition(groupEdges, newGroupEdge, 0);
    const afterGroupIndex = groupEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === afterGroupId);
    if (afterGroupIndex !== -1) return $88b8327741a45694$var$insertEdgeAtPosition(groupEdges, newGroupEdge, afterGroupIndex + 1);
    return groupEdges;
};

});

parcelRegister("cf7fh", function(module, exports) {
$parcel$export(module.exports, "insertEdgeBefore", () => $0d35c4acd0065c5a$export$af841f09852c57d0);
$parcel$export(module.exports, "insertEdgeAfter", () => $0d35c4acd0065c5a$export$10e6263a191d72a0);
$parcel$export(module.exports, "hasEdge", () => $0d35c4acd0065c5a$export$da04cd0b23213625);

var $37Ewn = parcelRequire("37Ewn");
const $0d35c4acd0065c5a$var$findEdgeIndex = (edges, id)=>{
    if (id == null) return -1;
    const { NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
    return edges.findIndex((edge)=>edge.getLinkedRecord(NODE)?.getValue('id') === id);
};
const $0d35c4acd0065c5a$export$af841f09852c57d0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $0d35c4acd0065c5a$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = [
        newEdge
    ].concat(edges);
    else nextEdges = edges.slice(0, index).concat(newEdge).concat(edges.slice(index));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $0d35c4acd0065c5a$export$10e6263a191d72a0 = (record, newEdge, id)=>{
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const index = $0d35c4acd0065c5a$var$findEdgeIndex(edges, id);
    let nextEdges;
    if (index === -1) nextEdges = edges.concat(newEdge);
    else nextEdges = edges.slice(0, index + 1).concat(newEdge).concat(edges.slice(index + 1));
    record.setLinkedRecords(nextEdges, EDGES);
};
const $0d35c4acd0065c5a$export$da04cd0b23213625 = (record, edge)=>{
    const { NODE: NODE, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES) ?? [];
    const edgeIndex = edges.findIndex((e)=>e.getLinkedRecord(NODE)?.getValue('id') === edge.getLinkedRecord(NODE)?.getValue('id'));
    return edgeIndex > -1;
};

});


parcelRegister("5NEjg", function(module, exports) {
$parcel$export(module.exports, "IssueFetchQueryVariablesContainer", () => $9a9cd43ba0376cc5$export$72556f17a9cf678b);
$parcel$export(module.exports, "useIssueFetchQueryVariables", () => $9a9cd43ba0376cc5$export$52ce8dcf7591a458);

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $9a9cd43ba0376cc5$export$72556f17a9cf678b = (0, $6E16M.createContainer)();
const $9a9cd43ba0376cc5$export$d4c72bab9d6cc13a = {
    fieldSetIds: []
};
const $9a9cd43ba0376cc5$var$updateStore = ()=>({ setState: setState, getState: getState }, { fieldSetIds: fieldSetIds })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(fieldSetIds, state.fieldSetIds)) setState({
            fieldSetIds: fieldSetIds
        });
    };
const $9a9cd43ba0376cc5$var$Store = (0, $GtRbT.createStore)({
    containedBy: $9a9cd43ba0376cc5$export$72556f17a9cf678b,
    initialState: $9a9cd43ba0376cc5$export$d4c72bab9d6cc13a,
    actions: {},
    handlers: {
        onInit: $9a9cd43ba0376cc5$var$updateStore,
        onContainerUpdate: $9a9cd43ba0376cc5$var$updateStore
    }
});
const $9a9cd43ba0376cc5$export$52ce8dcf7591a458 = (0, $iJq0l.createStateHook)($9a9cd43ba0376cc5$var$Store);

});

parcelRegister("fidcQ", function(module, exports) {
$parcel$export(module.exports, "useIssueFetchAndAppend", () => $88f0a96292e49178$export$e36c00c1dfa0c592);

var $6cWfq = parcelRequire("6cWfq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cHtIB = parcelRequire("cHtIB");

var $6bbL3 = parcelRequire("6bbL3");

var $34oCh = parcelRequire("34oCh");

var $d0yFI = parcelRequire("d0yFI");

var $5NEjg = parcelRequire("5NEjg");
const $88f0a96292e49178$var$issueConnectionQueryUpdater = (environment, response, issueConnectionId, insertionArgs, groupId)=>{
    const issue = response?.jira?.issueByKey;
    if (!issue) return;
    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
        (0, $d0yFI.issueConnectionUpdater)(store, {
            ...insertionArgs,
            issue: issue,
            issueConnectionId: issueConnectionId,
            issueRecordId: issue.__id,
            fieldSetsConnectionId: issue.fieldSetsById.__id,
            groupId: groupId
        });
    });
    (0, $d0yFI.removeHighlightAfterDelay)(environment, issue);
};
const $88f0a96292e49178$export$e36c00c1dfa0c592 = ({ issueConnectionId: issueConnectionId, groupContextFieldInput: groupContextFieldInput, jql: jql })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const shouldSkipIssuesConnectionUpdateAndShowFlag = (0, $6bbL3.useShouldSkipIssuesConnectionUpdate)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isSkipIssueCreateSuccessFlagEnabled = (0, $34oCh.useIsSkipIssueCreateSuccessFlagEnabled)();
    return (0, $eJOHy.useCallback)((issueKey, insertionArgs)=>{
        if (!issueConnectionId) return null;
        (0, $j4oe4.fetchQuery)(environment, (0, $6cWfq.default), {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isConditionalFormattingEnabled: false,
            ...groupContextFieldInput ? {
                shouldQueryFieldsByIdOrAlias: true,
                fieldIdsOrAliases: [
                    groupContextFieldInput.fieldId
                ]
            } : {
                shouldQueryFieldsByIdOrAlias: false,
                fieldIdsOrAliases: []
            },
            ...jql ? {
                shouldQueryMatchesIssueSearch: true,
                issueSearchInput: {
                    jql: jql
                }
            } : {
                shouldQueryMatchesIssueSearch: false,
                issueSearchInput: {
                    jql: ''
                }
            },
            isTimelineEnabled: isTimelineEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled
        }).subscribe({
            next: (data)=>{
                const shouldSkipIssueConnectionUpdate = shouldSkipIssuesConnectionUpdateAndShowFlag(groupContextFieldInput, data?.jira?.issueByKey, undefined, undefined, undefined, isSkipIssueCreateSuccessFlagEnabled);
                if (shouldSkipIssueConnectionUpdate === true) return;
                $88f0a96292e49178$var$issueConnectionQueryUpdater(environment, data, issueConnectionId, insertionArgs, groupContextFieldInput?.groupId);
            }
        });
    }, [
        cloudId,
        environment,
        fieldSetIds,
        isDensityFull,
        isInlineEditingEnabled,
        issueConnectionId,
        groupContextFieldInput,
        jql,
        shouldSkipIssuesConnectionUpdateAndShowFlag,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isSkipIssueCreateSuccessFlagEnabled
    ]);
};

});
parcelRegister("6cWfq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a997d931b3b4a26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<389d14ce702d9466b7b9e5bea5648808>>
 * @relayHash 8d96e0214d94172de6e201e743ecf0e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9f530082fb67a2534b391b3bb34284ab93a6a3107604a70104f0c769377e002

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $FU9UR = parcelRequire("FU9UR");
const $9a997d931b3b4a26$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldIdsOrAliases"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldsByIdOrAlias"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryMatchesIssueSearch"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "idsOrAliases",
            "variableName": "fieldIdsOrAliases"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "JiraPriorityField"
    }, v24 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "number"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            v29 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraLabelsField"
    }, v32 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v26 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v34 = [
        v33 /*: any*/ 
    ], v35 = {
        "condition": "shouldQueryMatchesIssueSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "kind": "ScalarField",
                "name": "matchesIssueSearch"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v38 = {
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "kind": "ScalarField",
        "name": "value"
    }, v40 = [
        v39 /*: any*/ ,
        v38 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v41 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v42 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v43 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v44 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "date"
    }, v46 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "text"
    }, v48 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v49 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v50 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v38 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v53 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v54 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v55 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v49 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v57 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v58 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v59 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v60 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v61 = [
        v38 /*: any*/ 
    ], v62 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v61 /*: any*/ 
    }, v63 = {
        "kind": "ScalarField",
        "name": "href"
    }, v64 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v65 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v45 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v38 /*: any*/ 
    ], v66 = [
        v33 /*: any*/ ,
        v38 /*: any*/ 
    ], v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v66 /*: any*/ 
            }
        ],
        "type": "JiraSingleVersionPickerField"
    }, v68 = [
        v18 /*: any*/ ,
        v38 /*: any*/ 
    ], v69 = [
        v25 /*: any*/ ,
        v38 /*: any*/ 
    ], v70 = [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v69 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIssueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "highlightIssueRow"
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSetsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isConditionalFormattingEnabled",
                                                        "variableName": "isConditionalFormattingEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isDensityFull",
                                                        "variableName": "isDensityFull"
                                                    },
                                                    {
                                                        "kind": "Literal",
                                                        "name": "isEditableSyncLoaded",
                                                        "value": false
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isInlineEditingEnabled",
                                                        "variableName": "isInlineEditingEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isLinkRelationshipFieldEnabled",
                                                        "variableName": "isLinkRelationshipFieldEnabled"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isTimelineEnabled",
                                                        "variableName": "isTimelineEnabled"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "IssueRow_fieldSets"
                                            },
                                            v16 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.issueByKey.fieldSetsById"
                                },
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "selectedOption",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraRadioSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "JiraMultipleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v32 /*: any*/ ,
                                                    "type": "JiraCheckboxesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v34 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "version",
                                                            "plural": false,
                                                            "selections": v34 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleVersionPickerField"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v35 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useIssueFetchAndAppendQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraIssueFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v36 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldSetId"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v36 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "serviceId"
                                                                                                                },
                                                                                                                v21 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraAffectedServicesField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraCascadingOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "cascadingOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "childOptionValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCascadingSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "objectId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "label"
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "mediaClientConfig",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "clientId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "fileId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "url48"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "QueryError",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "errors",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "message"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCMDBField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v43 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v45 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDatePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "dateTime"
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDateTimePickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraEpic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "epic",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "summary"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "color"
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraEpicLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "renderedFieldHtml"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFallbackField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v47 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusCategory",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusCategory",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v48 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusCategoryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraLabelConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedLabelsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraLabel",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v21 /*: any*/ ,
                                                                                                                v50 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraLabelsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "small"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentIssue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraColorField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueColorField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v50 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v51 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v47 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v14 /*: any*/ ,
                                                                                                v52 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ids",
                                                                                                                    "value": [
                                                                                                                        "issuetype",
                                                                                                                        "project",
                                                                                                                        "summary",
                                                                                                                        "status"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsById",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v47 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                v53 /*: any*/ ,
                                                                                                                                                v21 /*: any*/ ,
                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                v54 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "status",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "statusCategory",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                                        v48 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v54 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v55 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraParentIssueField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "large"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraResolution",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "resolution",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraResolutionField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedSprintsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprint",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "state"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "endDate"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSprintField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "appType"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "AppUser"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRichText",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "richText",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraADF",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "adfValue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "isDensityFull",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "json"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraRichTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "requestType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v51 /*: any*/ ,
                                                                                                v38 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v27 /*: any*/ ,
                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLinkConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "statusCategory"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v49 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                },
                                                                                                                                                v38 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "isResolved"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v58 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueLinkField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isStoryPointField"
                                                                                        },
                                                                                        v29 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v41 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "formatConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "formatStyle"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "formatUnit"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraNumberField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCommentSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commentSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canAddComment"
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraCommentSummaryField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "uri"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraUrlField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v39 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v25 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v39 /*: any*/ ,
                                                                                                                v25 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOptionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v39 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraCheckboxesField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraUserConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedUsersConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v57 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "email"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraTeamView",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedTeam",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jiraSuppliedName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraTeamViewField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v41 /*: any*/ ,
                                                                                                                v59 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v36 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "timeTrackingField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v59 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v36 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedOption",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "label",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraRadioSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraVersionConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedVersionsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v43 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v33 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v62 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraGoalConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGoals",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoal",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "status"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v16 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraGoalsField"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v62 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isLinkEditable"
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraTownsquareProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "alias": "atlasProjectName",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "name"
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": "atlasProjectKey",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "key"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "privateProject"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "hasPermission"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWorkspaceActive"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTownsquareProjectField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "args": v42 /*: any*/ ,
                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "pageContent",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v63 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ],
                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroupConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedGroupsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroup",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v38 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "groupId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraFlag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "flag",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFlagged"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraFlagField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraWatch",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "watch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "count"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isWatching"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraWatchesField"
                                                                                },
                                                                                {
                                                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLink",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "direction"
                                                                                                        },
                                                                                                        v58 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "type",
                                                                                                            "plural": false,
                                                                                                            "selections": v61 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraIssueLinkRelationshipTypeField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "isTimelineEnabled",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v14 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ ,
                                                                                                                        v54 /*: any*/ ,
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraParentIssueField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssueField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v55 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "assigneeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v18 /*: any*/ ,
                                                                                                                        v56 /*: any*/ ,
                                                                                                                        v38 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v64 /*: any*/ ,
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "startDateViewField",
                                                                                                            "plural": false,
                                                                                                            "selections": v65 /*: any*/ ,
                                                                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                        },
                                                                                                        {
                                                                                                            "args": v64 /*: any*/ ,
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "endDateViewField",
                                                                                                            "plural": false,
                                                                                                            "selections": v65 /*: any*/ ,
                                                                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraTimelineField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConditionalFormattingEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v42 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "componentId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v67 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v53 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValue",
                                                                                                    "plural": false,
                                                                                                    "selections": v68 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedValues",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v68 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                },
                                v38 /*: any*/ ,
                                {
                                    "condition": "shouldQueryFieldsByIdOrAlias",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "fieldsByIdOrAlias",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "fieldOption",
                                                            "plural": false,
                                                            "selections": v69 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedSprintsConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "selectedOption",
                                                            "plural": false,
                                                            "selections": v69 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraRadioSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v70 /*: any*/ ,
                                                    "type": "JiraMultipleSelectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v70 /*: any*/ ,
                                                    "type": "JiraCheckboxesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v66 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                v67 /*: any*/ ,
                                                v38 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v35 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9f530082fb67a2534b391b3bb34284ab93a6a3107604a70104f0c769377e002",
            "metadata": {},
            "name": "useIssueFetchAndAppendQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$9a997d931b3b4a26$var$node.hash = "92fe6d9520071592f5157038f57aedf9";
var $9a997d931b3b4a26$export$2e2bcd8739ae039 = $9a997d931b3b4a26$var$node;

});


parcelRegister("dhVsI", function(module, exports) {
$parcel$export(module.exports, "toIssueCreateInput", () => $9a20f8fc188f0eb6$export$8430ab93380b81ae);

var $16aVR = parcelRequire("16aVR");

var $57raR = parcelRequire("57raR");

var $4cTDP = parcelRequire("4cTDP");

var $8ntPR = parcelRequire("8ntPR");
const $9a20f8fc188f0eb6$var$mapContextualFieldDataToInput = (payload)=>{
    let rank;
    if (payload.rankBeforeIssueId) rank = {
        beforeIssueId: payload.rankBeforeIssueId
    };
    else if (payload.rankAfterIssueId) rank = {
        afterIssueId: payload.rankAfterIssueId
    };
    return {
        rank: rank
    };
};
const $9a20f8fc188f0eb6$var$generateRankInput = (payload)=>{
    if (payload.rankBeforeIssueId) return {
        beforeIssueId: payload.rankBeforeIssueId
    };
    if (payload.rankAfterIssueId) return {
        afterIssueId: payload.rankAfterIssueId
    };
    return undefined;
};
const $9a20f8fc188f0eb6$export$8430ab93380b81ae = ({ project: project, issueType: issueType, summary: summary, assignee: assignee, dueDate: dueDate }, contextualFields, groupContextFieldInput, isIssueRankingEnabled)=>{
    if (!summary.trim().length) return null;
    const input = {
        projectId: project.id,
        issueTypeId: issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: 'summary',
                    text: summary
                }
            ],
            ...contextualFields.parentIssueAri !== undefined && {
                parentField: {
                    issueId: contextualFields.parentIssueAri
                }
            },
            ...groupContextFieldInput && (0, $8ntPR.convertFieldToIssueCreateInput)(groupContextFieldInput),
            ...assignee && (0, $4cTDP.fg)('jira_render_pic_in_nin') && {
                singleSelectUserPickerFields: [
                    {
                        fieldId: 'assignee',
                        user: {
                            accountId: assignee.accountId
                        }
                    }
                ]
            },
            ...dueDate && (0, $4cTDP.fg)('jira_render_pic_in_nin') && {
                datePickerFields: [
                    {
                        fieldId: 'duedate',
                        date: {
                            formattedDate: (0, $57raR.default)(dueDate, 'dd/MMM/yy')
                        }
                    }
                ]
            }
        },
        rank: isIssueRankingEnabled && (0, $4cTDP.fg)('jsc_list_reranking_gate') ? $9a20f8fc188f0eb6$var$generateRankInput(contextualFields) : undefined
    };
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) return input;
    return (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))(input, $9a20f8fc188f0eb6$var$mapContextualFieldDataToInput(contextualFields), (objValue, srcValue)=>{
        if (Array.isArray(objValue)) return objValue.concat(srcValue);
    });
};

});
parcelRegister("16aVR", function(module, exports) {

var $9AWD2 = parcelRequire("9AWD2");

var $kBNXn = parcelRequire("kBNXn");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $0cced4e66601137e$var$mergeWith = $kBNXn(function(object, source, srcIndex, customizer) {
    $9AWD2(object, source, srcIndex, customizer);
});
module.exports = $0cced4e66601137e$var$mergeWith;

});


parcelRegister("4uses", function(module, exports) {
$parcel$export(module.exports, "toOptimisticResponse", () => $9e8fadc0c70ba0f6$export$79353fa5e28d43d8);

var $57raR = parcelRequire("57raR");

var $4cTDP = parcelRequire("4cTDP");

var $8ntPR = parcelRequire("8ntPR");
const $9e8fadc0c70ba0f6$export$79353fa5e28d43d8 = ({ project: project, issueType: issueType, summary: summary, assignee: assignee, dueDate: dueDate }, optimisticId, isIssueHierarchyEnabled, groupContextFieldInput)=>{
    const issueId = optimisticId;
    const summaryEdge = summary ? $9e8fadc0c70ba0f6$var$toOptimisticSummary(issueId, summary) : null;
    const projectEdge = project ? $9e8fadc0c70ba0f6$var$toOptimisticProject(issueId, project) : null;
    const issueTypeEdge = issueType ? $9e8fadc0c70ba0f6$var$toOptimisticIssueType(issueId, issueType) : null;
    const assigneeEdge = assignee && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? $9e8fadc0c70ba0f6$var$toOptimisticAssignee(issueId, assignee) : null;
    const dueDateEdge = dueDate && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? $9e8fadc0c70ba0f6$var$toOptimisticDueDate(issueId, dueDate) : null;
    const edges = [
        summaryEdge,
        projectEdge,
        issueTypeEdge,
        assigneeEdge,
        dueDateEdge
    ].filter((edge)=>edge !== null);
    if (groupContextFieldInput) {
        if ((0, $4cTDP.fg)('jira_render_pic_in_nin')) {
            if (groupContextFieldInput.fieldId !== 'assignee' || assigneeEdge === null) {
                const groupContextFieldEdge = (0, $8ntPR.toOptimisticField)(issueId, groupContextFieldInput);
                // @ts-expect-error - TS2345 Typescript 5.9.2 upgrade
                edges.push(groupContextFieldEdge);
            }
        } else {
            const groupContextFieldEdge = (0, $8ntPR.toOptimisticField)(issueId, groupContextFieldInput);
            // @ts-expect-error - TS2345 Typescript 5.9.2 upgrade
            edges.push(groupContextFieldEdge);
        }
    }
    return {
        jira: {
            createIssue: {
                errors: null,
                issue: {
                    __typename: 'JiraIssue',
                    id: issueId,
                    issueId: issueId,
                    key: '',
                    fieldsByIdOrAlias: [],
                    fieldSetsById: {
                        edges: edges
                    },
                    matchesIssueSearch: undefined,
                    ...isIssueHierarchyEnabled ? {
                        issueTypeField: {
                            issueType: {
                                hierarchy: {
                                    level: issueType?.hierarchy?.level
                                },
                                id: issueType?.id
                            },
                            id: ''
                        },
                        canHaveChildIssues: false
                    } : {
                        issueTypeField: undefined,
                        canHaveChildIssues: undefined
                    }
                }
            }
        }
    };
};
const $9e8fadc0c70ba0f6$var$toOptimisticSummary = (issueId, summary)=>({
        node: {
            fieldSetId: 'summary',
            type: 'summary',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleLineTextField',
                            __isJiraIssueField: 'JiraSingleLineTextField',
                            fieldId: 'summary',
                            id: `${issueId}/summary`,
                            name: 'Summary',
                            text: summary,
                            type: 'summary',
                            lazyIsEditableInIssueView: undefined
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticIssueType = (issueId, issueType)=>({
        node: {
            fieldSetId: 'issuetype',
            type: 'issuetype',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraIssueTypeField',
                            __isJiraIssueField: 'JiraIssueTypeField',
                            fieldId: 'issuetype',
                            id: `${issueId}/issuetype`,
                            type: 'issuetype',
                            issueType: {
                                id: issueType.id,
                                ...(0, $4cTDP.fg)('jira_list_conditional_formatting') && {
                                    issueTypeId: issueType.issueTypeId
                                },
                                name: issueType.name,
                                avatar: issueType.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticProject = (issueId, project)=>({
        node: {
            fieldSetId: 'project',
            type: 'project',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraProjectField',
                            __isJiraIssueField: 'JiraProjectField',
                            fieldId: 'project',
                            id: `${issueId}/project`,
                            type: 'project',
                            project: {
                                id: project.id,
                                ...(0, $4cTDP.fg)('jira_list_conditional_formatting') && {
                                    projectId: project.projectId
                                },
                                key: project.key,
                                name: project.name,
                                avatar: project.avatar
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticAssignee = (issueId, { accountId: accountId, name: name, picture: picture })=>({
        node: {
            fieldSetId: 'assignee',
            type: 'assignee',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraSingleSelectUserPickerField',
                            __isJiraIssueField: 'JiraSingleSelectUserPickerField',
                            fieldId: 'assignee',
                            id: `${issueId}/assignee`,
                            type: 'assignee',
                            name: 'Assignee',
                            user: {
                                id: accountId,
                                accountId: accountId,
                                name: name,
                                picture: picture,
                                accountStatus: 'active',
                                __typename: 'AtlassianAccountUser'
                            }
                        }
                    }
                ]
            }
        }
    });
const $9e8fadc0c70ba0f6$var$toOptimisticDueDate = (issueId, dueDate)=>({
        node: {
            fieldSetId: 'duedate',
            type: 'duedate',
            fields: {
                totalCount: 1,
                edges: [
                    {
                        node: {
                            __typename: 'JiraDatePickerField',
                            __isJiraIssueField: 'JiraDatePickerField',
                            fieldId: 'duedate',
                            id: `${issueId}/duedate`,
                            type: 'duedate',
                            date: (0, $57raR.default)(dueDate, 'yyyy-MM-dd'),
                            name: 'Due Date',
                            fieldConfig: {
                                isRequired: false
                            }
                        }
                    }
                ]
            }
        }
    });

});

parcelRegister("5hgjg", function(module, exports) {
$parcel$export(module.exports, "useOptimisticId", () => $0e6eea24f2449862$export$753dc4430b354b6a);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");
const $0e6eea24f2449862$export$753dc4430b354b6a = ()=>{
    const optimisticIDtoReal = (0, $eJOHy.useRef)(new Map());
    const generateOptimisticId = (0, $eJOHy.useCallback)(()=>{
        const id = (0, $aXKmr.v4)();
        optimisticIDtoReal.current.set(id, undefined);
        return {
            id: id,
            saveRealId: (realId)=>{
                optimisticIDtoReal.current.set(id, realId);
            }
        };
    }, []);
    const getRealId = (0, $eJOHy.useCallback)((optimisticId)=>{
        return optimisticIDtoReal.current.get(optimisticId);
    }, []);
    return {
        generateOptimisticId: generateOptimisticId,
        getRealId: getRealId
    };
};

});



parcelRegister("lfz0B", function(module, exports) {
$parcel$export(module.exports, "PaginationControls", () => $389cf10d7be3e2cb$export$ff17519edeb6015d);

var $lvqEB = parcelRequire("lvqEB");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b3eVo = parcelRequire("b3eVo");

var $k71qx = parcelRequire("k71qx");

var $3LCex = parcelRequire("3LCex");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $21Au6 = parcelRequire("21Au6");
const $389cf10d7be3e2cb$var$getFirstPage = (data)=>{
    if (data?.pageCursors?.first) return data?.pageCursors.first.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[0]?.pageNumber;
    return undefined;
};
const $389cf10d7be3e2cb$var$getLastPage = (data)=>{
    if (data?.pageCursors?.last) return data?.pageCursors.last.pageNumber;
    if (data?.pageCursors?.around?.length) return data?.pageCursors.around[data?.pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $389cf10d7be3e2cb$var$getPageCursor = (data, page)=>{
    const { first: first, last: last, around: around } = data?.pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $389cf10d7be3e2cb$export$ff17519edeb6015d = ({ issues: issues, onPageChange: onPageChange, isNewFooterOrderEnabled: isNewFooterOrderEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $lvqEB.default), issues);
    const [optimisticCurrentPage, setOptimisticCurrentPage] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // Clear our optimistically set page number whenever fragment data changes.
        setOptimisticCurrentPage(null);
    }, [
        data
    ]);
    const pages = (0, $eJOHy.useMemo)(()=>{
        const firstPage = $389cf10d7be3e2cb$var$getFirstPage(data) ?? 1;
        const lastPage = $389cf10d7be3e2cb$var$getLastPage(data) ?? 1;
        return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
    }, [
        data
    ]);
    const currentPage = optimisticCurrentPage ?? data?.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onChange = (0, $eJOHy.useCallback)((_, page)=>{
        if (page === currentPage || optimisticCurrentPage !== null) return;
        const pageCursorToFetch = $389cf10d7be3e2cb$var$getPageCursor(data, page);
        if (pageCursorToFetch != null) {
            setOptimisticCurrentPage(page);
            onPageChange(pageCursorToFetch);
            const attributes = {
                currentPage: currentPage,
                nextPage: page,
                randomAccess: Math.abs(page - currentPage) > 1,
                isLastPage: page === pages.length
            };
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'pageNumber'
            }), 'issueTablePagination', attributes);
        }
    }, [
        createAnalyticsEvent,
        currentPage,
        data,
        onPageChange,
        optimisticCurrentPage,
        pages.length
    ]); // Disable the pagination buttons while the selected page is optimistically rendered as we may not have page cursors
    // readily available for pages rendered on the UI.
    const OptimisticDisabledButtonRenderer = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": !ariaLabel && props.page ? formatMessage((0, $21Au6.default).pageButtonPrefix, {
                page: props.page
            }) : ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        formatMessage,
        optimisticCurrentPage
    ]);
    const OptimisticDisabledButtonRendererWithTooltip = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ 'aria-label': ariaLabel, ...props }, ref)=>props.disabled && optimisticCurrentPage == null && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $21Au6.default).disabledButtonTooltipIssueTermRefresh : (0, $21Au6.default).disabledButtonTooltip),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($389cf10d7be3e2cb$var$FullHeightDisabledButton, {
            tabIndex: 0,
            isDisabled: true,
            "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $21Au6.default).disabledButtonTooltipIssueTermRefresh : (0, $21Au6.default).disabledButtonTooltip),
            "data-testid": "native-issue-table.ui.footer-renderer.pagination-controls.full-height-disabled-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            "aria-label": ariaLabel,
            disabled: props.disabled || optimisticCurrentPage !== null
        }), [
        optimisticCurrentPage,
        data?.isCappingIssueSearchResult,
        formatMessage
    ]);
    const components = (0, $eJOHy.useMemo)(()=>{
        const OptimisticDisabledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(OptimisticDisabledButtonRenderer);
        const OptimisticDisabledButtonWithTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(OptimisticDisabledButtonRendererWithTooltip);
        return {
            Page: OptimisticDisabledButton,
            Previous: OptimisticDisabledButton,
            Next: OptimisticDisabledButtonWithTooltip
        };
    }, [
        OptimisticDisabledButtonRenderer,
        OptimisticDisabledButtonRendererWithTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($389cf10d7be3e2cb$var$PaginationContainer, {
        isFlexCenter: isNewFooterOrderEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        testId: "native-issue-table.ui.footer-renderer.pagination-controls.pagination-controls",
        components: components,
        pages: pages,
        onChange: onChange,
        selectedIndex: currentPage - 1,
        max: 7,
        nextLabel: formatMessage((0, $21Au6.default).nextButton),
        previousLabel: formatMessage((0, $21Au6.default).prevButton)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $389cf10d7be3e2cb$var$FullHeightDisabledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $3LCex.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $389cf10d7be3e2cb$var$PaginationContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexCenter: isFlexCenter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o",
            __cmplp.isFlexCenter ? "_1bah1h6o" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lvqEB", function(module, exports) {
$parcel$export(module.exports, "default", () => $43e1f14ba9dac451$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<060fb173eea287115e5bcf553d9d303f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43e1f14ba9dac451$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "pageSize"
            }
        ],
        "kind": "Fragment",
        "name": "PaginationControls",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    },
                    {
                        "kind": "Variable",
                        "name": "pageSize",
                        "variableName": "pageSize"
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$43e1f14ba9dac451$var$node.hash = "8b100d40eebaedba37160add53361a22";
var $43e1f14ba9dac451$export$2e2bcd8739ae039 = $43e1f14ba9dac451$var$node;

});

parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb3eee7b92db2782a45444d8dbb123a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});
parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("3LCex", function(module, exports) {
$parcel$export(module.exports, "default", () => $0be296db7657e907$export$2e2bcd8739ae039);

var $cdbP5 = parcelRequire("cdbP5");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0be296db7657e907$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $cdbP5.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0be296db7657e907$export$2e2bcd8739ae039 = $0be296db7657e907$var$DisabledButtonWithTooltip;

});

parcelRegister("21Au6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea084c23b4d940a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ea084c23b4d940a9$var$messages = (0, $7qGN1.defineMessages)({
    nextButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.next-button",
        "defaultMessage": "Next page"
    },
    prevButton: {
        "id": "native-issue-table.footer-renderer.pagination-controls.prev-button",
        "defaultMessage": "Previous page"
    },
    pageButtonPrefix: {
        "id": "native-issue-table.footer-renderer.pagination-controls.page-button-prefix",
        "defaultMessage": "Page {page}"
    },
    disabledButtonTooltip: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "native-issue-table.footer-renderer.pagination-controls.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work."
    }
});
var $ea084c23b4d940a9$export$2e2bcd8739ae039 = $ea084c23b4d940a9$var$messages;

});



parcelRegister("4aaY3", function(module, exports) {
$parcel$export(module.exports, "IssueFetchQueryVariables", () => $93e181c8fcc95804$export$2cef1066f7674208);

var $1Snv4 = parcelRequire("1Snv4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5NEjg = parcelRequire("5NEjg");
const $93e181c8fcc95804$export$2cef1066f7674208 = ({ children: children, columns: columns })=>{
    const columnsData = (0, $j4oe4.useFragment)((0, $1Snv4.default), columns);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>columnsData.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        columnsData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NEjg.IssueFetchQueryVariablesContainer), {
        fieldSetIds: fieldSetIds
    }, children);
};

});
parcelRegister("1Snv4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d88706c7fcfe81f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d2cee26b7663287c8321469996d018f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d88706c7fcfe81f4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueFetchQueryVariables",
    "selections": [
        {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$d88706c7fcfe81f4$var$node.hash = "23fe80fc33e4a75a483fe224b74c4665";
var $d88706c7fcfe81f4$export$2e2bcd8739ae039 = $d88706c7fcfe81f4$var$node;

});


parcelRegister("aUa0f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5cbb6ab0c87c7db$export$2e2bcd8739ae039);

var $1J15n = parcelRequire("1J15n");

var $c5XWE = parcelRequire("c5XWE");

var $1Sk6u = parcelRequire("1Sk6u");

var $aCEgb = parcelRequire("aCEgb");

var $ikOp2 = parcelRequire("ikOp2");

var $iOJuQ = parcelRequire("iOJuQ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $1jdzZ = parcelRequire("1jdzZ");

var $lRq8t = parcelRequire("lRq8t");

var $jBNts = parcelRequire("jBNts");

var $jE8Tu = parcelRequire("jE8Tu");

var $gM8ln = parcelRequire("gM8ln");

var $9RE4U = parcelRequire("9RE4U");

var $6TGzt = parcelRequire("6TGzt");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");

var $hnyyS = parcelRequire("hnyyS");

var $34oCh = parcelRequire("34oCh");

var $Kdcei = parcelRequire("Kdcei");

var $pZqvR = parcelRequire("pZqvR");

var $hHg7L = parcelRequire("hHg7L");

var $9r0oq = parcelRequire("9r0oq");

var $f8QUz = parcelRequire("f8QUz");

var $d2QWN = parcelRequire("d2QWN");

var $eI4dM = parcelRequire("eI4dM");

var $l00LF = parcelRequire("l00LF");

var $kaSuB = parcelRequire("kaSuB");

var $l7U99 = parcelRequire("l7U99");

var $7WpdI = parcelRequire("7WpdI");

var $kmVLU = parcelRequire("kmVLU");
const $f5cbb6ab0c87c7db$var$emptyArray = []; // We use rowsCount=50 by default to set the minimum table height until virtualizer reads it from DOM
const $f5cbb6ab0c87c7db$var$getInitialTableHeight = (rowsCount = 50)=>(0, $8jOO7.ROW_HEIGHT) * rowsCount + (0, $8jOO7.HEADER_HEIGHT);
const $f5cbb6ab0c87c7db$var$IssueTable = ({ view: view, columnPickerProps: columnPickerProps, columns: columns, NoIssues: NoIssues, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, issueResults: issueResults, groupResults: groupResults, project: project, rankField: rankField, loading: loading, NoColumns: NoColumns, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, tableInjectedProps: tableInjectedProps, tableRef: tableRef, isGroupingSupported: isGroupingSupported, isCompactColumnEnabled: isCompactColumnEnabled = false, onIssueFlatListUpdated: onIssueFlatListUpdated, tableBorderRadius: tableBorderRadius, ifcConfig: ifcConfig, columnsQueryRef: columnsQueryRef, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, isDraggingRowFaded: isDraggingRowFaded, mergedColumnMinWidth: mergedColumnMinWidth, tableRole: tableRole, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, resizeHandleType: resizeHandleType, topLevelIssueCreateConfig: topLevelIssueCreateConfig, initialPopulateConnectionArgs: initialPopulateConnectionArgs })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [resizingColumnIndex, setResizingColumnIndex] = (0, $eJOHy.useState)();
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const InitializeVirtualizer = timelineCustomComponents?.InitializeVirtualizer ?? ((0, $4cTDP.fg)('jira_list_reduce_re_renders') ? (0, $kmVLU.InitializeVirtualizer) : (0, $7WpdI.InitializeVirtualizer));
    const viewData = (0, $j4oe4.useFragment)((0, $iOJuQ.default), view ?? null);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $ikOp2.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $aCEgb.default), groupResults);
    const projectData = (0, $j4oe4.useFragment)((0, $1Sk6u.default), project);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $c5XWE.default), formattingRules);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $1J15n.default), rankField);
    let flatList = $f5cbb6ab0c87c7db$var$emptyArray;
    if (!(0, $4cTDP.fg)('jira_list_reduce_re_renders')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        flatList = (0, $jE8Tu.useFlatList)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueKeys = (0, $jE8Tu.useFlatListIssueKeys)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const flatListIssueIds = (0, $jE8Tu.useIssueIds)();
        const flatListChildIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jE8Tu.useChildIssueIds)() : []; // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onIssueFlatListUpdated?.(flatListIssueKeys.filter(Boolean), flatListIssueIds, flatListChildIssueIds);
        }, [
            flatList,
            flatListIssueIds,
            flatListIssueKeys,
            onIssueFlatListUpdated,
            flatListChildIssueIds
        ]);
    } // initialFlatList is currently only guaranteed to keep virtualiser props stable while flatList is empty
    // If flatList is no longer empty, initialFlatList should be ignored
    const initialFlatList = (0, $eJOHy.useMemo)(()=>{
        if (!(flatList?.length <= 0 && (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store'))) return [];
        if (issueResultsData && issueResultsData.edges) return issueResultsData.edges.map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                itemId: issueId
            }));
        if (groupResultsData && groupResultsData.firstGroup && groupResultsData?.firstGroup?.id) {
            const firstGroupId = groupResultsData.firstGroup.id;
            return [
                (0, $jBNts.getFlatListKey)({
                    itemId: firstGroupId,
                    groupId: firstGroupId
                }),
                ...(groupResultsData.firstGroup.issues?.edges ?? []).map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                        itemId: issueId,
                        groupId: firstGroupId
                    })),
                ...groupResultsData.firstGroup.issues?.pageInfo?.hasNextPage ? [
                    (0, $jBNts.getFlatListKey)({
                        itemId: (0, $jE8Tu.getShowMoreItemKey)(firstGroupId),
                        groupId: firstGroupId
                    })
                ] : [],
                ...(groupResultsData.edges ?? []).map((edge)=>edge?.node?.id).filter((id)=>id !== firstGroupId).filter(Boolean).map((id)=>(0, $jBNts.getFlatListKey)({
                        itemId: id,
                        groupId: id
                    }))
            ];
        }
        return [];
    }, [
        flatList?.length,
        groupResultsData,
        issueResultsData
    ]); // Represents a stable list of item keys between first render (i.e. flat list is empty) and after flat list has been initialised in RSS.
    const readyFlatList = flatList?.length === 0 && (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? initialFlatList : flatList; /** @deprecated remove when jira_list_reduce_re_renders is cleaned up */ 
    const getItemKey = (0, $eJOHy.useCallback)((index)=>readyFlatList[index] ?? index, [
        readyFlatList
    ]); /** @deprecated remove when jira_list_reduce_re_renders is cleaned up */ 
    const totalSizeRef = (0, $eJOHy.useRef)($f5cbb6ab0c87c7db$var$getInitialTableHeight((0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? readyFlatList.length : issueResultsData?.edges?.length));
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const showNoIssues = issueResultsData && !issueResultsData.edges?.length;
    const showNoGroupingIssues = isGroupingSupported && groupResultsData && !groupResultsData.edges?.length;
    let isMergedColumnVisible = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const showNoColumns = columns.filter((col)=>!(0, $8jOO7.ACTION_COLUMNS).includes(col.id)).length === 0 && !isMergedColumnVisible;
    const { getScrollInfo: getScrollInfo } = (0, $7n9BS.useScrollStateActions)();
    let isStickyColumnsVisible = false; // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    const modifier = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? (0, $6TGzt.getInlineEditModifier)({
            columns: columns,
            getScrollInfo: getScrollInfo,
            isStickyColumnsVisible: isStickyColumnsVisible
        }) : ()=>[], [
        columns,
        getScrollInfo,
        isStickyColumnsVisible
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    const { handleMouseOver: handleMouseOver, handleMouseLeave: handleMouseLeave } = (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hHg7L.useEventDelegator)() : {
        handleMouseOver: undefined,
        handleMouseLeave: undefined
    };
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    const resizeHandler = resizeHandleType ?? (showNoIssues || showNoColumns ? (0, $8jOO7.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT));
    const resizeHandlerOld = (showNoIssues || showNoColumns) && !isTimelineEnabled ? (0, $8jOO7.COLUMN_RESIZE_HANDLE_HEADER_ONLY) : (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT);
    const tableHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $pZqvR.IFCConfigContextProviderComponent), {
        ifcConfig: ifcConfig,
        columns: columns,
        onColumnsChange: columnPickerProps?.onChange,
        queryRef: issueResultsData ?? null,
        columnsQueryRef: columnsQueryRef ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2QWN.Header), {
        view: viewData,
        columnPickerProps: columnPickerProps,
        columns: columns,
        canViewColumnConfiguration: canViewColumnConfiguration,
        canEditColumnConfiguration: canEditColumnConfiguration,
        isCompactColumnEnabled: isCompactColumnEnabled,
        resizeHandleType: (0, $4cTDP.fg)('refactor_issue_table_for_timline') ? resizeHandler : resizeHandlerOld,
        onColumnsChange: onColumnsChange,
        onResizeColumn: onResizeColumn,
        onFreezeColumn: onFreezeColumn,
        tableRef: tableRef,
        tableBorderRadius: tableBorderRadius,
        showNoColumns: showNoColumns,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            resizingColumnIndex: resizingColumnIndex,
            setResizingColumnIndex: setResizingColumnIndex
        },
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        mergedColumnMinWidth: mergedColumnMinWidth
    }));
    if (showNoIssues || showNoGroupingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), !isTimelineEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaSuB.default), {
        NoIssues: NoIssues,
        isLoading: loading
    }));
    if (showNoColumns) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, canViewColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$export$36d41a08d3c6eb45, {
        isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
        "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
        ref: tableRef
    }, tableHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l00LF.default), {
        NoColumns: NoColumns,
        hasColumnConfiguration: canViewColumnConfiguration,
        isLoading: loading
    }));
    const renderTableBody = ()=>{
        if (isGroupingSupported && groupResultsData && !issueResultsData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f8QUz.default), {
            groupResults: groupResultsData,
            rankField: rankFieldData ?? null,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            loading: loading,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            formattingRules: formattingRulesData ?? null,
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                resizingColumnIndex: resizingColumnIndex
            }
        });
        if (issueResultsData == null) return null;
        const tableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l7U99.default), {
            topLevelIssueCreateConfig: topLevelIssueCreateConfig,
            issueResults: issueResultsData,
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            project: projectData ?? null,
            rankField: rankFieldData ?? null,
            isGroupingSupported: isGroupingSupported,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isDraggingRowFaded: isDraggingRowFaded,
            formattingRules: formattingRulesData ?? null,
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                resizingColumnIndex: resizingColumnIndex
            },
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            initialPopulateConnectionArgs: initialPopulateConnectionArgs
        });
        return tableBody;
    };
    const renderTable = (style)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1jdzZ.EditViewPopupModifiersProvider), {
            modifiers: modifier
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$export$36d41a08d3c6eb45, {
            ...style ? {
                style: style
            } : {},
            role: (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? tableRole : undefined,
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            "aria-label": formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eI4dM.default).issuesTableLabelIssueTermRefresh : (0, $eI4dM.default).issuesTableLabel),
            ref: tableRef,
            "aria-rowcount": issueResultsData?.totalIssueSearchResultCount && issueResultsData?.totalIssueSearchResultCount > 0 && (0, $4cTDP.fg)('nin-grid-keyboard-navigation') ? issueResultsData?.totalIssueSearchResultCount : undefined,
            "data-vc": `issue-table${false && !isPageHydrating ? '-ssr' : ''}`,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave,
            ...false && !isPageHydrating && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder': 'issue-table-placeholder'
            },
            ...!false && !isPageHydrating && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
                'data-ssr-placeholder-replace': 'issue-table-placeholder'
            }
        }, tableHeader, renderTableBody(), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5cbb6ab0c87c7db$var$TableFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", null, (0, $4cTDP.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
            interactionName: "issue-table-renderer-overlay"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)))) : null, isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gM8ln.HoverPopoverWithDelegator), null) : null));
    }; /** @deprecated remove when jira_list_reduce_re_renders is cleaned up */ 
    // eslint-disable-next-line no-nested-ternary
    const rowsCount = (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? readyFlatList.length : flatList?.length > 0 ? flatList?.length : issueResultsData?.edges?.length;
    if (isVirtualizationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Kdcei.VirtualizationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InitializeVirtualizer, {
        rows: rowsCount ?? 0,
        getItemKey: getItemKey,
        totalSizeRef: totalSizeRef,
        issueResults: issueResultsData,
        groupResults: groupResultsData
    }), renderTable({
        width: '100%',
        position: 'relative'
    }));
    return renderTable();
};
var $f5cbb6ab0c87c7db$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f5cbb6ab0c87c7db$var$IssueTable;
const $f5cbb6ab0c87c7db$export$36d41a08d3c6eb45 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3it94y _kqswh2mm _yq5h18uv _btyzidpf",
            __cmplp.isFixedTableLayoutEnabled && "_1kqm1n9t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $f5cbb6ab0c87c7db$var$TableFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tfoot", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _p4liidpf _owipidpf _6autidpf _1pqwidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1J15n", function(module, exports) {
$parcel$export(module.exports, "default", () => $38a699c013685352$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df7c297b49260138292153459fcd81d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $38a699c013685352$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTable_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TableBody_rankField"
        },
        {
            "kind": "FragmentSpread",
            "name": "GroupTableBody_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$38a699c013685352$var$node.hash = "27d4e25cfd3c3a4e630c5db59dd935a9";
var $38a699c013685352$export$2e2bcd8739ae039 = $38a699c013685352$var$node;

});

parcelRegister("c5XWE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8424ca925d990a22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ef108bc27d4820650e1346e8894df8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8424ca925d990a22$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTable_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "GroupTableBody_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "TableBody_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$8424ca925d990a22$var$node.hash = "d1ada0c226e54cad77408668ddb89aab";
var $8424ca925d990a22$export$2e2bcd8739ae039 = $8424ca925d990a22$var$node;

});

parcelRegister("1Sk6u", function(module, exports) {
$parcel$export(module.exports, "default", () => $39fe50f996b37f63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6515383f83bf568fde7e7b1372a7cefd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $39fe50f996b37f63$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "IssueTable_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "GroupTableBody_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "TableBody_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$39fe50f996b37f63$var$node.hash = "1323da9301cd486842312425cd722a4f";
var $39fe50f996b37f63$export$2e2bcd8739ae039 = $39fe50f996b37f63$var$node;

});

parcelRegister("aCEgb", function(module, exports) {
$parcel$export(module.exports, "default", () => $13ec9303ea4c22fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ed7124311df63011baec39ee334acc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $13ec9303ea4c22fc$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v2 = {
        "kind": "Variable",
        "name": "isPaginating",
        "variableName": "isPaginating"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "name": "IssueTable_spreadsheetGroupConnection",
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "fieldSetsInput",
                                                "variableName": "fieldSetsInput"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 50
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "scope",
                                                "variableName": "fieldSetsScope"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "settings",
                                                "variableName": "settings"
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isConditionalFormattingEnabled",
                        "variableName": "isConditionalFormattingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isDensityFull",
                        "variableName": "isDensityFull"
                    },
                    {
                        "kind": "Variable",
                        "name": "isEditableSyncLoaded",
                        "variableName": "isEditableSyncLoaded"
                    },
                    {
                        "kind": "Variable",
                        "name": "isInlineEditingEnabled",
                        "variableName": "isInlineEditingEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isLinkRelationshipFieldEnabled",
                        "variableName": "isLinkRelationshipFieldEnabled"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "isRemoteLinkedIssuesEnabled",
                        "variableName": "isRemoteLinkedIssuesEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "isTimelineEnabled",
                        "variableName": "isTimelineEnabled"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKeys",
                        "variableName": "projectKeys"
                    },
                    v1 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "GroupTableBody"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v2 /*: any*/ 
                        ],
                        "kind": "FragmentSpread",
                        "name": "InitializeVirtualizer_groupResults"
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$13ec9303ea4c22fc$var$node.hash = "0dfe98b3bb47f14d517eacfd3ce276f0";
var $13ec9303ea4c22fc$export$2e2bcd8739ae039 = $13ec9303ea4c22fc$var$node;

});

parcelRegister("ikOp2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6ca26ca0b04c4e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d68b168bcdd7115f322fe45e760a131c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b6ca26ca0b04c4e4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "IssueTable_issueConnection",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "TableBodyTableBody"
        },
        {
            "kind": "FragmentSpread",
            "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreducererendersrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "InitializeVirtualizer_issueResults"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$b6ca26ca0b04c4e4$var$node.hash = "bd1b9d1c4f6ffa5376c3d0b571b916ea";
var $b6ca26ca0b04c4e4$export$2e2bcd8739ae039 = $b6ca26ca0b04c4e4$var$node;

});

parcelRegister("iOJuQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $20c4412d7ae3b06d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3489699a2d3cfbd514f802edc141599f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20c4412d7ae3b06d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTableIssueTable",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "HeaderCellContainer"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$20c4412d7ae3b06d$var$node.hash = "4c9fad0b83db602b39e7619ec2ef4dfb";
var $20c4412d7ae3b06d$export$2e2bcd8739ae039 = $20c4412d7ae3b06d$var$node;

});

parcelRegister("1jdzZ", function(module, exports) {
$parcel$export(module.exports, "EditViewPopupModifiersProvider", () => $2eb28ffca848904a$export$7605340c70fd949e);
$parcel$export(module.exports, "useEditViewPopupModifiersContext", () => $2eb28ffca848904a$export$9e8df37d8f62801b);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");
const $2eb28ffca848904a$var$EditViewPopupModifiersContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $2eb28ffca848904a$var$EditViewPopupModifiersProviderBase = ({ children: children, modifiers: modifiers })=>{
    const contextValue = {
        modifiers: modifiers
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2eb28ffca848904a$var$EditViewPopupModifiersContext.Provider, {
        value: contextValue
    }, children);
};
const $2eb28ffca848904a$var$EditViewPopupModifiersProviderDisabled = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $2eb28ffca848904a$export$7605340c70fd949e = (0, $f2JN3.componentWithCondition)(// eslint-disable-next-line jira/ff/no-preconditioning
()=>(0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix'), $2eb28ffca848904a$var$EditViewPopupModifiersProviderBase, $2eb28ffca848904a$var$EditViewPopupModifiersProviderDisabled);
const $2eb28ffca848904a$export$9e8df37d8f62801b = ()=>{
    const context = (0, $eJOHy.useContext)($2eb28ffca848904a$var$EditViewPopupModifiersContext);
    // Gracefully fallback to empty modifiers if no provider is rendered
    if (context === null) return [];
    return context?.modifiers() || [];
};

});

parcelRegister("gM8ln", function(module, exports) {
$parcel$export(module.exports, "HoverPopoverWithDelegator", () => $45aab2dddaf31bc3$export$9b1830049d07a4b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");

var $8qmYl = parcelRequire("8qmYl");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $bYhG9 = parcelRequire("bYhG9");


var $1VYeC = parcelRequire("1VYeC");
const $45aab2dddaf31bc3$export$9b1830049d07a4b = ()=>{
    const { hoverPopoverState: hoverPopoverState } = (0, $bYhG9.useHoverPopoverState)();
    const { isOpen: isOpen, content: content, contentElement: contentElement, alwaysShow: alwaysShow, cellRef: cellRef, onHoverOut: onHoverOut, shouldRenderToContent: shouldRenderToContent } = hoverPopoverState;
    const refToRenderTo = shouldRenderToContent ? contentElement : cellRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isOpen && refToRenderTo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67YQP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), {
        placement: "bottom-start",
        referenceElement: refToRenderTo
    }, ({ ref: ref, style: style, update: update, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            // Style is required for react-popper to apply positioning correctly (allows it to render to parent)
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
            style: style,
            className: (0, $hcewu.default)([
                shouldRenderToContent && "_19pku2gc _18u0x0bf"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VYeC.PopoverInternal), {
            content: content,
            contentElement: contentElement,
            onUpdate: update,
            isReferenceHidden: isReferenceHidden,
            alwaysShow: alwaysShow,
            onHoverOut: onHoverOut
        })))))));
};
const $45aab2dddaf31bc3$var$renderToContentStyles = null;

});
const $05f3bc586d738eb3$export$d57b6b390e78d90f = 'jira-yurree';
const $05f3bc586d738eb3$export$b8b9d90f9e5bd72b = '@atlassian/jira-hover-popover';

parcelRegister("1VYeC", function(module, exports) {
$parcel$export(module.exports, "PopoverInternal", () => $f2c475c7a9bd946f$export$681e33c5421549b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9CHGV = parcelRequire("9CHGV");

var $hX7Ca = parcelRequire("hX7Ca");
const $f2c475c7a9bd946f$var$CELL_HOVER_DELAY = 200;
const $f2c475c7a9bd946f$export$681e33c5421549b0 = ({ content: content, contentElement: contentElement, onUpdate: onUpdate, isReferenceHidden: isReferenceHidden, alwaysShow: alwaysShow, onHoverOut: onHoverOut })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const hoverTimeoutRef = (0, $eJOHy.useRef)(null);
    hoverTimeoutRef.current = setTimeout(()=>{
        if (alwaysShow) setIsPopupOpen(true);
        const elementWithTextContent = contentElement ? (0, $hX7Ca.getClosestTextElement)(contentElement) : undefined;
        const clientWidth = elementWithTextContent?.clientWidth || 0;
        const scrollWidth = elementWithTextContent?.scrollWidth || 0;
        const isClamped = (0, $hX7Ca.checkIsClamped)(elementWithTextContent);
        if (!contentElement || scrollWidth > clientWidth || isClamped) setIsPopupOpen(true);
    }, $f2c475c7a9bd946f$var$CELL_HOVER_DELAY);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            if (onHoverOut) onHoverOut();
        };
    }, [
        onHoverOut
    ]);
    if (isPopupOpen && content && !isReferenceHidden) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
        update: onUpdate
    }, content));
};
const $f2c475c7a9bd946f$var$fadeIn = null;
const $f2c475c7a9bd946f$var$containerStyles = null;

});
parcelRegister("9CHGV", function(module, exports) {
$parcel$export(module.exports, "PopupContent", () => $95ad311b87a00fc3$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $1OHZM = parcelRequire("1OHZM");

var $4B7rn = parcelRequire("4B7rn");
const $95ad311b87a00fc3$var$PopupContentComponent = ({ children: children, update: update, isInteractive: isInteractive, analyticsAttributes: analyticsAttributes })=>{
    const componentRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const mountTimeRef = (0, $eJOHy.useRef)(Date.now());
    (0, $1OHZM.useResizeObserver)({
        ref: componentRef,
        onResize: update
    });
    (0, $eJOHy.useEffect)(()=>{
        const mountTime = mountTimeRef.current;
        return ()=>{
            const duration = Date.now() - mountTime;
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'popup displayed', 'hoverPopover', {
                isInteractive: isInteractive,
                duration: duration,
                ...analyticsAttributes
            });
        };
    }, [
        createAnalyticsEvent,
        isInteractive,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: componentRef,
        "data-testid": "hover-popover.ui.popup-content.hover-popover-content",
        "aria-hidden": !isInteractive,
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: isInteractive ? 0 : undefined,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1reo1wug _18m91wug _18zrutpp _1rjc12x7 _bfhk1bhr _16qs1cd0 _qv3h2smr _k48pi7a9 _1i4q1hna _c71l1mjv _1nmz1hna _y2mvugt7 _1bg4v77o"
        ])
    }, children, /*#__PURE__*/ $eJOHy.createElement((0, $4B7rn.default), null));
};
const $95ad311b87a00fc3$export$2a2c7ba12d3231e3 = /*#__PURE__*/ (0, $eJOHy.memo)($95ad311b87a00fc3$var$PopupContentComponent);
const $95ad311b87a00fc3$var$popoverStyles = null;

});
parcelRegister("1OHZM", function(module, exports) {
$parcel$export(module.exports, "createResizeObserverHook", () => $7c1c433db2df08f5$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $7c1c433db2df08f5$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $7c1c433db2df08f5$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $7c1c433db2df08f5$export$e58143dc89297272);

var $eJOHy = parcelRequire("eJOHy");

var $cOhmL = parcelRequire("cOhmL");
function $7c1c433db2df08f5$export$87a9d3e287304ae4(params) {
    const group = new (0, $cOhmL.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eJOHy.useRef)(onResize);
        (0, $eJOHy.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eJOHy.useCallback)(()=>onResizeRef.current(), []);
        (0, $eJOHy.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $7c1c433db2df08f5$export$683480f191c0e3ea, flushResizeObservers: $7c1c433db2df08f5$export$a181ef2a6d0a1bb6 } = $7c1c433db2df08f5$export$87a9d3e287304ae4();
function $7c1c433db2df08f5$export$e58143dc89297272({ ref: ref, useResizeObserverDI: // eslint-disable-next-line react-hooks/react-compiler
useResizeObserverDI = $7c1c433db2df08f5$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eJOHy.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("cOhmL", function(module, exports) {
$parcel$export(module.exports, "ResizeObserverGroup", () => $4b26b203cb8a861d$export$607798bbe2869c0);

var $aQK2r = parcelRequire("aQK2r");

var $3s8bj = parcelRequire("3s8bj");
class $4b26b203cb8a861d$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $aQK2r.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});





parcelRegister("6TGzt", function(module, exports) {
$parcel$export(module.exports, "getInlineEditModifier", () => $f112f64b95db9ff9$export$aebe598173adea57);

var $8jOO7 = parcelRequire("8jOO7");

var $8FfYE = parcelRequire("8FfYE");
const $f112f64b95db9ff9$var$INLINE_EDIT_POPUP_SCROLL_MARGIN = 8;
const $f112f64b95db9ff9$var$isWithinStickyTableCell = (state)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const triggerEl = state.elements.reference;
    const closestTd = triggerEl.closest('td');
    // Check if the closest <td> element has an inline z-index style applied.
    // Frozen columns have a z-index, so if found, skip further handling
    // to avoid affecting frozen column inline edit behavior.
    if (closestTd) return globalThis.window.getComputedStyle(closestTd).position === 'sticky';
    return false;
};
const $f112f64b95db9ff9$export$aebe598173adea57 = ({ columns: columns, getScrollInfo: getScrollInfo, isStickyColumnsVisible: isStickyColumnsVisible })=>{
    const stickyColumnsWidth = (0, $8FfYE.calculateStickyColumnsWidth)(columns);
    return ()=>[
            {
                name: 'closeOnThreshold',
                enabled: true,
                phase: 'write',
                // When inline edit popup is open and the table is being scrolled,
                // hide the popup if it moves outside the table’s visible boundary.
                // No need to check popups from frozen columns.
                fn: ({ state: state })=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const isSticky = $f112f64b95db9ff9$var$isWithinStickyTableCell(state);
                    if (isSticky) return;
                    const { scrollElement: scrollElement, isScrolling: isScrolling, isSmallScreen: isSmallScreen } = getScrollInfo();
                    const totalWidth = isStickyColumnsVisible && !isSmallScreen ? stickyColumnsWidth : 0;
                    const scrollRect = scrollElement?.getBoundingClientRect();
                    if (!scrollRect) return;
                    const referenceElementRect = state.elements.reference.getBoundingClientRect();
                    const shoudHide = referenceElementRect.left < scrollRect.left + totalWidth || referenceElementRect.top < scrollRect.top + (0, $8jOO7.HEADER_HEIGHT) || referenceElementRect.bottom > scrollRect.bottom;
                    if (shoudHide && isScrolling) // eslint-disable-next-line no-param-reassign
                    state.elements.popper.style.display = 'none';
                },
                // When the popup is closed and a field is partially hidden (behind merged columns),
                // auto-scroll the table to bring that field back into view.
                // No need to check popups from frozen columns.
                effect: ({ state: state })=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const isSticky = $f112f64b95db9ff9$var$isWithinStickyTableCell(state);
                    if (isSticky) return;
                    const { scrollElement: scrollElement, isSmallScreen: isSmallScreen } = getScrollInfo();
                    const totalWidth = isStickyColumnsVisible && !isSmallScreen ? stickyColumnsWidth : 0;
                    const scrollRect = scrollElement?.getBoundingClientRect();
                    if (!scrollRect) return;
                    const referenceElementRect = state.elements.reference.getBoundingClientRect();
                    const isPartiallyHidden = referenceElementRect.left < scrollRect.left + totalWidth;
                    if (scrollElement && isPartiallyHidden && state.elements.popper.style.display !== 'none') {
                        // When clicking a partially hidden field, auto-scrolls it back into the table view
                        // and leaves an 8px margin on the left side of the field.
                        const scrollAmount = scrollRect.left + totalWidth - referenceElementRect.left + $f112f64b95db9ff9$var$INLINE_EDIT_POPUP_SCROLL_MARGIN;
                        scrollElement.scrollBy({
                            left: -scrollAmount,
                            behavior: 'auto'
                        });
                    }
                }
            }
        ];
};

});
parcelRegister("8FfYE", function(module, exports) {
$parcel$export(module.exports, "calculateStickyColumnsWidth", () => $e44637d13c1cefce$export$7a1e6dffa7beebd2);

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");
const $e44637d13c1cefce$export$7a1e6dffa7beebd2 = (columns)=>{
    let totalWidth = 0;
    for (const column of columns){
        const { id: id, isColumnSticky: isColumnSticky, defaultWidth: defaultWidth, customWidth: customWidth } = column;
        if (id === (0, $j8Km1.COLUMN_ID_CHECKBOX) || id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON) || id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) || isColumnSticky) {
            if (id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON)) totalWidth += defaultWidth + (0, $8jOO7.EXPAND_CELL_PADDING);
            else totalWidth += customWidth ?? defaultWidth;
        } else break;
    }
    return totalWidth;
};

});


parcelRegister("hnyyS", function(module, exports) {
$parcel$export(module.exports, "Overlay", () => $2263ce5e083f2a0f$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "OverlayOld", () => $2263ce5e083f2a0f$export$3dff7b29487a2410);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $bJscI = parcelRequire("bJscI");
const $2263ce5e083f2a0f$export$c6fdb837b070b4ff = ({ interactionName: interactionName })=>{
    return(// We are intentionally ignoring jira/ufo/valid-labels because we have a valid use case
    // for an encapsulated generic component, similar to generic AK components.
    // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2263ce5e083f2a0f$var$StyledOverlay, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $2263ce5e083f2a0f$var$StyledOverlayOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk166n _tzy4txnc _1sb2b3bt",
            __cmplp.className
        ])
    });
});
const $2263ce5e083f2a0f$var$StyledOverlayNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _bfhk166n _tzy4txnc _1sb2b3bt _1pby37uc",
            __cmplp.className
        ])
    });
});
const $2263ce5e083f2a0f$var$StyledOverlay = (0, $bJscI.componentWithFG)('issue_table_frozen_columns', $2263ce5e083f2a0f$var$StyledOverlayNew, $2263ce5e083f2a0f$var$StyledOverlayOld);
const $2263ce5e083f2a0f$export$3dff7b29487a2410 = $2263ce5e083f2a0f$var$StyledOverlay;

});

parcelRegister("Kdcei", function(module, exports) {
$parcel$export(module.exports, "VirtualizationContainer", () => $29e00bcf5213eb76$export$6f4d8b0593660d4a);
$parcel$export(module.exports, "useVirtualizationActions", () => $29e00bcf5213eb76$export$2d20df04c90a6b4d);
$parcel$export(module.exports, "useVirtualization", () => $29e00bcf5213eb76$export$8c88e6c844ce8aa0);
$parcel$export(module.exports, "useVirtualItemsMap", () => $29e00bcf5213eb76$export$48859eaeca922cb5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $29e00bcf5213eb76$var$initialState = {
    virtualizer: null,
    virtualItemsMap: {}
};
const $29e00bcf5213eb76$var$actions = {
    setVirtualizer: (virtualizer)=>({ setState: setState })=>{
            setState({
                virtualizer: virtualizer
            });
        },
    setVirtualItemsMap: (virtualItemsMap)=>({ setState: setState })=>{
            setState({
                virtualItemsMap: virtualItemsMap
            });
        }
};
const $29e00bcf5213eb76$export$6f4d8b0593660d4a = (0, $6E16M.createContainer)();
const $29e00bcf5213eb76$var$Store = (0, $GtRbT.createStore)({
    initialState: $29e00bcf5213eb76$var$initialState,
    actions: $29e00bcf5213eb76$var$actions,
    name: 'VirtualizerStore',
    containedBy: $29e00bcf5213eb76$export$6f4d8b0593660d4a
});
const $29e00bcf5213eb76$export$2d20df04c90a6b4d = (0, $iJq0l.createActionsHook)($29e00bcf5213eb76$var$Store);
const $29e00bcf5213eb76$export$88d9b12c2ccec7b9 = (0, $iJq0l.createHook)($29e00bcf5213eb76$var$Store);
const $29e00bcf5213eb76$var$getVirtualizerSelector = (state)=>state.virtualizer;
const $29e00bcf5213eb76$export$8c88e6c844ce8aa0 = (0, $iJq0l.createStateHook)($29e00bcf5213eb76$var$Store, {
    selector: $29e00bcf5213eb76$var$getVirtualizerSelector
});
const $29e00bcf5213eb76$var$getVirtualItemsMapSelector = (state)=>state.virtualItemsMap;
const $29e00bcf5213eb76$export$48859eaeca922cb5 = (0, $iJq0l.createStateHook)($29e00bcf5213eb76$var$Store, {
    selector: $29e00bcf5213eb76$var$getVirtualItemsMapSelector
});

});

parcelRegister("hHg7L", function(module, exports) {
$parcel$export(module.exports, "useEventDelegator", () => $a9d2dac88d84964b$export$d7391873b7d90fb9);
$parcel$export(module.exports, "useEventDelegatorRef", () => $a9d2dac88d84964b$export$5213ba3182c7ed61);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $3OT15 = parcelRequire("3OT15");

var $bYhG9 = parcelRequire("bYhG9");
const $a9d2dac88d84964b$var$HOVER_DEBOUNCE_DURATION = 100;
const $a9d2dac88d84964b$export$d7391873b7d90fb9 = ()=>{
    const { setPopoverClosed: setPopoverClosed, setPopoverOpen: setPopoverOpen } = (0, $bYhG9.useHoverPopoverSetter)();
    const { getCellIdByRef: getCellIdByRef } = (0, $3OT15.useHoverPopoverContent)();
    const currentHoveredCellFieldIdRef = (0, $eJOHy.useRef)(null);
    const debouncedSetHoverFocusStateRef = (0, $eJOHy.useRef)(null);
    const clearHoverFocusState = (0, $eJOHy.useCallback)(()=>{
        debouncedSetHoverFocusStateRef.current?.cancel();
        setPopoverClosed();
        currentHoveredCellFieldIdRef.current = null;
    }, [
        setPopoverClosed
    ]);
    const setHoverFocusState = (0, $eJOHy.useCallback)((fieldId, cell)=>{
        setPopoverOpen({
            fieldId: fieldId,
            cell: cell,
            clearHoverFocusState: clearHoverFocusState
        });
    }, [
        setPopoverOpen,
        clearHoverFocusState
    ]);
    const handleMouseOver = (0, $eJOHy.useCallback)((event)=>{
        if (event.target instanceof HTMLElement) {
            const target = event.target;
            // Get closest cell that is being hovered over
            const cell = target.closest('td');
            // If no cell is found, clear the hover state and return
            if (!cell || !(cell instanceof HTMLTableCellElement)) {
                clearHoverFocusState();
                return;
            }
            const fieldId = getCellIdByRef(cell);
            // If there is a cell but no field id, clear the hover state and return
            if (!fieldId) {
                clearHoverFocusState();
                return;
            }
            // If the cell is the same as the current hovered cell, return
            if (fieldId !== currentHoveredCellFieldIdRef.current) {
                // If the cell is different from the current hovered cell, clear the previous hover state
                if (currentHoveredCellFieldIdRef.current) clearHoverFocusState();
                // Finally, set the hover state for the new cell
                currentHoveredCellFieldIdRef.current = fieldId;
                debouncedSetHoverFocusStateRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>setHoverFocusState(fieldId, cell), $a9d2dac88d84964b$var$HOVER_DEBOUNCE_DURATION);
                debouncedSetHoverFocusStateRef.current();
            }
        }
    }, [
        clearHoverFocusState,
        getCellIdByRef,
        setHoverFocusState
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearHoverFocusState();
        debouncedSetHoverFocusStateRef.current?.cancel();
    }, [
        clearHoverFocusState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (currentHoveredCellFieldIdRef.current) clearHoverFocusState();
            debouncedSetHoverFocusStateRef.current?.cancel();
        };
    }, [
        clearHoverFocusState
    ]);
    return {
        handleMouseLeave: handleMouseLeave,
        handleMouseOver: handleMouseOver
    };
};
const $a9d2dac88d84964b$export$5213ba3182c7ed61 = (fieldId)=>{
    const lastNode = (0, $eJOHy.useRef)(null);
    const { setCellIdByRef: setCellIdByRef, deleteCellIdByRef: deleteCellIdByRef } = (0, $3OT15.useHoverPopoverContent)();
    const tableCellRef = (0, $eJOHy.useCallback)((node)=>{
        if (node && fieldId) {
            setCellIdByRef(node, fieldId);
            lastNode.current = node;
        } else if (lastNode.current) {
            deleteCellIdByRef(lastNode.current);
            lastNode.current = null;
        }
    }, [
        fieldId,
        setCellIdByRef,
        deleteCellIdByRef
    ]);
    return tableCellRef;
};

});

parcelRegister("f8QUz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1feeb10764a3558$export$2e2bcd8739ae039);

var $1YqG7 = parcelRequire("1YqG7");

var $89xNf = parcelRequire("89xNf");

var $cDSux = parcelRequire("cDSux");

var $66O9X = parcelRequire("66O9X");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $jPROM = parcelRequire("jPROM");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jBNts = parcelRequire("jBNts");

var $6d9QY = parcelRequire("6d9QY");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $cNwIG = parcelRequire("cNwIG");

var $l6qXI = parcelRequire("l6qXI");

var $NWRt9 = parcelRequire("NWRt9");

var $bJscI = parcelRequire("bJscI");

var $cgCO4 = parcelRequire("cgCO4");

var $7n9BS = parcelRequire("7n9BS");

var $1q3Q0 = parcelRequire("1q3Q0");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $km3XC = parcelRequire("km3XC");

var $8jOO7 = parcelRequire("8jOO7");

var $bKlUQ = parcelRequire("bKlUQ");

var $aNnbk = parcelRequire("aNnbk");

var $kfIml = parcelRequire("kfIml");

var $9r0oq = parcelRequire("9r0oq");
const $b1feeb10764a3558$export$4771958ed7a6df02 = ({ groupResults: groupResults, project: project, columns: columns, rankField: rankField, loading: loading, isConditionalFormattingEnabled: isConditionalFormattingEnabled, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, ...tableBodyProps })=>{
    const ChildIssueCreateRowComponent = (0, $9r0oq.useTimelineCustomComponents)()?.ChildIssueCreateRow;
    const groupsData = (0, $j4oe4.useFragment)((0, $66O9X.default), groupResults);
    const projectData = (0, $j4oe4.useFragment)((0, $cDSux.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $89xNf.default), rankField);
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $1YqG7.default), formattingRules);
    const groupConnectionId = groupsData.__id;
    const { populateConnection: populateConnection } = (0, $jE8Tu.useHierarchyActions)();
    const populateConnectionArgs = (0, $eJOHy.useMemo)(()=>({
            parentItemId: 'root',
            itemsConnectionId: groupConnectionId,
            parentConnectionId: groupConnectionId,
            list: groupsData?.edges?.map((edge)=>edge?.node && {
                    itemId: edge.node.id,
                    key: null,
                    groupId: edge.node.id
                }).filter(Boolean) ?? []
        }), [
        groupConnectionId,
        groupsData.edges
    ]);
    const prevPopulateConnectionArgs = (0, $6d9QY.usePrevious)(populateConnectionArgs);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(populateConnectionArgs, prevPopulateConnectionArgs)) populateConnection(populateConnectionArgs);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isIssueCreateEnabled = (0, $34oCh.useIsIssueCreateEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isRemoteLinkedIssuesEnabled = (0, $34oCh.useIsRemoteLinkedIssuesEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    const isInlineEditingEnabled = (0, $4cTDP.fg)('jira_timeline_disable_child_inline_editing') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsInlineEditingEnabled)() : true;
    let isStickyColumnsVisible = false;
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    } else {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const renderDraggableWrapper = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
            issueConnectionId: props.issueConnectionId,
            instanceId: props.instanceId
        }, props.children);
    }, []);
    const renderChildRows = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
            ...props,
            projectKey: projectData?.key,
            isGroupingSupported: true,
            childItemsExperience: (0, $8jOO7.GROUPED_ITEMS_EXPERIENCE),
            childItemsLoadMoreExperience: (0, $8jOO7.GROUPED_LOAD_MORE_EXPERIENCE),
            analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
            renderChildRowsLoader: (childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l6qXI.ChildRowsLoader), {
                    ...childRowsLoaderProps,
                    jql: jql,
                    width: width,
                    sortField: sortField,
                    sortDirection: sortDirection,
                    columns: columns,
                    amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                    actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                    pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                    isReparentingEnabled: isReparentingEnabled,
                    isTimelineEnabled: isTimelineEnabled,
                    isIssueRankDescending: isIssueRankDescending,
                    isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                    isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
                    rankFieldId: rankFieldData?.fieldId ?? null,
                    renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
                            project: projectData,
                            groupContextFieldInput: (0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') ? props.groupContextField : undefined,
                            formattingRules: formattingRulesData,
                            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
                            ...rowProps
                        }),
                    isStickyColumnsVisible: isStickyColumnsVisible,
                    renderTableCell: (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps),
                    renderCreateIssueController: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNnbk.CreateIssueController), {
                            ...args,
                            groupContextFieldInput: props.groupContextField,
                            jql: jql,
                            rankFieldTerms: rankFieldTerms
                        }),
                    renderDraggableWrapper: renderDraggableWrapper,
                    isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                    isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                    ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
                    isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                    isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
                    isEditableSyncLoaded: isEditableSyncLoaded,
                    cellBorderStyle: cellBorderStyle,
                    isInlineEditingEnabled: isInlineEditingEnabled
                })
        }), [
        projectData,
        jql,
        width,
        sortField,
        sortDirection,
        columns,
        isReparentingEnabled,
        isTimelineEnabled,
        isIssueRankDescending,
        isHideDoneItemsEnabled,
        isFixedTableLayoutEnabled,
        rankFieldData?.fieldId,
        isStickyColumnsVisible,
        renderDraggableWrapper,
        isConditionalFormattingEnabled,
        isInlineFieldConfigEnabled,
        ChildIssueCreateRowComponent,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        cellBorderStyle,
        isInlineEditingEnabled,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields,
        rankFieldTerms
    ]);
    const renderRows = (0, $eJOHy.useCallback)((rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
            project: projectData,
            formattingRules: formattingRulesData,
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            ...rowProps
        }), [
        projectData,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields
    ]);
    const renderCreateIssueController = (0, $eJOHy.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNnbk.CreateIssueController), {
            ...args,
            jql: jql
        }), [
        jql
    ]);
    const numFirstGroupIssues = groupsData?.firstGroup?.issues?.edges?.length;
    const isFirstGroupEmpty = (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(numFirstGroupIssues) || numFirstGroupIssues === 0;
    const renderGroups = (0, $eJOHy.useCallback)((isItemVirtual)=>groupsData?.edges?.map((group, index)=>group?.node && // We need to render the first group separately because it requires initialization during the table rendering process.
            // Additionally, it bypasses the ChildRowLoader and directly uses ChildRowsPagination, as the data is already available in data.firstGroup.
            (groupsData?.firstGroup && group.node.id === groupsData.firstGroup.id && !isFirstGroupEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
                key: groupsData.firstGroup.id,
                groupId: groupsData.firstGroup.id,
                groupConnectionId: (0, $4cTDP.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $NWRt9.FirstGroupRow), {
                firstGroupRow: groupsData.firstGroup,
                rankField: rankFieldData ?? null,
                groupConnectionId: groupConnectionId,
                loading: loading,
                isVirtual: isItemVirtual?.((0, $jBNts.getFlatListKey)({
                    itemId: groupsData.firstGroup.id,
                    groupId: groupsData.firstGroup.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isIssueRankDescending: isIssueRankDescending,
                isTimelineEnabled: isTimelineEnabled,
                columns: columns,
                width: width,
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                actionColumns: (0, $8jOO7.ACTION_COLUMNS),
                pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
                childItemsExperience: (0, $8jOO7.GROUPED_ITEMS_EXPERIENCE),
                childItemsLoadMoreExperience: (0, $8jOO7.GROUPED_LOAD_MORE_EXPERIENCE),
                analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
                renderRows: renderRows,
                renderCreateIssueController: renderCreateIssueController,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isGridNavigationEnabled: isGridNavigationEnabled,
                renderDraggableWrapper: renderDraggableWrapper,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled,
                ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded,
                isInlineEditingEnabled: isInlineEditingEnabled
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
                key: group.node.id,
                groupId: group.node.id,
                groupConnectionId: (0, $4cTDP.fg)('jsc_list_hide_done_items') ? groupConnectionId : undefined,
                ...tableBodyProps,
                columns: columns,
                renderChildRows: renderChildRows
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $NWRt9.GroupRow), {
                groupRow: group.node,
                groupConnectionId: groupConnectionId,
                isVirtual: isItemVirtual?.((0, $jBNts.getFlatListKey)({
                    itemId: group.node.id,
                    groupId: group.node.id
                })) ?? true,
                isGroupAtTop: index === 0,
                projectKey: projectData?.key,
                columns: columns,
                renderChildRows: renderChildRows,
                isIssueCreateEnabled: isIssueCreateEnabled,
                isGridNavigationEnabled: isGridNavigationEnabled,
                isStickyColumnsVisible: isStickyColumnsVisible,
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
            })))), [
        groupsData?.edges,
        groupsData.firstGroup,
        isFirstGroupEmpty,
        groupConnectionId,
        tableBodyProps,
        columns,
        rankFieldData,
        loading,
        projectData?.key,
        isHideDoneItemsEnabled,
        isIssueRankDescending,
        isTimelineEnabled,
        width,
        renderRows,
        renderCreateIssueController,
        isIssueCreateEnabled,
        isGridNavigationEnabled,
        renderDraggableWrapper,
        isConditionalFormattingEnabled,
        isInlineFieldConfigEnabled,
        isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled,
        ChildIssueCreateRowComponent,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        isInlineEditingEnabled,
        renderChildRows
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tbody",
        xcss: $b1feeb10764a3558$var$tableBodyStyles
    }, isVirtualizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km3XC.VirtualizedRows), {
        hasSpacers: true,
        columnsCount: columns.length
    }, renderGroups) : renderGroups());
};
const $b1feeb10764a3558$var$GroupTableBody = (0, $bJscI.componentWithFG)('initialise_virtualiser_state_from_relay_store', /*#__PURE__*/ (0, $eJOHy.memo)($b1feeb10764a3558$export$4771958ed7a6df02), $b1feeb10764a3558$export$4771958ed7a6df02);
var $b1feeb10764a3558$export$2e2bcd8739ae039 = $b1feeb10764a3558$var$GroupTableBody;
const $b1feeb10764a3558$var$tableBodyStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottom: 'none',
    overflowX: 'hidden'
});

});
parcelRegister("1YqG7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0205fd95f4cf5bf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee9b1c43ee52b2896dc1936afd8576fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0205fd95f4cf5bf9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GroupTableBody_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Rows_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$0205fd95f4cf5bf9$var$node.hash = "ff07da1a4c4e233045c0b3166944b4fb";
var $0205fd95f4cf5bf9$export$2e2bcd8739ae039 = $0205fd95f4cf5bf9$var$node;

});

parcelRegister("89xNf", function(module, exports) {
$parcel$export(module.exports, "default", () => $356262320b8f3f97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb5afbef507f250b2eefe731f5eeed67>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $356262320b8f3f97$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "GroupTableBody_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "FirstGroupRow_rankField"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$356262320b8f3f97$var$node.hash = "94b2b65f192e8494f5d4b70bec387bd5";
var $356262320b8f3f97$export$2e2bcd8739ae039 = $356262320b8f3f97$var$node;

});

parcelRegister("cDSux", function(module, exports) {
$parcel$export(module.exports, "default", () => $81de094825efeed2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d83e695be6319708d2c7acdd040809d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81de094825efeed2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "GroupTableBody_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows_project"
        }
    ],
    "type": "JiraProject"
};
$81de094825efeed2$var$node.hash = "b1bf39d9e47d705fe4c5f720da27e3ef";
var $81de094825efeed2$export$2e2bcd8739ae039 = $81de094825efeed2$var$node;

});

parcelRegister("66O9X", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce5b1ad866c58963$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4cc8d94d4dd6902931728a04b3cf4478>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ce5b1ad866c58963$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "firstGroup",
                        "issues"
                    ]
                }
            ]
        },
        "name": "GroupTableBody",
        "selections": [
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "firstGroup",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": "issues",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "fieldSetsScope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "settings",
                                        "variableName": "settings"
                                    },
                                    v1 /*: any*/ 
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isConditionalFormattingEnabled",
                                        "variableName": "isConditionalFormattingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isDensityFull",
                                        "variableName": "isDensityFull"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isEditableSyncLoaded",
                                        "variableName": "isEditableSyncLoaded"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isLinkRelationshipFieldEnabled",
                                        "variableName": "isLinkRelationshipFieldEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isRemoteLinkedIssuesEnabled",
                                        "variableName": "isRemoteLinkedIssuesEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isTimelineEnabled",
                                        "variableName": "isTimelineEnabled"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKey",
                                        "variableName": "projectKey"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectKeys",
                                        "variableName": "projectKeys"
                                    },
                                    v1 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "FirstGroupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "FirstGroupRow_GroupRow"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$ce5b1ad866c58963$var$node.hash = "ea98fd266d36d7d52d0d2835e94674f1";
var $ce5b1ad866c58963$export$2e2bcd8739ae039 = $ce5b1ad866c58963$var$node;

});

parcelRegister("cNwIG", function(module, exports) {
$parcel$export(module.exports, "ChildRows", () => $c306099c2e91dd3b$export$d1ec222e220e369e);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $5vQ2T = parcelRequire("5vQ2T");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $jE8Tu = parcelRequire("jE8Tu");


var $eYYOy = parcelRequire("eYYOy");
const $c306099c2e91dd3b$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows';
const $c306099c2e91dd3b$export$5881677fb314e6d9 = 'issue-table-child-rows-entrypoint-container';
const $c306099c2e91dd3b$export$d1ec222e220e369e = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: props.parentItemId,
        itemsConnectionId: props.itemsConnectionId,
        groupId: props.groupId
    });
    if (!isExpanded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c306099c2e91dd3b$var$ChildRowsInner, props);
});
const $c306099c2e91dd3b$var$ChildRowsInner = (props)=>{
    const { parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, type: type, parentItemConnectionId: parentItemConnectionId, depth: depth, groupId: groupId, renderChildRowsLoader: renderChildRowsLoader } = props;
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: props.childItemsExperience,
        analyticsSource: props.analyticsSource
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: props.childItemsExperience,
        attributes: {}
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $jE8Tu.useHierarchyActions)();
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        setIsItemExpanded({
            itemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, false);
        if (!hasFlag?.($c306099c2e91dd3b$export$5881677fb314e6d9)) {
            const isGrouping = groupId && depth === 0;
            showFlag({
                id: $c306099c2e91dd3b$export$5881677fb314e6d9,
                title: formatMessage(isGrouping ? (0, $eYYOy.default).errorFlagGroupingTitle : (0, $eYYOy.default).errorFlagTitle),
                description: formatMessage(isGrouping ? (0, $eYYOy.default).errorFlagGroupingDescription : (0, $eYYOy.default).errorFlagDescription),
                type: 'error',
                messageId: `issue-table-hierarchy.ui.child-rows.showFlag.${$c306099c2e91dd3b$export$5881677fb314e6d9}`,
                messageType: 'transactional'
            });
        }
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issue-table-child-rows-container',
                packageName: (0, $313deb82db1bb5f5$export$b8b9d90f9e5bd72b),
                teamName: (0, $313deb82db1bb5f5$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($c306099c2e91dd3b$var$PACKAGE_LOCATION, error);
        return null;
    }, [
        formatMessage,
        hasFlag,
        itemsConnectionId,
        onExperienceFail,
        parentItemId,
        setIsItemExpanded,
        showFlag,
        depth,
        groupId
    ]);
    const connectionMetadata = (0, $eJOHy.useMemo)(()=>{
        if (type === 'PARENT_CHILDREN' && parentItemConnectionId) return {
            type: type,
            parentRelayId: parentItemConnectionId,
            parentId: parentItemId
        };
        if (type === 'GROUP_CHILDREN' && groupId) return {
            type: type,
            fieldValue: props.groupFieldValue,
            groupId: groupId,
            jql: props.groupJql
        };
        return undefined;
    }, [
        type,
        parentItemConnectionId,
        groupId,
        props.groupFieldValue,
        props.groupJql,
        parentItemId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: $c306099c2e91dd3b$var$PACKAGE_LOCATION,
        packageName: (0, $313deb82db1bb5f5$export$b8b9d90f9e5bd72b),
        teamName: (0, $313deb82db1bb5f5$export$d57b6b390e78d90f),
        onError: (_, error)=>handleError(error)
    }, renderChildRowsLoader({
        ...props,
        connectionMetadata: connectionMetadata
    }));
};

});
const $313deb82db1bb5f5$export$b8b9d90f9e5bd72b = 'jira-issue-table-hierarchy';
const $313deb82db1bb5f5$export$d57b6b390e78d90f = 'keystone';

parcelRegister("eYYOy", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde560affa26929e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cde560affa26929e$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-title",
        "defaultMessage": "We couldn't expand hierarchy"
    },
    errorFlagDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-description",
        "defaultMessage": "Someone may have deleted a task or changed access to the parent. Try again or contact an admin."
    },
    errorFlagGroupingTitle: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-title",
        "defaultMessage": "We couldn't expand the group"
    },
    errorFlagGroupingDescription: {
        "id": "native-issue-table.rows.child-rows.error-flag-grouping-description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var $cde560affa26929e$export$2e2bcd8739ae039 = $cde560affa26929e$var$messages;

});


parcelRegister("l6qXI", function(module, exports) {
$parcel$export(module.exports, "ChildRowsLoader", () => $dfa944b5917963ac$export$148a4cf18f2e069b);

var $e7tgu = parcelRequire("e7tgu");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $4cTDP = parcelRequire("4cTDP");

var $e7tgu = parcelRequire("e7tgu");

var $cHtIB = parcelRequire("cHtIB");

var $9AekN = parcelRequire("9AekN");

var $hCzdk = parcelRequire("hCzdk");

var $eoeem = parcelRequire("eoeem");
const $dfa944b5917963ac$export$148a4cf18f2e069b = (props)=>{
    const [issueSearch, loadQuery, dispose] = (0, $j4oe4.useQueryLoader)((0, $e7tgu.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    const { sortField: sortField, sortDirection: sortDirection, jql: jql, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isGroupingSupported: isGroupingSupported, pageSize: pageSize, amountOfColumns: amountOfColumns, actionColumns: actionColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, projectKey: projectKey, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled } = props;
    const variables = (0, $eJOHy.useMemo)(()=>props.type === 'GROUP_CHILDREN' ? (0, $9AekN.getChildQueryVariablesForJql)({
            cloudId: cloudId,
            columns: columns,
            jql: props.groupJql,
            isReparentingEnabled: false,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded,
            isInlineEditingEnabled: isInlineEditingEnabled
        }) : (0, $9AekN.getChildQueryVariablesForParentIssue)({
            cloudId: cloudId,
            columns: columns,
            parentIssueKey: props.issueKey,
            sortDirection: sortDirection,
            sortField: sortField,
            jql: jql,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded,
            isInlineEditingEnabled: isInlineEditingEnabled
        }), [
        props.type,
        props.groupJql,
        props.issueKey,
        cloudId,
        columns,
        actionColumns,
        amountOfColumns,
        pageSize,
        sortDirection,
        sortField,
        jql,
        isConditionalFormattingEnabled,
        isHideDoneItemsEnabled,
        isReparentingEnabled,
        isTimelineEnabled,
        projectKey,
        isInlineFieldConfigEnabled,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        isInlineEditingEnabled
    ]);
    const prevIssueSearchInput = (0, $eJOHy.useRef)(variables.issueSearchInput);
    (0, $eJOHy.useEffect)(()=>{
        // This check prevents performing another network request for child items when the issue query changes
        // (which is unused as we re-fetch the issues when this happens). This is due to a race condition where
        // this component has not yet been unmounted when the issue query changes.
        if (props.isGroupingSupported && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables.issueSearchInput, prevIssueSearchInput.current)) return;
        loadQuery(variables);
        if (props.isGroupingSupported) prevIssueSearchInput.current = variables.issueSearchInput;
        return ()=>{
            dispose();
        };
    }, [
        variables,
        loadQuery,
        dispose,
        props.isGroupingSupported
    ]);
    if (!issueSearch) return null;
    const { groupId: groupId, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, connectionMetadata: connectionMetadata, isFormVisible: isFormVisible, formProps: formProps, rankFieldId: rankFieldId, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "native-issue-table-child-rows-query",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCzdk.default), {
            itemId: parentItemId,
            groupId: groupId,
            columnsCount: columns.length,
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                stickyColumnConfigs: columns.map((column)=>({
                        stickyOffsets: column.stickyOffsets,
                        isColumnSticky: column.isColumnSticky
                    }))
            },
            isFixedTableLayoutEnabled: props.isFixedTableLayoutEnabled,
            renderTableCell: props.renderTableCell,
            cellBorderStyle: props.cellBorderStyle
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dfa944b5917963ac$export$410977b2c408dd5d, {
        issueSearch: issueSearch,
        depth: depth,
        parentItemId: parentItemId,
        itemsConnectionId: itemsConnectionId,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: parentIssueRelayConnectionId,
        parentIssueHierarchyLevel: parentIssueHierarchyLevel,
        connectionMetadata: connectionMetadata,
        isFormVisible: isFormVisible,
        formProps: formProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        groupId: groupId,
        columns: columns,
        rankFieldId: rankFieldId,
        renderDraggableWrapper: renderDraggableWrapper,
        ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
        isTimelineEnabled: isTimelineEnabled
    }));
};
const $dfa944b5917963ac$export$410977b2c408dd5d = ({ issueSearch: issueSearch, ...rest })=>{
    const queryData = (0, $j4oe4.usePreloadedQuery)((0, $e7tgu.default), issueSearch);
    if (rest.isGroupingSupported && queryData?.jira?.issueSearch?.issueSearchError?.__typename) switch(queryData.jira.issueSearch.issueSearchError.__typename){
        case 'JiraInvalidJqlError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.messages?.[0] ?? 'Invalid JQL');
        case 'JiraInvalidSyntaxError':
        case 'JiraServerError':
            throw new Error(queryData.jira.issueSearch.issueSearchError.message ?? 'Unknown Error');
        default:
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eoeem.ChildRowsPagination), {
        ...rest,
        query: queryData
    });
};

});
parcelRegister("e7tgu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e37eab130944f618$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d76b7925647b1f84b2da6f6fa18f7e7b>>
 * @relayHash 613994617762a8591385875b9a5382cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c81b3314206792db59a5e3da3a35fe532df85e8559d2030dda38563491de2d9

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $e37eab130944f618$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRemoteLinkedIssuesEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v20 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v24 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v23 /*: any*/ ,
                "type": "JiraServerError"
            },
            {
                "kind": "InlineFragment",
                "selections": v23 /*: any*/ ,
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "key"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v31 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v32 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v34 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = [
        v35 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "isRemoteIssue"
    }, v38 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v39 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v40 = [
        v35 /*: any*/ ,
        v26 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v42 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = [
        v48 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v50 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v51 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v52 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v53 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v54 = {
        "kind": "ScalarField",
        "name": "date"
    }, v55 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "text"
    }, v57 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v58 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v26 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v60 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v62 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v63 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v65 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v66 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v67 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v68 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v69 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v70 = [
        v26 /*: any*/ 
    ], v71 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v70 /*: any*/ 
    }, v72 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "href"
    }, v74 = [
        v73 /*: any*/ 
    ], v75 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v29 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v76 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v77 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v78 = [
        v22 /*: any*/ ,
        v47 /*: any*/ ,
        v77 /*: any*/ ,
        v26 /*: any*/ 
    ], v79 = [
        v22 /*: any*/ ,
        v26 /*: any*/ 
    ], v80 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v81 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v82 = [
        v22 /*: any*/ ,
        v77 /*: any*/ ,
        v26 /*: any*/ 
    ], v83 = {
        "args": v76 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v82 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v84 = {
        "args": v76 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v82 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    }, v85 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ChildRowsPreloadedQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                        },
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isRemoteLinkedIssuesEnabled",
                            "variableName": "isRemoteLinkedIssuesEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v20 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ChildRowsPagination"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v12 /*: any*/ ,
                v4 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v14 /*: any*/ ,
                v3 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v18 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v17 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ChildRowsPreloadedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isRemoteLinkedIssuesEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": v40 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v36 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v22 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": v23 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v54 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v55 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v56 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v32 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v42 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v58 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v60 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v56 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v61 /*: any*/ ,
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        v59 /*: any*/ ,
                                                                                                                                                        v29 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v31 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v29 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v55 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v32 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v26 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v30 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v66 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v66 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v26 /*: any*/ ,
                                                                                                        v52 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v69 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v71 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v72 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ ,
                                                                                                v72 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v71 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v73 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": v74 /*: any*/ ,
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v65 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v70 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v57 /*: any*/ ,
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v75 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssueField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentIssue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v76 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v78 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v76 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v78 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v72 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v51 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v69 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v61 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v79 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v79 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v20 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isRemoteLinkedIssuesEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "issueError",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "errorType"
                                                                },
                                                                {
                                                                    "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "repairLink",
                                                                    "plural": false,
                                                                    "selections": v74 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRemoteLinkedIssueError"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v72 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v80 /*: any*/ ,
                                        v81 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v83 /*: any*/ ,
                                                                                                                v84 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v75 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v60 /*: any*/ ,
                                                        {
                                                            "args": v85 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v83 /*: any*/ ,
                                                                                        v84 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v65 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v80 /*: any*/ ,
                                                                        v81 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        },
                                                        {
                                                            "args": v85 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "timeline_jira_issueLinks",
                                                            "kind": "LinkedHandle",
                                                            "name": "issueLinks"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v72 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v72 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v72 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v21 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c81b3314206792db59a5e3da3a35fe532df85e8559d2030dda38563491de2d9",
            "metadata": {},
            "name": "ChildRowsPreloadedQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$e37eab130944f618$var$node.hash = "33582b4eb32c2b8ac1b2570822c6b07f";
var $e37eab130944f618$export$2e2bcd8739ae039 = $e37eab130944f618$var$node;

});

parcelRegister("9AekN", function(module, exports) {
$parcel$export(module.exports, "getChildQueryVariablesForJql", () => $014130e7555c3d46$export$e5b06f7246d135e);
$parcel$export(module.exports, "getChildQueryVariablesForParentIssue", () => $014130e7555c3d46$export$e350acffa980a984);

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $awWeA = parcelRequire("awWeA");
const $014130e7555c3d46$var$getProjectKeyFromIssueKey = (issueKey)=>{
    return issueKey.split('-')[0];
};
const $014130e7555c3d46$var$getChildQueryVariablesBase = ({ cloudId: cloudId, columns: columns, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, projectKey: projectKey, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    let fieldSetIds = columns.filter((column)=>!!column.id && !actionColumns.includes(column.id)).map((column)=>column.id).sort();
    const mergedColumnsIds = (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (columns.find((col)=>col?.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).map((col)=>col.id) : [];
    fieldSetIds = [
        ...mergedColumnsIds,
        ...fieldSetIds
    ];
    const operationScope = (0, $awWeA.getOperationScope)(projectKey);
    let fieldSetsScope = null;
    if ((0, $4cTDP.fg)('jira_nin_last_used_jql')) fieldSetsScope = {
        operationScope: operationScope,
        projectKey: projectKey ?? null
    };
    else if (isInlineFieldConfigEnabled) fieldSetsScope = {
        operationScope: operationScope,
        projectKey: projectKey
    };
    return {
        cloudId: cloudId,
        amountOfColumns: amountOfColumns,
        fieldSetsInput: {
            fieldSetIds: fieldSetIds
        },
        fieldSetIds: fieldSetIds,
        first: pageSize,
        namespace: '',
        shouldQueryFieldSetsById: true,
        filterId: null,
        viewId: null,
        isReparentingEnabled: isReparentingEnabled,
        isTimelineEnabled: isTimelineEnabled,
        scope: fieldSetsScope,
        isInlineEditingEnabled: isInlineEditingEnabled
    };
};
const $014130e7555c3d46$export$e5b06f7246d135e = ({ cloudId: cloudId, columns: columns, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, projectKey: projectKey, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    return {
        ...$014130e7555c3d46$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInlineEditingEnabled: isInlineEditingEnabled
        }),
        issueSearchInput: {
            jql: jql
        },
        shouldQueryHasChildren: false,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded,
        ...isHideDoneItemsEnabled && (0, $4cTDP.fg)('jsc_list_hide_done_items') && {
            viewConfigInput: {
                staticViewInput: {
                    isHideDoneEnabled: true
                }
            }
        }
    };
};
const $014130e7555c3d46$export$e350acffa980a984 = ({ cloudId: cloudId, columns: columns, parentIssueKey: parentIssueKey, jql: jql, isReparentingEnabled: isReparentingEnabled, isTimelineEnabled: isTimelineEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, actionColumns: actionColumns, amountOfColumns: amountOfColumns, pageSize: pageSize, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    const projectKey = $014130e7555c3d46$var$getProjectKeyFromIssueKey(parentIssueKey);
    return {
        ...$014130e7555c3d46$var$getChildQueryVariablesBase({
            cloudId: cloudId,
            columns: columns,
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            actionColumns: actionColumns,
            amountOfColumns: amountOfColumns,
            pageSize: pageSize,
            projectKey: projectKey,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInlineEditingEnabled: isInlineEditingEnabled
        }),
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: parentIssueKey,
                filterByProjectKeys: [
                    projectKey
                ],
                ...jql ? {
                    jql: jql
                } : {},
                ...(0, $4cTDP.fg)('jsc_list_hide_done_items') && {
                    namespace: 'ISSUE_NAVIGATOR'
                }
            }
        },
        projectKeys: [
            projectKey
        ],
        projectKey: projectKey,
        viewConfigInput: {
            staticViewInput: {
                isHierarchyEnabled: true,
                isGroupingEnabled: false,
                ...(0, $4cTDP.fg)('jsc_list_hide_done_items') && {
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            }
        },
        shouldQueryHasChildren: true,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded: isEditableSyncLoaded
    };
};

});
parcelRegister("awWeA", function(module, exports) {
$parcel$export(module.exports, "getOperationScope", () => $5af88e3fbe2eb6ab$export$93ef6e0525bce59d);

var $j8Km1 = parcelRequire("j8Km1");
const $5af88e3fbe2eb6ab$export$93ef6e0525bce59d = (projectKey)=>{
    let operationScope;
    if (projectKey != null) operationScope = (0, $j8Km1.NIN_PROJECT_OPERATION_SCOPE);
    else operationScope = (0, $j8Km1.NIN_GLOBAL_OPERATION_SCOPE);
    return operationScope;
};

});


parcelRegister("hCzdk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f47963be7d20baa6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");
const $f47963be7d20baa6$var$LoadingIssueRow = ({ itemId: itemId, groupId: groupId, columnsCount: columnsCount, stickyColumnConfigs: stickyColumnConfigs, isFixedTableLayoutEnabled: isFixedTableLayoutEnabled, cellBorderStyle: cellBorderStyle = 'FULL_BORDER', renderTableCell: renderTableCell })=>{
    const { setItemIsLoading: setItemIsLoading } = (0, $jE8Tu.useHierarchyActions)();
    (0, $eJOHy.useEffect)(()=>{
        setItemIsLoading({
            itemId: itemId,
            groupId: groupId,
            isLoading: true
        });
        return ()=>{
            setItemIsLoading({
                itemId: itemId,
                groupId: groupId,
                isLoading: false
            });
        };
    }, [
        itemId,
        groupId,
        setItemIsLoading
    ]);
    const columns = Array.from({
        length: columnsCount
    });
    const colSpans = columns.map((_, index)=>{
        const isLastColumn = index === columns.length - 1;
        return 1 + (isLastColumn && isFixedTableLayoutEnabled ? 1 : 0);
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        as: "tr",
        xcss: [
            (0, $4cTDP.fg)('issue_table_frozen_columns') ? $f47963be7d20baa6$var$wrapperStyles : $f47963be7d20baa6$var$wrapperOldStyles
        ]
    }, columns.map((_, i)=>renderTableCell({
            key: `${itemId}-${i}`,
            colSpan: colSpans[i],
            border: (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? [
                $f47963be7d20baa6$var$baseCellBorderStyles,
                $f47963be7d20baa6$var$cellBorderLocationStyleMap[cellBorderStyle],
                i === columnsCount - 1 && $f47963be7d20baa6$var$lastCellBorderStyles
            ] : [
                $f47963be7d20baa6$var$cellBorderStyles,
                i === columnsCount - 1 && $f47963be7d20baa6$var$lastCellBorderStyles
            ],
            children: /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
                xcss: $f47963be7d20baa6$var$loadingCellStyles
            }),
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: stickyColumnConfigs?.[i].isColumnSticky,
                stickyOffsets: stickyColumnConfigs?.[i].stickyOffsets
            }
        })));
};
var $f47963be7d20baa6$export$2e2bcd8739ae039 = $f47963be7d20baa6$var$LoadingIssueRow;
const $f47963be7d20baa6$var$wrapperOldStyles = (0, $1DXK0.xcss)({
    height: '40px'
});
const $f47963be7d20baa6$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: '40px',
    background: "var(--ds-surface, #FFFFFF)"
});
// TODO: Remove this with cleanup of jira_timeline_cell_border_style
const $f47963be7d20baa6$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$lastCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $f47963be7d20baa6$var$baseCellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0'
});
const $f47963be7d20baa6$var$fullCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$noColumnCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $f47963be7d20baa6$var$noRowCellBorderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $f47963be7d20baa6$var$cellBorderLocationStyleMap = {
    FULL_BORDER: $f47963be7d20baa6$var$fullCellBorderStyles,
    NO_COLUMN_BORDER: $f47963be7d20baa6$var$noColumnCellBorderStyles,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $f47963be7d20baa6$var$noRowCellBorderStyles
};
const $f47963be7d20baa6$var$loadingCellStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 3px)",
    padding: 'space.150',
    width: '100%'
});

});

parcelRegister("eoeem", function(module, exports) {
$parcel$export(module.exports, "ChildRowsPagination", () => $be4eddbd2c1894e4$export$74d2c2d9ae144c85);

var $2AB59 = parcelRequire("2AB59");

var $a714X = parcelRequire("a714X");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $dLXgn = parcelRequire("dLXgn");

var $4gytc = parcelRequire("4gytc");

var $7Slu4 = parcelRequire("7Slu4");
const $be4eddbd2c1894e4$var$PACKAGE_LOCATION = 'jira-issue-table-hierarchy-child-rows-pagination';
const $be4eddbd2c1894e4$export$74d2c2d9ae144c85 = ({ query: query, depth: depth, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, isFormVisible: isFormVisible, formProps: formProps, connectionMetadata: connectionMetadata, projectKey: projectKey, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, isIssueRankDescending: isIssueRankDescending, groupId: groupId, width: width, columns: columns, rankFieldId: rankFieldId, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent, isTimelineEnabled: isTimelineEnabled })=>{
    const { data: queryData, loadNext: loadNext, isLoadingNext: isLoadingNext, hasNext: hasNext } = (0, $j4oe4.usePaginationFragment)((0, $a714X.default), query);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $2AB59.default), queryData?.jira?.issueSearch);
    const { type: type } = connectionMetadata || {};
    const isGroupChildren = type === 'GROUP_CHILDREN';
    const onCreateIssueRef = (0, $eJOHy.useRef)();
    const setOnCreateIssue = (0, $eJOHy.useCallback)((onCreateIssue)=>{
        onCreateIssueRef.current = onCreateIssue;
    }, []);
    // Set the issue count on the group record if needed
    (0, $4gytc.useUpdateGroupIssueCountOnExpand)({
        groupId: groupId,
        isGroupChildren: isGroupChildren,
        totalIssueSearchResultCount: issueResultsData.totalIssueSearchResultCount || 0,
        isCappingIssueSearchResult: issueResultsData.isCappingIssueSearchResult ?? false
    });
    const onExperienceLoadMoreStart = (0, $8Uqf3.useExperienceStart)({
        experience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource
    });
    const onExperienceLoadMoreFail = (0, $aqnJa.useExperienceFail)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceLoadMoreSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: childItemsLoadMoreExperience,
        attributes: {}
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: childItemsExperience,
        attributes: {}
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    const childConnectionId = issueResultsData.__id;
    const [isSelected] = (0, $jE8Tu.useIsSelected)({
        itemsConnectionId: itemsConnectionId,
        groupId: groupId,
        itemId: parentItemId
    });
    const siblingIssueId = issueResultsData.edges?.[0]?.node?.id;
    const isChildIssueCreateRowVisible = isSelected && !!formProps && isFormVisible;
    if ((0, $cxKOj.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false)) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4gytc.useUpdateHierarchyHasChildrenOnExpand)({
        connectionMetadata: connectionMetadata,
        projectKey: projectKey,
        childCount: issueResultsData.edges?.length ?? 0
    });
    const connectionDetails = (0, $eJOHy.useMemo)(()=>{
        if (issueResultsData?.edges?.length === undefined || issueResultsData.edges.length === 0 && !isChildIssueCreateRowVisible || !connectionMetadata) return undefined;
        return {
            connectionId: childConnectionId,
            // This is the value the backend uses to fetch the issue list for realtime updates. It should be the connection length + 1
            // to ensure a potentially newly created issue is also fetched and included in the results.
            first: issueResultsData.edges.length + 1,
            ...connectionMetadata,
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') ? {
                fieldSetsData: queryData?.jira?.issueSearch
            } : {}
        };
    }, [
        childConnectionId,
        connectionMetadata,
        isChildIssueCreateRowVisible,
        issueResultsData.edges?.length,
        queryData?.jira?.issueSearch
    ]);
    (0, $dLXgn.useRegisterConnection)(connectionDetails);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCompleteLoadNextItems = (0, $eJOHy.useCallback)((error)=>{
        if (!error) onExperienceLoadMoreSuccess();
        else onExperienceLoadMoreFail($be4eddbd2c1894e4$var$PACKAGE_LOCATION, error);
    }, [
        onExperienceLoadMoreFail,
        onExperienceLoadMoreSuccess
    ]);
    const loadNextItems = (0, $eJOHy.useCallback)(()=>{
        onExperienceLoadMoreStart();
        const actionSubjectId = isGroupChildren ? 'groupingLoadMore' : 'hierarchyLoadMore';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        loadNext(pageSize, {
            onComplete: onCompleteLoadNextItems
        });
    }, [
        pageSize,
        onExperienceLoadMoreStart,
        isGroupChildren,
        createAnalyticsEvent,
        loadNext,
        onCompleteLoadNextItems
    ]);
    const renderChildIssueCreateRow = (0, $eJOHy.useCallback)(()=>{
        if (!isChildIssueCreateRowVisible || !onCreateIssueRef.current) return null;
        // Use custom child issue create row component if available, otherwise fallback to default
        const ResolvedChildIssueCreateRowComponent = ChildIssueCreateRowComponent ?? (0, $7Slu4.ChildIssueCreateRow);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedChildIssueCreateRowComponent, {
            canShowAdditionalFields: !isTimelineEnabled,
            depth: depth,
            parentIssueAri: parentIssueAri,
            siblingIssueId: siblingIssueId,
            isFormVisible: isFormVisible ?? false,
            ...formProps,
            width: width,
            isIssueRankDescending: isIssueRankDescending,
            onCreateIssue: onCreateIssueRef.current,
            columns: columns,
            rankFieldId: rankFieldId,
            isGrouping: !!groupId && (0, $4cTDP.fg)('jira_list_merged_column_gate')
        });
    }, [
        ChildIssueCreateRowComponent,
        groupId,
        isChildIssueCreateRowVisible,
        depth,
        parentIssueAri,
        siblingIssueId,
        isFormVisible,
        formProps,
        width,
        isIssueRankDescending,
        columns,
        rankFieldId,
        isTimelineEnabled
    ]);
    const renderChildRowsBody = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderCreateIssueController({
            childConnectionId: issueResultsData.__id,
            parentItemConnectionId: parentItemConnectionId,
            setOnCreateIssue: setOnCreateIssue,
            ...(0, $4cTDP.fg)('jira_timeline_analytics_harmonization_v2') && {
                location: 'childCreateForm'
            }
        }), renderRows({
            issueResults: issueResultsData,
            depth: depth + 1,
            parentItemId: parentItemId,
            itemsConnectionId: itemsConnectionId,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueHierarchyLevel: parentIssueHierarchyLevel,
            isLoadingNext: isLoadingNext,
            hasNext: hasNext,
            rankFieldId: rankFieldId,
            onLoadNextItems: loadNextItems,
            renderChildIssueCreateRow: renderChildIssueCreateRow,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey
            } : {}
        }));
    }, [
        renderCreateIssueController,
        issueResultsData,
        parentItemConnectionId,
        setOnCreateIssue,
        renderRows,
        depth,
        parentItemId,
        itemsConnectionId,
        parentIssueAri,
        parentIssueHierarchyLevel,
        isLoadingNext,
        hasNext,
        rankFieldId,
        loadNextItems,
        renderChildIssueCreateRow,
        isChildIssueCreateRowVisible,
        parentIssueRelayConnectionId,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderDraggableWrapper ? renderDraggableWrapper({
        instanceId: issueResultsData?.__id,
        issueConnectionId: childConnectionId,
        children: renderChildRowsBody()
    }) : renderChildRowsBody());
};

});
parcelRegister("2AB59", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0fdec66623b4ccf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b9698876d560ce474eec32b7ab079e1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a0fdec66623b4ccf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "ChildRowsPagination_issues",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$a0fdec66623b4ccf$var$node.hash = "b41b28271e30b6150b5a8c8974c3f123";
var $a0fdec66623b4ccf$export$2e2bcd8739ae039 = $a0fdec66623b4ccf$var$node;

});

parcelRegister("a714X", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0da9a2f27fa1774$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3584899a04f97d7b36b8766f7bb7f630>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bbv44 = parcelRequire("bbv44");
const $a0da9a2f27fa1774$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $bbv44.default)
            }
        },
        "name": "ChildRowsPagination",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "issueSearch",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "fieldSetsInput",
                                        "variableName": "fieldSetsInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "options",
                                        "variableName": "options"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "scope"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "viewConfigInput",
                                        "variableName": "viewConfigInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "isConditionalFormattingEnabled",
                                                "variableName": "isConditionalFormattingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isDensityFull",
                                                "variableName": "isDensityFull"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isEditableSyncLoaded",
                                                "variableName": "isEditableSyncLoaded"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isInlineEditingEnabled",
                                                "variableName": "isInlineEditingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isLinkRelationshipFieldEnabled",
                                                "variableName": "isLinkRelationshipFieldEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isRemoteLinkedIssuesEnabled",
                                                "variableName": "isRemoteLinkedIssuesEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isReparentingEnabled",
                                                "variableName": "isReparentingEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "isTimelineEnabled",
                                                "variableName": "isTimelineEnabled"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKey",
                                                "variableName": "projectKey"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKeys",
                                                "variableName": "projectKeys"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "ChildRowsPagination_issues"
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "getSelectedOptions",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "first",
                                                                        "value": 500
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueFieldSetConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldSets",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldSetEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v2 /*: any*/ ,
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "fields",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v1 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "fieldId"
                                                                                                            },
                                                                                                            v2 /*: any*/ ,
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraOptionConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "selectedOptions",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraOptionEdge",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "edges",
                                                                                                                                "plural": true,
                                                                                                                                "selections": [
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraOption",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "node",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "id"
                                                                                                                                            },
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "value"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v3 /*: any*/ 
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraCheckboxesField"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraOption",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "fieldOption",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "optionId"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraSingleSelectField"
                                                                                                            },
                                                                                                            v3 /*: any*/ 
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v3 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "fieldSets(first:500)"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasPreviousPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "startCursor"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.issueSearch"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$a0da9a2f27fa1774$var$node.hash = "7f004c25a1c439aa277ae00a3fd220b3";
var $a0da9a2f27fa1774$export$2e2bcd8739ae039 = $a0da9a2f27fa1774$var$node;

});
parcelRegister("bbv44", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d7551dd29053c95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca6d01b42787d697fb8c41e9d9a47ba0>>
 * @relayHash 9df590e3c96034918d0fe02d0b5751fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID adf37d6a281dc96ff3c57e7c78fccdbd00fbd81584341173840ee4f530c2d27f

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $2d7551dd29053c95$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v8 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJscIFCEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRemoteLinkedIssuesEnabled"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isReparentingEnabled"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v22 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v23 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "id"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "key"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v31 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v32 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v34 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = [
        v35 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "isRemoteIssue"
    }, v38 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v39 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v40 = [
        v35 /*: any*/ ,
        v26 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v42 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = [
        v48 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v50 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v51 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v52 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v53 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v54 = {
        "kind": "ScalarField",
        "name": "date"
    }, v55 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "text"
    }, v57 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v58 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v26 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v60 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v62 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v63 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v65 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v66 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v67 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v68 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v69 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v70 = [
        v26 /*: any*/ 
    ], v71 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v70 /*: any*/ 
    }, v72 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "href"
    }, v74 = [
        v73 /*: any*/ 
    ], v75 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v29 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v76 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v77 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v78 = [
        v24 /*: any*/ ,
        v47 /*: any*/ ,
        v77 /*: any*/ ,
        v26 /*: any*/ 
    ], v79 = [
        v24 /*: any*/ ,
        v26 /*: any*/ 
    ], v80 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v81 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v82 = [
        v24 /*: any*/ ,
        v77 /*: any*/ ,
        v26 /*: any*/ 
    ], v83 = {
        "args": v76 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v82 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v84 = {
        "args": v76 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v82 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    }, v85 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isDensityFull",
                            "variableName": "isDensityFull"
                        },
                        {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                        },
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isRemoteLinkedIssuesEnabled",
                            "variableName": "isRemoteLinkedIssuesEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        v22 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ChildRowsPagination"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                v30 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isRemoteLinkedIssuesEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canBeExported"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": v40 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isReparentingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v36 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v26 /*: any*/ ,
                                                                                        v24 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v54 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v55 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v56 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v32 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v58 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v42 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v58 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v60 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v56 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v61 /*: any*/ ,
                                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                                        v59 /*: any*/ ,
                                                                                                                                                        v29 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v31 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v29 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v40 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v55 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "isDensityFull",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "json"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v32 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v26 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v30 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v66 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v66 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v26 /*: any*/ ,
                                                                                                        v52 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v69 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v71 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v72 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ ,
                                                                                                v72 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v71 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v51 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v73 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v24 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": v74 /*: any*/ ,
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v65 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v70 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v57 /*: any*/ ,
                                                                                                        v50 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v75 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssueField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentIssue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v76 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v78 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v76 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v78 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v72 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v51 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v69 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v61 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v79 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v79 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "filterByProjectKeys",
                                                            "variableName": "projectKeys"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "args": [
                                                        v22 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isRemoteLinkedIssuesEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "issueError",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "errorType"
                                                                },
                                                                {
                                                                    "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "repairLink",
                                                                    "plural": false,
                                                                    "selections": v74 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRemoteLinkedIssueError"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v72 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v80 /*: any*/ ,
                                        v81 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v83 /*: any*/ ,
                                                                                                                v84 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v26 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        v75 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v36 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v60 /*: any*/ ,
                                                        {
                                                            "args": v85 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v83 /*: any*/ ,
                                                                                        v84 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v26 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v65 /*: any*/ ,
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v80 /*: any*/ ,
                                                                        v81 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        },
                                                        {
                                                            "args": v85 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "timeline_jira_issueLinks",
                                                            "kind": "LinkedHandle",
                                                            "name": "issueLinks"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v72 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v72 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v72 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v23 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "adf37d6a281dc96ff3c57e7c78fccdbd00fbd81584341173840ee4f530c2d27f",
            "metadata": {},
            "name": "tableBody_issueTableHierarchy_childIssuesPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isJscIFCEnabled": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$2d7551dd29053c95$var$node.hash = "7f004c25a1c439aa277ae00a3fd220b3";
var $2d7551dd29053c95$export$2e2bcd8739ae039 = $2d7551dd29053c95$var$node;

});


parcelRegister("4gytc", function(module, exports) {
$parcel$export(module.exports, "useUpdateHierarchyHasChildrenOnExpand", () => $c9ddcf47968a6013$export$7ab3d5838740f061);
$parcel$export(module.exports, "useUpdateGroupIssueCountOnExpand", () => $c9ddcf47968a6013$export$60baf22d0466329d);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kqd31 = parcelRequire("kqd31");
const $c9ddcf47968a6013$export$7ab3d5838740f061 = ({ connectionMetadata: connectionMetadata, projectKey: projectKey, childCount: childCount })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    (0, $eJOHy.useEffect)(()=>{
        if (connectionMetadata?.type === 'PARENT_CHILDREN' && childCount === 0) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const parentIssueRecord = store.get(connectionMetadata.parentRelayId);
            const updateArgs = projectKey ? {
                filterByProjectKeys: [
                    projectKey
                ]
            } : undefined;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            if (parentIssueRecord && parentIssueRecord.getValue('hasChildren', updateArgs) === true) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            parentIssueRecord.setValue(false, 'hasChildren', updateArgs);
        });
    }, [
        childCount,
        connectionMetadata,
        environment,
        projectKey
    ]);
};
const $c9ddcf47968a6013$export$60baf22d0466329d = ({ groupId: groupId, isGroupChildren: isGroupChildren, totalIssueSearchResultCount: totalIssueSearchResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // we need to update the group only once when the component mounts which happens on first expand
    // Other changes to issue count will be handled by realtime connection updates
    // also, we don't need to update the "firstGroup" field in the group record as it's expanded on default and realtime event always updates it
    const hasIssueCountUpdated = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasIssueCountUpdated.current && groupId && isGroupChildren) (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const relayId = (0, $kqd31.default)({
                id: groupId
            }, 'JiraSpreadsheetGroup');
            if (!relayId) return;
            const groupRecord = store.get(relayId);
            if (groupRecord?.getValue('issueCount') !== totalIssueSearchResultCount && !isCappingIssueSearchResult) groupRecord?.setValue(totalIssueSearchResultCount, 'issueCount');
        });
        hasIssueCountUpdated.current = true;
    }, [
        environment,
        groupId,
        isCappingIssueSearchResult,
        isGroupChildren,
        totalIssueSearchResultCount
    ]);
};

});

parcelRegister("7Slu4", function(module, exports) {
$parcel$export(module.exports, "ChildIssueCreateRow", () => $ab6d35972ebfb79a$export$3a3a78b432b7032f);

var $eJOHy = parcelRequire("eJOHy");

var $gOwRD = parcelRequire("gOwRD");
const $ab6d35972ebfb79a$export$3a3a78b432b7032f = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gOwRD.IssueCreateCell), props));
};

});
parcelRegister("gOwRD", function(module, exports) {
$parcel$export(module.exports, "IssueCreateCell", () => $1a3532c480c6bbee$export$2337c3632571bf46);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6xIZT = parcelRequire("6xIZT");
const $1a3532c480c6bbee$export$2337c3632571bf46 = ({ parentIssueAri: parentIssueAri, siblingIssueId: siblingIssueId, depth: depth, isIssueRankDescending: isIssueRankDescending, width: width, onCreateIssue: onCreateIssue, rankFieldId: rankFieldId, ...props })=>{
    const formContextualFields = (0, $eJOHy.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        }, [
        isIssueRankDescending,
        siblingIssueId,
        rankFieldId
    ]);
    const handleIssueCreate = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            parentIssueAri: parentIssueAri
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $1a3532c480c6bbee$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1a3532c480c6bbee$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        depth: depth + 1,
        rankFieldId: rankFieldId,
        ...props
    })));
};
const $1a3532c480c6bbee$var$cellStyles = (0, $1DXK0.xcss)({
    height: '40px',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $1a3532c480c6bbee$var$boxStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});

});




parcelRegister("NWRt9", function(module, exports) {
$parcel$export(module.exports, "FirstGroupRow", () => $ba5c06f69d989bc8$export$ac1801bcb8e0f256);
$parcel$export(module.exports, "GroupRow", () => $ba5c06f69d989bc8$export$84aac6ac2cec7eed);

var $bZGhL = parcelRequire("bZGhL");

var $d1QXB = parcelRequire("d1QXB");

var $bzPan = parcelRequire("bzPan");

var $eJOHy = parcelRequire("eJOHy");

var $8sbs2 = parcelRequire("8sbs2");

var $j4oe4 = parcelRequire("j4oe4");

var $68iTT = parcelRequire("68iTT");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $9AekN = parcelRequire("9AekN");

var $cxKOj = parcelRequire("cxKOj");

var $3mZMJ = parcelRequire("3mZMJ");

var $8ntPR = parcelRequire("8ntPR");

var $a23vo = parcelRequire("a23vo");

var $4k0Ma = parcelRequire("4k0Ma");

var $hqK6S = parcelRequire("hqK6S");
const $ba5c06f69d989bc8$var$toGroupContextFieldInput = ({ fieldId: fieldId, fieldValue: fieldValue, groupId: groupId, fieldType: fieldType, fieldSetId: fieldSetId })=>{
    const groupFieldValueBase = {
        fieldId: fieldId,
        groupId: groupId,
        optimisticResponse: fieldSetId ? $ba5c06f69d989bc8$export$6afa27f3196791b2({
            fieldType: fieldType,
            fieldSetId: fieldSetId,
            fieldValue: fieldValue
        }) : undefined
    };
    switch(fieldValue?.__typename){
        case 'JiraJqlPriorityFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.PRIORITY_TYPE),
                fieldValue: fieldValue?.priority?.priorityId ?? null
            };
        case 'JiraJqlUserFieldValue':
            return (0, $8ntPR.isUserFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.user?.accountId ?? null
            } : undefined;
        case 'JiraJqlStatusFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.STATUS_TYPE),
                fieldValue: fieldValue?.status?.id ?? null
            };
        case 'JiraJqlNumberFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.NUMBER_CF_TYPE),
                fieldValue: fieldValue?.number ?? null
            };
        case 'JiraJqlOptionFieldValue':
            return (0, $8ntPR.isOptionFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.option?.optionId ?? null
            } : undefined;
        case 'JiraJqlSprintFieldValue':
            return {
                ...groupFieldValueBase,
                fieldType: (0, $3mZMJ.SPRINT_TYPE),
                fieldValue: fieldValue?.sprint?.sprintId ?? null
            };
        case 'JiraJqlLabelFieldValue':
            return (0, $8ntPR.isLabelFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.label?.name ?? null
            } : undefined;
        case 'JiraJqlGroupFieldValue':
            return (0, $8ntPR.isGroupPickerFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.group?.name ?? null
            } : undefined;
        case 'JiraJqlVersionFieldValue':
            return (0, $8ntPR.isVersionFieldType)(fieldType) ? {
                ...groupFieldValueBase,
                fieldType: fieldType,
                fieldValue: fieldValue?.version?.versionId ?? null
            } : undefined;
        default:
            return undefined;
    }
};
const $ba5c06f69d989bc8$export$6afa27f3196791b2 = ({ fieldType: fieldType, fieldSetId: fieldSetId, fieldValue: fieldValue })=>{
    if (!fieldSetId) return undefined;
    switch(fieldType){
        case 0, $3mZMJ.PRIORITY_TYPE:
            if (fieldValue?.__typename === 'JiraJqlPriorityFieldValue' && fieldValue?.priority) return {
                type: (0, $3mZMJ.PRIORITY_TYPE),
                fieldSetId: fieldSetId,
                priority: {
                    id: fieldValue.priority.priorityId,
                    name: fieldValue.priority.name,
                    iconUrl: fieldValue.priority.iconUrl
                }
            };
            break;
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
        case 0, $3mZMJ.USER_CF_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                user: fieldValue?.__typename === 'JiraJqlUserFieldValue' && fieldValue?.user ? {
                    id: fieldValue.user.accountId,
                    accountId: fieldValue.user.accountId,
                    name: fieldValue.user.name,
                    picture: fieldValue.user.picture
                } : null
            };
        case 0, $3mZMJ.STATUS_TYPE:
            if (fieldValue?.__typename === 'JiraJqlStatusFieldValue' && fieldValue?.status && fieldValue?.status.statusCategory) return {
                type: (0, $3mZMJ.STATUS_TYPE),
                fieldSetId: fieldSetId,
                status: {
                    id: fieldValue.status.id,
                    name: fieldValue.status.name,
                    statusId: fieldValue.status.id,
                    statusCategory: {
                        statusCategoryId: fieldValue.status.statusCategory.statusCategoryId,
                        id: fieldValue.status.statusCategory.id
                    }
                }
            };
            break;
        case 0, $3mZMJ.SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
        case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
        case 0, $3mZMJ.CATEGORY_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                option: fieldValue?.__typename === 'JiraJqlOptionFieldValue' && fieldValue?.option ? {
                    id: fieldValue.option.optionId,
                    value: fieldValue.option.value,
                    optionId: fieldValue.option.optionId,
                    color: fieldValue.option.color ? {
                        colorKey: fieldValue.option.color.colorKey,
                        id: fieldValue.option.color.id
                    } : undefined
                } : null
            };
        case 0, $3mZMJ.SPRINT_TYPE:
            return {
                type: (0, $3mZMJ.SPRINT_TYPE),
                fieldSetId: fieldSetId,
                sprint: fieldValue?.__typename === 'JiraJqlSprintFieldValue' && fieldValue?.sprint ? {
                    id: fieldValue.sprint.sprintId,
                    sprintId: fieldValue.sprint.sprintId,
                    name: fieldValue.sprint.name,
                    state: fieldValue.sprint.state,
                    endDate: fieldValue.sprint.endDate
                } : null
            };
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
            return {
                type: (0, $3mZMJ.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                fieldSetId: fieldSetId
            };
        case 0, $3mZMJ.NUMBER_CF_TYPE:
            return {
                type: (0, $3mZMJ.NUMBER_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlNumberFieldValue' ? fieldValue.number : null,
                fieldSetId: fieldSetId,
                isStoryPointField: true
            };
        case 0, $3mZMJ.LABELS_TYPE:
        case 0, $3mZMJ.LABELS_CF_TYPE:
            return {
                type: (0, $4cTDP.fg)('group_by_any_field') ? fieldType : (0, $3mZMJ.LABELS_TYPE),
                value: fieldValue?.__typename === 'JiraJqlLabelFieldValue' ? fieldValue.label?.name ?? null : null,
                fieldSetId: fieldSetId
            };
        case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
            return {
                type: (0, $3mZMJ.MULTI_GROUP_CF_TYPE),
                value: fieldValue?.__typename === 'JiraJqlGroupFieldValue' && fieldValue?.group ? {
                    id: fieldValue.group.id,
                    groupId: fieldValue.group.groupId,
                    name: fieldValue.group.name
                } : null,
                fieldSetId: fieldSetId
            };
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
            return {
                type: fieldType,
                fieldSetId: fieldSetId,
                version: fieldValue?.__typename === 'JiraJqlVersionFieldValue' && fieldValue?.version ? {
                    id: fieldValue.version.id,
                    name: fieldValue.version.name ?? '',
                    versionId: fieldValue.version.versionId
                } : null
            };
        default:
            return undefined;
    }
};
const $ba5c06f69d989bc8$export$ac1801bcb8e0f256 = /*#__PURE__*/ (0, $eJOHy.memo)(({ firstGroupRow: firstGroupRow, rankField: rankField, groupConnectionId: groupConnectionId, isVirtual: isVirtual, loading: loading, isGroupAtTop: isGroupAtTop, projectKey: projectKey = null, columns: columns, actionColumns: actionColumns, amountOfColumns: amountOfColumns, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isTimelineEnabled: isTimelineEnabled, pageSize: pageSize, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, width: width, isIssueRankDescending: isIssueRankDescending, isIssueCreateEnabled: isIssueCreateEnabled, isGridNavigationEnabled: isGridNavigationEnabled, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled, isEditableSyncLoaded: isEditableSyncLoaded, isInlineEditingEnabled: isInlineEditingEnabled })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const firstGroupRowData = (0, $j4oe4.useFragment)((0, $bzPan.default), firstGroupRow);
    const variables = (0, $eJOHy.useMemo)(()=>{
        return {
            ...(0, $9AekN.getChildQueryVariablesForJql)({
                cloudId: cloudId,
                columns: columns,
                jql: firstGroupRowData.jql,
                isReparentingEnabled: false,
                isTimelineEnabled: isTimelineEnabled,
                actionColumns: actionColumns,
                amountOfColumns: amountOfColumns,
                pageSize: pageSize,
                isHideDoneItemsEnabled: isHideDoneItemsEnabled,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded
            }),
            shouldQueryFieldSetsById: false,
            namespace: 'ISSUE_NAVIGATOR',
            shouldQueryHasChildren: false,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled
        };
    }, [
        cloudId,
        columns,
        firstGroupRowData.jql,
        isTimelineEnabled,
        actionColumns,
        amountOfColumns,
        pageSize,
        isConditionalFormattingEnabled,
        isHideDoneItemsEnabled,
        isInlineFieldConfigEnabled,
        isInlineEditingEnabled,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded
    ]);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $d1QXB.default), rankField);
    const baseProps = [
        'cloudId',
        'issueSearchInput',
        'fieldSetsInput',
        'scope'
    ];
    const propsWithViewConfigInput = [
        ...baseProps,
        'viewConfigInput'
    ];
    const hasInitialised = (0, $4k0Ma.useInitialiseFirstGroupIssues)({
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        firstGroupItemsConnectionId: firstGroupRowData.issues?.__id ?? null,
        issueSearchVariables: (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(variables, ...isHideDoneItemsEnabled ? propsWithViewConfigInput : baseProps),
        loading: loading
    });
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: firstGroupRowData.id,
        groupId: firstGroupRowData.id,
        itemsConnectionId: groupConnectionId
    });
    let inlineCreateHandlers;
    let groupContextFieldInput;
    if ((0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        inlineCreateHandlers = (0, $68iTT.useInlineCreateHandlers)({
            projectKey: projectKey,
            defaultAssigneeId: firstGroupRowData.fieldType === (0, $3mZMJ.ASSIGNEE_TYPE) && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? firstGroupRowData.fieldValue?.user?.id : undefined,
            minHierarchyLevel: 0
        });
        const { fieldId: fieldId, fieldType: fieldType } = firstGroupRowData;
        if (fieldId && fieldType) groupContextFieldInput = $ba5c06f69d989bc8$var$toGroupContextFieldInput({
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: firstGroupRowData.fieldValue,
            groupId: firstGroupRowData.id,
            fieldSetId: firstGroupRowData.fieldSetId
        });
    }
    const renderChildIssueControllerWithGroupContextField = (0, $eJOHy.useCallback)((args)=>{
        return renderCreateIssueController?.({
            ...args,
            groupContextFieldInput: groupContextFieldInput
        });
    }, [
        renderCreateIssueController,
        groupContextFieldInput
    ]);
    const renderRowsWithGroupContextField = (0, $eJOHy.useCallback)((args)=>{
        return renderRows?.({
            ...args,
            groupContextFieldInput: groupContextFieldInput
        });
    }, [
        renderRows,
        groupContextFieldInput
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqK6S.GroupHeader), {
        projectKey: projectKey,
        groupHeader: firstGroupRowData,
        groupConnectionId: groupConnectionId,
        isGroupAtTop: isGroupAtTop,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: firstGroupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
    }), hasInitialised && isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a23vo.FirstGroupIssues), {
        variables: variables,
        rankField: rankFieldData ?? null,
        groupId: firstGroupRowData.id,
        groupConnectionId: groupConnectionId,
        groupFieldValue: firstGroupRowData.fieldValue?.jqlTerm ?? null,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        pageSize: pageSize,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        renderRows: (0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') ? renderRowsWithGroupContextField : renderRows,
        renderCreateIssueController: (0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false) ? renderChildIssueControllerWithGroupContextField : renderCreateIssueController,
        renderDraggableWrapper: renderDraggableWrapper,
        ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
        isTimelineEnabled: isTimelineEnabled
    }));
});
const $ba5c06f69d989bc8$export$84aac6ac2cec7eed = /*#__PURE__*/ (0, $eJOHy.memo)(({ groupRow: groupRow, groupConnectionId: groupConnectionId, isVirtual: isVirtual, projectKey: projectKey = null, columns: columns, isIssueCreateEnabled: isIssueCreateEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, renderChildRows: renderChildRows })=>{
    const groupRowData = (0, $j4oe4.useFragment)((0, $bZGhL.default), groupRow);
    let inlineCreateHandlers;
    let groupContextField;
    if ((0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
        inlineCreateHandlers = (0, $68iTT.useInlineCreateHandlers)({
            projectKey: projectKey,
            defaultAssigneeId: groupRowData.fieldType === (0, $3mZMJ.ASSIGNEE_TYPE) && (0, $4cTDP.fg)('jira_render_pic_in_nin') ? groupRowData.fieldValue?.user?.id : undefined,
            minHierarchyLevel: 0
        });
        const { fieldId: fieldId, fieldType: fieldType } = groupRowData;
        if (fieldId && fieldType) groupContextField = $ba5c06f69d989bc8$var$toGroupContextFieldInput({
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: groupRowData.fieldValue,
            groupId: groupRowData.id,
            fieldSetId: groupRowData.fieldSetId
        });
    }
    return groupRowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqK6S.GroupHeader), {
        projectKey: projectKey,
        groupHeader: groupRowData,
        groupConnectionId: groupConnectionId,
        createChildTriggerProps: inlineCreateHandlers?.triggerProps,
        columnsCount: columns.length,
        groupId: groupRowData.id,
        isIssueCreateEnabled: isIssueCreateEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isStickyColumnsVisible: isStickyColumnsVisible,
        isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
    }), renderChildRows?.({
        parentItemId: groupRowData.id,
        itemsConnectionId: groupConnectionId,
        depth: 0,
        type: 'GROUP_CHILDREN',
        groupFieldValue: groupRowData.fieldValue?.jqlTerm ?? null,
        groupJql: groupRowData.jql,
        formProps: inlineCreateHandlers?.formProps,
        isFormVisible: inlineCreateHandlers?.isFormVisible,
        groupId: groupRowData.id,
        groupContextField: groupContextField
    }));
});

});
parcelRegister("bZGhL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5518fcc53c1bc08b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4707d11394ed8d1871a152ce55c7af1c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5518fcc53c1bc08b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "FirstGroupRow_GroupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "kind": "ScalarField",
                "name": "fieldSetId"
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "GroupHeader"
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$5518fcc53c1bc08b$var$node.hash = "a52879ddb058e5a555c580af3ede9fbe";
var $5518fcc53c1bc08b$export$2e2bcd8739ae039 = $5518fcc53c1bc08b$var$node;

});

parcelRegister("d1QXB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a176cb75ffd839b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d7e5d20e0b6fe59f2b9427e40e88324>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a176cb75ffd839b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FirstGroupRow_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "FirstGroupIssues"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$2a176cb75ffd839b$var$node.hash = "7036d2690ec547661beb6083ae77c4c9";
var $2a176cb75ffd839b$export$2e2bcd8739ae039 = $2a176cb75ffd839b$var$node;

});

parcelRegister("bzPan", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6aa49075523806e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc546f19888560bf73ee6e3a63f3bb9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6aa49075523806e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "issues"
                    ]
                }
            ]
        },
        "name": "FirstGroupRow",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                "action": "THROW",
                "path": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "fieldType"
            },
            {
                "kind": "ScalarField",
                "name": "fieldSetId"
            },
            {
                "kind": "LinkedField",
                "name": "fieldValue",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlPriorityFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlUserFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCategoryId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlStatusFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ],
                        "type": "JiraJqlNumberFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ],
                        "type": "JiraJqlSprintFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v2 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    },
                                    v2 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "GroupHeader"
            },
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetsInput",
                        "variableName": "fieldSetsInput"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "fieldSetsScope"
                    },
                    {
                        "kind": "Variable",
                        "name": "settings",
                        "variableName": "settings"
                    },
                    {
                        "kind": "Variable",
                        "name": "viewConfigInput",
                        "variableName": "viewConfigInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__firstGroupSection_nativeIssueTable__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isDensityFull",
                                "variableName": "isDensityFull"
                            },
                            {
                                "kind": "Variable",
                                "name": "isEditableSyncLoaded",
                                "variableName": "isEditableSyncLoaded"
                            },
                            {
                                "kind": "Variable",
                                "name": "isInlineEditingEnabled",
                                "variableName": "isInlineEditingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isLinkRelationshipFieldEnabled",
                                "variableName": "isLinkRelationshipFieldEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isRemoteLinkedIssuesEnabled",
                                "variableName": "isRemoteLinkedIssuesEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isTimelineEnabled",
                                "variableName": "isTimelineEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "ChildRowsPagination_issues"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroup"
    };
}();
$a6aa49075523806e$var$node.hash = "7aa28decab9e13929ded4f5e22d3d8bf";
var $a6aa49075523806e$export$2e2bcd8739ae039 = $a6aa49075523806e$var$node;

});

parcelRegister("a23vo", function(module, exports) {
$parcel$export(module.exports, "FirstGroupIssues", () => $78949f6f69c2e45e$export$e2f0ecb1fcdc2610);

var $2YFHi = parcelRequire("2YFHi");

var $afBBg = parcelRequire("afBBg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eoeem = parcelRequire("eoeem");
const $78949f6f69c2e45e$export$e2f0ecb1fcdc2610 = ({ variables: variables, rankField: rankField, groupId: groupId, groupConnectionId: groupConnectionId, groupFieldValue: groupFieldValue, isFormVisible: isFormVisible, formProps: formProps, childItemsExperience: childItemsExperience, childItemsLoadMoreExperience: childItemsLoadMoreExperience, analyticsSource: analyticsSource, pageSize: pageSize, width: width, isIssueRankDescending: isIssueRankDescending, renderRows: renderRows, renderCreateIssueController: renderCreateIssueController, renderDraggableWrapper: renderDraggableWrapper, ChildIssueCreateRowComponent: ChildIssueCreateRowComponent, isTimelineEnabled: isTimelineEnabled })=>{
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $afBBg.default), variables, {
        fetchPolicy: 'store-only'
    });
    const rankFieldData = (0, $j4oe4.useFragment)((0, $2YFHi.default), rankField);
    const connectionMetadata = (0, $eJOHy.useMemo)(()=>variables.issueSearchInput.jql ? {
            type: 'GROUP_CHILDREN',
            fieldValue: groupFieldValue,
            groupId: groupId,
            jql: variables.issueSearchInput.jql
        } : undefined, [
        groupFieldValue,
        groupId,
        variables.issueSearchInput.jql
    ]);
    // Ensure relay cache is in correct state
    if (!data?.jira?.issueSearch?.edges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eoeem.ChildRowsPagination), {
        query: data,
        depth: 0,
        parentItemId: groupId,
        groupId: groupId,
        itemsConnectionId: groupConnectionId,
        connectionMetadata: connectionMetadata,
        width: width,
        isIssueRankDescending: isIssueRankDescending,
        pageSize: pageSize,
        childItemsExperience: childItemsExperience,
        childItemsLoadMoreExperience: childItemsLoadMoreExperience,
        analyticsSource: analyticsSource,
        rankFieldId: rankFieldData?.fieldId ?? null,
        renderRows: renderRows,
        renderCreateIssueController: renderCreateIssueController,
        renderDraggableWrapper: renderDraggableWrapper,
        isFormVisible: isFormVisible,
        formProps: formProps,
        ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
        isTimelineEnabled: isTimelineEnabled
    });
};

});
parcelRegister("2YFHi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a027866b3db236f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c679e0018346be6c2b20c2cf821164d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a027866b3db236f1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FirstGroupIssues",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$a027866b3db236f1$var$node.hash = "07fdb734208e30b5f6168c7a0d56cad5";
var $a027866b3db236f1$export$2e2bcd8739ae039 = $a027866b3db236f1$var$node;

});

parcelRegister("afBBg", function(module, exports) {
$parcel$export(module.exports, "default", () => $beae842622088a12$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2367eeef55a7d3fd3026c62eb9f16407>>
 * @relayHash 330fc73d787443f2103deeae10099eb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d0b54395c3dd286ef69e4fa2181b21eb661dafc40cf07d9f17e244a0bb04e12

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $ad5K7 = parcelRequire("ad5K7");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $gDQIG = parcelRequire("gDQIG");

var $iOvkB = parcelRequire("iOvkB");

var $FU9UR = parcelRequire("FU9UR");
const $beae842622088a12$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRemoteLinkedIssuesEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v16 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v17 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v18 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v19 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v20 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v21 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v24 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v25 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v26 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v25 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v27 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v18 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "id"
    }, v29 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "key"
    }, v31 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v33 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v34 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v35 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = [
        v37 /*: any*/ 
    ], v39 = {
        "kind": "ScalarField",
        "name": "isRemoteIssue"
    }, v40 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v41 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v42 = [
        v37 /*: any*/ ,
        v28 /*: any*/ 
    ], v43 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "value"
    }, v49 = [
        v48 /*: any*/ ,
        v28 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v50 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v51 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ 
        ]
    }, v52 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v53 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v54 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v55 = {
        "kind": "ScalarField",
        "name": "date"
    }, v56 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "text"
    }, v58 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v59 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v28 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v61 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v57 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v62 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v63 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v65 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v66 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v67 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v68 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v69 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v70 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v71 = [
        v28 /*: any*/ 
    ], v72 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v71 /*: any*/ 
    }, v73 = {
        "kind": "ClientExtension",
        "selections": [
            v41 /*: any*/ 
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "href"
    }, v75 = [
        v74 /*: any*/ 
    ], v76 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v31 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v77 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v78 = {
        "kind": "InlineFragment",
        "selections": [
            v55 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v79 = [
        v22 /*: any*/ ,
        v47 /*: any*/ ,
        v78 /*: any*/ ,
        v28 /*: any*/ 
    ], v80 = [
        v22 /*: any*/ ,
        v28 /*: any*/ 
    ], v81 = [
        v22 /*: any*/ ,
        v78 /*: any*/ ,
        v28 /*: any*/ 
    ], v82 = {
        "args": v77 /*: any*/ ,
        "kind": "LinkedField",
        "name": "startDateViewField",
        "plural": false,
        "selections": v81 /*: any*/ ,
        "storageKey": "startDateViewField(viewId:\"list_default\")"
    }, v83 = {
        "args": v77 /*: any*/ ,
        "kind": "LinkedField",
        "name": "endDateViewField",
        "plural": false,
        "selections": v81 /*: any*/ ,
        "storageKey": "endDateViewField(viewId:\"list_default\")"
    }, v84 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FirstGroupIssuesQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isEditableSyncLoaded",
                            "variableName": "isEditableSyncLoaded"
                        },
                        {
                            "kind": "Variable",
                            "name": "isLinkRelationshipFieldEnabled",
                            "variableName": "isLinkRelationshipFieldEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isRemoteLinkedIssuesEnabled",
                            "variableName": "isRemoteLinkedIssuesEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isTimelineEnabled",
                            "variableName": "isTimelineEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ChildRowsPagination"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "issueSearch",
                            "args": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "__hierarchy_nativeIssueTable__issueSearch_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v10 /*: any*/ ,
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v12 /*: any*/ ,
                v3 /*: any*/ ,
                v15 /*: any*/ ,
                v14 /*: any*/ ,
                v9 /*: any*/ ,
                v13 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "FirstGroupIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v27 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v31 /*: any*/ ,
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                },
                                                v32 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": v38 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isRemoteLinkedIssuesEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isLinkRelationshipFieldEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": v42 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v43 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v22 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "serviceId"
                                                                                                                        },
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraAffectedServicesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "cascadingOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "childOptionValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v49 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCascadingSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "objectId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "label"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "clientId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "fileId"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "url48"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "QueryError",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "errors",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "message"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCMDBField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedComponentsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v54 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraComponentsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v55 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                v56 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDatePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateTime"
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraDateTimePickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraEpic",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "epic",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "summary"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraEpicLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "renderedFieldHtml"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFallbackField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v57 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusCategoryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v34 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedLabelsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraLabelsField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "small"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v37 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraColorField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueColorField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v59 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueTypeField",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v60 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v61 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v29 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "issuetype",
                                                                                                                                "project",
                                                                                                                                "summary",
                                                                                                                                "status"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                v57 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "issueType",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                                        v31 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v47 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "status",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                                v33 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v31 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v35 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraParentIssueField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v30 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "large"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraResolution",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "resolution",
                                                                                                    "plural": false,
                                                                                                    "selections": v42 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraResolutionField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedSprintsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "sprintId"
                                                                                                                        },
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "state"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "endDate"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSprintField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        v64 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v65 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "appType"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AppUser"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v56 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraRichText",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "richText",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraADF",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "adfValue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "convertedPlainText",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "plainText"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraRichTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "requestType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "first",
                                                                                                            "value": 1
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueLinkConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v40 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "statusCategory"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v34 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                        },
                                                                                                                                                        v28 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v32 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v28 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v66 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueLinkField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isStoryPointField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "number"
                                                                                                },
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "formatConfig",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatStyle"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "formatUnit"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraNumberField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commentSummary",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canAddComment"
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCommentSummaryField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "uri"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraUrlField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v67 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v67 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedUsersConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "email"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraTeamView",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedTeam",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "jiraSuppliedName"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraTeamViewField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v44 /*: any*/ ,
                                                                                                                        v51 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "timeTrackingField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": "label",
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "value"
                                                                                                        },
                                                                                                        v28 /*: any*/ ,
                                                                                                        v53 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraRadioSelectField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedVersionsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v54 /*: any*/ ,
                                                                                                                        v70 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                v72 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGoals",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "status"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v73 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        v41 /*: any*/ ,
                                                                                                        v50 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraGoalsField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        v72 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isLinkEditable"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "alias": "atlasProjectName",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "name"
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": "atlasProjectKey",
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "key"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "privateProject"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "hasPermission"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWorkspaceActive"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraTownsquareProjectField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "args": v52 /*: any*/ ,
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v74 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "pageContent",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": v75 /*: any*/ ,
                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v46 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedGroupsConnection",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "groupId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v51 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraFlag",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "flag",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isFlagged"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraFlagField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraWatch",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "watch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "count"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isWatching"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraWatchesField"
                                                                                        },
                                                                                        {
                                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLink",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "direction"
                                                                                                                },
                                                                                                                v66 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "type",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v71 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v58 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "isTimelineEnabled",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v76 /*: any*/ ,
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssueField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentIssue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v29 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v28 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v30 /*: any*/ ,
                                                                                                                v36 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "assigneeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v63 /*: any*/ ,
                                                                                                                                v28 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v28 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v77 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v79 /*: any*/ ,
                                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v77 /*: any*/ ,
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endDateViewField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v79 /*: any*/ ,
                                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v73 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "isConditionalFormattingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v52 /*: any*/ ,
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "componentId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "priorityId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "projectId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraVersion",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "version",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v70 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v62 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValue",
                                                                                                            "plural": false,
                                                                                                            "selections": v80 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedValues",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v80 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        {
                                            "condition": "shouldQueryHasChildren",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasChildren"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canHaveChildIssues"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isRemoteLinkedIssuesEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "issueError",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "errorType"
                                                                },
                                                                {
                                                                    "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "repairLink",
                                                                    "plural": false,
                                                                    "selections": v75 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraRemoteLinkedIssueError"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v73 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v26 /*: any*/ ,
                                {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v82 /*: any*/ ,
                                                                                                                v83 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraTimelineField"
                                                                                                },
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        v76 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v38 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v61 /*: any*/ ,
                                                        {
                                                            "args": v84 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinks",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v82 /*: any*/ ,
                                                                                        v83 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v28 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v66 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinks(first:10)"
                                                        },
                                                        {
                                                            "args": v84 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "timeline_jira_issueLinks",
                                                            "kind": "LinkedHandle",
                                                            "name": "issueLinks"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v73 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v43 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v73 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v27 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options",
                                "fieldSetsInput",
                                "viewConfigInput",
                                "scope"
                            ],
                            "handle": "connection",
                            "key": "hierarchy_nativeIssueTable__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d0b54395c3dd286ef69e4fa2181b21eb661dafc40cf07d9f17e244a0bb04e12",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "bidirectional",
                        "path": [
                            "jira",
                            "issueSearch"
                        ]
                    }
                ]
            },
            "name": "FirstGroupIssuesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": (0, $ad5K7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$beae842622088a12$var$node.hash = "9aafb51c23bd65f5f8abb1f8f2b25741";
var $beae842622088a12$export$2e2bcd8739ae039 = $beae842622088a12$var$node;

});


parcelRegister("4k0Ma", function(module, exports) {
$parcel$export(module.exports, "useInitialiseFirstGroupIssues", () => $dd008cff549f4f94$export$3e4eaea282025a37);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $jE8Tu = parcelRequire("jE8Tu");
const $dd008cff549f4f94$var$JIRA = 'jira';
const $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION = 'hierarchy_nativeIssueTable__issueSearch';
const $dd008cff549f4f94$var$JIRA_ISSUE_CONNECTION_TYPE = 'JiraIssueConnection';
const $dd008cff549f4f94$var$CONNECTION = 'connection';
const $dd008cff549f4f94$export$3e4eaea282025a37 = ({ groupId: groupId, groupConnectionId: groupConnectionId, firstGroupItemsConnectionId: firstGroupItemsConnectionId, issueSearchVariables: issueSearchVariables, loading: loading })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const hasInitialised = (0, $eJOHy.useRef)(false);
    const prevGroupConnectionId = (0, $eJOHy.useRef)(groupConnectionId);
    const prevFieldSetsInput = (0, $eJOHy.useRef)(issueSearchVariables.fieldSetsInput);
    const prevViewConfigInput = (0, $eJOHy.useRef)(issueSearchVariables.viewConfigInput);
    const prevLoading = (0, $eJOHy.useRef)(loading);
    const { setIsItemExpanded: setIsItemExpanded } = (0, $jE8Tu.useHierarchyActions)();
    // When firstGroupItemsConnectionId is available, if the groupConnectionId changes, fieldSetsInput change or view has finished loading, trigger re-initialisation
    if (!!firstGroupItemsConnectionId && (!loading && prevLoading.current || prevGroupConnectionId.current !== groupConnectionId || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevFieldSetsInput.current, issueSearchVariables.fieldSetsInput) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevViewConfigInput.current, issueSearchVariables.viewConfigInput))) {
        hasInitialised.current = false;
        prevGroupConnectionId.current = groupConnectionId;
        prevFieldSetsInput.current = issueSearchVariables.fieldSetsInput;
        prevViewConfigInput.current = issueSearchVariables.viewConfigInput;
        prevLoading.current = loading;
    }
    if (!hasInitialised.current) {
        setIsItemExpanded({
            itemId: groupId,
            groupId: groupId,
            itemsConnectionId: groupConnectionId
        }, true);
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const firstGroupIssuesConnection = store.get(firstGroupItemsConnectionId ?? '');
            const jiraRecord = store.getRoot().getLinkedRecord($dd008cff549f4f94$var$JIRA);
            if (!firstGroupIssuesConnection || !jiraRecord) return;
            const connectionId = (0, $37Ewn.ConnectionHandler).getConnectionID(jiraRecord.getDataID(), $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION, issueSearchVariables);
            // If connection already exists, update it with the latest data. This ensures the field sets are correct.
            let connection = store.get(connectionId);
            if (!connection) connection = store.create(connectionId, $dd008cff549f4f94$var$JIRA_ISSUE_CONNECTION_TYPE);
            connection.copyFieldsFrom(firstGroupIssuesConnection);
            jiraRecord.setLinkedRecord(connection, (0, $37Ewn.getRelayHandleKey)($dd008cff549f4f94$var$CONNECTION, $dd008cff549f4f94$var$HIERARCHY_ISSUE_SEARCH_CONNECTION), issueSearchVariables);
            hasInitialised.current = true;
        });
    }
    return hasInitialised.current;
};

});

parcelRegister("hqK6S", function(module, exports) {
$parcel$export(module.exports, "GroupHeader", () => $05c7b3019429c04e$export$58d63a2875c58fc8);

var $k81tZ = parcelRequire("k81tZ");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $j4oe4 = parcelRequire("j4oe4");

var $lT9x0 = parcelRequire("lT9x0");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $6efFi = parcelRequire("6efFi");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $2XtSM = parcelRequire("2XtSM");

var $cxKOj = parcelRequire("cxKOj");

var $3Ldj6 = parcelRequire("3Ldj6");

var $8ntPR = parcelRequire("8ntPR");

var $1W85r = parcelRequire("1W85r");

var $5FAgT = parcelRequire("5FAgT");

var $98A5p = parcelRequire("98A5p");

var $iqCxS = parcelRequire("iqCxS");

var $aaLj4 = parcelRequire("aaLj4");

var $k29Y8 = parcelRequire("k29Y8");

var $jiKXd = parcelRequire("jiKXd");

var $b8Nt1 = parcelRequire("b8Nt1");

var $cKV4K = parcelRequire("cKV4K");

var $9jwn7 = parcelRequire("9jwn7");

var $aLKjs = parcelRequire("aLKjs");

var $immik = parcelRequire("immik");

var $2mFVu = parcelRequire("2mFVu");

var $4zhkx = parcelRequire("4zhkx");

var $e0hmq = parcelRequire("e0hmq");

var $4z3Ld = parcelRequire("4z3Ld");
const $05c7b3019429c04e$var$isCompletedSprintGroup = (data)=>data?.fieldValue?.__typename === 'JiraJqlSprintFieldValue' && data.fieldValue.sprint?.state === 'CLOSED';
const $05c7b3019429c04e$var$isSubtaskGroup = (data)=>{
    return data.fieldValue?.__typename === 'JiraJqlIssueTypeFieldValue' && data.fieldValue.issueTypes?.[0]?.hierarchy?.level === -1;
};
const $05c7b3019429c04e$var$getGroupIssueTypeId = (data)=>{
    switch(data.fieldType){
        case 0, $3mZMJ.ISSUE_TYPE:
            return data.fieldValue?.issueTypes?.[0]?.issueTypeId;
        default:
            return null;
    }
};
const $05c7b3019429c04e$var$ONBOARDING_TARGET_NAME = 'issue-navigator-create-issue-in-group';
const $05c7b3019429c04e$export$58d63a2875c58fc8 = ({ groupHeader: groupHeader, groupConnectionId: groupConnectionId, createChildTriggerProps: createChildTriggerProps, isGroupAtTop: isGroupAtTop = false, columnsCount: columnsCount, groupId: groupId, isIssueCreateEnabled: isIssueCreateEnabled = true, isGridNavigationEnabled: isGridNavigationEnabled = false, isStickyColumnsVisible: isStickyColumnsVisible, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tableRowRef = (0, $eJOHy.useRef)(null);
    const data = (0, $j4oe4.useFragment)((0, $k81tZ.default), groupHeader);
    const itemDetails = (0, $eJOHy.useMemo)(()=>data ? {
            itemsConnectionId: groupConnectionId,
            itemId: data.id,
            groupId: groupId
        } : null, [
        data,
        groupConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = (0, $4cTDP.fg)('nin-grid-keyboard-navigation') ? (0, $jE8Tu.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $jE8Tu.useIsSelected)(itemDetails);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Scroll the table row into view (if needed - block: nearest) when it becomes selected
        if (isSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected
    ]);
    const { setDefaultIssueType: setDefaultIssueType } = (0, $1W85r.useIICConfigActions)();
    const groupIssueTypeId = $05c7b3019429c04e$var$getGroupIssueTypeId(data);
    const focusCurrentRow = (0, $eJOHy.useCallback)(()=>{
        if (groupIssueTypeId && projectKey && (0, $4cTDP.fg)('group_by_any_field_issue_type_iic_fix')) setDefaultIssueType(projectKey, groupIssueTypeId);
        return setSelectedRow(itemDetails);
    }, [
        setSelectedRow,
        itemDetails,
        groupIssueTypeId,
        projectKey,
        setDefaultIssueType
    ]);
    const groupHeaderView = (0, $eJOHy.useMemo)(()=>{
        switch(data.fieldType){
            case 0, $3mZMJ.PRIORITY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqCxS.PriorityGroupHeader), {
                    priorityGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.REPORTER_TYPE:
            case 0, $3mZMJ.ASSIGNEE_TYPE:
            case 0, $3mZMJ.USER_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4zhkx.UserGroupHeader), {
                    userGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $3mZMJ.STATUS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k29Y8.StatusGroupHeader), {
                    statusGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.NUMBER_CF_TYPE:
            case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiKXd.StoryPointsGroupHeader), {
                    storyPointsGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.GOALS_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8Nt1.GoalGroupHeader), {
                    goalGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.ATLAS_PROJECT_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4z3Ld.AtlasProjectGroupHeader), {
                    atlasProjectGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.CATEGORY_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5FAgT.CategoryGroupHeader), {
                    categoryGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.SELECT_CF_TYPE:
            case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
            case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            case 0, $3mZMJ.RADIO_BUTTONS_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $immik.OptionGroupHeader), {
                    optionGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $3mZMJ.SPRINT_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaLj4.SprintGroupHeader), {
                    sprintGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.LABELS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cKV4K.LabelGroupHeader), {
                    labelGroupHeader: data.fieldValue ?? null
                });
            // TODO: combine with LABELS_TYPE once we've cleaned up the group_by_any_field flags
            case 0, $3mZMJ.LABELS_CF_TYPE:
                return (0, $4cTDP.fg)('group_by_any_field') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cKV4K.LabelGroupHeader), {
                    labelGroupHeader: data.fieldValue ?? null
                }) : null;
            case 0, $3mZMJ.ISSUE_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9jwn7.IssueTypeGroupHeader), {
                    issueTypeGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.GROUP_CF_TYPE:
            case 0, $3mZMJ.MULTI_GROUP_CF_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLKjs.GroupPickerGroupHeader), {
                    groupPickerGroupHeader: data.fieldValue ?? null
                });
            case 0, $3mZMJ.VERSION_CF_TYPE:
            case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
            case 0, $3mZMJ.FIX_VERSIONS_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mFVu.VersionGroupHeader), {
                    versionGroupHeader: data.fieldValue ?? null,
                    fieldType: data.fieldType
                });
            case 0, $3mZMJ.RESOLUTION_TYPE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e0hmq.ResolutionGroupHeader), {
                    resolutionGroupHeader: data.fieldValue ?? null
                });
            default:
                // should never happen
                return null;
        }
    }, [
        data
    ]);
    const groupMetadata = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, groupHeaderView, !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(data?.issueCount) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.subtlest"
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $98A5p.default).issuesIssueTermRefresh : (0, $98A5p.default).issues, {
            count: data.issueCount
        })));
    }, [
        data.issueCount,
        formatMessage,
        groupHeaderView
    ]);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)(itemDetails);
    const [isLoading] = (0, $jE8Tu.useIsItemLoading)(data?.id ?? null);
    const onCreateChildClick = (0, $eJOHy.useCallback)(()=>{
        if (groupIssueTypeId && projectKey && !(0, $4cTDP.fg)('group_by_any_field_issue_type_iic_fix')) setDefaultIssueType(projectKey, groupIssueTypeId);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupCreateChildButton');
        if (!isExpanded) toggleIsItemExpanded(itemDetails, 0);
        createChildTriggerProps?.onClick();
    }, [
        createAnalyticsEvent,
        isExpanded,
        toggleIsItemExpanded,
        itemDetails,
        createChildTriggerProps,
        setDefaultIssueType,
        groupIssueTypeId,
        projectKey
    ]);
    const headerContent = (0, $eJOHy.useMemo)(()=>{
        if ((0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButton), {
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            isGroupButton: true,
            groupId: groupId
        }) : null, groupMetadata, isIssueCreateEnabled && (0, $8ntPR.isCreateIssueSupportedForFieldType)(data.fieldType) && !$05c7b3019429c04e$var$isCompletedSprintGroup(data) && !$05c7b3019429c04e$var$isSubtaskGroup(data) && (isGroupAtTop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: $05c7b3019429c04e$var$ONBOARDING_TARGET_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
            engagementId: $05c7b3019429c04e$var$ONBOARDING_TARGET_NAME
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _yt1xcs5v"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
            onClick: onCreateChildClick,
            ref: createChildTriggerProps?.ref,
            isCreateWorkItem: true
        }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.issueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButtonWithCreateChildButton), {
            isGroupButton: true,
            itemId: data.id,
            itemsConnectionId: groupConnectionId,
            depth: 0,
            groupId: groupId
        }) : null, groupMetadata);
    }, [
        data,
        groupConnectionId,
        groupId,
        groupMetadata,
        isIssueCreateEnabled,
        isGroupAtTop,
        onCreateChildClick,
        createChildTriggerProps?.ref
    ]);
    const rowIndex = itemDetails && (0, $4cTDP.fg)('nin-grid-keyboard-navigation') ? list.indexOf(`${itemDetails.itemId}::${itemDetails.itemId}`) + 1 : -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        role: "row",
        tabIndex: -1,
        ...rowIndex > 0 && isGridNavigationEnabled && {
            'aria-rowindex': rowIndex
        },
        onFocus: focusCurrentRow,
        "data-testid": "issue-table-grouping.ui.group-row.group-header.tr",
        "aria-selected": isSelected,
        ref: tableRowRef,
        className: (0, $hcewu.default)([
            "_nt751r31 _49pcglyw _1hvw1o36 _irr3108i",
            isSelected && !isGridNavigationEnabled && "_bfhkfg4m _irr3i1yw",
            isGridNavigationEnabled && "_10j7fg4m _1p0pi1yw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td" // Additional column for configure columns menu & issue actions
        ,
        colSpan: columnsCount + 1,
        xcss: [
            $05c7b3019429c04e$var$borderStyles,
            isGroupAtTop && $05c7b3019429c04e$var$removeTopBorder,
            $05c7b3019429c04e$var$rowHeight,
            (!isExpanded || isLoading || !data.issueCount || (0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) && $05c7b3019429c04e$var$removeBottomBorder
        ],
        ...isGridNavigationEnabled && {
            tabIndex: -1
        }
    }, isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-table-grouping.ui.group-row.group-header.sticky-header",
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isAutoUnstickyOnSmallScreenEnabled ? $05c7b3019429c04e$var$stickyContainerResponsiveStyles : $05c7b3019429c04e$var$stickyContainerStyles : $05c7b3019429c04e$var$stickyContainerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $05c7b3019429c04e$var$inlineStyles,
            !data.issueCount && $05c7b3019429c04e$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $05c7b3019429c04e$var$inlineStyles,
            !data.issueCount && $05c7b3019429c04e$var$placeholderStyles
        ],
        space: "space.100"
    }, headerContent)));
};
const $05c7b3019429c04e$var$inlineStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.150',
    alignItems: 'center',
    gap: 'space.100'
});
const $05c7b3019429c04e$var$placeholderStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'space.400'
});
const $05c7b3019429c04e$var$stickyContainerStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    width: 'fit-content'
});
const $05c7b3019429c04e$var$stickyContainerStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    width: 'fit-content'
});
const $05c7b3019429c04e$var$stickyContainerResponsiveStyles = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        position: 'sticky',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        left: 'space.0',
        width: 'fit-content'
    }
});
const $05c7b3019429c04e$var$borderStyles = (0, $1DXK0.xcss)({
    border: 0,
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: 'border.width'
});
const $05c7b3019429c04e$var$removeTopBorder = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0'
});
const $05c7b3019429c04e$var$removeBottomBorder = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0'
});
const $05c7b3019429c04e$var$headerRowStyles = null;
const $05c7b3019429c04e$var$headerRowKeyboardNavigationStyles = null;
const $05c7b3019429c04e$var$activeRowStyles = null;
const $05c7b3019429c04e$var$raiseOnHoverStyles = null;
const $05c7b3019429c04e$var$rowHeight = (0, $1DXK0.xcss)({
    height: "var(--ds-space-500, 40px)"
});

});
parcelRegister("k81tZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $73da2ea55eabf43e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c30c64201d8c447494d4d8cf97eef649>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $73da2ea55eabf43e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "GroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldType"
        },
        {
            "kind": "ScalarField",
            "name": "issueCount"
        },
        {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "PriorityGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "UserGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "StatusGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "CategoryGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "OptionGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "VersionGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SprintGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "StoryPointsGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GoalGroupHeader"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "AtlasProjectGroupHeader"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "LabelGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "IssueTypeGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GroupPickerGroupHeader"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ResolutionGroupHeader"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "level"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraJqlIssueTypeFieldValue"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                }
                            ]
                        }
                    ],
                    "type": "JiraJqlSprintFieldValue"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroup"
};
$73da2ea55eabf43e$var$node.hash = "41baca64a8150960836113c6c55178c3";
var $73da2ea55eabf43e$export$2e2bcd8739ae039 = $73da2ea55eabf43e$var$node;

});

parcelRegister("2XtSM", function(module, exports) {
$parcel$export(module.exports, "ExpandButton", () => $e99284d207f534ad$export$5663c8f5aeb8c1c4);
$parcel$export(module.exports, "CreateChildButtonWithExpandToggle", () => $e99284d207f534ad$export$86df7a8824b06d6e);
$parcel$export(module.exports, "ExpandButtonWithCreateChildButton", () => $e99284d207f534ad$export$b921667debd4e0cb);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3Ldj6 = parcelRequire("3Ldj6");

var $jE8Tu = parcelRequire("jE8Tu");

var $d8783 = parcelRequire("d8783");

var $5XgIy = parcelRequire("5XgIy");
const $e99284d207f534ad$var$ICON_WIDTH = 24;
const $e99284d207f534ad$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND = 8;
const $e99284d207f534ad$export$5663c8f5aeb8c1c4 = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, isGroupButton: isGroupButton, groupId: groupId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    const onExpandClick = (0, $eJOHy.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupExpandButton' : 'hierarchyExpandButton';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId,
            groupId: groupId
        }, depth);
    }, [
        createAnalyticsEvent,
        depth,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton,
        groupId
    ]);
    const label = (0, $eJOHy.useMemo)(()=>{
        if (isGroupButton) return formatMessage(isExpanded ? (0, $d8783.default).collapseGroup : (0, $d8783.default).expandGroup);
        return formatMessage(isExpanded ? (0, $d8783.default).collapseIssue : (0, $d8783.default).expandIssue);
    }, [
        formatMessage,
        isExpanded,
        isGroupButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        spacing: "compact",
        appearance: "subtle",
        label: label,
        "aria-expanded": isExpanded,
        testId: "issue-table-hierarchy.ui.expand-button.expand-button",
        icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                ...iconProps,
                size: "small"
            }),
        onClick: onExpandClick,
        isTooltipDisabled: false
    });
};
const $e99284d207f534ad$export$86df7a8824b06d6e = ({ itemId: itemId, groupId: groupId, itemsConnectionId: itemsConnectionId, isCreateChildFormVisible: isCreateChildFormVisible, depth: depth, isGroupButton: isGroupButton, createChildTriggerProps: createChildTriggerProps, renderIcon: renderIcon })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isInlineCreateChildOpen, setIsInlineCreateChildOpen] = (0, $eJOHy.useState)(false);
    const [isExpanded, { toggleIsItemExpanded: toggleIsItemExpanded }] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: itemId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId
    });
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        if (!isCreateChildFormVisible) // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
        setIsInlineCreateChildOpen(false);
    }, [
        isCreateChildFormVisible
    ]);
    const onCreateChildClick = (0, $eJOHy.useCallback)(()=>{
        const actionSubjectId = isGroupButton ? 'groupCreateChildButton' : 'hierarchyCreateChildButton';
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', actionSubjectId);
        if (!isExpanded) toggleIsItemExpanded({
            itemId: itemId,
            itemsConnectionId: itemsConnectionId
        }, depth);
        if (!isCreateChildFormVisible) createChildTriggerProps?.onClick();
        setIsInlineCreateChildOpen(true);
    }, [
        createAnalyticsEvent,
        createChildTriggerProps,
        depth,
        isCreateChildFormVisible,
        isExpanded,
        itemId,
        itemsConnectionId,
        toggleIsItemExpanded,
        isGroupButton
    ]);
    return !isInlineCreateChildOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ldj6.default), {
        onClick: onCreateChildClick,
        ref: createChildTriggerProps?.ref,
        renderIcon: renderIcon
    });
};
const $e99284d207f534ad$export$b921667debd4e0cb = ({ itemId: itemId, itemsConnectionId: itemsConnectionId, depth: depth, hasChildren: hasChildren = true, isRowHoveredOrSelected: isRowHoveredOrSelected, showCreateChildButton: showCreateChildButton, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, isGroupButton: isGroupButton, groupId: groupId })=>{
    if (hasChildren) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        tabIndex: isRowHoveredOrSelected ? 0 : -1,
        xcss: [
            $e99284d207f534ad$var$cellStyle,
            !isGroupButton && $e99284d207f534ad$var$cellPaddingStyle
        ],
        "data-vc": "expand-button-with-create-child-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XgIy.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e99284d207f534ad$var$cellWrapperStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$e99284d207f534ad$var$ICON_WIDTH * depth}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$5663c8f5aeb8c1c4, {
        itemId: itemId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        isGroupButton: isGroupButton,
        groupId: groupId
    })), showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        tabIndex: 0,
        xcss: $e99284d207f534ad$var$cellSizeStyle,
        "data-vc": "expand-button-with-create-child-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XgIy.default), {
        depth: depth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e99284d207f534ad$var$cellPaddingStyle,
        style: {
            paddingLeft: `${$e99284d207f534ad$var$ICON_WIDTH * depth + $e99284d207f534ad$var$ICON_WIDTH + $e99284d207f534ad$var$EXTRA_PADDING_ROW_WITHOUT_EXPAND}px`
        }
    }, showCreateChildButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e99284d207f534ad$export$86df7a8824b06d6e, {
        depth: depth,
        itemId: itemId,
        groupId: groupId,
        isGroupButton: isGroupButton,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible
    })));
};
const $e99284d207f534ad$var$cellWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $e99284d207f534ad$var$cellSizeStyle = (0, $1DXK0.xcss)({
    height: '100%'
});
const $e99284d207f534ad$var$cellStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
});
const $e99284d207f534ad$var$cellPaddingStyle = (0, $1DXK0.xcss)({
    padding: 'space.100'
});

});
parcelRegister("3Ldj6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7c1775e33e0cf91$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $Ay1uj = parcelRequire("Ay1uj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2DRCb = parcelRequire("2DRCb");
const $b7c1775e33e0cf91$var$getWorkItemMessage = ()=>(0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $2DRCb.default).createWorkItem : (0, $2DRCb.default).createIssue;
const $b7c1775e33e0cf91$var$CreateChildButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isCreateWorkItem: isCreateWorkItem, renderIcon: renderIcon }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const defaultIcon = (0, $eJOHy.useCallback)((iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            ...iconProps,
            size: "small"
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        spacing: "compact",
        appearance: "subtle",
        label: isCreateWorkItem ? formatMessage($b7c1775e33e0cf91$var$getWorkItemMessage()) : formatMessage((0, $2DRCb.default).createChildItem),
        testId: "issue-table-hierarchy.ui.create-child-button.create",
        icon: renderIcon && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? renderIcon : defaultIcon,
        onClick: onClick,
        isTooltipDisabled: false,
        ref: ref
    });
});
var $b7c1775e33e0cf91$export$2e2bcd8739ae039 = $b7c1775e33e0cf91$var$CreateChildButton;

});
parcelRegister("2DRCb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7a4d5368b16f278$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c7a4d5368b16f278$var$messages = (0, $7qGN1.defineMessages)({
    createChildItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-child-item",
        "defaultMessage": "Create child item"
    },
    createWorkItem: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-work-item",
        "defaultMessage": "Create work item"
    },
    createIssue: {
        "id": "issue-table-hierarchy.ui.create-child-button.create-issue",
        "defaultMessage": "Create issue"
    }
});
var $c7a4d5368b16f278$export$2e2bcd8739ae039 = $c7a4d5368b16f278$var$messages;

});


parcelRegister("d8783", function(module, exports) {
$parcel$export(module.exports, "default", () => $0995f9578d4dea24$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0995f9578d4dea24$var$messages = (0, $7qGN1.defineMessages)({
    expandIssue: {
        "id": "native-issue-table.expand-button.expand-issue-hierarchy",
        "defaultMessage": "Expand hierarchy"
    },
    collapseIssue: {
        "id": "native-issue-table.expand-button.collapse",
        "defaultMessage": "Collapse hierarchy"
    },
    expandGroup: {
        "id": "native-issue-table.expand-button.expand-group-issue-hierarchy",
        "defaultMessage": "Expand group"
    },
    collapseGroup: {
        "id": "native-issue-table.expand-button.collapse-group",
        "defaultMessage": "Collapse group"
    }
});
var $0995f9578d4dea24$export$2e2bcd8739ae039 = $0995f9578d4dea24$var$messages;

});

parcelRegister("5XgIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cda404939b0af13$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $8cda404939b0af13$var$ICON_WIDTH = 24;
const $8cda404939b0af13$var$INDENTED_PADDING = 8;
const $8cda404939b0af13$var$IndentedIcon = ({ depth: depth })=>{
    if (depth <= 0) return null;
    const left = depth > 1 ? (depth - 1) * $8cda404939b0af13$var$ICON_WIDTH + $8cda404939b0af13$var$INDENTED_PADDING : $8cda404939b0af13$var$INDENTED_PADDING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            left: `${left}px`
        },
        xcss: $8cda404939b0af13$var$imgContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8cda404939b0af13$var$imgStyles,
        testId: "issue-table-hierarchy.ui.expand-button.indented-icon.indented-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 0V9.5C1 10.3284 1.67157 11 2.5 11H12V12H2.5C1.11929 12 0 10.8807 0 9.5V0H1Z",
        fill: "var(--ds-border, #091E4224)"
    }))));
};
const $8cda404939b0af13$var$imgStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
const $8cda404939b0af13$var$imgContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: '100%'
});
var $8cda404939b0af13$export$2e2bcd8739ae039 = $8cda404939b0af13$var$IndentedIcon;

});


parcelRegister("5FAgT", function(module, exports) {
$parcel$export(module.exports, "CategoryGroupHeader", () => $e3e89f6b5aceb5e9$export$fc0707d1ce99fe4d);

var $2U7aa = parcelRequire("2U7aa");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $ivVFT = parcelRequire("ivVFT");

var $lRq8t = parcelRequire("lRq8t");

var $ldHGO = parcelRequire("ldHGO");
const $e3e89f6b5aceb5e9$export$fc0707d1ce99fe4d = ({ categoryGroupHeader: categoryGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $2U7aa.default), categoryGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return data != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivVFT.default), {
        categoryColor: data?.option?.color?.colorKey ?? null,
        categoryName: data?.displayName,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $ldHGO.default).noCategory));
};

});
parcelRegister("2U7aa", function(module, exports) {
$parcel$export(module.exports, "default", () => $49a4a418ede0743f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5432b30245a6345c5d41d0875b65f74d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $49a4a418ede0743f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CategoryGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$49a4a418ede0743f$var$node.hash = "adc155d7b590635f8d7c06317caf565c";
var $49a4a418ede0743f$export$2e2bcd8739ae039 = $49a4a418ede0743f$var$node;

});

parcelRegister("ivVFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd752ee372910218$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $4KSRb = parcelRequire("4KSRb");
const $fd752ee372910218$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { backgroundColor: tagColor } = (0, $4KSRb.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ $eJOHy.createElement($fd752ee372910218$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: "var(--ds-text, #172B4D)",
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ $eJOHy.createElement($fd752ee372910218$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $fd752ee372910218$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fd752ee372910218$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd752ee372910218$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $awdRS.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564188d _1e0c116y _1bah1e5h _4cvr1h6o _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $fd752ee372910218$var$StyledTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko3gvi _19it11we _11c82smr _1reo15vq _18m915vq _bfhk18uv _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4KSRb", function(module, exports) {
$parcel$export(module.exports, "getRandomColor", () => $3bcf16c800b16b64$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3bcf16c800b16b64$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3bcf16c800b16b64$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3bcf16c800b16b64$export$49fce7fdcf55f26d);

var $jHxAK = parcelRequire("jHxAK");
const $3bcf16c800b16b64$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $jHxAK.CATEGORY_THEMES).length);
    return (0, $jHxAK.CATEGORY_THEMES)[randomIndex].name;
};
const $3bcf16c800b16b64$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $jHxAK.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $3bcf16c800b16b64$export$9eff62e8ee2aaa2c = (colorName)=>(0, $jHxAK.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $3bcf16c800b16b64$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $jHxAK.GREY_LIGHTEST_META;
    return (0, $jHxAK.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $jHxAK.GREY_LIGHTEST_META);
};
const $3bcf16c800b16b64$export$4ef6b7574883e63d = ()=>(0, $jHxAK.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("jHxAK", function(module, exports) {
$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $c24cfcc605338ece$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $c24cfcc605338ece$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $c24cfcc605338ece$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $c24cfcc605338ece$export$845e69f3af4133a6);

var $2hJG2 = parcelRequire("2hJG2");
const $c24cfcc605338ece$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $2hJG2.default).greyLightest
};
const $c24cfcc605338ece$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $2hJG2.default).greyLighter
};
const $c24cfcc605338ece$var$GREY_META = {
    name: 'GREY',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $2hJG2.default).grey
};
const $c24cfcc605338ece$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greyDarker
};
const $c24cfcc605338ece$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greyDarkest
};
const $c24cfcc605338ece$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $2hJG2.default).purpleLightest
};
const $c24cfcc605338ece$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $2hJG2.default).purpleLighter
};
const $c24cfcc605338ece$var$PURPLE_META = {
    name: 'PURPLE',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $2hJG2.default).purple
};
const $c24cfcc605338ece$var$PURPLE_DARKER_META = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).purpleDarker
};
const $c24cfcc605338ece$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).purpleDarkest
};
const $c24cfcc605338ece$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $2hJG2.default).blueLightest
};
const $c24cfcc605338ece$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $2hJG2.default).blueLighter
};
const $c24cfcc605338ece$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $2hJG2.default).blue
};
const $c24cfcc605338ece$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).blueDarker
};
const $c24cfcc605338ece$var$BLUE_DARKEST_META = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).blueDarkest
};
const $c24cfcc605338ece$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).tealLightest
};
const $c24cfcc605338ece$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).tealLighter
};
const $c24cfcc605338ece$var$TEAL_META = {
    name: 'TEAL',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $2hJG2.default).teal
};
const $c24cfcc605338ece$var$TEAL_DARKER_META = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).tealDarker
};
const $c24cfcc605338ece$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).tealDarkest
};
const $c24cfcc605338ece$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).greenLightest
};
const $c24cfcc605338ece$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).greenLighter
};
const $c24cfcc605338ece$var$GREEN_META = {
    name: 'GREEN',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $2hJG2.default).green
};
const $c24cfcc605338ece$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greenDarker
};
const $c24cfcc605338ece$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).greenDarkest
};
const $c24cfcc605338ece$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).limeLightest
};
const $c24cfcc605338ece$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).limeLighter
};
const $c24cfcc605338ece$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $2hJG2.default).lime
};
const $c24cfcc605338ece$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).limeDarker
};
const $c24cfcc605338ece$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).limeDarkest
};
const $c24cfcc605338ece$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellowLightest
};
const $c24cfcc605338ece$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellowLighter
};
const $c24cfcc605338ece$var$YELLOW_META = {
    name: 'YELLOW',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $2hJG2.default).yellow
};
const $c24cfcc605338ece$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).yellowDarker
};
const $c24cfcc605338ece$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).yellowDarkest
};
const $c24cfcc605338ece$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $2hJG2.default).orangeLightest
};
const $c24cfcc605338ece$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $2hJG2.default).orangeLighter
};
const $c24cfcc605338ece$var$ORANGE_META = {
    name: 'ORANGE',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $2hJG2.default).orange
};
const $c24cfcc605338ece$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).orangeDarker
};
const $c24cfcc605338ece$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).orangeDarkest
};
const $c24cfcc605338ece$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).redLightest
};
const $c24cfcc605338ece$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).redLighter
};
const $c24cfcc605338ece$var$RED_META = {
    name: 'RED',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $2hJG2.default).red
};
const $c24cfcc605338ece$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).redDarker
};
const $c24cfcc605338ece$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).redDarkest
};
const $c24cfcc605338ece$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magentaLightest
};
const $c24cfcc605338ece$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magentaLighter
};
const $c24cfcc605338ece$var$MAGENTA_META = {
    name: 'MAGENTA',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $2hJG2.default).magenta
};
const $c24cfcc605338ece$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).magentaDarker
};
const $c24cfcc605338ece$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $2hJG2.default).magentaDarkest
};
const $c24cfcc605338ece$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $c24cfcc605338ece$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $c24cfcc605338ece$export$845e69f3af4133a6 = [
    $c24cfcc605338ece$export$cb19a604bb399a88,
    $c24cfcc605338ece$var$PURPLE_LIGHTEST_META,
    $c24cfcc605338ece$var$BLUE_LIGHTEST_META,
    $c24cfcc605338ece$var$TEAL_LIGHTEST_META,
    $c24cfcc605338ece$var$GREEN_LIGHTEST_META,
    $c24cfcc605338ece$var$LIME_LIGHTEST_META,
    $c24cfcc605338ece$var$YELLOW_LIGHTEST_META,
    $c24cfcc605338ece$var$ORANGE_LIGHTEST_META,
    $c24cfcc605338ece$var$RED_LIGHTEST_META,
    $c24cfcc605338ece$var$MAGENTA_LIGHTEST_META,
    $c24cfcc605338ece$var$GREY_LIGHTER_META,
    $c24cfcc605338ece$var$PURPLE_LIGHTER_META,
    $c24cfcc605338ece$var$BLUE_LIGHTER_META,
    $c24cfcc605338ece$var$TEAL_LIGHTER_META,
    $c24cfcc605338ece$var$GREEN_LIGHTER_META,
    $c24cfcc605338ece$var$LIME_LIGHTER_META,
    $c24cfcc605338ece$var$YELLOW_LIGHTER_META,
    $c24cfcc605338ece$var$ORANGE_LIGHTER_META,
    $c24cfcc605338ece$var$RED_LIGHTER_META,
    $c24cfcc605338ece$var$MAGENTA_LIGHTER_META,
    $c24cfcc605338ece$var$GREY_META,
    $c24cfcc605338ece$var$PURPLE_META,
    $c24cfcc605338ece$var$BLUE_META,
    $c24cfcc605338ece$var$TEAL_META,
    $c24cfcc605338ece$var$GREEN_META,
    $c24cfcc605338ece$var$LIME_META,
    $c24cfcc605338ece$var$YELLOW_META,
    $c24cfcc605338ece$var$ORANGE_META,
    $c24cfcc605338ece$var$RED_META,
    $c24cfcc605338ece$var$MAGENTA_META,
    $c24cfcc605338ece$var$GREY_DARKER_META,
    $c24cfcc605338ece$var$PURPLE_DARKER_META,
    $c24cfcc605338ece$var$BLUE_DARKER_META,
    $c24cfcc605338ece$var$TEAL_DARKER_META,
    $c24cfcc605338ece$var$GREEN_DARKER_META,
    $c24cfcc605338ece$var$LIME_DARKER_META,
    $c24cfcc605338ece$var$YELLOW_DARKER_META,
    $c24cfcc605338ece$var$ORANGE_DARKER_META,
    $c24cfcc605338ece$var$RED_DARKER_META,
    $c24cfcc605338ece$var$MAGENTA_DARKER_META,
    $c24cfcc605338ece$var$GREY_DARKEST_META,
    $c24cfcc605338ece$var$PURPLE_DARKEST_META,
    $c24cfcc605338ece$var$BLUE_DARKEST_META,
    $c24cfcc605338ece$var$TEAL_DARKEST_META,
    $c24cfcc605338ece$var$GREEN_DARKEST_META,
    $c24cfcc605338ece$var$LIME_DARKEST_META,
    $c24cfcc605338ece$var$YELLOW_DARKEST_META,
    $c24cfcc605338ece$var$ORANGE_DARKEST_META,
    $c24cfcc605338ece$var$RED_DARKEST_META,
    $c24cfcc605338ece$var$MAGENTA_DARKEST_META
];

});
parcelRegister("2hJG2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4a201e1872b1174$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f4a201e1872b1174$var$messages = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});
var $f4a201e1872b1174$export$2e2bcd8739ae039 = $f4a201e1872b1174$var$messages;

});




parcelRegister("ldHGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a2b1fb7f562b512$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0a2b1fb7f562b512$var$messages = (0, $7qGN1.defineMessages)({
    noCategory: {
        "id": "issue-table-grouping.group-row.group-header.category-group-header.no-category",
        "defaultMessage": "Uncategorized"
    }
});
var $0a2b1fb7f562b512$export$2e2bcd8739ae039 = $0a2b1fb7f562b512$var$messages;

});


parcelRegister("98A5p", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f23a688be5d03c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7f23a688be5d03c8$var$messages = (0, $7qGN1.defineMessages)({
    issues: {
        "id": "issue-table-grouping.group-row.group-header.issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    issuesIssueTermRefresh: {
        "id": "issue-table-grouping.group-row.group-header.issues-issue-term-refresh",
        "defaultMessage": "{count, plural, one {# work item} other {# work items}}"
    }
});
var $7f23a688be5d03c8$export$2e2bcd8739ae039 = $7f23a688be5d03c8$var$messages;

});

parcelRegister("iqCxS", function(module, exports) {
$parcel$export(module.exports, "PriorityGroupHeader", () => $8eae647b702880ec$export$3d9fbda3fab02eba);

var $glH3u = parcelRequire("glH3u");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $2gIth = parcelRequire("2gIth");
const $8eae647b702880ec$export$3d9fbda3fab02eba = ({ priorityGroupHeader: priorityGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $glH3u.default), priorityGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data?.priority.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "img",
        src: data.priority.iconUrl,
        xcss: $8eae647b702880ec$var$iconStyles,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, data?.displayName ?? formatMessage((0, $2gIth.default).noPriority)));
};
const $8eae647b702880ec$var$iconStyles = (0, $1DXK0.xcss)({
    width: "var(--ds-space-250, 20px)",
    height: "var(--ds-space-250, 20px)"
});

});
parcelRegister("glH3u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab18543f277325ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5567a39166b30a4ff19c7b0a56c6571b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab18543f277325ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PriorityGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraJqlPriorityFieldValue"
};
$ab18543f277325ff$var$node.hash = "005933ac841dded3cda21a36de7b85e9";
var $ab18543f277325ff$export$2e2bcd8739ae039 = $ab18543f277325ff$var$node;

});

parcelRegister("2gIth", function(module, exports) {
$parcel$export(module.exports, "default", () => $a64d8ab52717dcf9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a64d8ab52717dcf9$var$messages = (0, $7qGN1.defineMessages)({
    noPriority: {
        "id": "issue-table-grouping.group-row.group-header.priority-group-header.no-priority",
        "defaultMessage": "No priority"
    }
});
var $a64d8ab52717dcf9$export$2e2bcd8739ae039 = $a64d8ab52717dcf9$var$messages;

});


parcelRegister("aaLj4", function(module, exports) {
$parcel$export(module.exports, "SprintGroupHeader", () => $5d3af1987d3a79a0$export$c4bf8cf8359b52ab);

var $fFL3z = parcelRequire("fFL3z");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $52CBb = parcelRequire("52CBb");
const $5d3af1987d3a79a0$export$c4bf8cf8359b52ab = ({ sprintGroupHeader: sprintGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $fFL3z.default), sprintGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let text;
    if (!data) text = formatMessage((0, $52CBb.default).backlog);
    else if (data.sprint?.state === 'CLOSED') text = formatMessage((0, $52CBb.default).completedSprint);
    else text = data.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        text: text
    });
};

});
parcelRegister("fFL3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba784cf17f20e69b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<857c2638fd8131352864d77dbbcc21dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba784cf17f20e69b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SprintGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraSprint",
            "kind": "LinkedField",
            "name": "sprint",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                }
            ]
        }
    ],
    "type": "JiraJqlSprintFieldValue"
};
$ba784cf17f20e69b$var$node.hash = "c2d9817a445caaca4793868218a63862";
var $ba784cf17f20e69b$export$2e2bcd8739ae039 = $ba784cf17f20e69b$var$node;

});

parcelRegister("ewOxf", function(module, exports) {
$parcel$export(module.exports, "default", () => $935d42f1f33a5e95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");
const $935d42f1f33a5e95$var$SimpleTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $935d42f1f33a5e95$var$SimpleTag = /*#__PURE__*/ (0, $eJOHy.memo)($935d42f1f33a5e95$var$SimpleTagComponent);
var $935d42f1f33a5e95$export$2e2bcd8739ae039 = $935d42f1f33a5e95$var$SimpleTag;

});
parcelRegister("1fStw", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb40a4175fb93ea9$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $eb40a4175fb93ea9$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $eb40a4175fb93ea9$var$baseStyles = null;
const $eb40a4175fb93ea9$var$interactiveStyles = null;
const $eb40a4175fb93ea9$var$focusRingStyles = null;
const $eb40a4175fb93ea9$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad",
            isInteractive && "_1e381q03 _7glxv77o",
            isLink && "_irr3166n _1di61dty",
            $eb40a4175fb93ea9$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb40a4175fb93ea9$export$2e2bcd8739ae039 = $eb40a4175fb93ea9$var$BaseTag;

});

parcelRegister("40nZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $dae242ab93c29e38$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dae242ab93c29e38$var$beforeElementStyles = null;
const $dae242ab93c29e38$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dae242ab93c29e38$export$2e2bcd8739ae039 = $dae242ab93c29e38$var$Before;

});

parcelRegister("6UE2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d73caba6a9e3a1c$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6d73caba6a9e3a1c$var$baseStyles = null;
const $6d73caba6a9e3a1c$var$linkStyles = null;
const $6d73caba6a9e3a1c$var$hasAfterStyles = null;
const $6d73caba6a9e3a1c$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d73caba6a9e3a1c$export$2e2bcd8739ae039 = $6d73caba6a9e3a1c$var$Content;

});


parcelRegister("52CBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $19f4af068b811078$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $19f4af068b811078$var$messages = (0, $7qGN1.defineMessages)({
    completedSprint: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "issue-table-grouping.group-row.group-header.sprint-group-header.backlog",
        "defaultMessage": "Backlog"
    }
});
var $19f4af068b811078$export$2e2bcd8739ae039 = $19f4af068b811078$var$messages;

});


parcelRegister("k29Y8", function(module, exports) {
$parcel$export(module.exports, "StatusGroupHeader", () => $0df23d6d0711eea2$export$47d603da63417bb);

var $7jRPp = parcelRequire("7jRPp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $jdqdp = parcelRequire("jdqdp");
const $0df23d6d0711eea2$var$appearanceMap = {
    [(0, $jx0Vw.UNDEFINED)]: 'default',
    [(0, $jx0Vw.TODO)]: 'default',
    [(0, $jx0Vw.DONE)]: 'success',
    [(0, $jx0Vw.IN_PROGRESS)]: 'inprogress'
};
const $0df23d6d0711eea2$export$47d603da63417bb = ({ statusGroupHeader: statusGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $7jRPp.default), statusGroupHeader);
    const appearance = data?.statusCategory.statusCategoryId != null ? $0df23d6d0711eea2$var$appearanceMap[(0, $jx0Vw.statusCategoryForId)(data?.statusCategory.statusCategoryId)] : $0df23d6d0711eea2$var$appearanceMap[0, $jx0Vw.UNDEFINED];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: appearance
    }, data?.displayName);
};

});
parcelRegister("7jRPp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3e74975dba84667$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8e00aec2e4e2d02156f37016fd5ac9eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3e74975dba84667$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StatusGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraJqlStatusFieldValue"
};
$a3e74975dba84667$var$node.hash = "cdc8aa737da69440878c7ee8e5c447e6";
var $a3e74975dba84667$export$2e2bcd8739ae039 = $a3e74975dba84667$var$node;

});

parcelRegister("jx0Vw", function(module, exports) {
$parcel$export(module.exports, "UNDEFINED", () => $89523e1d4dcff547$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $89523e1d4dcff547$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $89523e1d4dcff547$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $89523e1d4dcff547$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $89523e1d4dcff547$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $89523e1d4dcff547$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $89523e1d4dcff547$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $89523e1d4dcff547$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $89523e1d4dcff547$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $89523e1d4dcff547$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $89523e1d4dcff547$export$d928f247c903643a);
const $89523e1d4dcff547$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $89523e1d4dcff547$export$aa456a5030160740 = 'TODO';
const $89523e1d4dcff547$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $89523e1d4dcff547$export$71efb3495f6084f2 = 'DONE';
const $89523e1d4dcff547$export$d9119300f9d9a815 = [
    $89523e1d4dcff547$export$6db089fe7b26f5b6,
    $89523e1d4dcff547$export$aa456a5030160740,
    $89523e1d4dcff547$export$5a9ac66c2785cc13,
    $89523e1d4dcff547$export$71efb3495f6084f2
];
const $89523e1d4dcff547$var$statusCategories = [
    {
        id: '1',
        statusCategory: $89523e1d4dcff547$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $89523e1d4dcff547$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $89523e1d4dcff547$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $89523e1d4dcff547$export$71efb3495f6084f2
    }
];
const $89523e1d4dcff547$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $89523e1d4dcff547$export$3f42f49c284d5b58 = Object.freeze({
    [$89523e1d4dcff547$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.NEW]: 2,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.DONE]: 3,
    [$89523e1d4dcff547$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $89523e1d4dcff547$export$f3f919dc0f56d9eb = Object.values($89523e1d4dcff547$export$5d42a08d46cffe7);
const $89523e1d4dcff547$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $89523e1d4dcff547$export$6db089fe7b26f5b6;
};
const $89523e1d4dcff547$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $89523e1d4dcff547$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $89523e1d4dcff547$export$d928f247c903643a = (key)=>$89523e1d4dcff547$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("jiKXd", function(module, exports) {
$parcel$export(module.exports, "StoryPointsGroupHeader", () => $60c96ff097c46bfb$export$67c95e3a82fabe13);

var $8I9cR = parcelRequire("8I9cR");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $6qVOj = parcelRequire("6qVOj");
const $60c96ff097c46bfb$export$67c95e3a82fabe13 = ({ storyPointsGroupHeader: storyPointsGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $8I9cR.default), storyPointsGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        appearance: "default"
    }, typeof data?.number === 'number' ? formatMessage((0, $6qVOj.default).storyPoints, {
        points: data?.number
    }) : formatMessage((0, $6qVOj.default).noStoryPoints)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        text: typeof data?.number === 'number' ? formatMessage((0, $6qVOj.default).storyPoints, {
            points: data?.number
        }) : formatMessage((0, $6qVOj.default).noStoryPoints)
    });
};

});
parcelRegister("8I9cR", function(module, exports) {
$parcel$export(module.exports, "default", () => $930cf4c868a26bad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2335196e7ec7a803624759c68802955>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $930cf4c868a26bad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StoryPointsGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraJqlNumberFieldValue"
};
$930cf4c868a26bad$var$node.hash = "2d04d7c6471553920e11294e9de46cab";
var $930cf4c868a26bad$export$2e2bcd8739ae039 = $930cf4c868a26bad$var$node;

});

parcelRegister("6qVOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9524c98beda18117$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9524c98beda18117$var$messages = (0, $7qGN1.defineMessages)({
    storyPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "issue-table-grouping.group-row.group-header.story-points-group-header.no-story-points",
        "defaultMessage": "No points"
    }
});
var $9524c98beda18117$export$2e2bcd8739ae039 = $9524c98beda18117$var$messages;

});


parcelRegister("b8Nt1", function(module, exports) {
$parcel$export(module.exports, "GoalGroupHeader", () => $d9a50531439f16f6$export$2fac2323394ec085);

var $5Lzvn = parcelRequire("5Lzvn");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $jsdaB = parcelRequire("jsdaB");

var $jsdaB = parcelRequire("jsdaB");

var $4cTDP = parcelRequire("4cTDP");

var $dlGxm = parcelRequire("dlGxm");
const $d9a50531439f16f6$var$goalStatusToLabelMap = {
    ARCHIVED: (0, $dlGxm.default).statusLabelArchived,
    PENDING: (0, $dlGxm.default).statusLabelPending,
    IN_PROGRESS: (0, $dlGxm.default).statusLabelInProgress,
    COMPLETED: (0, $dlGxm.default).statusLabelCompleted,
    DONE: (0, $dlGxm.default).statusLabelCompleted,
    ON_TRACK: (0, $dlGxm.default).statusLabelOnTrack,
    PAUSED: (0, $dlGxm.default).statusLabelPaused,
    AT_RISK: (0, $dlGxm.default).statusLabelAtRisk,
    OFF_TRACK: (0, $dlGxm.default).statusLabelOffTrack,
    CANCELLED: (0, $dlGxm.default).statusLabelCancelled
};
const $d9a50531439f16f6$var$goalStatusToLozengeAppearanceMap = {
    ARCHIVED: 'default',
    PENDING: 'default',
    IN_PROGRESS: 'inprogress',
    COMPLETED: 'success',
    DONE: 'success',
    ON_TRACK: 'success',
    PAUSED: 'moved',
    AT_RISK: 'moved',
    OFF_TRACK: 'removed',
    CANCELLED: 'removed'
};
const $d9a50531439f16f6$export$2fac2323394ec085 = ({ goalGroupHeader: goalGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $5Lzvn.default), goalGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const displayName = data?.displayName ?? formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dlGxm.default).noGoalsDisplayNameIssueTermRefresh : (0, $dlGxm.default).noGoalsDisplayName);
    const status = formatMessage($d9a50531439f16f6$var$goalStatusToLabelMap[data?.goal?.status || 'PENDING']);
    const appearance = (0, $jsdaB.normalizeGoalAppearance)(data?.goal?.status || 'PENDING');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jsdaB.GoalIcon), {
        size: "16",
        appearance: appearance,
        goalIconKey: "GOAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d9a50531439f16f6$var$goalTextStyles
    }, displayName), data?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: $d9a50531439f16f6$var$goalStatusToLozengeAppearanceMap[data.goal.status || 'PENDING']
    }, status, data.goal.score && ` - ${data.goal.score || ''}`));
};
const $d9a50531439f16f6$var$goalTextStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("5Lzvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $030c002118a296eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e225ddfbf26150be35c273225aa8040>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $030c002118a296eb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GoalGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "score"
                }
            ]
        }
    ],
    "type": "JiraJqlGoalsFieldValue"
};
$030c002118a296eb$var$node.hash = "30c96208fa54dc40c8fbac3d2b4a9d25";
var $030c002118a296eb$export$2e2bcd8739ae039 = $030c002118a296eb$var$node;

});

parcelRegister("jsdaB", function(module, exports) {
$parcel$export(module.exports, "GoalIcon", () => $a7b2c6cc6d0f42bb$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $a7b2c6cc6d0f42bb$export$f1b3ca93191ce5cc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6IK2z = parcelRequire("6IK2z");

var $9qes7 = parcelRequire("9qes7");

var $9RMYL = parcelRequire("9RMYL");

var $1wxug = parcelRequire("1wxug");

var $dVVwX = parcelRequire("dVVwX");

var $h8rwk = parcelRequire("h8rwk");
const $a7b2c6cc6d0f42bb$var$appearanceToColorMap = {
    DEFAULT: 'gray',
    MENU: 'gray',
    OFF_TRACK: 'red',
    AT_RISK: 'yellow',
    ON_TRACK: 'green'
};
const $a7b2c6cc6d0f42bb$var$appearanceToNewColorMap = {
    MENU: "var(--ds-icon, #44546F)",
    DEFAULT: "var(--ds-icon-accent-gray, #758195)",
    OFF_TRACK: "var(--ds-icon-danger, #C9372C)",
    AT_RISK: "var(--ds-icon-warning, #E56910)",
    ON_TRACK: "var(--ds-icon-success, #22A06B)"
};
const $a7b2c6cc6d0f42bb$var$keyToIconMap = {
    GOAL: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7))),
    OBJECTIVE: (0, (/*@__PURE__*/$parcel$interopDefault($1wxug))),
    KEY_RESULT: (0, (/*@__PURE__*/$parcel$interopDefault($9RMYL)))
};
const $a7b2c6cc6d0f42bb$var$getLabel = (intl, label, localizedLabel)=>{
    if (label) return label;
    if (localizedLabel && (0, $h8rwk.isMessageId)(localizedLabel?.messageId)) return intl.formatMessage((0, $h8rwk.messages)[localizedLabel.messageId]);
    return '';
};
const $a7b2c6cc6d0f42bb$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel, goalIconKey: goalIconKey = 'GOAL', isVisualRefresh: isVisualRefresh = false, visualRefreshSpacing: visualRefreshSpacing = 'none', label: label, shouldScale: shouldScale = false })=>{
    const intl = (0, $lRq8t.default)();
    const iconLabel = $a7b2c6cc6d0f42bb$var$getLabel(intl, label, localizedLabel);
    const Icon = $a7b2c6cc6d0f42bb$var$keyToIconMap[goalIconKey] ?? $a7b2c6cc6d0f42bb$var$keyToIconMap.GOAL;
    if (isVisualRefresh) {
        const ResizableIcon = Icon;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ResizableIcon, {
            shouldScale: shouldScale,
            color: $a7b2c6cc6d0f42bb$var$appearanceToNewColorMap[appearance],
            label: iconLabel,
            spacing: visualRefreshSpacing
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        size: size,
        icon: Icon,
        label: iconLabel,
        appearance: $a7b2c6cc6d0f42bb$var$appearanceToColorMap[appearance]
    });
};
const $a7b2c6cc6d0f42bb$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceUppercase = statusValue.toLocaleUpperCase();
    return (0, $dVVwX.isGoalAppearance)(appearanceUppercase) ? appearanceUppercase : 'DEFAULT';
};

});
parcelRegister("6IK2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1c2fc9df73f09d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $41qqA = parcelRequire("41qqA");

var $l77v2 = parcelRequire("l77v2");
// Color mapping for size 16 standalone icons that will no longer be tiles
const $df1c2fc9df73f09d$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #1D7AFC)",
    blueBold: "var(--ds-icon-accent-blue, #1D7AFC)",
    gray: "var(--ds-icon-accent-gray, #758195)",
    grayBold: "var(--ds-icon-accent-gray, #758195)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E56910)",
    orangeBold: "var(--ds-icon-accent-orange, #E56910)",
    purple: "var(--ds-icon-accent-purple, #8270DB)",
    purpleBold: "var(--ds-icon-accent-purple, #8270DB)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $df1c2fc9df73f09d$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, LEGACY_fallbackComponent: LEGACY_fallbackComponent, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && (0, $eGOwo.fg)('platform_dst_icon_tile_circle_replacement')) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && (0, $eGOwo.fg)('platform_dst_new_icon_tile')) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            color: $df1c2fc9df73f09d$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $41qqA.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l77v2.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});
parcelRegister("41qqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef39d2750ac3c535$export$2e2bcd8739ae039);
/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ieO20 = parcelRequire("ieO20");
const $ef39d2750ac3c535$var$sizeCrossCompatibleMap = {
    // Size mapping from old pixel sizes to new t-shirt sizes
    '16': 'xsmall',
    // Not used
    '24': 'small',
    '32': 'medium',
    '40': 'large',
    '48': 'xlarge',
    xsmall: 'xsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
// Icon color mapping for Tile-based icons
const $ef39d2750ac3c535$var$iconColorMap = {
    blue: "_syaz1ov1",
    blueBold: "_syazwdcn",
    gray: "_syaz1oju",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syazwdcn",
    lime: "_syaz8645",
    limeBold: "_syazwdcn",
    magenta: "_syazv8hk",
    magentaBold: "_syazwdcn",
    orange: "_syaz7r97",
    orangeBold: "_syazwdcn",
    purple: "_syaz5yjc",
    purpleBold: "_syazwdcn",
    red: "_syaznbxb",
    redBold: "_syazwdcn",
    teal: "_syaz8uof",
    tealBold: "_syazwdcn",
    yellow: "_syaz1oqg",
    yellowBold: "_syazwdcn"
};
// Background color mapping for Tile component
const $ef39d2750ac3c535$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $ef39d2750ac3c535$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'small', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ieO20.default), {
        size: $ef39d2750ac3c535$var$sizeCrossCompatibleMap[size],
        backgroundColor: $ef39d2750ac3c535$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $ef39d2750ac3c535$var$iconColorMap[appearance]
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: label,
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("ieO20", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a27c3c406dff3d5$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9a27c3c406dff3d5$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6dmuej",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $9a27c3c406dff3d5$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $9a27c3c406dff3d5$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $9a27c3c406dff3d5$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk18uv",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.information': "_bfhk33gi",
    'color.background.information.bold': "_bfhk14wj"
};
function $9a27c3c406dff3d5$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hcewu.default)([
            $9a27c3c406dff3d5$var$styles.root,
            $9a27c3c406dff3d5$var$sizeMap[size],
            isInset ? $9a27c3c406dff3d5$var$styles.inset : $9a27c3c406dff3d5$var$styles.nonInset,
            isInset && $9a27c3c406dff3d5$var$insetSizeMap[size],
            $9a27c3c406dff3d5$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $9a27c3c406dff3d5$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("l77v2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd87b3d482b8dffc$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bd87b3d482b8dffc$var$sizeCrossCompatibleMap = {
    // Size mapping from new t-shirt sizes to old pixel sizes
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48',
    '16': '16',
    '24': '24',
    '32': '32',
    '40': '40',
    '48': '48'
};
const $bd87b3d482b8dffc$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $bd87b3d482b8dffc$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $bd87b3d482b8dffc$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $bd87b3d482b8dffc$var$iconTileStyles = null;
function $bd87b3d482b8dffc$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $bd87b3d482b8dffc$var$appearanceMap[appearance],
            $bd87b3d482b8dffc$var$sizeMap[$bd87b3d482b8dffc$var$sizeCrossCompatibleMap[size]],
            $bd87b3d482b8dffc$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});


parcelRegister("9RMYL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac5dd9d18e58065415ed9f773e6c5a23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72ef0e7f955dc8ab$var$_react = $72ef0e7f955dc8ab$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72ef0e7f955dc8ab$var$_baseNew = $72ef0e7f955dc8ab$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72ef0e7f955dc8ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "KeyResult".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing key results.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72ef0e7f955dc8ab$var$KeyResultIcon = (props)=>/*#__PURE__*/ $72ef0e7f955dc8ab$var$_react.default.createElement($72ef0e7f955dc8ab$var$_baseNew.default, Object.assign({
        name: "KeyResultIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.435.001a.75.75 0 0 1 .547.194l3.023 2.75-1.01 1.11-2.437-2.217A10.2 10.2 0 0 0 7.527 7.25h3.163l1.28-1.28a.75.75 0 0 1 .53-.22h2.75a.75.75 0 0 1 .671 1.085L15.339 8l.582 1.165a.75.75 0 0 1-.67 1.085H12.5a.75.75 0 0 1-.531-.22l-1.28-1.28H7.528c.149 2.02.895 3.88 2.051 5.41l2.414-2.213 1.014 1.106-3 2.75a.75.75 0 0 1-1.07-.059A11.75 11.75 0 0 1 6.023 8.75H2.756l1.361 1.184-.984 1.132-2.875-2.5a.75.75 0 0 1 0-1.132l2.875-2.5.984 1.132L2.755 7.25h3.269A11.7 11.7 0 0 1 8.914.255a.75.75 0 0 1 .52-.254m2.626 8 .75.749h1.226l-.208-.414a.75.75 0 0 1 0-.671l.208-.415H12.81z" clip-rule="evenodd"/>`
    }, props));
$72ef0e7f955dc8ab$var$KeyResultIcon.displayName = 'KeyResultIcon';
var $72ef0e7f955dc8ab$var$_default = module.exports.default = $72ef0e7f955dc8ab$var$KeyResultIcon;

});

parcelRegister("1wxug", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83da9dd00c73d6526faf1963ee50c72a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11c2c178697c4d79$var$_react = $11c2c178697c4d79$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11c2c178697c4d79$var$_baseNew = $11c2c178697c4d79$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11c2c178697c4d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11c2c178697c4d79$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $11c2c178697c4d79$var$_react.default.createElement($11c2c178697c4d79$var$_baseNew.default, Object.assign({
        name: "ObjectiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$11c2c178697c4d79$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $11c2c178697c4d79$var$_default = module.exports.default = $11c2c178697c4d79$var$ObjectiveIcon;

});

parcelRegister("dVVwX", function(module, exports) {
$parcel$export(module.exports, "isGoalAppearance", () => $5f59c3cc5e299b8b$export$86d2476abee3806b);
$parcel$export(module.exports, "isGoalIconKey", () => $5f59c3cc5e299b8b$export$51f87e2f4bd9e4bf);
const $5f59c3cc5e299b8b$export$d6870ac5e959c0f5 = [
    'DEFAULT',
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'MENU'
];
const $5f59c3cc5e299b8b$export$86d2476abee3806b = (value)=>$5f59c3cc5e299b8b$export$d6870ac5e959c0f5.includes(value);
const $5f59c3cc5e299b8b$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'DONE',
    'CANCELLED',
    'PAUSED',
    'ARCHIVED'
];
const $5f59c3cc5e299b8b$export$a65140e49f013a96 = [
    'GOAL',
    'OBJECTIVE',
    'KEY_RESULT'
];
const $5f59c3cc5e299b8b$export$51f87e2f4bd9e4bf = (value)=>$5f59c3cc5e299b8b$export$a65140e49f013a96.includes(value);

});

parcelRegister("h8rwk", function(module, exports) {
$parcel$export(module.exports, "isMessageId", () => $874dea3760057f53$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $874dea3760057f53$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $874dea3760057f53$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused'
];
const $874dea3760057f53$export$d28699f9b486207b = (value)=>$874dea3760057f53$var$MESSAGE_IDS.includes(value);
const $874dea3760057f53$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("dlGxm", function(module, exports) {
$parcel$export(module.exports, "default", () => $632cb9afa5d02bed$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $632cb9afa5d02bed$var$messages = (0, $7qGN1.defineMessages)({
    noGoalsDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.goal-group-header.no-goals-display-name",
        "defaultMessage": "Issues without goals"
    },
    noGoalsDisplayNameIssueTermRefresh: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.no-goals-display-name-issue-term-refresh",
        "defaultMessage": "Work items without goals"
    },
    statusLabelArchived: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-archived",
        "defaultMessage": "Archived"
    },
    statusLabelPending: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-pending",
        "defaultMessage": "Pending"
    },
    statusLabelInProgress: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-in-progress",
        "defaultMessage": "In progress"
    },
    statusLabelCompleted: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-completed",
        "defaultMessage": "Completed"
    },
    statusLabelOnTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-on-track",
        "defaultMessage": "On track"
    },
    statusLabelPaused: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-paused",
        "defaultMessage": "Paused"
    },
    statusLabelAtRisk: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-at-risk",
        "defaultMessage": "At risk"
    },
    statusLabelOffTrack: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-off-track",
        "defaultMessage": "Off track"
    },
    statusLabelCancelled: {
        "id": "issue-table-grouping.row.group-row.group-header.goal-group-header.status-label-cancelled",
        "defaultMessage": "Cancelled"
    }
});
var $632cb9afa5d02bed$export$2e2bcd8739ae039 = $632cb9afa5d02bed$var$messages;

});


parcelRegister("cKV4K", function(module, exports) {
$parcel$export(module.exports, "LabelGroupHeader", () => $f82594f1a021ae46$export$18b1d108a714e82e);

var $67Vsg = parcelRequire("67Vsg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $aIng6 = parcelRequire("aIng6");

var $7hEnC = parcelRequire("7hEnC");
const $f82594f1a021ae46$var$isColorfulLabelsEnabled = ()=>(0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false);
// Logic inherited from src/packages/issue/fields/platform/labels/readview-full/src/ui/labels/index.tsx
const $f82594f1a021ae46$var$getLabelColor = (label)=>{
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        if (!colorName) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
        const { tagColor: tagColor } = (0, $051tO.getColorMetadata)(colorName);
        return tagColor;
    }
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
};
const $f82594f1a021ae46$export$18b1d108a714e82e = ({ labelGroupHeader: labelGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $67Vsg.default), labelGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.label?.name,
        color: data?.label ? $f82594f1a021ae46$var$getLabelColor(data.label) : undefined,
        isColored: $f82594f1a021ae46$var$isColorfulLabelsEnabled(),
        noValueText: formatMessage((0, $7hEnC.default).noLabel)
    });
};

});
parcelRegister("67Vsg", function(module, exports) {
$parcel$export(module.exports, "default", () => $be04cc45d395e38c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70e7f722477a95b8a80b65e0cc80f9e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be04cc45d395e38c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LabelGroupHeader",
    "selections": [
        {
            "concreteType": "JiraLabel",
            "kind": "LinkedField",
            "name": "label",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlLabelFieldValue"
};
$be04cc45d395e38c$var$node.hash = "a8bfa525dbc0a2dfd874d9659eb9c96d";
var $be04cc45d395e38c$export$2e2bcd8739ae039 = $be04cc45d395e38c$var$node;

});

parcelRegister("aCFLd", function(module, exports) {
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $3bdc301abc6592d1$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $3bdc301abc6592d1$export$a80529ae8ec44f02);

var $5PQOA = parcelRequire("5PQOA");

var $cNNNb = parcelRequire("cNNNb");

var $1mQND = parcelRequire("1mQND");

var $eFge8 = parcelRequire("eFge8");
const $3bdc301abc6592d1$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $cNNNb.GREY_META).name;
};
const $3bdc301abc6592d1$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $cNNNb.GREY_META).tagColor;
};
const $3bdc301abc6592d1$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$97056d4b28203ee9);
const $3bdc301abc6592d1$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$a3f5334e7a13e57a);

});
parcelRegister("cNNNb", function(module, exports) {
$parcel$export(module.exports, "GREY_META", () => $711a16afce0bfcb3$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $711a16afce0bfcb3$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $711a16afce0bfcb3$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $711a16afce0bfcb3$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $711a16afce0bfcb3$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT", () => $711a16afce0bfcb3$export$20b2b274810f728a);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $711a16afce0bfcb3$export$7c14120abebd4749);

var $isE62 = parcelRequire("isE62");
const $711a16afce0bfcb3$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    borderColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLightest
};
const $711a16afce0bfcb3$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    borderColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLighter
};
const $711a16afce0bfcb3$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    borderColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).grey
};
const $711a16afce0bfcb3$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    borderColor: "var(--ds-border-accent-gray, #758195)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarker
};
const $711a16afce0bfcb3$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    borderColor: "var(--ds-background-neutral-bold, #44546F)",
    // grey700
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarkest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    borderColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLightest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    borderColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLighter
};
const $711a16afce0bfcb3$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    borderColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purple
};
const $711a16afce0bfcb3$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    borderColor: "var(--ds-border-accent-purple, #8270DB)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarker
};
const $711a16afce0bfcb3$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    borderColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarkest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    borderColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLightest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    borderColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLighter
};
const $711a16afce0bfcb3$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    borderColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blue
};
const $711a16afce0bfcb3$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    borderColor: "var(--ds-border-accent-blue, #1D7AFC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarker
};
const $711a16afce0bfcb3$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    borderColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarkest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    borderColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLightest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    borderColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLighter
};
const $711a16afce0bfcb3$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    borderColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).teal
};
const $711a16afce0bfcb3$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    borderColor: "var(--ds-border-accent-teal, #2898BD)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarker
};
const $711a16afce0bfcb3$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    borderColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarkest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    borderColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLightest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    borderColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLighter
};
const $711a16afce0bfcb3$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    borderColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).green
};
const $711a16afce0bfcb3$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    borderColor: "var(--ds-border-accent-green, #22A06B)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarker
};
const $711a16afce0bfcb3$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    borderColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarkest
};
const $711a16afce0bfcb3$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    borderColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLightest
};
const $711a16afce0bfcb3$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    borderColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLighter
};
const $711a16afce0bfcb3$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    borderColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).lime
};
const $711a16afce0bfcb3$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    borderColor: "var(--ds-border-accent-lime, #6A9A23)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarker
};
const $711a16afce0bfcb3$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    borderColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarkest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    borderColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLightest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    borderColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLighter
};
const $711a16afce0bfcb3$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    borderColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellow
};
const $711a16afce0bfcb3$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    borderColor: "var(--ds-border-accent-yellow, #B38600)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarker
};
const $711a16afce0bfcb3$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    borderColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarkest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    borderColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLightest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    borderColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLighter
};
const $711a16afce0bfcb3$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    borderColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orange
};
const $711a16afce0bfcb3$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    borderColor: "var(--ds-border-accent-orange, #E56910)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarker
};
const $711a16afce0bfcb3$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    borderColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarkest
};
const $711a16afce0bfcb3$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    borderColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLightest
};
const $711a16afce0bfcb3$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    borderColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLighter
};
const $711a16afce0bfcb3$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    borderColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).red
};
const $711a16afce0bfcb3$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    borderColor: "var(--ds-border-accent-red, #E2483D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarker
};
const $711a16afce0bfcb3$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    borderColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarkest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    borderColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLightest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    borderColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLighter
};
const $711a16afce0bfcb3$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    borderColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magenta
};
const $711a16afce0bfcb3$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    borderColor: "var(--ds-border-accent-magenta, #CD519D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarker
};
const $711a16afce0bfcb3$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    borderColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarkest
};
const $711a16afce0bfcb3$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $711a16afce0bfcb3$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $711a16afce0bfcb3$export$7f42563469df7e01 = [
    $711a16afce0bfcb3$var$GREY_LIGHTEST_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTEST_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTEST_META,
    $711a16afce0bfcb3$var$LIME_LIGHTEST_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META,
    $711a16afce0bfcb3$var$RED_LIGHTEST_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREY_LIGHTER_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTER_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTER_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTER_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTER_META,
    $711a16afce0bfcb3$var$LIME_LIGHTER_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTER_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTER_META,
    $711a16afce0bfcb3$var$RED_LIGHTER_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00,
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$BLUE_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$LIME_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$BLUE_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$var$LIME_DARKER_META,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META,
    $711a16afce0bfcb3$var$PURPLE_DARKEST_META,
    $711a16afce0bfcb3$export$69c4eac71b813fba,
    $711a16afce0bfcb3$var$TEAL_DARKEST_META,
    $711a16afce0bfcb3$var$GREEN_DARKEST_META,
    $711a16afce0bfcb3$var$LIME_DARKEST_META,
    $711a16afce0bfcb3$var$YELLOW_DARKEST_META,
    $711a16afce0bfcb3$var$ORANGE_DARKEST_META,
    $711a16afce0bfcb3$var$RED_DARKEST_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKEST_META
];
const $711a16afce0bfcb3$export$2c649adf8351b065 = [
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00
];
const $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$711a16afce0bfcb3$export$2c649adf8351b065.forEach((option)=>{
    $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $711a16afce0bfcb3$export$20b2b274810f728a = [
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META
];
const $711a16afce0bfcb3$export$7c14120abebd4749 = {};
$711a16afce0bfcb3$export$7f42563469df7e01.forEach((option)=>{
    $711a16afce0bfcb3$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("isE62", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ddc0b3065e46f63$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2ddc0b3065e46f63$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("1mQND", function(module, exports) {
$parcel$export(module.exports, "getHashValueForText", () => $682ff2f1c6e48764$export$e352defce701b36e);

const $682ff2f1c6e48764$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $12800e69511f991d$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $12800e69511f991d$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $12800e69511f991d$export$d15e38bcd75fda7c = 256;
const $12800e69511f991d$export$e143f4b09221a374 = 1000000007;


parcelRegister("eFge8", function(module, exports) {
$parcel$export(module.exports, "getRandomIndex", () => $e4e4b7d26b0de284$export$cb0dffe2d2ae675a);

var $cNNNb = parcelRequire("cNNNb");
const $e4e4b7d26b0de284$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("051tO", function(module, exports) {
$parcel$export(module.exports, "getRandomColor", () => $3b3f14c0d0659bfe$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3b3f14c0d0659bfe$export$49fce7fdcf55f26d);

var $cNNNb = parcelRequire("cNNNb");
const $3b3f14c0d0659bfe$export$e4369cabd7e84cd9 = ({ colorPaletteVariant: colorPaletteVariant = '' } = {})=>{
    // usign colorPaletteVariant to determine which color palette to use for random color selection
    const palette = colorPaletteVariant === 'newDarker' ? (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT) : (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT);
    const randomIndex = Math.floor(Math.random() * palette.length);
    return palette[randomIndex].name;
};
const $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9 = (colorValue, colorCardVariant = 'fill')=>{
    if (colorCardVariant === 'outline') return (0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.borderColor === colorValue)?.name ?? '';
    return (0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
};
const $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c = (colorName, colorCardVariant = 'fill')=>{
    if (colorCardVariant === 'outline') return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.borderColor ?? '';
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
};
const $3b3f14c0d0659bfe$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $cNNNb.GREY_META;
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $cNNNb.GREY_META);
};
const $3b3f14c0d0659bfe$export$4ef6b7574883e63d = ()=>(0, $cNNNb.OPTION_COLOR_THEMES).map((item)=>item.name);

});

parcelRegister("aIng6", function(module, exports) {
$parcel$export(module.exports, "TagGroupHeaderContent", () => $ca486725032725d5$export$be4c68ded587a8de);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $1tX0c = parcelRequire("1tX0c");

var $4cTDP = parcelRequire("4cTDP");
const $ca486725032725d5$export$be4c68ded587a8de = ({ text: text, noValueText: noValueText, ...colorProps })=>{
    return text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
        name: text,
        ...colorProps,
        isHoverPopoverEnabled: (0, $4cTDP.fg)('group_by_any_field_tag_tooltip')
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, noValueText);
};

});
parcelRegister("1tX0c", function(module, exports) {
$parcel$export(module.exports, "TagItem", () => $99a66faf131dedf1$export$32a09b7581f7fd80);
$parcel$export(module.exports, "TagItemPopupContentWrapper", () => $99a66faf131dedf1$export$c9925310d93bfb2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $2TCFC = parcelRequire("2TCFC");
var $5DgXR = parcelRequire("5DgXR");
var $lC3pF = parcelRequire("lC3pF");

var $cgxPA = parcelRequire("cgxPA");

var $ewOxf = parcelRequire("ewOxf");

var $cxKOj = parcelRequire("cxKOj");

var $iyBBa = parcelRequire("iyBBa");

var $ibVOD = parcelRequire("ibVOD");

var $9Mapt = parcelRequire("9Mapt");

var $bzbsd = parcelRequire("bzbsd");

var $gybMp = parcelRequire("gybMp");
const $99a66faf131dedf1$var$AVATAR_SIZE = 'xsmall';
const $99a66faf131dedf1$var$AVATAR_APPEARANCE = 'square';
const $99a66faf131dedf1$var$tagMarginFixStyles = null;
const $99a66faf131dedf1$var$tagMarginInlineFixStyles = null;
const $99a66faf131dedf1$var$strikethroughStyles = null;
const $99a66faf131dedf1$var$TagItemAvatar = ({ src: src, testId: testId = 'list-with-popup.ui.tag-item.avatar' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: $99a66faf131dedf1$var$AVATAR_APPEARANCE,
        size: $99a66faf131dedf1$var$AVATAR_SIZE,
        src: src,
        borderColor: "transparent",
        testId: testId
    });
const $99a66faf131dedf1$var$TagItemMediaImage = /*#__PURE__*/ (0, $eJOHy.memo)(({ mediaImage: mediaImage, fallbackSrc: fallbackSrc })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cgxPA.MediaImageWithErrorBoundary), {
        identifier: mediaImage.identifier,
        mediaClientConfig: mediaImage.mediaClientConfig,
        apiConfig: {
            ...mediaImage.apiConfig,
            width: (0, $2TCFC.AVATAR_SIZES)[$99a66faf131dedf1$var$AVATAR_SIZE],
            height: (0, $2TCFC.AVATAR_SIZES)[$99a66faf131dedf1$var$AVATAR_SIZE]
        }
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lC3pF.default), {
            appearance: $99a66faf131dedf1$var$AVATAR_APPEARANCE,
            size: $99a66faf131dedf1$var$AVATAR_SIZE
        });
        if (error || !data?.src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
            src: fallbackSrc,
            testId: "list-with-popup.ui.tag-item.media-image-error"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
            src: data?.src,
            testId: "list-with-popup.ui.tag-item.media-image-avatar"
        });
    }));
const $99a66faf131dedf1$var$TagItemIcon = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon.mediaImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemMediaImage, {
        mediaImage: icon.mediaImage,
        fallbackSrc: icon.url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemAvatar, {
        src: icon.url
    }));
const $99a66faf131dedf1$export$32a09b7581f7fd80 = ({ name: name, href: href, icon: icon, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isColored: isColored, color: color, isHoverPopoverEnabled: isHoverPopoverEnabled = false, isOnlyOneItem: isOnlyOneItem })=>{
    const tagRef = (0, $eJOHy.useRef)(null);
    if (isHoverPopoverEnabled) {
        const renderTagContent = (ref, props)=>{
            return isColored ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
                labelName: name,
                href: href,
                actionSubjectId: "listWithPopup",
                containerXcss: $99a66faf131dedf1$var$extraColoredTagStyles,
                contentXcss: $99a66faf131dedf1$var$extraColoredTagTextStyles,
                analyticsAttributes: {
                    isHoverPopoverEnabled: isHoverPopoverEnabled
                },
                ref: ref,
                ...color && (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                    color: color
                } : {},
                ...props
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1ule _1ul9ze3t"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                "data-testid": "list-with-popup.ui.tag-item.tag-item",
                ...props,
                className: (0, $hcewu.default)([
                    "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
                    "_2hwxr5cr _18u0r5cr",
                    shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
                elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemIcon, {
                    icon: icon
                }) : undefined,
                text: name,
                href: href,
                linkComponent: (0, $gybMp.default),
                ref: ref
            })));
        };
        const hoverPopoverContent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                contentRef: tagRef,
                content: name
            }, ({ ref: ref })=>renderTagContent((0, $bzbsd.mergeRefs)(tagRef, ref), props));
        if (isOnlyOneItem) return hoverPopoverContent();
        // If there are more then one tag, different popovers need to be rendered on the tag and the see more button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>hoverPopoverContent({
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            })));
    }
    if (isColored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
        labelName: name,
        href: href,
        actionSubjectId: "listWithPopup",
        containerXcss: $99a66faf131dedf1$var$extraColoredTagStyles,
        contentXcss: $99a66faf131dedf1$var$extraColoredTagTextStyles,
        ...color && (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            color: color
        } : {}
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "list-with-popup.ui.tag-item.tag-item",
        className: (0, $hcewu.default)([
            "_1e0c1o8l _19pkr5cr _otyrr5cr _p12f1osq _l9z01osq",
            "_2hwxr5cr _18u0r5cr",
            shouldDisplayStrikethrough && "_59381r81 _yha21cog _1nmzvv82"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        elemBefore: icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99a66faf131dedf1$var$TagItemIcon, {
            icon: icon
        }) : undefined,
        text: name,
        href: href,
        linkComponent: (0, $gybMp.default)
    }));
};
const $99a66faf131dedf1$export$c9925310d93bfb2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $99a66faf131dedf1$var$extraColoredTagTextStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $99a66faf131dedf1$var$extraColoredTagStyles = (0, $1DXK0.xcss)({
    marginInline: 'space.0',
    minWidth: '0px'
});
const $99a66faf131dedf1$var$hoverPopoverStyles = null;

});
parcelRegister("2TCFC", function(module, exports) {
$parcel$export(module.exports, "AVATAR_SIZES", () => $db6435c31362d4b0$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $db6435c31362d4b0$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $db6435c31362d4b0$export$e2bd4c1faded7921);
const $db6435c31362d4b0$export$9a270941bcff7e77 = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $db6435c31362d4b0$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $db6435c31362d4b0$export$e2bd4c1faded7921 = 2;
const $db6435c31362d4b0$export$89a980dfdf90df51 = 0.9;
const $db6435c31362d4b0$export$3c061e31594ebabe = '--avatar-background-color';
const $db6435c31362d4b0$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $db6435c31362d4b0$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("lC3pF", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd8f08acdf78d9e1$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $fd8f08acdf78d9e1$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $fd8f08acdf78d9e1$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $fd8f08acdf78d9e1$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $fd8f08acdf78d9e1$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $fd8f08acdf78d9e1$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$fd8f08acdf78d9e1$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hcewu.default)([
            $fd8f08acdf78d9e1$var$styles.root,
            $fd8f08acdf78d9e1$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && !(0, $eGOwo.fg)('platform_dst_avatar_tile') && $fd8f08acdf78d9e1$var$borderRadiusMap[size ?? 'medium'],
            appearance === 'square' && (0, $eGOwo.fg)('platform_dst_avatar_tile') && $fd8f08acdf78d9e1$var$styles.square,
            appearance === 'hexagon' && $fd8f08acdf78d9e1$var$styles.hexagon,
            weight === 'strong' && $fd8f08acdf78d9e1$var$styles.strongOpacity
        ])
    });
var $fd8f08acdf78d9e1$export$2e2bcd8739ae039 = $fd8f08acdf78d9e1$var$Skeleton;

});

parcelRegister("cgxPA", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $4d10e61645f59e88$export$758a2fef95a29ad0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $iDkaD = parcelRequire("iDkaD");
const $4d10e61645f59e88$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iDkaD.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("iDkaD", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithMediaClient", () => $124670e45144e8f4$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cu5Ae = parcelRequire("cu5Ae");

var $iN7PZ = parcelRequire("iN7PZ");

var $eGOwo = parcelRequire("eGOwo");
const $124670e45144e8f4$var$copyDivStyles = null;
const $124670e45144e8f4$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $eGOwo.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $hcewu.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $124670e45144e8f4$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eJOHy.useMemo)(()=>(0, $cu5Ae.withMediaClient)($124670e45144e8f4$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("cu5Ae", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $5bfc4058bddc627f$export$9f7977d4a2561bee);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");
const $5bfc4058bddc627f$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});
parcelRegister("93R6D", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $c470ce77068e97aa$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $c470ce77068e97aa$export$5bff351c86f56d97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
const $c470ce77068e97aa$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $c470ce77068e97aa$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c470ce77068e97aa$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});
parcelRegister("aRuva", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $3430d7925e0b0890$export$c9ecbc1b719fd417);

var $e33YM = parcelRequire("e33YM");
const $3430d7925e0b0890$export$f92e83e86b03c398 = new Map();
const $3430d7925e0b0890$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $e33YM.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3430d7925e0b0890$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $e33YM.MediaClient)(mediaClientConfig);
        $3430d7925e0b0890$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("e33YM", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $4ee615cd17ba35c7$export$fba8b4ca6d386aec);

var $adK77 = parcelRequire("adK77");
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");

var $jkwTu = parcelRequire("jkwTu");

var $iPHIU = parcelRequire("iPHIU");

var $gWavf = parcelRequire("gWavf");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

class $4ee615cd17ba35c7$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $1ZNSP.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $jkwTu.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $9t1Mu.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iPHIU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
        this.stargate = new (0, $gWavf.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("921Bq"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("adK77", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $igDjg !== 'undefined' && $igDjg.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $igDjg.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("1jG9B", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("bLPxw")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("7mZlN")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("7mZlN")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("9t1Mu")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $bLPxw = parcelRequire("bLPxw");

var $7mZlN = parcelRequire("7mZlN");

var $9t1Mu = parcelRequire("9t1Mu");

});
parcelRegister("bLPxw", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $b0497af2bbf706c4$export$8cef61637918b288);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $b0497af2bbf706c4$export$8cef61637918b288 = {
    streams: new (0, $7xkt0.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $adK77.EventEmitter2)()
};

});

parcelRegister("7mZlN", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $8faf84af4f6865cd$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $8faf84af4f6865cd$export$17f6055767a8d96a);
function $8faf84af4f6865cd$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $8faf84af4f6865cd$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $8faf84af4f6865cd$export$17f6055767a8d96a = (auth)=>{
    if ($8faf84af4f6865cd$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("9t1Mu", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $7f634a1b182817d3$export$d3e73a50cc549c2e);
var $7f634a1b182817d3$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("jkwTu", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $6c83a790055aaff5$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $6c83a790055aaff5$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $6c83a790055aaff5$export$20f9315304dd6726);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
var $7mZlN = parcelRequire("7mZlN");

var $6PCIn = parcelRequire("6PCIn");

var $1xw3A = parcelRequire("1xw3A");

var $h3W10 = parcelRequire("h3W10");
var $8RCh7 = parcelRequire("8RCh7");

var $2Cdf9 = parcelRequire("2Cdf9");

var $2dJnj = parcelRequire("2dJnj");

var $hsEvX = parcelRequire("hsEvX");

var $fEnUE = parcelRequire("fEnUE");
const $6c83a790055aaff5$var$MEDIA_API_REGION = 'media-api-region';
const $6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $6c83a790055aaff5$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $6PCIn.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $6PCIn.MAX_RESOLUTION),
            height: (0, $6PCIn.MAX_RESOLUTION)
        } : {}
    };
};
const $6c83a790055aaff5$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $6c83a790055aaff5$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $2dJnj.isCDNEnabled)()) result += '/cdn';
    return result;
};
class $6c83a790055aaff5$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $8RCh7.request)(artifactUrl, options, abortController).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $hsEvX.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hsEvX.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $9t1Mu.ChunkHashAlgorithm).Sha256;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $6c83a790055aaff5$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        if ((0, $fEnUE.isPathBasedEnabled)()) return (0, $fEnUE.mapToPathBasedUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        if ((0, $fEnUE.isPathBasedEnabled)()) return (0, $fEnUE.mapToPathBasedUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $1xw3A.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $2Cdf9.createUrl)((0, $2dJnj.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
        if ((0, $fEnUE.isPathBasedEnabled)()) return (0, $fEnUE.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $6c83a790055aaff5$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $2Cdf9.defaultShouldRetryError)(err) || (0, $h3W10.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $7mZlN.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $2dJnj.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $fEnUE.isPathBasedEnabled)()) url = (0, $fEnUE.mapToPathBasedUrl)(url);
        const response = await (0, $8RCh7.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $8RCh7.request)(url, {
            method: 'HEAD',
            traceContext: (0, $2Cdf9.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $6c83a790055aaff5$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $6c83a790055aaff5$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $6c83a790055aaff5$export$c8b741e18397852a = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT);
};
const $6c83a790055aaff5$export$20f9315304dd6726 = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION);
};

});
parcelRegister("6PCIn", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $b90d9cdebe03397b$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $b90d9cdebe03397b$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $b90d9cdebe03397b$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $b90d9cdebe03397b$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $b90d9cdebe03397b$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $b90d9cdebe03397b$export$f14f521f3d306044);

var $jmTJ7 = parcelRequire("jmTJ7");
const $b90d9cdebe03397b$export$860a16125e30000b = 'recents';
const $b90d9cdebe03397b$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $b90d9cdebe03397b$export$6e70f30e392bc53f = 4096;
const $b90d9cdebe03397b$export$c1abb8bab1e615cd = 5 * (0, $jmTJ7.DATA_UNIT).MB;
const $b90d9cdebe03397b$export$3d5157f0def70e54 = 1000;
const $b90d9cdebe03397b$export$f14f521f3d306044 = 2 * (0, $jmTJ7.DATA_UNIT).TB;

});
parcelRegister("jmTJ7", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $29f3d51eb645d15a$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $29f3d51eb645d15a$export$76cfea4c354af843);
const $29f3d51eb645d15a$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $29f3d51eb645d15a$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $29f3d51eb645d15a$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("1xw3A", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $91442ef87cdc4338$export$1cc24defa44e7f84);

var $2dJnj = parcelRequire("2dJnj");
const $91442ef87cdc4338$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $2dJnj.isCDNEnabled)() && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("2dJnj", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $bf5b522ee1224e39$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $bf5b522ee1224e39$export$fb88a576cf28364d);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");

var $7pw1V = parcelRequire("7pw1V");

var $fEnUE = parcelRequire("fEnUE");
const $bf5b522ee1224e39$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $bf5b522ee1224e39$export$3e47d0e609e44278() {
    return (0, $3NmFr.isCommercial)() && !(0, $7pw1V.isIsolatedCloud)() && (0, $eGOwo.fg)('platform_media_cdn_delivery') && !(0, $fEnUE.isPathBasedEnabled)();
}
function $bf5b522ee1224e39$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!$bf5b522ee1224e39$export$3e47d0e609e44278() || tokenLength > $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $eGOwo.fg)('platform_media_cdn_delivery') && (0, $eGOwo.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $bf5b522ee1224e39$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("3NmFr", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $130542adabbe691e$export$df69ff6733e73e50);
function $130542adabbe691e$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});

parcelRegister("fEnUE", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $e4d3865d0c2bde9e$export$6de3392754e98e65);
$parcel$export(module.exports, "mapToPathBasedUrl", () => $e4d3865d0c2bde9e$export$774e2add1fbe26aa);
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $e4d3865d0c2bde9e$export$e71b0af0000b3cfa);

var $eGOwo = parcelRequire("eGOwo");

var $9Wv0b = parcelRequire("9Wv0b");
function $e4d3865d0c2bde9e$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $e4d3865d0c2bde9e$export$6de3392754e98e65() {
    const isLocalhost = (0, $9Wv0b.default)()?.location?.hostname === 'localhost';
    return (0, $eGOwo.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $e4d3865d0c2bde9e$export$774e2add1fbe26aa(url) {
    if ($e4d3865d0c2bde9e$export$6de3392754e98e65()) {
        const parsedUrl = new URL(url);
        parsedUrl.pathname = `/media-api${parsedUrl.pathname}`;
        const location = (0, $9Wv0b.default)()?.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $e4d3865d0c2bde9e$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $e4d3865d0c2bde9e$export$e71b0af0000b3cfa(url) {
    const parsedUrl = new URL(url);
    parsedUrl.host = (0, $9Wv0b.default)()?.location.host ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    parsedUrl.pathname = `/media-api${parsedUrl.pathname}`;
    return parsedUrl;
}

});
parcelRegister("9Wv0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea1ee745dc0e3b5$export$2e2bcd8739ae039);
var $bea1ee745dc0e3b5$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("h3W10", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $360d238df22c07b8$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $360d238df22c07b8$export$3717b1ffef4428ea);

var $4rKJa = parcelRequire("4rKJa");
class $360d238df22c07b8$export$43ee7d0e4f429743 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $360d238df22c07b8$export$3717b1ffef4428ea(err) {
    return err instanceof $360d238df22c07b8$export$43ee7d0e4f429743;
}

});
parcelRegister("4rKJa", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $e9c543355e5204ca$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $e9c543355e5204ca$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $e9c543355e5204ca$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $e9c543355e5204ca$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $e9c543355e5204ca$export$c2b89b9a32286816);

var $eBofv = parcelRequire("eBofv");
class $e9c543355e5204ca$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $e9c543355e5204ca$export$e574d1724215079f extends $e9c543355e5204ca$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $e9c543355e5204ca$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $e9c543355e5204ca$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $e9c543355e5204ca$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $e9c543355e5204ca$export$e574d1724215079f(error?.reason || 'unknown-reason', error?.metadata, error?.innerError);
};
const $e9c543355e5204ca$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("eBofv", function(module, exports) {
$parcel$export(module.exports, "getMediaClientErrorReason", () => $508e04f54b9269ab$export$c15d72765ee2baa4);
function $508e04f54b9269ab$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $508e04f54b9269ab$export$c15d72765ee2baa4(err) {
    return $508e04f54b9269ab$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("8RCh7", function(module, exports) {
$parcel$export(module.exports, "request", () => $16d1dca60bf2e497$export$b5fe3f66a567bec0);

var $h3W10 = parcelRequire("h3W10");

var $2Cdf9 = parcelRequire("2Cdf9");

var $eGOwo = parcelRequire("eGOwo");

var $fEnUE = parcelRequire("fEnUE");

var $vcOMX = parcelRequire("vcOMX");
async function $16d1dca60bf2e497$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2Cdf9.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
    if ((0, $eGOwo.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            if ((0, $2Cdf9.isFetchNetworkError)(err) && (0, $vcOMX.default)()?.userAgent.includes('Edg/')) return false;
            return (0, $2Cdf9.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $2Cdf9.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            if ((0, $2Cdf9.isFetchNetworkError)(error) && (0, $vcOMX.default)()?.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $2Cdf9.createUrl)((0, $fEnUE.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
                return (0, $2Cdf9.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $2Cdf9.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("2Cdf9", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf);
$parcel$export(module.exports, "extendTraceContext", () => $8e2ee04a8e27c7ba$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $8e2ee04a8e27c7ba$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $8e2ee04a8e27c7ba$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $8e2ee04a8e27c7ba$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $8e2ee04a8e27c7ba$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $8e2ee04a8e27c7ba$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $8e2ee04a8e27c7ba$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $8e2ee04a8e27c7ba$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $8e2ee04a8e27c7ba$export$6e2e477edb7d6032);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $3xaEP = parcelRequire("3xaEP");

var $9WNJB = parcelRequire("9WNJB");

var $h3W10 = parcelRequire("h3W10");
const $8e2ee04a8e27c7ba$var$getStatusCode = (error)=>(0, $h3W10.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $8e2ee04a8e27c7ba$export$bc96a6a479480590(error) {
    const statusCode = error && $8e2ee04a8e27c7ba$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $8e2ee04a8e27c7ba$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $3xaEP.getRandomTelemetryId)()
    } : undefined;
const $8e2ee04a8e27c7ba$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $8e2ee04a8e27c7ba$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $9WNJB.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $8e2ee04a8e27c7ba$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth),
        ...$8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $8e2ee04a8e27c7ba$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $8e2ee04a8e27c7ba$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $8e2ee04a8e27c7ba$export$fee2242cbb339663 = (err)=>{
    const statusCode = $8e2ee04a8e27c7ba$var$getStatusCode(err);
    return $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $8e2ee04a8e27c7ba$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $8e2ee04a8e27c7ba$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$8e2ee04a8e27c7ba$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $8e2ee04a8e27c7ba$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err)) throw new (0, $h3W10.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $h3W10.isRequestError)(lastError)) throw $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $h3W10.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode);
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $8e2ee04a8e27c7ba$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $8e2ee04a8e27c7ba$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3xaEP", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $af4102ec3e3c11b2$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $af4102ec3e3c11b2$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $af4102ec3e3c11b2$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $af4102ec3e3c11b2$export$2e36de8639bad0ad);
const $af4102ec3e3c11b2$export$fce6876652108ab = (value)=>value === undefined;
const $af4102ec3e3c11b2$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $af4102ec3e3c11b2$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $af4102ec3e3c11b2$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $af4102ec3e3c11b2$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $af4102ec3e3c11b2$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $af4102ec3e3c11b2$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    }
    else randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    return randomHex;
}
function $af4102ec3e3c11b2$export$2e36de8639bad0ad() {
    return $af4102ec3e3c11b2$export$456b25e3a9b4a843(8);
}

});

parcelRegister("9WNJB", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $47d6feb819b26718$export$6833b130611df767);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");
function $47d6feb819b26718$export$6833b130611df767(auth) {
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("vcOMX", function(module, exports) {
$parcel$export(module.exports, "default", () => $50d40fcfaddb9f61$export$2e2bcd8739ae039);
var $50d40fcfaddb9f61$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});


parcelRegister("hsEvX", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $6d143f49360dbe76$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $6d143f49360dbe76$export$5211e1371264aec3);

var $3Y4Hn = parcelRequire("3Y4Hn");

var $3nErQ = parcelRequire("3nErQ");
const $6d143f49360dbe76$export$560085fe411c0660 = 10000;
const $6d143f49360dbe76$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $6d143f49360dbe76$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $3nErQ.rejectTimeout)(authProviderTimeout, new (0, $3Y4Hn.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $3Y4Hn.MediaStoreError)) throw err;
        throw new (0, $3Y4Hn.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $6d143f49360dbe76$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("3Y4Hn", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $d19f60583c5ce4e8$export$b78480bd311630bc);

var $4rKJa = parcelRequire("4rKJa");
class $d19f60583c5ce4e8$export$b78480bd311630bc extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $d19f60583c5ce4e8$export$8d2a9b675b2ce37a(err) {
    return err instanceof $d19f60583c5ce4e8$export$b78480bd311630bc;
}

});

parcelRegister("3nErQ", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $bdd7813d02cb717f$export$cf2d2a1124beacb2);
const $bdd7813d02cb717f$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $bdd7813d02cb717f$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iPHIU", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $09c82e56436a3d4e$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("1GWfm")).FileFetcherError);

var $2PBDa = parcelRequire("2PBDa");

var $3PmNk = parcelRequire("3PmNk");

var $8KLBw = parcelRequire("8KLBw");
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $g1OQu = parcelRequire("g1OQu");

var $jkwTu = parcelRequire("jkwTu");

var $bbNl0 = parcelRequire("bbNl0");

var $jmTJ7 = parcelRequire("jmTJ7");

var $1GWfm = parcelRequire("1GWfm");

var $2mMyO = parcelRequire("2mMyO");

var $abkQS = parcelRequire("abkQS");

var $lRBVi = parcelRequire("lRBVi");

var $6PCIn = parcelRequire("6PCIn");

var $eaj78 = parcelRequire("eaj78");

var $hRxrn = parcelRequire("hRxrn");

var $atDjN = parcelRequire("atDjN");

var $053B3 = parcelRequire("053B3");

var $iDYg8 = parcelRequire("iDYg8");

var $jFXx8 = parcelRequire("jFXx8");
var $kFG4u = parcelRequire("kFG4u");

var $ea8A0 = parcelRequire("ea8A0");

var $jkEmk = parcelRequire("jkEmk");

var $5JVfG = parcelRequire("5JVfG");

var $8UZz3 = parcelRequire("8UZz3");

var $393Zn = parcelRequire("393Zn");

var $iX2Cl = parcelRequire("iX2Cl");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

var $bksvR = parcelRequire("bksvR");

var $2Cdf9 = parcelRequire("2Cdf9");

var $4rKJa = parcelRequire("4rKJa");
const $09c82e56436a3d4e$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $09c82e56436a3d4e$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $09c82e56436a3d4e$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $1ZNSP.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $4rKJa.isCommonMediaClientError)(error)) return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $4rKJa.CommonMediaClientError)(error);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $4rKJa.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $jkEmk.createMediaSubject)();
            const poll = new (0, $393Zn.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $jmTJ7.isNotFoundMediaItemDetails)(response)) throw new (0, $1GWfm.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $iX2Cl.isEmptyFile)(response)) throw new (0, $1GWfm.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $bbNl0.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $iDYg8.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $atDjN.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $bbNl0.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if (fileState.mediaMetadata?.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch (_err) {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $hRxrn.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $bksvR.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(id)) {
            const subject = (0, $jkEmk.createMediaSubject)();
            const err = new (0, $1GWfm.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $jFXx8.fromObservable)(subject);
        }
        if (forceRefresh) (0, $abkQS.getFileStreamsCache)().remove(id);
        return (0, $jFXx8.fromObservable)((0, $abkQS.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $kFG4u.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $jkEmk.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $ea8A0.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $jkEmk.createMediaSubject)();
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $2PBDa.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $3PmNk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $2mMyO.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $jFXx8.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $g1OQu.downloadUrl)(url, {
            name: name
        });
        (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $6PCIn.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $2Cdf9.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $jkwTu.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $7mZlN.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $abkQS.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($09c82e56436a3d4e$var$isCopySourceFileWithToken(source) && $09c82e56436a3d4e$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $5JVfG.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $bbNl0.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $jkEmk.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $bbNl0.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $bbNl0.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $8UZz3.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $bbNl0.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $bbNl0.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $bbNl0.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $abkQS.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $jkEmk.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("g1OQu", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $c1f893c1652c9963$export$8a96edb1c96563f4);
const $c1f893c1652c9963$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("bbNl0", function(module, exports) {
$parcel$export(module.exports, "isUploadingFileState", () => $071e98cd60064284$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $071e98cd60064284$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $071e98cd60064284$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $071e98cd60064284$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $071e98cd60064284$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $071e98cd60064284$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $071e98cd60064284$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $071e98cd60064284$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $071e98cd60064284$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $071e98cd60064284$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $071e98cd60064284$export$ea3730792e8bebfb);
const $071e98cd60064284$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $071e98cd60064284$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $071e98cd60064284$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $071e98cd60064284$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $071e98cd60064284$export$92dd692b31e42e64 = (fileState)=>!$071e98cd60064284$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $071e98cd60064284$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $071e98cd60064284$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $071e98cd60064284$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $071e98cd60064284$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $071e98cd60064284$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $071e98cd60064284$export$ea3730792e8bebfb = (id, item)=>{
    return $071e98cd60064284$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("1GWfm", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $a248c46a7558c626$export$e3e60f0dab8641de);

var $4rKJa = parcelRequire("4rKJa");
class $a248c46a7558c626$export$e3e60f0dab8641de extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $a248c46a7558c626$export$5c3435f75ce0ce70(err) {
    return err instanceof $a248c46a7558c626$export$e3e60f0dab8641de;
}

});

parcelRegister("2mMyO", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $d0f3b9835713140d$export$a5575dbeeffdad98);

var $irjb3 = parcelRequire("irjb3");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $keN2a = parcelRequire("keN2a");

var $bpbRw = parcelRequire("bpbRw");

var $6PCIn = parcelRequire("6PCIn");

var $jZL78 = parcelRequire("jZL78");
const $d0f3b9835713140d$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $keN2a.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $d0f3b9835713140d$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $d0f3b9835713140d$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $d0f3b9835713140d$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $d0f3b9835713140d$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $d0f3b9835713140d$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $6PCIn.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $jZL78.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $jZL78.fileSizeError)) callbacks?.onUploadFinish(new (0, $bpbRw.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $irjb3.chunkinator)(content, {
        hashingFunction: (blob)=>$d0f3b9835713140d$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $d0f3b9835713140d$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6PCIn.PROCESSING_BATCH_SIZE),
        processingFunction: $d0f3b9835713140d$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $2opa2.from)(deferredUploadId).pipe((0, $4pIMA.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $4pIMA.concatMap)(()=>(0, $2opa2.from)($d0f3b9835713140d$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $d0f3b9835713140d$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("irjb3", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $d61183fbf8357e07$export$9ab6bef3838698f8);

var $jgII5 = parcelRequire("jgII5");

var $4pIMA = parcelRequire("4pIMA");

var $aoje7 = parcelRequire("aoje7");

var $9cPse = parcelRequire("9cPse");

var $fjIB7 = parcelRequire("fjIB7");

var $iyZWI = parcelRequire("iyZWI");

var $htAnC = parcelRequire("htAnC");

var $h9RjH = parcelRequire("h9RjH");

var $aN4rI = parcelRequire("aN4rI");

var $2opa2 = parcelRequire("2opa2");
const $d61183fbf8357e07$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $9cPse.fromPromise)((0, $aN4rI.fetchBlob)(file)).pipe((0, $4pIMA.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fjIB7.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $iyZWI.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $htAnC.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $jgII5.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $h9RjH.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $4pIMA.concatMap)((batchedChunks)=>{
            return (0, $2opa2.from)(batchedChunks);
        }), (0, $aoje7.bufferCount)(totalChunks));
    }));
const $d61183fbf8357e07$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $d61183fbf8357e07$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fjIB7", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $0dec34349839a009$export$5b92d769f2f57509);

var $4NFCE = parcelRequire("4NFCE");

var $3PmNk = parcelRequire("3PmNk");
const $0dec34349839a009$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $4NFCE.range)(0, totalChunks).pipe((0, $3PmNk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("iyZWI", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $946c6df5bbe7edda$export$d5f5a550a38ec367);

var $aN4rI = parcelRequire("aN4rI");
const $946c6df5bbe7edda$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $946c6df5bbe7edda$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $aN4rI.asyncMap)($946c6df5bbe7edda$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("aN4rI", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3);

var $7kixv = parcelRequire("7kixv");

var $eynBz = parcelRequire("eynBz");
async function $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $6bb2bbe9f31d7b02$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $6bb2bbe9f31d7b02$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $7kixv.Observable)((sub)=>{
            notifiers.push($6bb2bbe9f31d7b02$var$notify(project(value), sub, onReady));
        });
};
const $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $eynBz.mergeMap)($6bb2bbe9f31d7b02$var$mapper(project), concurrent);

});


parcelRegister("htAnC", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $376f95738497d04c$export$94ce0f3fcf999415);

var $aN4rI = parcelRequire("aN4rI");
const $376f95738497d04c$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $aN4rI.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("h9RjH", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $cfa6e3d7bb356500$export$2f21790600302ed);

var $aoje7 = parcelRequire("aoje7");

var $4pIMA = parcelRequire("4pIMA");
const $cfa6e3d7bb356500$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $aoje7.bufferCount)(options.batchSize)).pipe((0, $4pIMA.concatMap)(process));
};

});


parcelRegister("keN2a", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $a41e44f7241fbce8$export$14b114effbc08b6b);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
let $a41e44f7241fbce8$var$hasher = null;
let $a41e44f7241fbce8$var$sha256Hasher = null;
const $a41e44f7241fbce8$export$d9c9d11cd648a505 = ()=>{
    $a41e44f7241fbce8$var$hasher = null;
    $a41e44f7241fbce8$var$sha256Hasher = null;
};


const $a41e44f7241fbce8$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $9t1Mu.ChunkHashAlgorithm).Sha256) {
            if (!$a41e44f7241fbce8$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("2D0dL"));
                $a41e44f7241fbce8$var$sha256Hasher = new SimpleHasher();
            }
            return $a41e44f7241fbce8$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("got4H"));
    $a41e44f7241fbce8$var$hasher = new SimpleHasher();
    return $a41e44f7241fbce8$var$hasher;
};

});
parcelRegister("2D0dL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kxQbf").then(()=>parcelRequire('g8wZ9'));

});

parcelRegister("got4H", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("6rET6")
]).then(()=>parcelRequire('cPCGi'));

});


parcelRegister("bpbRw", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $85ab3781ae20a637$export$515240c3f059c807);

var $4rKJa = parcelRequire("4rKJa");
class $85ab3781ae20a637$export$515240c3f059c807 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $85ab3781ae20a637$export$80ee180172bc336(err) {
    return err instanceof $85ab3781ae20a637$export$515240c3f059c807;
}

});

parcelRegister("jZL78", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $b71a6cbe9ec1a24a$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $b71a6cbe9ec1a24a$export$71f452e02035c1e2);

var $jmTJ7 = parcelRequire("jmTJ7");

var $6PCIn = parcelRequire("6PCIn");
const $b71a6cbe9ec1a24a$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $b71a6cbe9ec1a24a$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $6PCIn.MAX_UPLOAD_FILE_SIZE)) throw new Error($b71a6cbe9ec1a24a$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $jmTJ7.DATA_UNIT).GB) return 5 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 50 * (0, $jmTJ7.DATA_UNIT).GB) return 50 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 0.95 * (0, $jmTJ7.DATA_UNIT).TB) return 100 * (0, $jmTJ7.DATA_UNIT).MB;
    return 210 * (0, $jmTJ7.DATA_UNIT).MB;
};

});


parcelRegister("abkQS", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $20fb1b7a81082f5e$export$f2f061938c1e6810);
class $20fb1b7a81082f5e$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $20fb1b7a81082f5e$var$streamCache;

const $20fb1b7a81082f5e$export$f2f061938c1e6810 = ()=>{
    if (!$20fb1b7a81082f5e$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("bLPxw")).mediaState;
        $20fb1b7a81082f5e$var$streamCache = new $20fb1b7a81082f5e$export$4293896e79732236(mediaState.streams);
    }
    return $20fb1b7a81082f5e$var$streamCache;
};

});

parcelRegister("lRBVi", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $175af825576b091d$export$68d003d3105952ad);
parcelRequire("1jG9B");
var $bLPxw = parcelRequire("bLPxw");
const $175af825576b091d$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $bLPxw.mediaState).eventEmitter) return (0, $bLPxw.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("eaj78", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5Ovjr = parcelRequire("5Ovjr");
var $a500d3812b6eabd3$require$Buffer = $5Ovjr.Buffer;
var $a500d3812b6eabd3$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $a500d3812b6eabd3$var$_byteToHex = [];
for(var $a500d3812b6eabd3$var$i = 0; $a500d3812b6eabd3$var$i < 256; $a500d3812b6eabd3$var$i++)$a500d3812b6eabd3$var$_byteToHex[$a500d3812b6eabd3$var$i] = ($a500d3812b6eabd3$var$i + 0x100).toString(16).substr(1);
function $a500d3812b6eabd3$var$unparse(buf, offset) {
    var i = offset || 0, bth = $a500d3812b6eabd3$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($a500d3812b6eabd3$require$Buffer.isBuffer(uuid)) parsedUuid = $a500d3812b6eabd3$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$a500d3812b6eabd3$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $a500d3812b6eabd3$var$extractVersion(parsedUuid);
    else if ($a500d3812b6eabd3$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $a500d3812b6eabd3$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("hRxrn", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $611f84914cb6f1a5$export$ae188fee39529b82);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $611f84914cb6f1a5$export$b79d95ee17a87a = 100;
const $611f84914cb6f1a5$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $611f84914cb6f1a5$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $611f84914cb6f1a5$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $611f84914cb6f1a5$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collection);
        if ($611f84914cb6f1a5$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($611f84914cb6f1a5$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $611f84914cb6f1a5$export$71cd2e8f8162d47b(keys, items);
    };
}
function $611f84914cb6f1a5$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $611f84914cb6f1a5$export$b79d95ee17a87a
    });
}

});

parcelRegister("atDjN", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $4c3ee7170cb316c1$export$ac3214931ffd82af);

var $5JVfG = parcelRequire("5JVfG");
const $4c3ee7170cb316c1$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $5JVfG.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("5JVfG", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isVideoMimeTypeSupportedByBrowser);

var $5hd6w = parcelRequire("5hd6w");

var $fK3MF = parcelRequire("fK3MF");

var $i9yw1 = parcelRequire("i9yw1");
const $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $5hd6w.isArchive)(mimeType)) return 'archive';
    if ((0, $fK3MF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $fK3MF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $fK3MF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $fK3MF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("5hd6w", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $d95d3f124d05d5e2$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $d95d3f124d05d5e2$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("fK3MF", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $14d0a1fe72c887af$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $14d0a1fe72c887af$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$55ca6cdaf6093034 = (mimeType)=>$14d0a1fe72c887af$export$74325e3c843a9555(mimeType) || $14d0a1fe72c887af$export$c021f2623a75015f(mimeType) || $14d0a1fe72c887af$export$ff36075ea755a717(mimeType) || $14d0a1fe72c887af$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("i9yw1", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $b92ae6a0fa1244e6$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$548d9148a80556a3 = (mimeType)=>$b92ae6a0fa1244e6$export$e9a065a80f76311e(mimeType) || $b92ae6a0fa1244e6$export$86baad7a89d908e9(mimeType) || $b92ae6a0fa1244e6$export$8cba23825d020bbb(mimeType) || $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3(mimeType) || $b92ae6a0fa1244e6$export$94e1479e01d2af53(mimeType);

});



parcelRegister("053B3", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $492d4a64b2b2425c$export$89097c0ec1e0dee1);

var $bbNl0 = parcelRequire("bbNl0");
const $492d4a64b2b2425c$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $bbNl0.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("iDYg8", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $87b4c423efa40e5c$export$ed17558b11b88056);
const $87b4c423efa40e5c$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("jFXx8", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $a6ac257ab8a71611$export$4b2432e2d8723823);

var $jkEmk = parcelRequire("jkEmk");
function $a6ac257ab8a71611$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $a6ac257ab8a71611$export$8659d1f07d151381(item) {
    return $a6ac257ab8a71611$export$4b2432e2d8723823((0, $jkEmk.createMediaSubject)(item));
}

});
parcelRegister("jkEmk", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $5f3a872941d2eff3$export$bc76d51553fa5e35);

var $86Sof = parcelRequire("86Sof");
function $5f3a872941d2eff3$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $86Sof.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("kFG4u", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $74eb9133065f0126$export$4dbaaf6c79705e6c);

var $2PBDa = parcelRequire("2PBDa");
const $74eb9133065f0126$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $2PBDa.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("ea8A0", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $2f9cb480159d13ae$export$71797c284d89a3e1);

var $hthqT = parcelRequire("hthqT");

var $gOskN = parcelRequire("gOskN");
const $2f9cb480159d13ae$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $hthqT.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $gOskN.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("hthqT", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $d7d48590d371ba3a$export$a1c3205f28a20414);
const $d7d48590d371ba3a$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("gOskN", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $4a8128b4320ca47f$export$62aabd5ff85d0451);
const $4a8128b4320ca47f$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("8UZz3", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $d7014b773fe3cff6$export$2ccdd6f9a9eba6a);

var $fK3MF = parcelRequire("fK3MF");
var $i9yw1 = parcelRequire("i9yw1");

var $gOskN = parcelRequire("gOskN");
async function $d7014b773fe3cff6$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $i9yw1.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $gOskN.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("393Zn", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $10b695ec33f62c2d$export$4c54d536f8e37dc2);

var $8iexj = parcelRequire("8iexj");
const $10b695ec33f62c2d$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $10b695ec33f62c2d$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$10b695ec33f62c2d$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("8iexj", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $76319a6a54892893$export$c3748c310e92340a);

var $4rKJa = parcelRequire("4rKJa");
class $76319a6a54892893$export$c3748c310e92340a extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $76319a6a54892893$export$541e3e52eea6fece(err) {
    return err instanceof $76319a6a54892893$export$c3748c310e92340a;
}

});


parcelRegister("iX2Cl", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $0723e6aaf9777481$export$728192ce8dd94659);
const $0723e6aaf9777481$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $0723e6aaf9777481$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $0723e6aaf9777481$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("48hWz", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => (parcelRequire("1ZNSP")).mediaStore);

var $1ZNSP = parcelRequire("1ZNSP");

});
parcelRegister("1ZNSP", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $8cb4e2ad5e722a42$export$5785580dea19518d);

var $7LOiC = parcelRequire("7LOiC");

var $1pZVO = parcelRequire("1pZVO");

var $96y8R = parcelRequire("96y8R");
const $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools = (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    }))));
const $8cb4e2ad5e722a42$var$mediaStoreWithDevtools = (0, $96y8R.createStore)()((0, $7LOiC.devtools)((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    })))));
const $8cb4e2ad5e722a42$export$5785580dea19518d = $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools;
const $8cb4e2ad5e722a42$export$503459913a0dc356 = (initialStore)=>{
    return (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7LOiC", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $5a83f092dca5fc3e$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $5a83f092dca5fc3e$export$5c593627aef9f076);
var $5a83f092dca5fc3e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $5a83f092dca5fc3e$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $5a83f092dca5fc3e$export$4feba8a1bc8e9afd = $5a83f092dca5fc3e$var$reduxImpl;
const $5a83f092dca5fc3e$var$trackedConnections = /* @__PURE__ */ new Map();
const $5a83f092dca5fc3e$var$getTrackedConnectionState = (name)=>{
    const api = $5a83f092dca5fc3e$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $5a83f092dca5fc3e$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $5a83f092dca5fc3e$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5a83f092dca5fc3e$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $5a83f092dca5fc3e$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $5a83f092dca5fc3e$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$5a83f092dca5fc3e$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5a83f092dca5fc3e$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $5a83f092dca5fc3e$export$6922d3b3a607469e = $5a83f092dca5fc3e$var$devtoolsImpl;
const $5a83f092dca5fc3e$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $5a83f092dca5fc3e$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $5a83f092dca5fc3e$export$5c593627aef9f076 = $5a83f092dca5fc3e$var$subscribeWithSelectorImpl;
const $5a83f092dca5fc3e$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $5a83f092dca5fc3e$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $5a83f092dca5fc3e$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $5a83f092dca5fc3e$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $5a83f092dca5fc3e$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $5a83f092dca5fc3e$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $5a83f092dca5fc3e$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $5a83f092dca5fc3e$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $5a83f092dca5fc3e$var$oldImpl(config, baseOptions);
    }
    return $5a83f092dca5fc3e$var$newImpl(config, baseOptions);
};
const $5a83f092dca5fc3e$export$9a6132153fba2e0 = $5a83f092dca5fc3e$var$persistImpl;

});

parcelRegister("1pZVO", function(module, exports) {
$parcel$export(module.exports, "immer", () => $10882a850d9663b5$export$428de7ec69ac95c);

var $K2rwM = parcelRequire("K2rwM");
const $10882a850d9663b5$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $K2rwM.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $10882a850d9663b5$export$428de7ec69ac95c = $10882a850d9663b5$var$immerImpl;

});
parcelRegister("K2rwM", function(module, exports) {
$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $08a6311ec7f77a2c$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $08a6311ec7f77a2c$export$2e2bcd8739ae039 = fn;

});


parcelRegister("96y8R", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $6a0f287ca3f709ed$export$f51a9068ac82ea43);
var $6a0f287ca3f709ed$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $6a0f287ca3f709ed$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $6a0f287ca3f709ed$export$f51a9068ac82ea43 = (createState)=>createState ? $6a0f287ca3f709ed$var$createStoreImpl(createState) : $6a0f287ca3f709ed$var$createStoreImpl;
var $6a0f287ca3f709ed$export$2e2bcd8739ae039 = (createState)=>{
    if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $6a0f287ca3f709ed$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("bksvR", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $6bed172d1e1e47c4$export$57945b6819e39246);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $6bed172d1e1e47c4$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $6bed172d1e1e47c4$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $6bed172d1e1e47c4$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("gWavf", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $60a1ef1a71feccaf$export$c66ca190f89caaac);
class $60a1ef1a71feccaf$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("921Bq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lPk9Z").then(()=>parcelRequire('h77Xn'));

});





parcelRegister("iN7PZ", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $eGOwo = parcelRequire("eGOwo");

var $7aoMz = parcelRequire("7aoMz");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $e54d3f9e11f733f6$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isLoading && (0, $eGOwo.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR and it's a blob URL, we can skip the refetch
            if (preview && (0, $k9eRE.isSSRPreview)(preview) && preview.dataURI.startsWith('blob:') && (0, $eGOwo.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        const isSSR = (0, $k9eRE.isSSRDataPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, preview?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $eGOwo.fg)('media-perf-uplift-mutation-fix')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $eGOwo.fg)('media-perf-uplift-mutation-fix') ? $e54d3f9e11f733f6$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);
$parcel$export(module.exports, "create", () => $aca29ade4cd157ce$export$185802fd694ee1f5);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {
$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    return mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    try {
        const dataURI = $acdcd6198e7dee1d$var$getDataUri(mediaClient, id, params, mediaBlobUrlAttrs);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $acdcd6198e7dee1d$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2
            }, mediaBlobUrlAttrs);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {
$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("lm4Lq"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("lm4Lq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("6FWCb"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {
$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {
$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);

var $eGOwo = parcelRequire("eGOwo");
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain' && (0, $eGOwo.fg)('platform_media-default-code-viewer-for-plain-text')) return 'text';
            return null;
    }
}

});


parcelRegister("6FWCb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {
$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, paramDataURI, paramSrcSet, dimensions, error, featureFlags = {}, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    if (featureFlags['media-perf-uplift-mutation-fix']) {
        const prevData = mediaCardSsr[key];
        const isPreviousImageLarger = prevData && prevData.dimensions?.width && dimensions?.width && prevData.dimensions.width > dimensions.width;
        const srcSet = isPreviousImageLarger ? prevData?.srcSet : paramSrcSet;
        const dataURI = isPreviousImageLarger ? prevData?.dataURI : paramDataURI;
        const img = script?.parentElement?.querySelector('img');
        if (img && dataURI) img.src = dataURI;
        if (img && srcSet) img.srcset = srcSet;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        img?.addEventListener('load', ()=>{
            if (img.currentSrc.startsWith('blob:')) return;
            fetch(img.currentSrc).then((res)=>res.blob()).then((blob)=>URL.createObjectURL(blob)).then((blobUrl)=>{
                img.src = blobUrl;
                img.srcset = '';
                mediaCardSsr[key] = {
                    ...mediaCardSsr[key],
                    dataURI: blobUrl,
                    srcSet: ''
                };
            }).catch((err)=>{
                mediaCardSsr[key] = {
                    ...mediaCardSsr[key],
                    error: err
                };
            });
        });
        mediaCardSsr[key] = isPreviousImageLarger ? prevData : {
            dataURI: dataURI,
            dimensions: dimensions,
            error: error,
            srcSet: srcSet
        };
    } else mediaCardSsr[key] = {
        dataURI: paramDataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, srcSet, dimensions, error, featureFlags = {})=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, srcSet, dimensions, error, featureFlags);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, srcSet, dimensions, error, featureFlags)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {
$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>`(function(){
			 let script = document.currentScript;
 			 ${statements.join(';')}
			 document.currentScript.remove();
		})();
		`;

});


parcelRegister("8Dv9L", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});




parcelRegister("iyBBa", function(module, exports) {
$parcel$export(module.exports, "ColoredTag", () => $edbc1f1c5365a1cc$export$526384205b143b58);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $051tO = parcelRequire("051tO");

var $aCFLd = parcelRequire("aCFLd");
const $edbc1f1c5365a1cc$export$526384205b143b58 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ labelName: labelName, href: href, actionSubjectId: actionSubjectId, containerXcss: containerXcss, contentXcss: contentXcss, analyticsAttributes: analyticsAttributes, color: color, ...restProps }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { backgroundColor: borderColor } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(labelName));
    const onHandleClickForAnchor = (0, $eJOHy.useCallback)(()=>{
        if (actionSubjectId) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: analyticsAttributes
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$hoverStyles,
            $edbc1f1c5365a1cc$var$anchorTextStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        href: href,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        },
        onClick: onHandleClickForAnchor,
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            ...containerXcss ? [
                containerXcss
            ] : []
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
});
const $edbc1f1c5365a1cc$var$tagStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.050',
    paddingBlock: '0',
    font: 'font.body',
    marginBlock: 'space.050',
    marginInline: 'space.050',
    height: '20px',
    alignItems: 'center',
    maxWidth: '100%'
});
const $edbc1f1c5365a1cc$var$hoverStyles = (0, $1DXK0.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'underline'
    }
});
const $edbc1f1c5365a1cc$var$tagTextStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});
const $edbc1f1c5365a1cc$var$anchorTextStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text'
    }
});

});

parcelRegister("ibVOD", function(module, exports) {
$parcel$export(module.exports, "useCellHoverCallbacks", () => $72d9a29ee2941367$export$793f17026bd5d1b4);
$parcel$export(module.exports, "CellHoverProvider", () => $72d9a29ee2941367$export$d427879c5002c548);
$parcel$export(module.exports, "useCellHoverHandlers", () => $72d9a29ee2941367$export$5ac0a932365e8caa);

var $eJOHy = parcelRequire("eJOHy");

var $hX7Ca = parcelRequire("hX7Ca");
const $72d9a29ee2941367$export$7c2be23b3b8e5093 = 200;
const $72d9a29ee2941367$export$1e4bd5ddbd3e82e5 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $72d9a29ee2941367$var$onShowPopup = ({ contentRef: contentRef, onPopupToggle: onPopupToggle, shouldGetParentRef: shouldGetParentRef })=>{
    const elementWithTextContent = contentRef?.current ? (0, $hX7Ca.getClosestTextElement)(shouldGetParentRef ? contentRef?.current.parentElement : contentRef?.current) : undefined;
    const clientWidth = elementWithTextContent?.clientWidth || 0;
    const scrollWidth = elementWithTextContent?.scrollWidth || 0;
    const isClamped = (0, $hX7Ca.checkIsClamped)(elementWithTextContent);
    // If contentRef is not provided then the popover should always be visible on hover.
    if (!contentRef?.current || scrollWidth > clientWidth || isClamped) onPopupToggle(true);
};
const $72d9a29ee2941367$export$793f17026bd5d1b4 = ({ contentRef: contentRef, onPreload: onPreload, onPopupToggle: onPopupToggle, onLoad: onLoad, shouldGetParentRef: shouldGetParentRef, onHoverOut: onHoverOut, onChangePopupState: onChangePopupState })=>{
    const handlers = (0, $eJOHy.useContext)($72d9a29ee2941367$export$1e4bd5ddbd3e82e5);
    const onHidePopup = (0, $eJOHy.useCallback)(()=>{
        onPopupToggle(false);
    }, [
        onPopupToggle
    ]);
    if (!handlers) return;
    if (handlers.onPreload) // eslint-disable-next-line react-hooks/react-compiler
    handlers.onPreload.current = onPreload || null;
    if (handlers.onLoad) handlers.onLoad.current = onLoad || null;
    if (handlers.onChangePopupState) handlers.onChangePopupState.current = onChangePopupState || null;
    handlers.onShowPopup.current = ()=>$72d9a29ee2941367$var$onShowPopup({
            contentRef: contentRef,
            onPopupToggle: onPopupToggle,
            shouldGetParentRef: shouldGetParentRef
        });
    handlers.onHidePopup.current = ()=>{
        onHidePopup();
        onHoverOut?.();
    };
};
const $72d9a29ee2941367$export$d427879c5002c548 = ({ children: children, delay: delay = $72d9a29ee2941367$export$7c2be23b3b8e5093 })=>{
    const hoverTimeoutRef = (0, $eJOHy.useRef)(null);
    const onPreloadRef = (0, $eJOHy.useRef)(null);
    const onLoadRef = (0, $eJOHy.useRef)(null);
    const onShowPopupRef = (0, $eJOHy.useRef)(null);
    const onHidePopupRef = (0, $eJOHy.useRef)(null);
    const onChangePopupStateRef = (0, $eJOHy.useRef)(null);
    const cleanUpTimeout = (0, $eJOHy.useCallback)(()=>{
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if (hoverTimeoutRef.current) return;
        onPreloadRef.current?.();
        hoverTimeoutRef.current = setTimeout(()=>{
            onLoadRef.current?.();
            onShowPopupRef.current?.();
        }, delay);
    }, [
        delay
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        cleanUpTimeout();
        onHidePopupRef.current?.();
    }, [
        cleanUpTimeout
    ]);
    const handleToggle = (0, $eJOHy.useCallback)(()=>{
        onLoadRef.current?.();
        onChangePopupStateRef.current?.();
    }, []);
    const handers = (0, $eJOHy.useMemo)(()=>({
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            onPreload: onPreloadRef,
            onLoad: onLoadRef,
            onShowPopup: onShowPopupRef,
            onHidePopup: onHidePopupRef,
            handleToggle: handleToggle,
            onChangePopupState: onChangePopupStateRef
        }), [
        handleMouseEnter,
        handleMouseLeave,
        handleToggle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return cleanUpTimeout;
    }, [
        cleanUpTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($72d9a29ee2941367$export$1e4bd5ddbd3e82e5.Provider, {
        value: handers
    }, children);
};
const $72d9a29ee2941367$export$5ac0a932365e8caa = ()=>{
    const handlers = (0, $eJOHy.useContext)($72d9a29ee2941367$export$1e4bd5ddbd3e82e5);
    if (handlers === null) throw new Error('useCellHoverHandlers must be used within a CellHoverProvider');
    return handlers;
};

});

parcelRegister("9Mapt", function(module, exports) {
$parcel$export(module.exports, "HoverPopoverWithContext", () => $356133080582a054$export$34da0ae4eaeabe16);
$parcel$export(module.exports, "CellHoverRenderer", () => $356133080582a054$export$15e55631babd0ec5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $kJsb4 = parcelRequire("kJsb4");

var $5vQ2T = parcelRequire("5vQ2T");

var $4EKqI = parcelRequire("4EKqI");

var $ibVOD = parcelRequire("ibVOD");


var $9CHGV = parcelRequire("9CHGV");
const $356133080582a054$var$PopupComponentInternal = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: popupChildren, isReferenceHidden: isReferenceHidden, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, ...restProps }, ref)=>{
    const { isFixedWidth: isFixedWidth, isInteractive: isInteractive, setIsPopupOpen: setIsPopupOpen } = (0, $eJOHy.useContext)($356133080582a054$var$HoverPopoverContext);
    return !isReferenceHidden ? /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>isInteractive && setIsPopupOpen(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>isInteractive && setIsPopupOpen(false),
        ...restProps,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1mouu2gc _j7hq1ida _tzy4idpf _5sag1yx9 _1pgl1v42 _1o51q7pw _p12f1mjv _lcxvglyw",
            "_1pbycs5v",
            isInteractive && "_1moux0bf _1rjcutpp _lcxv1wug",
            isFixedWidth && "_1bsb1mjv"
        ])
    }, popupChildren) : null;
});
const $356133080582a054$var$HoverPopoverContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isFixedWidth: false,
    isInteractive: false,
    setIsPopupOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $356133080582a054$var$HoverPopoverComponent = ({ content: content, children: children, contentRef: contentRef, entryPointActions: entryPointActions, isInteractive: isInteractive, shouldGetParentRef: shouldGetParentRef, isFixedWidth: isFixedWidth, onHoverOut: onHoverOut, hidePopover: hidePopover, analyticsAttributes: analyticsAttributes })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const togglePopup = (0, $eJOHy.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        isPopupOpen
    ]);
    (0, $ibVOD.useCellHoverCallbacks)({
        contentRef: contentRef,
        onPreload: entryPointActions?.preload,
        onLoad: entryPointActions?.load,
        onPopupToggle: setIsPopupOpen,
        shouldGetParentRef: shouldGetParentRef,
        onHoverOut: onHoverOut,
        onChangePopupState: togglePopup
    });
    if (content && isPopupOpen) return /*#__PURE__*/ $eJOHy.createElement((0, $4EKqI.default), {
        name: "jira-list-hover-popover",
        mode: "list"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira-list-hover-popover",
        packageName: (0, $05f3bc586d738eb3$export$b8b9d90f9e5bd72b),
        teamName: (0, $05f3bc586d738eb3$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ $eJOHy.createElement($356133080582a054$var$HoverPopoverContext.Provider, {
        value: {
            isFixedWidth: isFixedWidth,
            isInteractive: isInteractive,
            setIsPopupOpen: setIsPopupOpen
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, $kJsb4.Popup), {
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ update: update })=>/*#__PURE__*/ $eJOHy.createElement((0, $9CHGV.PopupContent), {
                isInteractive: isInteractive,
                update: update,
                analyticsAttributes: analyticsAttributes
            }, content),
        popupComponent: $356133080582a054$var$PopupComponentInternal,
        autoFocus: false,
        isOpen: !hidePopover && isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        trigger: ({ ref: ref })=>children({
                ref: ref,
                ariaExpanded: isPopupOpen
            }),
        placement: "bottom-start"
    }))));
    return typeof children === 'function' ? children({
        ref: null
    }) : children;
};
const $356133080582a054$export$34da0ae4eaeabe16 = /*#__PURE__*/ (0, $eJOHy.memo)($356133080582a054$var$HoverPopoverComponent);
const $356133080582a054$export$15e55631babd0ec5 = ({ children: children })=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleToggle: handleToggle } = (0, $ibVOD.useCellHoverHandlers)();
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.code === 'Space' || event.code === 'Enter') {
            // Prevent default is needed to prevent the table from scrolling down on space/enter press
            event.preventDefault();
            handleToggle();
        }
    }, [
        handleToggle
    ]);
    return children({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onKeyDown: handleKeyDown
    });
};
const $356133080582a054$var$fadeIn = null;
const $356133080582a054$var$interactiveStyles = null;
const $356133080582a054$var$containerStyles = null;
const $356133080582a054$var$renderToParentStyles = null;
const $356133080582a054$var$fixedWidthStyles = null;

});

parcelRegister("gybMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $03a1c6c7f1e563da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");
const $03a1c6c7f1e563da$var$Link = ({ onClick: onClick, wordBreak: wordBreak = true, shouldDisplayStrikethrough: shouldDisplayStrikethrough = false, ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'listWithPopup');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03a1c6c7f1e563da$var$StyledLink, {
        wordBreak: wordBreak,
        shouldDisplayStrikethrough: shouldDisplayStrikethrough,
        ...rest,
        onClick: onClickWithAnalytics,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
};
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $03a1c6c7f1e563da$var$PropFilteredLink = ({ wordBreak: wordBreak, shouldDisplayStrikethrough: shouldDisplayStrikethrough, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), rest);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03a1c6c7f1e563da$var$StyledLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $03a1c6c7f1e563da$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.wordBreak && "_1nmz1hna",
            __cmplp.shouldDisplayStrikethrough && "_4bfu1r81 _1hms1cog _ajmmvv82",
            __cmplp.className
        ])
    });
});
var $03a1c6c7f1e563da$export$2e2bcd8739ae039 = $03a1c6c7f1e563da$var$Link;

});



parcelRegister("7hEnC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d49520d2b77e8f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4d49520d2b77e8f2$var$messages = (0, $7qGN1.defineMessages)({
    noLabel: {
        "id": "issue-table-grouping.group-row.group-header.label-group-header.no-label",
        "defaultMessage": "No labels"
    }
});
var $4d49520d2b77e8f2$export$2e2bcd8739ae039 = $4d49520d2b77e8f2$var$messages;

});


parcelRegister("9jwn7", function(module, exports) {
$parcel$export(module.exports, "IssueTypeGroupHeader", () => $8f5648bc49997554$export$dccf116a86b73229);

var $akdSC = parcelRequire("akdSC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $8wyVH = parcelRequire("8wyVH");
const $8f5648bc49997554$export$dccf116a86b73229 = ({ issueTypeGroupHeader: issueTypeGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $akdSC.default), issueTypeGroupHeader);
    const issueType = data?.issueTypes[0]; // note: we are expecting only one issue type per group
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueType?.avatar?.small && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-200, 16px)",
        src: issueType.avatar.small,
        alt: issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, issueType?.name));
};

});
parcelRegister("akdSC", function(module, exports) {
$parcel$export(module.exports, "default", () => $80c7ba40eab2e34f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c3f3a0dba8222a1de29670a2c85f820>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80c7ba40eab2e34f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTypeGroupHeader",
    "selections": [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraJqlIssueTypeFieldValue"
};
$80c7ba40eab2e34f$var$node.hash = "c41ff0fec0474c5d560ad8876417768f";
var $80c7ba40eab2e34f$export$2e2bcd8739ae039 = $80c7ba40eab2e34f$var$node;

});


parcelRegister("aLKjs", function(module, exports) {
$parcel$export(module.exports, "GroupPickerGroupHeader", () => $6f95f7a561762d92$export$310ade6d89d65120);

var $bAMQR = parcelRequire("bAMQR");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6w3tC = parcelRequire("6w3tC");

var $1wrYf = parcelRequire("1wrYf");
const $6f95f7a561762d92$export$310ade6d89d65120 = ({ groupPickerGroupHeader: groupPickerGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $bAMQR.default), groupPickerGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.group?.name,
        noValueText: formatMessage((0, $1wrYf.default).noGroup)
    });
};

});
parcelRegister("bAMQR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eec429b61aee321$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa2503a8ad6b351d6c052591d78c4b50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7eec429b61aee321$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GroupPickerGroupHeader",
    "selections": [
        {
            "concreteType": "JiraGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlGroupFieldValue"
};
$7eec429b61aee321$var$node.hash = "08fb8e73749f71d49ccd999fc7f864e0";
var $7eec429b61aee321$export$2e2bcd8739ae039 = $7eec429b61aee321$var$node;

});

parcelRegister("6w3tC", function(module, exports) {
$parcel$export(module.exports, "TextGroupHeaderContent", () => $258f99b95fda91d0$export$902945573f65d5a4);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");
const $258f99b95fda91d0$export$902945573f65d5a4 = ({ text: text, noValueText: noValueText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, text ?? noValueText);
};

});

parcelRegister("1wrYf", function(module, exports) {
$parcel$export(module.exports, "default", () => $cee3bd62c7572fb0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cee3bd62c7572fb0$var$messages = (0, $7qGN1.defineMessages)({
    noGroup: {
        "id": "issue-table-grouping.group-row.group-header.group-picker-group-header.no-group",
        "defaultMessage": "No group"
    }
});
var $cee3bd62c7572fb0$export$2e2bcd8739ae039 = $cee3bd62c7572fb0$var$messages;

});


parcelRegister("immik", function(module, exports) {
$parcel$export(module.exports, "OptionGroupHeader", () => $6be13b415b00c9d9$export$100e8d6eda7c9ebc);

var $1RGmq = parcelRequire("1RGmq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3mZMJ = parcelRequire("3mZMJ");

var $6w3tC = parcelRequire("6w3tC");

var $aIng6 = parcelRequire("aIng6");

var $3QRBm = parcelRequire("3QRBm");
const $6be13b415b00c9d9$export$100e8d6eda7c9ebc = ({ optionGroupHeader: optionGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $1RGmq.default), optionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return fieldType === (0, $3mZMJ.RADIO_BUTTONS_CF_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.option?.value,
        noValueText: formatMessage((0, $3QRBm.default).noOption)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.displayName || data?.option?.value,
        noValueText: formatMessage((0, $3QRBm.default).noOption)
    });
};

});
parcelRegister("1RGmq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd05ea348248a358$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1f82cc0fae6280d93f9065afb2bf7c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bd05ea348248a358$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OptionGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraJqlOptionFieldValue"
};
$bd05ea348248a358$var$node.hash = "c4db465dc3b0a691a209bbf2635a74ed";
var $bd05ea348248a358$export$2e2bcd8739ae039 = $bd05ea348248a358$var$node;

});

parcelRegister("3QRBm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7965b3ff7c3d2b69$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7965b3ff7c3d2b69$var$messages = (0, $7qGN1.defineMessages)({
    noOption: {
        "id": "issue-table-grouping.group-row.group-header.option-group-header.no-option",
        "defaultMessage": "No value"
    }
});
var $7965b3ff7c3d2b69$export$2e2bcd8739ae039 = $7965b3ff7c3d2b69$var$messages;

});


parcelRegister("2mFVu", function(module, exports) {
$parcel$export(module.exports, "VersionGroupHeader", () => $82a52f5cd88544fa$export$e72e2cdf797c0426);

var $c7uBv = parcelRequire("c7uBv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3mZMJ = parcelRequire("3mZMJ");

var $6w3tC = parcelRequire("6w3tC");

var $aIng6 = parcelRequire("aIng6");

var $4z91V = parcelRequire("4z91V");
const $82a52f5cd88544fa$export$e72e2cdf797c0426 = ({ versionGroupHeader: versionGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $c7uBv.default), versionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return fieldType === (0, $3mZMJ.VERSION_CF_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.version?.name,
        noValueText: formatMessage((0, $4z91V.default).noVersion)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIng6.TagGroupHeaderContent), {
        text: data?.displayName || data?.version?.name,
        noValueText: formatMessage((0, $4z91V.default).noVersion)
    });
};

});
parcelRegister("c7uBv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bd17ee8ca09dcd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75233030ab85ba580c52460467caeeb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5bd17ee8ca09dcd6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "VersionGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlVersionFieldValue"
};
$5bd17ee8ca09dcd6$var$node.hash = "f5808a1ed0cb4468ba0571f25b813167";
var $5bd17ee8ca09dcd6$export$2e2bcd8739ae039 = $5bd17ee8ca09dcd6$var$node;

});

parcelRegister("4z91V", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc58f19fb4ae2242$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fc58f19fb4ae2242$var$messages = (0, $7qGN1.defineMessages)({
    noVersion: {
        "id": "issue-table-grouping.group-row.group-header.version-group-header.no-version",
        "defaultMessage": "No version"
    }
});
var $fc58f19fb4ae2242$export$2e2bcd8739ae039 = $fc58f19fb4ae2242$var$messages;

});


parcelRegister("4zhkx", function(module, exports) {
$parcel$export(module.exports, "UserGroupHeader", () => $b02527eca9c682fb$export$6a5bbfbd8cc048b3);

var $gqtrv = parcelRequire("gqtrv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $4UiGa = parcelRequire("4UiGa");

var $3mZMJ = parcelRequire("3mZMJ");

var $8vugl = parcelRequire("8vugl");
const $b02527eca9c682fb$export$6a5bbfbd8cc048b3 = ({ userGroupHeader: userGroupHeader, fieldType: fieldType })=>{
    const data = (0, $j4oe4.useFragment)((0, $gqtrv.default), userGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let noValueText;
    switch(fieldType){
        case 0, $3mZMJ.ASSIGNEE_TYPE:
            noValueText = formatMessage((0, $8vugl.default).unassignedDisplayName);
            break;
        case 0, $3mZMJ.USER_CF_TYPE:
            noValueText = formatMessage((0, $8vugl.default).noUserDisplayName);
            break;
        case 0, $3mZMJ.REPORTER_TYPE:
            noValueText = formatMessage((0, $8vugl.default).anonymousDisplayName);
            break;
        default:
            noValueText = null;
    }
    const displayName = data?.displayName ?? noValueText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4UiGa.AvatarLite), {
        avatarUrl: data.user?.picture
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, displayName));
};

});
parcelRegister("gqtrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b2664b03918e093$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eea95fc344aef76f38578e37f8ff9a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b2664b03918e093$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        }
    ],
    "type": "JiraJqlUserFieldValue"
};
$7b2664b03918e093$var$node.hash = "08198f06ef3106202be1a9d0e7e7aeea";
var $7b2664b03918e093$export$2e2bcd8739ae039 = $7b2664b03918e093$var$node;

});

parcelRegister("4UiGa", function(module, exports) {
$parcel$export(module.exports, "AvatarLite", () => $cb3b12b2e97c8824$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $cb3b12b2e97c8824$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3b12b2e97c8824$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $awdRS.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _12ji1r31 _1qu2glyw _12y3idpf _1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _80om1kw7 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.isHighlighted ? "_16qsa9gh" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $cb3b12b2e97c8824$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $cb3b12b2e97c8824$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eJOHy.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($cb3b12b2e97c8824$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cb3b12b2e97c8824$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("8vugl", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9aa0597a71f459f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f9aa0597a71f459f$var$messages = (0, $7qGN1.defineMessages)({
    unassignedDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.assignee-group-header.unassigned-display-name",
        "defaultMessage": "Unassigned"
    },
    noUserDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.user-group-header.no-user-display-name",
        "defaultMessage": "No user"
    },
    anonymousDisplayName: {
        "id": "issue-table-grouping.group-row.group-header.user-group-header.anonymous-display-name",
        "defaultMessage": "Anonymous"
    }
});
var $f9aa0597a71f459f$export$2e2bcd8739ae039 = $f9aa0597a71f459f$var$messages;

});


parcelRegister("e0hmq", function(module, exports) {
$parcel$export(module.exports, "ResolutionGroupHeader", () => $6217e59746f60130$export$d4278b92a1d7dd0c);

var $84BJz = parcelRequire("84BJz");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6w3tC = parcelRequire("6w3tC");

var $gA8Ur = parcelRequire("gA8Ur");
const $6217e59746f60130$export$d4278b92a1d7dd0c = ({ resolutionGroupHeader: resolutionGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $84BJz.default), resolutionGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6w3tC.TextGroupHeaderContent), {
        text: data?.displayName || data?.resolution?.name || data?.resolution?.id,
        noValueText: formatMessage((0, $gA8Ur.default).noResolution)
    });
};

});
parcelRegister("84BJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b53f4b14ffb399bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f28a6fec148280a5485288e085be8006>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b53f4b14ffb399bd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ResolutionGroupHeader",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraJqlResolutionFieldValue"
};
$b53f4b14ffb399bd$var$node.hash = "69c557634138dcd08dae628cc8eb1510";
var $b53f4b14ffb399bd$export$2e2bcd8739ae039 = $b53f4b14ffb399bd$var$node;

});

parcelRegister("gA8Ur", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ffefe9700680e82$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9ffefe9700680e82$var$messages = (0, $7qGN1.defineMessages)({
    noResolution: {
        "id": "issue-table-grouping.group-row.group-header.resolution-group-header.no-resolution",
        "defaultMessage": "No resolution"
    }
});
var $9ffefe9700680e82$export$2e2bcd8739ae039 = $9ffefe9700680e82$var$messages;

});


parcelRegister("4z3Ld", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectGroupHeader", () => $9206c2bdf85db90f$export$86103fc11f7604c4);

var $fMKAp = parcelRequire("fMKAp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5NtHI = parcelRequire("5NtHI");

var $lRq8t = parcelRequire("lRq8t");

var $g0jL2 = parcelRequire("g0jL2");

var $fRm4z = parcelRequire("fRm4z");

var $bCxCS = parcelRequire("bCxCS");
const $9206c2bdf85db90f$export$86103fc11f7604c4 = ({ atlasProjectGroupHeader: atlasProjectGroupHeader })=>{
    const data = (0, $j4oe4.useFragment)((0, $fMKAp.default), atlasProjectGroupHeader);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructAtlasProjectUrl = (0, $fRm4z.useProjectUrlConstructor)();
    if (data?.project) {
        const url = constructAtlasProjectUrl({
            ari: data?.project?.id ?? '',
            projectKey: data?.project?.key ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g0jL2.SimpleInlineSmartLink), {
            url: url,
            metadata: [
                {
                    name: (0, $5NtHI.ElementName).State
                }
            ],
            projectAri: data?.project?.id ?? '',
            isPrivate: data?.project?.privateProject ?? false,
            initialHasNoAccess: data?.project?.hasPermission === false
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9206c2bdf85db90f$var$atlasProjectTextStyles
    }, formatMessage((0, $bCxCS.default).noAtlasProjectDisplayName));
};
const $9206c2bdf85db90f$var$atlasProjectTextStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("fMKAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cc380c2a58fbd6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33009b3a1b84bf39ad85f1881d3611e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4cc380c2a58fbd6a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AtlasProjectGroupHeader",
    "selections": [
        {
            "concreteType": "JiraTownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "privateProject"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasPermission"
                }
            ]
        }
    ],
    "type": "JiraJqlTownsquareProjectFieldValue"
};
$4cc380c2a58fbd6a$var$node.hash = "6b7be7742a1e6e71932de9700288d473";
var $4cc380c2a58fbd6a$export$2e2bcd8739ae039 = $4cc380c2a58fbd6a$var$node;

});

parcelRegister("5NtHI", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc2e49eaf9e6df05$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc2e49eaf9e6df05$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc2e49eaf9e6df05$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc2e49eaf9e6df05$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc2e49eaf9e6df05$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc2e49eaf9e6df05$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc2e49eaf9e6df05$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc2e49eaf9e6df05$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc2e49eaf9e6df05$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc2e49eaf9e6df05$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc2e49eaf9e6df05$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc2e49eaf9e6df05$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc2e49eaf9e6df05$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc2e49eaf9e6df05$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc2e49eaf9e6df05$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc2e49eaf9e6df05$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc2e49eaf9e6df05$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc2e49eaf9e6df05$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804);
const $fc2e49eaf9e6df05$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc2e49eaf9e6df05$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc2e49eaf9e6df05$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc2e49eaf9e6df05$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc2e49eaf9e6df05$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc2e49eaf9e6df05$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc2e49eaf9e6df05$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc2e49eaf9e6df05$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc2e49eaf9e6df05$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc2e49eaf9e6df05$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc2e49eaf9e6df05$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc2e49eaf9e6df05$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc2e49eaf9e6df05$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc2e49eaf9e6df05$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc2e49eaf9e6df05$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc2e49eaf9e6df05$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc2e49eaf9e6df05$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc2e49eaf9e6df05$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("g0jL2", function(module, exports) {
$parcel$export(module.exports, "SimpleInlineSmartLink", () => $8ad4122ee3943dbc$export$e918b96127f4d56b);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $jstc7 = parcelRequire("jstc7");

var $g9Vr6 = parcelRequire("g9Vr6");

var $e6YEs = parcelRequire("e6YEs");

var $8rl2J = parcelRequire("8rl2J");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cSWVe = parcelRequire("cSWVe");

var $aJTdT = parcelRequire("aJTdT");

var $3Gg8D = parcelRequire("3Gg8D");

var $jMHWF = parcelRequire("jMHWF");

var $hUGaG = parcelRequire("hUGaG");
const $8ad4122ee3943dbc$export$e918b96127f4d56b = ({ initialHasNoAccess: initialHasNoAccess = false, showNoAccessPopup: showNoAccessPopup = true, isPrivate: isPrivate = false, onHandleNoAccess: onHandleNoAccess, ...props })=>{
    const [hasNoAccess, setHasNoAccess] = (0, $eJOHy.useState)(initialHasNoAccess || isPrivate);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleError = (0, $eJOHy.useCallback)((arg)=>{
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasProjectSmartLink failed', {
            errorStatus: arg.status,
            isPrivate: isPrivate,
            initialHasNoAccess: initialHasNoAccess,
            hasNoAccess: hasNoAccess
        });
        if (arg?.status === 'forbidden' || arg?.status === 'errored') {
            setHasNoAccess(true);
            onHandleNoAccess?.();
        }
    }, [
        createAnalyticsEvent,
        isPrivate,
        initialHasNoAccess,
        onHandleNoAccess,
        hasNoAccess
    ]);
    const handleResolve = (0, $eJOHy.useCallback)(()=>{
        setHasNoAccess(false);
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasProjectRestrictedSmartLink resolved', {
            isPrivate: isPrivate,
            initialHasNoAccess: initialHasNoAccess
        });
    }, [
        createAnalyticsEvent,
        isPrivate,
        initialHasNoAccess
    ]);
    if (hasNoAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ad4122ee3943dbc$var$RestrictedSmartLink, {
        ...props,
        initialHasNoAccess: initialHasNoAccess,
        showNoAccessPopup: showNoAccessPopup,
        isPrivate: isPrivate,
        onResolve: handleResolve,
        onError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hUGaG.InlineSmartLink), {
        ...props,
        onError: handleError
    });
};
const $8ad4122ee3943dbc$var$RestrictedSmartLink = ({ initialHasNoAccess: initialHasNoAccess, projectAri: projectAri, showNoAccessPopup: showNoAccessPopup, isPrivate: isPrivate, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderNoAccessSmartLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hUGaG.InlineSmartLink), {
        ...props,
        text: formatMessage((0, $aJTdT.default).restrictedProject),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedIcon), null),
        hideRetry: true,
        showHoverPreview: false
    });
    if (!showNoAccessPopup) return renderNoAccessSmartLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ad4122ee3943dbc$var$HoverPopupIfRestricted, {
        projectAri: projectAri,
        // only show private project popup if the project is private and initially the user has site access
        showPrivateProject: isPrivate && !initialHasNoAccess
    }, renderNoAccessSmartLink);
};
const $8ad4122ee3943dbc$var$HoverPopupIfRestricted = ({ projectAri: projectAri, showPrivateProject: showPrivateProject, children: children })=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const cloudId = projectAri ? (0, $8rl2J.TownsquareProjectAri).parse(projectAri).siteId : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleVisibilityChange = (0, $eJOHy.useCallback)((isVisible)=>{
        if (isVisible) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'atlasProjectAccessPopup viewed', {
            showPrivateProject: showPrivateProject
        });
    }, [
        createAnalyticsEvent,
        showPrivateProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Gg8D.HoverPopup), {
        renderContent: showPrivateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMHWF.PrivateProjectPopup), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jstc7.ProjectsAccess), {
            orgId: orgId,
            accountId: accountId ?? undefined,
            requestAccessSimplifiedUI: false,
            cloudId: cloudId
        }),
        onVisibilityChange: handleVisibilityChange
    }, children);
};

});
parcelRegister("jstc7", function(module, exports) {
$parcel$export(module.exports, "ProjectsAccess", () => $20ccd5e606873e3f$export$81863c54cac77212);
/* ProjectsAccess.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6X7AJ = parcelRequire("6X7AJ");
var $dNnxZ = parcelRequire("dNnxZ");

var $lRq8t = parcelRequire("lRq8t");

var $lc0OY = parcelRequire("lc0OY");
var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $dLR8J = parcelRequire("dLR8J");

var $8RHPx = parcelRequire("8RHPx");

var $eGjjZ = parcelRequire("eGjjZ");

var $6aXz6 = parcelRequire("6aXz6");

var $3uHC5 = parcelRequire("3uHC5");

var $gwjUU = parcelRequire("gwjUU");

var $gKJfP = parcelRequire("gKJfP");
const $20ccd5e606873e3f$var$styles = {
    container: "_1bsb1mjv _19bv1ejb _u5f31ejb _ca0qpxbi _n3tdpxbi"
};
const $20ccd5e606873e3f$var$getTownsquareUrl = ({ orgId: orgId, cloudId: cloudId })=>`https://${(0, $8RHPx.getATLContextDomain)('admin')}/o/${orgId}/townsquare?cloudId=${cloudId}&isSignup=true`;
const $20ccd5e606873e3f$export$81863c54cac77212 = ({ accountId: accountId, cloudId: cloudId, orgId: orgId, product: product, requestAccessSimplifiedUI: requestAccessSimplifiedUI = true })=>{
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isOrgAdmin: isOrgAdmin, loading: loading, hasErrorOccurred: hasErrorOccurred } = (0, $gwjUU.useOrgAdminPermission)(orgId, accountId);
    const onRequestAccess = (0, $eJOHy.useCallback)(async ()=>{
        if (crossFlow.isEnabled) await crossFlow.api.open({
            journey: (0, $6X7AJ.Journeys).GET_STARTED,
            sourceComponent: 'project-picker',
            sourceContext: product ?? 'jira',
            targetProduct: (0, $dNnxZ.Targets).ATLAS
        });
    }, [
        crossFlow,
        product
    ]);
    if (hasErrorOccurred) throw new Error('Error checking org admin permissions');
    if (loading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
        name: (0, $eGjjZ.UFOSegmentNames).ProjectAdminAccessCheckLoading,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uHC5.ProjectPickerLoadingSkeleton), {
            testId: "projects-access-loading"
        })
    });
    if (isOrgAdmin) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6aXz6.EmptyState), {
        heading: formatMessage((0, $gKJfP.messages).genericPermissionsStateHeading),
        description: formatMessage((0, $gKJfP.messages).turnOnProjectsDescription),
        buttonLabel: formatMessage((0, $gKJfP.messages).turnOnProjectsButtonLabel),
        onClick: ()=>{
            if (orgId && cloudId) window.open($20ccd5e606873e3f$var$getTownsquareUrl({
                orgId: orgId,
                cloudId: cloudId
            }), '_blank');
        }
    });
    if (requestAccessSimplifiedUI) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $20ccd5e606873e3f$var$styles.container,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.100",
            children: [
                formatMessage((0, $gKJfP.messages).requestAccessDescription),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                    href: "#",
                    onClick: onRequestAccess,
                    children: formatMessage((0, $gKJfP.messages).requestAccessLink)
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6aXz6.EmptyState), {
        heading: formatMessage((0, $gKJfP.messages).requestAccessHeading),
        description: formatMessage((0, $gKJfP.messages).requestAccessFullDescription),
        buttonLabel: formatMessage((0, $gKJfP.messages).requestAccessLink),
        onClick: onRequestAccess
    });
};

});
parcelRegister("eGjjZ", function(module, exports) {
$parcel$export(module.exports, "UFOSegmentNames", () => $0f9b5cb48ea7f7e2$export$a239e9f23c560e05);
const $0f9b5cb48ea7f7e2$export$a239e9f23c560e05 = {
    ProjectPicker: 'townsquare-project-picker',
    ProjectPickerLoading: 'townsquare-project-picker-loading',
    RecentProjectsLoading: 'townsquare-project-picker-recent-projects-loading',
    ProjectAdminAccessCheckLoading: 'townsquare-project-admin-access-check-loading'
};

});

parcelRegister("6aXz6", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $b41bd195e70f12e8$export$fddf379e22a74b00);
/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5CSKW = parcelRequire("5CSKW");

var $806LH = parcelRequire("806LH");

var $8wyVH = parcelRequire("8wyVH");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $2cAMY = parcelRequire("2cAMY");

var $8EmRQ = parcelRequire("8EmRQ");
const $b41bd195e70f12e8$var$styles = {
    container: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q _1bsb1gwv",
    projectCardImage: "_1e0c1txw _1bsb1wdt _c71l1lit"
};
const $b41bd195e70f12e8$export$fddf379e22a74b00 = ({ heading: heading, description: description, buttonLabel: buttonLabel, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $b41bd195e70f12e8$var$styles.container,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.300",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $b41bd195e70f12e8$var$styles.projectCardImage,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cAMY))),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: "small",
                    children: heading || formatMessage((0, $8EmRQ.messages).genericEmptyStateHeading)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text.subtle",
                    align: "center",
                    size: "medium",
                    children: description
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    appearance: "primary",
                    onClick: onClick,
                    children: buttonLabel || formatMessage((0, $8EmRQ.messages).createProjectButtonLabel)
                })
            ]
        })
    });
};

});
parcelRegister("2cAMY", function(module, exports) {
module.exports = new URL("ProductCardImage.40570c61.png", import.meta.url).toString();

});

parcelRegister("8EmRQ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $96df03f7aaf6c82a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $96df03f7aaf6c82a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    genericEmptyStateHeading: {
        id: 'project-picker.empty-state.generic-heading',
        defaultMessage: 'Get started with projects',
        description: 'Heading displayed on picker empty state when there are no projects available or projects are not turned on'
    },
    createProjectButtonLabel: {
        id: 'project-picker.empty-state.create-project-button-label',
        defaultMessage: 'Create project',
        description: 'Label for button to create a new project'
    }
});

});


parcelRegister("3uHC5", function(module, exports) {
$parcel$export(module.exports, "ProjectPickerLoadingSkeleton", () => $5bb839bf86555fad$export$51ac0a45c0e1cc2d);
/* ProjectPickerLoadingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $jjS5D = parcelRequire("jjS5D");

var $cABXr = parcelRequire("cABXr");

var $in42L = parcelRequire("in42L");
const $5bb839bf86555fad$var$styles = {
    headerSkeleton: "_otyr12x7 _ca0qutpp _u5f3utpp _19bvutpp",
    createButtonSkeleton: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $5bb839bf86555fad$export$c698677b82bddd68 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        columnGap: "space.100",
        alignItems: "center",
        xcss: $5bb839bf86555fad$var$styles.createButtonSkeleton,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                height: "20px",
                width: "20px",
                isShimmering: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                height: "20px",
                width: "120px",
                isShimmering: true
            })
        ]
    });
const $5bb839bf86555fad$export$51ac0a45c0e1cc2d = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cABXr.ProjectPickerLayout), {
        testId: testId,
        createButton: /*#__PURE__*/ (0, $gt9Am.jsx)($5bb839bf86555fad$export$c698677b82bddd68, {}),
        showCreateButton: true,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $5bb839bf86555fad$var$styles.headerSkeleton,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                    height: "15px",
                    width: "140px",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $in42L.ProjectListSkeleton), {
                itemCount: 5
            })
        ]
    });
};

});
parcelRegister("cABXr", function(module, exports) {
$parcel$export(module.exports, "ProjectPickerLayout", () => $f091b1db16c2e463$export$260453b9031bce9d);
/* ProjectPickerLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $ezqmt = parcelRequire("ezqmt");

var $ahaT5 = parcelRequire("ahaT5");
const $f091b1db16c2e463$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1bsb1gwv _bfhk1bhr",
    content: "_n3td12x7",
    title: "_ca0qpxbi _19bvpxbi _u5f3pxbi _n3td12x7",
    titleWithUnlinkButton: "_ca0q12x7",
    createButton: "_x3do7r9e _1bsb1osq _ca0q1b66 _n3td1b66",
    unlinkButton: "_1bsb1osq _ca0q1b66"
};
const $f091b1db16c2e463$export$260453b9031bce9d = ({ title: title, createButton: createButton, children: children, unlinkButton: unlinkButton, testId: testId, showCreateButton: showCreateButton })=>{
    const { onCreateProject: onCreateProject, hasProjectCreateAccess: hasProjectCreateAccess } = (0, $ezqmt.useProjectPicker)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        xcss: $f091b1db16c2e463$var$styles.container,
        testId: testId,
        children: [
            unlinkButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $f091b1db16c2e463$var$styles.unlinkButton,
                children: unlinkButton
            }),
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $k0ahr.cx)($f091b1db16c2e463$var$styles.title, unlinkButton && $f091b1db16c2e463$var$styles.titleWithUnlinkButton),
                role: "heading",
                "aria-level": 6,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text.subtlest",
                    weight: "bold",
                    size: "small",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $f091b1db16c2e463$var$styles.content,
                children: children
            }),
            (hasProjectCreateAccess || showCreateButton) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $f091b1db16c2e463$var$styles.createButton,
                children: createButton ? createButton : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ahaT5.CreateProjectButton), {
                    onClick: onCreateProject
                })
            })
        ]
    });
};

});
parcelRegister("ezqmt", function(module, exports) {
$parcel$export(module.exports, "ProjectPickerContext", () => $776b4ebe50bb91ea$export$43bcce6abe53342f);
$parcel$export(module.exports, "useProjectPicker", () => $776b4ebe50bb91ea$export$8fe735c15635f461);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $776b4ebe50bb91ea$export$1fd8522aeddaccda);

var $eJOHy = parcelRequire("eJOHy");
const $776b4ebe50bb91ea$export$43bcce6abe53342f = /*#__PURE__*/ (0, $eJOHy.createContext)({
    linkedProject: undefined,
    siteIds: [],
    analyticsAttributes: undefined,
    hasProjectCreateAccess: false,
    onCreateProject: undefined,
    onProjectSelect: undefined,
    onProjectUnlink: undefined
});
const $776b4ebe50bb91ea$export$8fe735c15635f461 = ()=>{
    const context = (0, $eJOHy.useContext)($776b4ebe50bb91ea$export$43bcce6abe53342f);
    return {
        linkedProject: context.linkedProject,
        siteIds: context.siteIds,
        hasProjectCreateAccess: context.hasProjectCreateAccess,
        onCreateProject: context.onCreateProject,
        onProjectSelect: context.onProjectSelect,
        onProjectUnlink: context.onProjectUnlink
    };
};
const $776b4ebe50bb91ea$export$1fd8522aeddaccda = ()=>{
    const context = (0, $eJOHy.useContext)($776b4ebe50bb91ea$export$43bcce6abe53342f);
    return context.analyticsAttributes;
};

});

parcelRegister("ahaT5", function(module, exports) {
$parcel$export(module.exports, "CreateProjectButton", () => $2e137bea86c1158b$export$e6ababadbbc5e958);
/* CreateProjectButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dcLzM = parcelRequire("dcLzM");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $ikkcZ = parcelRequire("ikkcZ");

var $j6ecc = parcelRequire("j6ecc");
const $2e137bea86c1158b$var$styles = {
    createButton: "_kqswh2mm _1bsb1osq _19bvutpp _u5f3utpp _ca0q12x7 _n3td12x7 _bfhk1bhr _1n1jcgz9 _1kt9b3bt _1cs8stnw _qnecze3t _1aukze3t _19woze3t _1mp4yh40 _18oh15vq _pgk1ewfl _olafewfl _1mg8ewfl _jomr166n _mizu1r31 _ra3xglyw _128m1o36 _irr3166n _1di61dty",
    iconWrapper: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o"
};
const $2e137bea86c1158b$export$e6ababadbbc5e958 = ({ onClick: onClick, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ikkcZ.useFireAnalyticEvent)();
    const handleClick = (...onClickArgs)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'townsquareProjectPickerCreateProjectButton'
        });
        onClick?.(...onClickArgs);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: $2e137bea86c1158b$var$styles.createButton,
        onClick: handleClick,
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $2e137bea86c1158b$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        label: "",
                        spacing: "none",
                        color: "var(--ds-icon)"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    children: formatMessage((0, $j6ecc.messages).createProjectButtonLabel)
                })
            ]
        })
    });
};

});
parcelRegister("ikkcZ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_TAGS", () => $3dd4eb5dca70c07c$export$5c5dde904519fd9b);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3dd4eb5dca70c07c$export$85183a312807388d);
$parcel$export(module.exports, "useFireAnalyticEvent", () => $3dd4eb5dca70c07c$export$2ed04b34b7f5fc7f);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $ezqmt = parcelRequire("ezqmt");
const $3dd4eb5dca70c07c$export$5c5dde904519fd9b = [
    'townsquare'
];
const $3dd4eb5dca70c07c$export$85183a312807388d = 'atlas';
const $3dd4eb5dca70c07c$export$2ed04b34b7f5fc7f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const baseAnalyticsAttributes = (0, $ezqmt.useAnalyticsAttributes)();
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)(({ analyticsAttributes: analyticsAttributes, eventType: eventType, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: eventType,
            tags: $3dd4eb5dca70c07c$export$5c5dde904519fd9b,
            attributes: {
                ...analyticsAttributes,
                ...baseAnalyticsAttributes
            }
        });
        analyticsEvent.fire($3dd4eb5dca70c07c$export$85183a312807388d);
    }, [
        baseAnalyticsAttributes,
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});

parcelRegister("j6ecc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $998672da8795038b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $998672da8795038b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    createProjectButtonLabel: {
        id: 'project-picker.create-project-button-label',
        defaultMessage: 'Create project',
        description: 'Label for the button to create a new project within the project picker'
    }
});

});



parcelRegister("in42L", function(module, exports) {
$parcel$export(module.exports, "ProjectListSkeleton", () => $899e2b64e9a847d0$export$372edd920d1be0da);
/* ProjectListSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $8y9ad = parcelRequire("8y9ad");
const $899e2b64e9a847d0$var$styles = {
    projectItemList: "_ca0q12x7 _u5f3pxbi _19bvpxbi _n3td12x7"
};
const $899e2b64e9a847d0$export$372edd920d1be0da = ({ itemCount: itemCount, space: space = 'space.150', ...stackProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        xcss: $899e2b64e9a847d0$var$styles.projectItemList,
        space: space,
        ...stackProps,
        children: Array.from({
            length: itemCount
        }, (_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8y9ad.ProjectItemSkeleton), {}, index))
    });

});
parcelRegister("8y9ad", function(module, exports) {
$parcel$export(module.exports, "ProjectItemSkeleton", () => $69f4a7cba3f35e0a$export$10720e04af30dc0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $78OnL = parcelRequire("78OnL");

var $jjS5D = parcelRequire("jjS5D");
const $69f4a7cba3f35e0a$export$10720e04af30dc0 = ({ titleLength: titleLength = '270px', subtitleLength: subtitleLength = '100px' })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
            columnGap: "space.100",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                    height: "24px",
                    width: "24px",
                    isShimmering: true
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.050",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                            height: "20px",
                            width: titleLength,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                            height: "16px",
                            width: subtitleLength,
                            isShimmering: true
                        })
                    ]
                })
            ]
        })
    });

});



parcelRegister("gwjUU", function(module, exports) {
$parcel$export(module.exports, "useOrgAdminPermission", () => $13d4e40028079537$export$ce7c8ae41ffe3315);

var $eJOHy = parcelRequire("eJOHy");
const $13d4e40028079537$var$getUserOrgPermissions = async (orgId, userId)=>{
    const data = {
        resourceId: `ari:cloud:platform::org/${orgId}`,
        principalId: `ari:cloud:identity::user/${userId}`,
        permissionId: 'manage-users'
    };
    const response = await fetch('/gateway/api/permissions/permitted', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return (await response.json()).permitted;
};
const $13d4e40028079537$export$ce7c8ae41ffe3315 = (orgId, userId)=>{
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchIsOrgAdmin = (0, $eJOHy.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        setError(null);
        try {
            const permitted = await $13d4e40028079537$var$getUserOrgPermissions(orgId, userId);
            setData(permitted);
        } catch (err) {
            setError(err);
            setData(null);
        } finally{
            setLoading(false);
        }
    }, [
        orgId,
        userId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (orgId && userId) fetchIsOrgAdmin();
    }, [
        orgId,
        userId,
        fetchIsOrgAdmin
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error
    };
};

});

parcelRegister("gKJfP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $395f4f974a592139$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $395f4f974a592139$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    genericPermissionsStateHeading: {
        id: 'project-picker.request-access.generic-heading',
        defaultMessage: 'Get started with projects',
        description: 'Heading displayed on picker when projects are not available in the site or user has not access to projects'
    },
    turnOnProjectsDescription: {
        id: 'project-picker.request-access.turn-on-projects-description',
        defaultMessage: "Link work items to a project for a clearer view of your team\u2019s progress and an easier way to share updates.",
        description: 'Description to turn on projects'
    },
    requestAccessDescription: {
        id: 'project-picker.request-access.request-access-description',
        defaultMessage: 'Ask your admin for access to projects so you can track work and share updates with your team.',
        description: 'Description to request access'
    },
    turnOnProjectsButtonLabel: {
        id: 'project-picker.request-access.turn-on-projects-button-label',
        defaultMessage: 'Turn on projects',
        description: 'Label for button to turn on projects'
    },
    requestAccessLink: {
        id: 'project-picker.request-access.request-access-link',
        defaultMessage: 'Request access',
        description: 'Label for link to request access'
    },
    requestAccessHeading: {
        id: 'project-picker.request-access.restricted-project-heading',
        defaultMessage: 'Get access to the Projects app',
        description: 'Heading displayed on picker when user has no access to the Project App'
    },
    requestAccessFullDescription: {
        id: 'project-picker.request-access.restricted-project-description',
        defaultMessage: "To view and track work in this project, you\u2019ll need access from your admin.",
        description: 'Description displayed on picker when user has no access to the Project App'
    }
});

});


parcelRegister("8rl2J", function(module, exports) {
$parcel$export(module.exports, "TownsquareProjectAri", () => $62512b0c7ae3d4f2$export$41215e8d01921e7d);

var $lURoZ = parcelRequire("lURoZ");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/townsquare/project/manifest.ts
var $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $lURoZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $lURoZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $62512b0c7ae3d4f2$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $62512b0c7ae3d4f2$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
};

});
parcelRegister("lURoZ", function(module, exports) {
$parcel$export(module.exports, "TownsquareProjectAriResourceOwner", () => $ff4840764fbc83c8$export$a258bc824c789b17);
$parcel$export(module.exports, "TownsquareProjectAriResourceType", () => $ff4840764fbc83c8$export$aa8900dadffaa32a);
// src/townsquare/project/types.ts
var $ff4840764fbc83c8$export$a258bc824c789b17 = "townsquare", $ff4840764fbc83c8$export$aa8900dadffaa32a = "project";

});


parcelRegister("cSWVe", function(module, exports) {
$parcel$export(module.exports, "RestrictedIcon", () => $232f9b4ae549ebbf$export$fb0d481c8f77ba99);
$parcel$export(module.exports, "RestrictedAlikeSmartLink", () => $232f9b4ae549ebbf$export$b7ba52991f8ac979);

var $eJOHy = parcelRequire("eJOHy");

var $9QgTI = parcelRequire("9QgTI");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8OdFP = parcelRequire("8OdFP");

var $aJTdT = parcelRequire("aJTdT");
const $232f9b4ae549ebbf$export$fb0d481c8f77ba99 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: formatMessage((0, $aJTdT.default).restrictedProject),
        size: "small",
        color: "var(--ds-icon-danger, #C9372C)"
    });
};
const $232f9b4ae549ebbf$export$b7ba52991f8ac979 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'atlasProjectRestrictedAlikeSmartLink viewed');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8OdFP.AlikeSmartLink), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($232f9b4ae549ebbf$export$fb0d481c8f77ba99, null),
        content: formatMessage((0, $aJTdT.default).restrictedProject)
    });
};

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("8OdFP", function(module, exports) {
$parcel$export(module.exports, "AlikeSmartLink", () => $9f253e03aac3e6ac$export$de7d290bc101b437);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $9f253e03aac3e6ac$var$styles = {
    containerStyle: "_4bfu18uv _1hmsglyw _ajmmnqa1 _2rko12b0 _zulp1b66 _11c82smr _1h6dmuej _189ee4h9 _1dqonqa1 _syaz1fxt _1e0c1txw _1ul9idpf _4t3i1tcg _80omtlke _u5f31b66 _19bv1b66 _ca0qv77o _n3tdv77o _4cvr1h6o _1a3b18uv _4fpr8stv _5goinqa1 _f8pj1fxt _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt",
    nameStyle: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf"
};
const $9f253e03aac3e6ac$export$de7d290bc101b437 = ({ icon: icon, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        xcss: $9f253e03aac3e6ac$var$styles.containerStyle
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $9f253e03aac3e6ac$var$styles.nameStyle
    }, content));
};

});

parcelRegister("aJTdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dfa601ba9e2949b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0dfa601ba9e2949b$var$messages = (0, $7qGN1.defineMessages)({
    restrictedProject: {
        "id": "issue-field-atlas-project-common.restricted.restricted-project",
        "defaultMessage": "Restricted project"
    }
});
var $0dfa601ba9e2949b$export$2e2bcd8739ae039 = $0dfa601ba9e2949b$var$messages;

});


parcelRegister("3Gg8D", function(module, exports) {
$parcel$export(module.exports, "HoverPopup", () => $4f1fa3f565c4b710$export$1671b398b5e36be4);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $kJsb4 = parcelRequire("kJsb4");
const $4f1fa3f565c4b710$var$FADE_IN_DELAY = 500;
const $4f1fa3f565c4b710$var$FADE_OUT_DELAY = 300;
const $4f1fa3f565c4b710$export$1671b398b5e36be4 = ({ children: children, renderContent: popupContent, canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = 510, noFadeDelay: noFadeDelay = false, fadeInDelay: customFadeInDelay, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = customFadeInDelay ?? $4f1fa3f565c4b710$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const handleSetIsOpen = (0, $eJOHy.useCallback)((open)=>{
        setIsOpen(open);
        onVisibilityChange?.(open);
    }, [
        onVisibilityChange
    ]);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        // If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            const CARD_GAP_PX = 8;
            popupOffset.current = [
                mousePos.current.x - left + CARD_GAP_PX,
                mousePos.current.y - bottom + CARD_GAP_PX
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        handleSetIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            fadeInTimeoutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $4f1fa3f565c4b710$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                fadeInTimeoutId.current = undefined;
            }
        };
    }, []);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        if ('clientX' in event && 'clientY' in event) {
            const mouseEvent = event; // eslint-disable-line @typescript-eslint/consistent-type-assertions
            setMousePosition(mouseEvent);
        }
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) handleSetIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                handleSetIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const contentElement = typeof popupContent === 'function' ? popupContent(update) : popupContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            onMouseEnter: initShowCard,
            onFocus: initShowCard,
            onMouseLeave: initHideCard,
            onBlur: initHideCard
        }, contentElement);
    }, [
        initShowCard,
        initHideCard,
        popupContent
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            ...triggerProps,
            onMouseEnter: initShowCard,
            onFocus: initShowCard,
            onMouseLeave: initHideCard,
            onBlur: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            testId: "issue-field-atlas-project-common.ui.hover-popup.hover-popup-trigger-wrapper"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        testId: "issue-field-atlas-project-common.ui.hover-popup.hover-popup",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex
    });
};

});

parcelRegister("jMHWF", function(module, exports) {
$parcel$export(module.exports, "PrivateProjectPopup", () => $a18a74dc8fc2636d$export$e6b64042204c6064);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $806LH = parcelRequire("806LH");

var $b3VL6 = parcelRequire("b3VL6");

var $lRq8t = parcelRequire("lRq8t");

var $8l31g = parcelRequire("8l31g");
const $a18a74dc8fc2636d$var$styles = {
    containerStyles: "_zulppxbi _4cvr1h6o _p12f1kdj _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o",
    textBlockStyles: "_zulpu2gc _4cvr1h6o"
};
const $a18a74dc8fc2636d$export$e6b64042204c6064 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $a18a74dc8fc2636d$var$styles.containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3VL6.default), {
        alt: formatMessage((0, $8l31g.default).iconLabel),
        height: 96,
        width: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $a18a74dc8fc2636d$var$styles.textBlockStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $8l31g.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, formatMessage((0, $8l31g.default).description))));
};

});
parcelRegister("b3VL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dad21cdeed809b0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// https://orangedam.atlassian.com/asset-management/2UWGDND5OCL7

var $c4huj = parcelRequire("c4huj");

var $cA8I6 = parcelRequire("cA8I6");

var $gNTkX = parcelRequire("gNTkX");
const $7dad21cdeed809b0$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gNTkX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cA8I6))
});
var $7dad21cdeed809b0$export$2e2bcd8739ae039 = $7dad21cdeed809b0$var$Illustration;
const $7dad21cdeed809b0$export$a179c88182cb9d56 = [
    0,
    0,
    210,
    160
];

});
parcelRegister("cA8I6", function(module, exports) {
module.exports = new URL("data-privacy-darkmode.1a06626c.svg", import.meta.url).toString();

});

parcelRegister("gNTkX", function(module, exports) {
module.exports = new URL("data-privacy.b24f52d9.svg", import.meta.url).toString();

});


parcelRegister("8l31g", function(module, exports) {
$parcel$export(module.exports, "default", () => $274ef57e904ce2d8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $274ef57e904ce2d8$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-atlas-project-common.private-project-popup.title",
        "defaultMessage": "This is a private project"
    },
    description: {
        "id": "issue-field-atlas-project-common.private-project-popup.description",
        "defaultMessage": "Only contributors or people the project is shared with can view this private project. Contact your admin to see if you can get access."
    },
    iconLabel: {
        "id": "issue-field-atlas-project-common.private-project-popup.icon-label",
        "defaultMessage": "Private project"
    }
});
var $274ef57e904ce2d8$export$2e2bcd8739ae039 = $274ef57e904ce2d8$var$messages;

});


parcelRegister("hUGaG", function(module, exports) {
$parcel$export(module.exports, "InlineSmartLink", () => $448159e980e9716e$export$51f4ac8749fbbc36);
/* InlineSmartLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $18DG7 = parcelRequire("18DG7");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $8YHJ2 = parcelRequire("8YHJ2");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $e90yL = parcelRequire("e90yL");

var $aJTdT = parcelRequire("aJTdT");
const $448159e980e9716e$var$styles = {
    inlineStyles: "_2rko12b0 _1mouv77o _1h6dmuej _1dqonqa1 _189ee4h9 _bfhkhp5a _1e0c116y _bozgv77o _irr31a0f",
    titleBlockStyles: "_zulp1b66 _4t3igktf _c71lgktf _1tkegktf _1e0c1txw _4cvr1h6o _1bah1h6o _11zf9jpi _1k81v77o _cvypm7j4 _1mmv15ej _1j7hr5cr _1vabv77o _n2w6v77o"
};
const $448159e980e9716e$var$uiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    theme: (0, $5NtHI.SmartLinkTheme).Black
};
const $448159e980e9716e$var$uiOptionsWithPlaceholder = {
    ...$448159e980e9716e$var$uiOptions,
    removeBlockRestriction: true
};
const $448159e980e9716e$var$actionOptions = {
    hide: false,
    exclude: [
        (0, $18DG7.CardAction).ChangeStatusAction
    ]
};
const $448159e980e9716e$export$51f4ac8749fbbc36 = ({ url: url, anchorTarget: anchorTarget, showHoverPreview: showHoverPreview = true, text: text, anchorRef: anchorRef, onError: onError, onResolve: onResolve, metadata: metadata = [
    {
        name: (0, $5NtHI.ElementName).State
    }
], position: position = (0, $5NtHI.SmartLinkPosition).Center, actions: actions, icon: icon, hideRetry: hideRetry })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const placeholderData = (0, $eJOHy.useMemo)(()=>{
        if (!url || !(0, $4cTDP.fg)('project_ssr_smart_card')) return undefined;
        return (0, $e90yL.generatePlaceholderData)(url, formatMessage((0, $aJTdT.default).restrictedProject), text);
    }, [
        formatMessage,
        text,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $448159e980e9716e$var$styles.inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YHJ2.CardSSR), {
        appearance: "inline",
        url: url,
        ui: placeholderData ? $448159e980e9716e$var$uiOptionsWithPlaceholder : $448159e980e9716e$var$uiOptions,
        actionOptions: $448159e980e9716e$var$actionOptions,
        showHoverPreview: showHoverPreview,
        onError: onError,
        onResolve: onResolve,
        placeholderData: placeholderData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: metadata,
        anchorTarget: anchorTarget ?? '_self',
        text: text,
        icon: icon,
        anchorRef: anchorRef,
        position: position,
        actions: actions,
        hideRetry: hideRetry,
        ...(0, $4cTDP.fg)('project_ssr_smart_card') ? {
            hideIconLoadingSkeleton: !!placeholderData
        } : {},
        className: (0, $hcewu.default)([
            $448159e980e9716e$var$styles.titleBlockStyles
        ])
    })));
};

});
parcelRegister("18DG7", function(module, exports) {
$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("fqBfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0af5d75f753a471$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $5FRJ8 = parcelRequire("5FRJ8");

var $i6ktq = parcelRequire("i6ktq");

var $6P8F3 = parcelRequire("6P8F3");

var $gjoE0 = parcelRequire("gjoE0");

var $haRRg = parcelRequire("haRRg");

var $1Ub5D = parcelRequire("1Ub5D");
const $a0af5d75f753a471$var$actionStyles = null;
const $a0af5d75f753a471$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return 0, $1Ub5D.default;
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return 0, $haRRg.default;
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return 0, $gjoE0.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $a0af5d75f753a471$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const { status: status = (0, $5NtHI.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6ktq.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $a0af5d75f753a471$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $a0af5d75f753a471$export$2e2bcd8739ae039 = $a0af5d75f753a471$var$TitleBlock;

});
parcelRegister("e3qu2", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $3d45ba8ff999246a$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $3d45ba8ff999246a$export$df67f318ded0283c);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $liquj = parcelRequire("liquj");
var $3d45ba8ff999246a$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $3d45ba8ff999246a$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $3d45ba8ff999246a$var$isNotLeftClick = (event)=>event.button !== 0;
const $3d45ba8ff999246a$export$df67f318ded0283c = (onMouseDown)=>{
    return $3d45ba8ff999246a$export$5993d3ca6c85f774(onMouseDown, $3d45ba8ff999246a$var$isNotLeftClick);
};

});
parcelRegister("liquj", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $9bb097c912a9f010$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $9bb097c912a9f010$export$263352d59c0c5966);

var $eJOHy = parcelRequire("eJOHy");

var $8GnsF = parcelRequire("8GnsF");

var $e3qu2 = parcelRequire("e3qu2");

var $b43DQ = parcelRequire("b43DQ");
const $9bb097c912a9f010$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $9bb097c912a9f010$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $9bb097c912a9f010$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $9bb097c912a9f010$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $8GnsF.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($9bb097c912a9f010$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $9bb097c912a9f010$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $9bb097c912a9f010$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $9bb097c912a9f010$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $9bb097c912a9f010$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $9bb097c912a9f010$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $9bb097c912a9f010$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $9bb097c912a9f010$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $9bb097c912a9f010$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
const $9bb097c912a9f010$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $9bb097c912a9f010$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $e3qu2.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $e3qu2.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$9bb097c912a9f010$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("8GnsF", function(module, exports) {
$parcel$export(module.exports, "browser", () => $9001dc59012896ed$export$3f2684e5d7cb1006);
const $9001dc59012896ed$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9001dc59012896ed$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9001dc59012896ed$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9001dc59012896ed$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9001dc59012896ed$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9001dc59012896ed$var$result.android = /Android \d/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9001dc59012896ed$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9001dc59012896ed$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9001dc59012896ed$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9001dc59012896ed$export$3f2684e5d7cb1006() {
    return $9001dc59012896ed$var$result;
}

});

parcelRegister("b43DQ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3132e66a6b380708$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3132e66a6b380708$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3132e66a6b380708$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3132e66a6b380708$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3132e66a6b380708$export$b91e0203b928470c);
const $3132e66a6b380708$export$85183a312807388d = 'media';
const $3132e66a6b380708$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3132e66a6b380708$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3132e66a6b380708$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3132e66a6b380708$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3132e66a6b380708$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3132e66a6b380708$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3132e66a6b380708$export$85183a312807388d);
};

});



parcelRegister("5FRJ8", function(module, exports) {
$parcel$export(module.exports, "FlexibleCardContext", () => $26ead80b20537add$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $26ead80b20537add$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "useFlexibleUiContext", () => $26ead80b20537add$export$61d7957a243df7aa);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $26ead80b20537add$export$e6b5ad18b56e8f51);

var $eJOHy = parcelRequire("eJOHy");
const $26ead80b20537add$export$13dde4423ab71d62 = (0, $eJOHy.createContext)(undefined);
const $26ead80b20537add$export$a8c4167e4e9f26ab = ()=>(0, $eJOHy.useContext)($26ead80b20537add$export$13dde4423ab71d62);
const $26ead80b20537add$export$61d7957a243df7aa = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.data;
const $26ead80b20537add$export$e6b5ad18b56e8f51 = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.ui;

});

parcelRegister("i6ktq", function(module, exports) {
$parcel$export(module.exports, "default", () => $890c0338844dfde1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $890c0338844dfde1$var$TitleElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Title
    }) : null;
};
var $890c0338844dfde1$export$2e2bcd8739ae039 = $890c0338844dfde1$var$TitleElement;

});
parcelRegister("8ygPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $adbc5d7a57662063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $fQH39 = parcelRequire("fQH39");
const $adbc5d7a57662063$var$DEFAULT_MAX_LINES = 2;
const $adbc5d7a57662063$var$MAXIMUM_MAX_LINES = 2;
const $adbc5d7a57662063$var$MINIMUM_MAX_LINES = 1;
const $adbc5d7a57662063$var$containerStyles = null;
const $adbc5d7a57662063$var$getMaxLines = (maxLines)=>{
    if (maxLines > $adbc5d7a57662063$var$MAXIMUM_MAX_LINES) return $adbc5d7a57662063$var$DEFAULT_MAX_LINES;
    if (maxLines < $adbc5d7a57662063$var$MINIMUM_MAX_LINES) return $adbc5d7a57662063$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $adbc5d7a57662063$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $adbc5d7a57662063$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $adbc5d7a57662063$var$baseAnchorStyle = null;
const $adbc5d7a57662063$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $adbc5d7a57662063$var$anchorConstantsStyles = null;
const $adbc5d7a57662063$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $adbc5d7a57662063$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1gjq _f8pj1gjq _30l31gjq _10531gjq",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $adbc5d7a57662063$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $adbc5d7a57662063$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5NtHI.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const hasSpace = (0, $eJOHy.useMemo)(()=>text ? (0, $fQH39.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $adbc5d7a57662063$var$linkStyleSizeMap[size],
            $adbc5d7a57662063$var$anchorLineClampMap[$adbc5d7a57662063$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $adbc5d7a57662063$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 1 && $adbc5d7a57662063$var$anchorLinkLineHeight1Map[size],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 2 && $adbc5d7a57662063$var$anchorLinkLineHeight2Map[size],
            $adbc5d7a57662063$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $adbc5d7a57662063$var$withTooltip(anchor, text, testId)
    });
};
var $adbc5d7a57662063$export$2e2bcd8739ae039 = $adbc5d7a57662063$var$BaseLinkElement;
const $adbc5d7a57662063$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});
parcelRegister("fQH39", function(module, exports) {
$parcel$export(module.exports, "sizeToButtonSpacing", () => $18f1b25c1730b97c$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $18f1b25c1730b97c$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $18f1b25c1730b97c$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $18f1b25c1730b97c$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $18f1b25c1730b97c$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $18f1b25c1730b97c$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $18f1b25c1730b97c$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $18f1b25c1730b97c$export$619e376a425cb759);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $joSn0 = parcelRequire("joSn0");

var $5NtHI = parcelRequire("5NtHI");
const $18f1b25c1730b97c$export$9d642f65a919fb93 = {
    [(0, $5NtHI.SmartLinkSize).Small]: 'none',
    [(0, $5NtHI.SmartLinkSize).Medium]: 'compact',
    [(0, $5NtHI.SmartLinkSize).Large]: 'compact',
    [(0, $5NtHI.SmartLinkSize).XLarge]: 'default'
};
const $18f1b25c1730b97c$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        });
    }
};
const $18f1b25c1730b97c$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $18f1b25c1730b97c$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $18f1b25c1730b97c$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $18f1b25c1730b97c$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1.75;
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $18f1b25c1730b97c$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $18f1b25c1730b97c$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5NtHI.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $18f1b25c1730b97c$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("6P8F3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6bccbbfb4f78611$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $brTAh = parcelRequire("brTAh");

var $a86OV = parcelRequire("a86OV");
const $a6bccbbfb4f78611$var$styles = null;
const $a6bccbbfb4f78611$var$renderActionItems = (items = [], size = (0, $5NtHI.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a86OV.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a6bccbbfb4f78611$var$ActionGroup = ({ items: items = [], size: size = (0, $5NtHI.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gRw8I.di)((0, $7rjYb.default));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const renderableActionItems = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fQH39.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).more_actions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $a6bccbbfb4f78611$export$2e2bcd8739ae039 = $a6bccbbfb4f78611$var$ActionGroup;

});
parcelRegister("aMdh8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52a17cfb35b19ee3ae1ff9abc93d8023>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d88af49f9584885$var$_react = $7d88af49f9584885$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7d88af49f9584885$var$_showMoreHorizontal = $7d88af49f9584885$var$_interopRequireDefault((parcelRequire("NByNW")));

var $7d88af49f9584885$var$_more = $7d88af49f9584885$var$_interopRequireDefault((parcelRequire("31yN3")));
function $7d88af49f9584885$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d88af49f9584885$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $7d88af49f9584885$var$_react.default.createElement($7d88af49f9584885$var$_showMoreHorizontal.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        LEGACY_fallbackIcon: $7d88af49f9584885$var$_more.default
    }, props));
$7d88af49f9584885$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIconMigration';
var $7d88af49f9584885$var$_default = module.exports.default = $7d88af49f9584885$var$ShowMoreHorizontalIcon;

});
parcelRegister("31yN3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $233c73b2e7ab22d3$var$_react = $233c73b2e7ab22d3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $233c73b2e7ab22d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $233c73b2e7ab22d3$var$MoreIcon = (props)=>/*#__PURE__*/ $233c73b2e7ab22d3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props));
$233c73b2e7ab22d3$var$MoreIcon.displayName = 'MoreIcon';
var $233c73b2e7ab22d3$var$_default = module.exports.default = $233c73b2e7ab22d3$var$MoreIcon;

});


parcelRegister("19nmp", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d6bf071ed8fc5324$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d6bf071ed8fc5324$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    experiment_connect_unauthorised_account_action: {
        id: 'fabric.linking.experiment_connect_unauthorised_account_action.non-final',
        defaultMessage: 'Connect {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    experiment_connect_link_account_card_name_title: {
        id: 'fabric.linking.experiment_connect_link_account_card_name.non-final',
        defaultMessage: 'Get more out of {context}',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    experiment_connect_hovercard_description_1: {
        id: 'fabric.linking.experiment_connect_hovercard_description_1.non-final',
        defaultMessage: 'Connect your {context} account to turn simple URLs into rich, interactive previews, making it easier to collaborate and stay in context.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. (experiment test 1)'
    },
    experiment_connect_hovercard_description_2: {
        id: 'fabric.linking.experiment_connect_hovercard_description_2.non-final',
        defaultMessage: 'Connect your {context} account to turn simple URLs into rich, interactive previews and unlock more AI experiences, making it easier to collaborate and stay in context.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. (experiment test 2)'
    },
    experiment_connect_hovercard_description_3: {
        id: 'fabric.linking.experiment_connect_hovercard_description_3.non-final',
        defaultMessage: 'Transform ordinary URLs into rich, interactive previews of your {context} content, and unlock enhanced AI-powered features within your Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. (experiment test 3)'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    experiment_learn_more_about_smart_links: {
        id: 'fabric.linking.experiment_learn_more_about_smart_links.non-final',
        defaultMessage: 'Learn more about smart link security and permissions.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Description on what Follow does'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    }
});

});

parcelRegister("brTAh", function(module, exports) {
$parcel$export(module.exports, "filterActionItems", () => $a0fe758b77d980f4$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $a0fe758b77d980f4$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $a0fe758b77d980f4$export$9678d3ca18bd7526);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $1YI3f = parcelRequire("1YI3f");

var $4RG9i = parcelRequire("4RG9i");

var $6P8F3 = parcelRequire("6P8F3");

var $k8J0S = parcelRequire("k8J0S");
const $a0fe758b77d980f4$export$f942619ce67b1a41 = {
    [(0, $5NtHI.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Location]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Preview]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).State]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Title]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).VoteCount]: [
        'inline'
    ]
};
const $a0fe758b77d980f4$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1;
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $a0fe758b77d980f4$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $6P8F3.default);
const $a0fe758b77d980f4$var$isElementDisplayValid = (name, display)=>{
    return $a0fe758b77d980f4$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $a0fe758b77d980f4$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $a0fe758b77d980f4$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && ((0, $1YI3f.isFlexibleUiElement)(node) || node.type === (0, $k8J0S.default));
const $a0fe758b77d980f4$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5NtHI.ActionName).DeleteAction:
            case (0, $5NtHI.ActionName).EditAction:
            case (0, $5NtHI.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5NtHI.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $a0fe758b77d980f4$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if ($a0fe758b77d980f4$var$isElementOrElementGroup(child) || $a0fe758b77d980f4$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $a0fe758b77d980f4$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4RG9i[name];
        const typedProps = props;
        if (Element && $a0fe758b77d980f4$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $gt9Am.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$a0fe758b77d980f4$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1YI3f", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiCard", () => $ec5109f5e7b621c7$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isStyleCacheProvider", () => $ec5109f5e7b621c7$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $ec5109f5e7b621c7$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $ec5109f5e7b621c7$export$c0547b4405cae584);

var $eJOHy = parcelRequire("eJOHy");

var $34CM9 = parcelRequire("34CM9");
var $fqBfo = parcelRequire("fqBfo");
var $8Rjtc = parcelRequire("8Rjtc");
var $lAF2k = parcelRequire("lAF2k");

var $4RG9i = parcelRequire("4RG9i");
const $ec5109f5e7b621c7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).some((child)=>$ec5109f5e7b621c7$export$df0092b19156b140(child))) return true;
    return false;
};
const $ec5109f5e7b621c7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($34CM9).some((type)=>type === node.type)) return true;
    return false;
};
const $ec5109f5e7b621c7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (Object.values($4RG9i).some((type)=>type === node.type)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $fqBfo.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $8Rjtc.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $lAF2k.default);

});
parcelRegister("34CM9", function(module, exports) {
$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("lAF2k")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gKsxm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("8Rjtc")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("5gb8b")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("fqBfo")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("bIdM1")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("3pcXQ")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("2qnEp")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("eMgzj")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("4cjOx")).default);

var $lAF2k = parcelRequire("lAF2k");

var $gKsxm = parcelRequire("gKsxm");

var $8Rjtc = parcelRequire("8Rjtc");

var $5gb8b = parcelRequire("5gb8b");

var $fqBfo = parcelRequire("fqBfo");

var $bIdM1 = parcelRequire("bIdM1");

var $3pcXQ = parcelRequire("3pcXQ");

var $2qnEp = parcelRequire("2qnEp");

var $eMgzj = parcelRequire("eMgzj");

var $4cjOx = parcelRequire("4cjOx");

});
parcelRegister("lAF2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b59a3b7a9f7670d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3pcXQ = parcelRequire("3pcXQ");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $9b59a3b7a9f7670d$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $9b59a3b7a9f7670d$export$2e2bcd8739ae039 = $9b59a3b7a9f7670d$var$FooterBlock;

});
parcelRegister("3pcXQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $462a2917906f3b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $6P8F3 = parcelRequire("6P8F3");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $462a2917906f3b08$var$actionGroupStyles = null;
const $462a2917906f3b08$var$safariStyles = null;
const $462a2917906f3b08$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5NtHI.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const hasActions = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                testId: "smart-element-group-actions",
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                className: (0, $hcewu.default)([
                    size === (0, $5NtHI.SmartLinkSize).XLarge && "_c71lxy5q",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $462a2917906f3b08$export$2e2bcd8739ae039 = $462a2917906f3b08$var$FooterBlockResolvedView;

});
parcelRegister("6l7Bk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a8115736e8f2ac6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $2a8115736e8f2ac6$var$ProviderElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Provider
    }) : null;
};
var $2a8115736e8f2ac6$export$2e2bcd8739ae039 = $2a8115736e8f2ac6$var$ProviderElement;

});
parcelRegister("4XCp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $e83b25175c466aed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $e83b25175c466aed$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $e83b25175c466aed$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $e83b25175c466aed$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $e83b25175c466aed$var$messageMapper = {
    [(0, $5NtHI.IconType).PriorityBlocker]: (0, $19nmp.messages).priority_blocker,
    [(0, $5NtHI.IconType).PriorityCritical]: (0, $19nmp.messages).priority_critical,
    [(0, $5NtHI.IconType).PriorityHigh]: (0, $19nmp.messages).priority_high,
    [(0, $5NtHI.IconType).PriorityHighest]: (0, $19nmp.messages).priority_highest,
    [(0, $5NtHI.IconType).PriorityLow]: (0, $19nmp.messages).priority_low,
    [(0, $5NtHI.IconType).PriorityLowest]: (0, $19nmp.messages).priority_lowest,
    [(0, $5NtHI.IconType).PriorityMajor]: (0, $19nmp.messages).priority_major,
    [(0, $5NtHI.IconType).PriorityMedium]: (0, $19nmp.messages).priority_medium,
    [(0, $5NtHI.IconType).PriorityMinor]: (0, $19nmp.messages).priority_minor,
    [(0, $5NtHI.IconType).PriorityTrivial]: (0, $19nmp.messages).priority_trivial,
    [(0, $5NtHI.IconType).PriorityUndefined]: (0, $19nmp.messages).priority_undefined
};
const $e83b25175c466aed$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e83b25175c466aed$var$messageMapper[icon];
        if (descriptor) return (0, $fQH39.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e83b25175c466aed$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e83b25175c466aed$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e83b25175c466aed$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const ui = (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FRJ8.useFlexibleUiOptionContext)() : undefined;
    const formattedMessageOrLabel = $e83b25175c466aed$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e83b25175c466aed$var$renderAtlaskitIcon(icon, testId) || $e83b25175c466aed$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            $e83b25175c466aed$var$styles.container,
            $e83b25175c466aed$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $e83b25175c466aed$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $e83b25175c466aed$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
var $e83b25175c466aed$export$2e2bcd8739ae039 = (0, $9jYtV.withOverrideCss)($e83b25175c466aed$var$BaseBadgeRefreshNew);
const $e83b25175c466aed$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("b4zhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d5d1de8f417451$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");

var $4Gz8O = parcelRequire("4Gz8O");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $d6d5d1de8f417451$var$getIconImportFn = (icon, size)=>{
    const item = (0, $FoFt2.getLazyIcons)()[icon];
    if ((0, $FoFt2.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $d6d5d1de8f417451$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $d6d5d1de8f417451$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5NtHI.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5NtHI.IconType).Document:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).Blog:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $d6d5d1de8f417451$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $d6d5d1de8f417451$var$importIcon(importFn);
    switch(icon){
        case (0, $5NtHI.IconType).Confluence:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5NtHI.IconType).Jira:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5NtHI.IconType).Error:
        case (0, $5NtHI.IconType).Forbidden:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $d6d5d1de8f417451$export$2e2bcd8739ae039 = $d6d5d1de8f417451$var$AtlaskitIcon;

});
parcelRegister("4Gz8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1589456b7a180f6b$export$2e2bcd8739ae039);

var $ihwup = parcelRequire("ihwup");

var $ff2hw = parcelRequire("ff2hw");

var $cPcks = parcelRequire("cPcks");
const $1589456b7a180f6b$var$BlogIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ihwup.default), (0, $ff2hw.default));
$1589456b7a180f6b$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $1589456b7a180f6b$export$2e2bcd8739ae039 = $1589456b7a180f6b$var$BlogIconWithColor;

});
parcelRegister("ihwup", function(module, exports) {
$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25f59ea2b6bc25c62576440e4e014d55>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $ixkyU = parcelRequire("ixkyU");

var $eGOwo = parcelRequire("eGOwo");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ixkyU.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b5ace82dd4a8965510da799b9153030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("ixkyU", function(module, exports) {
$parcel$export(module.exports, "default", () => $efb8455781b7b8dd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $amerd = parcelRequire("amerd");

var $gPsTF = parcelRequire("gPsTF");
function $efb8455781b7b8dd$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});
parcelRegister("gPsTF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9228c397c6e87f34$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $9228c397c6e87f34$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});


parcelRegister("37A7r", function(module, exports) {
$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7cef41f07f9ec4679337b66fb782a07>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("ff2hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $674c38c84d40fa8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee7129996bcdd9cb958d21a3e9c19719>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $iG796 = parcelRequire("iG796");

var $eGOwo = parcelRequire("eGOwo");

var $4HJXf = parcelRequire("4HJXf");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $674c38c84d40fa8d$var$Blog24Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iG796.default), {
        label: label,
        testId: testId,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
            label: label,
            testId: testId
        })
    });
};
$674c38c84d40fa8d$var$Blog24Icon.displayName = 'Blog24Icon';
var $674c38c84d40fa8d$export$2e2bcd8739ae039 = $674c38c84d40fa8d$var$Blog24Icon;

});
parcelRegister("iG796", function(module, exports) {
$parcel$export(module.exports, "default", () => $055e9e84485f53e7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $amerd = parcelRequire("amerd");

var $lkXQr = parcelRequire("lkXQr");
function $055e9e84485f53e7$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkXQr.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        color: isBold ? "var(--ds-icon, #44546F)" : "var(--ds-icon-accent-blue, #1D7AFC)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});
parcelRegister("lkXQr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9a1681b19d12ba2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $ieO20 = parcelRequire("ieO20");
function $e9a1681b19d12ba2$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $8GOss.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ieO20.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});


parcelRegister("4HJXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ddb48944e405ac0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90dcc35b3376b79911c4054d7edd4bc7>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $2ddb48944e405ac0$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$2ddb48944e405ac0$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ddb48944e405ac0$export$2e2bcd8739ae039 = $2ddb48944e405ac0$var$Blog24Icon;

});


parcelRegister("cPcks", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $5c2d46cff1f07a26$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $5c2d46cff1f07a26$export$87c3646d0e299cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $5c2d46cff1f07a26$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $5c2d46cff1f07a26$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $FoFt2.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $gt9Am.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(IconSmall, {
            ...props
        });
    };
};
const $5c2d46cff1f07a26$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
            appearance: appearance,
            icon: Icon,
            size: $5c2d46cff1f07a26$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $gt9Am.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("FoFt2", function(module, exports) {
$parcel$export(module.exports, "isSpecialEvent", () => $4836221d615e2d0d$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $4836221d615e2d0d$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $4836221d615e2d0d$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $4836221d615e2d0d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $4836221d615e2d0d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4836221d615e2d0d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4836221d615e2d0d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4836221d615e2d0d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4836221d615e2d0d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4836221d615e2d0d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4836221d615e2d0d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4836221d615e2d0d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $4836221d615e2d0d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $4836221d615e2d0d$export$6a4545d6b336c401);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $4CCpn = parcelRequire("4CCpn");

var $5NtHI = parcelRequire("5NtHI");

var $dyU3L = parcelRequire("dyU3L");
const $4836221d615e2d0d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4836221d615e2d0d$export$e6c5ffa684aac4d7() || $4836221d615e2d0d$export$d8de0cd37d316fdf(evt) || $4836221d615e2d0d$export$5b1771037ab7c451(evt));
const $4836221d615e2d0d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4836221d615e2d0d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $eGOwo.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $4836221d615e2d0d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4836221d615e2d0d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4836221d615e2d0d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};



























































































const $4836221d615e2d0d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5NtHI.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9dPtp")))
        },
        [(0, $5NtHI.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("4Gz8O")))
        },
        [(0, $5NtHI.IconType).Audio]: {
            default: ()=>(parcelRequire("cesFU"))
        },
        [(0, $5NtHI.IconType).Code]: {
            default: ()=>(parcelRequire("2hxmV"))
        },
        [(0, $5NtHI.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Folder]: {
            default: ()=>(parcelRequire("2vlwA"))
        },
        [(0, $5NtHI.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Image]: {
            default: ()=>(parcelRequire("ka9UC"))
        },
        [(0, $5NtHI.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("lQKQC")))
        },
        [(0, $5NtHI.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("4VIPx")))
        },
        [(0, $5NtHI.IconType).Video]: {
            default: ()=>(parcelRequire("4FvfE"))
        },
        [(0, $5NtHI.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lG2jM")))
        },
        [(0, $5NtHI.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kSre2")))
        },
        [(0, $5NtHI.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("eDFE1")))
        },
        [(0, $5NtHI.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("av9Of")))
        },
        [(0, $5NtHI.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("1NG86")))
        },
        [(0, $5NtHI.IconType).Archive]: {
            default: ()=>Promise.resolve((parcelRequire("8UJE5"))),
            large: ()=>Promise.resolve((parcelRequire("8ALRN")))
        },
        [(0, $5NtHI.IconType).Executable]: {
            default: ()=>(parcelRequire("2SUZV")),
            large: ()=>Promise.resolve((parcelRequire("gAsmN")))
        },
        [(0, $5NtHI.IconType).GIF]: {
            default: ()=>(parcelRequire("htCgV")),
            large: ()=>Promise.resolve((parcelRequire("2Pj0H")))
        },
        [(0, $5NtHI.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("3iL1Z")),
            large: ()=>Promise.resolve((parcelRequire("iqmbF")))
        },
        [(0, $5NtHI.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("dEWSV")),
            large: ()=>Promise.resolve((parcelRequire("hLw8T")))
        },
        [(0, $5NtHI.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("lGiQr")),
            large: ()=>Promise.resolve((parcelRequire("jpYYq")))
        },
        [(0, $5NtHI.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("1L06r")),
            large: ()=>Promise.resolve((parcelRequire("4SXVP")))
        },
        [(0, $5NtHI.IconType).MSExcel]: {
            default: ()=>(parcelRequire("hSMHC")),
            large: ()=>Promise.resolve((parcelRequire("91IX3")))
        },
        [(0, $5NtHI.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("1pcgz")),
            large: ()=>Promise.resolve((parcelRequire("jb8ZN")))
        },
        [(0, $5NtHI.IconType).MSWord]: {
            default: ()=>(parcelRequire("lt3XL")),
            large: ()=>Promise.resolve((parcelRequire("4w1Xx")))
        },
        [(0, $5NtHI.IconType).PDF]: {
            default: ()=>(parcelRequire("5H4a5")),
            large: ()=>Promise.resolve((parcelRequire("6OBnQ")))
        },
        [(0, $5NtHI.IconType).Sketch]: {
            default: ()=>(parcelRequire("j6e97")),
            large: ()=>Promise.resolve((parcelRequire("heBKY")))
        },
        // Bitbucket icons
        [(0, $5NtHI.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("liS9g"))),
            large: ()=>(parcelRequire("bQ1N4"))
        },
        [(0, $5NtHI.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("6wUJL"))),
            large: ()=>(parcelRequire("4OxG9"))
        },
        [(0, $5NtHI.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("es92x"))),
            large: ()=>(parcelRequire("1JRRC"))
        },
        [(0, $5NtHI.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gSqCA"))),
            large: ()=>(parcelRequire("gjbfK"))
        },
        // Jira icons
        [(0, $5NtHI.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("i3nvV"))),
            large: ()=>(parcelRequire("jVyke"))
        },
        [(0, $5NtHI.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("59W6U"))),
            large: ()=>(parcelRequire("70fC5"))
        },
        [(0, $5NtHI.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("4VGMo"))),
            large: ()=>(parcelRequire("bUsl4"))
        },
        [(0, $5NtHI.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("h6Xfo"))),
            large: ()=>Promise.resolve((parcelRequire("eHIwa")))
        },
        [(0, $5NtHI.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("erbJ6"))),
            large: ()=>(parcelRequire("7MVkC"))
        },
        [(0, $5NtHI.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("8WXuv"))),
            large: ()=>(parcelRequire("acF2K"))
        },
        [(0, $5NtHI.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("iaeCZ"))),
            large: ()=>(parcelRequire("5Z3lN"))
        },
        [(0, $5NtHI.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dV8me"))),
            large: ()=>(parcelRequire("1wvhU"))
        },
        [(0, $5NtHI.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("cOjgE"))),
            large: ()=>(parcelRequire("dyxwG"))
        },
        // Confluence icons
        [(0, $5NtHI.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("ilCAi"))),
            large: ()=>Promise.resolve((parcelRequire("hB03j")))
        },
        // Provider icons
        [(0, $5NtHI.IconType).Confluence]: {
            default: ()=>(parcelRequire("8A134")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5NtHI.IconType).Jira]: {
            default: ()=>(parcelRequire("6cjQd")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5NtHI.IconType).Attachment]: {
            default: ()=>(parcelRequire("bCsrc"))
        },
        [(0, $5NtHI.IconType).CheckItem]: {
            default: ()=>(parcelRequire("brHgq"))
        },
        [(0, $5NtHI.IconType).Component]: {
            default: ()=>(parcelRequire("bNgFX"))
        },
        [(0, $5NtHI.IconType).Comment]: {
            default: ()=>(parcelRequire("7gCMb"))
        },
        [(0, $5NtHI.IconType).View]: {
            default: ()=>(parcelRequire("koFqW"))
        },
        [(0, $5NtHI.IconType).React]: {
            default: ()=>(parcelRequire("fUMvo"))
        },
        [(0, $5NtHI.IconType).Vote]: {
            default: ()=>(parcelRequire("bAVbi"))
        },
        [(0, $5NtHI.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("fOxQN"))
        },
        [(0, $5NtHI.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("ekbvS"))
        },
        [(0, $5NtHI.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("j0sW6"))
        },
        [(0, $5NtHI.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("75OGX"))
        },
        [(0, $5NtHI.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("3aNz8"))
        },
        [(0, $5NtHI.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("4MiqP"))
        },
        [(0, $5NtHI.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("1Azbr"))
        },
        [(0, $5NtHI.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("hxTO3"))
        },
        [(0, $5NtHI.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("lRlMN"))
        },
        [(0, $5NtHI.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("gdaQK"))
        },
        [(0, $5NtHI.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("cH3kb"))
        },
        [(0, $5NtHI.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("4ft1P"))
        },
        [(0, $5NtHI.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("hMpZ8")))
        },
        [(0, $5NtHI.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("93JYU"))
        }
    };
};
const $4836221d615e2d0d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $dyU3L.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $4836221d615e2d0d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $4836221d615e2d0d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4836221d615e2d0d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4836221d615e2d0d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4836221d615e2d0d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4836221d615e2d0d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4836221d615e2d0d$export$e772c8ff12451969(interval);
            return $4836221d615e2d0d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4836221d615e2d0d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4836221d615e2d0d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4836221d615e2d0d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $4CCpn.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $4836221d615e2d0d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5NtHI.SmartLinkSize).Large,
        (0, $5NtHI.SmartLinkSize).XLarge
    ].includes(size);
const $4836221d615e2d0d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("dyU3L", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aa425783d81a7e4$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/i18n/no-literal-string-in-object */ 
var $5NtHI = parcelRequire("5NtHI");
const $9aa425783d81a7e4$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5NtHI.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5NtHI.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5NtHI.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5NtHI.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5NtHI.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5NtHI.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5NtHI.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5NtHI.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5NtHI.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5NtHI.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5NtHI.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5NtHI.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5NtHI.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5NtHI.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5NtHI.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5NtHI.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5NtHI.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $9aa425783d81a7e4$export$2e2bcd8739ae039 = $9aa425783d81a7e4$var$extractFileFormatIcon;

});

parcelRegister("9dPtp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a49966ca6c4774bc$export$2e2bcd8739ae039);

var $lImMk = parcelRequire("lImMk");

var $gxCW9 = parcelRequire("gxCW9");

var $DtmfJ = parcelRequire("DtmfJ");

var $cPcks = parcelRequire("cPcks");
const $a49966ca6c4774bc$var$PageIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), 'blueBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lImMk))), (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9)))));
$a49966ca6c4774bc$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a49966ca6c4774bc$export$2e2bcd8739ae039 = $a49966ca6c4774bc$var$PageIconWithColor;

});
parcelRegister("lImMk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fcef605c5c3325f6$var$_react = $fcef605c5c3325f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $fcef605c5c3325f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcef605c5c3325f6$var$Document16Icon = (props)=>/*#__PURE__*/ $fcef605c5c3325f6$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fcef605c5c3325f6$var$Document16Icon.displayName = 'Document16Icon';
var $fcef605c5c3325f6$var$_default = module.exports.default = $fcef605c5c3325f6$var$Document16Icon;

});

parcelRegister("gxCW9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c0adee7b3af1dc62$var$_react = $c0adee7b3af1dc62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c0adee7b3af1dc62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0adee7b3af1dc62$var$Document24Icon = (props)=>/*#__PURE__*/ $c0adee7b3af1dc62$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c0adee7b3af1dc62$var$Document24Icon.displayName = 'Document24Icon';
var $c0adee7b3af1dc62$var$_default = module.exports.default = $c0adee7b3af1dc62$var$Document24Icon;

});


parcelRegister("cesFU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lBret").then(()=>parcelRequire('lT9gU'));

});

parcelRegister("2hxmV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c4Piz").then(()=>parcelRequire('b9JjP'));

});

parcelRegister("2vlwA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fJRo2").then(()=>parcelRequire('3JiAU'));

});

parcelRegister("ka9UC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68koG").then(()=>parcelRequire('htaza'));

});

parcelRegister("4FvfE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfpt4").then(()=>parcelRequire('idFH3'));

});

parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7207a1a192d06bb66aba669d57a8645>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.displayName = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});

parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});


parcelRegister("2SUZV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("43EiL").then(()=>parcelRequire('bKXd3'));

});

parcelRegister("htCgV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i35Uh").then(()=>parcelRequire('ccKWN'));

});

parcelRegister("3iL1Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9vjhq").then(()=>parcelRequire('aSnEf'));

});

parcelRegister("dEWSV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j5W60").then(()=>parcelRequire('ju9Zq'));

});

parcelRegister("lGiQr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gHrjT").then(()=>parcelRequire('4BqrB'));

});

parcelRegister("1L06r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hCGN9").then(()=>parcelRequire('cwxjA'));

});

parcelRegister("hSMHC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("igTGi").then(()=>parcelRequire('llYLq'));

});

parcelRegister("1pcgz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8A7Un").then(()=>parcelRequire('bxHzv'));

});

parcelRegister("lt3XL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fnRpB").then(()=>parcelRequire('FXbTY'));

});

parcelRegister("5H4a5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fMJrt").then(()=>parcelRequire('do41j'));

});

parcelRegister("j6e97", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cxAqh").then(()=>parcelRequire('gbtcZ'));

});

parcelRegister("bQ1N4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvxvv").then(()=>parcelRequire('2j1uF'));

});

parcelRegister("4OxG9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5DW8N").then(()=>parcelRequire('8J7Hh'));

});

parcelRegister("1JRRC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("er5Rw").then(()=>parcelRequire('ktJB5'));

});

parcelRegister("gjbfK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a4ZTh").then(()=>parcelRequire('1O53N'));

});

parcelRegister("jVyke", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fVZub").then(()=>parcelRequire('jYfQG'));

});

parcelRegister("70fC5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("biRPG").then(()=>parcelRequire('gR3IA'));

});

parcelRegister("bUsl4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5PIwW").then(()=>parcelRequire('dmWJ4'));

});

parcelRegister("7MVkC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hy7F8").then(()=>parcelRequire('lR9WO'));

});

parcelRegister("acF2K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5UA41").then(()=>parcelRequire('aozTf'));

});

parcelRegister("5Z3lN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jQGZH").then(()=>parcelRequire('3mwl5'));

});

parcelRegister("1wvhU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("55GNU").then(()=>parcelRequire('7lmhQ'));

});

parcelRegister("dyxwG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eiZZR").then(()=>parcelRequire('f8Y7f'));

});

parcelRegister("ilCAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a3170ce3e9e98d41$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cbe873b765d214e34343034c1ec2722>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $cruFS = parcelRequire("cruFS");

var $cDkKD = parcelRequire("cDkKD");

var $eGOwo = parcelRequire("eGOwo");

var $7KbsS = parcelRequire("7KbsS");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a3170ce3e9e98d41$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cDkKD.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
            label: label,
            testId: testId
        })
    });
};
$a3170ce3e9e98d41$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $a3170ce3e9e98d41$export$2e2bcd8739ae039 = $a3170ce3e9e98d41$var$PageLiveDoc16Icon;

});
parcelRegister("cruFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90efccf3a3cdec59$var$_react = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90efccf3a3cdec59$var$_baseNew = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90efccf3a3cdec59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90efccf3a3cdec59$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $90efccf3a3cdec59$var$_react.default.createElement($90efccf3a3cdec59$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$90efccf3a3cdec59$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $90efccf3a3cdec59$var$_default = module.exports.default = $90efccf3a3cdec59$var$PageLiveDocIcon;

});

parcelRegister("cDkKD", function(module, exports) {
$parcel$export(module.exports, "default", () => $480ad5126b51835b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cruFS = parcelRequire("cruFS");

var $gPsTF = parcelRequire("gPsTF");
function $480ad5126b51835b$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("7KbsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $49cedc712f457d93$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0790382970f68205e1cae24a5f79045>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $49cedc712f457d93$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$49cedc712f457d93$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49cedc712f457d93$export$2e2bcd8739ae039 = $49cedc712f457d93$var$PageLiveDoc16Icon;

});


parcelRegister("hB03j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0bd6bb1ec7db3603$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f200c2eac2cd9165b71d24b95a477cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $cruFS = parcelRequire("cruFS");

var $2291z = parcelRequire("2291z");

var $eGOwo = parcelRequire("eGOwo");

var $kZFQQ = parcelRequire("kZFQQ");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0bd6bb1ec7db3603$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2291z.default), {
        label: label,
        testId: testId,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
            label: label,
            testId: testId
        })
    });
};
$0bd6bb1ec7db3603$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $0bd6bb1ec7db3603$export$2e2bcd8739ae039 = $0bd6bb1ec7db3603$var$PageLiveDoc24Icon;

});
parcelRegister("2291z", function(module, exports) {
$parcel$export(module.exports, "default", () => $87752ca850cdb3ff$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cruFS = parcelRequire("cruFS");

var $lkXQr = parcelRequire("lkXQr");
function $87752ca850cdb3ff$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkXQr.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        color: isBold ? "var(--ds-icon, #44546F)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("kZFQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6dc3d78982b295d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d75248a4a7ee8ec7fdf265d35dbedf6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $b6dc3d78982b295d$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$b6dc3d78982b295d$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6dc3d78982b295d$export$2e2bcd8739ae039 = $b6dc3d78982b295d$var$PageLiveDoc24Icon;

});


parcelRegister("8A134", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8qkPR").then(()=>parcelRequire('dci17'));

});

parcelRegister("6cjQd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbn5L").then(()=>parcelRequire('C9929'));

});

parcelRegister("bCsrc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gKXx1").then(()=>parcelRequire('4KX56'));

});

parcelRegister("brHgq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("76xTz").then(()=>parcelRequire('3Y0kU'));

});

parcelRegister("bNgFX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("7gCMb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("erj8t").then(()=>parcelRequire('amxqt'));

});

parcelRegister("koFqW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zrOr").then(()=>parcelRequire('dtTJ9'));

});

parcelRegister("fUMvo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l1bMV").then(()=>parcelRequire('6b4Xr'));

});

parcelRegister("bAVbi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("fOxQN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Eivj").then(()=>parcelRequire('gbfWz'));

});

parcelRegister("ekbvS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYxgH").then(()=>parcelRequire('dRjRH'));

});

parcelRegister("j0sW6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Asrt").then(()=>parcelRequire('9Vj9G'));

});

parcelRegister("75OGX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lHw2B").then(()=>parcelRequire('eRvGI'));

});

parcelRegister("3aNz8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kjPUS").then(()=>parcelRequire('6l95m'));

});

parcelRegister("4MiqP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iNoMF").then(()=>parcelRequire('fuz0W'));

});

parcelRegister("1Azbr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4oVpa").then(()=>parcelRequire('dn2cU'));

});

parcelRegister("hxTO3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("66VwL").then(()=>parcelRequire('cAlmw'));

});

parcelRegister("lRlMN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("giNlE").then(()=>parcelRequire('9HReW'));

});

parcelRegister("gdaQK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8vZhS").then(()=>parcelRequire('8Pg2Y'));

});

parcelRegister("cH3kb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gLziw")
]).then(()=>parcelRequire('lrD2G'));

});

parcelRegister("4ft1P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Z2q8").then(()=>parcelRequire('ka71P'));

});

parcelRegister("93JYU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kzCMD").then(()=>parcelRequire('kmi1F'));

});




parcelRegister("9020Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9e6bf288701895f$export$2e2bcd8739ae039);

var $ilCAi = parcelRequire("ilCAi");

var $hB03j = parcelRequire("hB03j");

var $cPcks = parcelRequire("cPcks");
const $d9e6bf288701895f$var$LiveDocumentIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ilCAi.default), (0, $hB03j.default));
$d9e6bf288701895f$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $d9e6bf288701895f$export$2e2bcd8739ae039 = $d9e6bf288701895f$var$LiveDocumentIconWithColor;

});


parcelRegister("67ulW", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e2ae224831a17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2HNHt = parcelRequire("2HNHt");

var $65mpR = parcelRequire("65mpR");
const $78e2ae224831a17c$var$styles = {
    roundImg: "_2rko1rr0"
};
const $78e2ae224831a17c$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hcewu.default)([
            appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: url,
        loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $hcewu.default)([
                appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $78e2ae224831a17c$export$2e2bcd8739ae039 = $78e2ae224831a17c$var$ImageIcon;

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("65mpR", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $dc3223680a49307e$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dc3223680a49307e$var$animationNameStyles = null;
const $dc3223680a49307e$var$loadingSkeletonStyle = null;
const $dc3223680a49307e$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hcewu.default)([
            "_2rkolb4i _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("9jYtV", function(module, exports) {
$parcel$export(module.exports, "withOverrideCss", () => $641d28b8590b444f$export$e0bdcacb944f1da6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $641d28b8590b444f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $eJOHy.useRef)(null);
        (0, $eJOHy.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});



parcelRegister("bIdM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b32359b6ff0e19a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $2b32359b6ff0e19a$var$baseBlockStyles = null;
const $2b32359b6ff0e19a$var$highlightRemoveStyles = null;
const $2b32359b6ff0e19a$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $2b32359b6ff0e19a$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2b32359b6ff0e19a$var$Block = ({ children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $eJOHy.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $2b32359b6ff0e19a$var$directionStyles[direction],
            $2b32359b6ff0e19a$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId,
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $2b32359b6ff0e19a$export$2e2bcd8739ae039 = $2b32359b6ff0e19a$var$Block;

});

parcelRegister("k8J0S", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef789dfa4e54c3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $7ef789dfa4e54c3c$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $7ef789dfa4e54c3c$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $7ef789dfa4e54c3c$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $7ef789dfa4e54c3c$var$baseStyles = null;
const $7ef789dfa4e54c3c$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $7ef789dfa4e54c3c$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $7ef789dfa4e54c3c$var$horizontalStyleBase = null;
const $7ef789dfa4e54c3c$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $7ef789dfa4e54c3c$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $7ef789dfa4e54c3c$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $7ef789dfa4e54c3c$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7ef789dfa4e54c3c$var$ElementGroup = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5NtHI.SmartLinkWidth).FitToContent, position: position = (0, $5NtHI.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5NtHI.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7ef789dfa4e54c3c$var$baseStyleBySize[size],
            $7ef789dfa4e54c3c$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $7ef789dfa4e54c3c$var$alignmentStyleMap[align],
            "_1ul99by0",
            $7ef789dfa4e54c3c$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $7ef789dfa4e54c3c$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Left && $7ef789dfa4e54c3c$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Right && $7ef789dfa4e54c3c$var$gapStylesRight[size],
            $7ef789dfa4e54c3c$var$positionStyle[position],
            className
        ]),
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $7ef789dfa4e54c3c$export$2e2bcd8739ae039 = $7ef789dfa4e54c3c$var$ElementGroup;

});



parcelRegister("gKsxm", function(module, exports) {
$parcel$export(module.exports, "default", () => $948e354a880fdc81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $948e354a880fdc81$var$DEFAULT_MAX_LINES = 2;
const $948e354a880fdc81$var$MAXIMUM_MAX_LINES = 2;
const $948e354a880fdc81$var$MINIMUM_MAX_LINES = 1;
const $948e354a880fdc81$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $948e354a880fdc81$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $948e354a880fdc81$var$getMaxLines = (maxLines)=>{
    if (maxLines > $948e354a880fdc81$var$MAXIMUM_MAX_LINES) return $948e354a880fdc81$var$DEFAULT_MAX_LINES;
    if (maxLines < $948e354a880fdc81$var$MINIMUM_MAX_LINES) return $948e354a880fdc81$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $948e354a880fdc81$var$ElementItemRenderer = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5NtHI.SmartLinkSize).Medium, maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $brTAh.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
        align: align,
        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
        width: (0, $5NtHI.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hcewu.default)([
            $948e354a880fdc81$var$truncateStyles[maxLines],
            $948e354a880fdc81$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $948e354a880fdc81$var$MetadataBlock = ({ maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5NtHI.SmartLinkSize).Medium;
    const maxLinesTotal = $948e354a880fdc81$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
};
var $948e354a880fdc81$export$2e2bcd8739ae039 = $948e354a880fdc81$var$MetadataBlock;

});

parcelRegister("8Rjtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $56e117ae59d9b928$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bgqs9 = parcelRequire("bgqs9");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $56e117ae59d9b928$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgqs9.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $56e117ae59d9b928$export$2e2bcd8739ae039 = $56e117ae59d9b928$var$PreviewBlock;

});
parcelRegister("bgqs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7730cb1921d134f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $7Byzo = parcelRequire("7Byzo");

var $bIdM1 = parcelRequire("bIdM1");
const $7730cb1921d134f4$var$previewBlockStyleCommon = null;
const $7730cb1921d134f4$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $7730cb1921d134f4$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)(style ?? {});
    const updateStyles = (0, $eJOHy.useCallback)(()=>{
        if (placement === (0, $5NtHI.MediaPlacement).Left || placement === (0, $5NtHI.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5NtHI.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5NtHI.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $eJOHy.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Byzo.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $7730cb1921d134f4$export$2e2bcd8739ae039 = $7730cb1921d134f4$var$PreviewBlockResolvedView;

});
parcelRegister("7Byzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cb8c392c94261f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4YO5T = parcelRequire("4YO5T");
const $4cb8c392c94261f3$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5NtHI.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4YO5T.default), {
        ...rest,
        ...data
    });
};
var $4cb8c392c94261f3$export$2e2bcd8739ae039 = $4cb8c392c94261f3$var$PreviewElement;

});
parcelRegister("4YO5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7eb4202b966638f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cbSL1 = parcelRequire("cbSL1");

var $5FRJ8 = parcelRequire("5FRJ8");

var $67ulW = parcelRequire("67ulW");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $d7eb4202b966638f$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $d7eb4202b966638f$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FRJ8.useFlexibleUiOptionContext)() : undefined;
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
            hideLoadingSkeleton: ui?.hideLoadingSkeleton,
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $d7eb4202b966638f$export$2e2bcd8739ae039 = $d7eb4202b966638f$var$MediaElement;

});




parcelRegister("5gb8b", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbe48527b965b005$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $5MmSu = parcelRequire("5MmSu");

var $f7w3l = parcelRequire("f7w3l");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
const $fbe48527b965b005$var$DEFAULT_MAX_LINES = 3;
const $fbe48527b965b005$var$MAXIMUM_MAX_LINES = 6;
const $fbe48527b965b005$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $fbe48527b965b005$var$SnippetBlock = ({ maxLines: maxLines = $fbe48527b965b005$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $5FRJ8.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fQH39.getMaxLines)(maxLines, $fbe48527b965b005$var$DEFAULT_MAX_LINES, $fbe48527b965b005$var$MAXIMUM_MAX_LINES, $fbe48527b965b005$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7w3l.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $gt9Am.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet
    });
};
var $fbe48527b965b005$export$2e2bcd8739ae039 = $fbe48527b965b005$var$SnippetBlock;

});
parcelRegister("5MmSu", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkRenderers", () => $8065e50e2bfb34aa$export$c3514c024fefef57);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $8065e50e2bfb34aa$export$c3514c024fefef57 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eJOHy.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("f7w3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5970e5c744f439f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $b5970e5c744f439f$var$snippetBaseStyle = null;
const $b5970e5c744f439f$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $b5970e5c744f439f$export$2e2bcd8739ae039 = $b5970e5c744f439f$var$SnippetElement;

});
parcelRegister("38cBa", function(module, exports) {
$parcel$export(module.exports, "default", () => $6311575d89bb2b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $6311575d89bb2b6b$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $6311575d89bb2b6b$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $fQH39 = parcelRequire("fQH39");
const $6311575d89bb2b6b$var$baseStyle = null;
const $6311575d89bb2b6b$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $6311575d89bb2b6b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $fQH39.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $6311575d89bb2b6b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $awdRS.default)(maxLines)
        },
        children: formattedContent
    });
};
var $6311575d89bb2b6b$export$2e2bcd8739ae039 = $6311575d89bb2b6b$export$79422073c7118b5b;
const $6311575d89bb2b6b$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $6311575d89bb2b6b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});



parcelRegister("2qnEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4a63c55a864af4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $gxvmf = parcelRequire("gxvmf");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $d4a63c55a864af4f$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxvmf.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $d4a63c55a864af4f$export$2e2bcd8739ae039 = $d4a63c55a864af4f$var$AISummaryBlock;

});
parcelRegister("gxvmf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5839dd28b40ea23d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $2LycE = parcelRequire("2LycE");

var $4zxv7 = parcelRequire("4zxv7");

var $ei710 = parcelRequire("ei710");

var $bIdM1 = parcelRequire("bIdM1");

var $cQU20 = parcelRequire("cQU20");
const $5839dd28b40ea23d$var$styles = null;
const $5839dd28b40ea23d$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $4zxv7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $2LycE.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eJOHy.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        direction: (0, $5NtHI.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQU20.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4zxv7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $5839dd28b40ea23d$export$2e2bcd8739ae039 = $5839dd28b40ea23d$var$AISummaryBlockResolvedView;

});
parcelRegister("2LycE", function(module, exports) {
$parcel$export(module.exports, "default", () => $442e3e8f06b649b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9R3Jd = parcelRequire("9R3Jd");
var $3seWH = parcelRequire("3seWH");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $5TXKo = parcelRequire("5TXKo");

var $5sknP = parcelRequire("5sknP");

var $k2hJv = parcelRequire("k2hJv");
const $442e3e8f06b649b8$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $442e3e8f06b649b8$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $k2hJv.useAISummaryConfig)();
    const cardState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $9R3Jd.extractAri)(data);
    const dataUrl = data && (0, $3seWH.extractLink)(data) || '';
    const onStart = (0, $eJOHy.useCallback)((id)=>{
        (0, $1mLfK.startUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eJOHy.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1mLfK.succeedUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eJOHy.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1mLfK.failUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $5sknP.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $442e3e8f06b649b8$export$2e2bcd8739ae039 = $442e3e8f06b649b8$var$useAISummaryAction;

});
parcelRegister("bmWcp", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $b236f5372ffdd3ba$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $928jS = parcelRequire("928jS");
const $b236f5372ffdd3ba$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $928jS.default)(...params));
        event.fire((0, $6462ef276ac974ec$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $6462ef276ac974ec$export$3f072f06b90c3985 = 'media';

parcelRegister("928jS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ac9e1681ec36717$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $5ac9e1681ec36717$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5ac9e1681ec36717$export$2e2bcd8739ae039 = $5ac9e1681ec36717$var$createEventPayload;

});


parcelRegister("1mLfK", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $e01fd61e15160d33$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e01fd61e15160d33$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e01fd61e15160d33$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $e01fd61e15160d33$export$4084c0df4a03a6af);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e01fd61e15160d33$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $e01fd61e15160d33$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9iIu4.ConcurrentExperience)('smart-link-rendered', $e01fd61e15160d33$var$renderExperience),
    'smart-link-authenticated': new (0, $9iIu4.ConcurrentExperience)('smart-link-authenticated', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9iIu4.ConcurrentExperience)('smart-link-action-invocation', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9iIu4.ConcurrentExperience)('smart-link-ai-summary', $e01fd61e15160d33$var$aiExperience)
};
const $e01fd61e15160d33$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $e01fd61e15160d33$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("5TXKo", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $644fcc1916cdb207$export$b0444d00ba7313c6);

var $iHcr1 = parcelRequire("iHcr1");

var $9kfy2 = parcelRequire("9kfy2");
const $644fcc1916cdb207$var$PENDING_STATE = {
    status: 'pending'
};
function $644fcc1916cdb207$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const cardState = (0, $iHcr1.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $644fcc1916cdb207$var$PENDING_STATE;
}

});

parcelRegister("5sknP", function(module, exports) {
$parcel$export(module.exports, "useAISummary", () => $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bI4It = parcelRequire("bI4It");

var $64EXn = parcelRequire("64EXn");
const $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eJOHy.useState)((0, $64EXn.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $64EXn.AISummariesStore).get(url)) (0, $64EXn.AISummariesStore).set(url, new (0, $bI4It.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $64EXn.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $64EXn.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("bI4It", function(module, exports) {
$parcel$export(module.exports, "AISummaryService", () => $ee3df5d12a847ac3$export$73e4b807d5bd74b6);

var $aXKmr = parcelRequire("aXKmr");

var $a5MXk = parcelRequire("a5MXk");

var $4NcaA = parcelRequire("4NcaA");

var $8hWqs = parcelRequire("8hWqs");

var $9ntiN = parcelRequire("9ntiN");
const $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $ee3df5d12a847ac3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
                return (0, $9ntiN.addPath)(baseUrl, $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT);
            }
            return (0, $9ntiN.addPath)('/gateway/api/', $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $4NcaA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $9ntiN.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $8hWqs.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $8hWqs.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("4NcaA", function(module, exports) {
$parcel$export(module.exports, "readStream", () => $3c1ef1a29697a261$export$e45226161c660403);

var $9ntiN = parcelRequire("9ntiN");
async function* $3c1ef1a29697a261$export$e45226161c660403(response) {
    const reader = (0, $9ntiN.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("9ntiN", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $75d74a4f0b187756$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $75d74a4f0b187756$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $75d74a4f0b187756$export$ff2962de2b2c930f);
const $75d74a4f0b187756$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $75d74a4f0b187756$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $75d74a4f0b187756$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $75d74a4f0b187756$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $75d74a4f0b187756$export$ff2962de2b2c930f = (product)=>{
    if ($75d74a4f0b187756$var$isJiraProduct(product)) return $75d74a4f0b187756$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("8hWqs", function(module, exports) {
$parcel$export(module.exports, "ChunkProcessingError", () => $424f983e1007104e$export$fcec967a4b7ebd84);
class $424f983e1007104e$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $424f983e1007104e$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("64EXn", function(module, exports) {
$parcel$export(module.exports, "AISummariesStore", () => $6b567d039eac44f3$export$6979339b6d41707e);

var $7xkt0 = parcelRequire("7xkt0");
const $6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE = 100;
const $6b567d039eac44f3$export$6979339b6d41707e = new (0, $7xkt0.LRUMap)($6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("k2hJv", function(module, exports) {
$parcel$export(module.exports, "useAISummaryConfig", () => $3042bebadd8b2921$export$4480af2c00aa7ebe);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $3042bebadd8b2921$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4zxv7", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e0b0d82c1c1601$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gzZ1I = parcelRequire("gzZ1I");

var $3JG7o = parcelRequire("3JG7o");
const $50e0b0d82c1c1601$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $50e0b0d82c1c1601$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gzZ1I.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3JG7o.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $50e0b0d82c1c1601$export$2e2bcd8739ae039 = $50e0b0d82c1c1601$var$AISummary;

});
parcelRegister("gzZ1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $031d6845af3014cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $031d6845af3014cc$var$t() {
    return $031d6845af3014cc$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $031d6845af3014cc$var$t.apply(this, arguments);
}
const $031d6845af3014cc$var$n = [
    "children",
    "options"
], $031d6845af3014cc$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $031d6845af3014cc$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($031d6845af3014cc$var$i || ($031d6845af3014cc$var$i = {}));
const $031d6845af3014cc$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $031d6845af3014cc$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $031d6845af3014cc$var$o = [
    "style",
    "script"
], $031d6845af3014cc$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $031d6845af3014cc$var$s = /mailto:/i, $031d6845af3014cc$var$d = /\n{2,}$/, $031d6845af3014cc$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $031d6845af3014cc$var$u = /^ *> ?/gm, $031d6845af3014cc$var$f = /^ {2,}\n/, $031d6845af3014cc$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $031d6845af3014cc$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $031d6845af3014cc$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $031d6845af3014cc$var$k = /^(?:\n *)*\n/, $031d6845af3014cc$var$x = /\r\n?/g, $031d6845af3014cc$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $031d6845af3014cc$var$v = /^\[\^([^\]]+)]/, $031d6845af3014cc$var$S = /\f/g, $031d6845af3014cc$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $031d6845af3014cc$var$C = /^\s*?\[(x|\s)\]/, $031d6845af3014cc$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $031d6845af3014cc$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $031d6845af3014cc$var$T = /^<!--[\s\S]*?(?:-->)/, $031d6845af3014cc$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $031d6845af3014cc$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $031d6845af3014cc$var$M = /^\{.*\}$/, $031d6845af3014cc$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $031d6845af3014cc$var$I = /^<([^ >]+@[^ >]+)>/, $031d6845af3014cc$var$U = /^<([^ >]+:\/[^ >]+)>/, $031d6845af3014cc$var$D = /-([a-z])?/gi, $031d6845af3014cc$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $031d6845af3014cc$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $031d6845af3014cc$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $031d6845af3014cc$var$_ = /\t/g, $031d6845af3014cc$var$G = /(^ *\||\| *$)/g, $031d6845af3014cc$var$W = /^ *:-+: *$/, $031d6845af3014cc$var$Z = /^ *:-+ *$/, $031d6845af3014cc$var$q = /^ *-+: *$/, $031d6845af3014cc$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $031d6845af3014cc$var$V = new RegExp(`^([*_])\\1${$031d6845af3014cc$var$Q}\\1\\1(?!\\1)`), $031d6845af3014cc$var$X = new RegExp(`^([*_])${$031d6845af3014cc$var$Q}\\1(?!\\1|\\w)`), $031d6845af3014cc$var$J = new RegExp(`^==${$031d6845af3014cc$var$Q}==`), $031d6845af3014cc$var$K = new RegExp(`^~~${$031d6845af3014cc$var$Q}~~`), $031d6845af3014cc$var$Y = /^\\([^0-9A-Za-z\s])/, $031d6845af3014cc$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $031d6845af3014cc$var$te = /^\n+/, $031d6845af3014cc$var$ne = /^([ \t]*)/, $031d6845af3014cc$var$re = /\\([^\\])/g, $031d6845af3014cc$var$ie = / *\n+$/, $031d6845af3014cc$var$le = /(?:^|\n)( *)$/, $031d6845af3014cc$var$ae = "(?:\\d+\\.)", $031d6845af3014cc$var$oe = "(?:[*+-])";
function $031d6845af3014cc$var$ce(e) {
    return "( *)(" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + ") +";
}
const $031d6845af3014cc$var$se = $031d6845af3014cc$var$ce(1), $031d6845af3014cc$var$de = $031d6845af3014cc$var$ce(2);
function $031d6845af3014cc$var$pe(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de));
}
const $031d6845af3014cc$var$ue = $031d6845af3014cc$var$pe(1), $031d6845af3014cc$var$fe = $031d6845af3014cc$var$pe(2);
function $031d6845af3014cc$var$he(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $031d6845af3014cc$var$me = $031d6845af3014cc$var$he(1), $031d6845af3014cc$var$ge = $031d6845af3014cc$var$he(2);
function $031d6845af3014cc$var$ye(e) {
    const t = 1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $031d6845af3014cc$var$ke = $031d6845af3014cc$var$ye(1), $031d6845af3014cc$var$xe = $031d6845af3014cc$var$ye(2);
function $031d6845af3014cc$var$be(e, t) {
    const n = 1 === t, i = n ? $031d6845af3014cc$var$ke : $031d6845af3014cc$var$xe, l = n ? $031d6845af3014cc$var$me : $031d6845af3014cc$var$ge, a = n ? $031d6845af3014cc$var$ue : $031d6845af3014cc$var$fe;
    return {
        match (e, t) {
            const n = $031d6845af3014cc$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($031d6845af3014cc$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($031d6845af3014cc$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($031d6845af3014cc$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $031d6845af3014cc$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $031d6845af3014cc$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $031d6845af3014cc$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $031d6845af3014cc$var$Ee = [
    $031d6845af3014cc$var$p,
    $031d6845af3014cc$var$m,
    $031d6845af3014cc$var$g,
    $031d6845af3014cc$var$$,
    $031d6845af3014cc$var$z,
    $031d6845af3014cc$var$w,
    $031d6845af3014cc$var$T,
    $031d6845af3014cc$var$j,
    $031d6845af3014cc$var$me,
    $031d6845af3014cc$var$ke,
    $031d6845af3014cc$var$ge,
    $031d6845af3014cc$var$xe
], $031d6845af3014cc$var$Ce = [
    ...$031d6845af3014cc$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $031d6845af3014cc$var$L,
    $031d6845af3014cc$var$B
];
function $031d6845af3014cc$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $031d6845af3014cc$var$we(e) {
    return $031d6845af3014cc$var$q.test(e) ? "right" : $031d6845af3014cc$var$W.test(e) ? "center" : $031d6845af3014cc$var$Z.test(e) ? "left" : null;
}
function $031d6845af3014cc$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $031d6845af3014cc$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $031d6845af3014cc$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($031d6845af3014cc$var$G, "").split("|").map($031d6845af3014cc$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $031d6845af3014cc$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $031d6845af3014cc$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.paragraph
    };
}
function $031d6845af3014cc$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $031d6845af3014cc$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $031d6845af3014cc$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $031d6845af3014cc$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$031d6845af3014cc$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $031d6845af3014cc$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $031d6845af3014cc$var$Ue(e) {
    return e.replace($031d6845af3014cc$var$re, "$1");
}
function $031d6845af3014cc$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $031d6845af3014cc$var$He = (e, t, n)=>({
        children: $031d6845af3014cc$var$De(t, e[1], n)
    });
function $031d6845af3014cc$var$Fe() {
    return {};
}
function $031d6845af3014cc$var$Pe() {
    return null;
}
function $031d6845af3014cc$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $031d6845af3014cc$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $031d6845af3014cc$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $031d6845af3014cc$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $031d6845af3014cc$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $031d6845af3014cc$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $031d6845af3014cc$var$t({}, n, l, {
            className: $031d6845af3014cc$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($031d6845af3014cc$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $031d6845af3014cc$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($031d6845af3014cc$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $eJOHy.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($031d6845af3014cc$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($031d6845af3014cc$var$O) && (e = e.replace($031d6845af3014cc$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $031d6845af3014cc$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($031d6845af3014cc$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($031d6845af3014cc$var$L.test(p) || $031d6845af3014cc$var$B.test(p)) && (n[d] = $eJOHy.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$031d6845af3014cc$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $031d6845af3014cc$export$3e2338ea76b578c9, i.slugify = i.slugify || $031d6845af3014cc$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $031d6845af3014cc$var$t({}, $031d6845af3014cc$var$a, i.namedCodesToUnicode) : $031d6845af3014cc$var$a, i.createElement = i.createElement || $eJOHy.createElement;
    const Z = [], q = {}, Q = {
        [$031d6845af3014cc$export$e0aa44767d8750d5.blockQuote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($031d6845af3014cc$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakLine]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$f),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakThematic]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$h),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeBlock]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $031d6845af3014cc$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeFenced]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeInline]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnoteReference]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $031d6845af3014cc$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.gfmTask]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.heading]: {
            match: $031d6845af3014cc$var$Be(i.enforceAtxHeadings ? $031d6845af3014cc$var$w : $031d6845af3014cc$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[2], n),
                    id: i.slugify(e[2], $031d6845af3014cc$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.headingSetext]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.heading
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($031d6845af3014cc$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $031d6845af3014cc$var$Ce.some((e)=>e.test(c)) ? $031d6845af3014cc$var$Ne : $031d6845af3014cc$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $031d6845af3014cc$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlComment]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$T),
            order: 1,
            parse: ()=>({}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.image]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.link]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$je(t, e[1], n),
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $031d6845af3014cc$var$Te($031d6845af3014cc$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $031d6845af3014cc$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                };
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.orderedList]: $031d6845af3014cc$var$be(d, 1),
        [$031d6845af3014cc$export$e0aa44767d8750d5.unorderedList]: $031d6845af3014cc$var$be(d, 2),
        [$031d6845af3014cc$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$k),
            order: 3,
            parse: $031d6845af3014cc$var$Fe,
            render: ()=>"\n"
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.paragraph]: {
            match: $031d6845af3014cc$var$Re,
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.ref]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refImage]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refLink]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.table]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$j),
            order: 1,
            parse: $031d6845af3014cc$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $031d6845af3014cc$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $031d6845af3014cc$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.text]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($031d6845af3014cc$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textBolded]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEmphasized]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEscaped]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textMarked]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$J),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$K),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock], delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($031d6845af3014cc$var$x, "\n").replace($031d6845af3014cc$var$S, "").replace($031d6845af3014cc$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $031d6845af3014cc$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $031d6845af3014cc$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $031d6845af3014cc$var$n);
    return $eJOHy.cloneElement($031d6845af3014cc$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3JG7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f398c5c3f3cb7e7$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $8f398c5c3f3cb7e7$var$listStyles = null;
const $8f398c5c3f3cb7e7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ...props,
        className: (0, $hcewu.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $8f398c5c3f3cb7e7$export$2e2bcd8739ae039 = $8f398c5c3f3cb7e7$var$UList;

});


parcelRegister("ei710", function(module, exports) {
$parcel$export(module.exports, "default", () => $fda5b98323afadf3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $fda5b98323afadf3$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eJOHy.useState)(0);
    const ref = (0, $eJOHy.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eJOHy.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $fda5b98323afadf3$export$2e2bcd8739ae039 = $fda5b98323afadf3$export$6118ed0013927eb2;

});

parcelRegister("cQU20", function(module, exports) {
$parcel$export(module.exports, "default", () => $f73e03b62ddf95ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $f73e03b62ddf95ac$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f73e03b62ddf95ac$export$2e2bcd8739ae039 = $f73e03b62ddf95ac$var$AIEventSummaryViewed;

});



parcelRegister("eMgzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a57421ef9d4f6376$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $37K19 = parcelRequire("37K19");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $a57421ef9d4f6376$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37K19.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $a57421ef9d4f6376$export$2e2bcd8739ae039 = $a57421ef9d4f6376$var$AIFooterBlock;

});
parcelRegister("37K19", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a90281cb091ec71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $bIdM1 = parcelRequire("bIdM1");

var $kopBz = parcelRequire("kopBz");
const $3a90281cb091ec71$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopBz.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $3a90281cb091ec71$export$2e2bcd8739ae039 = $3a90281cb091ec71$var$AIFooterBlockResolvedView;

});
parcelRegister("kopBz", function(module, exports) {
$parcel$export(module.exports, "AIFooterMetadata", () => $bf118c10e8951921$export$175228cc2c92b3b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fOqNz = parcelRequire("fOqNz");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $19nmp = parcelRequire("19nmp");

var $2LycE = parcelRequire("2LycE");

var $jeUcl = parcelRequire("jeUcl");

var $bB163 = parcelRequire("bB163");
const $bf118c10e8951921$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bB163.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
                label: "AI",
                ...(0, $eGOwo.fg)('navx-1959-remove-custom-ai-icon') ? undefined : {
                    LEGACY_fallbackIcon: (0, $jeUcl.default),
                    LEGACY_size: 'small'
                },
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("fOqNz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cff70d9276c693dca9eb8c1c54a9e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b830502683dea4c7$var$_react = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b830502683dea4c7$var$_baseNew = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b830502683dea4c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b830502683dea4c7$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $b830502683dea4c7$var$_react.default.createElement($b830502683dea4c7$var$_baseNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$b830502683dea4c7$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $b830502683dea4c7$var$_default = module.exports.default = $b830502683dea4c7$var$AtlassianIntelligenceIcon;

});

parcelRegister("jeUcl", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f62baba7cd68ce1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 * @deprecated Use @atlaskit/icon/core/atlassian-intelligence instead.
 * TODO: Remove on navx-1959-remove-custom-ai-icon cleanup
 */ const $9f62baba7cd68ce1$var$AiIcon = (props)=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $9f62baba7cd68ce1$export$2e2bcd8739ae039 = $9f62baba7cd68ce1$var$AiIcon;

});

parcelRegister("bB163", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", () => $ebe2ee8525f34821$export$2957fc44b3d2481);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $klVDP = parcelRequire("klVDP");
const $ebe2ee8525f34821$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $klVDP.default),
        ...props
    });

});
parcelRegister("klVDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f050f94233fcee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $95f050f94233fcee$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $95f050f94233fcee$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $95f050f94233fcee$var$InfoIconGlyph
    });
var $95f050f94233fcee$export$2e2bcd8739ae039 = $95f050f94233fcee$var$InfoIcon;

});





parcelRegister("4cjOx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a174909684ab758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $lHA6U = parcelRequire("lHA6U");

var $1dIgp = parcelRequire("1dIgp");
const $3a174909684ab758$var$ignoreContainerPaddingStyles = null;
const $3a174909684ab758$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $3a174909684ab758$var$sort = (a, b)=>{
    let idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $3a174909684ab758$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $3a174909684ab758$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gRw8I.di)((0, $1dIgp.ActionFooter));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onLoadingChange = (0, $eJOHy.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $3a174909684ab758$export$1af10e3728e3a644(ui?.size || (0, $5NtHI.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eJOHy.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($3a174909684ab758$var$sort);
        return arr.map((name)=>{
            const Action = name in $lHA6U ? $lHA6U[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dIgp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $3a174909684ab758$export$2e2bcd8739ae039 = $3a174909684ab758$var$ActionBlock;

});
parcelRegister("lHA6U", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("9hHCO")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("dckwx")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("c0FsA")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("dGv8r")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("lSW97")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("3MDCL")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("b1dbu")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("cLrUd")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("2fs4B")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("1EoLm")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("bKvNh")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("fd4of")).default);

var $9hHCO = parcelRequire("9hHCO");

var $dckwx = parcelRequire("dckwx");

var $c0FsA = parcelRequire("c0FsA");

var $dGv8r = parcelRequire("dGv8r");

var $lSW97 = parcelRequire("lSW97");

var $3MDCL = parcelRequire("3MDCL");

var $b1dbu = parcelRequire("b1dbu");

var $cLrUd = parcelRequire("cLrUd");

var $2fs4B = parcelRequire("2fs4B");

var $1EoLm = parcelRequire("1EoLm");

var $bKvNh = parcelRequire("bKvNh");

var $fd4of = parcelRequire("fd4of");

});
parcelRegister("9hHCO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2469864747178fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $8ABAe = parcelRequire("8ABAe");

var $fh1oH = parcelRequire("fh1oH");

var $dQnV8 = parcelRequire("dQnV8");

var $cNUXI = parcelRequire("cNUXI");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $c2469864747178fa$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cNUXI.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fh1oH.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ABAe.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $c2469864747178fa$export$2e2bcd8739ae039 = $c2469864747178fa$var$Action;

});
parcelRegister("8ABAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $810b448b0b6757f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $810b448b0b6757f9$var$IconOnlyLarge = null;
const $810b448b0b6757f9$var$SizeSmall = null;
const $810b448b0b6757f9$var$SizeSmallIconOnly = null;
const $810b448b0b6757f9$var$SizeSmallNotIconOnly = null;
const $810b448b0b6757f9$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $810b448b0b6757f9$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $810b448b0b6757f9$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $810b448b0b6757f9$var$ActionButtonRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $eJOHy.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
const $810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss = (0, $9jYtV.withOverrideCss)($810b448b0b6757f9$var$ActionButtonRefresh);
const $810b448b0b6757f9$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            size === (0, $5NtHI.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5NtHI.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5NtHI.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $5NtHI.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fQH39.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $810b448b0b6757f9$var$ActionButton = (props)=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonNew, {
        ...props
    });
};
var $810b448b0b6757f9$export$2e2bcd8739ae039 = $810b448b0b6757f9$var$ActionButton;

});

parcelRegister("fh1oH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4141238200e2a86d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $FoFt2 = parcelRequire("FoFt2");
const $4141238200e2a86d$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $FoFt2.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4141238200e2a86d$export$2e2bcd8739ae039 = $4141238200e2a86d$var$ActionDropdownItem;

});

parcelRegister("dQnV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $182322eb34547fdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $182322eb34547fdc$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$stackItemIconStylesOld = null;
const $182322eb34547fdc$var$stackItemIconStylesCompiled = null;
const $182322eb34547fdc$var$ActionIcon = ({ size: size, testId: testId, icon: icon, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap[$182322eb34547fdc$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $182322eb34547fdc$export$2e2bcd8739ae039 = $182322eb34547fdc$var$ActionIcon;

});

parcelRegister("cNUXI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d23b94a27dbb965d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $e5DLq = parcelRequire("e5DLq");
const $d23b94a27dbb965d$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $d23b94a27dbb965d$export$2e2bcd8739ae039 = $d23b94a27dbb965d$var$ActionStackItem;

});
parcelRegister("e5DLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6dc8e23eec4828$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $fQH39 = parcelRequire("fQH39");

var $dQnV8 = parcelRequire("dQnV8");
const $0d6dc8e23eec4828$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $0d6dc8e23eec4828$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fQH39.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $0d6dc8e23eec4828$export$2e2bcd8739ae039 = $0d6dc8e23eec4828$var$ActionButton;

});



parcelRegister("dckwx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3290b93af8be85b3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6J9k6 = parcelRequire("6J9k6");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $3290b93af8be85b3$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        ...props
    });
var $3290b93af8be85b3$export$2e2bcd8739ae039 = $3290b93af8be85b3$var$DeleteAction;

});

parcelRegister("c0FsA", function(module, exports) {
$parcel$export(module.exports, "default", () => $920fde411498a771$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bp0jd = parcelRequire("bp0jd");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $920fde411498a771$var$EditAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        ...props
    });
var $920fde411498a771$export$2e2bcd8739ae039 = $920fde411498a771$var$EditAction;

});
parcelRegister("bp0jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5f964c14b35b4c00537c8ae369245e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84d244d8a31b5641$var$_react = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84d244d8a31b5641$var$_edit = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $84d244d8a31b5641$var$_edit2 = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("dUYQ5")));
function $84d244d8a31b5641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84d244d8a31b5641$var$EditIcon = (props)=>/*#__PURE__*/ $84d244d8a31b5641$var$_react.default.createElement($84d244d8a31b5641$var$_edit.default, Object.assign({
        name: "EditIcon",
        LEGACY_fallbackIcon: $84d244d8a31b5641$var$_edit2.default
    }, props));
$84d244d8a31b5641$var$EditIcon.displayName = 'EditIconMigration';
var $84d244d8a31b5641$var$_default = module.exports.default = $84d244d8a31b5641$var$EditIcon;

});
parcelRegister("dUYQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21fb2aec03ab384$var$_react = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a21fb2aec03ab384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a21fb2aec03ab384$var$EditIcon = (props)=>/*#__PURE__*/ $a21fb2aec03ab384$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props));
$a21fb2aec03ab384$var$EditIcon.displayName = 'EditIcon';
var $a21fb2aec03ab384$var$_default = module.exports.default = $a21fb2aec03ab384$var$EditIcon;

});



parcelRegister("dGv8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea6a5d6049b9822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kHcBe = parcelRequire("kHcBe");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $bea6a5d6049b9822$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).DownloadAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $19nmp.messages).download_file : (0, $19nmp.messages).download;
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).download_description : (0, $19nmp.messages).download;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $bea6a5d6049b9822$export$2e2bcd8739ae039 = $bea6a5d6049b9822$var$DownloadAction;

});
parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c27208d6ab6791006597f11ce02c72b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        name: "DownloadIcon",
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.displayName = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});


parcelRegister("7xssH", function(module, exports) {
$parcel$export(module.exports, "default", () => $28096ecb360b0e22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $1mLfK = parcelRequire("1mLfK");
const $28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $28096ecb360b0e22$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $eJOHy.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $2QXr6.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1mLfK.startUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $2QXr6.mark(markName, 'resolved');
            (0, $1mLfK.succeedUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $2QXr6.mark(markName, 'errored');
            (0, $1mLfK.failUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $28096ecb360b0e22$export$2e2bcd8739ae039 = $28096ecb360b0e22$var$useInvokeClientAction;

});
parcelRegister("2QXr6", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $a922bc214c753b7c$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $a922bc214c753b7c$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $a922bc214c753b7c$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $a922bc214c753b7c$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $a922bc214c753b7c$export$185802fd694ee1f5);
const $a922bc214c753b7c$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $a922bc214c753b7c$var$hasPerformanceAPIAvailable = $a922bc214c753b7c$var$isPerformanceAPIAvailable();
const $a922bc214c753b7c$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $a922bc214c753b7c$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $a922bc214c753b7c$export$1a717feb4df1a945 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $a922bc214c753b7c$export$de42547d395c8271 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $a922bc214c753b7c$var$getMark = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $a922bc214c753b7c$export$185802fd694ee1f5 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measure = $a922bc214c753b7c$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $a922bc214c753b7c$var$getMark(id, 'pending');
            const endMark = $a922bc214c753b7c$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("lSW97", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe202eda411d4c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $59rsN = parcelRequire("59rsN");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $5UiT3 = parcelRequire("5UiT3");

var $kxXL5 = parcelRequire("kxXL5");


const $dfe202eda411d4c1$var$importIconMapper = {
    goal: ()=>(parcelRequire("iqCse")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("DxrmM")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $dfe202eda411d4c1$var$getIcon = (stackIconType)=>{
    const importFn = $dfe202eda411d4c1$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fQH39.importIcon)(importFn);
};
const $dfe202eda411d4c1$var$FollowAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $19nmp.messages).follow : (0, $19nmp.messages).unfollow;
    const projectMessage = value ? (0, $19nmp.messages).follow_project : (0, $19nmp.messages).unfollow_project;
    const goalMessage = value ? (0, $19nmp.messages).follow_goal : (0, $19nmp.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_project_descriptionGalaxia : (0, $19nmp.messages).follow_project_description : (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_project_descriptionGalaxia : (0, $19nmp.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $19nmp.messages).follow_goal_description : (0, $19nmp.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $dfe202eda411d4c1$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $kxXL5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UiT3.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $dfe202eda411d4c1$export$2e2bcd8739ae039 = $dfe202eda411d4c1$var$FollowAction;

});
parcelRegister("5UiT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce9aaae704363155$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $1rn8a = parcelRequire("1rn8a");

var $9hHCO = parcelRequire("9hHCO");
const $ce9aaae704363155$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const invoke = (0, $6O4ri.default)();
    const reload = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1rn8a.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $d0InI.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ce9aaae704363155$export$2e2bcd8739ae039 = $ce9aaae704363155$var$ServerAction;

});
parcelRegister("6O4ri", function(module, exports) {
$parcel$export(module.exports, "default", () => $b69a1ac7b939ac3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $18BbB = parcelRequire("18BbB");

var $9kfy2 = parcelRequire("9kfy2");
const $b69a1ac7b939ac3b$var$useInvoke = ()=>{
    const { connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const clientExt = (0, $18BbB.useSmartLinkClientExtension)(connections.client);
    return (0, $eJOHy.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b69a1ac7b939ac3b$export$2e2bcd8739ae039 = $b69a1ac7b939ac3b$var$useInvoke;

});
parcelRegister("18BbB", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkClientExtension", () => $365002b9ec3223b9$export$303ede4eed148855);

var $eJOHy = parcelRequire("eJOHy");

var $hhFie = parcelRequire("hhFie");

var $5CgrK = parcelRequire("5CgrK");

var $jAAbh = parcelRequire("jAAbh");
const $365002b9ec3223b9$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $jAAbh.useResolverUrl)(cardClient);
    const invoke = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            return await (0, $hhFie.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $5CgrK.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("5CgrK", function(module, exports) {
$parcel$export(module.exports, "SmartLinkActionType", () => $1ec6011516cb04bd$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $1ec6011516cb04bd$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $1ec6011516cb04bd$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $1ec6011516cb04bd$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("jAAbh", function(module, exports) {
$parcel$export(module.exports, "useResolverUrl", () => $248dfa90412a2e2f$export$d08617a365fbe694);

var $eJOHy = parcelRequire("eJOHy");

var $a5MXk = parcelRequire("a5MXk");
const $248dfa90412a2e2f$export$d08617a365fbe694 = (cardClient)=>(0, $eJOHy.useMemo)(()=>(0, $a5MXk.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("d0InI", function(module, exports) {
$parcel$export(module.exports, "getInvokeFailureReason", () => $842afed3b5601c74$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $842afed3b5601c74$export$1694272377fa07d8);

var $b43DQ = parcelRequire("b43DQ");
const $842afed3b5601c74$export$65b3f792dff0bd60 = (err)=>{
    if (!$842afed3b5601c74$export$1694272377fa07d8(err)) return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $b43DQ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    }
};
const $842afed3b5601c74$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("kbv8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $b139b7122b26d76a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3jSKi = parcelRequire("3jSKi");

var $9kfy2 = parcelRequire("9kfy2");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $99QxN = parcelRequire("99QxN");
const $b139b7122b26d76a$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $99QxN.default)();
    return (0, $eJOHy.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3jSKi.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1mLfK.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b139b7122b26d76a$export$2e2bcd8739ae039 = $b139b7122b26d76a$var$useResolve;

});
parcelRegister("99QxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b217076914baa8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
var $4pUJe = parcelRequire("4pUJe");
var $4g7cp = parcelRequire("4g7cp");

var $5NtHI = parcelRequire("5NtHI");

var $gA511 = parcelRequire("gA511");

const $69b217076914baa8$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eJOHy.useCallback)((url, metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eJOHy.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: url
        }, (0, $gA511.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4g7cp.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fallback', hostname, (0, $9121cfe34e6487d9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fatal', hostname, (0, $9121cfe34e6487d9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('error', hostname, (0, $9121cfe34e6487d9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $aQK2r.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $69b217076914baa8$export$2e2bcd8739ae039 = $69b217076914baa8$var$useResponse;

});
parcelRegister("gA511", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $af7c5b7c4494ebd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $af7c5b7c4494ebd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $af7c5b7c4494ebd5$export$e32193033a594efb);
const $af7c5b7c4494ebd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af7c5b7c4494ebd5$export$2796a804c6e44f63 = ()=>$af7c5b7c4494ebd5$var$emptyData;
const $af7c5b7c4494ebd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });
const $af7c5b7c4494ebd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });

});

const $9121cfe34e6487d9$export$297c39c8b9bfca0 = 'resolving';
const $9121cfe34e6487d9$export$b64a888338c24e0e = 'errored';
const $9121cfe34e6487d9$export$677b6edfa0002c70 = 'fallback';
const $9121cfe34e6487d9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $9121cfe34e6487d9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $9121cfe34e6487d9$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("1rn8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $6426c76052ace8de$export$2e2bcd8739ae039);
const $6426c76052ace8de$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $6426c76052ace8de$export$2e2bcd8739ae039 = $6426c76052ace8de$var$createInvokeRequest;

});


parcelRegister("kxXL5", function(module, exports) {
$parcel$export(module.exports, "getFollowActionErrorMessage", () => $b87644dc5deec150$export$49248678d3914625);

var $59rsN = parcelRequire("59rsN");

var $19nmp = parcelRequire("19nmp");
const $b87644dc5deec150$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_project_errorGalaxia : (0, $19nmp.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_project_errorGalaxia : (0, $19nmp.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $19nmp.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $19nmp.messages).unfollow_goal_error;
    return (0, $19nmp.messages).generic_error_message;
};

});

parcelRegister("iqCse", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3nUhw")
]).then(()=>parcelRequire('k96Yq'));

});

parcelRegister("DxrmM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1877j")
]).then(()=>parcelRequire('c6wmU'));

});


parcelRegister("3MDCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7238a60227ffb9b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1hBh4 = parcelRequire("1hBh4");

var $f4WMd = parcelRequire("f4WMd");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $a7238a60227ffb9b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).preview_description : (0, $19nmp.messages).preview_improved;
    const actionIcon = (0, $eJOHy.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview panel"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        });
    }, [
        hasPreviewPanel
    ]);
    const actionLabel = (0, $eJOHy.useCallback)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_panel
        });
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_modal
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_improved
        });
    }, [
        hasPreviewPanel
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: actionLabel(),
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $a7238a60227ffb9b$export$2e2bcd8739ae039 = $a7238a60227ffb9b$var$PreviewAction;

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2af12b1489cad8386543f983c1a67716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        name: "GrowDiagonalIcon",
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98db7ecf7a88004ad911d912e316fd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});


parcelRegister("f4WMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24c85da433a7def76f682c2e482c8374>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa4d2955554e918$var$_react = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afa4d2955554e918$var$_baseNew = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $afa4d2955554e918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa4d2955554e918$var$PanelRightIcon = (props)=>/*#__PURE__*/ $afa4d2955554e918$var$_react.default.createElement($afa4d2955554e918$var$_baseNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$afa4d2955554e918$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $afa4d2955554e918$var$_default = module.exports.default = $afa4d2955554e918$var$PanelRightIcon;

});


parcelRegister("b1dbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbc64436e41aec7f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $av9Of = parcelRequire("av9Of");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $cbc64436e41aec7f$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_url_to_clipboard);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $19nmp.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $cbc64436e41aec7f$export$2e2bcd8739ae039 = $cbc64436e41aec7f$var$CopyLinkAction;

});

parcelRegister("cLrUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c33132973d68a83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $8c33132973d68a83$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $8c33132973d68a83$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $6qaBj.cx)($8c33132973d68a83$var$styles.message, hasPadding && $8c33132973d68a83$var$styles.padding),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c33132973d68a83$var$styles.button,
        children: message
    }) : message;
};
var $8c33132973d68a83$export$2e2bcd8739ae039 = $8c33132973d68a83$var$UnresolvedAction;

});

parcelRegister("2fs4B", function(module, exports) {
$parcel$export(module.exports, "default", () => $b30a89f78a7b1395$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3IFDE = parcelRequire("3IFDE");
const $b30a89f78a7b1395$var$AISummaryAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IFDE.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b30a89f78a7b1395$export$2e2bcd8739ae039 = $b30a89f78a7b1395$var$AISummaryAction;

});
parcelRegister("3IFDE", function(module, exports) {
$parcel$export(module.exports, "AISummaryActionComponent", () => $f1effd59dd51917b$export$8eed96bc6d982595);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $4N9mw = parcelRequire("4N9mw");

var $9ljdO = parcelRequire("9ljdO");
const $f1effd59dd51917b$export$8eed96bc6d982595 = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $2LycE.default)(url);
    (0, $eJOHy.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ljdO.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4N9mw.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("4N9mw", function(module, exports) {
$parcel$export(module.exports, "AISummariseAction", () => $74950477f844069d$export$75a19de44af58722);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fOqNz = parcelRequire("fOqNz");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $jeUcl = parcelRequire("jeUcl");

var $9hHCO = parcelRequire("9hHCO");

var $4XsCU = parcelRequire("4XsCU");
function $74950477f844069d$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onCompleted = (0, $eJOHy.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $4XsCU.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            ...(0, $eGOwo.fg)('navx-1959-remove-custom-ai-icon') ? undefined : {
                LEGACY_fallbackIcon: (0, $jeUcl.default)
            }
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("4XsCU", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $97c2d7f54971c4db$export$82f46aa4e6535a45);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7tQSx = parcelRequire("7tQSx");

var $2Q7aM = parcelRequire("2Q7aM");

var $hDtQ6 = parcelRequire("hDtQ6");
const $97c2d7f54971c4db$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $7tQSx.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Q7aM.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDtQ6.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("7tQSx", function(module, exports) {
$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9b4bccd413fec8a7$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9b4bccd413fec8a7$export$cd2e891d7f87074d);

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $9b4bccd413fec8a7$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $9b4bccd413fec8a7$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $19nmp.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5NtHI.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $19nmp.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $19nmp.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $19nmp.messages).ai_summary_error_generic,
                url: (0, $5NtHI.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2Q7aM", function(module, exports) {
$parcel$export(module.exports, "default", () => $af835e3708ee9394$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $af835e3708ee9394$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $af835e3708ee9394$export$2e2bcd8739ae039 = $af835e3708ee9394$var$AIEventErrorViewed;

});

parcelRegister("hDtQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4df7b5a8aadcea38$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5NtHI = parcelRequire("5NtHI");
const $4df7b5a8aadcea38$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: (0, $5NtHI.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $4df7b5a8aadcea38$export$2e2bcd8739ae039 = $4df7b5a8aadcea38$var$AILearnMoreAnchor;

});



parcelRegister("9ljdO", function(module, exports) {
$parcel$export(module.exports, "CopySummaryAction", () => $d9ba8f475ac91e83$export$cfa1d3eed9a61059);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4TA31 = parcelRequire("4TA31");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
function $d9ba8f475ac91e83$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eJOHy.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $19nmp.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.displayName = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});





parcelRegister("1EoLm", function(module, exports) {
$parcel$export(module.exports, "default", () => $807f9b07437985a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $dtpha = parcelRequire("dtpha");

var $3cMgR = parcelRequire("3cMgR");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $4iE29 = parcelRequire("4iE29");

var $kkF5t = parcelRequire("kkF5t");

const $807f9b07437985a7$var$AutomationModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lCy2I")));
const $807f9b07437985a7$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const modal = (0, $fezTc.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5NtHI.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eJOHy.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $kkF5t.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($807f9b07437985a7$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $19nmp.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4iE29.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $807f9b07437985a7$export$2e2bcd8739ae039 = $807f9b07437985a7$var$AutomationAction;

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("fezTc", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalProvider", () => $a8c10a96c4151b39$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7JfLF = parcelRequire("7JfLF");
const $a8c10a96c4151b39$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a8c10a96c4151b39$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($a8c10a96c4151b39$var$FALLBACK_API);
const $a8c10a96c4151b39$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JfLF.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eJOHy.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8 = ()=>(0, $eJOHy.useContext)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c);

});
parcelRegister("7JfLF", function(module, exports) {
$parcel$export(module.exports, "StopPropagation", () => $7b6d8602f75ebf94$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $7b6d8602f75ebf94$var$styles = {
    pressable: "_c71lidpf _p12fidpf _kqswstnw"
};
const $7b6d8602f75ebf94$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: $7b6d8602f75ebf94$var$styles.pressable,
        onClick: onClick,
        children: children
    });
};

});


parcelRegister("4iE29", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe410232594ccf2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1fe410232594ccf2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1fe410232594ccf2$export$2e2bcd8739ae039 = $1fe410232594ccf2$var$AutomationManualTriggersGlyph;

});

parcelRegister("kkF5t", function(module, exports) {
$parcel$export(module.exports, "getModalContent", () => $c38c894acd6bcefe$export$93e707b363eaf5c8);

var $19nmp = parcelRequire("19nmp");
const $c38c894acd6bcefe$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $19nmp.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $19nmp.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("lCy2I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVzfx")
]).then(()=>parcelRequire('kczS3'));

});


parcelRegister("bKvNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8cb4fc04a0fca0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $8wmgQ = parcelRequire("8wmgQ");

const $1f8cb4fc04a0fca0$var$RelatedLinksModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("km9Nb")));
const $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $fezTc.useSmartLinkModal)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($1f8cb4fc04a0fca0$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).related_links_view_related_links
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wmgQ.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $1f8cb4fc04a0fca0$export$2e2bcd8739ae039 = $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction;

});
parcelRegister("8wmgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c344254860ed9d13$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");
const $c344254860ed9d13$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    });
var $c344254860ed9d13$export$2e2bcd8739ae039 = $c344254860ed9d13$var$RelatedLinksActionIcon;

});

parcelRegister("km9Nb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ojIT").then(()=>parcelRequire('3cErl'));

});


parcelRegister("fd4of", function(module, exports) {
$parcel$export(module.exports, "default", () => $875ad99f72c777d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $875ad99f72c777d8$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $875ad99f72c777d8$var$validErrorStatuses = [
    (0, $5NtHI.SmartLinkStatus).Forbidden,
    (0, $5NtHI.SmartLinkStatus).Unauthorized
];
const $875ad99f72c777d8$var$validateErrorStatus = (status)=>{
    return status !== undefined && $875ad99f72c777d8$var$validErrorStatuses.includes(status);
};
const $875ad99f72c777d8$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$875ad99f72c777d8$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $875ad99f72c777d8$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $875ad99f72c777d8$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $875ad99f72c777d8$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...messageDescriptor,
            values: values
        })
    });
    const component = hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $875ad99f72c777d8$var$styles.button,
        children: message
    }) : message;
    return Container ? /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        children: component
    }) : component;
};
var $875ad99f72c777d8$export$2e2bcd8739ae039 = $875ad99f72c777d8$var$CustomUnresolvedAction;

});


parcelRegister("1dIgp", function(module, exports) {
$parcel$export(module.exports, "ActionFooter", () => $495d2943b4977c6a$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $ei710 = parcelRequire("ei710");
const $495d2943b4977c6a$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $495d2943b4977c6a$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $495d2943b4977c6a$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $495d2943b4977c6a$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $495d2943b4977c6a$var$styles.errorContentStyles,
                children: [
                    message.icon || $495d2943b4977c6a$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $495d2943b4977c6a$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});



parcelRegister("4RG9i", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("9Xcvc")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("41Mwl")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("lVTJZ")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("gl0Fx")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("iCDdz")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("cSuZU")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("gA3VJ")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("aiy2i")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("k4xpX")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("kCe9K")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("kB4Nm")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jPfaa")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("2Bqsd")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("1FNi6")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("81kl8")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("946bQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("4Nd99")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("7Byzo")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("5kUaD")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("8MxlB")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6l7Bk")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("lwvSM")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2ITMK")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("iw2r2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("f7w3l")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("6Po2h")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("4U5iq")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("jJD7c")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("7mGkc")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("w1OaX")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("cwvSG")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("2j4b1")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("i6ktq")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("iQvIm")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("bApaO")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("1IQ2A")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("lJDNU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("i4NpI")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("5d1ks")).default);

var $9Xcvc = parcelRequire("9Xcvc");

var $41Mwl = parcelRequire("41Mwl");

var $lVTJZ = parcelRequire("lVTJZ");

var $gl0Fx = parcelRequire("gl0Fx");

var $iCDdz = parcelRequire("iCDdz");

var $cSuZU = parcelRequire("cSuZU");

var $gA3VJ = parcelRequire("gA3VJ");

var $aiy2i = parcelRequire("aiy2i");

var $k4xpX = parcelRequire("k4xpX");

var $kCe9K = parcelRequire("kCe9K");

var $kB4Nm = parcelRequire("kB4Nm");

var $jPfaa = parcelRequire("jPfaa");

var $2Bqsd = parcelRequire("2Bqsd");

var $1FNi6 = parcelRequire("1FNi6");

var $81kl8 = parcelRequire("81kl8");

var $946bQ = parcelRequire("946bQ");

var $4Nd99 = parcelRequire("4Nd99");

var $7Byzo = parcelRequire("7Byzo");

var $5kUaD = parcelRequire("5kUaD");

var $8MxlB = parcelRequire("8MxlB");

var $6l7Bk = parcelRequire("6l7Bk");

var $lwvSM = parcelRequire("lwvSM");

var $2ITMK = parcelRequire("2ITMK");

var $iw2r2 = parcelRequire("iw2r2");

var $f7w3l = parcelRequire("f7w3l");

var $6Po2h = parcelRequire("6Po2h");

var $4U5iq = parcelRequire("4U5iq");

var $jJD7c = parcelRequire("jJD7c");

var $7mGkc = parcelRequire("7mGkc");

var $w1OaX = parcelRequire("w1OaX");

var $cwvSG = parcelRequire("cwvSG");

var $2j4b1 = parcelRequire("2j4b1");

var $i6ktq = parcelRequire("i6ktq");

var $iQvIm = parcelRequire("iQvIm");

var $bApaO = parcelRequire("bApaO");

var $1IQ2A = parcelRequire("1IQ2A");

var $lJDNU = parcelRequire("lJDNU");

var $i4NpI = parcelRequire("i4NpI");

var $5d1ks = parcelRequire("5d1ks");

});
parcelRegister("9Xcvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e65e4967ed5bbb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $68e65e4967ed5bbb$var$AssignedToElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedTo
    }) : null;
};
var $68e65e4967ed5bbb$export$2e2bcd8739ae039 = $68e65e4967ed5bbb$var$AssignedToElement;

});

parcelRegister("41Mwl", function(module, exports) {
$parcel$export(module.exports, "default", () => $54562c55fd1b3586$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $54562c55fd1b3586$var$AssignedToGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedToGroup
    }) : null;
};
var $54562c55fd1b3586$export$2e2bcd8739ae039 = $54562c55fd1b3586$var$AssignedToGroupElement;

});
parcelRegister("vUns3", function(module, exports) {
$parcel$export(module.exports, "default", () => $672b014d8429d73d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $672b014d8429d73d$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $gqBnP = parcelRequire("gqBnP");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $fQH39 = parcelRequire("fQH39");
const $672b014d8429d73d$var$styles = null;
const $672b014d8429d73d$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5NtHI.ElementName).AssignedToGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).assigned_to, personName);
        case (0, $5NtHI.ElementName).OwnedByGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).owned_by, personName);
        case (0, $5NtHI.ElementName).AuthorGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $672b014d8429d73d$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $lRq8t.default)();
    const data = (0, $eJOHy.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5NtHI.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $672b014d8429d73d$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $eGOwo.fg)('platform-linking-enable-avatar-data-separator') ? {
            ['data-separator']: true
        } : {},
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $672b014d8429d73d$export$2e2bcd8739ae039 = $672b014d8429d73d$var$BaseAvatarGroup;
const $672b014d8429d73d$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("lVTJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca273e569a0c1d25$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $ca273e569a0c1d25$var$AttachmentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AttachmentCount
    }) : null;
};
var $ca273e569a0c1d25$export$2e2bcd8739ae039 = $ca273e569a0c1d25$var$AttachmentCountElement;

});

parcelRegister("gl0Fx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5186dee07e48afde$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $5186dee07e48afde$var$AuthorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AuthorGroup
    }) : null;
};
var $5186dee07e48afde$export$2e2bcd8739ae039 = $5186dee07e48afde$var$AuthorGroupElement;

});

parcelRegister("iCDdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e60145f3c4ab217$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $0e60145f3c4ab217$var$ChecklistProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }) : null;
};
var $0e60145f3c4ab217$export$2e2bcd8739ae039 = $0e60145f3c4ab217$var$ChecklistProgressElement;

});

parcelRegister("cSuZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3e78c51e7c53936$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $b3e78c51e7c53936$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CollaboratorGroup
    }) : null;
};
var $b3e78c51e7c53936$export$2e2bcd8739ae039 = $b3e78c51e7c53936$var$CollaboratorGroupElement;

});

parcelRegister("gA3VJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55e7c0307b507f46$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $55e7c0307b507f46$var$CommentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).CommentCount
    }) : null;
};
var $55e7c0307b507f46$export$2e2bcd8739ae039 = $55e7c0307b507f46$var$CommentCountElement;

});

parcelRegister("aiy2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $932490ed3e7f327b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $932490ed3e7f327b$var$CreatedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedOn
    }) : null;
};
var $932490ed3e7f327b$export$2e2bcd8739ae039 = $932490ed3e7f327b$var$CreatedOnElement;

});
parcelRegister("aKX5a", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb039ade903c50b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $cb039ade903c50b2$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wSDf = parcelRequire("6wSDf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $19nmp = parcelRequire("19nmp");
const $cb039ade903c50b2$var$styles = null;
const $cb039ade903c50b2$var$typeToDescriptorMap = {
    created: {
        relative: (0, $19nmp.messages).created_on_relative,
        absolute: (0, $19nmp.messages).created_on_absolute
    },
    modified: {
        relative: (0, $19nmp.messages).modified_on_relative,
        absolute: (0, $19nmp.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $19nmp.messages).sent_on_relative,
        absolute: (0, $19nmp.messages).sent_on_absolute
    }
};
const $cb039ade903c50b2$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $cb039ade903c50b2$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $lRq8t.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $6wSDf.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...$cb039ade903c50b2$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $cb039ade903c50b2$var$fontOverrideStyleMap[fontSize],
            className
        ]),
        children: content
    });
};
var $cb039ade903c50b2$export$2e2bcd8739ae039 = $cb039ade903c50b2$var$BaseDateTimeElement;
const $cb039ade903c50b2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("k4xpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f3b49272a6afc71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $3f3b49272a6afc71$var$CreatedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedBy
    }) : null;
};
var $3f3b49272a6afc71$export$2e2bcd8739ae039 = $3f3b49272a6afc71$var$CreatedByElement;

});

parcelRegister("kCe9K", function(module, exports) {
$parcel$export(module.exports, "default", () => $805a1aa3004ae832$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $805a1aa3004ae832$var$DueOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $cmzNL.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).DueOn
    }) : null;
};
var $805a1aa3004ae832$export$2e2bcd8739ae039 = $805a1aa3004ae832$var$DueOnElement;

});
parcelRegister("cmzNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $351b36f187c69d22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $351b36f187c69d22$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4Frd9 = parcelRequire("4Frd9");
const $351b36f187c69d22$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $351b36f187c69d22$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Frd9.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $351b36f187c69d22$export$2e2bcd8739ae039 = $351b36f187c69d22$var$BaseLozengeElement;
const $351b36f187c69d22$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qGN1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("4Frd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9074bb98cbadc69e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $EtcI0 = parcelRequire("EtcI0");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $CpyFM = parcelRequire("CpyFM");

var $b43DQ = parcelRequire("b43DQ");

var $hxkmu = parcelRequire("hxkmu");

var $e9seM = parcelRequire("e9seM");

var $5iuU7 = parcelRequire("5iuU7");

var $4dVhH = parcelRequire("4dVhH");

var $htuxE = parcelRequire("htuxE");

var $dsXZb = parcelRequire("dsXZb");
const $9074bb98cbadc69e$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9074bb98cbadc69e$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eJOHy.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [items, setItems] = (0, $eJOHy.useState)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)();
    const reload = (0, $kbv8x.default)();
    const invoke = (0, $6O4ri.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $eJOHy.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $EtcI0.default));
                const validItems = typeof text === 'string' ? $9074bb98cbadc69e$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $4dVhH.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $4dVhH.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsXZb.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $CpyFM.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $d0InI.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $eJOHy.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5iuU7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htuxE.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $9074bb98cbadc69e$export$2e2bcd8739ae039 = (0, $hxkmu.default)($9074bb98cbadc69e$var$LozengeAction);

});
parcelRegister("EtcI0", function(module, exports) {
$parcel$export(module.exports, "default", () => $377731e831492625$export$2e2bcd8739ae039);
const $377731e831492625$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $377731e831492625$export$2e2bcd8739ae039 = $377731e831492625$var$extractLozengeActionItems;

});

parcelRegister("CpyFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb2d7fc7fdf8041$export$2e2bcd8739ae039);
const $7cb2d7fc7fdf8041$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $7cb2d7fc7fdf8041$export$2e2bcd8739ae039 = $7cb2d7fc7fdf8041$var$createStatusUpdateRequest;

});

parcelRegister("hxkmu", function(module, exports) {
$parcel$export(module.exports, "default", () => $808be4e18c85f3f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $808be4e18c85f3f4$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: props?.appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };
var $808be4e18c85f3f4$export$2e2bcd8739ae039 = $808be4e18c85f3f4$var$withErrorBoundary;

});

parcelRegister("e9seM", function(module, exports) {
$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$618660b8f2aa87e2);
const $20533813e4fe1916$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $20533813e4fe1916$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $20533813e4fe1916$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $20533813e4fe1916$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("5iuU7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bafe1b037124149$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $7xssH = parcelRequire("7xssH");

var $fQH39 = parcelRequire("fQH39");
const $1bafe1b037124149$var$MAX_LINE_NUMBER = 8;
const $1bafe1b037124149$var$styles = {
    contentStyles: "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c82smr _bfhk18uv _1bah1e5h _1e0c1kw7 _syaz14q2 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l316c2"
};
const $1bafe1b037124149$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $1bafe1b037124149$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const invoke = (0, $7xssH.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $eJOHy.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.contentStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $hcewu.default)([
                                $1bafe1b037124149$var$styles.textStylesBase,
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $awdRS.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fQH39.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.linkStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                        testId: `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        xcss: $1bafe1b037124149$var$styles.openIssueInJiraStyles,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hcewu.default)([
            $1bafe1b037124149$var$styles.dropdownItemGroupStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $1bafe1b037124149$export$2e2bcd8739ae039 = $1bafe1b037124149$var$LozengeActionError;

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("4dVhH", function(module, exports) {
$parcel$export(module.exports, "LozengeActionErrorMessages", () => $d6614d1ef8f5be72$export$4f2e371a667ad688);

var $19nmp = parcelRequire("19nmp");
const $d6614d1ef8f5be72$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $19nmp.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $19nmp.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $19nmp.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $19nmp.messages)['status_change_update_error']
    }
};

});

parcelRegister("htuxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $df529be6a716333d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aLJ1L = parcelRequire("aLJ1L");

var $aDuBe = parcelRequire("aDuBe");
const $df529be6a716333d$var$dropdownItemGroupStyles = null;
const $df529be6a716333d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hcewu.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $aDuBe.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $df529be6a716333d$export$2e2bcd8739ae039 = $df529be6a716333d$var$LozengeActionItemsGroup;

});
parcelRegister("aDuBe", function(module, exports) {
$parcel$export(module.exports, "default", () => $f377c3a55bec1fd7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $f377c3a55bec1fd7$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        role: "presentation",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $f377c3a55bec1fd7$export$2e2bcd8739ae039 = $f377c3a55bec1fd7$var$LozengeActionItem;

});


parcelRegister("dsXZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d29b99195ec403c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $8d29b99195ec403c$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $8d29b99195ec403c$var$triggerLozengeStyles = null;
const $8d29b99195ec403c$var$triggerButtonStyles = null;
const $8d29b99195ec403c$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $eJOHy.useState)(false);
    const [isPressing, setIsPressing] = (0, $eJOHy.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $eJOHy.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $eJOHy.useState)(undefined);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $eJOHy.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $eJOHy.useCallback)(()=>setIsPressing(false), []);
    (0, $eJOHy.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)($8d29b99195ec403c$var$styles.lozengeContainer, (isOpen || isPressing) && $8d29b99195ec403c$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                    className: (0, $hcewu.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $8d29b99195ec403c$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small",
                                "aria-hidden": true
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $8d29b99195ec403c$export$2e2bcd8739ae039 = $8d29b99195ec403c$var$LozengeActionTrigger;

});




parcelRegister("kB4Nm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e36aa41e9ad3ded$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $9e36aa41e9ad3ded$var$LatestCommitElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LatestCommit
    }) : null;
};
var $9e36aa41e9ad3ded$export$2e2bcd8739ae039 = $9e36aa41e9ad3ded$var$LatestCommitElement;

});

parcelRegister("jPfaa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3002c31f53401640$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $d6nZP = parcelRequire("d6nZP");
const $3002c31f53401640$var$LinkIconElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context) return null;
    const data = (0, $d6nZP.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LinkIcon
    }) : null;
};
var $3002c31f53401640$export$2e2bcd8739ae039 = $3002c31f53401640$var$LinkIconElement;

});
parcelRegister("d6nZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a220f00187bff59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $7a220f00187bff59$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $fQH39 = parcelRequire("fQH39");
const $7a220f00187bff59$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7a220f00187bff59$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7a220f00187bff59$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $7a220f00187bff59$var$renderAtlaskitIcon = (icon, testId, size = (0, $5NtHI.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $7a220f00187bff59$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7a220f00187bff59$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5NtHI.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5NtHI.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7a220f00187bff59$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5NtHI.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $eJOHy.useMemo)(()=>{
        const defaultIcon = $7a220f00187bff59$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7a220f00187bff59$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton) || $7a220f00187bff59$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7a220f00187bff59$var$styles.container,
            $7a220f00187bff59$var$positionStyleMap[position],
            render && $7a220f00187bff59$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $7a220f00187bff59$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $7a220f00187bff59$export$2e2bcd8739ae039 = $7a220f00187bff59$var$IconElement;
const $7a220f00187bff59$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $FoFt2.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("2Bqsd", function(module, exports) {
$parcel$export(module.exports, "default", () => $684e70f9d4a0e20c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $684e70f9d4a0e20c$var$LocationElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        theme: (0, $5NtHI.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Location
    }) : null;
};
var $684e70f9d4a0e20c$export$2e2bcd8739ae039 = $684e70f9d4a0e20c$var$LocationElement;

});

parcelRegister("1FNi6", function(module, exports) {
$parcel$export(module.exports, "default", () => $59cc5cb27d2f6980$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $59cc5cb27d2f6980$var$ModifiedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ModifiedBy
    }) : null;
};
var $59cc5cb27d2f6980$export$2e2bcd8739ae039 = $59cc5cb27d2f6980$var$ModifiedByElement;

});

parcelRegister("81kl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b4cff059a6d0796$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $5b4cff059a6d0796$var$ModifiedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ModifiedOn
    }) : null;
};
var $5b4cff059a6d0796$export$2e2bcd8739ae039 = $5b4cff059a6d0796$var$ModifiedOnElement;

});

parcelRegister("946bQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $36681a63387d26b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $36681a63387d26b9$var$OwnedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages)[textPrefix], context?.ownedBy) : null;
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedBy
    }) : null;
};
var $36681a63387d26b9$export$2e2bcd8739ae039 = $36681a63387d26b9$var$OwnedByElement;

});

parcelRegister("4Nd99", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ab17b3f9ac16f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $d0ab17b3f9ac16f4$var$OwnedByGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedByGroup
    }) : null;
};
var $d0ab17b3f9ac16f4$export$2e2bcd8739ae039 = $d0ab17b3f9ac16f4$var$OwnedByGroupElement;

});

parcelRegister("5kUaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb8efb6535893df$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $8cb8efb6535893df$var$PriorityElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Priority
    }) : null;
};
var $8cb8efb6535893df$export$2e2bcd8739ae039 = $8cb8efb6535893df$var$PriorityElement;

});

parcelRegister("8MxlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $12bbc9fa6baf6ce0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ProgrammingLanguage
    }) : null;
};
var $12bbc9fa6baf6ce0$export$2e2bcd8739ae039 = $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement;

});

parcelRegister("lwvSM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c70b57958761eec$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $1c70b57958761eec$var$ReactCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ReactCount
    }) : null;
};
var $1c70b57958761eec$export$2e2bcd8739ae039 = $1c70b57958761eec$var$ReactCountElement;

});

parcelRegister("2ITMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2d9d65227b56648$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b2d9d65227b56648$var$ReadTimeElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ReadTime
    }) : null;
};
var $b2d9d65227b56648$export$2e2bcd8739ae039 = $b2d9d65227b56648$var$ReadTimeElement;

});

parcelRegister("iw2r2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e6bf42d4a97c401$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $0e6bf42d4a97c401$var$SentOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SentOn
    }) : null;
};
var $0e6bf42d4a97c401$export$2e2bcd8739ae039 = $0e6bf42d4a97c401$var$SentOnElement;

});

parcelRegister("6Po2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7164a95a609845f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $f7164a95a609845f$var$SourceBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SourceBranch
    }) : null;
};
var $f7164a95a609845f$export$2e2bcd8739ae039 = $f7164a95a609845f$var$SourceBranchElement;

});

parcelRegister("4U5iq", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd8773a8f5d6e97c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $cd8773a8f5d6e97c$var$StateElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).State
    }) : null;
};
var $cd8773a8f5d6e97c$export$2e2bcd8739ae039 = $cd8773a8f5d6e97c$var$StateElement;

});

parcelRegister("jJD7c", function(module, exports) {
$parcel$export(module.exports, "default", () => $e661b354f8faff8b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $e661b354f8faff8b$var$SubscriberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubscriberCount
    }) : null;
};
var $e661b354f8faff8b$export$2e2bcd8739ae039 = $e661b354f8faff8b$var$SubscriberCountElement;

});

parcelRegister("7mGkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $da8be0e62ff3be52$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $da8be0e62ff3be52$var$SubTasksProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubTasksProgress
    }) : null;
};
var $da8be0e62ff3be52$export$2e2bcd8739ae039 = $da8be0e62ff3be52$var$SubTasksProgressElement;

});

parcelRegister("w1OaX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da98c25506acfc3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hTi78 = parcelRequire("hTi78");
const $6da98c25506acfc3$var$StoryPointsElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $hTi78.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hTi78.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).StoryPoints
    }) : null;
};
var $6da98c25506acfc3$export$2e2bcd8739ae039 = $6da98c25506acfc3$var$StoryPointsElement;

});
parcelRegister("hTi78", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fb2764f8e50f778$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $5fb2764f8e50f778$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");
const $5fb2764f8e50f778$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $5fb2764f8e50f778$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
            children: value
        })
    });
};
var $5fb2764f8e50f778$export$2e2bcd8739ae039 = $5fb2764f8e50f778$var$BaseAtlaskitElementBadge;
const $5fb2764f8e50f778$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("cwvSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $44a8674c49925bc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $44a8674c49925bc5$var$TargetBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TargetBranch
    }) : null;
};
var $44a8674c49925bc5$export$2e2bcd8739ae039 = $44a8674c49925bc5$var$TargetBranchElement;

});

parcelRegister("2j4b1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee83b62dd045c6fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $ee83b62dd045c6fd$var$TeamMemberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT ? `${$ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TeamMemberCount
    }) : null;
};
var $ee83b62dd045c6fd$export$2e2bcd8739ae039 = $ee83b62dd045c6fd$var$TeamMemberCountElement;

});

parcelRegister("iQvIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $13574bab0abb9b76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $13574bab0abb9b76$var$UserAttributesElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5NtHI.ElementName).UserAttributes
                }, key));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: elements
    }) : null;
};
var $13574bab0abb9b76$export$2e2bcd8739ae039 = $13574bab0abb9b76$var$UserAttributesElement;

});

parcelRegister("bApaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $32db5b76dc584a40$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $32db5b76dc584a40$var$ViewCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).View,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ViewCount
    }) : null;
};
var $32db5b76dc584a40$export$2e2bcd8739ae039 = $32db5b76dc584a40$var$ViewCountElement;

});

parcelRegister("1IQ2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $49df200106082223$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $49df200106082223$var$VoteCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).VoteCount
    }) : null;
};
var $49df200106082223$export$2e2bcd8739ae039 = $49df200106082223$var$VoteCountElement;

});

parcelRegister("lJDNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b64afcea66b05029$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $b64afcea66b05029$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $19nmp.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Component,
        label: label,
        ...props
    });
};
var $b64afcea66b05029$export$2e2bcd8739ae039 = $b64afcea66b05029$var$AppliedToComponentsCountElement;

});

parcelRegister("i4NpI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e868f1df007f5c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $7e868f1df007f5c9$var$baseStyle = null;
const $7e868f1df007f5c9$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(x);
const $7e868f1df007f5c9$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $7e868f1df007f5c9$var$maxLinesCss = null;
const $7e868f1df007f5c9$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]?.values;
    if ($7e868f1df007f5c9$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $7e868f1df007f5c9$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ]),
        children: contentForAccessType
    });
};
var $7e868f1df007f5c9$export$2e2bcd8739ae039 = $7e868f1df007f5c9$var$CustomElementByAccessType;

});

parcelRegister("5d1ks", function(module, exports) {
$parcel$export(module.exports, "default", () => $255ff319c604874a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");
const $255ff319c604874a$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        children: component
    });
};
var $255ff319c604874a$export$2e2bcd8739ae039 = $255ff319c604874a$var$CustomByStatusElement;

});




parcelRegister("a86OV", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c0c5c54b91a954$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lHA6U = parcelRequire("lHA6U");
const $26c0c5c54b91a954$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $lHA6U ? $lHA6U[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $26c0c5c54b91a954$export$2e2bcd8739ae039 = $26c0c5c54b91a954$var$ActionGroupItem;

});


parcelRegister("gjoE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9925dc77e1d9b77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cLrUd = parcelRequire("cLrUd");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");
const $e9925dc77e1d9b77$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $e9925dc77e1d9b77$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position
            }),
            competitorPrompt ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $e9925dc77e1d9b77$var$styles.titleBoxCard,
                children: [
                    title,
                    competitorPrompt
                ]
            }) : title,
            showRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cLrUd.default), {
                    testId: testId
                })
            }),
            actionGroup
        ]
    });
};
var $e9925dc77e1d9b77$export$2e2bcd8739ae039 = $e9925dc77e1d9b77$var$TitleBlockErroredView;

});

parcelRegister("haRRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bf1e0846d3cab95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $3bf1e0846d3cab95$var$style = null;
const $3bf1e0846d3cab95$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $3bf1e0846d3cab95$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $brTAh.renderElementItems)(metadata);
    const subtitleElements = (0, $brTAh.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Vertical,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $hcewu.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $3bf1e0846d3cab95$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5NtHI.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $3bf1e0846d3cab95$export$2e2bcd8739ae039 = $3bf1e0846d3cab95$var$TitleBlockResolvedView;

});

parcelRegister("1Ub5D", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9eea7741f2cb919$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $65mpR = parcelRequire("65mpR");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $f9eea7741f2cb919$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5NtHI.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $f9eea7741f2cb919$export$2e2bcd8739ae039 = $f9eea7741f2cb919$var$TitleBlockResolvingView;

});


parcelRegister("8YHJ2", function(module, exports) {
$parcel$export(module.exports, "CardSSR", () => $265c0be3b7df6739$export$7b5e1b7f9a325b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $aXKmr = parcelRequire("aXKmr");

var $e2B2h = parcelRequire("e2B2h");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
const $265c0be3b7df6739$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $eJOHy.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorFallbackComponent, {});
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...cardProps
        });
    };
    if ((0, $eGOwo.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: (0, $b43DQ.context),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                FallbackComponent: errorBoundaryFallbackComponent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                        ...cardProps
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: (0, $b43DQ.context),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("4oATR", function(module, exports) {
$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");

var $ettNQ = parcelRequire("ettNQ");
const $e563c8affb3daadf$var$thirdPartyARIPrefix = 'ari:third-party';
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    const thirdPartyARI = (0, $03JM4.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $03JM4.getFirstPartyIdentifier)();
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    const fire3PClickEvent = (0, $eGOwo.fg)('platform_smartlink_3pclick_analytics') ? (0, $ettNQ.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
            if (thirdPartyARI && thirdPartyARI.startsWith($e563c8affb3daadf$var$thirdPartyARIPrefix)) {
                const clickURL = (0, $03JM4.getClickUrl)(url, state.details);
                if (clickURL === url && fire3PClickEvent) // For questions or concerns about this event,
                // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
                fire3PClickEvent();
            }
        }
        const isDisablePreviewPanel = disablePreviewPanel && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details),
                panelData: {
                    embedUrl: (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $hy9OT.extractSmartLinkEmbed)(state.details)?.src : undefined
                }
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        thirdPartyARI,
        disablePreviewPanel
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            placeholderData: (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? placeholderData : undefined,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("92xoS", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $19fb77b8a89e4410$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $19fb77b8a89e4410$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $19fb77b8a89e4410$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $dpRNR.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $19fb77b8a89e4410$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $bfW07._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});

parcelRegister("iT7eO", function(module, exports) {
$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("bde0S", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $ldBiz.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("ldBiz", function(module, exports) {
$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("03JM4", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $a9130c46b8c7e440$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $a9130c46b8c7e440$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $eGOwo = parcelRequire("eGOwo");

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$e029950864672b4 = (details)=>{
    if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $a9130c46b8c7e440$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $a9130c46b8c7e440$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $a9130c46b8c7e440$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $a9130c46b8c7e440$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $a9130c46b8c7e440$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $a9130c46b8c7e440$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("70skx", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("2vJUc", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {
$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("44bDi", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $59rsN = parcelRequire("59rsN");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("wq6W1", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("6jgT3", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("3u14o", function(module, exports) {
$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    });
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {
$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {
$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {
$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("kj3Kk", function(module, exports) {
$parcel$export(module.exports, "CardLinkView", () => $c60e87c9a02f8e5e$export$ce508304ed2dd145);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bu0pj = parcelRequire("bu0pj");
class $c60e87c9a02f8e5e$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("bu0pj", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $a33467e63cbde9e1$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3qu2 = parcelRequire("e3qu2");

var $hFjcp = parcelRequire("hFjcp");
const $a33467e63cbde9e1$export$b89a827e9254211a = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $hFjcp.WrapperAnchor) : (0, $hFjcp.WrapperSpan);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("hFjcp", function(module, exports) {
$parcel$export(module.exports, "WrapperSpan", () => $410d9f0a7ea732a2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $410d9f0a7ea732a2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $410d9f0a7ea732a2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $410d9f0a7ea732a2$var$interactiveStyles = null;
const $410d9f0a7ea732a2$var$hoveredStyles = null;
const $410d9f0a7ea732a2$var$hoveredWithBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withoutBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withBackgroundStyles = null;
const $410d9f0a7ea732a2$var$truncateStyles = null;
const $410d9f0a7ea732a2$var$notSelectedStyle = null;
const $410d9f0a7ea732a2$var$selectedStyles = null;

});



parcelRegister("fQuyl", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {
$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                ...(0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? {
                    CompetitorPrompt: CompetitorPrompt
                } : undefined,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {
$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $dBLxD = parcelRequire("dBLxD");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
const $b72b0d53d138fc6a$var$PENDING_LINK_STATUSES = [
    (0, $5NtHI.SmartLinkStatus).Pending,
    (0, $5NtHI.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $eJOHy.useMemo)(()=>$b72b0d53d138fc6a$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? (0, $dBLxD.extractPlaceHolderCardState)(placeholderData) : undefined, [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState?.status;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        onAuthorize,
        onClick,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        renderers,
        resolve,
        status,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? placeHolderStatus ?? status : status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                        extensionKey: details?.meta?.key
                    }
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dBLxD", function(module, exports) {
$parcel$export(module.exports, "extractPlaceHolderCardState", () => $d31cf9af0724655f$export$684541b2632ffbbc);
const $d31cf9af0724655f$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $d31cf9af0724655f$export$684541b2632ffbbc = (placeholderData)=>{
    return $d31cf9af0724655f$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};

});

parcelRegister("dpCTw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19it7r9e _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {
$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            role: 'presentation',
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {
$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $92xoS = parcelRequire("92xoS");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const handleSetIsOpen = (0, $eGOwo.fg)('hover-card-on-visibility-change-callback') ? (0, $eJOHy.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        if ((0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]) : undefined;
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        if (handleSetIsOpen && (0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen && (0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen && (0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER,
                ...(0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                    className: $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $dNwAf.default)
    });
};

});
parcelRegister("dNwAf", function(module, exports) {
$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {
$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {
$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("1UXt3", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $72576417d80bd61c$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $72576417d80bd61c$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $72576417d80bd61c$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $3jSKi = parcelRequire("3jSKi");
var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $72576417d80bd61c$export$b68822b76d5d51d5(response?.data);
};
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $72576417d80bd61c$export$44130aa92252501(response?.data);
};
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && $72576417d80bd61c$export$b592ddecae70b61d(response?.data);
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};

});

parcelRegister("3a3fF", function(module, exports) {
$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});



parcelRegister("2bxQs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rko1mok _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rko1mok _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {
$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13li1mok _qrwq1mok _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("7r0tl", function(module, exports) {
$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {
$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {
$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...(0, $eGOwo.fg)('navx-1910-fix-hovercard-performance-metrics') ? {} : {
                    marginBottom: "var(--ds-space-100, 8px)"
                },
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {
$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};

});




parcelRegister("1klMO", function(module, exports) {
$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $59rsN = parcelRequire("59rsN");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const hoverCardExperimentCohort = providerName === 'Google' ? (0, $59rsN.default).getExperimentValue('platform_editor_google_hovercard_experiment', 'cohort', 'control') : 'control';
    const connectActionMessage = hoverCardExperimentCohort === 'test1' || hoverCardExperimentCohort === 'test2' || hoverCardExperimentCohort === 'test3' ? (0, $19nmp.messages).experiment_connect_unauthorised_account_action : (0, $19nmp.messages).connect_unauthorised_account_action;
    const hoverCardTitle = hoverCardExperimentCohort === 'test1' || hoverCardExperimentCohort === 'test2' ? (0, $19nmp.messages).experiment_connect_link_account_card_name_title : (0, $19nmp.messages).connect_link_account_card_name;
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...connectActionMessage,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName,
        connectActionMessage
    ]);
    if (hoverCardExperimentCohort === 'test4') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...hoverCardTitle,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        appearance: hoverCardExperimentCohort !== 'control' ? 'hoverCardPreview' : undefined
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $4b17ec2d366022be$var$cohortMessages = {
    control: (0, $19nmp.messages).connect_unauthorised_account_description,
    test1: (0, $19nmp.messages).experiment_connect_hovercard_description_1,
    test2: (0, $19nmp.messages).experiment_connect_hovercard_description_2,
    test3: (0, $19nmp.messages).experiment_connect_hovercard_description_3,
    test4: (0, $19nmp.messages).connect_unauthorised_account_description
};
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content', appearance: appearance })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const hoverCardExperimentCohort = providerName === 'Google' && appearance === 'hoverCardPreview' ? (0, $59rsN.default).getExperimentValue('platform_editor_google_hovercard_experiment', 'cohort', 'control') : 'control';
    let learnMoreMessage;
    if (isProductIntegrationSupported) {
        if (hoverCardExperimentCohort === 'control') learnMoreMessage = (0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).learn_more_about_connecting_account_appify : (0, $19nmp.messages).learn_more_about_connecting_account;
        else learnMoreMessage = (0, $19nmp.messages).experiment_learn_more_about_smart_links;
    } else learnMoreMessage = (0, $19nmp.messages).learn_more_about_smart_links;
    let unauthorizedAccountDescriptionMessage;
    if (hoverCardExperimentCohort === 'control') unauthorizedAccountDescriptionMessage = (0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_appify : (0, $19nmp.messages).connect_unauthorised_account_description;
    else unauthorizedAccountDescriptionMessage = $4b17ec2d366022be$var$cohortMessages[hoverCardExperimentCohort];
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...unauthorizedAccountDescriptionMessage,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_no_provider_appify : (0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        "aria-hidden": true,
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {
$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                }
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractSmartLinkReactCount)(response),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSmartLinkSentOn)(response),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        type: (0, $dpM2S.extractType)(data),
        meta: {
            objectId: (0, $1UXt3.extractMetaObjectId)(meta),
            resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
            tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {
$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {
$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2fsAU", function(module, exports) {
$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("glHkX", function(module, exports) {
$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {
$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {
$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {
$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ccFJO", function(module, exports) {
$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $hy9OT.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("blyJR", function(module, exports) {
$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});



parcelRegister("7xgpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {
$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const result = (0, $5O37S.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});
parcelRegister("5O37S", function(module, exports) {
$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");

var $hziYa = parcelRequire("hziYa");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $hziYa.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel && (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel_modal', 'cohort', 'test')) return;
    if (src) {
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $hy9OT.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $aNEbu.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                            isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                            linkIcon: (0, $8z78z.extractLinkIcon)(response),
                            providerName: (0, $hy9OT.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $hy9OT.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $hy9OT.extractSmartLinkTitle)(response),
                            url: url,
                            isBlanketHidden: (0, $eGOwo.fg)('linking_platform_hide_preview_action_blanket_prop') ? actionOptions?.previewAction?.hideBlanket : undefined,
                            size: (0, $eGOwo.fg)('platform_linking_enable_card_preview_action_size') ? actionOptions?.previewAction?.size : undefined,
                            ...(0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5NtHI.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};

});
parcelRegister("hziYa", function(module, exports) {
$parcel$export(module.exports, "isWithinPreviewPanelIFrame", () => $4758778ac1a56d76$export$24def1b22639c691);
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $4758778ac1a56d76$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $4758778ac1a56d76$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $4758778ac1a56d76$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $4758778ac1a56d76$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $4758778ac1a56d76$var$getUrlSearchParams(currentSearch);
            if (currentParams && $4758778ac1a56d76$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $4758778ac1a56d76$export$24def1b22639c691 = ()=>{
    return $4758778ac1a56d76$export$9f140ed41af5108c() && $4758778ac1a56d76$export$f274fcef361fe59d();
};

});

parcelRegister("aNEbu", function(module, exports) {
$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("3nRTS"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("3nRTS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {
$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {
$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {
$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {
$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {
$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {
$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {
$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {
$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {
$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {
$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});



parcelRegister("iJBt4", function(module, exports) {
$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $hy9OT = parcelRequire("hy9OT");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {
$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {
$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};

});


parcelRegister("13x9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {
$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {
$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {
$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {
$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {
$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {
$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {
$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {
$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {
$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g961mok _1qo31x13"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {
$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    uiOptions.enableSnippetRenderer = true;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {
$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {
$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    });
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio,
                ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                    extensionKey: details?.meta?.key
                }
            });
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {
$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {
$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("k4P1T", function(module, exports) {
$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::838f4f86c5032d94c12ae3c464c4518b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $awZZu = parcelRequire("awZZu");

var $kSlVI = parcelRequire("kSlVI");

var $eGOwo = parcelRequire("eGOwo");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kSlVI.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("kSlVI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f8594533ccfc7e7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $awZZu = parcelRequire("awZZu");

var $gPsTF = parcelRequire("gPsTF");
function $5f8594533ccfc7e7$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("cBTRt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d7da5f0a9dbfdcb61e67416f34ea57c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e074effda908d62315fc623bb11ea4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $8lO5P = parcelRequire("8lO5P");

var $ipwys = parcelRequire("ipwys");

var $eGOwo = parcelRequire("eGOwo");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ipwys.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("ipwys", function(module, exports) {
$parcel$export(module.exports, "default", () => $528bc82bd809f6ef$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8lO5P = parcelRequire("8lO5P");

var $gPsTF = parcelRequire("gPsTF");
function $528bc82bd809f6ef$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        color: "var(--ds-icon-accent-purple, #8270DB)"
    });
}

});

parcelRegister("j8Au4", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508b706ee3537e027a0453638a0b8ef4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6debd57b02ce07c26b500a40c5cf84fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $7XCnf = parcelRequire("7XCnf");

var $klMVJ = parcelRequire("klMVJ");

var $eGOwo = parcelRequire("eGOwo");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klMVJ.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("klMVJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f854a954aead859f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7XCnf = parcelRequire("7XCnf");

var $gPsTF = parcelRequire("gPsTF");
function $f854a954aead859f$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("1OiKX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::410fb939afe4c212397f97afe36b0581>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28ad781cda66347f47adf68d1b8c9215>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $MUJuW = parcelRequire("MUJuW");

var $5ZU2f = parcelRequire("5ZU2f");

var $eGOwo = parcelRequire("eGOwo");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ZU2f.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("5ZU2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0ccf0bfb3196e91$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $MUJuW = parcelRequire("MUJuW");

var $gPsTF = parcelRequire("gPsTF");
function $f0ccf0bfb3196e91$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("3xtgM", function(module, exports) {
$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fa1181402c522778e280d3429cafbed>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba42c74cbfda9afab131839d0b6c6e6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $bwM92 = parcelRequire("bwM92");

var $iXN9z = parcelRequire("iXN9z");

var $eGOwo = parcelRequire("eGOwo");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXN9z.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("iXN9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4b71fd2f274d4b0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bwM92 = parcelRequire("bwM92");

var $gPsTF = parcelRequire("gPsTF");
function $b4b71fd2f274d4b0$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("dSbyY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3096846462441e20a58007578ded0cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {
$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {
$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a76a3f4404ba59acd822415adfff8b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.displayName = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {
$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::167fa533efc4ba93e24036848d1072d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $9UdpB = parcelRequire("9UdpB");

var $lcl8I = parcelRequire("lcl8I");

var $eGOwo = parcelRequire("eGOwo");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lcl8I.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("lcl8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9279295c562e43$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9UdpB = parcelRequire("9UdpB");

var $gPsTF = parcelRequire("gPsTF");
function $9f9279295c562e43$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("ePICl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5651d34540e7f43d2ed8c5db6223a91c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57ea112ed25eedff788d2782c5430357>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $4aDUk = parcelRequire("4aDUk");

var $5A1xk = parcelRequire("5A1xk");

var $eGOwo = parcelRequire("eGOwo");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5A1xk.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("5A1xk", function(module, exports) {
$parcel$export(module.exports, "default", () => $181b872bc3049d17$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4aDUk = parcelRequire("4aDUk");

var $gPsTF = parcelRequire("gPsTF");
function $181b872bc3049d17$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("bqSXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e76b2e34bfd0965e8540e18ec2ba179>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d6daab6c18f6607b508ad6a232f29d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $gtN4u = parcelRequire("gtN4u");

var $5qGkP = parcelRequire("5qGkP");

var $eGOwo = parcelRequire("eGOwo");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qGkP.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("5qGkP", function(module, exports) {
$parcel$export(module.exports, "default", () => $46db67a1a90c5389$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gtN4u = parcelRequire("gtN4u");

var $gPsTF = parcelRequire("gPsTF");
function $46db67a1a90c5389$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        color: "var(--ds-icon-accent-purple, #8270DB)"
    });
}

});

parcelRegister("3zPlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a44d02da4898e1053cddbd7d9579da66>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a2ca9a3d5107d7ac162a2a33430a5c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $ljmsu = parcelRequire("ljmsu");

var $6JTVR = parcelRequire("6JTVR");

var $eGOwo = parcelRequire("eGOwo");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JTVR.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f39860ce7f984391648fef01b18ffad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("6JTVR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad5af7b2ef48268$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ljmsu = parcelRequire("ljmsu");

var $gPsTF = parcelRequire("gPsTF");
function $7ad5af7b2ef48268$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("ewxpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12651d67bb24f12b3cf36f86bf08144>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bca06c5d0b322c69c2d7dabe129b3860>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $c59mr = parcelRequire("c59mr");

var $hMLdG = parcelRequire("hMLdG");

var $eGOwo = parcelRequire("eGOwo");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hMLdG.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("hMLdG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0fecfbb7e320ff1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c59mr = parcelRequire("c59mr");

var $gPsTF = parcelRequire("gPsTF");
function $b0fecfbb7e320ff1$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("28xc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92eaddadffe090000f45e8586efb1edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4391ff6105029c3c00dcb25fe777d0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $gNXvC = parcelRequire("gNXvC");

var $k4LJo = parcelRequire("k4LJo");

var $eGOwo = parcelRequire("eGOwo");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k4LJo.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3166f2fe0f47ea82d95571c4b7ab84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("k4LJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $225b63a81c5c98f6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gNXvC = parcelRequire("gNXvC");

var $gPsTF = parcelRequire("gPsTF");
function $225b63a81c5c98f6$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("kFcVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f32c1be67ac8ff7b63f610c2491e7e9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58018d99cc8a0f6abeddbd3fccbd6413>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $hVZow = parcelRequire("hVZow");

var $1ln11 = parcelRequire("1ln11");

var $eGOwo = parcelRequire("eGOwo");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ln11.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("1ln11", function(module, exports) {
$parcel$export(module.exports, "default", () => $02d2d79053f6e150$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hVZow = parcelRequire("hVZow");

var $gPsTF = parcelRequire("gPsTF");
function $02d2d79053f6e150$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("ayExB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1896fd3bafdfc1bc71c0fcf57c8b2685>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ad746f8d6850770b3cdfa715cfc8204>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $d67Vm = parcelRequire("d67Vm");

var $fDwRL = parcelRequire("fDwRL");

var $eGOwo = parcelRequire("eGOwo");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fDwRL.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c160a9f26591f77220765c2e9d99939c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("fDwRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e98ebbc21cca84e8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $d67Vm = parcelRequire("d67Vm");

var $gPsTF = parcelRequire("gPsTF");
function $e98ebbc21cca84e8$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
}

});

parcelRegister("kqL94", function(module, exports) {
$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7332e8f7ef1b441068cfb157f8d729a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {
$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("gxXx6", function(module, exports) {
$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type,
                    hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
const $7e6c0fa079b82f37$var$wrapperStylesOld = null;
const $7e6c0fa079b82f37$var$wrapperStylesNew = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>{
    const shouldAddLozengeAttribute = (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp');
    if ((0, $eGOwo.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...shouldAddLozengeAttribute && {
            'data-inline-card-lozenge': true
        },
        className: (0, $hcewu.default)([
            "_1e0c1o8l _154i1n1a _kqswh2mm _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...shouldAddLozengeAttribute && {
            'data-inline-card-lozenge': true
        },
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
};
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $FoFt2.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                onError: ()=>setHasImageErrored(true),
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {
$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {
$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {
$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9" : "_2rkolb4i _1h6d3acm _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9",
            !isSelected && "_2rkolb4i",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {
$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqz7r9e _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgv7r9e _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19ity6g5 _2rko12b0 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("65oSX", function(module, exports) {
$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {
$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $cbSL1 = parcelRequire("cbSL1");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton && (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? {
            onError: handleError
        } : undefined
    });
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {
$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {
$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {
$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");

var $diXta = parcelRequire("diXta");
const $367ff287c16eda7a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton
    ]);
    (0, $diXta.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text,
            extensionKey: extensionKey
        })
    });
});

});
parcelRegister("e3qHE", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                extensionKey: extensionKey,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {
$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3Gkc1 = parcelRequire("3Gkc1");

var $eGOwo = parcelRequire("eGOwo");

var $dxRkJ = parcelRequire("dxRkJ");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? (0, $dxRkJ.useConfluencePageData)(props.src || '', extensionKey || '') : undefined;
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Gkc1.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};

});
parcelRegister("3Gkc1", function(module, exports) {
$parcel$export(module.exports, "Page", () => $a2bc0e1a0c33c2da$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $gc6HS = parcelRequire("gc6HS");
const $a2bc0e1a0c33c2da$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gc6HS.Page), {
            ...props
        })
    });

});
parcelRegister("jyZeU", function(module, exports) {
$parcel$export(module.exports, "I18nProvider", () => $bad023223c621c92$export$a54013f0d02a8f82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $axNrS = parcelRequire("axNrS");
const $bad023223c621c92$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $axNrS.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $eJOHy.useState)();
    const locale = (0, $eJOHy.useMemo)(()=>(0, $axNrS.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $axNrS.DEFAULT_LOCALE),
        children: children
    });
};

});
parcelRegister("axNrS", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $e8050c0da9fad76c$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $e8050c0da9fad76c$export$dca0327c9b9c6498);
const $e8050c0da9fad76c$var$DEFAULT_LANGUAGE = 'en';
const $e8050c0da9fad76c$var$DEFAULT_REGION = 'US';
const $e8050c0da9fad76c$export$1af4c7e47ad72f44 = `${$e8050c0da9fad76c$var$DEFAULT_LANGUAGE}-${$e8050c0da9fad76c$var$DEFAULT_REGION}`;
const $e8050c0da9fad76c$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $e8050c0da9fad76c$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $e8050c0da9fad76c$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $e8050c0da9fad76c$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $e8050c0da9fad76c$export$1af4c7e47ad72f44;
};

});


parcelRegister("lWsis", function(module, exports) {
$parcel$export(module.exports, "default", () => $abece4116087a64f$export$2e2bcd8739ae039);

var $3i9VW = parcelRequire("3i9VW");

var $57But = parcelRequire("57But");
const $abece4116087a64f$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $3i9VW.default;
        case 'en-US':
        default:
            return 0, $57But.default;
    }
};
var $abece4116087a64f$export$2e2bcd8739ae039 = $abece4116087a64f$var$fetchTranslations;

});
parcelRegister("3i9VW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8a32cb4963d4eb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9a8a32cb4963d4eb$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("57But", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f988a238c590e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $22f988a238c590e1$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});


parcelRegister("gc6HS", function(module, exports) {
$parcel$export(module.exports, "Page", () => $85e32b2256736ca0$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5Mh3y = parcelRequire("5Mh3y");

var $lRq8t = parcelRequire("lRq8t");

var $4eSmy = parcelRequire("4eSmy");

var $6ijO8 = parcelRequire("6ijO8");
const $85e32b2256736ca0$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4eSmy.ViewPage), {
        locale: locale,
        ...props
    });
};
const $85e32b2256736ca0$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ijO8.EditPage), {
        locale: locale,
        ...props
    });
};
const $85e32b2256736ca0$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Mh3y.Page), {
        locale: locale,
        ...props,
        viewComponent: $85e32b2256736ca0$var$ViewComponent,
        editComponent: $85e32b2256736ca0$var$EditComponent
    });
};

});
parcelRegister("5Mh3y", function(module, exports) {
$parcel$export(module.exports, "Page", () => $e1e42838b53dfae8$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $5NuS5 = parcelRequire("5NuS5");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");
const $e1e42838b53dfae8$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NuS5.Page), {
                ...props
            })
        })
    });

});
parcelRegister("5NuS5", function(module, exports) {
$parcel$export(module.exports, "Page", () => $b83dd449ca0b36bb$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $9fAcm = parcelRequire("9fAcm");

var $52WL7 = parcelRequire("52WL7");

var $6DF4T = parcelRequire("6DF4T");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");
const $b83dd449ca0b36bb$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $b83dd449ca0b36bb$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $b83dd449ca0b36bb$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $9fAcm.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $eJOHy.useState)(mode);
    (0, $eJOHy.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $eJOHy.useState)(spaceKey);
    const switchToViewPage = (0, $eJOHy.useCallback)(()=>{
        setCurrentMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
				 * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
				 */ if (currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && ((0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.contentId === modifiers.contentId : true)) {
                    setCurrentMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $52WL7.useExperienceTracker)();
    (0, $eJOHy.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
				 * Using experienceTracker, we can switch from Edit to View page.
				 * 1. When the user clicks the Publish button and task success, it can switch to the View page.
				 *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
				 *          change the spaceKey during publish.
				 *          In that case, a new spaceKey will be added to the success event and tracked here.
				 * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
				 */ const isClosingPublishedEditPage = !draftShareId && name === $b83dd449ca0b36bb$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $b83dd449ca0b36bb$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null
    });
};

});
parcelRegister("52WL7", function(module, exports) {
$parcel$export(module.exports, "useExperienceTracker", () => $61f00e7f38957a02$export$cdefb2a8b53f879f);

var $eJOHy = parcelRequire("eJOHy");

var $87Obl = parcelRequire("87Obl");
var $40f0Z = parcelRequire("40f0Z");

var $9g7u4 = parcelRequire("9g7u4");

var $5ZujZ = parcelRequire("5ZujZ");
function $61f00e7f38957a02$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $eJOHy.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $87Obl.ExperienceTracker)();
    (0, $9g7u4.useAnalytics)(embeddedConfluenceETRef.current);
    $61f00e7f38957a02$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $61f00e7f38957a02$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $eJOHy.useRef)();
    const embeddingProductET = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $5ZujZ.setExperiencesForwarding)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("9g7u4", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $9b6e4424e97e8f9e$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $j2zMY = parcelRequire("j2zMY");

var $8NHBs = parcelRequire("8NHBs");

var $fnLem = parcelRequire("fnLem");
const $9b6e4424e97e8f9e$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $j2zMY.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $8NHBs.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $fnLem.ANALYTICS_CHANNEL));
    });
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("j2zMY", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_NAME_PREFIX", () => $a22062b7ca04dc2f$export$b9fadc635fed6276);
$parcel$export(module.exports, "ExperienceNames", () => $a22062b7ca04dc2f$export$312b1a9f1141bdaa);
$parcel$export(module.exports, "ExperienceReasons", () => $a22062b7ca04dc2f$export$db5add30a8721c38);
$parcel$export(module.exports, "SupportedExperienceNames", () => $a22062b7ca04dc2f$export$ce9b20b2ad3e7bc6);
const $a22062b7ca04dc2f$export$b9fadc635fed6276 = 'embedded-confluence/';
var $a22062b7ca04dc2f$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $a22062b7ca04dc2f$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $a22062b7ca04dc2f$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});

});

parcelRegister("8NHBs", function(module, exports) {
$parcel$export(module.exports, "createExperienceTrackerAnalyticsEventPayload", () => $55d79b53e5470d85$export$9c05e7ef9f2c8895);
const $55d79b53e5470d85$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $55d79b53e5470d85$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $55d79b53e5470d85$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}

});

parcelRegister("fnLem", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $4e744db00984a860$export$85183a312807388d);

var $9g7u4 = parcelRequire("9g7u4");
const $4e744db00984a860$export$85183a312807388d = 'embeddedConfluence';

});


parcelRegister("5ZujZ", function(module, exports) {
$parcel$export(module.exports, "setExperiencesForwarding", () => $08d63358f56f2fa7$export$7ecf150f65423c3f);
function $08d63358f56f2fa7$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}

});



parcelRegister("7oRxl", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundEmptyState", () => $9a8674d2e142bed1$export$d3ec4d3c4e3e468c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $Ov5I7 = parcelRequire("Ov5I7");

var $2XnNJ = parcelRequire("2XnNJ");
const $9a8674d2e142bed1$var$styles = {
    image: "_p12f1mjv _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
// Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const $9a8674d2e142bed1$var$PreviewPanelPageNotFoundSVG = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $9a8674d2e142bed1$var$styles.image,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2XnNJ.PageNotFoundSVG), {})
    });
};
const $9a8674d2e142bed1$export$d3ec4d3c4e3e468c = ({ embeddedConfluenceSource: embeddedConfluenceSource } = {})=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
    const EmptyStateImage = isInPreviewPanel ? $9a8674d2e142bed1$var$PreviewPanelPageNotFoundSVG : (0, $2XnNJ.PageNotFoundSVG);
    const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6MnLl.default), {
        header: formatMessage((0, $Ov5I7.default).emptyStateHeader),
        description: formatMessage((0, $Ov5I7.default).emptyStateDescription),
        width: EmptyStateWidth,
        renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(EmptyStateImage, {})
    });
};

});
parcelRegister("Ov5I7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e921b67742a22da0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e921b67742a22da0$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: 'embedded-confluence-common.src.content.empty-state-header',
        description: 'The header message in the empty state error screen shown to the user when there is no page to render'
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: 'embedded-confluence-common.src.content.empty-state-description',
        description: 'The description message in the empty state error screen shown to the user when there is no page to render'
    }
});
var $e921b67742a22da0$export$2e2bcd8739ae039 = $e921b67742a22da0$var$messages;

});

parcelRegister("2XnNJ", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundSVG", () => $608c538d98081b3b$export$7cd49dc959d58823);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $608c538d98081b3b$var$styles = `{
  cls4: { fill: '#b3f5ff' },
  cls50: { fill: '#79e2f2' },
  cls228: { fill: 'url(#radial-gradient-7)' },
  cls230: { fill: 'url(#radial-gradient-9)' },
  cls240: { fill: '#c1c7d0' },
  cls242: { fill: '#dfe1e5' },
  cls245: { fill: '#172b4d' },
  cls247: { fill: '#00c7e5' },
  cls249: { fill: 'none' },
  cls250: { fill: '#72594b' },
  cls261: { opacity: 0.6 },
  cls262: { fill: '#ff8b00' },
  cls263: { fill: '#ecc19c' },
}`;
const $608c538d98081b3b$export$7cd49dc959d58823 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "476.06",
        height: "482.63",
        viewBox: "0 0 476.06 482.63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "319.98",
                        y1: "322.55",
                        x2: "426.85",
                        y2: "215.68",
                        gradientTransform: "translate(-227.29)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".06",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".27",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".45",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".67"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".72",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "7261.66",
                        y1: "168.49",
                        x2: "7391.94",
                        y2: "38.21",
                        gradientTransform: "matrix(-1 0 0 1 7632.29 0)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: "146.17",
                        y1: "164.89",
                        x2: "239.99",
                        y2: "71.07",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: "782.51",
                        y1: "-1187.31",
                        x2: "790.62",
                        y2: "-1204.87",
                        gradientTransform: "rotate(-24.78 3495.39 868.508)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".25",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: "5.81",
                        y1: "472.52",
                        x2: "5.81",
                        y2: "284.67",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".43",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: "8.47",
                        y1: "472.52",
                        x2: "8.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: "69.15",
                        y1: "472.52",
                        x2: "69.15",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: "63.61",
                        y1: "472.52",
                        x2: "63.61",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: "67.33",
                        y1: "472.52",
                        x2: "67.33",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: "68.21",
                        y1: "472.52",
                        x2: "68.21",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: "68.78",
                        y1: "472.52",
                        x2: "68.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: "52.51",
                        y1: "472.52",
                        x2: "52.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: "56.67",
                        y1: "472.52",
                        x2: "56.67",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-15",
                        x1: "54.47",
                        y1: "472.52",
                        x2: "54.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: "60.3",
                        y1: "472.52",
                        x2: "60.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: "62.16",
                        y1: "472.52",
                        x2: "62.16",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-18",
                        x1: "58.5",
                        y1: "472.52",
                        x2: "58.5",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-19",
                        x1: "66.35",
                        y1: "472.52",
                        x2: "66.35",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-20",
                        x1: "3.23",
                        y1: "472.52",
                        x2: "3.23",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-21",
                        x1: "160.2",
                        y1: "472.52",
                        x2: "160.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-22",
                        x1: "71.2",
                        y1: "472.52",
                        x2: "71.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-23",
                        x1: "271.02",
                        y1: "472.52",
                        x2: "271.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-24",
                        x1: "4.82",
                        y1: "472.52",
                        x2: "4.82",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-25",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-26",
                        x1: "195.3",
                        y1: "472.52",
                        x2: "195.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-27",
                        x1: "3.53",
                        y1: "472.52",
                        x2: "3.53",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-28",
                        x1: "3.37",
                        y1: "472.52",
                        x2: "3.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-29",
                        x1: "4.07",
                        y1: "472.52",
                        x2: "4.07",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-30",
                        x1: "273.13",
                        y1: "472.52",
                        x2: "273.13",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-31",
                        x1: "273.13",
                        y1: "462.4",
                        x2: "273.13",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-32",
                        x1: "220.7",
                        y1: "472.52",
                        x2: "220.7",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-33",
                        x1: "220.7",
                        y1: "462.4",
                        x2: "220.7",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-34",
                        x1: "185.46",
                        y1: "472.52",
                        x2: "185.46",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-35",
                        x1: "185.46",
                        y1: "402.18",
                        x2: "185.46",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#abf2fd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".22",
                                stopColor: "#95ebf8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".4",
                                stopColor: "#85e6f5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".61",
                                stopColor: "#7ce3f3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".91",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-36",
                        x1: "148.26",
                        y1: "472.52",
                        x2: "148.26",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-37",
                        x1: "148.26",
                        y1: "402.18",
                        x2: "148.26",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-38",
                        x1: "186.02",
                        y1: "472.52",
                        x2: "186.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-39",
                        x1: "186.02",
                        y1: "462.4",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-40",
                        x1: "186.02",
                        y1: "402.18",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-41",
                        x1: "214.14",
                        y1: "472.52",
                        x2: "214.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-42",
                        x1: "214.14",
                        y1: "462.4",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-43",
                        x1: "214.14",
                        y1: "402.18",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-44",
                        x1: "185.54",
                        y1: "402.18",
                        x2: "185.54",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-45",
                        x1: "338.36",
                        y1: "472.52",
                        x2: "338.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-46",
                        x1: "338.36",
                        y1: "402.18",
                        x2: "338.36",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-47",
                        x1: "283.93",
                        y1: "472.52",
                        x2: "283.93",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-48",
                        x1: "283.93",
                        y1: "462.4",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-49",
                        x1: "283.93",
                        y1: "402.18",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-50",
                        x1: "403.38",
                        y1: "472.52",
                        x2: "403.38",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-51",
                        x1: "396.98",
                        y1: "411.33",
                        x2: "409.97",
                        y2: "305.52",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".02",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".78"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".61"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".07",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".47"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".1",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".34"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".23"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".17",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".15"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".03"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".52",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".67",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".74",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".04"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".09"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".83",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".16"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".86",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".25"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".93",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".49"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".65"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".82"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-52",
                        x1: "2.42",
                        y1: "362.88",
                        x2: "15.41",
                        y2: "257.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-53",
                        x1: "3.3",
                        y1: "362.99",
                        x2: "16.29",
                        y2: "257.18",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-54",
                        x1: "4.38",
                        y1: "363.12",
                        x2: "17.37",
                        y2: "257.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-55",
                        x1: "1.14",
                        y1: "362.72",
                        x2: "14.13",
                        y2: "256.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-56",
                        x1: "5.69",
                        y1: "363.28",
                        x2: "18.68",
                        y2: "257.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-57",
                        x1: "1.05",
                        y1: "362.71",
                        x2: "14.04",
                        y2: "256.9",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-58",
                        x1: "10.57",
                        y1: "363.88",
                        x2: "11.95",
                        y2: "352.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-59",
                        x1: "1.74",
                        y1: "362.79",
                        x2: "14.73",
                        y2: "256.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-60",
                        x1: "171.14",
                        y1: "472.52",
                        x2: "171.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-61",
                        x1: "165.11",
                        y1: "382.85",
                        x2: "178.1",
                        y2: "277.05",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-62",
                        x1: "251.72",
                        y1: "472.52",
                        x2: "251.72",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-63",
                        x1: "251.72",
                        y1: "462.4",
                        x2: "251.72",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-64",
                        x1: "249.31",
                        y1: "393.2",
                        x2: "262.3",
                        y2: "287.39",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-65",
                        x1: "237.87",
                        y1: "472.52",
                        x2: "237.87",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-66",
                        x1: "237.87",
                        y1: "462.4",
                        x2: "237.87",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-67",
                        x1: "235.86",
                        y1: "391.55",
                        x2: "248.85",
                        y2: "285.74",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-68",
                        x1: "153.84",
                        y1: "472.52",
                        x2: "153.84",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-69",
                        x1: "153.84",
                        y1: "402.18",
                        x2: "153.84",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-70",
                        x1: "152.5",
                        y1: "381.31",
                        x2: "165.5",
                        y2: "275.5",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-71",
                        x1: "172.27",
                        y1: "472.52",
                        x2: "172.27",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-72",
                        x1: "172.27",
                        y1: "462.4",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-73",
                        x1: "172.27",
                        y1: "402.18",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-74",
                        x1: "168.95",
                        y1: "383.33",
                        x2: "181.94",
                        y2: "277.52",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-75",
                        x1: "221.37",
                        y1: "472.52",
                        x2: "221.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-76",
                        x1: "221.37",
                        y1: "462.4",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-77",
                        x1: "221.37",
                        y1: "402.18",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-78",
                        x1: "218.94",
                        y1: "389.47",
                        x2: "231.93",
                        y2: "283.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-79",
                        x1: "187.52",
                        y1: "472.52",
                        x2: "187.52",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-80",
                        x1: "187.52",
                        y1: "462.4",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-81",
                        x1: "187.52",
                        y1: "402.18",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-82",
                        x1: "184.77",
                        y1: "385.27",
                        x2: "197.76",
                        y2: "279.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-83",
                        x1: "180.43",
                        y1: "402.18",
                        x2: "180.43",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-84",
                        x1: "178.58",
                        y1: "384.51",
                        x2: "191.57",
                        y2: "278.7",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-85",
                        x1: "193.4",
                        y1: "402.18",
                        x2: "193.4",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-86",
                        x1: "191.37",
                        y1: "386.08",
                        x2: "204.37",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-87",
                        x1: "240.98",
                        y1: "392.17",
                        x2: "253.97",
                        y2: "286.37",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-88",
                        x1: "333.44",
                        y1: "472.52",
                        x2: "333.44",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-89",
                        x1: "333.44",
                        y1: "402.18",
                        x2: "333.44",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-90",
                        x1: "329.79",
                        y1: "403.08",
                        x2: "342.78",
                        y2: "297.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-91",
                        x1: "283.96",
                        y1: "472.52",
                        x2: "283.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-92",
                        x1: "283.96",
                        y1: "462.4",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-93",
                        x1: "283.96",
                        y1: "402.18",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-94",
                        x1: "279.87",
                        y1: "396.95",
                        x2: "292.86",
                        y2: "291.14",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-95",
                        x1: "204.11",
                        y1: "472.52",
                        x2: "204.11",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-96",
                        x1: "184.3",
                        y1: "387.71",
                        x2: "228.81",
                        y2: "265.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-97",
                        x1: "197.55",
                        y1: "386.84",
                        x2: "210.54",
                        y2: "281.03",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-98",
                        x1: "375.18",
                        y1: "472.52",
                        x2: "375.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-99",
                        x1: "339.82",
                        y1: "444.31",
                        x2: "384.34",
                        y2: "322.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-100",
                        x1: "367.74",
                        y1: "407.74",
                        x2: "380.74",
                        y2: "301.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-101",
                        x1: "154.96",
                        y1: "472.52",
                        x2: "154.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-102",
                        x1: "154.96",
                        y1: "402.18",
                        x2: "154.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-103",
                        x1: "148.01",
                        y1: "374.5",
                        x2: "192.52",
                        y2: "252.19",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-104",
                        x1: "151.79",
                        y1: "381.22",
                        x2: "164.78",
                        y2: "275.42",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-105",
                        x1: "202.83",
                        y1: "472.52",
                        x2: "202.83",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-106",
                        x1: "202.83",
                        y1: "462.4",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-107",
                        x1: "202.83",
                        y1: "402.18",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-108",
                        x1: "190.53",
                        y1: "389.97",
                        x2: "235.04",
                        y2: "267.67",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-109",
                        x1: "199.1",
                        y1: "387.03",
                        x2: "212.09",
                        y2: "281.22",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-110",
                        x1: "170.79",
                        y1: "472.52",
                        x2: "170.79",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-111",
                        x1: "170.79",
                        y1: "462.4",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-112",
                        x1: "170.79",
                        y1: "402.18",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-113",
                        x1: "161.27",
                        y1: "379.33",
                        x2: "205.79",
                        y2: "257.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-114",
                        x1: "166.95",
                        y1: "383.08",
                        x2: "179.94",
                        y2: "277.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-115",
                        x1: "188.51",
                        y1: "472.52",
                        x2: "188.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-116",
                        x1: "188.51",
                        y1: "462.4",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-117",
                        x1: "188.51",
                        y1: "402.18",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-118",
                        x1: "177.1",
                        y1: "385.09",
                        x2: "221.61",
                        y2: "262.78",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-119",
                        x1: "184.49",
                        y1: "385.24",
                        x2: "197.49",
                        y2: "279.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-120",
                        x1: "181.55",
                        y1: "402.18",
                        x2: "181.55",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-121",
                        x1: "171.4",
                        y1: "383.01",
                        x2: "215.92",
                        y2: "260.71",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-122",
                        x1: "178.12",
                        y1: "384.46",
                        x2: "191.11",
                        y2: "278.65",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-123",
                        x1: "195.05",
                        y1: "402.18",
                        x2: "195.05",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-124",
                        x1: "183.47",
                        y1: "387.41",
                        x2: "227.99",
                        y2: "265.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-125",
                        x1: "191.39",
                        y1: "386.09",
                        x2: "204.38",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-126",
                        x1: "227.14",
                        y1: "403.3",
                        x2: "271.66",
                        y2: "281",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-127",
                        x1: "240.77",
                        y1: "392.15",
                        x2: "253.76",
                        y2: "286.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-128",
                        x1: "334.77",
                        y1: "472.52",
                        x2: "334.77",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-129",
                        x1: "334.77",
                        y1: "402.18",
                        x2: "334.77",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-130",
                        x1: "306.53",
                        y1: "432.19",
                        x2: "351.04",
                        y2: "309.89",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-131",
                        x1: "328.83",
                        y1: "402.96",
                        x2: "341.82",
                        y2: "297.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-132",
                        x1: "305.41",
                        y1: "472.52",
                        x2: "305.41",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-133",
                        x1: "305.41",
                        y1: "462.4",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-134",
                        x1: "305.41",
                        y1: "402.18",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-135",
                        x1: "280.29",
                        y1: "422.65",
                        x2: "324.81",
                        y2: "300.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-136",
                        x1: "299.79",
                        y1: "399.4",
                        x2: "312.78",
                        y2: "293.59",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-137",
                        x1: "237.39",
                        y1: "472.52",
                        x2: "237.39",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-138",
                        x1: "94.24",
                        y1: "336.36",
                        x2: "382.66",
                        y2: "336.36",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-139",
                        x1: "215.63",
                        y1: "399.11",
                        x2: "260.14",
                        y2: "276.81",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-140",
                        x1: "231.06",
                        y1: "390.96",
                        x2: "244.05",
                        y2: "285.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-141",
                        x1: "154.66",
                        y1: "472.52",
                        x2: "154.66",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-142",
                        x1: "154.66",
                        y1: "402.18",
                        x2: "154.66",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-143",
                        x1: "94.24",
                        y1: "347.55",
                        x2: "382.66",
                        y2: "347.55",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-144",
                        x1: "146.2",
                        y1: "373.84",
                        x2: "190.71",
                        y2: "251.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-145",
                        x1: "150.91",
                        y1: "381.12",
                        x2: "163.9",
                        y2: "275.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-146",
                        x1: "168.62",
                        y1: "472.52",
                        x2: "168.62",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-147",
                        x1: "168.62",
                        y1: "462.4",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-148",
                        x1: "168.62",
                        y1: "402.18",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-149",
                        x1: "94.24",
                        y1: "348.31",
                        x2: "382.66",
                        y2: "348.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-150",
                        x1: "157.53",
                        y1: "377.96",
                        x2: "202.04",
                        y2: "255.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-151",
                        x1: "164.09",
                        y1: "382.73",
                        x2: "177.09",
                        y2: "276.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-152",
                        x1: "188.58",
                        y1: "472.52",
                        x2: "188.58",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-153",
                        x1: "188.58",
                        y1: "462.4",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-154",
                        x1: "188.58",
                        y1: "402.18",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-155",
                        x1: "94.24",
                        y1: "350.99",
                        x2: "382.66",
                        y2: "350.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-156",
                        x1: "176.21",
                        y1: "384.76",
                        x2: "220.72",
                        y2: "262.46",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-157",
                        x1: "184.32",
                        y1: "385.22",
                        x2: "197.31",
                        y2: "279.41",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-158",
                        x1: "181.71",
                        y1: "402.18",
                        x2: "181.71",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-159",
                        x1: "94.24",
                        y1: "349.53",
                        x2: "382.66",
                        y2: "349.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-160",
                        x1: "170.01",
                        y1: "382.51",
                        x2: "214.52",
                        y2: "260.2",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-161",
                        x1: "177.73",
                        y1: "384.41",
                        x2: "190.72",
                        y2: "278.6",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-162",
                        x1: "193.08",
                        y1: "402.18",
                        x2: "193.08",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-163",
                        x1: "94.24",
                        y1: "352.21",
                        x2: "382.66",
                        y2: "352.21",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-164",
                        x1: "180.71",
                        y1: "386.4",
                        x2: "225.23",
                        y2: "264.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-165",
                        x1: "189.02",
                        y1: "385.79",
                        x2: "202.01",
                        y2: "279.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-166",
                        x1: "94.24",
                        y1: "349.07",
                        x2: "382.66",
                        y2: "349.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-167",
                        x1: "225.04",
                        y1: "402.53",
                        x2: "269.55",
                        y2: "280.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-168",
                        x1: "240.19",
                        y1: "392.08",
                        x2: "253.18",
                        y2: "286.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-169",
                        x1: "335.09",
                        y1: "472.52",
                        x2: "335.09",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-170",
                        x1: "335.09",
                        y1: "402.18",
                        x2: "335.09",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-171",
                        x1: "94.24",
                        y1: "346.43",
                        x2: "382.66",
                        y2: "346.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-172",
                        x1: "305.17",
                        y1: "431.7",
                        x2: "349.68",
                        y2: "309.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-173",
                        x1: "328.53",
                        y1: "402.92",
                        x2: "341.52",
                        y2: "297.12",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-174",
                        x1: "314.18",
                        y1: "472.52",
                        x2: "314.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-175",
                        x1: "314.18",
                        y1: "462.4",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-176",
                        x1: "314.18",
                        y1: "402.18",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-177",
                        x1: "94.24",
                        y1: "347.82",
                        x2: "382.66",
                        y2: "347.82",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-178",
                        x1: "286.17",
                        y1: "424.78",
                        x2: "330.68",
                        y2: "302.48",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-179",
                        x1: "307.73",
                        y1: "400.37",
                        x2: "320.72",
                        y2: "294.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-180",
                        x1: "238.45",
                        y1: "472.52",
                        x2: "238.45",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-181",
                        x1: "94.24",
                        y1: "336.66",
                        x2: "382.66",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-182",
                        x1: "120.57",
                        y1: "336.66",
                        x2: "356.32",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-183",
                        x1: "216.19",
                        y1: "399.31",
                        x2: "260.7",
                        y2: "277.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-184",
                        x1: "231.95",
                        y1: "391.07",
                        x2: "244.94",
                        y2: "285.26",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-185",
                        x1: "154.01",
                        y1: "472.52",
                        x2: "154.01",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-186",
                        x1: "154.01",
                        y1: "402.18",
                        x2: "154.01",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-187",
                        x1: "94.24",
                        y1: "340.77",
                        x2: "382.66",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-188",
                        x1: "120.57",
                        y1: "340.77",
                        x2: "356.32",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-189",
                        x1: "143.55",
                        y1: "372.88",
                        x2: "188.07",
                        y2: "250.57",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-190",
                        x1: "149.49",
                        y1: "380.94",
                        x2: "162.48",
                        y2: "275.13",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-191",
                        x1: "164.37",
                        y1: "472.52",
                        x2: "164.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-192",
                        x1: "164.37",
                        y1: "462.4",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-193",
                        x1: "164.37",
                        y1: "402.18",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-194",
                        x1: "94.24",
                        y1: "341.24",
                        x2: "382.66",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-195",
                        x1: "120.57",
                        y1: "341.24",
                        x2: "356.32",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-196",
                        x1: "151.77",
                        y1: "375.87",
                        x2: "196.28",
                        y2: "253.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-197",
                        x1: "159.34",
                        y1: "382.15",
                        x2: "172.34",
                        y2: "276.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-198",
                        x1: "94.24",
                        y1: "341.91",
                        x2: "382.66",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-199",
                        x1: "120.57",
                        y1: "341.91",
                        x2: "356.32",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-200",
                        x1: "221.5",
                        y1: "401.25",
                        x2: "266.01",
                        y2: "278.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-201",
                        x1: "238.15",
                        y1: "391.83",
                        x2: "251.14",
                        y2: "286.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-202",
                        x1: "335.78",
                        y1: "472.52",
                        x2: "335.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-203",
                        x1: "335.78",
                        y1: "402.18",
                        x2: "335.78",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-204",
                        x1: "94.24",
                        y1: "340.23",
                        x2: "382.66",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-205",
                        x1: "120.57",
                        y1: "340.23",
                        x2: "356.32",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-206",
                        x1: "303.69",
                        y1: "431.16",
                        x2: "348.2",
                        y2: "308.86",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-207",
                        x1: "328.42",
                        y1: "402.91",
                        x2: "341.41",
                        y2: "297.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-208",
                        x1: "326.47",
                        y1: "472.52",
                        x2: "326.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-209",
                        x1: "326.47",
                        y1: "462.4",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-210",
                        x1: "326.47",
                        y1: "402.18",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-211",
                        x1: "94.24",
                        y1: "340.83",
                        x2: "382.66",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-212",
                        x1: "120.57",
                        y1: "340.83",
                        x2: "356.32",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-213",
                        x1: "294.77",
                        y1: "427.92",
                        x2: "339.28",
                        y2: "305.61",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-214",
                        x1: "318.99",
                        y1: "401.75",
                        x2: "331.98",
                        y2: "295.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-215",
                        x1: "105.04",
                        y1: "472.52",
                        x2: "105.04",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-216",
                        x1: "134.74",
                        y1: "472.52",
                        x2: "134.74",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-217",
                        x1: "134.74",
                        y1: "402.18",
                        x2: "134.74",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-218",
                        x1: "115.09",
                        y1: "282.96",
                        x2: "376",
                        y2: "282.96",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3bac5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".85",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-219",
                        x1: "163.83",
                        y1: "347.6",
                        x2: "279.38",
                        y2: "232.05",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".14",
                                stopColor: "#c9ced6"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".68",
                                stopColor: "#e2e4e9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-220",
                        x1: "291.34",
                        y1: "337.73",
                        x2: "291.34",
                        y2: "198.21",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-221",
                        x1: "219.34",
                        y1: "215.53",
                        x2: "331.33",
                        y2: "215.53",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".18",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-222",
                        x1: "4697.25",
                        y1: "308.96",
                        x2: "4793.78",
                        y2: "308.96",
                        gradientTransform: "matrix(-1 0 0 1 4935.69 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-223",
                        x1: "-10103.77",
                        y1: "-1179.29",
                        x2: "-10103.77",
                        y2: "-1247.52",
                        gradientTransform: "matrix(.99 -.11 .11 .99 10362.66 390.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".37",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-224",
                        x1: "197.02",
                        y1: "184.01",
                        x2: "293.47",
                        y2: "87.57",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".36",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-225",
                        x1: "294.7",
                        y1: "238.16",
                        x2: "334.79",
                        y2: "238.16",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".12",
                                stopColor: "#0d6eff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".49",
                                stopColor: "#2f86ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".8",
                                stopColor: "#4495ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-226",
                        x1: "245.55",
                        y1: "299.49",
                        x2: "376",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".47",
                                stopColor: "#f5f6f8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-227",
                        x1: "153.96",
                        y1: "321.19",
                        x2: "337.13",
                        y2: "321.19",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-228",
                        x1: "115.09",
                        y1: "299.49",
                        x2: "245.55",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-229",
                        x1: "251.12",
                        y1: "196.75",
                        x2: "347.56",
                        y2: "100.3",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".08",
                                stopColor: "#ffa219"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#ffbb07"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-230",
                        x1: "-2946.9",
                        y1: "-501.86",
                        x2: "-2929.95",
                        y2: "-501.86",
                        gradientTransform: "matrix(-.75 .66 .66 .75 -1698.92 2528.01)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".54",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#00bddd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-231",
                        x1: "913.18",
                        y1: "236.51",
                        x2: "936.34",
                        y2: "213.36",
                        gradientTransform: "matrix(-1 0 0 1 1111.25 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".62",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-232",
                        x1: "2869.84",
                        y1: "1497.87",
                        x2: "2882.64",
                        y2: "1491.62",
                        gradientTransform: "matrix(-.9 -.43 -.43 .9 3435.48 110.98)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#00a8c5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#00b8d5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".84",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: "-6136.21",
                        y1: "5146.38",
                        x2: "-6130.92",
                        y2: "5141.09",
                        gradientTransform: "matrix(1 0 0 1.52 6291.96 -7637.21)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: "-6135.75",
                        y1: "5139.64",
                        x2: "-6131.37",
                        y2: "5135.26",
                        gradientTransform: "matrix(1 0 0 1.52 6301.53 -7627.42)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: "-6135.24",
                        y1: "5133.66",
                        x2: "-6131.89",
                        y2: "5130.31",
                        gradientTransform: "matrix(1 0 0 1.52 6309.67 -7619.1)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-233",
                        x1: "177.32",
                        y1: "462.13",
                        x2: "177.32",
                        y2: "382.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-234",
                        x1: "303.59",
                        y1: "388.02",
                        x2: "303.59",
                        y2: "380.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-235",
                        x1: "310.94",
                        y1: "133.6",
                        x2: "337.06",
                        y2: "186.14",
                        gradientTransform: "matrix(1 0 0 -1 0 582.59)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        gradientTransform: "matrix(1 0 0 .19 0 315.55)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".11",
                                stopColor: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#e6fcff",
                                stopOpacity: ".73"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".56",
                                stopColor: "#e6fcff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".77",
                                stopColor: "#e6fcff",
                                stopOpacity: ".19"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".92",
                                stopColor: "#e6fcff",
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#e6fcff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-3",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-4",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-5",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-6",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-7",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-8",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-9",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-10",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-12",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-13",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-15",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("style", {
                        children: $608c538d98081b3b$var$styles
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.11 212.89a42.69 42.69 0 00-23.17 17.18 32 32 0 00-19.06 0c-12.17 3.89-17.61 14-18.68 16.07a27.91 27.91 0 00-12.7-.75c-11.75 2.16-15.82 11.61-28.77 19.43a62.31 62.31 0 01-20.93 7.85h199.54c.21-1.14 2-11.54-5.62-19.8-8.13-8.86-19.65-7.25-20.55-7.1-.24-2.07-2.67-20.34-19.14-29.79-13.75-7.89-27.59-4.07-30.92-3.09z",
                                fill: "url(#linear-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M281.14 34.8a52.1 52.1 0 0128.24 21 39 39 0 0123.23 0c14.84 4.75 21.47 17 22.77 19.59a34 34 0 0115.49-.91c14.31 2.63 19.27 14.11 35.07 23.68a75.76 75.76 0 0025.5 9.57H188.21c-.26-1.39-2.41-14.07 6.84-24.14 9.92-10.8 24-8.83 25-8.66.3-2.52 3.26-24.78 23.34-36.3 16.82-9.63 33.68-5.02 37.75-3.83z",
                                fill: "url(#linear-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M118.71 264.49l-2.65-2.66a509.36 509.36 0 0070.25-87.4 509.23 509.23 0 0057.44-125.07l3.6 1.1a513.26 513.26 0 01-57.87 126 513.28 513.28 0 01-70.77 88.03z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z",
                                fill: "url(#linear-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M149.52 159.55a91.75 91.75 0 01-.5-82.63l81.91-.32a91.72 91.72 0 00.17 82.63z",
                                fill: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M152 139.06a217.27 217.27 0 0116.17-19.35 270.57 270.57 0 0021.13 19.19z",
                                fill: "url(#linear-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M165.12 139a226.29 226.29 0 0121.82-25.16 264.7 264.7 0 0026.61 25z",
                                fill: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.27 99.13c-.75 3.6-4 6.57-7.49 6.58a5.26 5.26 0 01-5.28-6.53 8.62 8.62 0 018-6.5c3.5-.02 5.5 2.84 4.77 6.45z",
                                fill: "#ffab00"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z",
                                opacity: ".4",
                                fill: "#79e2f2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.25 358.05z",
                                fill: "url(#linear-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M10.57 363.88a34.13 34.13 0 01-4.19-5.61 34.13 34.13 0 004.19 5.61z",
                                fill: "url(#linear-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.18 403.31c0-.11 0-.21-.05-.32.02.11.03.21.05.32z",
                                fill: "url(#linear-gradient-7)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36l-.39-.3z",
                                fill: "url(#linear-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.44 397l-.22-.43z",
                                fill: "url(#linear-gradient-9)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.24 399l-.06-.19z",
                                fill: "url(#linear-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.83 401.28c0-.17-.07-.33-.1-.5.03.22.07.33.1.5z",
                                fill: "url(#linear-gradient-11)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62z",
                                fill: "url(#linear-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M52.78 387.47l-.54-.15z",
                                fill: "url(#linear-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M56.85 388.76l-.36-.12z",
                                fill: "url(#linear-gradient-14)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M54.69 388l-.45-.13z",
                                fill: "url(#linear-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.44 390.25l-.28-.13z",
                                fill: "url(#linear-gradient-16)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M62.35 391.32l-.38-.23z",
                                fill: "url(#linear-gradient-17)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M58.76 389.5l-.51-.21z",
                                fill: "url(#linear-gradient-18)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M66.5 395.35l-.3-.44z",
                                fill: "url(#linear-gradient-19)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11a20.58 20.58 0 00.13 2.24 20.58 20.58 0 01-.13-2.24z",
                                fill: "url(#linear-gradient-20)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M261.42 301.27a609.78 609.78 0 00-90.77-6.5c-46.73 0-84 4.81-111.68 12.89 51-4.09 112.85-6.49 179.48-6.49q11.55 0 22.97.1z",
                                fill: "url(#linear-gradient-21)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M72.61 389.43c13.52 1.46 23-7.28 24.46-8.66a31.57 31.57 0 0018.2 9.25 28.77 28.77 0 006.33.13L131.82 373c-46.35-1.93-87.72-5.09-121.25-9.13a59.82 59.82 0 0010.28 8.71 120.25 120.25 0 0022.79 12.05 68.6 68.6 0 006.89 2.19 39.55 39.55 0 006.15-4.29 30.07 30.07 0 0015.93 6.9z",
                                fill: "url(#linear-gradient-22)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M155.07 392.74c2.57 1.87 4.48 3.74 4.48 5.61a412.84 412.84 0 01-90.34 11.72 28.54 28.54 0 01-1.91 7.77 16 16 0 00-1.3 6.21c0 26.77 37.45 48.47 124.94 48.47s158.43-21.7 158.43-48.47v-.78c63.6-3.54 113.92-18.7 126.69-38-.21-7.4-5.85-14.4-15.75-20.65-29.28 3.34-64.08 6-102.68 7.86l17.73 29.73L301.4 385l-56.53 77.4-48.33-66.17.86-13.31z",
                                fill: "url(#linear-gradient-23)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.12 355.81q-.33-.71-.6-1.44.27.74.6 1.44z",
                                fill: "url(#linear-gradient-24)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.37 407.61v.37c-.01-.13-.01-.25 0-.37z",
                                fill: "url(#linear-gradient-25)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.24 426.24a32 32 0 004.63-3.2 31.16 31.16 0 003.95-3.93q-1.92-3.23-3.81-6.79c-.87-1.64-1.68-3.25-2.46-4.83-.25.51-.53 1.05-.88 1.63-.56.89-1.11 1.81-1.67 2.75q-1.16 2-2.22 3.85a33.81 33.81 0 011.82 5.95 34.18 34.18 0 01.64 4.57z",
                                fill: "url(#linear-gradient-26)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.67 351.54q-.17-.74-.27-1.5.11.77.27 1.5z",
                                fill: "url(#linear-gradient-27)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.31 344.19c0-.32.08-.63.12-.95-.04.32-.09.63-.12.95z",
                                fill: "url(#linear-gradient-28)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.27 353.68c-.15-.46-.29-.92-.41-1.39.14.47.26.93.41 1.39z",
                                fill: "url(#linear-gradient-29)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-30)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-31)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-32)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-33)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-34)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-35)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-36)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-37)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-38)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-39)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-40)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-41)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-42)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-43)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z",
                                fill: "url(#linear-gradient-44)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-45)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-46)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-48)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-49)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-50)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-51)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.86 352.29c-.07-.25-.14-.5-.19-.75.05.25.12.46.19.75z",
                                fill: "url(#linear-gradient-52)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.52 354.37z",
                                fill: "url(#linear-gradient-53)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.36 356.36l-.24-.55z",
                                fill: "url(#linear-gradient-54)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11z",
                                fill: "url(#linear-gradient-55)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.38 358.27c0-.08-.08-.15-.13-.22s.08.14.13.22z",
                                fill: "url(#linear-gradient-56)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.44 343.18v.06a.64.64 0 000-.07z",
                                fill: "url(#linear-gradient-57)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-58)",
                                opacity: ".9",
                                d: "M10.57 363.88z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.4 350c0-.22-.08-.45-.11-.68.03.27.07.5.11.68z",
                                fill: "url(#linear-gradient-59)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-60)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-61)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-62)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-63)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-64)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-65)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-66)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-67)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-68)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-69)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-70)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-72)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-73)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-74)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-75)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-76)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-77)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-78)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-79)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-80)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-81)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-82)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-83)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-84)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-85)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-86)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z",
                                fill: "url(#linear-gradient-87)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-88)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-89)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-90)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-91)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-92)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-93)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-94)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-95)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-96)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-97)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-98)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-99)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-100)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-101)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-102)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-103)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-104)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-105)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-106)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-107)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-108)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-109)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-110)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-111)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-112)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-113)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-114)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-115)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-116)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-117)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-118)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-119)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-120)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-121)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-122)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-123)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-124)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-125)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-126)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-127)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-128)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-129)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-130)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-131)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-132)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-133)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-134)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-135)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-136)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-137)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-138)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-139)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-140)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-141)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-142)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-143)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-144)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-145)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-146)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-147)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-148)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-149)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-150)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-151)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-152)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-153)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-154)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-155)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-156)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-157)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-158)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-159)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-160)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-161)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-162)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-163)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-164)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-165)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-166)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-167)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-168)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-169)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-170)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-171)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-172)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-173)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-174)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-175)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-176)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-177)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-178)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-179)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-180)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-181)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-182)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-183)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-184)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-185)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-186)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-187)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-188)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-189)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-190)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-191)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-192)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-193)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-194)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-195)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-196)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-197)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-198)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-199)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-200)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-201)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-202)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-203)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-204)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-205)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-206)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-207)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-208)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-209)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-210)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-211)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-212)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-213)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-214)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.73 400.78z",
                                fill: "url(#radial-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.21 410.07z",
                                fill: "url(#radial-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.46c0-.72-.09-1.44-.18-2.15.09.69.15 1.43.18 2.15z",
                                fill: "url(#radial-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.13 403q-.12-.87-.3-1.71.17.83.3 1.71z",
                                fill: "url(#radial-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62v2c.03-.68.03-1.34 0-2z",
                                fill: "url(#radial-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45 13.64 13.64 0 00-1.2-1.45 12.87 12.87 0 00-1.19-1.1z",
                                fill: "url(#radial-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M56.49 388.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M50.53 386.83l1.71.49-1.71-.49z",
                                fill: "url(#radial-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M62 391.09q-.73-.45-1.53-.84.77.39 1.53.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.16 390.12z",
                                fill: "url(#radial-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-230",
                                d: "M58.25 389.29l-1.4-.53z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.18 398.84a15.81 15.81 0 00-.74-1.8 15.81 15.81 0 01.74 1.8z",
                                fill: "url(#radial-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.22 396.61a14.16 14.16 0 00-.72-1.26 14.16 14.16 0 01.72 1.26z",
                                fill: "url(#radial-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M54.24 387.91l-1.46-.44z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.42 392.06z",
                                fill: "url(#radial-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M159.55 398.35c0-1.87-1.91-3.74-4.48-5.61l-40.65 9.44 7.18-12a28.77 28.77 0 01-6.33-.13 31.57 31.57 0 01-18.2-9.25c-1.46 1.38-10.94 10.12-24.46 8.66a30.07 30.07 0 01-15.93-6.89 39.55 39.55 0 01-6.15 4.29l1.71.49.54.15 1.46.44.45.13c.6.19 1.21.39 1.8.6l.36.12 1.4.53.51.21c.48.2.94.4 1.4.62l.28.13q.8.39 1.53.84l.38.23c.37.24.73.49 1.07.74l.39.3a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45l.3.44a14.16 14.16 0 01.72 1.26l.22.43a15.81 15.81 0 01.74 1.8l.06.19c.18.57.35 1.15.49 1.75 0 .17.07.33.1.5q.18.84.3 1.71c0 .11 0 .21.05.32.09.71.15 1.43.18 2.15V408.02c0 .7-.07 1.4-.14 2.09a412.84 412.84 0 0090.33-11.76z",
                                fill: "url(#linear-gradient-215)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-216)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-217)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-218)",
                                d: "M245.54 265.79l-130.45-4.54 130.46 43.41L376 261.25l-130.46 4.54z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M239.61 200.11L154 337.73h91.59V198.21H243a4 4 0 00-3.39 1.9z",
                                fill: "url(#linear-gradient-219)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-240",
                                d: "M205.28 255.28l-3.12 5h43.39v-5h-40.27zM199.08 265.23l-3.11 5h49.58v-5h-46.47zM245.55 275.18h-52.66l-3.12 5h55.78v-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M251.49 200.11a4 4 0 00-3.41-1.9h-2.53v139.52h91.58z",
                                fill: "url(#linear-gradient-220)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M245.55 255.28h20.27v5.01h-20.27zM245.55 265.23h20.27v5.01h-20.27zM245.55 275.18h4.98v5.01h-4.98z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M246.9 226.91a41 41 0 0120.1 4.17 34.66 34.66 0 004.89 1.76l-20.36-32.73a4 4 0 00-3.41-1.9h-2.53V227c.41 0 .85-.06 1.31-.09z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-221)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("ellipse", {
                                cx: "190.18",
                                cy: "308.96",
                                rx: "48.27",
                                ry: "5.8",
                                fill: "url(#linear-gradient-222)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M185.7 301.74a14 14 0 01.43 3.35 14.28 14.28 0 01-.31 3l-1.61.68-.34-.66-.57 1.09a14.39 14.39 0 01-3.08 1.26 8.93 8.93 0 01-2.56.42c-1.39 0-3.44-.35-3.53-1.06-.06-.44.67-.68 2.25-1.89a15.9 15.9 0 002.73-2.66 11.3 11.3 0 001.8-3.36l.3-.87z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M174.84 236.19c0 1.93-.39 5.85-.31 9.29.3 12.41.56 19.91 2 30.32.89 6.27 2.08 15.42 3.16 26.77a8.92 8.92 0 006.88-1c-.18-1.82-.4-4.76-.41-8.4 0-6.72.73-9.48.3-14.85a45.06 45.06 0 00-1.57-8.63q1.4-9.27 2.78-18.54a11.6 11.6 0 007-6.47 11.37 11.37 0 00-2.1-11.53z",
                                fill: "url(#linear-gradient-223)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M196.05 302a13.43 13.43 0 00-.57 3.33 14 14 0 00.19 3l1.57.75.37-.65c.18.37.36.74.53 1.11a14.08 14.08 0 003 1.38 9.27 9.27 0 002.55.53c1.39.07 3.45-.21 3.57-.91.08-.44-.64-.71-2.18-2a16.49 16.49 0 01-2.62-2.77 11.21 11.21 0 01-1.65-3.44l-.27-.88zM192.04 238.74l-.09 4.58-8.74-4.11 8.83-.47zM191.79 237.53l1.88-.45 1.62-.19-1.63 2.37-1.87-1.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M177.85 236.91q1.92 5.47 3.8 11.05 3.84 11.43 7.23 22.54l5.25 32.69 6.81-.95q-1.2-16.9-2.41-33.8c-.2-3.54-1.43-25.55-2-28.67-.1-.56-.25-1.09-.25-1.09a16.4 16.4 0 00-1.92-4.36l-1.25.63z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M201.33 28.18l-16.94.27a13.73 13.73 0 00-13.51 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.82v.09c0 .06.11.06.12 0v-.09a8.28 8.28 0 017.9-6.08 13.71 13.71 0 0013.56-13.94 13.74 13.74 0 00-13.94-13.52zM384.25 141.53l-16.93.26a13.74 13.74 0 00-13.52 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.83v.08a.07.07 0 00.13 0v-.09a8.26 8.26 0 017.9-6.07A13.73 13.73 0 00398.19 155a13.73 13.73 0 00-13.94-13.47z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M228.71 128.46a89.94 89.94 0 00-10.59 37.28l20.12-.08c1.83 0 2.47-1.38 1.5-3.1a91.86 91.86 0 01-11.03-34.1z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-224)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M192.09 291.26l-3.44-1.53a612 612 0 0040.22-125.5A612.62 612.62 0 00241.27 45H245a615.38 615.38 0 01-12.47 120 615.64 615.64 0 01-40.44 126.26z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M342.5 235.7c.15-.74.44-1 1.47-2.24l.88-1c2-2.42 2.53-3.68 3.34-3.68.57 0 .92 1 2 2.06 1.33 1.24 1.26 2 1.14 2.62-.18.85-2.92 4.06-4.43 4.51-.45.13-3 1.24-3.43 1-.93-.5-1.19-2.08-1-3.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M299.43 243.7c.3.22.77.55 1.34.92 1.68 1.08 8.57 2.84 10.74 3.75s12.52 3.33 14.57 3.06a6.65 6.65 0 001.78-.49l16.46-11.48-1.32-4.81c-7 3.08-11.64 5.5-18.65 8.58l-22.71-6.32-2.13 3.22z",
                                fill: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M308.31 220.59c.57-.87 1.3-2.19.83-2.85s-1.42-.18-3.85-.08c-3.5.13-3.88-.47-5.65.09a6.82 6.82 0 00-3.52 2.44c-1.68 2.39-.9 5.38-.66 6.28a10 10 0 004.55 5.8l1.9 1.21 5.37-9.24z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.16 236.73h7.25a13.5 13.5 0 01-.78-8.17l-4.42-.21c-.06.26-.14.63-.27 1.08a3.75 3.75 0 01-.48 1.23 2.58 2.58 0 01-1.94.84c.21 1.74.42 3.49.64 5.23",
                                fill: "#543e36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.9 314.33c0-.14-2.25-.5-2.26-.65-.29-4.21-1-23.6-1.6-28.34-.89-7.08-1.73-13.77-1.27-16.81.12-.84.81-4 1.21-5.72a13.39 13.39 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.58.64.19a14.22 14.22 0 001.59.4c.45.09.82.14 1.09.17h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08 24.5 24.5 0 013.11 7.49c4.6 18.9 5.37 21.45 5.48 21.76v.2c.3 1.71 2.17 11.12 2.46 12.86-2.31 1.89-4.35 1.51-7.73 1.29-1.63-3.1-6.21-12.94-7.84-16.07l-3.58-6.91c0 5.11.16 22.38.13 27.49-3.05 1.27-4.25 4.1-7.41 3.55",
                                fill: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M300.94 274.09a11.32 11.32 0 01-2.37-5 15 15 0 01.41-6.31 14.78 14.78 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.59.64.2c.52.16 1 .3 1.59.41s.82.13 1.09.16h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08c2.66 4.2 3.58 9.74 4.87 14.53q1.46 5.37 2.73 10.79c.21.9 2.63 8.75 1.94 9.31-2.31 1.9-5.73 2.44-9.12 2.22-1.62-3.1-3.25-6.19-4.88-9.32-2-3.78-3.64-7.36-6.79-10.31a57.06 57.06 0 01-6-5.8",
                                fill: "#253858"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M308.31 220.59c.35.8.69 1.59 1 2.39l3.09 1.9c-.25.44-.5.88-.76 1.32l.27 4.75a11.78 11.78 0 01-3 1.6c-.42.14-.6.14-4.32.27-1.59.06-2.39.08-2.75-.36a2.08 2.08 0 01-.13-2c.24-.59.54-.54.82-1.12.43-.9-.11-1.42.17-2.27s.91-.67 1.9-1.71.9-1.95 2-3.35a6.5 6.5 0 011.69-1.45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M311.67 226.2a1.23 1.23 0 01.4.53 1.14 1.14 0 010 .73 4.73 4.73 0 01-1.2.42 4.66 4.66 0 01-.92.09c0 .24.06.57.11 1 .14 1 .22 1.13.31 1.18.33.18 1-.2 1.28-.75a1.45 1.45 0 00.14-.64 2.26 2.26 0 01.7 1.13 2.29 2.29 0 01-.28 1.63 3 3 0 01-2.26 1.29h-.15c-4 .2-4.31.2-4.56.13-2.28-.69-2.12-7.66-2.12-8l2.54-1.52a3.32 3.32 0 00-.32 2.85c.09.21.55 1.39 1.5 1.58s1.5-.89 3.4-1.42a6.35 6.35 0 011.4-.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M343 230.84s1.53 1.69.62 3.1c-.64 1 1.8 1.33 1.8 1.33a2.2 2.2 0 00.24-3.06c-1.29-1.77-2.66-2.34-2.66-1.37"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M372.38 264.49a513.32 513.32 0 01-70.76-88 512.55 512.55 0 01-57.87-126l3.59-1.1a508.92 508.92 0 0057.45 125.07A509.3 509.3 0 00375 261.83z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M348 228.66s-1.78 3.06-1.21 3.71 1.21-.08 1.21-.08-.73 1-.4 1.45 1.12-.32 1.12-.32-.64 1 0 1.37 1.05-.49 1.05-.49-.56 2.1 0 1.86 1.21-1 1.61-2.74-2-5.32-3.38-4.76M330.15 211.75c.29-.72-.1-1.12 0-3.88v-.51c0-1.44-.95-2-3.35-4.71-.59-.66-1.52-1.73-1.9-1.53a.67.67 0 00-.28.37c-.08.26.06.42 0 .53s-.55-.09-.73 0 .18 1.12.62 2.24c.8 2 .82 2.67.69 3.21 0 .13-.24.93-.7 1-.13 0-.3 0-.7-.34a8 8 0 01-1.14-1.27c-.52-.6-1.3-1.16-1.5-1s.13.53.27 1.39a13.9 13.9 0 010 1.62c.08.62.44 1 2.56 2.79a9.87 9.87 0 002.38 1.73 3.49 3.49 0 003.74-1.69"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M325.44 212.82c1.91 6.66 1 18.09 1 18.09s-13.3 3.32-16.49 3.61c0 0-6.81.64-10.54 2.5-.88.44-1.74.95-1.74.95-.47.28-.77.48-.77.48l-.1.06a4.93 4.93 0 00-1.9 5.56c.37 1.21.72 2.47 1.05 3.79a74.38 74.38 0 012.19 16.19 30.77 30.77 0 0021.17-1.62 99.26 99.26 0 01-1.49-11.3c-.18-2.33-.26-4.56-.28-6.67 2.38-.56 9.65-4.62 14.18-7.35a6.26 6.26 0 002.93-6.54c-1.15-6.13-2.93-16.42-4.23-19.47-3.12 1.12-4.98 1.72-4.98 1.72z",
                                fill: "url(#linear-gradient-225)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-226)",
                                d: "M376 261.25l-38.87 76.48-91.58-33.07L376 261.25z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M318.63 280.34l-5 1.67v35.67h5v-37.34zM328.59 277.03l-5.01 1.66v38.99h5.01v-40.65zM338.54 273.72l-5.01 1.66v27h5.01v-28.66z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-227)",
                                d: "M337.13 337.73H153.96l91.59-33.07 91.58 33.07z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-228)",
                                d: "M245.55 304.66l-91.59 33.07-38.87-76.48 130.46 43.41z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M245.55 0a5 5 0 015 5v201.67h-5V0z",
                                fill: "#fafbfc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-242",
                                d: "M245.54 0v206.67h-5V5a5 5 0 015-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M250 101.43a90.13 90.13 0 000 94.19h98.7a90.13 90.13 0 010-94.19z",
                                fill: "url(#linear-gradient-229)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306.75 128.62a6.3 6.3 0 01-5.66-3.1c-.89-1.2-1.45-2-3.23-2s-2.81.78-4.33 2c-1.75 1.38-3.86 3.1-7.17 3.1a6.29 6.29 0 01-5.66-3.1c-.89-1.2-1.45-2-3.24-2s-2.8.78-4.32 2c-1.75 1.38-3.86 3.1-7.18 3.1a6.28 6.28 0 01-5.65-3.1c-.89-1.2-1.45-2-3.23-2 .37-1.27.76-2.52 1.18-3.77 3.31 0 4.46 1.68 5.44 3 .85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3s4.47 1.68 5.45 3c.85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3a5.86 5.86 0 015.45 3c.85 1.19 1.44 2 3.22 2s2.79-.79 4.35-2c1.78-1.37 4.07-3 7.38-3-.42 1.25-.81 2.5-1.17 3.77-1.78 0-2.82.78-4.34 2-1.74 1.38-3.85 3.1-7.17 3.1z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.88 140.51a7.32 7.32 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.7.8-4.05 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.69.8-4 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1-1.22-1.72-2-3.5-2 .19-1.3.41-2.58.66-3.87 3.31 0 4.7 1.73 5.86 3.13 1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.59-1.4 3.64-3.13 7-3.13s4.7 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.6-1.4 3.64-3.13 7-3.13s4.71 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.69-.81 4.08-2c1.6-1.4 3.64-3.13 7-3.13-.24 1.29-.46 2.57-.65 3.87-1.78 0-2.71.8-4.06 2-1.73 1.4-3.61 3.15-6.93 3.15z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.61 152.52c-3.31 0-5.11-1.75-6.5-3.16-1.21-1.23-2-2-3.78-2s-2.58.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.22-1.23-2-2-3.78-2s-2.59.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.21-1.23-2-2-3.77-2 0-1.3.06-2.61.14-3.91 3.31 0 4.93 1.76 6.28 3.17 1.18 1.23 2 2 3.76 2s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.93 1.76 6.29 3.16c1.18 1.24 2 2.05 3.76 2.05s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.94 1.76 6.29 3.16c1.18 1.24 2 2.05 3.77 2.05s2.57-.81 3.8-2.05c1.41-1.41 3.22-3.16 6.54-3.16-.07 1.3-.12 2.61-.13 3.91-1.78 0-2.6.81-3.79 2-1.37 1.45-3.02 3.2-6.34 3.2z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306 164.48c-3.32 0-5.35-1.74-6.92-3.13-1.38-1.23-2.27-2-4.06-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.13c-1.38-1.23-2.27-2-4.05-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.14c-1.38-1.22-2.26-2-4-2-.16-1.29-.29-2.59-.38-3.89 3.31 0 5.16 1.75 6.7 3.16 1.34 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16s5.17 1.75 6.71 3.16c1.34 1.22 2.25 2 4 2s2.46-.81 3.54-2a7.4 7.4 0 016.11-3.16c3.32 0 5.17 1.75 6.71 3.16 1.35 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16.1 1.3.23 2.6.38 3.89-1.78 0-2.48.81-3.51 2-1.18 1.38-2.59 3.12-5.85 3.12z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M297.21 171.16c-1.78 0-2.37.8-3.24 2-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.35-3.06c-1.54-1.19-2.53-2-4.32-2s-2.37.8-3.24 2c-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.34-3.06c-1.55-1.19-2.54-2-4.32-2-.33-1.27-.63-2.54-.91-3.82 3.32 0 5.4 1.72 7.14 3.1 1.5 1.2 2.52 2 4.3 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1c3.31 0 5.4 1.73 7.13 3.1 1.51 1.2 2.53 2 4.31 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M182.26 189.82c-3.63 5.16 4.34 17.38 9.25 16.82 3.35-.38 5.2-6.62 5.37-7.19.51-1.71 1.53-5.17-.43-8.4a8.93 8.93 0 00-5.3-3.83c-3.29-.83-7.22.24-8.89 2.6z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M183 208.52l4.17 1 2.6-10.5-8.24-2.02c-.79.44-4 2.37-4.69 6-.18.92-.55 2.8.6 4.25s3.33 1.91 5.56 1.27z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M185 214.79c-3.72 1.33-6.9 2.27-9.32 2.92a48.24 48.24 0 01-6.84 1.37c-2.58.33-3.87.5-4.44.12-1.92-1.27-.92-5.22.43-16 .35-2.79.6-5.06.75-6.44.08-.62.17-1.24.25-1.86l4.48.28c-.36.73-.73 1.45-1.09 2.17q.09 7.35.17 14.7l11.43-4.33a6.71 6.71 0 011.79.42 5 5 0 012.6 2.17 5.08 5.08 0 01-.21 4.48z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M170.77 211.15l12.4-4.57a5.61 5.61 0 014 3.4 5.46 5.46 0 01-.66 4.76l-14 3.69a7.85 7.85 0 00-1.74-7.28z",
                                fill: "url(#linear-gradient-230)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175 217c.55-2.31 1.68-1.93 3.36-5.75a8.35 8.35 0 011.9-3.26 6.41 6.41 0 012.65-1.45h5.5a4.58 4.58 0 001.57 1.64c1.52.92 2.8.45 4.8.91h.1a6 6 0 012.88 1.68 5.09 5.09 0 011.45 3 15.48 15.48 0 01-1.72 8.3 33.5 33.5 0 00-2.49 10.49c.45 1.24 1 4.27 1.48 5.52a34.78 34.78 0 01-22.07.15c2-9.74 1.61-13.49 1.16-15.16-1.11-4.31-.89-4.72-.57-6.07z",
                                fill: "url(#linear-gradient-231)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.33 208.07a10.5 10.5 0 003.56.61 10.74 10.74 0 004.19-.87 8.4 8.4 0 01-1-2.18 7.87 7.87 0 01-.26-2.87l-6.77.9z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.82 190.38a22.9 22.9 0 00-1.07 2.16 22.06 22.06 0 00-1.08 3c-.11.14-.31.4-.58.71-.83.92-1.62 1.41-1.47 1.7 0 0 .75.45.87.58s-.3 2.64.09 3.7c.79 2.16 7.2 3.64 9.76 1a4.13 4.13 0 001.07-2.3 3.3 3.3 0 00-.32-.18 3.38 3.38 0 00-2.45-.1 4.19 4.19 0 00.05-2.92c-.35-.86-.82-.95-2.89-3.07a6.6 6.6 0 01-1.62-2.1 5.08 5.08 0 01-.36-2.18z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M191 210.05a4.52 4.52 0 004.83-.1 4.18 4.18 0 001.41-3c.12-1.79-.95-2.42-1.07-4.33a6.26 6.26 0 01.73-3.2 19.22 19.22 0 01-3.22-.73 20.07 20.07 0 01-4.09-1.86 5.26 5.26 0 01-.24 2.62c-1 2.6-3.62 2.62-4.52 5a4.53 4.53 0 00.6 4.25c1.11 1.49 3.31 1.99 5.57 1.35z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M200.34 250.5c-.18 1.21-.3 2.37-.43 3.57s-.23 2.66-.47 3.74a1.2 1.2 0 01-.67.84c-.22.1-.05-.37-.18-.24s0 .54-.24.73a.16.16 0 01-.17.07c-.13 0-.19-.43-.31-.42s-.17.38-.26.48-.21.31-.4.31-.11-.31-.32-.31-.2.69-.41.65-.29-.36-.31-.77c-.08-1.29.37-2.64.42-4.14a13.93 13.93 0 00-.26-2.58 7.75 7.75 0 00-.91 1.73 3.64 3.64 0 01-.74 1.27.89.89 0 01-.66.31c-.19 0-.46 0-.45-.14a14.18 14.18 0 01.73-2.6c.51-1.55 1.32-4.23 2.95-4.6s2.28 1.16 3.09 2.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M199.33 214.4c.9 4.85 1.91 8.62 2.45 14.62a80.48 80.48 0 01-1.44 21.89 21 21 0 01-3-.27c.2-6.68.5-13.68-1.15-20.08-1.24-4.83-3.2-9.14-4.74-13.52-.84-2.4-.6-3.89 1-5.53a2.41 2.41 0 011.84-.89c2.56.08 4.42.49 5.04 3.78z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.31 211.52a4.9 4.9 0 011.81-.94 4.37 4.37 0 015.16 3.47l1.82 8.67a8.3 8.3 0 00-3.41.68 9 9 0 00-3.26 1.74c-1-2.44-1.82-4.9-2.8-7.34a6 6 0 01-.45-4.56 4 4 0 011.13-1.72z",
                                fill: "url(#linear-gradient-232)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M156.83 188.77H160a.49.49 0 01.49.49v9.65h-4.14v-9.65a.49.49 0 01.48-.49z",
                                transform: "rotate(91.28 158.41 193.83)",
                                fill: "url(#New_Gradient_Swatch_13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.94 189.54H169a.5.5 0 01.5.5v8.51h-3.08V190a.5.5 0 01.52-.46z",
                                transform: "rotate(91.28 167.981 194.045)",
                                fill: "url(#New_Gradient_Swatch_13-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                transform: "rotate(91.28 176.118 194.226)",
                                fill: "url(#New_Gradient_Swatch_13-3)",
                                d: "M175.15 190.6h1.92v7.27h-1.92z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "178.59",
                                y: "193.96",
                                width: "3.06",
                                height: ".74",
                                rx: ".3",
                                transform: "rotate(91.28 180.12 194.325)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "150.26",
                                y: "193.12",
                                width: "4.96",
                                height: "1.2",
                                rx: ".49",
                                transform: "rotate(91.28 152.736 193.71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M168 194.23h1.47a.73.73 0 00.73-.73V192a1 1 0 00-.21-.52 1 1 0 00-.64-.36l-1.35-.02a.76.76 0 00-.56.24.85.85 0 00-.18.69v1.47a.74.74 0 00.74.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "166.04",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(180 166.77 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "169.9",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(-180 170.63 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M186.39 387.41l.65-2.09-.93.22c.1.62.19 1.24.28 1.87zM197.57 400.68c-.29 4.12-.58 7.54-.79 8.63-.1.55-.25 1.09-.25 1.09l-.14.48.38.12c-.45 1.24-1 4.28-1.48 5.52.14 1.52.35 2.89.59 4.14.22-.71.43-1.42.61-2.14 1.46-5.69 1.4-11.84 1.22-17.83zM344.22 423.89c-6-2.63-10-4.71-16-7.35l-2.05.57c2.65 1.35 6 3.24 8.38 4.69a5.4 5.4 0 012.52 5.62c-.48 2.55-1.08 5.92-1.7 9q4.68-5.9 9.55-11.63v-.06c-.31-.35-.54-.62-.7-.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M200.61 398.16h-.05c-.15-1.06-.26-2.09-.38-3.15s-.23-2.66-.47-3.74a1.2 1.2 0 00-.67-.84c-.22-.1 0 .36-.18.24s0-.55-.24-.73a.14.14 0 00-.17-.07c-.09 0-.14.19-.2.31.18-3 .33-5.72.44-7.56l-1.29.3-10.4 2.4-.65 2.09c-.09-.63-.18-1.25-.28-1.87L175.36 388c-.27 4.63-.41 9.51-.56 15.57-.05 2.44.1 5.11.21 7.15l-.31.09c2.05 9.75 1.61 13.5 1.16 15.17-.84 3.19-.93 4.24-.8 5.11a49.27 49.27 0 00-5.92-1.13c-2.58-.33-3.87-.49-4.44-.12-1.92 1.28-.92 5.23.43 16.05.35 2.79.6 5.06.75 6.43.05.4.11.79.16 1.19h-2.31a.5.5 0 00-.5-.48l-9.65.22a.47.47 0 00-.48-.43h-.23a.5.5 0 00-.48.5l.09 4a.49.49 0 00.5.47h.23a.48.48 0 00.46-.44l9.64-.21a.5.5 0 00.48-.51l2.51-.06v.44a.73.73 0 00.73.73.69.69 0 00.55-.26.9.9 0 00.14.22.81.81 0 00.56.24l1.35-.05a1 1 0 00.64-.36l.05-.09a.7.7 0 00.57.3.73.73 0 00.74-.73v-.56h.65a.52.52 0 00.49-.52v-.07l7.26-.16v.3a.3.3 0 00.3.29h.14a.31.31 0 00.3-.31l-.06-2.46a.29.29 0 00-.3-.29h-.14a.3.3 0 00-.3.31v.27l-7.27.17v1-1a.5.5 0 00-.51-.49h-1.86l-.84-1.68q.09-7.35.17-14.69l1.57.59a2.88 2.88 0 01-.22.27l7.91 2.91a3.91 3.91 0 00-1.24 1c-1.15 1.44-.78 3.32-.6 4.25a8.52 8.52 0 003 4.84l-.25.16c-.15.28.64.78 1.47 1.7.27.3.47.56.58.71-.53 2.19-.45 4.27.59 5.76 1.67 2.36 5.6 3.43 8.89 2.59a8.85 8.85 0 005.3-3.82c2-3.23.94-6.69.43-8.41-.05-.17-.26-.86-.61-1.75a5.53 5.53 0 01-.12-1.44c.12-1.91 1.19-2.55 1.08-4.33a4.5 4.5 0 00-1.1-2.67 6.4 6.4 0 001.63-1.21 5.13 5.13 0 001.44-2.92c0-.09.06-.18.08-.28l1.82-8.67h-.15c.33-1.89.62-3.93.83-6.32a80.51 80.51 0 00-1.38-21.92zm-4.12 20.36c-.18.72-.39 1.43-.61 2.14-.24-1.25-.45-2.62-.59-4.14.45-1.24 1-4.28 1.48-5.52l-.38-.12c.05-.17.11-.34.14-.48s.15-.54.25-1.09c.21-1.09.5-4.51.79-8.63h.14c.18 6 .29 12.15-1.22 17.84z",
                                fill: "url(#linear-gradient-233)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-234)",
                                d: "M301.4 385.02l4.39 1.02"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M327.83 451.92c.16.11.51-.12.63 0s0 .23 0 .45a.61.61 0 00.24.32c.32.17 1.12-.75 1.63-1.31 2.06-2.31 2.85-2.82 2.88-4.05v-.44a18.86 18.86 0 01.07-2.53q6.66-8.68 13.75-17c.64.85 1 1.38 1.39 1.56l.08.14c1 .4 2.55-1.6 2.88-3.17a1.68 1.68 0 000-.91 4.62 4.62 0 00-.76-1.83q9.87-11.32 20.49-21.94l-3.69-.86q-10.01 10.16-19.42 20.93a2 2 0 00-.41-.18c-.29-.09-1.56-.63-2.35-.82l.13-.5-14.14-9.86a5.44 5.44 0 00-1.53-.42c-1-.14-4.17.44-7.13 1.13 0-.3 0-.58.05-.88a85.6 85.6 0 011.28-9.71l-.86-.37a21.52 21.52 0 002.58-6.27c.11-.48.23-.94.34-1.4l.3-1.21-20.47-4.79a41.87 41.87 0 00-.41 8.76c.09.56.46 2.3.78 3.74l-.43.11a63.72 63.72 0 01-1.88 13.92c-.28 1.12-.58 2.21-.91 3.25a4.26 4.26 0 001.64 4.78h.09l.66.41s.73.44 1.5.82a14.06 14.06 0 002.25.86l-.27 2.27-1.49.95a8.58 8.58 0 00-3.91 5c-.21.78-.88 3.35.56 5.4a5.72 5.72 0 003 2.09c1.52.49 1.85 0 4.85.09 2.09.08 2.95.43 3.31-.07s-.22-1.71-.71-2.45c.29-.69.59-1.37.88-2.06l2.66-1.63c-.22-.38-.44-.76-.65-1.14a1.06 1.06 0 00.34-.45 1 1 0 000-.63l-.29-.13v-1a1.82 1.82 0 00.6-1 1.9 1.9 0 00-.24-1.4 2.56 2.56 0 00-1.94-1.11h-.13l-1.22-.06a12.75 12.75 0 01.27-1.55l1.08.12c2.74.26 14.17 3.11 14.17 3.11s.75 9.78-.88 15.51l-1.22 1c-1.82 1.5-2.13 1.86-2.2 2.4a9.91 9.91 0 010 1.39c-.12.73-.36 1.1-.23 1.2s.62-.21 1-.62q-5.31 7.17-10.32 14.54 3-1.26 5.7-2.58 2.89-4.12 5.86-8.2a.26.26 0 00.17.28zm-1.62-34.81l2.05-.57c6 2.64 10 4.72 16 7.35.16.22.39.49.72.87v.06q-4.87 5.73-9.55 11.63c.62-3.11 1.22-6.48 1.7-9a5.4 5.4 0 00-2.52-5.62c-2.43-1.48-5.75-3.37-8.4-4.72z",
                                fill: "url(#linear-gradient-235)"
                            })
                        ]
                    })
                })
            })
        ]
    });

});


parcelRegister("lzAG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2be71cde816260d0$export$2e2bcd8739ae039);

var $gVn2t = parcelRequire("gVn2t");
var $gF2uJ = parcelRequire("gF2uJ");
var $jIu2u = parcelRequire("jIu2u");
var $hOHHh = parcelRequire("hOHHh");
var $kbWAD = parcelRequire("kbWAD");
var $8VV1g = parcelRequire("8VV1g");
var $3RELU = parcelRequire("3RELU");
var $2GLVw = parcelRequire("2GLVw");
var $cyCkO = parcelRequire("cyCkO");
var $2kuK5 = parcelRequire("2kuK5");
var $ec4Zm = parcelRequire("ec4Zm");
var $adxPR = parcelRequire("adxPR");
var $7iSe8 = parcelRequire("7iSe8");
var $aRmqS = parcelRequire("aRmqS");
var $bSlng = parcelRequire("bSlng");
var $kZZGF = parcelRequire("kZZGF");
var $cZnHy = parcelRequire("cZnHy");
var $hmXBb = parcelRequire("hmXBb");
var $d39bX = parcelRequire("d39bX");
var $7em2L = parcelRequire("7em2L");
var $fbSjx = parcelRequire("fbSjx");
var $fazBu = parcelRequire("fazBu");
var $4lHnX = parcelRequire("4lHnX");
var $j9BMn = parcelRequire("j9BMn");
var $9CxAQ = parcelRequire("9CxAQ");
const $2be71cde816260d0$var$localeToTranslations = {
    'cs-CZ': $gVn2t.default,
    'da-DK': $gF2uJ.default,
    'de-DE': $jIu2u.default,
    'en-US': $hOHHh.default,
    'en-GB': $kbWAD.default,
    'en-ZZ': $8VV1g.default,
    'es-ES': $3RELU.default,
    'fi-FI': $2GLVw.default,
    'fr-FR': $cyCkO.default,
    'hu-HU': $2kuK5.default,
    'it-IT': $ec4Zm.default,
    'ja-JP': $adxPR.default,
    'ko-KR': $7iSe8.default,
    'no-NO': $aRmqS.default,
    'nl-NL': $bSlng.default,
    'pl-PL': $kZZGF.default,
    'pt-BR': $cZnHy.default,
    'ru-RU': $hmXBb.default,
    'sv-SE': $d39bX.default,
    'tr-TR': $fbSjx.default,
    'th-TH': $7em2L.default,
    'uk-UA': $fazBu.default,
    'vi-VN': $4lHnX.default,
    'zh-TW': $9CxAQ.default,
    'zh-CN': $j9BMn.default
};
const $2be71cde816260d0$var$fetchTranslations = async (locale)=>$2be71cde816260d0$var$localeToTranslations[locale] ?? $hOHHh.default;
var $2be71cde816260d0$export$2e2bcd8739ae039 = $2be71cde816260d0$var$fetchTranslations;

});
parcelRegister("gVn2t", function(module, exports) {
$parcel$export(module.exports, "default", () => $de84e86711535e87$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $86zeU = parcelRequire("86zeU");
var $de84e86711535e87$export$2e2bcd8739ae039 = (0, $86zeU.default);

});
parcelRegister("86zeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8813ea85494e9a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $f8813ea85494e9a0$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};

});


parcelRegister("gF2uJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4151db95aa266f6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iCo1l = parcelRequire("iCo1l");
var $d4151db95aa266f6$export$2e2bcd8739ae039 = (0, $iCo1l.default);

});
parcelRegister("iCo1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $e04985d3e12bc10d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $e04985d3e12bc10d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};

});


parcelRegister("jIu2u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae8fd2519722df33$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OKt1m = parcelRequire("OKt1m");
var $ae8fd2519722df33$export$2e2bcd8739ae039 = (0, $OKt1m.default);

});
parcelRegister("OKt1m", function(module, exports) {
$parcel$export(module.exports, "default", () => $4268ac55a57b7b64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $4268ac55a57b7b64$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};

});


parcelRegister("hOHHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aac9ab42f58e18$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fa9oE = parcelRequire("fa9oE");
var $35aac9ab42f58e18$export$2e2bcd8739ae039 = (0, $fa9oE.default);

});
parcelRegister("fa9oE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e00759fdb5dd3dbf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e00759fdb5dd3dbf$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("kbWAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2722a1e3e6a2d193$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4SI1O = parcelRequire("4SI1O");
var $2722a1e3e6a2d193$export$2e2bcd8739ae039 = (0, $4SI1O.default);

});
parcelRegister("4SI1O", function(module, exports) {
$parcel$export(module.exports, "default", () => $9591cf622278f558$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9591cf622278f558$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("8VV1g", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fde875848e0e1d3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iUxRF = parcelRequire("iUxRF");
var $5fde875848e0e1d3$export$2e2bcd8739ae039 = (0, $iUxRF.default);

});
parcelRegister("iUxRF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2695162625fbad9d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2695162625fbad9d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};

});


parcelRegister("3RELU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd33c96d2c6a3b38$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OyaMN = parcelRequire("OyaMN");
var $bd33c96d2c6a3b38$export$2e2bcd8739ae039 = (0, $OyaMN.default);

});
parcelRegister("OyaMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8002adc7390303d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $d8002adc7390303d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};

});


parcelRegister("2GLVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $79757001bdda6d20$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $k8GmK = parcelRequire("k8GmK");
var $79757001bdda6d20$export$2e2bcd8739ae039 = (0, $k8GmK.default);

});
parcelRegister("k8GmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf006fcc6db4a0c7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $bf006fcc6db4a0c7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};

});


parcelRegister("cyCkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1b75c40aca6111$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $97WrX = parcelRequire("97WrX");
var $6d1b75c40aca6111$export$2e2bcd8739ae039 = (0, $97WrX.default);

});
parcelRegister("97WrX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3ccc23c0718289$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ad3ccc23c0718289$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};

});


parcelRegister("2kuK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b0a53f3901ee842$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1uArQ = parcelRequire("1uArQ");
var $5b0a53f3901ee842$export$2e2bcd8739ae039 = (0, $1uArQ.default);

});
parcelRegister("1uArQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e95b01e8c12f0776$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $e95b01e8c12f0776$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};

});


parcelRegister("ec4Zm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5d40f2dbcf6c2db$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7MLET = parcelRequire("7MLET");
var $e5d40f2dbcf6c2db$export$2e2bcd8739ae039 = (0, $7MLET.default);

});
parcelRegister("7MLET", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a304e9615ca1cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $08a304e9615ca1cb$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};

});


parcelRegister("adxPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $090a54f256654417$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fRbOB = parcelRequire("fRbOB");
var $090a54f256654417$export$2e2bcd8739ae039 = (0, $fRbOB.default);

});
parcelRegister("fRbOB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e13736617ad05247$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e13736617ad05247$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};

});


parcelRegister("7iSe8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3175ea772765cd21$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bZXf1 = parcelRequire("bZXf1");
var $3175ea772765cd21$export$2e2bcd8739ae039 = (0, $bZXf1.default);

});
parcelRegister("bZXf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef766d79add86b1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $1ef766d79add86b1$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};

});


parcelRegister("aRmqS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7176f6091fac65c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6njdR = parcelRequire("6njdR");
var $b7176f6091fac65c$export$2e2bcd8739ae039 = (0, $6njdR.default);

});
parcelRegister("6njdR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebcf052d0bd9e2ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $ebcf052d0bd9e2ed$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};

});


parcelRegister("bSlng", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c106f196b16ae8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3lN6l = parcelRequire("3lN6l");
var $c1c106f196b16ae8$export$2e2bcd8739ae039 = (0, $3lN6l.default);

});
parcelRegister("3lN6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $758a1d2aec1019fe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $758a1d2aec1019fe$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};

});


parcelRegister("kZZGF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7970253c953659f7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3eKOc = parcelRequire("3eKOc");
var $7970253c953659f7$export$2e2bcd8739ae039 = (0, $3eKOc.default);

});
parcelRegister("3eKOc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4da433e029a4a52$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $c4da433e029a4a52$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};

});


parcelRegister("cZnHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cd3d203e236cba1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $Z01Pj = parcelRequire("Z01Pj");
var $1cd3d203e236cba1$export$2e2bcd8739ae039 = (0, $Z01Pj.default);

});
parcelRegister("Z01Pj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98b0e2c7a5a4e37$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $f98b0e2c7a5a4e37$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};

});


parcelRegister("hmXBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4515fc80428e0f3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5ak3O = parcelRequire("5ak3O");
var $e4515fc80428e0f3$export$2e2bcd8739ae039 = (0, $5ak3O.default);

});
parcelRegister("5ak3O", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d90428c652fb203$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $4d90428c652fb203$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("d39bX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3deeb5c49f5203b2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eiLYJ = parcelRequire("eiLYJ");
var $3deeb5c49f5203b2$export$2e2bcd8739ae039 = (0, $eiLYJ.default);

});
parcelRegister("eiLYJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d587b136dfe8dd7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $4d587b136dfe8dd7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};

});


parcelRegister("7em2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $27e7b432d02653a9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aT0sX = parcelRequire("aT0sX");
var $27e7b432d02653a9$export$2e2bcd8739ae039 = (0, $aT0sX.default);

});
parcelRegister("aT0sX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b61e557bbfdc46d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $9b61e557bbfdc46d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};

});


parcelRegister("fbSjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a67694ba155303$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fx6jl = parcelRequire("fx6jl");
var $01a67694ba155303$export$2e2bcd8739ae039 = (0, $fx6jl.default);

});
parcelRegister("fx6jl", function(module, exports) {
$parcel$export(module.exports, "default", () => $695eab6677f02e30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $695eab6677f02e30$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};

});


parcelRegister("fazBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1029988d2fbab422$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ll0mb = parcelRequire("ll0mb");
var $1029988d2fbab422$export$2e2bcd8739ae039 = (0, $ll0mb.default);

});
parcelRegister("ll0mb", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca0ed95888e2625$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $bca0ed95888e2625$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("4lHnX", function(module, exports) {
$parcel$export(module.exports, "default", () => $276bc4890ca504b9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $b6xoa = parcelRequire("b6xoa");
var $276bc4890ca504b9$export$2e2bcd8739ae039 = (0, $b6xoa.default);

});
parcelRegister("b6xoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d3e0f1c67bfee9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $d6d3e0f1c67bfee9$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};

});


parcelRegister("j9BMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ad23d78b1003b5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $d1LQj = parcelRequire("d1LQj");
var $c4ad23d78b1003b5$export$2e2bcd8739ae039 = (0, $d1LQj.default);

});
parcelRegister("d1LQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $de006bcaad3f1476$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $de006bcaad3f1476$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};

});


parcelRegister("9CxAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55cf7277abe54f0f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8sNnA = parcelRequire("8sNnA");
var $55cf7277abe54f0f$export$2e2bcd8739ae039 = (0, $8sNnA.default);

});
parcelRegister("8sNnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $986beac2870673da$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $986beac2870673da$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};

});




parcelRegister("4eSmy", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $0e0b16901c3f6e75$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $hEWmq = parcelRequire("hEWmq");
const $0e0b16901c3f6e75$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hEWmq.ViewPage), {
            ...props
        })
    });

});
parcelRegister("hEWmq", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $84f48369079b110f$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $35jyw = parcelRequire("35jyw");

var $lRq8t = parcelRequire("lRq8t");
const $84f48369079b110f$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $35jyw.ViewPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("35jyw", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $a8eed96c071859b9$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $dqJsX = parcelRequire("dqJsX");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");
const $a8eed96c071859b9$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8edRS.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dqJsX.ViewPage), {
                    ...props
                })
            })
        })
    });
};

});
parcelRegister("dqJsX", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $c7ae8fd93015352f$export$767e3006bdbb424a);
/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");
var $27wdK = parcelRequire("27wdK");

var $jWzbc = parcelRequire("jWzbc");

var $lCbi5 = parcelRequire("lCbi5");

var $8edRS = parcelRequire("8edRS");
const $c7ae8fd93015352f$var$embeddedPageContainerSytles = null;
const $c7ae8fd93015352f$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: children
    });
};
const $c7ae8fd93015352f$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { height: height } = (0, $27wdK.useContentSize)(uniqueKey);
    (0, $lCbi5.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>({
            experiences: {
                experience: (0, $j2zMY.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $j2zMY.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c7ae8fd93015352f$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%',
                    children: children
                }),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jWzbc.Content), {
        ...props,
        contentType: (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};

});
parcelRegister("27wdK", function(module, exports) {
$parcel$export(module.exports, "useContentSize", () => $135b10d553c176e1$export$7e7123f55b1139c9);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8qtes = parcelRequire("8qtes");

var $fSqCk = parcelRequire("fSqCk");
const $135b10d553c176e1$var$MESSAGE_TYPE = 'contentSize';
const $135b10d553c176e1$export$7e7123f55b1139c9 = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $eJOHy.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/ const { isMediaOpen: isMediaOpen } = (0, $8qtes.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $fSqCk.useIframeVisibleHeight)(uniqueKey);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $135b10d553c176e1$var$MESSAGE_TYPE && data?.height && (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};

});
parcelRegister("8qtes", function(module, exports) {
$parcel$export(module.exports, "useMediaViewerListener", () => $77826dd02e2a6e26$export$6d8905296959d5f5);

var $eJOHy = parcelRequire("eJOHy");
const $77826dd02e2a6e26$export$6d8905296959d5f5 = ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $eJOHy.useState)(false);
    const mediaMessageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};

});

parcelRegister("fSqCk", function(module, exports) {
$parcel$export(module.exports, "useIframeVisibleHeight", () => $fd2a92adc4bbbe65$export$4b9c38587bbe6e8b);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $fd2a92adc4bbbe65$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $fd2a92adc4bbbe65$export$4b9c38587bbe6e8b = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $eJOHy.useState)(1000);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $fd2a92adc4bbbe65$var$MESSAGE_TYPE && data?.value && (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        visibleHeight: visibleHeight
    };
};

});


parcelRegister("jWzbc", function(module, exports) {
$parcel$export(module.exports, "Content", () => $dc9eb7549e787e58$export$7c6e2c02157bb7d2);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5XSQP = parcelRequire("5XSQP");
var $40f0Z = parcelRequire("40f0Z");

var $52WL7 = parcelRequire("52WL7");
var $7LOUI = parcelRequire("7LOUI");

var $kUYZz = parcelRequire("kUYZz");

var $fuXvj = parcelRequire("fuXvj");
var $73Fae = parcelRequire("73Fae");
var $27wdK = parcelRequire("27wdK");
var $jgJaV = parcelRequire("jgJaV");
var $bbc8b = parcelRequire("bbc8b");

var $8edRS = parcelRequire("8edRS");

var $7oRxl = parcelRequire("7oRxl");

var $3ca9m = parcelRequire("3ca9m");

var $lRq8t = parcelRequire("lRq8t");

var $bF4mB = parcelRequire("bF4mB");
const $dc9eb7549e787e58$var$IframeWrapper = ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: wrapper?.(children) ?? children
    });
// helper to merge iframe refs
function $dc9eb7549e787e58$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $dc9eb7549e787e58$export$7c6e2c02157bb7d2 = (props)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, embeddedConfluenceSource: embeddedConfluenceSource, ...passThroughProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const experienceTracker = (0, $52WL7.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $7LOUI.useSetUpExperience)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $bbc8b.useUrl)(props);
    /**
	 * The difference between hasFooter and hasFooterLogo can be found here
	 * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
	 *
	 * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
	 */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $jgJaV.useFooter)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $27wdK.useContentSize)(uniqueKey);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5XSQP.Experience), {
            name: experience,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $73Fae.PageLoadValidation), {
                ...props,
                children: ({ iframeRef: iframeRef, iframeLoaded: iframeLoaded, isLoading: isLoading, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)($dc9eb7549e787e58$var$IframeWrapper, {
                                wrapper: contentConfiguration.getWrapperElement,
                                children: embeddedConfluenceUrl ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bF4mB.IframeLoadingScreen), {
                                    iframeLoaded: iframeLoaded,
                                    isLoading: isLoading,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kUYZz.Iframe), {
                                        ref: $dc9eb7549e787e58$var$mergeIframeRefs(iframeRef, externalIframeRef),
                                        // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
                                        src: redirectedToLogin ? '' : embeddedConfluenceUrl,
                                        ...passThroughProps,
                                        navigationPolicy: navigationPolicy,
                                        style: {
                                            flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
                                        },
                                        uniqueKey: uniqueKey,
                                        onLoad: (e)=>{
                                            handleIframeOnLoad();
                                            onLoad?.(e);
                                        },
                                        onUnload: handleIframeUnload,
                                        onContentLoadStarted: handleContentLoadStarted
                                    })
                                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {
                                    embeddedConfluenceSource: embeddedConfluenceSource
                                })
                            }),
                            showFooter && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fuXvj.Footer), {
                                url: footerUrl,
                                linkTooltip: formatMessage((0, $3ca9m.default).viewInConfluence),
                                label: formatMessage((0, $3ca9m.default).poweredBy)
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("5XSQP", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $34f6e829880f545b$export$c90b54e658fc4d7c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $boRG7 = parcelRequire("boRG7");
function $34f6e829880f545b$export$c90b54e658fc4d7c({ children: children, name: name }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $boRG7.ExperienceContext).Provider, {
        value: name,
        children: children
    });
}

});
parcelRegister("boRG7", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $1a24cfa7a9df9c2e$export$fb99266658f5da06);

var $eJOHy = parcelRequire("eJOHy");
const $1a24cfa7a9df9c2e$var$defaultExperienceContextValue = undefined;
const $1a24cfa7a9df9c2e$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($1a24cfa7a9df9c2e$var$defaultExperienceContextValue);

});


parcelRegister("7LOUI", function(module, exports) {
$parcel$export(module.exports, "useSetUpExperience", () => $249484d1e0a88b58$export$48d5d434479c259e);

var $eJOHy = parcelRequire("eJOHy");

var $bq2fr = parcelRequire("bq2fr");
const $249484d1e0a88b58$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $eJOHy.useRef)();
    const ccExperienceStartedRef = (0, $eJOHy.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
	 * Start experience as close to the user action as possible.
	 * Our approximation is component's first render.
	 *
	 * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
	 * We need to re-start experience if `contentId` or `spaceKey` has changed.
	 * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
	 */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
				 * We have experience forwarding from confluence-frontend
				 * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
				 */ experience.stopOn(events.find((event)=>(0, $bq2fr.isStop)(event) && event.name === ccExperience && event.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            /**
			 * User can navigates away (EP component unmount) before CC experience started
			 * In this case, we want to abort EP experience as the conclusion.
			 */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};

});
parcelRegister("bq2fr", function(module, exports) {
$parcel$export(module.exports, "isStop", () => $9cb259e8198ec504$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $9cb259e8198ec504$export$57069f5b2ecc9128);
const $9cb259e8198ec504$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $9cb259e8198ec504$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});


parcelRegister("kUYZz", function(module, exports) {
$parcel$export(module.exports, "Iframe", () => $addf700416df7c9f$export$5137ec99f248330b);
/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eaiF1 = parcelRequire("eaiF1");

var $huqaB = parcelRequire("huqaB");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");

var $eGOwo = parcelRequire("eGOwo");
const $addf700416df7c9f$var$iframeStyles = null;
const $addf700416df7c9f$export$5137ec99f248330b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $eJOHy.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    (0, $eJOHy.useEffect)(()=>{
        const handler = (e)=>{
            // only fire onUnload handler if uniqueKey (if it exists) matches
            const uniqueKeyMatch = !uniqueKey || !e.data?.uniqueKey || e.data.uniqueKey === uniqueKey || !(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed');
            if (e.data.type === 'windowUnload' && uniqueKeyMatch) onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload,
        uniqueKey
    ]);
    (0, $huqaB.useHostOffsetOverride)();
    const channel = (0, $eaiF1.useIframeCommunicationChannel)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    });
    // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        // Grant features to iframe (Currently the same as smart card iframe's granted features)
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...passThroughProps,
        className: (0, $hcewu.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    });
});

});
parcelRegister("eaiF1", function(module, exports) {
$parcel$export(module.exports, "useIframeCommunicationChannel", () => $cd35ea78faffb064$export$c745b3af35ea8585);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $8FR7r = parcelRequire("8FR7r");

var $eGOwo = parcelRequire("eGOwo");

var $8edRS = parcelRequire("8edRS");
let $cd35ea78faffb064$var$host = null;


// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // unable to evaluate fg('platform_deprecate_lp_cc_embed') at the module level and using uniqueKey query param (which is feature gated) instead
    let hasUniqueKey = false;
    if (typeof window !== 'undefined') try {
        hasUniqueKey = new URL(window.location.href).searchParams.has('uniqueKey');
    } catch (e) {
        hasUniqueKey = false;
    }
    $cd35ea78faffb064$var$host = hasUniqueKey ? (parcelRequire("1oIvu")) : (parcelRequire("818E2"));
}
function $cd35ea78faffb064$var$defineModule(name, module) {
    $cd35ea78faffb064$var$host.defineModule(name, module);
}
const $cd35ea78faffb064$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $eJOHy.useRef)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $cd35ea78faffb064$var$defineModule(uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `${0, $8FR7r.EXPERIENCE_FORWARDING_MODULE_NAME}_${uniqueKey}` : (0, $8FR7r.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $cd35ea78faffb064$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $eJOHy.useCallback)(()=>{
        $cd35ea78faffb064$var$host.dispatch((0, $8FR7r.PROPS_UPDATED), {
            addon_key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME) : (0, $8FR7r.CHANNEL_NAME),
            ...(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') && {
                key: passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME)
            }
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
		 * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
		 * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
		 **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps),
        passThroughProps.uniqueKey
    ]);
    const dispatchPropsUpdatedRef = (0, $eJOHy.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $cd35ea78faffb064$var$defineModule(passThroughProps.uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `${0, $8FR7r.PASSTHROUGH_PROPS_MODULE_NAME}_${passThroughProps.uniqueKey}` : (0, $8FR7r.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $eJOHy.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $cd35ea78faffb064$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $eJOHy.useRef)();
    const uniqueKey = passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME);
    $cd35ea78faffb064$var$useExperienceForwardingModule();
    $cd35ea78faffb064$var$usePassThroughPropsModule(passThroughProps);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $cd35ea78faffb064$var$host.create({
        addon_key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $8FR7r.CHANNEL_NAME),
        key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $8FR7r.CHANNEL_NAME),
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}

});
parcelRegister("8FR7r", function(module, exports) {
$parcel$export(module.exports, "CHANNEL_NAME", () => $0b197a18be2c51cd$export$ab9998995666ebe3);
$parcel$export(module.exports, "createUniqueKey", () => $0b197a18be2c51cd$export$f2fe03976fe13de);
$parcel$export(module.exports, "PASSTHROUGH_PROPS_MODULE_NAME", () => $0b197a18be2c51cd$export$45b0adb7f9689286);
$parcel$export(module.exports, "PROPS_UPDATED", () => $0b197a18be2c51cd$export$78cada8c8749e264);
$parcel$export(module.exports, "EXPERIENCE_FORWARDING_MODULE_NAME", () => $0b197a18be2c51cd$export$b75934a6b56fd9ba);

var $aXKmr = parcelRequire("aXKmr");
const $0b197a18be2c51cd$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $0b197a18be2c51cd$export$f2fe03976fe13de = ()=>{
    return `${$0b197a18be2c51cd$export$ab9998995666ebe3}-${(0, $aXKmr.v4)()}`;
};
const $0b197a18be2c51cd$export$45b0adb7f9689286 = 'passThroughProps';
const $0b197a18be2c51cd$export$78cada8c8749e264 = 'propsUpdated';
const $0b197a18be2c51cd$export$b75934a6b56fd9ba = 'experienceForwarding';

});

parcelRegister("8edRS", function(module, exports) {
$parcel$export(module.exports, "UniqueKeyProvider", () => $ac62a64a0b58e7a2$export$71829d27b87a2006);
$parcel$export(module.exports, "useUniqueKey", () => $ac62a64a0b58e7a2$export$cef64a0cfb90e369);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8FR7r = parcelRequire("8FR7r");
const $ac62a64a0b58e7a2$var$UniqueKeyContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    uniqueKey: undefined
});
const $ac62a64a0b58e7a2$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $eJOHy.useMemo)(()=>(0, $8FR7r.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ac62a64a0b58e7a2$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $ac62a64a0b58e7a2$export$cef64a0cfb90e369 = ()=>{
    return (0, $eJOHy.useContext)($ac62a64a0b58e7a2$var$UniqueKeyContext);
};

});

parcelRegister("1oIvu", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _util = _interopRequireDefault(_dereq_("./util"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PostMessage = /*#__PURE__*/ function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                var _default = PostMessage;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if (_typeof(source) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn("".concat(t.name, " object was detected and removed from the message."));
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && _typeof(value) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                         // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname; //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                var _default = util;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _xdmrpc = _interopRequireDefault(_dereq_("./xdmrpc"));
                var _util = _interopRequireDefault(_dereq_("../common/util"));
                var _featureFlag = _dereq_("./feature-flag");
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var Connect = /*#__PURE__*/ function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: "dispatch",
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: "broadcast",
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: "_createId",
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util.default.randomString();
                            }
                        },
                        {
                            key: "create",
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                options.platformFeatureFlags = (0, _featureFlag.getPlatformFeatureFlags)();
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            } // This is called from ACJS
                        },
                        {
                            key: "registerRequestNotifier",
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: "registerExtension",
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: "registerKeyListener",
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: "unregisterKeyListener",
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: "registerClickHandler",
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: "unregisterClickHandler",
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: "defineModule",
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: "isModuleDefined",
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: "defineGlobals",
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: "getExtensions",
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: "unregisterExtension",
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: "returnsPromise",
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: "setFeatureFlagGetter",
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: "registerExistingExtension",
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                var _default = Connect;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "../common/util": 2,
                "./feature-flag": 4,
                "./xdmrpc": 6
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getPlatformFeatureFlags = getPlatformFeatureFlags;
                var allowedPlatformFeatureFlags = [
                    'platform-visual-refresh-icons'
                ];
                function getPlatformFeatureFlags() {
                    var flags = {};
                    if (window.connectHost && window.connectHost.getBooleanFeatureFlag) allowedPlatformFeatureFlags.forEach(function(key) {
                        return flags[key] = window.connectHost.getBooleanFeatureFlag(key);
                    });
                    return flags;
                }
            },
            {}
        ],
        5: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _connect = _interopRequireDefault(_dereq_("./connect"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var _default = new _connect.default();
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "./connect": 3
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _util = _interopRequireDefault(_dereq_("../common/util"));
                var _postmessage = _interopRequireDefault(_dereq_("../common/postmessage"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _construct(Parent, args, Class) {
                    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
                    else _construct = function _construct(Parent, args, Class) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor();
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                    return _construct.apply(null, arguments);
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = /*#__PURE__*/ function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    var _super = _createSuper(XDMRPC);
                    function XDMRPC(config) {
                        var _this;
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        _this = _super.call(this, config);
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandlers = [];
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: "_padUndefinedArguments",
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        },
                        {
                            key: "_verifyAPI",
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                                else console.warn("_verifyAPI postMessage skipped as event source missing.");
                            }
                        },
                        {
                            key: "_handleInit",
                            value: function _handleInit(event, reg) {
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                else console.warn("_handleInit postMessage skipped as event source missing.");
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: "_getHostOffset",
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0; // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                                else console.warn("_getHostOffset postMessage skipped as event source missing.");
                            }
                        },
                        {
                            key: "_hasSameOrigin",
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {}
                                return false;
                            }
                        },
                        {
                            key: "_handleResponse",
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: "registerRequestNotifier",
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: "_handleRequest",
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util.default.sanitizeStructuredClone(_util.default.argumentsToArray(arguments));
                                    if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                    else console.warn("_handleRequest postMessage skipped as event source missing.");
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = _construct(Cls.constructor, args);
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!(_typeof(promiseResult) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            args: methodArgs,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "_handleBroadcast",
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: "_handleKeyTriggered",
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: "defineAPIModule",
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: "isAPIModuleDefined",
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: "_pendingEventKey",
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = "".concat(key, "@@").concat(targetSpec.key);
                                key = "".concat(key, "@@").concat(time);
                                return key;
                            }
                        },
                        {
                            key: "queueEvent",
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: "_cleanupInvalidEvents",
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: "_handleEventQuery",
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: "_handleUnload",
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: "dispatch",
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: "_findRegistrations",
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: "registerExtension",
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: "_keycodeKey",
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: "registerKeyListener",
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: "unregisterKeyListener",
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: "registerClickHandler",
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                this._clickHandlers.push(callback);
                            }
                        },
                        {
                            key: "_handleAddonClick",
                            value: function _handleAddonClick(event, reg) {
                                for(var i = 0; i < this._clickHandlers.length; i++)if (typeof this._clickHandlers[i] === 'function') this._clickHandlers[i]({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: "unregisterClickHandler",
                            value: function unregisterClickHandler() {
                                this._clickHandlers = [];
                            }
                        },
                        {
                            key: "getApiSpec",
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(_typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: "_originEqual",
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util.default.getOrigin(url); // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            } // validate origin of postMessage
                        },
                        {
                            key: "_checkOrigin",
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && no_source_types.includes(event.data.type);
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches); // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                 // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: "getRegisteredExtensions",
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: "unregisterExtension",
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: "setFeatureFlagGetter",
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage.default);
                var _default = XDMRPC;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        5
    ])(5);
});

});

parcelRegister("818E2", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_("./util");
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var PostMessage = function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util2.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg = void 0;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                exports.default = PostMessage;
                module1.exports = exports["default"];
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if ((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn(t.name + " object was detected and removed from the message.");
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue = void 0;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                        // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                        //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                exports.default = util;
                module1.exports = exports["default"];
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _xdmrpc = _dereq_('./xdmrpc');
                var _xdmrpc2 = _interopRequireDefault(_xdmrpc);
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Connect = function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc2.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: 'broadcast',
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: '_createId',
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util2.default.randomString();
                            }
                        },
                        {
                            key: 'create',
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util2.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: 'defineModule',
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: 'isModuleDefined',
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: 'defineGlobals',
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: 'getExtensions',
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: 'returnsPromise',
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: 'registerExistingExtension',
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                exports.default = Connect;
                module1.exports = exports['default'];
            },
            {
                "../common/util": 2,
                "./xdmrpc": 5
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _connect = _dereq_('./connect');
                var _connect2 = _interopRequireDefault(_connect);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                exports.default = new _connect2.default();
                module1.exports = exports['default'];
            },
            {
                "./connect": 3
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                var _postmessage = _dereq_('../common/postmessage');
                var _postmessage2 = _interopRequireDefault(_postmessage);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self, call) {
                    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                } /**
  * Postmessage format:
  *
  * Initialization
  * --------------
  * {
  *   type: 'init',
  *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
  * }
  *
  * Request
  * -------
  * {
  *   type: 'req',
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, required for callbacks
  *   mod: 'cookie',  // the module name
  *   fn: 'read',  // the method name
  *   args: [arguments]  // the method arguments
  * }
  *
  * Response
  * --------
  * {
  *   type: 'resp'
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, obtained from the request
  *   args: [arguments]  // the callback arguments
  * }
  *
  * Event
  * -----
  * {
  *   type: 'evt',
  *   etyp: 'some-event',
  *   evnt: { ... }  // the event data
  *   mid: 'xyz', // a unique message identifier for the event
  * }
  **/ 
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    _createClass(XDMRPC, [
                        {
                            key: '_padUndefinedArguments',
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        }
                    ]);
                    function XDMRPC(config) {
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        var _this = _possibleConstructorReturn(this, (XDMRPC.__proto__ || Object.getPrototypeOf(XDMRPC)).call(this, config));
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandler = null;
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload,
                            sub: _this._handleSubInit
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: '_verifyAPI',
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                            }
                        },
                        {
                            key: '_handleInit',
                            value: function _handleInit(event, reg) {
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: '_handleSubInit',
                            value: function _handleSubInit(event, reg) {
                                var blocked = reg.extension.options.noSub || this._getBooleanFeatureFlag && this._getBooleanFeatureFlag('com.atlassian.connect.resolve_inner_iframe_url');
                                var data = event.data;
                                if (blocked) _util2.default.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
                                else this.registerExtension(data.ext.id, {
                                    extension: data.ext
                                });
                                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                    sub: data.ext,
                                    type: data.type,
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id,
                                    blocked: blocked
                                });
                            }
                        },
                        {
                            key: '_getHostOffset',
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0;
                                    // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                            }
                        },
                        {
                            key: '_hasSameOrigin',
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {
                                // A exception will be thrown if the windows doesn't have the same origin
                                }
                                return false;
                            }
                        },
                        {
                            key: '_handleResponse',
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: '_handleRequest',
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util2.default.sanitizeStructuredClone(_util2.default.argumentsToArray(arguments));
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = new (Function.prototype.bind.apply(Cls.constructor, [
                                                        null
                                                    ].concat(args)))();
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!((typeof promiseResult === 'undefined' ? 'undefined' : _typeof(promiseResult)) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: '_handleBroadcast',
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: '_handleKeyTriggered',
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: 'defineAPIModule',
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util2.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: 'isAPIModuleDefined',
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: '_pendingEventKey',
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = key + '@@' + targetSpec.key;
                                key = key + '@@' + time;
                                return key;
                            }
                        },
                        {
                            key: 'queueEvent',
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util2.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: '_cleanupInvalidEvents',
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: '_handleEventQuery',
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: '_handleUnload',
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util2.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util2.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: '_findRegistrations',
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util2.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: '_keycodeKey',
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                                this._clickHandler = callback;
                            }
                        },
                        {
                            key: '_handleAddonClick',
                            value: function _handleAddonClick(event, reg) {
                                if (typeof this._clickHandler === 'function') this._clickHandler({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._clickHandler = null;
                            }
                        },
                        {
                            key: 'getApiSpec',
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(typeof member === 'undefined' ? 'undefined' : _typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util2.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: '_originEqual',
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util2.default.getOrigin(url);
                                // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            }
                        },
                        {
                            key: '_checkOrigin',
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                                // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: 'getRegisteredExtensions',
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage2.default);
                exports.default = XDMRPC;
                module1.exports = exports['default'];
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        4
    ])(4);
});

});


parcelRegister("huqaB", function(module, exports) {
$parcel$export(module.exports, "useHostOffsetOverride", () => $2eb8a60db06bd239$export$db5957f3934e2c38);

var $eJOHy = parcelRequire("eJOHy");
function $2eb8a60db06bd239$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $2eb8a60db06bd239$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $2eb8a60db06bd239$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($2eb8a60db06bd239$var$isSameOrigin(window1.top)) {
            const containerDepth = $2eb8a60db06bd239$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$2eb8a60db06bd239$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $2eb8a60db06bd239$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($2eb8a60db06bd239$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $2eb8a60db06bd239$export$db5957f3934e2c38() {
    (0, $eJOHy.useEffect)(()=>{
        $2eb8a60db06bd239$var$attachHostOffsetOverride(window);
        return ()=>{
            $2eb8a60db06bd239$var$detachHostOffsetOverride();
        };
    }, []);
}

});

parcelRegister("4nJ3E", function(module, exports) {
$parcel$export(module.exports, "usePerformanceMetrics", () => $212d532a1326c787$export$865423e6f8e2e839);
$parcel$export(module.exports, "PerformanceMetricsProvider", () => $212d532a1326c787$export$c6f19d9afc6c86c8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5P7sD = parcelRequire("5P7sD");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $212d532a1326c787$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $212d532a1326c787$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $212d532a1326c787$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $eJOHy.useState)(contentType);
    const isInitialized = (0, $eJOHy.useRef)(true);
    const iframeLoadMetrics = (0, $eJOHy.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $5P7sD.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$e5b04c2a3cc97ddc):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$9f8bbf62fac57d48):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$e08d2ab8ef653595):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$73b982309451f084):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $5P7sD.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $eJOHy.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $eJOHy.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $212d532a1326c787$export$865423e6f8e2e839 = ()=>{
    return (0, $eJOHy.useContext)($212d532a1326c787$var$PerformanceMetricsContext);
};
const $212d532a1326c787$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $212d532a1326c787$export$865423e6f8e2e839();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("5P7sD", function(module, exports) {
$parcel$export(module.exports, "embeddedViewToEditTransitionMetric", () => $e30bbd423029a7b8$export$4de078c3b9971f9b);
$parcel$export(module.exports, "embeddedConfluenceIframeLoadMetrics", () => $e30bbd423029a7b8$export$a23245993532c751);

var $hqYEY = parcelRequire("hqYEY");

var $cXQfL = parcelRequire("cXQfL");
const $e30bbd423029a7b8$export$4de078c3b9971f9b = ()=>(0, $hqYEY.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e30bbd423029a7b8$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e30bbd423029a7b8$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e30bbd423029a7b8$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e30bbd423029a7b8$var$timings
    }
};
const $e30bbd423029a7b8$export$a23245993532c751 = (contentType)=>(0, $hqYEY.metrics).pageSegmentLoad($e30bbd423029a7b8$var$loadingMetricsConfig[contentType]);

});

const $e5befacaa387021d$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $e5befacaa387021d$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $e5befacaa387021d$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $e5befacaa387021d$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $e5befacaa387021d$export$73b982309451f084 = 'embedded-iframe-content-initialized';



parcelRegister("fuXvj", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $aa643ac6d9a3565e$export$a06f1c675e846f6f);
/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-anchor */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");

var $lgMTT = parcelRequire("lgMTT");

var $k71qx = parcelRequire("k71qx");

var $fnLem = parcelRequire("fnLem");
const $aa643ac6d9a3565e$var$FOOTER_CONTENT_HEIGHT = 52;
const $aa643ac6d9a3565e$var$FOOTER_BORDER_PX = 2;
const $aa643ac6d9a3565e$export$a2dd5f25b5a4e5d2 = $aa643ac6d9a3565e$var$FOOTER_CONTENT_HEIGHT + $aa643ac6d9a3565e$var$FOOTER_BORDER_PX;
const $aa643ac6d9a3565e$var$containerStyles = null;
const $aa643ac6d9a3565e$var$contentWrapperStyles = null;
const $aa643ac6d9a3565e$var$logoWrapperSyles = null;
const $aa643ac6d9a3565e$var$linkStyles = null;
const $aa643ac6d9a3565e$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "footer-container",
        className: (0, $hcewu.default)([
            "_11c8dcr7 _16jlidpf _1o9zidpf _i0dl1ex1 _x3dowsm2 _4t3i1ex1 _syaz1n3s _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]),
        children: url ? /*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$ContentAction, {
            tooltipText: linkTooltip,
            href: url,
            children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$Content, {
                    isHovered: isHovered,
                    label: label
                })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$Content, {
            label: label
        })
    });
const $aa643ac6d9a3565e$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"
        ]),
        children: [
            label,
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                    appearance: isHovered ? 'brand' : 'neutral',
                    size: "xxsmall"
                })
            })
        ]
    });
const $aa643ac6d9a3565e$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $fnLem.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipText,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
            href: href,
            target: "_blank",
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseEnter: ()=>{
                setIsHovered(true);
            },
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: ()=>{
                setIsHovered(false);
            },
            onClick: handleClick,
            "data-testid": "link",
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"
            ]),
            children: children({
                isHovered: isHovered
            })
        })
    });
};

});

parcelRegister("73Fae", function(module, exports) {
$parcel$export(module.exports, "PageLoadValidation", () => $8aa4abb0dea40b7c$export$3b0759108d92fe77);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $drmS4 = parcelRequire("drmS4");

var $e5FZ0 = parcelRequire("e5FZ0");

var $bQ7Jf = parcelRequire("bQ7Jf");

var $ftN6c = parcelRequire("ftN6c");

var $bbc8b = parcelRequire("bbc8b");

var $d5di2 = parcelRequire("d5di2");

var $fnLem = parcelRequire("fnLem");
const $8aa4abb0dea40b7c$var$noop = ()=>{};
const $8aa4abb0dea40b7c$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $bbc8b.useUrl)(props);
    const { state: { contentLoadStarted: contentLoadStarted, iframeLoaded: iframeLoaded } } = (0, $d5di2.useValidationState)();
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $eJOHy.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        isLoading: contentLoadStarted && !iframeLoaded || false,
        iframeLoaded: iframeLoaded || true,
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $8aa4abb0dea40b7c$var$noop,
        handleContentLoadStarted: $8aa4abb0dea40b7c$var$noop,
        handleIframeUnload: $8aa4abb0dea40b7c$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($8aa4abb0dea40b7c$var$CrossDomainErrorValidation, {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    }, embeddedConfluenceUrl || props.contentId);
};
const $8aa4abb0dea40b7c$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $d5di2.useValidationState)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $eJOHy.useRef)(null);
    /* This ref is specifically used for the purpose of recoding whether or not a delayed dispatch of the iframe occured.
		This recorded value is later used to fire analytics if contentLoadStarted arrives after the delayed dispatch, and reset
		once the event has fired or if the users needs to go through login flow.
	*/ const iframeLoadedWithDelayRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isLoginFlowDisabled = (0, $eJOHy.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $eJOHy.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
      If anonymous access is permitted globally but restricted on a content's parent space,
      the iframe will attempt a login redirect which we intercept.
      To avoid an error in the iframe, we need to wait for the iframe window to unload
      before unmouting the Iframe component.
    */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // modifiy the navigationPolicy to intercept login redirects
                // so that login can be handled outside of the iframe
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $d5di2.Subjects).CONTENT_LOAD,
                        status: (0, $d5di2.LoadingStatus).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    const handleIframeOnLoad = (0, $eJOHy.useCallback)(()=>{
        const dispatchNow = ()=>{
            dispatch({
                subject: (0, $d5di2.Subjects).CONTENT_LOAD,
                status: (0, $d5di2.LoadingStatus).IFRAME_LOADED
            });
        };
        const totalNumberOfTries = 2;
        const iframeOfDispatch = iframeRef.current;
        const iframeSrcOfDispatch = iframeOfDispatch?.src;
        let tries = 0;
        const dispatchWithDelay = ()=>{
            /* We verify whether the iframeRef is current, as our intent is to invoke this only for the Iframe component created within the Content component (embedded-confluence-common/src/content/Content.tsx).
			It's important to note that the same Iframe component is also used by the StorageAccessPage component; however, we do not need to perform that check in this context.
			Additionally, the src of the iframe may change during transitions between view/edit modes or other redirects. Therefore, we must ensure that our invocation is limited to the current src of the iframe.
			*/ if (iframeRef.current !== iframeOfDispatch || iframeOfDispatch?.src !== iframeSrcOfDispatch) return;
            ++tries;
            if (contentLoadStarted || tries > totalNumberOfTries) {
                // If content load arrived after a timeout, failure to load was prevented by the delay
                if (contentLoadStarted && iframeLoadedWithDelayRef.current) {
                    createAnalyticsEvent({
                        action: 'delayedDispatch',
                        actionSubject: 'iframeOnLoad',
                        actionSubjectId: 'crossDomainErrorValidation',
                        source: 'pageLoadValidation',
                        eventType: 'track'
                    }).fire((0, $fnLem.ANALYTICS_CHANNEL));
                    //reset the ref for now. If the delayed dispatch is triggered again, the event will get fired too
                    iframeLoadedWithDelayRef.current = false;
                }
                dispatchNow();
            } else {
                /* This determines whether to fire a track analytics event
				to log instances where iframe load is delayed to wait for the confluence content to load.*/ if (!iframeLoadedWithDelayRef.current) iframeLoadedWithDelayRef.current = true;
                setTimeout(dispatchWithDelay, 1000);
            }
        };
        dispatchWithDelay();
    }, [
        contentLoadStarted,
        createAnalyticsEvent,
        dispatch
    ]);
    const handleContentLoadStarted = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        isLoading: contentLoadStarted && !iframeLoaded,
        iframeLoaded: iframeLoaded,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQ7Jf.StorageAccessPage), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5FZ0.LoginPage), {
            contentId: contentId,
            parentProduct: parentProduct,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $drmS4.ErrorScreen), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};

});
parcelRegister("drmS4", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", () => $2d64f4bf7c30dace$export$42f84e610f279c31);
/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $5bY40 = parcelRequire("5bY40");

var $806LH = parcelRequire("806LH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lgMTT = parcelRequire("lgMTT");

var $9itkV = parcelRequire("9itkV");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $boRG7 = parcelRequire("boRG7");
var $40f0Z = parcelRequire("40f0Z");

var $j2zMY = parcelRequire("j2zMY");

var $lKjnT = parcelRequire("lKjnT");

var $ijVIe = parcelRequire("ijVIe");

var $4nJ3E = parcelRequire("4nJ3E");
const $2d64f4bf7c30dace$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $2d64f4bf7c30dace$var$styles = {
    loginButtonWrapper: "_19pkxy5q _otyrpxbi",
    mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
const $2d64f4bf7c30dace$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const experience = (0, $eJOHy.useContext)((0, $boRG7.ExperienceContext));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $j2zMY.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "error-screen-container",
        className: (0, $hcewu.default)([
            $2d64f4bf7c30dace$var$styles.mainWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lKjnT.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $ijVIe.default).paragraphLogin)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2d64f4bf7c30dace$var$styles.loginButtonWrapper,
                // data tag for JSM KB to target for excluding LinkButton from global styles
                // used instead of className as the className prop is not allowed
                // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
                "data-embedded-confluence-no-global-styles-link-button": "true",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                    appearance: "primary",
                    "aria-label": formatMessage((0, $ijVIe.default).buttonLoginToConfluenceNewTab),
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
                    href: standaloneConfluenceUrl ?? '',
                    target: "_blank",
                    children: formatMessage((0, $ijVIe.default).buttonLoginToConfluenceNewTab)
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: formatMessage((0, $ijVIe.default).paragraphAlreadyLoggedIn)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: formatMessage((0, $ijVIe.default).paragraphStillHavingTrouble, {
                            link: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                href: $2d64f4bf7c30dace$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
                                target: "_blank",
                                "aria-label": formatMessage((0, $ijVIe.default).linkAriaLabel),
                                children: formatMessage((0, $ijVIe.default).linkTroubleshootingText)
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lKjnT", function(module, exports) {
$parcel$export(module.exports, "LoginToConfluenceIcon", () => $449669a96dd7ddb7$export$ae31f6824db63a1c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $449669a96dd7ddb7$export$ae31f6824db63a1c = ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        width: "148",
        height: "160",
        viewBox: "0 0 148 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_499_12980)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "147.652",
                        height: "160",
                        transform: "translate(0.174194)",
                        fill: "var(--ds-icon-inverse, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z",
                        fill: "url(#paint0_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 44.9982H121.774V46.1167H147.826V44.9982Z",
                            fill: "url(#paint1_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 47.9763H121.774V49.0948H147.826V47.9763Z",
                            fill: "url(#paint2_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M141.564 50.951H121.774V52.0696H141.564V50.951Z",
                            fill: "url(#paint3_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 0H56.186V1.11852H82.238V0Z",
                            fill: "url(#paint4_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 2.97815H56.186V4.09667H82.238V2.97815Z",
                            fill: "url(#paint5_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z",
                            fill: "url(#paint6_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z",
                        fill: "url(#paint7_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z",
                        fill: "url(#paint8_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z",
                        fill: "var(--ds-icon-inverse, white)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #CCE0FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z",
                        fill: "url(#paint9_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFFAE5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z",
                        fill: "url(#paint10_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z",
                        fill: "url(#paint11_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6116 84.6954V74.9203V65.1453V55.3737",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3518 84.4312V75.1948V65.9584V56.722",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z",
                        fill: "url(#paint12_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z",
                        fill: "url(#paint13_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z",
                        fill: "url(#paint14_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z",
                        fill: "url(#paint15_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z",
                        fill: "url(#paint16_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "url(#paint17_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "url(#paint18_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.5641 127.131L58.1314 128.784L49.5641 127.131Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L67.4159 130.575L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L83.9638 133.77L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z",
                        fill: "url(#paint19_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "url(#paint20_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M106.598 139.729L88.1222 136.103L106.598 139.729Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint21_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint22_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z",
                        fill: "url(#paint23_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00B8D9)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z",
                        fill: "url(#paint24_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z",
                        fill: "url(#paint25_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z",
                        fill: "url(#paint26_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z",
                        fill: "url(#paint27_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z",
                        fill: "url(#paint28_linear_499_12980)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_499_12980",
                        x1: "50.6701",
                        y1: "127.204",
                        x2: "144.895",
                        y2: "32.9795",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2415",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFF)",
                                stopOpacity: "0.7585"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4317",
                                stopColor: "var(--ds-background-accent-blue-bolder, #59A1FF)",
                                stopOpacity: "0.5683"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6043",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AABFF)",
                                stopOpacity: "0.3957"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7666",
                                stopColor: "var(--ds-background-accent-blue-subtle, #81B8FF)",
                                stopOpacity: "0.2334"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9202",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #9FC9FF)",
                                stopOpacity: "0.0798"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_499_12980",
                        x1: "121.776",
                        y1: "45.5575",
                        x2: "147.826",
                        y2: "45.5575",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_499_12980",
                        x1: "121.776",
                        y1: "48.5346",
                        x2: "147.826",
                        y2: "48.5346",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_499_12980",
                        x1: "121.776",
                        y1: "51.5113",
                        x2: "141.565",
                        y2: "51.5113",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint4_linear_499_12980",
                        x1: "56.1854",
                        y1: "0.55854",
                        x2: "82.2361",
                        y2: "0.55854",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_499_12980",
                        x1: "56.1854",
                        y1: "3.53525",
                        x2: "82.2361",
                        y2: "3.53525",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_499_12980",
                        x1: "56.1854",
                        y1: "6.51231",
                        x2: "75.9746",
                        y2: "6.51231",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_499_12980",
                        x1: "54.7482",
                        y1: "124.969",
                        x2: "145.885",
                        y2: "33.833",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #2684FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3613",
                                stopColor: "var(--ds-background-accent-blue-subtle, #2986FF)",
                                stopOpacity: "0.6387"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6457",
                                stopColor: "var(--ds-background-accent-blue-subtle, #338CFF)",
                                stopOpacity: "0.3543"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9031",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4495FF)",
                                stopOpacity: "0.0969"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_499_12980",
                        x1: "132.434",
                        y1: "109.023",
                        x2: "129.764",
                        y2: "78.307",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7911",
                                stopColor: "var(--ds-background-accent-blue-subtle, #66A3FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_499_12980",
                        x1: "23.785",
                        y1: "51.7314",
                        x2: "42.402",
                        y2: "33.1132",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2089",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_499_12980",
                        x1: "42.596",
                        y1: "129.08",
                        x2: "141.953",
                        y2: "29.7225",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_499_12980",
                        x1: "37.0626",
                        y1: "130.862",
                        x2: "125.647",
                        y2: "42.2776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DEEBFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6383",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #EBF1FA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_499_12980",
                        x1: "94.0388",
                        y1: "28.347",
                        x2: "117.556",
                        y2: "28.347",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtle, #6E7C93)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtle, #6C798F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_499_12980",
                        x1: "50.5705",
                        y1: "26.7136",
                        x2: "49.861",
                        y2: "13.9285",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_499_12980",
                        x1: "45.5246",
                        y1: "24.8807",
                        x2: "54.0025",
                        y2: "13.9733",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_499_12980",
                        x1: "101.929",
                        y1: "89.445",
                        x2: "103.151",
                        y2: "76.738",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_499_12980",
                        x1: "96.7524",
                        y1: "86.8327",
                        x2: "105.46",
                        y2: "77.236",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_499_12980",
                        x1: "46.7436",
                        y1: "124.678",
                        x2: "85.5786",
                        y2: "85.843",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_499_12980",
                        x1: "55.645",
                        y1: "135.098",
                        x2: "94.1816",
                        y2: "96.5612",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint19_linear_499_12980",
                        x1: "82.9016",
                        y1: "129.529",
                        x2: "83.3365",
                        y2: "138.118",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint20_linear_499_12980",
                        x1: "66.7271",
                        y1: "153.359",
                        x2: "112.794",
                        y2: "115.971",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint21_linear_499_12980",
                        x1: "64.8985",
                        y1: "150.541",
                        x2: "110.859",
                        y2: "113.239",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint22_linear_499_12980",
                        x1: "99.6982",
                        y1: "120.33",
                        x2: "103.749",
                        y2: "121.161",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint23_linear_499_12980",
                        x1: "0.174194",
                        y1: "146.568",
                        x2: "56.0521",
                        y2: "146.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint24_linear_499_12980",
                        x1: "58.1309",
                        y1: "158.125",
                        x2: "87.7433",
                        y2: "158.125",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint25_linear_499_12980",
                        x1: "78.6253",
                        y1: "150.658",
                        x2: "68.697",
                        y2: "151.584",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.452",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint26_linear_499_12980",
                        x1: "79.3893",
                        y1: "142.265",
                        x2: "75.8395",
                        y2: "140.601",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3539",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFB500)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7017",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint27_linear_499_12980",
                        x1: "76.9238",
                        y1: "139.183",
                        x2: "90.7241",
                        y2: "138.741",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7262",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint28_linear_499_12980",
                        x1: "90.4515",
                        y1: "22.6491",
                        x2: "117.556",
                        y2: "22.6491",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.0346",
                                stopColor: "var(--ds-icon-inverse, white)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3965",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F7F7F8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9604",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #E1E3E6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_499_12980",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "147.652",
                            height: "160",
                            fill: "var(--ds-icon-inverse, white)",
                            transform: "translate(0.174194)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("ijVIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a66953f9d62b484$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66953f9d62b484$var$messages = (0, $7qGN1.defineMessages)({
    connectToConfluenceHeading: {
        id: 'embedded.confluence.connect-to-confluence.heading',
        description: 'The heading for the connect to Confluence page',
        defaultMessage: 'Connect to Confluence for notes access'
    },
    connectToConfluenceDescription: {
        id: 'embedded.confluence.connect-to-confluence.description',
        description: 'The description for the connect to Confluence page',
        defaultMessage: 'Connect your Loom account to Confluence to access this page.'
    },
    connectConfluenceButton: {
        id: 'embedded.confluence.connect-to-confluence.button',
        description: 'The text inside the connect to Confluence button',
        defaultMessage: 'Connect Confluence'
    },
    connectConfluenceButtonAriaLabel: {
        id: 'embedded.confluence.connect-to-confluence.button.aria-label',
        description: 'The aria label for the connect to Confluence button',
        defaultMessage: 'Connect Confluence Button'
    },
    buttonLoginToConfluenceNewTab: {
        id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
        description: 'The text inside the login to Confluence button',
        defaultMessage: 'Log in to Confluence'
    },
    paragraphLogin: {
        id: 'embedded.confluence.need-to-log-in-paragraph',
        description: 'The text inside embedded confluence that tell user they need to be logged in to view this page',
        defaultMessage: 'You need to be logged in to view this page'
    },
    paragraphAlreadyLoggedIn: {
        id: 'embedded.confluence.already-logged-in-paragraph',
        description: 'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
        defaultMessage: 'Already logged in? Try refreshing.'
    },
    paragraphStillHavingTrouble: {
        id: 'embedded.confluence.still-having-trouble-paragraph',
        description: 'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
        defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}'
    },
    linkTroubleshootingText: {
        id: 'embedded.confluence.troubleshooting-link-text',
        description: 'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
        defaultMessage: 'refer to this troubleshooting guide.'
    },
    linkAriaLabel: {
        id: 'embedded.confluence.troubleshooting-link.aria-label',
        description: 'The aria label for troubleshooting link.',
        defaultMessage: 'troubleshooting guide link'
    },
    loginAriaLabel: {
        id: 'embedded.confluence.login-page.login-button.aria-label',
        description: 'The aria label for login button',
        defaultMessage: 'Login Button'
    },
    loginText: {
        id: 'embedded.confluence.login-page.login-text',
        description: 'Text to display before login button',
        defaultMessage: 'You need to be logged in to view this page'
    },
    loginButton: {
        id: 'embedded.confluence.login-page.login-button',
        description: 'The label for login button',
        defaultMessage: 'Log in to Confluence'
    },
    refreshBanner: {
        id: 'embedded.confluence.login-page.refresh-page-banner',
        description: 'The banner displayed prompting a user to refresh the page',
        defaultMessage: 'After logging in, this page should refresh automatically. If not, you can click here to refresh'
    },
    refreshBannerLink: {
        id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
        description: 'A link to refresh the page',
        defaultMessage: 'Refresh page'
    }
});
var $1a66953f9d62b484$export$2e2bcd8739ae039 = $1a66953f9d62b484$var$messages;

});


parcelRegister("e5FZ0", function(module, exports) {
$parcel$export(module.exports, "LoginPage", () => $46ab436a36e209ea$export$f14c0e3f98d164c0);
/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");
var $78OnL = parcelRequire("78OnL");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $806LH = parcelRequire("806LH");

var $5CSKW = parcelRequire("5CSKW");

var $lgMTT = parcelRequire("lgMTT");

var $kopi2 = parcelRequire("kopi2");

var $lKjnT = parcelRequire("lKjnT");

var $j2zMY = parcelRequire("j2zMY");

var $8edRS = parcelRequire("8edRS");

var $4AWDd = parcelRequire("4AWDd");

var $ijVIe = parcelRequire("ijVIe");

var $4nJ3E = parcelRequire("4nJ3E");

var $kfi6y = parcelRequire("kfi6y");

var $5qJVF = parcelRequire("5qJVF");
const $46ab436a36e209ea$var$fadeIn = null;
const $46ab436a36e209ea$var$styles = {
    loginButtonWrapper: "_19pkxy5q",
    parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
    refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n",
    loomLoginButton: "_2rkogktf _11c81ixg _v5642hjt _1bsb842n _4t3i8vuz _bfhkb29m _syaz15cr _k48p1pd9 _o7ks2hjt _irr3u1se _1di6qkzo"
};
const $46ab436a36e209ea$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $46ab436a36e209ea$export$f14c0e3f98d164c0 = ({ contentId: contentId, parentProduct: parentProduct, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $eJOHy.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        const uniqueKeyParam = uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `&uniqueKey=${uniqueKey}` : '';
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$46ab436a36e209ea$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}${uniqueKeyParam}`;
    }, [
        url,
        locale,
        uniqueKey
    ]);
    const isLoomParentProduct = parentProduct === 'loom' && (0, $eGOwo.fg)('mr2-meeting-recording-notes-confluence');
    const handleClick = ()=>{
        $46ab436a36e209ea$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $eJOHy.useState)(false);
    return isLoomParentProduct ? /*#__PURE__*/ (0, $gt9Am.jsx)($46ab436a36e209ea$export$e65dcd3f2d7567ae, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($46ab436a36e209ea$export$50083a1d14fa7d72, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    });
};
const $46ab436a36e209ea$export$e65dcd3f2d7567ae = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hcewu.default)([
            $46ab436a36e209ea$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}-loom`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kfi6y.ConnectLoomToConfluenceSVG), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                        space: "space.100",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                as: "h2",
                                size: "large",
                                children: formatMessage((0, $ijVIe.default).connectToConfluenceHeading)
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                color: "color.text.subtlest",
                                size: "medium",
                                children: formatMessage((0, $ijVIe.default).connectToConfluenceDescription)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                        xcss: $46ab436a36e209ea$var$styles.loomLoginButton,
                        onClick: handleClick,
                        testId: "connect-confluence-button",
                        "aria-label": formatMessage((0, $ijVIe.default).connectConfluenceButtonAriaLabel),
                        children: formatMessage((0, $ijVIe.default).connectConfluenceButton)
                    }),
                    displayRefreshBanner && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $46ab436a36e209ea$var$styles.refreshBannerFade
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4AWDd.default), {
                            reloadEP: reloadEP,
                            title: formatMessage((0, $ijVIe.default).refreshBanner),
                            actionLabel: formatMessage((0, $ijVIe.default).refreshBannerLink)
                        })
                    })
                ]
            })
        ]
    });
};
const $46ab436a36e209ea$export$50083a1d14fa7d72 = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hcewu.default)([
            $46ab436a36e209ea$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lKjnT.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $ijVIe.default).loginText)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $46ab436a36e209ea$var$styles.loginButtonWrapper,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "login-button",
                    "aria-label": formatMessage((0, $ijVIe.default).loginAriaLabel),
                    appearance: "primary",
                    onClick: handleClick,
                    children: formatMessage((0, $ijVIe.default).loginButton)
                })
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $46ab436a36e209ea$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4AWDd.default), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $ijVIe.default).refreshBanner),
                    actionLabel: formatMessage((0, $ijVIe.default).refreshBannerLink)
                })
            })
        ]
    });
};
function $46ab436a36e209ea$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}

});
parcelRegister("kopi2", function(module, exports) {
$parcel$export(module.exports, "ExperienceStart", () => $80a280f19a7661a1$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");
function $80a280f19a7661a1$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const wasCalledRef = (0, $eJOHy.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("4AWDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd4c0eb9ad4557e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h0TP6 = parcelRequire("h0TP6");

var $3wl9L = parcelRequire("3wl9L");

const $4fd4c0eb9ad4557e$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h0TP6.default), {
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
            spacing: "spacious",
            color: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $4fd4c0eb9ad4557e$export$2e2bcd8739ae039 = $4fd4c0eb9ad4557e$var$RefreshBanner;

});

parcelRegister("kfi6y", function(module, exports) {
$parcel$export(module.exports, "ConnectLoomToConfluenceSVG", () => $7848c829a07d8eab$export$b8ca9c7db864e9fb);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $7848c829a07d8eab$export$b8ca9c7db864e9fb = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "167",
        height: "110",
        viewBox: "0 0 167 110",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M31.3301 44.2761C32.0417 39.4311 36.5463 36.0803 41.3913 36.792L76.4821 41.9462C81.3272 42.6579 84.6779 47.1624 83.9663 52.0075L78.812 87.0983C78.1004 91.9433 73.5958 95.294 68.7508 94.5824L33.66 89.4282C28.815 88.7165 25.4642 84.2119 26.1759 79.3669L31.3301 44.2761Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M67.5284 73.4352C59.3 67.8513 56.8065 66.8312 53.0744 66.2831C48.6954 65.6399 44.6958 66.9131 40.6098 71.5432L39.9395 72.2997C39.3904 72.9231 39.2547 73.1546 39.2113 73.45C39.1679 73.7454 39.2811 74.0134 39.7778 74.4384L44.8874 78.7596C45.1571 79.0004 45.3914 79.1354 45.6402 79.1719C45.9388 79.2158 46.1595 79.0973 46.5232 78.6981L47.6213 77.4513C49.3256 75.5391 50.6708 75.0326 52.2632 75.2665C53.6565 75.4712 55.2408 76.1062 57.1364 77.3904L62.6032 81.0097C63.157 81.3928 63.8256 81.3401 64.2254 80.6948L67.9086 74.9997C68.3084 74.3544 68.1745 73.8821 67.5284 73.4352ZM43.286 58.8607C51.5144 64.4446 54.0079 65.4647 57.74 66.0129C62.119 66.656 66.1186 65.3828 70.2046 60.7527L70.8749 59.9962C71.424 59.3728 71.5597 59.1413 71.6031 58.8459C71.6464 58.5505 71.5333 58.2825 71.0366 57.8575L65.9269 53.5363C65.6573 53.2956 65.4229 53.1606 65.1741 53.124C64.8756 53.0802 64.6548 53.1986 64.2912 53.5978L63.193 54.8446C61.4888 56.7568 60.1435 57.2633 58.5512 57.0294C57.1579 56.8247 55.5736 56.1897 53.678 54.9055L48.2111 51.2862C47.6574 50.9031 46.9888 50.9558 46.589 51.6011L42.9058 57.2962C42.506 57.9415 42.6399 58.4138 43.286 58.8607Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M79.0185 46.5871C78.7238 41.699 82.4475 37.4974 87.3356 37.2027L122.739 35.0683C127.627 34.7736 131.828 38.4973 132.123 43.3855L134.257 78.7885C134.552 83.6766 130.828 87.8782 125.94 88.1729L90.5372 90.3073C85.6491 90.602 81.4476 86.8782 81.1529 81.9901L79.0185 46.5871Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M131.339 50.0102C131.38 50.4171 131.327 50.505 131.302 50.1756C131.296 50.0816 131.32 49.9587 131.339 50.0102ZM131.57 52.9057C131.605 53.3647 131.523 53.1278 131.517 53.0508C131.491 52.7277 131.544 52.4429 131.45 52.3368C131.432 52.1403 131.48 52.3249 131.475 52.2024C131.466 51.974 131.411 51.7504 131.395 51.5148C131.394 51.4988 131.393 51.4827 131.392 51.4667C131.409 51.4389 131.425 51.3739 131.444 51.3812C131.483 51.6293 131.561 52.7919 131.57 52.9057ZM131.427 50.9503C131.427 51.0635 131.396 51.0164 131.425 51.2291C131.405 51.2768 131.371 51.0701 131.365 50.9646C131.366 50.9616 131.384 50.975 131.383 50.95C131.373 50.7637 131.336 50.4831 131.384 50.4742C131.369 50.6602 131.426 50.8363 131.427 50.9503ZM131.282 48.5903C131.246 48.5428 131.245 48.4575 131.257 48.3261C131.265 48.3353 131.273 48.3382 131.281 48.3488C131.28 48.4257 131.282 48.5106 131.282 48.5903ZM131.26 48.1016C131.214 48.0042 131.204 47.4619 131.229 47.556C131.24 47.7377 131.25 47.9201 131.26 48.1016ZM107.62 90.4766C107.274 90.5679 106.006 90.5716 105.721 90.5878C104.407 90.6624 103.378 90.7473 102.165 90.8174C101.392 90.862 100.675 90.8822 99.9078 90.9254C99.7367 90.8515 99.5625 90.7784 99.3886 90.705C99.498 90.7054 99.555 90.7128 99.6801 90.7055C99.8054 90.698 100.106 90.6919 100.18 90.6481C100.066 90.6154 99.6636 90.6311 99.5409 90.6386C99.305 90.6532 99.4564 90.6823 99.2947 90.7011C99.1322 90.7198 98.859 90.6833 98.6613 90.7154C98.1978 90.7907 99.0717 90.7683 99.232 90.7501C99.1833 90.8416 98.7878 90.762 98.6394 90.8403C98.6993 90.8575 98.9438 90.8941 99.0348 90.8735C99.125 90.8526 98.9797 90.809 99.1761 90.8123C99.3083 90.8528 99.4553 90.895 99.5867 90.9362C99.3933 90.9602 99.0982 90.9499 98.9253 90.9616C97.8606 91.0345 96.8159 91.0945 95.7699 91.1505C94.9029 91.1696 94.0376 91.187 93.174 91.2031C93.1836 91.205 93.1924 91.2072 93.2008 91.2093C93.2152 91.2129 93.2294 91.2164 93.2482 91.2186C93.2489 91.2181 93.2496 91.2176 93.2504 91.2171C93.2716 91.22 93.3038 91.2207 93.3367 91.2214C93.3818 91.2223 93.4283 91.2234 93.4497 91.2302C93.4243 91.2339 93.3988 91.2377 93.3734 91.2414C93.3171 91.2482 93.2574 91.2556 93.2003 91.2626C93.1442 91.2437 93.0882 91.2247 93.0322 91.2058C92.7606 91.2108 92.489 91.2157 92.2176 91.2205C92.2071 91.2169 92.1935 91.2133 92.1762 91.2101C92.1625 91.2076 92.1487 91.2051 92.135 91.2025C92.1133 91.2019 92.0916 91.2013 92.0699 91.2006C91.957 91.1974 91.8172 91.1977 91.7043 91.1983C91.674 91.1985 91.6449 91.1988 91.6183 91.199C91.5339 91.1995 91.4672 91.2 91.416 91.1995C91.4092 91.1994 91.4019 91.1995 91.3948 91.1994C91.3921 91.197 91.3877 91.1948 91.3823 91.1928C91.342 91.1785 91.2874 91.1824 91.2329 91.1949C91.2272 91.1964 91.2215 91.1979 91.2158 91.1994C91.1868 91.1995 91.1581 91.1996 91.132 91.1996C91.0351 91.1998 90.9251 91.1993 90.7943 91.1963C90.7267 91.1947 90.6606 91.1924 90.5904 91.1899C90.5804 91.1896 90.5702 91.1894 90.56 91.189C90.5594 91.189 90.5589 91.189 90.5583 91.189C90.5114 91.1876 90.4628 91.1858 90.411 91.1836C90.3415 91.1806 90.267 91.1769 90.1953 91.1735C90.1278 91.1703 90.0396 91.1663 89.946 91.164C89.7468 91.1666 88.9653 91.107 88.5938 91.034C88.4281 91.0058 88.2629 90.9911 88.1944 91.0022C88.101 90.9806 88.007 90.9575 87.9141 90.9331C87.9082 90.9345 87.8999 90.9352 87.8885 90.9345C87.864 90.9327 87.823 90.9258 87.7788 90.9177C87.6952 90.9027 87.6003 90.8836 87.5888 90.8972C87.6785 90.9206 87.7675 90.9425 87.8575 90.9632C87.8634 90.9646 87.8693 90.9661 87.8752 90.9675C87.9335 90.993 87.6034 90.9524 87.4974 90.905C87.413 90.8688 87.4552 90.8308 87.4954 90.8131C87.4526 90.7998 87.4099 90.7861 87.3674 90.7721C87.3541 90.7724 87.3444 90.775 87.3343 90.7775C87.3182 90.7815 87.3009 90.7859 87.265 90.7827C87.0814 90.7695 86.6535 90.5904 86.8491 90.6095C86.7354 90.5643 86.716 90.5671 86.6938 90.5718C86.6703 90.5765 86.6421 90.5832 86.4934 90.5273C86.3176 90.4597 86.2527 90.4186 86.1919 90.3808C86.1597 90.3605 86.1282 90.3405 86.0824 90.3162C86.0409 90.2943 85.967 90.2599 85.8842 90.2195C85.7023 90.1317 85.48 90.011 85.4441 89.959C85.4025 89.9008 85.4973 89.942 85.58 89.9786C85.3732 89.8604 85.1712 89.7347 84.9742 89.6018C84.9683 89.6082 84.9628 89.6164 84.9563 89.626C84.6803 89.4614 84.6463 89.4058 84.7056 89.4138C84.4619 89.2369 84.2266 89.0487 84.0011 88.8505C83.9491 88.815 83.898 88.778 83.8573 88.7474C83.8663 88.77 83.9181 88.8143 83.9672 88.8549C84.0087 88.8894 84.0486 88.9216 84.0578 88.9379C84.1217 89.065 83.5954 88.7066 83.7348 88.7207C83.7682 88.7247 83.8061 88.7288 83.773 88.6802C83.7475 88.644 83.6269 88.5267 83.5785 88.4881C83.58 88.4881 83.5814 88.4881 83.5829 88.4881C83.5793 88.4851 83.5723 88.4815 83.5627 88.4766C83.5507 88.4709 83.5388 88.4651 83.5268 88.4593C83.495 88.4441 83.4558 88.4248 83.4272 88.4066C83.3929 88.384 83.3536 88.3551 83.3137 88.325C82.8696 87.978 83.1905 88.265 82.8441 87.8048C82.8172 87.7684 82.7836 87.7308 82.7522 87.695C82.7247 87.6635 82.6985 87.6329 82.6802 87.6068C82.6449 87.5582 82.616 87.5138 82.5881 87.4702C82.5357 87.3883 82.4859 87.3084 82.4032 87.2011C82.4008 87.1982 82.4038 87.2055 82.4083 87.2165C82.5222 87.4874 82.2959 87.0342 82.2912 87.0204C82.2843 87.0085 82.2788 86.9991 82.2796 86.9978C82.2871 86.9874 82.3585 87.0764 82.4443 87.1771C82.525 87.2721 82.6195 87.3779 82.6785 87.4268C82.6462 87.3841 82.6142 87.341 82.5827 87.2978C82.544 87.2596 82.5018 87.2089 82.4626 87.1481C82.4523 87.1315 82.4576 87.1307 82.4627 87.1299C82.4628 87.1298 82.4629 87.1298 82.4629 87.1297C82.4354 87.0902 82.4081 87.0506 82.3812 87.0107C82.3732 87.0062 82.3701 87.0087 82.3696 87.0092C82.3688 87.0091 82.3681 87.009 82.3673 87.0089C82.3132 86.9471 82.1273 86.6606 82.1188 86.6193C82.1159 86.6088 82.1154 86.6013 82.1174 86.5973C82.0521 86.4889 81.989 86.3792 81.9282 86.2686C81.92 86.2589 81.9122 86.2484 81.9052 86.2367C81.8892 86.2113 81.8767 86.182 81.8655 86.1525C81.8362 86.0972 81.8071 86.0414 81.779 85.9858C81.7779 85.9858 81.7768 85.9858 81.7757 85.9858C81.7681 85.986 81.7599 85.986 81.7526 85.9766C81.9146 86.2648 81.8715 86.2166 81.8189 86.1646C81.795 86.1404 81.7701 86.115 81.7643 86.1207C81.7571 86.1293 81.7854 86.1854 81.8128 86.238C81.8471 86.3039 81.8798 86.3648 81.835 86.3242C81.7541 86.1559 81.6866 86.0493 81.6196 85.9409C81.4113 85.5958 81.4418 85.5059 81.5671 85.7679C81.5941 85.8225 81.6228 85.879 81.6506 85.9161C81.6827 85.9595 81.7048 85.9637 81.7246 85.9673C81.734 85.9691 81.7432 85.9709 81.7526 85.9766C81.7505 85.9738 81.7485 85.971 81.7465 85.9681C81.7389 85.9589 81.5991 85.7219 81.5883 85.6967C81.5147 85.5528 81.5228 85.5549 81.535 85.5597C81.5414 85.5621 81.5492 85.5651 81.5486 85.5495C81.5479 85.5434 81.5404 85.5246 81.533 85.5057C81.5233 85.4809 81.5138 85.4558 81.5184 85.4579C81.5225 85.4581 81.5307 85.4662 81.5403 85.4775C81.5243 85.4406 81.5084 85.4033 81.4928 85.3661C81.4797 85.3476 81.4678 85.3297 81.4595 85.3121C81.4553 85.3034 81.3896 85.1212 81.3911 85.1194C81.3912 85.1189 81.3925 85.12 81.3947 85.1222C81.2502 84.748 81.1298 84.3647 81.0343 83.9759C81.0341 83.9724 81.0338 83.9689 81.0336 83.9654C81.0332 83.9596 81.0329 83.9536 81.0325 83.9476C81.0317 83.9311 81.0309 83.9146 81.0301 83.8981C81.0275 83.8381 81.0247 83.7495 81.0197 83.6666C81.0161 83.6075 81.0102 83.5303 80.9992 83.4389C80.9883 83.3487 80.9675 83.2035 80.9296 83.0313C80.9038 82.9144 80.8771 82.8037 80.8493 82.7188C80.8136 82.6096 80.7836 82.558 80.7674 82.5406C80.7627 82.5356 80.7584 82.5334 80.7545 82.5341C80.7425 82.5071 80.7338 82.4871 80.733 82.4854C80.7088 82.3834 80.7232 82.3809 80.7338 82.3798C80.7362 82.3795 80.7386 82.3791 80.7402 82.3776C80.7451 82.3701 80.7683 82.3392 80.7809 82.3254C80.7742 82.2219 80.7692 82.1179 80.7659 82.0134C80.7559 81.6901 80.7456 81.3663 80.7349 81.0422C80.7207 80.6135 80.7032 80.181 80.6826 79.745C80.6695 79.4657 80.6552 79.1847 80.6397 78.9027C80.6302 78.9271 80.6201 78.9398 80.6023 78.8581C80.5776 78.7426 80.5856 78.4294 80.5869 78.3818C80.585 78.373 80.5814 78.3636 80.5772 78.3522C80.5673 78.3258 80.5531 78.288 80.5445 78.2183C80.5251 78.0634 80.3678 77.3508 80.3787 77.1825C80.3693 77.0425 80.3596 76.9019 80.3497 76.7614C80.348 76.7092 80.3461 76.6588 80.3445 76.6114C80.348 76.5958 80.3509 76.5773 80.3531 76.555C80.3757 76.3205 80.3758 75.8656 80.4059 75.605C80.4224 75.6733 80.4382 75.7545 80.4543 75.8278C80.4653 75.7741 80.4764 75.7195 80.4874 75.665C80.4942 75.6747 80.5009 75.6836 80.5077 75.6925C80.5085 75.5271 80.5092 75.3616 80.51 75.1962C80.5093 75.1966 80.5085 75.1968 80.5078 75.1971C80.4996 75.1382 80.5033 75.1116 80.5104 75.095C80.5108 75.0137 80.5113 74.9324 80.5117 74.8511C80.5071 74.8269 80.5022 74.8005 80.497 74.7742C80.4786 74.7564 80.4601 74.7386 80.4416 74.7209C80.4489 74.6766 80.4562 74.6324 80.4635 74.5882C80.4432 74.4592 80.4319 74.3318 80.4533 74.2422C80.4471 74.1671 80.4409 74.0919 80.4347 74.0168C80.4269 73.9667 80.4215 73.911 80.4189 73.8562C80.3929 73.7794 80.2514 73.5491 80.2112 73.1899C80.2561 73.1982 80.301 73.2066 80.346 73.215C80.3322 73.1088 80.3184 73.0027 80.3046 72.8965C80.275 72.8709 80.2454 72.8452 80.2159 72.8196C80.2372 72.806 80.2586 72.7923 80.2799 72.7787C80.264 72.5745 80.2481 72.3704 80.2322 72.1662C80.2318 72.1662 80.2314 72.1663 80.2311 72.1663C80.2279 72.1399 80.2271 72.1211 80.2277 72.1076C80.2256 72.0798 80.2234 72.052 80.2212 72.0242C80.2403 72.0275 80.2593 72.0309 80.2784 72.0343C80.2785 72.0312 80.2788 72.0281 80.2787 72.0245C80.2776 71.9657 80.2699 71.9109 80.2596 71.8565C80.2526 71.8783 80.2457 71.9001 80.2388 71.9219C80.2027 71.6505 80.1667 71.3791 80.1307 71.1076C80.1409 71.072 80.1512 71.0364 80.1615 71.0008C80.1598 70.9882 80.1585 70.9758 80.1579 70.9648C80.1582 70.9631 80.1657 70.9624 80.1731 70.9594C80.1772 70.9448 80.1814 70.9302 80.1856 70.9156C80.1853 70.9103 80.185 70.9051 80.1846 70.8998C80.1459 70.8409 80.1072 70.7821 80.0684 70.7233C80.0579 70.5699 80.0474 70.4165 80.037 70.2631C80.035 70.1419 80.0339 70.0263 80.0328 69.9182C80.0445 69.7275 80.0562 69.5368 80.0678 69.346C80.0515 69.3242 80.0392 69.3047 80.0301 69.2856C80.0302 69.2133 80.0303 69.1724 80.0303 69.1724C80.0221 69.163 80.0138 69.1537 80.0055 69.1444C80.0071 69.0531 80.0211 68.9288 79.969 68.6875C80.0104 68.6956 80.0517 68.7037 80.0931 68.7117C80.0956 68.688 80.0999 68.6606 80.1057 68.631C80.0471 68.3825 79.9886 68.1341 79.9301 67.8857C79.9837 67.7705 80.0373 67.6552 80.0909 67.54C80.0838 67.262 80.0766 66.9841 80.0695 66.7062C80.0664 66.6765 80.0636 66.6465 80.0605 66.6168C80.0416 66.7078 80.0226 66.7988 80.0037 66.8898C79.944 66.8071 79.8842 66.7244 79.8245 66.6416C79.8578 66.4725 79.8911 66.3034 79.9244 66.1342C79.8061 65.3199 79.9727 64.5136 79.7355 64.8227C79.7519 64.9322 79.7684 65.0417 79.7848 65.1512C79.7383 65.0113 79.6918 64.8714 79.6454 64.7315C79.6676 64.5993 79.6898 64.4671 79.712 64.3348C79.6892 64.1731 79.6663 64.0114 79.6435 63.8497C79.671 63.8019 79.6985 63.7542 79.726 63.7065C79.6899 63.5758 79.6537 63.4451 79.6176 63.3144C79.6609 63.2008 79.7042 63.0871 79.7475 62.9735C79.6979 62.3226 79.6483 61.6717 79.5987 61.0208C79.6525 60.0392 79.5116 60.5012 79.4237 59.8255C79.4384 59.5102 79.4531 59.195 79.4678 58.8797C79.4325 58.7663 79.3972 58.6529 79.362 58.5395C79.3723 58.4369 79.3826 58.3344 79.393 58.2318C79.3687 57.749 79.3445 57.2662 79.3202 56.7834C79.2766 56.8794 79.233 56.9754 79.1894 57.0714C79.1742 56.982 79.1591 56.8925 79.1439 56.8031C79.1899 56.564 79.2358 56.3249 79.2818 56.0858C79.2522 55.9 79.2227 55.7143 79.1932 55.5286C79.1887 55.2678 79.1841 55.0071 79.1795 54.7464C79.2151 54.7336 79.2506 54.7209 79.2861 54.7082C79.2221 54.6167 79.158 54.5251 79.094 54.4336C79.0614 54.0636 79.0287 53.6935 78.996 53.3235C79.0365 53.5433 79.077 53.7631 79.1175 53.9829C79.1303 53.7921 79.1431 53.6013 79.1559 53.4105C79.1273 53.2084 79.0986 53.0062 79.07 52.8041C79.0432 52.7445 79.0165 52.685 78.9898 52.6254C78.9878 52.2029 78.9857 51.7805 78.9837 51.358C78.954 50.8549 78.9243 50.3518 78.8946 49.8487C78.7823 49.4097 78.8897 48.6265 78.6532 48.5856C78.6472 48.1752 78.6413 47.7648 78.6354 47.3544C78.617 47.2651 78.5985 47.1759 78.5801 47.0866C78.6077 47.0381 78.6353 46.9897 78.6629 46.9412C78.6391 46.8317 78.6154 46.7223 78.5916 46.6128C78.5777 46.5465 78.5646 46.48 78.5521 46.4135C78.544 46.1586 78.5462 45.9011 78.5589 45.6468C78.5767 45.7278 78.5956 45.8079 78.6155 45.888C78.6565 45.1694 78.7813 44.4595 78.9865 43.7757C78.9398 43.7258 78.8935 43.6754 78.8475 43.6243C78.9342 43.3654 79.0325 43.1102 79.1413 42.861C79.12 42.8162 79.0991 42.771 79.0784 42.7256C79.233 42.3018 79.4186 41.8886 79.6329 41.4908C79.8971 41.1088 80.1878 40.7491 80.501 40.4152C80.7499 39.8965 81.5911 38.9271 81.9551 38.918C82.4932 38.438 83.09 38.0189 83.7307 37.6738C83.7112 37.7222 83.692 37.7707 83.6735 37.8191C83.7343 37.7993 83.7953 37.7801 83.8561 37.7618C83.8806 37.6928 83.9062 37.6239 83.9328 37.5549C84.1786 37.4814 84.4251 37.419 84.673 37.3669C84.5981 37.4263 84.5235 37.487 84.4508 37.5484C84.3568 37.5872 84.264 37.6274 84.1714 37.6694C84.3145 37.6444 84.457 37.6232 84.5999 37.6053C84.5945 37.6084 84.5891 37.6114 84.5836 37.6145C85.2161 37.4001 85.7845 37.3042 86.2854 37.2596C86.3256 37.2564 86.3657 37.2534 86.4059 37.2506C86.9855 37.2195 87.24 37.3094 87.3206 37.3772C87.3386 37.3929 87.3481 37.4094 87.3491 37.4263C87.3491 37.4263 87.3491 37.4263 87.3491 37.4263C87.3536 37.5039 87.1847 37.5851 86.856 37.6805C86.8279 37.6884 86.7999 37.6964 86.7721 37.7045C86.3117 37.8332 85.8271 37.9752 85.3817 38.137C85.4686 38.1219 85.5525 38.1102 85.6205 38.1063C85.5736 38.1325 85.517 38.1606 85.4671 38.1881C85.5109 38.1893 85.5557 38.1906 85.5999 38.1924C85.5919 38.2047 85.5899 38.215 85.578 38.2289C85.3094 38.3084 84.98 38.4856 84.7525 38.5867C84.5446 38.6783 84.408 38.6911 84.2496 38.7672C84.0868 38.8398 83.6355 39.1787 83.6803 39.0438C83.6527 39.0557 83.6141 39.0751 83.5873 39.0857C83.615 39.1859 83.3832 39.2423 83.1935 39.3952C83.1035 39.4659 82.8854 39.7388 83.0403 39.4458C83.0091 39.4667 82.9936 39.4718 82.9658 39.4879C82.7884 39.7796 82.6552 39.8348 82.3589 40.0477C82.1924 40.1656 81.8866 40.4424 82.0829 40.3758C81.9825 40.5636 81.7389 40.6956 81.648 40.8147C81.5589 40.9321 81.7257 40.811 81.6061 40.9687C81.5856 40.9942 81.4152 41.2135 81.3615 41.2767C81.3074 41.3385 81.3322 41.2371 81.2587 41.3492C80.9423 41.8384 80.7524 42.3451 80.5338 42.8996C80.0775 44.0705 79.8857 45.2827 79.9687 46.5298C80.0068 47.0976 80.0444 47.6739 80.0832 48.2653C80.1054 48.6026 80.2269 50.3483 80.2056 50.5496C80.1319 51.2394 79.9913 49.7944 80.0004 50.7772C80.3346 51.0247 80.2752 51.6099 80.3287 52.4314C80.3681 53.0372 80.4728 54.0132 80.4669 54.5351C80.4607 55.092 80.3957 54.6488 80.3477 54.9832C80.4922 55.1983 80.5351 55.4647 80.5703 55.922C80.6074 56.4025 80.5958 56.8851 80.616 57.3871C80.6228 57.5562 80.6651 57.7847 80.6653 57.9784C80.6656 58.2199 80.587 58.1635 80.585 58.3117C80.5831 58.4603 80.6621 58.3274 80.6855 58.4876C80.6962 58.5605 80.7297 59.0693 80.7028 59.1805C80.6965 59.2064 80.6631 59.1128 80.6386 59.1345C80.6252 59.1465 80.5177 59.1487 80.5343 59.2722C80.6361 59.3769 80.733 59.3798 80.7632 59.7658C80.8107 60.376 80.801 60.9562 80.8335 61.6063C80.8409 61.7518 80.9318 62.092 80.8594 62.2541C80.8383 62.3014 80.7444 62.2823 80.7631 62.5136C80.7791 62.7126 80.823 62.7413 80.8651 62.9129C80.881 62.978 80.8385 62.9994 80.8719 63.1225C80.9052 63.2464 80.9753 63.4223 80.8664 63.5094C80.902 63.5238 80.9328 63.5246 80.9664 63.5343C80.9856 63.7547 80.882 64.1396 80.983 64.0672C80.9972 64.2942 81.0114 64.5217 81.0256 64.7487C80.9906 64.7907 80.9553 64.8316 80.9201 64.8736C80.8761 64.7406 80.9118 64.5274 80.8399 64.5069C80.8461 64.7026 80.8524 64.9009 80.8585 65.0948C81.0434 65.0319 81.1744 65.6375 80.9695 65.514C80.9306 65.491 80.9861 65.8896 81.0041 65.9755C81.022 66.0608 81.0994 66.0792 81.0619 66.2597C81.0407 66.3622 80.9991 66.427 81.0658 66.6657C81.0782 66.5177 81.0946 66.3596 81.109 66.2086C81.1136 66.43 81.157 66.7154 81.1287 66.9141C81.1216 66.9632 81.082 66.7738 81.0714 66.8647C81.0607 66.9559 81.0921 67.3236 81.1609 67.2422C81.0275 67.4207 81.1452 67.3897 81.1706 67.7482C81.1736 67.7938 81.0587 68.1645 81.1418 68.3253C81.1714 68.3821 81.262 68.2671 81.2374 68.5537C81.2192 68.7646 81.1234 68.5544 81.0907 68.789C81.1945 68.6745 81.2802 69.0334 81.2957 69.2456C81.3233 69.6218 81.2503 69.5699 81.2271 69.6922C81.1854 69.9128 81.2883 70.0951 81.2113 70.2217C81.2053 70.1579 81.195 70.1003 81.1874 70.0389C81.1847 70.1751 81.1825 70.3115 81.1798 70.4471C81.2253 70.4385 81.271 70.4288 81.3161 70.4208C81.345 70.6481 81.2953 70.7473 81.2954 70.9378C81.2955 70.9645 81.3263 70.9358 81.3283 70.963C81.3444 71.1821 81.3311 71.2535 81.4059 71.4106C81.2912 71.4278 81.385 71.7063 81.3478 71.9351C81.3372 71.9992 81.2802 72.0386 81.4063 72.0244C81.4037 72.4543 81.4333 72.7757 81.3579 73.1275C81.4762 72.9922 81.5078 73.4838 81.4906 73.7712C81.4857 73.8479 81.4013 73.9199 81.4262 74.0801C81.4614 74.0345 81.5017 73.9823 81.5381 73.9337C81.57 74.2598 81.449 74.1949 81.4783 74.4711C81.4913 74.5923 81.6174 74.5074 81.5731 74.7418C81.5476 74.876 81.3938 74.9617 81.5904 74.999C81.6113 75.1832 81.5413 75.0724 81.5417 75.202C81.5421 75.2834 81.6195 75.3695 81.6182 75.4949C81.6153 75.7334 81.4976 76.062 81.6404 76.0674C81.6607 76.2346 81.5938 76.1173 81.6107 76.2693C81.6334 76.473 81.7574 76.9754 81.6503 77.0673C81.6505 77.0675 81.6507 77.0678 81.6509 77.068C81.7258 77.2307 81.7354 77.7772 81.6288 77.65C81.6382 77.3597 81.5181 77.1442 81.537 77.4343C81.5561 77.7269 81.5481 77.8044 81.5098 77.8429C81.5386 77.9894 81.5777 78.0631 81.596 78.2689C81.609 78.4151 81.6007 78.6197 81.6128 78.7972C81.631 78.7961 81.6476 78.8036 81.6596 78.845C81.6904 78.9522 81.6575 79.3112 81.6652 79.4291C81.6653 79.4313 81.6656 79.4336 81.6657 79.4358C81.6852 79.4575 81.7136 79.4506 81.7332 79.5715C81.7387 79.6052 81.717 79.6885 81.7063 79.7898C81.7181 79.8755 81.7292 79.9576 81.7347 80.0388C81.7367 80.0694 81.7375 80.1027 81.7376 80.1375C81.7695 80.2945 81.8212 80.5598 81.8288 80.6757C81.8332 80.7442 81.8059 80.8818 81.8057 80.9081C81.8064 80.9997 81.8553 80.954 81.8643 81.033C81.8969 81.3173 81.9205 81.6306 81.9422 81.9425C81.9631 82.243 81.9994 82.539 82.052 82.7981C82.1536 83.2782 82.2275 83.5353 82.3958 84.0036C82.5562 84.4368 82.8028 84.7398 82.412 84.5236C82.5366 84.891 82.5486 84.7214 82.6308 84.7478C82.6799 84.7633 82.6931 84.8683 82.7088 84.884C82.7603 84.9343 82.7158 84.7788 82.7556 84.82C82.9001 84.9919 83.3403 85.854 83.4787 86.0175C84.0563 86.7981 84.6208 87.2996 85.3402 87.8156C85.802 88.1402 86.2618 88.4206 86.7771 88.6427C86.8985 88.785 87.0282 88.9245 87.1654 89.0607C87.0867 89.0258 87.0454 88.9991 86.9579 88.9657C86.8696 88.9331 86.6612 88.8338 86.6134 88.8547C86.6948 88.9347 86.9796 89.0561 87.0671 89.0859C87.2348 89.1449 87.1205 89.0645 87.2341 89.0941C87.3474 89.124 87.5549 89.2431 87.6944 89.2594C88.0173 89.2978 87.3797 89.0942 87.2703 89.0588C87.2884 88.9737 87.5891 89.1765 87.6807 89.128C87.6323 89.0937 87.4491 88.9855 87.3889 88.9811C87.3283 88.9775 87.4408 89.0691 87.2998 89.007C87.1981 88.9223 87.0888 88.829 86.994 88.7398C87.1234 88.7776 87.3311 88.8802 87.4512 88.916C88.4365 89.2163 89.4532 89.3364 90.4743 89.2633C90.8804 89.2347 91.2884 89.2062 91.6995 89.1771C91.8445 89.1668 92.1325 89.1468 92.2748 89.1505C92.3853 89.1536 92.3677 89.2155 92.469 89.1912C92.4791 89.1873 92.4249 89.1528 92.5623 89.1345C92.8227 89.0996 93.4025 89.0557 93.6957 89.0353C96.5687 88.834 99.3834 88.6223 102.299 88.5115C102.451 88.5058 103.024 88.4704 103.131 88.4848C103.449 88.5281 103.397 88.6145 103.568 88.4739C103.736 88.4566 103.622 88.5264 103.701 88.5388C103.733 88.5427 103.924 88.4412 104.009 88.4683C104.2 88.5309 103.884 88.5563 103.773 88.5974C104.056 88.6222 104.336 88.5333 104.575 88.5172C104.642 88.5126 104.656 88.5819 104.671 88.5833C104.954 88.5902 104.918 88.4547 104.901 88.3978C104.759 88.3992 104.619 88.4005 104.477 88.4024C104.752 88.3656 104.959 88.394 105.24 88.3953C105.307 88.3955 105.213 88.338 105.367 88.3528C105.418 88.3939 105.467 88.438 105.517 88.4802C105.873 88.4196 105.998 88.3857 105.547 88.3423C105.725 88.3324 105.904 88.3219 106.082 88.3124C106.021 88.3626 106.118 88.4302 106.291 88.3759C106.331 88.363 106.221 88.3202 106.272 88.3024C106.323 88.2848 106.709 88.2737 106.742 88.2755C107.039 88.2932 107.092 88.3899 107.343 88.3227C107.266 88.3299 106.926 88.2971 107.145 88.2565C107.39 88.2114 108.407 88.2081 108.705 88.2089C109.212 88.2105 109.458 88.2207 109.897 88.2667C109.98 88.2755 109.978 88.3383 110.14 88.3529C110.355 88.3722 110.745 88.3682 110.988 88.3942C110.94 88.4105 110.881 88.4262 110.829 88.4421C110.882 88.452 110.936 88.462 110.99 88.4719C110.984 88.482 110.984 88.4913 110.974 88.5021C110.673 88.5279 110.308 88.6122 110.039 88.6372C109.793 88.6598 109.625 88.6255 109.433 88.6384C109.242 88.6515 108.673 88.7619 108.731 88.6614C108.696 88.6601 108.647 88.6605 108.613 88.658C108.644 88.7564 108.354 88.7045 108.102 88.7394C107.983 88.7559 107.671 88.8672 107.906 88.706C107.864 88.7076 107.844 88.7037 107.807 88.7028C107.543 88.8488 107.362 88.8217 106.946 88.8124C106.713 88.8072 106.255 88.815 106.512 88.8899C106.327 88.9652 105.984 88.8972 105.827 88.9157C105.671 88.9344 105.92 88.9671 105.71 88.9911C105.673 88.9953 105.372 89.0192 105.278 89.0191C105.184 89.0188 105.265 88.9734 105.124 88.9901C104.51 89.0621 103.982 89.1887 103.336 89.2587C103.094 89.285 102.852 89.3103 102.612 89.3348C103.136 89.3553 103.527 89.4546 104.191 89.1609C104.628 89.1218 105.064 89.0827 105.5 89.0436C105.526 89.056 105.553 89.0685 105.579 89.081C105.608 89.0781 105.634 89.0753 105.658 89.0731C105.831 89.0562 106.036 89.0382 106.257 89.0201C106.703 88.9836 107.28 88.9407 107.942 88.8939C109.272 88.7999 111.002 88.6864 112.838 88.572C112.849 88.5713 112.861 88.5706 112.872 88.5698C112.883 88.5693 112.894 88.5687 112.905 88.5681C112.961 88.5653 113.023 88.5624 113.082 88.5602C113.115 88.5589 113.245 88.5537 113.383 88.5549C113.421 88.5552 113.677 88.5565 113.854 88.5927C113.881 88.5982 113.905 88.6045 113.926 88.6114C114.067 88.616 114.208 88.6206 114.349 88.6252C114.348 88.6452 114.347 88.6651 114.347 88.6851C114.461 88.6773 114.575 88.6697 114.688 88.662C114.702 88.6539 114.717 88.6458 114.731 88.6377C115.087 88.6059 115.443 88.574 115.798 88.5422C115.898 88.5507 115.997 88.5592 116.097 88.5677C116.427 88.5464 116.746 88.5261 117.049 88.5076C117.064 88.4833 117.078 88.459 117.093 88.4347C117.255 88.4484 117.417 88.4622 117.579 88.4759C117.893 88.4577 118.183 88.4419 118.441 88.4289C118.433 88.4203 118.425 88.4116 118.417 88.4029C118.735 88.3554 119.053 88.3078 119.371 88.2603C119.503 88.2731 119.635 88.286 119.767 88.2989C119.867 88.2753 119.966 88.2518 120.066 88.2283C120.499 88.1981 120.932 88.1679 121.365 88.1377C121.473 88.1688 121.581 88.1999 121.689 88.231C121.816 88.2179 121.943 88.2047 122.069 88.1916C121.967 88.1745 121.865 88.1574 121.763 88.1403C122.122 88.1116 122.481 88.083 122.84 88.0544C122.848 88.0184 122.855 87.9825 122.863 87.9465C122.758 87.9585 122.656 87.9697 122.565 87.9757C122.487 87.9806 122.505 87.9378 122.489 87.9378C122.177 87.9428 122.154 88.0258 122.146 88.0605C122.305 88.055 122.461 88.0495 122.62 88.0437C122.297 88.0756 122.079 88.0649 121.767 88.0733C121.693 88.0754 121.77 88.108 121.605 88.1038C121.567 88.08 121.533 88.0542 121.498 88.0297C121.073 88.079 120.918 88.1043 121.4 88.1163C121.197 88.1283 120.994 88.1407 120.79 88.1525C120.882 88.1193 120.806 88.0807 120.588 88.1199C120.537 88.1292 120.638 88.1522 120.573 88.165C120.508 88.1776 120.071 88.1974 120.038 88.1973C119.715 88.1961 119.702 88.1381 119.392 88.1879C119.481 88.181 119.842 88.19 119.579 88.2223C119.286 88.2584 118.152 88.2938 117.821 88.3031C117.257 88.3189 116.987 88.321 116.519 88.3069C116.43 88.3042 116.463 88.2649 116.29 88.2612C116.059 88.2563 115.622 88.2717 115.364 88.2636C115.384 88.2597 115.408 88.256 115.431 88.2521C115.678 88.2338 115.914 88.22 116.121 88.2141C116.872 88.0834 117.738 88.0405 118.013 88.0156C118.011 88.0179 118.009 88.0205 118.004 88.0234C118.042 88.023 118.096 88.0211 118.133 88.0216C118.138 87.9958 118.196 87.9857 118.284 87.9797C118.325 87.9786 118.375 87.9773 118.439 87.9758C118.436 87.9748 118.435 87.9736 118.433 87.9726C118.522 87.9693 118.624 87.9653 118.727 87.9556C118.805 87.9602 118.886 87.9625 118.958 87.964C118.953 87.9655 118.948 87.9671 118.943 87.9686C118.991 87.9663 119.011 87.9678 119.052 87.9672C119.053 87.9669 119.055 87.9665 119.056 87.9662C119.062 87.9664 119.069 87.9666 119.075 87.9667C119.093 87.9671 119.113 87.9674 119.133 87.9679C119.242 87.9703 119.371 87.9732 119.491 87.9741C119.62 87.9749 119.744 87.9695 119.928 87.9564C120.006 87.9509 120.1 87.9437 120.217 87.9341C120.044 87.9827 120.346 88.0334 120.852 87.9989C120.922 87.964 120.731 87.9939 120.73 87.9773C120.73 87.9605 120.921 87.9679 120.85 87.9414C120.536 87.9517 120.684 87.9779 120.446 87.9994C120.502 87.9778 120.439 87.9481 120.481 87.9303C120.546 87.9024 120.683 87.9095 120.71 87.8922C120.728 87.8906 120.746 87.8888 120.765 87.8872C120.906 87.8801 121.047 87.8728 121.187 87.8654C121.326 87.8394 121.86 87.8849 122.121 87.9005C122.105 87.9033 122.089 87.906 122.074 87.9087C122.113 87.9071 122.151 87.9055 122.189 87.9039C122.208 87.9047 122.223 87.9054 122.235 87.9055C122.301 87.9056 122.339 87.9142 122.366 87.9207C122.354 87.9247 122.348 87.9287 122.353 87.9325C122.544 87.9232 122.742 87.9132 122.941 87.9033C122.941 87.9079 122.935 87.9127 122.926 87.9177C123.208 87.8993 123.488 87.8798 123.767 87.8594C124.202 87.8274 124.634 87.7928 125.061 87.7554C125.345 87.7305 125.628 87.7054 125.911 87.68C126.043 87.6679 126.173 87.6528 126.303 87.6347C126.313 87.6199 126.335 87.5917 126.341 87.585C126.342 87.5832 126.342 87.5806 126.342 87.5781C126.341 87.5674 126.34 87.5536 126.434 87.5554C126.435 87.5557 126.454 87.5599 126.481 87.5655C126.481 87.5694 126.484 87.5733 126.489 87.5767C126.508 87.5884 126.56 87.6062 126.664 87.6115C126.745 87.6157 126.851 87.6086 126.958 87.5941C127.117 87.5727 127.247 87.5341 127.325 87.5069C127.404 87.4794 127.469 87.4507 127.517 87.4273C127.584 87.3947 127.655 87.3548 127.702 87.3278C127.718 87.3186 127.732 87.3105 127.741 87.3051C127.746 87.3025 127.75 87.3 127.754 87.2975C127.757 87.2959 127.76 87.2943 127.762 87.2927C128.1 87.1798 128.431 87.0443 128.749 86.8889C128.746 86.8889 128.745 86.8886 128.745 86.8882C128.748 86.8852 128.895 86.8048 128.903 86.8005C128.918 86.7936 128.937 86.7882 128.957 86.7836C128.988 86.7672 129.019 86.7506 129.05 86.7339C129.037 86.736 129.027 86.7365 129.024 86.734C129.02 86.7324 129.04 86.7204 129.059 86.7084C129.075 86.6992 129.09 86.6898 129.094 86.6857C129.102 86.6747 129.095 86.6719 129.089 86.6697C129.077 86.6652 129.071 86.663 129.196 86.5998C129.219 86.5885 129.433 86.4869 129.443 86.4816C129.446 86.4805 129.449 86.4793 129.452 86.4782C129.433 86.4722 129.414 86.4662 129.395 86.4601C129.383 86.4588 129.367 86.4603 129.345 86.4681C129.307 86.481 129.26 86.5078 129.214 86.5329C129.134 86.5772 129.058 86.6166 129.051 86.5739C129.161 86.5089 129.247 86.4702 129.331 86.4309C129.43 86.385 129.528 86.3379 129.655 86.2407C129.706 86.2297 129.658 86.2638 129.605 86.2998C129.563 86.3285 129.518 86.3585 129.521 86.3692C129.523 86.3769 129.554 86.3695 129.583 86.3624C129.645 86.3462 129.702 86.3349 129.452 86.4782C129.462 86.4749 129.468 86.4792 129.474 86.4836C129.475 86.4842 129.476 86.4848 129.477 86.4855C129.524 86.4564 129.57 86.4265 129.616 86.3965C129.637 86.3782 129.658 86.3608 129.681 86.3479C129.691 86.3418 129.702 86.3367 129.712 86.3326C129.804 86.2711 129.894 86.2074 129.983 86.1423C129.982 86.1381 129.985 86.1318 129.991 86.124C130.012 86.0944 130.249 85.9165 130.307 85.8774C130.308 85.8775 130.309 85.8776 130.309 85.8777C130.309 85.8777 130.311 85.8819 130.32 85.8805C130.353 85.8541 130.385 85.8274 130.417 85.8004C130.417 85.8004 130.416 85.8005 130.416 85.8006C130.412 85.7982 130.407 85.7954 130.42 85.7836C130.466 85.741 130.511 85.7077 130.552 85.6836C130.586 85.6529 130.621 85.6213 130.656 85.5901C130.596 85.6207 130.497 85.6917 130.408 85.7519C130.314 85.8157 130.232 85.8677 130.228 85.8562C130.227 85.8549 130.234 85.8485 130.243 85.8402C130.274 85.8105 130.329 85.7572 130.191 85.8127C130.472 85.5813 130.408 85.6674 130.382 85.7054C130.376 85.7138 130.373 85.7193 130.375 85.7176C130.467 85.6474 130.522 85.5887 130.578 85.528C130.607 85.4957 130.637 85.4623 130.673 85.426C130.691 85.4065 130.717 85.3844 130.744 85.3613C130.774 85.3349 130.806 85.3068 130.831 85.2782C130.851 85.255 130.899 85.1862 130.943 85.119C130.991 85.0465 131.036 84.975 131.047 84.9659C131.083 84.9693 131.162 84.9106 131.238 84.8515C131.271 84.8257 131.303 84.8002 131.332 84.78C131.356 84.7637 131.388 84.7468 131.415 84.7325C131.425 84.7269 131.436 84.7212 131.446 84.7155C131.454 84.7109 131.46 84.7067 131.463 84.704C131.461 84.7043 131.46 84.7045 131.458 84.7048C131.497 84.6685 131.585 84.5547 131.599 84.5197C131.613 84.4847 131.598 84.4795 131.577 84.4817C131.563 84.4842 131.549 84.4866 131.535 84.489C131.517 84.4905 131.51 84.4841 131.536 84.4487C131.655 84.2828 131.801 84.1881 131.79 84.2561C131.786 84.2719 131.76 84.307 131.732 84.3431C131.699 84.3855 131.663 84.4303 131.66 84.4516C131.69 84.42 131.727 84.3805 131.764 84.3419C131.913 84.1343 132.052 83.9202 132.18 83.7006C132.132 83.723 132.143 83.6714 132.289 83.4458C132.299 83.4514 132.307 83.4563 132.315 83.4595C132.41 83.2835 132.499 83.1033 132.579 82.9216C132.54 82.9868 132.492 83.0585 132.489 82.9968C132.485 82.9427 132.577 82.7558 132.642 82.604C132.672 82.5347 132.697 82.4729 132.71 82.4363C132.723 82.396 132.729 82.3658 132.735 82.3352C132.738 82.3218 132.741 82.3078 132.744 82.2931C132.782 82.1944 132.821 82.0863 132.859 81.9722C132.876 81.9428 132.887 81.9347 132.897 81.9279C132.914 81.9169 132.928 81.9075 132.955 81.8102C132.919 81.8613 132.911 81.8385 132.918 81.7847C132.946 81.6947 132.972 81.6017 132.996 81.5089C133.005 81.4862 133.015 81.4652 133.024 81.4486C133.039 81.4227 133.051 81.413 133.062 81.4039C133.069 81.3981 133.076 81.3924 133.082 81.3835C133.09 81.3478 133.097 81.312 133.104 81.2762C133.088 81.2863 133.067 81.2937 133.05 81.2902C133.06 81.2491 133.07 81.2079 133.078 81.1673C133.094 81.1486 133.113 81.0868 133.13 81.03C133.14 80.995 133.149 80.9614 133.156 80.9429C133.16 80.9343 133.164 80.929 133.167 80.9251C133.179 80.8476 133.19 80.7706 133.2 80.6932C133.232 80.6454 133.27 80.512 133.283 80.3756C133.294 80.2724 133.307 80.1304 133.315 79.9834C133.325 79.9753 133.339 79.948 133.357 79.8382C133.345 79.7991 133.334 79.7573 133.326 79.713C133.33 79.5149 133.326 79.3393 133.323 79.2639C133.321 79.1879 133.314 79.1164 133.308 79.0613C133.301 79.003 133.292 78.9429 133.283 78.8869C133.281 78.8736 133.279 78.8605 133.277 78.8476C133.272 78.8168 133.267 78.787 133.263 78.7583C133.263 78.7578 133.263 78.7573 133.263 78.7568C133.251 78.6812 133.24 78.6108 133.229 78.5391C133.203 78.1079 133.188 77.6693 133.161 77.2203C133.15 77.0263 133.115 76.7699 133.106 76.5463C133.095 76.2674 133.143 76.3188 133.137 76.1472C133.132 75.9753 133.092 76.1431 133.071 75.9624C133.061 75.8798 133.019 75.298 133.03 75.1653C133.032 75.1349 133.056 75.2369 133.069 75.2075C133.077 75.1913 133.138 75.1689 133.123 75.0298C133.059 74.9272 133.003 74.9409 132.968 74.5007C132.913 73.8049 132.892 73.1341 132.844 72.3894C132.833 72.223 132.765 71.8461 132.8 71.6461C132.81 71.5878 132.865 71.5929 132.844 71.3293C132.825 71.1027 132.799 71.0775 132.767 70.887C132.754 70.8146 132.778 70.7824 132.753 70.6461C132.728 70.5091 132.68 70.3183 132.739 70.1985C132.718 70.1882 132.7 70.1922 132.68 70.1869C132.659 69.936 132.701 69.4743 132.646 69.5758C132.628 69.3163 132.609 69.0564 132.591 68.7969C132.609 68.7422 132.627 68.6882 132.646 68.6335C132.677 68.7791 132.666 69.0318 132.709 69.0427C132.697 68.8178 132.684 68.5898 132.672 68.3669C132.567 68.4724 132.464 67.7985 132.588 67.9045C132.612 67.9234 132.562 67.4736 132.547 67.3777C132.533 67.2825 132.488 67.2752 132.501 67.0603C132.509 66.9381 132.53 66.8557 132.48 66.5919C132.48 66.7649 132.478 66.9499 132.476 67.1268C132.463 66.8719 132.425 66.5505 132.433 66.3161C132.435 66.2582 132.466 66.4693 132.468 66.3623C132.47 66.2551 132.435 65.8367 132.399 65.9429C132.468 65.7132 132.402 65.77 132.371 65.3609C132.367 65.3094 132.417 64.8613 132.361 64.6902C132.342 64.63 132.294 64.7782 132.296 64.4427C132.297 64.1959 132.362 64.4216 132.37 64.1445C132.315 64.2953 132.249 63.8967 132.231 63.6546C132.198 63.2254 132.242 63.2722 132.25 63.1271C132.264 62.8651 132.196 62.6724 132.235 62.5126C132.241 62.5853 132.25 62.6501 132.257 62.7197C132.253 62.562 132.248 62.4048 132.243 62.2478C132.217 62.2659 132.191 62.2843 132.165 62.3016C132.138 62.0443 132.163 61.9213 132.154 61.7012C132.153 61.6709 132.136 61.7093 132.134 61.6783C132.115 61.4283 132.119 61.3443 132.069 61.1763C132.134 61.136 132.067 60.8303 132.079 60.5596C132.082 60.4838 132.113 60.4288 132.041 60.4675C132.023 59.9708 131.991 59.6054 132.019 59.1859C131.956 59.3629 131.916 58.8021 131.913 58.4674C131.912 58.3778 131.958 58.2791 131.936 58.0983C131.918 58.1571 131.897 58.2242 131.878 58.2868C131.845 57.9164 131.918 57.9698 131.888 57.6564C131.875 57.5189 131.806 57.6392 131.821 57.3614C131.83 57.2019 131.915 57.0757 131.799 57.0675C131.779 56.8584 131.824 56.9736 131.818 56.824C131.814 56.7302 131.766 56.6446 131.761 56.4997C131.752 56.2239 131.805 55.8229 131.722 55.8421C131.703 55.6533 131.747 55.7774 131.73 55.6053C131.708 55.3744 131.613 54.8165 131.671 54.6914C131.671 54.6912 131.671 54.6909 131.671 54.6907C131.62 54.5165 131.59 53.8865 131.657 54.0142C131.665 54.3512 131.744 54.5785 131.72 54.2468C131.68 53.7032 131.708 53.8023 131.777 53.6702C131.787 53.6508 131.783 53.4961 131.799 53.5269C131.815 53.5575 131.851 53.8877 131.87 53.7C131.874 53.6637 131.839 53.4949 131.869 53.4577C131.86 53.424 131.851 53.4078 131.842 53.3809C131.892 53.0737 131.914 53.0428 131.958 53.6011C131.942 53.5874 131.926 53.5739 131.91 53.5595C131.933 53.6377 131.956 53.7046 131.98 53.7908C132.017 54.4028 132.128 55.2221 132.143 55.7752C132.156 56.2587 132.104 55.5966 132.1 55.5852C132.063 55.4654 132.064 55.6879 132.045 55.6935C132.026 55.6983 131.979 55.4282 132.004 55.6719C132.007 55.7043 132.087 56.0233 132.096 56.034C132.141 56.085 132.154 56.0152 132.171 56.0846C132.101 54.5358 132.049 53.278 131.995 52.0608C131.981 51.7405 131.966 51.4202 131.952 51.0999C131.898 49.9494 131.872 49.0718 131.852 48.3491C131.828 48.1218 131.803 47.8945 131.779 47.6671C131.783 47.5914 131.787 47.5156 131.792 47.4398C131.768 47.0426 131.745 46.6453 131.721 46.248C131.733 46.2299 131.745 46.2118 131.757 46.1938C131.595 45.5363 131.853 45.3268 131.604 44.7653C131.583 44.5234 131.561 44.2816 131.54 44.0398C131.566 43.9841 131.593 43.9283 131.619 43.8726C131.61 43.8508 131.6 43.829 131.591 43.8071C131.589 43.6774 131.588 43.5476 131.586 43.4178C131.586 43.3393 131.584 43.2609 131.581 43.1828C131.546 43.0366 131.506 42.8909 131.463 42.7476C131.558 42.6223 131.163 41.5097 131.287 41.7132C131.241 41.5509 131.19 41.3921 131.134 41.233C131.158 41.2671 131.182 41.3014 131.205 41.336C131.205 41.3084 131.205 41.2808 131.205 41.2532C131.151 41.1392 131.095 41.0276 131.036 40.9169C131.096 40.6984 130.914 40.5445 130.869 40.4701C130.798 40.3466 130.678 40.1145 130.667 40.1011C130.651 40.081 130.728 40.3091 130.618 40.1405C130.589 40.0362 130.558 39.9325 130.524 39.8288C130.507 39.8241 130.491 39.8195 130.474 39.815C130.444 39.7481 130.413 39.6816 130.382 39.6155C130.394 39.6095 130.407 39.6035 130.42 39.5975C130.402 39.5581 130.383 39.5189 130.365 39.4797C130.341 39.4653 130.317 39.4511 130.294 39.437C130.189 39.2836 130.079 39.134 129.964 38.9883C129.9 38.8652 129.832 38.743 129.761 38.6223C129.713 38.5675 129.665 38.5135 129.616 38.4601C129.587 38.4642 129.558 38.4685 129.53 38.4729C129.425 38.3071 129.314 38.1441 129.196 37.9845C129.116 37.9124 129.034 37.8419 128.951 37.7732C128.961 37.7995 128.971 37.8258 128.98 37.8521C129.014 37.873 129.047 37.8942 129.08 37.9157C129.079 37.9287 129.077 37.9417 129.075 37.9547C128.945 37.8497 128.811 37.749 128.675 37.6526C128.632 37.5997 128.587 37.5473 128.542 37.4953C128.496 37.4695 128.449 37.4442 128.402 37.4193C128.224 37.2819 128.041 37.1517 127.853 37.0291C127.819 36.9813 127.784 36.9338 127.749 36.8864C127.691 36.8533 127.633 36.8209 127.575 36.7892C127.613 36.8275 127.651 36.8661 127.688 36.905C127.528 36.8085 127.365 36.7176 127.199 36.6322C127.18 36.6525 127.161 36.6728 127.143 36.6932C127.073 36.65 127.002 36.608 126.931 36.5669C126.933 36.5516 126.936 36.5363 126.938 36.5211C126.646 36.3466 126.343 36.1897 126.028 36.0514C126.006 36.0736 125.984 36.0958 125.962 36.1181C125.54 35.9251 125.065 35.8467 124.661 35.7684C124.491 35.7341 124.274 35.6311 124.298 35.7111C123.964 35.6614 123.628 35.6323 123.29 35.6237C123.191 35.6378 123.096 35.6536 122.999 35.6711C122.924 35.6625 122.849 35.6549 122.774 35.6484C122.696 35.6423 122.619 35.6363 122.542 35.6302C122.312 35.7014 121.11 35.8108 121.139 35.7249C120.872 35.7608 120.892 35.7418 120.569 35.7903C120.491 35.7786 120.412 35.7669 120.334 35.7552C120.197 35.7604 120.06 35.7655 119.923 35.7707C119.743 35.7964 119.562 35.8221 119.381 35.8478C119.258 35.829 119.135 35.8102 119.011 35.7915C119.006 35.8123 119.001 35.8332 118.997 35.854C118.89 35.8672 118.783 35.8803 118.677 35.8935C118.392 36.0132 118.724 35.6983 117.818 35.8742C117.957 35.8675 118.095 35.8608 118.233 35.8542C118.287 35.8762 118.342 35.8983 118.397 35.9204C118.205 35.9423 118.013 35.9641 117.821 35.986C117.685 35.986 117.549 35.9859 117.413 35.9859C117.3 36.0001 117.187 36.0144 117.074 36.0287C116.772 36.0305 116.47 36.0324 116.168 36.0343C115.885 36.0577 115.601 36.0811 115.317 36.1046C115.265 36.0916 115.213 36.0787 115.162 36.0657C115.038 36.0926 114.914 36.1195 114.79 36.1464C114.74 36.1462 114.69 36.146 114.64 36.1458C114.625 36.1327 114.609 36.1196 114.594 36.1064C114.368 36.1281 114.142 36.1498 113.916 36.1715C113.757 36.1684 113.598 36.1654 113.439 36.1624C113.446 36.1744 113.453 36.1865 113.46 36.1985C112.731 36.2409 112.003 36.2834 111.274 36.3258C111.272 36.3257 111.271 36.3257 111.269 36.3256C111.19 36.291 110.813 36.4017 110.852 36.276C110.83 36.2894 110.808 36.3029 110.786 36.3163C110.707 36.3138 110.628 36.3113 110.549 36.3088C110.553 36.2943 110.557 36.2798 110.561 36.2653C110.502 36.2683 110.443 36.2713 110.383 36.2742C110.379 36.2924 110.375 36.3105 110.37 36.3286C110.438 36.3364 110.505 36.3441 110.573 36.3518C110.405 36.3557 110.238 36.3596 110.071 36.3635C110.093 36.3501 110.115 36.3367 110.138 36.3233C109.921 36.3029 109.286 36.485 109.756 36.1744C109.873 36.1791 109.99 36.1838 110.106 36.1886C110.04 36.1672 109.975 36.1458 109.909 36.1245C109.925 36.1028 109.941 36.0812 109.956 36.0596C110.062 36.0668 110.169 36.0739 110.275 36.0811C110.328 36.064 110.381 36.047 110.434 36.0299C110.396 36.0236 110.358 36.0174 110.32 36.0111C110.382 35.9955 110.445 35.9799 110.508 35.9643C110.719 35.9478 110.929 35.9313 111.14 35.9148C111.177 35.9215 111.214 35.9281 111.251 35.9347C111.615 35.9169 111.98 35.8992 112.345 35.8814C112.302 35.8999 112.259 35.9184 112.216 35.9369C112.312 35.9316 112.408 35.9263 112.505 35.921C112.535 35.9047 112.565 35.8884 112.595 35.8721C112.691 35.8623 112.787 35.8525 112.882 35.8427C112.865 35.872 112.848 35.9013 112.831 35.9306C112.739 35.9561 112.648 35.9817 112.556 36.0072C112.633 36.0116 112.71 36.016 112.787 36.0205C112.8 35.9989 112.813 35.9773 112.825 35.9557C112.936 35.9506 113.046 35.9456 113.156 35.9406C113.102 35.9286 113.048 35.9166 112.995 35.9047C113.02 35.886 113.046 35.8673 113.072 35.8486C113.227 35.8318 113.382 35.8149 113.537 35.7981C113.554 35.8096 113.572 35.8212 113.589 35.8328C113.702 35.8111 113.816 35.7894 113.929 35.7677C113.986 35.7728 114.043 35.7779 114.099 35.7831C114.124 35.7736 114.149 35.7642 114.173 35.7548C114.304 35.7483 114.435 35.7419 114.566 35.7354C114.647 35.7443 114.728 35.7532 114.809 35.7621C114.891 35.7449 114.972 35.7277 115.053 35.7106C115.545 35.6941 116.036 35.6777 116.527 35.6612C116.856 35.5677 117.633 35.6326 117.584 35.5636C118.002 35.5409 118.42 35.5182 118.838 35.4956C118.922 35.502 119.006 35.5085 119.09 35.515C119.507 35.4826 119.925 35.4502 120.343 35.4178C120.866 35.4084 121.388 35.399 121.911 35.3896C121.856 35.3675 121.802 35.3454 121.748 35.3233C121.912 35.315 122.076 35.3067 122.24 35.2984C122.34 35.3105 122.44 35.3225 122.539 35.3345C122.61 35.3183 122.681 35.3021 122.752 35.2859C122.773 35.281 122.794 35.2763 122.814 35.2716C122.943 35.393 123.258 35.2276 123.672 35.2888C123.898 35.1876 124.206 35.4015 124.478 35.3244C124.464 35.3346 124.449 35.3449 124.435 35.3553C124.52 35.3677 124.606 35.3816 124.691 35.3966C124.869 35.4115 125.048 35.4322 125.225 35.4585C125.227 35.4759 125.229 35.4933 125.23 35.5108C125.304 35.5309 125.377 35.5521 125.45 35.5742C125.406 35.5771 125.362 35.5802 125.319 35.5838C125.382 35.6039 125.445 35.6248 125.508 35.6464C125.742 35.6916 125.974 35.7471 126.205 35.8123C126.258 35.8455 126.311 35.8793 126.364 35.9135C126.399 35.9138 126.434 35.9143 126.469 35.9151C126.596 35.9769 126.722 36.042 126.845 36.1097C126.841 36.0941 126.837 36.0784 126.833 36.0628C126.775 36.0358 126.717 36.0095 126.659 35.9838C126.667 35.9739 126.675 35.9639 126.683 35.954C126.878 36.0402 127.07 36.1338 127.257 36.2341C127.246 36.2187 127.234 36.2034 127.223 36.1881C127.383 36.2724 127.541 36.362 127.696 36.4561C127.693 36.4535 127.69 36.4503 127.687 36.4476C127.636 36.3952 127.725 36.3498 127.392 36.1706C127.104 36.0218 127.036 36.0295 126.767 35.9363C126.664 35.9023 126.656 35.8572 126.459 35.8008C126.259 35.743 125.963 35.6941 125.883 35.5686C125.844 35.5869 125.829 35.6091 125.798 35.6287C125.462 35.5228 124.905 35.2966 124.976 35.4036C124.619 35.3307 124.255 35.2802 123.891 35.2531C123.835 35.2171 123.778 35.1816 123.72 35.1466C123.947 35.1269 124.278 35.2048 124.335 35.1531C124.019 35.1084 123.696 35.0808 123.38 35.0709C123.416 35.1789 122.962 35.2483 122.749 35.2444C122.65 35.241 122.602 35.2155 122.677 35.1589C122.721 35.125 122.061 35.1877 121.918 35.2063C121.776 35.2249 121.732 35.2917 121.445 35.2665C121.282 35.2523 121.184 35.2192 120.782 35.2855C121.021 35.2904 121.274 35.2983 121.517 35.3048C121.156 35.3172 120.684 35.3652 120.365 35.3486C120.286 35.3444 120.602 35.3035 120.456 35.2979C120.31 35.2923 119.706 35.333 119.825 35.3887C119.56 35.2815 119.587 35.3808 118.998 35.4163C118.923 35.4206 118.342 35.3367 118.064 35.414C117.966 35.4415 118.136 35.5144 117.673 35.5043C117.333 35.4968 117.694 35.4069 117.317 35.3879C117.484 35.4723 116.883 35.5593 116.534 35.5806C115.917 35.6185 116.016 35.5542 115.821 35.539C115.47 35.5117 115.153 35.6068 114.961 35.5459C115.066 35.5383 115.161 35.5272 115.263 35.5184C115.042 35.5213 114.82 35.5247 114.6 35.5276C114.605 35.5661 114.612 35.6047 114.617 35.6429C114.241 35.6763 114.089 35.6377 113.779 35.6451C113.735 35.6461 113.776 35.6713 113.731 35.6741C113.371 35.6962 113.258 35.6877 112.988 35.7576C112.982 35.6602 112.508 35.7512 112.143 35.7279C112.041 35.7213 111.989 35.6743 111.987 35.7814C111.287 35.7957 110.759 35.8332 110.2 35.7821C110.398 35.8781 109.591 35.924 109.126 35.9203C109.002 35.9193 108.901 35.8495 108.635 35.8769C108.703 35.9053 108.779 35.9378 108.851 35.9671C108.314 36.0067 108.443 35.901 107.988 35.9365C107.788 35.9523 107.902 36.0569 107.529 36.028C107.315 36.0114 107.205 35.883 107.106 36.0526C106.802 36.0775 106.997 36.0133 106.785 36.0187C106.652 36.0222 106.497 36.0916 106.293 36.0953C105.905 36.102 105.392 36.0139 105.356 36.1362C105.08 36.1598 105.285 36.0983 105.034 36.1185C104.699 36.1456 103.855 36.271 103.726 36.1828C103.726 36.183 103.726 36.1832 103.726 36.1834C103.447 36.2537 102.553 36.2827 102.781 36.1867C103.252 36.1836 103.626 36.0727 103.15 36.1C102.369 36.1447 102.527 36.1069 102.397 36.0022C102.378 35.9871 102.159 35.9891 102.214 35.9659C102.269 35.9427 102.753 35.8987 102.509 35.8651C102.462 35.8588 102.2 35.906 102.171 35.8609C102.118 35.8743 102.09 35.8863 102.045 35.8992C101.659 35.8179 101.633 35.7849 102.438 35.7342C102.407 35.7575 102.375 35.7809 102.343 35.8042C102.469 35.7711 102.579 35.7396 102.716 35.7057C103.59 35.6669 104.806 35.5239 105.581 35.5156C106.258 35.5083 105.311 35.5684 105.288 35.5735C105.093 35.6256 105.402 35.6293 105.395 35.6578C105.387 35.6862 104.977 35.7485 105.333 35.7176C105.38 35.7133 105.88 35.6045 105.903 35.5916C106.068 35.4887 105.755 35.4966 106.498 35.4299C106.763 35.4061 107.53 35.3537 107.821 35.3325C108.141 35.3093 108.403 35.342 108.594 35.3256C108.784 35.309 108.603 35.289 108.828 35.2707C109.274 35.2347 109.919 35.2277 110.33 35.2024C110.796 35.1737 110.928 35.1187 111.379 35.0913C111.691 35.0723 112.114 35.083 112.465 35.0473C112.549 35.0677 112.396 35.1728 112.63 35.1527C112.915 35.128 112.514 35.0935 112.655 35.0565C112.943 35.0245 112.74 35.0796 112.75 35.0804C112.893 35.0905 113.134 35.0635 113.309 35.0627C113.192 35.05 113.078 35.039 112.954 35.0265C113.434 35.03 113.186 34.9767 113.568 34.9401C113.668 34.9307 113.899 34.9892 114.245 34.9488C114.327 34.9392 115.139 34.8437 115.402 34.8309C115.515 34.8254 115.7 34.8475 115.74 34.8468C115.883 34.8442 115.866 34.8011 115.999 34.7913C116.986 34.7187 118.122 34.6777 119.064 34.6194C119.96 34.5639 120.448 34.5326 121.361 34.477C122.208 34.4255 122.977 34.3084 122.073 34.5841C122.722 34.5761 122.541 34.5229 122.702 34.4601C122.704 34.4594 122.705 34.4588 122.707 34.4582C122.816 34.4198 122.974 34.4433 123.022 34.4367C123.182 34.4134 122.902 34.3951 123.027 34.3775C123.538 34.2573 125.375 34.5579 125.762 34.7148C127.6 35.2452 128.929 36.0678 130.156 37.3315C130.928 38.1493 131.498 39.04 131.948 40.0575C131.981 40.3059 132.005 40.5576 132.019 40.8061C131.972 40.6587 131.953 40.581 131.887 40.4157C131.824 40.25 131.655 39.8569 131.576 39.7753C131.621 39.9302 131.841 40.4527 131.898 40.6166C132.014 40.9288 131.972 40.7191 132.054 40.9349C132.136 41.1519 132.2 41.53 132.278 41.7994C132.46 42.438 132.217 41.2218 132.119 41.0109C132.217 41.0611 132.288 41.6184 132.388 41.8178C132.388 41.7321 132.344 41.3851 132.293 41.2614C132.244 41.1394 132.261 41.3471 132.192 41.0768C132.175 40.8878 132.147 40.678 132.118 40.4892C132.231 40.7481 132.339 41.1613 132.404 41.403C132.58 42.043 132.686 42.6965 132.723 43.3493C132.834 45.305 132.93 47.2322 133.032 49.2082C133.044 49.4466 133.068 49.9182 133.068 50.1363C133.067 50.3058 133.011 50.2089 133.035 50.3943C133.039 50.4161 133.069 50.3663 133.088 50.604C133.125 51.0502 133.177 52.0064 133.202 52.4879C133.41 56.5582 133.625 60.5694 133.784 64.6007C133.791 64.5582 133.798 64.5158 133.804 64.4733C133.833 64.5867 133.861 64.7 133.889 64.8133C133.919 65.1931 133.949 65.5729 133.978 65.9526C133.966 66.0193 133.954 66.086 133.942 66.1526C133.975 66.8104 134.007 67.4682 134.039 68.1259C134.005 68.0486 133.972 67.9714 133.939 67.8941C133.948 68.0677 133.958 68.2413 133.968 68.4149C133.997 68.4695 134.026 68.5241 134.055 68.5787C134.073 68.7508 134.091 68.9229 134.108 69.095C134.056 69.0642 134.003 69.0334 133.95 69.0026C133.92 68.8957 133.891 68.7887 133.861 68.6818C133.861 68.6842 133.86 68.6865 133.86 68.6894C133.856 68.7328 133.953 69.1494 133.93 69.2508C133.926 69.2674 133.922 69.2793 133.919 69.2884C133.923 69.3886 133.928 69.4887 133.932 69.5889C133.954 69.4922 133.975 69.3955 133.997 69.2988C134.031 69.3451 134.064 69.3914 134.098 69.4377C134.128 69.7178 134.158 69.9979 134.189 70.2779C134.168 70.3086 134.147 70.3393 134.127 70.37C134.166 70.5746 134.205 70.7791 134.244 70.9836C134.235 71.0864 134.225 71.1891 134.216 71.2919C134.233 71.3359 134.25 71.3799 134.267 71.424C134.279 71.6601 134.29 71.8963 134.302 72.1324C134.286 72.2788 134.27 72.4253 134.254 72.5717C134.285 72.7184 134.316 72.865 134.347 73.0116C134.377 73.8981 134.406 74.7845 134.436 75.671C134.604 76.2637 134.488 77.6653 134.612 77.5753C134.633 77.9713 134.655 78.3672 134.676 78.7632C134.697 79.1403 134.695 79.5156 134.67 79.8915C134.64 80.0475 134.606 80.2011 134.568 80.3546C134.494 81.1362 134.319 81.91 134.047 82.6502C133.656 83.5536 133.122 84.3874 132.476 85.1127C132.573 85.066 132.669 85.0173 132.766 84.9665C132.575 85.2102 132.372 85.4444 132.159 85.6678C132.007 85.7815 131.853 85.8898 131.697 85.9928C131.59 86.1326 131.478 86.2698 131.361 86.4043C131.036 86.3762 130.727 86.9835 129.99 87.3186C129.721 87.7028 129.021 87.677 128.625 88.026C128.635 88.025 128.645 88.0241 128.655 88.0232C128.645 88.0401 128.642 88.0551 128.63 88.0723C128.55 88.0903 128.461 88.1139 128.376 88.1331C128.424 88.0634 128.501 88.0396 128.617 88.0271C128.631 88.0014 128.645 87.9758 128.659 87.9501C128.503 88.0071 128.344 88.0602 128.185 88.1086C127.866 88.2362 127.537 88.3464 127.204 88.438C127.187 88.4108 127.17 88.3836 127.154 88.3563C127.059 88.3709 126.964 88.3842 126.869 88.3959C126.876 88.4053 126.874 88.416 126.856 88.4267C126.406 88.5112 126.336 88.4129 126.695 88.3664C126.734 88.3609 126.776 88.3629 126.809 88.3695C126.854 88.3475 126.898 88.3251 126.943 88.3023C126.816 88.3157 126.69 88.3262 126.563 88.3343C126.361 88.374 126.161 88.4066 125.956 88.4329C125.752 88.4596 125.547 88.4863 125.343 88.513C125.362 88.5313 125.377 88.5503 125.366 88.57C125.206 88.6001 124.717 88.6347 124.315 88.6599C124.315 88.6608 124.314 88.6617 124.314 88.6625C124.242 88.6661 124.171 88.6696 124.099 88.6731C123.916 88.684 123.777 88.6919 123.74 88.6945C123.667 88.6995 123.611 88.7004 123.569 88.6992C123.439 88.7056 123.309 88.712 123.179 88.7185C123.168 88.7203 123.156 88.722 123.143 88.7235C123.174 88.7356 123.204 88.7477 123.235 88.7597C122.901 88.7763 122.567 88.7928 122.233 88.8093C122.092 88.8421 122.063 88.887 122.286 88.8734C122.864 88.838 122.748 88.8796 122.848 89.0078C122.863 89.0262 123.024 89.0289 122.984 89.0553C122.944 89.0818 122.586 89.1231 122.769 89.1689C122.804 89.1775 122.996 89.1271 123.019 89.1816C123.058 89.1669 123.078 89.1533 123.11 89.139C123.399 89.2452 123.42 89.285 122.824 89.327C122.847 89.2999 122.869 89.2726 122.892 89.2456C122.799 89.2821 122.72 89.3172 122.619 89.3545C121.973 89.3807 121.075 89.5236 120.501 89.5155C119.999 89.5085 120.702 89.4584 120.717 89.453C120.859 89.3953 120.632 89.3838 120.635 89.3501C120.639 89.3163 120.942 89.2512 120.679 89.2797C120.645 89.2836 120.275 89.403 120.26 89.4174C120.141 89.5363 120.372 89.5342 119.824 89.5967C119.628 89.619 119.061 89.6637 118.846 89.6823C118.609 89.7026 118.414 89.6574 118.273 89.6727C118.132 89.688 118.267 89.7161 118.101 89.7327C117.772 89.7655 117.294 89.759 116.99 89.7796C116.645 89.8032 116.549 89.8659 116.216 89.8882C115.985 89.9037 115.672 89.881 115.412 89.9155C115.349 89.8893 115.46 89.7672 115.287 89.7859C115.076 89.8088 115.374 89.8592 115.271 89.9C115.06 89.9315 115.204 89.8715 115.2 89.8694C115.094 89.854 114.916 89.8807 114.786 89.8777C114.872 89.8955 114.957 89.9114 115.05 89.9291C114.694 89.9138 114.879 89.9831 114.598 90.018C114.524 90.027 114.351 89.9518 114.095 89.9921C114.034 90.0018 113.435 90.0968 113.241 90.1061C113.157 90.1099 113.019 90.0793 112.99 90.0792C112.884 90.079 112.898 90.1308 112.8 90.1394C112.07 90.2033 111.229 90.2262 110.532 90.274C109.87 90.3196 109.509 90.3456 108.834 90.3908C108.208 90.4327 107.641 90.5548 108.303 90.2464C107.818 90.2409 107.961 90.3101 107.837 90.3823C107.764 90.4248 107.653 90.397 107.62 90.4059C107.511 90.4363 107.705 90.4539 107.62 90.4766ZM131.794 52.3138C131.865 52.5254 131.873 52.3166 131.849 52.7824C131.761 52.3416 131.766 52.982 131.713 52.9884C131.683 52.9912 131.687 52.7722 131.668 52.708C131.637 52.6094 131.608 52.7596 131.585 52.6413C131.562 52.5233 131.565 52.1028 131.555 51.968C131.536 51.7101 131.503 51.4911 131.487 51.2759C131.472 51.0606 131.475 50.7198 131.469 50.5801C131.463 50.4409 131.448 50.3074 131.443 50.2849C131.416 50.1545 131.379 50.2499 131.366 50.0615C131.406 50.0349 131.454 49.7515 131.497 50.0189C131.495 49.9786 131.5 49.9263 131.496 49.8883C131.479 49.7092 131.429 49.8289 131.414 49.7475C131.388 49.6101 131.438 49.6921 131.441 49.69C131.465 49.5367 131.43 49.6213 131.409 49.5658C131.398 49.5359 131.36 49.2703 131.357 49.2118C131.354 49.1542 131.381 49.2189 131.38 49.1802C131.374 49.0128 131.368 48.8403 131.352 48.6767C131.336 48.5134 131.291 48.4341 131.347 48.4165C131.356 48.4141 131.37 48.5046 131.389 48.4676C131.389 48.4676 131.389 48.4676 131.389 48.4676C131.395 48.4553 131.417 48.3092 131.449 48.4889C131.458 48.5397 131.465 48.5956 131.469 48.6538C131.46 48.6352 131.451 48.6174 131.443 48.5988C131.445 48.644 131.448 48.6892 131.45 48.7343C131.429 48.7159 131.407 48.6962 131.386 48.6852C131.37 48.7512 131.401 48.805 131.402 48.8157C131.404 48.9735 131.363 48.9729 131.417 49.0624C131.418 48.9551 131.419 48.8488 131.42 48.7444C131.43 48.7432 131.441 48.7418 131.451 48.7403C131.452 48.7608 131.453 48.7814 131.454 48.802C131.461 48.7879 131.469 48.7732 131.476 48.7591C131.483 48.9071 131.48 49.0652 131.475 49.2047C131.461 49.1624 131.444 49.1151 131.429 49.0738C131.451 49.2503 131.42 49.1556 131.415 49.2861C131.464 49.3031 131.458 49.3771 131.462 49.4841C131.466 49.5909 131.492 49.4415 131.503 49.5473C131.526 49.7631 131.495 50.1544 131.568 50.1875C131.544 50.4811 131.515 50.141 131.497 50.1276C131.419 50.0712 131.488 50.6371 131.534 50.7113C131.516 50.7991 131.484 50.8107 131.507 51.0233C131.538 51.3118 131.535 50.6664 131.568 51.0611C131.59 51.3252 131.554 51.2992 131.554 51.4335C131.556 51.6831 131.602 52.1117 131.641 51.9425C131.656 51.8744 131.618 51.6965 131.634 51.6182C131.642 51.575 131.748 51.6318 131.656 51.4304C131.646 51.4109 131.618 51.544 131.605 51.3602C131.601 51.3073 131.622 51.1205 131.602 50.9737C131.594 50.9093 131.53 50.6479 131.535 50.4764C131.541 50.2913 131.568 50.562 131.58 50.4896C131.591 50.4161 131.574 50.1928 131.608 50.1896C131.653 50.2972 131.596 50.3317 131.601 50.3705C131.622 50.5197 131.67 50.3759 131.678 50.5992C131.65 50.6429 131.556 50.4724 131.598 50.789C131.6 50.7891 131.614 50.7074 131.627 50.8091C131.651 50.9872 131.682 51.3335 131.696 51.5571C131.74 51.526 131.718 51.2533 131.74 51.1036C131.768 51.4018 131.805 51.7324 131.776 51.9668C131.763 51.8553 131.748 51.7433 131.735 51.6325C131.746 51.7651 131.757 51.898 131.768 52.0299C131.746 51.9871 131.678 51.7047 131.681 51.9204C131.732 51.9198 131.76 52.2129 131.794 52.3138ZM131.642 53.9472C131.594 53.8009 131.588 53.572 131.574 53.3321C131.617 53.3703 131.623 53.7664 131.642 53.9472ZM131.363 47.6522C131.417 47.4685 131.453 48.0949 131.461 48.3485C131.457 48.2902 131.453 48.2308 131.45 48.1725C131.438 48.2037 131.425 48.2326 131.413 48.2638C131.407 48.2002 131.401 48.1367 131.395 48.0731C131.386 48.1539 131.375 48.227 131.365 48.3044C131.294 48.1639 131.331 48.1368 131.324 47.8932C131.319 47.7372 131.294 47.6861 131.28 47.4964C131.211 46.6087 131.12 45.7047 131.067 44.7863C131.118 44.7651 131.132 44.7807 131.15 44.9467C131.135 44.9461 131.119 44.948 131.104 44.948C131.117 45.057 131.131 45.1637 131.145 45.2694C131.146 45.1636 131.148 45.0585 131.151 44.955C131.156 45.0052 131.162 45.0686 131.17 45.1479C131.175 45.2062 131.197 45.2125 131.2 45.2933C131.207 45.4662 131.161 45.7143 131.19 45.895C131.207 45.9996 131.253 45.8296 131.255 46.0957C131.203 45.9589 131.16 45.8661 131.204 46.258C131.224 46.0124 131.223 46.2008 131.247 46.2773C131.263 46.3255 131.235 45.9881 131.274 46.1972C131.282 46.242 131.352 46.9125 131.316 46.8992C131.237 46.8687 131.243 46.8309 131.316 47.2533C131.307 46.686 131.392 47.1732 131.388 47.4287C131.386 47.5588 131.336 47.358 131.363 47.6522ZM131.08 44.3431C131.088 44.515 131.126 44.5458 131.111 44.6817C131.109 44.6934 131.067 44.5942 131.06 44.5127C131.053 44.4306 131.032 43.8971 131.036 43.8783C131.085 43.6976 131.077 44.2829 131.08 44.3431ZM131.048 43.8066C131.039 43.6884 131.03 43.5702 131.021 43.4519C131.015 43.3722 131.008 43.2929 131 43.2141C131 43.2143 131 43.2146 131 43.2148C131.008 43.2189 131.016 43.2238 131.024 43.2285C131.029 43.3024 131.032 43.3766 131.035 43.4511C131.039 43.5696 131.044 43.6882 131.048 43.8066ZM131.776 54.7145C131.722 54.6726 131.729 54.8776 131.735 54.9556C131.758 55.2351 131.726 55.4132 131.784 55.5167C131.803 55.3426 131.76 55.235 131.758 55.152C131.755 54.9705 131.796 54.9531 131.776 54.7145ZM131.834 55.7916C131.828 55.8681 131.8 55.8417 131.8 55.9447C131.799 56.048 131.809 56.3449 131.826 56.4513C131.843 56.5573 131.881 56.5278 131.901 56.6113C131.879 56.3344 131.857 56.0687 131.834 55.7916ZM131.953 57.3753C131.946 57.2172 131.881 57.046 131.915 57.4011C131.916 57.4166 131.959 57.5354 131.944 57.6485C131.934 57.7217 131.917 57.6735 131.907 57.7701C131.896 57.8666 131.984 58.0666 131.953 57.3753ZM132.146 60.93C132.141 60.8557 132.111 60.7747 132.109 60.8122C132.096 61.1066 132.171 61.2751 132.146 60.93ZM131.151 44.955C131.151 44.9522 131.15 44.9494 131.15 44.9467C131.15 44.9467 131.151 44.9466 131.151 44.9466C131.151 44.9493 131.151 44.9523 131.151 44.955ZM132.109 60.2066C132.127 60.3438 132.146 60.4813 132.165 60.6185C132.168 60.5296 132.171 60.4412 132.174 60.3529C132.152 60.3046 132.13 60.2551 132.109 60.2066ZM132.199 59.9528C132.165 59.942 132.137 59.9665 132.128 60.1413C132.162 60.1665 132.18 60.066 132.199 59.9528ZM132.264 62.1801C132.248 62.3839 132.382 62.4757 132.307 62.2002C132.299 62.174 132.266 62.1651 132.264 62.1801ZM131.451 48.7403C131.45 48.7383 131.45 48.7363 131.45 48.7343C131.452 48.7361 131.455 48.7381 131.457 48.7399C131.455 48.7402 131.453 48.74 131.451 48.7403ZM93.3376 89.2456C93.4786 89.2881 93.6173 89.1511 93.5883 89.1444C93.4469 89.113 93.2374 89.2151 93.3376 89.2456ZM132.148 57.9964C132.166 57.5171 132.062 57.4667 132.05 57.4352C131.987 57.2718 132.07 57.1938 132.067 57.1526C132.051 56.957 131.975 57.2219 131.975 57.2495C131.978 57.684 132.043 57.5514 132.068 57.5882C132.123 57.6695 132.103 57.9714 132.148 57.9964ZM131.476 48.7591C131.474 48.7236 131.472 48.6886 131.47 48.6546C131.471 48.6585 131.474 48.6631 131.475 48.667C131.475 48.5996 131.475 48.5322 131.475 48.4647C131.485 48.5442 131.496 48.6234 131.506 48.7022C131.496 48.7214 131.486 48.7399 131.476 48.7591ZM132.637 67.2545C132.682 66.9435 132.544 65.9749 132.564 66.6367C132.567 66.7509 132.584 66.6872 132.589 66.7575C132.589 66.7577 132.589 66.758 132.589 66.7583C132.595 66.8291 132.603 67.4856 132.637 67.2545ZM131.869 54.5247C131.843 54.6183 131.863 54.7594 131.88 54.9295C131.89 54.9086 131.901 54.8873 131.911 54.8665C131.897 54.7529 131.883 54.6382 131.869 54.5247ZM91.1452 89.4018C91.2906 89.3803 91.5548 89.3909 91.5384 89.3233C91.4172 89.3231 91.2956 89.3226 91.1744 89.3224C91.1647 89.3488 91.155 89.3754 91.1452 89.4018ZM89.6884 89.5722C89.8134 89.5537 89.6778 89.5091 89.7259 89.4792C89.7745 89.4514 90.1742 89.4666 89.9016 89.387C89.8181 89.3656 89.3461 89.4106 89.1993 89.3395C89.1109 89.4847 89.3859 89.4038 89.5757 89.4759C89.6332 89.4977 89.4673 89.5638 89.6884 89.5722ZM132.687 68.2316C132.702 68.3677 132.717 68.5051 132.733 68.6411C132.725 68.5062 132.717 68.3704 132.71 68.2355C132.702 68.2344 132.695 68.2327 132.687 68.2316ZM131.352 84.5971C131.364 84.5782 131.377 84.5592 131.389 84.5401C131.435 84.4867 131.478 84.4353 131.518 84.3872C131.542 84.3727 131.566 84.3581 131.59 84.3433C131.512 84.4297 131.433 84.5143 131.352 84.5971ZM132.93 71.0545C132.936 70.8174 132.867 70.5127 132.85 70.6924C132.829 70.9085 132.921 71.44 132.93 71.0545ZM132.792 69.6947C132.811 70.2086 132.913 70.5556 132.846 69.8968C132.842 69.8604 132.8 69.8162 132.792 69.6947ZM130.528 85.422C130.69 85.3417 130.168 85.8454 129.979 85.9428C130.014 85.8872 130.047 85.8314 130.08 85.7754C130.101 85.7589 130.123 85.7392 130.145 85.7188C130.205 85.673 130.307 85.5936 130.429 85.4905C130.479 85.4567 130.525 85.4248 130.53 85.4224C130.529 85.4222 130.529 85.4221 130.528 85.422ZM84.7985 87.5101C85.0408 87.9015 85.2114 87.8508 85.0075 87.6512C84.9826 87.6273 84.8108 87.4837 84.7985 87.5101ZM132.262 59.3645C132.276 59.3477 132.37 59.4982 132.287 59.2264C132.258 59.1327 132.237 59.1571 132.215 58.8796C132.239 59.1362 132.174 59.1114 132.172 59.1404C132.15 59.377 132.24 59.6048 132.269 59.5529C132.277 59.5369 132.248 59.382 132.262 59.3645ZM131.492 47.9518C131.483 47.8133 131.475 47.6741 131.467 47.5357C131.479 47.5483 131.491 47.5595 131.503 47.572C131.499 47.6991 131.497 47.8289 131.492 47.9518ZM86.1421 88.7104C86.1822 88.6832 85.9517 88.3588 85.9174 88.3224C85.6791 88.0937 85.4797 88.0842 85.2615 87.8631C85.2656 88.0089 85.4902 88.0781 85.615 88.2244C85.6541 88.2696 85.4269 88.2397 85.6581 88.4205C85.6583 88.4207 85.6584 88.4209 85.6586 88.421C85.7331 88.4803 86.0396 88.6231 86.1421 88.7104ZM129.735 86.0995C129.823 86.0603 129.709 86.2261 129.508 86.2753C129.501 86.2763 129.502 86.2702 129.502 86.2646C129.503 86.2594 129.504 86.2544 129.498 86.2556C129.48 86.2611 129.408 86.2971 129.322 86.3369C129.149 86.4191 128.917 86.5129 128.989 86.4538C129.097 86.3971 129.205 86.338 129.312 86.2761C129.34 86.2678 129.366 86.2627 129.39 86.258C129.424 86.2516 129.458 86.2449 129.5 86.2283C129.577 86.1977 129.663 86.1443 129.709 86.1151C129.727 86.104 129.738 86.0967 129.741 86.0955C129.739 86.0968 129.737 86.0982 129.735 86.0995ZM82.9098 85.881C82.9177 85.9342 83.0551 86.1475 83.082 86.1532C83.1064 86.1586 83.0981 86.1199 83.0914 86.0852C83.0763 86.0588 83.0613 86.0323 83.0464 86.0057C83.0605 86.0268 83.0749 86.048 83.0891 86.0689C83.0833 86.0332 83.0853 86.0121 83.1408 86.0698C83.2656 86.2594 83.4012 86.4487 83.5431 86.6292C83.5513 86.5874 83.5602 86.5458 83.5694 86.5047C83.5329 86.4775 83.4962 86.4496 83.46 86.4219C83.4398 86.379 83.4201 86.3361 83.4006 86.2932C83.6219 86.2859 83.7143 86.7281 84.017 86.9257C83.9891 86.9517 83.9622 86.9811 83.9335 87.0049C84.3273 87.4778 84.0702 87.1425 84.1079 87.0467C84.1293 86.9918 84.2365 87.1707 84.2684 87.1891C84.4813 87.3127 84.0977 86.8238 83.9759 86.6783C83.8482 86.5374 83.6247 86.3727 83.4946 86.2004C83.4178 86.0982 83.4391 86.0599 83.3651 85.9557C83.2533 85.8 83.0772 85.5091 82.9732 85.3762C82.9351 85.3286 82.9 85.4151 82.9014 85.4346C82.9059 85.4819 82.9805 85.5347 83.0005 85.5802C83.0204 85.6257 82.9776 85.6139 83.0086 85.6705C83.0388 85.7288 83.2375 86.0038 83.2563 86.0179C83.3586 86.1037 83.2731 85.914 83.3702 86.0626C83.2969 86.3955 83.0793 85.817 83.0286 85.7527C82.9008 85.6109 82.9017 85.6486 82.9268 85.7191C82.9837 85.8289 83.042 85.9367 83.0414 85.945C83.0323 86.0253 82.9837 85.9628 82.935 85.8712C82.9193 85.8647 82.9056 85.8603 82.9086 85.8793C82.909 85.8799 82.9094 85.8804 82.9098 85.881ZM81.7036 78.6226C81.6739 78.2203 81.7973 78.4439 81.8031 78.5116C81.8267 78.7953 81.7165 79.0257 81.8694 79.1412C81.8875 79.3137 81.8178 79.1428 81.8178 79.2492C81.8181 79.4602 81.9074 79.68 81.911 79.8998C81.8801 79.9191 81.8489 79.9722 81.8155 79.9607C81.7667 79.7386 81.7111 78.7236 81.7036 78.6226ZM131.997 56.0241C132.022 56.2069 132.048 56.3902 132.073 56.573C132.049 56.3065 132.038 56.2099 132.067 56.0365C132.044 56.0326 132.02 56.028 131.997 56.0241ZM132.703 67.0617C132.706 67.0355 132.666 66.5469 132.641 66.5505C132.638 66.6399 132.677 67.2342 132.703 67.0617ZM81.9024 81.1621C81.8613 80.8032 81.9575 80.7415 81.977 81.0299C81.9824 81.1123 81.9327 81.2116 81.9024 81.1621ZM104.208 88.6997C104.254 88.6981 104.861 88.6579 104.799 88.599C104.472 88.6106 104.122 88.6242 103.787 88.6369C103.808 88.6552 103.903 88.6705 103.951 88.6755C104.069 88.6886 104.04 88.7054 104.208 88.6997ZM81.8166 80.3344C81.8232 80.237 81.8731 80.285 81.8385 80.0952C81.8432 80.0939 81.8479 80.0926 81.8526 80.0913C81.886 80.1043 81.9197 80.2573 81.9227 80.3378C81.9223 80.3409 81.8918 80.3237 81.8921 80.3457C81.8967 80.5078 81.9401 80.7574 81.8576 80.7525C81.8965 80.5974 81.8102 80.4322 81.8166 80.3344ZM132.182 57.3238C132.17 57.1167 132.116 57.0025 132.087 57.0456C132.102 57.1816 132.118 57.3184 132.133 57.4544C132.149 57.411 132.165 57.3673 132.182 57.3238ZM107.736 88.4741C107.674 88.4709 107.612 88.468 107.55 88.4649C107.586 88.4564 107.623 88.448 107.66 88.4395C107.608 88.4358 107.554 88.4322 107.501 88.4285C107.447 88.4637 107.393 88.499 107.338 88.5343C107.47 88.5143 107.603 88.494 107.736 88.4741ZM84.7116 87.9431C84.8085 88.0758 84.849 87.9309 84.7906 87.8662C84.7319 87.8016 84.584 87.7179 84.5657 87.6274C84.67 87.6832 84.7485 87.7956 84.8731 87.8734C85.0203 87.9641 84.9147 87.795 84.8683 87.7806C84.7748 87.7518 84.8187 87.8592 84.6768 87.6794C84.5587 87.5254 84.7885 87.5663 84.6743 87.4567C84.5315 87.3167 84.5397 87.4239 84.5643 87.5075C84.4633 87.4335 84.3649 87.3556 84.2678 87.2762C84.5375 87.5358 84.5163 87.6274 84.4989 87.7635C84.6143 87.8796 84.5484 87.7216 84.6704 87.8379C84.7135 87.8786 84.7038 87.9317 84.7116 87.9431ZM90.646 89.5248C90.9748 89.5026 90.9658 89.4159 90.689 89.4751C90.6301 89.4877 90.6353 89.5061 90.646 89.5248ZM132.1 56.6454C132.106 56.7579 132.112 56.8708 132.118 56.9833C132.126 56.9844 132.134 56.9861 132.142 56.9872C132.136 56.8749 132.129 56.7624 132.123 56.65C132.116 56.649 132.108 56.6465 132.1 56.6454ZM131.967 54.4085C131.983 54.5582 131.975 54.8174 132.012 54.8188C132.009 54.6843 132.006 54.5492 132.002 54.4147C131.991 54.4125 131.979 54.4101 131.967 54.4085ZM132.705 66.6199C132.705 66.6517 132.707 66.6798 132.709 66.7049C132.708 66.6764 132.706 66.6477 132.705 66.6191C132.705 66.6194 132.705 66.6197 132.705 66.6199ZM131.934 53.7989C131.948 53.9124 131.962 54.0273 131.976 54.1407C131.973 54.0288 131.971 53.9164 131.969 53.8051C131.957 53.8028 131.946 53.8012 131.934 53.7989ZM126.522 87.3726C126.484 87.3868 126.322 87.3981 126.174 87.4025C126.076 87.4057 125.983 87.4065 125.932 87.4099C126.116 87.2733 126.551 87.3634 126.522 87.3726ZM106.342 88.7655C107.128 88.7354 106.76 88.517 106.131 88.5628C106.091 88.617 106.246 88.5768 106.259 88.6044C106.271 88.632 106.09 88.6105 106.173 88.6576C106.454 88.6559 106.301 88.6055 106.504 88.5817C106.468 88.6144 106.545 88.6663 106.52 88.6936C106.472 88.7445 106.297 88.7094 106.342 88.7655ZM82.2246 84.1768C82.2244 84.175 82.224 84.1728 82.2238 84.1711C82.2113 84.059 82.3347 83.9972 82.3325 83.9769C82.2954 83.7471 82.1456 83.6669 82.1392 83.8189C82.1363 83.9087 82.2588 84.0157 82.1785 84.0459C82.1401 83.8734 82.1126 83.8154 82.0906 83.8005C82.132 83.9265 82.1769 84.0521 82.2246 84.1768ZM81.7253 78.2566C81.6546 78.2125 81.6704 77.871 81.6507 77.7114C81.7214 77.849 81.7163 78.0472 81.7253 78.2566ZM132.249 58.7529C132.266 59.0153 132.29 58.9544 132.308 58.9963C132.305 58.9355 132.302 58.8748 132.299 58.8149C132.282 58.7942 132.266 58.7734 132.249 58.7529ZM81.2569 71.6008C81.2611 71.6659 81.3077 71.7436 81.3133 71.7114C81.3553 71.4628 81.2377 71.2987 81.2569 71.6008ZM82.5823 84.9327C82.6884 85.0831 82.8245 85.4296 82.8973 85.3549C82.7981 85.0454 82.828 85.1727 82.7186 85.0707C82.6451 85.001 82.6327 84.8291 82.5823 84.9327ZM105.072 88.6515C104.972 88.654 104.871 88.6565 104.771 88.6589C104.808 88.676 104.846 88.6933 104.884 88.7104C104.946 88.6909 105.01 88.6711 105.072 88.6515ZM126.991 87.3618C126.96 87.4289 126.252 87.4813 126.353 87.4411C126.637 87.4164 126.618 87.398 126.597 87.3806C126.587 87.3719 126.576 87.3624 126.595 87.35C126.701 87.286 127.016 87.3135 126.991 87.3618ZM132.196 56.9296C132.193 57.0068 132.189 57.0847 132.186 57.1612C132.199 57.1904 132.211 57.2195 132.224 57.2488C132.221 57.178 132.217 57.1075 132.214 57.038C132.208 57.0019 132.202 56.9657 132.196 56.9296ZM82.0184 83.4501C82.0595 83.1711 82.123 83.1168 82.0321 83.118C82.0339 83.1715 82.0283 83.2016 82.0124 83.1772C82.0086 83.1579 82.0052 83.1387 82.0016 83.1193C81.9868 83.1207 81.9692 83.1221 81.9491 83.1245C81.9699 83.2326 81.9932 83.3425 82.0184 83.4501ZM81.3478 74.6949C81.3493 74.8321 81.449 74.9953 81.4157 74.6825C81.4138 74.6683 81.3497 74.5561 81.3814 74.4634C81.4037 74.403 81.4293 74.4484 81.4544 74.3684C81.4793 74.2886 81.3419 74.0949 81.3478 74.6949ZM81.3858 75.3624C81.4048 75.6052 81.4251 75.8388 81.446 76.0822C81.4605 76.0183 81.5074 76.0481 81.5148 75.9602C81.5222 75.8717 81.5251 75.6145 81.5033 75.5192C81.4814 75.4244 81.4154 75.4392 81.3858 75.3624ZM124.13 87.8099C124.014 87.8233 123.755 87.8529 123.808 87.8219C123.831 87.8099 123.9 87.8079 123.96 87.8063C124.032 87.8043 124.094 87.8026 124.061 87.7847C123.817 87.758 123.608 87.7793 123.323 87.8087C123.315 87.8096 123.306 87.8105 123.298 87.8114C123.295 87.8122 123.305 87.8147 123.319 87.8182C123.356 87.8273 123.423 87.8438 123.383 87.8593C123.365 87.8582 123.348 87.8573 123.334 87.8569C123.208 87.8527 123.249 87.8414 123.058 87.8506C123.046 87.8512 123.002 87.854 122.941 87.8583C122.921 87.8555 122.898 87.8534 122.871 87.8527C122.83 87.8516 122.778 87.8533 122.723 87.8552C122.635 87.8582 122.54 87.8615 122.477 87.8532C122.516 87.8291 122.7 87.8319 122.851 87.8344C122.945 87.8359 123.025 87.8373 123.05 87.8318C123.056 87.8306 123.068 87.8217 123.082 87.8104C123.105 87.7923 123.135 87.768 123.164 87.7592C123.147 87.7587 123.111 87.7624 123.071 87.7666C122.992 87.7751 122.897 87.7852 122.909 87.7656C122.91 87.7648 122.91 87.7639 122.911 87.7631C122.912 87.7621 122.912 87.7611 122.912 87.7601C122.913 87.76 122.913 87.7599 122.913 87.7598C122.931 87.7293 122.961 87.6793 123.139 87.6672C123.154 87.6659 123.166 87.669 123.179 87.6726C123.194 87.6768 123.212 87.6815 123.241 87.6807C123.284 87.6791 123.331 87.6744 123.379 87.6696C123.441 87.6633 123.505 87.6567 123.559 87.6572C123.575 87.6572 123.593 87.661 123.612 87.6651C123.637 87.6704 123.664 87.6761 123.694 87.6753C123.717 87.6745 123.751 87.6674 123.793 87.6587C123.866 87.6433 123.964 87.6231 124.061 87.6244C124.127 87.6249 124.246 87.6736 124.12 87.6916C124.043 87.7027 124.026 87.6959 124.011 87.69C124.003 87.6869 123.994 87.6841 123.979 87.6843C123.943 87.6851 123.9 87.6891 123.859 87.6932C123.762 87.7028 123.668 87.7122 123.667 87.6762C123.571 87.6814 123.582 87.7201 123.61 87.7267C123.684 87.747 124.514 87.7353 124.591 87.7142C124.593 87.7134 124.588 87.7121 124.582 87.7102C124.556 87.7026 124.496 87.6843 124.654 87.6398C124.776 87.6061 124.927 87.5992 124.997 87.596C125.018 87.5951 125.031 87.5944 125.035 87.5935C125.039 87.5922 125.029 87.5868 125.015 87.5795C124.958 87.55 124.837 87.4877 125.304 87.5182C125.36 87.5101 125.349 87.5004 125.34 87.4922C125.333 87.4864 125.328 87.4812 125.346 87.4778C125.399 87.4677 125.62 87.4463 125.646 87.4483C125.659 87.4581 125.672 87.4679 125.685 87.4777C125.681 87.4787 125.657 87.4811 125.623 87.4847C125.511 87.4965 125.284 87.5205 125.296 87.5409C125.565 87.5097 125.668 87.5159 125.882 87.529C125.887 87.5292 125.894 87.5299 125.902 87.5308C125.909 87.5318 125.918 87.5332 125.927 87.5347C125.987 87.544 126.076 87.5563 126.115 87.5169C126.124 87.5084 126.085 87.5082 126.043 87.5077C125.986 87.5072 125.923 87.5056 125.954 87.4861C126.091 87.4774 126.164 87.4582 126.25 87.435C126.256 87.4336 126.261 87.4321 126.266 87.4306C126.301 87.4366 126.27 87.4482 126.243 87.4581C126.224 87.4648 126.206 87.471 126.214 87.4742C126.218 87.4775 126.417 87.4899 126.428 87.4894C126.465 87.4875 126.553 87.476 126.64 87.4627C126.699 87.4537 126.758 87.4439 126.801 87.4373C126.846 87.43 126.905 87.4242 126.952 87.4189C126.988 87.4148 127.018 87.4112 127.032 87.4082C127.059 87.402 127.087 87.3916 127.115 87.3808C127.15 87.3676 127.187 87.3533 127.227 87.3449C127.247 87.3408 127.272 87.3394 127.299 87.3382C127.284 87.346 127.268 87.3543 127.25 87.363C127.225 87.3755 127.202 87.3872 127.179 87.3984C127.139 87.4186 127.1 87.4376 127.053 87.4576C127.044 87.4554 127.032 87.4539 127.019 87.453C126.975 87.4313 126.799 87.463 126.538 87.5065C126.476 87.5165 126.471 87.5243 126.467 87.5312C126.464 87.5356 126.462 87.5397 126.445 87.5434C126.35 87.5625 126.229 87.5784 126.105 87.5915C126.039 87.5984 125.971 87.6047 125.906 87.6107C125.828 87.6179 125.754 87.6257 125.689 87.6348C125.694 87.648 125.763 87.6403 125.818 87.6342C125.845 87.6312 125.869 87.6287 125.88 87.6293C125.893 87.6303 125.907 87.6387 125.909 87.6489C125.909 87.6495 125.909 87.6502 125.909 87.6508C125.909 87.6628 125.891 87.6767 125.838 87.6842C125.645 87.7101 125.58 87.6922 125.519 87.6752C125.489 87.6668 125.46 87.6587 125.416 87.656C125.132 87.6399 124.744 87.6883 124.948 87.7375C124.708 87.7288 124.702 87.7356 124.693 87.7463C124.689 87.751 124.684 87.7563 124.66 87.7614C124.463 87.8045 124.417 87.8038 124.338 87.8022C124.3 87.8015 124.254 87.8005 124.18 87.8043C124.172 87.8049 124.154 87.8071 124.13 87.8099ZM81.472 77.0184C81.5626 77.0688 81.5638 76.8911 81.5584 76.8229C81.539 76.5779 81.6055 76.4342 81.5129 76.3303C81.4691 76.4742 81.5342 76.5771 81.5318 76.6486C81.5256 76.8052 81.4538 76.809 81.472 77.0184ZM81.921 82.5539C81.933 82.5801 81.9307 82.6841 81.9594 82.8546C81.9545 82.8183 81.9499 82.7815 81.9455 82.7456C81.9659 82.7663 81.9825 82.8109 81.9959 82.8638C81.9681 82.6976 81.9503 82.5926 81.9288 82.5577C81.9262 82.5566 81.9236 82.5552 81.921 82.5539C81.9183 82.5481 81.9148 82.5436 81.9103 82.5462C81.9103 82.5467 81.9102 82.5472 81.9102 82.5476C81.9138 82.5501 81.9175 82.5521 81.921 82.5539ZM108.385 88.5644C108.346 88.5441 108.306 88.5236 108.267 88.5033C108.231 88.5374 108.196 88.5717 108.161 88.6058C108.235 88.5921 108.31 88.5781 108.385 88.5644ZM127.47 87.2361C127.402 87.2471 127.331 87.2537 127.336 87.241C127.429 87.2233 127.504 87.1948 127.571 87.1643C127.57 87.1649 127.569 87.1656 127.569 87.1662C127.568 87.1669 127.567 87.1675 127.566 87.1682C127.565 87.1689 127.564 87.1696 127.563 87.1703C127.536 87.1908 127.503 87.2143 127.47 87.2361ZM128.144 87.056C128.117 87.0661 128.093 87.0727 128.071 87.0771C128.08 87.07 128.088 87.063 128.096 87.0564C128.129 87.0273 128.147 87.0057 128.161 86.9859C128.22 86.9652 128.279 86.9441 128.309 86.9344C128.336 86.9515 128.302 86.9985 128.144 87.056ZM82.6844 39.6906C82.7068 39.7005 82.7294 39.7104 82.7517 39.7205C82.7392 39.7075 82.734 39.6804 82.7273 39.6549C82.713 39.6668 82.6987 39.6787 82.6844 39.6906ZM80.5969 62.726C80.5714 62.9275 80.6682 63.2065 80.7098 63.0575C80.7594 62.878 80.6385 62.399 80.5969 62.726ZM91.5024 89.5393C91.6757 89.6012 92.1506 89.5893 91.7996 89.5346C91.7106 89.5208 91.5964 89.5366 91.5024 89.5393ZM81.2728 72.2303C81.2497 72.1078 81.2266 71.984 81.2035 71.8615C81.1925 71.9368 81.1817 72.013 81.1706 72.0877C81.2047 72.1349 81.2389 72.1832 81.2728 72.2303ZM80.8435 66.0569C80.7454 66.3113 80.9161 67.1766 80.9267 66.6046C80.9283 66.5067 80.8955 66.5562 80.891 66.495C80.891 66.4948 80.8911 66.4945 80.8912 66.4943C80.887 66.4321 80.9168 65.8682 80.8435 66.0569ZM81.1394 70.4994C81.1811 70.3294 80.9574 70.2156 81.0681 70.4712C81.0789 70.4955 81.1358 70.5117 81.1394 70.4994ZM80.7428 63.9299C80.7447 63.4833 80.593 63.1574 80.6632 63.7406C80.6676 63.773 80.7384 63.8221 80.7428 63.9299ZM80.8231 65.2072C80.8064 65.0867 80.7897 64.9652 80.7729 64.8447C80.7765 64.9622 80.7803 65.0808 80.7838 65.1982C80.7969 65.2012 80.81 65.2042 80.8231 65.2072ZM127.167 87.3282C127.238 87.3084 127.333 87.2857 127.424 87.2662C127.414 87.2726 127.404 87.2787 127.395 87.2842C127.383 87.2916 127.37 87.2992 127.357 87.3068C127.294 87.3147 127.23 87.3218 127.167 87.3282ZM81.8165 81.8566C81.8182 81.8535 81.8193 81.8485 81.8191 81.8406C81.8191 81.8391 81.8187 81.8372 81.8185 81.8354C81.8178 81.8423 81.8172 81.8499 81.8165 81.8566ZM81.7781 82.0282C81.7937 82.0792 81.7988 82.037 81.8077 81.9506C81.8103 81.923 81.8131 81.8912 81.8165 81.8566C81.8075 81.8729 81.7779 81.8337 81.7779 81.862C81.7779 81.8919 81.7777 81.9221 81.7777 81.9524C81.7776 81.9777 81.7777 82.003 81.7781 82.0282ZM81.6684 81.2003C81.6716 81.2434 81.6752 81.2859 81.6797 81.3235C81.7109 81.3349 81.746 81.3254 81.7579 81.3671C81.7623 81.3829 81.765 81.3954 81.7662 81.4051C81.7754 81.3469 81.7779 81.2629 81.7727 81.1782C81.7361 81.2132 81.6992 81.2416 81.6684 81.2003ZM81.102 72.4233C81.1593 72.4415 81.2085 72.4275 81.2352 72.2802C81.1784 72.2496 81.1409 72.3312 81.102 72.4233ZM81.7109 81.4605C81.733 81.4969 81.7499 81.4788 81.761 81.4318C81.7468 81.4429 81.7105 81.4077 81.7083 81.4093C81.7049 81.4176 81.7019 81.4258 81.6995 81.4325C81.7029 81.444 81.7068 81.4537 81.7109 81.4605ZM81.6209 80.2956C81.6262 80.34 81.6363 80.3767 81.6513 80.3859C81.6794 80.4025 81.6855 80.3202 81.6831 80.2397C81.6627 80.1033 81.6412 80.2376 81.6209 80.2956ZM81.6443 80.8861C81.649 80.921 81.6529 80.9704 81.6566 81.0251C81.6941 81.0329 81.7092 80.9814 81.71 80.9079C81.6922 80.8835 81.6703 80.8737 81.6443 80.8861ZM101.029 36.5274C101.182 36.5225 101.457 36.4608 101.523 36.4955C101.364 36.5181 101.623 36.5744 101.779 36.5445C101.926 36.5192 101.902 36.5028 101.78 36.4883C102.291 36.4586 102.88 36.3927 103.286 36.41C103.208 36.4222 103.195 36.4392 103.182 36.4572C103.182 36.4575 103.182 36.4578 103.182 36.4581C103.344 36.4501 103.434 36.4733 103.625 36.4508C103.595 36.428 103.533 36.4183 103.47 36.4097C103.882 36.3966 104.455 36.3113 104.743 36.3547C104.425 36.3725 104.187 36.3818 104.271 36.4592C104.404 36.4462 104.534 36.4321 104.664 36.4194C104.87 36.4568 104.473 36.5151 104.71 36.5083C104.933 36.4726 104.985 36.5133 105.204 36.4772C105.212 36.4204 105.151 36.3733 104.95 36.315C105.679 36.2586 106.418 36.1983 107.132 36.1488C106.901 36.204 106.627 36.1988 106.506 36.2122C106.398 36.2245 106.417 36.2535 106.323 36.2681C106.338 36.2649 106.037 36.2551 106.09 36.2918C106.193 36.3004 106.297 36.3089 106.402 36.3165C106.718 36.3051 106.562 36.2542 106.819 36.2369C106.953 36.2659 107.633 36.2414 107.443 36.1736C107.3 36.1845 107.078 36.2302 107.081 36.1732C107.324 36.144 107.454 36.1678 107.728 36.1255C107.851 36.1477 107.581 36.203 107.831 36.1903C107.934 36.1794 107.859 36.1543 107.938 36.1418C108.144 36.2329 108.636 36.1927 109.075 36.1762C108.849 36.2248 108.594 36.3283 108.295 36.3124C108.367 36.3419 108.241 36.3552 108.215 36.3772C107.984 36.3702 107.403 36.4572 107.541 36.4088C107.589 36.3924 107.8 36.3926 107.75 36.3687C107.47 36.3503 107.004 36.4954 107.54 36.4656C107.41 36.4783 107.282 36.4924 107.152 36.5051C106.968 36.4437 107.274 36.4199 107.209 36.3679C107.096 36.3579 106.841 36.3992 106.766 36.4323C107.165 36.4027 106.803 36.4395 107.023 36.4811C106.617 36.4888 106.43 36.5693 106.062 36.5602C106.305 36.5333 106.461 36.462 106.612 36.3913C106.42 36.3867 106.069 36.4637 106.089 36.52C105.899 36.5332 105.702 36.5199 105.726 36.5759C105.83 36.5751 105.928 36.5756 106.01 36.5847C105.316 36.6953 104.534 36.7187 103.435 36.847C103.275 36.8463 103.146 36.831 102.969 36.8382C102.738 36.8957 102.355 36.877 102.218 36.8772C102.079 36.8767 101.87 36.9017 101.802 36.9006C101.379 36.8912 101.154 36.8027 100.846 36.7533C100.844 36.7532 100.842 36.7532 100.84 36.7532C101.003 36.6866 100.903 36.5974 101.029 36.5274ZM81.629 79.7333C81.626 79.5695 81.4776 79.2026 81.5664 79.6329C81.5496 79.6474 81.533 79.6621 81.5163 79.6767C81.516 79.6791 81.5156 79.682 81.5151 79.6843C81.553 79.7005 81.5911 79.7165 81.629 79.7333ZM81.6007 79.4919C81.6 79.4894 81.5994 79.4869 81.5987 79.4844C81.5988 79.4902 81.599 79.4969 81.5989 79.5025C81.5995 79.4993 81.6001 79.4951 81.6007 79.4919ZM81.4127 77.9062C81.4106 78.0109 81.3998 78.1324 81.4327 78.2221C81.4594 78.1742 81.4864 78.1247 81.5133 78.0761C81.4857 78.017 81.467 77.9525 81.4544 77.881C81.4419 77.8879 81.4279 77.8957 81.4127 77.9062ZM133.569 80.8831C133.503 81.0256 133.376 81.5059 133.498 81.187C133.529 81.1056 133.549 80.9804 133.569 80.8831ZM81.2042 74.9135C81.2495 74.8874 81.3018 74.8103 81.3027 74.7966C81.3231 74.4783 81.2387 74.5022 81.1884 74.4924C81.1929 74.5434 81.1968 74.5937 81.1996 74.6427C81.2004 74.6439 81.2012 74.6451 81.2021 74.6463C81.2284 74.7022 81.2213 74.7403 81.2044 74.77C81.2049 74.7942 81.2055 74.819 81.2053 74.8425C81.2052 74.8702 81.2047 74.8936 81.2042 74.9135ZM82.1842 84.2491C82.207 84.305 82.2293 84.3621 82.2499 84.4163C82.2645 84.4018 82.2485 84.3438 82.1843 84.202C82.1845 84.2209 82.1844 84.2362 82.1842 84.2491ZM83.7732 86.9562C83.7606 86.927 83.7485 86.8979 83.7362 86.8686C83.6877 86.8608 83.6389 86.8527 83.5899 86.8435C83.6132 86.8718 83.6379 86.9013 83.6615 86.9295C83.6986 86.9386 83.7362 86.9478 83.7732 86.9562ZM81.8376 82.9071C81.8442 82.9766 81.861 83.0215 81.88 83.072C81.8654 83.0004 81.8496 82.9265 81.8348 82.8603C81.8352 82.8747 81.8361 82.8903 81.8376 82.9071ZM118.613 88.0392C118.524 88.0501 118.433 88.0611 118.344 88.072C118.378 88.0834 118.413 88.0948 118.447 88.1061C118.502 88.0838 118.558 88.0614 118.613 88.0392ZM80.7176 66.2042C80.7102 66.2241 80.7465 66.6552 80.7894 66.659C80.799 66.5835 80.7739 66.0636 80.7176 66.2042ZM80.3254 61.8665C80.3625 61.8345 80.4762 61.8296 80.4854 61.7254C80.4996 61.5596 80.4398 61.4029 80.3905 61.4993C80.3757 61.528 80.3637 61.8461 80.3254 61.8665ZM83.3254 86.4265C83.3113 86.4244 83.2619 86.356 83.2485 86.3477C83.2655 86.375 83.2828 86.4024 83.3001 86.4294C83.3085 86.4284 83.3172 86.4276 83.3254 86.4265ZM133.512 75.2744C133.517 75.3542 133.521 75.4301 133.525 75.5024C133.524 75.4709 133.523 75.4363 133.52 75.394C133.517 75.3632 133.515 75.3209 133.512 75.2744ZM133.63 75.943C133.617 75.9181 133.601 76.0104 133.597 75.8461C133.602 75.8135 133.606 75.7795 133.61 75.7457C133.599 75.6422 133.586 75.5339 133.576 75.4276C133.562 75.5008 133.548 75.5741 133.534 75.6476C133.556 76.0183 133.573 76.2816 133.587 76.4727C133.597 76.3885 133.572 75.9187 133.56 75.8106C133.613 75.8311 133.582 76.2331 133.631 76.353C133.636 76.3173 133.641 76.2225 133.643 76.1326C133.641 76.0958 133.639 76.0588 133.636 76.022C133.635 75.9965 133.633 75.9699 133.63 75.943ZM133.482 73.9872C133.463 73.7822 133.444 73.5743 133.427 73.3638C133.428 73.4069 133.427 73.4494 133.424 73.4879C133.422 73.5023 133.417 73.497 133.41 73.4864C133.412 73.5271 133.415 73.5678 133.417 73.6076C133.428 73.799 133.438 73.9791 133.447 74.1487C133.461 74.0941 133.474 74.0345 133.482 73.9872ZM126.032 36.0474C126.083 36.0565 126.134 36.0661 126.185 36.0762C126.143 36.0577 126.101 36.0396 126.058 36.0218C126.049 36.0303 126.041 36.0389 126.032 36.0474ZM133.726 80.0079C133.696 80.3617 133.741 80.4003 133.748 80.0788C133.749 80.0108 133.738 80.0066 133.726 80.0079ZM133.318 71.8059C133.318 71.8059 133.318 71.8059 133.318 71.8059C133.322 71.8856 133.326 71.9649 133.331 72.043C133.331 72.0435 133.332 72.0439 133.333 72.0443C133.328 71.9651 133.323 71.8854 133.318 71.8059ZM80.2024 58.5658C80.1792 58.7024 80.2264 58.9079 80.2591 58.8033C80.2916 58.6983 80.2314 58.3968 80.2024 58.5658ZM82.0528 84.6593C82.0908 84.6992 82.2209 84.7949 82.249 84.7732C82.2933 84.7383 82.2682 84.5679 82.199 84.4631C82.1816 84.4644 82.1637 84.4572 82.146 84.4162C82.1096 84.4153 82.0698 84.4613 82.0391 84.2628C82.0376 84.2525 82.0391 84.2255 82.0413 84.1923C81.997 84.0904 81.9292 83.9079 81.907 83.7979C81.882 83.7832 81.8583 83.777 81.8394 83.8061C81.8076 83.8553 81.9031 84.0877 81.9296 84.1915C81.9402 84.2358 81.9143 84.272 81.916 84.2807C81.9397 84.3855 81.9869 84.4063 82.0251 84.4966C82.0429 84.5385 82.015 84.6196 82.0528 84.6593ZM119.496 88.0562C119.339 88.073 119.181 88.0899 119.024 88.1067C119.092 88.1066 119.159 88.1065 119.227 88.1064C119.182 88.1129 119.137 88.1192 119.093 88.1257C119.149 88.1263 119.207 88.1269 119.263 88.1274C119.341 88.1038 119.418 88.0799 119.496 88.0562ZM80.5658 64.534C80.5609 64.5817 80.5561 64.6301 80.5511 64.6784C80.5705 64.6734 80.59 64.6678 80.6093 64.6628C80.5835 64.5696 80.5576 64.4762 80.5318 64.3836C80.5232 64.4196 80.5145 64.4571 80.5059 64.4931C80.5258 64.507 80.546 64.5201 80.5658 64.534ZM81.0342 73.1327C81.0347 73.1409 81.0354 73.1492 81.0359 73.1575C81.0608 73.1355 81.0898 73.1388 81.0933 73.1269C81.1398 72.9555 81.0409 72.7678 80.9794 72.7464C80.9884 72.8029 80.9974 72.8783 81.0064 72.975C80.9806 72.9735 80.9544 72.9712 80.9286 72.9692C80.964 73.0245 80.9981 73.0704 81.0342 73.1327ZM80.3682 66.0206C80.3882 66.3026 80.4091 66.5823 80.4308 66.8595C80.5164 66.8311 80.5597 67.0675 80.6336 67.0376C80.6763 67.0199 80.6405 66.7491 80.6451 66.6435C80.6472 66.5986 80.6837 66.5905 80.6847 66.5822C80.6925 66.4787 80.6527 66.4224 80.6443 66.3189C80.6406 66.271 80.6946 66.2324 80.6715 66.17C80.6481 66.1074 80.5566 65.9214 80.5218 65.9132C80.4595 65.899 80.421 66.0983 80.4795 66.2525C80.508 66.3278 80.5947 66.2657 80.5578 66.4955C80.5526 66.5264 80.4678 66.6581 80.4802 66.7697C80.4164 66.6354 80.3911 66.1849 80.3958 65.9941C80.3828 65.9914 80.3741 66.0017 80.3682 66.0206ZM84.5878 88.1085C84.7082 88.2337 84.841 88.2676 84.7791 88.1527C84.7594 88.119 84.5298 87.8979 84.5276 87.8427C84.5398 87.9034 84.5123 88.0292 84.5878 88.1085ZM81.1393 74.8555C81.1429 74.9015 81.1562 74.9197 81.1738 74.9221C81.1692 74.892 81.1646 74.857 81.1605 74.824C81.1481 74.8362 81.1388 74.8462 81.1393 74.8555ZM87.034 89.4018C87.133 89.4795 87.4018 89.5205 87.2431 89.4281C87.1164 89.354 86.9367 89.3253 87.034 89.4018ZM81.5247 81.2226C81.5034 81.4155 81.4723 81.4408 81.5059 81.6526C81.5293 81.54 81.5799 81.3141 81.5247 81.2226ZM123.359 87.9212C123.41 87.9142 123.46 87.9069 123.496 87.8996C123.423 87.8982 123.347 87.9008 123.27 87.9058C123.298 87.9057 123.325 87.9055 123.352 87.9054C123.354 87.9107 123.357 87.9159 123.359 87.9212ZM81.2476 78.0506C81.2926 78.0488 81.3762 78.071 81.2734 77.9116C81.2625 77.8947 81.2519 77.8854 81.242 77.8757C81.2429 77.9143 81.266 78.0067 81.2476 78.0506ZM80.9772 73.1671C80.9874 73.2041 80.9962 73.2553 81.0028 73.3377C80.9947 73.2625 81.0014 73.2168 81.014 73.1883C81.0142 73.177 81.0145 73.1655 81.0147 73.1543C81.0022 73.1582 80.9897 73.163 80.9772 73.1671ZM82.8947 86.1337C82.8813 86.095 82.8676 86.0553 82.8549 86.0166C82.8366 86.0234 82.818 86.0304 82.7997 86.0372C82.7789 85.9916 82.7584 85.9458 82.7383 85.8995C82.7383 85.8996 82.7382 85.8996 82.7381 85.8997C82.729 85.9221 82.7201 85.9449 82.7112 85.9674C82.7717 86.0241 82.8332 86.0797 82.8947 86.1337ZM125.41 87.8882C125.306 87.8935 125.202 87.899 125.097 87.9042C124.924 87.9129 124.27 87.9536 124.158 87.9482C123.825 87.9318 123.922 87.8765 123.667 87.9693C123.471 87.9857 123.632 87.9385 123.549 87.9335C123.532 87.9327 123.457 87.9501 123.376 87.9656C123.379 87.9715 123.381 87.9774 123.384 87.9832C124.042 87.9912 124.7 87.9991 125.359 88.0071C125.376 87.9675 125.393 87.9278 125.41 87.8882ZM80.9778 74.8207C81.0082 74.9136 81.0614 74.9619 81.0976 74.9411C81.0898 74.8854 81.0819 74.8298 81.074 74.7741C81.0661 74.8031 81.0582 74.83 81.0478 74.8361C81.0171 74.8538 80.9567 74.6544 80.9778 74.8207ZM131.784 42.7479C131.771 42.6394 131.749 42.516 131.723 42.3865C131.717 42.4038 131.711 42.4211 131.706 42.4384C131.719 42.4954 131.732 42.5525 131.744 42.6093C131.728 42.6103 131.712 42.6112 131.697 42.6122C131.703 42.6919 131.708 42.7718 131.713 42.8519C131.746 42.9233 131.778 42.9954 131.809 43.0677C131.809 43.0387 131.808 43.0098 131.808 42.9809C131.801 42.9036 131.793 42.8255 131.784 42.7479ZM81.138 75.8296C81.1354 75.7729 81.1329 75.7161 81.1303 75.6595C81.1219 75.6624 81.1133 75.6651 81.105 75.6678C81.1027 75.6866 81.0992 75.7049 81.0945 75.7235C81.096 75.7556 81.0975 75.7878 81.099 75.8199C81.1119 75.8231 81.125 75.8264 81.138 75.8296ZM80.1231 62.0486C80.1542 61.9444 80.2161 61.9373 80.2866 61.9224C80.2919 61.7569 80.2194 61.8792 80.2219 61.7058C80.2228 61.6448 80.2705 61.6407 80.2737 61.6287C80.3098 61.4835 80.1709 61.4757 80.1608 61.5608C80.1509 61.6462 80.1915 61.8398 80.138 61.8906C80.1047 61.7531 80.1342 61.6288 80.1099 61.4642C80.1026 61.4147 80.0931 61.3887 80.0835 61.3782C80.0875 61.4448 80.0915 61.5116 80.0955 61.5783C80.1101 61.5969 80.1161 61.6197 80.1032 61.7092C80.1099 61.8223 80.1165 61.9355 80.1231 62.0486ZM132.005 46.1879C131.991 46.1045 131.979 46.0163 131.968 45.9213C131.957 45.9454 131.945 45.9695 131.934 45.9936C131.935 46.0428 131.936 46.0921 131.938 46.1413C131.949 46.1373 131.961 46.1387 131.975 46.1497C131.985 46.1583 131.995 46.1719 132.005 46.1879ZM80.7327 69.2916C80.7065 69.3868 80.6503 69.5749 80.7055 69.6942C80.7309 69.5207 80.7633 69.5142 80.7327 69.2916ZM81.0633 76.1256C81.0681 76.1171 81.073 76.1104 81.0786 76.1103C81.1119 76.1107 81.174 76.355 81.1475 76.1394C81.1458 76.1285 81.1301 76.0851 81.1101 76.0322C81.0893 76.0233 81.068 76.0281 81.051 76.0486C81.0551 76.0741 81.0592 76.1001 81.0633 76.1256ZM132.537 53.5224C132.503 53.4528 132.473 53.3746 132.449 53.2884C132.437 53.3762 132.425 53.464 132.413 53.5518C132.407 53.5441 132.4 53.5365 132.393 53.5288C132.393 53.5331 132.394 53.5374 132.394 53.5416C132.413 53.6001 132.426 53.653 132.435 53.7023C132.464 53.4831 132.517 53.8725 132.553 54.075C132.552 53.9446 132.551 53.8143 132.551 53.684C132.546 53.6303 132.542 53.5762 132.537 53.5224ZM131.002 40.1377C130.977 40.1239 130.953 40.1102 130.928 40.0966C130.99 40.206 131.05 40.3168 131.107 40.4295C131.114 40.4759 131.12 40.5221 131.125 40.5683C131.16 40.6091 131.194 40.6504 131.228 40.6923C131.254 40.8022 131.277 40.9125 131.298 41.0223C131.332 41.0471 131.367 41.0722 131.401 41.0976C131.394 41.0829 131.387 41.0659 131.379 41.0452C131.35 40.9713 131.214 40.6053 131.095 40.3297C131.065 40.2652 131.034 40.2012 131.002 40.1377ZM133.305 68.4963C133.306 68.525 133.307 68.5536 133.308 68.5823C133.309 68.5754 133.31 68.5685 133.312 68.5616C133.31 68.54 133.308 68.518 133.305 68.4963ZM132.387 53.0135C132.383 53.0412 132.379 53.0689 132.375 53.0965C132.375 53.1039 132.375 53.1117 132.376 53.1191C132.383 53.1016 132.39 53.0841 132.397 53.0665C132.394 53.0492 132.39 53.0313 132.387 53.0135ZM80.476 67.6761C80.4868 67.8375 80.4976 67.999 80.5084 68.1604C80.5609 68.2325 80.5489 68.0376 80.5384 67.8724C80.5307 67.9521 80.5227 68.0319 80.5132 68.1095C80.5065 67.9881 80.4996 67.8659 80.4927 67.7446C80.5058 67.7468 80.519 67.7492 80.5322 67.7512C80.5309 67.7171 80.5306 67.6901 80.5333 67.6779C80.5496 67.6075 80.6504 67.6333 80.5953 67.4454C80.5743 67.3742 80.5333 67.4622 80.5329 67.5518C80.4653 67.2331 80.4428 67.3078 80.4429 67.4931C80.4539 67.5541 80.465 67.6151 80.476 67.6761ZM79.723 53.9517C79.7901 53.8201 79.7866 53.3561 79.7238 53.6632C79.7081 53.7412 79.722 53.8596 79.723 53.9517ZM80.3503 63.2875C80.349 63.249 80.3477 63.2085 80.3465 63.17C80.3223 63.126 80.2979 63.0817 80.2737 63.0377C80.2649 63.0648 80.2559 63.0907 80.2471 63.1178C80.2814 63.1739 80.316 63.2309 80.3503 63.2875ZM80.2783 64.6563C80.2956 64.6347 80.3006 64.5128 80.3106 64.4686C80.3277 64.3941 80.3695 64.5644 80.388 64.5236C80.388 64.5229 80.388 64.5221 80.3879 64.5214C80.4064 64.4789 80.3969 64.2148 80.3775 64.1845C80.3352 64.1204 80.3179 64.3619 80.281 64.1744C80.2728 63.9334 80.2649 63.6861 80.2567 63.4427C80.2397 63.4494 80.2227 63.4565 80.2058 63.4631C80.2293 63.8626 80.2536 64.2608 80.2783 64.6563ZM131.545 41.3086C131.488 41.1013 131.474 41.2529 131.402 41.0989C131.432 41.2276 131.459 41.3563 131.482 41.4852C131.487 41.4481 131.491 41.4108 131.494 41.3734C131.518 41.4056 131.542 41.438 131.565 41.4706C131.568 41.4336 131.567 41.3916 131.545 41.3086ZM81.0342 75.2779C81.037 75.2569 81.041 75.2344 81.0464 75.2115C81.0457 75.1887 81.0448 75.1657 81.0442 75.1429C81.0313 75.147 81.0184 75.1509 81.0056 75.155C81.0067 75.1936 81.0078 75.2325 81.009 75.2711C81.0174 75.273 81.0258 75.2758 81.0342 75.2779ZM95.1887 89.8143C95.3234 89.769 95.4333 89.734 94.9234 89.7476C94.923 89.7496 94.922 89.7518 94.9215 89.7538C95.1096 89.7509 95.2175 89.7658 95.1887 89.8143ZM133.565 71.5946C133.562 71.5501 133.559 71.5228 133.555 71.5069C133.559 71.5608 133.563 71.6147 133.567 71.6685C133.558 71.8401 133.559 71.9322 133.567 71.9895C133.57 71.8389 133.573 71.7008 133.565 71.5946ZM80.8592 72.9167C80.8616 72.9129 80.8641 72.9067 80.8671 72.9034C80.8629 72.8963 80.8588 72.8926 80.8548 72.8875C80.8542 72.8942 80.8555 72.9036 80.8592 72.9167ZM130.263 38.8951C130.263 38.8933 130.263 38.8915 130.263 38.8897C130.255 38.8789 130.248 38.8681 130.24 38.8574C130.248 38.8699 130.255 38.8825 130.263 38.8951ZM81.1668 77.9731C81.1657 77.9708 81.1645 77.9688 81.1634 77.9665C81.1635 77.968 81.1635 77.9695 81.1636 77.971C81.1647 77.9717 81.1657 77.9725 81.1668 77.9731ZM82.0074 84.6689C82.0074 84.6677 82.0073 84.6662 82.0073 84.665C82.0067 84.6539 81.9744 84.5774 81.9372 84.4955C81.96 84.5532 81.9834 84.6113 82.0074 84.6689ZM127.961 36.6673C127.976 36.6741 127.991 36.6809 128.005 36.6877C127.975 36.6684 127.946 36.649 127.918 36.63C127.933 36.6424 127.947 36.6548 127.961 36.6673ZM83.8995 87.6155C83.8909 87.5939 83.8735 87.5638 83.8438 87.5223C83.7826 87.4369 83.701 87.3669 83.6415 87.3341C83.7276 87.4339 83.8155 87.5295 83.8995 87.6155ZM129.116 37.5548C129.123 37.5591 129.131 37.5633 129.139 37.5675C129.109 37.5386 129.078 37.5096 129.048 37.4809C129.071 37.5054 129.093 37.5301 129.116 37.5548ZM80.0336 60.5589C80.0448 60.5395 80.0533 60.5005 80.0568 60.4314C80.0569 60.4314 80.057 60.4314 80.0571 60.4314C80.0618 60.3344 80.0137 59.9561 80.0392 59.8306C80.0277 59.8184 80.0093 59.8285 79.988 59.8503C80.0035 60.0857 80.0188 60.3221 80.0336 60.5589ZM131.054 39.8634C130.987 39.8079 130.933 39.7772 130.872 39.7236C130.934 39.8371 130.994 39.9521 131.051 40.0686C131.044 40.0701 131.036 40.0716 131.029 40.0731C131.042 40.0852 131.054 40.0924 131.056 40.0809C131.06 40.0616 131.152 40.0406 131.054 39.8634ZM118.686 88.4018C118.661 88.4082 118.635 88.4145 118.61 88.4209C118.649 88.4194 118.688 88.4184 118.726 88.4178C118.713 88.4125 118.7 88.4072 118.686 88.4018ZM101.642 89.4297C101.632 89.4307 101.621 89.4317 101.61 89.4327C101.612 89.4337 101.613 89.4347 101.615 89.4357C101.623 89.4337 101.634 89.4317 101.642 89.4297ZM80.1782 62.8411C80.1856 62.4545 80.1786 62.4592 80.1509 62.5226C80.157 62.6274 80.163 62.7323 80.1691 62.8371C80.1721 62.8387 80.1752 62.8395 80.1782 62.8411ZM79.9449 59.2134C79.9634 59.081 79.9532 58.8218 79.9474 58.7345C79.9372 58.5795 79.9163 58.6283 79.8994 58.5879C79.9151 58.7953 79.9302 59.004 79.9449 59.2134ZM79.5953 55.4016C79.6192 55.5974 79.6424 55.7947 79.6644 55.9947C79.6657 55.9576 79.6696 55.9204 79.6791 55.8896C79.6959 55.8356 79.7792 56.0494 79.7671 55.8081C79.7379 55.6609 79.7033 55.791 79.6686 55.7234C79.6409 55.6688 79.632 55.3817 79.5953 55.4016ZM125.354 88.0165C125.257 88.0374 125.161 88.0583 125.064 88.0792C125.152 88.0785 125.239 88.0779 125.327 88.0772C125.336 88.057 125.345 88.0367 125.354 88.0165ZM132.589 54.146C132.587 54.1585 132.585 54.1709 132.583 54.1834C132.586 54.1811 132.588 54.1723 132.589 54.1543C132.589 54.1516 132.589 54.1487 132.589 54.146ZM79.6925 54.7675C79.6757 54.4383 79.5863 54.398 79.6422 54.6981C79.6541 54.7619 79.6731 54.7672 79.6925 54.7675ZM79.884 58.3864C79.8875 58.2653 79.8984 58.1222 79.8778 58.0123C79.864 57.9392 79.8534 57.9085 79.8455 57.9055C79.8586 58.065 79.8715 58.2255 79.884 58.3864ZM79.4095 52.0066C79.4271 52.0339 79.4444 52.044 79.4549 52.019C79.4847 51.947 79.4379 51.8344 79.3988 51.7694C79.4024 51.8484 79.4058 51.9275 79.4095 52.0066ZM127.191 35.8966C126.914 35.7202 126.441 35.6033 126.641 35.7315C126.882 35.8772 127.633 36.1811 127.191 35.8966ZM98.9819 36.4348C99.3531 36.3845 101.015 36.2982 101.182 36.288C101.844 36.2471 101.455 36.3616 101.344 36.3689C100.877 36.4 100.524 36.3144 100.306 36.4495C100.021 36.4717 100.313 36.4054 100.139 36.4096C99.795 36.4179 99.4207 36.5025 99.0621 36.514C99.0616 36.514 99.0611 36.5141 99.0606 36.5141C99.0352 36.4884 98.9567 36.4637 98.9819 36.4348ZM112.707 35.6375C112.6 35.6435 112.464 35.6863 112.516 35.6898C112.913 35.7163 113.202 35.6095 112.707 35.6375ZM97.0078 36.555C97.6005 36.5061 97.6824 36.5861 97.2084 36.6137C97.0732 36.6216 96.9212 36.5828 97.0078 36.555ZM98.3727 36.4499C98.5301 36.4518 98.4406 36.4965 98.7568 36.4596C98.759 36.4615 98.7611 36.4633 98.7632 36.4652C98.7706 36.4954 98.4876 36.5346 98.3464 36.5406C98.3418 36.5402 98.3752 36.5137 98.3396 36.5148C98.0747 36.5249 97.6595 36.5718 97.6833 36.501C97.9286 36.5284 98.2146 36.4481 98.3727 36.4499ZM125.295 35.2743C125.99 35.4727 126.56 35.564 125.624 35.3001C125.572 35.2875 125.464 35.3154 125.295 35.2743ZM121.816 35.0722C121.421 34.998 119.978 35.1769 120.907 35.1641C121.067 35.1618 120.993 35.1356 121.094 35.1294C121.094 35.1295 121.094 35.1295 121.094 35.1295C121.196 35.1235 122.11 35.1277 121.816 35.0722ZM123.206 35.0342C123.206 35.0343 123.206 35.0344 123.206 35.0345C123.408 35.0261 123.608 35.0241 123.811 35.0291C123.617 35.0137 123.425 35.0047 123.23 35.0017C123.222 35.0126 123.214 35.0233 123.206 35.0342ZM107.65 35.8334C107.426 35.8398 107.139 35.9317 107.656 35.8911C107.679 35.8892 107.874 35.8298 108.019 35.8534C108.113 35.8702 108.034 35.894 108.159 35.9124C108.159 35.9124 108.158 35.9124 108.158 35.9125C108.283 35.9306 108.627 35.8055 107.65 35.8334ZM101.775 36.2925C101.86 36.2303 102.413 36.2308 102.676 36.2078C102.439 36.2735 102.118 36.2768 101.775 36.2925ZM105.37 35.9704C105.472 35.9803 105.413 36.0217 105.556 36.0246C105.556 36.0247 105.556 36.0248 105.556 36.0249C105.699 36.0279 106.117 36.0206 106.276 35.9983C106.436 35.976 106.423 35.9197 106.554 35.8914C106.155 35.917 105.77 35.9432 105.37 35.9704ZM111.678 35.6752C111.882 35.6508 112.087 35.6263 112.291 35.6019C112.171 35.5953 112.049 35.589 111.929 35.5824C111.846 35.6133 111.762 35.6444 111.678 35.6752ZM114.523 35.4949C114.792 35.5243 115.02 35.3284 114.582 35.433C114.54 35.4432 114.503 35.4927 114.523 35.4949ZM103.84 36.0287C103.741 36.108 104.029 36.1021 104.141 36.0949C104.544 36.0689 104.765 36.1204 104.953 36.0373C104.726 36.0054 104.546 36.065 104.43 36.0656C104.176 36.0663 104.184 36.0051 103.84 36.0287ZM128.56 36.5079C128.576 36.5607 128.505 36.6259 128.632 36.7379C128.835 36.9158 129.068 37.0601 128.985 36.9295C128.961 36.887 128.563 36.5468 128.56 36.5079ZM111.396 35.5366C111.356 35.5863 111.369 35.6277 111.604 35.645C111.665 35.5952 111.539 35.5663 111.396 35.5366ZM131.763 40.8993C131.718 40.6819 131.556 40.3657 131.588 40.5318C131.622 40.6959 131.82 41.1667 131.763 40.8993ZM100.534 35.9434C100.881 35.8439 100.599 35.8272 101.225 35.8737C100.547 35.9927 101.438 36.0011 101.406 36.0789C101.387 36.1228 101.087 36.1118 100.984 36.1391C100.825 36.1812 101.009 36.2281 100.829 36.2587C100.649 36.2892 100.071 36.2749 99.8767 36.2859C99.5062 36.3073 99.1785 36.3507 98.8691 36.3687C98.5598 36.3867 98.0913 36.373 97.8934 36.3788C97.6958 36.3846 97.4987 36.4028 97.4649 36.4091C97.2643 36.4463 97.3687 36.5024 97.0984 36.5177C97.0919 36.4578 96.7367 36.3806 97.1396 36.3239C97.0826 36.3252 97.0136 36.3172 96.9582 36.3215C96.6976 36.342 96.8254 36.4185 96.701 36.4392C96.4899 36.4742 96.6453 36.4012 96.6419 36.3985C96.4487 36.359 96.5397 36.4118 96.4467 36.4423C96.398 36.4579 96.0001 36.5071 95.9177 36.5097C95.8362 36.5123 95.9466 36.4741 95.8922 36.4752C95.6559 36.4805 95.4134 36.4844 95.1751 36.5039C94.937 36.5236 94.7946 36.5875 94.8127 36.5047C94.8164 36.4917 94.9505 36.4726 94.9133 36.4448C94.9133 36.4446 94.9133 36.4445 94.9133 36.4443C94.9008 36.4353 94.7161 36.3985 94.9888 36.3564C95.0661 36.3445 95.1489 36.336 95.2334 36.3304C95.2007 36.3432 95.1679 36.356 95.1352 36.3688C95.2 36.366 95.2644 36.3635 95.3288 36.3609C95.2873 36.3917 95.2431 36.4241 95.2128 36.4533C95.2918 36.4802 95.3908 36.4344 95.405 36.434C95.6249 36.4345 95.5916 36.4953 95.7566 36.4172C95.6084 36.4143 95.4632 36.4099 95.3202 36.4051C95.3262 36.3903 95.3324 36.3753 95.3379 36.3605C95.3669 36.3593 95.396 36.3582 95.4252 36.357C95.4112 36.3459 95.3972 36.3346 95.3832 36.3235C95.5926 36.3173 95.8085 36.3249 95.9971 36.336C95.9278 36.3561 95.8512 36.3787 95.7827 36.3999C96.0429 36.3724 95.8875 36.4164 96.0645 36.427C96.1257 36.354 96.223 36.3652 96.3739 36.3623C96.5246 36.3593 96.3367 36.3175 96.492 36.3032C96.8078 36.2742 97.3243 36.33 97.425 36.2237C97.813 36.266 97.3221 36.3002 97.2892 36.3266C97.1524 36.4395 97.9869 36.352 98.1242 36.2868C98.2319 36.3152 98.2235 36.3631 98.5348 36.3342C98.9568 36.295 98.0621 36.2836 98.6329 36.2445C99.0148 36.2184 98.9511 36.2719 99.1368 36.2742C99.4829 36.2783 100.11 36.2201 99.9046 36.1598C99.8217 36.1358 99.5478 36.1867 99.4517 36.162C99.3987 36.1482 99.5573 35.9951 99.2094 36.1254C99.1757 36.1384 99.3381 36.1828 99.074 36.1978C98.9982 36.2021 98.7561 36.1671 98.5384 36.1924C98.4431 36.2035 98.0328 36.2911 97.7998 36.2789C97.5478 36.2662 97.9434 36.2321 97.851 36.2139C97.7578 36.1958 97.4387 36.2144 97.4592 36.1655C97.6426 36.1015 97.6469 36.1857 97.7047 36.1789C97.9263 36.1518 97.763 36.0779 98.0772 36.0713C98.1165 36.1139 97.8104 36.2488 98.2802 36.194C98.2825 36.1919 98.1774 36.1694 98.329 36.1518C98.5928 36.1211 99.0939 36.0845 99.4136 36.0696C99.4041 36.0038 99.0117 36.0288 98.8216 35.9929C99.2548 35.959 99.739 35.9136 100.041 35.961C99.8768 35.9786 99.7121 35.9964 99.5485 36.014C99.7404 36.0009 99.9328 35.9879 100.124 35.9748C100.047 36.0067 99.606 36.0994 99.907 36.0993C99.9444 36.0254 100.369 35.9907 100.534 35.9434ZM101.072 89.7744C101.077 89.7789 101.082 89.7834 101.086 89.7877C101.29 89.7757 101.493 89.7674 101.695 89.7608C101.487 89.7653 101.28 89.7699 101.072 89.7744ZM94.6675 36.6006C94.7732 36.6038 94.8929 36.6033 95.0037 36.6042C94.9106 36.6564 94.7917 36.6557 94.6189 36.6347C94.6378 36.6233 94.6467 36.612 94.6675 36.6006ZM121.6 34.9703C121.57 34.9646 120.86 35.0121 120.846 35.0491C120.966 35.0544 121.818 35.0131 121.6 34.9703ZM93.5344 36.6567C93.7938 36.6447 94.0522 36.6352 94.3103 36.6254C94.1411 36.6899 93.3828 36.6917 93.5344 36.6567ZM133.838 68.9527C133.829 68.873 133.819 68.7951 133.809 68.7378C133.806 68.8008 133.806 68.8672 133.808 68.9349C133.818 68.9409 133.828 68.9468 133.838 68.9527ZM124.385 34.925C124.309 34.9085 124.231 34.8931 124.153 34.8785C124.155 34.8953 124.157 34.9125 124.159 34.9293C124.321 34.9289 124.483 34.9326 124.645 34.9409C124.589 34.9228 124.532 34.9051 124.476 34.8882C124.446 34.9002 124.415 34.9127 124.385 34.925ZM80.2875 71.401C80.3022 71.5012 80.3177 71.6443 80.3323 71.797C80.338 71.6881 80.3438 71.5793 80.3495 71.4705C80.3284 71.4121 80.3073 71.3537 80.2861 71.2954C80.2866 71.3306 80.2871 71.3658 80.2875 71.401ZM111.806 89.3959C111.699 89.3072 112.001 89.2292 112.253 89.1969C112.217 89.1893 112.182 89.1818 112.146 89.1742C112.13 89.1754 112.113 89.1766 112.097 89.1778C112.011 89.209 111.925 89.2402 111.839 89.2714C111.688 89.2574 111.537 89.2434 111.386 89.2293C111.313 89.2347 111.241 89.2401 111.169 89.2454C111.12 89.2823 111.07 89.3191 111.021 89.356C110.91 89.3514 110.8 89.3467 110.689 89.3421C110.848 89.369 111.106 89.4084 111.251 89.3477C111.323 89.3172 111.195 89.2259 111.538 89.2487C111.791 89.2656 111.526 89.3645 111.806 89.3959ZM108.654 35.5629C108.006 35.5253 107.858 35.6758 107.805 35.6929C107.532 35.7812 107.486 35.6582 107.427 35.6614C107.145 35.6795 107.453 35.7985 107.491 35.7989C108.095 35.8051 107.96 35.706 108.03 35.67C108.184 35.5921 108.586 35.6278 108.654 35.5629ZM112.954 89.2398C112.996 89.208 113.037 89.1763 113.079 89.1445C112.957 89.1582 112.835 89.1719 112.713 89.1856C112.803 89.2001 112.818 89.2286 112.884 89.2446C112.907 89.243 112.93 89.2414 112.954 89.2398ZM121.227 34.5272C120.848 34.5141 120.512 34.6355 120.716 34.6672C120.836 34.6857 121.167 34.5996 121.085 34.6765C120.525 34.6741 120.577 34.7336 120.585 34.7441C120.641 34.8196 120.223 34.8665 120.259 34.9302C120.279 34.966 120.728 34.9251 120.899 34.925C120.972 34.925 120.978 34.9561 120.991 34.9564C121.159 34.9591 121.257 34.9231 121.428 34.912C121.507 34.907 121.558 34.9516 121.665 34.9294C121.771 34.907 122.092 34.8216 122.112 34.7916C122.147 34.7378 121.831 34.7126 121.568 34.7686C121.44 34.7959 121.524 34.8674 121.157 34.8447C121.108 34.8417 120.91 34.7739 120.725 34.7888C120.956 34.729 121.695 34.6904 122.005 34.6871C122.039 34.6305 121.52 34.679 121.322 34.6631C121.155 34.6497 121.258 34.529 121.227 34.5272ZM103.948 89.701C103.942 89.7056 103.935 89.7101 103.929 89.7147C103.953 89.7464 103.989 89.7869 104.152 89.7814C104.084 89.7546 104.016 89.7278 103.948 89.701ZM110.352 89.3477C110.383 89.3421 110.418 89.337 110.458 89.3325C110.4 89.33 110.343 89.3276 110.286 89.3251C110.308 89.3326 110.33 89.3402 110.352 89.3477ZM132.702 48.4934C132.649 48.6949 132.67 49.4525 132.712 48.9647C132.723 48.8407 132.706 48.6437 132.702 48.4934ZM80.5889 76.3505C80.5882 76.3314 80.5875 76.3124 80.5868 76.2933C80.5842 76.2859 80.5815 76.2785 80.5789 76.2711C80.5822 76.2974 80.5856 76.3244 80.5889 76.3505ZM107.839 89.5453C107.807 89.585 108.296 89.5252 108.401 89.5063C108.446 89.4981 108.479 89.4787 108.517 89.4623C108.508 89.4581 108.499 89.4539 108.489 89.4496C108.402 89.4567 108.323 89.4632 108.254 89.4689C108.124 89.4799 107.993 89.4909 107.863 89.502C107.86 89.5143 107.853 89.5287 107.839 89.5453ZM93.7674 36.4622C93.5536 36.3785 94.4477 36.3414 94.804 36.3359C94.7208 36.3398 94.6366 36.3438 94.5533 36.3479C94.5874 36.3662 94.6162 36.3851 94.6503 36.4034C94.5578 36.4108 94.4662 36.418 94.3737 36.4254C94.4786 36.4407 94.5719 36.4592 94.672 36.4748C94.4235 36.5766 94.4139 36.521 94.0717 36.526C93.8522 36.5293 93.7627 36.5643 93.4891 36.5812C92.2105 36.6604 90.8926 36.7713 89.5835 36.8266C89.5923 36.7521 89.6247 36.7321 89.8679 36.7092C89.8554 36.7318 89.8458 36.7545 89.8342 36.7771C89.9948 36.7607 90.1536 36.7429 90.3105 36.7247C90.1654 36.7196 90.0213 36.7143 89.8799 36.7081C89.9534 36.7014 90.0456 36.6941 90.1609 36.6852C90.2457 36.6786 90.2709 36.6471 90.385 36.6444C90.629 36.6386 90.9367 36.7121 91.2083 36.6738C91.3658 36.6516 91.1658 36.5797 91.5351 36.5831C91.307 36.6558 91.146 36.7168 91.721 36.6614C91.3973 36.626 91.6553 36.6331 91.7799 36.5987C91.858 36.5767 91.3714 36.6097 91.6899 36.5582C91.7545 36.5478 92.7393 36.4599 92.6914 36.5134C92.5898 36.6283 92.5426 36.6183 93.182 36.5215C92.3907 36.5205 93.1282 36.4082 93.4779 36.4207C93.6557 36.4271 93.3405 36.4953 93.7674 36.4622ZM124.509 88.5731C124.68 88.5718 124.86 88.5304 125.04 88.5012C124.987 88.4938 124.934 88.4864 124.881 88.479C124.822 88.5046 124.763 88.5302 124.704 88.5558C124.626 88.5552 124.548 88.5544 124.47 88.5538C124.463 88.5645 124.464 88.5735 124.509 88.5731ZM110.631 35.4286C110.619 35.4074 110.897 35.274 110.458 35.3894C110.307 35.4294 110.326 35.4609 109.926 35.4867C110.298 35.4573 110.214 35.5515 110.252 35.5562C110.563 35.5943 110.945 35.4675 110.896 35.4234C110.881 35.4107 110.644 35.4496 110.631 35.4286ZM107.398 89.5394C107.391 89.54 107.382 89.5406 107.374 89.5412C107.381 89.5414 107.388 89.5415 107.395 89.5417C107.396 89.541 107.397 89.5402 107.398 89.5394ZM123.964 88.6004C124.121 88.6114 124.25 88.6187 124.347 88.5525C124.203 88.5511 124.059 88.5497 123.915 88.5483C123.932 88.5657 123.948 88.5831 123.964 88.6004ZM128.891 36.3448C128.596 36.1145 128.611 36.2091 128.66 36.2908C128.454 36.1542 128.247 36.0267 128.033 35.9069C128.624 36.2793 128.554 36.3483 128.512 36.4295C128.728 36.602 128.617 36.436 128.843 36.6209C128.922 36.687 128.892 36.7156 128.905 36.7301C129.064 36.9058 129.175 36.8484 129.074 36.7477C128.972 36.6462 128.689 36.4619 128.657 36.3819C128.866 36.5076 129.009 36.6574 129.235 36.8328C129.501 37.044 129.336 36.8208 129.245 36.7641C129.064 36.653 129.138 36.7688 128.878 36.5131C128.653 36.2977 129.12 36.5285 128.891 36.3448ZM88.3058 36.8508C88.0927 36.7735 88.8978 36.8003 88.9814 36.7974C89.2257 36.7889 89.2952 36.7353 89.4722 36.7596C89.488 36.7625 89.318 36.8225 89.1994 36.831C89.0797 36.8395 88.3283 36.8576 88.3058 36.8508ZM125.818 88.5659C125.701 88.5599 125.765 88.5087 125.532 88.5456C125.53 88.5433 125.529 88.5409 125.527 88.5386C125.521 88.5024 125.73 88.4619 125.834 88.458C125.838 88.4583 125.814 88.4896 125.84 88.4892C125.877 88.488 125.917 88.4855 125.959 88.4827C126.147 88.4705 126.352 88.4435 126.342 88.5123C126.215 88.4923 126.078 88.5259 125.963 88.5479C125.907 88.559 125.857 88.5679 125.818 88.5659ZM115.704 89.1292C115.727 89.1349 115.741 89.1303 115.744 89.0883C115.709 89.0876 115.674 89.0869 115.639 89.0861C115.661 89.1005 115.682 89.1149 115.704 89.1292ZM103.647 35.8871C103.756 35.9288 103.966 35.9017 104.214 35.8812C104.193 35.8655 104.172 35.8498 104.151 35.8341C103.984 35.8517 103.815 35.8696 103.647 35.8871ZM126.486 35.3307C126.487 35.3308 126.487 35.331 126.488 35.3312C126.548 35.3552 126.609 35.3803 126.669 35.4057C126.75 35.4189 126.833 35.4339 126.914 35.4495C126.878 35.424 126.842 35.3989 126.805 35.3738C126.699 35.3575 126.593 35.3434 126.486 35.3307ZM88.2156 36.8313C87.9159 36.8491 87.6161 36.8668 87.3164 36.8846C87.3167 36.8845 87.3169 36.8845 87.3172 36.8844C87.3303 36.8726 87.3447 36.8609 87.3588 36.849C87.6443 36.8431 87.9301 36.8372 88.2156 36.8313ZM127.246 35.2891C126.907 35.1266 126.329 34.9625 125.93 34.8472C125.693 34.7782 125.71 34.7481 125.467 34.6873C125.105 34.5937 124.459 34.4811 124.106 34.4746C123.979 34.471 124.004 34.5356 124.026 34.5445C124.084 34.5656 124.287 34.5547 124.372 34.5716C124.457 34.5881 124.358 34.6009 124.475 34.6192C124.593 34.6315 125.243 34.7418 125.289 34.7532C125.572 34.7902 125.241 34.6758 125.563 34.7615C125.655 34.9971 124.77 34.6596 124.592 34.6589C123.951 34.6204 124.468 34.7019 124.586 34.7389C124.705 34.7747 124.404 34.7581 124.466 34.7851C124.467 34.7852 124.468 34.7852 124.469 34.7853C124.532 34.8089 124.976 34.8891 125.033 34.8882C125.156 34.8795 124.763 34.7749 125.089 34.8172C125.493 34.9051 125.9 35.0235 126.29 35.1665C126.287 35.1358 126.283 35.105 126.28 35.0745C126.187 35.0521 126.092 35.0307 125.999 35.0114C125.93 34.9805 125.861 34.9506 125.791 34.9216C126.266 34.9002 126.727 35.2333 127.423 35.5033C127.371 35.5129 127.323 35.5265 127.268 35.535C128.209 36.071 127.595 35.7026 127.653 35.6403C127.687 35.6053 127.955 35.8043 128.023 35.8383C128.5 36.0684 127.597 35.4335 127.246 35.2891ZM119.44 34.8638C120.623 34.7083 118.602 34.8174 118.468 34.8609C118.217 34.9433 119.121 34.8582 119.235 34.869C119.347 34.8801 119.284 34.9674 119.601 34.913C119.722 34.8923 119.586 34.8607 119.44 34.8638ZM116.568 35.1013C116.417 35.0826 116.122 35.0415 115.917 35.0934C116.195 35.1084 116.199 35.1359 116.568 35.1013ZM89.8799 36.7081C89.8759 36.7085 89.8717 36.7088 89.8679 36.7092C89.8681 36.7088 89.869 36.7083 89.8693 36.7079C89.8693 36.7078 89.8693 36.7077 89.8693 36.7076C89.8728 36.7077 89.8764 36.708 89.8799 36.7081ZM106.881 89.6672C106.791 89.6717 106.702 89.6762 106.613 89.6808C106.612 89.6821 106.61 89.6838 106.609 89.6852C106.715 89.6817 106.821 89.6781 106.927 89.6746C106.912 89.6721 106.896 89.6696 106.881 89.6672ZM132.729 44.7556C132.585 44.4656 132.706 45.0606 132.665 45.3447C132.665 45.3442 132.665 45.3437 132.665 45.3432C132.653 45.4279 132.573 45.066 132.593 45.4615C132.624 45.7066 132.648 45.501 132.68 45.6178C132.713 45.7357 132.734 46.4439 132.781 46.0308C132.796 45.9025 132.695 44.9799 132.729 44.7556ZM132.696 47.1708C132.723 47.7102 132.802 47.7935 132.742 47.2942C132.73 47.1874 132.713 47.1751 132.696 47.1708ZM80.785 83.1802C80.7615 83.0409 80.6517 82.5606 80.6005 82.0234C80.5098 81.1258 80.426 80.0982 80.6325 80.5719C80.6353 80.5782 80.6371 80.582 80.6376 80.5791C80.6862 80.2546 80.2813 79.5046 80.5519 79.0711C80.5614 79.0558 80.5689 79.0436 80.5694 79.0376C80.5718 79.0118 80.5607 78.9315 80.548 78.8388C80.5274 78.6893 80.5023 78.5066 80.5214 78.4651C80.5373 78.5267 80.5456 78.6212 80.5532 78.7093C80.5579 78.7638 80.5625 78.8159 80.5685 78.8564C80.5765 78.9107 80.5878 78.9457 80.5992 78.9806C80.6158 79.0322 80.6325 79.0841 80.6385 79.1972C80.6537 79.479 80.6085 79.3588 80.5881 79.3045C80.5829 79.2908 80.5793 79.2816 80.5787 79.2839C80.5789 79.2927 80.5791 79.3015 80.5792 79.3103C80.5843 79.5967 80.588 79.8064 80.644 80.0456C80.6657 80.0763 80.6601 80.0146 80.6534 79.9431C80.6478 79.8825 80.6413 79.8145 80.6505 79.79C80.675 79.7341 80.6764 79.9941 80.6771 80.1108C80.6772 80.1354 80.6774 80.1539 80.6777 80.1614C80.6829 80.2358 80.6892 80.2813 80.6946 80.319C80.7056 80.3969 80.7119 80.4418 80.6928 80.643C80.6906 80.6679 80.6858 80.6732 80.6816 80.6776C80.6721 80.6879 80.6661 80.6953 80.7036 80.9323C80.6302 80.7357 80.6288 81.1267 80.6789 81.4065C80.6868 81.4495 80.6985 81.4777 80.7104 81.5065C80.7347 81.5651 80.76 81.6269 80.7575 81.8216C80.7556 81.9259 80.7136 81.9 80.708 81.8698C80.7062 81.8597 80.7059 81.8357 80.7057 81.8081C80.7051 81.753 80.7044 81.6837 80.6906 81.6806C80.6887 81.7788 80.6923 81.8972 80.6969 82.0176C80.6982 82.0502 80.6997 82.083 80.7014 82.1155C80.7087 82.2566 80.7192 82.3932 80.724 82.5007C80.7247 82.5205 80.7214 82.524 80.7178 82.5279C80.681 82.5645 80.7779 83.1092 80.8216 83.1492C80.8275 83.1627 80.8334 83.1736 80.839 83.1823C80.8393 83.2397 80.838 83.288 80.8369 83.3387C80.8363 83.3667 80.8358 83.3954 80.8358 83.4273C80.8358 83.4493 80.836 83.4703 80.836 83.4894C80.7843 83.3599 80.8073 83.3152 80.785 83.1802ZM105.815 35.7362C106.087 35.7034 106.359 35.6708 106.63 35.6382C106.244 35.6664 106.102 35.681 105.885 35.6338C105.862 35.6678 105.838 35.7021 105.815 35.7362ZM129.99 37.2615C129.952 37.358 130.344 37.6871 130.486 37.945C130.53 38.0209 130.159 37.6948 130.459 38.1037C130.459 38.104 130.459 38.1042 130.459 38.1044C130.559 38.2332 130.959 38.7521 131.041 38.9452C131.125 39.0063 130.988 38.5208 130.944 38.4462C130.683 37.966 130.327 37.6729 129.99 37.2615ZM95.3379 36.3605C95.335 36.3606 95.3317 36.3607 95.3288 36.3609C95.333 36.3578 95.337 36.3546 95.3411 36.3516C95.34 36.3545 95.3389 36.3575 95.3379 36.3605ZM104.433 89.9464C104.673 89.9707 105.021 89.8699 104.846 89.8288C104.635 89.7799 104.043 89.9068 104.433 89.9464ZM133.101 52.1987C133.127 52.0128 133.03 51.5696 133.005 51.6926C132.97 51.8654 133.096 52.2355 133.101 52.1987ZM107.751 35.4965C107.456 35.508 107.257 35.5862 107.295 35.6292C107.495 35.6102 107.694 35.591 107.893 35.572C107.846 35.5469 107.798 35.5216 107.751 35.4965ZM124.229 89.1211C123.975 89.2321 124.185 89.2585 123.72 89.1884C124.219 89.062 123.558 89.0312 123.579 88.9391C123.592 88.887 123.815 88.9072 123.89 88.877C124.007 88.8304 123.869 88.7699 124.002 88.7375C124.135 88.7052 124.563 88.7358 124.707 88.7271C124.981 88.7102 125.223 88.666 125.452 88.6516C125.603 88.6421 125.807 88.6508 125.969 88.6571C126.057 88.66 126.134 88.661 126.186 88.6589C126.341 88.6528 126.493 88.6266 126.519 88.6181C126.672 88.5679 126.585 88.5053 126.792 88.4756C126.803 88.5469 127.094 88.6195 126.784 88.7081C126.829 88.7039 126.885 88.7096 126.928 88.7013C127.132 88.6604 127.018 88.5776 127.112 88.5443C127.27 88.487 127.163 88.5843 127.165 88.5881C127.324 88.619 127.243 88.564 127.31 88.5199C127.345 88.4984 127.643 88.3984 127.705 88.3835C127.767 88.3703 127.692 88.4286 127.733 88.4206C127.914 88.3846 128.103 88.3428 128.279 88.2791C128.455 88.2146 128.54 88.1122 128.556 88.2103C128.558 88.2259 128.461 88.274 128.5 88.2988C128.5 88.2989 128.5 88.2991 128.5 88.2993C128.512 88.3072 128.669 88.3132 128.471 88.4145C128.415 88.4428 128.353 88.4677 128.289 88.4888C128.311 88.4684 128.331 88.4481 128.352 88.4276C128.303 88.4423 128.254 88.4565 128.205 88.4702C128.228 88.4276 128.251 88.3831 128.265 88.3442C128.195 88.3267 128.133 88.3961 128.122 88.3982C128.123 88.3983 128.123 88.3984 128.123 88.3985C127.952 88.4325 127.961 88.356 127.854 88.4702C127.97 88.4531 128.085 88.436 128.197 88.4177C128.197 88.4359 128.198 88.4541 128.198 88.4722C128.176 88.4785 128.152 88.4849 128.13 88.491C128.144 88.5016 128.159 88.5121 128.173 88.5226C128.01 88.5645 127.837 88.5864 127.686 88.5964C127.736 88.5645 127.79 88.5282 127.838 88.4943C127.642 88.5603 127.752 88.4888 127.612 88.4979C127.581 88.5905 127.501 88.5892 127.383 88.6074C127.265 88.6251 127.42 88.6567 127.301 88.6878C127.055 88.7533 126.639 88.7101 126.568 88.838C126.254 88.7966 126.645 88.7448 126.666 88.7108C126.76 88.5751 126.118 88.6973 126.009 88.7666C125.996 88.7613 125.985 88.7555 125.975 88.7495C125.922 88.7152 125.896 88.6774 125.7 88.7006C125.389 88.7377 126.052 88.7718 125.63 88.8053C125.348 88.8275 125.394 88.7652 125.256 88.7581C125 88.7453 124.536 88.8001 124.69 88.8769C124.752 88.9078 124.954 88.8533 125.026 88.8851C125.065 88.903 124.952 89.0818 125.206 88.9344C125.231 88.9197 125.11 88.8629 125.305 88.851C125.361 88.8478 125.542 88.895 125.702 88.8697C125.742 88.8634 125.856 88.8303 125.978 88.8064C126.08 88.7877 126.185 88.7724 126.266 88.7784C126.466 88.792 126.154 88.8348 126.229 88.856C126.305 88.8785 126.558 88.8502 126.546 88.9084C126.403 88.9892 126.394 88.8881 126.349 88.8969C126.172 88.9302 126.308 89.0196 126.052 89.0248C126.023 88.9786 126.215 88.847 125.982 88.8633C125.958 88.8649 125.928 88.8683 125.894 88.8738C125.889 88.8754 125.971 88.9054 125.858 88.9232C125.663 88.9537 125.292 88.986 125.056 88.9965C125.065 89.0753 125.356 89.0544 125.498 89.1016C125.178 89.1321 124.82 89.1753 124.594 89.1117C124.716 89.0945 124.838 89.0769 124.959 89.0597C124.817 89.0709 124.674 89.082 124.533 89.0931C124.589 89.0568 124.913 88.9563 124.691 88.9494C124.665 89.0368 124.35 89.0684 124.229 89.1211ZM121.777 88.9428C121.849 88.8502 121.634 88.8505 121.551 88.8566C121.254 88.8782 121.088 88.8116 120.952 88.9065C121.121 88.95 121.253 88.8829 121.339 88.8849C121.527 88.8899 121.523 88.9629 121.777 88.9428ZM95.3832 36.3235C95.3327 36.325 95.2826 36.3272 95.2334 36.3304C95.2403 36.3277 95.2471 36.325 95.254 36.3223C95.1608 36.3207 95.0683 36.3193 94.9751 36.3178C95.0927 36.3047 95.2095 36.2915 95.3261 36.2783C95.3451 36.2934 95.3642 36.3085 95.3832 36.3235ZM108.48 89.6691C108.746 89.7572 109.634 89.6199 109.307 89.5869C109.225 89.592 109.142 89.5971 109.06 89.6022C109.052 89.609 109.043 89.6154 109.014 89.6174C109.014 89.6173 109.013 89.6172 109.013 89.6171C108.938 89.622 108.261 89.596 108.48 89.6691ZM105.903 89.7886C105.364 89.79 104.952 89.9469 105.664 89.8709C105.703 89.8664 105.772 89.7935 105.903 89.7886ZM107.453 89.6965C107.305 89.7144 107.157 89.7326 107.01 89.7507C107.152 89.746 107.295 89.7411 107.437 89.7366C107.442 89.7233 107.447 89.7099 107.453 89.6965ZM115.977 89.1835C115.926 89.1918 115.874 89.2002 115.823 89.2086C115.824 89.2092 115.825 89.2098 115.826 89.2105C115.818 89.2109 115.81 89.2114 115.803 89.2119C115.71 89.2269 115.617 89.2418 115.525 89.2568C115.615 89.2674 115.705 89.2779 115.794 89.2885C115.854 89.2535 115.917 89.2183 115.977 89.1835ZM132.818 48.0885C132.84 48.3396 132.836 48.7425 132.897 48.7928C132.894 48.6032 132.892 48.4134 132.89 48.2238C132.866 48.1791 132.842 48.1333 132.818 48.0885ZM118.959 89.0876C119.125 89.0852 119.334 88.9822 118.952 89.0187C118.935 89.0207 118.792 89.0867 118.684 89.0552C118.659 89.0471 118.651 89.0381 118.646 89.0291C118.609 89.0406 118.571 89.052 118.534 89.0634C118.605 89.0797 118.735 89.0909 118.959 89.0876ZM110.983 35.1699C110.703 35.2294 110.441 35.2483 110.083 35.2545C109.98 35.314 109.877 35.3734 109.775 35.4329C110.327 35.4055 109.926 35.3414 110.407 35.3248C110.469 35.296 110.197 35.3245 110.245 35.3074C110.477 35.2242 110.798 35.2971 111.122 35.2394C111.077 35.2163 111.029 35.1931 110.983 35.1699ZM129.448 87.737C129.264 87.8216 129.077 87.8974 128.889 87.967C128.991 87.8613 129.541 87.6596 129.448 87.737ZM117.226 89.1192C117.438 89.3064 117.899 89.2232 117.88 89.1046C117.754 89.1114 117.627 89.1182 117.501 89.125C117.409 89.123 117.317 89.1211 117.226 89.1192ZM106.751 35.6C106.911 35.5938 107.072 35.5876 107.233 35.5813C107.24 35.57 107.248 35.5587 107.255 35.5475C107.095 35.5538 106.935 35.5598 106.775 35.566C106.768 35.5773 106.759 35.5887 106.751 35.6ZM113.875 89.3328C113.674 89.2915 113.51 89.5203 113.831 89.4056C113.862 89.3945 113.889 89.3363 113.875 89.3328ZM119.769 89.0436C120.064 89.0223 120.348 88.9999 120.644 88.9767C120.608 88.9698 120.599 88.9548 120.588 88.9405C120.409 88.9537 120.23 88.9668 120.052 88.98C119.991 88.9783 119.93 88.9765 119.869 88.9748C119.843 88.9999 119.821 89.027 119.769 89.0436ZM116.19 89.3556C116.219 89.2972 116.208 89.2474 116.033 89.2214C115.99 89.2794 116.084 89.3168 116.19 89.3556ZM103.56 35.7405C103.779 35.7205 104.131 35.7396 104.161 35.6839C103.973 35.6856 103.784 35.6874 103.595 35.6892C103.583 35.7062 103.571 35.7234 103.56 35.7405ZM113.704 35.0307C113.445 35.0368 112.705 35.1783 113.478 35.0892C113.482 35.1057 113.487 35.1221 113.491 35.1386C113.562 35.1027 113.633 35.0666 113.704 35.0307ZM107.217 35.4659C107.322 35.4727 107.426 35.4796 107.529 35.4865C107.632 35.4493 107.737 35.4122 107.841 35.375C107.633 35.4052 107.425 35.4357 107.217 35.4659ZM102.693 35.7741C102.861 35.7565 103.029 35.7391 103.197 35.7215C103.041 35.7221 102.884 35.7223 102.729 35.7229C102.717 35.7399 102.705 35.757 102.693 35.7741ZM123.934 34.5065C123.395 34.4194 123.594 34.4633 123.27 34.498C123.052 34.5239 122.818 34.4803 122.856 34.555C123.233 34.5071 123.872 34.5816 123.934 34.5065ZM116.498 34.9205C116.842 34.8335 115.585 34.8459 115.524 34.9927C115.762 34.9731 116.336 34.9613 116.498 34.9205ZM103.363 90.2292C103.329 90.1918 103.336 90.0763 103.212 90.0678C103.013 90.0547 102.818 90.1168 102.928 90.1661C102.962 90.1809 103.343 90.1905 103.363 90.2292ZM129.365 88.0148C129.567 88.0514 128.9 88.3309 128.622 88.4017C128.685 88.3803 128.749 88.3577 128.812 88.3348C128.779 88.3214 128.75 88.3065 128.717 88.2929C128.785 88.2649 128.853 88.2362 128.921 88.2065C128.835 88.2133 128.756 88.2131 128.674 88.2162C128.825 88.0478 128.853 88.1102 129.108 88.022C129.271 87.9636 129.324 87.9018 129.517 87.8072C130.423 87.3601 131.254 86.7229 131.999 86.0189C132.054 86.089 132.051 86.1246 131.917 86.2661C131.907 86.2395 131.896 86.2136 131.885 86.1876C131.799 86.281 131.713 86.373 131.627 86.4632C131.723 86.4001 131.818 86.3364 131.911 86.2725C131.87 86.3148 131.817 86.3666 131.751 86.4297C131.702 86.4762 131.71 86.5171 131.638 86.5732C131.484 86.6937 131.229 86.76 131.073 86.9104C130.982 86.9971 131.167 86.9868 130.912 87.1343C131.021 86.9677 131.09 86.846 130.733 87.1289C130.979 87.037 130.797 87.1328 130.732 87.2159C130.692 87.2693 131.008 87.0432 130.82 87.2216C130.785 87.2658 130.134 87.7125 130.135 87.6342C130.144 87.4762 130.19 87.4791 129.773 87.782C130.352 87.5322 129.875 87.8935 129.602 87.9798C129.466 88.023 129.67 87.861 129.365 88.0148ZM108.643 89.7959C108.667 89.8032 109.19 89.763 109.2 89.7193C109.11 89.7101 108.48 89.7397 108.643 89.7959ZM114.749 34.997C114.853 34.9503 114.373 34.9747 114.319 34.9891C114.105 35.0462 114.643 35.0437 114.749 34.997ZM129.548 36.8176C129.504 36.7703 129.174 36.4895 129.144 36.4991C129.584 37.0211 129.899 37.1889 129.548 36.8176ZM118.222 89.3878C118.703 89.4476 118.809 89.2713 118.848 89.252C119.048 89.1528 119.085 89.3008 119.129 89.2983C119.337 89.2832 119.105 89.134 119.077 89.1326C118.629 89.1112 118.733 89.2327 118.682 89.274C118.57 89.3637 118.27 89.3118 118.222 89.3878ZM99.3675 90.3806C99.5296 90.4032 99.7832 90.3534 99.6607 90.3211C99.5378 90.2888 99.1671 90.3525 99.3675 90.3806ZM132.718 85.3167C132.907 85.2584 132.431 85.6897 132.381 85.7323C132.246 85.8693 132.248 85.9517 132.121 86.0216C132.109 86.0271 132.163 85.8883 132.225 85.8192C132.292 85.7533 132.702 85.328 132.718 85.3167ZM81.0778 84.4811C81.1711 84.754 81.0451 84.7462 81.0459 84.4359C81.046 84.4244 81.0462 84.4126 81.0462 84.4002C81.0568 84.4232 81.0672 84.4491 81.0778 84.4811ZM106.61 89.9637C106.667 89.9684 106.725 89.9728 106.782 89.9774C106.779 89.9578 106.774 89.9379 106.77 89.9183C106.655 89.9452 106.54 89.9723 106.425 89.9993C106.467 90.0078 106.51 90.0164 106.553 90.0249C106.572 90.0046 106.591 89.984 106.61 89.9637ZM132.785 85.2811C132.934 85.0957 133.076 84.9043 133.21 84.7084C133.21 84.7089 133.21 84.7094 133.209 84.7098C133.214 84.7263 133.218 84.7431 133.222 84.7603C133.083 84.9391 132.937 85.1133 132.785 85.2811ZM108.932 90.334C109.213 90.3583 109.46 90.2208 109.307 90.1782C109.218 90.1535 108.974 90.2488 109.033 90.1587C109.448 90.1747 109.407 90.1026 109.401 90.0898C109.357 89.9982 109.666 89.9518 109.638 89.8748C109.622 89.8315 109.291 89.87 109.164 89.8661C109.111 89.8643 109.105 89.8282 109.095 89.8266C109.095 89.8266 109.094 89.8267 109.094 89.8267C108.969 89.8195 108.898 89.8601 108.772 89.8695C108.714 89.8736 108.674 89.8192 108.596 89.8432C108.518 89.8676 108.282 89.9619 108.268 89.9973C108.243 90.0609 108.479 90.0984 108.672 90.0377C108.766 90.0081 108.702 89.9205 108.975 89.9561C109.011 89.9608 109.16 90.0464 109.296 90.0331C109.126 90.0991 108.58 90.1281 108.35 90.1248C108.326 90.1917 108.711 90.1455 108.858 90.1691C108.983 90.1889 108.909 90.3306 108.932 90.334ZM116.76 89.5023C116.77 89.5278 116.567 89.681 116.889 89.5531C117 89.5089 116.986 89.4709 117.281 89.4493C117.006 89.4756 117.066 89.3654 117.038 89.3587C116.807 89.306 116.526 89.4486 116.564 89.5024C116.575 89.518 116.75 89.477 116.76 89.5023ZM131.911 86.2725C131.913 86.2704 131.915 86.2681 131.917 86.2661C131.917 86.2665 131.918 86.2669 131.918 86.2673C131.916 86.2688 131.913 86.2709 131.911 86.2725ZM121.924 89.1162C121.842 89.064 121.687 89.0914 121.504 89.1102C121.52 89.1295 121.536 89.1486 121.552 89.1679C121.676 89.1508 121.801 89.1333 121.924 89.1162ZM128.198 88.4722C128.2 88.4716 128.203 88.4709 128.205 88.4702C128.203 88.4745 128.199 88.4791 128.197 88.4833C128.197 88.4797 128.198 88.4758 128.198 88.4722ZM93.745 90.9047C93.5941 90.8377 93.0333 90.8451 93.3963 90.9065C93.4885 90.9219 93.6339 90.9065 93.745 90.9047ZM103.266 90.6276C103.526 90.6251 103.476 90.5514 103.412 90.508C103.584 90.4879 103.755 90.4696 103.926 90.4504C103.435 90.4732 103.443 90.382 103.428 90.2683C103.228 90.2641 103.367 90.337 103.158 90.3358C103.084 90.3352 103.085 90.287 103.071 90.2838C102.9 90.2481 102.875 90.3899 102.976 90.3992C103.079 90.4084 103.316 90.3658 103.37 90.4198C103.201 90.4548 103.054 90.4257 102.853 90.4517C102.614 90.4828 102.809 90.5428 102.882 90.5208C103.028 90.4766 102.934 90.4263 103.192 90.4616C103.413 90.4918 103.061 90.6294 103.266 90.6276ZM120.322 89.2463C120.121 89.2791 119.92 89.3118 119.72 89.3445C120.005 89.3197 120.11 89.3057 120.273 89.3671C120.289 89.3269 120.305 89.2865 120.322 89.2463ZM128.173 88.5226C128.212 88.5126 128.251 88.5015 128.288 88.4892C128.284 88.4934 128.279 88.4978 128.275 88.5021C128.348 88.4878 128.421 88.4726 128.495 88.4564C128.407 88.4941 128.319 88.5307 128.231 88.5657C128.211 88.5515 128.193 88.5369 128.173 88.5226ZM105.08 90.1929C105.033 90.1945 104.985 90.196 104.939 90.1974C104.883 90.2224 104.826 90.2476 104.77 90.2727C104.801 90.2814 104.833 90.29 104.865 90.2987C104.937 90.2635 105.007 90.2281 105.08 90.1929ZM112.369 89.7559C112.481 89.7818 112.701 89.8376 112.851 89.7805C112.645 89.7561 112.641 89.7231 112.369 89.7559ZM118.893 89.4878C119.111 89.481 119.257 89.3924 119.227 89.3401C119.08 89.3582 118.932 89.3764 118.785 89.3945C118.821 89.4256 118.857 89.4567 118.893 89.4878ZM110.246 89.9729C109.374 90.1315 110.871 90.0478 110.968 89.999C111.151 89.9064 110.482 89.9873 110.399 89.9716C110.316 89.9556 110.359 89.8529 110.126 89.9106C110.038 89.9325 110.138 89.9732 110.246 89.9729ZM104.624 90.6203C104.882 90.6056 105.291 90.5153 105.58 90.4987C105.751 90.489 105.747 90.5295 105.919 90.5197C106.177 90.5053 106.629 90.4875 106.87 90.4488C106.958 90.4346 106.933 90.3617 106.916 90.3542C106.873 90.3366 106.736 90.3817 106.675 90.3782C106.615 90.3746 106.68 90.3405 106.597 90.3416C106.514 90.3427 106.056 90.3806 106.023 90.3881C105.827 90.4334 106.071 90.4602 105.839 90.4658C105.721 90.2172 106.392 90.3399 106.511 90.319C106.957 90.2405 106.589 90.2405 106.5 90.2237C106.412 90.2069 106.624 90.1629 106.576 90.1444C106.576 90.1445 106.575 90.1446 106.574 90.1448C106.526 90.1261 106.204 90.1378 106.166 90.1579C106.083 90.2015 106.373 90.217 106.142 90.2561C105.851 90.2663 105.552 90.2763 105.258 90.2866C105.269 90.3193 105.281 90.352 105.291 90.3847C105.357 90.3699 105.425 90.3547 105.491 90.3397C105.544 90.3474 105.597 90.3552 105.65 90.3627C105.348 90.5633 104.96 90.3801 104.441 90.492C104.468 90.4519 104.492 90.4104 104.522 90.3712C103.755 90.3639 104.264 90.388 104.253 90.484C104.247 90.539 104.013 90.501 103.96 90.5124C103.597 90.5928 104.365 90.6352 104.624 90.6203ZM119.631 89.3874C119.512 89.3911 119.393 89.3947 119.275 89.3984C119.27 89.4118 119.264 89.4254 119.259 89.4386C119.378 89.4348 119.496 89.4313 119.614 89.4275C119.619 89.4142 119.626 89.4007 119.631 89.3874ZM116.507 89.8033C116.713 89.7388 116.906 89.7222 117.171 89.723C117.246 89.6544 117.321 89.5859 117.395 89.5174C116.986 89.5373 117.286 89.6228 116.929 89.6315C116.884 89.6645 117.085 89.6367 117.05 89.656C116.88 89.7502 116.64 89.6556 116.402 89.717C116.436 89.7457 116.472 89.7745 116.507 89.8033ZM102.275 90.726C102.239 90.6114 101.888 90.7024 101.683 90.6548C101.622 90.6399 101.961 90.5268 101.601 90.5137C101.484 90.5096 101.023 90.5615 100.874 90.5366C100.809 90.5847 101.159 90.7443 101.217 90.7533C101.597 90.8105 101.903 90.6918 102.275 90.726ZM96.5166 91.0243C96.727 90.8592 96.2894 90.9895 96.0777 90.9341C96.0152 90.9173 96.2816 90.8313 95.9901 90.8454C95.8093 90.8763 95.9616 90.9102 95.8761 90.9461C95.7897 90.9819 95.2646 90.9908 95.5724 91.0569C95.6679 91.0773 96.3489 90.9785 96.5166 91.0243ZM94.7251 90.9293C94.3261 90.949 94.2669 91.0403 94.6353 90.9811C94.7139 90.9685 94.7224 90.9491 94.7251 90.9293ZM121.992 89.2938C121.831 89.3125 121.569 89.2814 121.549 89.3471C121.688 89.3495 121.828 89.3518 121.967 89.354C121.976 89.334 121.985 89.3139 121.992 89.2938ZM122.634 89.2735C122.511 89.2907 122.386 89.3077 122.262 89.3248C122.378 89.3277 122.494 89.3309 122.609 89.3339C122.618 89.3138 122.626 89.2936 122.634 89.2735ZM119.289 89.5369C119.212 89.5264 119.135 89.5156 119.058 89.5051C118.982 89.5471 118.906 89.5891 118.83 89.6311C118.983 89.5998 119.136 89.5682 119.289 89.5369ZM114.494 89.9066C114.687 89.905 115.229 89.7535 114.66 89.842C114.656 89.8222 114.652 89.8024 114.648 89.7826C114.597 89.8238 114.546 89.8654 114.494 89.9066ZM94.0484 91.053C93.8629 91.074 93.5645 91.0599 93.5291 91.1311C93.6694 91.1327 93.8097 91.1345 93.95 91.1361C93.9825 91.1084 94.0159 91.0806 94.0484 91.053ZM112.426 89.9733C112.173 90.0693 113.105 90.0841 113.146 89.91C112.97 89.9279 112.546 89.9284 112.426 89.9733ZM113.72 89.9227C113.644 89.976 113.998 89.9581 114.039 89.9422C114.196 89.8789 113.797 89.8693 113.72 89.9227ZM106.984 90.3869C107.364 90.4307 107.222 90.4016 107.444 90.34C107.594 90.2983 107.76 90.3535 107.731 90.2637C107.467 90.3106 107.018 90.2852 106.984 90.3869ZM102.709 90.7199C102.752 90.722 103.054 90.7082 103.063 90.6785C102.587 90.5537 102.353 90.7029 102.709 90.7199Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M122.985 59.8655L113.36 60.4458L121.405 55.1309L119.384 52.0699L111.338 57.3847L115.647 48.7601L112.365 47.1197L108.057 55.7444L107.476 46.1206L103.815 46.3413L104.396 55.966L99.0799 47.9207L96.0198 49.9425L101.335 57.9869L92.7092 53.678L91.0698 56.9589L99.6951 61.2687L90.0707 61.8489L90.2915 65.5102L99.915 64.93L91.8707 70.2448L93.8925 73.3059L101.937 67.9919L97.6271 76.6166L100.909 78.256L105.218 69.6305L105.799 79.2551L109.46 79.0344L108.88 69.4107L114.193 77.4551L117.254 75.4333L111.94 67.388L120.565 71.6978L122.204 68.416L113.58 64.1071L123.203 63.5269L122.983 59.8656L122.985 59.8655ZM106.938 67.6672C104.178 67.8337 101.805 65.7311 101.639 62.9703C101.472 60.2096 103.575 57.8371 106.336 57.6706C109.096 57.5042 111.469 59.607 111.635 62.3677C111.801 65.1284 109.699 67.5008 106.938 67.6672Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M79.8862 43.1973C82.7846 45.0075 84.4952 48.4161 83.9666 52.0133L80.886 72.9769C80.5274 72.0368 80.324 71.0191 80.3072 69.9547L79.8862 43.1973Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M152.163 41.95C152.422 42.1727 157.679 41.5416 156.414 40.7276C156.007 40.3685 155.55 40.383 155.288 40.8755C155.355 39.9005 154.106 41.1453 153.715 40.8078C154.029 40.1402 152.331 41.483 152.754 40.7931C147.444 39.8042 134.971 45.8342 149.285 42.5314C148.017 42.1648 149.336 41.9571 149.903 42.1348C148.852 42.9578 151.526 42.3273 152.055 42.0509C151.274 42.0312 152.697 41.4548 152.161 41.9477L152.163 41.95Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M144.103 33.2987C144.826 33.2902 148.886 28.6898 149.364 28.2563C150.233 27.1752 148.612 27.0082 148.131 27.9422C147.96 28.0977 147.191 29.4236 146.989 28.83C145.525 29.0606 144.786 31.4609 143.573 31.5539C143.69 31.8803 143.187 32.2387 143.235 32.4555C142.892 32.4019 142.593 32.851 142.668 32.8962C140.902 34.0119 142.442 35.5039 143.632 33.8363C143.677 33.9123 144.152 33.631 144.102 33.3032L144.103 33.2987Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M127.951 23.5219C127.133 24.2779 127.365 23.4494 127.768 23.0838C128.184 23.8171 128.556 22.1695 128.459 21.7379C128.385 21.9073 128.074 21.9198 128.207 21.5664C128.861 21.9306 130.489 17.4535 128.262 19.3334C128.24 19.4107 128.809 19.5378 128.599 19.599C127.769 19.307 128.15 20.1124 128.152 20.3224C127.697 20.2448 128.058 20.5024 127.853 20.5223C127.319 20.1801 127.968 21.4947 127.451 21.121C126.178 22.0024 126.739 24.2402 125.63 24.8919C126.478 25.6001 123.857 28.6536 126.237 27.6949C127.149 26.3436 127.783 25.2187 127.951 23.5219Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M141.26 16.6354C139.968 16.0531 139.255 19.1998 138.4 19.9494C137.24 20.8363 130.777 31.3271 134.487 28.9268C136.417 25.7404 138.534 23.3591 140.406 19.293C140.758 18.6458 142.275 16.7035 141.26 16.6354Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M142.897 51.6418C141.713 52.6636 141.02 51.0539 139.942 51.8779C138.193 53.5089 148.442 55.7454 148.714 53.8345C148.718 52.1988 143.419 52.438 142.897 51.6418Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M34.0511 21.4768C34.2527 21.2013 33.2103 16.0093 32.4983 17.3346C32.1723 17.7687 32.2227 18.2234 32.7342 18.4455C31.757 18.4552 33.0961 19.603 32.7904 20.0191C32.1002 19.759 33.5723 21.3456 32.8512 20.9785C32.2828 26.35 39.2746 38.31 34.8569 24.2999C34.5911 25.5931 34.2804 24.2942 34.413 23.7151C35.3161 24.6984 34.4773 22.0823 34.1602 21.5767C34.2019 22.3562 33.5154 20.9832 34.0489 21.4788L34.0511 21.4768Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M26.0595 30.1916C25.9942 29.4715 21.0889 25.7855 20.6193 25.3436C19.4732 24.562 19.4342 26.1915 20.403 26.5975C20.5714 26.7551 21.9537 27.4177 21.3778 27.666C21.7228 29.1074 24.1738 29.6551 24.3617 30.8568C24.678 30.7147 25.0748 31.1878 25.2873 31.1236C25.2607 31.4691 25.7319 31.7319 25.7711 31.6538C27.0221 33.3266 28.3884 31.6739 26.6325 30.6184C26.7047 30.5685 26.3869 30.1163 26.0641 30.1922L26.0595 30.1916Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M17.583 47.0616C18.401 47.8181 17.5568 47.6517 17.1607 47.2789C17.859 46.8064 16.1872 46.5647 15.7646 46.6957C15.9394 46.7564 15.9762 47.0647 15.6134 46.9599C15.9251 46.2791 11.3339 45.0084 13.383 47.0808C13.4619 47.097 13.5438 46.5198 13.6214 46.7245C13.3954 47.5741 14.1684 47.1313 14.3777 47.1132C14.336 47.573 14.5644 47.192 14.6005 47.3953C14.3013 47.9545 15.5608 47.2038 15.2289 47.7488C16.2076 48.9483 18.3943 48.213 19.1312 49.2674C19.7707 48.367 23.0207 50.7398 21.8778 48.4424C20.4591 47.6393 19.2878 47.0962 17.583 47.0616Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M9.67164 34.335C9.19267 35.669 12.3858 36.1327 13.2002 36.9259C14.1755 38.0131 25.1419 43.6314 22.4575 40.1213C19.1292 38.4474 16.5888 36.5239 12.3882 34.9777C11.7153 34.6782 9.65976 33.3177 9.67164 34.335Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M44.4412 29.9519C45.553 31.0521 44.0027 31.8695 44.9089 32.8789C46.6723 34.4945 48.0962 24.1012 46.1699 23.9803C44.539 24.1056 45.1939 29.3686 44.4412 29.9519Z",
                fill: "#101214"
            })
        ]
    });

});


parcelRegister("bQ7Jf", function(module, exports) {
$parcel$export(module.exports, "StorageAccessPage", () => $ed3c22dd93ae1fa7$export$64a8a56a2c35628c);
/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $kopi2 = parcelRequire("kopi2");

var $j2zMY = parcelRequire("j2zMY");

var $lRq8t = parcelRequire("lRq8t");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");

var $eGOwo = parcelRequire("eGOwo");
const $ed3c22dd93ae1fa7$var$iframeStyles = null;
const $ed3c22dd93ae1fa7$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const iframeRef = (0, $eJOHy.useRef)(null);
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $eJOHy.useMemo)(()=>{
        const uniqueKeyParam = uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `&uniqueKey=${uniqueKey}` : '';
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}${uniqueKeyParam}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url,
        uniqueKey
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                "data-testid": "storage-access-page-iframe",
                title: "storage-access-iframe",
                src: src,
                ref: iframeRef,
                className: (0, $hcewu.default)([
                    "_19itglyw _1bsb1osq _4t3i1osq"
                ])
            })
        ]
    });
};

});

parcelRegister("bbc8b", function(module, exports) {
$parcel$export(module.exports, "themeStateObjectToQueryString", () => $05685c35af67dcaf$export$6e43e60d51b79331);
$parcel$export(module.exports, "useUrl", () => $05685c35af67dcaf$export$305222dff575c4e3);

var $eJOHy = parcelRequire("eJOHy");

var $4CCpn = parcelRequire("4CCpn");

var $eGOwo = parcelRequire("eGOwo");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");

var $8HgDC = parcelRequire("8HgDC");

var $lRq8t = parcelRequire("lRq8t");

var $944VV = parcelRequire("944VV");

var $8edRS = parcelRequire("8edRS");
const $05685c35af67dcaf$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $4CCpn.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $05685c35af67dcaf$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $05685c35af67dcaf$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $05685c35af67dcaf$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $eJOHy.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $eJOHy.useMemo)(()=>allowedFeatures === 'all' ? (0, $8HgDC.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$05685c35af67dcaf$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $944VV.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $944VV.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const queryParams = (0, $eJOHy.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $05685c35af67dcaf$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            ...$05685c35af67dcaf$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $05685c35af67dcaf$var$CONTEXT_PATH = '/wiki/spaces';
const $05685c35af67dcaf$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $05685c35af67dcaf$var$constructUrl(mode = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$05685c35af67dcaf$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$05685c35af67dcaf$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$05685c35af67dcaf$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}

});
parcelRegister("944VV", function(module, exports) {
$parcel$export(module.exports, "isRedirectionEnabled", () => $96d0b9880a83dcb1$export$51abd16148027412);
$parcel$export(module.exports, "getCrossSiteTenantIdFromAllowedFeature", () => $96d0b9880a83dcb1$export$243fbba563b8aa8e);
const $96d0b9880a83dcb1$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $96d0b9880a83dcb1$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};

});


parcelRegister("d5di2", function(module, exports) {
$parcel$export(module.exports, "Subjects", () => $5039f3b5eeec03e2$export$29953e2fb702813a);
$parcel$export(module.exports, "LoadingStatus", () => $5039f3b5eeec03e2$export$19d37de7e9a4af59);
$parcel$export(module.exports, "useValidationState", () => $5039f3b5eeec03e2$export$1faa35b5a06780c0);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $eGOwo = parcelRequire("eGOwo");

var $j2zMY = parcelRequire("j2zMY");

var $8edRS = parcelRequire("8edRS");
var $5039f3b5eeec03e2$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $5039f3b5eeec03e2$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $5039f3b5eeec03e2$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $5039f3b5eeec03e2$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $5039f3b5eeec03e2$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
					 */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported.
          So we can skip asking for storage access and direct user to the Login CTA.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $5039f3b5eeec03e2$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $eJOHy.useReducer)($5039f3b5eeec03e2$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const messageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { subject: subject, result: result, embeddedConfluenceUrl: embeddedConfluenceUrl } = messageEvent.data ?? {};
        const messageKey = embeddedConfluenceUrl && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? new URL(embeddedConfluenceUrl).searchParams.get('uniqueKey') : null;
        if (!subject || !result || messageKey && uniqueKey && messageKey !== uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker,
        uniqueKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};

});


parcelRegister("jgJaV", function(module, exports) {
$parcel$export(module.exports, "useFooter", () => $ccc878979acefb1a$export$d07da6ac6fc160b0);

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $3V5nR = parcelRequire("3V5nR");
const $ccc878979acefb1a$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $eJOHy.useState)(standaloneConfluenceUrl);
    (0, $eJOHy.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $j2zMY.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
	 * Currently footer is hidden for the JSM Portal view which passes
	 * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
	 *
	 * JSM portal view will provide "JSM-Portal" as the parent product eventually
	 * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
	 * We need to support these two parent product keys to keep backward compatible for the time being.
	 *
	 * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
	 *
	 * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
	 * External API remains unchanged.
	 */ const showFooter = (0, $eJOHy.useMemo)(()=>{
        const parentProducts = [
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};

});

parcelRegister("3ca9m", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ddffc24222dbaf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $72ddffc24222dbaf$var$messages = (0, $7qGN1.defineMessages)({
    viewInConfluence: {
        id: 'embedded.confluence.footer.hover.text',
        description: 'Hover text on Confluence Footer Content',
        defaultMessage: 'View in Confluence'
    },
    poweredBy: {
        id: 'embedded.confluence.footer.prefix',
        description: 'Prefix label on Confluence Logo',
        defaultMessage: 'Powered by'
    }
});
var $72ddffc24222dbaf$export$2e2bcd8739ae039 = $72ddffc24222dbaf$var$messages;

});

parcelRegister("bF4mB", function(module, exports) {
$parcel$export(module.exports, "IframeLoadingScreen", () => $b8e6c349b8b4992c$export$666e684aed003bfe);
/* IframeLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");

var $jjS5D = parcelRequire("jjS5D");
const $b8e6c349b8b4992c$var$visibilityStyles = {
    hidden: "_1e0cglyw",
    invisible: "_tzy4idpf _4t3i1osq",
    visible: "_tzy4kb7n _4t3i1osq"
};
const $b8e6c349b8b4992c$var$overlayStyles = {
    default: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _1bahv2br _1pbyb4wl"
};
const $b8e6c349b8b4992c$var$containerStyles = {
    default: "_kqswh2mm _1bsb1osq _4t3i1osq"
};
const $b8e6c349b8b4992c$export$666e684aed003bfe = ({ children: children, iframeLoaded: iframeLoaded, isLoading: isLoading })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        xcss: $b8e6c349b8b4992c$var$containerStyles.default,
        "aria-busy": isLoading,
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hYvlq.default), {
                gap: "space.400",
                alignItems: "start",
                xcss: isLoading ? $b8e6c349b8b4992c$var$overlayStyles.default : $b8e6c349b8b4992c$var$visibilityStyles.hidden,
                "aria-hidden": !isLoading,
                role: "status",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "250px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.0",
                "aria-hidden": isLoading,
                xcss: !iframeLoaded ? $b8e6c349b8b4992c$var$visibilityStyles.invisible : $b8e6c349b8b4992c$var$visibilityStyles.visible,
                children: children
            })
        ]
    });

});
parcelRegister("hYvlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});



parcelRegister("lCbi5", function(module, exports) {
$parcel$export(module.exports, "useGetCurrentScrollPosition", () => $8510204e3c256619$export$4d8f561c32665bbe);

var $eJOHy = parcelRequire("eJOHy");

var $8qtes = parcelRequire("8qtes");
// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $8510204e3c256619$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $8510204e3c256619$export$4d8f561c32665bbe = (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $eJOHy.useState)(0);
    const defaultScrollPosition = (0, $eJOHy.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $eJOHy.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $8qtes.useMediaViewerListener)();
    (0, $eJOHy.useEffect)(()=>{
        const handleScroll = $8510204e3c256619$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
					Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
					it may already have been opened or closed, and we do not have control over the actions that occur
					just before the media viewer is activated (which happens in a different package that we do not manage).
					Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
					This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
					which is misleading since the container height will have been reduced at this point.
					To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
					When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
					inaccuracies associated with saving the scroll position under the conditions of a condensed height.
				*/ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};

});





parcelRegister("6ijO8", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $8212e0b78a96b746$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $gWqMk = parcelRequire("gWqMk");
const $8212e0b78a96b746$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gWqMk.EditPage), {
            ...props
        })
    });

});
parcelRegister("gWqMk", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $1919213bb3817aab$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6q6x9 = parcelRequire("6q6x9");

var $lRq8t = parcelRequire("lRq8t");
const $1919213bb3817aab$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6q6x9.EditPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("6q6x9", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $e16a2d7d4327cedc$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $TJJ14 = parcelRequire("TJJ14");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");
const $e16a2d7d4327cedc$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8edRS.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $TJJ14.EditPage), {
                    ...props
                })
            })
        })
    });
};

});
parcelRegister("TJJ14", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $2003a24730d7f067$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");

var $jWzbc = parcelRequire("jWzbc");
const $2003a24730d7f067$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $2003a24730d7f067$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>{
        const isTemplateBrowserEnabled = allowedFeatures === 'all' || allowedFeatures?.find((feature)=>feature === 'template-browser' || feature.hasOwnProperty('template-browser')) !== undefined;
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $2003a24730d7f067$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $j2zMY.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $j2zMY.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jWzbc.Content), {
        ...props,
        contentType: (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};

});






parcelRegister("dxRkJ", function(module, exports) {
$parcel$export(module.exports, "useConfluencePageData", () => $069cdb8482617006$export$10fb2803bc7b79fc);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7y92E = parcelRequire("7y92E");
var $4CCpn = parcelRequire("4CCpn");
var $069cdb8482617006$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $069cdb8482617006$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $069cdb8482617006$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $069cdb8482617006$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) return undefined;
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($069cdb8482617006$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $4CCpn.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $eJOHy.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $7y92E.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};

});


parcelRegister("RCgNH", function(module, exports) {
$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("diXta", function(module, exports) {
$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa);

var $eJOHy = parcelRequire("eJOHy");

var $kbv8x = parcelRequire("kbv8x");
const $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $kbv8x.default)();
    (0, $eJOHy.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve(url, true);
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});


parcelRegister("iUsXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {
$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    });
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title,
                    ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                        extensionKey: details?.meta?.key
                    }
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details?.meta?.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {
$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1NG86 = parcelRequire("1NG86");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("4Rp6r", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");

var $g6YpQ = parcelRequire("g6YpQ");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $36fa193905cb5ef0$var$experimentEnabledStyles = {
    control: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    test1: "_syaz15cr _80omtlke _bfhk1fvw _qrwqlb4i _1o0zlb4i _irr318hz _1di6gr1v",
    test2: "_syaz15cr _80omtlke _bfhk1t1b _qrwqlb4i _1o0zlb4i _irr3e4nv _1di682ra"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $g6YpQ.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : experimentValue !== 'control' ? $36fa193905cb5ef0$var$experimentEnabledStyles[experimentValue] : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});
parcelRegister("g6YpQ", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $f1d9f52443f254ec$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValNoExposure", () => $f1d9f52443f254ec$export$94f132839aec533f);

var $59rsN = parcelRequire("59rsN");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $f1d9f52443f254ec$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $bfW07._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $bfW07._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $59rsN.default).initializeCompleted()) return defaultValue;
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    return experimentValue;
}
function $f1d9f52443f254ec$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $f1d9f52443f254ec$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
}
function $f1d9f52443f254ec$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $f1d9f52443f254ec$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});



parcelRegister("6kw7n", function(module, exports) {
$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                appearance: "moved",
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: renderForbiddenAccessMessage()
            })
        });
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {
$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {
$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            viewType: 'unauthorised',
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});


parcelRegister("ettNQ", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $6b9d8190953f47e0$export$ed70996d478e16d3);
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $6b9d8190953f47e0$export$e682245dc886cff2);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $b43DQ = parcelRequire("b43DQ");
function $6b9d8190953f47e0$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $eJOHy.useMemo)(()=>new (0, $b43DQ.SmartLinkEvents)(), []);
    return events;
}
function $6b9d8190953f47e0$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});


parcelRegister("k9P6L", function(module, exports) {
$parcel$export(module.exports, "LoadingCardLink", () => $9acebe3c2480723a$export$1ca0544321134ad6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kj3Kk = parcelRequire("kj3Kk");

const $9acebe3c2480723a$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ed49f57481afa45$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
const $6ed49f57481afa45$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';



parcelRegister("e90yL", function(module, exports) {
$parcel$export(module.exports, "generatePlaceholderData", () => $720441f191aac54c$export$5d49eb8909604ac1);
const $720441f191aac54c$export$5d49eb8909604ac1 = (url, restrictedName, name)=>{
    return {
        meta: {
            auth: [],
            definitionId: 'watermelon-object-provider',
            product: 'townsquare',
            visibility: 'restricted',
            access: 'granted',
            key: 'watermelon-object-provider'
        },
        data: {
            '@context': {
                '@vocab': 'https://www.w3.org/ns/activitystreams#',
                atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                schema: 'http://schema.org/'
            },
            generator: {
                '@type': 'Application',
                '@id': 'https://www.atlassian.com/#TeamCentral',
                name: 'Projects'
            },
            '@type': [
                'Object',
                'atlassian:Project'
            ],
            url: url,
            // TODO - Review if we can use real icon via React Node usage (ANIP-361)
            icon: {
                '@type': 'Image',
                url: 'data:image/svg+xml;base64,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'
            },
            name: name || restrictedName
        }
    };
};

});



parcelRegister("fRm4z", function(module, exports) {
$parcel$export(module.exports, "useProjectUrlConstructor", () => $80656e7520d9f842$export$b90dbdb6cfc4b7d0);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $kyq27 = parcelRequire("kyq27");

var $8rl2J = parcelRequire("8rl2J");

const $80656e7520d9f842$export$b90dbdb6cfc4b7d0 = ()=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isStagingOrDevOrLocal = (0, $kyq27.useIsStagingOrDevOrLocal)();
    return (0, $eJOHy.useCallback)(({ ari: ari, projectKey: projectKey })=>{
        const atlassianHomeUrl = isStagingOrDevOrLocal ? (0, $3bc23e8d20cc37b7$export$46b5a4e5fbe6e304) : (0, $3bc23e8d20cc37b7$export$732915c664dff395);
        const siteId = (0, $8rl2J.TownsquareProjectAri).parse(ari).siteId;
        return `${atlassianHomeUrl}/o/${orgId}/s/${siteId}/project/${projectKey}`;
    }, [
        isStagingOrDevOrLocal,
        orgId
    ]);
};
const $80656e7520d9f842$export$9cce062687913114 = (url)=>url.split('/').pop();

});
const $3bc23e8d20cc37b7$export$732915c664dff395 = 'https://home.atlassian.com';
const $3bc23e8d20cc37b7$export$46b5a4e5fbe6e304 = 'https://home.stg.atlassian.com';


parcelRegister("bCxCS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac2994246833a05e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ac2994246833a05e$var$messages = (0, $7qGN1.defineMessages)({
    noAtlasProjectDisplayName: {
        "id": "ui.groupHeader.atlasProjectGroupHeader.noAtlasProjectDisplayName",
        "defaultMessage": "No project"
    }
});
var $ac2994246833a05e$export$2e2bcd8739ae039 = $ac2994246833a05e$var$messages;

});




parcelRegister("cgCO4", function(module, exports) {
$parcel$export(module.exports, "useShouldApplyFrozenColumns", () => $b2dad0224ea212bd$export$26a13b614880b279);

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");
const $b2dad0224ea212bd$export$26a13b614880b279 = ()=>{
    if (!(0, $4cTDP.fg)('issue_table_frozen_columns')) return {
        isStickyColumnsVisible: false,
        isSmallScreen: false
    };
    // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    const isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    const { hasScrolled: hasScrolled, tableWidth: tableWidth } = (0, $7n9BS.useScrollStateSelector)((state)=>({
            hasScrolled: state.hasScrolled,
            tableWidth: state.width
        }));
    const isSmallScreen = isAutoUnstickyOnSmallScreenEnabled && tableWidth < (0, $8jOO7.SMALL_TABLE_WIDTH) && tableWidth !== 0;
    // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    let isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    if (isStickyColumnsVisible) isStickyColumnsVisible = hasScrolled ? !isSmallScreen : true;
    return {
        isStickyColumnsVisible: isStickyColumnsVisible,
        isSmallScreen: isSmallScreen
    };
};

});

parcelRegister("1q3Q0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef615d8a7f688f1$export$2e2bcd8739ae039);

var $ksIye = parcelRequire("ksIye");

var $6CYrO = parcelRequire("6CYrO");

var $99yt2 = parcelRequire("99yt2");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $68iTT = parcelRequire("68iTT");

var $kGj4V = parcelRequire("kGj4V");

var $jBNts = parcelRequire("jBNts");

var $6d9QY = parcelRequire("6d9QY");

var $jE8Tu = parcelRequire("jE8Tu");

var $bJscI = parcelRequire("bJscI");

var $cgCO4 = parcelRequire("cgCO4");

var $aqT6C = parcelRequire("aqT6C");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $4ukXD = parcelRequire("4ukXD");

var $f9D6R = parcelRequire("f9D6R");

var $jNv5I = parcelRequire("jNv5I");

var $km3XC = parcelRequire("km3XC");
const $7ef615d8a7f688f1$var$HierarchyRow = /*#__PURE__*/ (0, $eJOHy.memo)(({ project: project, depth: depth, itemsConnectionId: itemsConnectionId, rankFieldId: rankFieldId, parentItemConnectionId: parentItemConnectionId, parentIssueAri: parentIssueAri, parentIssueHierarchyLevel: parentIssueHierarchyLevel, rowsData: rowsData, index: index, isVirtual: isVirtual, isIssueHierarchyEnabled: isIssueHierarchyEnabled, measureElement: measureElement, projectKey: projectKey, previousItemId: previousItemId, isDraggingRowFaded: isDraggingRowFaded, isStickyColumnsVisible: isStickyColumnsVisible, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig })=>{
    const issueRow = rowsData?.edges?.[index];
    const hierarchyLevel = issueRow?.node?.issueTypeField?.issueType?.hierarchy?.level;
    const { renderChildRows: renderChildRows } = (0, $jNv5I.useRowContext)();
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)({
        projectKey: (0, $34oCh.useProjectContext)(),
        ...hierarchyLevel != null && {
            minHierarchyLevel: hierarchyLevel - 1,
            maxHierarchyLevel: hierarchyLevel - 1
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            rowIndex: index,
            tableRowNumber: index
        }
    }, isVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ukXD.default), {
        project: project,
        rankFieldId: rankFieldId,
        rowIndex: index,
        itemsConnectionId: rowsData.__id,
        issueEdge: issueRow ?? null,
        fieldSets: issueRow?.fieldSets ?? null,
        depth: depth,
        parentIssueAri: parentIssueAri,
        parentItemConnectionId: parentItemConnectionId,
        parentIssueRelayConnectionId: itemsConnectionId,
        parentIssueHierarchyLevel: parentIssueHierarchyLevel,
        triggerProps: triggerProps,
        isFormVisible: isFormVisible,
        measureElement: measureElement,
        previousItemId: previousItemId,
        isDraggingRowFaded: isDraggingRowFaded,
        isStickyColumnsVisible: isStickyColumnsVisible,
        formattingRules: formattingRules,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
        ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
            hierarchyLevel: hierarchyLevel,
            issueKey: issueRow?.node?.key,
            projectKey: projectKey
        } : {}
    }), issueRow?.node?.issueId && isIssueHierarchyEnabled && renderChildRows?.({
        issueKey: issueRow?.node?.key,
        parentItemId: issueRow?.node?.issueId,
        itemsConnectionId: rowsData.__id,
        depth: depth,
        parentIssueAri: issueRow?.node?.id,
        parentItemConnectionId: issueRow?.__id,
        parentIssueRelayConnectionId: itemsConnectionId,
        parentIssueHierarchyLevel: hierarchyLevel,
        type: 'PARENT_CHILDREN',
        isFormVisible: isFormVisible,
        formProps: formProps,
        hasChildren: issueRow?.hasChildren ?? false
    }));
});
const $7ef615d8a7f688f1$export$c0febbacdd540b37 = ({ project: project, projectKey: projectKey, issueResults: issueResults, rankFieldId: rankFieldId, depth: depth = 0, parentItemId: parentItemId, itemsConnectionId: itemsConnectionId, parentIssueAri: parentIssueAri, parentItemConnectionId: parentItemConnectionId, parentIssueRelayConnectionId: parentIssueRelayConnectionId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, isLoadingNext: isLoadingNext, hasNext: hasNext, isChildIssueCreateRowVisible: isChildIssueCreateRowVisible, onLoadNextItems: onLoadNextItems, renderChildIssueCreateRow: renderChildIssueCreateRow, isDraggingRowFaded: isDraggingRowFaded, formattingRules: formattingRules, groupContextFieldInput: groupContextFieldInput, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig, initialPopulateConnectionArgs: initialPopulateConnectionArgs })=>{
    const rowsData = (0, $j4oe4.useFragment)((0, $99yt2.default), issueResults);
    const projectData = (0, $j4oe4.useFragment)((0, $6CYrO.default), project ?? null);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $ksIye.default), formattingRules ?? null);
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const { populateConnection: populateConnection } = (0, $jE8Tu.useHierarchyActions)();
    const { columns: columns, groupId: groupId } = (0, $jNv5I.useRowContext)();
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    else {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const hasCheckboxColumn = columns.length > 0 && columns[0].id === (0, $8jOO7.COLUMN_ID_CHECKBOX);
    const populateConnectionArgs = (0, $eJOHy.useMemo)(()=>({
            parentItemId: parentItemId,
            itemsConnectionId: rowsData.__id,
            parentConnectionId: itemsConnectionId,
            list: rowsData?.edges?.map((edge)=>edge?.node && {
                    key: edge.node.key,
                    itemId: edge.node.issueId,
                    groupId: groupId
                }).filter(Boolean) ?? [],
            hasNext: hasNext,
            groupId: groupId,
            isChildIssueCreateRowVisible: isChildIssueCreateRowVisible
        }), [
        parentItemId,
        itemsConnectionId,
        rowsData.__id,
        rowsData?.edges,
        hasNext,
        groupId,
        isChildIssueCreateRowVisible
    ]);
    /*
   *  initialPopulateConnectionArgs is used to initialise the hierarchy store container for root connections, and will
   *  hence prevent calling populateConnection for root connections if the root connection matches populateConnectionArgs.
   *
   *  On initial load, Rows.tsx can be rendered as root connection for hierarchy on/off.
   *  However, for grouping, Rows.tsx is used to render the first group connection, which is difficult to initialise
   *  as there's a store-only lazy loaded query FirstGroupIssuesQuery we'd need to mimic to get the right itemsConnectionId.
   *  So for now, we'll allow populateConnection to proceed for the first group rows, which will cause later render.
   *
   *  If the connection arguments mismatch for any reason, we gracefully populateConnection, but will pay a render interruption penalty.
   */ const prevPopulateConnectArgs = (0, $6d9QY.usePrevious)(populateConnectionArgs) ?? // eslint-disable-next-line jira/ff/no-preconditioning
    ((0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') && initialPopulateConnectionArgs ? initialPopulateConnectionArgs.find((args)=>args.parentItemId === 'root') : undefined);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(populateConnectionArgs, prevPopulateConnectArgs)) populateConnection(populateConnectionArgs);
    const renderRowItem = (0, $eJOHy.useCallback)((index, measureElement)=>{
        const issueRow = rowsData?.edges?.[index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
            key: issueRow?.node?.key || index,
            attributes: {
                rowIndex: index,
                tableRowNumber: index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ukXD.default), {
            project: projectData,
            rowIndex: index,
            rankFieldId: rankFieldId,
            itemsConnectionId: rowsData.__id,
            issueEdge: issueRow ?? null,
            fieldSets: issueRow?.fieldSets ?? null,
            depth: depth,
            parentIssueAri: parentIssueAri,
            parentItemConnectionId: parentItemConnectionId,
            parentIssueRelayConnectionId: parentIssueRelayConnectionId,
            parentIssueHierarchyLevel: parentIssueHierarchyLevel,
            measureElement: measureElement,
            isDraggingRowFaded: isDraggingRowFaded,
            isStickyColumnsVisible: isStickyColumnsVisible,
            formattingRules: formattingRulesData,
            ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
                projectKey: projectKey,
                issueKey: issueRow?.node?.key
            } : {},
            ...(0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') && {
                groupContextFieldInput: groupContextFieldInput
            },
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields
        }));
    }, [
        rowsData?.edges,
        rowsData.__id,
        projectData,
        rankFieldId,
        depth,
        parentIssueAri,
        parentItemConnectionId,
        parentIssueRelayConnectionId,
        parentIssueHierarchyLevel,
        isDraggingRowFaded,
        isStickyColumnsVisible,
        formattingRulesData,
        projectKey,
        groupContextFieldInput,
        rowInlineCreateCanShowAdditionalFields
    ]);
    const renderRows = (0, $eJOHy.useCallback)((isItemVirtual, measureElement)=>{
        const childIssueCreateItemId = (0, $jBNts.getFlatListKey)({
            itemId: (0, $jE8Tu.getChildIssueCreateItemKey)(parentItemId),
            groupId: groupId
        });
        const isChildIssueCreateRowVirtual = isItemVirtual?.(childIssueCreateItemId) ?? true;
        const showMoreItemId = (0, $jBNts.getFlatListKey)({
            itemId: (0, $jE8Tu.getShowMoreItemKey)(parentItemId),
            groupId: groupId
        });
        const isShowMoreItemVirtual = isItemVirtual?.(showMoreItemId) ?? true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isChildIssueCreateRowVirtual && renderChildIssueCreateRow?.(), rowsData?.edges?.map((edge, index)=>{
            const flatListIssueId = (0, $jBNts.getFlatListKey)({
                itemId: edge?.node?.issueId ?? '',
                groupId: groupId
            });
            let isVirtual = isItemVirtual?.(flatListIssueId) ?? true;
            // we're using row index as virtualisation key fallback when flatList is empty
            // hence the check includes both itemId and index to avoid rows flickering on transition
            if ((0, $4cTDP.fg)('jira_list_isvirtual_by_index')) isVirtual = (isItemVirtual?.(flatListIssueId) || isItemVirtual?.(`${index}`)) ?? true;
            const previousItemId = index > 0 && (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? rowsData?.edges?.[index - 1]?.node?.issueId : undefined;
            return isIssueHierarchyEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef615d8a7f688f1$var$HierarchyRow, {
                project: projectData,
                key: flatListIssueId,
                rankFieldId: rankFieldId,
                itemsConnectionId: itemsConnectionId,
                isVirtual: isVirtual,
                index: index,
                rowsData: rowsData,
                depth: depth,
                parentItemConnectionId: parentItemConnectionId ?? '',
                parentIssueAri: parentIssueAri ?? '',
                parentIssueHierarchyLevel: parentIssueHierarchyLevel,
                isIssueHierarchyEnabled: isIssueHierarchyEnabled,
                measureElement: measureElement,
                projectKey: projectKey,
                previousItemId: previousItemId,
                isDraggingRowFaded: isDraggingRowFaded,
                isStickyColumnsVisible: isStickyColumnsVisible,
                formattingRules: formattingRulesData,
                rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
                topLevelIssueCreateConfig: topLevelIssueCreateConfig
            }) : isVirtual && renderRowItem(index, measureElement);
        }), hasNext && isShowMoreItemVirtual && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqT6C.default), {
            isLoadingNext: isLoadingNext,
            columnsCount: columns.length,
            loadNext: onLoadNextItems ?? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            isStickyColumnsVisible: isStickyColumnsVisible,
            ...isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? {
                hasCheckboxColumn: hasCheckboxColumn
            } : {}
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f9D6R.RowsAdditionalContentRenderer), {
            depth: depth,
            groupId: groupId,
            issues: rowsData
        }));
    }, [
        parentItemId,
        groupId,
        renderChildIssueCreateRow,
        rowsData,
        hasNext,
        isLoadingNext,
        columns.length,
        onLoadNextItems,
        isStickyColumnsVisible,
        isTimelineEnabled,
        hasCheckboxColumn,
        depth,
        isIssueHierarchyEnabled,
        projectData,
        rankFieldId,
        itemsConnectionId,
        parentItemConnectionId,
        parentIssueAri,
        parentIssueHierarchyLevel,
        projectKey,
        isDraggingRowFaded,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields,
        topLevelIssueCreateConfig,
        renderRowItem
    ]);
    const isVirtualizationEnabled = (0, $34oCh.useIsVirtualizationEnabled)();
    if (isVirtualizationEnabled) {
        const isGrouping = Boolean(groupId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $km3XC.VirtualizedRows), {
            hasSpacers: depth === 0 && !isGrouping,
            columnsCount: columns.length
        }, renderRows);
    }
    return renderRows();
};
const $7ef615d8a7f688f1$var$Rows = (0, $bJscI.componentWithFG)('initialise_virtualiser_state_from_relay_store', /*#__PURE__*/ (0, $eJOHy.memo)($7ef615d8a7f688f1$export$c0febbacdd540b37), $7ef615d8a7f688f1$export$c0febbacdd540b37);
var $7ef615d8a7f688f1$export$2e2bcd8739ae039 = $7ef615d8a7f688f1$var$Rows;

});
parcelRegister("ksIye", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a0d0f9528d70e6e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa34ba6f472e0b8148f1264eff626129>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6a0d0f9528d70e6e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Rows_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Row_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$6a0d0f9528d70e6e$var$node.hash = "b4b335939ad75aad9e255c08b8521ec5";
var $6a0d0f9528d70e6e$export$2e2bcd8739ae039 = $6a0d0f9528d70e6e$var$node;

});

parcelRegister("6CYrO", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eb219d57b0f6df8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b512891704b7282f1fa80d7a954947f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4eb219d57b0f6df8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "Rows_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Row_project"
        }
    ],
    "type": "JiraProject"
};
$4eb219d57b0f6df8$var$node.hash = "6529dd7b2cd4ebb69d9c7a29ad22a15d";
var $4eb219d57b0f6df8$export$2e2bcd8739ae039 = $4eb219d57b0f6df8$var$node;

});

parcelRegister("99yt2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7a47433bdebc400$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcb239721bc32add0f4fa291fb4cf3b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e7a47433bdebc400$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isDensityFull",
        "variableName": "isDensityFull"
    }, v1 = {
        "kind": "Variable",
        "name": "isLinkRelationshipFieldEnabled",
        "variableName": "isLinkRelationshipFieldEnabled"
    }, v2 = {
        "kind": "Variable",
        "name": "isTimelineEnabled",
        "variableName": "isTimelineEnabled"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "Rows",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "isRemoteLinkedIssuesEnabled",
                                "variableName": "isRemoteLinkedIssuesEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "isReparentingEnabled",
                                "variableName": "isReparentingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "Row_issueEdge"
                    },
                    {
                        "condition": "shouldQueryHasChildren",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "filterByProjectKeys",
                                        "variableName": "projectKeys"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "hasChildren"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "issueId"
                            },
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                "kind": "LinkedField",
                                                "name": "hierarchy",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "level"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 500
                            }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isConditionalFormattingEnabled",
                                        "variableName": "isConditionalFormattingEnabled"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "isEditableSyncLoaded",
                                        "variableName": "isEditableSyncLoaded"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "isInlineEditingEnabled",
                                        "variableName": "isInlineEditingEnabled"
                                    },
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ],
                                "kind": "FragmentSpread",
                                "name": "Row_fieldSets"
                            }
                        ],
                        "storageKey": "fieldSets(first:500)"
                    },
                    v3 /*: any*/ 
                ]
            },
            {
                "args": [
                    v2 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "RowsAdditionalContentRenderer"
            },
            v3 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$e7a47433bdebc400$var$node.hash = "5fe1f1794b2f08dfbbbf913d2d4839d2";
var $e7a47433bdebc400$export$2e2bcd8739ae039 = $e7a47433bdebc400$var$node;

});

parcelRegister("aqT6C", function(module, exports) {
$parcel$export(module.exports, "default", () => $1118dff792cb08d1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $bKlUQ = parcelRequire("bKlUQ");

var $34oCh = parcelRequire("34oCh");

var $aIvQb = parcelRequire("aIvQb");
const $1118dff792cb08d1$var$ROW_HEIGHT = 40;
const $1118dff792cb08d1$export$68a5941629c7f57a = ({ loadNext: loadNext, isLoadingNext: isLoadingNext = false, columnsCount: columnsCount, isStickyColumnsVisible: isStickyColumnsVisible, hasCheckboxColumn: hasCheckboxColumn })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLoadingNext,
        onClick: loadNext
    }, isLoadingNext ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aIvQb.default).loadingMoreItemsIssueTermRefresh : (0, $aIvQb.default).loadingMoreItems) : formatMessage((0, $aIvQb.default).showMore));
    const cellBorderStyles = (0, $eJOHy.useMemo)(()=>{
        return (0, $4cTDP.fg)('jira_timeline_cell_border_style') ? [
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1118dff792cb08d1$var$baseCellBorderStylesRTL : $1118dff792cb08d1$var$baseCellBorderStyles,
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1118dff792cb08d1$var$cellBorderLocationStyleMap[cellBorderStyle] : $1118dff792cb08d1$var$cellBorderLocationStyleMapOld[cellBorderStyle]
        ] : [
            $1118dff792cb08d1$var$cellBorderStylesOld
        ];
    }, [
        cellBorderStyle
    ]);
    const isColumnSticky = isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns');
    const stickyButton = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.load-more-items-row.load-more-wrapper",
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isAutoUnstickyOnSmallScreenEnabled ? $1118dff792cb08d1$var$stickyContainerResponsiveStylesRTL : $1118dff792cb08d1$var$stickyContainerStylesRTL : $1118dff792cb08d1$var$stickyContainerStylesOldRTL
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.load-more-items-row.load-more-wrapper",
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isAutoUnstickyOnSmallScreenEnabled ? $1118dff792cb08d1$var$stickyContainerResponsiveStyles : $1118dff792cb08d1$var$stickyContainerStyles : $1118dff792cb08d1$var$stickyContainerStylesOld
    }, button);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tr",
        xcss: $1118dff792cb08d1$var$rowStyles
    }, isColumnSticky && hasCheckboxColumn === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        hasRightShadow: true,
        spacing: $1118dff792cb08d1$var$firstColumnSpacingStyles,
        border: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1118dff792cb08d1$var$firstColumnBorderStyles : $1118dff792cb08d1$var$firstColumnBorderStylesOld,
        isColumnSticky: isColumnSticky
    }, stickyButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorderStyles,
        isColumnSticky: isColumnSticky
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorderStyles,
        colSpan: columnsCount
    }, isColumnSticky ? stickyButton : button)));
};
const $1118dff792cb08d1$var$LoadMoreItemsRow = (0, $bJscI.componentWithFG)('initialise_virtualiser_state_from_relay_store', /*#__PURE__*/ (0, $eJOHy.memo)($1118dff792cb08d1$export$68a5941629c7f57a), $1118dff792cb08d1$export$68a5941629c7f57a);
var $1118dff792cb08d1$export$2e2bcd8739ae039 = $1118dff792cb08d1$var$LoadMoreItemsRow;
const $1118dff792cb08d1$var$rowStyles = (0, $1DXK0.xcss)({
    height: `${$1118dff792cb08d1$var$ROW_HEIGHT}px`,
    backgroundColor: 'elevation.surface'
});
// TODO: Remove this with cleanup of jira_timeline_cell_border_style
const $1118dff792cb08d1$var$cellBorderStylesOld = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $1118dff792cb08d1$var$baseCellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: '0'
});
const $1118dff792cb08d1$var$baseCellBorderStylesRTL = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '0'
});
const $1118dff792cb08d1$var$topCellBorderStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: 'border.width'
});
const $1118dff792cb08d1$var$topCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width'
});
const $1118dff792cb08d1$var$noRowCellBorderStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0'
});
const $1118dff792cb08d1$var$noRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: '0'
});
const $1118dff792cb08d1$var$cellBorderLocationStyleMapOld = {
    FULL_BORDER: $1118dff792cb08d1$var$topCellBorderStylesOld,
    NO_COLUMN_BORDER: $1118dff792cb08d1$var$topCellBorderStylesOld,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $1118dff792cb08d1$var$noRowCellBorderStylesOld
};
const $1118dff792cb08d1$var$cellBorderLocationStyleMap = {
    FULL_BORDER: $1118dff792cb08d1$var$topCellBorderStyles,
    NO_COLUMN_BORDER: $1118dff792cb08d1$var$topCellBorderStyles,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $1118dff792cb08d1$var$noRowCellBorderStyles
};
const $1118dff792cb08d1$var$stickyContainerStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerStylesOldRTL = (0, $1DXK0.xcss)({
    position: 'sticky',
    insetInlineStart: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerStylesRTL = (0, $1DXK0.xcss)({
    position: 'sticky',
    insetInlineStart: 'space.600',
    width: 'fit-content'
});
const $1118dff792cb08d1$var$stickyContainerResponsiveStyles = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        position: 'sticky',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        left: 'space.600',
        width: 'fit-content'
    }
});
const $1118dff792cb08d1$var$stickyContainerResponsiveStylesRTL = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        position: 'sticky',
        insetInlineStart: 'space.600',
        width: 'fit-content'
    }
});
const $1118dff792cb08d1$var$firstColumnSpacingStyles = (0, $1DXK0.xcss)({
    padding: '0'
});
const $1118dff792cb08d1$var$firstColumnBorderStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightColor: 'color.border',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $1118dff792cb08d1$var$firstColumnBorderStyles = (0, $1DXK0.xcss)({
    borderInlineEndColor: 'color.border',
    borderInlineEndStyle: 'solid',
    borderInlineEndWidth: 'border.width'
});

});
parcelRegister("bKlUQ", function(module, exports) {
$parcel$export(module.exports, "TableCell", () => $939ec101f3206f90$export$1e4baea7053fc0e3);

var $eJOHy = parcelRequire("eJOHy");

var $buoPQ = parcelRequire("buoPQ");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $ibVOD = parcelRequire("ibVOD");

var $johMb = parcelRequire("johMb");

var $34oCh = parcelRequire("34oCh");

var $hHg7L = parcelRequire("hHg7L");

var $8jOO7 = parcelRequire("8jOO7");
const $939ec101f3206f90$export$1e4baea7053fc0e3 = (props)=>{
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    return isSingleLineRowHeightEnabled && !(0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($939ec101f3206f90$var$TableCellInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($939ec101f3206f90$var$TableCellInner, props);
};
const $939ec101f3206f90$var$TableCellInner = ({ children: children, border: border, spacing: spacing, formatting: formatting, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, hasRightShadow: hasRightShadow, fieldId: fieldId, onFocusHandler: onFocusHandler, onBlurHandler: onBlurHandler, ...htmlAttributes })=>{
    const spacingStyles = spacing !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(spacing) : [
        (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$defaultSpacingStyles : $939ec101f3206f90$var$defaultSpacingStylesOld
    ];
    const borderStyles = border !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(border) : [];
    const formattingStyles = formatting !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(formatting) : [];
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const eventDelegatorRef = isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hHg7L.useEventDelegatorRef)(fieldId) : null;
    let singleLineRowHeightProps = {};
    if (isSingleLineRowHeightEnabled && !(0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave } = (0, $ibVOD.useCellHoverHandlers)();
        singleLineRowHeightProps = {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        };
    }
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const stickyColumnZIndex = stickyOffsets === 0 ? (0, $8jOO7.Z_INDEX_STICKY_COLUMN) + 1 : (0, $8jOO7.Z_INDEX_STICKY_COLUMN);
    const stickyResponsiveStylesFG = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$stickyResponsiveStyles : $939ec101f3206f90$var$stickyResponsiveStylesOld;
    const shadowResponsiveStylesFG = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$shadowResponsiveStyles : $939ec101f3206f90$var$shadowResponsiveStylesOld;
    const shadowStylesFG = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $939ec101f3206f90$var$shadowStylesNew : $939ec101f3206f90$var$shadowStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: [
            $939ec101f3206f90$var$baseStyles,
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') && $939ec101f3206f90$var$textAlignInherit,
            ...spacingStyles,
            ...borderStyles,
            ...isConditionalFormattingEnabled ? formattingStyles : [],
            isGridNavigationEnabled && $939ec101f3206f90$var$keyboardNavigationStyles,
            // eslint-disable-next-line no-nested-ternary
            ...isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') ? (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? [
                isAutoUnstickyOnSmallScreenEnabled ? stickyResponsiveStylesFG : $939ec101f3206f90$var$stickyStyles
            ] : [
                $939ec101f3206f90$var$stickyStylesOld
            ] : [],
            // eslint-disable-next-line no-nested-ternary
            ...hasRightShadow && (0, $4cTDP.fg)('issue_table_frozen_columns') ? (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? [
                isAutoUnstickyOnSmallScreenEnabled ? shadowResponsiveStylesFG : shadowStylesFG
            ] : [
                $939ec101f3206f90$var$shadowStylesOld
            ] : []
        ],
        ...htmlAttributes,
        ...isSingleLineRowHeightEnabled && !(0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') && singleLineRowHeightProps,
        ...isGridNavigationEnabled && {
            tabIndex: -1
        },
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            style: {
                ...htmlAttributes.style,
                left: isColumnSticky ? (0, $johMb.getColumnOffset)(stickyOffsets ?? 0, !!isColumnResizing) : undefined,
                // Adjust zIndex for the first sticky column to ensure the inline create indicator line
                // is displayed above it. Previously, zIndex was 7 (greater than CHART_PREVIEW_BAR_Z_INDEX = 6).
                // Now, for the first column (stickyOffsets === 0), we set zIndex to 8.
                // This ensures the indicator line is not hidden behind the second sticky column,
                // whose zIndex remains lower (7).
                zIndex: isColumnSticky ? stickyColumnZIndex : undefined,
                height: isTimelineEnabled ? `${0, $8jOO7.ROW_HEIGHT}px` : undefined
            }
        },
        ...eventDelegatorRef && {
            ref: eventDelegatorRef
        },
        ...onFocusHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onFocus: onFocusHandler
        } : {},
        ...onBlurHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onBlur: onBlurHandler
        } : {}
    }, children);
};
const $939ec101f3206f90$var$baseStyles = (0, $1DXK0.xcss)({
    background: 'inherit',
    // Cross-browser CSS hack to allow inline editable fields to fill the entire space of their `td`. The
    // preferred long-term solution is to adopt a flexbox layout, but until then, please do extensive
    // cross-browser testing before you update this rule.
    height: '100%',
    position: 'relative'
});
const $939ec101f3206f90$var$textAlignInherit = (0, $1DXK0.xcss)({
    textAlign: 'inherit'
});
const $939ec101f3206f90$var$keyboardNavigationStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    ':focus': {
        outline: 'unset'
    },
    ':focus::before': {
        display: 'block',
        content: '" "',
        position: 'absolute',
        height: '100%',
        width: '100%',
        inset: '0px',
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.focused',
        borderStyle: 'solid',
        boxSizing: 'border-box',
        pointerEvents: 'none'
    }
});
const $939ec101f3206f90$var$defaultSpacingStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInlineEnd: 'space.100'
    }
});
const $939ec101f3206f90$var$defaultSpacingStylesOld = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        paddingLeft: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        paddingRight: 'space.100'
    }
});
const $939ec101f3206f90$var$stickyStyles = (0, $1DXK0.xcss)({
    position: 'sticky'
});
const $939ec101f3206f90$var$stickyResponsiveStyles = (0, $1DXK0.xcss)({
    position: 'sticky',
    // @ts-expect-error doesn't support media.md yet
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    [(0, $6efFi.media).below.md]: {
        insetInlineStart: '0 !important',
        position: 'relative'
    }
});
const $939ec101f3206f90$var$stickyResponsiveStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky',
    // @ts-expect-error doesn't support media.md yet
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/no-physical-properties
    [(0, $6efFi.media).below.md]: {
        left: '0 !important',
        position: 'relative'
    }
});
const $939ec101f3206f90$var$stickyStylesOld = (0, $1DXK0.xcss)({
    position: 'sticky'
});
const $939ec101f3206f90$var$shadowStylesOld = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        right: '-5px',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        top: 'space.0'
    }
});
const $939ec101f3206f90$var$shadowStylesNew = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        insetInlineEnd: '-5px',
        insetBlockStart: 'space.0'
    }
});
const $939ec101f3206f90$var$shadowStyles = (0, $1DXK0.xcss)({
    '::after': {
        height: '100%',
        width: '4px',
        content: "''",
        opacity: 0.5,
        transition: 'opacity 0.25s',
        background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        right: '-5px',
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        top: 'space.0'
    }
});
const $939ec101f3206f90$var$shadowResponsiveStyles = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        '::after': {
            height: '100%',
            width: '4px',
            content: "''",
            opacity: 0.5,
            transition: 'opacity 0.25s',
            background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
            position: 'absolute',
            insetInlineEnd: '-5px',
            insetBlockStart: 'space.0'
        }
    }
});
const $939ec101f3206f90$var$shadowResponsiveStylesOld = (0, $1DXK0.xcss)({
    [(0, $6efFi.media).above.md]: {
        '::after': {
            height: '100%',
            width: '4px',
            content: "''",
            opacity: 0.5,
            transition: 'opacity 0.25s',
            background: 'linear-gradient(90deg, #0000001a 0%, #0000)',
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
            right: '-5px',
            // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
            top: 'space.0'
        }
    }
});

});
parcelRegister("buoPQ", function(module, exports) {

var $4sprp = parcelRequire("4sprp");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $85d5c2cbe671e6d1$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $4sprp(value) ? value : [
        value
    ];
}
module.exports = $85d5c2cbe671e6d1$var$castArray;

});

parcelRegister("johMb", function(module, exports) {
$parcel$export(module.exports, "getExpandColumnWidth", () => $20ef55c956fe2fc8$export$6344c84966147aa0);
$parcel$export(module.exports, "getColumnOffset", () => $20ef55c956fe2fc8$export$3e2d9135e2882f1d);

var $8jOO7 = parcelRequire("8jOO7");
const $20ef55c956fe2fc8$export$6344c84966147aa0 = (depth)=>depth * (0, $8jOO7.DEPTH_WIDTH) + (0, $8jOO7.EXPAND_BUTTON_WIDTH) + (0, $8jOO7.CREATE_CHILD_BUTTON_WIDTH) + (0, $8jOO7.EXPAND_CELL_PADDING);
const $20ef55c956fe2fc8$export$3e2d9135e2882f1d = (stickyOffsets, isResizing)=>{
    if (isResizing) return `calc(${stickyOffsets}px + var(--local-resizing-offset, 0px))`;
    return `${stickyOffsets}px`;
};

});


parcelRegister("aIvQb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7f7f80423ad6969$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a7f7f80423ad6969$var$messages = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "native-issue-table.common.load-more-items-row.show-more",
        "defaultMessage": "Show more"
    },
    loadingMoreItems: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items",
        "defaultMessage": "Loading more issues"
    },
    loadingMoreItemsIssueTermRefresh: {
        "id": "native-issue-table.common.load-more-items-row.loading-more-items-issue-term-refresh",
        "defaultMessage": "Loading more"
    }
});
var $a7f7f80423ad6969$export$2e2bcd8739ae039 = $a7f7f80423ad6969$var$messages;

});


parcelRegister("4ukXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $27642a2bda62ee3e$export$2e2bcd8739ae039);

var $bmU4Y = parcelRequire("bmU4Y");

var $WeZRw = parcelRequire("WeZRw");

var $sJESu = parcelRequire("sJESu");

var $3dj04 = parcelRequire("3dj04");

var $5Y0sY = parcelRequire("5Y0sY");

var $8RCdW = parcelRequire("8RCdW");

var $fW2pM = parcelRequire("fW2pM");

var $eATeg = parcelRequire("eATeg");

var $iwZRK = parcelRequire("iwZRK");

var $5GSsM = parcelRequire("5GSsM");

var $fKELC = parcelRequire("fKELC");

var $6oQnh = parcelRequire("6oQnh");

var $gCeVo = parcelRequire("gCeVo");

var $fLV7A = parcelRequire("fLV7A");

var $d2t3W = parcelRequire("d2t3W");

var $dYqKE = parcelRequire("dYqKE");

var $7naPT = parcelRequire("7naPT");

var $e9mO4 = parcelRequire("e9mO4");

var $1Z7CP = parcelRequire("1Z7CP");

var $jB3kn = parcelRequire("jB3kn");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $1DXK0 = parcelRequire("1DXK0");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $68iTT = parcelRequire("68iTT");

var $bzbsd = parcelRequire("bzbsd");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $jBNts = parcelRequire("jBNts");

var $bJscI = parcelRequire("bJscI");

var $9RE4U = parcelRequire("9RE4U");

var $l4EsH = parcelRequire("l4EsH");

var $7n9BS = parcelRequire("7n9BS");

var $34oCh = parcelRequire("34oCh");

var $3TtKq = parcelRequire("3TtKq");

var $4NiKr = parcelRequire("4NiKr");

var $3F6xT = parcelRequire("3F6xT");

var $jNv5I = parcelRequire("jNv5I");

var $fZpej = parcelRequire("fZpej");

var $29rOm = parcelRequire("29rOm");

var $7EMZm = parcelRequire("7EMZm");

var $6P9sy = parcelRequire("6P9sy");

var $c3pb3 = parcelRequire("c3pb3");

var $8zNZc = parcelRequire("8zNZc");
const $27642a2bda62ee3e$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-row",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $27642a2bda62ee3e$var$RowWithSiblingCreate = (props)=>{
    const { itemsConnectionId: itemsConnectionId, rowIndex: rowIndex, parentIssueAri: parentIssueAri, rankFieldId: rankFieldId, parentIssueHierarchyLevel: parentIssueHierarchyLevel, groupContextFieldInput: groupContextFieldInput, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig } = props;
    const projectRef = (0, $j4oe4.useFragment)((0, $jB3kn.default), props.project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $1Z7CP.default), props.formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $e9mO4.default), props.issueEdge);
    const issueRowData = issueRowEdgeData?.node;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $7naPT.default), props.fieldSets);
    const { onMouseLeave: onMouseLeave, onMouseMove: onMouseMove } = (0, $4NiKr.useSiblingIssueCreateHandler)(itemsConnectionId, rowIndex);
    const projectContext = (0, $34oCh.useProjectContext)();
    let inlineCreateHandlersInput;
    if (parentIssueHierarchyLevel != null && (0, $4cTDP.fg)('jsc_list_reranking_gate')) inlineCreateHandlersInput = {
        projectKey: projectContext,
        minHierarchyLevel: parentIssueHierarchyLevel - 1,
        maxHierarchyLevel: parentIssueHierarchyLevel - 1
    };
    else if (parentIssueHierarchyLevel == null && (0, $4cTDP.fg)('timeline_harmonisation_m3_targeting')) inlineCreateHandlersInput = {
        projectKey: projectContext,
        maxHierarchyLevel: topLevelIssueCreateConfig?.maxHierarchyLevel,
        minHierarchyLevel: topLevelIssueCreateConfig?.minHierarchyLevel ?? 0
    };
    else inlineCreateHandlersInput = {
        projectKey: projectContext,
        minHierarchyLevel: 0
    };
    const { isFormVisible: isFormVisible, formProps: formProps, triggerProps: triggerProps } = (0, $68iTT.useInlineCreateHandlers)(inlineCreateHandlersInput);
    const issueCreateRowContext = (0, $eJOHy.useMemo)(()=>({
            isFormVisible: isFormVisible,
            triggerProps: triggerProps
        }), [
        isFormVisible,
        triggerProps
    ]);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    let setIsSiblingCreateVisible = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    setIsSiblingCreateVisible = (0, $jE8Tu.useHierarchyActions)().setIsSiblingCreateVisible;
     // Reset the sibling create visibility when form is closed of row is unmounted
    const prevIsFormVisible = (0, $eJOHy.useRef)(isFormVisible);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) return;
        const itemId = issueRowData?.issueId;
        if (itemId && prevIsFormVisible.current && isFormVisible === false) setIsSiblingCreateVisible?.({
            itemsConnectionId: itemsConnectionId,
            itemId: itemId,
            groupId: groupId
        }, false);
        prevIsFormVisible.current = isFormVisible;
        return ()=>{
            if (isFormVisible && itemId) setIsSiblingCreateVisible?.({
                itemsConnectionId: itemsConnectionId,
                itemId: itemId,
                groupId: groupId
            }, false);
        };
    }, [
        isFormVisible,
        setIsSiblingCreateVisible,
        itemsConnectionId,
        groupId,
        issueRowData?.issueId
    ]);
    const issueCreateRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EMZm.IssueCreateRow), {
        canShowAdditionalFields: (0, $4cTDP.fg)('refactor_issue_table_for_timline') ? rowInlineCreateCanShowAdditionalFields : !isTimelineEnabled,
        depth: 0,
        isGrouping: !!groupId && (0, $4cTDP.fg)('jira_list_merged_column_gate'),
        isFormVisible: isFormVisible,
        issuesConnectionId: itemsConnectionId,
        siblingIssueId: issueRowData?.id ?? '',
        rankFieldId: rankFieldId,
        parentIssueAri: parentIssueAri,
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            location: 'siblingCreateForm'
        },
        ...(0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') && {
            groupContextFieldInput: groupContextFieldInput
        },
        ...formProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NiKr.SiblingIssueCreateRowContext).Provider, {
        value: issueCreateRowContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeRowWithDragAndDrop, {
        ...props,
        project: projectRef,
        formattingRules: formattingRulesRef,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        beforeRow: issueCreateRow
    }));
};
const $27642a2bda62ee3e$var$RowWithDragAndDrop = (props)=>{
    const projectRef = (0, $j4oe4.useFragment)((0, $dYqKE.default), props.project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $d2t3W.default), props.formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $fLV7A.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $gCeVo.default), props.fieldSets);
    const issueRowData = issueRowEdgeData?.node;
    const draggableRef = (0, $l4EsH.useDraggableRow)({
        edgeIndex: props.rowIndex,
        issueId: issueRowData?.id ?? '',
        hierarchyLevel: props.hierarchyLevel,
        parentIssueAri: props.parentIssueAri,
        parentIssueEdgeRelayId: props.parentItemConnectionId,
        parentIssueConnectionId: props.parentIssueRelayConnectionId,
        issueEdgeRelayId: issueRowEdgeData?.__id,
        depth: props.depth,
        itemsConnectionId: props.itemsConnectionId,
        projectKey: props.projectKey,
        hasChildren: Boolean(issueRowEdgeData?.hasChildren),
        issueKey: props.issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeMemoRowInner, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: projectRef,
        formattingRules: formattingRulesRef,
        ref: draggableRef
    });
};
const $27642a2bda62ee3e$var$MaybeRowWithDragAndDrop = (props)=>{
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const projectRef = (0, $j4oe4.useFragment)((0, $6oQnh.default), props.project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $fKELC.default), props.formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $5GSsM.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $iwZRK.default), props.fieldSets);
    if (isDragAndDropEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$RowWithDragAndDrop, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: projectRef,
        formattingRules: formattingRulesRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeMemoRowInner, {
        ...props,
        project: projectRef,
        formattingRules: formattingRulesRef,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null
    });
};
const $27642a2bda62ee3e$var$RowInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const { rowIndex: rowIndex, project: project, issueEdge: issueEdge, fieldSets: fieldSets, itemsConnectionId: itemsConnectionId, depth: depth, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, beforeRow: beforeRow, triggerProps: triggerProps, isFormVisible: isFormVisible, parentIssueAri: parentIssueAri, parentIssueRelayConnectionId: parentIssueRelayConnectionId, measureElement: measureElement = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), hierarchyLevel: hierarchyLevel, issueKey: issueKey, projectKey: projectKey, previousItemId: previousItemId, isDraggingRowFaded: isDraggingRowFaded, isStickyColumnsVisible: isStickyColumnsVisible, formattingRules: formattingRules } = props;
    const tableRowRef = (0, $eJOHy.useRef)(null);
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    const projectRef = (0, $j4oe4.useFragment)((0, $eATeg.default), project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $fW2pM.default), formattingRules);
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $8RCdW.default), issueEdge);
    const issueRowData = issueRowEdgeData?.node;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $5Y0sY.default), fieldSets);
    const itemDetails = (0, $eJOHy.useMemo)(()=>issueRowData ? {
            itemsConnectionId: itemsConnectionId,
            itemId: issueRowData.issueId,
            groupId: groupId
        } : null, [
        issueRowData,
        itemsConnectionId,
        groupId
    ]); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const list = isGridNavigationEnabled ? (0, $jE8Tu.useFlatList)() : [];
    const [isSelected, { setSelectedRow: setSelectedRow }] = (0, $jE8Tu.useIsSelected)(itemDetails);
    const prevIsSelected = (0, $6d9QY.usePreviousWithInitial)(isSelected);
    const [isFocused, { resetFocus: resetFocus }] = (0, $jE8Tu.useIsFocused)(itemDetails);
    const [isRowHovered, setIsRowHovered] = (0, $eJOHy.useState)(false);
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const [currentDraggingRow, setCurrentDraggingRow] = (0, $eJOHy.useState)(null);
    const isScrolling = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.isScrolling);
    const isIssueSelected = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelected)({
        rowIndex: rowIndex,
        issueId: issueRowData?.issueId ?? '',
        depth: depth
    }) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3TtKq.useIsIssueSelectedOld)(issueRowEdgeData?.node?.issueId ?? '');
    (0, $eJOHy.useEffect)(()=>{
        // Explicitly reset our internal state to track which row is focused. We do this to prevent the DOM element being re-focused unintentionally when the component is re-rendered.
        if (isFocused) resetFocus();
    }, [
        isFocused,
        resetFocus
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    const onMouseOverHandler = (0, $eJOHy.useCallback)(()=>{
        if (!isScrolling && (isIssueHierarchyEnabled || isConditionalFormattingEnabled || isDragAndDropEnabled || isGridNavigationEnabled && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style'))) setIsRowHovered(true);
    }, [
        isScrolling,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        isDragAndDropEnabled,
        isGridNavigationEnabled
    ]);
    const onMouseLeaveHandler = (0, $eJOHy.useCallback)((e)=>{
        onMouseLeave?.(e);
        if (isIssueHierarchyEnabled || isConditionalFormattingEnabled || isDragAndDropEnabled || isGridNavigationEnabled && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) setIsRowHovered(false);
    }, [
        onMouseLeave,
        isIssueHierarchyEnabled,
        isConditionalFormattingEnabled,
        isDragAndDropEnabled,
        isGridNavigationEnabled
    ]);
    const focusCurrentRow = (0, $eJOHy.useCallback)(()=>setSelectedRow(itemDetails), [
        setSelectedRow,
        itemDetails
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const clickAnalytics = createAnalyticsEvent({});
        const actionSubjectId = issueRowData ? 'issueRow' : 'blankRow';
        (0, $kRgKj.fireUIAnalytics)(clickAnalytics, 'rowItem clicked', actionSubjectId);
    }, [
        createAnalyticsEvent,
        issueRowData
    ]);
    const isColumnBordersEnabled = (0, $34oCh.useIsColumnBordersEnabled)();
    let showBorderOnTopLevelItem = false;
    if ((0, $4cTDP.fg)('jira_timeline_cell_border_style')) {
        let isExpanded = false;
        if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isExpanded = (0, $jE8Tu.useIsItemVisuallyExpanded)(itemDetails);
        else // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        [isExpanded] = (0, $jE8Tu.useIsItemExpanded)(itemDetails);
        const previousItemDetails = previousItemId ? {
            itemsConnectionId: itemsConnectionId,
            itemId: previousItemId,
            groupId: groupId
        } : null;
        let isPreviousItemExpanded = false;
        if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isPreviousItemExpanded = (0, $jE8Tu.useIsItemVisuallyExpanded)(previousItemDetails);
        else // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        [isPreviousItemExpanded] = (0, $jE8Tu.useIsItemExpanded)(previousItemDetails);
        showBorderOnTopLevelItem = cellBorderStyle === 'ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY' && depth === 0 && (isExpanded || isPreviousItemExpanded);
    }
    const isGrouping = !!groupId && (0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false);
    const cellBorder = (0, $eJOHy.useMemo)(()=>(0, $4cTDP.fg)('jira_timeline_cell_border_style') ? [
            $27642a2bda62ee3e$var$baseCellBorderStyles,
            $27642a2bda62ee3e$var$cellBorderLocationStyleMap[cellBorderStyle],
            showBorderOnTopLevelItem && $27642a2bda62ee3e$var$topCellBorderStyles,
            rowIndex === 0 && !parentIssueAri && !isGrouping && $27642a2bda62ee3e$var$firstRowCellBorderStyles
        ] : [
            isColumnBordersEnabled ? $27642a2bda62ee3e$var$cellBorderStyles : $27642a2bda62ee3e$var$cellBorderStylesWithNoColumn,
            rowIndex === 0 && !parentIssueAri && !isGrouping && $27642a2bda62ee3e$var$firstRowCellBorderStyles
        ], [
        cellBorderStyle,
        showBorderOnTopLevelItem,
        rowIndex,
        parentIssueAri,
        isGrouping,
        isColumnBordersEnabled
    ]);
    const beforeFirstCell = (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        if (issueRowEdgeData?.node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fZpej.BeforeFirstCell), {
            edgeIndex: rowIndex,
            issueId: issueRowEdgeData?.node.id,
            itemsConnectionId: itemsConnectionId,
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            parentIssueConnectionId: parentIssueRelayConnectionId,
            issueKey: issueKey,
            projectKey: projectKey,
            ...isDragAndDropEnabled ? {
                isRowHovered: isRowHovered
            } : {},
            ...isReParentingEnabled ? {
                issueRowData: issueRowEdgeData?.node || null,
                setCurrentDraggingRow: setCurrentDraggingRow
            } : {
                issueRowData: null
            }
        });
        return null;
    }, [
        rowIndex,
        itemsConnectionId,
        hierarchyLevel,
        parentIssueAri,
        parentIssueRelayConnectionId,
        issueKey,
        projectKey,
        isDragAndDropEnabled,
        isRowHovered,
        isReParentingEnabled,
        issueRowEdgeData?.node
    ]) : null;
    const getRowContent = ()=>{
        /**
     * Fix for flicker during optimistic issue creation caused by Relay fragment race condition.
     *
     * When Relay replaces an optimistic issue with real server data, there's a brief moment where
     * issueEdge.node exists but issueRowEdgeData (from useFragment) is temporarily unavailable.
     * Returning null prevents the flicker: IssueRow → BlankIssueRow → IssueRow.
     */ if (!issueRowEdgeData?.node && issueEdge && 'node' in issueEdge && issueEdge.node && (0, $4cTDP.fg)('jira_list_fragment_data_race_condition_fix')) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueRowEdgeDataFragmentHydration failed');
            return null;
        }
        if (issueRowEdgeData?.node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c3pb3.IssueRow), {
            project: projectRef,
            issueEdge: issueRowEdgeData ?? null,
            fieldSets: fieldSetsData ?? null,
            cellBorder: cellBorder,
            isStickyColumnsVisible: isStickyColumnsVisible,
            beforeFirstCell: (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? beforeFirstCell : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fZpej.BeforeFirstCell), {
                edgeIndex: rowIndex,
                issueId: issueRowEdgeData?.node.id,
                itemsConnectionId: itemsConnectionId,
                hierarchyLevel: hierarchyLevel,
                parentIssueAri: parentIssueAri,
                parentIssueConnectionId: parentIssueRelayConnectionId,
                issueKey: issueKey,
                projectKey: projectKey,
                ...isDragAndDropEnabled ? {
                    isRowHovered: isRowHovered
                } : {},
                ...isReParentingEnabled ? {
                    issueRowData: issueRowEdgeData?.node || null,
                    setCurrentDraggingRow: setCurrentDraggingRow
                } : {
                    issueRowData: null
                }
            }),
            itemsConnectionId: itemsConnectionId,
            depth: depth,
            isRowHoveredOrSelected: isFocused || isSelected || isRowHovered,
            rowIndex: rowIndex,
            triggerProps: triggerProps,
            isFormVisible: isFormVisible,
            formattingRules: formattingRulesRef
        });
        if (issueRowEdgeData?.issueError && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6P9sy.default), {
            isSelected: isSelected,
            cellBorder: cellBorder,
            errorRef: issueRowEdgeData.issueError,
            issueKey: issueKey
        });
         // Default to blank row
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29rOm.default), {
            isSelected: isSelected,
            cellBorder: cellBorder
        });
    };
    const rowContent = getRowContent(); /**
                                       * Only scroll table row into view when it's a _newly_ selected row.
                                       *
                                       * We keep track of the prev selected state to avoid jumping to the selected row on mount. This issue
                                       * was introduced when we enabled virtualization as part of the infinite scroll work.
                                       * @see https://getsupport.atlassian.com/browse/PCS-359806
                                       */ 
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isSelected && isSelected !== prevIsSelected) tableRowRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        isSelected,
        prevIsSelected
    ]);
    const highlightFadeOut = (0, $eJOHy.useRef)(false);
    const onInterceptionItemRef = (0, $3F6xT.useObserveItem)(issueRowData?.id);
    let trRef = (0, $bzbsd.default)(onInterceptionItemRef, tableRowRef, forwardedRef);
    const isHighlighted = issueRowData?.isHighlightedIssueRow ?? false;
    const prevIsHighlighted = (0, $6d9QY.usePrevious)(isHighlighted); // Begin fade out animation when isHighlighted changes to false
    if (prevIsHighlighted && !isHighlighted) highlightFadeOut.current = true;
    trRef = (0, $bzbsd.default)(trRef, measureElement);
    let itemKey = null;
    if (itemsConnectionId && issueRowData?.id) itemKey = (0, $jE8Tu.getItemKey)(itemsConnectionId, issueRowData.id);
    const overallRowIndex = itemDetails && isGridNavigationEnabled ? list.indexOf((0, $jBNts.getFlatListKey)(itemDetails)) + 1 : -1; // eslint-disable-next-line no-nested-ternary
    const color = (0, $4cTDP.fg)('jira_list_conditional_formatting') ? (0, $4cTDP.fg)('saved_list_view_technical_changes') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8zNZc.useRowColor)(fieldSetsData, null, formattingRulesRef) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8zNZc.useRowColor)(fieldSetsData, projectRef) : undefined; // placeholder for what will be const color = useRowColor in the future.
    // TODO: Move inside `css` prop on `jsc-2065-unify-onrowreorder` cleanup
    const shouldHaveDraggableRowStyles = (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? isDragAndDropEnabled && isEntireRowDraggable : isEntireRowDraggable;
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    if (!rowContent && (0, $4cTDP.fg)('jira_list_fragment_data_race_condition_fix')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "native-issue-table.ui.issue-row",
        "aria-selected": isIssueSelected && isGridNavigationEnabled || isSelected,
        ...overallRowIndex > 0 && isGridNavigationEnabled && {
            'aria-rowindex': overallRowIndex
        },
        role: "row",
        onAnimationEnd: ()=>{
            /*
        Animation set using @compiled may be inadvertently started when the scripting engine applies
        new styles (e.g. after a new issue row is appended). We need to set the animation duration
        to 0s once the animation has completed to prevent the animation restarting.
        See https://drafts.csswg.org/css-animations-1/#animations
         */ if (tableRowRef.current) tableRowRef.current.style.animationDuration = '0s';
        },
        onFocus: focusCurrentRow,
        onClick: onClick,
        onMouseOver: onMouseOverHandler,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeaveHandler,
        tabIndex: -1,
        ...isConditionalFormattingEnabled && color && {
            style: {
                backgroundColor: isRowHovered ? color.hoverValue : color.value
            }
        },
        'data-index': rowIndex,
        ref: trRef,
        "data-vc": `issue-row${false && !isPageHydrating ? '-ssr' : ''}`,
        ...false && !isPageHydrating && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder': 'issue-row-placeholder'
        },
        ...!false && !isPageHydrating && (0, $4cTDP.fg)('additional_nin_ssr_placeholders') && {
            'data-ssr-placeholder-replace': 'issue-row-placeholder'
        },
        className: (0, $hcewu.default)([
            "_4t3i1ylp _kqswh2mm _bfhkvuon _nt751r31 _49pcglyw _1hvw1o36 _7psyru3m _irr3108i",
            isGridNavigationEnabled && "_qj5iru3m _10j7fg4m _1p0pi1yw",
            highlightFadeOut.current && "",
            highlightFadeOut.current && "_j7hqwkqb _5sagymdr _1pgl6ui8",
            (isSelected && !(0, $4cTDP.fg)('nin-grid-keyboard-navigation') || isIssueSelected) && "_5sagru3m _bfhkfg4m _irr3i1yw",
            isHighlighted && "_bfhkavxe",
            shouldHaveDraggableRowStyles && "_80om1qgj _1qam5szm",
            currentDraggingRow !== null && currentDraggingRow === itemKey && (isDraggingRowFaded || !(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) && (0, $4cTDP.fg)('jsc_list_reparenting') && "_tzy41ou4"
        ])
    }, rowContent)));
});
const $27642a2bda62ee3e$var$MaybeMemoRowInner = /*#__PURE__*/ (0, $eJOHy.memo)($27642a2bda62ee3e$var$RowInner);
const $27642a2bda62ee3e$var$RowNonMemoized = (props)=>{
    const issueRowEdgeData = (0, $j4oe4.useFragment)((0, $3dj04.default), props.issueEdge);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $sJESu.default), props.fieldSets);
    const project = (0, $j4oe4.useFragment)((0, $WeZRw.default), props.project);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $bmU4Y.default), props.formattingRules);
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    if (isSiblingIssueCreateEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$RowWithSiblingCreate, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: project,
        formattingRules: formattingRulesData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27642a2bda62ee3e$var$MaybeRowWithDragAndDrop, {
        ...props,
        issueEdge: issueRowEdgeData ?? null,
        fieldSets: fieldSetsData ?? null,
        project: project,
        formattingRules: formattingRulesData
    });
};
const $27642a2bda62ee3e$var$Row = (0, $bJscI.componentWithFG)('initialise_virtualiser_state_from_relay_store', /*#__PURE__*/ (0, $eJOHy.memo)($27642a2bda62ee3e$var$RowNonMemoized), $27642a2bda62ee3e$var$RowNonMemoized);
var $27642a2bda62ee3e$export$2e2bcd8739ae039 = $27642a2bda62ee3e$var$Row;
const $27642a2bda62ee3e$var$ROW_HEIGHT = 40; // TODO: Remove with clean up of jira_timeline_cell_border_style
const $27642a2bda62ee3e$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockStartWidth: 'border.width',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: '0'
    }
}); // TODO: Remove with clean up of jira_timeline_cell_border_style
const $27642a2bda62ee3e$var$cellBorderStylesWithNoColumn = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockStartWidth: 'border.width',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '0'
});
const $27642a2bda62ee3e$var$firstRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: '0'
});
const $27642a2bda62ee3e$var$baseCellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockEndWidth: '0',
    borderInlineStartWidth: '0',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: '0'
    }
});
const $27642a2bda62ee3e$var$fullCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width',
    borderInlineEndWidth: 'border.width'
});
const $27642a2bda62ee3e$var$noColumnCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width',
    borderInlineEndWidth: '0'
});
const $27642a2bda62ee3e$var$noRowCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: '0',
    borderInlineEndWidth: 'border.width'
});
const $27642a2bda62ee3e$var$topCellBorderStyles = (0, $1DXK0.xcss)({
    borderBlockStartWidth: 'border.width'
});
const $27642a2bda62ee3e$var$cellBorderLocationStyleMap = {
    FULL_BORDER: $27642a2bda62ee3e$var$fullCellBorderStyles,
    NO_COLUMN_BORDER: $27642a2bda62ee3e$var$noColumnCellBorderStyles,
    ROW_BORDER_FOR_EXPANDED_TOP_LEVEL_ONLY: $27642a2bda62ee3e$var$noRowCellBorderStyles
};
const $27642a2bda62ee3e$var$fadeOut = null;
const $27642a2bda62ee3e$var$rowStyles = null;
const $27642a2bda62ee3e$var$rowStylesKeyboardNavigation = null;
const $27642a2bda62ee3e$var$draggableRowStyles = null;
const $27642a2bda62ee3e$var$activeRowStyles = null;
const $27642a2bda62ee3e$var$highlightRowStyles = null;
const $27642a2bda62ee3e$var$draggingRowFadedStyles = null;
const $27642a2bda62ee3e$var$highlightFadeOutStyles = null;

});
parcelRegister("bmU4Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $20c3b5e5bb6e324d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<931b8a8e2d118f3bc5a3772b6e630d17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20c3b5e5bb6e324d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Row_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "RowWithSiblingCreate_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$20c3b5e5bb6e324d$var$node.hash = "7dff2c26d095d5e3683d5477fc25813c";
var $20c3b5e5bb6e324d$export$2e2bcd8739ae039 = $20c3b5e5bb6e324d$var$node;

});

parcelRegister("WeZRw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4caa581789ccdce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<575237eb5c039abf0810a572b4b54219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4caa581789ccdce$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "Row_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowMaybeWithDragAndDrop_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithSiblingCreate_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$c4caa581789ccdce$var$node.hash = "29bc757a62493204a08d7359797abc9b";
var $c4caa581789ccdce$export$2e2bcd8739ae039 = $c4caa581789ccdce$var$node;

});

parcelRegister("sJESu", function(module, exports) {
$parcel$export(module.exports, "default", () => $622d35675373501e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<409000e83557fda1696afaefcb0bc0cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $622d35675373501e$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "Row_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithSiblingCreate_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowMaybeWithDragAndDrop_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_fieldSets"
            },
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useRowColor"
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$622d35675373501e$var$node.hash = "0018309ff3a83209b2cf9935ef8f2458";
var $622d35675373501e$export$2e2bcd8739ae039 = $622d35675373501e$var$node;

});

parcelRegister("3dj04", function(module, exports) {
$parcel$export(module.exports, "default", () => $1aa01893f76c2c30$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4efd5a53413717b0d68f9e9748182492>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1aa01893f76c2c30$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "Row_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithSiblingCreate_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowMaybeWithDragAndDrop_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$1aa01893f76c2c30$var$node.hash = "d9df20eb58b51c0f60df6f3b02d6583f";
var $1aa01893f76c2c30$export$2e2bcd8739ae039 = $1aa01893f76c2c30$var$node;

});

parcelRegister("5Y0sY", function(module, exports) {
$parcel$export(module.exports, "default", () => $5445d1a2195ee112$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eb0dae690d1c33d596523393a5dbca0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5445d1a2195ee112$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_fieldSets",
    "selections": [
        {
            "condition": "isConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useRowColor"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueRow_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$5445d1a2195ee112$var$node.hash = "9882f56e8bb49695f4d3d789cf350d24";
var $5445d1a2195ee112$export$2e2bcd8739ae039 = $5445d1a2195ee112$var$node;

});

parcelRegister("8RCdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $25b5b3eb93268313$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<86a5cd7eb22cde3262f246e638dd75f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25b5b3eb93268313$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueRowWithFragments_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isReparentingEnabled",
                            "variableName": "isReparentingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "BeforeFirstCell"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHighlightedIssueRow"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isRemoteLinkedIssuesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "issueError",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "remoteIssueErrorRow_nativeIssueTable"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$25b5b3eb93268313$var$node.hash = "72b6c32de647f01cd45e824ded332d3f";
var $25b5b3eb93268313$export$2e2bcd8739ae039 = $25b5b3eb93268313$var$node;

});

parcelRegister("fW2pM", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a5152bf7a7d416f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d584e1b8f1dbe67e3b1d4db631a9101b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a5152bf7a7d416f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_rules",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useRowColor_savedView_rules"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueRow_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$9a5152bf7a7d416f$var$node.hash = "9ebb21229d16cd8d8f5a9e2d4f85a37e";
var $9a5152bf7a7d416f$export$2e2bcd8739ae039 = $9a5152bf7a7d416f$var$node;

});

parcelRegister("eATeg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c854d42e45b12e14$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<059fd63b15cc735c824bb62e5ac23eff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c854d42e45b12e14$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowInner_project",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "useRowColor_rules"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "IssueRow"
        }
    ],
    "type": "JiraProject"
};
$c854d42e45b12e14$var$node.hash = "8be14ee957ae4ac1000f061823c57081";
var $c854d42e45b12e14$export$2e2bcd8739ae039 = $c854d42e45b12e14$var$node;

});

parcelRegister("iwZRK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6e4609ea1dc64ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fd4f77b4a159dc64c7069ee9f6d2e53>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6e4609ea1dc64ed$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
        },
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "RowMaybeWithDragAndDrop_fieldSets",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_fieldSets"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_fieldSets"
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$f6e4609ea1dc64ed$var$node.hash = "cd09469225ea664ec221e4c1ecb8938f";
var $f6e4609ea1dc64ed$export$2e2bcd8739ae039 = $f6e4609ea1dc64ed$var$node;

});

parcelRegister("5GSsM", function(module, exports) {
$parcel$export(module.exports, "default", () => $a25b8dc149a31f53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c02c3cca022cac91e0fbd4e30e2ba0f3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a25b8dc149a31f53$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isDensityFull",
            "variableName": "isDensityFull"
        },
        {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
        },
        {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
        },
        {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isReparentingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "RowMaybeWithDragAndDrop_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_issueEdge"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_issueEdge"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$a25b8dc149a31f53$var$node.hash = "ac91377160a49d398209c4ab8f0dad27";
var $a25b8dc149a31f53$export$2e2bcd8739ae039 = $a25b8dc149a31f53$var$node;

});

parcelRegister("fKELC", function(module, exports) {
$parcel$export(module.exports, "default", () => $480995bfbc9bb9fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5f5fc2b314adffc8928163d18f02f9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $480995bfbc9bb9fe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RowMaybeWithDragAndDrop_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowWithDragAndDrop_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "RowInner_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$480995bfbc9bb9fe$var$node.hash = "08b9aeb323501268f81c92713a749c54";
var $480995bfbc9bb9fe$export$2e2bcd8739ae039 = $480995bfbc9bb9fe$var$node;

});

parcelRegister("6oQnh", function(module, exports) {
$parcel$export(module.exports, "default", () => $12a65ebe49814fa1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43f19697759d9e7d6bd573958bc13de2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $12a65ebe49814fa1$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "RowMaybeWithDragAndDrop_project",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowWithDragAndDrop_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RowInner_project"
            }
        ],
        "type": "JiraProject"
    };
}();
$12a65ebe49814fa1$var$node.hash = "7b2fa8240809ed877a350cb43191a25e";
var $12a65ebe49814fa1$export$2e2bcd8739ae039 = $12a65ebe49814fa1$var$node;

});

parcelRegister("gCeVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c2795fc3beec2f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28ae15ef0b76f2cfab974ccdec5838f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0c2795fc3beec2f2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowInner_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$0c2795fc3beec2f2$var$node.hash = "c33ee218a603532c93608b35fa4ba2a8";
var $0c2795fc3beec2f2$export$2e2bcd8739ae039 = $0c2795fc3beec2f2$var$node;

});

parcelRegister("fLV7A", function(module, exports) {
$parcel$export(module.exports, "default", () => $183d15c477540265$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<38032053a9a7f2df1dcf4d00ffbe3e9c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $183d15c477540265$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowInner_issueEdge"
        },
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$183d15c477540265$var$node.hash = "d2e8902f955173a824707a1e4a160629";
var $183d15c477540265$export$2e2bcd8739ae039 = $183d15c477540265$var$node;

});

parcelRegister("d2t3W", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b58374314627791$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0fe38090b498f56a6896bae60efc1efe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b58374314627791$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowInner_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$1b58374314627791$var$node.hash = "411d45a42f6096614da4ec8427974ed3";
var $1b58374314627791$export$2e2bcd8739ae039 = $1b58374314627791$var$node;

});

parcelRegister("dYqKE", function(module, exports) {
$parcel$export(module.exports, "default", () => $316631534bf204c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<655f873df16294d2f8d6f122ac29210e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $316631534bf204c7$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithDragAndDrop_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowInner_project"
        }
    ],
    "type": "JiraProject"
};
$316631534bf204c7$var$node.hash = "600d8dce94ac71f00862105938b2962a";
var $316631534bf204c7$export$2e2bcd8739ae039 = $316631534bf204c7$var$node;

});

parcelRegister("7naPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $22021c0c255aa5ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1485f35ae641007e4b05c10db225e103>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22021c0c255aa5ca$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_fieldSets",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$22021c0c255aa5ca$var$node.hash = "f1999205364d01468f86cc16002a6b48";
var $22021c0c255aa5ca$export$2e2bcd8739ae039 = $22021c0c255aa5ca$var$node;

});

parcelRegister("e9mO4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f84f3baf0961c33$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51e25c856826096602ce978535432799>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f84f3baf0961c33$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_issueEdge",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_issueEdge"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$5f84f3baf0961c33$var$node.hash = "3b1fe3bbefc4839f3ccefb18c4157ecd";
var $5f84f3baf0961c33$export$2e2bcd8739ae039 = $5f84f3baf0961c33$var$node;

});

parcelRegister("1Z7CP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff9f5e2ddfa7463b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f051b0f3bc2a436aa842355fafd91f46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ff9f5e2ddfa7463b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$ff9f5e2ddfa7463b$var$node.hash = "bf0fac83a25d23ffe38288db84bbe828";
var $ff9f5e2ddfa7463b$export$2e2bcd8739ae039 = $ff9f5e2ddfa7463b$var$node;

});

parcelRegister("jB3kn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7432c642c9b1a0a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f60d02c7a28a1c92a33e779c4f66dda>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7432c642c9b1a0a4$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowWithSiblingCreate_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "RowMaybeWithDragAndDrop_project"
        }
    ],
    "type": "JiraProject"
};
$7432c642c9b1a0a4$var$node.hash = "4aa0ed8501f38926bbd2f9ec7930aec3";
var $7432c642c9b1a0a4$export$2e2bcd8739ae039 = $7432c642c9b1a0a4$var$node;

});

parcelRegister("l4EsH", function(module, exports) {
$parcel$export(module.exports, "useDraggableRows", () => $97cccd1c556c1005$export$1e4d2f7e506c2b7d);
$parcel$export(module.exports, "useDraggableRow", () => $97cccd1c556c1005$export$a878804271d34ba8);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3nrCN = parcelRequire("3nrCN");

var $dROq6 = parcelRequire("dROq6");

var $iJoDE = parcelRequire("iJoDE");

var $1l4lS = parcelRequire("1l4lS");

var $bGx3v = parcelRequire("bGx3v");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");

var $2ApNu = parcelRequire("2ApNu");
var $3pSHx = parcelRequire("3pSHx");

var $cHtIB = parcelRequire("cHtIB");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $443cm = parcelRequire("443cm");

var $j5Wzv = parcelRequire("j5Wzv");

var $15Apk = parcelRequire("15Apk");

var $jNv5I = parcelRequire("jNv5I");

var $kfIml = parcelRequire("kfIml");

var $t5ecZ = parcelRequire("t5ecZ");
const $97cccd1c556c1005$var$ATTACH_INSTRUCTION_MODE = 'standard';
const $97cccd1c556c1005$var$SUPPORTED_TYPES = new Set([
    (0, $8jOO7.MAKE_CHILD),
    (0, $8jOO7.REORDER_ABOVE),
    (0, $8jOO7.REORDER_BELOW)
]);
const $97cccd1c556c1005$var$CHECKBOX_COLUMN_WIDTH = 42;
const $97cccd1c556c1005$var$INDENT_PER_LEVEL = 12;
const $97cccd1c556c1005$export$1e4d2f7e506c2b7d = (0, $iJq0l.createHook)((0, $kfIml.Store));
const $97cccd1c556c1005$var$isDraggableRowData = (data)=>data != null && typeof data === 'object' && 'operation' in data && data.operation === (0, $8jOO7.ROW_OPERATION_REORDER);
const $97cccd1c556c1005$export$a878804271d34ba8 = (props)=>{
    const { edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueEdgeRelayId: parentIssueEdgeRelayId, parentIssueConnectionId: parentIssueConnectionId, issueEdgeRelayId: issueEdgeRelayId, issueKey: issueKey } = props;
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    const isEntireRowDraggable = (0, $34oCh.useIsEntireRowDraggable)();
    let isRowReorderingEnabled = false;
    if (!(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const rankIssues = (0, $j5Wzv.useIssuesRanker)();
    let sortDirection;
    let getBlockedInstructions = (0, $t5ecZ.getBlockedInstructionsOld);
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        getBlockedInstructions = (0, $t5ecZ.getBlockedInstructions);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        sortDirection = (0, $34oCh.useSortDirection)();
    }
    const [{ instanceId: instanceId, onRowReorder: onRowReorderHandler }, { registerItem: registerItem, setDropTarget: setDropTarget, unregisterItem: unregisterItem }] = $97cccd1c556c1005$export$1e4d2f7e506c2b7d();
    let reparent = null;
    if ((0, $4cTDP.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reparent: reparent } = (0, $443cm.useUpdateParent)());
    const cloudId = (0, $cHtIB.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onRowReorder = isIssueRankingEnabled ? rankIssues : onRowReorderHandler;
    // TODO: Use `rankIssues` directly on jsc-2065-unify-onrowreorder cleanup
    const onRankIssues = (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? rankIssues : onRowReorder;
    const cleanupFnRef = (0, $eJOHy.useRef)(null);
    const { groupId: groupId, columns: columns } = (0, $jNv5I.useRowContext)();
    const hasCheckboxColumn = columns.length > 0 && columns[0].id === (0, $8jOO7.COLUMN_ID_CHECKBOX);
    const attachDraggableElement = (0, $eJOHy.useCallback)((rowElement)=>isEntireRowDraggable ? (0, $bGx3v.draggable)({
            element: rowElement,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    issueKey: issueKey,
                    groupId: groupId
                };
            },
            onDragStart () {
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'useDraggableRow',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), [
        isEntireRowDraggable,
        instanceId,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        parentIssueEdgeRelayId,
        parentIssueConnectionId,
        issueEdgeRelayId,
        edgeIndex,
        props.itemsConnectionId,
        issueKey,
        groupId,
        createAnalyticsEvent
    ]);
    const attachDropTargetElement = (0, $eJOHy.useCallback)((rowElement)=>(0, $bGx3v.dropTargetForElements)({
            element: rowElement,
            canDrop ({ source: source }) {
                return source.data.operation === (0, $8jOO7.ROW_OPERATION_REORDER) && source.data.issueId !== issueId;
            },
            getData ({ input: input, element: element, source: source }) {
                const data = {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    issueEdgeRelayId: issueEdgeRelayId,
                    parentIssueEdgeRelayId: parentIssueEdgeRelayId,
                    rowIndex: edgeIndex,
                    itemsConnectionId: props.itemsConnectionId,
                    hasChildren: Boolean(props.hasChildren),
                    groupId: groupId
                };
                if ((0, $4cTDP.fg)('jsc_list_reparenting')) {
                    const blockedInstructions = $97cccd1c556c1005$var$isDraggableRowData(source.data) ? getBlockedInstructions({
                        dropTarget: {
                            ...data,
                            ...props
                        },
                        draggedItem: source.data,
                        isRowReorderingEnabled: isRowReorderingEnabled,
                        isIssueRankingEnabled: isIssueRankingEnabled
                    }) : [
                        (0, $8jOO7.MAKE_CHILD),
                        (0, $8jOO7.REORDER_BELOW),
                        (0, $8jOO7.REORDER_BELOW)
                    ];
                    // currentLevel is used purely to calculate the indentation of the row using currentLevel * indentPerLevel
                    // when hasCheckboxColumn is true, the desired indentation = currentDepth * indentPerLevel + checkboxColumnWidth
                    // since we need a uniform value for the indentPerLevel, we adjust the currentLevel value.
                    const currentDepth = props.depth || 0;
                    const adjustedCurrentLevel = currentDepth + $97cccd1c556c1005$var$CHECKBOX_COLUMN_WIDTH / $97cccd1c556c1005$var$INDENT_PER_LEVEL;
                    return (0, $iJoDE.attachInstruction)(data, {
                        input: input,
                        element: element,
                        mode: $97cccd1c556c1005$var$ATTACH_INSTRUCTION_MODE,
                        indentPerLevel: $97cccd1c556c1005$var$INDENT_PER_LEVEL,
                        currentLevel: hasCheckboxColumn ? adjustedCurrentLevel : currentDepth,
                        block: blockedInstructions
                    });
                }
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag ({ self: self, source: source }) {
                // Don't set drop edge if source target is the same as this row instance
                if (issueId === source.data.issueId) return;
                if ((0, $4cTDP.fg)('jsc_list_reparenting')) {
                    const extractedInstruction = (0, $iJoDE.extractInstruction)(self.data);
                    extractedInstruction && setDropTarget({
                        issueId: issueId,
                        dropInstruction: extractedInstruction
                    });
                    return;
                }
                const closestEdge = (0, $3nrCN.extractClosestEdge)(self.data);
                closestEdge && setDropTarget({
                    issueId: issueId,
                    dropEdge: closestEdge
                });
            },
            onDragLeave () {
                setDropTarget(null);
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                setDropTarget(null);
                if (!$97cccd1c556c1005$var$isDraggableRowData(source.data) || !$97cccd1c556c1005$var$isDraggableRowData(destination?.data)) return;
                let closestEdgeOfTarget;
                let extractedInstruction;
                if ((0, $4cTDP.fg)('jsc_list_reparenting')) {
                    extractedInstruction = (0, $iJoDE.extractInstruction)(destination.data);
                    closestEdgeOfTarget = extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE) ? 'top' : 'bottom';
                } else closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                const dragItemParent = source.data?.parentIssueAri;
                const dropTargetParent = props?.parentIssueAri;
                const isWithinSameParent = dragItemParent === dropTargetParent;
                // We are dropping at specific edge but not changing parent, meaning only reranking
                const isRerankingOnly = (extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE) || extractedInstruction?.type === (0, $8jOO7.REORDER_BELOW)) && isWithinSameParent;
                const shouldRerank = (0, $4cTDP.fg)('jsc_list_reranking_gate') ? isRerankingOnly && (isRowReorderingEnabled || isIssueRankingEnabled) : isRowReorderingEnabled;
                const shouldReparent = (0, $4cTDP.fg)('jsc_list_reranking_gate') ? !isRerankingOnly && isReParentingEnabled : isReParentingEnabled;
                if (shouldRerank) {
                    if (!closestEdgeOfTarget) return;
                    const startIndex = source.data.rowIndex;
                    const finishIndex = (0, $1l4lS.getReorderDestinationIndex)({
                        axis: 'vertical',
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        startIndex: startIndex,
                        indexOfTarget: destination.data.rowIndex
                    });
                    if (startIndex === finishIndex) return;
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'updatedRanking',
                        actionSubject: 'dragActionsButton',
                        actionSubjectId: 'jscDraggableIssue'
                    }));
                    const edge = isIssueRankingEnabled ? (0, $15Apk.getEdgeForRerank)(startIndex, finishIndex, sortDirection) : closestEdgeOfTarget;
                    onRankIssues?.({
                        source: {
                            issueIds: [
                                source.data.issueId
                            ],
                            rowIndex: startIndex
                        },
                        destination: {
                            relativeToIssueId: destination.data.issueId,
                            rowIndex: finishIndex
                        },
                        edge: edge
                    });
                }
                if (shouldReparent) {
                    if (extractedInstruction && $97cccd1c556c1005$var$SUPPORTED_TYPES.has(extractedInstruction.type)) {
                        const issueIdToReparent = (0, $2ApNu.JiraIssueAri).parse(source.data.issueId).issueId;
                        const issueFieldAriToReparent = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueIdToReparent,
                            fieldId: (0, $3mZMJ.PARENT_TYPE)
                        }).toString();
                        const oldParentId = source.data.parentIssueAri && (0, $2ApNu.JiraIssueAri).parse(source.data.parentIssueAri).issueId;
                        const newParentAri = extractedInstruction.type === (0, $8jOO7.MAKE_CHILD) ? destination.data.issueId : destination.data.parentIssueAri;
                        const newParentId = newParentAri ? (0, $2ApNu.JiraIssueAri).parse(newParentAri).issueId : undefined;
                        const newParentEdgeId = extractedInstruction?.type === (0, $8jOO7.MAKE_CHILD) ? destination.data.issueEdgeRelayId : destination.data.parentIssueEdgeRelayId;
                        let dropIndex = 0;
                        if (extractedInstruction?.type === (0, $8jOO7.REORDER_ABOVE)) dropIndex = destination.data.rowIndex;
                        else if (extractedInstruction?.type === (0, $8jOO7.REORDER_BELOW)) dropIndex = destination.data.rowIndex + 1;
                        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                            isJscReparenting: true
                        });
                        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueParent updated', {
                            isJscReparenting: true
                        });
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'updatedParent',
                            actionSubject: 'dragActionsButton',
                            actionSubjectId: 'jscDraggableIssue'
                        }), {
                            reparentingMethod: extractedInstruction.type,
                            isAddingParent: !oldParentId,
                            isUnparenting: !newParentAri,
                            droppedIssueHierarchyLevel: source.data.hierarchyLevel
                        });
                        reparent?.({
                            issueId: source.data.issueId,
                            issueAri: issueFieldAriToReparent,
                            oldParentId: oldParentId,
                            newParentId: newParentId,
                            newParentAri: newParentAri || null,
                            newParentEdgeId: newParentEdgeId,
                            index: dropIndex,
                            projectKey: props.projectKey,
                            issueKey: source.data.issueKey
                        });
                    }
                }
            }
        }), [
        instanceId,
        issueId,
        parentIssueAri,
        parentIssueConnectionId,
        issueEdgeRelayId,
        parentIssueEdgeRelayId,
        edgeIndex,
        props,
        groupId,
        getBlockedInstructions,
        isRowReorderingEnabled,
        isIssueRankingEnabled,
        setDropTarget,
        isReParentingEnabled,
        createAnalyticsEvent,
        sortDirection,
        onRankIssues,
        cloudId,
        reparent,
        hasCheckboxColumn
    ]);
    const registerDraggableRow = (0, $eJOHy.useCallback)(()=>{
        registerItem(edgeIndex, issueId);
    }, [
        edgeIndex,
        issueId,
        registerItem
    ]);
    const unregisterDraggableRow = (0, $eJOHy.useCallback)(()=>{
        unregisterItem(edgeIndex);
    }, [
        edgeIndex,
        unregisterItem
    ]);
    const attachDraggableRow = (0, $eJOHy.useCallback)((rowElement)=>{
        // If there's an existing ref, clean up before attaching
        cleanupFnRef.current?.();
        if (!rowElement) return;
        cleanupFnRef.current = (0, $dROq6.combine)(attachDraggableElement(rowElement), attachDropTargetElement(rowElement), ()=>{
            // Reset the ref to null so that the cleanup function is not called again
            cleanupFnRef.current = null;
        });
    }, [
        attachDraggableElement,
        attachDropTargetElement
    ]);
    (0, $eJOHy.useEffect)(()=>()=>cleanupFnRef.current?.(), []);
    (0, $eJOHy.useEffect)(()=>{
        registerDraggableRow();
        return ()=>{
            unregisterDraggableRow();
        };
    }, [
        registerDraggableRow,
        unregisterDraggableRow
    ]);
    return isDragAndDropEnabled ? attachDraggableRow : null;
};

});
parcelRegister("3nrCN", function(module, exports) {
$parcel$export(module.exports, "attachClosestEdge", () => $d7df9ca07492ea22$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $d7df9ca07492ea22$export$945a571f3b658bf);
const $d7df9ca07492ea22$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $d7df9ca07492ea22$var$uniqueKey = Symbol('closestEdge');
function $d7df9ca07492ea22$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $d7df9ca07492ea22$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$d7df9ca07492ea22$var$uniqueKey]: addClosestEdge
    };
}
function $d7df9ca07492ea22$export$945a571f3b658bf(userData) {
    return userData[$d7df9ca07492ea22$var$uniqueKey] ?? null;
}

});

parcelRegister("iJoDE", function(module, exports) {
$parcel$export(module.exports, "attachInstruction", () => $438e65d4c84faf14$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $438e65d4c84faf14$export$c8ffecbe249dc8f8);

var $d2foH = parcelRequire("d2foH");
// using a symbol so we can guarantee a key with a unique value
const $438e65d4c84faf14$var$uniqueKey = Symbol('tree-item-instruction');
function $438e65d4c84faf14$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $438e65d4c84faf14$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $438e65d4c84faf14$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $438e65d4c84faf14$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $438e65d4c84faf14$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $438e65d4c84faf14$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $438e65d4c84faf14$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $d2foH.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $438e65d4c84faf14$var$memoizeInstruction = (0, $d2foH.stable)($438e65d4c84faf14$var$areInstructionsEqual);
function $438e65d4c84faf14$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $438e65d4c84faf14$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $438e65d4c84faf14$var$getInstruction(rest);
    const withBlock = $438e65d4c84faf14$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $438e65d4c84faf14$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$438e65d4c84faf14$var$uniqueKey]: memoized
    };
}
function $438e65d4c84faf14$export$c8ffecbe249dc8f8(userData) {
    return userData[$438e65d4c84faf14$var$uniqueKey] ?? null;
}

});
parcelRegister("d2foH", function(module, exports) {
$parcel$export(module.exports, "isShallowEqual", () => $9b80b5f622cdc59f$export$2225b4c39d37f8b3);
$parcel$export(module.exports, "stable", () => $9b80b5f622cdc59f$export$3f55479a3469259f);
function $9b80b5f622cdc59f$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $9b80b5f622cdc59f$export$3f55479a3469259f(isEqual = $9b80b5f622cdc59f$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}

});


parcelRegister("1l4lS", function(module, exports) {
$parcel$export(module.exports, "getReorderDestinationIndex", () => $f0909d4a1662ae03$export$846f792f51b92b6e);
function $f0909d4a1662ae03$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});

parcelRegister("443cm", function(module, exports) {
$parcel$export(module.exports, "useUpdateParent", () => $7516b102f870f621$export$d767b1cfe1a164d3);

var $gtOUD = parcelRequire("gtOUD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $kqd31 = parcelRequire("kqd31");

var $cSXp8 = parcelRequire("cSXp8");

var $8Uqf3 = parcelRequire("8Uqf3");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4SjAP = parcelRequire("4SjAP");

var $lRq8t = parcelRequire("lRq8t");

var $2ApNu = parcelRequire("2ApNu");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $8pBFu = parcelRequire("8pBFu");

var $adrlS = parcelRequire("adrlS");
const $7516b102f870f621$export$d767b1cfe1a164d3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $8pBFu.REPARENTING_EXPERIENCE)
    });
    const [commitMutation, loading] = (0, $j4oe4.useMutation)((0, $gtOUD.default));
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'issueTableReparentMutation',
                packageName: (0, $8jOO7.PACKAGE_NAME),
                teamName: (0, $8jOO7.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8jOO7.PACKAGE_NAME), error);
        showFlag((0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
    }, [
        onExperienceFail,
        showFlag
    ]);
    const updater = (0, $adrlS.useGetReparentUpdater)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const highlightIssue = (0, $eJOHy.useCallback)(({ issueId: issueId, store: store })=>{
        // Highlight the row
        const issueRelayID = (0, $kqd31.default)({
            id: issueId
        }, (0, $adrlS.JIRA_ISSUE_TYPENAME));
        if (issueRelayID) {
            const node = store.get(issueRelayID);
            if (node) node?.setValue(true, 'isHighlightedIssueRow');
        }
    }, []);
    const reparent = (0, $eJOHy.useCallback)(({ issueId: issueId, issueAri: issueAri, oldParentId: oldParentId, newParentId: newParentId, newParentAri: newParentAri, newParentEdgeId: newParentEdgeId, index: index, projectKey: projectKey, issueKey: issueKey })=>{
        const input = {
            id: issueAri,
            operation: {
                operation: 'SET',
                id: newParentAri
            }
        };
        onExperienceStart();
        if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.PARENT_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
                fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.PARENT_TYPE],
                oldValId: oldParentId,
                newValId: newParentId
            }
        });
        commitMutation({
            variables: {
                input: input
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    issueId: issueId,
                    oldParentId: oldParentId,
                    newParentId: newParentId,
                    newParentEdgeId: newParentEdgeId,
                    index: index,
                    projectKey: projectKey
                });
                // Highlight the row
                highlightIssue({
                    store: store,
                    issueId: issueId
                });
            },
            updater: (store, response)=>{
                if (response?.jira?.updateParentField?.success) {
                    updater({
                        store: store,
                        issueId: issueId,
                        oldParentId: oldParentId,
                        newParentId: newParentId,
                        newParentEdgeId: newParentEdgeId,
                        index: index,
                        projectKey: projectKey
                    });
                    highlightIssue({
                        store: store,
                        issueId: issueId
                    });
                    const issueRelayID = (0, $kqd31.default)({
                        id: issueId
                    }, (0, $adrlS.JIRA_ISSUE_TYPENAME));
                    if (issueRelayID) setTimeout(()=>{
                        (0, $j4oe4.commitLocalUpdate)(environment, (currentStore)=>{
                            const node = currentStore.get(issueRelayID);
                            node?.setValue(false, 'isHighlightedIssueRow');
                        });
                    }, (0, $8jOO7.HIGHLIGHT_LINGER_DURATION_MS));
                }
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateParentField ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $adrlS.getFlagDetails)(statusCode, intl, issueKey);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue reparented', (0, $8pBFu.ACTION_SUBJECT_ID));
                onExperienceSuccess();
            },
            onError: (error)=>{
                const err = new (0, $4SjAP.MutationError)(error);
                handleError(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        environment,
        handleError,
        highlightIssue,
        onExperienceStart,
        onExperienceSuccess,
        showFlag,
        updater,
        intl
    ]);
    return {
        reparent: reparent,
        loading: loading
    };
};

});
parcelRegister("gtOUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2e9000c51021ad8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a14b547dc80db979d18a2f6b7caad927>>
 * @relayHash 912b3665801859ed64b357f816488c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766
const $f2e9000c51021ad8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraParentIssueField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reparentMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5822dc5c39bb3263eb89e5efb2750a9fb42f5c4f74af60f422e877ecfaac2766",
            "metadata": {},
            "name": "reparentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f2e9000c51021ad8$var$node.hash = "8010fe7d0e37915f076661fa947a0546";
var $f2e9000c51021ad8$export$2e2bcd8739ae039 = $f2e9000c51021ad8$var$node;

});

parcelRegister("8pBFu", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", () => $abcfa65d938eed87$export$e80b28191e1d3602);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", () => $abcfa65d938eed87$export$29d372313e7a3d7b);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA", () => $abcfa65d938eed87$export$e40785c138c2ad43);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $abcfa65d938eed87$export$a75bfbb3fb2f437c);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", () => $abcfa65d938eed87$export$6a4ca5120f2baf63);
$parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $abcfa65d938eed87$export$4cba4bafd925e182);
$parcel$export(module.exports, "REPARENTING_EXPERIENCE", () => $abcfa65d938eed87$export$4c7c3fa9c49bb0d7);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $abcfa65d938eed87$export$9957974f8b4d8f74);

var $f55DR = parcelRequire("f55DR");
const $abcfa65d938eed87$export$e80b28191e1d3602 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParentGenericErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$29d372313e7a3d7b = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$e40785c138c2ad43 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTermRefreshGalaxia,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term-galaxia.error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$a75bfbb3fb2f437c = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$6a4ca5120f2baf63 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent404ErrorDescription,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$4cba4bafd925e182 = {
    type: 'error',
    title: (0, $f55DR.default).updateIssueParentErrorTitle,
    description: (0, $f55DR.default).updateIssueParent404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $abcfa65d938eed87$export$4c7c3fa9c49bb0d7 = 'updateParent';
const $abcfa65d938eed87$export$11823571c61d4d02 = 'SUCCEEDED';
const $abcfa65d938eed87$export$d71930f7f5807a72 = 'FAILED';
const $abcfa65d938eed87$export$f3390a0e172fee41 = 'useUpdateParent';
const $abcfa65d938eed87$export$9957974f8b4d8f74 = 'issueTableUpdateIssueParent';

});
parcelRegister("f55DR", function(module, exports) {
$parcel$export(module.exports, "default", () => $60f7f21fe7d4c781$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $60f7f21fe7d4c781$var$messages = (0, $7qGN1.defineMessages)({
    updateIssueParentErrorTitle: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    updateIssueParentGenericErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-generic-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    updateIssueParent400ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description",
        "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
    },
    updateIssueParent404ErrorDescription: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description",
        "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
    },
    updateIssueParent400ErrorTitleIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "You don\u2019t have permission to update {issueKey}"
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Contact your project admin."
    },
    updateIssueParent404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
    },
    updateIssueParent404ErrorTitleIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "We\u2019re having trouble updating {issueKey}"
    },
    updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-404-error-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh and try again."
    },
    updateIssueParent400ErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "You don\u2019t have permission to update this work item. Contact a space admin."
    },
    updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia: {
        "id": "native-issue-table.services.reparent-mutation.update-issue-parent-400-error-description-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "Contact your space admin."
    }
});
var $60f7f21fe7d4c781$export$2e2bcd8739ae039 = $60f7f21fe7d4c781$var$messages;

});


parcelRegister("adrlS", function(module, exports) {
$parcel$export(module.exports, "getFlagDetails", () => $d54f04439f880b90$export$e0141c03826f0c2c);
$parcel$export(module.exports, "JIRA_ISSUE_TYPENAME", () => $d54f04439f880b90$export$8df31253ff7294c9);
$parcel$export(module.exports, "useGetReparentUpdater", () => $d54f04439f880b90$export$b3f12c98c1f443a);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $cxKOj = parcelRequire("cxKOj");

var $kqd31 = parcelRequire("kqd31");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");

var $f55DR = parcelRequire("f55DR");

var $8pBFu = parcelRequire("8pBFu");
const $d54f04439f880b90$export$e0141c03826f0c2c = (statusCode, intl, issueKey)=>{
    switch(statusCode){
        case 400:
            if (issueKey && (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return $d54f04439f880b90$export$2aa1f96ba5bf0010(intl, issueKey);
            if ((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
                if ((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false)) return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
                return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM;
            }
            return 0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_400_FLAG;
        case 404:
            if (issueKey && (0, $cxKOj.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return $d54f04439f880b90$export$c7d107a3107d23fd(intl, issueKey);
            return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_404_FLAG);
        default:
            return null;
    }
};
const $d54f04439f880b90$export$2aa1f96ba5bf0010 = (intl, issueKey)=>{
    const updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia : (0, $f55DR.default).updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4;
    return {
        type: 'error',
        title: intl.formatMessage((0, $f55DR.default).updateIssueParent400ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        description: intl.formatMessage(updateIssueParent400ErrorDescriptionIssueTerminologyRefreshM4Galaxia, {
            issueKey: issueKey
        }),
        messageId: 'native-issue-table.services.reparent-mutation.flag.error.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic.1.1',
        messageType: 'transactional'
    };
};
const $d54f04439f880b90$export$c7d107a3107d23fd = (intl, issueKey)=>{
    return {
        type: 'error',
        title: intl.formatMessage((0, $f55DR.default).updateIssueParent404ErrorTitleIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        description: intl.formatMessage((0, $f55DR.default).updateIssueParent404ErrorDescriptionIssueTerminologyRefreshM4, {
            issueKey: issueKey
        }),
        messageId: 'native-issue-table.services.reparent-mutation.flag.error.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic.1.1.1',
        messageType: 'transactional'
    };
};
const $d54f04439f880b90$export$8df31253ff7294c9 = 'JiraIssue';
const $d54f04439f880b90$export$b3f12c98c1f443a = ()=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const getConection = (0, $eJOHy.useCallback)(({ issueId: issueId })=>Object.values(connections).find((connection)=>{
            if (issueId) return connection.type === 'PARENT_CHILDREN' && connection.parentId === issueId;
            return connection.type === 'ROOT_ISSUES';
        }), [
        connections
    ]);
    const updater = (0, $eJOHy.useCallback)(({ store: store, issueId: issueId, oldParentId: oldParentId, newParentId: newParentId, newParentEdgeId: newParentEdgeId, index: index = 0, projectKey: projectKey })=>{
        const relayId = (0, $kqd31.default)({
            id: issueId
        }, $d54f04439f880b90$export$8df31253ff7294c9);
        if (!relayId) return;
        const oldConnection = getConection({
            issueId: oldParentId
        });
        const newConnection = getConection({
            issueId: newParentId
        });
        if (!oldConnection) // Since the issue has to be visible to be repartented, this case should not occur
        return;
        const oldConnectionRecord = store.get(oldConnection.connectionId);
        if (!oldConnectionRecord) return;
        if (newParentEdgeId) (0, $57Nys.updateParentHasChildren)({
            store: store,
            parentIssueEdgeRecordId: newParentEdgeId,
            connectionId: newConnection?.connectionId,
            hasChildren: true,
            projectKey: projectKey
        });
        if (newConnection) {
            const newConnectionRecord = store.get(newConnection.connectionId);
            if (!newConnectionRecord) return;
            const existingEdge = oldConnectionRecord.getLinkedRecords('edges')?.find((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId);
            // no before or after implies an empty conneciton, verify then create the edges list
            const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
            const edges = newConnectionRecord.getLinkedRecords(EDGES);
            if (!edges || !existingEdge) return;
            const nextEdges = edges.slice(0, index).concat(existingEdge).concat(edges.slice(index));
            newConnectionRecord.setLinkedRecords(nextEdges, EDGES);
            updateConnectionDetails({
                store: store,
                connection: newConnection,
                netChangeInIssueCount: 1,
                remainingIssueCount: newConnectionRecord.getLinkedRecords('edges')?.length,
                projectKey: projectKey
            });
        }
        if (oldConnection) // remove the issue from the old connection
        {
            if (oldConnectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === relayId)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(oldConnectionRecord, relayId);
                updateConnectionDetails({
                    store: store,
                    connection: oldConnection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: oldConnectionRecord.getLinkedRecords('edges')?.length,
                    projectKey: projectKey
                });
            }
        }
    }, [
        getConection,
        updateConnectionDetails
    ]);
    return updater;
};

});


parcelRegister("j5Wzv", function(module, exports) {
$parcel$export(module.exports, "useIssuesRanker", () => $5e8d51b9b9659210$export$40f5e450e8552c78);

var $9LOV3 = parcelRequire("9LOV3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $isfFo = parcelRequire("isfFo");

var $ftN6c = parcelRequire("ftN6c");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $4SjAP = parcelRequire("4SjAP");

var $kRgKj = parcelRequire("kRgKj");

var $2ApNu = parcelRequire("2ApNu");

var $8jOO7 = parcelRequire("8jOO7");

var $kfIml = parcelRequire("kfIml");

var $dPwlR = parcelRequire("dPwlR");

var $1jyN6 = parcelRequire("1jyN6");

var $ikiN2 = parcelRequire("ikiN2");
const $5e8d51b9b9659210$var$getRankMutationEdge = (edge)=>{
    switch(edge){
        case 'top':
            return 'TOP';
        case 'bottom':
            return 'BOTTOM';
        default:
            // Unsupported edge
            return null;
    }
};
const $5e8d51b9b9659210$export$40f5e450e8552c78 = ()=>{
    const [issueConnectionId] = (0, $kfIml.useDraggableRowsConnectionId)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $dPwlR.RE_RANKING_EXPERIENCE)
    });
    const [rankIssuesMutation] = (0, $j4oe4.useMutation)((0, $9LOV3.default));
    const showErrorFlag = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh : (0, $ikiN2.default).reorderErrorTitle,
            description: (0, $ikiN2.default).reorderErrorDescription,
            isAutoDismiss: true,
            messageId: 'native-issue-table.services.rank-mutation.show-flag.error.use-issues-ranker.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const reorderIssuesUpdater = (0, $eJOHy.useCallback)((store, startIndex, finishIndex)=>{
        const issueConnection = store.get(issueConnectionId);
        if (!issueConnection) return;
        const edges = issueConnection.getLinkedRecords('edges');
        if (!edges) return;
        const reorderedEdges = (0, $isfFo.reorder)({
            list: edges,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        issueConnection.setLinkedRecords(reorderedEdges, 'edges');
    }, [
        issueConnectionId
    ]);
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'commitRankIssuesMutationError',
                packageName: (0, $8jOO7.PACKAGE_NAME),
                teamName: (0, $8jOO7.TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8jOO7.PACKAGE_NAME), error);
        showErrorFlag();
    }, [
        onExperienceFail,
        showErrorFlag
    ]);
    const rankIssues = (0, $eJOHy.useCallback)((payload)=>{
        const { source: source, destination: destination, edge: edge } = payload;
        const rankMutationEdge = $5e8d51b9b9659210$var$getRankMutationEdge(edge);
        onExperienceStart();
        // 1event does not currently support bulk analytics
        if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) {
            if (payload.source.issueIds.length === 1) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.RANK_CF_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    issueId: (0, $2ApNu.JiraIssueAri).parse(payload.source.issueIds[0]).issueId,
                    fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.RANK_CF_TYPE]
                }
            });
        }
        if (rankMutationEdge == null) {
            showErrorFlag();
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'commitRankIssuesError',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: new Error(`Edge "${edge}" is unsupported in JiraMutation.rankIssues`),
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        rankIssuesMutation({
            variables: {
                rankInput: {
                    issues: source.issueIds,
                    relativeToIssue: destination.relativeToIssueId,
                    edge: rankMutationEdge
                }
            },
            optimisticUpdater (store) {
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            updater (store, data) {
                // Rollback update if mutation fails
                if (!data?.jira?.rankIssues?.success) return;
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            onCompleted (data) {
                const { errors: errors } = data?.jira?.rankIssues ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    const clientSideErrorMessage = (0, $1jyN6.getFlagDetails)(statusCode);
                    if (clientSideErrorMessage) {
                        showFlag(clientSideErrorMessage);
                        onExperienceSuccess();
                        return;
                    }
                    handleError(error);
                    return;
                }
                if (!data.jira?.rankIssues?.success) {
                    const error = new Error(errors?.[0]?.message ?? 'Failed to reorder issues: Unknown Error occurred');
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue updated', 'issueTableUpdateIssueRank');
            },
            onError (error) {
                handleError(error);
            }
        });
    }, [
        createAnalyticsEvent,
        handleError,
        onExperienceStart,
        onExperienceSuccess,
        rankIssuesMutation,
        reorderIssuesUpdater,
        showErrorFlag,
        showFlag
    ]);
    return rankIssues;
};

});
parcelRegister("9LOV3", function(module, exports) {
$parcel$export(module.exports, "default", () => $94b46e5847e96eac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8dca5785751aa5f70f854c54040a53f>>
 * @relayHash 3c50fcdcb26a2dd5e3d81a1c04369a89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b99aeae9f0df6a7bca9414b7ce6f013700af4287f820cc74b0dfd95403d65cb2
const $94b46e5847e96eac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rankInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "rankInput",
            "variableName": "rankInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIssuesRankerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIssuesRankerMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRankMutationPayload",
                            "kind": "LinkedField",
                            "name": "rankIssues",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b99aeae9f0df6a7bca9414b7ce6f013700af4287f820cc74b0dfd95403d65cb2",
            "metadata": {},
            "name": "useIssuesRankerMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$94b46e5847e96eac$var$node.hash = "824e5e71233747b29ef715625b9350f2";
var $94b46e5847e96eac$export$2e2bcd8739ae039 = $94b46e5847e96eac$var$node;

});

parcelRegister("dPwlR", function(module, exports) {
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG", () => $411491f5dedc5b65$export$c58c5fc634df2e30);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA", () => $411491f5dedc5b65$export$ecb799b5eeb91e4e);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$d37d45ebdf6e6be4);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG", () => $411491f5dedc5b65$export$d9fdb4939efc3fa9);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$83a2ceb0732d655a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG", () => $411491f5dedc5b65$export$3b5b9901de703a5a);
$parcel$export(module.exports, "REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM", () => $411491f5dedc5b65$export$b57a01d3fd8405a5);
$parcel$export(module.exports, "RE_RANKING_EXPERIENCE", () => $411491f5dedc5b65$export$cb50c1de8dfcf0a5);

var $ikiN2 = parcelRequire("ikiN2");
const $411491f5dedc5b65$export$9aa93234f179f11b = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-generic-flag.error.update-item-parent-fail-generic-flag.error.reparent-mutation.update-item-parent-fail-generic-flag.error.flag.update-item-parent-fail-generic',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$c58c5fc634df2e30 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag.error.update-item-parent-fail-400-flag.error.reparent-mutation.update-item-parent-fail-400-flag.error.flag.update-issue-parent400error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$ecb799b5eeb91e4e = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescriptionIssueTermRefreshGalaxia,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term-galaxia.error.reorder-item-fail-400-flag-with-issue-term-gal-axia.error.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh-galaxia',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$d37d45ebdf6e6be4 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue400ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-400-flag-with-issue-term.error.update-item-parent-fail-400-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-400-flag-with-issue-term.error.flag.update-issue-parent400error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$d9fdb4939efc3fa9 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue404ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$83a2ceb0732d655a = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue404ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$3b5b9901de703a5a = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitle,
    description: (0, $ikiN2.default).reorderIssue409ErrorDescription,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag.error.reorder-item-fail-404-flag.error.update-item-parent-fail-404-flag.error.reparent-mutation.update-item-parent-fail-404-flag.error.flag.update-issue-parent404error',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$b57a01d3fd8405a5 = {
    type: 'error',
    title: (0, $ikiN2.default).reorderErrorTitleIssueTermRefresh,
    description: (0, $ikiN2.default).reorderIssue409ErrorDescriptionIssueTermRefresh,
    messageId: 'native-issue-table.services.rank-mutation.reorder-item-fail-409-flag-with-issue-term.error.reorder-item-fail-404-flag-with-issue-term.error.update-item-parent-fail-404-flag-with-issue-term.error.reparent-mutation.update-item-parent-fail-404-flag-with-issue-term.error.flag.update-issue-parent404error-issue-term-refresh',
    messageType: 'transactional'
};
const $411491f5dedc5b65$export$cb50c1de8dfcf0a5 = 'reRankIssue';

});
parcelRegister("ikiN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f0324d073f2689$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $22f0324d073f2689$var$messages = (0, $7qGN1.defineMessages)({
    reorderErrorTitle: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    reorderErrorTitleIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't reorder those work items"
    },
    reorderIssue400ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description",
        "defaultMessage": "You don\u2019t have permission to reorder this issue. Contact a project admin."
    },
    reorderIssue404ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description",
        "defaultMessage": "We\u2019re having trouble reordering this issue. To continue, refresh the page."
    },
    reorderIssue409ErrorDescription: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description",
        "defaultMessage": "There was a conflict reordering those issues. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a project admin."
    },
    reorderIssue404ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-404-error-description-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble reordering this work item. To continue, refresh the page."
    },
    reorderIssue409ErrorDescriptionIssueTermRefresh: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-409-error-description-issue-term-refresh",
        "defaultMessage": "There was a conflict reordering those work items. Please try again."
    },
    reorderIssue400ErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "You don\u2019t have permission to reorder this work item. Contact a space admin."
    }
});
var $22f0324d073f2689$export$2e2bcd8739ae039 = $22f0324d073f2689$var$messages;

});


parcelRegister("1jyN6", function(module, exports) {
$parcel$export(module.exports, "getFlagDetails", () => $fb1754413aaa4816$export$e0141c03826f0c2c);

var $4cTDP = parcelRequire("4cTDP");

var $cxKOj = parcelRequire("cxKOj");

var $dPwlR = parcelRequire("dPwlR");
const $fb1754413aaa4816$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 400:
            if ((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false)) return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
                return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM;
            }
            return 0, $dPwlR.REORDER_ITEM_FAIL_400_FLAG;
        case 404:
            return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dPwlR.REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, $dPwlR.REORDER_ITEM_FAIL_404_FLAG);
        case 409:
            return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dPwlR.REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM) : (0, $dPwlR.REORDER_ITEM_FAIL_409_FLAG);
        default:
            return null;
    }
};

});


parcelRegister("15Apk", function(module, exports) {
$parcel$export(module.exports, "getEdgeForRerank", () => $c1d6810499cb70fa$export$6bd827e42c9b2c6f);
const $c1d6810499cb70fa$export$6bd827e42c9b2c6f = (sourceIndex, destinationIndex, sortDirection)=>{
    // When sorting DESC, the visual direction is inverted
    // Moving up visually (lower index) means moving down in ascending order
    if (sortDirection === 'DESC') return sourceIndex > destinationIndex ? 'bottom' : 'top';
    // ASC: normal logic
    return sourceIndex > destinationIndex ? 'top' : 'bottom';
};

});

parcelRegister("jNv5I", function(module, exports) {
$parcel$export(module.exports, "useRowContext", () => $ab12d7ac2653f245$export$7a486b5630cc7522);
$parcel$export(module.exports, "RowContextProvider", () => $ab12d7ac2653f245$export$81ecc1ee96e0504e);

var $eJOHy = parcelRequire("eJOHy");
const $ab12d7ac2653f245$var$RowContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ab12d7ac2653f245$export$7a486b5630cc7522 = ()=>{
    const context = (0, $eJOHy.useContext)($ab12d7ac2653f245$var$RowContext);
    if (!context) throw new Error('useRowContext must be used within RowContextProvider');
    return context;
};
const $ab12d7ac2653f245$export$81ecc1ee96e0504e = ({ children: children, columns: columns, tableInjectedProps: tableInjectedProps, renderChildRows: renderChildRows, groupId: groupId, groupConnectionId: groupConnectionId, resizingColumnIndex: resizingColumnIndex })=>{
    const props = (0, $eJOHy.useMemo)(()=>({
            columns: columns,
            tableInjectedProps: tableInjectedProps,
            renderChildRows: renderChildRows,
            groupId: groupId,
            groupConnectionId: groupConnectionId,
            resizingColumnIndex: resizingColumnIndex
        }), [
        columns,
        tableInjectedProps,
        renderChildRows,
        groupId,
        groupConnectionId,
        resizingColumnIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ab12d7ac2653f245$var$RowContext.Provider, {
        value: props
    }, children);
};

});

parcelRegister("t5ecZ", function(module, exports) {
$parcel$export(module.exports, "getBlockedInstructions", () => $f79d815e41b917a5$export$44539271c2e3abc8);
$parcel$export(module.exports, "getBlockedInstructionsOld", () => $f79d815e41b917a5$export$704f71e2437b55b4);

var $lBtjB = parcelRequire("lBtjB");

var $8jOO7 = parcelRequire("8jOO7");
const $f79d815e41b917a5$export$acc17f62bededcaf = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const draggedItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    const draggedItemGrouping = draggedItem?.groupId;
    const dropTargetGrouping = dropTarget?.groupId;
    // CASE 1: Grouping information does not match
    if (draggedItemGrouping !== dropTargetGrouping) return {
        [(0, $8jOO7.COMBINE)]: 'blocked',
        [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
        [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
    };
    // CASE 2: Both items have no hierarchy information
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) {
        // Still consider if they're are in the first depth, but prevent combining
        if (dropTarget?.depth === 0 && draggedItem?.depth === 0) return {
            [(0, $8jOO7.COMBINE)]: 'not-available',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        return {
            [(0, $8jOO7.COMBINE)]: 'available',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
    }
    const draggedItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || draggedItemParentIsDropTarget);
    // CASE 3: Both items have parent information
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        if (draggedItemParentIsDropTarget && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
    }
    // CASE 4: Reparenting if there's a difference in hierarchy levels
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'available',
            [(0, $8jOO7.REORDER_AFTER)]: 'available'
        };
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) {
            if (draggedItemHasParent || isIssueRankingEnabled) return {
                [(0, $8jOO7.COMBINE)]: 'blocked',
                [(0, $8jOO7.REORDER_BEFORE)]: 'available',
                [(0, $8jOO7.REORDER_AFTER)]: 'available'
            };
        }
        if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
        // Any other actions is an invalid drop onto an item
        return {
            [(0, $8jOO7.COMBINE)]: 'blocked',
            [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
            [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
        };
    }
    // CASE 5: We cannot unparent a subtask that does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'blocked',
        [(0, $8jOO7.REORDER_AFTER)]: 'blocked'
    };
    // CASE 6: Unparenting any non-subtask
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && draggedItemHasParent) return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'available',
        [(0, $8jOO7.REORDER_AFTER)]: 'available'
    };
    // Default case: Drop target is valid
    return {
        [(0, $8jOO7.COMBINE)]: 'available',
        [(0, $8jOO7.REORDER_BEFORE)]: 'available',
        [(0, $8jOO7.REORDER_AFTER)]: 'available'
    };
};
const $f79d815e41b917a5$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isIssueRankingEnabled: isIssueRankingEnabled })=>{
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    const draggedItemGrouping = draggedItem?.groupId;
    const dropTargeGrouping = dropTarget?.groupId;
    if (draggedItemGrouping !== dropTargeGrouping) return [
        (0, $8jOO7.MAKE_CHILD),
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) {
        if (isIssueRankingEnabled && isSiblingOfDropTarget) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        if (dragItemParentIsDropTarget && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting or reranking), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) {
            if (dragItemHasParent || isIssueRankingEnabled) return [
                (0, $8jOO7.MAKE_CHILD)
            ];
        }
        if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
        // Any other actions is an invalid drop onto an item
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL)) return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [];
};
const $f79d815e41b917a5$export$704f71e2437b55b4 = ({ dropTarget: dropTarget, draggedItem: draggedItem, isRowReorderingEnabled: isRowReorderingEnabled })=>{
    // We don't support reordering and reparenting
    if (isRowReorderingEnabled) return [
        (0, $8jOO7.MAKE_CHILD)
    ];
    const draggedItemLevel = draggedItem?.hierarchyLevel;
    const dropTargetLevel = dropTarget?.hierarchyLevel;
    const dragItemHasParent = !!draggedItem?.parentIssueAri;
    const dropTargetHasParent = !!dropTarget?.parentIssueAri;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(dropTargetLevel) || !(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(draggedItemLevel)) return [];
    const dragItemParentIsDropTarget = String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);
    const isSiblingOfDropTarget = String(dropTarget?.parentIssueAri) === String(draggedItem?.parentIssueAri);
    const droppingToSameParent = // Do not take into account when both drag item and drop target do not have parent, in which case
    // they have an equal parent value but is not reparenting to same parent
    draggedItem?.parentIssueAri !== '' && draggedItem?.parentIssueAri != null && (isSiblingOfDropTarget || dragItemParentIsDropTarget);
    if (droppingToSameParent) return [
        (0, $8jOO7.MAKE_CHILD),
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // if the difference is not of one level up, we could be reparenting by dragging
    if (dropTargetLevel !== draggedItemLevel + 1) {
        // If drop target is of same level as drag item and drop target has parent,
        // do not block reorder as we are reordering to reparent
        if (dropTargetLevel === draggedItemLevel && dropTargetHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // If we are dropping to a top level issue (unparenting), we should not block reordering
        if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [
            (0, $8jOO7.MAKE_CHILD)
        ];
        // Any other actions are invalid
        return [
            (0, $8jOO7.MAKE_CHILD),
            (0, $8jOO7.REORDER_BELOW),
            (0, $8jOO7.REORDER_ABOVE)
        ];
    }
    // we cannot unparent a subtask nor an item that already does not have a parent
    if (draggedItemLevel === (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) || !dragItemHasParent) return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
    // Unparenting any non-subtask issue type
    if (dropTarget?.depth === 0 && draggedItemLevel > (0, $8jOO7.SUBTASK_HIERARCHY_LEVEL) && dragItemHasParent) return [];
    // we are dropping to a valid parent
    return [
        (0, $8jOO7.REORDER_BELOW),
        (0, $8jOO7.REORDER_ABOVE)
    ];
};

});
parcelRegister("lBtjB", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $fba3cb134bd6d57d$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fba3cb134bd6d57d$var$isNumber(value) {
    return typeof value == 'number' || $7gKgM(value) && $1O9y6(value) == $fba3cb134bd6d57d$var$numberTag;
}
module.exports = $fba3cb134bd6d57d$var$isNumber;

});



parcelRegister("4NiKr", function(module, exports) {
$parcel$export(module.exports, "SiblingIssueCreateRowContext", () => $519225a615dc40ac$export$93b3e64bc25dd687);
$parcel$export(module.exports, "useSiblingIssueCreateRow", () => $519225a615dc40ac$export$4d2a6b6549dc23e8);
$parcel$export(module.exports, "useSiblingIssueCreateHandler", () => $519225a615dc40ac$export$6dac168b5104cc);
$parcel$export(module.exports, "useSiblingIssueCreateOnScroll", () => $519225a615dc40ac$export$2dfe9712a7a20bc9);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $34oCh = parcelRequire("34oCh");

var $6LwYU = parcelRequire("6LwYU");

const $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE = 16;
const $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA = 12;
const $519225a615dc40ac$export$93b3e64bc25dd687 = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $519225a615dc40ac$export$4d2a6b6549dc23e8 = ()=>{
    const context = (0, $eJOHy.useContext)($519225a615dc40ac$export$93b3e64bc25dd687);
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    return isSiblingIssueCreateEnabled ? context : {};
};
const $519225a615dc40ac$export$6dac168b5104cc = (connectionId, edgeIndex)=>{
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const { setIndex: setIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $6LwYU.useSiblingCreateActiveIndexActions)();
    const calculateRowIndex = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((event)=>{
            const currentRow = event.currentTarget;
            if (!currentRow) return;
            // Calculate the y position of the mouse relative to the top of the current row.
            const currentRowRect = currentRow.getBoundingClientRect();
            // This calculation ranges from -1 to 39, instead of 0 to 40, potentially due to the row's border.
            // For this reason, we add 1 to ensure the value is correct.
            const currentRowMouseVerticalOffset = event.clientY - currentRowRect.top + 1;
            if (currentRowMouseVerticalOffset >= 0 && currentRowMouseVerticalOffset <= $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA) // When hovering the top part of a row, the trigger should be rendered at the top of the current row.
            setIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex
            ]);
            else if (currentRowMouseVerticalOffset > currentRowRect.height - $519225a615dc40ac$var$SIBLING_CREATE_HOVER_AREA) // When hovering the bottom part of a row, the trigger should be rendered at the top of the next row.
            setIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8), [
                connectionId,
                edgeIndex + 1
            ]);
            else // When hovering the middle part of a row, the trigger should not be rendered.
            clearIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
        }, $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE), [
        connectionId,
        edgeIndex,
        clearIndex,
        setIndex
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearIndexAfterDelay((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const onMouseMove = (0, $eJOHy.useCallback)((event)=>{
        calculateRowIndex(event);
    }, [
        calculateRowIndex
    ]);
    return isSiblingIssueCreateEnabled ? {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove
    } : {};
};
const $519225a615dc40ac$export$2dfe9712a7a20bc9 = ()=>{
    const isSiblingIssueCreateEnabled = (0, $34oCh.useIsSiblingIssueCreateEnabled)();
    const { clearIndex: clearIndex } = (0, $6LwYU.useSiblingCreateActiveIndexActions)();
    return (0, $eJOHy.useMemo)(()=>isSiblingIssueCreateEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(()=>{
            clearIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
        }, $519225a615dc40ac$var$MOUSE_MOVE_THROTTLE) : undefined, [
        clearIndex,
        isSiblingIssueCreateEnabled
    ]);
};

});
const $a11b3ba2d46b97f5$export$76a449e52fa0e1e8 = 'issue';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $a11b3ba2d46b97f5$var$FIELD = 'field';


parcelRegister("fZpej", function(module, exports) {
$parcel$export(module.exports, "BeforeFirstCell", () => $287a9a214985335d$export$bcb733e1e43aa5a8);

var $3xRNb = parcelRequire("3xRNb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $4NiKr = parcelRequire("4NiKr");

var $6LwYU = parcelRequire("6LwYU");

var $8h5Ee = parcelRequire("8h5Ee");

var $aTzcv = parcelRequire("aTzcv");
const $287a9a214985335d$export$bcb733e1e43aa5a8 = ({ edgeIndex: edgeIndex, issueId: issueId, itemsConnectionId: itemsConnectionId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, issueRowData: issueRowData, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const { isFormVisible: isFormVisible } = (0, $4NiKr.useSiblingIssueCreateRow)();
    const firstCellData = (0, $j4oe4.useFragment)((0, $3xRNb.default), issueRowData);
    const isDragAndDropEnabled = (0, $34oCh.useIsDragAndDropEnabled)();
    let isReparentingEnabled = false;
    if ((0, $4cTDP.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    let isAdjacentInlineIssueCreateActive = false;
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isInlineIssueCreateActive] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
            itemsConnectionId,
            edgeIndex
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isInlineIssueCreateActiveRowBelow] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
            itemsConnectionId,
            edgeIndex + 1
        ]);
        isAdjacentInlineIssueCreateActive = isInlineIssueCreateActive || isInlineIssueCreateActiveRowBelow;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, // Check value instead of truthiness because it can be `undefined` if sibling issue create is disabled
    isFormVisible === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aTzcv.SiblingIssueCreateButton), {
        edgeIndex: edgeIndex,
        issuesConnectionId: itemsConnectionId,
        issue: firstCellData
    }), isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8h5Ee.DragActionsButton), {
        edgeIndex: edgeIndex,
        issueId: issueId,
        isRowHovered: isRowHovered && !isAdjacentInlineIssueCreateActive,
        parentIssueConnectionId: parentIssueConnectionId,
        ...isReparentingEnabled ? {
            hierarchyLevel: hierarchyLevel,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            projectKey: projectKey,
            firstCellData: firstCellData ?? null,
            itemsConnectionId: itemsConnectionId,
            setCurrentDraggingRow: setCurrentDraggingRow
        } : {
            firstCellData: null
        }
    }));
};

});
parcelRegister("3xRNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c1fea5565158e4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8353713c0bee4b6aad98f970a91e4d33>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1c1fea5565158e4c$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "BeforeFirstCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "DragActionsButton"
        },
        {
            "kind": "FragmentSpread",
            "name": "siblingIssueCreateButton_nativeIssueTable"
        }
    ],
    "type": "JiraIssue"
};
$1c1fea5565158e4c$var$node.hash = "bd3217e88c79f770b5aec35587e91367";
var $1c1fea5565158e4c$export$2e2bcd8739ae039 = $1c1fea5565158e4c$var$node;

});

parcelRegister("8h5Ee", function(module, exports) {
$parcel$export(module.exports, "DragActionsButton", () => $c0fd66e97582aa66$export$d55b3c0033758134);

var $bDUMq = parcelRequire("bDUMq");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $5k2HF = parcelRequire("5k2HF");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $dX4g9 = parcelRequire("dX4g9");

var $aHiGM = parcelRequire("aHiGM");

var $6qaBj = parcelRequire("6qaBj");

var $bGx3v = parcelRequire("bGx3v");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $2ApNu = parcelRequire("2ApNu");

var $d1S9l = parcelRequire("d1S9l");

var $bzbsd = parcelRequire("bzbsd");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $aBHUF = parcelRequire("aBHUF");

var $6pTKw = parcelRequire("6pTKw");

var $l4EsH = parcelRequire("l4EsH");

var $gbzqX = parcelRequire("gbzqX");

var $4AddX = parcelRequire("4AddX");

var $j5Wzv = parcelRequire("j5Wzv");

var $15Apk = parcelRequire("15Apk");

var $jNv5I = parcelRequire("jNv5I");

var $gCGxb = parcelRequire("gCGxb");

var $h4EQn = parcelRequire("h4EQn");

var $bCFDb = parcelRequire("bCFDb");
const $c0fd66e97582aa66$var$styles = {
    button: "_1dqonqa1 _1h6dmuej _189ee4h9 _4t3i7vkz _1bsbdlk8 _16qs1cd0 _bfhkhp5a _syaz1fxt _80om1qgj _irr31a0f _1di6qctv _9h8h16c2 _1qam5szm"
}; // Negatively offset by 1px to account for the cell border
const $c0fd66e97582aa66$var$offset = [
    (0, $8jOO7.ROW_HEIGHT) / 2 - 1,
    -1
];
const $c0fd66e97582aa66$var$BUTTON_SIZE = 16;
const $c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE = 'idle';
const $c0fd66e97582aa66$var$PREVIEW_DRAGGABLE_STATE = 'preview';
const $c0fd66e97582aa66$var$DRAGGING_DRAGGABLE_STATE = 'dragging';
const $c0fd66e97582aa66$var$isDropEdgeTarget = (dropTarget)=>'dropEdge' in dropTarget;
const $c0fd66e97582aa66$export$d55b3c0033758134 = ({ edgeIndex: edgeIndex, issueId: issueId, hierarchyLevel: hierarchyLevel, parentIssueAri: parentIssueAri, parentIssueConnectionId: parentIssueConnectionId, issueKey: issueKey, projectKey: projectKey, isRowHovered: isRowHovered, firstCellData: firstCellData, itemsConnectionId: itemsConnectionId, setCurrentDraggingRow: setCurrentDraggingRow })=>{
    const dragPreviewData = (0, $j4oe4.useFragment)((0, $bDUMq.default), firstCellData);
    const buttonRef = (0, $eJOHy.useRef)(null);
    const [buttonState, setButtonState] = (0, $eJOHy.useState)($c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const [{ currentDropTarget: currentDropTarget, instanceId: instanceId, items: items }, { reorderRows: reorderRows }] = (0, $l4EsH.useDraggableRows)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let isRowReorderingEnabled = false;
    if (!(0, $4cTDP.fg)('jsc-2065-unify-onrowreorder')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isRowReorderingEnabled = (0, $34oCh.useIsRowReorderingEnabled)();
    const isIssueRankingEnabled = (0, $34oCh.useIsIssueRankingEnabled)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    let rankIssues = null;
    let sortDirection;
    if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rankIssues = (0, $j5Wzv.useIssuesRanker)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        sortDirection = (0, $34oCh.useSortDirection)();
    }
    let fireAnalyticsStart = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    fireAnalyticsStart = (0, $eJOHy.useCallback)((fieldKeys, editType)=>{
        fieldKeys.forEach((fieldKey)=>{
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldKey, {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
                    parentId: parentIssueAri ? (0, $2ApNu.JiraIssueAri).parse(parentIssueAri).issueId : undefined,
                    issueType: dragPreviewData?.issueTypeField?.issueType?.name,
                    issueHierarchy: hierarchyLevel,
                    isDragEditing: editType === 'dragEditing',
                    isContextMenuEditing: editType === 'contextMenuEditing',
                    fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[fieldKey]
                }
            });
        });
    }, [
        createAnalyticsEvent,
        dragPreviewData?.issueTypeField?.issueType?.name,
        hierarchyLevel,
        issueId,
        parentIssueAri
    ]);
    const onRankIssuesNew = (0, $eJOHy.useCallback)((sourceIndex, destinationIndex)=>{
        const edge = (0, $15Apk.getEdgeForRerank)(sourceIndex, destinationIndex, sortDirection);
        return rankIssues?.({
            source: {
                issueIds: [
                    items.get(sourceIndex) ?? ''
                ],
                rowIndex: sourceIndex
            },
            destination: {
                relativeToIssueId: items.get(destinationIndex) ?? '',
                rowIndex: destinationIndex
            },
            edge: edge
        });
    }, [
        items,
        sortDirection,
        rankIssues
    ]);
    const onReorderRows = isIssueRankingEnabled ? onRankIssuesNew : reorderRows; // Note: It will use the `isIssueRankingEnabled` condition in the dropdown items instead
    // TODO: Use `onRankIssuesNew` directly on jsc-2065-unify-onrowreorder cleanup
    const onRankIssues = (0, $4cTDP.fg)('jsc-2065-unify-onrowreorder') ? onRankIssuesNew : onReorderRows;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isVisible = isDropdownOpen || isRowHovered || buttonState === $c0fd66e97582aa66$var$DRAGGING_DRAGGABLE_STATE;
    const isDropTarget = currentDropTarget?.issueId === issueId;
    const [draggableState, setDraggableState] = (0, $eJOHy.useState)({
        type: $c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE
    });
    const cloudId = (0, $cHtIB.useCloudId)();
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!buttonRef.current) return;
        return (0, $bGx3v.draggable)({
            element: buttonRef.current,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.ROW_OPERATION_REORDER),
                    instanceId: instanceId,
                    issueId: issueId,
                    rowIndex: edgeIndex,
                    hierarchyLevel: hierarchyLevel,
                    parentIssueAri: parentIssueAri,
                    parentIssueConnectionId: parentIssueConnectionId,
                    itemsConnectionId: itemsConnectionId,
                    issueKey: issueKey,
                    groupId: groupId
                };
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                // We need to make sure that the element not obfuscated by the sticky header
                (0, $aHiGM.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $dX4g9.pointerOutsideOfPreview)({
                        x: "var(--ds-space-250, 20px)",
                        y: "var(--ds-space-250, 20px)"
                    }),
                    render ({ container: container }) {
                        setDraggableState({
                            type: $c0fd66e97582aa66$var$PREVIEW_DRAGGABLE_STATE,
                            container: container
                        });
                        return ()=>setDraggableState({
                                type: $c0fd66e97582aa66$var$IDLE_DRAGGABLE_STATE
                            });
                    }
                });
            },
            onDragStart () {
                if (isReparentingEnabled && itemsConnectionId && (0, $4cTDP.fg)('jsc_list_reparenting')) {
                    const itemKey = (0, $jE8Tu.getItemKey)(itemsConnectionId, issueId);
                    setCurrentDraggingRow && setCurrentDraggingRow(itemKey);
                }
                setButtonState('dragging');
                if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) {
                    const fieldKeys = [
                        (isIssueRankingEnabled || isRowReorderingEnabled) && (0, $3mZMJ.RANK_CF_TYPE),
                        isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting') && (0, $3mZMJ.PARENT_TYPE)
                    ].filter(Boolean);
                    fireAnalyticsStart(fieldKeys, 'dragEditing');
                }
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dragged',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            },
            onDrop () {
                if (isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting')) setCurrentDraggingRow && setCurrentDraggingRow(null);
                buttonRef.current?.blur();
                setButtonState('idle');
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'dropped',
                    actionSubject: 'dragActionsButton',
                    actionSubjectId: 'jscDraggableIssue'
                }));
            }
        });
    }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4cTDP.fg)('jira_timeline_analytics_harmonization') ? [
        createAnalyticsEvent,
        edgeIndex,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        instanceId,
        itemsConnectionId,
        parentIssueConnectionId,
        setCurrentDraggingRow,
        isReparentingEnabled,
        isRowReorderingEnabled,
        isIssueRankingEnabled,
        issueKey,
        groupId,
        fireAnalyticsStart
    ] : [
        createAnalyticsEvent,
        edgeIndex,
        issueId,
        hierarchyLevel,
        parentIssueAri,
        instanceId,
        itemsConnectionId,
        parentIssueConnectionId,
        setCurrentDraggingRow,
        isReparentingEnabled,
        issueKey,
        groupId
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        if (parentIssueAri) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'changeParent');
        else (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'addParent');
    }, [
        createAnalyticsEvent,
        parentIssueAri
    ]);
    const isFirstRow = edgeIndex === 0 && !parentIssueAri;
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $eJOHy.useState)(false);
    let handleSubmitReparenting;
    if ((0, $4cTDP.fg)('jsc_list_reparenting')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    handleSubmitReparenting = (0, $gbzqX.useReparentingFromModal)({
        projectKey: projectKey
    });
    const modalEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            issueId: issueId,
            parentIssueAri: parentIssueAri,
            issueKey: issueKey,
            hierarchyLevel: hierarchyLevel,
            onSubmit: handleSubmitReparenting
        }), [
        handleSubmitReparenting,
        hierarchyLevel,
        issueId,
        issueKey,
        parentIssueAri
    ]);
    const handleMoveToTop = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, 0);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveToTop'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveUp = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, edgeIndex - 1);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveUp'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveDown = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, edgeIndex + 1);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveDown'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        onRankIssues
    ]);
    const handleMoveToBottom = (0, $eJOHy.useCallback)(()=>{
        onRankIssues(edgeIndex, items.size - 1);
        if ((0, $4cTDP.fg)('jsc_list_reranking_gate')) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rankIssue', {
            action: 'moveToBottom'
        });
    }, [
        createAnalyticsEvent,
        edgeIndex,
        items.size,
        onRankIssues
    ]);
    if (!issueKey && isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting')) // if the issue key is empty, it indicates that it’s an optimistic row so we should not render the drag handler
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            if (attrs.isOpen && (0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) {
                const fieldKeys = [
                    (isIssueRankingEnabled || isRowReorderingEnabled) && items.size > 1 && (0, $3mZMJ.RANK_CF_TYPE),
                    isReparentingEnabled && (0, $4cTDP.fg)('jsc_list_reparenting') && (0, $3mZMJ.PARENT_TYPE)
                ].filter(Boolean);
                fireAnalyticsStart(fieldKeys, 'contextMenuEditing');
            }
            setIsDropdownOpen(attrs.isOpen);
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pTKw.RowPopupButton), {
                alignToYAxis: true,
                buttonSize: $c0fd66e97582aa66$var$BUTTON_SIZE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k2HF))), {
                    label: "",
                    size: "small"
                }),
                isVisible: isVisible || isOnboardingVisible,
                label: formatMessage((0, $bCFDb.default).label),
                offset: $c0fd66e97582aa66$var$offset,
                ref: (0, $bzbsd.mergeRefs)(triggerRef, buttonRef),
                xcss: (0, $6qaBj.cx)($c0fd66e97582aa66$var$styles.button),
                onClick: triggerProps.onClick
            }),
        testId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        "data-testid": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reorder-menu-items"
    }, (isRowReorderingEnabled || isIssueRankingEnabled) && items.size > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === 0,
        onClick: handleMoveToTop
    }, formatMessage((0, $bCFDb.default).moveToTop)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === 0,
        onClick: handleMoveUp
    }, formatMessage((0, $bCFDb.default).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: handleMoveDown
    }, formatMessage((0, $bCFDb.default).moveDown)), isIssueRankingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        isDisabled: edgeIndex === items.size - 1,
        onClick: handleMoveToBottom
    }, formatMessage((0, $bCFDb.default).moveToBottom))), projectKey && (0, $4cTDP.fg)('jsc_list_reparenting') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $4AddX.reparentModalEntryPoint),
        entryPointProps: modalEntryPointProps,
        entryPointParams: {
            cloudId: cloudId,
            projectKey: projectKey
        },
        interactionName: "open-reparent-issue-modal",
        useInternalModal: true,
        onClick: handleClick
    }, parentIssueAri ? formatMessage((0, $bCFDb.default).changeParent) : formatMessage((0, $bCFDb.default).addParent)))), isDropTarget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBHUF.RowDropIndicator), $c0fd66e97582aa66$var$isDropEdgeTarget(currentDropTarget) ? {
        edge: currentDropTarget.dropEdge
    } : {
        instruction: currentDropTarget.dropInstruction
    }), draggableState.type === $c0fd66e97582aa66$var$PREVIEW_DRAGGABLE_STATE && isReparentingEnabled && dragPreviewData && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4EQn.DragPreview), {
        issueId: (0, $2ApNu.JiraIssueAri).parse(issueId).issueId,
        itemsConnectionId: itemsConnectionId,
        summary: dragPreviewData.summary,
        issueTypeAvatarUrl: dragPreviewData.issueTypeField?.issueType?.avatar?.small
    }), draggableState.container), isFirstRow && isReparentingEnabled && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gCGxb.ReparentingOnboarding), {
        buttonElement: buttonRef.current,
        setIsOnboardingVisible: setIsOnboardingVisible
    }));
};

});
parcelRegister("bDUMq", function(module, exports) {
$parcel$export(module.exports, "default", () => $47630aec647e3e5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79f9bfcc37cd62f909d1301b9a0ba3ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $47630aec647e3e5f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DragActionsButton",
    "selections": [
        {
            "condition": "isReparentingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$47630aec647e3e5f$var$node.hash = "393733eb40041d691aec62e761940301";
var $47630aec647e3e5f$export$2e2bcd8739ae039 = $47630aec647e3e5f$var$node;

});

parcelRegister("5k2HF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e00ead02e99da4c$var$_react = $3e00ead02e99da4c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3e00ead02e99da4c$var$_baseNew = $3e00ead02e99da4c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3e00ead02e99da4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e00ead02e99da4c$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $3e00ead02e99da4c$var$_react.default.createElement($3e00ead02e99da4c$var$_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$3e00ead02e99da4c$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $3e00ead02e99da4c$var$_default = module.exports.default = $3e00ead02e99da4c$var$DragHandleVerticalIcon;

});

parcelRegister("aBHUF", function(module, exports) {
$parcel$export(module.exports, "RowDropIndicator", () => $fe45d0eb6b7ca840$export$fa88485e37d4f027);

var $eJOHy = parcelRequire("eJOHy");

var $hM0gG = parcelRequire("hM0gG");

var $igtYB = parcelRequire("igtYB");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $7n9BS = parcelRequire("7n9BS");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $fe45d0eb6b7ca840$export$feefd628b4f4feb5 = ({ instruction: instruction })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollWidth - (0, $8jOO7.EXTRA_SPACE_PER_LEVEL));
    const isReParentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $fe45d0eb6b7ca840$var$boxStyles : $fe45d0eb6b7ca840$var$boxStylesOld,
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $fe45d0eb6b7ca840$var$dropIndicatorStyles : $fe45d0eb6b7ca840$var$dropIndicatorStylesOld
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, isReParentingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hM0gG.DropIndicator), {
        instruction: instruction
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: instruction.type === (0, $8jOO7.REORDER_ABOVE) ? 'top' : 'bottom',
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') ? {
            appearance: instruction.type === (0, $8jOO7.INSTRUCTION_BLOCKED) ? 'warning' : 'default'
        } : {}
    }));
};
const $fe45d0eb6b7ca840$export$d508f4eb766c5ef8 = ({ edge: edge })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.common.ui.row-drop-indicator.box",
        xcss: [
            (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $fe45d0eb6b7ca840$var$boxStyles : $fe45d0eb6b7ca840$var$boxStylesOld
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${width}px`
        },
        "data-row-drop-indicator": true
    }, edge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: edge
    }));
};
const $fe45d0eb6b7ca840$export$fa88485e37d4f027 = /*#__PURE__*/ (0, $eJOHy.memo)(({ edge: edge, instruction: instruction })=>{
    if (instruction && (0, $4cTDP.fg)('jsc_list_reparenting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe45d0eb6b7ca840$export$feefd628b4f4feb5, {
        instruction: instruction
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe45d0eb6b7ca840$export$d508f4eb766c5ef8, {
        edge: edge
    });
});
const $fe45d0eb6b7ca840$var$boxStylesOld = (0, $1DXK0.xcss)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    bottom: 'space.0',
    // Negatively offset by 1px to account for the cell border
    insetInlineStart: '-1px',
    pointerEvents: 'none'
});
const $fe45d0eb6b7ca840$var$boxStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    insetBlockStart: 'space.0',
    insetBlockEnd: 'space.0',
    // Negatively offset by 1px to account for the cell border
    insetInlineStart: '-1px',
    pointerEvents: 'none'
});
const $fe45d0eb6b7ca840$var$dropIndicatorStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.050',
    width: '100%',
    zIndex: 'tooltip'
});
const $fe45d0eb6b7ca840$var$dropIndicatorStyles = (0, $1DXK0.xcss)({
    insetInlineStart: 'space.050',
    width: '100%',
    zIndex: 'tooltip'
});

});
parcelRegister("hM0gG", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $eab1d74837eadd45$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5HaAt = parcelRequire("5HaAt");

var $igtYB = parcelRequire("igtYB");
function $eab1d74837eadd45$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5HaAt.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $eab1d74837eadd45$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $eab1d74837eadd45$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $eab1d74837eadd45$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}

});
parcelRegister("5HaAt", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $23ed11adb70c127c$export$62ed72bc21f6b8a6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4EbJC = parcelRequire("4EbJC");

var $kStpA = parcelRequire("kStpA");
function $23ed11adb70c127c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4EbJC.Border), {
        strokeColor: (0, $kStpA.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$23ed11adb70c127c$export$2e2bcd8739ae039 = $23ed11adb70c127c$export$62ed72bc21f6b8a6;

});
parcelRegister("4EbJC", function(module, exports) {
$parcel$export(module.exports, "Border", () => $00f4a5c271d0d0a5$export$d8e9c9d63e86d41e);
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kStpA = parcelRequire("kStpA");
const $00f4a5c271d0d0a5$var$styles = null;
function $00f4a5c271d0d0a5$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $kStpA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $kStpA.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $hcewu.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
}
var // For React.lazy
$00f4a5c271d0d0a5$export$2e2bcd8739ae039 = $00f4a5c271d0d0a5$export$d8e9c9d63e86d41e;

});




parcelRegister("6pTKw", function(module, exports) {
$parcel$export(module.exports, "RowPopupButton", () => $a86e6d6da2b92676$export$960d0282617d39c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $6qaBj = parcelRequire("6qaBj");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $8nu6j = parcelRequire("8nu6j");

var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");

var $bzbsd = parcelRequire("bzbsd");

var $8cv11 = parcelRequire("8cv11");

var $4cTDP = parcelRequire("4cTDP");
const $a86e6d6da2b92676$var$styles = {
    referenceOld: "_1ltvze3t _154ize3t",
    reference: "_1e02ze3t _152tze3t",
    visuallyHiddenOld: "_19itglyw _1reo15vq _18m915vq _1bsbt94y _4t3it94y _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _kqswstnw _mkrz1ly6 _o5721q9c",
    visuallyHidden: "_19itglyw _1reo15vq _18m915vq _1bsbt94y _4t3it94y _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _kqswstnw _mkrz1ly6 _o5721q9c"
};
const $a86e6d6da2b92676$var$buttonStyles = {
    root: "_1e0c1txw _1bah1h6o _4cvr1h6o _1pby1nn1",
    default: "_2rko12b0 _bfhk1bhr _80omtlke _irr316qz _1di6vq0a"
};
const $a86e6d6da2b92676$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
// Height/width of the popup button
const $a86e6d6da2b92676$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $a86e6d6da2b92676$var$REFERENCE_SIZE = 1;
const $a86e6d6da2b92676$export$960d0282617d39c3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const { icon: icon, isVisible: isVisible, label: label, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tooltipContent: tooltipContent, tooltipPosition: tooltipPosition, alignToYAxis: alignToYAxis = true, buttonSize: buttonSize = $a86e6d6da2b92676$var$DEFAULT_BUTTON_SIZE, offset: offset = [
        0,
        0
    ], xcss: xcss } = props;
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const updateRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Recompute popup position when the button is shown
        isVisible && updateRef.current?.();
    }, [
        isVisible
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Recompute popup position when the button is focused
        isFocused && updateRef.current?.();
    }, [
        isFocused
    ]);
    const [along, away] = offset;
    const finalOffset = (0, $eJOHy.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            along,
            away - (buttonSize + $a86e6d6da2b92676$var$REFERENCE_SIZE) / 2
        ], [
        along,
        away,
        buttonSize
    ]);
    const modifiers = (0, $eJOHy.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -(buttonSize / 2);
        // Retain the provided offset for the secondary axis
        const padding = alignToYAxis ? {
            left: finalOffset[1],
            top: alongCenterOffset,
            bottom: alongCenterOffset
        } : {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$a86e6d6da2b92676$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isFocused,
                    resize: isFocused
                }
            }
        ];
    }, [
        alignToYAxis,
        buttonSize,
        finalOffset,
        isFocused
    ]);
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $bzbsd.mergeRefs)), []);
    const isVisuallyHidden = !isVisible && !isFocused;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: (0, $6qaBj.cx)((0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $a86e6d6da2b92676$var$styles.reference : $a86e6d6da2b92676$var$styles.referenceOld, (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $a86e6d6da2b92676$var$styles.visuallyHidden : $a86e6d6da2b92676$var$styles.visuallyHiddenOld),
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: alignToYAxis ? 'right' : 'bottom',
        modifiers: modifiers,
        offset: finalOffset,
        messageId: "native-issue-table.common.ui.row-popup-button.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            position: tooltipPosition,
            content: tooltipContent,
            canAppear: ()=>tooltipContent != null
        }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
                ...triggerProps,
                "aria-label": label,
                testId: `native-issue-table.common.ui.row-popup-button.pressable${isVisuallyHidden ? '-hidden' : ''}`,
                xcss: (0, $6qaBj.cx)($a86e6d6da2b92676$var$buttonStyles.root, $a86e6d6da2b92676$var$buttonStyles.default, // See https://atlassian.design/components/css/overview#building-reusable-components
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                xcss, isVisuallyHidden && $a86e6d6da2b92676$var$styles.visuallyHidden),
                onClick: (e, analyticEvent)=>{
                    onClick?.(e, analyticEvent);
                    triggerProps.onClick(e);
                },
                onFocus: (e)=>{
                    setIsFocused(true);
                    triggerProps.onFocus(e);
                },
                onBlur: (e)=>{
                    setIsFocused(false);
                    triggerProps.onBlur(e);
                },
                onMouseMove: (e)=>{
                    // Stop propagation so the button isn't inadvertently hidden when hovering
                    e.stopPropagation();
                    triggerProps.onMouseMove?.(e);
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ref: memoizedMergeRefs(ref, triggerProps.ref, forwardedRef),
                // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
                style: style
            }, icon));
    }));
});

});

parcelRegister("gbzqX", function(module, exports) {
$parcel$export(module.exports, "useReparentingFromModal", () => $69b98f49ec4fd4fd$export$7ed8dfd115f70801);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $9pTd3 = parcelRequire("9pTd3");

var $2ApNu = parcelRequire("2ApNu");

var $ftN6c = parcelRequire("ftN6c");

var $3mZMJ = parcelRequire("3mZMJ");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $cHtIB = parcelRequire("cHtIB");

var $cSXp8 = parcelRequire("cSXp8");

var $4cTDP = parcelRequire("4cTDP");

var $adrlS = parcelRequire("adrlS");

var $8jOO7 = parcelRequire("8jOO7");

var $8pBFu = parcelRequire("8pBFu");
const $69b98f49ec4fd4fd$export$7ed8dfd115f70801 = ({ projectKey: projectKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const updateParentConnections = (0, $adrlS.useGetReparentUpdater)();
    let createAnalyticsEvent;
    if ((0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    createAnalyticsEvent = (0, $ftN6c.useAnalyticsEvents)().createAnalyticsEvent;
    return (0, $eJOHy.useCallback)((updatedIssues, newParentId, newIssueParent, requestPromise)=>{
        if (updatedIssues.length) {
            const updatedIssue = updatedIssues[0];
            if (updatedIssue.id) {
                const ariIssueId = (0, $2ApNu.JiraIssueAri).create({
                    issueId: updatedIssue.id,
                    siteId: cloudId
                }).toString();
                if (createAnalyticsEvent && (0, $4cTDP.fg)('jira_timeline_analytics_harmonization')) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.PARENT_TYPE), {
                    analytics: createAnalyticsEvent({}),
                    attributes: {
                        issueId: updatedIssue.id,
                        fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.PARENT_TYPE],
                        oldValId: updatedIssue.parentId,
                        newValId: newParentId
                    }
                });
                (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
                    updateParentConnections({
                        store: store,
                        issueId: ariIssueId,
                        oldParentId: updatedIssue.parentId,
                        newParentId: newParentId,
                        index: 0,
                        projectKey: projectKey
                    });
                });
                requestPromise.catch((error)=>{
                    // Rollback
                    (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
                        updateParentConnections({
                            store: store,
                            issueId: ariIssueId,
                            oldParentId: newParentId,
                            newParentId: updatedIssue.parentId,
                            index: 0,
                            projectKey: projectKey
                        });
                    });
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'issueTableReparentMutationFromModal',
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag((0, $8pBFu.UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                });
            }
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        environment,
        projectKey,
        showFlag,
        updateParentConnections
    ]);
};

});

parcelRegister("4AddX", function(module, exports) {
$parcel$export(module.exports, "reparentModalEntryPoint", () => $10fd1aa1388ec33e$export$e5e5cbbac06953a1);

var $gaDzZ = parcelRequire("gaDzZ");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $10fd1aa1388ec33e$export$e5e5cbbac06953a1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bJuhx")), {
        moduleId: "92cce941",
        moduleName: "ReparentModalEntryPoint",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                projectData: {
                    parameters: $gaDzZ.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("bJuhx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b25oZ").then(()=>parcelRequire('fe43f'));

});


parcelRegister("gCGxb", function(module, exports) {
$parcel$export(module.exports, "ReparentingOnboarding", () => $77a5b7e391e34013$export$18bcadaeddef642);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $d2s5v = parcelRequire("d2s5v");

var $8IeH1 = parcelRequire("8IeH1");

var $58yRG = parcelRequire("58yRG");

var $6zxfT = parcelRequire("6zxfT");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $jie4g = parcelRequire("jie4g");

var $cOh4b = parcelRequire("cOh4b");

var $2TobG = parcelRequire("2TobG");
const $77a5b7e391e34013$export$ae06398c30161061 = 'jira-list-nin-reparent-onboarding-stg';
const $77a5b7e391e34013$export$c63f3f365035b47c = 'jira-list-nin-reparent-onboarding';
const $77a5b7e391e34013$var$ENV_STAGING = 'staging';
const $77a5b7e391e34013$var$STARGATE_URL = '/gateway/api';
const $77a5b7e391e34013$export$18bcadaeddef642 = ({ buttonElement: buttonElement, setIsOnboardingVisible: setIsOnboardingVisible })=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $kyq27.useEnvironment)() === $77a5b7e391e34013$var$ENV_STAGING ? $77a5b7e391e34013$export$ae06398c30161061 : $77a5b7e391e34013$export$c63f3f365035b47c;
    const cloudId = (0, $cHtIB.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const spotlight = colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($2TobG))) : (0, (/*@__PURE__*/$parcel$interopDefault($cOh4b)));
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(false);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $77a5b7e391e34013$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled) {
            setIsOnboardingVisible(true);
            stopEnrolment(false);
            setTimeout(()=>{
                setIsSpotlightActive(true);
            }, 50);
        }
    }, [
        isEnrolled,
        setIsOnboardingVisible,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isSpotlightActive && buttonElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseOver: (event)=>{
            event.stopPropagation();
        },
        onMouseLeave: (event)=>{
            event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        image: spotlight,
        messageId: "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setIsOnboardingVisible(false);
                },
                text: formatMessage((0, $jie4g.default).dismiss)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $jie4g.default).onboardingHeading),
        targetNode: buttonElement,
        targetRadius: 3,
        key: "reparenting-onboarding"
    }, formatMessage((0, $jie4g.default).onboardingDescription)))));
};

});
parcelRegister("jie4g", function(module, exports) {
$parcel$export(module.exports, "default", () => $825ad67642b58329$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $825ad67642b58329$var$messages = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-heading",
        "defaultMessage": "Re-parent work items"
    },
    onboardingDescription: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.onboarding-description",
        "defaultMessage": "Select and move a work item to add, or change, the parent."
    },
    dismiss: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.reparenting-onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $825ad67642b58329$export$2e2bcd8739ae039 = $825ad67642b58329$var$messages;

});

parcelRegister("cOh4b", function(module, exports) {
module.exports = new URL("reparent-onboarding-light.f5faa58e.gif", import.meta.url).toString();

});

parcelRegister("2TobG", function(module, exports) {
module.exports = new URL("reparent-onboarding-dark.ad59f27a.gif", import.meta.url).toString();

});


parcelRegister("h4EQn", function(module, exports) {
$parcel$export(module.exports, "DragPreview", () => $aba8ee8166d92834$export$905ab40ac2179daa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $jE8Tu = parcelRequire("jE8Tu");
const $aba8ee8166d92834$var$MAX_ISSUE_COUNT = 99;
const $aba8ee8166d92834$export$905ab40ac2179daa = ({ summary: summary, issueTypeAvatarUrl: issueTypeAvatarUrl, issueId: issueId, itemsConnectionId: itemsConnectionId })=>{
    const [{ listMetadata: listMetadata, connectionMap: connectionMap, connectionItems: connectionItems }] = (0, $jE8Tu.useHierarchyStore)();
    const [isExpanded] = (0, $jE8Tu.useIsItemExpanded)({
        itemId: issueId,
        itemsConnectionId: itemsConnectionId || ''
    });
    const childCount = (0, $eJOHy.useMemo)(()=>{
        if (isExpanded) {
            const itemKey = listMetadata.find((element)=>element.itemId === issueId)?.key || '';
            const keyConnection = connectionMap[itemKey];
            const itemConnectionItems = keyConnection ? connectionItems[keyConnection] || [] : [];
            return itemConnectionItems.length ? (0, $jE8Tu.filterNonIssueItems)(itemConnectionItems.map((item)=>item.itemId)).length || 0 : 0;
        }
        return 0;
    }, [
        connectionItems,
        connectionMap,
        isExpanded,
        issueId,
        listMetadata
    ]);
    const showChildIssues = childCount > 0;
    const hasMoreThanOneChild = childCount > 1;
    const countIncludingParent = childCount > 0 ? childCount + 1 : 0;
    const hasLessThanMaxIssueCount = countIncludingParent < $aba8ee8166d92834$var$MAX_ISSUE_COUNT;
    const roundedIssueCount = hasLessThanMaxIssueCount ? countIncludingParent : $aba8ee8166d92834$var$MAX_ISSUE_COUNT;
    return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aba8ee8166d92834$var$rootStyles
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasMoreThanOneChild ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$child2Styles
        ]
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$child1Styles
        ]
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $aba8ee8166d92834$var$listItemStyles,
            $aba8ee8166d92834$var$primaryItemStyles
        ]
    }, showChildIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: hasLessThanMaxIssueCount ? $aba8ee8166d92834$var$badgeStyles : [
            $aba8ee8166d92834$var$badgeStyles,
            $aba8ee8166d92834$var$smallContentStyles
        ],
        alignItems: "center",
        justifyContent: "center"
    }, hasLessThanMaxIssueCount ? roundedIssueCount : `${roundedIssueCount}+`) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $aba8ee8166d92834$var$innerStyles,
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center"
    }, issueTypeAvatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: issueTypeAvatarUrl,
        alt: "",
        className: (0, $hcewu.default)([
            "_4t3ipxbi _1bsbpxbi"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $aba8ee8166d92834$var$textStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, summary)))))) : null;
};
const $aba8ee8166d92834$var$MAX_WIDTH = 300;
const $aba8ee8166d92834$var$rootStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    width: `${$aba8ee8166d92834$var$MAX_WIDTH}px`
});
const $aba8ee8166d92834$var$listItemStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overlay',
    position: 'absolute',
    height: 'size.400',
    width: `${$aba8ee8166d92834$var$MAX_WIDTH}px`
});
const $aba8ee8166d92834$var$primaryItemStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingLeft: 'space.200',
    backgroundColor: 'color.background.input'
});
const $aba8ee8166d92834$var$innerStyles = (0, $1DXK0.xcss)({
    height: '100%'
});
const $aba8ee8166d92834$var$textStyle = (0, $1DXK0.xcss)({
    maxWidth: '220px'
});
const $aba8ee8166d92834$var$imageStyles = null;
const $aba8ee8166d92834$var$child1Styles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.075'
});
const $aba8ee8166d92834$var$child2Styles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.150',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.150'
});
const $aba8ee8166d92834$var$badgeStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.negative.150',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    right: 'space.negative.150',
    borderRadius: 'radius.full',
    backgroundColor: 'color.background.accent.red.bolder',
    width: 'size.200',
    height: 'size.200',
    color: 'color.text.inverse'
});
const $aba8ee8166d92834$var$smallContentStyles = (0, $1DXK0.xcss)({
    font: 'font.body.small'
});

});

parcelRegister("bCFDb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ec151de2659cca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d4ec151de2659cca$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.label",
        "defaultMessage": "Actions"
    },
    addParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.add-parent",
        "defaultMessage": "Add parent"
    },
    changeParent: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.change-parent",
        "defaultMessage": "Change parent"
    },
    moveToTop: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-top",
        "defaultMessage": "Move to top"
    },
    moveUp: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-up",
        "defaultMessage": "Move up"
    },
    moveDown: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-down",
        "defaultMessage": "Move down"
    },
    moveToBottom: {
        "id": "native-issue-table.ui.row.before-first-cell.drag-actions-button.move-to-bottom",
        "defaultMessage": "Move to bottom"
    }
});
var $d4ec151de2659cca$export$2e2bcd8739ae039 = $d4ec151de2659cca$var$messages;

});


parcelRegister("aTzcv", function(module, exports) {
$parcel$export(module.exports, "SiblingIssueCreateButton", () => $d33708464bf5704f$export$76f0c0887f3df38d);

var $5YbM4 = parcelRequire("5YbM4");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $dcLzM = parcelRequire("dcLzM");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jE8Tu = parcelRequire("jE8Tu");

var $4cTDP = parcelRequire("4cTDP");

var $aBHUF = parcelRequire("aBHUF");

var $6pTKw = parcelRequire("6pTKw");

var $6LwYU = parcelRequire("6LwYU");


var $4NiKr = parcelRequire("4NiKr");

var $jNv5I = parcelRequire("jNv5I");

var $e980u = parcelRequire("e980u");
const $d33708464bf5704f$var$styles = {
    button: "_1dqonqa1 _189ee4h9 _1h6dmuej _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs1cd0"
};
const $d33708464bf5704f$var$offset = [
    -1,
    -1
]; /**
                                            * Display a 'Create' popup button positioned relative to the nearest containing block that will appear when hovering
                                            * between issue rows.
                                            */ 
const $d33708464bf5704f$export$76f0c0887f3df38d = ({ issuesConnectionId: issuesConnectionId, edgeIndex: edgeIndex, issue: issue })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    let groupId;
    let setIsSiblingCreateVisible = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        setIsSiblingCreateVisible = (0, $jE8Tu.useHierarchyActions)().setIsSiblingCreateVisible; // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        groupId = (0, $jNv5I.useRowContext)().groupId;
    }
    const issueData = (0, $j4oe4.useFragment)((0, $5YbM4.default), issue);
    const [isInlineIssueCreateActive, { lockIndex: lockIndex, clearIndexAfterDelay: clearIndexAfterDelay }] = (0, $6LwYU.useIsSiblingIssueCreateActive)([
        issuesConnectionId,
        edgeIndex
    ]);
    const [isMouseOverSiblingCreate, setIsMouseOverSiblingCreate] = (0, $eJOHy.useState)(false);
    const { triggerProps: triggerProps } = (0, $4NiKr.useSiblingIssueCreateRow)();
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsMouseOverSiblingCreate(true);
        lockIndex((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsMouseOverSiblingCreate(false);
        clearIndexAfterDelay((0, $a11b3ba2d46b97f5$export$76a449e52fa0e1e8));
    }, [
        clearIndexAfterDelay
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        triggerProps?.onClick();
        if (issueData?.issueId && (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting')) setIsSiblingCreateVisible?.({
            itemsConnectionId: issuesConnectionId,
            itemId: issueData.issueId,
            groupId: groupId
        }, true);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'siblingIssueCreateButton');
    }, [
        createAnalyticsEvent,
        groupId,
        issueData?.issueId,
        issuesConnectionId,
        setIsSiblingCreateVisible,
        triggerProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pTKw.RowPopupButton), {
        alignToYAxis: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            label: ""
        }),
        isVisible: isInlineIssueCreateActive,
        label: formatMessage((0, $e980u.default).createLabel),
        offset: $d33708464bf5704f$var$offset,
        onClick: handleOnClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: triggerProps?.ref,
        tooltipContent: formatMessage((0, $e980u.default).createLabel),
        tooltipPosition: "left",
        xcss: $d33708464bf5704f$var$styles.button
    }), isMouseOverSiblingCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBHUF.RowDropIndicator), {
        edge: "top"
    }));
};

});
parcelRegister("5YbM4", function(module, exports) {
$parcel$export(module.exports, "default", () => $52eaec062b55fcf0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16ceb52b98514a7346dd29733ae7e258>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52eaec062b55fcf0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "siblingIssueCreateButton_nativeIssueTable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "issueId"
        }
    ],
    "type": "JiraIssue"
};
$52eaec062b55fcf0$var$node.hash = "6aee15b0398ae80100f4770b20226da4";
var $52eaec062b55fcf0$export$2e2bcd8739ae039 = $52eaec062b55fcf0$var$node;

});

parcelRegister("e980u", function(module, exports) {
$parcel$export(module.exports, "default", () => $17e444ad74de1b00$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $17e444ad74de1b00$var$messages = (0, $7qGN1.defineMessages)({
    createLabel: {
        "id": "native-issue-table.ui.row.before-first-cell.sibling-issue-create-button.create-label",
        "defaultMessage": "Create"
    }
});
var $17e444ad74de1b00$export$2e2bcd8739ae039 = $17e444ad74de1b00$var$messages;

});



parcelRegister("29rOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cc4cd5321bb6155$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $bKlUQ = parcelRequire("bKlUQ");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $8jOO7 = parcelRequire("8jOO7");

var $c2eR8 = parcelRequire("c2eR8");
const $0cc4cd5321bb6155$var$BlankIssueRow = ({ isSelected: isSelected, cellBorder: cellBorder })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { columns: columns } = (0, $jNv5I.useRowContext)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const hasSpacerColumn = (0, $eJOHy.useMemo)(()=>isFixedTableLayoutEnabled && columns.some((c)=>c.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)), [
        isFixedTableLayoutEnabled,
        columns
    ]);
    const shouldAddSpacerColumn = (0, $4cTDP.fg)('fix_whitespace_shown') ? hasSpacerColumn : isFixedTableLayoutEnabled;
    const colSpan = columns.length + (shouldAddSpacerColumn ? 1 : 0); // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        colSpan: colSpan,
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cc4cd5321bb6155$var$Text, {
        isSelected: isSelected
    }, formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c2eR8.default).blankRowTextWithArchiveIssueIssueTermRefresh : (0, $c2eR8.default).blankRowTextWithArchiveIssue)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    }));
};
var $0cc4cd5321bb6155$export$2e2bcd8739ae039 = $0cc4cd5321bb6155$var$BlankIssueRow;
const $0cc4cd5321bb6155$var$textColorActiveState = "var(--ds-text-selected, #0C66E4)";
const $0cc4cd5321bb6155$var$textColor = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cc4cd5321bb6155$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19bv1b66 _80om73ad",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c2eR8", function(module, exports) {
$parcel$export(module.exports, "default", () => $0299e96509ca7ed3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0299e96509ca7ed3$var$messages = (0, $7qGN1.defineMessages)({
    blankRow: {
        "id": "native-issue-table.issue-row.blank-row.blank-row",
        "defaultMessage": "We can't display this issue"
    },
    blankRowText: {
        "id": "native-issue-table.row.blank-row.blank-row-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    blankRowTextWithArchiveIssue: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue",
        "defaultMessage": "This issue can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    blankRowTextWithArchiveIssueIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-with-archive-issue-issue-term-refresh",
        "defaultMessage": "This work item can\u2019t be opened because it may have been archived or deleted, or you don\u2019t have access to it."
    },
    tooltip: {
        "id": "native-issue-table.issue-row.blank-row.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankRowIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    blankRowTextIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.blank-row-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it."
    },
    tooltipIssueTermRefresh: {
        "id": "native-issue-table.row.blank-row.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});
var $0299e96509ca7ed3$export$2e2bcd8739ae039 = $0299e96509ca7ed3$var$messages;

});


parcelRegister("7EMZm", function(module, exports) {
$parcel$export(module.exports, "IssueCreateRow", () => $566ff58d0f75b900$export$a7c20b50f3f5d02c);

var $eJOHy = parcelRequire("eJOHy");

var $es8uT = parcelRequire("es8uT");
const $566ff58d0f75b900$export$a7c20b50f3f5d02c = ({ isFormVisible: isFormVisible, ...props })=>{
    return isFormVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $es8uT.IssueCreateCell), props));
};

});
parcelRegister("es8uT", function(module, exports) {
$parcel$export(module.exports, "IssueCreateCell", () => $c269d40757de226d$export$2337c3632571bf46);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6xIZT = parcelRequire("6xIZT");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $9r0oq = parcelRequire("9r0oq");

var $aNnbk = parcelRequire("aNnbk");
const $c269d40757de226d$export$2337c3632571bf46 = ({ issuesConnectionId: issuesConnectionId, siblingIssueId: siblingIssueId, rankFieldId: rankFieldId, parentIssueAri: parentIssueAri, location: location, groupContextFieldInput: groupContextFieldInput, ...props })=>{
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    let jql;
    if ((0, $cxKOj.expVal)('jira_spreadsheet_issue_create_in_group', 'isEnabled', false)) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    jql = (0, $34oCh.useJql)();
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    // JSC-169 Set rankFieldId into formContextualFields so correct rank is set for GIC fallback
    const formContextualFields = (0, $eJOHy.useMemo)(()=>isIssueRankDescending ? {
            rankAfterIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        } : {
            rankBeforeIssueId: siblingIssueId,
            rankFieldId: rankFieldId
        }, [
        isIssueRankDescending,
        siblingIssueId,
        rankFieldId
    ]);
    const onCreateIssue = (0, $aNnbk.useIssueCreateMutation)({
        issueConnectionId: issuesConnectionId,
        jql: jql,
        ...(0, $4cTDP.fg)('group_by_any_field_sibling_inline_issue_create') && {
            groupContextFieldInput: groupContextFieldInput
        },
        ...(0, $4cTDP.fg)('jsc_list_reranking_gate') && {
            location: location
        }
    });
    const handleIssueCreate = (0, $eJOHy.useCallback)((issueToCreate, contextualFields)=>{
        onCreateIssue(issueToCreate, {
            ...contextualFields,
            ...parentIssueAri && {
                parentIssueAri: parentIssueAri
            }
        }, {
            insertAfter: false,
            insertNodeId: siblingIssueId
        });
    }, [
        onCreateIssue,
        parentIssueAri,
        siblingIssueId
    ]);
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xIZT.default), {
        contextualFields: formContextualFields,
        onCreateIssue: handleIssueCreate,
        rankFieldId: rankFieldId,
        location: location,
        ...props
    });
    if (isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c269d40757de226d$var$CustomisableIssueCreateCellWrapper, {
        width: width
    }, form);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $c269d40757de226d$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c269d40757de226d$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, form));
};
const $c269d40757de226d$export$2eff3f295c9bc2ba = ({ children: children, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "td",
        xcss: $c269d40757de226d$var$cellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c269d40757de226d$var$boxStyles,
        style: {
            width: `${width}px`
        }
    }, children));
const $c269d40757de226d$var$CustomisableIssueCreateCellWrapper = ({ children: children, width: width })=>{
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const Wrapper = timelineCustomComponents?.IssueCreateCellWrapper ?? $c269d40757de226d$export$2eff3f295c9bc2ba;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, {
        width: width
    }, children);
};
const $c269d40757de226d$var$cellStyles = (0, $1DXK0.xcss)({
    height: '40px',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'sticky',
    zIndex: 'card'
});
const $c269d40757de226d$var$boxStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});

});


parcelRegister("6P9sy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f275defbc93e5d7$export$2e2bcd8739ae039);

var $9GbI9 = parcelRequire("9GbI9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");

var $eJ9f5 = parcelRequire("eJ9f5");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $eS29z = parcelRequire("eS29z");
var $ftN6c = parcelRequire("ftN6c");

var $gPQL9 = parcelRequire("gPQL9");

var $kRgKj = parcelRequire("kRgKj");

var $244Ix = parcelRequire("244Ix");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $bKlUQ = parcelRequire("bKlUQ");

var $8jOO7 = parcelRequire("8jOO7");

var $j9Qlh = parcelRequire("j9Qlh");
const $9f275defbc93e5d7$var$APPLINK_MISSING = 'APPLINK_MISSING';
const $9f275defbc93e5d7$var$APPLINK_REQ_AUTH = 'APPLINK_REQ_AUTH';
const $9f275defbc93e5d7$var$RemoteIssueErrorRow = ({ isSelected: isSelected, cellBorder: cellBorder, errorRef: errorRef, issueKey: issueKey, onAuthenticationClick: onAuthenticationClick })=>{
    // Define fragment inside the component to satisfy Relay linting rules
    const error = (0, $j4oe4.useFragment)((0, $9GbI9.default), errorRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { columns: columns, tableInjectedProps: tableInjectedProps } = (0, $jNv5I.useRowContext)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const hasSpacerColumn = (0, $eJOHy.useMemo)(()=>isFixedTableLayoutEnabled && columns.some((c)=>c.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)), [
        isFixedTableLayoutEnabled,
        columns
    ]);
    // Extract remoteServerHostname from repairLink.href
    const remoteServerHostname = (0, $eJOHy.useMemo)(()=>{
        if (error?.repairLink?.href) try {
            return new URL(error.repairLink.href).hostname;
        } catch  {
            return null;
        }
        return null;
    }, [
        error?.repairLink?.href
    ]);
    const getAttributes = (0, $eJOHy.useCallback)(()=>({
            errorType: error?.errorType || 'NONE',
            issueKey: issueKey || 'UNKNOWN',
            remoteServerHostname: remoteServerHostname || 'UNKNOWN',
            isSelected: isSelected,
            hasRepairLink: !!error?.repairLink?.href,
            hasError: !!error,
            isRemote: !!remoteServerHostname,
            component: 'RemoteIssueErrorRow',
            context: 'issue-table'
        }), [
        error,
        issueKey,
        remoteServerHostname,
        isSelected
    ]);
    const handleUserClickAnalytics = (0, $eJOHy.useCallback)((actionSubjectId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issueView.ErrorIssueRow'
        });
        const attributes = getAttributes();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getAttributes
    ]);
    const handleAuthentication = (0, $eJOHy.useCallback)(async ()=>{
        // Track authentication click analytics
        handleUserClickAnalytics('errorIssueRow.authenticationLink');
        const analyticsEvent = createAnalyticsEvent({
            action: 'authenticate',
            actionSubject: 'errorIssueRow.authenticationLink'
        });
        // Check if error has repairLink
        if (error?.repairLink?.href) try {
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'applink authenticate', {
                authStatus: 'start'
            });
            await (0, $244Ix.default)(error.repairLink.href);
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'applink authenticate', {
                authStatus: 'success'
            });
            // On successful authentication, refetch the table data
            if (tableInjectedProps.onIssueRefetch) tableInjectedProps.onIssueRefetch(issueKey || '');
        } catch (authError) {
            // Track authentication failure for Splunk monitoring
            if (authError instanceof Error || authError instanceof TypeError) (0, $gPQL9.trackOrLogClientError)('remote-issue-error-row', 'Failed to authenticate with applinks', authError);
        }
        else if (onAuthenticationClick) // Fallback to the original authentication click handler
        onAuthenticationClick();
    }, [
        error,
        issueKey,
        tableInjectedProps,
        onAuthenticationClick,
        handleUserClickAnalytics,
        createAnalyticsEvent
    ]);
    const renderContent = (0, $eJOHy.useMemo)(()=>{
        switch(error?.errorType){
            case $9f275defbc93e5d7$var$APPLINK_REQ_AUTH:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    color: isSelected ? 'color.text.selected' : 'color.text'
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                    ...(0, $j9Qlh.default).linkedWorkItemAuthRequiredWithCta,
                    values: {
                        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: error.repairLink?.href || '#',
                            onClick: (e)=>{
                                e.preventDefault();
                                handleAuthentication();
                            }
                        }, formatMessage((0, $j9Qlh.default).linkedWorkItemAuthRequiredCta))
                    }
                }));
            case $9f275defbc93e5d7$var$APPLINK_MISSING:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    color: "color.text.danger"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                    ...(0, $j9Qlh.default).linkedWorkItemMissingApplinkWithCta,
                    values: {
                        cta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: "/plugins/servlet/applinks/listApplicationLinks",
                            target: "_blank",
                            onClick: ()=>handleUserClickAnalytics('errorIssueRow.projectSettingsLink')
                        }, formatMessage((0, $j9Qlh.default).linkedWorkItemMissingApplinkCta))
                    }
                }));
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                    color: isSelected ? 'color.text.selected' : 'color.text'
                }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $j9Qlh.default).remoteLinkGeneralErrorIssueTermRefresh : (0, $j9Qlh.default).remoteLinkGeneralError));
        }
    }, [
        error,
        formatMessage,
        handleAuthentication,
        isSelected,
        handleUserClickAnalytics
    ]);
    // Extra column added to account for the blank spacer column added to the table
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        colSpan: columns.length + (hasSpacerColumn ? 1 : 0),
        border: cellBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInlineStart: "space.050"
    }, renderContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "errorRemoteIssue"
    }));
};
var $9f275defbc93e5d7$export$2e2bcd8739ae039 = $9f275defbc93e5d7$var$RemoteIssueErrorRow;

});
parcelRegister("9GbI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e602875ba3d951d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e49a0d171cf204c0b601fbf996d84ae3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e602875ba3d951d6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "remoteIssueErrorRow_nativeIssueTable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "errorType"
        },
        {
            "concreteType": "JiraRemoteLinkedIssueRepairLink",
            "kind": "LinkedField",
            "name": "repairLink",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "href"
                }
            ]
        }
    ],
    "type": "JiraRemoteLinkedIssueError"
};
$e602875ba3d951d6$var$node.hash = "4b0b11002505554c4dfc4885dad1c880";
var $e602875ba3d951d6$export$2e2bcd8739ae039 = $e602875ba3d951d6$var$node;

});

parcelRegister("gPQL9", function(module, exports) {
$parcel$export(module.exports, "trackOrLogClientError", () => $10ba3674ae190436$export$2fc29872103bf255);

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $dMM78 = parcelRequire("dMM78");
const $10ba3674ae190436$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $10ba3674ae190436$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $dMM78.isClientFetchError)(error)) $10ba3674ae190436$export$c392d6295c0a29c7(location, message, error);
    else (0, $eSnSE.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("244Ix", function(module, exports) {
$parcel$export(module.exports, "default", () => $981ba3ecf8731a91$export$2e2bcd8739ae039);
/**
    This function is in order to encapsulate the behavior of the AppLinksUtils functionality

    AppLinksUtils is an Atlassian Plugin.

    AppLinks repository: https://bitbucket.org/atlassian/application-links
 */ /**
    The following function implements the same interface as the [OAuthCallback object](https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-plugin/src/main/resources/applinks/internal/feature/oauth/oauth-callback.js?at=master)

    It creates the object, assigns the object to a global variable in window and calls the plugin in a new window

    Once the Authentication dance is perform, the opened window will call success or failure callbacks from the window.opener.oauthCallback (https://bitbucket.org/atlassian/application-links/src/02de9b212e57ff72a3a44744ed6cabc5ff359874/applinks-oauth-plugin/src/main/resources/com/atlassian/applinks/oauth/auth/oauth-dance.js?at=master)
 */ const $981ba3ecf8731a91$var$authenticateUsingAppLinks = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.oauthCallback) // preventing opening more than one authentication at the time.
    return null;
    const result = new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reject)=>{
        let oauthWindow;
        let timer;
        let isPending = true;
        const oauthCallback = {
            success: ()=>{
                clearInterval(timer);
                // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                resolve();
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            },
            failure: ()=>{
                clearInterval(timer);
                reject(Error('Failed to authenticate with applinks'));
                isPending = false;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                oauthWindow && oauthWindow.close();
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.oauthCallback = oauthCallback;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
        timer = setInterval(()=>{
            if (oauthWindow && oauthWindow.closed && isPending) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                delete window.oauthCallback;
                reject(Error('Failed to authenticate with applinks'));
                clearInterval(timer);
            }
        }, 500);
    });
    return result;
};
var $981ba3ecf8731a91$export$2e2bcd8739ae039 = $981ba3ecf8731a91$var$authenticateUsingAppLinks;

});

parcelRegister("j9Qlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf380362dad6239$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5cf380362dad6239$var$messages = (0, $7qGN1.defineMessages)({
    remoteLinkGeneralErrorIssueTermRefresh: {
        "id": "issues.issue-links.remote-issue-link-error.general-error-issue-term-refresh",
        "defaultMessage": "Failed to load work item"
    },
    remoteLinkGeneralError: {
        "id": "issues.issue-links.remote-issue-link-error.general-error",
        "defaultMessage": "Failed to load remote issue"
    },
    // Copy for linked work items error row
    linkedWorkItemAuthRequiredCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-auth-required.cta",
        "defaultMessage": "Authenticate"
    },
    // Combined text + CTA with placeholder for proper spacing/i18n handling
    linkedWorkItemAuthRequiredWithCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-auth-required.with-cta",
        "defaultMessage": "This linked work item belongs to a separate Jira site that's not authenticated. {cta}"
    },
    linkedWorkItemMissingApplinkCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-missing-applink.cta",
        "defaultMessage": "Go to Project settings to link"
    },
    // Combined text + CTA with placeholder for proper spacing/i18n handling
    linkedWorkItemMissingApplinkWithCta: {
        "id": "native-issue-table.remote-issue-error.linked-work-item-missing-applink.with-cta",
        "defaultMessage": "This linked work item belongs to a separate Jira site that\u2019s not linked. {cta}"
    }
});
var $5cf380362dad6239$export$2e2bcd8739ae039 = $5cf380362dad6239$var$messages;

});


parcelRegister("c3pb3", function(module, exports) {
$parcel$export(module.exports, "IssueRow", () => $da6c3c43cb5f64c3$export$29013dcb6d1b879d);

var $lxfhZ = parcelRequire("lxfhZ");

var $gagun = parcelRequire("gagun");

var $i99Df = parcelRequire("i99Df");

var $cxdNb = parcelRequire("cxdNb");

var $eJOHy = parcelRequire("eJOHy");

var $buoPQ = parcelRequire("buoPQ");

var $12DRg = parcelRequire("12DRg");

var $5PQOA = parcelRequire("5PQOA");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $2QZBX = parcelRequire("2QZBX");

var $j8Km1 = parcelRequire("j8Km1");

var $cxKOj = parcelRequire("cxKOj");

var $ftN6c = parcelRequire("ftN6c");

var $7n9BS = parcelRequire("7n9BS");

var $8jOO7 = parcelRequire("8jOO7");

var $kJbAU = parcelRequire("kJbAU");

var $auNiK = parcelRequire("auNiK");

var $1iVG2 = parcelRequire("1iVG2");

var $lqvgs = parcelRequire("lqvgs");

var $9ZBXb = parcelRequire("9ZBXb");

var $1pe67 = parcelRequire("1pe67");

var $g3S5f = parcelRequire("g3S5f");

var $wJcwZ = parcelRequire("wJcwZ");

var $40Xgt = parcelRequire("40Xgt");

var $dQN02 = parcelRequire("dQN02");

var $l17Xm = parcelRequire("l17Xm");

var $avymT = parcelRequire("avymT");

var $4mhLJ = parcelRequire("4mhLJ");

var $crxno = parcelRequire("crxno");

var $kHiWE = parcelRequire("kHiWE");

var $2Oa4s = parcelRequire("2Oa4s");

var $dBL3m = parcelRequire("dBL3m");

var $5eN53 = parcelRequire("5eN53");

var $aa1Tw = parcelRequire("aa1Tw");

var $arQXy = parcelRequire("arQXy");

var $69Ju5 = parcelRequire("69Ju5");

var $fqa5Z = parcelRequire("fqa5Z");

var $jG8is = parcelRequire("jG8is");

var $acnWs = parcelRequire("acnWs");

var $fjuAd = parcelRequire("fjuAd");

var $1LuaS = parcelRequire("1LuaS");

var $h0Klc = parcelRequire("h0Klc");

var $8lV7c = parcelRequire("8lV7c");

var $iCclW = parcelRequire("iCclW");

var $fr65p = parcelRequire("fr65p");

var $5U6Sf = parcelRequire("5U6Sf");

var $36qKB = parcelRequire("36qKB");

var $j5nH8 = parcelRequire("j5nH8");

var $fAn1n = parcelRequire("fAn1n");

var $gfFaI = parcelRequire("gfFaI");

var $48WLd = parcelRequire("48WLd");

var $aqqsA = parcelRequire("aqqsA");

var $fj3ot = parcelRequire("fj3ot");

var $g6JiP = parcelRequire("g6JiP");

var $bKlUQ = parcelRequire("bKlUQ");

var $P01So = parcelRequire("P01So");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");

var $9wlkB = parcelRequire("9wlkB");

var $4UEvW = parcelRequire("4UEvW");

var $81JsW = parcelRequire("81JsW");

var $jT7JX = parcelRequire("jT7JX");

var $100iH = parcelRequire("100iH");

var $01wyE = parcelRequire("01wyE");

var $9FoLd = parcelRequire("9FoLd");

var $ajiOP = parcelRequire("ajiOP");

var $jQO5F = parcelRequire("jQO5F");

var $cOqgG = parcelRequire("cOqgG");

var $gToWi = parcelRequire("gToWi");

var $4XMye = parcelRequire("4XMye");

var $69bTC = parcelRequire("69bTC");
const $da6c3c43cb5f64c3$export$cc10a6916fdb60c = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((typename, createAnalyticsEvent)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'tableCellUnhandledGraphQLType',
            packageName: (0, $8jOO7.PACKAGE_NAME),
            teamName: (0, $8jOO7.TEAM_NAME)
        },
        error: new Error(`Unhandled GraphQL type ${typename} when trying to render issue field.`),
        event: createAnalyticsEvent({}),
        attributes: {
            typename: typename
        }
    });
});
const $da6c3c43cb5f64c3$export$b1e360b45a7ed518 = ({ project: project, issueEdge: issueEdge, fieldSets: fieldSets, cellBorder: cellBorder, beforeFirstCell: beforeFirstCell, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, rowIndex: rowIndex, triggerProps: triggerProps, isFormVisible: isFormVisible, isStickyColumnsVisible: isStickyColumnsVisible, formattingRules: formattingRules })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    // State for managing merged cell focus
    const [isMergedCellFocused, setIsMergedCellFocused] = (0, $eJOHy.useState)(false);
    const projectRef = (0, $j4oe4.useFragment)((0, $cxdNb.default), project);
    const formattingRulesRef = (0, $j4oe4.useFragment)((0, $i99Df.default), formattingRules);
    const issueEdgeData = (0, $j4oe4.useFragment)((0, $gagun.default), issueEdge);
    const issueData = issueEdgeData?.node;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $lxfhZ.default), fieldSets);
    // eslint-disable-next-line no-nested-ternary
    const colorForId = (0, $4cTDP.fg)('jira_list_conditional_formatting') ? (0, $4cTDP.fg)('saved_list_view_technical_changes') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jQO5F.useCellsConditionalFormatting)(null, fieldSetsData, formattingRulesRef) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jQO5F.useCellsConditionalFormatting)(projectRef, fieldSetsData) : {}; // placeholder for what will soon be const color = ...
    const isCreateSubTaskAllowed = issueData && issueData.issueTypeField?.issueType?.hierarchy?.level === 0;
    const { columns: columns, tableInjectedProps: tableInjectedProps, groupConnectionId: groupConnectionId, groupId: groupId, resizingColumnIndex: resizingColumnIndex } = (0, $jNv5I.useRowContext)();
    const columnConfigByIdMap = (0, $eJOHy.useMemo)(()=>{
        const result = new Map();
        columns.forEach((columnConfig)=>{
            result.set(columnConfig.id, columnConfig);
        });
        return result;
    }, [
        columns
    ]);
    const onFocusHandler = (0, $eJOHy.useCallback)(()=>setIsMergedCellFocused(true), []);
    const onBlurHandler = (0, $eJOHy.useCallback)((e)=>{
        if (!(0, $4cTDP.fg)('fix_mergedcell_action_button_keyboard_nav')) {
            setIsMergedCellFocused(false);
            return;
        }
        const currentTarget = e.currentTarget;
        const relatedTarget = e.relatedTarget;
        if (!relatedTarget || !(relatedTarget instanceof Node) || !currentTarget.contains(relatedTarget)) setIsMergedCellFocused(false);
    }, []);
    const isIssueHierarchyEnabled = (0, $34oCh.useIsIssueHierarchyEnabled)();
    let handleStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('jsc_list_hide_done_items') && !(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    handleStatusUpdate = (0, $jT7JX.useHideDoneItems)({
        itemsConnectionId: itemsConnectionId,
        recordId: issueData?.__id,
        projectKey: issueData?.key && (0, $P01So.getProjectKeyFromIssueKey)(issueData.key),
        groupConnectionId: groupConnectionId
    });
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const handleUpdateCacheNew = (0, $eJOHy.useCallback)((issueKey, fieldName, field)=>{
        tableInjectedProps.onUpdateCache?.(issueKey, fieldName, field);
        handleStatusUpdate(field);
    }, [
        handleStatusUpdate,
        tableInjectedProps
    ]);
    const handleUpdateCache = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jsc_list_hide_done_items') && !(0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? handleUpdateCacheNew : tableInjectedProps.onUpdateCache;
    const isIssueOperationMeatballMenuEnabled = (0, $34oCh.useIsIssueOperationMeatballMenuEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const fieldElementByIdMap = (0, $eJOHy.useMemo)(()=>{
        // Map all issue fields into their respective cell type keyed by fieldSetId. This will be used as a lookup when
        // mapping table columns in the row.
        const result = new Map();
        if (isIssueHierarchyEnabled && issueEdgeData && !(isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate'))) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gToWi.default), {
                isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                itemsConnectionId: itemsConnectionId,
                depth: depth,
                issueRef: issueEdgeData,
                triggerProps: triggerProps,
                isFormVisible: isFormVisible
            });
            result.set((0, $8jOO7.COLUMN_ID_EXPAND_BUTTON), {
                cellElement: element,
                spacing: $da6c3c43cb5f64c3$var$noSpacingStyles
            });
        }
        if (issueEdgeData && isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')) {
            const { issueTypeField: issueTypeField, issueKeyField: issueKeyField, summaryField: summaryField, fieldId: fieldId } = (0, $69bTC.getMergedFields)(fieldSetsData);
            const isHierarchyEnabled = isIssueHierarchyEnabled;
            if (isHierarchyEnabled || issueTypeField || issueKeyField || summaryField) {
                const mergedColumns = columns.find(({ id: id })=>id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns?.map(({ id: id })=>id) ?? [];
                const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XMye.MergedCell), {
                    key: (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
                    itemsConnectionId: itemsConnectionId,
                    depth: depth,
                    issueRef: issueEdgeData,
                    isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                    isCreateChildFormVisible: isFormVisible,
                    createChildTriggerProps: triggerProps,
                    groupId: groupId,
                    isHierarchyEnabled: isHierarchyEnabled,
                    ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') && {
                        isFocused: isMergedCellFocused
                    },
                    renderContent: ({ actionButtons: actionButtons, isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueTypeField && mergedColumns.includes('issuetype') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                            xcss: isHierarchyEnabled ? $da6c3c43cb5f64c3$var$typeCellStyles : $da6c3c43cb5f64c3$var$typeCellNoHierarchyStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $69Ju5.IssueTypeCell), {
                            fieldRef: issueTypeField
                        })), issueKeyField && mergedColumns.includes('issuekey') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHiWE.IssueKeyCell), {
                            fieldRef: issueKeyField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected,
                            isRowHoveredOrSelected: (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? Boolean(isRowHoveredOrSelected) : undefined,
                            isTruncated: Boolean(summaryField) === false
                        }), !summaryField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                            xcss: $da6c3c43cb5f64c3$var$childCreateButtonStyle
                        }, actionButtons), summaryField && mergedColumns.includes('summary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $arQXy.IssueSummaryCell), {
                            fieldRef: summaryField,
                            issueRef: issueData,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected,
                            isRowHoveredOrSelected: Boolean(isRowHoveredOrSelected),
                            readViewHighlightOnHover: false,
                            ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') && {
                                isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered
                            }
                        }, actionButtons))
                });
                result.set((0, $j8Km1.COLUMN_ID_MERGED_COLUMN), {
                    cellElement: element,
                    spacing: $da6c3c43cb5f64c3$var$noSpacingStyles,
                    multipleFieldLayoutAdjustment: true,
                    columnIds: mergedColumns,
                    ...fieldId ? {
                        fieldId: fieldId
                    } : {}
                });
            }
        }
        fieldSetsData?.edges?.map((edge)=>edge?.node).filter((0, $P01So.isNonNullish)).forEach((fieldSet)=>{
            // @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
            const columnConfig = columnConfigByIdMap.get(fieldSet.fieldSetId);
            if (!fieldSet.fieldSetId || !columnConfig) return;
            const projectKey = (0, $P01So.getProjectKeyFromIssueKey)(issueData.key);
            // Handle Collapsed Fields on a single issue (rare) by simply rendering a node for each field.
            const fieldElements = [];
            // Allow td spacing to be configured for the given field type
            let spacing;
            // Stop gap fix to wrap inline editable field elements in styled containers when there are multiple
            // fields within a single cell. This is necessary as inline editable fields have min-height: 100% by
            // default.
            // TODO JSC-1783 This approach will need to be revised as part of single row height once we gather data
            //  on prevalence of this edge case.
            let multipleFieldLayoutAdjustment;
            let fieldId;
            const hasDuplicates = (fieldSet.fields?.totalCount ?? 1) > 1;
            fieldSet.fields?.edges?.forEach((fieldEdge, count)=>{
                // True if it is the first occuring cell
                const isFirstField = count === 0;
                if ((0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) fieldId = fieldEdge?.node?.id;
                switch(fieldEdge?.node?.__typename){
                    case 'JiraAffectedServicesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJbAU.AffectedServicesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCascadingSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wJcwZ.CascadingSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraCMDBField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pe67.CmdbObjectsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraCheckboxesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ZBXb.CheckboxSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraComponentsField':
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3S5f.ComponentsInlineEditCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm,
                            projectKey: projectKey
                        }));
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraTimelineField':
                        if (isTimelineEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $01wyE.TimelineCellRenderer), {
                                key: fieldEdge.node.fieldId,
                                depth: depth,
                                groupId: groupId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDatePickerField':
                        if (isInlineEditingExtendedFieldSupportEnabled) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40Xgt.DateInlineEditCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40Xgt.DateCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            if (fieldEdge.node.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE) spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraDateTimePickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQN02.DateTimeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraEpicLinkField':
                        // This field is deprecated; this field will show text "Replaced by Parent field" as content
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l17Xm.EpicLinkCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraFallbackField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avymT.FallbackCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        break;
                    case 'JiraIssueTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $69Ju5.IssueTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraLabelsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqa5Z.LabelsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jG8is.MultiSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        // This field is not treated with single line row height since the read view
                        // is using <AvatarGroup> component from @atlaskit/avatar-group. Until this component is modified,
                        // or rebuilt, right truncation will not be applied.
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $acnWs.MultiUserPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleGroupPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $100iH.MultiGroupPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        break;
                    case 'JiraNumberField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1LuaS.NumberCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraParentIssueField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lV7c.ParentCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            fieldType: fieldEdge.node.type
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraPriorityField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fr65p.PriorityCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraProjectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5U6Sf.ProjectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isRequired: fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).PROJECT
                        }));
                        break;
                    case 'JiraResolutionField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fAn1n.ResolutionCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraRichTextField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfFaI.RichTextCell), {
                            issueKey: issueData.key,
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueRef: issueData,
                            isFirstField: isFirstField
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSingleLineTextField':
                        if (fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHiWE.IssueKeyCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                isRowHoveredOrSelected: (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? Boolean(isRowHoveredOrSelected) : undefined,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        } else if (fieldEdge.node.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $arQXy.IssueSummaryCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                issueRef: issueData,
                                onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        } else {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCclW.PlainTextCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node,
                                isFirstField: isFirstField,
                                hasDuplicates: hasDuplicates
                            }));
                            multipleFieldLayoutAdjustment = true;
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    case 'JiraSingleSelectUserPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g6JiP.UserCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            projectKey: projectKey,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSingleSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48WLd.SingleSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraSprintField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqqsA.SprintCell), {
                            key: fieldEdge.node.fieldId,
                            projectKey: (0, $2QZBX.toProjectKey)(projectKey),
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            jqlTerm: columnConfig.jqlTerm
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraStatusCategoryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eN53.IssueStatusCategoryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraStatusField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aa1Tw.IssueStatusCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueKey: issueData.key,
                            issueId: issueData.issueId,
                            onUpdateCache: handleUpdateCache,
                            recordId: issueData?.__id,
                            itemsConnectionId: itemsConnectionId,
                            groupConnectionId: groupConnectionId,
                            ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
                                isColumnSticky: columnConfig?.isColumnSticky
                            }
                        }));
                        break;
                    case 'JiraServiceManagementRequestTypeField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5nH8.RequestTypeCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraTeamViewField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fj3ot.TeamCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraIssueLinkField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Oa4s.IssueLinksCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueSearchBaseUrl: tableInjectedProps.issueSearchBaseUrl,
                            issueKey: issueData.key
                        }));
                        break;
                    case 'JiraCommentSummaryField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wlkB.CommentSummaryCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            issueKey: issueData.key,
                            onIssueLinkSelected: tableInjectedProps.onIssueLinkSelected
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        break;
                    case 'JiraUrlField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4UEvW.UrlCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraOriginalTimeEstimateField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h0Klc.OriginalEstimateCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraRadioSelectField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $36qKB.RadioSelectCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraMultipleVersionPickerField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $81JsW.MultiVersionPickerCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node,
                            isFirstField: isFirstField,
                            hasDuplicates: hasDuplicates
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraGoalsField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $crxno.GoalsCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraTownsquareProjectField':
                        if ((0, $cxKOj.expValEquals)('atlassian_projects_-_native_integration', 'cohort', 'variation', 'control')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $auNiK.AtlasProjectCell), {
                                key: fieldEdge.node.fieldId,
                                fieldRef: fieldEdge.node
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                            multipleFieldLayoutAdjustment = true;
                        }
                        break;
                    case 'JiraConfluenceRemoteIssueLinksField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjuAd.ConfluencePagesCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        multipleFieldLayoutAdjustment = true;
                        break;
                    case 'JiraFlagField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4mhLJ.FlagCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraWatchesField':
                        fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9FoLd.WatchersCell), {
                            key: fieldEdge.node.fieldId,
                            fieldRef: fieldEdge.node
                        }));
                        break;
                    case 'JiraIssueLinkRelationshipTypeField':
                        if ((0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) {
                            fieldElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajiOP.LinkRelationshipTypeCell), {
                                key: fieldEdge.node.fieldId,
                                issueRef: issueData,
                                fieldRef: fieldEdge.node,
                                onIssueUnlink: tableInjectedProps.onIssueDelete,
                                issueStoreId: issueData?.__id,
                                itemsConnectionId: itemsConnectionId
                            }));
                            spacing = $da6c3c43cb5f64c3$var$noSpacingStyles;
                        }
                        break;
                    default:
                        if (fieldEdge?.node?.__typename) $da6c3c43cb5f64c3$export$cc10a6916fdb60c(fieldEdge?.node?.__typename, createAnalyticsEvent);
                        break;
                }
            });
            if (fieldElements.length) result.set(fieldSet.fieldSetId, {
                cellElement: fieldElements,
                spacing: spacing,
                multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment,
                ...fieldId ? {
                    fieldId: fieldId
                } : {}
            });
        });
        // Always include the Issue Operations meatball menu cell.
        // But show it empty if isIssueOperationMeatballMenuEnabled is false
        result.set((0, $8jOO7.COLUMN_ID_MEATBALL_MENU), {
            cellElement: isIssueOperationMeatballMenuEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBL3m.IssueOperations), {
                key: (0, $8jOO7.COLUMN_ID_MEATBALL_MENU),
                workType: issueData?.issueTypeField?.issueType?.name,
                issueId: Number(issueData.issueId),
                issueKey: issueData.key,
                onIssueRefetch: tableInjectedProps.onIssueRefetch,
                onIssueDelete: tableInjectedProps.onIssueDelete,
                isCreateSubTaskAllowed: isCreateSubTaskAllowed
            })
        });
        result.set((0, $8jOO7.COLUMN_ID_CHECKBOX), {
            cellElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqvgs.CheckboxCell), {
                issueId: issueData.issueId,
                rowIndex: rowIndex,
                ...(0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) && {
                    depth: depth
                }
            })
        });
        return result;
    }, [
        isIssueHierarchyEnabled,
        issueEdgeData,
        isMergedColumnEnabled,
        fieldSetsData,
        isIssueOperationMeatballMenuEnabled,
        issueData,
        tableInjectedProps.onIssueRefetch,
        tableInjectedProps.onIssueDelete,
        tableInjectedProps.onIssueLinkSelected,
        tableInjectedProps.issueSearchBaseUrl,
        isCreateSubTaskAllowed,
        rowIndex,
        isRowHoveredOrSelected,
        itemsConnectionId,
        depth,
        triggerProps,
        isFormVisible,
        groupId,
        columnConfigByIdMap,
        isTimelineEnabled,
        isInlineEditingExtendedFieldSupportEnabled,
        handleUpdateCache,
        createAnalyticsEvent,
        columns,
        isMergedCellFocused,
        groupConnectionId
    ]);
    const cellBorderWithNoInlineBordersStyles = (0, $eJOHy.useMemo)(()=>{
        if (cellBorder === undefined) return $da6c3c43cb5f64c3$var$noInlineBordersStyles;
        return [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(cellBorder),
            $da6c3c43cb5f64c3$var$noInlineBordersStyles
        ];
    }, [
        cellBorder
    ]);
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isConditionalFormattingEnabled = (0, $34oCh.useIsConditionalFormattingEnabled)();
    let scrollLeft = 0;
    let hasScrolledHorizontally = false;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && !(0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    scrollLeft = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollLeft) || 0;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    hasScrolledHorizontally = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.scrollLeft > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, columns.map(({ id: id, type: type, isPlaceHolderField: isPlaceHolderField, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isLastStickyColumn: isLastStickyColumn }, index)=>{
        const field = fieldElementByIdMap.get(id);
        const columnIds = field?.columnIds; /* when cells are merged, multiple column ids */ 
        const formatting = (()=>{
            if (!(0, $4cTDP.fg)('jira_list_conditional_formatting')) return undefined;
            if (!isConditionalFormattingEnabled) return undefined;
            /* merged cell is 1 column, many fields. check each columnId for the column's rules -> find first rule */ if (columnIds) {
                const rules = columnIds.map((columnId)=>colorForId[columnId]).filter(Boolean);
                if (!rules.length) return undefined;
                const appliedRuleIndex = Math.min(...rules.map(({ index: i })=>i));
                /* find rule with lowest index */ return rules.find(({ index: i })=>appliedRuleIndex === i);
            }
            return colorForId[id];
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: id
        }, // TODO: EM-7165 – Update the extra filler cell logic when refactoring the column picker column
        // Empty cell to fill remainig space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
            border: cellBorderWithNoInlineBordersStyles,
            "aria-hidden": true,
            ...isConditionalFormattingEnabled && {
                formatting: $da6c3c43cb5f64c3$var$formattingStyles,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style: {
                    '--issue-row-bg': formatting?.value,
                    '--issue-row-hover-bg': formatting?.hoverValue
                }
            }
        }), isPlaceHolderField && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1iVG2.LoadingCell), {
            cellBorder: cellBorder,
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets,
                hasRightShadow: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isLastStickyColumn && hasScrolledHorizontally : isLastStickyColumn && scrollLeft > 0
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOqgG.default), {
            type: type,
            beforeElement: index === 0 ? beforeFirstCell : undefined,
            cellElement: field?.cellElement,
            spacing: field?.spacing,
            multipleFieldLayoutAdjustment: field?.multipleFieldLayoutAdjustment,
            border: cellBorder,
            ...isConditionalFormattingEnabled && {
                formatting: (0, $4cTDP.fg)('issue_table_frozen_columns') ? $da6c3c43cb5f64c3$var$formattingStyles : $da6c3c43cb5f64c3$var$formattingStylesOld,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style: {
                    '--issue-row-bg': formatting?.value,
                    '--issue-row-hover-bg': formatting?.hoverValue
                }
            },
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets,
                hasRightShadow: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? isLastStickyColumn && hasScrolledHorizontally : isLastStickyColumn && scrollLeft > 0,
                isColumnResizing: isColumnSticky && (resizingColumnIndex ?? 0) < index && (0, $4cTDP.fg)('issue_table_frozen_columns')
            },
            ...field?.fieldId && {
                fieldId: field.fieldId
            },
            ...id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') && {
                onFocusHandler: onFocusHandler,
                onBlurHandler: onBlurHandler
            }
        }));
    }));
};
const $da6c3c43cb5f64c3$var$noSpacingStyles = (0, $1DXK0.xcss)({
    padding: 'space.0'
});
const $da6c3c43cb5f64c3$var$noInlineBordersStyles = (0, $1DXK0.xcss)({
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '0'
});
const $da6c3c43cb5f64c3$var$formattingStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error XCSS typings don't allow css variables
    backgroundColor: 'var(--issue-row-bg, inherit)',
    ':hover': {
        // @ts-expect-error XCSS typings don't allow css variables
        backgroundColor: 'var(--issue-row-hover-bg, inherit)'
    }
});
const $da6c3c43cb5f64c3$var$formattingStylesOld = (0, $1DXK0.xcss)({
    // @ts-expect-error XCSS typings don't allow css variables
    backgroundColor: 'var(--issue-row-bg)',
    ':hover': {
        // @ts-expect-error XCSS typings don't allow css variables
        backgroundColor: 'var(--issue-row-hover-bg)'
    }
});
const $da6c3c43cb5f64c3$var$typeCellStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.050'
});
const $da6c3c43cb5f64c3$var$typeCellNoHierarchyStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.100'
});
const $da6c3c43cb5f64c3$var$childCreateButtonStyle = (0, $1DXK0.xcss)({
    marginInlineStart: 'auto',
    marginInlineEnd: 'space.100'
});
const $da6c3c43cb5f64c3$export$29013dcb6d1b879d = /*#__PURE__*/ (0, $eJOHy.memo)($da6c3c43cb5f64c3$export$b1e360b45a7ed518);

});
parcelRegister("lxfhZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $838fdadec9c02dc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91c22bfef0147c1d94e611523ace0f19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $838fdadec9c02dc0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "type"
    }, v1 = {
        "kind": "Variable",
        "name": "isInlineEditingEnabled",
        "variableName": "isInlineEditingEnabled"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
        },
        v1 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isEditableSyncLoaded"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isTimelineEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "IssueRow_fieldSets",
        "selections": [
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "useCellsConditionalFormatting"
                    }
                ]
            },
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    },
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "AffectedServicesCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "CascadingSelectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "CmdbObjectsCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "ComponentsCell_ComponentsInlineEditCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "DateInlineEditCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "DateInlineEditCell_DateInlineEditCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "DateTimeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "EpicLinkCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "FallbackCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueKeyCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueStatusCategoryCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueStatusCell"
                                                    },
                                                    {
                                                        "args": v3 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueSummaryCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "LabelsCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueTypeCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "ParentCell"
                                                    },
                                                    {
                                                        "args": v3 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "PriorityCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ProjectCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ResolutionCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "SprintCell"
                                                    },
                                                    {
                                                        "args": v3 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "UserCellInternal"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "PlainTextCellOld"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isDensityFull",
                                                                "variableName": "isDensityFull"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "RichTextCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "RequestTypeCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "IssueLinksCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "NumberCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "CommentSummaryCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "UrlCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "SingleSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "CheckboxSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiUserPickerCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "TeamCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "args": v2 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "OriginalEstimateCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v2 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "OriginalEstimateCell_OriginalEstimateCellNew"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "RadioSelectCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiVersionPickerCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "GoalsCell"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v2 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "AtlasProjectCell"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "ConfluencePagesCell"
                                                    },
                                                    {
                                                        "args": v2 /*: any*/ ,
                                                        "kind": "FragmentSpread",
                                                        "name": "MultiGroupPickerCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "FlagCell"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "WatchersCell"
                                                    },
                                                    {
                                                        "condition": "isLinkRelationshipFieldEnabled",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "args": v3 /*: any*/ ,
                                                                "kind": "FragmentSpread",
                                                                "name": "LinkRelationshipTypeCell_fieldRef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "isTimelineEnabled",
                                                                "variableName": "isTimelineEnabled"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "TimelineCellRenderer"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$838fdadec9c02dc0$var$node.hash = "1a723aacdbbf7f366e4e0e6d9464bb44";
var $838fdadec9c02dc0$export$2e2bcd8739ae039 = $838fdadec9c02dc0$var$node;

});

parcelRegister("gagun", function(module, exports) {
$parcel$export(module.exports, "default", () => $d35b154310d4360b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d8296bdde7a062ba5a542bc4642fbca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d35b154310d4360b$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        },
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
        },
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDensityFull"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLinkRelationshipFieldEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isRemoteLinkedIssuesEnabled"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            }
        ],
        "kind": "Fragment",
        "name": "IssueRowWithFragments_issueEdge",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "FirstColumnCell"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": v0 /*: any*/ ,
                        "kind": "FragmentSpread",
                        "name": "MergedCell"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                            "kind": "LinkedField",
                                            "name": "hierarchy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "level"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "IssueSummaryCell_issue"
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "IssueKeyCell_fields"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isDensityFull",
                                    "variableName": "isDensityFull"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "RichTextCell_issue"
                        },
                        {
                            "condition": "isLinkRelationshipFieldEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "LinkRelationshipTypeCell_issueRef"
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$d35b154310d4360b$var$node.hash = "3bfecaefd0275dc7cffe81ed403403e2";
var $d35b154310d4360b$export$2e2bcd8739ae039 = $d35b154310d4360b$var$node;

});

parcelRegister("i99Df", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aab3ff9e70579d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<215b0940296c014942340277189a073f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7aab3ff9e70579d3$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueRow_rules",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useCellsConditionalFormatting_savedView_rules"
                }
            ]
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$7aab3ff9e70579d3$var$node.hash = "e4507afd0584d23bc2b3f6adb1c45a91";
var $7aab3ff9e70579d3$export$2e2bcd8739ae039 = $7aab3ff9e70579d3$var$node;

});

parcelRegister("cxdNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $f57ab6025ee8f561$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<275dc094b2586e9c667521dd3eebd79e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f57ab6025ee8f561$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueRow",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "useCellsConditionalFormatting_rules"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$f57ab6025ee8f561$var$node.hash = "8bb10e5786d1690e677fdb7b7af7715c";
var $f57ab6025ee8f561$export$2e2bcd8739ae039 = $f57ab6025ee8f561$var$node;

});

parcelRegister("kJbAU", function(module, exports) {
$parcel$export(module.exports, "AffectedServicesCell", () => $158a6dcf4de806f6$export$e6c0da3971931bb1);

var $hY7oK = parcelRequire("hY7oK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $1vkmT = parcelRequire("1vkmT");
const $158a6dcf4de806f6$export$e6c0da3971931bb1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $hY7oK.default), fieldRef);
    const affectedServices = data.selectedAffectedServicesConnection?.edges;
    const filteredAffectedServices = affectedServices?.map((edge)=>edge?.node?.name != null ? {
            key: edge.node.serviceId,
            name: edge.node.name
        } : null).filter((0, $P01So.isNonNullish)) ?? [];
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    if (!affectedServices || affectedServices.length !== filteredAffectedServices.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "affectedServices",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredAffectedServices,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1vkmT.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("hY7oK", function(module, exports) {
$parcel$export(module.exports, "default", () => $56738b5aa71494a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c6a37e015fc2e5292f85a578b495973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56738b5aa71494a6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AffectedServicesCell",
    "selections": [
        {
            "concreteType": "JiraAffectedServiceConnection",
            "kind": "LinkedField",
            "name": "selectedAffectedServicesConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedService",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "serviceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraAffectedServicesField"
};
$56738b5aa71494a6$var$node.hash = "035c17386bbefd01aae50ed77503a32e";
var $56738b5aa71494a6$export$2e2bcd8739ae039 = $56738b5aa71494a6$var$node;

});

parcelRegister("2j0d2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1696def9371c7de3$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $ibVOD = parcelRequire("ibVOD");

var $f8qFy = parcelRequire("f8qFy");
const $1696def9371c7de3$var$ListWithPopup = ({ items: items, ItemComponent: ItemComponent, maxLimit: maxLimit, initialIsOpen: initialIsOpen, isHoverPopoverEnabled: isHoverPopoverEnabled, ...restProps })=>{
    const [firstItem, ...restItems] = items;
    const ShowMorePopupRenderer = (0, $eJOHy.useCallback)(()=>isHoverPopoverEnabled ? /*#__PURE__*/ $eJOHy.createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ $eJOHy.createElement((0, $f8qFy.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        })) : /*#__PURE__*/ $eJOHy.createElement((0, $f8qFy.default), {
            items: restItems,
            maxLimit: maxLimit,
            ItemComponent: ItemComponent,
            initialIsOpen: initialIsOpen,
            isHoverPopoverEnabled: isHoverPopoverEnabled,
            ...restProps
        }), [
        ItemComponent,
        initialIsOpen,
        isHoverPopoverEnabled,
        maxLimit,
        restItems,
        restProps
    ]);
    if (items.length === 0) return null;
    return /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isHoverPopoverEnabled,
        xcss: isHoverPopoverEnabled && $1696def9371c7de3$var$hoverPopoverStyles
    }, /*#__PURE__*/ $eJOHy.createElement(ItemComponent, {
        ...firstItem,
        isHoverPopoverEnabled: isHoverPopoverEnabled,
        className: (0, $hcewu.default)([
            isHoverPopoverEnabled && "_1ul9ze3t"
        ])
    }), restItems.length >= 1 && ShowMorePopupRenderer());
};
const $1696def9371c7de3$var$hoverPopoverStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.050',
    width: '100%'
});
const $1696def9371c7de3$var$hoverPopoverItemStyles = null;
var $1696def9371c7de3$export$2e2bcd8739ae039 = $1696def9371c7de3$var$ListWithPopup;

});
parcelRegister("f8qFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4966e4da02c2cf85$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4B7rn = parcelRequire("4B7rn");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");
const $4966e4da02c2cf85$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, items: items, ItemComponent: ItemComponent, PopupContentWrapper: PopupContentWrapper = (0, $eJOHy.Fragment), maxLimit: maxLimit = 99, OverrideContentComponent: OverrideContentComponent, initialIsOpen: initialIsOpen = false, isHoverPopoverEnabled: isHoverPopoverEnabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialIsOpen);
    const list = items.slice(0, maxLimit);
    const content = (0, $eJOHy.useCallback)(()=>list.map(({ key: key, ...item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ItemComponent, item))), [
        ItemComponent,
        list
    ]);
    if (items.length === 0) return null;
    const onClickTrigger = ()=>{
        setIsOpen(!isOpen);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'listWithPopup');
    };
    const contentWithWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: [
                $4966e4da02c2cf85$var$ContainerDialogStyles,
                $4966e4da02c2cf85$var$ContainerDialogBorderStyles
            ]
        }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
    if (isHoverPopoverEnabled) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hoverPopoverContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $4966e4da02c2cf85$var$HoverPopoverContainerDialogStyles
            }, OverrideContentComponent === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PopupContentWrapper, null, content()) : OverrideContentComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null)), [
            OverrideContentComponent,
            PopupContentWrapper,
            content
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: hoverPopoverContent,
                isInteractive: true
            }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    isSelected: isOpen,
                    spacing: "none",
                    testId: "list-with-popup.ui.show-more-popup.items-count",
                    "aria-expanded": ariaExpanded,
                    ref: ref,
                    ...props
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4966e4da02c2cf85$var$ItemsCount, null, "+", list.length))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom",
        content: contentWithWrapper,
        testId: "list-with-popup.ui.show-more-popup",
        messageId: "list-with-popup.ui.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $4966e4da02c2cf85$var$TooltipContainer,
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                testId: "list-with-popup.ui.show-more-popup.items-count"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4966e4da02c2cf85$var$ItemsCount, null, "+", list.length)))
    });
};
const $4966e4da02c2cf85$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $4966e4da02c2cf85$var$tooltipContainerStyles
    }));
const $4966e4da02c2cf85$var$ContainerDialogStyles = (0, $1DXK0.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100'
});
const $4966e4da02c2cf85$var$HoverPopoverContainerDialogStyles = (0, $1DXK0.xcss)({
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.050'
});
const $4966e4da02c2cf85$var$ContainerDialogBorderStyles = (0, $1DXK0.xcss)({
    border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
});
const $4966e4da02c2cf85$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4966e4da02c2cf85$var$ItemsCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _k48pi7a9 _vwz4v47k",
            __cmplp.className
        ])
    });
});
var $4966e4da02c2cf85$export$2e2bcd8739ae039 = $4966e4da02c2cf85$var$ShowMorePopup;

});


parcelRegister("86BUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ceecc2739c875115$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $9pTd3 = parcelRequire("9pTd3");

var $d8UFE = parcelRequire("d8UFE");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $80M6O = parcelRequire("80M6O");
const $ceecc2739c875115$var$fireAnalyticsCache = {};
const $ceecc2739c875115$var$fireAnalyticsDebouncedByCellType = (cellType, reason, event)=>{
    if (!(cellType in $ceecc2739c875115$var$fireAnalyticsCache)) $ceecc2739c875115$var$fireAnalyticsCache[cellType] = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))($ceecc2739c875115$var$fireAnalytics);
    $ceecc2739c875115$var$fireAnalyticsCache[cellType](cellType, reason, event);
};
const $ceecc2739c875115$var$fireAnalytics = (cellType, reason, event)=>{
    const options = reason instanceof Error ? {
        cause: reason
    } : undefined;
    const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`, options);
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'errorCell',
            packageName: (0, $8jOO7.PACKAGE_NAME),
            teamName: (0, $8jOO7.TEAM_NAME)
        },
        error: error,
        event: event,
        attributes: {
            cellType: cellType
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // Clean up debounced function after flush
    delete $ceecc2739c875115$var$fireAnalyticsCache[cellType];
};
const $ceecc2739c875115$var$ErrorCell = ({ cellType: cellType, reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovered(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovered(false), []);
    const iconColor = isHovered ? "var(--ds-icon, #44546F)" : "var(--ds-icon-subtle, #626F86)";
    const message = formatMessage((0, $80M6O.default).tooltip);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('empanada_error_cell_logging')) return;
        const timerId = setTimeout(()=>$ceecc2739c875115$var$fireAnalyticsDebouncedByCellType(cellType, reason, createAnalyticsEvent({})));
        // Cancel any pending events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>clearTimeout(timerId);
    // Only fire on mount
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('empanada_error_cell_logging')) return;
        const sendAnalytics = ()=>{
            const error = new Error(`Failed to render cell data for the ${cellType} cell type. Reason: ${reason}`);
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'errorCell',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error,
                event: createAnalyticsEvent({}),
                attributes: {
                    cellType: cellType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const sendAnalyticsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(sendAnalytics);
        sendAnalyticsDebounced();
        // Cancel any debounced events on unmount. This prevents sending an error event when the cell was mounted
        // due to an intermediary render. We've observed this when new columns are committed to the Relay store
        // in a separate render before issue field sets are aligned.
        return ()=>{
            sendAnalyticsDebounced.cancel();
        };
    // Only fire on mount
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const cellContent = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "native-issue-table.common.error-cell.tooltip-target",
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseEnter: onMouseEnter,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
            color: iconColor,
            label: message,
            spacing: "spacious"
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message,
        position: "bottom-start"
    }, cellContent());
};
var $ceecc2739c875115$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($ceecc2739c875115$var$ErrorCell);

});
parcelRegister("80M6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $83096c771fe45e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $83096c771fe45e4d$var$messages = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "native-issue-table.common.error-cell.tooltip",
        "defaultMessage": "We couldn\u2019t load this field\u2019s details. Refresh and try again."
    }
});
var $83096c771fe45e4d$export$2e2bcd8739ae039 = $83096c771fe45e4d$var$messages;

});


parcelRegister("1vkmT", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf4715a793d93265$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bf4715a793d93265$var$messages = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.affected-services.trigger-button",
        "defaultMessage": "See more affected services"
    }
});
var $bf4715a793d93265$export$2e2bcd8739ae039 = $bf4715a793d93265$var$messages;

});


parcelRegister("auNiK", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectCell", () => $dbc1d58f57ea4eb3$export$7333563cf8787197);

var $fd34G = parcelRequire("fd34G");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bthRw = parcelRequire("bthRw");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $dbc1d58f57ea4eb3$export$7333563cf8787197 = ({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $fd34G.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = isInlineEditingExtendedFieldSupportEnabled && 'lazyIsEditableInIssueView' in data && data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bthRw.AtlasProjectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: !!isEditable,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        popupPlacement: "bottom-start"
    });
};

});
parcelRegister("fd34G", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d4013d544c52d91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d77fcd05d7a2eced9a8437e774adc766>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d4013d544c52d91$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "AtlasProjectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTownsquareProjectField"
};
$5d4013d544c52d91$var$node.hash = "1fb64e8e716aa47668f59a4da7d571a6";
var $5d4013d544c52d91$export$2e2bcd8739ae039 = $5d4013d544c52d91$var$node;

});

parcelRegister("bthRw", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectInlineEditViewWithIsEditable", () => $24b675dda3555a96$export$95490dcdca861bf1);
$parcel$export(module.exports, "AtlasProjectInlineEditView", () => $24b675dda3555a96$export$2bbd2b55549b58de);

var $8FuB6 = parcelRequire("8FuB6");

var $9bzjj = parcelRequire("9bzjj");

var $1X6Ul = parcelRequire("1X6Ul");

var $i1y1q = parcelRequire("i1y1q");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $956it = parcelRequire("956it");

var $4EKqI = parcelRequire("4EKqI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $kqd31 = parcelRequire("kqd31");

var $cSXp8 = parcelRequire("cSXp8");

var $ftN6c = parcelRequire("ftN6c");

var $g9Vr6 = parcelRequire("g9Vr6");

var $9McQo = parcelRequire("9McQo");

var $47YLd = parcelRequire("47YLd");

var $cHtIB = parcelRequire("cHtIB");

var $bJscI = parcelRequire("bJscI");

var $auNLL = parcelRequire("auNLL");

var $lRq8t = parcelRequire("lRq8t");

var $jXGTZ = parcelRequire("jXGTZ");

var $ebGhx = parcelRequire("ebGhx");


var $5mlwW = parcelRequire("5mlwW");

var $8htSu = parcelRequire("8htSu");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $24b675dda3555a96$var$isEqualOption = (a, b)=>a?.id === b?.id;
const $24b675dda3555a96$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-atlas-project-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $24b675dda3555a96$export$95490dcdca861bf1 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, popupPlacement: popupPlacement = 'bottom-end', spacing: spacing = 'compact' })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $i1y1q.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commitLinkMutation] = (0, $j4oe4.useMutation)((0, $1X6Ul.default));
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commitUnlinkMutation] = (0, $j4oe4.useMutation)((0, $9bzjj.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, type: fieldType, project: project, issue: issue, isLinkEditable: isLinkEditable } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>project ? {
            id: project.id,
            name: project.atlasProjectName ?? '',
            key: project.atlasProjectKey ?? '',
            isPrivate: !!project.privateProject
        } : null, [
        project
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const [disableEdit, setDisableEdit] = (0, $eJOHy.useState)(isLinkEditable === false || project?.hasPermission === false || project?.isWorkspaceActive === false);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable && !disableEdit && isLinkEditable !== false), [
        isLinkEditable,
        overrideIsEditable,
        isEditable,
        disableEdit
    ]);
    const handleNoAccess = (0, $eJOHy.useCallback)(()=>{
        setDisableEdit(()=>true);
    }, []);
    // #endregion Common state
    // #region Mutation handlers
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireAtlasProjectAnalyticsEvent: fireAtlasProjectAnalyticsEvent } = (0, $8htSu.useAtlasProjectAnalyticsEvent)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const [showConfirmatonModal, setShowConfirmationModal] = (0, $eJOHy.useState)(false);
    const replaceChildLinks = (0, $eJOHy.useRef)(false);
    const handleMutationError = (0, $eJOHy.useCallback)(({ errorType: errorType, canReplace: canReplace, onFail: onFail, onFireAnalyticsEvent: onFireAnalyticsEvent })=>{
        if (errorType === (0, $jXGTZ.LINK_MUTATION_ERROR_TYPES).CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT) {
            if (canReplace) setShowConfirmationModal(true);
            else {
                showFlag({
                    type: 'error',
                    title: formatMessage((0, $ebGhx.default).childIssueAlreadyLinkedNoReplaceTitle),
                    description: formatMessage((0, $ebGhx.default).childIssueAlreadyLinkedNoReplaceDescription),
                    isAutoDismiss: false,
                    messageId: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: formatMessage((0, $ebGhx.default).childIssueAlreadyLinkedNoReplaceAction),
                            href: (0, $a1452414e695131e$export$228ddfe2e1c9e3bf),
                            target: '_blank'
                        }
                    ]
                });
                // Only fire analytics event if we are not displaying the confirmation modal
                onFireAnalyticsEvent();
            }
            return;
        }
        // Unhandled error scenarios
        onFail();
        onFireAnalyticsEvent();
    }, [
        formatMessage,
        showFlag
    ]);
    const updater = (0, $eJOHy.useCallback)(({ store: store, projectId: projectId, mutation: mutation, value: value })=>{
        const projectDataId = (0, $kqd31.default)({
            id: projectId
        }, 'TownsquareProject');
        const fieldDataId = (0, $kqd31.default)({
            id: uniqueFieldId
        }, 'JiraTownsquareProjectField');
        if (!projectDataId || !fieldDataId) return;
        const fieldRecord = store.get(fieldDataId);
        if (!fieldRecord) return;
        if (mutation === 'link' && value) {
            let projectRecord = store.get(projectDataId);
            if (!projectRecord) projectRecord = store.create(projectDataId, 'TownsquareProject');
            projectRecord.setValue(projectId, 'id');
            projectRecord.setValue(value.name, 'name');
            projectRecord.setValue(value.key, 'key');
            fieldRecord.setLinkedRecord(projectRecord, 'project');
        } else fieldRecord.setValue(null, 'project');
    }, [
        uniqueFieldId
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        // Early return if no change
        if ($24b675dda3555a96$var$isEqualOption(value, initialValue)) return;
        const issueId = issue?.id;
        // If linking, the value.id will be the projectId being linked.
        // If unlinking, the value will be null so we fall back to the currently linked project id.
        const projectId = value?.id || project?.id;
        const shouldReplaceChildLinks = replaceChildLinks.current;
        // Reset replaceChildLinks ref
        replaceChildLinks.current = false;
        // Early return if we don't have the required IDs to call the mutation
        if (!issueId || !projectId) {
            onFail();
            return;
        }
        onSubmit?.(value);
        if (value === null) commitUnlinkMutation({
            variables: {
                input: {
                    workItemId: issueId,
                    projectId: projectId
                }
            },
            onCompleted: (response, graphqlErrors)=>{
                if (graphqlErrors && graphqlErrors.length > 0) {
                    fireAtlasProjectAnalyticsEvent({
                        event: 'operational',
                        action: 'unlinked-failed',
                        analyticsAttributes: {
                            error: graphqlErrors?.[0],
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    onFail();
                    return;
                }
                const mutationResponse = response.projects_removeJiraWorkItemLink;
                if (mutationResponse?.success) {
                    fireAtlasProjectAnalyticsEvent({
                        event: 'track',
                        action: 'unlinked',
                        analyticsAttributes: {
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    onSuccess();
                    return;
                }
                const { errorType: errorType, statusCode: statusCode } = mutationResponse?.errors?.[0]?.extensions || {};
                const errorMessage = mutationResponse?.errors?.[0]?.message || '';
                fireAtlasProjectAnalyticsEvent({
                    event: 'track',
                    action: 'unlinked-failed',
                    analyticsAttributes: {
                        error: {
                            message: errorMessage,
                            errorType: errorType,
                            statusCode: statusCode
                        },
                        projectId: projectId
                    }
                });
                onFail();
            },
            onError: (error)=>{
                fireAtlasProjectAnalyticsEvent({
                    event: 'operational',
                    action: 'unlinked-failed',
                    analyticsAttributes: {
                        error: {
                            message: error.message,
                            stack: error.stack
                        },
                        linkedWorkItemId: issueId,
                        projectId: projectId
                    }
                });
                onFail(error);
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'unlink'
                });
            },
            updater: (store, response)=>{
                // Do not update the store if the mutation was not successful
                if (!response?.projects_removeJiraWorkItemLink?.success) return;
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'unlink'
                });
            }
        });
        else commitLinkMutation({
            variables: {
                input: {
                    workItemId: issueId,
                    projectId: projectId,
                    // This should always be true, as on Jira, users should always be able to replace the project attached to a work item
                    replaceCurrentWorkItemLink: true,
                    replaceChildWorkItemLinks: shouldReplaceChildLinks
                }
            },
            onCompleted: (response, graphqlErrors)=>{
                if (graphqlErrors && graphqlErrors.length > 0) {
                    fireAtlasProjectAnalyticsEvent({
                        event: 'operational',
                        action: 'linked-failed',
                        analyticsAttributes: {
                            error: graphqlErrors?.[0],
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    onFail();
                    return;
                }
                const mutationResponse = response.projects_addJiraWorkItemLink;
                if (mutationResponse?.success) {
                    onSuccess();
                    fireAtlasProjectAnalyticsEvent({
                        event: 'track',
                        action: 'linked',
                        analyticsAttributes: {
                            linkedWorkItemId: issueId,
                            projectId: projectId
                        }
                    });
                    return;
                }
                const { errorType: errorType, statusCode: statusCode, canReplace: canReplace } = mutationResponse?.errors?.[0]?.extensions || {};
                const errorMessage = mutationResponse?.errors?.[0]?.message || '';
                handleMutationError({
                    errorType: errorType,
                    canReplace: canReplace,
                    onFail: onFail,
                    onFireAnalyticsEvent: ()=>{
                        fireAtlasProjectAnalyticsEvent({
                            event: 'track',
                            action: 'linked-failed',
                            analyticsAttributes: {
                                error: {
                                    message: errorMessage,
                                    errorType: errorType,
                                    statusCode: statusCode
                                },
                                projectId: projectId
                            }
                        });
                    }
                });
            },
            onError: (error)=>{
                fireAtlasProjectAnalyticsEvent({
                    event: 'operational',
                    action: 'linked-failed',
                    analyticsAttributes: {
                        error: {
                            message: error.message,
                            stack: error.stack
                        },
                        linkedWorkItemId: issueId,
                        projectId: projectId
                    }
                });
                onFail(error);
            },
            optimisticUpdater: (store)=>{
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'link'
                });
            },
            updater: (store, response)=>{
                // Do not update the store if the mutation was not successful
                if (!response?.projects_addJiraWorkItemLink?.success) return;
                updater({
                    store: store,
                    projectId: projectId,
                    value: value,
                    mutation: 'link'
                });
            }
        });
    }, [
        initialValue,
        issue?.id,
        project?.id,
        onSubmit,
        commitUnlinkMutation,
        fireAtlasProjectAnalyticsEvent,
        updater,
        commitLinkMutation,
        handleMutationError
    ]);
    // #endregion Mutation handlers
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $24b675dda3555a96$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: ()=>{
            // Reset the updated value to the initial value on submit failure to allow the user to make another selection
            setUpdatedValue(initialValue);
            onSubmitFailed?.();
        },
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24b675dda3555a96$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47YLd.AtlasProjectReadView), {
            fragmentRef: data,
            onHandleNoAccess: handleNoAccess,
            showNoAccessTooltip: disableEdit && !!project?.privateProject && !(project?.hasPermission === false || project?.isWorkspaceActive === false)
        }));
    // #endregion
    // #region Edit view
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const editViewEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            onClose: ()=>{
                // This is needed as the project picker needs to stay open even when the edit view loses the focus, which is enabled via keepEditViewOpenOnBlur
                // This is to allow users to interact with the project create form, which will be rendered within the project picker
                // Copied from src/packages/platform/ui/inline-edit-lite/src/ui/use-inline-edit/index.tsx
                handleCancel(createAnalyticsEvent({
                    action: 'canceled',
                    actionSubject: 'inlineEdit'
                }));
            },
            onProjectSelect: handleChangeAndConfirm,
            onProjectUnlink: ()=>handleChangeAndConfirm(null),
            linkedProject: initialValue || undefined,
            isCompact: spacing === 'compact',
            popupProps: {
                placement: popupPlacement
            },
            cloudId: cloudId,
            orgId: orgId,
            product: 'jira',
            emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47YLd.AtlasProjectEmptytView), null)
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $9McQo.projectPickerEntrypoint),
        editViewEntryPointParams: editViewEntryPointParams,
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        // Not invoking handleConfirm here as the value updates are handled via onProjectSelect in getEditViewProps and confirmed with handleChangeAndConfirm
        // This is to ensure that Form submit events from the project picker do not interfere with the inline edit confirm flow
        onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        keepEditViewOpenOnBlur: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, showConfirmatonModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5mlwW.LinkConfirmationModal), {
        onClose: ()=>setShowConfirmationModal(false),
        onLink: ()=>{
            replaceChildLinks.current = true;
            handleConfirm(createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'inlineEdit'
            }));
            setShowConfirmationModal(false);
        }
    })));
};
const $24b675dda3555a96$export$2bbd2b55549b58de = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $8FuB6.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24b675dda3555a96$export$95490dcdca861bf1, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8FuB6", function(module, exports) {
$parcel$export(module.exports, "default", () => $81fd3804d8a70da9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c78edf816bb0e32c61021a0d8a256f02>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81fd3804d8a70da9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTownsquareProjectField"
};
$81fd3804d8a70da9$var$node.hash = "a65462d58befdde3cf6398f90e5e70ca";
var $81fd3804d8a70da9$export$2e2bcd8739ae039 = $81fd3804d8a70da9$var$node;

});

parcelRegister("9bzjj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4c65090cb60fbfa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ae635e0e4634f6ea9cbfc7c6e23cdf0>>
 * @relayHash 545f444aaf5274101b6a492dce4cdb6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b289ca2f1d3807b2db74e7ab190beb6ba0f0e196b16fec755ef4206276a699b4
const $b4c65090cb60fbfa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsRemoveJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_removeJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsRemoveJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_removeJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b289ca2f1d3807b2db74e7ab190beb6ba0f0e196b16fec755ef4206276a699b4",
            "metadata": {},
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b4c65090cb60fbfa$var$node.hash = "81a581954454862ea2506465764ef409";
var $b4c65090cb60fbfa$export$2e2bcd8739ae039 = $b4c65090cb60fbfa$var$node;

});

parcelRegister("1X6Ul", function(module, exports) {
$parcel$export(module.exports, "default", () => $c54e762855f5c79b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<316a004180f3d949fb9cf8ce0ffb97dc>>
 * @relayHash 044e27832145774d49d0d615ef03b9d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 720b4f7aa278046d69b3c13196f405b79dee8a76ea1d4ee85d9345f0c1ff2dce
const $c54e762855f5c79b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canReplace"
            }
        ],
        "type": "TownsquareProjectsChildWorkItemsAlreadyLinkedMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_addJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
                    "kind": "LinkedField",
                    "name": "projects_addJiraWorkItemLink",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "720b4f7aa278046d69b3c13196f405b79dee8a76ea1d4ee85d9345f0c1ff2dce",
            "metadata": {},
            "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c54e762855f5c79b$var$node.hash = "c423f19e22ae55b49c7da9df767fe9b1";
var $c54e762855f5c79b$export$2e2bcd8739ae039 = $c54e762855f5c79b$var$node;

});

parcelRegister("i1y1q", function(module, exports) {
$parcel$export(module.exports, "default", () => $25d059ddda728083$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<449660548732f66d65437a7b6b067e4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25d059ddda728083$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "isLinkEditable"
            },
            {
                "concreteType": "JiraTownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "alias": "atlasProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "alias": "atlasProjectKey",
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "privateProject"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWorkspaceActive"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView"
            }
        ],
        "type": "JiraTownsquareProjectField"
    };
}();
$25d059ddda728083$var$node.hash = "f4f8d3d0048964da5915281582597f79";
var $25d059ddda728083$export$2e2bcd8739ae039 = $25d059ddda728083$var$node;

});

parcelRegister("4s7iN", function(module, exports) {
$parcel$export(module.exports, "useFieldInlineEditActions", () => $d37bf9db13197a19$export$ad535fb3592a66ff);

var $eJOHy = parcelRequire("eJOHy");

var $1IiSl = parcelRequire("1IiSl");

var $d2AGn = parcelRequire("d2AGn");

var $8c3Yt = parcelRequire("8c3Yt");

var $9XwQG = parcelRequire("9XwQG");

var $6jOZV = parcelRequire("6jOZV");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3mxJ5 = parcelRequire("3mxJ5");

var $78Ere = parcelRequire("78Ere");

var $kB1g4 = parcelRequire("kB1g4");

var $aIlUW = parcelRequire("aIlUW");

var $SKIZT = parcelRequire("SKIZT");

var $4cTDP = parcelRequire("4cTDP");
const $d37bf9db13197a19$var$defaultIsEquals = (a, b)=>a === b;
const $d37bf9db13197a19$export$ad535fb3592a66ff = ({ attributes: attributes, fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, initialValue: initialValue, isValueEqual: isValueEqual = $d37bf9db13197a19$var$defaultIsEquals, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onUpdateValue: onUpdateValue, startWithEditViewOpen: startWithEditViewOpen = false, updatedValue: updatedValue, validator: validator, setAnalyticsAttributes: setAnalyticsAttributes, analyticsFieldType: analyticsFieldType, clipboardComponentType: clipboardComponentType, onUnchangedSubmit: onUnchangedSubmit })=>{
    const [isEditing, setIsEditing] = (0, $8c3Yt.useOptionallyControlledEditingState)(startWithEditViewOpen, fieldId, (0, $eJOHy.useMemo)(()=>({
            // Ensure our updatedValue is re-initialised if editing is enabled via an external store update
            onSharedChange: (sharedIsEditing)=>sharedIsEditing && onUpdateValue(initialValue, true)
        }), [
        onUpdateValue,
        initialValue
    ]));
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $SKIZT.useRealTimeComments)();
    const [invalidMessage, { validateChange: validateChange, validateSubmit: validateSubmit, clearValidation: clearValidation }] = (0, $9XwQG.useClientValidationHandler)(validator);
    const [hasServerValidationError, { handleSubmitFailed: handleSubmitFailed, clearServerValidation: clearServerValidation }] = (0, $6jOZV.useServerValidationHandler)(fieldName, setIsEditing, onSubmitFailed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    /** Clear any validation errors and transition to read view. */ const onStopEditing = (0, $eJOHy.useCallback)(()=>{
        clearValidation();
        clearServerValidation();
        setIsEditing(false);
    }, [
        clearServerValidation,
        clearValidation,
        setIsEditing
    ]);
    /** Handler to validate and submit the updated value for a field. */ const handleSubmit = (0, $eJOHy.useCallback)((value, analyticsEvent, event)=>{
        // Early exit if a validation error is present
        if (validateSubmit(value) === 'error') return;
        onStopEditing();
        // Skip mutation if value is unchanged
        if (isValueEqual(initialValue, value)) {
            (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && onUnchangedSubmit?.();
            return;
        }
        onSubmit(value, {
            onSuccess: ()=>{
                // Field updated event is a core action used to track MCU as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'field updated', {
                    ...attributes,
                    fieldKey: fieldId,
                    fieldType: fieldType,
                    isRealTimeCommentUpdated: !!isRealTimeCommentUpdated
                });
                onSubmitSucceeded?.(value);
            },
            onFail: (error, message)=>{
                handleSubmitFailed(error, message);
            }
        }, event);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent);
    }, [
        attributes,
        createAnalyticsEvent,
        fieldId,
        fieldType,
        handleSubmitFailed,
        initialValue,
        isValueEqual,
        onStopEditing,
        onSubmit,
        onSubmitSucceeded,
        validateSubmit,
        isRealTimeCommentUpdated,
        onUnchangedSubmit
    ]);
    /** Exits `editView` and switches back to `readView`. This is called when the cancel action button (x) is clicked. */ const handleCancel = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        onStopEditing();
        onCancel?.();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent);
    }, [
        onCancel,
        onStopEditing
    ]);
    /** Handler called when readView is clicked. */ const handleEdit = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        // Re-initialise the edit view value unless there is a server error, in which case we want to preserve the
        // previous dirty value.
        if (!hasServerValidationError) onUpdateValue(initialValue, true);
        setIsEditing(true);
        onEdit?.();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent);
        const fieldIdWithoutAri = (0, $1IiSl.getFieldIdFromAri)(fieldId);
        const fieldTypeAttribute = analyticsFieldType ?? fieldType;
        if (fieldIdWithoutAri && fieldTypeAttribute) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: fieldTypeAttribute
            }
        });
    }, [
        hasServerValidationError,
        setIsEditing,
        onEdit,
        fieldId,
        fieldType,
        onUpdateValue,
        initialValue,
        createAnalyticsEvent,
        analyticsFieldType
    ]);
    /** Saves and confirms the value entered into the field. It exits `editView` and returns to `readView`. */ const handleConfirm = (0, $eJOHy.useCallback)((analyticsEvent, event)=>{
        handleSubmit(updatedValue, analyticsEvent, event);
    }, [
        handleSubmit,
        updatedValue
    ]);
    /**
	 * Handler called when the `editView` is updated by the user. This will validate the input and call
	 * `onUpdateValue` to update the value in state.
	 */ const handleChange = (0, $eJOHy.useCallback)((value)=>{
        validateChange(value);
        onUpdateValue(value, false);
        setAnalyticsAttributes?.(value);
    }, [
        onUpdateValue,
        setAnalyticsAttributes,
        validateChange
    ]);
    /**
	 * Handler called when the `editView` is updated by the user which will immediately confirm the value and return to
	 * `readView`.
	 *
	 * Note that this **will not** run any `change` validator functions. Consumers should instead define a `submit`
	 * validator function if required.
	 */ const handleChangeAndConfirm = (0, $eJOHy.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: 'inlineEdit'
        });
        onUpdateValue(value, false);
        handleSubmit(value, analyticsEvent);
        setAnalyticsAttributes?.(value);
    }, [
        createAnalyticsEvent,
        handleSubmit,
        onUpdateValue,
        setAnalyticsAttributes
    ]);
    const reportClipboardError = (0, $kB1g4.useClipboardErrorReporting)(fieldName, fieldType);
    /**
	 * Attempt to submit changes to a field in the background (i.e. while remaining in `readView`). If the updated
	 * value fails `change` or `submit` validation then we forcibly switch to `editView` to allow users to correct
	 * their changes.
	 */ const handleBackgroundSubmit = (0, $eJOHy.useCallback)((value)=>{
        if (validateChange(value) === 'error' || validateSubmit(value) === 'error') {
            onUpdateValue(value, false);
            setIsEditing(true);
        } else handleChangeAndConfirm(value);
    }, [
        handleChangeAndConfirm,
        setIsEditing,
        onUpdateValue,
        validateChange,
        validateSubmit
    ]);
    const copyToClipboard = (0, $eJOHy.useMemo)(()=>{
        return clipboardComponentType !== undefined ? (0, $3mxJ5.getOnCopyHandler)(clipboardComponentType, /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialValue) : undefined;
    }, [
        clipboardComponentType,
        initialValue
    ]);
    const handleCopy = (0, $eJOHy.useMemo)(()=>{
        return ()=>{
            if (copyToClipboard) {
                copyToClipboard();
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCopy',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $78Ere.ClipboardValidationError).copyOperationUnsupported());
            return false;
        };
    }, [
        copyToClipboard,
        createAnalyticsEvent,
        reportClipboardError
    ]);
    const handleCut = (0, $eJOHy.useMemo)(()=>{
        return ()=>{
            if (clipboardComponentType !== undefined && copyToClipboard) {
                copyToClipboard();
                if ((0, $aIlUW.isNullableComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit(null);
                else if ((0, $aIlUW.isStringComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit('');
                else if ((0, $aIlUW.isArrayComponentType)(clipboardComponentType)) /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
					 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handleBackgroundSubmit([]);
                else reportClipboardError((0, $78Ere.ClipboardValidationError).cutNonEditableError(clipboardComponentType));
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clipboardCut',
                    actionSubject: 'inlineEdit'
                }));
                // Signal the copy event has been explicitly handled
                return true;
            }
            reportClipboardError((0, $78Ere.ClipboardValidationError).cutOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        copyToClipboard,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    const handlePaste = (0, $eJOHy.useMemo)(()=>{
        if (clipboardComponentType !== undefined) {
            const onPaste = (0, $3mxJ5.getOnPasteHandler)(clipboardComponentType);
            return (e)=>{
                try {
                    const value = onPaste(e);
                    if (value !== undefined) {
                        /* Type assertion is safe in this instance as we have previously asserted that FieldValue is
						 * compatible with ClipboardComponentValue<Type> via ClipboardCompatibleValue. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        handleBackgroundSubmit(value);
                        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                            action: 'clipboardPaste',
                            actionSubject: 'inlineEdit'
                        }));
                        // Signal the paste event has been explicitly handled
                        return true;
                    }
                } catch (error) {
                    reportClipboardError(error instanceof Error ? error : undefined);
                }
                return false;
            };
        }
        return ()=>{
            reportClipboardError((0, $78Ere.ClipboardValidationError).pasteOperationUnsupported());
            return false;
        };
    }, [
        clipboardComponentType,
        createAnalyticsEvent,
        handleBackgroundSubmit,
        reportClipboardError
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleCancel: handleCancel,
            handleEdit: handleEdit,
            handleConfirm: handleConfirm,
            handleChange: handleChange,
            handleChangeAndConfirm: handleChangeAndConfirm,
            hasServerValidationError: hasServerValidationError,
            handleCopy: handleCopy,
            handleCut: handleCut,
            handlePaste: handlePaste,
            invalidMessage: invalidMessage,
            isEditing: isEditing
        }), [
        handleCancel,
        handleChange,
        handleChangeAndConfirm,
        handleConfirm,
        handleEdit,
        handleCopy,
        handleCut,
        handlePaste,
        hasServerValidationError,
        invalidMessage,
        isEditing
    ]);
};

});
parcelRegister("1IiSl", function(module, exports) {
$parcel$export(module.exports, "getFieldIdFromAri", () => $dc5becc3ae3f43e9$export$4ae913a052c0d582);
$parcel$export(module.exports, "getPriorityIdFromAri", () => $dc5becc3ae3f43e9$export$d3f3dc1a70aa9a8);
$parcel$export(module.exports, "getUserIdFromAri", () => $dc5becc3ae3f43e9$export$364d97890ac491af);
const $dc5becc3ae3f43e9$var$FIELD_ID_ARI_REGEX = /ari:cloud:jira:.*?:issuefieldvalue\/.*?\/(.*)/;
const $dc5becc3ae3f43e9$var$PRIORITY_ID_ARI_REGEX = /ari:cloud:jira:.*?:priority\/activation\/.*?\/(.*)/;
const $dc5becc3ae3f43e9$var$USER_ID_ARI_REGEX = /ari:cloud:identity::user\/(.*)/;
const $dc5becc3ae3f43e9$export$4ae913a052c0d582 = (fieldIdOrAri)=>{
    const match = fieldIdOrAri?.match($dc5becc3ae3f43e9$var$FIELD_ID_ARI_REGEX);
    return match ? match[1] : fieldIdOrAri;
};
const $dc5becc3ae3f43e9$export$d3f3dc1a70aa9a8 = (priorityIdOrAri)=>{
    const match = priorityIdOrAri?.match($dc5becc3ae3f43e9$var$PRIORITY_ID_ARI_REGEX);
    return match ? match[1] : priorityIdOrAri;
};
const $dc5becc3ae3f43e9$export$364d97890ac491af = (userIdOrAri)=>{
    const match = userIdOrAri?.match($dc5becc3ae3f43e9$var$USER_ID_ARI_REGEX);
    return match ? match[1] : userIdOrAri;
};

});

parcelRegister("9XwQG", function(module, exports) {
$parcel$export(module.exports, "useClientValidationHandler", () => $2dafbdf964d3724b$export$f57c10638969fb77);

var $eJOHy = parcelRequire("eJOHy");
/** Return an `ValidationStatus` for a given validation message. */ const $2dafbdf964d3724b$var$getValidationStatus = (message)=>message ? message.type : 'success';
// Priority order for ValidationStatus. Higher value = higher priority.
const $2dafbdf964d3724b$var$invalidStatusPriority = {
    success: 0,
    warning: 1,
    error: 2
};
/**
 * Return the higher priority message of `messageA` and `messageB`. If the priority is equal then `messageA` will be
 * returned.
 */ const $2dafbdf964d3724b$var$getHigherPriorityMessage = (messageA, messageB)=>{
    const statusA = $2dafbdf964d3724b$var$getValidationStatus(messageA);
    const statusB = $2dafbdf964d3724b$var$getValidationStatus(messageB);
    return $2dafbdf964d3724b$var$invalidStatusPriority[statusA] >= $2dafbdf964d3724b$var$invalidStatusPriority[statusB] ? messageA : messageB;
};
const $2dafbdf964d3724b$export$f57c10638969fb77 = (validator)=>{
    const [invalidEvent, setInvalidEvent] = (0, $eJOHy.useState)(null);
    const { change: change, submit: submit } = validator ?? {};
    const validateChange = (0, $eJOHy.useCallback)((value)=>{
        // If no change validator is defined then the value is considered valid
        const message = change ? change(value) : null;
        setInvalidEvent(message ? {
            action: 'change',
            state: message
        } : null);
        return $2dafbdf964d3724b$var$getValidationStatus(message);
    }, [
        change
    ]);
    const validateSubmit = (0, $eJOHy.useCallback)((value)=>{
        // If no submit validator is defined then the value is considered valid
        const message = submit ? submit(value) : null;
        const changeInvalidMessage = invalidEvent?.action === 'change' ? invalidEvent.state : null;
        // Only update the change event invalid state if a higher priority message is returned
        const higherPriorityMessage = $2dafbdf964d3724b$var$getHigherPriorityMessage(message, changeInvalidMessage);
        setInvalidEvent(higherPriorityMessage ? {
            action: 'submit',
            state: higherPriorityMessage
        } : null);
        return $2dafbdf964d3724b$var$getValidationStatus(higherPriorityMessage);
    }, [
        invalidEvent,
        submit
    ]);
    const clearValidation = (0, $eJOHy.useCallback)(()=>{
        setInvalidEvent(null);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>({
            validateChange: validateChange,
            validateSubmit: validateSubmit,
            clearValidation: clearValidation
        }), [
        clearValidation,
        validateChange,
        validateSubmit
    ]);
    return [
        invalidEvent?.state ?? null,
        actions
    ];
};

});

parcelRegister("6jOZV", function(module, exports) {
$parcel$export(module.exports, "useServerValidationHandler", () => $1ed3149aae721e64$export$1bf5fbbc94f09320);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $3Kttn = parcelRequire("3Kttn");
const $1ed3149aae721e64$export$1bf5fbbc94f09320 = (fieldName, setIsEditing, onSubmitFailed)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [hasServerValidationError, setHasServerValidationError] = (0, $eJOHy.useState)(false);
    const handleSubmitFailed = (0, $eJOHy.useCallback)((error, message)=>{
        setHasServerValidationError(true);
        const flagId = showFlag({
            type: 'error',
            title: formatMessage((0, $3Kttn.default).submitFailedTitle, {
                fieldName: fieldName
            }),
            description: message ?? formatMessage((0, $3Kttn.default).submitFailedDescription),
            testId: 'issue-field-validation-handler.controllers.server-validation-handler.submit-failed-flag',
            messageId: 'issue-field-validation-handler.controllers.server-validation-handler.show-flag.error.submit-failed',
            messageType: 'transactional',
            onDismissed: ()=>{
                setHasServerValidationError(false);
            },
            actions: setIsEditing ? [
                {
                    content: (0, $3Kttn.default).submitFailedTryAgain,
                    onClick: ()=>{
                        setIsEditing(true);
                        flagId && dismissFlag(flagId);
                    }
                }
            ] : undefined
        });
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'serverValidationHandler',
                packageName: 'jiraIssueFieldValidationHandler',
                teamName: 'empanada'
            },
            event: createAnalyticsEvent({}),
            error: error,
            attributes: {
                fieldName: fieldName
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
        onSubmitFailed?.(error);
    }, [
        dismissFlag,
        fieldName,
        formatMessage,
        onSubmitFailed,
        setIsEditing,
        showFlag,
        createAnalyticsEvent
    ]);
    const clearServerValidation = (0, $eJOHy.useCallback)(()=>setHasServerValidationError(false), []);
    return (0, $eJOHy.useMemo)(()=>[
            hasServerValidationError,
            {
                handleSubmitFailed: handleSubmitFailed,
                clearServerValidation: clearServerValidation
            }
        ], [
        hasServerValidationError,
        handleSubmitFailed,
        clearServerValidation
    ]);
};

});
parcelRegister("3Kttn", function(module, exports) {
$parcel$export(module.exports, "default", () => $663c31e87c1dd7c6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
// Keep up to date with jira/src/packages/issue/keyboard-shortcuts/src/services/assign-to-me-or-unassign/messages.tsx
const $663c31e87c1dd7c6$var$messages = (0, $7qGN1.defineMessages)({
    submitFailedTitle: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-title-new",
        "defaultMessage": "We couldn\u2019t update the {fieldName} value"
    },
    submitFailedDescription: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-description",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    submitFailedTryAgain: {
        "id": "issue-field-validation-handler.controllers.server-validation-handler.submit-failed-try-again",
        "defaultMessage": "Try editing the field again"
    }
});
var $663c31e87c1dd7c6$export$2e2bcd8739ae039 = $663c31e87c1dd7c6$var$messages;

});


parcelRegister("3mxJ5", function(module, exports) {
$parcel$export(module.exports, "getOnCopyHandler", () => $7f34b51931f27aa7$export$ce96a952c1e6691a);
$parcel$export(module.exports, "getOnPasteHandler", () => $7f34b51931f27aa7$export$66ac6a407d63bc45);

var $hGArn = parcelRequire("hGArn");

var $i6t0v = parcelRequire("i6t0v");

var $67o6i = parcelRequire("67o6i");

var $78Ere = parcelRequire("78Ere");
/** Returns a sanitised HTML string with the provided `componentType` and `value` set as HTML attributes. */ const $7f34b51931f27aa7$var$safelyAddRichValueToHtml = (componentType, value)=>{
    try {
        const html = `<div data-type="table-cell" data-component-type="${componentType}" />`;
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(value));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return null;
    }
};
function $7f34b51931f27aa7$export$89af511f3acca517(componentType, value, textSerialiser) {
    const clipboardItems = {
        'text/plain': new globalThis.window.Blob([
            textSerialiser(value)
        ], {
            type: 'text/plain'
        })
    };
    const html = $7f34b51931f27aa7$var$safelyAddRichValueToHtml(componentType, value);
    if (html) clipboardItems['text/html'] = new globalThis.window.Blob([
        html
    ], {
        type: 'text/html'
    });
    const clipboardItem = new globalThis.window.ClipboardItem(clipboardItems);
    globalThis.navigator.clipboard.write([
        clipboardItem
    ]);
}
const $7f34b51931f27aa7$export$29418a91c5daf3d9 = (e)=>{
    const html = e.clipboardData?.getData('text/html');
    if (!html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.componentType || !data.fieldValue) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            componentType: data.componentType,
            value: JSON.parse(data.fieldValue)
        };
    } catch (error) {
        return null;
    }
};
const $7f34b51931f27aa7$export$ce96a952c1e6691a = (componentType, value)=>{
    const textSerialiser = (0, $hGArn.getDefaultClipboardTextSerialiser)();
    return ()=>$7f34b51931f27aa7$export$89af511f3acca517(componentType, value, textSerialiser);
};
const $7f34b51931f27aa7$export$66ac6a407d63bc45 = (componentType)=>{
    const parser = (0, $i6t0v.getDefaultClipboardParser)(componentType);
    return (e)=>{
        let caughtError;
        const metadata = $7f34b51931f27aa7$export$29418a91c5daf3d9(e);
        if (metadata) try {
            return parser(metadata);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = error;
        }
        const plainText = e.clipboardData?.getData('text/plain');
        if (plainText) try {
            if (componentType === 'text') return (0, $67o6i.stringClipboardTextParser)(plainText);
            return (0, $67o6i.defaultClipboardTextParser)(plainText);
        } catch (error) {
            // Silently ignore and fallthrough
            caughtError = caughtError ?? error;
        }
        if (caughtError instanceof (0, $78Ere.ClipboardValidationError)) throw caughtError;
    };
};

});
parcelRegister("hGArn", function(module, exports) {
$parcel$export(module.exports, "getDefaultClipboardTextSerialiser", () => $58f0868807ff38e7$export$2bbd2e5056252b1d);
const $58f0868807ff38e7$export$2bbd2e5056252b1d = ()=>{
    return (value)=>{
        switch(typeof value){
            case 'string':
            case 'number':
            case 'boolean':
                return String(value);
            default:
                return '';
        }
    };
};

});

parcelRegister("i6t0v", function(module, exports) {
$parcel$export(module.exports, "getDefaultClipboardParser", () => $7b612785ecca3e27$export$b221956cf03526aa);

var $78Ere = parcelRequire("78Ere");
const $7b612785ecca3e27$var$isComponentType = (meta, type)=>meta.componentType === type;
const $7b612785ecca3e27$export$b221956cf03526aa = (expectedComponentType)=>{
    return (meta)=>{
        if ($7b612785ecca3e27$var$isComponentType(meta, expectedComponentType)) return meta.value;
        throw (0, $78Ere.ClipboardValidationError).pasteUnexpectedComponentType(meta.componentType, expectedComponentType);
    };
};

});
parcelRegister("78Ere", function(module, exports) {
$parcel$export(module.exports, "ClipboardValidationError", () => $927996358e9f15b0$export$41262351255fc0fe);
class $927996358e9f15b0$export$41262351255fc0fe extends Error {
    constructor(type, message){
        super(message);
        this.name = 'ClipboardValidationError';
        this.type = type;
    }
    static copyOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('copyOperationUnsupported', 'Copy operation not supported.');
    }
    static cutOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('cutOperationUnsupported', 'Cut operation not supported.');
    }
    static cutNonEditableError(actual) {
        return new $927996358e9f15b0$export$41262351255fc0fe('cutNonEditableError', `Received component type '${actual}' cannot be cut.`);
    }
    static pasteOperationUnsupported() {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteOperationUnsupported', 'Paste operation not supported.');
    }
    static pasteUnexpectedComponentType(actual, expected) {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteUnexpectedComponentType', `Received component type '${actual}' when '${expected}' was expected.`);
    }
    static pasteUnsupportedFormat(format) {
        return new $927996358e9f15b0$export$41262351255fc0fe('pasteUnsupportedFormat', `Unsupported data transfer format '${format}'.`);
    }
}

});


parcelRegister("67o6i", function(module, exports) {
$parcel$export(module.exports, "defaultClipboardTextParser", () => $99079690e1495c78$export$eaf687a0cd453100);
$parcel$export(module.exports, "stringClipboardTextParser", () => $99079690e1495c78$export$95f020f7a1102e64);

var $78Ere = parcelRequire("78Ere");
const $99079690e1495c78$export$eaf687a0cd453100 = ()=>{
    throw (0, $78Ere.ClipboardValidationError).pasteUnsupportedFormat('text/plain');
};
const $99079690e1495c78$export$95f020f7a1102e64 = (plainText)=>plainText;

});


parcelRegister("kB1g4", function(module, exports) {
$parcel$export(module.exports, "useClipboardErrorReporting", () => $f82dd9dc823d71e4$export$a3594035e6545378);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $48Ylx = parcelRequire("48Ylx");

var $78Ere = parcelRequire("78Ere");
const $f82dd9dc823d71e4$var$uniqueFlagId = (0, $jn1Cb.toFlagId)('JSC_COPY_PASTE_FLAG');
const $f82dd9dc823d71e4$var$assertUnreachable = (_)=>{
    throw new Error('Unreachable code reached');
};
const $f82dd9dc823d71e4$var$useGetErrorFlag = (fieldName)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((errorType)=>{
        switch(errorType){
            case 'copyOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).copyErrorTitle),
                    description: formatMessage((0, $48Ylx.default).copyValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.copy-validation-error',
                    messageType: 'transactional'
                };
            case 'cutOperationUnsupported':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).cutErrorTitle),
                    description: formatMessage((0, $48Ylx.default).cutValidationError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-validation-error',
                    messageType: 'transactional'
                };
            case 'cutNonEditableError':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).cutErrorTitle),
                    description: formatMessage((0, $48Ylx.default).cutNonEditableError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.cut-non-editable-error',
                    messageType: 'transactional'
                };
            case 'pasteOperationUnsupported':
            case 'pasteUnexpectedComponentType':
            case 'pasteUnsupportedFormat':
                return {
                    type: 'error',
                    title: formatMessage((0, $48Ylx.default).pasteErrorTitle),
                    description: formatMessage((0, $48Ylx.default).pasteUnsupportedError, {
                        name: fieldName
                    }),
                    messageId: 'issue-field-copy-paste.controller.flag.error.paste-unsupported-error',
                    messageType: 'transactional'
                };
            default:
                return $f82dd9dc823d71e4$var$assertUnreachable(errorType);
        }
    }, [
        fieldName,
        formatMessage
    ]);
};
const $f82dd9dc823d71e4$export$a3594035e6545378 = (fieldName, fieldType)=>{
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const getErrorFlag = $f82dd9dc823d71e4$var$useGetErrorFlag(fieldName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((error)=>{
        if (error instanceof (0, $78Ere.ClipboardValidationError)) {
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'inlineEdit clipboardValidationError', {
                clipboardValidationErrorType: error.type,
                fieldType: fieldType
            });
            dismissFlag($f82dd9dc823d71e4$var$uniqueFlagId);
            showFlag({
                ...getErrorFlag(error.type),
                id: $f82dd9dc823d71e4$var$uniqueFlagId
            });
        } else {
            const ugcSafeMessage = `Failed to perform clipboard operation for field of type ${fieldType}`;
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'clipboardOperationError',
                    packageName: 'jiraIssueFieldCopyPaste',
                    teamName: 'empanada'
                },
                attributes: {
                    message: ugcSafeMessage,
                    fieldType: fieldType
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        dismissFlag,
        fieldType,
        getErrorFlag,
        showFlag
    ]);
};

});
parcelRegister("48Ylx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c28fb312260a79a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c28fb312260a79a6$var$messages = (0, $7qGN1.defineMessages)({
    copyErrorTitle: {
        "id": "issue-field-copy-paste.controller.copy-error-title",
        "defaultMessage": "Unable to copy"
    },
    copyValidationError: {
        "id": "issue-field-copy-paste.controller.copy-validation-error",
        "defaultMessage": "{name} can't be copied."
    },
    cutErrorTitle: {
        "id": "issue-field-cut-paste.controller.cut-error-title",
        "defaultMessage": "Unable to cut"
    },
    cutValidationError: {
        "id": "issue-field-cut-paste.controller.cut-validation-error",
        "defaultMessage": "{name} can't be cut."
    },
    cutNonEditableError: {
        "id": "business-list.controllers.clipboard.cut-non-editable-error",
        "defaultMessage": "{name} is copied to your clipboard instead."
    },
    pasteErrorTitle: {
        "id": "issue-field-copy-paste.controller.paste-error-title",
        "defaultMessage": "Unable to paste"
    },
    pasteUnsupportedError: {
        "id": "issue-field-copy-paste.controller.paste-unsupported-error",
        "defaultMessage": "This can't be pasted on {name}."
    }
});
var $c28fb312260a79a6$export$2e2bcd8739ae039 = $c28fb312260a79a6$var$messages;

});


parcelRegister("aIlUW", function(module, exports) {
$parcel$export(module.exports, "isNullableComponentType", () => $746cf1207b9950e2$export$caeca7da2724234c);
$parcel$export(module.exports, "isStringComponentType", () => $746cf1207b9950e2$export$6e42f8250885ab5b);
$parcel$export(module.exports, "isArrayComponentType", () => $746cf1207b9950e2$export$1c384554b943e9d8);
/**
 * Exhaustive assertion that will throw for all component types that do not support a `null` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `null` values then it must be added to the below switch
 * case.
 */ const $746cf1207b9950e2$var$assertIsNullableComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'text':
        case 'priority':
        case 'labels':
        case 'originalEstimate':
            throw new Error(`Type '${type}' does not support null values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$caeca7da2724234c = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsNullableComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support a `string` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `string` values then it must be added to the below
 * switch case.
 */ const $746cf1207b9950e2$var$assertIsStringComponentType = (type)=>{
    switch(type){
        case 'number':
        case 'boolean':
        case 'checkboxSelect':
        case 'numberNullable':
        case 'priority':
        case 'sprint':
        case 'singleUser':
        case 'labels':
        case 'singleSelect':
        case 'multiUserPicker':
        case 'multiSelect':
        case 'multiGroupPicker':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'components':
        case 'team':
        case 'multiVersionSelect':
        case 'parent':
            throw new Error(`Type '${type}' does not support string values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$6e42f8250885ab5b = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsStringComponentType(type);
        return true;
    } catch  {
        return false;
    }
};
/**
 * Exhaustive assertion that will throw for all component types that do not support an `array` value. If a new
 * `ClipboardComponentType` is defined that **does not** support `array` values then it must be added to the below
 * switch case.
 */ const $746cf1207b9950e2$var$assertIsArrayComponentType = (type)=>{
    switch(type){
        case 'date':
        case 'dateTime':
        case 'text':
        case 'number':
        case 'numberNullable':
        case 'boolean':
        case 'sprint':
        case 'originalEstimate':
        case 'singleUser':
        case 'singleSelect':
        case 'url':
        case 'priority':
        case 'cascadingSelect':
        case 'radioSelect':
        case 'team':
        case 'parent':
            throw new Error(`Type '${type}' does not support array values`);
        default:
            return type;
    }
};
const $746cf1207b9950e2$export$1c384554b943e9d8 = (type)=>{
    try {
        $746cf1207b9950e2$var$assertIsArrayComponentType(type);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("SKIZT", function(module, exports) {
$parcel$export(module.exports, "useRealTimeComments", () => $b2344957e97b16de$export$77846b359c3804dd);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $b2344957e97b16de$var$initialState = {
    isRealTimeCommentUpdated: false
};
const $b2344957e97b16de$var$actions = {
    setRealTimeCommentUpdated: (isRealTimeCommentUpdated)=>({ setState: setState })=>{
            setState({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
        }
};
const $b2344957e97b16de$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view.controllers.realtime-comments',
    initialState: $b2344957e97b16de$var$initialState,
    actions: $b2344957e97b16de$var$actions
});
const $b2344957e97b16de$export$77846b359c3804dd = (0, $iJq0l.createHook)($b2344957e97b16de$var$store);

});


parcelRegister("99gun", function(module, exports) {
$parcel$export(module.exports, "FieldInlineEditLiteWithEntryPoint", () => $a603698b24549ac2$export$d14ba912eb773f8d);

var $eJOHy = parcelRequire("eJOHy");

var $dllpM = parcelRequire("dllpM");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $tYLUh = parcelRequire("tYLUh");

var $8uEpk = parcelRequire("8uEpk");

var $6TknG = parcelRequire("6TknG");

const $a603698b24549ac2$export$d14ba912eb773f8d = ({ editViewEntryPoint: editViewEntryPoint, editViewEntryPointParams: editViewEntryPointParams, getEditViewProps: getEditViewProps, ...props })=>{
    const { hideEditButton: hideEditButton, isEditable: isEditable, isEditing: isEditing, readView: readView, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, disableReadViewAppearanceOnHoverOnly: disableReadViewAppearanceOnHoverOnly = false, readViewHighlightOnHover: readViewHighlightOnHover } = props;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const pressTrace = (0, $dllpM.default)('issue.field.inline-edit-lite');
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(editViewEntryPoint, editViewEntryPointParams);
    const entryPointEventMap = (0, $eJOHy.useMemo)(()=>{
        const actions = (0, $dZ3jN.getDefaultEntrypointActionEventMap)(entryPointActions);
        const { click: click } = actions;
        actions.click = (e)=>{
            pressTrace();
            click(e);
        };
        return actions;
    }, [
        entryPointActions,
        pressTrace
    ]);
    const readViewTrigger = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, true, entryPointEventMap);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // This component can be mounted in an editing state or toggled externally, so we need to ensure the entrypoint
        // is always explicitly loaded when entering edit view.
        if (isEditing) entryPointActions.load();
    }, [
        isEditing,
        entryPointActions
    ]);
    const renderEditView = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "editView",
            packageName: "jiraIssueFieldInlineEditLite",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TknG.ReadViewNonEditable), {
                hideEditButton: hideEditButton,
                isLoading: true,
                readViewFitContainerHeight: readViewFitContainerHeight,
                readViewHighlightOnHover: readViewHighlightOnHover
            }, readView()),
            runtimeProps: getEditViewProps(fieldProps)
        });
    const renderedOutsideIssueView = readViewFitContainerHeight && props.editViewPopup && props.editViewPopupAlignBlock === 'center';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uEpk.default), {
        ...props,
        ...isExperimentEnabled && {
            value: renderedOutsideIssueView || disableReadViewAppearanceOnHoverOnly ? true : getEditViewProps()?.value || getEditViewProps()?.defaultValue
        },
        readViewContainerRef: isEditable ? readViewTrigger : undefined,
        editView: renderEditView,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled
    });
};

});
parcelRegister("tYLUh", function(module, exports) {
$parcel$export(module.exports, "useBespokeEmptyFieldTextExperiment", () => $6e661923caaee82d$export$5a7b1bb3c8ba459f);

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $FhXEJ = parcelRequire("FhXEJ");
const $6e661923caaee82d$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT) && (0, $4cTDP.fg)('fg_bespoke-placeholder-experiment-ga')) && isFieldRenderedInIssueView && (0, $4cTDP.fg)('bespoke-empty-field-text-gate');
};
const $6e661923caaee82d$export$5a7b1bb3c8ba459f = ()=>{
    const isExperimentEligible = $6e661923caaee82d$var$useIsExperimentEligible();
    const isVisibleAlways = isExperimentEligible && (0, $cxKOj.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'always', 'never');
    const isVisibleOnHover = isExperimentEligible && (0, $cxKOj.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'hover', 'never');
    return {
        bespokeEmptyFieldTextExperimentVariant: isExperimentEligible ? (0, $cxKOj.expVal)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'never') : null,
        isExperimentEnabled: isVisibleAlways || isVisibleOnHover,
        isVisibleAlways: isVisibleAlways,
        isVisibleOnHover: isVisibleOnHover
    };
};

});

parcelRegister("8uEpk", function(module, exports) {
$parcel$export(module.exports, "default", () => $166556c5a2840ca0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $f4cRx = parcelRequire("f4cRx");

var $lRq8t = parcelRequire("lRq8t");

var $tYLUh = parcelRequire("tYLUh");

var $dA2s3 = parcelRequire("dA2s3");

var $2TDKv = parcelRequire("2TDKv");

var $2KSbM = parcelRequire("2KSbM");

var $ew20k = parcelRequire("ew20k");

// Fallback placements to be used for the validation popover if it overflows its clipping parent
const $166556c5a2840ca0$var$fallbackPlacements = [
    'left',
    'top-start',
    'auto'
];
/**
 * Component leveraging `@atlassian/jira-inline-edit-lite` to provide consistent spacing and validation UX for issue
 * fields.
 */ const $166556c5a2840ca0$var$FieldInlineEditLite = ({ editView: editView, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, fieldName: fieldName, hasUnsubmittedChanges: hasUnsubmittedChanges, hideActionButtons: hideActionButtons, hideEditButton: hideEditButton, invalidMessage: invalidMessage, isEditable: isEditable, isEditing: isEditing, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onCopy: onCopy, onCut: onCut, onPaste: onPaste, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerRef: readViewContainerRef, readView: readView, readViewContainerTarget: readViewContainerTarget, confirmButtonLabel: confirmButtonLabelProp, cancelButtonLabel: cancelButtonLabelProp, editButtonLabel: editButtonLabelProp, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, value: value })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { context: context, refs: refs } = (0, $f4cRx.useInlineEdit)({
        isEditing: isEditing,
        onCancel: onCancel,
        onConfirm: onConfirm,
        onEdit: onEdit
    });
    const confirmButtonLabel = confirmButtonLabelProp ?? formatMessage((0, $2KSbM.default).confirmButtonLabel, {
        fieldName: fieldName
    });
    const cancelButtonLabel = cancelButtonLabelProp ?? formatMessage((0, $2KSbM.default).cancelButtonLabel, {
        fieldName: fieldName
    });
    const editButtonLabel = editButtonLabelProp ?? formatMessage((0, $2KSbM.default).editButtonLabel, {
        fieldName: fieldName
    });
    if (isEditing && isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2TDKv.EditView), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: editViewPopupMinWidth,
        editViewPopupTarget: editViewPopupTarget,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dA2s3.default), {
        message: invalidMessage,
        trigger: (triggerProps)=>editView(triggerProps),
        placement: "right",
        fallbackPlacements: $166556c5a2840ca0$var$fallbackPlacements
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ew20k.ReadView), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: refs.editButton,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditable,
        isInvalid: hasUnsubmittedChanges,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readViewContainerRef: readViewContainerRef,
        onCopy: onCopy,
        onCut: onCut,
        onPaste: onPaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        ...isExperimentEnabled && {
            value: value
        },
        readViewContainerTarget: readViewContainerTarget
    }, readView());
};
var $166556c5a2840ca0$export$2e2bcd8739ae039 = $166556c5a2840ca0$var$FieldInlineEditLite;

});
parcelRegister("f4cRx", function(module, exports) {
$parcel$export(module.exports, "useInlineEdit", () => $82c0f5b6e77ac78a$export$4059f16ba5dcb4e1);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $ftN6c = parcelRequire("ftN6c");
const $82c0f5b6e77ac78a$var$actionSubject = 'inlineEdit';
const $82c0f5b6e77ac78a$export$4059f16ba5dcb4e1 = ({ isEditing: isEditing, onCancel: onCancelOption, onConfirm: onConfirmOption, onEdit: onEditOption })=>{
    const editButtonRef = (0, $eJOHy.useRef)(null);
    const preventFocusOnEditButtonRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const prevIsEditing = (0, $6d9QY.usePrevious)(isEditing);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !isEditing) {
            if (preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else editButtonRef.current?.focus();
        }
    }, [
        prevIsEditing,
        isEditing
    ]);
    const onCancel = (0, $eJOHy.useCallback)((preventFocusReturn = true)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'canceled',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onCancelOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onCancelOption
    ]);
    const onConfirm = (0, $eJOHy.useCallback)((preventFocusReturn = true, event)=>{
        preventFocusOnEditButtonRef.current = preventFocusReturn;
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onConfirmOption(analyticsEvent, event);
    }, [
        createAnalyticsEvent,
        onConfirmOption
    ]);
    const onEdit = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: $82c0f5b6e77ac78a$var$actionSubject
        });
        onEditOption(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEditOption
    ]);
    const context = (0, $eJOHy.useMemo)(()=>({
            onCancel: onCancel,
            onConfirm: onConfirm,
            onEdit: onEdit
        }), [
        onCancel,
        onConfirm,
        onEdit
    ]);
    const refs = (0, $eJOHy.useMemo)(()=>({
            editButton: editButtonRef
        }), []);
    return (0, $eJOHy.useMemo)(()=>({
            context: context,
            refs: refs
        }), [
        context,
        refs
    ]);
};

});

parcelRegister("dA2s3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f07c4c3cece0ae1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iGn6g = parcelRequire("iGn6g");
/**
 * Popup component to display a validation message for inline editable fields. The message will be displayed when the
 * user focuses the trigger attached to this component (which should be an interactive form field), and hidden when the
 * trigger is blurred.
 *
 * Why do we have a custom popup instead of using an existing `@atlaskit` component? There are a couple of caveats from
 * the existing components which makes them unsuitable for our use case:
 * 1. `@atlaskit/popup` - Creates a focus lock within the popup preventing the user from tab navigating to and from the
 * popup content.
 * 2. `@atlaskit/inline-dialog` - Deprecated in favour of `@atlaskit/popup`.
 * 3. `@atlaskit/tooltip` - Does not allow visibility to be controlled via a prop and attaches to mouseover events,
 * which is undesired.
 */ const $7f07c4c3cece0ae1$var$ValidationPopup = ({ message: message, placement: placement, fallbackPlacements: fallbackPlacements, trigger: trigger })=>{
    const [isVisuallyHidden, setIsVisuallyHidden] = (0, $eJOHy.useState)(true);
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const triggerRef = (0, $eJOHy.useRef)();
    const onFocus = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
        setIsVisuallyHidden(false);
    };
    const onBlur = ()=>{
        wasFocusReceivedSinceLastBlurRef.current = false;
        setTimeout(()=>{
            if (!wasFocusReceivedSinceLastBlurRef.current) setIsVisuallyHidden(true);
        }, 0);
    };
    const popupContentId = (0, $eJOHy.useMemo)(()=>`${(0, $aXKmr.v4)()}-validation-popup`, []);
    const fieldProps = {
        ref: triggerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        'aria-describedby': isVisuallyHidden ? undefined : popupContentId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, trigger(fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iGn6g.default), {
        id: popupContentId,
        isVisuallyHidden: isVisuallyHidden,
        message: message,
        onFocus: onFocus,
        onBlur: onBlur,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        referenceElement: triggerRef?.current
    }));
};
var $7f07c4c3cece0ae1$export$2e2bcd8739ae039 = $7f07c4c3cece0ae1$var$ValidationPopup;

});
parcelRegister("iGn6g", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c2d5c88d4613b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");

var $IW7jS = parcelRequire("IW7jS");

var $9cbmy = parcelRequire("9cbmy");

var $8cv11 = parcelRequire("8cv11");

var $efqhN = parcelRequire("efqhN");
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $b1c2d5c88d4613b7$var$getDirectionFromPlacement = (placement)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    placement.split('-')[0];
// Inverts motion direction
const $b1c2d5c88d4613b7$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $b1c2d5c88d4613b7$var$ValidationPopper = ({ id: id, isVisuallyHidden: isVisuallyHidden, message: message, onFocus: onFocus, onBlur: onBlur, placement: placement, fallbackPlacements: fallbackPlacements, referenceElement: referenceElement })=>{
    const updateRef = (0, $eJOHy.useRef)();
    const modifiers = (0, $eJOHy.useMemo)(()=>[
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ], [
        fallbackPlacements
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Since we are applying visually hidden styles instead of unmounting the popup for accessibility reasons,
        // there will be cases where the popup placement is calculated while it's visually hidden (e.g. when a
        // validation occurs on blur). While visually hidden, popup size is 1px x 1px, and this can make Popper
        // think that the popup fits in a placement where it doesn't actually fit, and end up overflowing the
        // viewport. To prevent this from happening, we ask Popper to recompute popup position when it becomes visible.
        !isVisuallyHidden && updateRef.current?.();
    }, [
        isVisuallyHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), {
        appear: true
    }, message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: placement,
        referenceElement: referenceElement,
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-validation-popup.ui.validation-popper.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, placement: finalPlacement, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
            entranceDirection: $b1c2d5c88d4613b7$var$invertedDirection[$b1c2d5c88d4613b7$var$getDirectionFromPlacement(finalPlacement)]
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line jira/react/no-style-attribute
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ...isVisuallyHidden && (0, $9cbmy.visuallyHiddenStyles),
                    zIndex: (0, $IW7jS.layers).layer()
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efqhN.default), {
                ...message,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                id: id,
                onFocus: onFocus,
                onBlur: onBlur,
                "data-testid": "issue-field-validation-popup.ui.validation-popper.popup-content",
                testId: `issue-field-validation-popup.ui.validation-popper.popup-content${isVisuallyHidden ? '-hidden' : ''}`
            })));
    }));
};
var $b1c2d5c88d4613b7$export$2e2bcd8739ae039 = $b1c2d5c88d4613b7$var$ValidationPopper;

});
parcelRegister("efqhN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2564887d15946d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $iyBj8 = parcelRequire("iyBj8");
const $fa2564887d15946d$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $fa2564887d15946d$var$useIcon = (type)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    switch(type){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
                spacing: "spacious",
                label: formatMessage((0, $iyBj8.default).errorLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        case 'warning':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
                spacing: "spacious",
                label: formatMessage((0, $iyBj8.default).warningLabel),
                color: "var(--ds-icon-warning, #E56910)"
            });
        default:
            $fa2564887d15946d$var$assertUnreachable(type);
    }
};
const $fa2564887d15946d$var$PopupContent = ({ className: className, id: id, message: message, onFocus: onFocus, onBlur: onBlur, testId: testId, title: title, type: type })=>{
    const icon = $fa2564887d15946d$var$useIcon(type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa2564887d15946d$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        role: "alert",
        id: id,
        hasTitle: !!title,
        onFocus: onFocus,
        onBlur: onBlur,
        "data-testid": testId
    }, icon, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.075",
        xcss: $fa2564887d15946d$var$titleStyles
    }, title), message) : message);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa2564887d15946d$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTitle: hasTitle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _vchhusvi _p12f1feq _bfhk1bhr _16qs1cd0 _1bsb1ns9",
            __cmplp.hasTitle ? "_zulppxbi" : "_zulp12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fa2564887d15946d$var$titleStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px'
});
var $fa2564887d15946d$export$2e2bcd8739ae039 = $fa2564887d15946d$var$PopupContent;

});
parcelRegister("iyBj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $699d6029843e778e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $699d6029843e778e$var$messages = (0, $7qGN1.defineMessages)({
    errorLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.error-label",
        "defaultMessage": "Error"
    },
    warningLabel: {
        "id": "issue-field-validation-popup.validation-popper.popup-content.warning-label",
        "defaultMessage": "Warning"
    }
});
var $699d6029843e778e$export$2e2bcd8739ae039 = $699d6029843e778e$var$messages;

});




parcelRegister("2TDKv", function(module, exports) {
$parcel$export(module.exports, "EditView", () => $589496f4abd155cb$export$280eb2fbab4e5389);

var $eJOHy = parcelRequire("eJOHy");

var $2tS6J = parcelRequire("2tS6J");

var $3Js2r = parcelRequire("3Js2r");
const $589496f4abd155cb$export$280eb2fbab4e5389 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupMinWidth: editViewPopupMinWidth, editViewPopupTarget: editViewPopupTarget, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2tS6J.Form), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: keepEditViewOpenOnBlur
    }, children);
    if (editViewPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Js2r.EditViewPopup), {
        alignBlock: editViewPopupAlignBlock,
        width: editViewPopupWidth,
        minWidth: editViewPopupMinWidth,
        target: editViewPopupTarget
    }, form);
    return form;
};

});
parcelRegister("2tS6J", function(module, exports) {
$parcel$export(module.exports, "Form", () => $101e08a54c1b522e$export$a7fed597f4b8afd8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4cTDP = parcelRequire("4cTDP");

var $46mQ4 = parcelRequire("46mQ4");
const $101e08a54c1b522e$export$a7fed597f4b8afd8 = ({ cancelButtonLabel: cancelButtonLabel, children: children, confirmButtonLabel: confirmButtonLabel, context: context, hideActionButtons: hideActionButtons, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur })=>{
    const { onCancel: onCancel, onConfirm: onConfirm } = context;
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const formRef = (0, $eJOHy.useRef)(null);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save)
   */ const onBlur = (0, $eJOHy.useCallback)((event)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            setTimeout(()=>{
                // Check the form hasn't unmounted before attempting to auto-submit
                !wasFocusReceivedSinceLastBlurRef.current && formRef.current && onConfirm(true, event);
            }, 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        onConfirm
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field
   */ const onFocus = (0, $eJOHy.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const onSubmit = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onConfirm(false, event);
    }, [
        onConfirm
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) onSubmit(event);
        if (event.key === 'Esc' || event.key === 'Escape') {
            onCancel(false);
            if ((0, $4cTDP.fg)('jira_issue_view_esc_behaviour_fix')) event.stopPropagation();
        }
    }, [
        onCancel,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($101e08a54c1b522e$var$StyledForm, {
        ref: formRef,
        role: "presentation",
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onSubmit: onSubmit
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46mQ4.FormControls), {
        cancelButtonLabel: cancelButtonLabel,
        confirmButtonLabel: confirmButtonLabel,
        context: context,
        hideActionButtons: hideActionButtons
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $101e08a54c1b522e$var$StyledForm = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("46mQ4", function(module, exports) {
$parcel$export(module.exports, "FormControls", () => $36c7b7a5b7d284f3$export$9b13823dba16e7d1);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");

var $83PoE = parcelRequire("83PoE");
const $36c7b7a5b7d284f3$export$9b13823dba16e7d1 = ({ cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, context: { onCancel: onCancel }, hideActionButtons: hideActionButtons })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83PoE.default), {
        cancelButtonLabel: cancelButtonLabel ?? formatMessage((0, $bGUQI.default).cancelButtonLabel),
        confirmButtonLabel: confirmButtonLabel ?? formatMessage((0, $bGUQI.default).confirmButtonLabel),
        onCancelClick: ()=>onCancel(false)
    }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
        hidden: true,
        type: "submit",
        "aria-label": formatMessage((0, $bGUQI.default).submitButtonLabel)
    });
};

});
parcelRegister("bGUQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $785a91e9889ee2a9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $785a91e9889ee2a9$var$messages = (0, $7qGN1.defineMessages)({
    editButtonLabel: {
        "id": "inline-edit-lite.read-view.edit-button-label",
        "defaultMessage": "Edit"
    },
    confirmButtonLabel: {
        "id": "inline-edit-lite.edit-view.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "inline-edit-lite.edit-view.cancel-button-label",
        "defaultMessage": "Cancel"
    },
    submitButtonLabel: {
        "id": "inline-edit-lite.edit-view.submit-button-label",
        "defaultMessage": "Submit"
    }
});
var $785a91e9889ee2a9$export$2e2bcd8739ae039 = $785a91e9889ee2a9$var$messages;

});

parcelRegister("83PoE", function(module, exports) {
$parcel$export(module.exports, "default", () => $b29521711d40a0dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lwpci = parcelRequire("lwpci");

var $6zhpo = parcelRequire("6zhpo");
const $b29521711d40a0dd$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": confirmButtonLabel,
        type: "submit",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwpci))), {
            label: confirmButtonLabel
        }),
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b29521711d40a0dd$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": cancelButtonLabel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: cancelButtonLabel
        }),
        onClick: onCancelClick,
        shouldFitContainer: true,
        onMouseDown: onMouseDown
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b29521711d40a0dd$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1pfh12x7 _kqswstnw _152t1osq _rjxpidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $b29521711d40a0dd$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1cd0 _1mpy1b66 _1nlx1bhr _l2uv16qz _7mfvvq0a _szlb1fxt",
            __cmplp.className
        ])
    });
});
var $b29521711d40a0dd$export$2e2bcd8739ae039 = $b29521711d40a0dd$var$Buttons;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});




parcelRegister("3Js2r", function(module, exports) {
$parcel$export(module.exports, "EditViewPopup", () => $685159e43c153664$export$3ce17fd683f703eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $LFmXM = parcelRequire("LFmXM");

var $6G5P1 = parcelRequire("6G5P1");
var $azjc1 = parcelRequire("azjc1");

var $bzbsd = parcelRequire("bzbsd");

var $8cv11 = parcelRequire("8cv11");

var $4cTDP = parcelRequire("4cTDP");

var $1jdzZ = parcelRequire("1jdzZ");
const $685159e43c153664$var$getModifiers = (alignBlock)=>[
        {
            name: 'offset',
            enabled: alignBlock === 'center',
            options: {
                // Use negative offset of half the popper height to vertically center the content
                offset: ({ popper: popper })=>[
                        0,
                        -popper.height / 2
                    ]
            }
        },
        {
            name: 'flip',
            enabled: false
        },
        {
            name: 'computeStyles',
            options: {
                // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                gpuAcceleration: false
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 0,
                rootBoundary: 'viewport',
                // Allow the popup to remain within the clipping parent when overflowing the Y axis
                altAxis: true
            }
        }
    ];
/** Map the provided alignment to the appropriate popper placement. */ const $685159e43c153664$var$toPopperPlacement = (alignBlock)=>{
    switch(alignBlock){
        case 'end':
            return 'top-start';
        default:
            return 'bottom-start';
    }
};
/** Map the provided min width breakpoint to a pixel value. */ const $685159e43c153664$var$toMinWidth = (minWidth)=>{
    switch(minWidth){
        case 'large':
            return '400px';
        case 'medium':
            return '200px';
        default:
            return '140px';
    }
};
const $685159e43c153664$export$3ce17fd683f703eb = ({ alignBlock: alignBlock = 'start', width: width, minWidth: minWidth = 'medium', target: target, children: children })=>{
    const updateRef = (0, $eJOHy.useRef)();
    const resizeObserver = (0, $eJOHy.useRef)();
    const modifiersFromContext = (0, $1jdzZ.useEditViewPopupModifiersContext)();
    const additionalModifiers = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line jira/ff/no-preconditioning
        return (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? modifiersFromContext : [];
    }, [
        modifiersFromContext
    ]);
    // Cleanup the resize observer when the component is unmounted
    (0, $eJOHy.useEffect)(()=>()=>resizeObserver.current?.disconnect(), []);
    const resizeRef = (0, $eJOHy.useCallback)((el)=>{
        if (el) {
            // Update popup positioning whenever content is resized
            resizeObserver.current = new ResizeObserver(()=>updateRef.current?.());
            resizeObserver.current.observe(el);
        }
    }, []);
    const Target = (0, $eJOHy.useMemo)(()=>target != null ? target : $685159e43c153664$var$DefaultTarget, [
        target
    ]);
    // Ensure a stable ref function is passed through to the popup content
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $bzbsd.mergeRefs)), []);
    const modifiers = (0, $eJOHy.useMemo)(()=>[
            ...$685159e43c153664$var$getModifiers(alignBlock),
            ...additionalModifiers
        ], [
        alignBlock,
        additionalModifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Target, {
            ref: ref
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        placement: $685159e43c153664$var$toPopperPlacement(alignBlock),
        strategy: "absolute",
        modifiers: modifiers,
        messageId: "issue-field-inline-edit-lite.ui.field-inline-edit-lite.edit-view.edit-view-popup.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($685159e43c153664$var$Content, {
            ref: memoizedMergeRefs(ref, resizeRef),
            width: width,
            minWidth: minWidth,
            /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style
        }, children);
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $685159e43c153664$var$DefaultTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbidpf",
            __cmplp.className
        ])
    });
});
const $685159e43c153664$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19fgw0l": (0, $awdRS.default)((()=>{
                return __cmplp.width ? '0px' : `max(100%, ${$685159e43c153664$var$toMinWidth(__cmplp.minWidth)})`;
            })()),
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91oyu _p12fkbql _1pby16oo",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1ris",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2KSbM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b248572e32a7e865$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b248572e32a7e865$var$messages = (0, $7qGN1.defineMessages)({
    confirmButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "issue-field-inline-edit-lite.field-inline-edit-lite.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    }
});
var $b248572e32a7e865$export$2e2bcd8739ae039 = $b248572e32a7e865$var$messages;

});

parcelRegister("ew20k", function(module, exports) {
$parcel$export(module.exports, "ReadView", () => $ab3c7684ddf42ea0$export$a4b5824ec1e018e1);

var $eJOHy = parcelRequire("eJOHy");

var $64Dbx = parcelRequire("64Dbx");

var $tYLUh = parcelRequire("tYLUh");

var $k4Rl5 = parcelRequire("k4Rl5");

var $kjtxW = parcelRequire("kjtxW");
const $ab3c7684ddf42ea0$export$a4b5824ec1e018e1 = ({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton, isEditInteractionEnabled: isEditInteractionEnabled, isInvalid: isInvalid, isLoading: isLoading, readViewContainerRef: readViewContainerRef, readViewFitContainerHeight: readViewFitContainerHeight, readViewContainerTarget: readViewContainerTarget, onCopy: onCopy, onCut: onCut, onPaste: onPaste, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, value: value })=>{
    const { isEditButtonFocused: isEditButtonFocused, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus } = (0, $64Dbx.useInlineEditReadViewContainer)(context, isEditInteractionEnabled);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { onFocus: onFocus, onBlur: onBlur, lastCopiedTarget: isCopied } = (0, $kjtxW.useCopyPasteTarget)({
        onCopy: onCopy,
        onCut: onCut,
        // Don't allow paste interaction for non-editable fields
        onPaste: isEditInteractionEnabled ? onPaste : undefined
    });
    const handleEditButtonBlur = (0, $eJOHy.useCallback)((e)=>{
        onEditButtonBlur(e);
        onBlur(e);
    }, [
        onEditButtonBlur,
        onBlur
    ]);
    const handleEditButtonFocus = (0, $eJOHy.useCallback)((e)=>{
        onEditButtonFocus(e);
        onFocus(e);
    }, [
        onEditButtonFocus,
        onFocus
    ]);
    if (readViewContainerTarget) {
        const Target = readViewContainerTarget;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Target, {
            context: context,
            editButtonLabel: editButtonLabel,
            editButtonRef: editButtonRef,
            hideEditButton: hideEditButton,
            isEditable: isEditInteractionEnabled,
            isLoading: isLoading,
            isInvalid: isInvalid,
            onClick: onClick,
            editViewPreloadTriggerRef: readViewContainerRef
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4Rl5.default), {
        context: context,
        editButtonLabel: editButtonLabel,
        editButtonRef: editButtonRef,
        hideEditButton: hideEditButton,
        isEditInteractionEnabled: isEditInteractionEnabled,
        isEditButtonFocused: isEditButtonFocused,
        isCopied: isCopied,
        // Highlight the field as invalid to notify the user if there was an error attempting to submit changes.
        isInvalid: isInvalid,
        isLoading: isLoading,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onEditButtonBlur: handleEditButtonBlur,
        onEditButtonFocus: handleEditButtonFocus,
        readViewFitContainerHeight: readViewFitContainerHeight,
        ref: readViewContainerRef,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        ...isExperimentEnabled && {
            value: value
        }
    }, children);
};

});
parcelRegister("64Dbx", function(module, exports) {
$parcel$export(module.exports, "useInlineEditReadViewContainer", () => $8db9de8130ba3246$export$49374f374d70ab51);

var $eJOHy = parcelRequire("eJOHy");
const $8db9de8130ba3246$var$DRAG_THRESHOLD = 5;
const $8db9de8130ba3246$var$isLinkOrButton = (element)=>element.closest('a') != null || element.closest('button') != null;
const $8db9de8130ba3246$export$49374f374d70ab51 = ({ onEdit: onEdit }, isEditInteractionEnabled = true)=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startY = (0, $eJOHy.useRef)(0);
    const [isEditButtonFocused, setEditButtonFocused] = (0, $eJOHy.useState)(false);
    const mouseHasMovedAfterMouseDown = (0, $eJOHy.useCallback)((event)=>Math.abs(startX.current - event.clientX) >= $8db9de8130ba3246$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $8db9de8130ba3246$var$DRAG_THRESHOLD, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const element = event.target;
        /** If a link or button is clicked in the read view, default action should be taken */ if (element instanceof HTMLElement && !$8db9de8130ba3246$var$isLinkOrButton(element) && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEdit();
        }
    }, [
        mouseHasMovedAfterMouseDown,
        onEdit
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)((event)=>{
        startX.current = event.clientX;
        startY.current = event.clientY;
    }, []);
    const onEditButtonBlur = (0, $eJOHy.useCallback)(()=>setEditButtonFocused(false), []);
    const onEditButtonFocus = (0, $eJOHy.useCallback)(()=>setEditButtonFocused(true), []);
    return {
        isEditButtonFocused: isEditButtonFocused,
        onClick: isEditInteractionEnabled ? onClick : undefined,
        onMouseDown: isEditInteractionEnabled ? onMouseDown : undefined,
        onEditButtonBlur: onEditButtonBlur,
        onEditButtonFocus: onEditButtonFocus
    };
};

});

parcelRegister("k4Rl5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dcf29bcd23ed8fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $gFFoY = parcelRequire("gFFoY");

var $ejhcC = parcelRequire("ejhcC");

var $jCuWH = parcelRequire("jCuWH");

var $tYLUh = parcelRequire("tYLUh");
const $6dcf29bcd23ed8fd$var$borderStyles = {
    focused: "_1h6d1p6i",
    invalid: "_1h6d1bqt",
    copied: "_1h6d1p6i _1dqogq9o",
    none: "_1h6d3acm"
};
const $6dcf29bcd23ed8fd$var$getBorderStyle = ({ isFocusRingVisible: isFocusRingVisible, isInvalid: isInvalid, isCopied: isCopied })=>{
    if (isFocusRingVisible) return 'focused';
    if (isInvalid) return 'invalid';
    if (isCopied) return 'copied';
    return 'none';
};
/**
 * This component is designed to be rendered within the `readView` of a `FieldInlineEditLite` component. This can be
 * rendered in a 'read-only' layout by omitting the `context` prop which is provided by `useInlineEdit` in
 * `@atlassian/jira-inline-edit-lite`. This ensures consistent spacing for consumers when a field is conditionally
 * editable.
 */ const $6dcf29bcd23ed8fd$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, context: context, editButtonLabel: editButtonLabel, editButtonRef: editButtonRef, hideEditButton: hideEditButton = true, isCopied: isCopied = false, isEditButtonFocused: isEditButtonFocused = false, isEditInteractionEnabled: isEditInteractionEnabled = true, isLoading: isLoading = false, isInvalid: isInvalid = false, onClick: onClick, onMouseDown: onMouseDown, onEditButtonBlur: onEditButtonBlur, onEditButtonFocus: onEditButtonFocus, readViewFitContainerHeight: readViewFitContainerHeight = false, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false, value: value, readViewHighlightOnHover: readViewHighlightOnHover = true }, ref)=>{
    const isHiddenButtonFocused = hideEditButton && isEditButtonFocused;
    const isFocusRingVisible = isHiddenButtonFocused || isLoading;
    const isEditable = Boolean(context) && isEditInteractionEnabled;
    const { isVisibleOnHover: isVisibleOnHover } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const [isMouseOver, setIsMouseOver] = (0, $eJOHy.useState)(false);
    const handleOnHover = (0, $eJOHy.useCallback)(()=>setIsMouseOver(true), []);
    const handleOnLeave = (0, $eJOHy.useCallback)(()=>setIsMouseOver(false), []);
    const borderStyle = $6dcf29bcd23ed8fd$var$getBorderStyle({
        isFocusRingVisible: isFocusRingVisible,
        isInvalid: isInvalid,
        isCopied: isCopied
    });
    const childrenToRender = !isVisibleOnHover || value?.toString() || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(value) || isMouseOver ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6dcf29bcd23ed8fd$var$readViewHiddenUntilHoverStyle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$Container, {
        "data-testid": "issue-field-inline-edit-read-view-container.ui.container",
        "data-vc": "issue-field-inline-edit-read-view-container",
        readViewFitContainerHeight: readViewFitContainerHeight,
        isEditable: isEditable,
        onClick: onClick,
        onMouseDown: onMouseDown,
        role: "presentation",
        ref: ref,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        showOverflow: hasReadViewTruncateDisabled && !(0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting'),
        onFocus: handleOnHover,
        onBlur: handleOnLeave,
        onMouseEnter: handleOnHover,
        onMouseLeave: handleOnLeave,
        // Consumers may currently update non-visual styles dynamically based off isEditable prop.
        // Here we allow consumers to exclude the attachment of edit styles from VC calculation.
        // Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9211
        "data-vc-nvs": (0, $4cTDP.fg)('ignore_inline_edit_cell'),
        readViewHighlightOnHover: readViewHighlightOnHover,
        className: (0, $hcewu.default)([
            borderStyle && $6dcf29bcd23ed8fd$var$borderStyles[borderStyle]
        ])
    }, hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ejhcC.EditButtonHidden), {
        ref: editButtonRef,
        context: context ?? (0, $gFFoY.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$LoadingOverlay, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dcf29bcd23ed8fd$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null))) : childrenToRender, !hideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCuWH.EditButton), {
        ref: editButtonRef,
        context: context ?? (0, $gFFoY.EMPTY_INLINE_EDIT_CONTEXT),
        isDisabled: !isEditable,
        label: editButtonLabel,
        onBlur: onEditButtonBlur,
        onFocus: onEditButtonFocus,
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        /* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766, */ style: $6dcf29bcd23ed8fd$var$editButtonStyles
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dcf29bcd23ed8fd$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { readViewFitContainerHeight: readViewFitContainerHeight, showOverflow: showOverflow, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, isEditable: isEditable, readViewHighlightOnHover: readViewHighlightOnHover, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _zulpu2gc _189e1dm9 _1dqonqa1 _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _1e0c1txw _4cvr1h6o _vchhusvi _p12f1osq _kqswh2mm _16jlkb7n",
            __cmplp.readViewFitContainerHeight ? "_1tke1osq" : "_1tkezwfg",
            __cmplp.showOverflow ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.hasReadViewTruncateDisabled ? "_1bton7od" : "_1bto1l2s",
            __cmplp.isEditable && "_v56412tl",
            __cmplp.isEditable && __cmplp.readViewHighlightOnHover && "_irr3166n",
            __cmplp.isEditable && "_yyosidpf _37uft94y _1rr4t94y",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$editButtonStyles = {
    flexShrink: 0,
    marginLeft: 'auto',
    opacity: 'var(--edit-button-opacity, 0)'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6dcf29bcd23ed8fd$var$LoadingOverlay = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lcxvglyw _tzy4n2vs",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltv1ssb _154i1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $6dcf29bcd23ed8fd$var$readViewHiddenUntilHoverStyle = (0, $1DXK0.xcss)({
    visibility: 'hidden'
});
var $6dcf29bcd23ed8fd$export$2e2bcd8739ae039 = $6dcf29bcd23ed8fd$var$InlineEditReadViewContainer;

});
parcelRegister("gFFoY", function(module, exports) {
$parcel$export(module.exports, "EMPTY_INLINE_EDIT_CONTEXT", () => $01d5176cdfd5ecd4$export$817cfe3c303a8a15);

var $12DRg = parcelRequire("12DRg");
const $01d5176cdfd5ecd4$export$817cfe3c303a8a15 = {
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});

parcelRegister("ejhcC", function(module, exports) {
$parcel$export(module.exports, "EditButtonHidden", () => $c9cbb95271b5bc33$export$c2bd955fafbef8bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");
const $c9cbb95271b5bc33$export$c2bd955fafbef8bc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $bGUQI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9cbb95271b5bc33$var$HiddenButton, {
        "aria-label": finalEditButtonLabel,
        disabled: isDisabled,
        "aria-hidden": isDisabled,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: onEdit,
        ref: ref,
        type: "button"
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-html-button -- Ignored via go/DSP-18766
const $c9cbb95271b5bc33$var$HiddenButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jCuWH", function(module, exports) {
$parcel$export(module.exports, "EditButton", () => $b4e433ce880239a1$export$a8d3280cb45e38b8);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $gTr6H = parcelRequire("gTr6H");

var $lRq8t = parcelRequire("lRq8t");

var $bGUQI = parcelRequire("bGUQI");
const $b4e433ce880239a1$export$a8d3280cb45e38b8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ context: { onEdit: onEdit }, isDisabled: isDisabled, label: label, onBlur: onBlur, onFocus: onFocus, style: style }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const finalEditButtonLabel = label ?? formatMessage((0, $bGUQI.default).editButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "data-vc": "inline-edit-lite-edit-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))), {
            spacing: "spacious",
            label: finalEditButtonLabel,
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: isDisabled,
        "aria-hidden": isDisabled,
        onClick: onEdit,
        onBlur: onBlur,
        onFocus: onFocus,
        ref: ref,
        spacing: "none",
        // In future providing CSS variables *may* be something that makes its way into the design system, but
        // for now this is an acceptable override to prevent managing additional state with JS.
        // More context here https://atlassian.slack.com/archives/C060GTVV988/p1703214250865779?thread_ts=1703212675.166419&cid=C060GTVV988
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jira/react/no-style-attribute -- Ignored via go/DSP-18766
        style: style
    });
});

});


parcelRegister("kjtxW", function(module, exports) {
$parcel$export(module.exports, "CopyPasteContextProvider", () => $cafc82d5a6cd54a2$export$1afe5f1aa41cba74);
$parcel$export(module.exports, "useCopyPasteTarget", () => $cafc82d5a6cd54a2$export$6bdcb2980d85cb0f);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $cafc82d5a6cd54a2$var$CopyPasteContext = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $cafc82d5a6cd54a2$export$1afe5f1aa41cba74 = ({ children: children })=>{
    const copyPasteTarget = (0, $eJOHy.useRef)(null);
    const lastCopiedTarget = (0, $eJOHy.useRef)(null);
    const updateCopyPasteTarget = (0, $eJOHy.useCallback)((handlers)=>{
        copyPasteTarget.current = handlers;
    }, []);
    /** Update the last copied target if the copy event is explicitly handled. */ const updateLastCopiedTargetWhenHandled = (0, $eJOHy.useCallback)((handled, nextTarget)=>{
        if (!handled) return;
        // Clear previously copied target
        lastCopiedTarget.current?.onLastCopiedTarget(false);
        // Set next copied target
        nextTarget?.onLastCopiedTarget(true);
        lastCopiedTarget.current = nextTarget;
    }, []);
    const onCopy = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCopy(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onCut = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onCut(event) ?? false, copyPasteTarget.current);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    const onPaste = (0, $eJOHy.useCallback)((event)=>{
        updateLastCopiedTargetWhenHandled(copyPasteTarget.current?.onPaste(event) ?? false, null);
    }, [
        updateLastCopiedTargetWhenHandled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        globalThis.document.addEventListener('copy', onCopy);
        globalThis.document.addEventListener('cut', onCut);
        globalThis.document.addEventListener('paste', onPaste, true);
        return ()=>{
            globalThis.document.removeEventListener('copy', onCopy);
            globalThis.document.removeEventListener('cut', onCut);
            globalThis.document.removeEventListener('paste', onPaste, true);
        };
    }, [
        onCopy,
        onCut,
        onPaste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cafc82d5a6cd54a2$var$CopyPasteContext.Provider, {
        value: updateCopyPasteTarget
    }, children);
};
const $cafc82d5a6cd54a2$export$6bdcb2980d85cb0f = ({ onCopy: onCopy, onCut: onCut, onPaste: onPaste })=>{
    const updateCopyPasteTarget = (0, $eJOHy.useContext)($cafc82d5a6cd54a2$var$CopyPasteContext);
    const [lastCopiedTarget, setLastCopiedTarget] = (0, $eJOHy.useState)(false);
    // Track callbacks as refs so they can be invoked using a stable function reference
    const onCopyRef = (0, $eJOHy.useRef)(onCopy);
    onCopyRef.current = onCopy;
    const onCutRef = (0, $eJOHy.useRef)(onCut);
    onCutRef.current = onCut;
    const onPasteRef = (0, $eJOHy.useRef)(onPaste);
    onPasteRef.current = onPaste;
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        // Ensure stable function reference is provided as the callback functions are only bound to the document once
        const stableCopy = (event)=>onCopyRef.current?.(event) ?? false;
        const stableCut = (event)=>onCutRef.current?.(event) ?? false;
        const stablePaste = (event)=>onPasteRef.current?.(event) ?? false;
        /* Queue as a microtask to ensure the blur callback is emitted before calling updateCopyPasteTarget when
		 * navigating between targets. */ queueMicrotask(()=>{
            updateCopyPasteTarget({
                onCopy: stableCopy,
                onCut: stableCut,
                onPaste: stablePaste,
                onLastCopiedTarget: setLastCopiedTarget
            });
        });
    }, [
        updateCopyPasteTarget
    ]);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        updateCopyPasteTarget(null);
    }, [
        updateCopyPasteTarget
    ]);
    return {
        lastCopiedTarget: lastCopiedTarget,
        onFocus: onFocus,
        onBlur: onBlur
    };
};

});



parcelRegister("6TknG", function(module, exports) {
$parcel$export(module.exports, "ReadViewNonEditable", () => $cf90f517f772227d$export$4efb4956550fac52);

var $eJOHy = parcelRequire("eJOHy");

var $k4Rl5 = parcelRequire("k4Rl5");
const $cf90f517f772227d$export$4efb4956550fac52 = ({ children: children, hideEditButton: hideEditButton, isLoading: isLoading, readViewFitContainerHeight: readViewFitContainerHeight, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled, readViewHighlightOnHover: readViewHighlightOnHover })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4Rl5.default), {
        hideEditButton: hideEditButton,
        isLoading: isLoading,
        readViewFitContainerHeight: readViewFitContainerHeight,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        readViewHighlightOnHover: readViewHighlightOnHover
    }, children);

});


parcelRegister("9McQo", function(module, exports) {
$parcel$export(module.exports, "projectPickerEntrypoint", () => $c4b26cf04f7c5c0b$export$942637108617a018);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4OtOO = parcelRequire("4OtOO");
const $c4b26cf04f7c5c0b$var$fetchPolicy = 'store-or-network';

const $c4b26cf04f7c5c0b$export$942637108617a018 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("euq18")).then(({ ProjectPickerWithEntrypoint: ProjectPickerWithEntrypoint })=>ProjectPickerWithEntrypoint), {
        moduleId: "49b4106c",
        moduleName: "ProjectPicker",
        priority: "interaction",
        moduleId: 'project-picker-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                projectPickerQuery: {
                    parameters: (0, $4OtOO.default),
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $c4b26cf04f7c5c0b$var$fetchPolicy
                    }
                }
            }
        })
});

});
parcelRegister("4OtOO", function(module, exports) {
$parcel$export(module.exports, "default", () => $900151cd3a581f9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d364fb3d7691afc7a9753da59d0a91af>>
 * @relayHash fe6ed7432af1a3342bf7ae86b5667b67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74f3acf7195af915f9968961a5fb9e989f33a9b3cba830de48d0aab93c7eec51
const $900151cd3a581f9d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPickerAtlasQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ProjectPicker_Atlas"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPickerAtlasQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "cloudId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "concreteType": "TownsquareUnshardedUserCapabilities",
                                            "kind": "LinkedField",
                                            "name": "userCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUnshardedCapability",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "capability"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "capabilityContainer"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "74f3acf7195af915f9968961a5fb9e989f33a9b3cba830de48d0aab93c7eec51",
            "metadata": {},
            "name": "ProjectPickerAtlasQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$900151cd3a581f9d$var$node.hash = "2948919b46c076b76def512ee4c32b35";
var $900151cd3a581f9d$export$2e2bcd8739ae039 = $900151cd3a581f9d$var$node;

});

parcelRegister("euq18", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("7mXtG")
]).then(()=>parcelRequire('aECgo'));

});


parcelRegister("47YLd", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectEmptytView", () => $fb18749c66bfb73c$export$c37c7436101c336a);
$parcel$export(module.exports, "AtlasProjectReadView", () => $fb18749c66bfb73c$export$5d49fcebb0d1908b);

var $c2hFC = parcelRequire("c2hFC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $aZLCL = parcelRequire("aZLCL");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $cuxZE = parcelRequire("cuxZE");

var $9yG0T = parcelRequire("9yG0T");
const $fb18749c66bfb73c$var$styles = {
    container: "_ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _4t3izwfg _1bsb1osq _y3gn1e5h _1e0c1txw _4cvr1h6o"
};
const $fb18749c66bfb73c$export$c37c7436101c336a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fb18749c66bfb73c$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $9yG0T.default).emptyFieldText)
    }));
}; /**
    * The AtlasProjectReadView will show a read only view of AtlasProject field.
    * @param props [AtlasProjectReadViewProps](./types.tsx)
    */ 
const $fb18749c66bfb73c$export$5d49fcebb0d1908b = ({ fragmentRef: fragmentRef, onHandleNoAccess: onHandleNoAccess, showNoAccessTooltip: showNoAccessTooltip })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { project: project, isLinkEditable: isLinkEditable, issue: issue } = (0, $j4oe4.useFragment)((0, $c2hFC.default), fragmentRef);
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $9yG0T.default).emptyFieldText)
    });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cuxZE.AtlasProjectSmartLink), {
        projectAri: project.id,
        projectKey: project.atlasProjectKey,
        name: project.atlasProjectName,
        isPrivate: !!project.privateProject,
        isInherited: isLinkEditable === false,
        issueAri: issue?.id,
        initialHasNoAccess: project?.hasPermission === false || project?.isWorkspaceActive === false,
        onHandleNoAccess: onHandleNoAccess
    });
    if (showNoAccessTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aZLCL.RestrictedTooltipHotspot), {
        message: formatMessage((0, $9yG0T.default).noAccessTooltip)
    }, content);
    return content;
};

});
parcelRegister("c2hFC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec7672e5f0253442$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce0eb7ce66b1914471dec120ca392a23>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ec7672e5f0253442$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isLinkEditable"
            },
            {
                "concreteType": "JiraTownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "project.id"
                    },
                    {
                        "alias": "atlasProjectKey",
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "alias": "atlasProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "privateProject"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWorkspaceActive"
                    }
                ]
            },
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "issue.id"
                    }
                ]
            }
        ],
        "type": "JiraTownsquareProjectField"
    };
}();
$ec7672e5f0253442$var$node.hash = "87020946b61803dccd36df8793fbe401";
var $ec7672e5f0253442$export$2e2bcd8739ae039 = $ec7672e5f0253442$var$node;

});

parcelRegister("aZLCL", function(module, exports) {
$parcel$export(module.exports, "RestrictedTooltipHotspot", () => $249475836b92bc26$export$75ec3e3445fa376c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");
const $249475836b92bc26$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bsb1osq",
    hotspotWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    hotspot: "_1e0c1ule _4t3igktf"
};
const $249475836b92bc26$export$75ec3e3445fa376c = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, message: message, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $249475836b92bc26$var$styles.container,
        testId: testId
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $249475836b92bc26$var$styles.hotspotWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "span",
        xcss: $249475836b92bc26$var$styles.hotspot
    })))));
$249475836b92bc26$export$75ec3e3445fa376c.displayName = 'RestrictedTooltipHotspot';

});

parcelRegister("d9T1A", function(module, exports) {
$parcel$export(module.exports, "EmptyFieldText", () => $dd0e40972cfd3cc1$export$f6d716da5f11cd01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $3Lkm9 = parcelRequire("3Lkm9");
const $dd0e40972cfd3cc1$export$f6d716da5f11cd01 = ({ emptyText: emptyText, placeholderText: placeholderText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dd0e40972cfd3cc1$var$EmptyValueStyleWrapper, null, emptyText ?? formatMessage(placeholderText ?? (0, $3Lkm9.default).emptyFieldText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $dd0e40972cfd3cc1$var$EmptyValueStyleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _syaz131l _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Lkm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4a1e0054ae710f1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a4a1e0054ae710f1$var$messages = (0, $7qGN1.defineMessages)({
    emptyFieldText: {
        "id": "issue-empty-field-text.empty-field-text",
        "defaultMessage": "None"
    },
    bespokenDateTimePlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-date-time-placeholder-empty-field-text",
        "defaultMessage": "Add date"
    },
    bespokenSingleGroupPickerPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-single-group-placeholder-empty-field-text",
        "defaultMessage": "Add group"
    },
    bespokenMultiGroupPickerPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-multi-group-placeholder-empty-field-text",
        "defaultMessage": "Add groups"
    },
    bespokenCascadingSelectPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-cascading-select-placeholder-empty-field-text",
        "defaultMessage": "Add option"
    },
    bespokenSingleSelectPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-single-select-placeholder-empty-field-text",
        "defaultMessage": "Add option"
    },
    bespokenUrlPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-url-placeholder-empty-field-text",
        "defaultMessage": "Add URL"
    },
    bespokenTextPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-text-placeholder-empty-field-text",
        "defaultMessage": "Add text"
    },
    bespokenMultiSelectPlaceholderEmptyFieldText: {
        "id": "issue-empty-field-text.bespoken-multi-select-placeholder-empty-field-text",
        "defaultMessage": "Add options"
    }
});
var $a4a1e0054ae710f1$export$2e2bcd8739ae039 = $a4a1e0054ae710f1$var$messages;

});


parcelRegister("cuxZE", function(module, exports) {
$parcel$export(module.exports, "AtlasProjectSmartLink", () => $de9b775b07545d7a$export$63acba7661050605);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $lRq8t = parcelRequire("lRq8t");

var $b8OI0 = parcelRequire("b8OI0");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $fRm4z = parcelRequire("fRm4z");

var $baxj2 = parcelRequire("baxj2");

var $90YnL = parcelRequire("90YnL");

var $k3JEF = parcelRequire("k3JEF");

var $cSWVe = parcelRequire("cSWVe");

var $g0jL2 = parcelRequire("g0jL2");

var $evtSI = parcelRequire("evtSI");
const $de9b775b07545d7a$var$styles = {
    container: "_y4tiu2gc"
};
const $de9b775b07545d7a$var$EntryPointWrapper = ({ children: children, onClose: onClose, onInheritancePopupOpen: onInheritancePopupOpen, issueAri: issueAri, linkedProject: linkedProject })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $baxj2.inheritancePopupEntryPoint),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $90YnL.InheritancePopupSkeleton), null),
        errorFallback: (0, $k3JEF.InheritancePopupErrorFallback),
        entryPointProps: {
            onInheritancePopupOpen: onInheritancePopupOpen,
            issueAri: issueAri,
            linkedProject: linkedProject
        },
        entryPointParams: {
            issueId: issueAri
        },
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default // eslint-disable-next-line react/jsx-props-no-spreading
            ), triggerProps, children),
        placement: "bottom",
        zIndex: 600
    });
};
const $de9b775b07545d7a$export$63acba7661050605 = ({ projectAri: projectAri, projectKey: projectKey, isInherited: isInherited, isPrivate: isPrivate, issueAri: issueAri, initialHasNoAccess: initialHasNoAccess, onHandleNoAccess: onHandleNoAccess, name: name })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructAtlasProjectUrl = (0, $fRm4z.useProjectUrlConstructor)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isPinned, setIsPinned] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const containerRef = (0, $eJOHy.useRef)(null);
    const shouldShowActions = isInherited && (isHovered || isFocused || isPinned);
    const projectUrl = (0, $eJOHy.useMemo)(()=>projectKey ? constructAtlasProjectUrl({
            ari: projectAri,
            projectKey: projectKey
        }) : null, [
        constructAtlasProjectUrl,
        projectAri,
        projectKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!issueAri || !isInherited) return [];
        return [
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                onClick: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'inheritedButton'
                    }));
                },
                content: formatMessage((0, $evtSI.default).inheritedProject),
                tooltipMessage: formatMessage((0, $evtSI.default).inheritedProjectTooltip),
                hideIcon: true,
                entryPointWrapper: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($de9b775b07545d7a$var$EntryPointWrapper, {
                        ...p,
                        onClose: ()=>setIsPinned(false),
                        onInheritancePopupOpen: ()=>setIsPinned(true),
                        issueAri: issueAri,
                        linkedProject: {
                            projectUrl: projectUrl,
                            isRestricted: initialHasNoAccess
                        }
                    })
            }
        ];
    }, [
        issueAri,
        isInherited,
        formatMessage,
        createAnalyticsEvent,
        projectUrl,
        initialHasNoAccess
    ]);
    if (projectUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        ref: containerRef,
        testId: "issue-field-atlas-project-common.ui.atlas-project-smart-link.container",
        xcss: !isInherited && $de9b775b07545d7a$var$styles.container,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onMouseDown: ()=>{
            // this is covering an edge case where user clicks inherit button to close the popup, it won't lose focus so we have to help it a little
            if (isPinned) setIsFocused(false);
        },
        onFocus: ()=>setIsFocused(true),
        onBlur: (event)=>{
            // Check if focus is moving outside the container
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) setIsFocused(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g0jL2.SimpleInlineSmartLink), {
        anchorTarget: "_blank",
        url: projectUrl,
        metadata: [],
        actions: shouldShowActions ? actions : undefined,
        initialHasNoAccess: initialHasNoAccess,
        projectAri: projectAri,
        showNoAccessPopup: isInherited === false,
        isPrivate: isPrivate,
        onHandleNoAccess: onHandleNoAccess,
        text: (0, $4cTDP.fg)('project_ssr_smart_card') ? name || undefined : undefined
    }));
     // handle no project key returned
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSWVe.RestrictedAlikeSmartLink), null);
};

});
parcelRegister("baxj2", function(module, exports) {
$parcel$export(module.exports, "inheritancePopupEntryPoint", () => $ea2016e2a194da4e$export$8a532031d2a56f2b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $2PF9b = parcelRequire("2PF9b");
const $ea2016e2a194da4e$var$fetchPolicy = 'network-only';

const $ea2016e2a194da4e$export$8a532031d2a56f2b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7r0eb")), {
        moduleId: "23f80e0f",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                inheritancePopupQuery: {
                    parameters: (0, $2PF9b.default),
                    variables: {
                        issueId: issueId
                    },
                    options: {
                        fetchPolicy: $ea2016e2a194da4e$var$fetchPolicy
                    }
                }
            }
        })
});

});
parcelRegister("2PF9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $024d7ee124a59044$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0be8da337a05a02cca34308a95fc576a>>
 * @relayHash b08192541f6dadc77d4bacab16163a55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 207bfd7c801f72741185aa635e9c24c24c7bcd9a889d5f6ecfaa69eeeb0d35ce
const $024d7ee124a59044$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "inheritancePopupQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueTownsquareProjectLink",
                            "kind": "LinkedField",
                            "name": "getProjectLinkInheritanceSources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "inheritancePopup_issueFieldAtlasProjectCommon_InheritancePopupContent"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "inheritancePopupQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueTownsquareProjectLink",
                            "kind": "LinkedField",
                            "name": "getProjectLinkInheritanceSources",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                        },
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "xsmall"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "linkType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "207bfd7c801f72741185aa635e9c24c24c7bcd9a889d5f6ecfaa69eeeb0d35ce",
            "metadata": {},
            "name": "inheritancePopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$024d7ee124a59044$var$node.hash = "600dd4544a21bd6cf3876c430837d737";
var $024d7ee124a59044$export$2e2bcd8739ae039 = $024d7ee124a59044$var$node;

});

parcelRegister("7r0eb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c0oLq").then(()=>parcelRequire('eFczo'));

});


parcelRegister("90YnL", function(module, exports) {
$parcel$export(module.exports, "InheritancePopupSkeleton", () => $fdcb45bd89f527a1$export$87daa27b1369b050);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $jjS5D = parcelRequire("jjS5D");
const $fdcb45bd89f527a1$var$styles = {
    container: "_1bsb1byl",
    topSection: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    bottomSection: "_1bsb1byl _4t3ip3fh _mrkb1mok _1o0z1mok _bfhkn82g"
};
const $fdcb45bd89f527a1$export$87daa27b1369b050 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fdcb45bd89f527a1$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200",
        xcss: $fdcb45bd89f527a1$var$styles.topSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "170px",
        height: "24px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "426px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "344px",
        height: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "152px",
        height: "16px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $fdcb45bd89f527a1$var$styles.bottomSection
    }));

});

parcelRegister("k3JEF", function(module, exports) {
$parcel$export(module.exports, "InheritancePopupErrorFallback", () => $617b2940a3c56b8b$export$cafc10054684fdbb);
/* error-fallback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $iHPvF = parcelRequire("iHPvF");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $59JiD = parcelRequire("59JiD");
const $617b2940a3c56b8b$var$styles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $617b2940a3c56b8b$export$cafc10054684fdbb = ()=>{
    const intl = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inheritancePopup'
        }), {
            hasError: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $617b2940a3c56b8b$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        title: intl.formatMessage((0, $59JiD.default).errorLoadingInheritancePopupTitle)
    }, intl.formatMessage((0, $59JiD.default).errorLoadingInheritancePopupMessage)));
};

});
parcelRegister("iHPvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});




parcelRegister("59JiD", function(module, exports) {
$parcel$export(module.exports, "default", () => $acfd36dd9b68efaa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $acfd36dd9b68efaa$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-atlas-project-common.inheritance-popup.title",
        "defaultMessage": "Inherited project"
    },
    description: {
        "id": "issue-field-atlas-project-common.inheritance-popup.description",
        "defaultMessage": "This work item\u2019s project comes from its parent work item. To change the project, select {workItemKey} below."
    },
    restrictedDescriptionTwoLevels: {
        "id": "issue-field-atlas-project-common.inheritance-popup.restricted-description-two-levels",
        "defaultMessage": "This project comes from its parent work item, which you don\u2019t have access to. Contact your admin if you want to change this project."
    },
    restrictedDescriptionThreeOrMoreLevels: {
        "id": "issue-field-atlas-project-common.inheritance-popup.restricted-description-three-or-more-levels",
        "defaultMessage": "This project comes from a work item that you don\u2019t have access to. Contact your admin if you want to change this project."
    },
    moreInformation: {
        "id": "issue-field-atlas-project-common.inheritance-popup.more-information",
        "defaultMessage": "More on project inheritance"
    },
    errorLoadingInheritancePopupTitle: {
        "id": "issue-field-atlas-project-common.inheritance-popup.error-loading.title",
        "defaultMessage": "We couldn't load the inheritance details"
    },
    errorLoadingInheritancePopupMessage: {
        "id": "issue-field-atlas-project-common.inheritance-popup.error-loading.message",
        "defaultMessage": "Check your connection, then try again."
    }
});
var $acfd36dd9b68efaa$export$2e2bcd8739ae039 = $acfd36dd9b68efaa$var$messages;

});


parcelRegister("evtSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde4f3074d53482f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cde4f3074d53482f$var$messages = (0, $7qGN1.defineMessages)({
    inheritedProject: {
        "id": "issue-field-atlas-project-common.atlas-project-smart-link.inherited-project",
        "defaultMessage": "Inherited"
    },
    inheritedProjectTooltip: {
        "id": "issue-field-atlas-project-common.atlas-project-smart-link.inherited-project.tooltip",
        "defaultMessage": "Learn where this project comes from"
    }
});
var $cde4f3074d53482f$export$2e2bcd8739ae039 = $cde4f3074d53482f$var$messages;

});


parcelRegister("9yG0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $17b53aeccf8f2dd1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $17b53aeccf8f2dd1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyFieldText: {
        "id": "issue-field-atlas-project-readview-full.atlas-project.empty-field-text",
        "defaultMessage": "Add project"
    },
    noAccessTooltip: {
        "id": "issue-field-atlas-project-readview-full.atlas-project.no-access-tooltip",
        "defaultMessage": "You need edit permission on this private project to unlink it from this work item."
    }
});

});


parcelRegister("auNLL", function(module, exports) {
$parcel$export(module.exports, "InlineEditFieldInjectionsContext", () => $24da2a466c96bb11$export$5b3426c89ef7f7de);
$parcel$export(module.exports, "useInlineEditFieldInjections", () => $24da2a466c96bb11$export$23de4844126025dd);

var $eJOHy = parcelRequire("eJOHy");

var $kLKe4 = parcelRequire("kLKe4");
const $24da2a466c96bb11$var$initialValue = {
    overriding: {
        overrideLabel: (0, $kLKe4.identity),
        overrideDescription: (0, $kLKe4.identity),
        overrideIsEditable: (0, $kLKe4.identity),
        overrideFieldOptionsFilter: (0, $kLKe4.identity)
    }
};
const $24da2a466c96bb11$export$5b3426c89ef7f7de = /*#__PURE__*/ (0, $eJOHy.createContext)($24da2a466c96bb11$var$initialValue);
const $24da2a466c96bb11$export$23de4844126025dd = ()=>(0, $eJOHy.useContext)($24da2a466c96bb11$export$5b3426c89ef7f7de);

});
parcelRegister("kLKe4", function(module, exports) {
$parcel$export(module.exports, "identity", () => $f351f1a309dc1227$export$f0954fd7d5368655);
$parcel$export(module.exports, "FieldInjectionsContext", () => $f351f1a309dc1227$export$a6ff76841695c6c0);

var $eJOHy = parcelRequire("eJOHy");
// Replace empty function with noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $f351f1a309dc1227$var$noop = ()=>{};
const $f351f1a309dc1227$export$f0954fd7d5368655 = (x)=>x;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f351f1a309dc1227$var$initialValue = {
    capturing: {
        captureAllowedValues: $f351f1a309dc1227$var$noop,
        captureDescription: $f351f1a309dc1227$var$noop,
        captureFieldId: $f351f1a309dc1227$var$noop,
        captureFieldType: $f351f1a309dc1227$var$noop,
        captureIsDisabled: $f351f1a309dc1227$var$noop,
        captureIsRequired: $f351f1a309dc1227$var$noop,
        captureLabel: $f351f1a309dc1227$var$noop,
        captureRenderer: $f351f1a309dc1227$var$noop
    },
    overriding: {
        overrideLabel: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideElementAfterLabel: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideIsRequired: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideIsDisabled: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideAllowedValues: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideFieldOptionsFilter: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideOnChange: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideOnBlur: $f351f1a309dc1227$export$f0954fd7d5368655,
        overrideDescription: $f351f1a309dc1227$export$f0954fd7d5368655
    }
};
const $f351f1a309dc1227$export$a6ff76841695c6c0 = /*#__PURE__*/ (0, $eJOHy.createContext)($f351f1a309dc1227$var$initialValue);

});


parcelRegister("jXGTZ", function(module, exports) {
$parcel$export(module.exports, "LINK_MUTATION_ERROR_TYPES", () => $2206d6e13172df60$export$180e4e80606c5318);
const $2206d6e13172df60$export$180e4e80606c5318 = {
    CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT: 'CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT'
};

});

parcelRegister("ebGhx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c49ad0ad0cfe8a9a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c49ad0ad0cfe8a9a$var$messages = (0, $7qGN1.defineMessages)({
    childIssueAlreadyLinkedNoReplaceTitle: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.title",
        "defaultMessage": "Can't link project"
    },
    childIssueAlreadyLinkedNoReplaceDescription: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.description",
        "defaultMessage": "This work item has child items linked to another project. Since you don't have permission to edit those child items, this project can't be linked here. "
    },
    childIssueAlreadyLinkedNoReplaceAction: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.action",
        "defaultMessage": "More on project inheritance"
    }
});
var $c49ad0ad0cfe8a9a$export$2e2bcd8739ae039 = $c49ad0ad0cfe8a9a$var$messages;

});

const $a1452414e695131e$export$228ddfe2e1c9e3bf = 'https://support.atlassian.com/platform-experiences/docs/link-goals-and-projects-to-work-in-jira/';

parcelRegister("5mlwW", function(module, exports) {
$parcel$export(module.exports, "LinkConfirmationModal", () => $f6eda955cd1add2e$export$c3ca8865f7a1438f);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lJKII = parcelRequire("lJKII");

var $lRq8t = parcelRequire("lRq8t");


var $eTfPS = parcelRequire("eTfPS");
const $f6eda955cd1add2e$export$c3ca8865f7a1438f = ({ onClose: onClose, onLink: onLink })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.modal-dialog.confirmation-modal",
        messageType: "transactional",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $eTfPS.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $eTfPS.default).description, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: (0, $a1452414e695131e$export$228ddfe2e1c9e3bf),
                target: "_blank"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $eTfPS.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "warning",
        onClick: onLink
    }, formatMessage((0, $eTfPS.default).linkButton))));
};

});
parcelRegister("eTfPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $304c467e938d6cd3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $304c467e938d6cd3$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.title",
        "defaultMessage": "Some child items are linked to other projects"
    },
    description: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.description",
        "defaultMessage": "Linking this project will also replace the project for all child items under this work item. <Link>More on project inheritance</Link>"
    },
    cancelButton: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    linkButton: {
        "id": "issue-field-atlas-project-inline-edit-full.ui.atlas-project.link-confirmation-modal.link-button",
        "defaultMessage": "Link work item"
    }
});
var $304c467e938d6cd3$export$2e2bcd8739ae039 = $304c467e938d6cd3$var$messages;

});


parcelRegister("8htSu", function(module, exports) {
$parcel$export(module.exports, "useAtlasProjectAnalyticsEvent", () => $623688ff325eecfa$export$15a2c3c010ae5556);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $623688ff325eecfa$var$DEFAULT_ACTION_SUBJECT = 'project';
const $623688ff325eecfa$export$15a2c3c010ae5556 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAtlasProjectAnalyticsEvent = (0, $eJOHy.useCallback)(({ event: event, analyticsAttributes: analyticsAttributes, action: action, actionSubject: actionSubject = $623688ff325eecfa$var$DEFAULT_ACTION_SUBJECT })=>{
        if (event === 'operational') {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`, analyticsAttributes);
            return;
        }
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`, analyticsAttributes);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAtlasProjectAnalyticsEvent: fireAtlasProjectAnalyticsEvent
    };
};

});


parcelRegister("4vHFI", function(module, exports) {
$parcel$export(module.exports, "INLINE_EDIT_ANALYTICS_ATTRIBUTES", () => $91288825d5f914de$export$a659dfe9528cfc57);
// Attributes for inline editing track events
const $91288825d5f914de$export$a659dfe9528cfc57 = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};

});


parcelRegister("1iVG2", function(module, exports) {
$parcel$export(module.exports, "LoadingCell", () => $be7d804ab43d5c91$export$5191481abee8295e);

var $eJOHy = parcelRequire("eJOHy");

var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $4cTDP = parcelRequire("4cTDP");

var $bKlUQ = parcelRequire("bKlUQ");
const $be7d804ab43d5c91$export$5191481abee8295e = ({ cellBorder: cellBorder, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasRightShadow: hasRightShadow })=>{
    const cellBorderStylesFg = (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $be7d804ab43d5c91$var$cellBorderStyles : $be7d804ab43d5c91$var$cellBorderStylesOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: cellBorder ?? cellBorderStylesFg,
        isColumnSticky: isColumnSticky,
        stickyOffsets: stickyOffsets,
        hasRightShadow: hasRightShadow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        testId: "native-issue-table.common.ui.issue-cells.loading-cell",
        height: "16px",
        width: "100%",
        borderRadius: "3px"
    }));
};
const $be7d804ab43d5c91$var$cellBorderStylesOld = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderTopWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderBottomWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderLeftWidth: '0',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    borderRightWidth: 'border.width'
});
const $be7d804ab43d5c91$var$cellBorderStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderBlockStartWidth: '0',
    borderBlockEndWidth: 'border.width',
    borderInlineStartWidth: '0',
    borderInlineEndWidth: 'border.width'
});

});

parcelRegister("9ZBXb", function(module, exports) {
$parcel$export(module.exports, "CheckboxSelectCell", () => $0c9ab47539bc080b$export$1fd5a9db1fedc6bb);

var $fe4Ll = parcelRequire("fe4Ll");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4l5Js = parcelRequire("4l5Js");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $0c9ab47539bc080b$export$1fd5a9db1fedc6bb = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $fe4Ll.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l5Js.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $0c9ab47539bc080b$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l5Js.CheckboxSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        menuPosition: "fixed",
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isTruncated: true,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
    });
};
const $0c9ab47539bc080b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $0c9ab47539bc080b$var$customTargetStyles : $0c9ab47539bc080b$var$customTargetStylesOld,
        ref: ref
    });
});
const $0c9ab47539bc080b$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $0c9ab47539bc080b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("fe4Ll", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c6ea215ff017cc2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79139860b4500454d765dbfc4a21186e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c6ea215ff017cc2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "CheckboxSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCheckboxesField"
};
$3c6ea215ff017cc2$var$node.hash = "c8b91de26aff0acbf897cc9f413e2f3a";
var $3c6ea215ff017cc2$export$2e2bcd8739ae039 = $3c6ea215ff017cc2$var$node;

});

parcelRegister("4l5Js", function(module, exports) {
$parcel$export(module.exports, "CheckboxSelectInlineEditViewWithIsEditable", () => $d58acf5f3ab7c8b2$export$1b3be05b9a6273f2);

var $ioZ2j = parcelRequire("ioZ2j");

var $fktbb = parcelRequire("fktbb");

var $gb8GX = parcelRequire("gb8GX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8Y7vF = parcelRequire("8Y7vF");

var $ifQgt = parcelRequire("ifQgt");

var $auNLL = parcelRequire("auNLL");
const $d58acf5f3ab7c8b2$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-checkbox-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $d58acf5f3ab7c8b2$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $d58acf5f3ab7c8b2$export$1b3be05b9a6273f2 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupTarget: editViewPopupTarget, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $gb8GX.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $fktbb.default));
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.id ?? '',
                label: edge?.node?.value ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateCheckboxesField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateCheckboxesField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            value: edge.label ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $d58acf5f3ab7c8b2$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'checkboxSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d58acf5f3ab7c8b2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifQgt.CheckboxSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled
        })), [
        data,
        isTruncated,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8Y7vF.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $d58acf5f3ab7c8b2$export$110d4fbf3ef97d6 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $ioZ2j.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d58acf5f3ab7c8b2$export$1b3be05b9a6273f2, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("ioZ2j", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9d34824802c4510$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<865dcb3c94a5735613636474e65b5c54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9d34824802c4510$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$d9d34824802c4510$var$node.hash = "578907f93847166d177912bba783cc44";
var $d9d34824802c4510$export$2e2bcd8739ae039 = $d9d34824802c4510$var$node;

});

parcelRegister("fktbb", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a09d1cb9cb0011a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a674bc11003d5a4f6042bd041448c62>>
 * @relayHash 2f2935fb2f2e43d33d4c8ed1e1b2cd67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e
const $2a09d1cb9cb0011a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCheckboxesFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCheckboxesField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCheckboxesField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8540386bf8ddcde1b4f569318aad611087a8b356d205fa2274ec5675ba438f8e",
            "metadata": {},
            "name": "checkboxSelect_issueFieldCheckboxSelect_CheckboxSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2a09d1cb9cb0011a$var$node.hash = "8471c6b898ae5a82094ee733778542d4";
var $2a09d1cb9cb0011a$export$2e2bcd8739ae039 = $2a09d1cb9cb0011a$var$node;

});

parcelRegister("gb8GX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3fe594bc152f312$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e85c1b6294972f8a4727536d560cd70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3fe594bc152f312$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCheckboxesField"
    };
}();
$e3fe594bc152f312$var$node.hash = "949a32b9c93f1898a846b4634eca9e93";
var $e3fe594bc152f312$export$2e2bcd8739ae039 = $e3fe594bc152f312$var$node;

});

parcelRegister("8Y7vF", function(module, exports) {
$parcel$export(module.exports, "default", () => $76c3753d64a477f9$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $76c3753d64a477f9$var$CheckboxSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("izioT")), {
        moduleId: "6225fccd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $76c3753d64a477f9$export$2e2bcd8739ae039 = $76c3753d64a477f9$var$CheckboxSelectEditViewEntryPoint;

});
parcelRegister("izioT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("561TQ").then(()=>parcelRequire('cg7du'));

});


parcelRegister("ifQgt", function(module, exports) {
$parcel$export(module.exports, "CheckboxSelectReadView", () => $660041d08f4602e0$export$9aaea694d3042383);

var $5MZfY = parcelRequire("5MZfY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $fI7RQ = parcelRequire("fI7RQ");
const $660041d08f4602e0$export$9aaea694d3042383 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $5MZfY.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedOptions = data?.selectedOptions?.edges?.filter((edge)=>Boolean(edge?.node?.value)).map((edge)=>({
            name: edge?.node?.value || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isHoverPopoverEnabled && $660041d08f4602e0$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedOptions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $fI7RQ.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $660041d08f4602e0$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            key: value.key,
            text: value.name
        })));
};
const $660041d08f4602e0$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $660041d08f4602e0$var$widthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("5MZfY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e9593a3d50f3042$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e66798db69b7174dc3e67181cb94bce4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e9593a3d50f3042$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "checkboxSelect_issueFieldCheckboxSelectReadviewFull_CheckboxSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCheckboxesField"
};
$3e9593a3d50f3042$var$node.hash = "d4b0ebe1c72d70b5bd1191947a37e196";
var $3e9593a3d50f3042$export$2e2bcd8739ae039 = $3e9593a3d50f3042$var$node;

});

parcelRegister("fI7RQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $178b1865ab14869a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $178b1865ab14869a$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-checkbox-select-readview-full.checkbox-select.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});
var $178b1865ab14869a$export$2e2bcd8739ae039 = $178b1865ab14869a$var$messages;

});




parcelRegister("1pe67", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectsCell", () => $bb7d4c8fd6edd603$export$eebc6db46b17b7b3);

var $c39UU = parcelRequire("c39UU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $bYOuG = parcelRequire("bYOuG");

var $P01So = parcelRequire("P01So");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $lIbdr = parcelRequire("lIbdr");

var $aVDPt = parcelRequire("aVDPt");
const $bb7d4c8fd6edd603$var$CELL_TYPE = 'cmdbObjects';
const $bb7d4c8fd6edd603$export$eebc6db46b17b7b3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $c39UU.default), fieldRef);
    const errors = data?.selectedCmdbObjectsConnection?.errors?.map((error)=>error?.message);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (errors?.length) // At time of writing, these errors are not wired up on the issue backend. However we will maintain this
    // logging so that it is present if/when it is wired up so we can get error information immediately.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: $bb7d4c8fd6edd603$var$CELL_TYPE,
        reason: `Errors present: ${errors.length} - ${errors.join(', ')}; Edges present: ${data?.selectedCmdbObjectsConnection?.edges?.length}`
    });
    const objects = data?.selectedCmdbObjectsConnection?.edges;
    const filteredObjectsWithMedia = objects?.map((edge)=>{
        if (!edge?.node?.label) return null;
        let mediaImage;
        const iconUrl = edge.node.avatar?.url48 ?? undefined;
        if (edge.node.avatar?.mediaClientConfig?.clientId && edge.node.avatar?.mediaClientConfig?.fileId && edge.node.avatar?.mediaClientConfig?.mediaBaseUrl && edge.node.avatar?.mediaClientConfig?.mediaJwtToken) {
            const identifier = {
                id: edge.node.avatar.mediaClientConfig.fileId,
                mediaItemType: 'file'
            };
            const clientBasedAuth = {
                clientId: edge.node.avatar.mediaClientConfig.clientId,
                token: edge.node.avatar.mediaClientConfig.mediaJwtToken,
                baseUrl: edge.node.avatar.mediaClientConfig.mediaBaseUrl
            };
            const mediaClientConfig = {
                authProvider: ()=>Promise.resolve(clientBasedAuth)
            };
            mediaImage = {
                identifier: identifier,
                mediaClientConfig: mediaClientConfig
            };
        }
        return {
            key: edge.node.objectId || 'missingId',
            name: edge.node.label,
            href: (0, $4cTDP.fg)('assets_as_an_app_v2') ? (0, $bYOuG.createObjectDetailUrl)(edge.node.objectId || '') : (0, $lIbdr.createObjectDetailUrl)(edge.node.objectId || ''),
            icon: {
                url: !mediaImage ? iconUrl : undefined,
                mediaImage: mediaImage
            }
        };
    }).filter((0, $P01So.isNonNullish)) ?? [];
    if (!objects || objects.length !== filteredObjectsWithMedia.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: $bb7d4c8fd6edd603$var$CELL_TYPE,
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: filteredObjectsWithMedia,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $aVDPt.default).triggerButton),
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("c39UU", function(module, exports) {
$parcel$export(module.exports, "default", () => $61a347693e82b21f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a781bd8aa19ad1604b8c0ca03d22f712>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61a347693e82b21f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CmdbObjectsCell",
    "selections": [
        {
            "concreteType": "JiraCmdbObjectConnection",
            "kind": "LinkedField",
            "name": "selectedCmdbObjectsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "objectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "concreteType": "JiraCmdbAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCmdbMediaClientConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaClientConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "clientId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fileId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaBaseUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaJwtToken"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url48"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCMDBField"
};
$61a347693e82b21f$var$node.hash = "62b9469a8713e4f595123c2f627a6aec";
var $61a347693e82b21f$export$2e2bcd8739ae039 = $61a347693e82b21f$var$node;

});

parcelRegister("bYOuG", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $59de792af1bc0730$export$42e57fb76a904fc3);
$parcel$export(module.exports, "ASSETS_APP_OBJECT_ROUTE_PREFIX", () => $59de792af1bc0730$export$aede099f2ae23728);
$parcel$export(module.exports, "isInsightRoute", () => $59de792af1bc0730$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $59de792af1bc0730$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $59de792af1bc0730$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $59de792af1bc0730$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $59de792af1bc0730$export$20fd4a0aec335970);
$parcel$export(module.exports, "getAssetsSettingsUrl", () => $59de792af1bc0730$export$15f6d6ab94d89135);
$parcel$export(module.exports, "getDataManagerUrl", () => $59de792af1bc0730$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerGettingStartedUrl", () => $59de792af1bc0730$export$3d0380185f73b3d);
$parcel$export(module.exports, "getDataManagerObjectClassesUrl", () => $59de792af1bc0730$export$4c9768bc51c7a1a);
$parcel$export(module.exports, "getDataManagerVisualizationUrl", () => $59de792af1bc0730$export$6c3cb6f103b2324);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $59de792af1bc0730$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $59de792af1bc0730$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsDashboardsUrl", () => $59de792af1bc0730$export$da30a4c2eb7e2c58);
$parcel$export(module.exports, "getAssetsReportUrl", () => $59de792af1bc0730$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsForYouUrl", () => $59de792af1bc0730$export$ea8a41c5d5a50829);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $59de792af1bc0730$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $59de792af1bc0730$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $59de792af1bc0730$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $59de792af1bc0730$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $59de792af1bc0730$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $59de792af1bc0730$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $59de792af1bc0730$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $59de792af1bc0730$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $59de792af1bc0730$export$415502b49e27270d);

var $b5RwB = parcelRequire("b5RwB");

var $4cTDP = parcelRequire("4cTDP");

var $9suIz = parcelRequire("9suIz");
const $59de792af1bc0730$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $59de792af1bc0730$export$42e57fb76a904fc3 = '/jira/assets';
const $59de792af1bc0730$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $59de792af1bc0730$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $59de792af1bc0730$export$aede099f2ae23728 = '/jira/assets/object';
const $59de792af1bc0730$export$296d80f3ce129968 = (pathname)=>pathname.includes($59de792af1bc0730$export$6d7574dbda22cf7);
const $59de792af1bc0730$export$1f9b8b558a361aaf = ()=>$59de792af1bc0730$export$ee637ecb2dfa4f6a;
const $59de792af1bc0730$export$5413f45d031c7806 = ()=>(0, $4cTDP.fg)('assets_as_an_app_v2') ? $59de792af1bc0730$export$42e57fb76a904fc3 : $59de792af1bc0730$export$80e512187a5e0d10;
const $59de792af1bc0730$export$9366da5a373815e5 = ()=>$59de792af1bc0730$export$5413f45d031c7806();
const $59de792af1bc0730$export$20fd4a0aec335970 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/global`;
const $59de792af1bc0730$export$15f6d6ab94d89135 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/configure/global`;
const $59de792af1bc0730$export$c9b27b0d2e19d52f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/`;
const $59de792af1bc0730$export$3d0380185f73b3d = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/getting-started`;
const $59de792af1bc0730$export$4c9768bc51c7a1a = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/object-classes`;
const $59de792af1bc0730$export$6c3cb6f103b2324 = ()=>`${$59de792af1bc0730$export$42e57fb76a904fc3}/data-manager/#/dashboards`;
const $59de792af1bc0730$export$cd6b35373ba077a = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/data-manager/adapters/`;
const $59de792af1bc0730$export$c1909404b7ea317f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/reports`;
const $59de792af1bc0730$export$da30a4c2eb7e2c58 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/dashboards`;
const $59de792af1bc0730$export$771825afb10f956f = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/analytics/data-view/create`;
const $59de792af1bc0730$export$272d35cbff1c220e = (reportId)=>`${$59de792af1bc0730$export$c1909404b7ea317f()}/${reportId}`;
const $59de792af1bc0730$export$97bfda8f5f38a121 = (query)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $59de792af1bc0730$export$ea8a41c5d5a50829 = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/for-you`;
const $59de792af1bc0730$export$c48ea1282c74411e = ()=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schemas`;
const $59de792af1bc0730$export$3a0332e980fe56cf = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$59de792af1bc0730$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9suIz.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $59de792af1bc0730$export$f02479149ce3cac7 = (objectSchemaId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $59de792af1bc0730$export$51e4229f2c7d3866 = (objectId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/object/${objectId}`;
const $59de792af1bc0730$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$59de792af1bc0730$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $59de792af1bc0730$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$59de792af1bc0730$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $59de792af1bc0730$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$59de792af1bc0730$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $59de792af1bc0730$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>(0, $4cTDP.fg)('aurum-677-assets-usage-migration') ? '/jira/assets/configure/global?menu=app-usage' : `/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $59de792af1bc0730$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9suIz", function(module, exports) {
$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $38b78989e1c789e8$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $38b78989e1c789e8$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $38b78989e1c789e8$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $38b78989e1c789e8$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $38b78989e1c789e8$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_COMMON_DATA_MODEL", () => $38b78989e1c789e8$export$b5445f8b5c64a799);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $38b78989e1c789e8$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $38b78989e1c789e8$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $38b78989e1c789e8$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $38b78989e1c789e8$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $38b78989e1c789e8$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $38b78989e1c789e8$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $38b78989e1c789e8$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $38b78989e1c789e8$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $38b78989e1c789e8$export$1927b50f7d074492);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $4ZeQj = parcelRequire("4ZeQj");

var $95O7y = parcelRequire("95O7y");
var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");
const $38b78989e1c789e8$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $38b78989e1c789e8$export$f7855185bab37329 = 'reference-types';
const $38b78989e1c789e8$export$3739ebbc7c6e87e8 = 'statuses';
const $38b78989e1c789e8$export$2c22dc6c729ae0bd = 'icons';
const $38b78989e1c789e8$export$f37b3a97acf56eaf = 'data-manager';
const $38b78989e1c789e8$export$b5445f8b5c64a799 = 'common-data-model';
const $38b78989e1c789e8$export$12ebb1d5017e1d6d = 'general';
const $38b78989e1c789e8$export$a77734d9ea30fe44 = 'roles';
const $38b78989e1c789e8$export$be37b820df30c947 = 'import';
const $38b78989e1c789e8$export$670faa8ae93e0903 = 'inheritance';
const $38b78989e1c789e8$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const updateQueryParams = (0, $eJOHy.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eJOHy.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $38b78989e1c789e8$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eJOHy.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $4ZeQj.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $38b78989e1c789e8$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $4ZeQj.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $38b78989e1c789e8$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $38b78989e1c789e8$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $95O7y.useQueryParam)($38b78989e1c789e8$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});
parcelRegister("4ZeQj", function(module, exports) {
$parcel$export(module.exports, "toSchemaId", () => $a31a1cf0aae81680$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a31a1cf0aae81680$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a31a1cf0aae81680$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a31a1cf0aae81680$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a31a1cf0aae81680$export$cfd92c18cee8add7);
const $a31a1cf0aae81680$export$d577b7f3b832f656 = (id)=>id;
const $a31a1cf0aae81680$export$1ba342595bc7be13 = (id)=>id;
const $a31a1cf0aae81680$export$b46e25afa2bab6a = (id)=>id;
const $a31a1cf0aae81680$export$d002b8d7821b6b59 = (id)=>id;
const $a31a1cf0aae81680$export$ece2917434bb0a8c = (id)=>id;
const $a31a1cf0aae81680$export$cfd92c18cee8add7 = (id)=>id;

});



parcelRegister("lIbdr", function(module, exports) {
$parcel$export(module.exports, "createObjectDetailUrl", () => $4bcc9ec1645a5953$export$51e4229f2c7d3866);
// Hardcoded values from @atlassian/jira-servicedesk-insight-urls
const $4bcc9ec1645a5953$var$ASSETS_ROUTE_PREFIX = '/jira/servicedesk/assets';
const $4bcc9ec1645a5953$export$51e4229f2c7d3866 = (objectId)=>`${$4bcc9ec1645a5953$var$ASSETS_ROUTE_PREFIX}/object/${objectId}`;

});

parcelRegister("aVDPt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8748f15801c24aca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8748f15801c24aca$var$messages = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.cmdb-objects.trigger-button",
        "defaultMessage": "See more assets"
    }
});
var $8748f15801c24aca$export$2e2bcd8739ae039 = $8748f15801c24aca$var$messages;

});


parcelRegister("g3S5f", function(module, exports) {
$parcel$export(module.exports, "ComponentsInlineEditCell", () => $02df092dfe81a3d5$export$b3c67e48ecea06e4);

var $hW50S = parcelRequire("hW50S");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $ho4SO = parcelRequire("ho4SO");

var $P01So = parcelRequire("P01So");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
/**
 * Expected JQL Output: `project = ${projectKey} AND ${jqlTerm} = ${name}`
 */ const $02df092dfe81a3d5$var$getLinkJql = (projectKey, jqlTerm, name)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).compoundClause((0, $f26C8.default).compoundOperator((0, $f6415dda43b7f459$export$6d6d48d210d3ca97)), [
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field('project'), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(projectKey)),
        (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand((0, $P01So.escapeBackslashes)(name)))
    ])));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $02df092dfe81a3d5$export$b3c67e48ecea06e4 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, projectKey: projectKey })=>{
    const data = (0, $j4oe4.useFragment)((0, $hW50S.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const formatComponentJql = (0, $eJOHy.useCallback)((componentName)=>$02df092dfe81a3d5$var$getLinkJql(projectKey, jqlTerm, componentName), [
        jqlTerm,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ho4SO.ComponentsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        formatComponentJql: formatComponentJql,
        fragmentRef: data,
        isTruncated: true,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};

});
parcelRegister("hW50S", function(module, exports) {
$parcel$export(module.exports, "default", () => $d98fff595f44c554$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e33b0850f20d78ac500bca95b6a39f05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d98fff595f44c554$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ComponentsCell_ComponentsInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraComponentsField"
};
$d98fff595f44c554$var$node.hash = "039baef83cb8ffecbd5b697cd1ab09e0";
var $d98fff595f44c554$export$2e2bcd8739ae039 = $d98fff595f44c554$var$node;

});

const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

parcelRegister("f26C8", function(module, exports) {
$parcel$export(module.exports, "internalCreators", () => $54a2df64babed64e$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $54a2df64babed64e$export$2e2bcd8739ae039);

var $8gbOL = parcelRequire("8gbOL");

var $lmH0l = parcelRequire("lmH0l");

var $2caal = parcelRequire("2caal");

var $6LAlr = parcelRequire("6LAlr");

var $NDSAF = parcelRequire("NDSAF");

var $1d8p9 = parcelRequire("1d8p9");

var $72SeG = parcelRequire("72SeG");

var $5qiTO = parcelRequire("5qiTO");

var $q681h = parcelRequire("q681h");

var $5WHbI = parcelRequire("5WHbI");

var $5pxYG = parcelRequire("5pxYG");

var $i8g3z = parcelRequire("i8g3z");

var $hE0gi = parcelRequire("hE0gi");

var $83AJ4 = parcelRequire("83AJ4");

var $d0MpM = parcelRequire("d0MpM");

var $lDhFj = parcelRequire("lDhFj");

var $6Dx67 = parcelRequire("6Dx67");

var $hbAhR = parcelRequire("hbAhR");

var $89aGW = parcelRequire("89aGW");

var $8XEos = parcelRequire("8XEos");

var $52A7I = parcelRequire("52A7I");

var $jArsO = parcelRequire("jArsO");
const $54a2df64babed64e$export$64d991963cfb5532 = {
    query: (0, $8XEos.queryInternal),
    compoundClause: (0, $lmH0l.compoundClauseInternal),
    compoundOperator: (0, $2caal.compoundOperatorInternal),
    terminalClause: (0, $52A7I.terminalClauseInternal),
    notClause: (0, $5WHbI.notClauseInternal),
    notClauseOperator: (0, $5pxYG.notClauseOperatorInternal),
    predicate: (0, $6Dx67.predicateInternal),
    predicateOperator: (0, $hbAhR.predicateOperatorInternal),
    field: (0, $6LAlr.fieldInternal),
    property: (0, $89aGW.propertyInternal),
    operator: (0, $i8g3z.operatorInternal),
    valueOperand: (0, $jArsO.valueOperandInternal),
    keywordOperand: (0, $5qiTO.keywordOperandInternal),
    functionOperand: (0, $NDSAF.functionOperandInternal),
    functionString: (0, $1d8p9.functionStringInternal),
    argument: (0, $8gbOL.argumentInternal),
    listOperand: (0, $q681h.listOperandInternal),
    orderBy: (0, $hE0gi.orderByInternal),
    orderByOperator: (0, $lDhFj.orderByOperatorInternal),
    orderByField: (0, $d0MpM.orderByFieldInternal),
    orderByDirection: (0, $83AJ4.orderByDirectionInternal)
};
var $54a2df64babed64e$export$2e2bcd8739ae039 = {
    jast: $72SeG.jast,
    query: $8XEos.query,
    compoundClause: $lmH0l.compoundClause,
    compoundOperator: $2caal.compoundOperator,
    terminalClause: $52A7I.terminalClause,
    notClause: $5WHbI.notClause,
    notClauseOperator: $5pxYG.notClauseOperator,
    predicate: $6Dx67.predicate,
    predicateOperator: $hbAhR.predicateOperator,
    field: $6LAlr.field,
    property: $89aGW.property,
    operator: $i8g3z.operator,
    valueOperand: $jArsO.valueOperand,
    keywordOperand: $5qiTO.keywordOperand,
    functionOperand: $NDSAF.functionOperand,
    functionString: $1d8p9.functionString,
    argument: $8gbOL.argument,
    listOperand: $q681h.listOperand,
    orderBy: $hE0gi.orderBy,
    orderByOperator: $lDhFj.orderByOperator,
    orderByField: $d0MpM.orderByField,
    orderByDirection: $83AJ4.orderByDirection,
    byText: {
        argument: (0, $8gbOL.argumentByText),
        valueOperand: (0, $jArsO.valueOperandByText)
    }
};

});
parcelRegister("8gbOL", function(module, exports) {
$parcel$export(module.exports, "argument", () => $9899f3160c8155c6$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $9899f3160c8155c6$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $9899f3160c8155c6$export$84c43d23f51170cb);

var $h8zsn = parcelRequire("h8zsn");
var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $9899f3160c8155c6$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $9899f3160c8155c6$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $9899f3160c8155c6$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $9899f3160c8155c6$export$6ea29ee575e3f5ff = (value)=>$9899f3160c8155c6$export$5b341d50fa5bcdd5(value, (0, $ykU4x.sanitiseJqlString)(value));
const $9899f3160c8155c6$export$84c43d23f51170cb = (text)=>$9899f3160c8155c6$export$5b341d50fa5bcdd5((0, $h8zsn.normaliseJqlString)(text), text);
const $9899f3160c8155c6$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $9899f3160c8155c6$var$acceptArgument,
        enterNode: $9899f3160c8155c6$var$enterNode,
        exitNode: $9899f3160c8155c6$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
parcelRegister("h8zsn", function(module, exports) {
$parcel$export(module.exports, "normaliseJqlString", () => $e879e944a9dd4709$export$cecf78a779acc0ff);
const $e879e944a9dd4709$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $e879e944a9dd4709$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $e879e944a9dd4709$export$b86601123607fee5 = (maybeQuotedString)=>$e879e944a9dd4709$export$7a0b99b892e0dda8(maybeQuotedString) || $e879e944a9dd4709$export$d5efd6512db694fd(maybeQuotedString);
const $e879e944a9dd4709$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($e879e944a9dd4709$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("ykU4x", function(module, exports) {
$parcel$export(module.exports, "sanitiseJqlString", () => $c0a3cffda0853f39$export$3eb9033c48208278);

var $6PCNA = parcelRequire("6PCNA");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $c0a3cffda0853f39$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $c0a3cffda0853f39$export$3eb9033c48208278 = (jqlString)=>{
    if ($c0a3cffda0853f39$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("6PCNA", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4f959a1cf3d02dc6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $4f959a1cf3d02dc6$var$reHasRegExpChar = RegExp($4f959a1cf3d02dc6$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $4f959a1cf3d02dc6$var$escapeRegExp(string) {
    string = $cz1WF(string);
    return string && $4f959a1cf3d02dc6$var$reHasRegExpChar.test(string) ? string.replace($4f959a1cf3d02dc6$var$reRegExpChar, '\\$&') : string;
}
module.exports = $4f959a1cf3d02dc6$var$escapeRegExp;

});


parcelRegister("fa1eE", function(module, exports) {
$parcel$export(module.exports, "noChildren", () => $b71c996bd5b4efee$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $b71c996bd5b4efee$export$a4685923af2913a);
const $b71c996bd5b4efee$export$470bef71e654b804 = ()=>[];
const $b71c996bd5b4efee$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("lmH0l", function(module, exports) {
$parcel$export(module.exports, "compoundClause", () => $7990dc2160e1df04$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $7990dc2160e1df04$export$cd65eed8c10b0911);


var $569g0 = parcelRequire("569g0");

var $fa1eE = parcelRequire("fa1eE");
function $7990dc2160e1df04$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $7990dc2160e1df04$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $7990dc2160e1df04$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $7990dc2160e1df04$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $7990dc2160e1df04$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $7990dc2160e1df04$export$cd65eed8c10b0911(operator, clauses);
};
const $7990dc2160e1df04$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $7990dc2160e1df04$var$acceptCompoundClause,
        enterNode: $7990dc2160e1df04$var$enterNode,
        exitNode: $7990dc2160e1df04$var$exitNode,
        getChildren: $7990dc2160e1df04$var$getChildren,
        parent: null,
        appendClause: $569g0.appendClause,
        remove: $569g0.remove,
        removeClause: $569g0.removeClause,
        replace: $569g0.replace,
        replaceClause: $569g0.replaceClause
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
const $2a3824620e125bfd$export$7a58b23488ea076b = 'compound';
const $2a3824620e125bfd$export$ae56b4ef248a2b6a = 'terminal';
const $2a3824620e125bfd$export$e356b89f8c8d2fcb = 'not';

const $07f17d613ee96ad1$export$98dda21ec825792 = 'query';
const $07f17d613ee96ad1$export$2d205682cc545947 = 'clause';
const $07f17d613ee96ad1$export$d2f212d8ddbc8d1d = 'operand';
const $07f17d613ee96ad1$export$da0f73edded4a63d = 'order_by';

parcelRegister("569g0", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $fa1eE = parcelRequire("fa1eE");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $fa1eE.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $fa1eE.assignParent)(this);
}

});


parcelRegister("2caal", function(module, exports) {
$parcel$export(module.exports, "compoundOperator", () => $b3ac9a1079c049ae$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $b3ac9a1079c049ae$export$63c33bc3fe74fee6);

var $fa1eE = parcelRequire("fa1eE");
function $b3ac9a1079c049ae$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $b3ac9a1079c049ae$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $b3ac9a1079c049ae$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $b3ac9a1079c049ae$export$84bb3ebbba491aee = (value)=>$b3ac9a1079c049ae$export$63c33bc3fe74fee6(value, []);
const $b3ac9a1079c049ae$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $b3ac9a1079c049ae$var$acceptCompoundOperator,
        enterNode: $b3ac9a1079c049ae$var$enterNode,
        exitNode: $b3ac9a1079c049ae$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("6LAlr", function(module, exports) {
$parcel$export(module.exports, "field", () => $40455f5cc088ebfe$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $40455f5cc088ebfe$export$2193f8c541622b6);

var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $40455f5cc088ebfe$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $40455f5cc088ebfe$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $40455f5cc088ebfe$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $40455f5cc088ebfe$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $40455f5cc088ebfe$export$e0f35d825088c098 = (value, properties)=>{
    return $40455f5cc088ebfe$export$2193f8c541622b6(value, (0, $ykU4x.sanitiseJqlString)(value), properties);
};
const $40455f5cc088ebfe$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $40455f5cc088ebfe$var$acceptField,
        enterNode: $40455f5cc088ebfe$var$enterNode,
        exitNode: $40455f5cc088ebfe$var$exitNode,
        getChildren: $40455f5cc088ebfe$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("NDSAF", function(module, exports) {
$parcel$export(module.exports, "functionOperand", () => $3d621d62a26d18dc$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $3d621d62a26d18dc$export$c1f2ce91dc05872a);


var $fa1eE = parcelRequire("fa1eE");
function $3d621d62a26d18dc$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $3d621d62a26d18dc$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $3d621d62a26d18dc$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $3d621d62a26d18dc$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $3d621d62a26d18dc$export$4f981b0e83488ce = (functionString, args = [])=>$3d621d62a26d18dc$export$c1f2ce91dc05872a(functionString, args);
const $3d621d62a26d18dc$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $3d621d62a26d18dc$var$acceptFunctionOperand,
        enterNode: $3d621d62a26d18dc$var$enterNode,
        exitNode: $3d621d62a26d18dc$var$exitNode,
        getChildren: $3d621d62a26d18dc$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
const $862dfd240457f00b$export$38accfc5a5d1c113 = 'value';
const $862dfd240457f00b$export$f6049126fd97001f = 'keyword';
const $862dfd240457f00b$export$19c7c729db381f9d = 'function';
const $862dfd240457f00b$export$fabec4aebba3f4df = 'list';
const $862dfd240457f00b$export$1c46dca02aac24dd = 'empty';


parcelRegister("1d8p9", function(module, exports) {
$parcel$export(module.exports, "functionString", () => $0c094943ece8f752$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $0c094943ece8f752$export$7aa9944588b7a69f);

var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $0c094943ece8f752$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $0c094943ece8f752$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $0c094943ece8f752$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $0c094943ece8f752$export$4e1bb9a7ff8d0ef9 = (value)=>$0c094943ece8f752$export$7aa9944588b7a69f(value, (0, $ykU4x.sanitiseJqlString)(value));
const $0c094943ece8f752$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $0c094943ece8f752$var$acceptFunctionString,
        enterNode: $0c094943ece8f752$var$enterNode,
        exitNode: $0c094943ece8f752$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("72SeG", function(module, exports) {
$parcel$export(module.exports, "jast", () => $a25d6c4a0f00f5da$export$b9e70a00f479ff43);
const $a25d6c4a0f00f5da$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("5qiTO", function(module, exports) {
$parcel$export(module.exports, "keywordOperand", () => $152e52666e87d978$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $152e52666e87d978$export$7cc55480b054047b);


var $fa1eE = parcelRequire("fa1eE");
function $152e52666e87d978$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $152e52666e87d978$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $152e52666e87d978$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $152e52666e87d978$export$2edd4971ed69f2ce = ()=>$152e52666e87d978$export$7cc55480b054047b((0, $862dfd240457f00b$export$1c46dca02aac24dd));
const $152e52666e87d978$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $152e52666e87d978$var$acceptKeywordOperand,
        enterNode: $152e52666e87d978$var$enterNode,
        exitNode: $152e52666e87d978$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("q681h", function(module, exports) {
$parcel$export(module.exports, "listOperand", () => $da0279a594b64f69$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $da0279a594b64f69$export$663c7831528c984b);


var $a9ys9 = parcelRequire("a9ys9");

var $fa1eE = parcelRequire("fa1eE");
function $da0279a594b64f69$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $da0279a594b64f69$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $da0279a594b64f69$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $da0279a594b64f69$var$getChildren() {
    return [
        ...this.values
    ];
}
const $da0279a594b64f69$export$769866c3e9d41d50 = (values)=>$da0279a594b64f69$export$663c7831528c984b(values);
const $da0279a594b64f69$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $da0279a594b64f69$var$acceptListOperand,
        enterNode: $da0279a594b64f69$var$enterNode,
        exitNode: $da0279a594b64f69$var$exitNode,
        getChildren: $da0279a594b64f69$var$getChildren,
        parent: null,
        appendOperand: $a9ys9.appendOperand
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("a9ys9", function(module, exports) {
$parcel$export(module.exports, "appendOperand", () => $8339039101fa111c$export$d94c54f1aee177c4);


var $fa1eE = parcelRequire("fa1eE");
function $8339039101fa111c$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $fa1eE.assignParent)(this);
}

});


parcelRegister("5WHbI", function(module, exports) {
$parcel$export(module.exports, "notClause", () => $cf05e1bf306c2cdd$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $cf05e1bf306c2cdd$export$b25621824fea4548);


var $lmKuC = parcelRequire("lmKuC");

var $fa1eE = parcelRequire("fa1eE");

var $5pxYG = parcelRequire("5pxYG");
function $cf05e1bf306c2cdd$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $cf05e1bf306c2cdd$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $cf05e1bf306c2cdd$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $cf05e1bf306c2cdd$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $cf05e1bf306c2cdd$export$b4734a9fedb4d44e = (clause)=>{
    return $cf05e1bf306c2cdd$export$b25621824fea4548(clause, (0, $5pxYG.notClauseOperator)());
};
const $cf05e1bf306c2cdd$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $cf05e1bf306c2cdd$var$acceptNotClause,
        enterNode: $cf05e1bf306c2cdd$var$enterNode,
        exitNode: $cf05e1bf306c2cdd$var$exitNode,
        getChildren: $cf05e1bf306c2cdd$var$getChildren,
        parent: null,
        remove: $lmKuC.remove,
        removeClause: $lmKuC.removeClause,
        replace: $lmKuC.replace,
        replaceClause: $lmKuC.replaceClause
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("lmKuC", function(module, exports) {
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $fa1eE = parcelRequire("fa1eE");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $fa1eE.assignParent)(this);
    }
}

});

parcelRegister("5pxYG", function(module, exports) {
$parcel$export(module.exports, "notClauseOperator", () => $1b4f1909e547322d$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $1b4f1909e547322d$export$1b15a32bb57b9020);

var $jPlb3 = parcelRequire("jPlb3");

var $fa1eE = parcelRequire("fa1eE");
function $1b4f1909e547322d$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $1b4f1909e547322d$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $1b4f1909e547322d$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $1b4f1909e547322d$export$d2cd8239f99c13d3 = ()=>$1b4f1909e547322d$export$1b15a32bb57b9020();
const $1b4f1909e547322d$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $jPlb3.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $1b4f1909e547322d$var$acceptNotClauseOperator,
        enterNode: $1b4f1909e547322d$var$enterNode,
        exitNode: $1b4f1909e547322d$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
parcelRegister("jPlb3", function(module, exports) {
$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $cee78cdd174c9cda$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $cee78cdd174c9cda$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $cee78cdd174c9cda$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $cee78cdd174c9cda$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $cee78cdd174c9cda$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $cee78cdd174c9cda$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $cee78cdd174c9cda$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $cee78cdd174c9cda$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $cee78cdd174c9cda$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $cee78cdd174c9cda$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $cee78cdd174c9cda$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $cee78cdd174c9cda$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $cee78cdd174c9cda$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $cee78cdd174c9cda$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $cee78cdd174c9cda$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $cee78cdd174c9cda$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $cee78cdd174c9cda$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $cee78cdd174c9cda$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $cee78cdd174c9cda$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $cee78cdd174c9cda$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $cee78cdd174c9cda$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $cee78cdd174c9cda$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $cee78cdd174c9cda$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $cee78cdd174c9cda$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $cee78cdd174c9cda$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $cee78cdd174c9cda$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $cee78cdd174c9cda$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $cee78cdd174c9cda$export$77c793736847e030);
const $cee78cdd174c9cda$export$c6c71ceedb15cda9 = 'not';
const $cee78cdd174c9cda$export$466517a888d00195 = '=';
const $cee78cdd174c9cda$export$6d0d8810623974a5 = '!=';
const $cee78cdd174c9cda$export$bcbb090ab3c498b3 = '>';
const $cee78cdd174c9cda$export$4bf1a4aa659c6ea4 = '<';
const $cee78cdd174c9cda$export$83ce674214a54b2a = '>=';
const $cee78cdd174c9cda$export$9629fd1727ef62ee = '<=';
const $cee78cdd174c9cda$export$c4e3fb55e320e979 = 'in';
const $cee78cdd174c9cda$export$f9857532eaa24ddc = 'not in';
const $cee78cdd174c9cda$export$221595834b8766ab = '~';
const $cee78cdd174c9cda$export$fcefabf94a9bffbf = '!~';
const $cee78cdd174c9cda$export$4feeb3f4ff56bcef = 'is';
const $cee78cdd174c9cda$export$d08d969a0da27188 = 'is not';
const $cee78cdd174c9cda$export$8f907e179985256d = 'was';
const $cee78cdd174c9cda$export$cc7b9d0b3ee23193 = 'was in';
const $cee78cdd174c9cda$export$585d3c004af078bb = 'was not in';
const $cee78cdd174c9cda$export$123eaa9ccc2d9445 = 'was not';
const $cee78cdd174c9cda$export$15f5b446ba8c941e = 'changed';
const $cee78cdd174c9cda$export$643c6101f3fc8547 = [
    $cee78cdd174c9cda$export$466517a888d00195,
    $cee78cdd174c9cda$export$6d0d8810623974a5
];
const $cee78cdd174c9cda$export$329664c9cf18cca6 = [
    $cee78cdd174c9cda$export$221595834b8766ab,
    $cee78cdd174c9cda$export$fcefabf94a9bffbf
];
const $cee78cdd174c9cda$export$1b167a3705885a8b = [
    $cee78cdd174c9cda$export$4bf1a4aa659c6ea4,
    $cee78cdd174c9cda$export$bcbb090ab3c498b3,
    $cee78cdd174c9cda$export$9629fd1727ef62ee,
    $cee78cdd174c9cda$export$83ce674214a54b2a
];
const $cee78cdd174c9cda$export$f25cf16c2270312f = [
    $cee78cdd174c9cda$export$c4e3fb55e320e979,
    $cee78cdd174c9cda$export$f9857532eaa24ddc
];
const $cee78cdd174c9cda$export$eb58cfffe4a6b805 = [
    $cee78cdd174c9cda$export$4feeb3f4ff56bcef,
    $cee78cdd174c9cda$export$d08d969a0da27188
];
const $cee78cdd174c9cda$export$c22a981f581de218 = [
    $cee78cdd174c9cda$export$8f907e179985256d,
    $cee78cdd174c9cda$export$123eaa9ccc2d9445
];
const $cee78cdd174c9cda$export$6d08c4699bb75284 = [
    $cee78cdd174c9cda$export$cc7b9d0b3ee23193,
    $cee78cdd174c9cda$export$585d3c004af078bb
];
const $cee78cdd174c9cda$export$b7dc214eef214c1c = [
    $cee78cdd174c9cda$export$15f5b446ba8c941e
];
const $cee78cdd174c9cda$export$184799fc79ccac89 = [
    ...$cee78cdd174c9cda$export$643c6101f3fc8547,
    ...$cee78cdd174c9cda$export$329664c9cf18cca6,
    ...$cee78cdd174c9cda$export$1b167a3705885a8b,
    ...$cee78cdd174c9cda$export$f25cf16c2270312f,
    ...$cee78cdd174c9cda$export$eb58cfffe4a6b805,
    ...$cee78cdd174c9cda$export$c22a981f581de218,
    ...$cee78cdd174c9cda$export$6d08c4699bb75284,
    ...$cee78cdd174c9cda$export$b7dc214eef214c1c
];
const $cee78cdd174c9cda$export$77c793736847e030 = [
    $cee78cdd174c9cda$export$c4e3fb55e320e979,
    $cee78cdd174c9cda$export$f9857532eaa24ddc,
    $cee78cdd174c9cda$export$cc7b9d0b3ee23193,
    $cee78cdd174c9cda$export$585d3c004af078bb
];

});



parcelRegister("i8g3z", function(module, exports) {
$parcel$export(module.exports, "operator", () => $43a4abca705ed742$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $43a4abca705ed742$export$649025bc60ab9c3b);

var $fa1eE = parcelRequire("fa1eE");
function $43a4abca705ed742$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $43a4abca705ed742$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $43a4abca705ed742$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $43a4abca705ed742$export$dbd72860f701d4f3 = (value)=>$43a4abca705ed742$export$649025bc60ab9c3b(value, value);
const $43a4abca705ed742$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $43a4abca705ed742$var$acceptOperator,
        enterNode: $43a4abca705ed742$var$enterNode,
        exitNode: $43a4abca705ed742$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("hE0gi", function(module, exports) {
$parcel$export(module.exports, "orderBy", () => $c0a3843a9e7de571$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $c0a3843a9e7de571$export$e4eb1fa6bc8465c1);


var $ekRIJ = parcelRequire("ekRIJ");

var $fa1eE = parcelRequire("fa1eE");

var $lDhFj = parcelRequire("lDhFj");
function $c0a3843a9e7de571$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $c0a3843a9e7de571$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $c0a3843a9e7de571$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $c0a3843a9e7de571$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $c0a3843a9e7de571$export$f18af21d6f4dafd8 = (fields)=>{
    return $c0a3843a9e7de571$export$e4eb1fa6bc8465c1(fields, (0, $lDhFj.orderByOperator)());
};
const $c0a3843a9e7de571$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $c0a3843a9e7de571$var$acceptOrderBy,
        enterNode: $c0a3843a9e7de571$var$enterNode,
        exitNode: $c0a3843a9e7de571$var$exitNode,
        getChildren: $c0a3843a9e7de571$var$getChildren,
        parent: null,
        prependOrderField: $ekRIJ.prependOrderField,
        setOrderDirection: $ekRIJ.setOrderDirection,
        replace: $ekRIJ.replace,
        replaceOrderField: $ekRIJ.replaceOrderField,
        remove: $ekRIJ.remove,
        removeOrderField: $ekRIJ.removeOrderField
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("ekRIJ", function(module, exports) {
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $fa1eE = parcelRequire("fa1eE");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $fa1eE.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $fa1eE.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("lDhFj", function(module, exports) {
$parcel$export(module.exports, "orderByOperator", () => $3dd1a82964518ff4$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $3dd1a82964518ff4$export$739e30af23a08da0);


var $fa1eE = parcelRequire("fa1eE");
function $3dd1a82964518ff4$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $3dd1a82964518ff4$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $3dd1a82964518ff4$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $3dd1a82964518ff4$export$c7307b67924c61ea = ()=>$3dd1a82964518ff4$export$739e30af23a08da0();
const $3dd1a82964518ff4$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $adec16a85d57f51f$export$ca51f5fd60a74517),
        position: position,
        accept: $3dd1a82964518ff4$var$acceptOrderByOperator,
        enterNode: $3dd1a82964518ff4$var$enterNode,
        exitNode: $3dd1a82964518ff4$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});
const $adec16a85d57f51f$export$ca51f5fd60a74517 = 'ORDER BY';
const $adec16a85d57f51f$export$6d60017b9e092e73 = 'ASC';
const $adec16a85d57f51f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("83AJ4", function(module, exports) {
$parcel$export(module.exports, "orderByDirection", () => $c704c2d23a3fd91f$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $c704c2d23a3fd91f$export$8c65cac1a7852d1f);

var $fa1eE = parcelRequire("fa1eE");
function $c704c2d23a3fd91f$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $c704c2d23a3fd91f$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $c704c2d23a3fd91f$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $c704c2d23a3fd91f$export$864d934efed3ccaa = (value)=>$c704c2d23a3fd91f$export$8c65cac1a7852d1f(value);
const $c704c2d23a3fd91f$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $c704c2d23a3fd91f$var$acceptOrderByDirection,
        enterNode: $c704c2d23a3fd91f$var$enterNode,
        exitNode: $c704c2d23a3fd91f$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("d0MpM", function(module, exports) {
$parcel$export(module.exports, "orderByField", () => $38c966c2448f3b7a$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $38c966c2448f3b7a$export$661a7786e3d15926);

var $hKUyp = parcelRequire("hKUyp");

var $fa1eE = parcelRequire("fa1eE");
function $38c966c2448f3b7a$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $38c966c2448f3b7a$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $38c966c2448f3b7a$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $38c966c2448f3b7a$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $38c966c2448f3b7a$export$942df63e5e3d3899 = (field, direction)=>$38c966c2448f3b7a$export$661a7786e3d15926(field, direction);
const $38c966c2448f3b7a$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $38c966c2448f3b7a$var$acceptOrderByField,
        enterNode: $38c966c2448f3b7a$var$enterNode,
        exitNode: $38c966c2448f3b7a$var$exitNode,
        getChildren: $38c966c2448f3b7a$var$getChildren,
        parent: null,
        setOrderDirection: $hKUyp.setOrderDirection,
        replace: $hKUyp.replace,
        remove: $hKUyp.remove
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("hKUyp", function(module, exports) {
$parcel$export(module.exports, "setOrderDirection", () => $e6633080911e1e18$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $e6633080911e1e18$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $e6633080911e1e18$export$cd7f480d6b8286c3);

var $fa1eE = parcelRequire("fa1eE");
function $e6633080911e1e18$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $fa1eE.assignParent)(this);
}
function $e6633080911e1e18$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $e6633080911e1e18$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("6Dx67", function(module, exports) {
$parcel$export(module.exports, "predicate", () => $425b3c9785c66bdc$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $425b3c9785c66bdc$export$a767a27ad05a38a2);

var $fa1eE = parcelRequire("fa1eE");
function $425b3c9785c66bdc$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $425b3c9785c66bdc$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $425b3c9785c66bdc$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $425b3c9785c66bdc$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $425b3c9785c66bdc$export$5fc51e445ce24faf = (operator, operand)=>$425b3c9785c66bdc$export$a767a27ad05a38a2(operator, operand);
const $425b3c9785c66bdc$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $425b3c9785c66bdc$var$acceptPredicate,
        enterNode: $425b3c9785c66bdc$var$enterNode,
        exitNode: $425b3c9785c66bdc$var$exitNode,
        getChildren: $425b3c9785c66bdc$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("hbAhR", function(module, exports) {
$parcel$export(module.exports, "predicateOperator", () => $48cdeafcf75d3a91$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $48cdeafcf75d3a91$export$c69d893689716768);

var $fa1eE = parcelRequire("fa1eE");
function $48cdeafcf75d3a91$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $48cdeafcf75d3a91$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $48cdeafcf75d3a91$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $48cdeafcf75d3a91$export$5419b7f16910ea62 = (value)=>$48cdeafcf75d3a91$export$c69d893689716768(value, value);
const $48cdeafcf75d3a91$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $48cdeafcf75d3a91$var$acceptPredicateOperator,
        enterNode: $48cdeafcf75d3a91$var$enterNode,
        exitNode: $48cdeafcf75d3a91$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});

parcelRegister("89aGW", function(module, exports) {
$parcel$export(module.exports, "property", () => $1ed758994e0eb78c$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $1ed758994e0eb78c$export$1cbd90994fef1fad);

var $fa1eE = parcelRequire("fa1eE");
function $1ed758994e0eb78c$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $1ed758994e0eb78c$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $1ed758994e0eb78c$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $1ed758994e0eb78c$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $1ed758994e0eb78c$export$d541bacb2bda4494 = (key, path = [])=>$1ed758994e0eb78c$export$1cbd90994fef1fad(key, path);
const $1ed758994e0eb78c$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $1ed758994e0eb78c$var$acceptProperty,
        enterNode: $1ed758994e0eb78c$var$enterNode,
        exitNode: $1ed758994e0eb78c$var$exitNode,
        getChildren: $1ed758994e0eb78c$var$getChildren,
        parent: null
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});

parcelRegister("8XEos", function(module, exports) {
$parcel$export(module.exports, "query", () => $d6ce43aac43752fe$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $d6ce43aac43752fe$export$bc2d6e2e1fd9014);


var $qZ8nR = parcelRequire("qZ8nR");

var $fa1eE = parcelRequire("fa1eE");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $d6ce43aac43752fe$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $d6ce43aac43752fe$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $d6ce43aac43752fe$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $d6ce43aac43752fe$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $d6ce43aac43752fe$export$2fa187e846a241c4 = (where, orderBy)=>$d6ce43aac43752fe$export$bc2d6e2e1fd9014(where, orderBy);
const $d6ce43aac43752fe$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $d6ce43aac43752fe$var$acceptQuery,
        enterNode: $d6ce43aac43752fe$var$enterNode,
        exitNode: $d6ce43aac43752fe$var$exitNode,
        getChildren: $d6ce43aac43752fe$var$getChildren,
        parent: null,
        appendClause: $qZ8nR.appendClause,
        prependOrderField: $qZ8nR.prependOrderField,
        setOrderDirection: $qZ8nR.setOrderDirection,
        removeClause: $qZ8nR.removeClause,
        replaceClause: $qZ8nR.replaceClause,
        replaceOrderBy: $qZ8nR.replaceOrderBy,
        removeOrderBy: $qZ8nR.removeOrderBy
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("qZ8nR", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $f26C8 = parcelRequire("f26C8");

var $fa1eE = parcelRequire("fa1eE");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $f26C8.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $f26C8.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $fa1eE.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $f26C8.default).orderBy([
            orderField
        ]);
        (0, $fa1eE.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $fa1eE.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $fa1eE.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("52A7I", function(module, exports) {
$parcel$export(module.exports, "terminalClause", () => $c357857da31d9c1c$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $c357857da31d9c1c$export$cc08e43598d091fc);


var $2mQsQ = parcelRequire("2mQsQ");

var $fa1eE = parcelRequire("fa1eE");
function $c357857da31d9c1c$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $c357857da31d9c1c$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $c357857da31d9c1c$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $c357857da31d9c1c$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $c357857da31d9c1c$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $c357857da31d9c1c$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $c357857da31d9c1c$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $07f17d613ee96ad1$export$2d205682cc545947),
        clauseType: (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $c357857da31d9c1c$var$acceptTerminalClause,
        enterNode: $c357857da31d9c1c$var$enterNode,
        exitNode: $c357857da31d9c1c$var$exitNode,
        getChildren: $c357857da31d9c1c$var$getChildren,
        parent: null,
        setOperator: $2mQsQ.setOperator,
        setOperand: $2mQsQ.setOperand,
        appendOperand: $2mQsQ.appendOperand,
        remove: $2mQsQ.remove,
        replace: $2mQsQ.replace
    };
    (0, $fa1eE.assignParent)(node);
    return node;
};

});
parcelRegister("2mQsQ", function(module, exports) {
$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $f26C8 = parcelRequire("f26C8");

var $fa1eE = parcelRequire("fa1eE");
function setOperator(operator) {
    this.operator = operator;
    (0, $fa1eE.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $fa1eE.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $f26C8.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("jArsO", function(module, exports) {
$parcel$export(module.exports, "valueOperand", () => $19d73696559a6b33$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $19d73696559a6b33$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $19d73696559a6b33$export$3ac9155bde56a45f);


var $h8zsn = parcelRequire("h8zsn");
var $ykU4x = parcelRequire("ykU4x");

var $fa1eE = parcelRequire("fa1eE");
function $19d73696559a6b33$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $19d73696559a6b33$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $19d73696559a6b33$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $19d73696559a6b33$export$2b6e4d2ed8d53bf3 = (value)=>$19d73696559a6b33$export$79c37d97caac8627(value, (0, $ykU4x.sanitiseJqlString)(value));
const $19d73696559a6b33$export$3ac9155bde56a45f = (text)=>$19d73696559a6b33$export$79c37d97caac8627((0, $h8zsn.normaliseJqlString)(text), text);
const $19d73696559a6b33$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $07f17d613ee96ad1$export$d2f212d8ddbc8d1d),
        operandType: (0, $862dfd240457f00b$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $19d73696559a6b33$var$acceptValueOperand,
        enterNode: $19d73696559a6b33$var$enterNode,
        exitNode: $19d73696559a6b33$var$exitNode,
        getChildren: (0, $fa1eE.noChildren),
        parent: null
    });

});


parcelRegister("1jiqw", function(module, exports) {
$parcel$export(module.exports, "print", () => $c24354720bbe7250$export$c2d084dc44961371);

var $8sbs2 = parcelRequire("8sbs2");

var $9xrcu = parcelRequire("9xrcu");

var $gWLgz = parcelRequire("gWLgz");
const $c24354720bbe7250$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gWLgz.printDocToString)((0, $9xrcu.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("9xrcu", function(module, exports) {
$parcel$export(module.exports, "printAstToDoc", () => $4d18f5eec7d6c329$export$f0ef38932978952);


var $dl9fK = parcelRequire("dl9fK");

var $b8gMN = parcelRequire("b8gMN");
const $4d18f5eec7d6c329$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $4d18f5eec7d6c329$export$27a275559a5c8102 extends (0, $dl9fK.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $b8gMN.ifBreak)((0, $b8gMN.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $b8gMN.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $b8gMN.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $b8gMN.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $b8gMN.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $4d18f5eec7d6c329$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $b8gMN.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $b8gMN.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $b8gMN.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $4d18f5eec7d6c329$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $b8gMN.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $b8gMN.group)([
            query.where.accept(this),
            (0, $b8gMN.ifBreak)((0, $b8gMN.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $b8gMN.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $b8gMN.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $4d18f5eec7d6c329$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $4d18f5eec7d6c329$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("dl9fK", function(module, exports) {
$parcel$export(module.exports, "AbstractJastVisitor", () => $eca78231bf7c6646$export$51be62b46ee668fd);
class $eca78231bf7c6646$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param _aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(_aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param _node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param _currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(_node, _currentResult) {
        return true;
    }
}

});

parcelRegister("b8gMN", function(module, exports) {
$parcel$export(module.exports, "group", () => $5fbb607da15f7724$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $5fbb607da15f7724$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $5fbb607da15f7724$export$dc84f6841f96b7da);
const $5fbb607da15f7724$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $5fbb607da15f7724$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $5fbb607da15f7724$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gWLgz", function(module, exports) {
$parcel$export(module.exports, "printDocToString", () => $ae252d48f146c7f1$export$316fc7e94b95b118);
const $ae252d48f146c7f1$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $ae252d48f146c7f1$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $ae252d48f146c7f1$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $ae252d48f146c7f1$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $ae252d48f146c7f1$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $ae252d48f146c7f1$var$printGroup(doc, context);
        case 'if-break':
            return $ae252d48f146c7f1$var$printIfBreak(doc, context);
        case 'new-line':
            return $ae252d48f146c7f1$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $ae252d48f146c7f1$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $ae252d48f146c7f1$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $ae252d48f146c7f1$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $ae252d48f146c7f1$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $ae252d48f146c7f1$var$printDoc(doc.breakContents, context);
    return $ae252d48f146c7f1$var$printDoc(doc.flatContents, context);
};
const $ae252d48f146c7f1$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $ae252d48f146c7f1$var$defaultPrintWidth = 100;
const $ae252d48f146c7f1$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $ae252d48f146c7f1$var$defaultPrintWidth } = options;
    const output = $ae252d48f146c7f1$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});


parcelRegister("ho4SO", function(module, exports) {
$parcel$export(module.exports, "ComponentsInlineEditViewWithIsEditable", () => $699cbb166c13207d$export$32ccb5f0cb497709);

var $bPc2T = parcelRequire("bPc2T");

var $7Usdb = parcelRequire("7Usdb");

var $3h1nJ = parcelRequire("3h1nJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $lCtpC = parcelRequire("lCtpC");

var $5SZDT = parcelRequire("5SZDT");

var $auNLL = parcelRequire("auNLL");
const $699cbb166c13207d$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-components-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $699cbb166c13207d$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $699cbb166c13207d$export$32ccb5f0cb497709 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, baseSearchUrl: baseSearchUrl, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql })=>{
    const data = (0, $j4oe4.useFragment)((0, $3h1nJ.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $7Usdb.default));
    const { id: uniqueFieldId, name: name, selectedComponentsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                value: edge?.node?.value ?? '',
                label: edge?.node?.label ?? ''
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.value) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateComponentsField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateComponentsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedComponentsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.value ?? '',
                                            label: edge.label ?? '',
                                            value: edge.value ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $699cbb166c13207d$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'components'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($699cbb166c13207d$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5SZDT.ComponentsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            baseSearchUrl: baseSearchUrl,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover,
            formatComponentJql: formatComponentJql
        })), [
        data,
        baseSearchUrl,
        isTruncated,
        isTruncatedWithHoverPopover,
        formatComponentJql
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (values, actionMeta)=>{
        const mutableOptions = values?.map((i)=>({
                label: i.label,
                value: i.value || ''
            })) || null;
        handleChange(mutableOptions);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleOnChange,
            fetchSuggestionsOnMount: true,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $lCtpC.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $699cbb166c13207d$export$bbb45a0e0da9bd53 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $bPc2T.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($699cbb166c13207d$export$32ccb5f0cb497709, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("bPc2T", function(module, exports) {
$parcel$export(module.exports, "default", () => $869d6499628ae96f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d752273960d62c97543fd5c98cc9b483>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $869d6499628ae96f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraComponentsField"
};
$869d6499628ae96f$var$node.hash = "616223369097ff7023289b730e24e390";
var $869d6499628ae96f$export$2e2bcd8739ae039 = $869d6499628ae96f$var$node;

});

parcelRegister("7Usdb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1ebcbbeceb36b85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a287f8603250d4bcfa340f08a133c0c>>
 * @relayHash 7fdc4a8b53b49ddfa954865ceb36f19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3
const $b1ebcbbeceb36b85$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraComponentsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateComponentsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraComponentsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3",
            "metadata": {},
            "name": "components_issueFieldComponents_ComponentsField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b1ebcbbeceb36b85$var$node.hash = "55d6de75b11bbe1bea570947ba244198";
var $b1ebcbbeceb36b85$export$2e2bcd8739ae039 = $b1ebcbbeceb36b85$var$node;

});

parcelRegister("3h1nJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $79aff15c1c5068e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<176cf950f3063d94accb5a37ad63e7ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $79aff15c1c5068e2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$79aff15c1c5068e2$var$node.hash = "7d58e8d795b9134c31920723b434efe7";
var $79aff15c1c5068e2$export$2e2bcd8739ae039 = $79aff15c1c5068e2$var$node;

});

parcelRegister("lCtpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2539dfc09599984$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d2539dfc09599984$var$ComponentsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7I5QK")), {
        moduleId: "09bac631",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $d2539dfc09599984$export$2e2bcd8739ae039 = $d2539dfc09599984$var$ComponentsEditViewEntryPoint;

});
parcelRegister("7I5QK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dXOpn").then(()=>parcelRequire('kb00V'));

});


parcelRegister("5SZDT", function(module, exports) {
$parcel$export(module.exports, "ComponentsReadView", () => $e07554ca3e796e3f$export$1841519927c4fa28);

var $k0HKH = parcelRequire("k0HKH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ar6fB = parcelRequire("ar6fB");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $bnIBr = parcelRequire("bnIBr");

var $caakL = parcelRequire("caakL");
const $e07554ca3e796e3f$export$e2150facc9f107aa = (componentName)=>`component = ${(0, $bnIBr.toQuotedString)(componentName)}`;
const $e07554ca3e796e3f$export$12458b8497b0a890 = (componentJql, baseSearchUrl = '/issues/')=>`${baseSearchUrl}?jql=${encodeURIComponent(componentJql)}`;
const $e07554ca3e796e3f$export$1841519927c4fa28 = ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover, formatComponentJql: formatComponentJql = $e07554ca3e796e3f$export$e2150facc9f107aa })=>{
    const data = (0, $j4oe4.useFragment)((0, $k0HKH.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedComponents = data?.selectedComponentsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.label)).map((item)=>{
        const href = item?.node?.label ? $e07554ca3e796e3f$export$12458b8497b0a890(formatComponentJql(item?.node?.label), baseSearchUrl) : undefined;
        return {
            name: item?.node?.label || '',
            key: item?.node?.value || '',
            href: href
        };
    }) || [];
    if (!selectedComponents?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $e07554ca3e796e3f$var$widthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedComponents,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $caakL.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e07554ca3e796e3f$var$containerWithNegativeMarginOffset
    }, selectedComponents.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
            key: item.key,
            isRemovable: false,
            text: item.name,
            href: item.href
        })));
};
const $e07554ca3e796e3f$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $e07554ca3e796e3f$var$widthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("k0HKH", function(module, exports) {
$parcel$export(module.exports, "default", () => $cea0b61fb36095e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<309f4d62bd850a58613b75bc1e5b17ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cea0b61fb36095e8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "components_issueFieldComponentsReadviewFull_ComponentsReadView",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "value",
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "alias": "label",
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedComponentsConnection"
        }
    ],
    "type": "JiraComponentsField"
};
$cea0b61fb36095e8$var$node.hash = "35b9643b76a914d7422dfb3f74901db8";
var $cea0b61fb36095e8$export$2e2bcd8739ae039 = $cea0b61fb36095e8$var$node;

});

parcelRegister("ar6fB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bf2340f5bdb4d38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $315a7 = parcelRequire("315a7");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $Ys7jv = parcelRequire("Ys7jv");
var $lncqW = parcelRequire("lncqW");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");

var $h89xH = parcelRequire("h89xH");
const $7bf2340f5bdb4d38$var$textLinkCssVar = '--ds-ctl';
const $7bf2340f5bdb4d38$var$textDefaultCssVar = '--ds-ct';
const $7bf2340f5bdb4d38$var$textActiveCssVar = '--ds-ctp';
const $7bf2340f5bdb4d38$var$backgroundHoverCssVar = '--ds-cbh';
const $7bf2340f5bdb4d38$var$backgroundActiveCssVar = '--ds-cba';
var $7bf2340f5bdb4d38$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($7bf2340f5bdb4d38$var$TagStatus || {});
const $7bf2340f5bdb4d38$var$packageName = "platform-pkg";
const $7bf2340f5bdb4d38$var$packageVersion = "0.0.0-use.local";
const $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $7bf2340f5bdb4d38$var$removingStyles = null;
const $7bf2340f5bdb4d38$var$RemovableTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $3Vuhz.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eJOHy.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eJOHy.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $315a7.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $7bf2340f5bdb4d38$var$packageName,
            packageVersion: $7bf2340f5bdb4d38$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eJOHy.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eJOHy.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eJOHy.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eJOHy.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h89xH.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$7bf2340f5bdb4d38$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$7bf2340f5bdb4d38$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$7bf2340f5bdb4d38$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$7bf2340f5bdb4d38$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$7bf2340f5bdb4d38$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lncqW.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
                    ref: (0, $gyJTO.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hcewu.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $7bf2340f5bdb4d38$var$RemovableTag = /*#__PURE__*/ (0, $eJOHy.memo)($7bf2340f5bdb4d38$var$RemovableTagComponent);
var $7bf2340f5bdb4d38$export$2e2bcd8739ae039 = $7bf2340f5bdb4d38$var$RemovableTag;

});
parcelRegister("lncqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f384baaa61acd2$export$2e2bcd8739ae039);

var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $Ys7jv = parcelRequire("Ys7jv");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $10f384baaa61acd2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    const exiting = (0, $Ys7jv.useExitingPersistence)();
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    const setTimeout = (0, $gcrIE.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $5mfrv.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $34ZNB.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $34ZNB.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $10f384baaa61acd2$export$2e2bcd8739ae039 = $10f384baaa61acd2$var$ShrinkOut;

});
parcelRegister("grWPV", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $d3a4ee4e08936b24$export$ff879f35a69d56b7);

var $eJOHy = parcelRequire("eJOHy");
const $d3a4ee4e08936b24$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eJOHy.useRef)(null);
    const setRef = (0, $eJOHy.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("h89xH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebeaa36c6c332ef4$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $ebeaa36c6c332ef4$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $ebeaa36c6c332ef4$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($ebeaa36c6c332ef4$var$removeButtonStyles.root, $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon.root, (0, $eGOwo.fg)('platform-visual-refresh-icons') && $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebeaa36c6c332ef4$export$2e2bcd8739ae039 = $ebeaa36c6c332ef4$var$RemoveButton;

});
parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});




parcelRegister("bnIBr", function(module, exports) {
$parcel$export(module.exports, "toQuotedString", () => $a183e8d5995c289a$export$dbeab020a4aa404);
$parcel$export(module.exports, "createProjectAllWorkUri", () => $a183e8d5995c289a$export$497544a08e0b5e51);
$parcel$export(module.exports, "createAllWorkUrl", () => $a183e8d5995c289a$export$ca075a1255c9a76d);

var $4cTDP = parcelRequire("4cTDP");
const $a183e8d5995c289a$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $a183e8d5995c289a$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $a183e8d5995c289a$var$ENCODE_MAP[character] || character;
};
const $a183e8d5995c289a$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $a183e8d5995c289a$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $a183e8d5995c289a$export$497544a08e0b5e51 = (jql)=>(0, $4cTDP.fg)('jira_list_nin_merge') ? `/list/?jql=${encodeURIComponent(jql)}` : `/issues/?jql=${encodeURIComponent(jql)}`;
const $a183e8d5995c289a$export$ca075a1255c9a76d = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});

parcelRegister("caakL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6b87dd9236836a3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c6b87dd9236836a3$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-components-readview-full.components.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});
var $c6b87dd9236836a3$export$2e2bcd8739ae039 = $c6b87dd9236836a3$var$messages;

});




parcelRegister("wJcwZ", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectCell", () => $4a8feacfce5feb7b$export$4f505fdc26f544f5);

var $2KeCG = parcelRequire("2KeCG");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $alVoT = parcelRequire("alVoT");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");
const $4a8feacfce5feb7b$export$4f505fdc26f544f5 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $2KeCG.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alVoT.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $4a8feacfce5feb7b$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        isTruncated: true,
        shouldRenderHoverPopover: isFirstField && shouldRenderHoverPopover
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alVoT.CascadingSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: $4a8feacfce5feb7b$var$CustomTarget,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        menuPosition: "fixed",
        isTruncated: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
};
const $4a8feacfce5feb7b$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $4a8feacfce5feb7b$var$customTargetStyles : $4a8feacfce5feb7b$var$customTargetStylesOld,
        ref: ref
    });
});
const $4a8feacfce5feb7b$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: '0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $4a8feacfce5feb7b$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: '0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("2KeCG", function(module, exports) {
$parcel$export(module.exports, "default", () => $130662c119fd55ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ebb0f7e5de3e0258d4718e93a459f4b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $130662c119fd55ad$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "CascadingSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraCascadingSelectField"
};
$130662c119fd55ad$var$node.hash = "1112734932f045893d2130ef6f9132f5";
var $130662c119fd55ad$export$2e2bcd8739ae039 = $130662c119fd55ad$var$node;

});

parcelRegister("alVoT", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectInlineEditViewIsEditable", () => $a381d2d31fb89055$export$d3164c915fdde2ef);
$parcel$export(module.exports, "CascadingSelectInlineEditView", () => $a381d2d31fb89055$export$c72b86275efea41a);

var $jrGLl = parcelRequire("jrGLl");

var $brzz4 = parcelRequire("brzz4");

var $hs8vH = parcelRequire("hs8vH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $9j9do = parcelRequire("9j9do");

var $99gun = parcelRequire("99gun");

var $dG41I = parcelRequire("dG41I");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $tYLUh = parcelRequire("tYLUh");
const $a381d2d31fb89055$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-cascading-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment)); /** Check if the new selected value is equal to the old value */ 
const $a381d2d31fb89055$var$isEqualSelection = (a, b)=>a?.parentOptionValue?.value === b?.parentOptionValue?.value && a?.childOptionValue?.value === b?.childOptionValue?.value;
const $a381d2d31fb89055$var$EditViewWrapper = ({ children: children })=>{
    // This needs to be fixed by DST: go/DSP-22083
    // Dropdown z-index is 1, action bar is 200
    // Bento fixes this by wrapping dropdown into a new 300 stack context
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a381d2d31fb89055$var$wrapperStyles
    }, children);
}; /**
    * Inline edit will handle the switching behaviour between the 'readView' and 'editView' components.
    *
    * @param props [CascadingSelectInlineEditViewProps](./types.tsx)
    */ 
const $a381d2d31fb89055$export$d3164c915fdde2ef = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, readViewFitContainerHeight: readViewFitContainerHeight, hideActionButtons: hideActionButtons = false, menuPosition: menuPosition, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, spacing: spacing = 'default', isTruncated: isTruncated = false, isEditable: isEditable = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)(); // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $hs8vH.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $brzz4.default));
    const { id: uniqueFieldId, cascadingOption: cascadingOption, name: name, fieldId: fieldId, type: fieldType } = data; // #endregion
    // #region State
    const initialValue = (0, $eJOHy.useMemo)(()=>({
            parentOptionValue: cascadingOption?.parentOptionValue ? {
                id: cascadingOption?.parentOptionValue?.id ?? '',
                value: cascadingOption?.parentOptionValue?.value ?? '',
                isDisabled: cascadingOption?.parentOptionValue?.isDisabled
            } : null,
            childOptionValue: cascadingOption?.childOptionValue ? {
                id: cascadingOption?.childOptionValue?.id ?? '',
                value: cascadingOption?.childOptionValue?.value ?? '',
                isDisabled: cascadingOption?.childOptionValue?.isDisabled
            } : null
        }), [
        cascadingOption?.childOptionValue,
        cascadingOption?.parentOptionValue
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]); // #endregion
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newOption); // note: If these objects happen to include more than what is expected, Relay will complain.
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = newOption || {};
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        parentOption: parentOptionValue?.id || null,
                        childOption: childOptionValue?.id || null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateCascadingSelectField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>onFail(error, error.message),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            optimisticResponse: {
                jira: {
                    updateCascadingSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            cascadingOption: newOption
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $a381d2d31fb89055$var$isEqualSelection,
        clipboardComponentType: 'cascadingSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange, invalidMessage: invalidMessage, isEditing: isEditing } = actions; // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a381d2d31fb89055$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dG41I.CascadingSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        isTruncated,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            wrapper: $a381d2d31fb89055$var$EditViewWrapper,
            fieldId: uniqueFieldId,
            autoFocus: true,
            parentOptionValue: updatedValue?.parentOptionValue,
            childOptionValue: updatedValue?.childOptionValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing,
            ...isExperimentEnabled && {
                value: !updatedValue || !updatedValue.parentOptionValue?.id ? null : updatedValue
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $9j9do.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: hideActionButtons,
        hasReadViewTruncateDisabled: shouldRenderHoverPopover
    }); // #endregion Action
};
const $a381d2d31fb89055$export$c72b86275efea41a = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $jrGLl.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a381d2d31fb89055$export$d3164c915fdde2ef, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $a381d2d31fb89055$var$wrapperStyles = (0, $1DXK0.xcss)({
    zIndex: 'modal',
    position: 'relative'
});

});
parcelRegister("jrGLl", function(module, exports) {
$parcel$export(module.exports, "default", () => $851ebb56b44cef28$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391d228206c5d2da2084fd47967509e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $851ebb56b44cef28$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraCascadingSelectField"
};
$851ebb56b44cef28$var$node.hash = "e2f7106f0e284e4683ba8bf8fd5fa780";
var $851ebb56b44cef28$export$2e2bcd8739ae039 = $851ebb56b44cef28$var$node;

});

parcelRegister("brzz4", function(module, exports) {
$parcel$export(module.exports, "default", () => $297c463699425fe3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<536cc6e4be6a9e008fa89cd2d190dd49>>
 * @relayHash d4f2fd55ec1cda569c82f3a78e17226c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3430325e9d7c639fc8979955e4f2694766d816c7b02d5f34ceb0cb60423e7ce9
const $297c463699425fe3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCascadingSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateCascadingSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraCascadingSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3430325e9d7c639fc8979955e4f2694766d816c7b02d5f34ceb0cb60423e7ce9",
            "metadata": {},
            "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$297c463699425fe3$var$node.hash = "792c8e7af6ed535746e17a76dc52564b";
var $297c463699425fe3$export$2e2bcd8739ae039 = $297c463699425fe3$var$node;

});

parcelRegister("hs8vH", function(module, exports) {
$parcel$export(module.exports, "default", () => $00ae13543d7d5391$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ae6d5401514d5954c10b2c3baa89186>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $00ae13543d7d5391$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$00ae13543d7d5391$var$node.hash = "afadb43a696a96b327cd8181443d429b";
var $00ae13543d7d5391$export$2e2bcd8739ae039 = $00ae13543d7d5391$var$node;

});

parcelRegister("9j9do", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d63c91c286e9e61$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9d63c91c286e9e61$var$CascadingEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bwgf1")), {
        moduleId: "d23a4651",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $9d63c91c286e9e61$export$2e2bcd8739ae039 = $9d63c91c286e9e61$var$CascadingEditViewEntryPoint;

});
parcelRegister("bwgf1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dnyoG").then(()=>parcelRequire('lOgAb'));

});


parcelRegister("dG41I", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectReadView", () => $1a98731018f28a4c$export$4b0478fdeeb1c69);

var $lDsel = parcelRequire("lDsel");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");

var $3Lkm9 = parcelRequire("3Lkm9");

var $k6Nau = parcelRequire("k6Nau");

var $9Ndu3 = parcelRequire("9Ndu3");
const $1a98731018f28a4c$var$getFieldValueAsText = (cascadingOption)=>{
    if (!cascadingOption || !cascadingOption?.parentOptionValue) return null;
    if (!cascadingOption?.childOptionValue) return cascadingOption.parentOptionValue.value;
    return `${cascadingOption.parentOptionValue.value} - ${cascadingOption.childOptionValue.value}`;
};
const $1a98731018f28a4c$export$4b0478fdeeb1c69 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $lDsel.default), fragmentRef);
    const { cascadingOption: cascadingOption } = data;
    const fieldValueAsText = $1a98731018f28a4c$var$getFieldValueAsText(cascadingOption);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: fieldValueAsText
    });
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!fieldValueAsText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenCascadingSelectPlaceholderEmptyFieldText
    });
    if (isTruncated) {
        if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
            value: fieldValueAsText,
            ref: hoverPopoverRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ndu3.CascadingSelectOptionTruncated), {
            value: fieldValueAsText
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldValueAsText);
};

});
parcelRegister("lDsel", function(module, exports) {
$parcel$export(module.exports, "default", () => $f289b1101cffcad0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a989a5fab7a00d0dd8cf9e21787bea2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f289b1101cffcad0$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
}();
$f289b1101cffcad0$var$node.hash = "ff5454b1cc5b1b18150500d392d7759f";
var $f289b1101cffcad0$export$2e2bcd8739ae039 = $f289b1101cffcad0$var$node;

});

parcelRegister("k6Nau", function(module, exports) {
$parcel$export(module.exports, "useBespokeEmptyFieldTextGA", () => $0f6d5c201f25ecc0$export$742913b25ea3560e);

var $cxKOj = parcelRequire("cxKOj");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $FhXEJ = parcelRequire("FhXEJ");
const $0f6d5c201f25ecc0$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT)) && isFieldRenderedInIssueView;
};
const $0f6d5c201f25ecc0$export$742913b25ea3560e = ()=>{
    const isExperimentEligible = $0f6d5c201f25ecc0$var$useIsExperimentEligible();
    const isBespokePlaceholderEnabled = isExperimentEligible && (0, $cxKOj.expVal)('bespoke-placeholder-experiment-ga', 'isEnabled', false);
    return isBespokePlaceholderEnabled;
};

});

parcelRegister("9Ndu3", function(module, exports) {
$parcel$export(module.exports, "CascadingSelectOptionTruncated", () => $d5a65d8f464678ec$export$8691872cfdb45f29);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d5a65d8f464678ec$export$8691872cfdb45f29 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ value: value }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $d5a65d8f464678ec$var$cascadingValueStylesTruncated,
        ref: ref
    }, value);
});
const $d5a65d8f464678ec$var$cascadingValueStylesTruncated = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: '100%'
});

});




parcelRegister("40Xgt", function(module, exports) {
$parcel$export(module.exports, "DateCell", () => $d91a8d1b3542e6b2$export$64a69967f353bb7c);
$parcel$export(module.exports, "DateInlineEditCell", () => $d91a8d1b3542e6b2$export$976ea8051f04575);

var $d0Tjw = parcelRequire("d0Tjw");

var $1I7sZ = parcelRequire("1I7sZ");

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7qGN1 = parcelRequire("7qGN1");

var $5gpGG = parcelRequire("5gpGG");

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $eqbO4 = parcelRequire("eqbO4");

var $86BUM = parcelRequire("86BUM");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $d91a8d1b3542e6b2$var$parseDate = (dateString)=>{
    if (dateString !== null && dateString !== '') {
        const date = (0, $kQ82p.default)(dateString);
        if (date.toString() !== 'Invalid Date') return date;
    }
    return null;
};
const $d91a8d1b3542e6b2$var$formattedDate = (dateString)=>{
    const date = $d91a8d1b3542e6b2$var$parseDate(dateString);
    if (!date) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7qGN1.FormattedDate), {
        value: date,
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
const $d91a8d1b3542e6b2$export$64a69967f353bb7c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRequired: isRequired })=>{
    const data = (0, $j4oe4.useFragment)((0, $1I7sZ.default), fieldRef);
    if (data.__typename === 'JiraDatePickerField' && data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).DUE_DATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d91a8d1b3542e6b2$export$976ea8051f04575, {
        fieldRef: data
    });
    let date = null;
    if (data.__typename === 'JiraDatePickerField') date = data.date ?? null;
    else if (data.__typename === 'JiraDateTimePickerField') date = data.dateTime ?? null;
    if (isRequired && date == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "date",
        reason: "Missing required fields"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d91a8d1b3542e6b2$var$wrapperStyles
    }, $d91a8d1b3542e6b2$var$formattedDate(date));
});
const $d91a8d1b3542e6b2$export$976ea8051f04575 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $d0Tjw.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gpGG.DateInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $d91a8d1b3542e6b2$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gpGG.DateInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldShowHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $d91a8d1b3542e6b2$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $d91a8d1b3542e6b2$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $d91a8d1b3542e6b2$var$customTargetStyles : $d91a8d1b3542e6b2$var$customTargetStylesOld,
        ref: ref
    });
});
const $d91a8d1b3542e6b2$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $d91a8d1b3542e6b2$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("d0Tjw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1322a19d1bc13a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6a8c71f5f1afa282471b7c614b7a657>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1322a19d1bc13a9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DateInlineEditCell_DateInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDatePickerField"
};
$c1322a19d1bc13a9$var$node.hash = "1b7d630d3dcbf1130faba8a093d7e599";
var $c1322a19d1bc13a9$export$2e2bcd8739ae039 = $c1322a19d1bc13a9$var$node;

});

parcelRegister("1I7sZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $88e35579ddca15ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b7a86ed570e1710e3b96774dd68b700>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $88e35579ddca15ff$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DateInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "date"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isInlineEditingEnabled",
                            "variableName": "isInlineEditingEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DateInlineEditCell_DateInlineEditCell"
                }
            ],
            "type": "JiraDatePickerField"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$88e35579ddca15ff$var$node.hash = "08f283612324c48c575ea0eab88bb740";
var $88e35579ddca15ff$export$2e2bcd8739ae039 = $88e35579ddca15ff$var$node;

});

parcelRegister("5gpGG", function(module, exports) {
$parcel$export(module.exports, "DateInlineEditViewWithIsEditable", () => $da48bca7bd3c96b9$export$af387cb7b19f78a3);
$parcel$export(module.exports, "DateInlineEditView", () => $da48bca7bd3c96b9$export$d1623660a0dc5b59);

var $9y3IM = parcelRequire("9y3IM");

var $96KlH = parcelRequire("96KlH");

var $6V9qT = parcelRequire("6V9qT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $FhXEJ = parcelRequire("FhXEJ");

var $h6i8k = parcelRequire("h6i8k");

var $4cTDP = parcelRequire("4cTDP");

var $l11m9 = parcelRequire("l11m9");

var $bekdN = parcelRequire("bekdN");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $cxKOj = parcelRequire("cxKOj");

var $8oOr4 = parcelRequire("8oOr4");

var $6pncb = parcelRequire("6pncb");

var $bmoS1 = parcelRequire("bmoS1");

var $fkc6h = parcelRequire("fkc6h");

var $bNexr = parcelRequire("bNexr");

var $ftN6c = parcelRequire("ftN6c");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $hbF3h = parcelRequire("hbF3h");

var $k745d = parcelRequire("k745d");
const $da48bca7bd3c96b9$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-date-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $da48bca7bd3c96b9$var$RecurWorkItemContainerEmpty = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $da48bca7bd3c96b9$export$7358e6ab68a1bc5c = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('thor-date-field-use-monitoring-wrapper'), (0, $fkc6h.useIssueExperienceMonitoring), ()=>({
        enrichCommitWithIssueExperienceMonitoring: (mutationArgs)=>mutationArgs
    }));
const $da48bca7bd3c96b9$export$af387cb7b19f78a3 = (props)=>{
    const { attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupTarget: editViewPopupTarget, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, isEditing: isEditingProp = false, isEditable: isEditable, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, includeUrgencyTreatment: includeUrgencyTreatment, context: context, shouldShowHoverPopover: shouldShowHoverPopover } = props;
    const data = (0, $j4oe4.useFragment)((0, $6V9qT.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $96KlH.default));
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = $da48bca7bd3c96b9$export$7358e6ab68a1bc5c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, fieldConfig: fieldConfig } = data;
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    const validator = (0, $k745d.useDateValidator)(fieldName, isFieldRequired);
    const initialValue = data.date ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail }, event)=>{
        if ((0, $4cTDP.fg)('thor-date-field-use-monitoring-wrapper')) (0, $h6i8k.default)('issue.field.date.edit', event?.timeStamp);
        onSubmit?.(value);
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        date: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateField: {
                        success: true,
                        errors: null,
                        field: {
                            date: value,
                            id: uniqueFieldId
                        }
                    }
                }
            }
        }, 'date_issueFieldDate_DateField_Mutation', {
            sendUFOEvent: true
        }, ()=>(0, $4cTDP.fg)('thor-date-field-use-monitoring-wrapper')));
    }, [
        commit,
        onSubmit,
        uniqueFieldId,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.(value);
    }, [
        onSubmitSucceeded
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: isEditingProp,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'date'
    });
    const isRecurWorkItemEnabled = (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT)) && context === 'ISSUE_DETAIL' && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurringWorkPopup', false);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da48bca7bd3c96b9$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bekdN.DateReadView), {
            fragmentRef: data,
            includeUrgencyTreatment: includeUrgencyTreatment,
            ...(0, $4cTDP.fg)('issue_view_due_date_colored_field_targeting_gate') ? {
                fieldId: fieldId
            } : {},
            shouldShowRecurWorkIcon: isRecurWorkItemEnabled && (0, $cxKOj.expVal)('jira-recur-single-work-item-on-sched-due-date-exp', 'showRecurWorkIconInDueDate', false),
            shouldShowHoverPopover: shouldShowHoverPopover
        })), [
        data,
        fieldId,
        includeUrgencyTreatment,
        isRecurWorkItemEnabled,
        shouldShowHoverPopover
    ]);
    const RecurWorkItemContainer = isRecurWorkItemEnabled ? (0, $6pncb.RecurWorkItemContainer) : $da48bca7bd3c96b9$var$RecurWorkItemContainerEmpty;
    // copied from @atlassian/jira-inline-edit-lite/src/ui/use-inline-edit/index.tsx
    const handleCancelWithEvent = (0, $eJOHy.useCallback)(()=>handleCancel(createAnalyticsEvent({
            action: 'canceled',
            actionSubject: 'inlineEdit'
        })), [
        handleCancel,
        createAnalyticsEvent
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: handleChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            label: fieldName,
            ...isRecurWorkItemEnabled && {
                issueKey: issueKey,
                isRecurWorkItemEnabled: isRecurWorkItemEnabled,
                onCancel: handleCancelWithEvent
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RecurWorkItemContainer, {
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $l11m9.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        invalidMessage: invalidMessage,
        hideActionButtons: true
    }));
};
const $da48bca7bd3c96b9$export$d1623660a0dc5b59 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $9y3IM.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da48bca7bd3c96b9$export$af387cb7b19f78a3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("9y3IM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5665c7d240b1b213$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c7e4c91cc0608cf472bd3e81527b427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5665c7d240b1b213$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$5665c7d240b1b213$var$node.hash = "0548aa5d7a0a6ecdbe8581123c90487f";
var $5665c7d240b1b213$export$2e2bcd8739ae039 = $5665c7d240b1b213$var$node;

});

parcelRegister("96KlH", function(module, exports) {
$parcel$export(module.exports, "default", () => $9886dde8952c3b20$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b134f64f11ffd1a4cc70559f78e71c9>>
 * @relayHash cb875b164e467c388678144a56847c99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4a8e2a313c01273300fc41c78b263d8655ffa36feab8671b8a00e403ffdb829
const $9886dde8952c3b20$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "date"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "date_issueFieldDate_DateField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDatePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c4a8e2a313c01273300fc41c78b263d8655ffa36feab8671b8a00e403ffdb829",
            "metadata": {},
            "name": "date_issueFieldDate_DateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9886dde8952c3b20$var$node.hash = "210cf117686622e3bb1cfb655e147341";
var $9886dde8952c3b20$export$2e2bcd8739ae039 = $9886dde8952c3b20$var$node;

});

parcelRegister("6V9qT", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e881deeddfc7042$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e77458cde4889443c861d0d7069e28b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e881deeddfc7042$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "date_issueFieldDateReadviewFull_DateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }
    ],
    "type": "JiraDatePickerField"
};
$3e881deeddfc7042$var$node.hash = "2d11e23373a2a9517c8a8ac5a6bfe366";
var $3e881deeddfc7042$export$2e2bcd8739ae039 = $3e881deeddfc7042$var$node;

});

parcelRegister("l11m9", function(module, exports) {
$parcel$export(module.exports, "default", () => $28e41e4dc412b477$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $28e41e4dc412b477$var$DateEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bPnKn")), {
        moduleId: "652b5c22",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $28e41e4dc412b477$export$2e2bcd8739ae039 = $28e41e4dc412b477$var$DateEditViewEntryPoint;

});
parcelRegister("bPnKn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lx5kZ")
]).then(()=>parcelRequire('7tcPf'));

});


parcelRegister("bekdN", function(module, exports) {
$parcel$export(module.exports, "DateReadView", () => $5f9b76cb43e378fb$export$c663acc1a0b7c5a9);

var $3JU4H = parcelRequire("3JU4H");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $bemI6 = parcelRequire("bemI6");

var $4cTDP = parcelRequire("4cTDP");

var $lBRZk = parcelRequire("lBRZk");

var $dVT0O = parcelRequire("dVT0O");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $3NHJr = parcelRequire("3NHJr");

var $8oOr4 = parcelRequire("8oOr4");

var $6pncb = parcelRequire("6pncb");

var $9Vf8k = parcelRequire("9Vf8k");

var $bzbsd = parcelRequire("bzbsd");

var $9Mapt = parcelRequire("9Mapt");

var $3OT15 = parcelRequire("3OT15");

var $chMwR = parcelRequire("chMwR");

var $7y0HS = parcelRequire("7y0HS");
const $5f9b76cb43e378fb$var$RecurringWorkItemIcon = ({ useUrgentColour: useUrgentColour })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $6pncb.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bemI6))), {
        label: "",
        testId: "issue-field-date-readview-full.ui.date.recur-work-icon",
        ...useUrgentColour ? {
            color: "var(--ds-icon-danger, #C9372C)"
        } : {}
    });
};
const $5f9b76cb43e378fb$var$EmptyContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $5f9b76cb43e378fb$export$c663acc1a0b7c5a9 = ({ fragmentRef: fragmentRef, fieldId: fieldId, includeUrgencyTreatment: includeUrgencyTreatment, shouldShowRecurWorkIcon: shouldShowRecurWorkIcon = false, shouldShowHoverPopover: shouldShowHoverPopover })=>{
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const noValueTextExperiment = formatMessage(fieldId === (0, $8oOr4.DUE_DATE) ? (0, $7y0HS.default).noValueTextExperimentDueDate : (0, $7y0HS.default).noValueTextExperiment);
    const data = (0, $j4oe4.useFragment)((0, $3JU4H.default), fragmentRef);
    const { date: date } = data || {};
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldShowHoverPopover && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (!date) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const daysSinceDate = (0, $chMwR.getNoOfDaysSinceUTCDateString)(date);
    const isDatePast = daysSinceDate != null && daysSinceDate > 0;
    const isDueToday = daysSinceDate === 0;
    const renderColoredDueDate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBRZk.ColoredDueDate), {
            dateString: date,
            pastDue: isDatePast && Boolean(includeUrgencyTreatment) && fieldId === (0, $8oOr4.DUE_DATE),
            dueToday: isDueToday && Boolean(includeUrgencyTreatment) && fieldId === (0, $8oOr4.DUE_DATE),
            warningIconTestId: "date-field.warning-icon",
            clockIconTestId: "date-field.clock-icon",
            calendarIconTestId: "date-field.calendar-icon",
            maybeShowRecurIcon: shouldShowRecurWorkIcon,
            recurIconTestId: "date-field.recur-icon"
        });
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: formatDateOnly(date)
    });
    const renderedValue = includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('due_date_colured_field', 'showUrgencyIndicator', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dVT0O.DateWithUrgencyIndicator), {
        value: date
    }) : formatDateOnly(date);
    const Container = shouldShowRecurWorkIcon ? (0, $3Wh6p.default) : $5f9b76cb43e378fb$var$EmptyContainer;
    /**
   * Hover popover is only enabled on NIN, GNIN, and CHIN and hence the conditional rendering of
   * other formatted dates is ignroed
   */ if (shouldShowHoverPopover) return (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $5f9b76cb43e378fb$var$dateReadViewStyles,
            $5f9b76cb43e378fb$var$singleLineStyles
        ],
        ref: hoverPopoverRef
    }, formatDateOnly(date))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        contentRef: contentRef,
        content: formatDateOnly(date)
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
            space: "space.075",
            alignBlock: "center",
            testId: "issue-field-date-readview-full.ui.date.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: [
                $5f9b76cb43e378fb$var$dateReadViewStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            maxLines: 1,
            ref: (0, $bzbsd.mergeRefs)(ref, contentRef)
        }, formatDateOnly(date)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, {
        space: "space.075",
        alignBlock: "center",
        testId: "issue-field-date-readview-full.ui.date.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $5f9b76cb43e378fb$var$dateReadViewStyles,
            !(includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('color_due_date_all_views', 'showColoredDueDate', false)) && $5f9b76cb43e378fb$var$clampStyles
        ]
    }, includeUrgencyTreatment && fieldId === (0, $8oOr4.DUE_DATE) && (0, $cxKOj.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? renderColoredDueDate() : renderedValue), !(0, $cxKOj.expVal)('color_due_date_all_views', 'showColoredDueDate', false) && shouldShowRecurWorkIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f9b76cb43e378fb$var$RecurringWorkItemIcon, {
        useUrgentColour: (isDatePast || isDueToday) && !!includeUrgencyTreatment && (0, $cxKOj.expVal)('due_date_colured_field', 'showUrgencyIndicator', false)
    }));
};
const $5f9b76cb43e378fb$var$dateReadViewStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $5f9b76cb43e378fb$var$clampStyles = (0, $1DXK0.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
});
const $5f9b76cb43e378fb$var$singleLineStyles = (0, $1DXK0.xcss)({
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1
});

});
parcelRegister("3JU4H", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6dd5f636cb2f6de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a35fee1cfaa8a326bc1500f46687768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6dd5f636cb2f6de$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "date_issueFieldDateReadviewFull_DateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "date"
        }
    ],
    "type": "JiraDatePickerField"
};
$f6dd5f636cb2f6de$var$node.hash = "9249ac9d622710a08c9de2f57a3e7b89";
var $f6dd5f636cb2f6de$export$2e2bcd8739ae039 = $f6dd5f636cb2f6de$var$node;

});

parcelRegister("bemI6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0b019b9a1703ba836e9431143f4089a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82d29e52dbda888e$var$_react = $82d29e52dbda888e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $82d29e52dbda888e$var$_baseNew = $82d29e52dbda888e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $82d29e52dbda888e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82d29e52dbda888e$var$RepeatIcon = (props)=>/*#__PURE__*/ $82d29e52dbda888e$var$_react.default.createElement($82d29e52dbda888e$var$_baseNew.default, Object.assign({
        name: "RepeatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$82d29e52dbda888e$var$RepeatIcon.displayName = 'RepeatIcon';
var $82d29e52dbda888e$var$_default = module.exports.default = $82d29e52dbda888e$var$RepeatIcon;

});

parcelRegister("lBRZk", function(module, exports) {
$parcel$export(module.exports, "ColoredDueDate", () => $a14336caaa0d75c4$export$63c54814247cca36);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bemI6 = parcelRequire("bemI6");

var $btkTq = parcelRequire("btkTq");

var $i5stJ = parcelRequire("i5stJ");

var $leOHG = parcelRequire("leOHG");

var $k71qx = parcelRequire("k71qx");

var $1M2hR = parcelRequire("1M2hR");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $6pncb = parcelRequire("6pncb");

var $9Vf8k = parcelRequire("9Vf8k");

var $kPKM4 = parcelRequire("kPKM4");
const $a14336caaa0d75c4$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $6pncb.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bemI6))), {
        label: "",
        testId: testId
    });
};
const $a14336caaa0d75c4$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $1M2hR.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const isYearLiteralInShortFormat = part.type === 'literal' && (dateParts[index + 1]?.type === 'year' || dateParts[index - 1]?.type === 'year') && !includeYear;
            if (part.type === 'year' && includeYear || part.type !== 'year' && !isYearLiteralInShortFormat) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $kPKM4.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $kPKM4.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const iconLabel = pastDue ? formatMessage((0, $kPKM4.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $kPKM4.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $a14336caaa0d75c4$var$styles.dateTag,
            $a14336caaa0d75c4$var$styles.flexContainer,
            pastDue ? $a14336caaa0d75c4$var$styles.overdue : undefined,
            dueToday ? $a14336caaa0d75c4$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $a14336caaa0d75c4$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a14336caaa0d75c4$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($leOHG))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a14336caaa0d75c4$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $a14336caaa0d75c4$var$styles = {
    dateTag: (0, $1DXK0.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'radius.small',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    dateTagNoBorder: (0, $1DXK0.xcss)({
        cursor: 'pointer'
    }),
    flexContainer: (0, $1DXK0.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $1DXK0.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $1DXK0.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $1DXK0.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $1DXK0.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("leOHG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7623c787bc0988e$var$_react = $f7623c787bc0988e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f7623c787bc0988e$var$_baseNew = $f7623c787bc0988e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f7623c787bc0988e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7623c787bc0988e$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $f7623c787bc0988e$var$_react.default.createElement($f7623c787bc0988e$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f7623c787bc0988e$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $f7623c787bc0988e$var$_default = module.exports.default = $f7623c787bc0988e$var$WarningOutlineIcon;

});

parcelRegister("6pncb", function(module, exports) {
$parcel$export(module.exports, "RecurWorkItemContainer", () => $c7179b3f6e81c7a6$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $c7179b3f6e81c7a6$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $c7179b3f6e81c7a6$export$eb9ad4e1e739768e);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $cHtIB = parcelRequire("cHtIB");

var $kyq27 = parcelRequire("kyq27");

var $bNexr = parcelRequire("bNexr");

var $3MbOI = parcelRequire("3MbOI");

var $eSnSE = parcelRequire("eSnSE");

var $5Ix22 = parcelRequire("5Ix22");

var $as8tn = parcelRequire("as8tn");
const $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer = (0, $6E16M.createContainer)();
const $c7179b3f6e81c7a6$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const environment = (0, $kyq27.useEnvironment)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!projectId) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $c7179b3f6e81c7a6$var$Store = (0, $GtRbT.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $as8tn.INITIAL_STATE),
    actions: $5Ix22.actions,
    containedBy: $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $5Ix22.actions).fetch());
            }
    }
});
const $c7179b3f6e81c7a6$export$5730c874dfb9803f = (0, $iJq0l.createStateHook)($c7179b3f6e81c7a6$var$Store);
const $c7179b3f6e81c7a6$export$eb9ad4e1e739768e = (0, $iJq0l.createActionsHook)($c7179b3f6e81c7a6$var$Store);

});
parcelRegister("5Ix22", function(module, exports) {
$parcel$export(module.exports, "actions", () => $13cafe401ee5ee68$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1Lz15 = parcelRequire("1Lz15");

var $2ZEsM = parcelRequire("2ZEsM");

var $b7KsF = parcelRequire("b7KsF");

var $f0czN = parcelRequire("f0czN");
const $13cafe401ee5ee68$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $13cafe401ee5ee68$export$e324594224ef24da = {
    fetch: $1Lz15.fetch,
    setIssueProperties: $13cafe401ee5ee68$export$5153917efea4a83d,
    setAsNonRecurringIssue: $2ZEsM.setAsNonRecurringIssue,
    setAsRecurringIssue: $b7KsF.setAsRecurringIssue,
    updateRule: $f0czN.updateRule
};

});
parcelRegister("1Lz15", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");

var $k9ldc = parcelRequire("k9ldc");

var $g7LgB = parcelRequire("g7LgB");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $9Vf8k = parcelRequire("9Vf8k");
const $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $g7LgB.RuleState).DISABLED) {
                    await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4cTDP.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("k9ldc", function(module, exports) {
$parcel$export(module.exports, "fetchIssueProperties", () => $5469679b83f8a32d$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $5469679b83f8a32d$export$3cada9835f092161);

var $jbPE2 = parcelRequire("jbPE2");

var $14RSn = parcelRequire("14RSn");

var $keOPi = parcelRequire("keOPi");
const $5469679b83f8a32d$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $keOPi.performIssueGetRequest)(recurrenceConfigEndpoint, undefined, 'recur-work-item/src/services/fetch-rule');
    } catch (error) {
        if (error instanceof (0, $14RSn.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $5469679b83f8a32d$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $keOPi.performIssueGetRequest)(summaryEndpoint, undefined, 'recur-work-item/src/services/fetch-rule');
    } catch (error) {
        if (error instanceof (0, $14RSn.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("jbPE2", function(module, exports) {
$parcel$export(module.exports, "getAutomationStack", () => $192a6ea715d806e4$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $192a6ea715d806e4$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $192a6ea715d806e4$export$8e479e490e1e69bc);

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
const $192a6ea715d806e4$var$localStorage = (0, $3hRxq.createLocalStorageProvider)('automation-menu');
const $192a6ea715d806e4$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $192a6ea715d806e4$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4cTDP.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $192a6ea715d806e4$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $192a6ea715d806e4$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $192a6ea715d806e4$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $192a6ea715d806e4$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $192a6ea715d806e4$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $192a6ea715d806e4$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4cTDP.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("g7LgB", function(module, exports) {
$parcel$export(module.exports, "RuleState", () => $fc4f058c04244dcc$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $fc4f058c04244dcc$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $fc4f058c04244dcc$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $fc4f058c04244dcc$export$c07ca23c166d6344);
const $fc4f058c04244dcc$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $fc4f058c04244dcc$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $fc4f058c04244dcc$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $fc4f058c04244dcc$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("f3jI4", function(module, exports) {
$parcel$export(module.exports, "deleteRule", () => $e4bbd2fe0788cecd$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $e4bbd2fe0788cecd$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a);

var $jbPE2 = parcelRequire("jbPE2");

var $keOPi = parcelRequire("keOPi");

var $3ugTQ = parcelRequire("3ugTQ");
const $e4bbd2fe0788cecd$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $keOPi.performIssueDeleteRequest)(DELETE_RULE_URL, undefined, 'recur-work-item/src/services/set-non-recurring');
};
const $e4bbd2fe0788cecd$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $keOPi.performIssueDeleteRequest)(ruleConfigEndpoint, undefined, 'recur-work-item/src/services/set-non-recurring');
};
const $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    // eslint-disable-next-line jira/js/no-jira-fetch
    return (0, $3ugTQ.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("9riZR", function(module, exports) {
$parcel$export(module.exports, "callServiceWithAnalytics", () => $6b2665faae66cf06$export$7ad2acdaf7d8c23c);

var $14RSn = parcelRequire("14RSn");

var $kRgKj = parcelRequire("kRgKj");
const $6b2665faae66cf06$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $14RSn.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $6b2665faae66cf06$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$6b2665faae66cf06$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("9Vf8k", function(module, exports) {
$parcel$export(module.exports, "mapFrequencyToRRule", () => $aefb7d8338ffa0c9$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $aefb7d8338ffa0c9$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $aefb7d8338ffa0c9$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $aefb7d8338ffa0c9$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $aefb7d8338ffa0c9$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $aefb7d8338ffa0c9$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $aefb7d8338ffa0c9$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $aefb7d8338ffa0c9$export$555109634e8a63b6);

var $cSmYj = parcelRequire("cSmYj");

var $5IPrF = parcelRequire("5IPrF");

var $8RQlO = parcelRequire("8RQlO");

var $e3Aqb = parcelRequire("e3Aqb");

var $fBF7C = parcelRequire("fBF7C");
var $h5cuQ = parcelRequire("h5cuQ");

var $9RPB3 = parcelRequire("9RPB3");

var $4cTDP = parcelRequire("4cTDP");

var $3lACf = parcelRequire("3lACf");

var $b5IjV = parcelRequire("b5IjV");
const $aefb7d8338ffa0c9$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig, recurDayOfMonth)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                byDay: [
                    (0, $9RPB3.Days).MO,
                    (0, $9RPB3.Days).TU,
                    (0, $9RPB3.Days).WE,
                    (0, $9RPB3.Days).TH,
                    (0, $9RPB3.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        case 'MONTHLY':
            return {
                frequency: (0, $9RPB3.Frequencies).MONTHLY,
                byMonthDay: recurDayOfMonth ? [
                    recurDayOfMonth
                ] : [],
                interval: 1
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        case 'MONTHLY':
            return '{{now.plusMonths(1)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9RPB3.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(rrule.byDay, [
            (0, $9RPB3.Days).MO,
            (0, $9RPB3.Days).TU,
            (0, $9RPB3.Days).WE,
            (0, $9RPB3.Days).TH,
            (0, $9RPB3.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9RPB3.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
    if (rrule.frequency === (0, $9RPB3.Frequencies).MONTHLY && rrule.interval === 1) return 'MONTHLY';
};
const $aefb7d8338ffa0c9$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $b5IjV.default).recursOnComplete;
    const frequency = $aefb7d8338ffa0c9$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $b5IjV.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $b5IjV.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $b5IjV.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $b5IjV.default).recursWeekly;
    // Monthly
    if (frequency === 'MONTHLY') return (0, $b5IjV.default).recursMonthly;
    return (0, $b5IjV.default).setToRecur;
};
const $aefb7d8338ffa0c9$var$byDayOptions = Object.values((0, $9RPB3.Days));
const $aefb7d8338ffa0c9$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $aefb7d8338ffa0c9$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$aefb7d8338ffa0c9$var$byDayOptions}`);
    const firstDayOfWeek = (0, $5IPrF.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $8RQlO.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $aefb7d8338ffa0c9$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$aefb7d8338ffa0c9$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $aefb7d8338ffa0c9$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, recurDayOfMonth: recurDayOfMonth, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'MONTHLY':
                    if (!recurDayOfMonth) throw new Error('A monthly recurring rule requires a recurDayOfMonth');
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteMonthly, {
                            issueKey: issueKey
                        }),
                        description: recurDayOfMonth > 0 ? intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteMonthly, {
                            issueType: issueTypeLowercase,
                            ordinalDayOfMonth: (0, $3lACf.getRecurDayOfMonthOptionLabel)(intl.formatMessage, recurDayOfMonth)
                        }) : intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteMonthlyLastDay, {
                            issueType: issueTypeLowercase
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'MONTHLY':
                    if (!recurDayOfMonth) throw new Error('A monthly recurring rule requires a recurDayOfMonth');
                    return {
                        title: recurDayOfMonth > 0 ? intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleMonthly, {
                            issueKey: issueKey,
                            ordinalDayOfMonth: (0, $3lACf.getRecurDayOfMonthOptionLabel)(intl.formatMessage, recurDayOfMonth)
                        }) : intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleMonthlyLastDay, {
                            issueKey: issueKey
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $aefb7d8338ffa0c9$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $aefb7d8338ffa0c9$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $aefb7d8338ffa0c9$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $aefb7d8338ffa0c9$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$aefb7d8338ffa0c9$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return (0, $4cTDP.fg)('jira-monthly-recurring-work-item-option') ? !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(formInput.byDay, formOutput.byDay) : !$aefb7d8338ffa0c9$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    if (formInput.frequency === 'MONTHLY') return formInput.dayOfMonth !== formOutput.dayOfMonth;
    return false;
};
const $aefb7d8338ffa0c9$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $e3Aqb.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $e3Aqb.default)(userTimezone);
    return (0, $fBF7C.default)((0, $h5cuQ.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9RPB3", function(module, exports) {
$parcel$export(module.exports, "NEWLINE_REGEX", () => $0c0ab4669e06d62e$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $0c0ab4669e06d62e$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $0c0ab4669e06d62e$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $0c0ab4669e06d62e$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $0c0ab4669e06d62e$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $0c0ab4669e06d62e$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $0c0ab4669e06d62e$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $0c0ab4669e06d62e$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $0c0ab4669e06d62e$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $0c0ab4669e06d62e$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $0c0ab4669e06d62e$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $0c0ab4669e06d62e$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $0c0ab4669e06d62e$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $0c0ab4669e06d62e$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $0c0ab4669e06d62e$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $0c0ab4669e06d62e$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $0c0ab4669e06d62e$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $0c0ab4669e06d62e$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $0c0ab4669e06d62e$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $0c0ab4669e06d62e$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $0c0ab4669e06d62e$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $0c0ab4669e06d62e$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $0c0ab4669e06d62e$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $0c0ab4669e06d62e$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $0c0ab4669e06d62e$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $0c0ab4669e06d62e$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $0c0ab4669e06d62e$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $0c0ab4669e06d62e$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $0c0ab4669e06d62e$export$f3abe3d006c81602);
const $0c0ab4669e06d62e$export$665ca7211e0c33c = /\r?\n/;
const $0c0ab4669e06d62e$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $0c0ab4669e06d62e$export$ae9ea0d00d3d8982 = 'CRLF';
const $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a = '\r\n';
const $0c0ab4669e06d62e$export$606cfc2a8896c91f = 'LF';
const $0c0ab4669e06d62e$export$477fea8aa280bb1e = '\n';
const $0c0ab4669e06d62e$export$ccae594c20078277 = {
    CRLF: $0c0ab4669e06d62e$export$ae9ea0d00d3d8982,
    LF: $0c0ab4669e06d62e$export$606cfc2a8896c91f
};
const $0c0ab4669e06d62e$export$c3edd2b21ac02f88 = {
    [$0c0ab4669e06d62e$export$ae9ea0d00d3d8982]: $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a,
    [$0c0ab4669e06d62e$export$606cfc2a8896c91f]: $0c0ab4669e06d62e$export$477fea8aa280bb1e
};
const $0c0ab4669e06d62e$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $0c0ab4669e06d62e$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $0c0ab4669e06d62e$export$f62540a8bebc4ed3 = 'BEGIN';
const $0c0ab4669e06d62e$export$32239d68d9c6cb49 = 'END';
const $0c0ab4669e06d62e$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $0c0ab4669e06d62e$export$987d86d2e891c4cb = 'END:VEVENT';
const $0c0ab4669e06d62e$export$fd1a0e011a586e26 = 'DTSTART';
const $0c0ab4669e06d62e$export$d86ed937a45b0291 = 'RRULE';
const $0c0ab4669e06d62e$export$913055729e1380b2 = 'SUMMARY';
const $0c0ab4669e06d62e$export$87d0ca22edb7493a = 'LOCATION';
const $0c0ab4669e06d62e$export$d44826c816b5619b = 'DESCRIPTION';
const $0c0ab4669e06d62e$export$c8b4a4d253b84ce0 = 'UID';
const $0c0ab4669e06d62e$export$34694f8d8b23ee2a = 'SEQUENCE';
const $0c0ab4669e06d62e$export$e50006273435e7d4 = 'STATUS';
const $0c0ab4669e06d62e$export$36034111438e3f25 = 'TRANSP';
const $0c0ab4669e06d62e$export$bb34f3538ba26c7e = 'PRIORITY';
const $0c0ab4669e06d62e$export$30dbcad954808285 = 'DTEND';
const $0c0ab4669e06d62e$export$bacc88974c736870 = 'DURATION';
const $0c0ab4669e06d62e$export$da3a32b38cbf59ba = 'ATTACH';
const $0c0ab4669e06d62e$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $0c0ab4669e06d62e$export$a513ea61a7bee91c = 'CATEGORIES';
const $0c0ab4669e06d62e$export$a29989082612d0d9 = 'COMMENT';
const $0c0ab4669e06d62e$export$11038cc09fdccb91 = 'CONTACT';
const $0c0ab4669e06d62e$export$133ffe3c8efbf133 = 'EXDATE';
const $0c0ab4669e06d62e$export$7e27a94778a9d7d7 = 'EXRULE';
const $0c0ab4669e06d62e$export$3d166b1dacd2503a = 'RDATE';
const $0c0ab4669e06d62e$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $0c0ab4669e06d62e$export$4e841128923ef26 = 'RESOURCES';
const $0c0ab4669e06d62e$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $0c0ab4669e06d62e$export$61abde59b50deb8e = 'URL';
const $0c0ab4669e06d62e$export$ff39ebd4bb12b718 = 'CREATED';
const $0c0ab4669e06d62e$export$2ebcefe61501d5fe = 'DTSTAMP';
const $0c0ab4669e06d62e$export$90812500f628da64 = 'LAST-MODIFIED';
const $0c0ab4669e06d62e$export$5409f4c14bda7ac = 'ORGANIZER';
const $0c0ab4669e06d62e$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $0c0ab4669e06d62e$export$98eba4d8ff00c139 = {
    BEGIN: $0c0ab4669e06d62e$export$f62540a8bebc4ed3,
    END: $0c0ab4669e06d62e$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $0c0ab4669e06d62e$export$67de00e87412dc6f,
    END_VEVENT: $0c0ab4669e06d62e$export$987d86d2e891c4cb,
    SUMMARY: $0c0ab4669e06d62e$export$913055729e1380b2,
    LOCATION: $0c0ab4669e06d62e$export$87d0ca22edb7493a,
    DESCRIPTION: $0c0ab4669e06d62e$export$d44826c816b5619b,
    UID: $0c0ab4669e06d62e$export$c8b4a4d253b84ce0,
    SEQUENCE: $0c0ab4669e06d62e$export$34694f8d8b23ee2a,
    STATUS: $0c0ab4669e06d62e$export$e50006273435e7d4,
    TRANSP: $0c0ab4669e06d62e$export$36034111438e3f25,
    PRIORITY: $0c0ab4669e06d62e$export$bb34f3538ba26c7e,
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291,
    DTEND: $0c0ab4669e06d62e$export$30dbcad954808285,
    DURATION: $0c0ab4669e06d62e$export$bacc88974c736870,
    ATTACH: $0c0ab4669e06d62e$export$da3a32b38cbf59ba,
    ATTENDEE: $0c0ab4669e06d62e$export$5e0bdf8bba8d5088,
    CATEGORIES: $0c0ab4669e06d62e$export$a513ea61a7bee91c,
    COMMENT: $0c0ab4669e06d62e$export$a29989082612d0d9,
    CONTACT: $0c0ab4669e06d62e$export$11038cc09fdccb91,
    EXDATE: $0c0ab4669e06d62e$export$133ffe3c8efbf133,
    EXRULE: $0c0ab4669e06d62e$export$7e27a94778a9d7d7,
    RDATE: $0c0ab4669e06d62e$export$3d166b1dacd2503a,
    RELATED_TO: $0c0ab4669e06d62e$export$47a1d4cd38dddc05,
    RESOURCES: $0c0ab4669e06d62e$export$4e841128923ef26,
    RECURRENCE_ID: $0c0ab4669e06d62e$export$1c0dd28c42f2741e,
    URL: $0c0ab4669e06d62e$export$61abde59b50deb8e,
    CREATED: $0c0ab4669e06d62e$export$ff39ebd4bb12b718,
    DTSTAMP: $0c0ab4669e06d62e$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $0c0ab4669e06d62e$export$90812500f628da64,
    ORGANIZER: $0c0ab4669e06d62e$export$5409f4c14bda7ac,
    REQUEST_STATUS: $0c0ab4669e06d62e$export$9fe99b3b71be9378
};
const $0c0ab4669e06d62e$export$38b1323f325ffd22 = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291
};
const $0c0ab4669e06d62e$export$5b9a78912028c06d = 'TZID';
const $0c0ab4669e06d62e$export$20184b745430719e = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    TZID: $0c0ab4669e06d62e$export$5b9a78912028c06d
};
const $0c0ab4669e06d62e$export$fb124b4fa837b262 = 'FREQ';
const $0c0ab4669e06d62e$export$4cc4f35131ed029c = 'UNTIL';
const $0c0ab4669e06d62e$export$7dea0e6e08f87a8a = 'INTERVAL';
const $0c0ab4669e06d62e$export$a764ed9c4884f76d = 'BYHOUR';
const $0c0ab4669e06d62e$export$7a96578de7a037b6 = 'BYMINUTE';
const $0c0ab4669e06d62e$export$55bcca3bd8d3041f = 'BYSECOND';
const $0c0ab4669e06d62e$export$f512ea3e90612d03 = 'BYDAY';
const $0c0ab4669e06d62e$export$b3203f635d74ce88 = 'BYMONTH';
const $0c0ab4669e06d62e$export$15623ad945e92c4c = 'BYMONTHDAY';
const $0c0ab4669e06d62e$export$7898bd020dba0a27 = {
    FREQ: $0c0ab4669e06d62e$export$fb124b4fa837b262,
    UNTIL: $0c0ab4669e06d62e$export$4cc4f35131ed029c,
    INTERVAL: $0c0ab4669e06d62e$export$7dea0e6e08f87a8a,
    BYHOUR: $0c0ab4669e06d62e$export$a764ed9c4884f76d,
    BYMINUTE: $0c0ab4669e06d62e$export$7a96578de7a037b6,
    BYSECOND: $0c0ab4669e06d62e$export$55bcca3bd8d3041f,
    BYDAY: $0c0ab4669e06d62e$export$f512ea3e90612d03,
    BYMONTH: $0c0ab4669e06d62e$export$b3203f635d74ce88,
    BYMONTHDAY: $0c0ab4669e06d62e$export$15623ad945e92c4c
};
const $0c0ab4669e06d62e$export$64c81710c321f252 = 'MISSING';
const $0c0ab4669e06d62e$export$ccb33e29d92c9a58 = 'EMPTY';
const $0c0ab4669e06d62e$export$9a105a556e65c2c0 = 'INVALID';
const $0c0ab4669e06d62e$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("3lACf", function(module, exports) {
$parcel$export(module.exports, "getRecurDayOfMonthOptionLabel", () => $f0654f7d964ce8bc$export$ed1a22f465b65f58);
$parcel$export(module.exports, "RecurMonthlyConfigField", () => $f0654f7d964ce8bc$export$e2e316c3848266b6);

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $1M2hR = parcelRequire("1M2hR");

var $iw2hI = parcelRequire("iw2hI");

var $1MObh = parcelRequire("1MObh");
const $f0654f7d964ce8bc$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recurDayOfMonthLabel: {
        "id": "recur-work-item.fields.RecurMonthlyConfigField.recur-day-of-month-label",
        "defaultMessage": "Select day of month"
    },
    recurDayOfMonthSelectHeading: {
        "id": "recur-work-item.fields.RecurMonthlyConfigField.recur-day-of-month-select-heading",
        "defaultMessage": "On the"
    },
    ordinalDayOfMonth: {
        "id": "recur-work-item.fields.RecurMonthlyConfigField.ordinal-day-of-month",
        "defaultMessage": "{dayOfMonth, selectordinal, one {#st} two {#nd} few {#rd} other{#th}}"
    },
    lastDayOfMonth: {
        "id": "recur-work-item.fields.RecurMonthlyConfigField.last-day-of-month",
        "defaultMessage": "Last day"
    },
    dayOfMonthSelected: {
        "id": "recur-work-item.fields.RecurMonthlyConfigField.day-of-month-selected",
        "defaultMessage": "On the {ordinalDayOfMonth}"
    }
});
const $f0654f7d964ce8bc$export$ed1a22f465b65f58 = (formatMessage, dayOfMonth)=>dayOfMonth > 0 ? formatMessage($f0654f7d964ce8bc$export$defe85febe8b728c.ordinalDayOfMonth, {
        dayOfMonth: dayOfMonth
    }) : formatMessage($f0654f7d964ce8bc$export$defe85febe8b728c.lastDayOfMonth);
const $f0654f7d964ce8bc$var$DEFAULT_RECUR_DAY_OF_MONTH_VALUE = 1;
const $f0654f7d964ce8bc$export$e2e316c3848266b6 = ({ value: value = $f0654f7d964ce8bc$var$DEFAULT_RECUR_DAY_OF_MONTH_VALUE })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const locale = (0, $1M2hR.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const [dayOfMonth, setDayOfMonth] = (0, $eJOHy.useState)(value);
    const options = (0, $eJOHy.useMemo)(()=>Array.from({
            length: 29
        }, (_, i)=>{
            // The user can select from days 1-28 and the last day (which we represent here as day -1)
            const adjDayOfMonth = i <= 27 ? i + 1 : -1;
            return {
                label: $f0654f7d964ce8bc$export$ed1a22f465b65f58(formatMessage, adjDayOfMonth),
                value: adjDayOfMonth
            };
        }), [
        formatMessage
    ]);
    const optionsOnceSelected = (0, $eJOHy.useMemo)(()=>new Map(options.map((option)=>[
                option.value,
                {
                    label: formatMessage($f0654f7d964ce8bc$export$defe85febe8b728c.dayOfMonthSelected, {
                        ordinalDayOfMonth: option.label.toLocaleLowerCase(standardizedLocale)
                    }),
                    value: option.value
                }
            ])), [
        formatMessage,
        options,
        standardizedLocale
    ]);
    const optionsWithHeading = (0, $eJOHy.useMemo)(()=>{
        return [
            {
                label: formatMessage($f0654f7d964ce8bc$export$defe85febe8b728c.recurDayOfMonthSelectHeading).toLocaleUpperCase(standardizedLocale),
                options: options
            }
        ];
    }, [
        formatMessage,
        options,
        standardizedLocale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: "recurDayOfMonth",
        defaultValue: value
    }, ({ fieldProps: { onChange: onChange, ...restFieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MObh.FormSelect), {
            ...restFieldProps,
            options: optionsWithHeading,
            value: optionsOnceSelected.get(dayOfMonth),
            onChange: (newValue)=>{
                if (!newValue) return;
                onChange(newValue.value);
                setDayOfMonth(newValue.value);
            },
            label: formatMessage($f0654f7d964ce8bc$export$defe85febe8b728c.recurDayOfMonthLabel)
        }));
};

});
parcelRegister("iw2hI", function(module, exports) {
$parcel$export(module.exports, "standardizeLocale", () => $07e147bc3d7cc59d$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $07e147bc3d7cc59d$export$93ff13646da25bd);

var $jbr6p = parcelRequire("jbr6p");

var $eSnSE = parcelRequire("eSnSE");
const $07e147bc3d7cc59d$var$FALLBACK_LOCALE = 'en-US';
const $07e147bc3d7cc59d$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$07e147bc3d7cc59d$var$FALLBACK_LOCALE}.`);
        return $07e147bc3d7cc59d$var$FALLBACK_LOCALE;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $jbr6p.default).includes(jiraLocale)) (0, $eSnSE.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $07e147bc3d7cc59d$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($07e147bc3d7cc59d$var$FALLBACK_LOCALE, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("1MObh", function(module, exports) {
$parcel$export(module.exports, "FormSelect", () => $24142b2c7ef44d37$export$5fd2f4d5c2a24bfa);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");
const $24142b2c7ef44d37$export$5fd2f4d5c2a24bfa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        styles: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        },
        menuPortalTarget: globalThis.document.body,
        ...props
    });

});


parcelRegister("b5IjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $129c4b3b6b9310c5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $129c4b3b6b9310c5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursMonthly: {
        "id": "recur-work-item.recurs-monthly",
        "defaultMessage": "Recurs monthly"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagTitleRecurOnScheduleIfCompleteMonthly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-monthly",
        "defaultMessage": "{issueKey} recurs every month"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteMonthly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-monthly",
        "defaultMessage": "This {issueType} recurs on the {ordinalDayOfMonth} day of the month when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteMonthlyLastDay: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-monthly-last-day",
        "defaultMessage": "This {issueType} recurs on the last day of the month when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleMonthly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-monthly",
        "defaultMessage": "{issueKey} recurs on the {ordinalDayOfMonth} day of the month"
    },
    successFlagTitleRecurOnScheduleMonthlyLastDay: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-monthly-last-day",
        "defaultMessage": "{issueKey} recurs on the last day of the month"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("2ZEsM", function(module, exports) {
$parcel$export(module.exports, "setAsNonRecurringIssue", () => $215cf24c960383d9$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRgKj = parcelRequire("kRgKj");

var $as8tn = parcelRequire("as8tn");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");
const $215cf24c960383d9$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("as8tn", function(module, exports) {
$parcel$export(module.exports, "INITIAL_STATE", () => $924bedb187db69de$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $924bedb187db69de$export$a1b15f9b9ceb0f70);
const $924bedb187db69de$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $924bedb187db69de$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("b7KsF", function(module, exports) {
$parcel$export(module.exports, "setAsRecurringIssue", () => $480578f2ddd18139$export$5d9cc8e9f9314f21);

var $aXKmr = parcelRequire("aXKmr");

var $kRgKj = parcelRequire("kRgKj");

var $bPEVb = parcelRequire("bPEVb");

var $g7LgB = parcelRequire("g7LgB");

var $9riZR = parcelRequire("9riZR");
const $480578f2ddd18139$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $aXKmr.v4)();
        const templateId = (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("bPEVb", function(module, exports) {
$parcel$export(module.exports, "createTemplate", () => $688cd7c66c97ef2e$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $688cd7c66c97ef2e$export$5153917efea4a83d);

var $3osLr = parcelRequire("3osLr");

var $jbPE2 = parcelRequire("jbPE2");

var $keOPi = parcelRequire("keOPi");

var $g7LgB = parcelRequire("g7LgB");
const $688cd7c66c97ef2e$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $keOPi.performIssuePostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    }, 'recur-work-item/src/services/set-recurring');
};
const $688cd7c66c97ef2e$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $keOPi.performIssuePutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    }, 'recur-work-item/src/services/set-recurring');
};

});


parcelRegister("f0czN", function(module, exports) {
$parcel$export(module.exports, "updateRule", () => $d769bcc7f9751998$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRgKj = parcelRequire("kRgKj");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $b7KsF = parcelRequire("b7KsF");

var $2ZEsM = parcelRequire("2ZEsM");
const $d769bcc7f9751998$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $2ZEsM.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("kPKM4", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a82ad686544dfbb0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a82ad686544dfbb0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("dVT0O", function(module, exports) {
$parcel$export(module.exports, "DateWithUrgencyIndicator", () => $89428acd7cb12298$export$31bba0fc7d099434);

var $eJOHy = parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $3NHJr = parcelRequire("3NHJr");

var $iemGy = parcelRequire("iemGy");

var $2cNSz = parcelRequire("2cNSz");
const $89428acd7cb12298$export$31bba0fc7d099434 = ({ value: value, formattedDateString: formattedDateString })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)();
    const daysBetweenTodayAndValue = (0, $eJOHy.useMemo)(()=>(0, $iemGy.getNoOfDaysSinceUTCDateString)(value), [
        value
    ]);
    const formattedDate = (0, $eJOHy.useMemo)(()=>formattedDateString || formatDateOnly(value), [
        formattedDateString,
        formatDateOnly,
        value
    ]);
    const dueMessage = daysBetweenTodayAndValue === 0 ? formatMessage((0, $2cNSz.default).dueToday) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $2cNSz.default).dueIn,
        values: {
            daysBetween: daysBetweenTodayAndValue
        }
    });
    const isDatePast = daysBetweenTodayAndValue != null && daysBetweenTodayAndValue >= 0;
    const Icon = daysBetweenTodayAndValue === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($d8UFE)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        testId: "date-with-urgency-indicator.container",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $89428acd7cb12298$var$baseStyles,
            isDatePast ? $89428acd7cb12298$var$redBackgroundStyle : false
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: isDatePast ? 'color.text.accent.red' : 'color.text.accent.gray.bolder'
    }, formattedDate)), isDatePast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: dueMessage,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        LEGACY_size: "medium",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "date-with-urgency-indicator.warning-icon"
    })));
};
const $89428acd7cb12298$var$baseStyles = (0, $1DXK0.xcss)({
    padding: 'space.025',
    borderRadius: 'radius.small'
});
const $89428acd7cb12298$var$redBackgroundStyle = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest',
    ':hover': {
        backgroundColor: 'color.background.accent.red.subtlest.hovered'
    },
    minWidth: '92px'
});

});
parcelRegister("3NHJr", function(module, exports) {
$parcel$export(module.exports, "useDateTimeFormatter", () => $c04f3d2981f71a59$export$163f492669f74d5b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $3MbOI = parcelRequire("3MbOI");

var $1M2hR = parcelRequire("1M2hR");

var $gKm6m = parcelRequire("gKm6m");

var $iw2hI = parcelRequire("iw2hI");
const $c04f3d2981f71a59$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $gRw8I.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $3MbOI.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $1M2hR.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $iw2hI.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $eJOHy.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $gKm6m.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $eJOHy.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $gKm6m.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $eJOHy.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $eJOHy.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("gKm6m", function(module, exports) {
$parcel$export(module.exports, "longDateTimeFormat", () => $3c5abb5b9eb6dd5e$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $3c5abb5b9eb6dd5e$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $3c5abb5b9eb6dd5e$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $3c5abb5b9eb6dd5e$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});


parcelRegister("iemGy", function(module, exports) {
$parcel$export(module.exports, "getNoOfDaysSinceUTCDateString", () => $6350001782ddbd27$export$7f4e2d0c87567b43);

var $fSCkM = parcelRequire("fSCkM");
/**
 * Normalizes a given date by removing the time component.
 *
 * @param {Date} date - The date to be normalized.
 * @returns {Date} - The normalized date without the time component.
 */ const $6350001782ddbd27$var$normalizeDate = (date)=>new Date(date.getFullYear(), date.getMonth(), date.getDate());
/**
 * Adds a specified number of days to a given date.
 *
 * @param date - The date to which the days should be added.
 * @param days - The number of days to add.
 * @returns The new date after adding the specified number of days.
 */ const $6350001782ddbd27$var$datePlusXDays = (date, days)=>$6350001782ddbd27$var$normalizeDate(new Date(date.getTime() + days * 86400000));
const $6350001782ddbd27$export$9417a5d0968b488e = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const date = $6350001782ddbd27$var$normalizeDate(new Date(dateString));
    if (Number.isNaN(date.getTime())) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const TODAY = $6350001782ddbd27$var$normalizeDate(new Date());
    const TODAY_PLUS_DUE_DAYS_OFFSET = $6350001782ddbd27$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = date.getTime() === TODAY.getTime() || date < TODAY;
    const isDueSoon = !isDueDatePast && date < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $6350001782ddbd27$export$3d094644d6bd82b9 = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return {
            isDueDatePast: false,
            isDueSoon: false
        };
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const TODAY_PLUS_DUE_DAYS_OFFSET = $6350001782ddbd27$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = inputDateInISO.getTime() === TODAY.getTime() || inputDateInISO < TODAY;
    const isDueSoon = !isDueDatePast && inputDateInISO < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $6350001782ddbd27$export$7f4e2d0c87567b43 = (dateString)=>{
    if (!dateString) return null;
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return null;
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const daysBetween = Math.floor((TODAY.getTime() - inputDateInISO.getTime()) / 86400000);
    return daysBetween;
};

});
parcelRegister("fSCkM", function(module, exports) {
$parcel$export(module.exports, "DateOnly", () => $f890d9b837113be1$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $f890d9b837113be1$export$b0961ad8aee63b8b);
const $f890d9b837113be1$export$9cda9b56d134780f = 'Invalid date or date format';
const $f890d9b837113be1$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $f890d9b837113be1$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $f890d9b837113be1$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $f890d9b837113be1$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $f890d9b837113be1$var$isLeapYear(year) ? 29 : $f890d9b837113be1$var$daysInMonth[month - 1])) return false;
    return true;
};
const $f890d9b837113be1$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $f890d9b837113be1$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $f890d9b837113be1$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $f890d9b837113be1$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $f890d9b837113be1$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $f890d9b837113be1$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$f890d9b837113be1$var$isDateValid(year, month, day)) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $f890d9b837113be1$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $f890d9b837113be1$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $f890d9b837113be1$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $f890d9b837113be1$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("2cNSz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9601b7655c62666f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9601b7655c62666f$var$messages = (0, $7qGN1.defineMessages)({
    dueToday: {
        "id": "date-with-urgency-indicator.due-today",
        "defaultMessage": "Due today"
    },
    dueIn: {
        "id": "date-with-urgency-indicator.due-in",
        "defaultMessage": "{daysBetween} {daysBetween, plural, one {day} other {days}} overdue"
    }
});
var $9601b7655c62666f$export$2e2bcd8739ae039 = $9601b7655c62666f$var$messages;

});


parcelRegister("chMwR", function(module, exports) {
$parcel$export(module.exports, "getNoOfDaysSinceUTCDateString", () => $acc777e3d2c5b893$export$7f4e2d0c87567b43);

var $fSCkM = parcelRequire("fSCkM");
/**
 * Normalizes a given date by removing the time component.
 *
 * @param {Date} date - The date to be normalized.
 * @returns {Date} - The normalized date without the time component.
 */ const $acc777e3d2c5b893$var$normalizeDate = (date)=>new Date(date.getFullYear(), date.getMonth(), date.getDate());
/**
 * Adds a specified number of days to a given date.
 *
 * @param date - The date to which the days should be added.
 * @param days - The number of days to add.
 * @returns The new date after adding the specified number of days.
 */ const $acc777e3d2c5b893$var$datePlusXDays = (date, days)=>$acc777e3d2c5b893$var$normalizeDate(new Date(date.getTime() + days * 86400000));
const $acc777e3d2c5b893$export$9417a5d0968b488e = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const date = $acc777e3d2c5b893$var$normalizeDate(new Date(dateString));
    if (Number.isNaN(date.getTime())) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    const TODAY = $acc777e3d2c5b893$var$normalizeDate(new Date());
    const TODAY_PLUS_DUE_DAYS_OFFSET = $acc777e3d2c5b893$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = date.getTime() === TODAY.getTime() || date < TODAY;
    const isDueSoon = !isDueDatePast && date < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $acc777e3d2c5b893$export$3d094644d6bd82b9 = (dateString, dueDaysOffset = 7)=>{
    if (!dateString) return {
        isDueDatePast: false,
        isDueSoon: false
    };
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return {
            isDueDatePast: false,
            isDueSoon: false
        };
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const TODAY_PLUS_DUE_DAYS_OFFSET = $acc777e3d2c5b893$var$datePlusXDays(TODAY, dueDaysOffset);
    const isDueDatePast = inputDateInISO.getTime() === TODAY.getTime() || inputDateInISO < TODAY;
    const isDueSoon = !isDueDatePast && inputDateInISO < TODAY_PLUS_DUE_DAYS_OFFSET;
    return {
        isDueDatePast: isDueDatePast,
        isDueSoon: isDueSoon
    };
};
const $acc777e3d2c5b893$export$7f4e2d0c87567b43 = (dateString)=>{
    if (!dateString) return null;
    let inputDateInISO;
    try {
        inputDateInISO = (0, $fSCkM.DateOnly).fromISODateString(dateString).toLocalDate();
    } catch (e) {
        return null;
    }
    const TODAY = (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date()).toLocalDate();
    const daysBetween = Math.floor((TODAY.getTime() - inputDateInISO.getTime()) / 86400000);
    return daysBetween;
};

});

parcelRegister("7y0HS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d326cc713d411d8c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d326cc713d411d8c$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment",
        "defaultMessage": "Add date"
    },
    noValueTextExperimentDueDate: {
        "id": "issue-field-date-readview-full.date.no-value-text-experiment-due-date",
        "defaultMessage": "Add due date"
    }
});
var $d326cc713d411d8c$export$2e2bcd8739ae039 = $d326cc713d411d8c$var$messages;

});


parcelRegister("fkc6h", function(module, exports) {
$parcel$export(module.exports, "useIssueExperienceMonitoring", () => $512cbef46162db63$export$316dd354b9e65dba);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");

var $2QO3b = parcelRequire("2QO3b");

var $2gvG4 = parcelRequire("2gvG4");

var $mjinE = parcelRequire("mjinE");

var $bpkMB = parcelRequire("bpkMB");

var $14RSn = parcelRequire("14RSn");

var $ePvyd = parcelRequire("ePvyd");

var $bNexr = parcelRequire("bNexr");

var $bmoS1 = parcelRequire("bmoS1");

var $7wFII = parcelRequire("7wFII");

var $3ibpe = parcelRequire("3ibpe");

var $e9OSL = parcelRequire("e9OSL");
const $512cbef46162db63$var$isExtensions = (value)=>{
    return typeof value === 'object' && value !== null && 'gateway' in value && typeof value.gateway === 'object' && value.gateway !== null && 'trace_id' in value.gateway && typeof value.gateway.trace_id === 'string';
};
const $512cbef46162db63$var$isAGGResponse = (value)=>{
    return typeof value === 'object' && value !== null && ('jira' in value && typeof value.jira === 'object' && value.jira !== null || 'errors' in value && typeof value.errors === 'object');
};
const $512cbef46162db63$var$extractError = (response)=>{
    if (response.errors) return response.errors;
    for(const key in response.jira)if (response.jira[key]) {
        const value = response.jira[key];
        if (value.errors) return value.errors;
    }
    return [];
};
const $512cbef46162db63$var$stopCapturingAndGetTraceId = (mutationName)=>{
    const [extensions] = (0, $ePvyd.getExtensions)(mutationName);
    (0, $ePvyd.stopCapturingExtensions)(mutationName);
    return $512cbef46162db63$var$isExtensions(extensions) ? extensions.gateway.trace_id : 'unknown';
};
const $512cbef46162db63$var$isAbortableStatusCode = (statusCode)=>{
    return statusCode && statusCode >= 400 && statusCode < 500;
};
const $512cbef46162db63$var$stopCapturingAndGetMetaData = (mutationName, response, error)=>{
    const traceId = $512cbef46162db63$var$stopCapturingAndGetTraceId(mutationName);
    const aggError = error?.[0] || (response ? $512cbef46162db63$var$extractError(response)[0] : undefined);
    const statusCode = aggError?.extensions?.statusCode;
    const errorMessage = aggError?.message;
    return {
        traceId: traceId,
        errorMessage: errorMessage,
        statusCode: statusCode,
        aggError: aggError
    };
};
const $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold = (activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, hasError, statusCode, errorMessage)=>{
    if (sendUFOEvent) {
        if (hasError && activeInteraction?.ufoName) {
            (0, $2gvG4.addUFOCustomData)({
                traceId: traceId,
                statusCode: statusCode
            });
            (0, $bpkMB.setInteractionError)(activeInteraction?.ufoName, {
                errorMessage: errorMessage || 'unknown',
                name: errorMessage || 'unknown'
            });
        }
        ufoHoldCleanup?.();
    }
};
const $512cbef46162db63$export$316dd354b9e65dba = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    /**
	 * Enriches React Relay mutation commits with comprehensive experience monitoring and analytics.
	 *
	 * This function wraps Relay mutation configurations to automatically:
	 * - Capture gateway trace IDs for debugging
	 * - Send UFO (performance) events with error handling
	 * - Track experience analytics with success/failure states
	 * - Handle both AGG API responses and network errors
	 *
	 * @param commitArgs - The original React Relay mutation configuration
	 * @param mutationName - Unique identifier for the mutation (used for trace capture)
	 * @param options - Configuration object for monitoring behavior
	 * @param options.sendUFOEvent - Whether to send UFO performance events (default: false)
	 * @param options.additionalAttributes - Extra analytics attributes to include
	 * @param options.task - Experience name for analytics (string or function that takes success boolean)
	 * @param options.overrideAttributesCallback - !Use with CAUTION! Function to override entire analytics attributes based on error and success attributes
	 *   Called with (isSuccess, mandatoryAttributes, errorObjects) and should return additional attributes.
	 *   Use this to add context-specific data like field names, validation errors, or business logic results.
	 * @param shouldWrapWithAnalytics - Function to conditionally enable monitoring (default: () => true)
	 *
	 * @returns Enhanced configuration for Relay commit with monitoring wrapped around onCompleted/onError
	 *
	 * @example
	 * ```tsx
	 * const [commit] = useMutation(UpdateIssueMutation);
	 * const { enrichCommitWithIssueExperienceMonitoring } = useIssueExperienceMonitoring();
	 *
	 * const handleUpdate = () => {
	 *   commit(enrichCommitWithIssueExperienceMonitoring({
	 *     variables: { input: { issueId, status: 'Done' } },
	 *     onCompleted: (response) => console.log('Success!'),
	 *   }, 'updateIssueStatus', {
	 *     sendUFOEvent: true,
	 *     task: 'issue.update.status',
	 *     additionalAttributes: { statusType: 'Done' }
	 *   }));
	 * };
	 * ```
	 */ const enrichCommitWithIssueExperienceMonitoring = (0, $eJOHy.useCallback)((commitArgs, mutationName, { sendUFOEvent: sendUFOEvent, additionalAttributes: additionalAttributes, task: task, overrideAttributesCallback: overrideAttributesCallback } = {}, shouldWrapWithAnalytics = ()=>true)=>{
        if (!shouldWrapWithAnalytics()) return commitArgs;
        (0, $ePvyd.startCapturingExtensions)(mutationName);
        let activeInteraction;
        let ufoHoldCleanup;
        if (sendUFOEvent) {
            activeInteraction = (0, $2QO3b.getActiveInteraction)();
            ufoHoldCleanup = context?.hold(activeInteraction?.ufoName);
            (0, $2gvG4.addUFOCustomData)({
                application: (0, $mjinE.transformApplication)(application || null),
                edition: (0, $mjinE.transformEdition)(edition || null)
            });
        }
        const defaultExperienceArgs = {
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            additionalAttributes: additionalAttributes
        };
        return {
            ...commitArgs,
            onCompleted: (response, error)=>{
                const aggResponse = $512cbef46162db63$var$isAGGResponse(response) ? response : undefined;
                const { traceId: traceId, aggError: aggError, errorMessage: errorMessage, statusCode: statusCode } = $512cbef46162db63$var$stopCapturingAndGetMetaData(mutationName, aggResponse, error);
                let action = 'taskSuccess';
                if (aggError) action = $512cbef46162db63$var$isAbortableStatusCode(statusCode) ? 'taskAbort' : 'taskFail';
                commitArgs.onCompleted?.(response, error);
                $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold(activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, !!aggError, statusCode, errorMessage);
                const additionalAttributesWithErrorProperties = {
                    ...additionalAttributes,
                    ...action !== 'taskSuccess' && {
                        traceId: traceId,
                        ...errorMessage !== undefined && {
                            errorMessage: errorMessage
                        },
                        ...statusCode !== undefined && {
                            statusCode: statusCode
                        }
                    }
                };
                const overrideAttributes = overrideAttributesCallback ? overrideAttributesCallback(!aggError, additionalAttributesWithErrorProperties, {}) : {};
                if (task || overrideAttributes?.task) (0, $3ibpe.sendExperienceAnalytics)({
                    ...defaultExperienceArgs,
                    experience: task || String(overrideAttributes?.task),
                    action: action,
                    additionalAttributes: additionalAttributesWithErrorProperties,
                    ...overrideAttributes
                });
            },
            onError: (error)=>{
                const traceId = $512cbef46162db63$var$stopCapturingAndGetTraceId(mutationName);
                const aggError = (0, $e9OSL.extractFirstErrorFromRelayError)(error);
                const errorMessage = aggError?.message || error?.message;
                const statusCode = (0, $14RSn.isFetchError)(error) ? error?.statusCode : aggError?.statusCode;
                const hasError = !!aggError || !!(0, $14RSn.isFetchError)(error);
                const action = (0, $7wFII.isAbortableError)(error) || $512cbef46162db63$var$isAbortableStatusCode(statusCode) ? 'taskAbort' : 'taskFail';
                commitArgs.onError?.(error);
                $512cbef46162db63$var$maybeSendUFOErrorAndReleaseHold(activeInteraction, ufoHoldCleanup, traceId, sendUFOEvent, hasError, statusCode, errorMessage);
                const overrideAttributes = overrideAttributesCallback ? overrideAttributesCallback(false, additionalAttributes, {
                    aggError: aggError,
                    networkError: hasError,
                    statusCode: statusCode,
                    rawError: error
                }) : {};
                if (task || overrideAttributes?.task) (0, $3ibpe.sendExperienceAnalytics)({
                    ...defaultExperienceArgs,
                    experience: task || String(overrideAttributes.task),
                    action: action,
                    additionalAttributes: {
                        ...additionalAttributes,
                        traceId: traceId,
                        ...errorMessage !== undefined && {
                            errorMessage: errorMessage
                        },
                        ...statusCode !== undefined && {
                            statusCode: statusCode
                        }
                    },
                    ...overrideAttributes
                });
            }
        };
    }, [
        analyticsSource,
        application,
        edition,
        context
    ]);
    return {
        enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring
    };
};

});
parcelRegister("7wFII", function(module, exports) {
$parcel$export(module.exports, "isAbortableError", () => $a93b392b7e4fefa9$export$e05e0fb17c2ab75a);

var $6NFx3 = parcelRequire("6NFx3");

var $9Dhvc = parcelRequire("9Dhvc");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $4cTDP = parcelRequire("4cTDP");
const $a93b392b7e4fefa9$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = $a93b392b7e4fefa9$var$extractStatusCode(error);
    if ((0, $dMM78.isHttpClientErrorStatusCode)(statusCode) || !statusCode && (0, $dMM78.isClientFetchError)(error) || error?.name === (0, $14RSn.VALIDATION_ERROR_NAME)) return true;
    return false;
};
const $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($6NFx3)))(statusCodes);
    return statusCode || null;
};
const $a93b392b7e4fefa9$var$extractStatusCode = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(networkError, [
        'statusCode'
    ], null);
    const relayErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'source',
        'errors'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(graphQLErrors);
    if (Array.isArray(relayErrors) && relayErrors.length > 0 && (0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(relayErrors);
    return null;
};

});
parcelRegister("6NFx3", function(module, exports) {

var $dbOsL = parcelRequire("dbOsL");

var $9wRNl = parcelRequire("9wRNl");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $4f3789168d11a4da$var$max(array) {
    return array && array.length ? $dbOsL(array, $d7YnM, $9wRNl) : undefined;
}
module.exports = $4f3789168d11a4da$var$max;

});
parcelRegister("dbOsL", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $99a3725aea015bd0$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9D78T(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $99a3725aea015bd0$var$baseExtremum;

});

parcelRegister("9wRNl", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $6f00d4c0b88cefe1$var$baseGt(value, other) {
    return value > other;
}
module.exports = $6f00d4c0b88cefe1$var$baseGt;

});



parcelRegister("e9OSL", function(module, exports) {
$parcel$export(module.exports, "useFieldExperienceTracking", () => $4a9350ba25b6d2c6$export$94c85d2216d24740);
$parcel$export(module.exports, "extractFirstErrorFromRelayError", () => $4a9350ba25b6d2c6$export$1e49248e7b3f98d6);
/**
 * Based on jira/src/packages/issue/issue-view/src/epics/experience-tracking/field-experience-tracking-epic.tsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $7wFII = parcelRequire("7wFII");

var $dMM78 = parcelRequire("dMM78");

var $bmoS1 = parcelRequire("bmoS1");

var $3ibpe = parcelRequire("3ibpe");

var $bNexr = parcelRequire("bNexr");

var $47pEa = parcelRequire("47pEa");
const $4a9350ba25b6d2c6$export$94c85d2216d24740 = ({ fieldId: fieldId })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const getEditEventPayload = (0, $eJOHy.useCallback)(({ hasSuccess: hasSuccess, hasEdit: hasEdit, errorMessage: errorMessage, traceId: traceId, statusCode: statusCode, action: action })=>{
        const additionalAttributes = {};
        if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
        if (traceId != null) additionalAttributes.traceId = traceId;
        if (statusCode) additionalAttributes.statusCode = statusCode;
        return {
            experience: 'editIssue',
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            wasExperienceSuccesful: hasSuccess,
            field: fieldId,
            hasEdit: hasEdit,
            additionalAttributes: additionalAttributes,
            action: action
        };
    }, [
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendSubmitSucceededExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: true
        }));
    }, [
        getEditEventPayload
    ]);
    const sendSubmitFailedExperienceEvent = (0, $eJOHy.useCallback)((error)=>{
        if (!(0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences') && (0, $dMM78.isClientFetchError)(error) || !error) return;
        const errorType = (0, $47pEa.default)(error);
        const match = error?.message?.match(/response: (\d+)/);
        const statusCode = match ? parseInt(match[1], 10) : undefined;
        if (statusCode && statusCode >= 400 && statusCode < 500) (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'issue.issue-view.editIssue',
                teamName: 'obsidian'
            },
            attributes: {
                experience: 'editIssue',
                analyticsSource: analyticsSource || 'unknown',
                application: application || null,
                edition: edition || null,
                wasExperienceSuccesful: false,
                field: fieldId,
                hasEdit: true,
                traceId: 'traceId' in error ? String(error?.traceId) : undefined
            }
        });
        let action;
        if ((0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences')) action = (0, $7wFII.isAbortableError)(error) ? 'taskAbort' : 'taskFail';
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: (0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences') ? (0, $7wFII.isAbortableError)(error) : errorType !== (0, $47pEa.SERVER_ERROR),
            hasEdit: true,
            errorMessage: 'statusCode' in error ? `${error.statusCode} - ${error.message}` : error.message,
            traceId: 'traceId' in error ? String(error?.traceId) : undefined,
            statusCode: 'statusCode' in error && typeof error?.statusCode === 'number' ? error.statusCode : undefined,
            action: action
        }));
    }, [
        getEditEventPayload,
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendEditCancelExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: false
        }));
    }, [
        getEditEventPayload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sendSubmitSucceededExperienceEvent: sendSubmitSucceededExperienceEvent,
            sendSubmitFailedExperienceEvent: sendSubmitFailedExperienceEvent,
            sendEditCancelExperienceEvent: sendEditCancelExperienceEvent
        }), [
        sendEditCancelExperienceEvent,
        sendSubmitFailedExperienceEvent,
        sendSubmitSucceededExperienceEvent
    ]);
};
const $4a9350ba25b6d2c6$export$1e49248e7b3f98d6 = (error)=>{
    if (!('source' in error)) return null;
    const errorSource = error.source;
    const errors = typeof errorSource === 'object' && errorSource != null && 'errors' in errorSource && errorSource.errors;
    const firstError = Array.isArray(errors) ? errors[0] : null;
    const statusCode = firstError?.extensions?.statusCode;
    const message = firstError?.message;
    return statusCode ? {
        statusCode: statusCode,
        message: message
    } : null;
};

});
parcelRegister("47pEa", function(module, exports) {
$parcel$export(module.exports, "SERVER_ERROR", () => $427c11e98f93775d$export$125ebd30471ac25c);
$parcel$export(module.exports, "default", () => $427c11e98f93775d$export$2e2bcd8739ae039);

var $14RSn = parcelRequire("14RSn");
const $427c11e98f93775d$export$125ebd30471ac25c = 'SERVER_ERROR';
const $427c11e98f93775d$export$558b92200f9a795 = 'VALIDATION_ERROR';
const $427c11e98f93775d$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
const $427c11e98f93775d$var$classifyFieldError = (error)=>{
    if (error instanceof (0, $14RSn.ValidationError)) return $427c11e98f93775d$export$558b92200f9a795;
    if (!(error instanceof (0, $14RSn.default))) return $427c11e98f93775d$export$683dbe11f74cd161;
    if (error.statusCode >= 400 && error.statusCode < 500) return $427c11e98f93775d$export$558b92200f9a795;
    return $427c11e98f93775d$export$125ebd30471ac25c;
};
var $427c11e98f93775d$export$2e2bcd8739ae039 = $427c11e98f93775d$var$classifyFieldError;

});



parcelRegister("k745d", function(module, exports) {
$parcel$export(module.exports, "useDateValidator", () => $8853f60cb6101294$export$bb028423d75e7237);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $cwGo1 = parcelRequire("cwGo1");
const $8853f60cb6101294$export$bb028423d75e7237 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && (!value || value.trim().length === 0)) return {
            type: 'error',
            message: formatMessage((0, $cwGo1.messages).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("cwGo1", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a28e04ebf5c72bb6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a28e04ebf5c72bb6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-field-date-inline-edit-full.date.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});

});




parcelRegister("dQN02", function(module, exports) {
$parcel$export(module.exports, "DateTimeCell", () => $2f1fdd96ec7a68b5$export$372b87ceae2922a4);

var $kfcZc = parcelRequire("kfcZc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aIRHL = parcelRequire("aIRHL");

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $2f1fdd96ec7a68b5$export$372b87ceae2922a4 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $kfcZc.default), fieldRef);
    const isCreatedOrUpdated = data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).CREATED || data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).UPDATED;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = !isCreatedOrUpdated && isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the created/updated fields as they are never editable.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIRHL.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $2f1fdd96ec7a68b5$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIRHL.DateTimeInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isAutoFocusFixEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $2f1fdd96ec7a68b5$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $2f1fdd96ec7a68b5$var$customTargetStyles : $2f1fdd96ec7a68b5$var$customTargetStylesOld,
        ref: ref
    });
});
const $2f1fdd96ec7a68b5$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $2f1fdd96ec7a68b5$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("kfcZc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8204f63de57e03f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<713daee6cb5caf5614ea1870c045f17f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b8204f63de57e03f$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "DateTimeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$b8204f63de57e03f$var$node.hash = "cd275eca12ae208ba73a8e77c5e6c544";
var $b8204f63de57e03f$export$2e2bcd8739ae039 = $b8204f63de57e03f$var$node;

});

parcelRegister("aIRHL", function(module, exports) {
$parcel$export(module.exports, "DateTimeInlineEditViewWithIsEditable", () => $03d97e1e763124f7$export$40278230a655efcf);
$parcel$export(module.exports, "DateTimeInlineEditView", () => $03d97e1e763124f7$export$2044e876297ff5d7);

var $6U0ni = parcelRequire("6U0ni");

var $47Hfw = parcelRequire("47Hfw");

var $j91Br = parcelRequire("j91Br");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $gQeix = parcelRequire("gQeix");

var $b3Emp = parcelRequire("b3Emp");

var $auNLL = parcelRequire("auNLL");

var $1M2hR = parcelRequire("1M2hR");

var $iw2hI = parcelRequire("iw2hI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $bJscI = parcelRequire("bJscI");

var $9pTd3 = parcelRequire("9pTd3");

var $3wIGE = parcelRequire("3wIGE");
const $03d97e1e763124f7$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-date-time-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $03d97e1e763124f7$export$40278230a655efcf = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, timeZone: timeZone, isAutoFocusFixEnabled: isAutoFocusFixEnabled, readViewDateOnlyFormat: readViewDateOnlyFormat, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $j91Br.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, dateTime: dateTime } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $47Hfw.default));
    // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const locale = (0, $1M2hR.useLocale)();
    const initialValue = dateTime ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    // #endregion
    // #region Handle new value
    const handleSubmit = (0, $eJOHy.useCallback)((newDateTime, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newDateTime);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        datetime: newDateTime ?? null,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateDateTimeField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateDateTimeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            dateTime: newDateTime
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'dateTime'
    });
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3Emp.DateTimeReadView), {
            fragmentRef: data,
            timeZone: timeZone,
            isDateOnlyFormat: readViewDateOnlyFormat,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        timeZone,
        readViewDateOnlyFormat,
        shouldRenderHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const timePlaceholder = (0, $eJOHy.useMemo)(()=>{
        const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
        return (0, $3wIGE.getNext30MinuteInterval)(undefined, standardizedLocale);
    }, [
        locale
    ]);
    const datePlaceholder = (0, $eJOHy.useMemo)(()=>{
        let formattedDate = '';
        try {
            formattedDate = (0, $3wIGE.getFormattedDate)(locale);
        } catch (dateFormatError) {
            (0, $9pTd3.fireErrorAnalytics)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: dateFormatError,
                meta: {
                    packageName: 'dateTimeFieldInlineEdit',
                    id: 'formatDateError'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return formattedDate;
    }, [
        locale
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: isAutoFocusFixEnabled,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            timeZone: timeZone,
            ...(0, $cxKOj.expValEquals)('jira_issue_view_date_time_picker_experiment_new', 'isEnabled', true) ? {
                autoFocus: true,
                spacing: spacing,
                datePlaceholder: datePlaceholder,
                timePlaceholder: timePlaceholder
            } : {}
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPoint: (0, $gQeix.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $03d97e1e763124f7$export$2044e876297ff5d7 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $6U0ni.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03d97e1e763124f7$export$40278230a655efcf, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("6U0ni", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dce39f3bc1fd401$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49f946ae62813e18b283e25b40bb99be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dce39f3bc1fd401$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraDateTimePickerField"
};
$4dce39f3bc1fd401$var$node.hash = "3ebe6796584f81815d1e09db6e20b21f";
var $4dce39f3bc1fd401$export$2e2bcd8739ae039 = $4dce39f3bc1fd401$var$node;

});

parcelRegister("47Hfw", function(module, exports) {
$parcel$export(module.exports, "default", () => $449421f6ccdf1783$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35b0d1b8dda4ba883b598557010413d2>>
 * @relayHash b962bde817ae9133f076383673744639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0
const $449421f6ccdf1783$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "dateTime"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDateTimeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateDateTimeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0",
            "metadata": {},
            "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$449421f6ccdf1783$var$node.hash = "e0c0e1ca810b79fb98a05142a47ace9e";
var $449421f6ccdf1783$export$2e2bcd8739ae039 = $449421f6ccdf1783$var$node;

});

parcelRegister("j91Br", function(module, exports) {
$parcel$export(module.exports, "default", () => $26e6d5fe67544e2a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf046c3fc1d1cb9d3c8a8b0339c689f5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26e6d5fe67544e2a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$26e6d5fe67544e2a$var$node.hash = "e7911508d34079b211453d8cdb4bbc3d";
var $26e6d5fe67544e2a$export$2e2bcd8739ae039 = $26e6d5fe67544e2a$var$node;

});

parcelRegister("gQeix", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef2e1b73562b3d0c$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ef2e1b73562b3d0c$var$DateTimeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cClR4")), {
        moduleId: "60a5161a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $ef2e1b73562b3d0c$export$2e2bcd8739ae039 = $ef2e1b73562b3d0c$var$DateTimeEditViewEntryPoint;

});
parcelRegister("cClR4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aF0RO").then(()=>parcelRequire('ejuPL'));

});


parcelRegister("b3Emp", function(module, exports) {
$parcel$export(module.exports, "DateTimeReadView", () => $4ca1d1549d29cfd8$export$962e920a3f993096);

var $4EKpv = parcelRequire("4EKpv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $3NHJr = parcelRequire("3NHJr");

var $k6Nau = parcelRequire("k6Nau");

var $3OT15 = parcelRequire("3OT15");

var $3Lkm9 = parcelRequire("3Lkm9");
const $4ca1d1549d29cfd8$export$962e920a3f993096 = (props)=>{
    const { fragmentRef: fragmentRef, timeZone: overrideTimeZone, isDateOnlyFormat: isDateOnlyFormat = false, shouldRenderHoverPopover: shouldRenderHoverPopover = false } = props;
    const data = (0, $j4oe4.useFragment)((0, $4EKpv.default), fragmentRef);
    const { dateTime: dateTime } = data || {};
    const { formatDateTime: formatDateTime, formatDateOnly: formatDateOnly } = (0, $3NHJr.useDateTimeFormatter)(overrideTimeZone);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data?.id) : null;
    let hoverPopoverRef = null;
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!dateTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenDateTimePlaceholderEmptyFieldText
    });
    let content;
    try {
        content = isDateOnlyFormat ? formatDateOnly(dateTime) : formatDateTime(dateTime);
    } catch (err) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    }
    if (shouldRenderHoverPopover && dateTime) {
        if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
            content: content
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: 1,
            ref: hoverPopoverRef
        }, content);
    }
    return content;
};

});
parcelRegister("4EKpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4c808c94044cc91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f43566eb6285cd6f11a8e08e8d33a3be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4c808c94044cc91$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$a4c808c94044cc91$var$node.hash = "60be07d95cc7946b937010e24a94ffe0";
var $a4c808c94044cc91$export$2e2bcd8739ae039 = $a4c808c94044cc91$var$node;

});


parcelRegister("3wIGE", function(module, exports) {
$parcel$export(module.exports, "getNext30MinuteInterval", () => $9162a9d29e7f73f1$export$84c10da5aad3dff1);
$parcel$export(module.exports, "getFormattedDate", () => $9162a9d29e7f73f1$export$92521769c5df59ad);

var $57raR = parcelRequire("57raR");
var $ibLUB = parcelRequire("ibLUB");
var $cT05m = parcelRequire("cT05m");

var $2Jz68 = parcelRequire("2Jz68");

var $dO9h7 = parcelRequire("dO9h7");
function $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, intervalString, userLocale) {
    if (userLocale) {
        const normalizedLocale = userLocale.replace(/_/g, '-');
        return new Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(intervalTime);
    }
    return intervalString;
}
function $9162a9d29e7f73f1$export$84c10da5aad3dff1(date, userLocale) {
    // Get the current date and time
    const now = date ?? new Date();
    // Format current time to 'HH:mm'
    const currentTime = (0, $57raR.default)(now, 'HH:mm');
    // Find the next interval
    for (const interval of (0, $2Jz68.default)){
        // Parse the interval time to a Date object
        const intervalTime = (0, $cT05m.default)(interval, 'HH:mm', now);
        // Check if the interval is after the current time
        if ((0, $ibLUB.default)(intervalTime, now) || interval === currentTime) return $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, interval, userLocale);
    }
    const intervalTime = (0, $cT05m.default)((0, $2Jz68.default)[0], 'HH:mm', now);
    // If no interval is found that is after the current time, return the first interval of the next day
    return $9162a9d29e7f73f1$var$getLocalisedTimeString(intervalTime, (0, $2Jz68.default)[0], userLocale);
}
const $9162a9d29e7f73f1$export$92521769c5df59ad = (userLocale)=>{
    return (0, $dO9h7.formatWithLocale)(new Date(), 'P', userLocale);
};

});
parcelRegister("2Jz68", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7849d24320f1c75$export$2e2bcd8739ae039);
const $c7849d24320f1c75$var$availableTimes = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];
var $c7849d24320f1c75$export$2e2bcd8739ae039 = $c7849d24320f1c75$var$availableTimes;

});




parcelRegister("l17Xm", function(module, exports) {
$parcel$export(module.exports, "EpicLinkCell", () => $bb6aace6a451e72f$export$6c1071448075813f);

var $cgVpX = parcelRequire("cgVpX");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $8URAw = parcelRequire("8URAw");

var $1wTTU = parcelRequire("1wTTU");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $bBiKm = parcelRequire("bBiKm");
const $bb6aace6a451e72f$var$getLozengeThemes = (0, $1wTTU.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $bb6aace6a451e72f$var$getLozengeThemeByColor = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $bb6aace6a451e72f$var$getLozengeThemes[color] ?? $bb6aace6a451e72f$var$getLozengeThemes[0, $8URAw.DEFAULT_EPIC_COLOR]; // type assertion is fine as the record key is of type Color
const $bb6aace6a451e72f$var$findColor = (color)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys((0, $8URAw.MAP_COLOR_TO_AK_COLOR)).find((key)=>(0, $8URAw.MAP_COLOR_TO_AK_COLOR)[key] === color);
const $bb6aace6a451e72f$export$6c1071448075813f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { epic: epic } = (0, $j4oe4.useFragment)((0, $cgVpX.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)(); /**
                                                                           * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
                                                                           * we're rendering a "Replaced by Parent field" deprecation message in the "Epic Link" cell.
                                                                           * At the time of writing this comment, "Epic Link" is still used in ~6% of issue tables, and
                                                                           * we hope this message will help these users migrate and use the "Parent" field from now on.
                                                                           */ 
    if ((0, $4cTDP.fg)('replace-epic-parent-link-by-depreca-message-in-nin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span",
        color: "color.text.subtlest",
        maxLines: isSingleLineRowHeightEnabled ? 1 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $bBiKm.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    if (!epic) return null;
    if (epic.key == null || epic.summary == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "epicLink",
        reason: "Missing required fields"
    });
    const epicColor = (0, $1wTTU.asColor)(epic.color);
    const tagColor = (0, $8URAw.MAP_COLOR_TO_AK_COLOR)[epicColor];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bb6aace6a451e72f$var$TagWrapper, {
        href: `/browse/${epic.key}`,
        "aria-label": `${formatMessage((0, $bBiKm.default).epicTitle)} ${epic.summary}`,
        style: $bb6aace6a451e72f$var$getLozengeThemeByColor($bb6aace6a451e72f$var$findColor(tagColor)),
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        }
    }, epic.summary);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb6aace6a451e72f$var$TagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _2rkofajl _1e0c1o8l _s7n4nkob _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq _vchhusvi _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cgVpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b82888c5de56ad8d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a56aaf62e03d0f4bfd42e5aa14827ccf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b82888c5de56ad8d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EpicLinkCell",
    "selections": [
        {
            "concreteType": "JiraEpic",
            "kind": "LinkedField",
            "name": "epic",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                }
            ]
        }
    ],
    "type": "JiraEpicLinkField"
};
$b82888c5de56ad8d$var$node.hash = "cbc046611b6b7cab39bbe7c2ae02d46d";
var $b82888c5de56ad8d$export$2e2bcd8739ae039 = $b82888c5de56ad8d$var$node;

});

parcelRegister("8URAw", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $f89c7f0e34657bc4$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $f89c7f0e34657bc4$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $f89c7f0e34657bc4$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $f89c7f0e34657bc4$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $f89c7f0e34657bc4$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $f89c7f0e34657bc4$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $f89c7f0e34657bc4$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $f89c7f0e34657bc4$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $f89c7f0e34657bc4$export$92b6aebfb522f0d9);

var $2IQEX = parcelRequire("2IQEX");


var $38IWH = parcelRequire("38IWH");
const $f89c7f0e34657bc4$export$c2357bec51c5cf5b = 'PURPLE';
const $f89c7f0e34657bc4$export$db33d74b098e3da9 = {
    [(0, $38IWH.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $38IWH.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $38IWH.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $38IWH.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $38IWH.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $38IWH.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $38IWH.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $38IWH.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $38IWH.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $38IWH.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $38IWH.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $38IWH.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $38IWH.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $38IWH.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $f89c7f0e34657bc4$export$fc5fe4213a5703f1 = {
    [(0, $7bb4c1736002a04a$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7bb4c1736002a04a$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7bb4c1736002a04a$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7bb4c1736002a04a$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7bb4c1736002a04a$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7bb4c1736002a04a$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7bb4c1736002a04a$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7bb4c1736002a04a$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7bb4c1736002a04a$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7bb4c1736002a04a$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7bb4c1736002a04a$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7bb4c1736002a04a$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7bb4c1736002a04a$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7bb4c1736002a04a$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $f89c7f0e34657bc4$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$db33d74b098e3da9);
const $f89c7f0e34657bc4$export$43264b0781f10167 = {
    [(0, $38IWH.SERVER_PURPLE)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.SERVER_DARK_PURPLE)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.SERVER_BLUE)]: (0, $38IWH.BLUE),
    [(0, $38IWH.SERVER_DARK_BLUE)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.SERVER_GREEN)]: (0, $38IWH.GREEN),
    [(0, $38IWH.SERVER_DARK_GREEN)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.SERVER_TEAL)]: (0, $38IWH.TEAL),
    [(0, $38IWH.SERVER_DARK_TEAL)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.SERVER_YELLOW)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.SERVER_DARK_YELLOW)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.SERVER_ORANGE)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.SERVER_DARK_ORANGE)]: (0, $38IWH.DARK_ORANGE),
    [(0, $38IWH.SERVER_GREY)]: (0, $38IWH.GREY),
    [(0, $38IWH.SERVER_DARK_GREY)]: (0, $38IWH.DARK_GREY)
};
const $f89c7f0e34657bc4$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$43264b0781f10167);
const $f89c7f0e34657bc4$export$fb5d051fe1b2bccc = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
const $f89c7f0e34657bc4$export$994d3ffa39be04fd = {
    [(0, $38IWH.AGILE_COLOR_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.AGILE_COLOR_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.AGILE_COLOR_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.AGILE_COLOR_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.AGILE_COLOR_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.AGILE_COLOR_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.AGILE_COLOR_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.AGILE_COLOR_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.AGILE_COLOR_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.AGILE_COLOR_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.AGILE_COLOR_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.AGILE_COLOR_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.AGILE_COLOR_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.AGILE_COLOR_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$994d3ffa39be04fd);
const $f89c7f0e34657bc4$export$1fdd5a248b5f697c = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.AGILE_COLOR_1),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.AGILE_COLOR_2),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.AGILE_COLOR_3),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.AGILE_COLOR_4),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.AGILE_COLOR_5),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.AGILE_COLOR_6),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.AGILE_COLOR_7),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.AGILE_COLOR_8),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.AGILE_COLOR_9),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.AGILE_COLOR_10),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.AGILE_COLOR_11),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.AGILE_COLOR_12),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.AGILE_COLOR_13),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.AGILE_COLOR_14)
};
const $f89c7f0e34657bc4$export$82fc3b0b98905453 = {
    [(0, $38IWH.DARK_GREY)]: 'grey',
    [(0, $38IWH.DARK_YELLOW)]: 'yellow',
    [(0, $38IWH.YELLOW)]: 'yellowLight',
    [(0, $38IWH.DARK_BLUE)]: 'blue',
    [(0, $38IWH.DARK_TEAL)]: 'teal',
    [(0, $38IWH.GREEN)]: 'greenLight',
    [(0, $38IWH.PURPLE)]: 'purpleLight',
    [(0, $38IWH.DARK_PURPLE)]: 'purple',
    [(0, $38IWH.ORANGE)]: 'redLight',
    [(0, $38IWH.BLUE)]: 'blueLight',
    [(0, $38IWH.TEAL)]: 'tealLight',
    [(0, $38IWH.GREY)]: 'greyLight',
    [(0, $38IWH.DARK_GREEN)]: 'green',
    [(0, $38IWH.DARK_ORANGE)]: 'red'
};
const $f89c7f0e34657bc4$export$703aca53c431bb88 = {
    [(0, $38IWH.AGILE_COLOR_1)]: 'grey',
    [(0, $38IWH.AGILE_COLOR_2)]: 'yellow',
    [(0, $38IWH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $38IWH.AGILE_COLOR_4)]: 'blue',
    [(0, $38IWH.AGILE_COLOR_5)]: 'teal',
    [(0, $38IWH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $38IWH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $38IWH.AGILE_COLOR_8)]: 'purple',
    [(0, $38IWH.AGILE_COLOR_9)]: 'redLight',
    [(0, $38IWH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $38IWH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $38IWH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $38IWH.AGILE_COLOR_13)]: 'green',
    [(0, $38IWH.AGILE_COLOR_14)]: 'red'
};
const $f89c7f0e34657bc4$export$92b6aebfb522f0d9 = {
    [(0, $38IWH.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("2IQEX", function(module, exports) {

var $9hKkF = parcelRequire("9hKkF");

var $h3TKx = parcelRequire("h3TKx");

var $d7YnM = parcelRequire("d7YnM");
/** Used for built-in method references. */ var $1fb889f558f23ac4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1fb889f558f23ac4$var$nativeObjectToString = $1fb889f558f23ac4$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $1fb889f558f23ac4$var$invert = $h3TKx(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $1fb889f558f23ac4$var$nativeObjectToString.call(value);
    result[value] = key;
}, $9hKkF($d7YnM));
module.exports = $1fb889f558f23ac4$var$invert;

});
parcelRegister("h3TKx", function(module, exports) {

var $8uipj = parcelRequire("8uipj");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $c6bdf63192b21f8e$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $8uipj(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $c6bdf63192b21f8e$var$createInverter;

});
parcelRegister("8uipj", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $62df67589f85c449$var$baseInverter(object, setter, iteratee, accumulator) {
    $75Jcs(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $62df67589f85c449$var$baseInverter;

});



parcelRegister("38IWH", function(module, exports) {
$parcel$export(module.exports, "PURPLE", () => $92f22b7535e1838e$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $92f22b7535e1838e$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $92f22b7535e1838e$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $92f22b7535e1838e$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $92f22b7535e1838e$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $92f22b7535e1838e$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $92f22b7535e1838e$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $92f22b7535e1838e$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $92f22b7535e1838e$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $92f22b7535e1838e$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $92f22b7535e1838e$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $92f22b7535e1838e$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $92f22b7535e1838e$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $92f22b7535e1838e$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $92f22b7535e1838e$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $92f22b7535e1838e$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $92f22b7535e1838e$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $92f22b7535e1838e$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $92f22b7535e1838e$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $92f22b7535e1838e$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $92f22b7535e1838e$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $92f22b7535e1838e$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $92f22b7535e1838e$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $92f22b7535e1838e$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $92f22b7535e1838e$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $92f22b7535e1838e$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $92f22b7535e1838e$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $92f22b7535e1838e$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $92f22b7535e1838e$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $92f22b7535e1838e$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $92f22b7535e1838e$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $92f22b7535e1838e$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $92f22b7535e1838e$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $92f22b7535e1838e$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $92f22b7535e1838e$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $92f22b7535e1838e$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $92f22b7535e1838e$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $92f22b7535e1838e$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $92f22b7535e1838e$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $92f22b7535e1838e$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $92f22b7535e1838e$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $92f22b7535e1838e$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $92f22b7535e1838e$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $92f22b7535e1838e$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $92f22b7535e1838e$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $92f22b7535e1838e$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $92f22b7535e1838e$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $92f22b7535e1838e$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $92f22b7535e1838e$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $92f22b7535e1838e$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $92f22b7535e1838e$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $92f22b7535e1838e$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $92f22b7535e1838e$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $92f22b7535e1838e$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $92f22b7535e1838e$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $92f22b7535e1838e$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $92f22b7535e1838e$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $92f22b7535e1838e$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $92f22b7535e1838e$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $92f22b7535e1838e$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $92f22b7535e1838e$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $92f22b7535e1838e$export$7ffdeca4b2f927a2 = 'PURPLE';
const $92f22b7535e1838e$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $92f22b7535e1838e$export$738c3b9a44c87ecc = 'BLUE';
const $92f22b7535e1838e$export$1225f83626261b80 = 'DARK_BLUE';
const $92f22b7535e1838e$export$48d4b2cd5bc0e88b = 'GREEN';
const $92f22b7535e1838e$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $92f22b7535e1838e$export$d0446fe88325854e = 'TEAL';
const $92f22b7535e1838e$export$bb848c92687e69dc = 'DARK_TEAL';
const $92f22b7535e1838e$export$aab610c505c06a8f = 'YELLOW';
const $92f22b7535e1838e$export$466af87757d343a2 = 'DARK_YELLOW';
const $92f22b7535e1838e$export$3de5e29ed1757f9b = 'ORANGE';
const $92f22b7535e1838e$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $92f22b7535e1838e$export$7d278ca694634874 = 'GREY';
const $92f22b7535e1838e$export$26453300bfc61cb8 = 'DARK_GREY';
const $92f22b7535e1838e$export$56d196d2844d1ca1 = [
    $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    $92f22b7535e1838e$export$c815fe495e8174a0,
    $92f22b7535e1838e$export$738c3b9a44c87ecc,
    $92f22b7535e1838e$export$1225f83626261b80,
    $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    $92f22b7535e1838e$export$d0446fe88325854e,
    $92f22b7535e1838e$export$bb848c92687e69dc,
    $92f22b7535e1838e$export$aab610c505c06a8f,
    $92f22b7535e1838e$export$466af87757d343a2,
    $92f22b7535e1838e$export$3de5e29ed1757f9b,
    $92f22b7535e1838e$export$da02e4820b6ab753,
    $92f22b7535e1838e$export$7d278ca694634874,
    $92f22b7535e1838e$export$26453300bfc61cb8
];
const $92f22b7535e1838e$export$792af22a0198af8d = 'purple';
const $92f22b7535e1838e$export$588af712afdcb006 = 'dark_purple';
const $92f22b7535e1838e$export$84c4918645391802 = 'blue';
const $92f22b7535e1838e$export$b8f1f5838352a33a = 'dark_blue';
const $92f22b7535e1838e$export$9384b7e350ee6542 = 'green';
const $92f22b7535e1838e$export$87d3fb8d8656d38b = 'dark_green';
const $92f22b7535e1838e$export$b0b4ce3e99e66aae = 'teal';
const $92f22b7535e1838e$export$a89b77a449bd223e = 'dark_teal';
const $92f22b7535e1838e$export$9a33b5e3cde94885 = 'yellow';
const $92f22b7535e1838e$export$33253d7862bceb8a = 'dark_yellow';
const $92f22b7535e1838e$export$6609c2b23fc42f39 = 'orange';
const $92f22b7535e1838e$export$cd994662b5911917 = 'dark_orange';
const $92f22b7535e1838e$export$1793d43e13e078c5 = 'grey';
const $92f22b7535e1838e$export$487a6e9145526564 = 'dark_grey';
const $92f22b7535e1838e$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $92f22b7535e1838e$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $92f22b7535e1838e$export$94ac87c81ed074a7 = 'ghx-label-3';
const $92f22b7535e1838e$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $92f22b7535e1838e$export$610a2c132b6fcf96 = 'ghx-label-5';
const $92f22b7535e1838e$export$8e4997dba71f1c40 = 'ghx-label-6';
const $92f22b7535e1838e$export$18a545b4e69b27b4 = 'ghx-label-7';
const $92f22b7535e1838e$export$27fff1a0d295292a = 'ghx-label-8';
const $92f22b7535e1838e$export$e57aa662a56724e1 = 'ghx-label-9';
const $92f22b7535e1838e$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $92f22b7535e1838e$export$457ecb9560f2bf83 = 'ghx-label-11';
const $92f22b7535e1838e$export$a866db37165a696c = 'ghx-label-12';
const $92f22b7535e1838e$export$9b18447c1168a1b6 = 'ghx-label-13';
const $92f22b7535e1838e$export$93b9ad4020e271b7 = 'ghx-label-14';
const $92f22b7535e1838e$export$5cd2af17b34de3e3 = 'color_1';
const $92f22b7535e1838e$export$987671fa69482a7b = 'color_2';
const $92f22b7535e1838e$export$70ba8a5b1f4c7446 = 'color_3';
const $92f22b7535e1838e$export$fcd1c42d8d3ebd36 = 'color_4';
const $92f22b7535e1838e$export$f80a5bd2fa0ba256 = 'color_5';
const $92f22b7535e1838e$export$37ad5ce8d2aeaf78 = 'color_6';
const $92f22b7535e1838e$export$9dc62d5d151cb355 = 'color_7';
const $92f22b7535e1838e$export$1ed15b30f5663f92 = 'color_8';
const $92f22b7535e1838e$export$5d23a84d55ac1644 = 'color_9';
const $92f22b7535e1838e$export$bf08c9a6ed42e349 = 'color_10';
const $92f22b7535e1838e$export$66c5d8f0b5ff279c = 'color_11';
const $92f22b7535e1838e$export$da30755a37c3a597 = 'color_12';
const $92f22b7535e1838e$export$721cf84faff6bf19 = 'color_13';
const $92f22b7535e1838e$export$4b8f8666bd7b61dd = 'color_14';
const $92f22b7535e1838e$export$c537fa0d021d010b = {
    PURPLE: $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $92f22b7535e1838e$export$c815fe495e8174a0,
    BLUE: $92f22b7535e1838e$export$738c3b9a44c87ecc,
    DARK_BLUE: $92f22b7535e1838e$export$1225f83626261b80,
    GREEN: $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    TEAL: $92f22b7535e1838e$export$d0446fe88325854e,
    DARK_TEAL: $92f22b7535e1838e$export$bb848c92687e69dc,
    YELLOW: $92f22b7535e1838e$export$aab610c505c06a8f,
    DARK_YELLOW: $92f22b7535e1838e$export$466af87757d343a2,
    ORANGE: $92f22b7535e1838e$export$3de5e29ed1757f9b,
    DARK_ORANGE: $92f22b7535e1838e$export$da02e4820b6ab753,
    GREY: $92f22b7535e1838e$export$7d278ca694634874,
    DARK_GREY: $92f22b7535e1838e$export$26453300bfc61cb8
};
const $92f22b7535e1838e$export$d33d39828a18210a = {
    SERVER_PURPLE: $92f22b7535e1838e$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $92f22b7535e1838e$export$588af712afdcb006,
    SERVER_BLUE: $92f22b7535e1838e$export$84c4918645391802,
    SERVER_DARK_BLUE: $92f22b7535e1838e$export$b8f1f5838352a33a,
    SERVER_GREEN: $92f22b7535e1838e$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $92f22b7535e1838e$export$87d3fb8d8656d38b,
    SERVER_TEAL: $92f22b7535e1838e$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $92f22b7535e1838e$export$a89b77a449bd223e,
    SERVER_YELLOW: $92f22b7535e1838e$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $92f22b7535e1838e$export$33253d7862bceb8a,
    SERVER_ORANGE: $92f22b7535e1838e$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $92f22b7535e1838e$export$cd994662b5911917,
    SERVER_GREY: $92f22b7535e1838e$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $92f22b7535e1838e$export$487a6e9145526564
};
const $92f22b7535e1838e$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $92f22b7535e1838e$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $92f22b7535e1838e$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $92f22b7535e1838e$export$94ac87c81ed074a7,
    GHX_LABEL_4: $92f22b7535e1838e$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $92f22b7535e1838e$export$610a2c132b6fcf96,
    GHX_LABEL_6: $92f22b7535e1838e$export$8e4997dba71f1c40,
    GHX_LABEL_7: $92f22b7535e1838e$export$18a545b4e69b27b4,
    GHX_LABEL_8: $92f22b7535e1838e$export$27fff1a0d295292a,
    GHX_LABEL_9: $92f22b7535e1838e$export$e57aa662a56724e1,
    GHX_LABEL_10: $92f22b7535e1838e$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $92f22b7535e1838e$export$457ecb9560f2bf83,
    GHX_LABEL_12: $92f22b7535e1838e$export$a866db37165a696c,
    GHX_LABEL_13: $92f22b7535e1838e$export$9b18447c1168a1b6,
    GHX_LABEL_14: $92f22b7535e1838e$export$93b9ad4020e271b7
};
const $92f22b7535e1838e$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $92f22b7535e1838e$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $92f22b7535e1838e$export$987671fa69482a7b,
    AGILE_COLOR_3: $92f22b7535e1838e$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $92f22b7535e1838e$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $92f22b7535e1838e$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $92f22b7535e1838e$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $92f22b7535e1838e$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $92f22b7535e1838e$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $92f22b7535e1838e$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $92f22b7535e1838e$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $92f22b7535e1838e$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $92f22b7535e1838e$export$da30755a37c3a597,
    AGILE_COLOR_13: $92f22b7535e1838e$export$721cf84faff6bf19,
    AGILE_COLOR_14: $92f22b7535e1838e$export$4b8f8666bd7b61dd
};

});


parcelRegister("1wTTU", function(module, exports) {
$parcel$export(module.exports, "asColor", () => $b36086cea9eb1a24$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $b36086cea9eb1a24$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $b36086cea9eb1a24$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $b36086cea9eb1a24$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $b36086cea9eb1a24$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $b36086cea9eb1a24$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $b36086cea9eb1a24$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $b36086cea9eb1a24$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $b36086cea9eb1a24$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $b36086cea9eb1a24$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $b36086cea9eb1a24$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $b36086cea9eb1a24$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $b36086cea9eb1a24$export$e4369cabd7e84cd9);

var $2IQEX = parcelRequire("2IQEX");

var $38IWH = parcelRequire("38IWH");

var $8URAw = parcelRequire("8URAw");

var $efpPR = parcelRequire("efpPR");
const $b36086cea9eb1a24$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $38IWH.Colors).PURPLE;
    if (color in (0, $38IWH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $38IWH.Colors).PURPLE;
};
const $b36086cea9eb1a24$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $38IWH.ServerColors).SERVER_PURPLE;
    if (color in (0, $38IWH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $38IWH.ServerColors).SERVER_PURPLE;
};
const $b36086cea9eb1a24$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
    if (color in (0, $38IWH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
};
const $b36086cea9eb1a24$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $8URAw.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $38IWH.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $b36086cea9eb1a24$export$a00423580059ae28 = (color)=>(0, $8URAw.MAP_COLORS_TO_VALUE)[color] || (0, $8URAw.MAP_COLORS_TO_VALUE)[0, $38IWH.PURPLE];
const $b36086cea9eb1a24$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))((0, $8URAw.MAP_COLORS_TO_VALUE))[value] || (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$47af25386a01de1 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $b36086cea9eb1a24$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$28fb68bb1de025d5 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $b36086cea9eb1a24$var$paletteColorValues = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $b36086cea9eb1a24$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $efpPR.default).purpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).blueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).greenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).tealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).yellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).orangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).greyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREY]
        },
        {
            label: formatMessage((0, $efpPR.default).darkPurpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkBlueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).darkTealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).darkYellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).darkOrangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREY]
        }
    ];
const $b36086cea9eb1a24$var$getLozengeThemes = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $b36086cea9eb1a24$export$949dc67535a8ff2 = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $b36086cea9eb1a24$var$getLozengeThemes[color] ?? $b36086cea9eb1a24$var$getLozengeThemes[0, $8URAw.DEFAULT_EPIC_COLOR];
const $b36086cea9eb1a24$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $38IWH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("efpPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5a8789e55bcd8e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f5a8789e55bcd8e1$var$messages = (0, $7qGN1.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "Purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "Blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "Green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "Teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "Yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "Orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "Grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "Dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "Dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "Dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "Dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "Dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "Dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "Dark grey"
    }
});
var $f5a8789e55bcd8e1$export$2e2bcd8739ae039 = $f5a8789e55bcd8e1$var$messages;

});


parcelRegister("bBiKm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3241fb4419868a9b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3241fb4419868a9b$var$messages = (0, $7qGN1.defineMessages)({
    epicTitle: {
        "id": "native-issue-table.common.issue-cells.epic-link.epic-title",
        "defaultMessage": "Click to visit"
    },
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});
var $3241fb4419868a9b$export$2e2bcd8739ae039 = $3241fb4419868a9b$var$messages;

});


parcelRegister("avymT", function(module, exports) {
$parcel$export(module.exports, "FallbackCell", () => $b016b9d3e5546a5f$export$de9d519be820a473);

var $1ADvX = parcelRequire("1ADvX");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $9Mapt = parcelRequire("9Mapt");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $b016b9d3e5546a5f$var$TYPES_TO_REMOVE_TITLE = new Set([
    'lastViewed'
]); /**
                                                        * Render fallback version of the issue field cell that is generated by the backend.
                                                        * We trust the backend to do all HTML entity encoding and other sanitization.
                                                        */ 
const $b016b9d3e5546a5f$export$de9d519be820a473 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $1ADvX.default), fieldRef);
    const { renderedFieldHtml: renderedFieldHtml, type: type } = data;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const removeTitleAttributeRef = (0, $eJOHy.useCallback)((el)=>{
        if (!$b016b9d3e5546a5f$var$TYPES_TO_REMOVE_TITLE.has(type)) return;
        el?.querySelectorAll('[title]').forEach((node)=>{
            node.removeAttribute('title');
        });
    }, [
        type
    ]);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (renderedFieldHtml == null) return /*#__PURE__*/ $eJOHy.createElement((0, $86BUM.default), {
        cellType: "fallback",
        reason: "Missing required fields"
    });
    if (!renderedFieldHtml.trim().length) return null;
    let hoverPopoverRef = null;
    switch(type){
        case 'thumbnail':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            },
                            className: (0, $hcewu.default)([
                                "_1jpx1f51 _rtys1osq _19l31osq"
                            ])
                        }),
                        alwaysShow: true
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$AttachmentFallbackContainer, {
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                        ref: hoverPopoverRef
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        className: (0, $hcewu.default)([
                            "_1jpx1f51 _rtys1osq _19l31osq"
                        ])
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$AttachmentFallbackContainer, {
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                        ref: ref
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$AttachmentFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.attachment-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                },
                isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
            });
        case 'progress':
        case 'aggregateprogress':
            // No need for hover popover for progress as contents (graphic) is responsive to cell width
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$ProgressFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.progress-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-request-feedback':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SatisfactionFallbackContainer, {
                        ref: hoverPopoverRef,
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SatisfactionFallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SatisfactionFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.satisfaction-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        case 'com.atlassian.servicedesk:sd-sla-field':
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SlaFallbackContainer, {
                        ref: hoverPopoverRef,
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SlaFallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$SlaFallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.sla-fallback-container",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
        default:
            if (isSingleLineRowHeightEnabled) {
                if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
                    hoverPopoverRef = hoverPopoverRefFactory({
                        content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                        , {
                            dangerouslySetInnerHTML: {
                                __html: renderedFieldHtml
                            }
                        })
                    });
                    return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$FallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(hoverPopoverRef, removeTitleAttributeRef),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    });
                }
                return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                    contentRef: contentRef,
                    content: /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line react/no-danger
                    , {
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        }
                    })
                }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$FallbackContainer, {
                        ref: (0, $bzbsd.mergeRefs)(contentRef, ref, removeTitleAttributeRef),
                        "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                        dangerouslySetInnerHTML: {
                            __html: renderedFieldHtml
                        },
                        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
                    }));
            }
            return /*#__PURE__*/ $eJOHy.createElement($b016b9d3e5546a5f$var$FallbackContainer, {
                "data-testid": "native-issue-table.common.ui.issue-cells.fallback.div",
                dangerouslySetInnerHTML: {
                    __html: renderedFieldHtml
                }
            });
    }
});
/**
 * Disabling selector eslint rules because we must provide the fallback style overrides this way due
 * to the markup and base styles coming from the monolith.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$FallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _p12f1osq _1bto1l2s _bna71wug _rtys1osq",
            __cmplp && "_o5721q9c _wmb415vq _12ev15vq _5c4l1l2s _1e4iglyw",
            __cmplp.className
        ])
    });
});
const $b016b9d3e5546a5f$var$attachmentPopoverStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$AttachmentFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bna71wug _19l3uuw1 _mezj1wug _rtys1osq",
            __cmplp && "_1rjcv77o _1e0c1txw _1bah1h6o _4cvr1h6o _19l31ul9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$ProgressFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4idpf _1lms18uv _xu7xt94y _19jqt94y _iv7lt94y _18m0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$SatisfactionFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nmi71oqg _17go131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b016b9d3e5546a5f$var$SlaFallbackContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $b016b9d3e5546a5f$var$FallbackContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1xngu2gc _1kss1txw _1v441h6o _1fecusic _1op7t9kd _i95c17hp _c4xnnbxb _1mf8wdcn _10ku8uof _m1tonbxb _g3h87r97",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1ADvX", function(module, exports) {
$parcel$export(module.exports, "default", () => $992dac4faf65e1f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f6556eba348c4e1df94ffe1af75e7a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $992dac4faf65e1f5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FallbackCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "renderedFieldHtml"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        }
    ],
    "type": "JiraFallbackField"
};
$992dac4faf65e1f5$var$node.hash = "5a44333782fe000d835b0ea393cc6a88";
var $992dac4faf65e1f5$export$2e2bcd8739ae039 = $992dac4faf65e1f5$var$node;

});


parcelRegister("4mhLJ", function(module, exports) {
$parcel$export(module.exports, "FlagCell", () => $1a7c562f013d4ae8$export$be4c47c19457cd1e);

var $3YACX = parcelRequire("3YACX");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $kePo9 = parcelRequire("kePo9");
const $1a7c562f013d4ae8$export$be4c47c19457cd1e = ({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $3YACX.default), fieldRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return data.flag?.isFlagged && formatMessage((0, $kePo9.default).flagged);
};

});
parcelRegister("3YACX", function(module, exports) {
$parcel$export(module.exports, "default", () => $45e9f9f17f5e45a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e161f484d39cb7060e7fafe9b975774>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45e9f9f17f5e45a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FlagCell",
    "selections": [
        {
            "concreteType": "JiraFlag",
            "kind": "LinkedField",
            "name": "flag",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFlagged"
                }
            ]
        }
    ],
    "type": "JiraFlagField"
};
$45e9f9f17f5e45a9$var$node.hash = "a132d27c76c2fbd37572315422c76c0c";
var $45e9f9f17f5e45a9$export$2e2bcd8739ae039 = $45e9f9f17f5e45a9$var$node;

});

parcelRegister("kePo9", function(module, exports) {
$parcel$export(module.exports, "default", () => $44166ff552e5c007$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $44166ff552e5c007$var$messages = (0, $7qGN1.defineMessages)({
    flagged: {
        "id": "native-issue-table.common.issue-cells.flag.flagged",
        "defaultMessage": "Impediment"
    }
});
var $44166ff552e5c007$export$2e2bcd8739ae039 = $44166ff552e5c007$var$messages;

});


parcelRegister("crxno", function(module, exports) {
$parcel$export(module.exports, "GoalsCell", () => $87d28259df048411$export$aea87ff07be8100d);

var $kqoda = parcelRequire("kqoda");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dHPoe = parcelRequire("dHPoe");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $87d28259df048411$export$aea87ff07be8100d = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $kqoda.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled && data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dHPoe.GoalsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: shouldTruncate
    });
};

});
parcelRegister("kqoda", function(module, exports) {
$parcel$export(module.exports, "default", () => $efe946ba5ccefb1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3785c96450d71659edfe05fdcad96d83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $efe946ba5ccefb1a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "GoalsCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraGoalsField"
};
$efe946ba5ccefb1a$var$node.hash = "3bef28866cbc81a4082bd51e2208be0f";
var $efe946ba5ccefb1a$export$2e2bcd8739ae039 = $efe946ba5ccefb1a$var$node;

});

parcelRegister("dHPoe", function(module, exports) {
$parcel$export(module.exports, "GoalsInlineEditViewWithIsEditable", () => $b69d8ff6824a40f6$export$16ba9f62f4ede1d3);

var $bb4YW = parcelRequire("bb4YW");

var $f47Or = parcelRequire("f47Or");

var $6z2Km = parcelRequire("6z2Km");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $kqd31 = parcelRequire("kqd31");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $jZbQD = parcelRequire("jZbQD");

var $cHtIB = parcelRequire("cHtIB");

var $byUzi = parcelRequire("byUzi");

var $auNLL = parcelRequire("auNLL");

var $knIOf = parcelRequire("knIOf");

var $4cTDP = parcelRequire("4cTDP");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b69d8ff6824a40f6$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aUrlSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aUrlSet.has(option.url));
};
const $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME = 'JiraGoal';
const $b69d8ff6824a40f6$var$JIRA_GOAL_EDGE_TYPENAME = 'JiraGoalEdge';
const $b69d8ff6824a40f6$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-goals-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b69d8ff6824a40f6$export$16ba9f62f4ede1d3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $6z2Km.default), fragmentRef);
    // for the mutation, only need to worry about the deletion / removal
    // don't worry about insertion as that's handled by the townsquare goal picker
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $f47Or.default));
    // #endregion Relay
    // #region State
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const { __id: __id, id: uniqueFieldId, name: name, type: fieldType, selectedGoals: selectedGoals, issue: issue } = data;
    const selectedGoalsConnectionId = selectedGoals?.__id;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        return nodes.map((node)=>({
                id: node.id,
                url: constructGoalUrl({
                    ari: node.id,
                    key: node.key
                })
            }));
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #region Action
    const updater = (0, $eJOHy.useCallback)((store, value)=>{
        const connection = selectedGoalsConnectionId ? store.get(selectedGoalsConnectionId) : null;
        if (!connection) return;
        const { EDGES: EDGES, NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
        const edges = connection.getLinkedRecords(EDGES) ?? [];
        const edgesByNodeId = {};
        edges.forEach((edge)=>{
            const nodeId = edge.getLinkedRecord(NODE)?.getValue('id');
            if (typeof nodeId === 'string') edgesByNodeId[nodeId] = edge;
        });
        const nextEdges = [];
        value.forEach(({ id: id, url: url })=>{
            if (id && id in edgesByNodeId) nextEdges.push(edgesByNodeId[id]);
            else {
                const nodeRelayDataId = (0, $kqd31.default)({
                    id: id
                }, $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME);
                const key = (0, $byUzi.getGoalKeyFromUrl)(url);
                if (nodeRelayDataId) {
                    let node = store.get(nodeRelayDataId);
                    if (!node) {
                        node = store.create(nodeRelayDataId, $b69d8ff6824a40f6$var$JIRA_GOAL_TYPENAME);
                        (0, $4cTDP.fg)('jira_nin_goals_smart_link_fix') ? node.setValue(id, 'id') : node.setValue(nodeRelayDataId, 'id');
                    }
                    if (key) node.setValue(key, 'key');
                    const edge = (0, $j4oe4.ConnectionHandler).createEdge(store, connection, node, $b69d8ff6824a40f6$var$JIRA_GOAL_EDGE_TYPENAME);
                    nextEdges.push(edge);
                }
            }
        });
        connection.setLinkedRecords(nextEdges, EDGES);
    }, [
        selectedGoalsConnectionId
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        const initialIds = initialValue.map(({ id: id })=>id).filter(Boolean);
        const initialIdSet = new Set(initialIds);
        const updatedIds = value.map(({ id: id })=>id).filter(Boolean);
        const updatedIdSet = new Set(updatedIds);
        const deletedRelationships = initialIds.filter((id)=>!updatedIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        const createdRelationships = updatedIds.filter((id)=>!initialIdSet.has(id)).map((id)=>({
                from: issue.id,
                to: id
            }));
        commit({
            variables: {
                createInput: {
                    relationships: createdRelationships
                },
                deleteInput: {
                    relationships: deletedRelationships
                }
            },
            updater: (store)=>updater(store, value),
            optimisticUpdater: (store)=>updater(store, value),
            onCompleted (mutationData) {
                if (mutationData.townsquare?.createRelationships?.success && mutationData.townsquare?.deleteRelationships?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                townsquare: {
                    createRelationships: {
                        success: true,
                        relationships: createdRelationships
                    },
                    deleteRelationships: {
                        success: true,
                        relationships: deletedRelationships
                    }
                }
            }
        });
    }, [
        onSubmit,
        initialValue,
        commit,
        issue.id,
        updater
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b69d8ff6824a40f6$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #endregion Action
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69d8ff6824a40f6$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $knIOf.GoalsReadView), {
            fragmentRef: data,
            isTruncated: isTruncated
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            issueAri: issue.id,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    const cloudId = (0, $cHtIB.useCloudId)();
    const editViewEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            issueAri: issue.id
        }), [
        cloudId,
        issue.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $jZbQD.default),
        editViewEntryPointParams: editViewEntryPointParams,
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
// #endregion Edit View
};
const $b69d8ff6824a40f6$export$fc2645c54795e7e6 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $bb4YW.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69d8ff6824a40f6$export$16ba9f62f4ede1d3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("bb4YW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b263b3518298fbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7542446408a11d8dcd6f34ea8741757a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b263b3518298fbc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraGoalsField"
};
$7b263b3518298fbc$var$node.hash = "d698a934047d8a1aef53370ee1f7570c";
var $7b263b3518298fbc$export$2e2bcd8739ae039 = $7b263b3518298fbc$var$node;

});

parcelRegister("f47Or", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bcb9233c46e9d29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57d11f4e2332b19d87c403e7d64ec868>>
 * @relayHash f896f939a1918da6870fd74a26e67107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f
const $9bcb9233c46e9d29$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteInput"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "success"
        },
        {
            "concreteType": "TownsquareRelationship",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "from"
                },
                {
                    "kind": "ScalarField",
                    "name": "to"
                }
            ]
        }
    ], v2 = [
        {
            "concreteType": "TownsquareMutationApi",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "createInput"
                        }
                    ],
                    "concreteType": "TownsquareCreateRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "createRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "deleteInput"
                        }
                    ],
                    "concreteType": "TownsquareDeleteRelationshipsPayload",
                    "kind": "LinkedField",
                    "name": "deleteRelationships",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "8dbb1de2807924cc75847f0e6cb98eddad0909f975f61d85473712a94f60740f",
            "metadata": {},
            "name": "goals_issueFieldGoals_GoalsField_LinkUnlinkIssueToGoalMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9bcb9233c46e9d29$var$node.hash = "d5d407c381c2f478408ef64adaf27177";
var $9bcb9233c46e9d29$export$2e2bcd8739ae039 = $9bcb9233c46e9d29$var$node;

});

parcelRegister("6z2Km", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0c63300a1234272$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b806e0d4bbf68b8eb5cca1fbda58643>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0c63300a1234272$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issue"
            },
            {
                "kind": "FragmentSpread",
                "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    }
                                ]
                            }
                        ]
                    },
                    v1 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraGoalsField"
    };
}();
$b0c63300a1234272$var$node.hash = "46c4ce64c1ccf9c7ee8dc2090f374288";
var $b0c63300a1234272$export$2e2bcd8739ae039 = $b0c63300a1234272$var$node;

});

parcelRegister("jZbQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b571ab63a42dd1e$export$2e2bcd8739ae039);

var $ie272 = parcelRequire("ie272");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b571ab63a42dd1e$var$GoalsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7IslU")), {
        moduleId: "8bcf8112",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueAri: issueAri })=>({
            queries: {
                GoalsPopupQuery: {
                    parameters: (0, $ie272.default),
                    variables: {
                        cloudId: cloudId,
                        issueAri: issueAri
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});
var $7b571ab63a42dd1e$export$2e2bcd8739ae039 = $7b571ab63a42dd1e$var$GoalsEditViewEntryPoint;

});
parcelRegister("ie272", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c952a81be973c1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce58d611252b9956cb488acbd8175ebf>>
 * @relayHash e100e4608f0f09869a047dc4d2e25a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 937157055e12959c4a5dedd3877600cd0531fb0e4b7826db78fa93e5143aa6d7
const $7c952a81be973c1a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "concreteType": "TownsquareUnshardedUserCapabilities",
        "kind": "LinkedField",
        "name": "userCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareUnshardedCapability",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "capability"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                    }
                ]
            }
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueAri"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v14 = [
        "id"
    ], v15 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalsPopupQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueGoals_AtlassianGoalPicker"
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalsPopupQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareLocalizationField",
                                                                    "kind": "LinkedField",
                                                                    "name": "localizedLabel",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "messageId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appearance"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareGoal"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "filters": v14 /*: any*/ ,
                            "handle": "connection",
                            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v15 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
                            "kind": "LinkedField",
                            "name": "jiraEpicContributesToAtlasGoal",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "TownsquareGoal"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "issueGoalPicker",
                            "args": v15 /*: any*/ ,
                            "filters": v14 /*: any*/ ,
                            "handle": "connection",
                            "key": "Goals_issueGoalPicker",
                            "kind": "LinkedHandle",
                            "name": "jiraEpicContributesToAtlasGoal"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
                    "kind": "LinkedField",
                    "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareUnshardedWorkspaceSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "937157055e12959c4a5dedd3877600cd0531fb0e4b7826db78fa93e5143aa6d7",
            "metadata": {},
            "name": "GoalsPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7c952a81be973c1a$var$node.hash = "6b6483c49f35e89caf438218f946dd41";
var $7c952a81be973c1a$export$2e2bcd8739ae039 = $7c952a81be973c1a$var$node;

});

parcelRegister("7IslU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("9ZmDf")
]).then(()=>parcelRequire('8gn0t'));

});


parcelRegister("byUzi", function(module, exports) {
$parcel$export(module.exports, "useGoalUrlConstructor", () => $3db898fb705dc57f$export$141a926c45c15603);
$parcel$export(module.exports, "getGoalKeyFromUrl", () => $3db898fb705dc57f$export$9bf22e4fb9891a0d);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $hxEoB = parcelRequire("hxEoB");

var $4cTDP = parcelRequire("4cTDP");

var $kyq27 = parcelRequire("kyq27");

const $3db898fb705dc57f$export$141a926c45c15603 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isStagingOrDevOrLocal = (0, $kyq27.useIsStagingOrDevOrLocal)();
    const atlassianHomeUrl = isStagingOrDevOrLocal ? (0, $07a8c3e317a6072d$export$46b5a4e5fbe6e304) : (0, $07a8c3e317a6072d$export$732915c664dff395);
    return (0, $eJOHy.useCallback)(({ ari: ari, key: key })=>{
        if ((0, $4cTDP.fg)('jira_nin_goals_smart_link_fix')) {
            const siteId = (0, $hxEoB.TownsquareGoalAri).parse(ari).siteId;
            return `${atlassianHomeUrl}/o/${orgId}/s/${siteId}/goal/${key}`;
        }
        return `${atlassianHomeUrl}/o/${orgId}/s/${cloudId}/goal/${key}`;
    }, [
        atlassianHomeUrl,
        cloudId,
        orgId
    ]);
};
const $3db898fb705dc57f$export$9bf22e4fb9891a0d = (url)=>url.split('/').pop();

});
parcelRegister("hxEoB", function(module, exports) {
$parcel$export(module.exports, "TownsquareGoalAri", () => $cc54da830a83e212$export$e45ea1bd9a289a4f);

var $fU8Xu = parcelRequire("fU8Xu");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/townsquare/goal/manifest.ts
var $cc54da830a83e212$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fU8Xu.TownsquareGoalAriResourceOwner),
    resourceType: (0, $fU8Xu.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $cc54da830a83e212$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $cc54da830a83e212$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $cc54da830a83e212$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $cc54da830a83e212$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
};

});
parcelRegister("fU8Xu", function(module, exports) {
$parcel$export(module.exports, "TownsquareGoalAriResourceOwner", () => $b94308f9cc97b4c4$export$947838268868cc57);
$parcel$export(module.exports, "TownsquareGoalAriResourceType", () => $b94308f9cc97b4c4$export$935b9c2af9d62e80);
// src/townsquare/goal/types.ts
var $b94308f9cc97b4c4$export$947838268868cc57 = "townsquare", $b94308f9cc97b4c4$export$935b9c2af9d62e80 = "goal";

});


const $07a8c3e317a6072d$export$732915c664dff395 = 'https://home.atlassian.com';
const $07a8c3e317a6072d$export$46b5a4e5fbe6e304 = 'https://home.stg.atlassian.com';


parcelRegister("knIOf", function(module, exports) {
$parcel$export(module.exports, "GoalsReadView", () => $1ca37a34ff4fe805$export$7f51e00c35102426);

var $ljlHd = parcelRequire("ljlHd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $byUzi = parcelRequire("byUzi");

var $8lb7o = parcelRequire("8lb7o");

var $3PRLs = parcelRequire("3PRLs");

var $d9T1A = parcelRequire("d9T1A");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $dLVMI = parcelRequire("dLVMI");

var $w8hPK = parcelRequire("w8hPK");

var $2jdpt = parcelRequire("2jdpt");
const $1ca37a34ff4fe805$export$7f51e00c35102426 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const constructGoalUrl = (0, $byUzi.useGoalUrlConstructor)();
    const { selectedGoals: selectedGoals } = (0, $j4oe4.useFragment)((0, $ljlHd.default), fragmentRef);
    const { firstGoal: firstGoal, totalGoalsCount: totalGoalsCount } = (0, $eJOHy.useMemo)(()=>{
        const nodes = selectedGoals?.edges?.map((edge)=>edge?.node)?.filter((node)=>Boolean(node?.key)) ?? [];
        const transformedNodes = nodes.map((node)=>({
                ...node,
                key: node.id,
                url: constructGoalUrl({
                    ari: node.id,
                    key: node.key
                })
            }));
        return {
            firstGoal: transformedNodes[0],
            totalGoalsCount: transformedNodes.length
        };
    }, [
        constructGoalUrl,
        selectedGoals?.edges
    ]);
    const placeholderDataForSmartCard = (0, $eJOHy.useMemo)(()=>{
        return firstGoal && (0, $4cTDP.fg)('goals_ssr_smart_card') ? (0, $2jdpt.generatePlaceholderData)(firstGoal.url, firstGoal.name, firstGoal.status) : undefined;
    }, [
        firstGoal
    ]);
    if (totalGoalsCount === 0 || !selectedGoals) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: firstGoal.url,
            ...(0, $4cTDP.fg)('goals_ssr_smart_card') ? {
                placeholderData: placeholderDataForSmartCard
            } : {}
        }),
        totalItems: totalGoalsCount,
        isTruncated: isTruncated,
        entryPoint: (0, $dLVMI.goalsPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: {
            fragmentRef: selectedGoals
        },
        showMoreTooltip: formatMessage((0, $w8hPK.default).showMoreTooltip),
        actionSubjectIdPrefix: "goals"
    });
};

});
parcelRegister("ljlHd", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db57d336fee8eee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cca8185d4e99740aa617bbb52991dbaf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9db57d336fee8eee$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraGoalConnection",
            "kind": "LinkedField",
            "name": "selectedGoals",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "popupContent_issueFieldGoalsReadviewFull"
                },
                {
                    "concreteType": "JiraGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGoal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedGoals(first:1000)"
        }
    ],
    "type": "JiraGoalsField"
};
$9db57d336fee8eee$var$node.hash = "e8e15ade4d6e6ee4a59b31ff82e7a584";
var $9db57d336fee8eee$export$2e2bcd8739ae039 = $9db57d336fee8eee$var$node;

});

parcelRegister("8lb7o", function(module, exports) {
$parcel$export(module.exports, "ItemWithEntryPointPopup", () => $14af9ae86efae763$export$15750a4e92a11aeb);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $l1Evt = parcelRequire("l1Evt");

var $l8oUV = parcelRequire("l8oUV");
const $14af9ae86efae763$export$15750a4e92a11aeb = ({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointRuntimeProps: entryPointRuntimeProps, ...props })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)(entryPoint, entryPointParams);
    const [retryKey, setRetryKey] = (0, $eJOHy.useState)(0);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l1Evt.default), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        triggerRefCallback: triggerRef,
        entryPointActions: entryPointActions,
        PopupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            key: retryKey,
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "popup-content",
            packageName: "jiraItemWithPopup",
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8oUV.ErrorFallback), {
                    onClick: ()=>setRetryKey((prev)=>prev + 1)
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                padding: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: entryPointRuntimeProps
        }),
        ...props
    });
};

});
parcelRegister("l1Evt", function(module, exports) {
$parcel$export(module.exports, "default", () => $9039846db754c967$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");

var $ibVOD = parcelRequire("ibVOD");

var $1O6K6 = parcelRequire("1O6K6");
const $9039846db754c967$var$ItemWithPopup = ({ ItemComponent: ItemComponent, showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated = false, entryPointActions: entryPointActions })=>{
    if (ItemComponent === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isTruncated
    }, ItemComponent, totalItems > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1O6K6.default), {
        showMoreTooltip: showMoreTooltip,
        totalItems: totalItems - 1,
        PopupComponent: PopupComponent,
        isOpen: isOpen,
        onSetIsOpen: onSetIsOpen,
        triggerRefCallback: triggerRefCallback,
        actionSubjectIdPrefix: actionSubjectIdPrefix,
        isTruncated: isTruncated,
        entryPointActions: entryPointActions
    })));
};
var $9039846db754c967$export$2e2bcd8739ae039 = $9039846db754c967$var$ItemWithPopup;

});
parcelRegister("1O6K6", function(module, exports) {
$parcel$export(module.exports, "default", () => $db629c491ab3411a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4B7rn = parcelRequire("4B7rn");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9Mapt = parcelRequire("9Mapt");
const $db629c491ab3411a$var$ShowMorePopup = ({ showMoreTooltip: showMoreTooltip, totalItems: totalItems, PopupComponent: PopupComponent, isOpen: isOpen, onSetIsOpen: onSetIsOpen, triggerRefCallback: triggerRefCallback, actionSubjectIdPrefix: actionSubjectIdPrefix, isTruncated: isTruncated, entryPointActions: entryPointActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (totalItems === 0) return null;
    const onClickTrigger = ()=>{
        onSetIsOpen(!isOpen);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), `${actionSubjectIdPrefix}ItemWithPopup`);
    };
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $db629c491ab3411a$var$ContainerDialogStyles
        }, PopupComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: PopupComponent,
            entryPointActions: entryPointActions,
            isInteractive: true
        }, ({ ref: ref, ariaExpanded: ariaExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                spacing: "none",
                "aria-expanded": ariaExpanded,
                testId: "item-with-popup.ui.item-with-popup.show-more-popup.button",
                ref: ref,
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $db629c491ab3411a$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        placement: "bottom",
        content: content,
        testId: "item-with-popup.ui.item-with-popup.show-more-popup.show-more-popup",
        messageId: "item-with-popup.ui.item-with-popup.show-more-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                key: "triggerLinksDialog",
                content: showMoreTooltip,
                tag: $db629c491ab3411a$var$TooltipContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                "aria-label": `${showMoreTooltip} +${totalItems}`,
                isSelected: isOpen,
                onClick: onClickTrigger,
                spacing: "none",
                ref: (element)=>{
                    triggerRefCallback && triggerRefCallback(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $db629c491ab3411a$var$itemsCountStyles,
                paddingInline: "space.050"
            }, "+", totalItems)))
    });
};
const $db629c491ab3411a$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ...props,
        ref: ref,
        as: "span",
        xcss: $db629c491ab3411a$var$tooltipContainerStyles
    }));
const $db629c491ab3411a$var$ContainerDialogStyles = (0, $1DXK0.xcss)({
    width: '240px',
    maxHeight: '220px',
    overflow: 'auto',
    padding: 'space.100',
    border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
    borderRadius: 'radius.small'
});
const $db629c491ab3411a$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $db629c491ab3411a$var$itemsCountStyles = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-250, 20px)"
});
var $db629c491ab3411a$export$2e2bcd8739ae039 = $db629c491ab3411a$var$ShowMorePopup;

});


parcelRegister("l8oUV", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $374ab770514ac6b8$export$8a7ad05c3ee0c78a);

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $80DPg = parcelRequire("80DPg");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $447R4 = parcelRequire("447R4");
const $374ab770514ac6b8$export$8a7ad05c3ee0c78a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "strong"
    }, formatMessage((0, $447R4.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: onClick,
        spacing: "compact"
    }, formatMessage((0, $447R4.default).retryMessage)));
};

});
parcelRegister("447R4", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd7cd7f56cf414b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cd7cd7f56cf414b6$var$messages = (0, $7qGN1.defineMessages)({
    retryMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.retry-message",
        "defaultMessage": "Click to retry"
    },
    errorMessage: {
        "id": "item-with-popup.ui.item-with-entrypoint-popup.error-fallback.error-message",
        "defaultMessage": "Failed to load content"
    }
});
var $cd7cd7f56cf414b6$export$2e2bcd8739ae039 = $cd7cd7f56cf414b6$var$messages;

});



parcelRegister("3PRLs", function(module, exports) {
$parcel$export(module.exports, "SimpleInlineSmartLink", () => $6ee98882ad11c6d7$export$e918b96127f4d56b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $18DG7 = parcelRequire("18DG7");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $8YHJ2 = parcelRequire("8YHJ2");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $7Bn2k = parcelRequire("7Bn2k");
const $6ee98882ad11c6d7$var$uiOptions = {
    clickableContainer: true,
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    size: (0, $5NtHI.SmartLinkSize).Medium
};
const $6ee98882ad11c6d7$var$uiOptionsWithPlaceholder = {
    ...$6ee98882ad11c6d7$var$uiOptions,
    removeBlockRestriction: true
};
const $6ee98882ad11c6d7$var$actionOptions = {
    hide: false,
    exclude: [
        (0, $18DG7.CardAction).ChangeStatusAction
    ]
};
const $6ee98882ad11c6d7$export$e918b96127f4d56b = ({ onRemove: onRemove, url: url, anchorTarget: anchorTarget, showHoverPreview: showHoverPreview = true, text: text, anchorRef: anchorRef, onError: onError, placeholderData: placeholderData })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.025",
        paddingInline: "space.050",
        xcss: $6ee98882ad11c6d7$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YHJ2.CardSSR), {
        appearance: "inline",
        url: url,
        ui: (0, $4cTDP.fg)('jfp-magma-fix-url-field-ssr-hydration') || placeholderData && (0, $4cTDP.fg)('goals_ssr_smart_card') ? $6ee98882ad11c6d7$var$uiOptionsWithPlaceholder : $6ee98882ad11c6d7$var$uiOptions,
        actionOptions: $6ee98882ad11c6d7$var$actionOptions,
        showHoverPreview: showHoverPreview,
        placeholderData: placeholderData,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
        hideTitleTooltip: true,
        maxLines: 1,
        metadata: [
            {
                name: (0, $5NtHI.ElementName).State
            }
        ],
        anchorTarget: anchorTarget ?? '_self',
        text: (0, $4cTDP.fg)('goals_ssr_smart_card') ? undefined : text,
        anchorRef: anchorRef,
        ...(0, $4cTDP.fg)('goals_ssr_smart_card') ? {
            hideIconLoadingSkeleton: !!placeholderData
        } : {},
        className: (0, $hcewu.default)([
            "_zulp1b66"
        ])
    })), onRemove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Bn2k.RemoveButton), {
        onClick: onRemove
    }));
};
const $6ee98882ad11c6d7$var$inlineStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    gap: 'space.050'
});
const $6ee98882ad11c6d7$var$titleBlockStyles = null;

});
parcelRegister("7Bn2k", function(module, exports) {
$parcel$export(module.exports, "RemoveButton", () => $0d8083ad70c45c39$export$4e9d5ce1e6c22a94);

var $eJOHy = parcelRequire("eJOHy");

var $6zhpo = parcelRequire("6zhpo");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $bWlv0 = parcelRequire("bWlv0");
const $0d8083ad70c45c39$export$4e9d5ce1e6c22a94 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
        onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $bWlv0.default).removeTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            ...tooltipProps,
            "aria-label": formatMessage((0, $bWlv0.default).removeTooltip),
            onClick: handleClick,
            padding: "space.0",
            xcss: $0d8083ad70c45c39$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            color: "var(--ds-icon, #44546F)",
            spacing: "compact",
            label: "",
            size: "small"
        })));
};
const $0d8083ad70c45c39$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    display: 'flex',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("bWlv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $90667d3202671c6f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $90667d3202671c6f$var$messages = (0, $7qGN1.defineMessages)({
    removeTooltip: {
        "id": "issue-smart-links-popup-edit-view.smart-link-options-trigger.remove-button.remove-all-tooltip",
        "defaultMessage": "Remove"
    }
});
var $90667d3202671c6f$export$2e2bcd8739ae039 = $90667d3202671c6f$var$messages;

});



parcelRegister("dLVMI", function(module, exports) {
$parcel$export(module.exports, "goalsPopupContentEntryPoint", () => $7628b25b096ee0c0$export$dc38dd29dc6b8559);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7628b25b096ee0c0$export$dc38dd29dc6b8559 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kg2fg")), {
        moduleId: "e7e5e5c1",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kg2fg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bihbw").then(()=>parcelRequire('aH7r4'));

});


parcelRegister("w8hPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $33c1064efeb698b8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $33c1064efeb698b8$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-goals-readview-full.goals.show-more-tooltip",
        "defaultMessage": "See more selected goals"
    }
});
var $33c1064efeb698b8$export$2e2bcd8739ae039 = $33c1064efeb698b8$var$messages;

});

parcelRegister("2jdpt", function(module, exports) {
$parcel$export(module.exports, "generatePlaceholderData", () => $9e440d9012e18f03$export$5d49eb8909604ac1);

var $1QRVx = parcelRequire("1QRVx");
var $2xJv1 = parcelRequire("2xJv1");
const $9e440d9012e18f03$export$5d49eb8909604ac1 = (url, name, status)=>{
    // TODO - Remove name and status checks when cleaning goals_ssr_smart_card (ANIP-459)
    if (!url || !name || !status) return undefined;
    // `atlassian:state` is not typed in SmartLinkResponse, so we needed to forcibly set data to JsonLd.Data.Goal
    const data = {
        '@context': {
            '@vocab': 'https://www.w3.org/ns/activitystreams#',
            atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
            schema: 'http://schema.org/'
        },
        generator: {
            '@type': 'Application',
            '@id': 'https://www.atlassian.com/#TeamCentral',
            name: 'Goals'
        },
        '@type': [
            'Object',
            'atlassian:Goal'
        ],
        url: url,
        // TODO - Review if we can use real icon via React Node usage (ANIP-361)
        icon: {
            '@type': 'Image',
            url: 'data:image/png;base64,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'
        },
        name: name,
        'atlassian:state': {
            '@type': 'Object',
            name: (0, $2xJv1.getGoalStatusLabel)(status).defaultMessage,
            appearance: (0, $1QRVx.getGoalStatusAppearance)(status)
        }
    };
    return {
        meta: {
            auth: [],
            definitionId: 'watermelon-object-provider',
            product: 'townsquare',
            visibility: 'restricted',
            access: 'granted',
            key: 'watermelon-object-provider'
        },
        data: data
    };
};

});
parcelRegister("1QRVx", function(module, exports) {
$parcel$export(module.exports, "getGoalStatusAppearance", () => $cfcdcb252e61ba2c$export$f3c978edf3168c96);

var $7yljC = parcelRequire("7yljC");
const $cfcdcb252e61ba2c$export$f3c978edf3168c96 = (status)=>{
    switch(status){
        case (0, $7yljC.goalStatusValues).ON_TRACK:
            return 'success';
        case (0, $7yljC.goalStatusValues).AT_RISK:
            return 'moved';
        case (0, $7yljC.goalStatusValues).OFF_TRACK:
            return 'removed';
        default:
            return 'default';
    }
};

});
parcelRegister("7yljC", function(module, exports) {
$parcel$export(module.exports, "goalStatusValues", () => $98181fc84d73c663$export$d7b4c6a971e28318);
const $98181fc84d73c663$export$d7b4c6a971e28318 = {
    ON_TRACK: 'ON_TRACK',
    AT_RISK: 'AT_RISK',
    OFF_TRACK: 'OFF_TRACK',
    PENDING: 'PENDING',
    DONE: 'DONE',
    CANCELLED: 'CANCELLED',
    PAUSED: 'PAUSED',
    ARCHIVED: 'ARCHIVED',
    COMPLETED: 'COMPLETED'
};

});


parcelRegister("2xJv1", function(module, exports) {
$parcel$export(module.exports, "getGoalStatusLabel", () => $9bb15c56309bfd49$export$9d87710a33c624b0);

var $gEcrN = parcelRequire("gEcrN");
const $9bb15c56309bfd49$export$9d87710a33c624b0 = (status)=>{
    switch(status){
        case 'ON_TRACK':
            return (0, $gEcrN.messages).ON_TRACK;
        case 'OFF_TRACK':
            return (0, $gEcrN.messages).OFF_TRACK;
        case 'AT_RISK':
            return (0, $gEcrN.messages).AT_RISK;
        case 'PENDING':
            return (0, $gEcrN.messages).PENDING;
        case 'COMPLETED':
        case 'DONE':
            return (0, $gEcrN.messages).COMPLETED;
        case 'CANCELLED':
            return (0, $gEcrN.messages).CANCELLED;
        case 'PAUSED':
            return (0, $gEcrN.messages).PAUSED;
        case 'ARCHIVED':
            return (0, $gEcrN.messages).ARCHIVED;
        default:
            // Fallback to displaying the raw status text if it's unrecognized
            return {
                defaultMessage: status
            };
    }
};

});
parcelRegister("gEcrN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ef9378426989bfd3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");

var $7yljC = parcelRequire("7yljC");
const $ef9378426989bfd3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    [(0, $7yljC.goalStatusValues).ON_TRACK]: {
        id: 'Goals.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    [(0, $7yljC.goalStatusValues).OFF_TRACK]: {
        id: 'Goals.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    [(0, $7yljC.goalStatusValues).AT_RISK]: {
        id: 'Goals.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    [(0, $7yljC.goalStatusValues).PENDING]: {
        id: 'Goals.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    [(0, $7yljC.goalStatusValues).COMPLETED]: {
        id: 'Goals.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    [(0, $7yljC.goalStatusValues).DONE]: {
        id: 'Goals.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    [(0, $7yljC.goalStatusValues).CANCELLED]: {
        id: 'Goals.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    [(0, $7yljC.goalStatusValues).PAUSED]: {
        id: 'Goals.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    },
    [(0, $7yljC.goalStatusValues).ARCHIVED]: {
        id: 'Goals.label.archived',
        defaultMessage: 'Archived',
        description: 'The label for the "archived" goal status'
    }
});

});






parcelRegister("kHiWE", function(module, exports) {
$parcel$export(module.exports, "IssueKeyCell", () => $307c1eca8f25f6fc$export$a6c835c7dffd9abf);

var $ktfGs = parcelRequire("ktfGs");

var $iUKPv = parcelRequire("iUKPv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $bzbsd = parcelRequire("bzbsd");

var $lRq8t = parcelRequire("lRq8t");

var $jCEKQ = parcelRequire("jCEKQ");

var $6XJko = parcelRequire("6XJko");

var $9Mapt = parcelRequire("9Mapt");

var $4cTDP = parcelRequire("4cTDP");

var $jiTA8 = parcelRequire("jiTA8");

var $3OT15 = parcelRequire("3OT15");

var $6bLlX = parcelRequire("6bLlX");

var $deFVD = parcelRequire("deFVD");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");

var $88mo0 = parcelRequire("88mo0");

var $89fzG = parcelRequire("89fzG");

var $bofXS = parcelRequire("bofXS");

var $84lUd = parcelRequire("84lUd");
const $307c1eca8f25f6fc$export$a6c835c7dffd9abf = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRowHoveredOrSelected: isRowHoveredOrSelected, isTruncated: isTruncated, issueRef: issueRef, onIssueLinkSelected: onIssueLinkSelected })=>{
    const intl = (0, $lRq8t.default)();
    const issueKeyData = (0, $j4oe4.useFragment)((0, $iUKPv.default), fieldRef);
    const { text: issueKey } = issueKeyData;
    const fieldsByIdFragment = (0, $j4oe4.useFragment)((0, $ktfGs.default), issueRef || null);
    const isRemoteIssue = fieldsByIdFragment?.isRemoteIssue;
    const webUrl = fieldsByIdFragment?.webUrl;
    let toolTipContent = issueKey || '';
    if (isRemoteIssue && webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) {
        let remoteServerHostname = '';
        try {
            remoteServerHostname = new URL(webUrl).hostname;
        } catch (e) {
        /* empty */ }
        toolTipContent = remoteServerHostname || toolTipContent;
    }
    const issueAriId = fieldsByIdFragment?.id;
    const issueUrl = isRemoteIssue && webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? webUrl : `/browse/${issueKey}`;
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    let showCopyIssueLink = false;
    if ((0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key')) showCopyIssueLink = !!isRowHoveredOrSelected;
    const tableCellLinkRef = (0, $eJOHy.useRef)(null);
    let isMergedColumnVisible = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(issueKeyData.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: issueKey
    });
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    let shouldShowIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        return false;
    }, []);
    let openIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
    /* empty */ }, []);
    if ((0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const shouldShowIssueInIframePreviewPanel = (0, $deFVD.useShouldShowIframeIssuePreviewPanel)();
        shouldShowIframePreviewPanel = shouldShowIssueInIframePreviewPanel;
    }
    if (shouldShowIframePreviewPanel()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { openPreviewPanel: openPreviewPanel } = (0, $6bLlX.useGlobalObjectPreviewPanels)();
        openIframePreviewPanel = openPreviewPanel;
    }
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        if (isRemoteIssue && webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) return;
        if (shouldShowIframePreviewPanel()) {
            e.preventDefault();
            openIframePreviewPanel({
                ari: issueAriId || '',
                url: issueUrl,
                name: 'jira-issue'
            });
            return;
        }
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && issueKey && onIssueLinkSelected(issueKey);
        if (handled) e.preventDefault();
    }, [
        isRemoteIssue,
        webUrl,
        shouldShowIframePreviewPanel,
        isEmbedMode,
        onIssueLinkSelected,
        issueKey,
        openIframePreviewPanel,
        issueAriId,
        issueUrl
    ]);
    const issueKeyWithHoverPopover = (0, $eJOHy.useCallback)(({ content: content, link: link })=>{
        if ((0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) return link(hoverPopoverRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: content,
            contentRef: tableCellLinkRef
        }, ({ ref: ref })=>link(ref));
    }, [
        hoverPopoverRef,
        tableCellLinkRef
    ]);
    if (!issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueKey",
        reason: "Missing required fields"
    });
    const issueStrikeThroughProps = {};
    const statusField = fieldsByIdFragment?.statusField?.status;
    const statusCategoryId = statusField?.statusCategory?.statusCategoryId;
    const isResolved = fieldsByIdFragment?.isResolved ?? undefined;
    const isIssueResolved = (0, $jCEKQ.shouldDisplayStrikethrough)(isResolved, (0, $jx0Vw.statusCategoryForId)(statusCategoryId));
    issueStrikeThroughProps.shouldDisplayStrikethrough = isIssueResolved;
    issueStrikeThroughProps['aria-label'] = intl.formatMessage((0, $84lUd.default).issueKeyWithResolution, {
        issueKey: issueKey,
        isResolved: isIssueResolved
    });
    const getWrapperStyles = ()=>{
        if (isDensityFull) return (0, $6XJko.isVisualRefreshEnabled)() ? $307c1eca8f25f6fc$var$wrapperStylesFull : $307c1eca8f25f6fc$var$wrapperStylesFullOld;
        return (0, $6XJko.isVisualRefreshEnabled)() ? $307c1eca8f25f6fc$var$wrapperStylesCompact : $307c1eca8f25f6fc$var$wrapperStylesCompactOld;
    };
    if (isInlineEditingExtendedFieldSupportEnabled) {
        const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellLink), {
                ...issueStrikeThroughProps,
                href: issueUrl,
                isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
                onClick: onClick,
                ref: (0, $bzbsd.mergeRefs)(tableCellLinkRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell"
            }, issueKey);
        const issueKeyLinkWithWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
            "data-vc": "native-issue-table-ui-issue-key-cell",
            xcss: [
                isMergedColumnVisible && isTruncated && $307c1eca8f25f6fc$var$overflowHiddenStyles
            ]
        }, isSingleLineRowHeightEnabled ? issueKeyWithHoverPopover({
            content: toolTipContent,
            link: issueKeyLink
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: toolTipContent
        }, issueKeyLink()));
        return (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89fzG.ActionContainer), null, issueKeyLinkWithWrapper, showCopyIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bofXS.CopyIssueLink), {
            issueKey: issueKey
        })) : issueKeyLinkWithWrapper;
    }
    const issueKeyLink = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellDiscreteLink), {
            href: issueUrl,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-key.issue-key-cell",
            ...issueStrikeThroughProps,
            isSubtle: true,
            ref: (0, $bzbsd.mergeRefs)(tableCellLinkRef, ref),
            onClick: onClick
        }, issueKey);
    const issueKeyLinkWithWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: isMergedColumnVisible ? 'space.050' : 'space.100',
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            getWrapperStyles(),
            isSingleLineRowHeightEnabled && $307c1eca8f25f6fc$var$singleLineRowHeightStyles,
            isMergedColumnVisible && !isTruncated && $307c1eca8f25f6fc$var$overflowVisibleStyles
        ],
        "data-vc": "native-issue-table-ui-issue-key-cell"
    }, isSingleLineRowHeightEnabled ? issueKeyWithHoverPopover({
        content: toolTipContent,
        link: issueKeyLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: toolTipContent
    }, issueKeyLink()));
    return (0, $4cTDP.fg)('jsc-2733-copy_link_from_issue_key') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89fzG.ActionContainer), null, issueKeyLinkWithWrapper, showCopyIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bofXS.CopyIssueLink), {
        issueKey: issueKey
    })) : issueKeyLinkWithWrapper;
});
const $307c1eca8f25f6fc$var$singleLineRowHeightStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis'
});
const $307c1eca8f25f6fc$var$wrapperStylesCompactOld = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $307c1eca8f25f6fc$var$wrapperStylesCompact = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $307c1eca8f25f6fc$var$wrapperStylesFullOld = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $307c1eca8f25f6fc$var$wrapperStylesFull = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    maxWidth: '100%'
});
const $307c1eca8f25f6fc$var$overflowVisibleStyles = (0, $1DXK0.xcss)({
    overflow: 'visible'
});
const $307c1eca8f25f6fc$var$overflowHiddenStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("ktfGs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9df556d82cff303$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfbdab2f00717e1d38ac2f235d1e87ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9df556d82cff303$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueKeyCell_fields",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "isResolved"
        },
        {
            "concreteType": "JiraStatusField",
            "kind": "LinkedField",
            "name": "statusField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCategoryId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isRemoteLinkedIssuesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRemoteIssue"
                },
                {
                    "kind": "ScalarField",
                    "name": "webUrl"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$f9df556d82cff303$var$node.hash = "a1753ba360213f4a7ae012c6019ee10d";
var $f9df556d82cff303$export$2e2bcd8739ae039 = $f9df556d82cff303$var$node;

});

parcelRegister("iUKPv", function(module, exports) {
$parcel$export(module.exports, "default", () => $cca52927e38c8589$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ed19731780bdad3d52e95d62b84f1a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cca52927e38c8589$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueKeyCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$cca52927e38c8589$var$node.hash = "da780fe572d68360177cd1d738e295b6";
var $cca52927e38c8589$export$2e2bcd8739ae039 = $cca52927e38c8589$var$node;

});

parcelRegister("jCEKQ", function(module, exports) {
$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $71a3d2c694c5502c$export$1e1e848245d3a6f7);

var $jx0Vw = parcelRequire("jx0Vw");
const { DONE: $71a3d2c694c5502c$var$DONE } = (0, $jx0Vw);
const $71a3d2c694c5502c$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $71a3d2c694c5502c$var$DONE;
};

});

parcelRegister("deFVD", function(module, exports) {
$parcel$export(module.exports, "useGetIssueAriId", () => $7dab99ed1e58ce52$export$3d3ea5770fee9878);
$parcel$export(module.exports, "useShouldShowIframeIssuePreviewPanel", () => $7dab99ed1e58ce52$export$ad255876e5b7c30a);
$parcel$export(module.exports, "useShouldShowNativeIssuePreviewPanel", () => $7dab99ed1e58ce52$export$b0fbfff1091392b6);
$parcel$export(module.exports, "useOpenNativeIssuePreviewPanel", () => $7dab99ed1e58ce52$export$1ca477344eac8cb1);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $fLy7J = parcelRequire("fLy7J");

var $6bLlX = parcelRequire("6bLlX");

var $FhXEJ = parcelRequire("FhXEJ");

var $eWzpp = parcelRequire("eWzpp");

var $cHtIB = parcelRequire("cHtIB");

var $8oKDI = parcelRequire("8oKDI");

var $kfvK2 = parcelRequire("kfvK2");
var $95O7y = parcelRequire("95O7y");
const $7dab99ed1e58ce52$export$2e131fc4108f9106 = (0, $kfvK2.createRouterSelector)(({ route: route })=>{
    return route?.name === 'issue';
});
const $7dab99ed1e58ce52$export$3d3ea5770fee9878 = (issueId)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueAriId = (0, $eJOHy.useMemo)(()=>{
        if (!issueId || !cloudId) return '';
        return (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId
        });
    }, [
        issueId,
        cloudId
    ]);
    return issueAriId;
};
const $7dab99ed1e58ce52$export$ad255876e5b7c30a = ()=>{
    const isFullPageIssueView = $7dab99ed1e58ce52$export$2e131fc4108f9106();
    const isPreviewPanelContextAvailable = !!(0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    const shouldShowIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        const isIssueEmbedPreviewPanel = (0, $fLy7J.isIssueEmbedPreviewPanelOpen)();
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel') && isPreviewPanelContextAvailable && ((0, $4cTDP.fg)('jsm_enable_preview_panel') || !isJSMOrJPDProject)) return isFullPageIssueView && (0, $4cTDP.fg)('gpp_child_linked_full_page_issue_view') || isIssueEmbedPreviewPanel;
        return false;
    }, [
        isPreviewPanelContextAvailable,
        isJSMOrJPDProject,
        isFullPageIssueView
    ]);
    return shouldShowIframePreviewPanel;
};
const $7dab99ed1e58ce52$export$b0fbfff1091392b6 = ()=>{
    const isPreviewPanelContextAvailable = !!(0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    const isIssueNativePreviewPanel = (0, $fLy7J.useIsNativeIssueViewPreviewPanel)();
    const shouldShowNativeIssuePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel') && isPreviewPanelContextAvailable && ((0, $4cTDP.fg)('jsm_enable_preview_panel') || !isJSMOrJPDProject)) return isIssueNativePreviewPanel;
        return false;
    }, [
        isPreviewPanelContextAvailable,
        isJSMOrJPDProject,
        isIssueNativePreviewPanel
    ]);
    return shouldShowNativeIssuePreviewPanel;
};
const $7dab99ed1e58ce52$export$1ca477344eac8cb1 = ()=>{
    const [, setSelectedIssue] = (0, $95O7y.useQueryParam)('selectedIssue');
    const openNativeIssuePreviewPanel = (0, $eJOHy.useCallback)((issueKey)=>{
        if (!issueKey) return;
        setSelectedIssue(issueKey);
    }, [
        setSelectedIssue
    ]);
    return openNativeIssuePreviewPanel;
};

});
parcelRegister("fLy7J", function(module, exports) {
$parcel$export(module.exports, "useIsIssuePreviewPanelOpen", () => $b587122c15ef9343$export$39416963f8c85a8a);
$parcel$export(module.exports, "isIssueEmbedPreviewPanelOpen", () => $b587122c15ef9343$export$b0a8938f24ab6382);
$parcel$export(module.exports, "useIsNativeIssueViewPreviewPanel", () => $b587122c15ef9343$export$cf8b981318c31dcc);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $jZ41J = parcelRequire("jZ41J");

var $6bLlX = parcelRequire("6bLlX");
const $b587122c15ef9343$export$39416963f8c85a8a = ()=>{
    const panel = (0, $jZ41J.useCurrentPreviewPanel)();
    return panel !== null && panel.type === 'jira-issue';
};
// Helper function to detect if we're in an iframe
const $b587122c15ef9343$var$isInIframe = ()=>{
    (0, $gRw8I.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $b587122c15ef9343$export$b0a8938f24ab6382 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $b587122c15ef9343$var$isInIframe() && window.location.search.includes('previewPanels');
};
const $b587122c15ef9343$export$521182cda3e1f453 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    return !!context;
};
const $b587122c15ef9343$export$cf8b981318c31dcc = ()=>{
    const panel = (0, $jZ41J.useCurrentPreviewPanel)();
    return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};

});


parcelRegister("88mo0", function(module, exports) {
$parcel$export(module.exports, "TableCellDiscreteLink", () => $89c9752ede73cfdb$export$4e03936e0e9409e2);
$parcel$export(module.exports, "TableCellLink", () => $89c9752ede73cfdb$export$fce640eb3bd348ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");

var $34oCh = parcelRequire("34oCh");
const $89c9752ede73cfdb$export$4e03936e0e9409e2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'tableIssueLink');
        onClick && onClick(e);
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89c9752ede73cfdb$var$StyledLink, {
        ...rest,
        onClick: onClickWithAnalytics,
        ref: ref,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    });
});
const $89c9752ede73cfdb$export$fce640eb3bd348ea = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-label': ariaLabel, children: children, href: href, isTruncated: isTruncated, onClick: onClick, shouldDisplayStrikethrough: shouldDisplayStrikethrough, testId: testId }, ref)=>{
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick && onClick(e);
    }, [
        onClick
    ]);
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        "aria-label": ariaLabel,
        href: href,
        onClick: onClickWithAnalytics,
        ref: ref,
        testId: testId,
        xcss: [
            $89c9752ede73cfdb$var$linkDefaultStyles,
            isTruncated && $89c9752ede73cfdb$var$linkTruncatedStyles,
            shouldDisplayStrikethrough && $89c9752ede73cfdb$var$linkStrikethroughStyles
        ],
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});
// Fix for Compiled bug where invalid props are passed on to the underlying DOM element when using inheritance.
const $89c9752ede73cfdb$var$PropFilteredLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ innerFocusOutline: innerFocusOutline, shouldDisplayStrikethrough: shouldDisplayStrikethrough, isSubtle: isSubtle, ...rest }, ref)=>// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ...rest,
        ref: ref
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89c9752ede73cfdb$var$StyledLinkOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $89c9752ede73cfdb$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $89c9752ede73cfdb$var$StyledLinkNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $89c9752ede73cfdb$var$PropFilteredLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.isSubtle ? "_syaz1gjq" : "_syaz1fxt",
            __cmplp.innerFocusOutline && "_1ah31i6y",
            __cmplp.shouldDisplayStrikethrough && "_4bfu18uv _1hms1911 _ajmmnqa1",
            __cmplp.isSingleLineRowHeightEnabled && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $89c9752ede73cfdb$var$linkDefaultStyles = (0, $1DXK0.xcss)({
    cursor: 'pointer',
    display: 'block',
    font: 'font.body',
    overflow: 'hidden',
    textDecoration: 'underline',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $89c9752ede73cfdb$var$linkTruncatedStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap'
});
const $89c9752ede73cfdb$var$linkStrikethroughStyles = (0, $1DXK0.xcss)({
    textDecoration: 'line-through',
    ':hover': {
        textDecoration: 'line-through'
    }
});
const $89c9752ede73cfdb$var$StyledLink = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $89c9752ede73cfdb$var$StyledLinkNew, $89c9752ede73cfdb$var$StyledLinkOld);

});

parcelRegister("89fzG", function(module, exports) {
$parcel$export(module.exports, "ActionContainer", () => $35c61a9c86e8e23b$export$37ab3bdebc286ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $35c61a9c86e8e23b$export$37ab3bdebc286ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.common.ui.issue-cells.issue-key.action-container",
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _bp4dglyw _7iw51txw _1yzlt94y _s1241txw _fx2mt94y"
        ])
    }, children);
};
const $35c61a9c86e8e23b$var$containerStyles = null;

});

parcelRegister("bofXS", function(module, exports) {
$parcel$export(module.exports, "CopyIssueLink", () => $bdb8672f6634ddb7$export$8ac20de618d64f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $Ay1uj = parcelRequire("Ay1uj");

var $cV8sz = parcelRequire("cV8sz");

var $3wl9L = parcelRequire("3wl9L");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $8jOO7 = parcelRequire("8jOO7");

var $eRxrG = parcelRequire("eRxrG");
const $bdb8672f6634ddb7$export$3fee15f76e8cacc7 = 3000;
const $bdb8672f6634ddb7$export$8ac20de618d64f5 = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isCopied, setCopied] = (0, $eJOHy.useState)(false);
    const handleCopy = async (e, analyticsEvent)=>{
        e.preventDefault();
        e.stopPropagation();
        const url = typeof window !== 'undefined' ? `${window.location.origin}/browse/${issueKey}` : '';
        try {
            await globalThis.navigator.clipboard.writeText(url);
            setCopied(true);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableCopyIssueLink');
        } catch (error) {
            setCopied(false);
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'copyIssueLink',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                }
            });
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        const copyTimer = isCopied ? setTimeout(()=>setCopied(false), $bdb8672f6634ddb7$export$3fee15f76e8cacc7) : undefined;
        return ()=>copyTimer && clearTimeout(copyTimer);
    }, [
        isCopied
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c18j6 _tzy4pcxq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false,
        onClick: handleCopy,
        label: formatMessage(isCopied ? (0, $eRxrG.default).copied : (0, $eRxrG.default).copy),
        icon: (iconProps)=>isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
                ...iconProps,
                size: "small",
                color: "var(--ds-icon-success, #22A06B)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                ...iconProps,
                size: "small"
            })
    }));
};
const $bdb8672f6634ddb7$var$wrapperStyles = null;

});
parcelRegister("eRxrG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a8715e060277f5f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6a8715e060277f5f$var$messages = (0, $7qGN1.defineMessages)({
    copy: {
        "id": "native-issue-table.common.issue-cells.issue-key.copy-issue-link.copy",
        "defaultMessage": "Copy link"
    },
    copied: {
        "id": "native-issue-table.common.issue-cells.issue-key.copy-issue-link.copied",
        "defaultMessage": "Copied"
    }
});
var $6a8715e060277f5f$export$2e2bcd8739ae039 = $6a8715e060277f5f$var$messages;

});


parcelRegister("84lUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f69130195f8c718$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5f69130195f8c718$var$messages = (0, $7qGN1.defineMessages)({
    issueKeyWithResolution: {
        "id": "native-issue-table.common.issue-cells.issue-key.issue-key-with-resolution",
        "defaultMessage": "{issueKey} is {isResolved, select, \n            true {resolved}\n            false {not resolved}\n            other {}\n        }"
    }
});
var $5f69130195f8c718$export$2e2bcd8739ae039 = $5f69130195f8c718$var$messages;

});


parcelRegister("2Oa4s", function(module, exports) {
$parcel$export(module.exports, "IssueLinksCell", () => $9fbe8ab73e77d900$export$75aa2ccc20dd7954);

var $1mF9A = parcelRequire("1mF9A");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $8lb7o = parcelRequire("8lb7o");

var $1tX0c = parcelRequire("1tX0c");

var $cHtIB = parcelRequire("cHtIB");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $5O293 = parcelRequire("5O293");

var $kwfkD = parcelRequire("kwfkD");
const $9fbe8ab73e77d900$export$75aa2ccc20dd7954 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, issueKey: issueKey, accordionInitialIsOpen: accordionInitialIsOpen = false, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $1mF9A.default), fieldRef);
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        issueKey,
        cloudId
    ]);
    const issueLinks = data?.issueLinkConnection?.edges;
    const totalCount = data?.issueLinkConnection?.totalCount;
    const filteredIssueLinks = (0, $eJOHy.useMemo)(()=>issueLinks?.map((edge)=>edge?.node?.issue?.key != null ? {
                key: edge.node.issue?.key || 'missingId',
                name: edge.node.issue?.key,
                href: edge.node.issue?.webUrl || '',
                relationName: edge.node.relationName,
                shouldDisplayStrikethrough: (0, $4cTDP.fg)('nin-strikethrough-resolution-update') ? edge.node.issue?.isResolved === true : edge.node.issue?.fieldsById?.edges?.[0]?.node?.statusCategory?.statusCategoryId === '3' || false
            } : null).filter(Boolean) ?? [], [
        issueLinks
    ]);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            issueSearchBaseUrl: issueSearchBaseUrl,
            accordionInitialIsOpen: accordionInitialIsOpen
        }), [
        issueKey,
        issueSearchBaseUrl,
        accordionInitialIsOpen
    ]);
    if (!issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing issue links field"
    });
    if (issueLinks.length !== filteredIssueLinks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing fields on issue links"
    });
    if (totalCount === undefined || totalCount === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Missing total count"
    });
    if (totalCount < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Invalid total count"
    });
    if (totalCount > 0 && filteredIssueLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "issueLinks",
        reason: "Total count valid but no issue links given"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        entryPoint: (0, $5O293.issueLinksPopUpContentEntryPoint),
        entryPointParams: entryPointParams,
        entryPointRuntimeProps: runtimeProps,
        totalItems: Math.min(totalCount, 1000),
        ItemComponent: totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tX0c.TagItem), {
            name: filteredIssueLinks[0].name,
            href: filteredIssueLinks[0].href,
            shouldDisplayStrikethrough: filteredIssueLinks[0].shouldDisplayStrikethrough,
            key: filteredIssueLinks[0].key,
            isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
            isOnlyOneItem: totalCount === 1
        }) : undefined,
        showMoreTooltip: formatMessage((0, $kwfkD.default).triggerButton),
        actionSubjectIdPrefix: "issueLinks",
        isTruncated: isSingleLineRowHeightEnabled
    }));
});

});
parcelRegister("1mF9A", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8789746bcd38487$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edee2d7a833365702ebf47b935d8763e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c8789746bcd38487$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "IssueLinksCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "JiraIssueLinkConnection",
            "kind": "LinkedField",
            "name": "issueLinkConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                {
                    "concreteType": "JiraIssueLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                        "statusCategory"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "relationName"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "issueLinkConnection(first:1)"
        }
    ],
    "type": "JiraIssueLinkField"
};
$c8789746bcd38487$var$node.hash = "6f8544377bd3253e00a7282eb15fe7f9";
var $c8789746bcd38487$export$2e2bcd8739ae039 = $c8789746bcd38487$var$node;

});

parcelRegister("5O293", function(module, exports) {
$parcel$export(module.exports, "issueLinksPopUpContentEntryPoint", () => $e0267059e9a46e26$export$94cbcdadb553c314);

var $c4v0s = parcelRequire("c4v0s");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

const $e0267059e9a46e26$export$94cbcdadb553c314 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("d3bw0")), {
        moduleId: "a490a919",
        moduleName: "IssueLinksPopUpContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, cloudId: cloudId })=>({
            queries: {
                links: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $c4v0s.default,
                    variables: {
                        issueKey: issueKey,
                        cloudId: cloudId,
                        isNinStrikethroughResolutionUpdateEnabled: (0, $4cTDP.fg)('nin-strikethrough-resolution-update')
                    }
                }
            }
        })
});

});
parcelRegister("c4v0s", function(module, exports) {
$parcel$export(module.exports, "default", () => $13098bf84348d516$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40103709839894f4f600f4230241eb3f>>
 * @relayHash 47462afc0ebf26ecf33671324e3c8ebe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15ef48ce3d4b994e09c46825fbb643f76a3bce05b8e6f2d677841b8d309fe9bb
const $13098bf84348d516$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15ef48ce3d4b994e09c46825fbb643f76a3bce05b8e6f2d677841b8d309fe9bb",
        "metadata": {},
        "name": "IssueLinksPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $13098bf84348d516$export$2e2bcd8739ae039 = $13098bf84348d516$var$node;

});

parcelRegister("d3bw0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2DJ8B").then(()=>parcelRequire('a8JgW'));

});


parcelRegister("kwfkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6704bed28e4bf44$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a6704bed28e4bf44$var$messages = (0, $7qGN1.defineMessages)({
    triggerButton: {
        "id": "native-issue-table.common.issue-cells.issue-links.trigger-button",
        "defaultMessage": "See more"
    },
    showMoreLink: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link",
        "defaultMessage": "Go to all linked issues"
    },
    showMoreLinkIssueTermRefresh: {
        "id": "native-issue-table.common.issue-cells.issue-links.show-more-link-issue-term-refresh",
        "defaultMessage": "Go to all linked work items"
    }
});
var $a6704bed28e4bf44$export$2e2bcd8739ae039 = $a6704bed28e4bf44$var$messages;

});


parcelRegister("dBL3m", function(module, exports) {
$parcel$export(module.exports, "IssueOperations", () => $a53c21bf66ddff69$export$125bc3f55de1b4bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");


const $a53c21bf66ddff69$var$BaseIssueOperations = (parcelRequire("4rVHQ")).default;
const $a53c21bf66ddff69$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-cell-issue-operations",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $a53c21bf66ddff69$export$125bc3f55de1b4bd = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, issueId: issueId, workType: workType, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete, isCreateSubTaskAllowed: isCreateSubTaskAllowed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a53c21bf66ddff69$var$BaseIssueOperations, {
        issueId: issueId,
        issueKey: issueKey,
        workType: workType,
        isCreateSubTaskAllowed: isCreateSubTaskAllowed,
        onIssueRefetch: onIssueRefetch,
        onIssueDelete: onIssueDelete
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a53c21bf66ddff69$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _bfhk1w7a _1bsb1ns9 _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4rVHQ", function(module, exports) {


module.exports = (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
    return parcelRequire('lWS5G');
}, function() {
    return parcelRequire('3NFLp');
}, {
    l: (parcelRequire("bbrhz")),
    i: [
        "gD3cg",
        "e01ok"
    ]
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});


parcelRegister("bbrhz", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});



parcelRegister("5eN53", function(module, exports) {
$parcel$export(module.exports, "IssueStatusCategoryCell", () => $34f57cfe240d8d06$export$663286ccb241374c);

var $jRqh7 = parcelRequire("jRqh7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $hRhIm = parcelRequire("hRhIm");

var $3OT15 = parcelRequire("3OT15");

var $4cTDP = parcelRequire("4cTDP");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $34f57cfe240d8d06$export$663286ccb241374c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $jRqh7.default), fieldRef);
    const { statusCategory: statusCategory } = data;
    const { name: name } = statusCategory;
    const statusCategoryId = parseInt(statusCategory.statusCategoryId, 10);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: statusCategory.name
    });
    if (Number.isNaN(statusCategoryId) || statusCategoryId === -1 || !name?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "statusCategory",
        reason: "Missing required fields"
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $34f57cfe240d8d06$var$alignmentFixStyles : $34f57cfe240d8d06$var$alignmentFixStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $34f57cfe240d8d06$var$alignmentFixStyles : $34f57cfe240d8d06$var$alignmentFixStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: {
            id: '',
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        },
        contentRef: hoverPopoverRef
    }));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $34f57cfe240d8d06$var$alignmentFixStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'space.negative.025'
});
const $34f57cfe240d8d06$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    marginInlineStart: 'space.negative.025'
});

});
parcelRegister("jRqh7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a250e76b366867d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9616e526ed63460518841a4209c90070>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8a250e76b366867d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueStatusCategoryCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                }
            ]
        }
    ],
    "type": "JiraStatusCategoryField"
};
$8a250e76b366867d$var$node.hash = "572521b74cb1e5c0d987e2f909d90e33";
var $8a250e76b366867d$export$2e2bcd8739ae039 = $8a250e76b366867d$var$node;

});

parcelRegister("hRhIm", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", () => $7b782d104096cf08$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $7b782d104096cf08$export$9f5070a985b0679b);

var $eJOHy = parcelRequire("eJOHy");

var $6UBwj = parcelRequire("6UBwj");
const $7b782d104096cf08$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $7b782d104096cf08$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("6UBwj", function(module, exports) {
$parcel$export(module.exports, "TEST_ID_PREFIX", () => $517c92a4e3fff9f6$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $517c92a4e3fff9f6$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $abjs4 = parcelRequire("abjs4");

var $fL0In = parcelRequire("fL0In");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $2zOdI = parcelRequire("2zOdI");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $fWpUz = parcelRequire("fWpUz");

var $jAZ6b = parcelRequire("jAZ6b");
const $517c92a4e3fff9f6$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $517c92a4e3fff9f6$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $517c92a4e3fff9f6$var$StatusLozengeNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $517c92a4e3fff9f6$var$hoverOverlayStyles
    })));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $517c92a4e3fff9f6$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $517c92a4e3fff9f6$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    })));
const $517c92a4e3fff9f6$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, name)));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `${"var(--ds-border-width-selected, 2px)"} solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: "var(--ds-radius-small, 4px)",
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$StatusLozengeNew, $517c92a4e3fff9f6$var$StatusLozengeOld);
const $517c92a4e3fff9f6$export$69ea4907eefa8e7b = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$WrappedStatusLozengeNew, $517c92a4e3fff9f6$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozenge = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $2zOdI.disabledColor).text : !(0, $6XJko.isVisualRefreshEnabled)() ? (0, $2zOdI.textColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $2zOdI.textColorOld)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $2zOdI.disabledColor).text : (0, $2zOdI.textHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $cdbP5.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StatusContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $517c92a4e3fff9f6$var$pressableStyles = (0, $1DXK0.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: 'radius.small',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $517c92a4e3fff9f6$var$hoverOverlayStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: 'radius.small',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("2zOdI", function(module, exports) {
$parcel$export(module.exports, "statusCategoryToThemeMap", () => $576836415c331af3$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $576836415c331af3$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $576836415c331af3$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $576836415c331af3$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $576836415c331af3$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $576836415c331af3$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $576836415c331af3$export$b70f10fc4a6ba453);
const $576836415c331af3$export$61137dce61763ec3 = 'default';
const $576836415c331af3$export$132676d06d92ad48 = 'success';
const $576836415c331af3$export$5c1f3b72419aa125 = 'inprogress';
const $576836415c331af3$export$d9e35f42afe1e488 = {
    '1': $576836415c331af3$export$61137dce61763ec3,
    '2': $576836415c331af3$export$61137dce61763ec3,
    '3': $576836415c331af3$export$132676d06d92ad48,
    '4': $576836415c331af3$export$5c1f3b72419aa125
};
const $576836415c331af3$export$7dcbec377a25efc6 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $576836415c331af3$export$32f78bffcd82ff28 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$26ac04004fa4ead4 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$69fdf3ba928b4c77 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $576836415c331af3$export$99ec0cf2cf1b2082 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("fWpUz", function(module, exports) {
$parcel$export(module.exports, "Lozenge", () => $b5ac3d09b389e3b4$export$a31cbe1bf5463979);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $2zOdI = parcelRequire("2zOdI");

const $b5ac3d09b389e3b4$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $2zOdI.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $2zOdI.disabledColor).text,
                backgroundColor: (0, $2zOdI.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("jAZ6b", function(module, exports) {
$parcel$export(module.exports, "LozengeOld", () => $6750667a552dd8b6$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $eJOHy = parcelRequire("eJOHy");
const $6750667a552dd8b6$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $6750667a552dd8b6$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $6750667a552dd8b6$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$contentStyles
    }, children));
$6750667a552dd8b6$export$26089816624d22fc.displayName = 'Lozenge';

});




parcelRegister("aa1Tw", function(module, exports) {
$parcel$export(module.exports, "IssueStatusCell", () => $e390628a0a08524c$export$58e0df5bb69dbb83);

var $dKO5q = parcelRequire("dKO5q");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $1jVV7 = parcelRequire("1jVV7");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6BnaS = parcelRequire("6BnaS");

var $hRhIm = parcelRequire("hRhIm");

var $kRgKj = parcelRequire("kRgKj");

var $2QZBX = parcelRequire("2QZBX");

var $9Mapt = parcelRequire("9Mapt");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $1jdzZ = parcelRequire("1jdzZ");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");

var $jT7JX = parcelRequire("jT7JX");

var $P01So = parcelRequire("P01So");

var $7Gpga = parcelRequire("7Gpga");
const $e390628a0a08524c$export$58e0df5bb69dbb83 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKeyProp, issueId: issueId, onUpdateCache: onUpdateCacheProp, recordId: recordId, itemsConnectionId: itemsConnectionId, groupConnectionId: groupConnectionId, isColumnSticky: isColumnSticky })=>{
    let handleStatusUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('jsc_list_hide_done_items') && (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    handleStatusUpdate = (0, $jT7JX.useHideDoneItems)({
        itemsConnectionId: itemsConnectionId,
        recordId: recordId,
        projectKey: issueKeyProp && (0, $P01So.getProjectKeyFromIssueKey)(issueKeyProp),
        groupConnectionId: groupConnectionId
    });
    const handleUpdateCache = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jsc_list_hide_done_items') && (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((issueKey, fieldName, field)=>{
        onUpdateCacheProp?.(issueKey, fieldName, field);
        handleStatusUpdate(field);
    }, [
        handleStatusUpdate,
        onUpdateCacheProp
    ]) : onUpdateCacheProp;
    const data = (0, $j4oe4.useFragment)((0, $dKO5q.default), fieldRef);
    const { status: status } = data;
    const [value, setValue] = (0, $eJOHy.useState)(status);
    const [isEditing, setIsEditing] = (0, $eJOHy.useState)(false);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const contentRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        setValue(status);
    }, [
        status
    ]);
    const onSubmit = (0, $eJOHy.useCallback)((oldValue, newValue, meta, event)=>{
        // Mirrors the updated event fired from the issue view (with the addition of `isInlineEditing: true`) to
        // be used for core action tracking as defined in https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/3767029088/Monthly+Core+User+MCU+Definition
        (0, $kRgKj.fireTrackAnalytics)(event, 'issueStatus updated', {
            oldValId: oldValue.id,
            oldStatusCategoryId: oldValue.statusCategory.id,
            newValId: newValue.id,
            newStatusCategoryId: newValue.statusCategory.id,
            hasScreen: meta.transition.hasScreen,
            isConditional: meta.transition.isConditional,
            isInlineEditing: true
        });
    }, []);
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const modifiersFromContext = (0, $1jdzZ.useEditViewPopupModifiersContext)();
    const popperProps = (0, $eJOHy.useMemo)(()=>{
        const hasBasicFrozenColumns = // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix');
        const isStickyColumn = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && isColumnSticky;
        if (isStickyColumn && hasBasicFrozenColumns) return {
            modifiers: [
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ],
            strategy: 'absolute',
            innerRef: (element)=>{
                if (element) // setting the zIndex to ensure the dropdown is not on top of the workflow modal
                // eslint-disable-next-line no-param-reassign
                element.style.zIndex = String((0, $1jVV7.layers).modal - 1);
            }
        };
        return hasBasicFrozenColumns ? {
            modifiers: modifiersFromContext
        } : undefined;
    }, [
        modifiersFromContext,
        isColumnSticky
    ]);
    if (value?.statusCategory?.statusCategoryId === undefined || !value?.name?.length || !value?.statusId?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "status",
        reason: "Missing required fields"
    });
    const onSuccess = (newStatus)=>{
        const transformedStatus = (0, $7Gpga.toJiraStatusField)(newStatus);
        setValue(transformedStatus);
        handleUpdateCache && handleUpdateCache(issueKeyProp, 'status', transformedStatus);
    };
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: (0, $7Gpga.toStatusValue)(value).name
    });
    // If the property does not exist in fragment data then we know it has been conditionally excluded because
    // inline editing is disabled. In future this should follow the same design/deferred loading strategy of
    // other inline editable fields, however this would require a larger effort to decompose the status field.
    const isEditable = data && typeof data.id === 'string';
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $e390628a0a08524c$var$alignmentFixStyles : $e390628a0a08524c$var$alignmentFixStylesOld,
        "data-vc": "native-issue-table-ui-issue-status-box"
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
        issueKey: (0, $2QZBX.toIssueKey)(issueKeyProp),
        issueId: issueId && (0, $2QZBX.toIssueId)(issueId),
        appearance: "lozenge",
        value: (0, $7Gpga.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: (0, $7Gpga.toStatusValue)(value)
    }));
    return hoverPopoverRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $e390628a0a08524c$var$alignmentFixStyles : $e390628a0a08524c$var$alignmentFixStylesOld,
        "data-vc": "native-issue-table-ui-issue-status-box",
        ref: isEditing ? ()=>hoverPopoverRef(null) : hoverPopoverRef
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
        popperProps: popperProps,
        issueKey: (0, $2QZBX.toIssueKey)(issueKeyProp),
        issueId: issueId && (0, $2QZBX.toIssueId)(issueId),
        appearance: "lozenge",
        value: (0, $7Gpga.toStatusValue)(value),
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onEditStart: ()=>setIsEditing(true),
        onEditCancel: ()=>setIsEditing(false),
        ...(0, $4cTDP.fg)('nin-grid-keyboard-navigation') ? {
            shouldCaptureEscape: false
        } : {}
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: (0, $7Gpga.toStatusValue)(value)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: (0, $7Gpga.toStatusValue)(value).name,
        contentRef: contentRef,
        hidePopover: isEditing
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $e390628a0a08524c$var$alignmentFixStyles : $e390628a0a08524c$var$alignmentFixStylesOld,
            "data-vc": "native-issue-table-ui-issue-status-box",
            ref: ref
        }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.AsyncIssueStatusField), {
            issueKey: (0, $2QZBX.toIssueKey)(issueKeyProp),
            issueId: issueId && (0, $2QZBX.toIssueId)(issueId),
            appearance: "lozenge",
            value: (0, $7Gpga.toStatusValue)(value),
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            statusButtonRef: contentRef,
            onEditStart: ()=>setIsEditing(true),
            onEditCancel: ()=>setIsEditing(false),
            ...(0, $4cTDP.fg)('nin-grid-keyboard-navigation') ? {
                shouldCaptureEscape: false
            } : {}
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
            value: (0, $7Gpga.toStatusValue)(value)
        })));
});
// Status lozenges have a 2px invisible border around them to keep them in the same place if they enter an "error" state (where a border colour is added).
// Refer to: src/packages/issue/fields/status/src/common/ui/status-lozenge/main.tsx
const $e390628a0a08524c$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    marginInlineStart: 'space.negative.025'
});
const $e390628a0a08524c$var$alignmentFixStylesOld = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'space.negative.025'
});

});
parcelRegister("dKO5q", function(module, exports) {
$parcel$export(module.exports, "default", () => $b782203320e87b8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92c5d77b9fb3628068374d2bcf387330>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b782203320e87b8b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueStatusCell",
    "selections": [
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "concreteType": "JiraStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusId"
                },
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraStatusField"
};
$b782203320e87b8b$var$node.hash = "437005b12e4b057a438ab749ffd12538";
var $b782203320e87b8b$export$2e2bcd8739ae039 = $b782203320e87b8b$var$node;

});

parcelRegister("6BnaS", function(module, exports) {
$parcel$export(module.exports, "AsyncIssueStatusField", () => $d4bd70c5964975e8$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $d4bd70c5964975e8$export$dba9e9c892560f60);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $hRhIm = parcelRequire("hRhIm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4bd70c5964975e8$var$AsyncLazyIssueStatusField = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("d8WYQ"))), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $d4bd70c5964975e8$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4bd70c5964975e8$var$AsyncLazyIssueStatusField, props)));
};
const $d4bd70c5964975e8$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("jT7JX", function(module, exports) {
$parcel$export(module.exports, "useHideDoneItems", () => $ceb2e86724727d09$export$c2cb7b17819b92d4);

var $eJOHy = parcelRequire("eJOHy");

var $dLXgn = parcelRequire("dLXgn");

var $iN7UY = parcelRequire("iN7UY");

var $34oCh = parcelRequire("34oCh");

var $57Nys = parcelRequire("57Nys");
// For status update with hide done it will always be a single work item that is removed
const $ceb2e86724727d09$var$NET_CHANGE_ISSUE_COUNT = -1;
function $ceb2e86724727d09$export$c2cb7b17819b92d4({ groupConnectionId: groupConnectionId, itemsConnectionId: itemsConnectionId, recordId: recordId, projectKey: projectKey }) {
    const isHideDoneEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getConnectionDetails = (0, $eJOHy.useCallback)(()=>Object.values(connections).find((connection)=>{
            return connection.connectionId === itemsConnectionId;
        }), [
        connections,
        itemsConnectionId
    ]);
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const removeConnection = (0, $eJOHy.useCallback)(({ store: store, remainingIssueCount: remainingIssueCount })=>{
        const connectionDetails = getConnectionDetails();
        if (!connectionDetails) return;
        updateConnectionDetails({
            store: store,
            connection: connectionDetails,
            remainingIssueCount: remainingIssueCount,
            netChangeInIssueCount: $ceb2e86724727d09$var$NET_CHANGE_ISSUE_COUNT,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey
        });
    }, [
        getConnectionDetails,
        groupConnectionId,
        projectKey,
        updateConnectionDetails
    ]);
    const handler = (0, $iN7UY.useHandleStatusUpdate)(itemsConnectionId, recordId, removeConnection, {
        isHideDoneEnabled: isHideDoneEnabled
    });
    return handler;
}

});
parcelRegister("iN7UY", function(module, exports) {
$parcel$export(module.exports, "useHandleStatusUpdate", () => $b0dddbd9500361a0$export$9b67a4661b4d570a);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");


var $fRHdC = parcelRequire("fRHdC");

var $3bmN3 = parcelRequire("3bmN3");
const $b0dddbd9500361a0$var$DEFAULT_OPTIONS = {
    isHideDoneEnabled: false
};
function $b0dddbd9500361a0$export$9b67a4661b4d570a(itemsConnectionId, recordId, removeConnection, options = $b0dddbd9500361a0$var$DEFAULT_OPTIONS) {
    const updater = (0, $fRHdC.useDeleteRecord)(itemsConnectionId, recordId, removeConnection);
    const handler = (0, $3bmN3.useCommitLocalUpdate)(updater, options);
    return (0, $eJOHy.useCallback)((field)=>{
        try {
            handler(field);
        } catch (error) {
            if (error instanceof Error) (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'issue-table-hide-done-status-update',
                    packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
                    teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    }, [
        handler
    ]);
}

});
const $54713f11448e89c8$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $54713f11448e89c8$export$d57b6b390e78d90f = 'keystone';
const $54713f11448e89c8$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $54713f11448e89c8$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("fRHdC", function(module, exports) {
$parcel$export(module.exports, "useDeleteRecord", () => $5aaaec4fac311dfb$export$4495a148dad9d147);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");
function $5aaaec4fac311dfb$export$4495a148dad9d147(itemsConnectionId, recordId, removeConnection) {
    return (0, $eJOHy.useCallback)((store)=>{
        $5aaaec4fac311dfb$var$assert(itemsConnectionId, 'itemsConnectionId');
        $5aaaec4fac311dfb$var$assert(recordId, 'recordId');
        const connectionRecord = store.get(itemsConnectionId);
        if (!connectionRecord) return;
        (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, recordId);
        removeConnection({
            store: store,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length ?? 0
        });
    }, [
        itemsConnectionId,
        recordId,
        removeConnection
    ]);
}
function $5aaaec4fac311dfb$var$assertString(value, paramName) {
    if (typeof value !== 'string') throw new Error(`${paramName} must be a string`);
}
function $5aaaec4fac311dfb$var$assertNotEmpty(value, paramName) {
    if (value.trim().length === 0) throw new Error(`${paramName} must not be an empty string`);
}
function $5aaaec4fac311dfb$var$assert(value, paramName) {
    $5aaaec4fac311dfb$var$assertString(value, paramName);
    $5aaaec4fac311dfb$var$assertNotEmpty(value, paramName);
}

});

parcelRegister("3bmN3", function(module, exports) {
$parcel$export(module.exports, "useCommitLocalUpdate", () => $c3e4ffd5f883a42d$export$f0d146dc82ca0c9c);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");
function $c3e4ffd5f883a42d$export$f0d146dc82ca0c9c(updater, { isHideDoneEnabled: isHideDoneEnabled }) {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((field)=>{
        if (!isHideDoneEnabled) return;
        if ((0, $jx0Vw.statusCategoryForId)(field.statusCategory?.statusCategoryId) !== (0, $jx0Vw.DONE)) return;
        (0, $j4oe4.commitLocalUpdate)(environment, updater);
    }, [
        environment,
        isHideDoneEnabled,
        updater
    ]);
}

});



parcelRegister("7Gpga", function(module, exports) {
$parcel$export(module.exports, "toJiraStatusField", () => $0f7719130d68fc56$export$54bbdde829b87b5c);
$parcel$export(module.exports, "toStatusValue", () => $0f7719130d68fc56$export$2950d85c450ec19d);
const $0f7719130d68fc56$export$54bbdde829b87b5c = (statusValue)=>({
        statusId: statusValue.id,
        name: statusValue.name,
        statusCategory: {
            statusCategoryId: `${statusValue.statusCategory.id}`
        }
    });
const $0f7719130d68fc56$export$2950d85c450ec19d = (jiraStatusField)=>({
        id: jiraStatusField.statusId,
        name: jiraStatusField.name ?? '',
        statusCategory: {
            id: parseInt(jiraStatusField.statusCategory?.statusCategoryId ?? '', 10)
        }
    });

});


parcelRegister("arQXy", function(module, exports) {
$parcel$export(module.exports, "IssueSummaryCell", () => $80aa29a1c195fc8f$export$4da280f2973efc5c);

var $bz7mi = parcelRequire("bz7mi");

var $gr7g9 = parcelRequire("gr7g9");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $9t1Xl = parcelRequire("9t1Xl");

var $4cTDP = parcelRequire("4cTDP");

var $9Mapt = parcelRequire("9Mapt");

var $bzbsd = parcelRequire("bzbsd");

var $2QZBX = parcelRequire("2QZBX");

var $jiTA8 = parcelRequire("jiTA8");

var $3OT15 = parcelRequire("3OT15");

var $6bLlX = parcelRequire("6bLlX");

var $deFVD = parcelRequire("deFVD");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $86BUM = parcelRequire("86BUM");

var $88mo0 = parcelRequire("88mo0");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");

var $fQPwz = parcelRequire("fQPwz");

var $8fpTm = parcelRequire("8fpTm");

var $5TzMU = parcelRequire("5TzMU");
const $80aa29a1c195fc8f$export$4da280f2973efc5c = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, children: children, isRowHoveredOrSelected: isRowHoveredOrSelected, onIssueLinkSelected: onIssueLinkSelected, readViewHighlightOnHover: readViewHighlightOnHover, isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered })=>{
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const data = (0, $j4oe4.useFragment)((0, $gr7g9.default), fieldRef);
    const issueData = (0, $j4oe4.useFragment)((0, $bz7mi.default), issueRef);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const updateIssueSummary = (0, $4cTDP.fg)('jsc_list_reparenting') ? (0, $fQPwz.useUpdateIssueSummary)() : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const issueAriId = issueData?.id;
    let shouldShowIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
        return false;
    }, []);
    let openIframePreviewPanel = (0, $eJOHy.useCallback)(()=>{
    /* empty */ }, []);
    if ((0, $4cTDP.fg)('issue_preview_panel_issue_view_subtask')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const shouldShowIssueInIframePreviewPanel = (0, $deFVD.useShouldShowIframeIssuePreviewPanel)();
        shouldShowIframePreviewPanel = shouldShowIssueInIframePreviewPanel;
    }
    if (shouldShowIframePreviewPanel()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { openPreviewPanel: openPreviewPanel } = (0, $6bLlX.useGlobalObjectPreviewPanels)();
        openIframePreviewPanel = openPreviewPanel;
    }
    const isOpenIssueLinkEnabled = (0, $4cTDP.fg)('jira_issue_table_open_issue_link_config') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsOpenIssueLinkEnabled)() : true;
    const onSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        if (issueData?.__id && (0, $4cTDP.fg)('jsc_list_reparenting')) updateIssueSummary(issueData.__id, value);
    }, [
        issueData?.__id,
        updateIssueSummary
    ]);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    let isEditable = false;
    if ('isEditableInIssueView' in data) isEditable = data.isEditableInIssueView;
    else if ('lazyIsEditableInIssueView' in data) isEditable = data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $34oCh.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const contentRef = (0, $eJOHy.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const issueUrl = issueData?.isRemoteIssue && issueData?.webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? issueData.webUrl : `/browse/${issueData.key}`;
    const onLinkClick = (0, $eJOHy.useCallback)((e)=>{
        if (issueData?.isRemoteIssue && issueData?.webUrl && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) return;
        if (shouldShowIframePreviewPanel()) {
            e.preventDefault();
            openIframePreviewPanel({
                ari: issueAriId || '',
                url: issueUrl,
                name: 'jira-issue'
            });
            return;
        }
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueData.key);
        if (handled) e.preventDefault();
    }, [
        issueData?.isRemoteIssue,
        issueData?.webUrl,
        issueData.key,
        shouldShowIframePreviewPanel,
        isEmbedMode,
        onIssueLinkSelected,
        openIframePreviewPanel,
        issueAriId,
        issueUrl
    ]);
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    let showOpenIssueLink = isOpenIssueLinkEnabled;
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    isGridNavigationEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate') && (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) {
        if ((0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility')) showOpenIssueLink = isOpenIssueLinkEnabled && !!isMergedCellFocusedOrHovered;
        else showOpenIssueLink = isOpenIssueLinkEnabled && !!isRowHoveredOrSelected;
    }
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const renderCustomReadView = (0, $eJOHy.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
            cellType: "summary",
            reason: "Missing required fields"
        });
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
            content: text,
            shouldRenderToContent: true
        });
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88mo0.TableCellDiscreteLink), {
            innerFocusOutline: true,
            href: issueUrl,
            isSubtle: false,
            onClick: onLinkClick,
            "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, text);
        if (isInlineEditingExtendedFieldSupportEnabled && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            ref: hoverPopoverRef,
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW)
        }, text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: text,
            contentRef: contentRef
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
                maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW)
            }, text)), (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $80aa29a1c195fc8f$var$actionButtonsWrapStyles
        }, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $2QZBX.toIssueKey)(issueData.key),
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $2QZBX.toIssueKey)(issueData.key),
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children));
        if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            testId: "native-issue-table.common.ui.issue-cells.issue-summary.issue-summary-cell",
            maxLines: isDensityCompact ? 2 : undefined
        }, text), (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $80aa29a1c195fc8f$var$actionButtonsWrapStyles
        }, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $2QZBX.toIssueKey)(issueData.key),
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOpenIssueLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5TzMU.OpenIssueLink), {
            issueKey: (0, $2QZBX.toIssueKey)(issueData.key),
            url: issueUrl,
            onClick: onLinkClick
        }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && children));
        // Span is necessary here to ensure only link text is clickable for multiline summaries, rather than the
        // entire content box.
        return isDensityCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: $80aa29a1c195fc8f$var$textOverflowStyles
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, content);
    }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? [
        children,
        isDensityCompact,
        isEmbedMode,
        isInlineEditingExtendedFieldSupportEnabled,
        isSingleLineRowHeightEnabled,
        issueData.key,
        onLinkClick,
        showOpenIssueLink,
        hoverPopoverRefFactory
    ] : [
        children,
        isDensityCompact,
        isEmbedMode,
        isInlineEditingExtendedFieldSupportEnabled,
        isSingleLineRowHeightEnabled,
        issueData.key,
        onLinkClick,
        showOpenIssueLink,
        hoverPopoverRefFactory
    ]);
    const node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: $80aa29a1c195fc8f$var$EditViewPopupTarget,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        isRequired: true,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: isInlineEditingExtendedFieldSupportEnabled,
        onSubmitSucceeded: (0, $4cTDP.fg)('jsc_list_reparenting') ? onSubmitSucceeded : undefined,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled,
        readViewHighlightOnHover: readViewHighlightOnHover
    });
    if (isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8fpTm.ActionContainer), null, node);
    return node;
});
const $80aa29a1c195fc8f$var$EditViewPopupTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $80aa29a1c195fc8f$var$customTargetStyles,
        ref: ref
    });
});
// We have an extra flex container around our inline edit component so we can show the open issue link button. We need
// to explicitly center align the edit view popup target to ensure consistent alignment in the table cell.
const $80aa29a1c195fc8f$var$customTargetStyles = (0, $1DXK0.xcss)({
    alignSelf: 'center',
    width: '0'
});
const $80aa29a1c195fc8f$var$textOverflowStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $80aa29a1c195fc8f$var$actionButtonsWrapStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.050'
});

});
parcelRegister("bz7mi", function(module, exports) {
$parcel$export(module.exports, "default", () => $320c7f9a95b842c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3823e14d417b69e84ad7482411f3902e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $320c7f9a95b842c1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueSummaryCell_issue",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "condition": "isRemoteLinkedIssuesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRemoteIssue"
                },
                {
                    "kind": "ScalarField",
                    "name": "webUrl"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$320c7f9a95b842c1$var$node.hash = "94c423e4276945fd081d35286ac16a82";
var $320c7f9a95b842c1$export$2e2bcd8739ae039 = $320c7f9a95b842c1$var$node;

});

parcelRegister("gr7g9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a45f45026ff3e450$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9399fe6e98d55949bf8063754d2960fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a45f45026ff3e450$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "IssueSummaryCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$a45f45026ff3e450$var$node.hash = "6f8d06a4f8a9d249a760bf0f1397534f";
var $a45f45026ff3e450$export$2e2bcd8739ae039 = $a45f45026ff3e450$var$node;

});

parcelRegister("9t1Xl", function(module, exports) {
$parcel$export(module.exports, "SingleLineTextInlineEditViewWithIsEditable", () => $05ffceec1b992bab$export$f267c8aeb8112733);
$parcel$export(module.exports, "SingleLineTextInlineEditView", () => $05ffceec1b992bab$export$ad603a514b680587);

var $e7hE4 = parcelRequire("e7hE4");

var $ehWR9 = parcelRequire("ehWR9");

var $dxYuw = parcelRequire("dxYuw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $77rtG = parcelRequire("77rtG");

var $beyOl = parcelRequire("beyOl");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $gBHYt = parcelRequire("gBHYt");
const $05ffceec1b992bab$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-line-text-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $05ffceec1b992bab$export$f267c8aeb8112733 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen, isRequired: isRequired = false, hideEditButton: hideEditButton, maxLength: maxLength, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, renderCustomReadView: renderCustomReadView, hasReadViewTruncateDisabled: hasReadViewTruncateDisabled = false, readViewHighlightOnHover: readViewHighlightOnHover = true, onUnchangedSubmit: onUnchangedSubmit })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $dxYuw.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, text: text, name: name } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $ehWR9.default));
    // #endregion
    // #region Common state
    const initialValue = text ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    // #endregion
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding ? overriding.overrideIsEditable(isEditable) : isEditable, [
        isEditable,
        overriding
    ]);
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding ? overriding.overrideLabel(name) : name, [
        name,
        overriding
    ]);
    const validator = (0, $gBHYt.useSingleLineTextValidator)(fieldName, isRequired, maxLength);
    /**
   * This will execute the GraphQL mutation.
   */ const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        text: value,
                        operation: 'SET'
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateSingleLineTextField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleLineTextField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            text: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        initialValue: initialValue,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'text',
        onUnchangedSubmit: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? onUnchangedSubmit : undefined
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05ffceec1b992bab$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $beyOl.SingleLineTextReadView), {
            fragmentRef: data,
            renderCustomReadView: renderCustomReadView
        })), [
        data,
        renderCustomReadView
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            value: updatedValue,
            onChange: onChange,
            isInvalid: !!invalidMessage,
            autoFocus: true,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "large",
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $77rtG.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        hideEditButton: hideEditButton,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasReadViewTruncateDisabled: hasReadViewTruncateDisabled,
        readViewHighlightOnHover: readViewHighlightOnHover
    });
};
const $05ffceec1b992bab$export$ad603a514b680587 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $e7hE4.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05ffceec1b992bab$export$f267c8aeb8112733, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("e7hE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9aa9957d2c29bd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5603fda12586c734accd519f63ebd761>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9aa9957d2c29bd6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleLineTextField"
};
$b9aa9957d2c29bd6$var$node.hash = "834bf98c01966c210bc0a4f6e9f0f4a7";
var $b9aa9957d2c29bd6$export$2e2bcd8739ae039 = $b9aa9957d2c29bd6$var$node;

});

parcelRegister("ehWR9", function(module, exports) {
$parcel$export(module.exports, "default", () => $f93877c2a5f40217$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f87bbae0df7928fcb860f8d696c8c51>>
 * @relayHash 029277561796d9f13acaef1dbb085ee8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152
const $f93877c2a5f40217$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSingleLineTextFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateSingleLineTextField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a6baebfa2f37e676d26595f29fc232725ad41353c9fcd04168be34a6b616f152",
            "metadata": {},
            "name": "singleLineText_issueFieldSingleLineText_SingleLineTextField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f93877c2a5f40217$var$node.hash = "7910ed923271af0f6fe2fd325e2358de";
var $f93877c2a5f40217$export$2e2bcd8739ae039 = $f93877c2a5f40217$var$node;

});

parcelRegister("dxYuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2331200186e2823b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebc67ee0e5b1d19577ad84dec6dd3022>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2331200186e2823b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$2331200186e2823b$var$node.hash = "fa64e21466cd3e14f917674796ea3359";
var $2331200186e2823b$export$2e2bcd8739ae039 = $2331200186e2823b$var$node;

});

parcelRegister("77rtG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c81c30a47fc76fc$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1c81c30a47fc76fc$var$SingleLineTextEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dp5GT")), {
        moduleId: "c6bbf997",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $1c81c30a47fc76fc$export$2e2bcd8739ae039 = $1c81c30a47fc76fc$var$SingleLineTextEditViewEntryPoint;

});
parcelRegister("dp5GT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8WF7X").then(()=>parcelRequire('2sEmv'));

});


parcelRegister("beyOl", function(module, exports) {
$parcel$export(module.exports, "SingleLineTextReadView", () => $2f2fb34322581dfc$export$5a145b2225896aea);

var $bqbuJ = parcelRequire("bqbuJ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $guChT = parcelRequire("guChT");

var $eNS8S = parcelRequire("eNS8S");

var $cxKOj = parcelRequire("cxKOj");

var $d9T1A = parcelRequire("d9T1A");

var $8UsZ0 = parcelRequire("8UsZ0");

var $4cTDP = parcelRequire("4cTDP");

var $3Lkm9 = parcelRequire("3Lkm9");

var $k6Nau = parcelRequire("k6Nau");
const $2f2fb34322581dfc$export$5a145b2225896aea = ({ fragmentRef: fragmentRef, renderFieldContentWrapper: FieldContentWrapper, renderCustomReadView: renderCustomReadView })=>{
    const { text: text = null, fieldId: fieldId } = (0, $j4oe4.useFragment)((0, $bqbuJ.default), fragmentRef);
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    const getReadView = (0, $eJOHy.useCallback)(()=>{
        if (renderCustomReadView) return renderCustomReadView(text);
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
            placeholderText: (0, $3Lkm9.default).bespokenTextPlaceholderEmptyFieldText
        });
        const testId = `issue.views.field.single-line-text.read-view.${fieldId}`;
        if ((0, $eNS8S.default)(text, true) && (0, $cxKOj.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) {
            if ((0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: `redaction-marker-${fieldId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UsZ0.LazySmartLink), {
                appearance: "inline",
                url: text
            })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
                "data-testid": testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UsZ0.LazySmartLink), {
                appearance: "inline",
                url: text
            }));
        }
        if ((0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: `redaction-marker-${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
            "data-testid": testId
        }, text));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f2fb34322581dfc$var$ReadViewContainer, {
            "data-testid": testId
        }, text);
    }, [
        renderCustomReadView,
        text,
        fieldId,
        isBespokeEmptyFieldTextGA
    ]);
    if (FieldContentWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldContentWrapper, null, getReadView());
    return getReadView();
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f2fb34322581dfc$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _vwz4gktf _1nmz1hna _kqswh2mm _1bsb1osq _1eog1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bqbuJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $14eaab89a17af546$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28cc3f1e512619502f58cc6e1fc159db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14eaab89a17af546$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "text"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$14eaab89a17af546$var$node.hash = "5f51bd1526b02ac7cd91c57eec827a2f";
var $14eaab89a17af546$export$2e2bcd8739ae039 = $14eaab89a17af546$var$node;

});

parcelRegister("eNS8S", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $ae6a7d95440d0325$export$bef94a5618bf18bf);
$parcel$export(module.exports, "default", () => $ae6a7d95440d0325$export$2e2bcd8739ae039);
/**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $ae6a7d95440d0325$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $ae6a7d95440d0325$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $ae6a7d95440d0325$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $ae6a7d95440d0325$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $ae6a7d95440d0325$var$stricterURLRegex.test(string) || $ae6a7d95440d0325$var$protocolRegex.test(string);
    return $ae6a7d95440d0325$var$URLStandardRegex.test(string);
}
var $ae6a7d95440d0325$export$2e2bcd8739ae039 = $ae6a7d95440d0325$export$bef94a5618bf18bf;

});

parcelRegister("8UsZ0", function(module, exports) {
$parcel$export(module.exports, "LazySmartLink", () => $8977add9d34e6e7b$export$fe7f8e391b2babff);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $6qmxl = parcelRequire("6qmxl");
const $8977add9d34e6e7b$var$entryPointParams = {};
const $8977add9d34e6e7b$export$fe7f8e391b2babff = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $6qmxl.SmartLinkEntryPoint), $8977add9d34e6e7b$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.issue-field.smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("6qmxl", function(module, exports) {
$parcel$export(module.exports, "SmartLinkEntryPoint", () => $caa0557c78d97e7a$export$29454edb61a1a57e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $caa0557c78d97e7a$export$29454edb61a1a57e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hMHOW")).then((module)=>module.SmartLink), {
        moduleId: "3da73bc4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hMHOW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("91SIJ").then(()=>parcelRequire('bmeQi'));

});




parcelRegister("gBHYt", function(module, exports) {
$parcel$export(module.exports, "useSingleLineTextValidator", () => $d52f5e0d730f9978$export$6955d95abfe9109c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $g2Uiq = parcelRequire("g2Uiq");
const $d52f5e0d730f9978$export$6955d95abfe9109c = (fieldName, isRequired, maxLength)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const change = (0, $eJOHy.useCallback)((value)=>{
        if (maxLength && maxLength > 0 && value.length > maxLength) return {
            type: 'error',
            message: formatMessage((0, $g2Uiq.default).maxLengthErrorMessage, {
                maxLength: maxLength
            })
        };
        return null;
    }, [
        formatMessage,
        maxLength
    ]);
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value.trim().length === 0) return {
            type: 'error',
            message: formatMessage((0, $g2Uiq.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        change: change,
        submit: submit
    };
};

});
parcelRegister("g2Uiq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe796aeade62014$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ebe796aeade62014$var$messages = (0, $7qGN1.defineMessages)({
    maxLengthErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.max-length-error-message",
        "defaultMessage": "{maxLength} character limit"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-line-text-inline-edit-full.single-line-text.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});
var $ebe796aeade62014$export$2e2bcd8739ae039 = $ebe796aeade62014$var$messages;

});



parcelRegister("fQPwz", function(module, exports) {
$parcel$export(module.exports, "useUpdateIssueSummary", () => $67b77c5a2df6a013$export$8664a69d14346ead);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $67b77c5a2df6a013$export$8664a69d14346ead = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issueRelayId, summary)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const issueEntry = store.get(issueRelayId);
            if (issueEntry) issueEntry.setValue(summary, 'summary');
        });
    }, [
        environment
    ]);
};

});

parcelRegister("8fpTm", function(module, exports) {
$parcel$export(module.exports, "ActionContainer", () => $9c426a359ad88357$export$37ab3bdebc286ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");
const $9c426a359ad88357$export$37ab3bdebc286ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.common.ui.issue-cells.issue-summary.action-container",
        className: (0, $hcewu.default)([
            (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') ? "_1e0c1txw _16jlkb7n _1tke1osq _ic7gglyw _1ufvglyw _lt0o1yb4 _17mg1txw _1w9r1txw _ev7t1txw _z5tv1txw" : "_1e0c1txw _16jlkb7n _1tke1osq _ic7gglyw _18wjidpf _lt0o1yb4 _17mg1txw _1se1t94y _nouyt94y _ev7t1txw _1aszt94y _12nht94y" : "_1e0c1txw _16jlkb7n _1tke1osq _155eidpf _nouyt94y _12nht94y"
        ])
    }, children);
};
const $9c426a359ad88357$var$containerStylesNew = null;
const $9c426a359ad88357$var$containerStyles = null;
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9c426a359ad88357$var$containerStylesOld = null;

});

parcelRegister("5TzMU", function(module, exports) {
$parcel$export(module.exports, "OpenIssueLink", () => $9a4c8f9eda00c36f$export$8f0bae95f8140072);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $ac080 = parcelRequire("ac080");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $jiTA8 = parcelRequire("jiTA8");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $dD4QM = parcelRequire("dD4QM");
const $9a4c8f9eda00c36f$export$8f0bae95f8140072 = ({ issueKey: issueKey, onClick: onClick, url: url })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        onClick?.(e);
    }, [
        onClick
    ]);
    let style;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) {
        if ((0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) {
            if (!isGridNavigationEnabled) style = $9a4c8f9eda00c36f$var$openIssueLinkStyle;
        } else style = $9a4c8f9eda00c36f$var$buttonOpacityVariableStyle;
    } else style = $9a4c8f9eda00c36f$var$buttonOpacityVariableStyleOld;
    const linkUrl = url && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? url : `/browse/${issueKey}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: (0, $4cTDP.fg)('nin_list_summary_cta_tooltip_change') ? formatMessage((0, $dD4QM.default).openTooltipNew) : formatMessage((0, $dD4QM.default).openTooltip)
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            ...triggerProps,
            "aria-label": (0, $4cTDP.fg)('nin_list_summary_cta_tooltip_change') ? formatMessage((0, $dD4QM.default).openLabelNew, {
                issueKey: issueKey
            }) : formatMessage((0, $dD4QM.default).openLabel, {
                issueKey: issueKey
            }),
            href: linkUrl,
            onClick: handleClick,
            xcss: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? $9a4c8f9eda00c36f$var$buttonStyles : $9a4c8f9eda00c36f$var$buttonStylesOld,
            // Cannot provide CSS variable as a compile time value due to various type constraints between
            // primitives + compiled.
            // eslint-disable-next-line jira/react/no-style-attribute,@atlaskit/ui-styling-standard/enforce-style-prop
            style: style,
            ...isEmbedMode && {
                target: '_blank',
                rel: 'noopener'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac080))), {
            label: "",
            ...(0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style') && {
                size: 'small'
            }
        })));
};
const $9a4c8f9eda00c36f$var$buttonOpacityVariableStyle = {
    display: 'var(--open-button-display, "none")'
};
const $9a4c8f9eda00c36f$var$openIssueLinkStyle = {
    display: 'var(--open-button-display, "flex")'
};
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9a4c8f9eda00c36f$var$buttonOpacityVariableStyleOld = {
    opacity: 'var(--open-button-opacity, 0)'
};
const $9a4c8f9eda00c36f$var$buttonStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    borderStyle: 'none',
    borderColor: 'color.border',
    borderWidth: '0',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    marginInlineStart: 'auto',
    padding: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});
/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */ const $9a4c8f9eda00c36f$var$buttonStylesOld = (0, $1DXK0.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    color: 'color.text',
    display: 'inline-flex',
    height: '24px',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingRight: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingBottom: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    paddingLeft: 'space.050',
    width: '24px',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    },
    ':active': {
        color: 'color.text'
    }
});

});
parcelRegister("dD4QM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f0b787aedc47989$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5f0b787aedc47989$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openTooltip: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip",
        "defaultMessage": "Select work item"
    },
    openLabel: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label",
        "defaultMessage": "Select work item {issueKey}"
    },
    openTooltipNew: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-tooltip-new",
        "defaultMessage": "Open work item"
    },
    openLabelNew: {
        "id": "native-issue-table.common.issue-cells.issue-summary.open-issue-link.open-label-new",
        "defaultMessage": "Open work item {issueKey}"
    }
});

});



parcelRegister("69Ju5", function(module, exports) {
$parcel$export(module.exports, "IssueTypeCell", () => $45eb161bb048aee0$export$75b44b408924c851);

var $9NBqq = parcelRequire("9NBqq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7PXBL = parcelRequire("7PXBL");
const $45eb161bb048aee0$export$75b44b408924c851 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $9NBqq.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PXBL.IconCell), {
        fragmentRef: data,
        showErrorIconWhenEmpty: true
    });
});

});
parcelRegister("9NBqq", function(module, exports) {
$parcel$export(module.exports, "default", () => $759a334c47df7956$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edda4e3dd30ca8cf6adeddd3dbc8df0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $759a334c47df7956$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueTypeCell",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "IconCell"
        }
    ],
    "type": "JiraIssueTypeField"
};
$759a334c47df7956$var$node.hash = "877c101cf6c61ca9ea0f6a9dfeefabab";
var $759a334c47df7956$export$2e2bcd8739ae039 = $759a334c47df7956$var$node;

});

parcelRegister("7PXBL", function(module, exports) {
$parcel$export(module.exports, "IconCell", () => $009899e793dea9f9$export$5ffd26a2d6f7e2d);

var $fsc7D = parcelRequire("fsc7D");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $9Mapt = parcelRequire("9Mapt");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $009899e793dea9f9$export$5ffd26a2d6f7e2d = /*#__PURE__*/ (0, $eJOHy.memo)(({ nameOld: nameOld, iconUrlOld: iconUrlOld, showErrorIconWhenEmpty: showErrorIconWhenEmpty, fragmentRef: fragmentRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $fsc7D.default), fragmentRef);
    const iconUrl = iconUrlOld ?? data?.issueType?.avatar?.small;
    const name = nameOld ?? data?.issueType?.name;
    const isSingleLineRowHeightFeatureEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightFeatureEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data?.id) : null;
    let isMergedColumnVisible = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnVisible = (0, $34oCh.useIsMergedColumnVisible)();
    const isSingleLineRowHeightEnabled = isSingleLineRowHeightFeatureEnabled && !isMergedColumnVisible;
    if (!name?.length || !iconUrl?.length) return showErrorIconWhenEmpty ? /*#__PURE__*/ $eJOHy.createElement((0, $86BUM.default), {
        cellType: "icon",
        reason: "Missing required fields"
    }) : null; // aka an empty cell
    const imgComponent = (ref = null)=>/*#__PURE__*/ $eJOHy.createElement("img", {
            height: "16",
            width: "16",
            src: iconUrl,
            alt: name,
            "data-vc": "native-issue-table-ui-icon-cell-img" // Assertion can be cleaned up with issue_table_single_line_row_height_event_delegator fg
            ,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            className: (0, $hcewu.default)([
                isSingleLineRowHeightEnabled && "_1e0c1ule"
            ])
        });
    if (isSingleLineRowHeightEnabled) {
        let hoverPopoverRef = null;
        if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
            hoverPopoverRef = hoverPopoverRefFactory({
                content: name,
                alwaysShow: true
            });
            return imgComponent(hoverPopoverRef);
        }
        return /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: name
        }, ({ ref: ref })=>imgComponent(ref));
    }
    return(// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript)
    /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: name,
        tag: $009899e793dea9f9$var$AlignmentFix
    }, imgComponent()));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $009899e793dea9f9$var$AlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $009899e793dea9f9$var$imgStyles = null;

});
parcelRegister("fsc7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f73e5fe3321e35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c49622331b3d7750ce8d5e4b34b7ed85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9f73e5fe3321e35$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IconCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "small"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraIssueTypeField"
};
$b9f73e5fe3321e35$var$node.hash = "08d51c88eaef04241b1eefa353f8f767";
var $b9f73e5fe3321e35$export$2e2bcd8739ae039 = $b9f73e5fe3321e35$var$node;

});



parcelRegister("fqa5Z", function(module, exports) {
$parcel$export(module.exports, "LabelsCell", () => $0ebc834caf937d66$export$b1db1ca9063ebfb8);

var $jRumi = parcelRequire("jRumi");

var $cIM10 = parcelRequire("cIM10");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $i45OY = parcelRequire("i45OY");

var $j8Km1 = parcelRequire("j8Km1");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $8jOO7 = parcelRequire("8jOO7");
const $0ebc834caf937d66$export$b1db1ca9063ebfb8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $cIM10.default), fieldRef);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ebc834caf937d66$export$194e7ceec6d29085, {
        fieldRef: data,
        issueSearchBaseUrl: issueSearchBaseUrl,
        isTruncated: !isDensityFull,
        isHoverPopoverEnabled: isSingleLineRowHeightEnabled,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
});
const $0ebc834caf937d66$export$194e7ceec6d29085 = ({ fieldRef: fieldRef, issueSearchBaseUrl: issueSearchBaseUrl, isTruncated: isTruncated, menuPortalTarget: menuPortalTarget, isHoverPopoverEnabled: isHoverPopoverEnabled, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $jRumi.default), fieldRef);
    const isLabelsSystemField = data.fieldId === (0, $j8Km1.KNOWN_COLUMN_TYPES).LABELS;
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isLabelsSystemField || isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isHoverPopoverEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i45OY.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $0ebc834caf937d66$var$CustomTarget : undefined,
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isFirstField && isHoverPopoverEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i45OY.LabelsInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        baseSearchUrl: issueSearchBaseUrl,
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isTruncated: isTruncated,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        menuPortalTarget: menuPortalTarget,
        readViewFitContainerHeight: true,
        isHoverPopoverEnabled: isHoverPopoverEnabled
    });
};
const $0ebc834caf937d66$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $0ebc834caf937d66$var$customTargetStyles : $0ebc834caf937d66$var$customTargetStylesOld,
        ref: ref
    });
});
const $0ebc834caf937d66$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $0ebc834caf937d66$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("jRumi", function(module, exports) {
$parcel$export(module.exports, "default", () => $66e6cd61268f183a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<017b43c8a8aafd39977ff72be5268a38>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66e6cd61268f183a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "LabelsCell_LabelsInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraLabelsField"
};
$66e6cd61268f183a$var$node.hash = "4b2d18a610614313c48c9aa8c73d40ed";
var $66e6cd61268f183a$export$2e2bcd8739ae039 = $66e6cd61268f183a$var$node;

});

parcelRegister("cIM10", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f694d73d5858f41$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ad84ef0696da43eb9dcae70ba90e75b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8f694d73d5858f41$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "LabelsCell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "LabelsCell_LabelsInlineEditCell"
        }
    ],
    "type": "JiraLabelsField"
};
$8f694d73d5858f41$var$node.hash = "5b6e5c66a83c717ab1a01b371fce907d";
var $8f694d73d5858f41$export$2e2bcd8739ae039 = $8f694d73d5858f41$var$node;

});

parcelRegister("i45OY", function(module, exports) {
$parcel$export(module.exports, "LabelsInlineEditViewWithIsEditable", () => $08b033632138b934$export$f00c136eadca5f4b);
$parcel$export(module.exports, "LabelsInlineEditView", () => $08b033632138b934$export$f066b3edf0d7cd25);

var $jmtvE = parcelRequire("jmtvE");

var $eYjK5 = parcelRequire("eYjK5");

var $5XpUh = parcelRequire("5XpUh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $eSnSE = parcelRequire("eSnSE");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $4EKqI = parcelRequire("4EKqI");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $1j4Y6 = parcelRequire("1j4Y6");

var $chD07 = parcelRequire("chD07");

var $h67Wd = parcelRequire("h67Wd");

var $ftN6c = parcelRequire("ftN6c");

var $cNNNb = parcelRequire("cNNNb");

var $fAZgY = parcelRequire("fAZgY");

var $5UIJ7 = parcelRequire("5UIJ7");
const $08b033632138b934$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-labels-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $08b033632138b934$var$FIELD_KEY = 'labels';
const $08b033632138b934$var$FIELD_TYPE = 'labels';
const $08b033632138b934$export$1b05898090f57b12 = 'issue-field.save-value';
const $08b033632138b934$export$3f27bc10068ef877 = `Failed to update field ${$08b033632138b934$var$FIELD_KEY} of type ${$08b033632138b934$var$FIELD_TYPE}`;
const $08b033632138b934$var$transformAggToAtlaskitOption = (connection)=>{
    const labelValues = connection?.edges?.map((edge)=>edge?.node ?? null).filter(Boolean).filter((label)=>label && label.name != null) || [];
    const labelOptions = labelValues.map((label)=>({
            label: label.name || '',
            value: label.name || '',
            ...label.color ? {
                color: label.color.colorKey
            } : {}
        }));
    return labelOptions;
};
const $08b033632138b934$var$transformAtlaskitOptionToAgg = (value)=>({
        totalCount: value.length,
        edges: value.map((label)=>({
                node: {
                    name: label.value,
                    ...label.color ? {
                        color: {
                            colorKey: label.color
                        }
                    } : {
                        color: null
                    }
                }
            }))
    });
const $08b033632138b934$var$transformLabelsOptionsToLabelNames = (value)=>value?.map((labelOption)=>labelOption.value) ?? [];
const $08b033632138b934$var$transformLabelsOptionsToColoredLabels = (labels)=>{
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraOptionColorInput | null | undefined'.
    return labels?.map(({ value: value, color: color, __isNew__: __isNew__ })=>{
        if (color) return {
            name: value,
            color: color
        };
        return {
            name: value,
            ...__isNew__ ? {
                color: (0, $cNNNb.GREY_META).name
            } : {}
        };
    }) ?? [];
};
const $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput = (operations)=>operations.map(({ operation: operation, value: value })=>{
        if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
            const coloredLabels = $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value);
            return {
                operation: operation,
                labels: coloredLabels?.map((label)=>label.name) || [],
                labelProperties: coloredLabels
            };
        }
        return {
            operation: operation,
            labels: $08b033632138b934$var$transformLabelsOptionsToLabelNames(value)
        };
    });
const $08b033632138b934$var$isEqualLabels = (a, b)=>a.length === b.length && a.every((option, index)=>option.label === b[index].label && option.value === b[index].value);
const $08b033632138b934$export$f00c136eadca5f4b = ({ attributes: attributes, spacing: spacing = 'compact', baseSearchUrl: baseSearchUrl, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, isTruncated: isTruncated, isEditable: isEditable, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldScrollIntoView: menuShouldScrollIntoView, onCancel: onCancel, onEdit: onEdit, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceededProp, onSubmitFailed: onSubmitFailedProp, fragmentRef: fragmentRef, readViewFitContainerHeight: readViewFitContainerHeight, shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox, shouldPrefetchSuggestions: shouldPrefetchSuggestions = false, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [currentProjectOnly, setCurrentProjectOnly] = (0, $eJOHy.useState)((0, $5UIJ7.getProjectScopeLabelCheckboxValueFromLocalStorage));
    (0, $eJOHy.useEffect)(()=>{
        (0, $4cTDP.fg)('labels_restricted_to_project_experiment') && (0, $5UIJ7.setProjectScopeLabelCheckboxValueFromLocalStorage)(currentProjectOnly);
    }, [
        currentProjectOnly
    ]);
    const data = (0, $j4oe4.useFragment)((0, $5XpUh.default), fragmentRef);
    const { id: uniqueFieldId, name: fieldNameNoOverrides, fieldId: fieldId, type: type } = data;
    const isFieldEditable = overriding.overrideIsEditable(isEditable);
    const fieldName = overriding.overrideLabel(fieldNameNoOverrides);
    const initialValue = (0, $eJOHy.useMemo)(()=>$08b033632138b934$var$transformAggToAtlaskitOption(data?.selectedLabelsConnection), [
        data?.selectedLabelsConnection
    ]);
    const [newValue, setNewValue] = (0, $eJOHy.useState)(initialValue);
    const [cachedLabels, { addToCache: addToCache }] = (0, $h67Wd.useLabelsCache)(fieldId);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $eYjK5.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const validator = (0, $5UIJ7.useLabelsValidator)();
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const updatedValue = $08b033632138b934$var$transformLabelsOptionsToLabelNames(value);
        const updatedColoredValue = $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value);
        addToCache((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? updatedColoredValue : updatedValue);
        onSubmit?.((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? updatedColoredValue : updatedValue);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: $08b033632138b934$var$transformOptionsOperationsIntoAggOperationInput([
                        {
                            operation: 'SET',
                            value: value
                        }
                    ])
                }
            },
            optimisticResponse: {
                jira: {
                    updateLabelsField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            type: type,
                            fieldId: fieldId,
                            // @ts-expect-error - ts2322 - Property 'id' is missing in type '{ readonly colorKey: string | null | undefined; }' but required in type '{ readonly colorKey: string | null | undefined; readonly id: string | null | undefined; }'.
                            selectedLabelsConnection: $08b033632138b934$var$transformAtlaskitOptionToAgg(value)
                        }
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData?.jira?.updateLabelsField?.success) onSuccess();
                else {
                    const errorMessage = mutationData?.jira?.updateLabelsField?.errors?.[0]?.message ?? undefined;
                    onFail(undefined, errorMessage);
                    (0, $eSnSE.default).safeErrorWithoutCustomerData($08b033632138b934$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$08b033632138b934$var$FIELD_TYPE}`);
                }
            },
            onError (error) {
                onFail(error, error.message);
                (0, $eSnSE.default).safeErrorWithoutCustomerData($08b033632138b934$export$1b05898090f57b12, `Failed to update field ${fieldId} of type ${$08b033632138b934$var$FIELD_TYPE}`);
            }
        });
    }, // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        addToCache,
        onSubmit,
        commit,
        uniqueFieldId,
        fieldName,
        type,
        fieldId,
        createAnalyticsEvent
    ]);
    const handleSubmitSucceeded = (0, $fAZgY.useCallbackWithCondition)((value)=>{
        // onSubmitSucceededProp expects a list of strings so we must map our updated value accordingly.
        onSubmitSucceededProp?.((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? $08b033632138b934$var$transformLabelsOptionsToColoredLabels(value) : $08b033632138b934$var$transformLabelsOptionsToLabelNames(value));
    }, [
        onSubmitSucceededProp
    ], ()=>(0, $4cTDP.fg)('jfp-magma-stability-issue-view-2'));
    const [config] = (0, $cxKOj.UNSAFE_noExposureExp)('labels_restricted_to_project');
    const memoizedAttributes = (0, $fAZgY.useMemoWithCondition)(()=>({
            ...attributes,
            ...(0, $4cTDP.fg)('labels_restricted_to_project_experiment') ? {
                hasProjectScopedLabels: config.get('showProjectFilter', false),
                currentProjectOnly: currentProjectOnly
            } : {}
        }), [
        attributes,
        config,
        currentProjectOnly
    ], ()=>(0, $4cTDP.fg)('jfp-magma-stability-issue-view-2'));
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: memoizedAttributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $08b033632138b934$var$isEqualLabels,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: handleSubmitSucceeded,
        onSubmitFailed: onSubmitFailedProp,
        onUpdateValue: setNewValue,
        updatedValue: newValue,
        validator: validator,
        clipboardComponentType: 'labels'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08b033632138b934$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $chD07.LabelsReadView), {
            baseSearchUrl: baseSearchUrl,
            fragmentRef: data,
            isTruncated: isTruncated,
            isHoverPopoverEnabled: isHoverPopoverEnabled
        })), [
        baseSearchUrl,
        data,
        isTruncated,
        isHoverPopoverEnabled
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ariaLabel: fieldName,
            spacing: spacing,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            onChange: handleChange,
            value: newValue,
            cachedOptions: cachedLabels,
            nodeIdFragment: data,
            isInvalid: !!invalidMessage,
            sessionId: sessionId.current,
            testId: 'issue-field-labels-inline-edit-view-full.ui.labels.edit-view',
            shouldShowProjectScopedCheckbox: shouldShowProjectScopedCheckbox,
            ...(0, $4cTDP.fg)('labels_restricted_to_project_experiment') ? {
                currentProjectOnly: currentProjectOnly,
                setCurrentProjectOnly: setCurrentProjectOnly
            } : {}
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPoint: (0, $1j4Y6.default),
        editViewEntryPointParams: shouldPrefetchSuggestions ? {
            id: uniqueFieldId
        } : {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        invalidMessage: invalidMessage,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        hasReadViewTruncateDisabled: isHoverPopoverEnabled,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        hasUnsubmittedChanges: hasServerValidationError
    });
};
const $08b033632138b934$export$f066b3edf0d7cd25 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/graphql-naming */ // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $jmtvE.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08b033632138b934$export$f00c136eadca5f4b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("jmtvE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bdc8b298b8d382c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a5d785db9d94536cfc54c642b914993>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2bdc8b298b8d382c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraLabelsField"
};
$2bdc8b298b8d382c$var$node.hash = "83c0a65ee08db15e69b7b1d990bb3c2d";
var $2bdc8b298b8d382c$export$2e2bcd8739ae039 = $2bdc8b298b8d382c$var$node;

});

parcelRegister("eYjK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d81d3c01cbd4049f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7947fae5515817c329d71de17e81921>>
 * @relayHash c63fef829683257621ca44c6de704569
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID decd3960fcb949b4372ef20ce095b3faec3c8a144d2c1b402c746b261e027e87
const $d81d3c01cbd4049f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "colorKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "decd3960fcb949b4372ef20ce095b3faec3c8a144d2c1b402c746b261e027e87",
            "metadata": {},
            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d81d3c01cbd4049f$var$node.hash = "b7c0af684826341f4d5d5b319e095b51";
var $d81d3c01cbd4049f$export$2e2bcd8739ae039 = $d81d3c01cbd4049f$var$node;

});

parcelRegister("5XpUh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a51f8a9fdc04e48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f260bad90f08e590a093963f832701b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a51f8a9fdc04e48$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView"
            },
            {
                "kind": "FragmentSpread",
                "name": "labels_issueFieldLabelsEditviewFull_LabelsEditView_nodeIdFragment"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000
                        }
                    ],
                    "concreteType": "JiraLabelConnection",
                    "kind": "LinkedField",
                    "name": "selectedLabelsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraLabelEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "concreteType": "JiraColor",
                                            "kind": "LinkedField",
                                            "name": "color",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "colorKey"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "selectedLabelsConnection(first:1000)"
                },
                "action": "THROW",
                "path": "selectedLabelsConnection"
            }
        ],
        "type": "JiraLabelsField"
    };
}();
$3a51f8a9fdc04e48$var$node.hash = "36e5976ba7a2feeb9ac95152dd750aef";
var $3a51f8a9fdc04e48$export$2e2bcd8739ae039 = $3a51f8a9fdc04e48$var$node;

});

parcelRegister("1j4Y6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a5de43dc26a37ed$export$2e2bcd8739ae039);

var $L8BZE = parcelRequire("L8BZE");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3a5de43dc26a37ed$var$LabelsEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cX6lF")), {
        moduleId: "f49080b6",
        priority: "interaction"
    }),
    getPreloadProps: ({ id: id })=>id ? {
            queries: {
                labelsSuggestionsData: {
                    parameters: $L8BZE.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id
                    }
                }
            }
        } : {}
});
var $3a5de43dc26a37ed$export$2e2bcd8739ae039 = $3a5de43dc26a37ed$var$LabelsEditViewEntryPoint;

});
parcelRegister("L8BZE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c60c3724c891dcef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1812ef87b1f80def77b88faa395f28a5>>
 * @relayHash cf60cab627fd5a4526b86847467cc927
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e
const $c60c3724c891dcef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        },
        {
            "kind": "Literal",
            "name": "suggested",
            "value": true
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragment_suggestionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraLabelConnection",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(first:50,searchBy:\"\",suggested:true)"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "filters": [
                                        "suggested",
                                        "searchBy",
                                        "currentProjectOnly"
                                    ],
                                    "handle": "connection",
                                    "key": "labels_issueFieldLabelsEditviewFull_LabelsEditViewWithSuggestionsFragmentSearch__labels",
                                    "kind": "LinkedHandle",
                                    "name": "labels"
                                }
                            ],
                            "type": "JiraLabelsField"
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "16a655da0b16a10ad930e84f8f7bfc022914d3262cbdef1fd962c0f5bc00523e",
            "metadata": {},
            "name": "labels_issueFieldLabelsEditviewFull_LabelsEditViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c60c3724c891dcef$var$node.hash = "f7c0efbc6f8dee59af5c37b02898ac3e";
var $c60c3724c891dcef$export$2e2bcd8739ae039 = $c60c3724c891dcef$var$node;

});

parcelRegister("cX6lF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8L4O3").then(()=>parcelRequire('i1Kmk'));

});


parcelRegister("chD07", function(module, exports) {
$parcel$export(module.exports, "LabelsReadView", () => $908eb3b1fb928d18$export$79e9d2357368ec9e);

var $1ClZA = parcelRequire("1ClZA");

var $bNhhZ = parcelRequire("bNhhZ");

var $kwYMD = parcelRequire("kwYMD");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $ar6fB = parcelRequire("ar6fB");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $iiHt1 = parcelRequire("iiHt1");

var $fjnDV = parcelRequire("fjnDV");

var $gZJc1 = parcelRequire("gZJc1");
const $908eb3b1fb928d18$var$getLabelTagColor = (label)=>{
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        if (!colorName) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label?.name || '');
        const { tagColor: tagColor } = (0, $051tO.getColorMetadata)(colorName);
        return tagColor;
    }
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(label.name);
};
const $908eb3b1fb928d18$export$79e9d2357368ec9e = (0, $1ClZA.isReactCompilerForLabelsFieldEnabled)() ? (t0)=>{
    const $ = (0, $bNhhZ.c)(13);
    const { baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled } = t0;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $gZJc1.default).noValueTextExperiment);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const noValueTextExperiment = t1;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $kwYMD.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        let t2;
        if ($[2] !== baseSearchUrl || $[3] !== fieldId || $[4] !== isHoverPopoverEnabled || $[5] !== isTruncated || $[6] !== labels.edges) {
            t2 = Symbol.for("react.early_return_sentinel");
            bb0: {
                const labelValues = labels?.edges?.filter(Boolean).map($908eb3b1fb928d18$var$_temp).filter($908eb3b1fb928d18$var$_temp2) || [];
                if (labelValues.length !== 0) {
                    if (isTruncated) {
                        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjnDV.LabelsTruncatedReadView), {
                            baseSearchUrl: baseSearchUrl,
                            fieldId: fieldId,
                            labelValues: labelValues,
                            isHoverPopoverEnabled: isHoverPopoverEnabled
                        });
                        break bb0;
                    }
                    let t3;
                    if ($[8] !== baseSearchUrl || $[9] !== fieldId) {
                        t3 = (label_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
                                key: label_0.name,
                                isRemovable: false,
                                text: label_0.name,
                                href: (0, $iiHt1.getLabelHref)(fieldId, label_0.name, baseSearchUrl),
                                color: $908eb3b1fb928d18$var$getLabelTagColor(label_0)
                            });
                        $[8] = baseSearchUrl;
                        $[9] = fieldId;
                        $[10] = t3;
                    } else t3 = $[10];
                    t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($908eb3b1fb928d18$var$GroupWithNegativeMarginOffset, null, labelValues.map(t3));
                    break bb0;
                }
            }
            $[2] = baseSearchUrl;
            $[3] = fieldId;
            $[4] = isHoverPopoverEnabled;
            $[5] = isTruncated;
            $[6] = labels.edges;
            $[7] = t2;
        } else t2 = $[7];
        if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    }
    const t2 = isExperimentEnabled ? noValueTextExperiment : undefined;
    let t3;
    if ($[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
            emptyText: t2
        });
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ baseSearchUrl: baseSearchUrl, fragmentRef: fragmentRef, isTruncated: isTruncated, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $gZJc1.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $kwYMD.default), fragmentRef);
    const { selectedLabelsConnection: labels, fieldId: fieldId } = data;
    if (labels.totalCount !== 0) {
        const labelValues = labels?.edges?.filter(Boolean).map((edge)=>edge.node).filter((label)=>label != null && label.name != null) || [];
        if (labelValues.length !== 0) {
            if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjnDV.LabelsTruncatedReadView), {
                baseSearchUrl: baseSearchUrl,
                fieldId: fieldId,
                labelValues: labelValues,
                isHoverPopoverEnabled: isHoverPopoverEnabled
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($908eb3b1fb928d18$var$GroupWithNegativeMarginOffset, null, labelValues.map((label_0)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
                    key: label_0.name,
                    isRemovable: false,
                    text: label_0.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label_0.name, baseSearchUrl),
                    color: $908eb3b1fb928d18$var$getLabelTagColor(label_0)
                });
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $908eb3b1fb928d18$var$GroupWithNegativeMarginOffset = /*#__PURE__*/ (0, $eJOHy.forwardRef)((0, $1ClZA.isReactCompilerForLabelsFieldEnabled)() ? (t0, __cmplr)=>{
    const $ = (0, $bNhhZ.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80 _1bah1y6m _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});
function $908eb3b1fb928d18$var$_temp(edge) {
    return edge.node;
}
function $908eb3b1fb928d18$var$_temp2(label) {
    return label != null && label.name != null;
}

});
parcelRegister("1ClZA", function(module, exports) {
$parcel$export(module.exports, "isReactCompilerForLabelsFieldEnabled", () => $580a25047c74a1a0$export$cc47643e818fe2c1);

var $4cTDP = parcelRequire("4cTDP");
function $580a25047c74a1a0$export$cc47643e818fe2c1() {
    if ((0, $4cTDP.fg)('react_compiler_for_labels_field')) return true;
    return false;
}

});

parcelRegister("bNhhZ", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */ "use no memo";
"use strict";
var $8961ae8e4b5337af$var$__create = Object.create;
var $8961ae8e4b5337af$var$__defProp = Object.defineProperty;
var $8961ae8e4b5337af$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $8961ae8e4b5337af$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $8961ae8e4b5337af$var$__getProtoOf = Object.getPrototypeOf;
var $8961ae8e4b5337af$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8961ae8e4b5337af$var$__export = (target, all)=>{
    for(var name in all)$8961ae8e4b5337af$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $8961ae8e4b5337af$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $8961ae8e4b5337af$var$__getOwnPropNames(from))if (!$8961ae8e4b5337af$var$__hasOwnProp.call(to, key) && key !== except) $8961ae8e4b5337af$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $8961ae8e4b5337af$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $8961ae8e4b5337af$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $8961ae8e4b5337af$var$__create($8961ae8e4b5337af$var$__getProtoOf(mod)) : {}, $8961ae8e4b5337af$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $8961ae8e4b5337af$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $8961ae8e4b5337af$var$__toCommonJS = (mod)=>$8961ae8e4b5337af$var$__copyProps($8961ae8e4b5337af$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $8961ae8e4b5337af$var$index_exports = {};
$8961ae8e4b5337af$var$__export($8961ae8e4b5337af$var$index_exports, {
    $dispatcherGuard: ()=>$8961ae8e4b5337af$var$$dispatcherGuard,
    $makeReadOnly: ()=>$8961ae8e4b5337af$var$$makeReadOnly,
    $reset: ()=>$8961ae8e4b5337af$var$$reset,
    $structuralCheck: ()=>$8961ae8e4b5337af$var$$structuralCheck,
    c: ()=>$8961ae8e4b5337af$var$c,
    clearRenderCounterRegistry: ()=>$8961ae8e4b5337af$var$clearRenderCounterRegistry,
    renderCounterRegistry: ()=>$8961ae8e4b5337af$var$renderCounterRegistry,
    useRenderCounter: ()=>$8961ae8e4b5337af$var$useRenderCounter
});
module.exports = $8961ae8e4b5337af$var$__toCommonJS($8961ae8e4b5337af$var$index_exports);

var $8961ae8e4b5337af$var$React = $8961ae8e4b5337af$var$__toESM((parcelRequire("eJOHy")));
var { useRef: $8961ae8e4b5337af$var$useRef, useEffect: $8961ae8e4b5337af$var$useEffect, isValidElement: $8961ae8e4b5337af$var$isValidElement } = $8961ae8e4b5337af$var$React;
var $8961ae8e4b5337af$var$_a;
var $8961ae8e4b5337af$var$ReactSecretInternals = //@ts-ignore
($8961ae8e4b5337af$var$_a = $8961ae8e4b5337af$var$React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? $8961ae8e4b5337af$var$_a : $8961ae8e4b5337af$var$React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var $8961ae8e4b5337af$var$$empty = Symbol.for("react.memo_cache_sentinel");
var $8961ae8e4b5337af$var$_a2;
var $8961ae8e4b5337af$var$c = // @ts-expect-error
typeof (($8961ae8e4b5337af$var$_a2 = $8961ae8e4b5337af$var$React.__COMPILER_RUNTIME) == null ? void 0 : $8961ae8e4b5337af$var$_a2.c) === "function" ? // @ts-expect-error
$8961ae8e4b5337af$var$React.__COMPILER_RUNTIME.c : function c2(size) {
    return $8961ae8e4b5337af$var$React.useMemo(()=>{
        const $ = new Array(size);
        for(let ii = 0; ii < size; ii++)$[ii] = $8961ae8e4b5337af$var$$empty;
        $[$8961ae8e4b5337af$var$$empty] = true;
        return $;
    }, []);
};
var $8961ae8e4b5337af$var$LazyGuardDispatcher = {};
[
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
].forEach((name)=>{
    $8961ae8e4b5337af$var$LazyGuardDispatcher[name] = ()=>{
        throw new Error(`[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `);
    };
});
var $8961ae8e4b5337af$var$originalDispatcher = null;
$8961ae8e4b5337af$var$LazyGuardDispatcher["useMemoCache"] = (count)=>{
    if ($8961ae8e4b5337af$var$originalDispatcher == null) throw new Error("React Compiler internal invariant violation: unexpected null dispatcher");
    else return $8961ae8e4b5337af$var$originalDispatcher.useMemoCache(count);
};
function $8961ae8e4b5337af$var$setCurrent(newDispatcher) {
    $8961ae8e4b5337af$var$ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return $8961ae8e4b5337af$var$ReactSecretInternals.ReactCurrentDispatcher.current;
}
var $8961ae8e4b5337af$var$guardFrames = [];
function $8961ae8e4b5337af$var$$dispatcherGuard(kind) {
    const curr = $8961ae8e4b5337af$var$ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0 /* PushGuardContext */ ) {
        $8961ae8e4b5337af$var$guardFrames.push(curr);
        if ($8961ae8e4b5337af$var$guardFrames.length === 1) $8961ae8e4b5337af$var$originalDispatcher = curr;
        if (curr === $8961ae8e4b5337af$var$LazyGuardDispatcher) throw new Error(`[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`);
        $8961ae8e4b5337af$var$setCurrent($8961ae8e4b5337af$var$LazyGuardDispatcher);
    } else if (kind === 1 /* PopGuardContext */ ) {
        const lastFrame = $8961ae8e4b5337af$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        if ($8961ae8e4b5337af$var$guardFrames.length === 0) $8961ae8e4b5337af$var$originalDispatcher = null;
        $8961ae8e4b5337af$var$setCurrent(lastFrame);
    } else if (kind === 2 /* PushExpectHook */ ) {
        $8961ae8e4b5337af$var$guardFrames.push(curr);
        $8961ae8e4b5337af$var$setCurrent($8961ae8e4b5337af$var$originalDispatcher);
    } else if (kind === 3 /* PopExpectHook */ ) {
        const lastFrame = $8961ae8e4b5337af$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        $8961ae8e4b5337af$var$setCurrent(lastFrame);
    } else throw new Error("React Compiler internal error: unreachable block" + kind);
}
function $8961ae8e4b5337af$var$$reset($) {
    for(let ii = 0; ii < $.length; ii++)$[ii] = $8961ae8e4b5337af$var$$empty;
}
function $8961ae8e4b5337af$var$$makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
}
var $8961ae8e4b5337af$var$renderCounterRegistry = /* @__PURE__ */ new Map();
function $8961ae8e4b5337af$var$clearRenderCounterRegistry() {
    for (const counters of $8961ae8e4b5337af$var$renderCounterRegistry.values())counters.forEach((counter)=>{
        counter.count = 0;
    });
}
function $8961ae8e4b5337af$var$registerRenderCounter(name, val) {
    let counters = $8961ae8e4b5337af$var$renderCounterRegistry.get(name);
    if (counters == null) {
        counters = /* @__PURE__ */ new Set();
        $8961ae8e4b5337af$var$renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
}
function $8961ae8e4b5337af$var$removeRenderCounter(name, val) {
    const counters = $8961ae8e4b5337af$var$renderCounterRegistry.get(name);
    if (counters == null) return;
    counters.delete(val);
}
function $8961ae8e4b5337af$var$useRenderCounter(name) {
    const val = $8961ae8e4b5337af$var$useRef(null);
    if (val.current != null) val.current.count += 1;
    $8961ae8e4b5337af$var$useEffect(()=>{
        if (val.current == null) {
            const counter = {
                count: 0
            };
            $8961ae8e4b5337af$var$registerRenderCounter(name, counter);
            val.current = counter;
        }
        return ()=>{
            if (val.current !== null) $8961ae8e4b5337af$var$removeRenderCounter(name, val.current);
        };
    });
}
var $8961ae8e4b5337af$var$seenErrors = /* @__PURE__ */ new Set();
function $8961ae8e4b5337af$var$$structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
        const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
        if ($8961ae8e4b5337af$var$seenErrors.has(str)) return;
        $8961ae8e4b5337af$var$seenErrors.add(str);
        console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
        if (depth > depthLimit) return;
        else if (oldValue2 === newValue2) return;
        else if (typeof oldValue2 !== typeof newValue2) error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
        else if (typeof oldValue2 === "object") {
            const oldArray = Array.isArray(oldValue2);
            const newArray = Array.isArray(newValue2);
            if (oldValue2 === null && newValue2 !== null) error("null", `type ${typeof newValue2}`, path, depth);
            else if (newValue2 === null) error(`type ${typeof oldValue2}`, "null", path, depth);
            else if (oldValue2 instanceof Map) {
                if (!(newValue2 instanceof Map)) error(`Map instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Map instance with size ${oldValue2.size}`, `Map instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const [k, v] of oldValue2)if (!newValue2.has(k)) error(`Map instance with key ${k}`, `Map instance without key ${k}`, path, depth);
                    else recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
                }
            } else if (newValue2 instanceof Map) error("other value", `Map instance`, path, depth);
            else if (oldValue2 instanceof Set) {
                if (!(newValue2 instanceof Set)) error(`Set instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Set instance with size ${oldValue2.size}`, `Set instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const v of newValue2)if (!oldValue2.has(v)) error(`Set instance without element ${v}`, `Set instance with element ${v}`, path, depth);
                }
            } else if (newValue2 instanceof Set) error("other value", `Set instance`, path, depth);
            else if (oldArray || newArray) {
                if (oldArray !== newArray) error(`type ${oldArray ? "array" : "object"}`, `type ${newArray ? "array" : "object"}`, path, depth);
                else if (oldValue2.length !== newValue2.length) error(`array with length ${oldValue2.length}`, `array with length ${newValue2.length}`, path, depth);
                else for(let ii = 0; ii < oldValue2.length; ii++)recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            } else if ($8961ae8e4b5337af$var$isValidElement(oldValue2) || $8961ae8e4b5337af$var$isValidElement(newValue2)) {
                if ($8961ae8e4b5337af$var$isValidElement(oldValue2) !== $8961ae8e4b5337af$var$isValidElement(newValue2)) error(`type ${$8961ae8e4b5337af$var$isValidElement(oldValue2) ? "React element" : "object"}`, `type ${$8961ae8e4b5337af$var$isValidElement(newValue2) ? "React element" : "object"}`, path, depth);
                else if (oldValue2.type !== newValue2.type) error(`React element of type ${oldValue2.type}`, `React element of type ${newValue2.type}`, path, depth);
                else recur(oldValue2.props, newValue2.props, `[props of ${path}]`, depth + 1);
            } else {
                for(const key in newValue2)if (!(key in oldValue2)) error(`object without key ${key}`, `object with key ${key}`, path, depth);
                for(const key in oldValue2)if (!(key in newValue2)) error(`object with key ${key}`, `object without key ${key}`, path, depth);
                else recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
        } else if (typeof oldValue2 === "function") return;
        else if (isNaN(oldValue2) || isNaN(newValue2)) {
            if (isNaN(oldValue2) !== isNaN(newValue2)) error(`${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`, `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`, path, depth);
        } else if (oldValue2 !== newValue2) error(oldValue2, newValue2, path, depth);
    }
    recur(oldValue, newValue, "", 0);
}

});

parcelRegister("kwYMD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2001a55d2e4c9ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7dec5d911d8d729060e7c86a5f17d210>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2001a55d2e4c9ef$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "labels_issueFieldLabelsReadviewFull_LabelsReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            "action": "THROW",
            "path": "selectedLabelsConnection"
        }
    ],
    "type": "JiraLabelsField"
};
$c2001a55d2e4c9ef$var$node.hash = "3f7bd1f7c0b3da8b1c1b35313d9735b4";
var $c2001a55d2e4c9ef$export$2e2bcd8739ae039 = $c2001a55d2e4c9ef$var$node;

});

parcelRegister("iiHt1", function(module, exports) {
$parcel$export(module.exports, "getLabelHref", () => $95a0728e309b1229$export$a1200807f331a4bd);

var $bnIBr = parcelRequire("bnIBr");
const $95a0728e309b1229$var$CUSTOM_FIELD_PREFIX = 'customfield_';
const $95a0728e309b1229$export$faff4881e53b3cb6 = (fieldId)=>{
    if (fieldId.startsWith($95a0728e309b1229$var$CUSTOM_FIELD_PREFIX)) {
        const customId = fieldId.substring($95a0728e309b1229$var$CUSTOM_FIELD_PREFIX.length, fieldId.length);
        return `cf[${customId}]`;
    }
    return fieldId;
};
const $95a0728e309b1229$export$a1200807f331a4bd = (fieldId, label, baseSearchUrl = '/issues/')=>{
    const jqlEncodedValue = encodeURIComponent(`${$95a0728e309b1229$export$faff4881e53b3cb6(fieldId)} = ${(0, $bnIBr.toQuotedString)(label)}`);
    return `${baseSearchUrl}?jql=${jqlEncodedValue}`;
};

});

parcelRegister("fjnDV", function(module, exports) {
$parcel$export(module.exports, "LabelsTruncatedReadView", () => $d18877e75f12e55a$export$95d698e57184b56c);

var $1ClZA = parcelRequire("1ClZA");

var $bNhhZ = parcelRequire("bNhhZ");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $iiHt1 = parcelRequire("iiHt1");

var $gZJc1 = parcelRequire("gZJc1");
const $d18877e75f12e55a$export$627d17b212b38ee0 = (label)=>{
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const colorName = label?.color?.colorKey;
        const { backgroundColor: color } = (0, $051tO.getColorMetadata)(colorName || (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
        return color;
    }
    if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
        const { backgroundColor: color } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
        return color;
    }
};
const $d18877e75f12e55a$export$95d698e57184b56c = (0, $1ClZA.isReactCompilerForLabelsFieldEnabled)() ? (t0)=>{
    const $ = (0, $bNhhZ.c)(17);
    const { baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues, isHoverPopoverEnabled: isHoverPopoverEnabled } = t0;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $gZJc1.default).noValueTextExperiment);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const noValueTextExperiment = t1;
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    if (labelValues.length === 0) {
        const t2 = isExperimentEnabled ? noValueTextExperiment : undefined;
        let t3;
        if ($[2] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
                emptyText: t2
            });
            $[2] = t2;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    let t2;
    if ($[4] !== baseSearchUrl || $[5] !== fieldId || $[6] !== labelValues) {
        let t3;
        if ($[8] !== baseSearchUrl || $[9] !== fieldId) {
            t3 = (label)=>{
                if ((0, $cxKOj.expVal)("adding-color-to-labels-field-in-jira-experiment", "isColoredLabelsEnabled", false) || (0, $cxKOj.expVal)("adding-color-to-labels-field-experiment-milestone2", "isColorfulNewLabelsEnabled", false)) return {
                    name: label.name,
                    key: label.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
                    isColored: true,
                    ...(0, $cxKOj.expVal)("adding-color-to-labels-field-experiment-milestone2", "isColorfulNewLabelsEnabled", false) ? {
                        color: $d18877e75f12e55a$export$627d17b212b38ee0(label)
                    } : {}
                };
                return {
                    name: label.name,
                    key: label.name,
                    href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl)
                };
            };
            $[8] = baseSearchUrl;
            $[9] = fieldId;
            $[10] = t3;
        } else t3 = $[10];
        t2 = labelValues.map(t3);
        $[4] = baseSearchUrl;
        $[5] = fieldId;
        $[6] = labelValues;
        $[7] = t2;
    } else t2 = $[7];
    const items = t2;
    let t3;
    if ($[11] !== formatMessage) {
        t3 = formatMessage((0, $gZJc1.default).showMoreTooltip);
        $[11] = formatMessage;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== isHoverPopoverEnabled || $[14] !== items || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            xcss: $d18877e75f12e55a$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
            items: items,
            ItemComponent: (0, $1tX0c.TagItem),
            PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
            showMoreTooltip: t3,
            isHoverPopoverEnabled: isHoverPopoverEnabled
        }));
        $[13] = isHoverPopoverEnabled;
        $[14] = items;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ baseSearchUrl: baseSearchUrl, fieldId: fieldId, labelValues: labelValues, isHoverPopoverEnabled: isHoverPopoverEnabled })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $gZJc1.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    if (labelValues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    });
    const items = labelValues.map((label)=>{
        if ((0, $cxKOj.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) return {
            name: label.name,
            key: label.name,
            href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl),
            isColored: true,
            ...(0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
                color: $d18877e75f12e55a$export$627d17b212b38ee0(label)
            } : {}
        };
        return {
            name: label.name,
            key: label.name,
            href: (0, $iiHt1.getLabelHref)(fieldId, label.name, baseSearchUrl)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: $d18877e75f12e55a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: items,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $gZJc1.default).showMoreTooltip),
        isHoverPopoverEnabled: isHoverPopoverEnabled
    }));
};
const $d18877e75f12e55a$var$containerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("gZJc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9950418b3a51d36e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9950418b3a51d36e$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-labels-readview-full.labels.compact.show-more-tooltip",
        "defaultMessage": "See more labels"
    },
    noValueTextExperiment: {
        "id": "issue-field-labels-readview-full.labels.compact.no-value-text-experiment",
        "defaultMessage": "Add labels"
    }
});
var $9950418b3a51d36e$export$2e2bcd8739ae039 = $9950418b3a51d36e$var$messages;

});



parcelRegister("h67Wd", function(module, exports) {
$parcel$export(module.exports, "useLabelsCache", () => $4950fca072871133$export$18b2bd971a089d24);

var $eJOHy = parcelRequire("eJOHy");

var $jKTNh = parcelRequire("jKTNh");

var $eSnSE = parcelRequire("eSnSE");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $aCTqO = parcelRequire("aCTqO");
const $4950fca072871133$var$useRerenderTrigger = ()=>{
    const [token, setSymbol] = (0, $eJOHy.useState)(Symbol('useRerenderTrigger_initial'));
    const refreshToken = (0, $eJOHy.useCallback)(()=>setSymbol(Symbol('useRerenderTrigger_rerender')), []);
    return [
        token,
        refreshToken
    ];
};
const $4950fca072871133$var$isStringArray = (labels)=>{
    return labels.length > 0 && typeof labels[0] === 'string';
};
const $4950fca072871133$var$isColoredLabelArray = (labels)=>{
    return labels.length > 0 && typeof labels[0] !== 'string';
};
const $4950fca072871133$export$18b2bd971a089d24 = (fieldId)=>{
    const labelsCache = (0, $jKTNh.getLabelsCache)(fieldId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [cachedLabels, setCachedLabels] = (0, $eJOHy.useState)([]);
    const [cacheRefreshToken, refreshCache] = $4950fca072871133$var$useRerenderTrigger();
    const addToCache = (0, $eJOHy.useCallback)((labels)=>{
        // Filter out labels with spaces upfront if feature flag is enabled
        let labelsToProcess;
        if (!(0, $4cTDP.fg)('kenji-jjj-fix-spaced-label-recommendation')) labelsToProcess = labels;
        else if (labels.length === 0) labelsToProcess = labels;
        else if ($4950fca072871133$var$isStringArray(labels)) // String array - filter out labels with spaces
        labelsToProcess = labels.filter((label)=>!label.includes(' '));
        else if ($4950fca072871133$var$isColoredLabelArray(labels)) // ColoredLabel array - filter out labels with spaces
        labelsToProcess = labels.filter((label)=>!label.name?.includes(' '));
        else labelsToProcess = labels;
        Promise.all(labelsToProcess.map(async (label)=>{
            try {
                if (typeof label !== 'string') {
                    const cachedOption = await labelsCache.get(label.name);
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                        isFromCache: Boolean(cachedOption?.label)
                    });
                    return label && labelsCache.set(`${label.name}`, {
                        label: label.name,
                        ...label.color ? {
                            color: label.color
                        } : {}
                    });
                }
                const cachedOption = await labelsCache.get(label);
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache set', {
                    isFromCache: Boolean(cachedOption?.label)
                });
                return label && labelsCache.set(`${label}`, {
                    label: label
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view.labels.cache.set', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    const removeFromCache = (0, $eJOHy.useCallback)((labels)=>{
        Promise.all(labels.map(async (label)=>{
            try {
                const cachedOption = await labelsCache.get(label);
                if (cachedOption) {
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'labelPickerCache removed');
                    return cachedOption && labelsCache.remove(`${cachedOption.label}`);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view.labels.cache.remove', error.message);
            }
            return undefined;
        })).then(()=>{
            refreshCache(); // trigger an update of the returned cached labels value
        });
    }, [
        createAnalyticsEvent,
        labelsCache,
        refreshCache
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const getCachedLabels = async ()=>{
            const cachedItems = await labelsCache.getAll();
            // Filter out labels with spaces before processing
            const filteredCachedItems = (0, $4cTDP.fg)('kenji-jjj-fix-spaced-label-recommendation') ? cachedItems.filter((item)=>{
                return item.label && !item.label.includes(' ');
            }) : cachedItems;
            const transformedCachedItems = (0, $aCTqO.transformCacheEntries)(filteredCachedItems);
            const labelOptions = (0, $aCTqO.mapCachedItemsToLabelOptions)(transformedCachedItems);
            setCachedLabels(labelOptions);
        };
        getCachedLabels();
    // Having cacheRefreshToken in the deps array allows us to retrigger a loading of the cached values whenever refreshCache is called
    }, [
        cacheRefreshToken,
        labelsCache
    ]);
    return [
        cachedLabels,
        {
            addToCache: addToCache,
            removeFromCache: removeFromCache
        }
    ];
};

});
parcelRegister("jKTNh", function(module, exports) {
$parcel$export(module.exports, "getLabelsCache", () => $f4c5914506d97267$export$f7e90ae127ed72ef);

var $gB3jQ = parcelRequire("gB3jQ");

var $bKn7P = parcelRequire("bKn7P");
const $f4c5914506d97267$var$labelsCaches = {};
const $f4c5914506d97267$export$f7e90ae127ed72ef = (labelsFieldId)=>{
    const cacheKey = labelsFieldId || (0, $bKn7P.props).cacheKey;
    if (!$f4c5914506d97267$var$labelsCaches[cacheKey]) $f4c5914506d97267$var$labelsCaches[cacheKey] = (0, $gB3jQ.default)({
        ...(0, $bKn7P.props),
        cacheKey: cacheKey
    });
    return $f4c5914506d97267$var$labelsCaches[cacheKey];
};

});
parcelRegister("bKn7P", function(module, exports) {
$parcel$export(module.exports, "props", () => $734b627f60d019d2$export$8128bb6492cf3de7);

const $734b627f60d019d2$var$MAX_RESULTS = 10;
const $734b627f60d019d2$var$CACHE_SIZE = $734b627f60d019d2$var$MAX_RESULTS * 2;
const $734b627f60d019d2$var$LABELS_CACHE_KEY = 'labels';
const $734b627f60d019d2$export$8128bb6492cf3de7 = {
    size: $734b627f60d019d2$var$CACHE_SIZE,
    cacheKey: $734b627f60d019d2$var$LABELS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)
};

});
const $08db7ac9f9f525e1$export$7271276960377470 = 'common-cache';
const $08db7ac9f9f525e1$export$a61768fefd33fcb1 = 'capacity exceeded';
const $08db7ac9f9f525e1$export$6c4d37c7f376a1de = 'clear';
const $08db7ac9f9f525e1$export$e271b26eefe41db8 = 'update';
const $08db7ac9f9f525e1$export$4bd2facc4a3e6aa1 = 'delete';
const $08db7ac9f9f525e1$export$26d12233004a7a60 = 'delete stale entry';
const $08db7ac9f9f525e1$export$1bb358554aac31c1 = 'get';
const $08db7ac9f9f525e1$export$61f74127e2b53cbe = 'hydrate';
const $08db7ac9f9f525e1$export$5e8f180ef0142226 = 'set';
const $08db7ac9f9f525e1$export$9eb68924983e00fb = 'get entries';
const $08db7ac9f9f525e1$export$bf340b99118a1511 = 'memory';
const $08db7ac9f9f525e1$export$2670cb7d5d4f7184 = 'local';
const $08db7ac9f9f525e1$export$b796061ff0c82e1a = 'session';



parcelRegister("aCTqO", function(module, exports) {
$parcel$export(module.exports, "mapCachedItemsToLabelOptions", () => $a0b3ef3b5b5776a6$export$9ba85e25262c8a32);
$parcel$export(module.exports, "transformCacheEntries", () => $a0b3ef3b5b5776a6$export$64c1e7aa265973f8);

const $a0b3ef3b5b5776a6$export$9ba85e25262c8a32 = (items)=>items.map((item)=>({
            label: item.label,
            value: item.label,
            ...item.color ? {
                color: item.color
            } : {}
        }));
const $a0b3ef3b5b5776a6$export$64c1e7aa265973f8 = (items)=>items.slice(-1 * (0, $c663f6eba89f5eed$export$f6b2881bc1090cea)).reverse();

});
const $c663f6eba89f5eed$export$ffb1c0893bcc2c13 = 'customfield_';
const $c663f6eba89f5eed$export$f6b2881bc1090cea = 5;



parcelRegister("5UIJ7", function(module, exports) {
$parcel$export(module.exports, "useLabelsValidator", () => $5feb26d49619397f$export$990e7f2d0da9a96a);
$parcel$export(module.exports, "getProjectScopeLabelCheckboxValueFromLocalStorage", () => $5feb26d49619397f$export$6181698b046b748f);
$parcel$export(module.exports, "setProjectScopeLabelCheckboxValueFromLocalStorage", () => $5feb26d49619397f$export$9e31f8fbc2feb98f);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");


var $at2Tf = parcelRequire("at2Tf");
const $5feb26d49619397f$export$990e7f2d0da9a96a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const change = (0, $eJOHy.useCallback)((newValues)=>{
        for(let i = newValues.length - 1; i >= 0; i -= 1){
            const { __isNew__: __isNew__, value: value } = newValues[i];
            if (__isNew__ === true) {
                if (value.includes(' ')) return {
                    type: 'error',
                    message: formatMessage((0, $at2Tf.default).newLabelContainsSpacesError)
                };
                if (value.length > (0, $705a9ff31bc3258c$export$e85fda072a12fed9)) return {
                    type: 'error',
                    message: formatMessage((0, $at2Tf.default).newLabelTooLongError, {
                        maxLength: (0, $705a9ff31bc3258c$export$e85fda072a12fed9)
                    })
                };
            }
        }
        if (newValues.length > (0, $705a9ff31bc3258c$export$45f4d7adca48db10)) return {
            type: 'warning',
            message: formatMessage((0, $at2Tf.default).maximumNumberOfLabelsExceededError, {
                maxNumberOfLabels: (0, $705a9ff31bc3258c$export$45f4d7adca48db10)
            })
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        change: change
    };
};
const $5feb26d49619397f$export$f04a317778b8db56 = 'restrict_labels_to_projects_checkbox_value';
const $5feb26d49619397f$export$b19885560047617b = (0, $3hRxq.createLocalStorageProvider)('project-scoped-labels');
const $5feb26d49619397f$export$6181698b046b748f = ()=>{
    if (!(0, $4cTDP.fg)('labels_restricted_to_project_experiment')) return false;
    return $5feb26d49619397f$export$b19885560047617b.get($5feb26d49619397f$export$f04a317778b8db56) || false;
};
const $5feb26d49619397f$export$9e31f8fbc2feb98f = (value)=>{
    return $5feb26d49619397f$export$b19885560047617b.set($5feb26d49619397f$export$f04a317778b8db56, value);
};

});
const $705a9ff31bc3258c$export$45f4d7adca48db10 = 55;
const $705a9ff31bc3258c$export$e85fda072a12fed9 = 255;

parcelRegister("at2Tf", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6558214ceb0917$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0d6558214ceb0917$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-title",
        "defaultMessage": "We couldn't set the labels value"
    },
    errorMessage: {
        "id": "issue-field-labels-inline-edit-view-full.labels.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    noValueText: {
        "id": "issue-field-labels-inline-edit-view-full.labels.no-value-text",
        "defaultMessage": "None"
    },
    newLabelTooLongError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-too-long-error",
        "defaultMessage": "Labels can't be more than {maxLength} characters."
    },
    newLabelContainsSpacesError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.new-label-contains-spaces-error",
        "defaultMessage": "Labels can't have spaces."
    },
    maximumNumberOfLabelsExceededError: {
        "id": "issue-field-labels-inline-edit-view-full.labels.maximum-number-of-labels-exceeded-error",
        "defaultMessage": "Can't have more than {maxNumberOfLabels} labels."
    }
});
var $0d6558214ceb0917$export$2e2bcd8739ae039 = $0d6558214ceb0917$var$messages;

});




parcelRegister("jG8is", function(module, exports) {
$parcel$export(module.exports, "MultiSelectCell", () => $aebfac5a3d8db8f6$export$4ae427e87d8482e2);

var $cV0Im = parcelRequire("cV0Im");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cqb3z = parcelRequire("cqb3z");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $aebfac5a3d8db8f6$export$4ae427e87d8482e2 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $cV0Im.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqb3z.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $aebfac5a3d8db8f6$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqb3z.MultiSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $aebfac5a3d8db8f6$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $aebfac5a3d8db8f6$var$customTargetStyles : $aebfac5a3d8db8f6$var$customTargetStylesOld,
        ref: ref
    });
});
const $aebfac5a3d8db8f6$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $aebfac5a3d8db8f6$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("cV0Im", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ca410a98ec3313e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30280ee8bff5652917405813a15cc39e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ca410a98ec3313e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectField"
};
$8ca410a98ec3313e$var$node.hash = "46d86714fadeb62e9681c95e4741f478";
var $8ca410a98ec3313e$export$2e2bcd8739ae039 = $8ca410a98ec3313e$var$node;

});

parcelRegister("cqb3z", function(module, exports) {
$parcel$export(module.exports, "MultiSelectInlineEditViewWithIsEditable", () => $b97be3da31764f0c$export$2dcdfc567a992efd);

var $4VuI3 = parcelRequire("4VuI3");

var $ygzCA = parcelRequire("ygzCA");

var $2QpOv = parcelRequire("2QpOv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8xlP3 = parcelRequire("8xlP3");

var $l8r9T = parcelRequire("l8r9T");

var $auNLL = parcelRequire("auNLL");

var $bJscI = parcelRequire("bJscI");
const $b97be3da31764f0c$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b97be3da31764f0c$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $b97be3da31764f0c$export$2dcdfc567a992efd = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $2QpOv.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $ygzCA.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedOptions: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                optionId: edge?.node?.optionId ?? '',
                value: edge?.node?.value ?? '',
                selectableLabel: edge?.node?.value ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOptions: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            value: edge.selectableLabel ?? '',
                                            optionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b97be3da31764f0c$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiSelect'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b97be3da31764f0c$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l8r9T.MultiSelectReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            openMenuOnFocus: true,
            spacing: spacing
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8xlP3.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $b97be3da31764f0c$export$9d754a44e976e46a = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $4VuI3.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b97be3da31764f0c$export$2dcdfc567a992efd, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("4VuI3", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d7fcdab25bd9bed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c8784dc5c6cf0181fba42792ac91445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d7fcdab25bd9bed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$1d7fcdab25bd9bed$var$node.hash = "d32e2ded197d2b2b4bc30729f9587a62";
var $1d7fcdab25bd9bed$export$2e2bcd8739ae039 = $1d7fcdab25bd9bed$var$node;

});

parcelRegister("ygzCA", function(module, exports) {
$parcel$export(module.exports, "default", () => $56f2cf57eb77e224$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab89800218576513b704c68f8ce1ac28>>
 * @relayHash b4af6905e862873a8846fa4a71f56a57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d
const $56f2cf57eb77e224$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12ff733a258befd165b334ced2a9a4ad512afe20c3502276964dc077438a292d",
            "metadata": {},
            "name": "multiSelect_issueFieldMultiSelect_MultiSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$56f2cf57eb77e224$var$node.hash = "cb08d7ecaba6a03f3f00edae8eb1b5a3";
var $56f2cf57eb77e224$export$2e2bcd8739ae039 = $56f2cf57eb77e224$var$node;

});

parcelRegister("2QpOv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a6d495cf00d0cbd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<357beb53165a8a4df485e730345c9792>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a6d495cf00d0cbd$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiSelect_issueFieldMultiSelectInlineEditFull_MultiSelectInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView"
            },
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectField"
    };
}();
$3a6d495cf00d0cbd$var$node.hash = "51442265271466c01819bfe490c82976";
var $3a6d495cf00d0cbd$export$2e2bcd8739ae039 = $3a6d495cf00d0cbd$var$node;

});

parcelRegister("8xlP3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6be29c11818f392$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a6be29c11818f392$var$MultiSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("1CasD"))), {
        moduleId: "f60cd571",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $a6be29c11818f392$export$2e2bcd8739ae039 = $a6be29c11818f392$var$MultiSelectEditViewEntryPoint;

});

parcelRegister("l8r9T", function(module, exports) {
$parcel$export(module.exports, "MultiSelectReadView", () => $3094c29efbad1630$export$ecebbf80cc7a07f1);

var $3aszq = parcelRequire("3aszq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $1tX0c = parcelRequire("1tX0c");

var $2j0d2 = parcelRequire("2j0d2");

var $k6Nau = parcelRequire("k6Nau");

var $3Lkm9 = parcelRequire("3Lkm9");

var $4cTDP = parcelRequire("4cTDP");

var $hIfdw = parcelRequire("hIfdw");
const $3094c29efbad1630$export$ecebbf80cc7a07f1 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $3aszq.default), fragmentRef);
    const transformedSelectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!data?.selectedOptions?.edges) return null;
        const selectedOptions = data.selectedOptions.edges.map((edge)=>edge?.node).filter((node)=>Boolean(node?.value));
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.value,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedOptions?.edges
    ]);
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenMultiSelectPlaceholderEmptyFieldText
    });
    if (isTruncated) {
        let ItemComponent = null;
        if ((0, $4cTDP.fg)('multi_select_label_truncation_fix')) ItemComponent = (0, $kp5kj.OptionTag);
        else ItemComponent = isTruncatedWithHoverPopover ? (0, $1tX0c.TagItem) : (0, $kp5kj.OptionTag);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            space: "space.100",
            role: "group",
            xcss: isTruncatedWithHoverPopover && $3094c29efbad1630$var$inlineStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
            items: transformedSelectedOptions,
            ItemComponent: ItemComponent,
            PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
            showMoreTooltip: formatMessage((0, $hIfdw.default).showMoreTooltip),
            isHoverPopoverEnabled: isTruncatedWithHoverPopover
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $3094c29efbad1630$var$inlineStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("3aszq", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfb087594e0a6656$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24f8ea29f5b0a9e715aebdeec184bd0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dfb087594e0a6656$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiSelect_issueFieldMultiSelectReadviewFull_MultiSelectReadView",
    "selections": [
        {
            "concreteType": "JiraOptionConnection",
            "kind": "LinkedField",
            "name": "selectedOptions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectField"
};
$dfb087594e0a6656$var$node.hash = "30f1fb233423b8843508f947cb7c3c09";
var $dfb087594e0a6656$export$2e2bcd8739ae039 = $dfb087594e0a6656$var$node;

});

parcelRegister("kp5kj", function(module, exports) {
$parcel$export(module.exports, "OptionTag", () => $3f06606f2017e535$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $cxKOj = parcelRequire("cxKOj");

var $051tO = parcelRequire("051tO");
const $3f06606f2017e535$export$5991b62d89f5cc = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true, showTooltip: showTooltip = false, isColoredLabel: isColoredLabel }, ref)=>{
    const { backgroundColor: tagColor } = (0, $051tO.getColorMetadata)(color);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3f06606f2017e535$var$tagWrapperStyles,
            isInteractive && $3f06606f2017e535$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, isColoredLabel && (0, $cxKOj.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: `option-color-picker.option-tag.${color || 'default'}`,
        xcss: $3f06606f2017e535$var$styledTagsStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: tagColor
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f06606f2017e535$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3f06606f2017e535$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: name
    }, content)) : content;
}));
const $3f06606f2017e535$var$tooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $3f06606f2017e535$var$tagWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $3f06606f2017e535$var$interactiveStyles = (0, $1DXK0.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f06606f2017e535$var$StyledTagBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$StyledTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $3f06606f2017e535$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko3gvi _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$styledTagsStyles = (0, $1DXK0.xcss)({
    font: 'font.body',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    paddingRight: 'space.050',
    paddingLeft: 'space.050',
    maxWidth: '180px'
});

});

parcelRegister("hIfdw", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db827a084446152$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4db827a084446152$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-select-readview-full.multi-select.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});
var $4db827a084446152$export$2e2bcd8739ae039 = $4db827a084446152$var$messages;

});




parcelRegister("acnWs", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerCell", () => $1d87a0fc1026ff5f$export$900adf2a2bd19e48);

var $81TPT = parcelRequire("81TPT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1b9aE = parcelRequire("1b9aE");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $1d87a0fc1026ff5f$export$900adf2a2bd19e48 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $81TPT.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1b9aE.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $1d87a0fc1026ff5f$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1b9aE.MultiUserPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        menuPosition: "fixed",
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true
    });
};
const $1d87a0fc1026ff5f$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1d87a0fc1026ff5f$var$customTargetStyles : $1d87a0fc1026ff5f$var$customTargetStylesOld,
        ref: ref
    });
});
const $1d87a0fc1026ff5f$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $1d87a0fc1026ff5f$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("81TPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3d7402bc1fe429b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdf07695cbe24b3c9dcff7c7fb6f4a74>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3d7402bc1fe429b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiUserPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$f3d7402bc1fe429b$var$node.hash = "b122136283417cdc5ffc57377984a2bb";
var $f3d7402bc1fe429b$export$2e2bcd8739ae039 = $f3d7402bc1fe429b$var$node;

});

parcelRegister("1b9aE", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerInlineEditViewWithIsEditable", () => $bd008b5eaa50c36c$export$2d98458340508c60);
$parcel$export(module.exports, "MultiUserPickerInlineEditView", () => $bd008b5eaa50c36c$export$117723181a3f3b6b);

var $1vTZH = parcelRequire("1vTZH");

var $koE1D = parcelRequire("koE1D");

var $8bqDU = parcelRequire("8bqDU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $22FmW = parcelRequire("22FmW");

var $flmqW = parcelRequire("flmqW");

var $8y7U1 = parcelRequire("8y7U1");

var $auNLL = parcelRequire("auNLL");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");
const $bd008b5eaa50c36c$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-user-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $bd008b5eaa50c36c$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $bd008b5eaa50c36c$export$2d98458340508c60 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact' })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $8bqDU.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $koE1D.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedUsersConnection: selectedUsersConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedUsersConnection?.edges) return null;
        return selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    }, [
        selectedUsersConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((users, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(users);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: users?.map((user)=>user.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedUsersConnection: {
                                edges: users?.map((user)=>({
                                        node: {
                                            __typename: 'AtlassianAccountUser',
                                            ...user
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $bd008b5eaa50c36c$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiUserPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd008b5eaa50c36c$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8y7U1.MultiUserPickerReadView), {
            fragmentRef: data
        })), [
        data
    ]);
    // #endregion
    // #region Edit view
    const transformedEditViewValue = (0, $eJOHy.useMemo)(()=>{
        if (!updatedValue) return null;
        return updatedValue.map((0, $22FmW.transformAggToUserOption));
    }, [
        updatedValue
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: transformedEditViewValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing,
            inputId: uniqueFieldId,
            ariaLabel: fieldName
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $flmqW.default),
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $bd008b5eaa50c36c$export$117723181a3f3b6b = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1vTZH.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd008b5eaa50c36c$export$2d98458340508c60, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1vTZH", function(module, exports) {
$parcel$export(module.exports, "default", () => $49f2d17a28c1bbb2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c4638e38e1d56970af022bce2a6a8dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $49f2d17a28c1bbb2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$49f2d17a28c1bbb2$var$node.hash = "cce81be96601eacce28b3398c7aff2e6";
var $49f2d17a28c1bbb2$export$2e2bcd8739ae039 = $49f2d17a28c1bbb2$var$node;

});

parcelRegister("koE1D", function(module, exports) {
$parcel$export(module.exports, "default", () => $010de0568afd1352$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8bd4e0e5d9e1acf3340c27b0e3b8df1>>
 * @relayHash 562b3a946b93846046a2c880c621d019
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0d7fe195cdf6fa0ec9c4cc82b4535cfebcbdf6f940b25c2dd411f4d2a0ff25f
const $010de0568afd1352$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountStatus"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "email"
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c0d7fe195cdf6fa0ec9c4cc82b4535cfebcbdf6f940b25c2dd411f4d2a0ff25f",
            "metadata": {},
            "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$010de0568afd1352$var$node.hash = "66516ecfc9f74fa693150553eb2bae7f";
var $010de0568afd1352$export$2e2bcd8739ae039 = $010de0568afd1352$var$node;

});

parcelRegister("8bqDU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ead0575469c11ba7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87c2e0fc25d3c82a0a376ce7418f273f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ead0575469c11ba7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView"
            },
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountStatus"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleSelectUserPickerField"
    };
}();
$ead0575469c11ba7$var$node.hash = "b0466005c00a3d3242fa4c867100b929";
var $ead0575469c11ba7$export$2e2bcd8739ae039 = $ead0575469c11ba7$var$node;

});

parcelRegister("22FmW", function(module, exports) {
$parcel$export(module.exports, "transformAggToUserOption", () => $0a955f742f9dce61$export$e466b9791a3fee63);
const $0a955f742f9dce61$export$e466b9791a3fee63 = (user)=>({
        avatarUrl: user.picture,
        id: user.id,
        accountId: user.accountId,
        name: user.name,
        active: user.accountStatus === 'active',
        byline: user.email ?? undefined,
        appType: user.appType
    });

});

parcelRegister("flmqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8227025ef6ca891a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $8227025ef6ca891a$var$MultiUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6Q5wh")), {
        moduleId: "d8224b35",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $8227025ef6ca891a$export$2e2bcd8739ae039 = $8227025ef6ca891a$var$MultiUserPickerEditViewEntryPoint;

});
parcelRegister("6Q5wh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("74Iit").then(()=>parcelRequire('dfmeK'));

});


parcelRegister("8y7U1", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerReadView", () => $84ea473a7b6539c0$export$183c102b43ea6c63);

var $62qvA = parcelRequire("62qvA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gqBnP = parcelRequire("gqBnP");

var $d9T1A = parcelRequire("d9T1A");

var $4cTDP = parcelRequire("4cTDP");

var $9yHlD = parcelRequire("9yHlD");
const $84ea473a7b6539c0$export$183c102b43ea6c63 = ({ fragmentRef: fragmentRef })=>{
    const { selectedUsersConnection: selectedUsersConnection } = (0, $j4oe4.useFragment)((0, $62qvA.default), fragmentRef);
    const transformedData = (0, $eJOHy.useMemo)(()=>{
        const filteredEdges = selectedUsersConnection?.edges?.filter((edge)=>Boolean(edge?.node)) ?? [];
        return filteredEdges.map((edge)=>({
                name: edge.node.name,
                key: edge.node.accountId,
                src: edge.node.picture
            }));
    }, [
        selectedUsersConnection?.edges
    ]);
    if ((0, $4cTDP.fg)('jsc_inline_edit_fast_follow_field_types')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9yHlD.UserConnectionReadView), {
        fragmentRef: selectedUsersConnection ?? null
    });
    if (transformedData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        data: transformedData,
        size: "small"
    });
};

});
parcelRegister("62qvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd8c043d1d313584$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0909847a960d2365b5bf01eca759700d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd8c043d1d313584$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPickerReadviewFull_MultiUserPickerReadView",
    "selections": [
        {
            "concreteType": "JiraUserConnection",
            "kind": "LinkedField",
            "name": "selectedUsersConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "UserConnectionReadView"
                },
                {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleSelectUserPickerField"
};
$dd8c043d1d313584$var$node.hash = "e7c567c090efcaaf1ee9f347df482399";
var $dd8c043d1d313584$export$2e2bcd8739ae039 = $dd8c043d1d313584$var$node;

});

parcelRegister("9yHlD", function(module, exports) {
$parcel$export(module.exports, "UserConnectionReadView", () => $5755e0fcc33e5d35$export$9e5ab932424a081a);

var $377RN = parcelRequire("377RN");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gqBnP = parcelRequire("gqBnP");

var $d9T1A = parcelRequire("d9T1A");
const $5755e0fcc33e5d35$export$9e5ab932424a081a = ({ avatarGroupOverrides: avatarGroupOverrides, fragmentRef: fragmentRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $377RN.default), fragmentRef);
    const transformedData = (0, $eJOHy.useMemo)(()=>{
        const filteredEdges = data?.edges?.filter((edge)=>Boolean(edge?.node)) ?? [];
        return filteredEdges.map((edge)=>({
                name: edge.node.name,
                key: edge.node.accountId,
                src: edge.node.picture
            }));
    }, [
        data?.edges
    ]);
    if (transformedData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        data: transformedData,
        overrides: avatarGroupOverrides,
        size: "small"
    });
};

});
parcelRegister("377RN", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eb793e9534f18f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a90643615e98ab2e1349de4e54e3754>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5eb793e9534f18f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserConnectionReadView",
    "selections": [
        {
            "concreteType": "JiraUserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraUserConnection"
};
$5eb793e9534f18f6$var$node.hash = "cfc79c27bbbda8b9e1a6bde015d76c82";
var $5eb793e9534f18f6$export$2e2bcd8739ae039 = $5eb793e9534f18f6$var$node;

});





parcelRegister("fjuAd", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagesCell", () => $46d7fc6ea1d42d7c$export$486bd1bbeaa77e1b);

var $bhyR0 = parcelRequire("bhyR0");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lIUOF = parcelRequire("lIUOF");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
const $46d7fc6ea1d42d7c$export$486bd1bbeaa77e1b = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $bhyR0.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lIUOF.ConfluencePagesInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        isTruncated: shouldTruncate,
        menuPosition: "fixed",
        readViewFitContainerHeight: true
    });
};

});
parcelRegister("bhyR0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ab77be8b2948a06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f85988df5b4096f46127ec23619e48b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ab77be8b2948a06$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ConfluencePagesCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$6ab77be8b2948a06$var$node.hash = "4feb137c78c79dda7d51e4a768ceade1";
var $6ab77be8b2948a06$export$2e2bcd8739ae039 = $6ab77be8b2948a06$var$node;

});

parcelRegister("lIUOF", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagesInlineEditViewWithIsEditable", () => $cdb3021b77eb3aaa$export$efa01917dd201830);

var $IEFvw = parcelRequire("IEFvw");

var $5dE3S = parcelRequire("5dE3S");

var $kxS3D = parcelRequire("kxS3D");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $42SRb = parcelRequire("42SRb");

var $gGrR8 = parcelRequire("gGrR8");
const $cdb3021b77eb3aaa$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-confluence-pages-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $cdb3021b77eb3aaa$var$isEqualOption = (a, b)=>{
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.url));
    return b.every((option)=>aIdSet.has(option.url));
};
const $cdb3021b77eb3aaa$export$efa01917dd201830 = ({ editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $kxS3D.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $5dE3S.default));
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: fieldName, type: fieldType, confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>confluenceRemoteIssueLinks?.edges?.map((edge)=>edge?.node).filter(Boolean).map((node)=>{
            const url = (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') ? node.pageContent?.href ?? node.href ?? '' : node.href ?? '';
            return {
                id: node.id,
                url: url
            };
        }) ?? [], [
        confluenceRemoteIssueLinks
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            // Retain the ID of existing linked pages and use the URL for new links to add.
                            links: value.map(({ id: id, url: url })=>id ? {
                                    id: id
                                } : {
                                    href: url
                                }),
                            operation: 'SET'
                        }
                    ]
                },
                isJiraConfluencePageContentEnabled: (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout')
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateConfluenceRemoteIssueLinksField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateConfluenceRemoteIssueLinksField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            confluenceRemoteIssueLinks: {
                                totalCount: value.length,
                                edges: value.map((option)=>({
                                        node: {
                                            id: option.id ?? (0, $aXKmr.v4)(),
                                            href: option.url,
                                            pageContent: (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') ? {
                                                __typename: 'JiraConfluencePageContentDetails',
                                                href: option.url
                                            } : null
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $cdb3021b77eb3aaa$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue
    });
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdb3021b77eb3aaa$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gGrR8.ConfluencePagesReadView), {
            isTruncated: isTruncated,
            fragmentRef: data
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            initialIsOpen: true,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $42SRb.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $cdb3021b77eb3aaa$export$f4b4c94c27bd1239 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $IEFvw.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdb3021b77eb3aaa$export$efa01917dd201830, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("IEFvw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2f79f746b9faa3d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af30466501d29bf9367df09283f83219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d2f79f746b9faa3d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraConfluenceRemoteIssueLinksField"
};
$d2f79f746b9faa3d$var$node.hash = "b82ba55e135c40c22b29327df36827d2";
var $d2f79f746b9faa3d$export$2e2bcd8739ae039 = $d2f79f746b9faa3d$var$node;

});

parcelRegister("5dE3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $79ee585cf2db4239$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<169509d56041966e298998cb87a38e17>>
 * @relayHash 356127a3390d1de988ecf2b4a1c1a03c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7b140651da7182c815fbb41a5ffa4914e5873e27f703bb3bf555585dc1ffb61

var $jvWSl = parcelRequire("jvWSl");
const $79ee585cf2db4239$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraConfluencePageContentEnabled"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "href"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "JiraConfluencePageContentDetails"
    }, v9 = [
        {
            "kind": "LinkedField",
            "name": "pageContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v8 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
                                        },
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "condition": "isJiraConfluencePageContentEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "pageContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateConfluenceRemoteIssueLinksField",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraConfluenceRemoteIssueLinksField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": v9 /*: any*/ 
                                                                },
                                                                {
                                                                    "condition": "isJiraConfluencePageContentEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": v9 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                }
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c7b140651da7182c815fbb41a5ffa4914e5873e27f703bb3bf555585dc1ffb61",
            "metadata": {},
            "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$79ee585cf2db4239$var$node.hash = "6df37fe378e93b2269d708c82fda03c4";
var $79ee585cf2db4239$export$2e2bcd8739ae039 = $79ee585cf2db4239$var$node;

});

parcelRegister("kxS3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb40e5316ae8e3d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e3a18ee915c0b08d612d2e87cfc9491>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eb40e5316ae8e3d4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "href"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            }
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    };
}();
$eb40e5316ae8e3d4$var$node.hash = "0a786319535ed66ad895589d6a3c3b0d";
var $eb40e5316ae8e3d4$export$2e2bcd8739ae039 = $eb40e5316ae8e3d4$var$node;

});

parcelRegister("42SRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $10e6d0a5d209f87f$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $10e6d0a5d209f87f$var$ConfluencePagesEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1Xexh")), {
        moduleId: "7aa734f7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $10e6d0a5d209f87f$export$2e2bcd8739ae039 = $10e6d0a5d209f87f$var$ConfluencePagesEditViewEntryPoint;

});
parcelRegister("1Xexh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("dZaje")
]).then(()=>parcelRequire('c3eOq'));

});


parcelRegister("gGrR8", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagesReadView", () => $127aee618b583128$export$10de55138ce5421b);

var $5FcwY = parcelRequire("5FcwY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8lb7o = parcelRequire("8lb7o");

var $lRq8t = parcelRequire("lRq8t");

var $3PRLs = parcelRequire("3PRLs");

var $4cTDP = parcelRequire("4cTDP");

var $eQdsc = parcelRequire("eQdsc");

var $43xuA = parcelRequire("43xuA");
const $127aee618b583128$export$10de55138ce5421b = ({ fragmentRef: fragmentRef, isTruncated: isTruncated = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { confluenceRemoteIssueLinks: confluenceRemoteIssueLinks } = (0, $j4oe4.useFragment)((0, $5FcwY.default), fragmentRef);
    const totalCount = confluenceRemoteIssueLinks?.totalCount ?? 0;
    const node = confluenceRemoteIssueLinks?.edges?.[0]?.node;
    const popupContentProps = (0, $eJOHy.useMemo)(()=>confluenceRemoteIssueLinks ? {
            fragmentRef: confluenceRemoteIssueLinks
        } : null, [
        confluenceRemoteIssueLinks
    ]);
    if (!popupContentProps || !node || totalCount === 0) return null;
    const url = (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') ? node.pageContent?.href ?? node.href ?? '' : node.href ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8lb7o.ItemWithEntryPointPopup), {
        ItemComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
            anchorTarget: "_blank",
            url: url
        }),
        totalItems: Math.min(totalCount, 1000),
        entryPoint: (0, $eQdsc.confluencePagesPopupContentEntryPoint),
        entryPointParams: {},
        entryPointRuntimeProps: popupContentProps,
        showMoreTooltip: formatMessage((0, $43xuA.default).showMore),
        actionSubjectIdPrefix: "confluencePages",
        isTruncated: isTruncated
    });
};

});
parcelRegister("5FcwY", function(module, exports) {
$parcel$export(module.exports, "default", () => $af30a5c414eac913$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be9406e042814591ec1e62ed2c45e3d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af30a5c414eac913$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "href"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                    }
                ],
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "popupContent_issueFieldConfluencePagesReadviewFull"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "pageContent",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ 
                                                        ],
                                                        "type": "JiraConfluencePageContentDetails"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            }
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    };
}();
$af30a5c414eac913$var$node.hash = "f3dfa170a3952ce8210f6278505d4948";
var $af30a5c414eac913$export$2e2bcd8739ae039 = $af30a5c414eac913$var$node;

});

parcelRegister("eQdsc", function(module, exports) {
$parcel$export(module.exports, "confluencePagesPopupContentEntryPoint", () => $4cc0ba0819c90cbd$export$a98f421071b5b6ae);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4cc0ba0819c90cbd$export$a98f421071b5b6ae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bDyQX")), {
        moduleId: "5019f0bb",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bDyQX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bJbeT").then(()=>parcelRequire('4sxUW'));

});


parcelRegister("43xuA", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf8902fe0b4f33fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bf8902fe0b4f33fd$var$messages = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "confluence-pages-readview-full.ui.confluence-pages.show-more",
        "defaultMessage": "Show more"
    }
});
var $bf8902fe0b4f33fd$export$2e2bcd8739ae039 = $bf8902fe0b4f33fd$var$messages;

});




parcelRegister("1LuaS", function(module, exports) {
$parcel$export(module.exports, "NumberCell", () => $6740de3d0823c560$export$da27302eef6199ea);

var $e1fJX = parcelRequire("e1fJX");

var $kQbke = parcelRequire("kQbke");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $lgXDp = parcelRequire("lgXDp");

var $j8Km1 = parcelRequire("j8Km1");

var $7jVFI = parcelRequire("7jVFI");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $6740de3d0823c560$export$da27302eef6199ea = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $kQbke.default), fieldRef);
    const isSingleRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (data.isStoryPointField || data.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7jVFI.StoryPointEstimateCell), {
        fieldRef: data,
        shouldRenderHoverPopover: isSingleRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6740de3d0823c560$var$NumberInlineEditCell, {
        fieldRef: data,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
});
const $6740de3d0823c560$var$NumberInlineEditCell = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $e1fJX.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgXDp.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $6740de3d0823c560$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isFirstField && isSingleRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgXDp.NumberInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    });
});
const $6740de3d0823c560$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $6740de3d0823c560$var$customTargetStyles : $6740de3d0823c560$var$customTargetStylesOld,
        ref: ref
    });
});
const $6740de3d0823c560$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $6740de3d0823c560$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("e1fJX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f5eb782f33c1baf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ca9a2224428eaa8baab227f4b90a8db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f5eb782f33c1baf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "NumberCell_NumberInlineEditCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$6f5eb782f33c1baf$var$node.hash = "96b1d6b4586ae0a1c65ffaf350a06694";
var $6f5eb782f33c1baf$export$2e2bcd8739ae039 = $6f5eb782f33c1baf$var$node;

});

parcelRegister("kQbke", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b55b41184738daa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d986ca8f0840593b87371d1db847fdf0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b55b41184738daa$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isInlineEditingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "NumberCell",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "NumberCell_NumberInlineEditCell"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "StoryPointEstimateCell"
            }
        ],
        "type": "JiraNumberField"
    };
}();
$5b55b41184738daa$var$node.hash = "c443aa487352d4791d3b2181e5622bfa";
var $5b55b41184738daa$export$2e2bcd8739ae039 = $5b55b41184738daa$var$node;

});

parcelRegister("lgXDp", function(module, exports) {
$parcel$export(module.exports, "NumberInlineEditViewWithIsEditable", () => $1cd2ec746a518e4f$export$96ce9815e2ea97b5);
$parcel$export(module.exports, "NumberInlineEditView", () => $1cd2ec746a518e4f$export$47665260b410f801);

var $jqWNk = parcelRequire("jqWNk");

var $8pwvP = parcelRequire("8pwvP");

var $kSJZ2 = parcelRequire("kSJZ2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $4EKqI = parcelRequire("4EKqI");

var $auNLL = parcelRequire("auNLL");

var $2Sipn = parcelRequire("2Sipn");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $bJscI = parcelRequire("bJscI");

var $wZ00q = parcelRequire("wZ00q");

var $g5wv4 = parcelRequire("g5wv4");
const $1cd2ec746a518e4f$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-number-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $1cd2ec746a518e4f$export$96ce9815e2ea97b5 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, editViewPopupWidth: editViewPopupWidth, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isSingleRowHeightEnabled: isSingleRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $kSJZ2.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, name: fieldName, type: type, number: number, formatConfig: formatConfig } = data;
    const initialValue = (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? (0, $g5wv4.transformToUI)(number, formatConfig?.formatStyle) : number;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $8pwvP.default));
    // #endregion
    // #region Common state
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const isFieldEditable = overriding.overrideIsEditable(isEditable ?? false);
    // #endregion
    // #region Handle new value
    const handleSubmit = (0, $eJOHy.useCallback)((newNumber, { onSuccess: onSuccess, onFail: onFail })=>{
        const tranformedNumber = (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? (0, $g5wv4.transformToServer)(newNumber, formatConfig?.formatStyle) : newNumber;
        onSubmit?.(tranformedNumber);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: tranformedNumber
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData.jira?.updateNumberField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            number: tranformedNumber
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId,
        formatConfig?.formatStyle
    ]);
    const getFormatConfigAnalyticsAttributes = (0, $eJOHy.useCallback)(()=>formatConfig ? {
            formatStyle: formatConfig.formatStyle,
            formatUnit: formatConfig.formatUnit
        } : {}, [
        formatConfig
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: {
            ...attributes,
            ...getFormatConfigAnalyticsAttributes()
        },
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]);
    // #region Read view
    const renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wZ00q.NumberReadView), {
            fragmentRef: data,
            isSingleRowHeightEnabled: isSingleRowHeightEnabled
        }));
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            label: fieldName,
            defaultValue: updatedValue,
            onChange: onChange,
            spacing: spacing
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $2Sipn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isSingleRowHeightEnabled
    });
};
const $1cd2ec746a518e4f$export$47665260b410f801 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $jqWNk.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd2ec746a518e4f$export$96ce9815e2ea97b5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("jqWNk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4a0ddf708884f79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<400e2c417f56cd4032eb1b86f93266a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4a0ddf708884f79$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$f4a0ddf708884f79$var$node.hash = "4d2b6ae17d10a992ce5a5b82bfdc0179";
var $f4a0ddf708884f79$export$2e2bcd8739ae039 = $f4a0ddf708884f79$var$node;

});

parcelRegister("8pwvP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7278133da95b693$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eac824a5d526dbdcbe1b4f030e7c4b8>>
 * @relayHash bac56b5a15fe2bdd371f393834598764
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670
const $a7278133da95b693$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5b9b5e7ad81080c3ef0caaf8a1945246c94639ab4dd9c2bfabbb0adde00cb670",
            "metadata": {},
            "name": "number_issueFieldNumber_NumberField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a7278133da95b693$var$node.hash = "229bc4c46fc83a0e7aaf848fb3a4b543";
var $a7278133da95b693$export$2e2bcd8739ae039 = $a7278133da95b693$var$node;

});

parcelRegister("kSJZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9be423b8dc624296$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<551dba2675f09b90c1ded9ed27d88d82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9be423b8dc624296$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "number_issueFieldNumberReadviewFull_NumberReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$9be423b8dc624296$var$node.hash = "b1237a150436223d181b77d20b811582";
var $9be423b8dc624296$export$2e2bcd8739ae039 = $9be423b8dc624296$var$node;

});

parcelRegister("2Sipn", function(module, exports) {
$parcel$export(module.exports, "default", () => $386d161ba121aaff$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $386d161ba121aaff$var$NumberEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dzH8P")), {
        moduleId: "ac3a36e0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $386d161ba121aaff$export$2e2bcd8739ae039 = $386d161ba121aaff$var$NumberEditViewEntryPoint;

});
parcelRegister("dzH8P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aq2De").then(()=>parcelRequire('70nnk'));

});


parcelRegister("wZ00q", function(module, exports) {
$parcel$export(module.exports, "NumberReadViewInner", () => $4a1db8e5c57729b2$export$6c68fbb587c0f1dd);
$parcel$export(module.exports, "NumberReadView", () => $4a1db8e5c57729b2$export$9267d0b69e52e344);

var $jLSzN = parcelRequire("jLSzN");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $bzbsd = parcelRequire("bzbsd");

var $lRq8t = parcelRequire("lRq8t");

var $1M2hR = parcelRequire("1M2hR");

var $d9T1A = parcelRequire("d9T1A");

var $9Mapt = parcelRequire("9Mapt");

var $g5wv4 = parcelRequire("g5wv4");

var $tYLUh = parcelRequire("tYLUh");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $kTUE3 = parcelRequire("kTUE3");
const $4a1db8e5c57729b2$export$6c68fbb587c0f1dd = ({ fieldData: fieldData, isSingleRowHeightEnabled: isSingleRowHeightEnabled = false, shouldTransformNumber: shouldTransformNumber = true })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $kTUE3.default).noValueTextExperiment);
    const contentRef = (0, $eJOHy.useRef)(null);
    const locale = (0, $1M2hR.useLocale)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const hoverPopoverRefFactory = isSingleRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(fieldData.id) : null;
    let hoverPopoverRef = null;
    const { number: number, formatConfig: formatConfig } = fieldData;
    const tranformedNumber = shouldTransformNumber && (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? (0, $g5wv4.transformToUI)(number, formatConfig?.formatStyle) : number;
    const numberContent = formatConfig && formatConfig.formatStyle && (0, $4cTDP.fg)('frontier-currency-field-d1') ? (0, $g5wv4.formatNumberField)(tranformedNumber ?? 0, {
        formatStyle: formatConfig.formatStyle,
        formatUnit: formatConfig.formatUnit,
        locale: locale
    }) : formatNumber(number ?? 0);
    const children = number === null || number === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }) : numberContent;
    if (isSingleRowHeightEnabled) {
        if ((0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
            if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
                content: numberContent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                testId: "issue-field-number-readview-full.ui.number.text",
                ref: hoverPopoverRef,
                maxLines: 1
            }, children);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            contentRef: contentRef,
            content: numberContent
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                testId: "issue-field-number-readview-full.ui.number.text",
                ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                maxLines: 1
            }, children));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "issue-field-number-readview-full.ui.number.span"
    }, children);
};
const $4a1db8e5c57729b2$export$9267d0b69e52e344 = ({ fragmentRef: fragmentRef, isSingleRowHeightEnabled: isSingleRowHeightEnabled = false })=>{
    const fieldData = (0, $j4oe4.useFragment)((0, $jLSzN.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4a1db8e5c57729b2$export$6c68fbb587c0f1dd, {
        fieldData: fieldData,
        isSingleRowHeightEnabled: isSingleRowHeightEnabled
    });
};

});
parcelRegister("jLSzN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad4f0360dff8dc0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c9269db8fc4813c06734d7aade16678>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad4f0360dff8dc0a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "number_issueFieldNumberReadviewFull_NumberReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "JiraNumberFieldFormatConfig",
                    "kind": "LinkedField",
                    "name": "formatConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "formatStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "formatUnit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraNumberField"
};
$ad4f0360dff8dc0a$var$node.hash = "7678fb417f2cd4513c78086113294dc1";
var $ad4f0360dff8dc0a$export$2e2bcd8739ae039 = $ad4f0360dff8dc0a$var$node;

});

parcelRegister("g5wv4", function(module, exports) {
$parcel$export(module.exports, "formatDecimal", () => $9f3ef12a68cb7fc4$export$845857f28dc08744);
$parcel$export(module.exports, "formatNumberField", () => $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01);
$parcel$export(module.exports, "transformToUI", () => $9f3ef12a68cb7fc4$export$ecbf259380af1f03);
$parcel$export(module.exports, "transformToServer", () => $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4);
$parcel$export(module.exports, "isSidebarFormatConfigEnabled", () => $9f3ef12a68cb7fc4$export$3c854a930069a447);
$parcel$export(module.exports, "formatConfigFromAggJiraNumberFieldFormatConfig", () => $9f3ef12a68cb7fc4$export$29f524126725ba4b);

var $4cTDP = parcelRequire("4cTDP");

/**
 * This is due to Jira commonly using the POSIX format (using '_' for defining locales),
 * such as in jira/src/packages/platform/supported-locales/src/supported-locales.tsx,
 * whereas the Intl Javascript API requires locales to be in the IETF BCP 47 format.
 */ const $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat = (locale)=>{
    return locale.replace('_', '-');
};
// Converts strings to lower case while also preventing string literal types from being converted
// into the more general `string` type as the String.prototype.toLowerCase() method always returns
// a `string` type, even if the string is a string literal. For example:
// const string = 'CONSTANT'; // type is `'CONSTANT'`;
// string.toLowerCase() // returned type is `string`;
// toLowerCase(string) // returned type is `'constant'`;
const $9f3ef12a68cb7fc4$var$toLowerCase = (inputString)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return inputString.toLocaleLowerCase();
};
const $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode = (currencyCode)=>{
    // Check if the currency code is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$a82896da99871ba4))).includes(currencyCode);
};
const $9f3ef12a68cb7fc4$var$isSupportedUnit = (unit)=>{
    // Check if the unit is supported
    return Intl.supportedValuesOf($9f3ef12a68cb7fc4$var$toLowerCase((0, $7b3dcdbff4fbb09a$export$83551de9ca24925e))).includes(unit);
};
const $9f3ef12a68cb7fc4$export$3dc27271f5d5c629 = (amount, config = {})=>{
    const { currencyCode: currencyCode = (0, $7b3dcdbff4fbb09a$export$c852e1f5bb177898), locale: locale, currencyDisplay: currencyDisplay = (0, $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437), ...rest } = config;
    // Check if the currency code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = $9f3ef12a68cb7fc4$var$isSupportedCurrencyCode(currencyCode) ? {
        style: (0, $7b3dcdbff4fbb09a$export$a82896da99871ba4).toLocaleLowerCase(),
        currency: currencyCode,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6 = (amount, config = {})=>{
    const { locale: locale, ...rest } = config;
    return new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), {
        ...rest,
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: (0, $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2)
    }).format(amount ?? 0);
};
const $9f3ef12a68cb7fc4$export$bd39b96f71da1885 = (number, config = {})=>{
    const { unit: unit, locale: locale, ...rest } = config;
    // Check if the unit code is supported. fall back to decimal format if not.
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    const formatOptions = unit && $9f3ef12a68cb7fc4$var$isSupportedUnit(unit) ? {
        style: (0, $7b3dcdbff4fbb09a$export$83551de9ca24925e).toLocaleLowerCase(),
        unit: unit,
        ...rest
    } : {
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...rest
    };
    const formatter = new Intl.NumberFormat(locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(locale), formatOptions);
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$845857f28dc08744 = (number, config = {})=>{
    const formatter = new Intl.NumberFormat(config.locale && $9f3ef12a68cb7fc4$var$coerceBCPLocaleFormat(config.locale), {
        // @ts-expect-error - TS2769 Typescript 5.9.2 upgrade
        style: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea).toLocaleLowerCase(),
        ...config
    });
    return formatter.format(number ?? 0);
};
const $9f3ef12a68cb7fc4$export$d390e3b8d1c21e01 = (number, config = {
    formatStyle: (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea)
})=>{
    const { formatStyle: formatStyle, formatUnit: formatUnit, locale: locale } = config;
    switch(formatStyle){
        case 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4:
            return formatUnit ? $9f3ef12a68cb7fc4$export$3dc27271f5d5c629(number, {
                locale: locale,
                currencyCode: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9:
            return $9f3ef12a68cb7fc4$export$32e6b1ae352e94d6(number, {
                locale: locale
            });
        case 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e:
            return formatUnit ? $9f3ef12a68cb7fc4$export$bd39b96f71da1885(number, {
                locale: locale,
                unit: formatUnit
            }) : $9f3ef12a68cb7fc4$export$845857f28dc08744(number, {
                locale: locale
            });
        default:
            return $9f3ef12a68cb7fc4$export$845857f28dc08744(number);
    }
};
const $9f3ef12a68cb7fc4$export$ecbf259380af1f03 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>number && formatStyle === (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) && (0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage') ? number * 100 : number;
const $9f3ef12a68cb7fc4$export$e7caeabf4d12f5b4 = (number, formatStyle = (0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea))=>{
    if (!number || formatStyle !== (0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9) || !(0, $4cTDP.fg)('frontier-currency-field-fix-percentage-storage')) return number;
    // Use Number.EPSILON to avoid floating-point precision issues
    const result = number / 100;
    const factor = Math.pow(10, 8); // 8 decimal places should be sufficient for percentage precision
    return Math.round((result + Number.EPSILON) * factor) / factor;
};
const $9f3ef12a68cb7fc4$export$3c854a930069a447 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('frontier-currency-field-d1') && (0, $4cTDP.fg)('fields-settings-currency-field-display');
const $9f3ef12a68cb7fc4$var$formatStyleMapper = (jiraFormatStyle)=>{
    switch(jiraFormatStyle){
        case 'CURRENCY':
            return 0, $7b3dcdbff4fbb09a$export$a82896da99871ba4;
        case 'PERCENT':
            return 0, $7b3dcdbff4fbb09a$export$e50c15d5408652a9;
        case 'UNIT':
            return 0, $7b3dcdbff4fbb09a$export$83551de9ca24925e;
        default:
            return 0, $7b3dcdbff4fbb09a$export$768e3e8e60d01cea;
    }
};
const $9f3ef12a68cb7fc4$export$29f524126725ba4b = (gqlFormatConfig)=>{
    const { formatDecimals: formatDecimals, formatStyle: formatStyle, formatUnit: formatUnit } = gqlFormatConfig || {};
    return {
        formatStyle: $9f3ef12a68cb7fc4$var$formatStyleMapper(formatStyle),
        formatUnit: formatUnit || null,
        formatDecimals: formatDecimals ?? null
    };
};

});
const $7b3dcdbff4fbb09a$export$c852e1f5bb177898 = 'USD';
const $7b3dcdbff4fbb09a$export$b9e50a64e0ca3437 = 'narrowSymbol';
const $7b3dcdbff4fbb09a$export$768e3e8e60d01cea = 'DECIMAL';
const $7b3dcdbff4fbb09a$export$a82896da99871ba4 = 'CURRENCY';
const $7b3dcdbff4fbb09a$export$e50c15d5408652a9 = 'PERCENT';
const $7b3dcdbff4fbb09a$export$83551de9ca24925e = 'UNIT';
const $7b3dcdbff4fbb09a$export$e0f41b79f8d902b5 = 'liter';
const $7b3dcdbff4fbb09a$export$83a33c313ebf2c4a = 'meter';
const $7b3dcdbff4fbb09a$export$32fca264df3a7957 = 'kilogram';
const $7b3dcdbff4fbb09a$export$97f1ae291e87b4b2 = 'percent';


parcelRegister("kTUE3", function(module, exports) {
$parcel$export(module.exports, "default", () => $43ed06390f00aff2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $43ed06390f00aff2$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-number-readview-full.number.no-value-text-experiment",
        "defaultMessage": "Add number"
    }
});
var $43ed06390f00aff2$export$2e2bcd8739ae039 = $43ed06390f00aff2$var$messages;

});



parcelRegister("7jVFI", function(module, exports) {
$parcel$export(module.exports, "StoryPointEstimateCell", () => $156da583d0db6981$export$78dcdef75b89353b);

var $9sebT = parcelRequire("9sebT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fzIah = parcelRequire("fzIah");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");
const $156da583d0db6981$export$78dcdef75b89353b = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $9sebT.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fzIah.StoryPointEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: shouldRenderHoverPopover
    });
});

});
parcelRegister("9sebT", function(module, exports) {
$parcel$export(module.exports, "default", () => $27136564c97472ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2149b1dfc06498a68625beb316ebd9b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27136564c97472ea$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "StoryPointEstimateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraNumberField"
};
$27136564c97472ea$var$node.hash = "4d4b9859c9022b4f86ea1672efbdc156";
var $27136564c97472ea$export$2e2bcd8739ae039 = $27136564c97472ea$var$node;

});

parcelRegister("fzIah", function(module, exports) {
$parcel$export(module.exports, "StoryPointEstimateInlineEditViewIsEditable", () => $dcc00af3f4448d4a$export$d2c15e488724d3b6);
$parcel$export(module.exports, "StoryPointEstimateInlineEditView", () => $dcc00af3f4448d4a$export$53d82fd5560565fa);

var $7mEiF = parcelRequire("7mEiF");

var $h2t9f = parcelRequire("h2t9f");

var $h17EP = parcelRequire("h17EP");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $3bSs8 = parcelRequire("3bSs8");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $2Sipn = parcelRequire("2Sipn");

var $8DpUN = parcelRequire("8DpUN");

var $3mZMJ = parcelRequire("3mZMJ");

var $5dZy9 = parcelRequire("5dZy9");
const $dcc00af3f4448d4a$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-story-point-estimate-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $dcc00af3f4448d4a$export$d2c15e488724d3b6 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $h17EP.default), fragmentRef);
    const { id: uniqueFieldId, type: type, name: fieldName, number: initialValue } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $h2t9f.default));
    // #endregion
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const validator = (0, $5dZy9.useStoryPointEstimateValidator)();
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        number: value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateNumberField) {
                    const { success: success, errors: responseErrors, field: field } = mutationData.jira.updateNumberField;
                    if (success && field != null) onSuccess();
                    else {
                        const errorMessage = responseErrors?.[0]?.message;
                        onFail(new Error(errorMessage || 'Relay error encountered while updating number field'), // Display server error message in flag if it exists
                        errorMessage ?? undefined);
                    }
                }
            },
            onError: (incomingError)=>{
                onFail(incomingError);
            },
            optimisticResponse: {
                jira: {
                    updateNumberField: {
                        success: true,
                        errors: [],
                        field: {
                            id: uniqueFieldId,
                            number: value != null ? value : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        uniqueFieldId
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleChange: handleChange, handleConfirm: handleConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: uniqueFieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        clipboardComponentType: 'numberNullable',
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        ...(0, $4cTDP.fg)('prevent-negative-story-point-estimate') ? {
            validator: validator
        } : {},
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        analyticsFieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE]
    });
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        handleChange(typedValue);
    }, [
        handleChange
    ]);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcc00af3f4448d4a$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8DpUN.StoryPointEstimateReadView), {
            fragmentRef: data,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            label: fieldName,
            defaultValue: updatedValue,
            isInvalid: invalidMessage != null || hasServerValidationError,
            onChange: onChange
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $2Sipn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditable: isFieldEditable,
        isEditing: isEditing || hasServerValidationError,
        keepEditViewOpenOnBlur: hasServerValidationError,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $dcc00af3f4448d4a$export$53d82fd5560565fa = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $7mEiF.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcc00af3f4448d4a$export$d2c15e488724d3b6, {
        ...props,
        fragmentRef: data,
        isEditable: data.isEditableInIssueView ?? false
    });
};

});
parcelRegister("7mEiF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0f5f7536d0c260b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5a0439ffc3e7985b2ffc49200c7c91a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0f5f7536d0c260b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "kind": "ScalarField",
            "name": "isEditableInIssueView"
        }
    ],
    "type": "JiraNumberField"
};
$e0f5f7536d0c260b$var$node.hash = "e4b34a649ef5dd8533f5cabe75fe48a9";
var $e0f5f7536d0c260b$export$2e2bcd8739ae039 = $e0f5f7536d0c260b$var$node;

});

parcelRegister("h2t9f", function(module, exports) {
$parcel$export(module.exports, "default", () => $e75f603e5fe9e296$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3848ab8ba84307c52100812d34d678eb>>
 * @relayHash d31d751b8d2df6b00dba2227445c1922
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321
const $e75f603e5fe9e296$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraNumberFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateNumberField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNumberField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321",
            "metadata": {},
            "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e75f603e5fe9e296$var$node.hash = "cd8233b80d650588112eb0d15d581a9c";
var $e75f603e5fe9e296$export$2e2bcd8739ae039 = $e75f603e5fe9e296$var$node;

});

parcelRegister("h17EP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9179fa879450e87d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<104e7a7c30e42c208fb29f3aec68910d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9179fa879450e87d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateInlineEditFull_StoryPointEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$9179fa879450e87d$var$node.hash = "c258cd7d5b4392c1e7419c5721e2a6cd";
var $9179fa879450e87d$export$2e2bcd8739ae039 = $9179fa879450e87d$var$node;

});

parcelRegister("8DpUN", function(module, exports) {
$parcel$export(module.exports, "StoryPointEstimateReadView", () => $0b1dd76fc20e2df8$export$29398521b1f444c1);

var $7FWhJ = parcelRequire("7FWhJ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $3OT15 = parcelRequire("3OT15");


var $dXaoD = parcelRequire("dXaoD");
const $0b1dd76fc20e2df8$export$29398521b1f444c1 = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $dXaoD.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const data = (0, $j4oe4.useFragment)((0, $7FWhJ.default), fragmentRef);
    const { number: number } = data;
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (number === null || number === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : undefined
    }));
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: formatNumber(number)
    });
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverRef
    }, formatNumber(number)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $9449af9a14f793a7$export$d3d47c5f37010b20)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0b1dd76fc20e2df8$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $9449af9a14f793a7$export$3804bd7641b5a138)
    }, formatNumber(number))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0b1dd76fc20e2df8$var$BadgeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e1dm9 _1dqonqa1 _1h6d3acm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7FWhJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $95e9098bb4a75ed1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c402fb1fd95bc1e95b501749101ff8fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95e9098bb4a75ed1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        }
    ],
    "type": "JiraNumberField"
};
$95e9098bb4a75ed1$var$node.hash = "23757b8b917d47b2444d3b2414b283dc";
var $95e9098bb4a75ed1$export$2e2bcd8739ae039 = $95e9098bb4a75ed1$var$node;

});

const $9449af9a14f793a7$export$3804bd7641b5a138 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate.badge';
const $9449af9a14f793a7$export$d3d47c5f37010b20 = 'issue-field-story-point-estimate-readview-full.ui.story-point-estimate';

parcelRegister("dXaoD", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fde5f4779b82760$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0fde5f4779b82760$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-story-point-estimate-readview-full.story-point-estimate.no-value-text-experiment",
        "defaultMessage": "Add story points"
    }
});
var $0fde5f4779b82760$export$2e2bcd8739ae039 = $0fde5f4779b82760$var$messages;

});


parcelRegister("5dZy9", function(module, exports) {
$parcel$export(module.exports, "useStoryPointEstimateValidator", () => $334b6283e068d76c$export$a7e5b5687078d1af);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3buZW = parcelRequire("3buZW");
const $334b6283e068d76c$export$a7e5b5687078d1af = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (value && value < 0) return {
            type: 'error',
            message: formatMessage((0, $3buZW.default).popupStoryPointNonNegative)
        };
        return null;
    }, [
        formatMessage
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("3buZW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d236167a8cb6c457$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d236167a8cb6c457$var$messages = (0, $7qGN1.defineMessages)({
    popupStoryPointNonNegative: {
        "id": "issue-field-story-point-estimate-inline-edit.story-point-estimate.tooltip-label",
        "defaultMessage": "Time for some positivity. Story point estimates can't be negative."
    }
});
var $d236167a8cb6c457$export$2e2bcd8739ae039 = $d236167a8cb6c457$var$messages;

});





parcelRegister("h0Klc", function(module, exports) {
$parcel$export(module.exports, "OriginalEstimateCell", () => $01cd2beefc732cd3$export$6ffde629399d0fd4);

var $ebA4D = parcelRequire("ebA4D");

var $3pmjN = parcelRequire("3pmjN");

var $1KCrp = parcelRequire("1KCrp");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4iyed = parcelRequire("4iyed");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");
const $01cd2beefc732cd3$var$OriginalEstimateCellOld = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    // NOTE: original estimate type is used to get timeTrackingField data, which is used in underlying original estimate decomposed field.
    const data = (0, $j4oe4.useFragment)((0, $1KCrp.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($01cd2beefc732cd3$var$OriginalEstimateTimeTrackingFieldCell, {
        fieldRef: data.issue?.timeTrackingField ?? null,
        isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover,
        issueFieldId: data.id
    });
};
const $01cd2beefc732cd3$var$OriginalEstimateCellNew = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    // NOTE: original estimate type is used to get timeTrackingField data, which is used in underlying original estimate decomposed field.
    const data = (0, $j4oe4.useFragment)((0, $3pmjN.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = data && 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data?.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4iyed.OriginalEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data?.issue?.timeTrackingField ?? null,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled,
        issueFieldId: data.id
    });
};
const $01cd2beefc732cd3$export$6ffde629399d0fd4 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira-original-estimate-editable-fix'), $01cd2beefc732cd3$var$OriginalEstimateCellNew, $01cd2beefc732cd3$var$OriginalEstimateCellOld);
const $01cd2beefc732cd3$var$OriginalEstimateTimeTrackingFieldCell = ({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover, issueFieldId: issueFieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $ebA4D.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = data && 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data?.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4iyed.OriginalEstimateInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data ?? null,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled,
        issueFieldId: issueFieldId
    });
};

});
parcelRegister("ebA4D", function(module, exports) {
$parcel$export(module.exports, "default", () => $95c81f360c159b50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b466e5a5db03aca0b437cf003393dbba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95c81f360c159b50$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTimeTrackingField"
};
$95c81f360c159b50$var$node.hash = "2c3d3c8f77186bb4daccfec9a1c84692";
var $95c81f360c159b50$export$2e2bcd8739ae039 = $95c81f360c159b50$var$node;

});

parcelRegister("3pmjN", function(module, exports) {
$parcel$export(module.exports, "default", () => $acd973ac1322266f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a9c32a1ff4f249d1666bc93ab756523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $acd973ac1322266f$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "OriginalEstimateCell_OriginalEstimateCellNew",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraTimeTrackingField",
                    "kind": "LinkedField",
                    "name": "timeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraOriginalTimeEstimateField"
};
$acd973ac1322266f$var$node.hash = "f32a8180d501ca136d5e15126610a012";
var $acd973ac1322266f$export$2e2bcd8739ae039 = $acd973ac1322266f$var$node;

});

parcelRegister("1KCrp", function(module, exports) {
$parcel$export(module.exports, "default", () => $3187f8108381b398$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<117bc721eb645cd6ae76146e94bffd56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3187f8108381b398$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "OriginalEstimateCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraTimeTrackingField",
                    "kind": "LinkedField",
                    "name": "timeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isInlineEditingEnabled",
                                    "variableName": "isInlineEditingEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraOriginalTimeEstimateField"
};
$3187f8108381b398$var$node.hash = "6dac9d8940c4d8f0a9099192b46018ab";
var $3187f8108381b398$export$2e2bcd8739ae039 = $3187f8108381b398$var$node;

});

parcelRegister("4iyed", function(module, exports) {
$parcel$export(module.exports, "OriginalEstimateInlineEditViewIsEditable", () => $6630dfecd752d78e$export$6b7ba0cc8e5fd10);
$parcel$export(module.exports, "OriginalEstimateInlineEditView", () => $6630dfecd752d78e$export$63b1ca4384eabbd8);

var $7l4ES = parcelRequire("7l4ES");

var $79Sa8 = parcelRequire("79Sa8");

var $dUuu1 = parcelRequire("dUuu1");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $auNLL = parcelRequire("auNLL");

var $flcqE = parcelRequire("flcqE");

var $iz9K8 = parcelRequire("iz9K8");

var $bWfD9 = parcelRequire("bWfD9");

var $8T4lL = parcelRequire("8T4lL");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $tYLUh = parcelRequire("tYLUh");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $gc7nM = parcelRequire("gc7nM");
const $6630dfecd752d78e$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-original-estimate-lite-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $6630dfecd752d78e$export$6b7ba0cc8e5fd10 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isEditing: startWithEditViewOpen, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover, issueFieldId: issueFieldId })=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $dUuu1.default), fragmentRef);
    const { id: uniqueFieldId = '', name: name = '', fieldId: fieldId = '', type: fieldType = '', originalEstimate: originalEstimate, timeTrackingSettings: timeTrackingSettings } = data || {};
    const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit } = timeTrackingSettings ?? {};
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $79Sa8.default));
    // #endregion
    // #region Common state
    const settingsInput = {
        workingHoursPerDay: workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek,
        defaultFormat: defaultFormat,
        defaultUnit: defaultUnit
    };
    const formatInputValue = (0, $bWfD9.useFormatInputValue)(settingsInput);
    const initialValue = (0, $eJOHy.useMemo)(()=>originalEstimate ? formatInputValue(originalEstimate.timeInSeconds ?? 0) : '', [
        formatInputValue,
        originalEstimate
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const validator = (0, $gc7nM.useOriginalEstimateValidator)(settingsInput);
    const parseTimeString = (0, $8T4lL.useParseTimeString)(settingsInput);
    const { overriding: { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } } = (0, $auNLL.useInlineEditFieldInjections)();
    const fieldName = overrideLabel(name);
    const isFieldEditable = overrideIsEditable(isEditable);
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        const timeInSeconds = parseTimeString(value) ?? 0;
        onSubmit?.(timeInSeconds);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    originalEstimate: {
                        timeInSeconds: timeInSeconds
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateTimeTrackingField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTimeTrackingField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            originalEstimate: {
                                timeInSeconds: timeInSeconds
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        onSubmit,
        parseTimeString,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>onSubmitSucceeded?.(parseTimeString(value) ?? 0), [
        onSubmitSucceeded,
        parseTimeString
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        validator: validator,
        clipboardComponentType: 'originalEstimate'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6630dfecd752d78e$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $flcqE.OriginalEstimateReadView), {
            fragmentRef: data ?? null,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            issueFieldId: issueFieldId
        })), [
        data,
        shouldRenderHoverPopover,
        issueFieldId
    ]);
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        handleChange(event.target.value);
    }, [
        handleChange
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            ...isExperimentEnabled ? {
                value: updatedValue === '0m' ? undefined : updatedValue
            } : {
                value: updatedValue
            },
            spacing: spacing,
            onChange: onChange,
            isInvalid: Boolean(invalidMessage)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iz9K8.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage ?? undefined,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $6630dfecd752d78e$export$63b1ca4384eabbd8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $7l4ES.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6630dfecd752d78e$export$6b7ba0cc8e5fd10, {
        ...props,
        fragmentRef: data ?? null,
        isEditable: data?.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("7l4ES", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fb8a074c17dd209$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5335009b59f96bef1dbea7b79653d9c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6fb8a074c17dd209$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$6fb8a074c17dd209$var$node.hash = "7c668f5d814871c9f0ed4a8aa42dca72";
var $6fb8a074c17dd209$export$2e2bcd8739ae039 = $6fb8a074c17dd209$var$node;

});

parcelRegister("79Sa8", function(module, exports) {
$parcel$export(module.exports, "default", () => $53939db8b5f05955$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8633ab51539eb5964d048f1e02614494>>
 * @relayHash 2b9999c9f430b4dda72109599e853618
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 778533cd42b1035109f3872065d291e4f0d98dadaae1304d1ee064df84405593
const $53939db8b5f05955$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraTimeTrackingFieldPayload",
                    "kind": "LinkedField",
                    "name": "updateTimeTrackingField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraTimeTrackingField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "JiraEstimate",
                                    "kind": "LinkedField",
                                    "name": "originalEstimate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "timeInSeconds"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "778533cd42b1035109f3872065d291e4f0d98dadaae1304d1ee064df84405593",
            "metadata": {},
            "name": "originalEstimate_OriginalEstimateInlineEditViewIsEditable_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$53939db8b5f05955$var$node.hash = "8e4396c085a50b830136e492ba97931f";
var $53939db8b5f05955$export$2e2bcd8739ae039 = $53939db8b5f05955$var$node;

});

parcelRegister("dUuu1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4bc773f61436815$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<565704827e85cb165877ec877094e77b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e4bc773f61436815$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$e4bc773f61436815$var$node.hash = "9d4d77e9fb33d79699c085bd5ddf9412";
var $e4bc773f61436815$export$2e2bcd8739ae039 = $e4bc773f61436815$var$node;

});

parcelRegister("flcqE", function(module, exports) {
$parcel$export(module.exports, "OriginalEstimateReadView", () => $a23c3d9b42eb819c$export$9fbd5776dc81fee9);

var $dv0ed = parcelRequire("dv0ed");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $tYLUh = parcelRequire("tYLUh");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");

var $bWfD9 = parcelRequire("bWfD9");

var $9QjVb = parcelRequire("9QjVb");
const $a23c3d9b42eb819c$export$9fbd5776dc81fee9 = ({ fragmentRef: fragmentRef, shouldRenderHoverPopover: shouldRenderHoverPopover, issueFieldId: issueFieldId })=>{
    const data = (0, $j4oe4.useFragment)((0, $dv0ed.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $9QjVb.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const settingsInput = {
        workingHoursPerDay: data?.timeTrackingSettings?.workingHoursPerDay,
        workingDaysPerWeek: data?.timeTrackingSettings?.workingDaysPerWeek,
        defaultFormat: data?.timeTrackingSettings?.defaultFormat,
        defaultUnit: data?.timeTrackingSettings?.defaultUnit
    };
    const formatInputValue = (0, $bWfD9.useFormatInputValue)(settingsInput);
    const timeString = (0, $eJOHy.useMemo)(()=>data ? formatInputValue(data.originalEstimate?.timeInSeconds ?? 0) : null, [
        data,
        formatInputValue
    ]);
    const hoverPopoverContentRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(issueFieldId) : null;
    let hoverPopoverContentRef = null;
    if (hoverPopoverContentRefFactory) hoverPopoverContentRef = hoverPopoverContentRefFactory({
        content: timeString
    });
    if (!data?.originalEstimate?.timeInSeconds && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: noValueTextExperiment
    });
    if (timeString === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (shouldRenderHoverPopover) return(// Empty div to allow ellipsis
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverContentRef
    }, timeString))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, timeString);
};

});
parcelRegister("dv0ed", function(module, exports) {
$parcel$export(module.exports, "default", () => $e08bb88ce6cc7969$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f139c9e4c74bf141b30d416189961e0a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e08bb88ce6cc7969$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "originalEstimate_issueFieldOriginalEstimateReadviewFull_OriginalEstimateReadView",
    "selections": [
        {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "originalEstimate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                }
            ]
        },
        {
            "concreteType": "JiraTimeTrackingSettings",
            "kind": "LinkedField",
            "name": "timeTrackingSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "workingHoursPerDay"
                },
                {
                    "kind": "ScalarField",
                    "name": "workingDaysPerWeek"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultFormat"
                },
                {
                    "kind": "ScalarField",
                    "name": "defaultUnit"
                }
            ]
        }
    ],
    "type": "JiraTimeTrackingField"
};
$e08bb88ce6cc7969$var$node.hash = "416ee9c2ca1a0709882a616f7a6e726b";
var $e08bb88ce6cc7969$export$2e2bcd8739ae039 = $e08bb88ce6cc7969$var$node;

});

parcelRegister("bWfD9", function(module, exports) {
$parcel$export(module.exports, "useFormatInputValue", () => $0d58d74844c77d4a$export$249a26bf47be0b0b);

var $eJOHy = parcelRequire("eJOHy");

var $kjvkS = parcelRequire("kjvkS");

var $lRq8t = parcelRequire("lRq8t");


var $5GvTs = parcelRequire("5GvTs");
const $0d58d74844c77d4a$var$toTimeFormat = (format)=>{
    return format ? (0, $5GvTs.toLowercaseTimeUnion)(format) : (0, $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df);
};
const $0d58d74844c77d4a$var$toTimeUnit = (unit)=>{
    return unit ? (0, $5GvTs.toLowercaseTimeUnion)(unit) : (0, $e1e7fb6a6c70503b$export$2ee07242bbb09b61);
};
const $0d58d74844c77d4a$export$249a26bf47be0b0b = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((value)=>{
        return (0, $kjvkS.timeTrackingFormatter)(value, {
            workingHoursPerDay: workingHoursPerDay || (0, $e1e7fb6a6c70503b$export$8c7070611f332ef9),
            workingDaysPerWeek: workingDaysPerWeek || (0, $e1e7fb6a6c70503b$export$21ed1f454652d913),
            timeFormat: $0d58d74844c77d4a$var$toTimeFormat(defaultFormat),
            defaultUnit: $0d58d74844c77d4a$var$toTimeUnit(defaultUnit)
        }, intl);
    }, [
        workingHoursPerDay,
        workingDaysPerWeek,
        defaultFormat,
        defaultUnit,
        intl
    ]);
};

});
parcelRegister("kjvkS", function(module, exports) {
$parcel$export(module.exports, "timeTrackingFormatter", () => $9d0512273747699d$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $9d0512273747699d$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $9d0512273747699d$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $9d0512273747699d$export$8516173ab945b52f);

var $iYiee = parcelRequire("iYiee");

var $b7Ydn = parcelRequire("b7Ydn");

var $hjbuK = parcelRequire("hjbuK");
const $9d0512273747699d$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $9d0512273747699d$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $9d0512273747699d$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $9d0512273747699d$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $9d0512273747699d$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $iYiee.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $hjbuK.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $b7Ydn.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $b7Ydn.default).timeUnitDay,
            transform: $9d0512273747699d$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $b7Ydn.default).timeUnitHour,
            transform: $9d0512273747699d$var$validate(isTimeValid),
            seconds: (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $b7Ydn.default).timeUnitMinute,
            seconds: (0, $iYiee.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $iYiee.TimeFormats).DAYS:
            return $9d0512273747699d$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $iYiee.TimeFormats).HOURS:
            return $9d0512273747699d$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $iYiee.TimeFormats).PRETTY:
        default:
            return $9d0512273747699d$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $9d0512273747699d$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $iYiee.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $iYiee.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $iYiee.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $iYiee.defaultTimeTrackingOptions).defaultUnit
    };
    return $9d0512273747699d$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $9d0512273747699d$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $iYiee.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $hjbuK.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $b7Ydn.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $b7Ydn.default).timeUnitLongDay,
            transform: $9d0512273747699d$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $b7Ydn.default).timeUnitLongHour,
            transform: $9d0512273747699d$var$validate(isTimeValid),
            seconds: (0, $iYiee.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $b7Ydn.default).timeUnitLongMinute,
            seconds: (0, $iYiee.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $iYiee.TimeFormats).DAYS:
            return $9d0512273747699d$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $iYiee.TimeFormats).HOURS:
            return $9d0512273747699d$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $iYiee.TimeFormats).PRETTY:
        default:
            return $9d0512273747699d$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $9d0512273747699d$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $iYiee.TimeFormats).DAYS:
            return (0, $iYiee.TimeFormats).DAYS;
        case (0, $iYiee.TimeFormats).HOURS:
            return (0, $iYiee.TimeFormats).HOURS;
        case (0, $iYiee.TimeFormats).PRETTY:
            return (0, $iYiee.TimeFormats).PRETTY;
        default:
            return (0, $iYiee.TimeFormats).DAYS;
    }
};
const $9d0512273747699d$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $iYiee.TimeUnits).DAY:
            return (0, $iYiee.TimeUnits).DAY;
        case (0, $iYiee.TimeUnits).HOUR:
            return (0, $iYiee.TimeUnits).HOUR;
        case (0, $iYiee.TimeUnits).MINUTE:
            return (0, $iYiee.TimeUnits).MINUTE;
        case (0, $iYiee.TimeUnits).WEEK:
            return (0, $iYiee.TimeUnits).WEEK;
        default:
            return (0, $iYiee.TimeUnits).DAY;
    }
};

});
parcelRegister("iYiee", function(module, exports) {
$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8c530bce5cc29340$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8c530bce5cc29340$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8c530bce5cc29340$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8c530bce5cc29340$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8c530bce5cc29340$export$f8d48c1fed813e90);
const $8c530bce5cc29340$export$544c576050746347 = 60;
const $8c530bce5cc29340$var$MINUTES_PER_HOUR = 60;
const $8c530bce5cc29340$export$3cc7ae4b390f50a = $8c530bce5cc29340$var$MINUTES_PER_HOUR * $8c530bce5cc29340$export$544c576050746347;
const $8c530bce5cc29340$var$TIME_FORMAT_PRETTY = 'pretty';
const $8c530bce5cc29340$var$TIME_FORMAT_DAYS = 'days';
const $8c530bce5cc29340$var$TIME_FORMAT_HOURS = 'hours';
const $8c530bce5cc29340$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8c530bce5cc29340$var$TIME_FORMAT_PRETTY,
    DAYS: $8c530bce5cc29340$var$TIME_FORMAT_DAYS,
    HOURS: $8c530bce5cc29340$var$TIME_FORMAT_HOURS
});
const $8c530bce5cc29340$var$TIME_UNIT_WEEK = 'week';
const $8c530bce5cc29340$var$TIME_UNIT_DAY = 'day';
const $8c530bce5cc29340$var$TIME_UNIT_HOUR = 'hour';
const $8c530bce5cc29340$var$TIME_UNIT_MINUTE = 'minute';
const $8c530bce5cc29340$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8c530bce5cc29340$var$TIME_UNIT_WEEK,
    DAY: $8c530bce5cc29340$var$TIME_UNIT_DAY,
    HOUR: $8c530bce5cc29340$var$TIME_UNIT_HOUR,
    MINUTE: $8c530bce5cc29340$var$TIME_UNIT_MINUTE
});
const $8c530bce5cc29340$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8c530bce5cc29340$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8c530bce5cc29340$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("b7Ydn", function(module, exports) {
$parcel$export(module.exports, "default", () => $01af1416d2d590d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $01af1416d2d590d9$var$messages = (0, $7qGN1.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});
var $01af1416d2d590d9$export$2e2bcd8739ae039 = $01af1416d2d590d9$var$messages;

});

parcelRegister("hjbuK", function(module, exports) {
$parcel$export(module.exports, "createUnit", () => $df66d7a8dfc617f8$export$aab44654646f3ccc);
const $df66d7a8dfc617f8$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


const $e1e7fb6a6c70503b$export$8c7070611f332ef9 = 8;
const $e1e7fb6a6c70503b$export$21ed1f454652d913 = 5;
const $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df = 'pretty';
const $e1e7fb6a6c70503b$export$2ee07242bbb09b61 = 'minute';

parcelRegister("5GvTs", function(module, exports) {
$parcel$export(module.exports, "toLowercaseTimeUnion", () => $2643f7fbf3114189$export$72046bdd228710d3);
// Exclude union value automatically added by Relay
// eslint-disable-next-line @atlassian/relay/no-future-added-value
const $2643f7fbf3114189$export$72046bdd228710d3 = (union)=>union.toLowerCase();

});


parcelRegister("9QjVb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a5a4811371f334c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0a5a4811371f334c$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-original-estimate-readview-full.original-estimate.no-value-text-experiment",
        "defaultMessage": "Add estimate"
    }
});
var $0a5a4811371f334c$export$2e2bcd8739ae039 = $0a5a4811371f334c$var$messages;

});


parcelRegister("iz9K8", function(module, exports) {
$parcel$export(module.exports, "default", () => $309767fda67bd6c2$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $309767fda67bd6c2$var$OriginalEstimateEditViewWithFormattedValueEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jMxUj")), {
        moduleId: "78b5a554",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $309767fda67bd6c2$export$2e2bcd8739ae039 = $309767fda67bd6c2$var$OriginalEstimateEditViewWithFormattedValueEntryPoint;

});
parcelRegister("jMxUj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("74Sbn").then(()=>parcelRequire('fCAPY'));

});


parcelRegister("8T4lL", function(module, exports) {
$parcel$export(module.exports, "useValidateTimeString", () => $ffea187516977204$export$27badca43bbaa0e);
$parcel$export(module.exports, "useParseTimeString", () => $ffea187516977204$export$a1109322d92e0ba8);

var $eJOHy = parcelRequire("eJOHy");

var $169bb = parcelRequire("169bb");


var $5GvTs = parcelRequire("5GvTs");
const $ffea187516977204$var$toTimeFormat = (format)=>{
    return format ? (0, $5GvTs.toLowercaseTimeUnion)(format) : (0, $e1e7fb6a6c70503b$export$c4d2eaadfa3c28df);
};
const $ffea187516977204$var$toTimeUnit = (unit)=>{
    return unit ? (0, $5GvTs.toLowercaseTimeUnion)(unit) : (0, $e1e7fb6a6c70503b$export$2ee07242bbb09b61);
};
const $ffea187516977204$var$useTimeTrackingParsingConfig = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: defaultFormat, defaultUnit: defaultUnit })=>{
    return (0, $eJOHy.useMemo)(()=>({
            hoursPerDay: workingHoursPerDay || (0, $e1e7fb6a6c70503b$export$8c7070611f332ef9),
            daysPerWeek: workingDaysPerWeek || (0, $e1e7fb6a6c70503b$export$21ed1f454652d913),
            format: $ffea187516977204$var$toTimeFormat(defaultFormat),
            defaultUnit: $ffea187516977204$var$toTimeUnit(defaultUnit),
            isTimeTrackingEnabled: true
        }), [
        defaultFormat,
        defaultUnit,
        workingDaysPerWeek,
        workingHoursPerDay
    ]);
};
const $ffea187516977204$export$27badca43bbaa0e = (input)=>{
    const config = $ffea187516977204$var$useTimeTrackingParsingConfig(input);
    return (0, $eJOHy.useMemo)(()=>(0, $169bb.isValidTimeString)(config), [
        config
    ]);
};
const $ffea187516977204$export$a1109322d92e0ba8 = (input)=>{
    const config = $ffea187516977204$var$useTimeTrackingParsingConfig(input);
    return (0, $eJOHy.useMemo)(()=>(0, $169bb.parseTimeString)(config), [
        config
    ]);
};

});
parcelRegister("169bb", function(module, exports) {
$parcel$export(module.exports, "formatTimeString", () => $711aadf76714c8f0$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $711aadf76714c8f0$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $711aadf76714c8f0$export$53148bfa4e677363);

var $1CwHR = parcelRequire("1CwHR");

var $bjCt4 = parcelRequire("bjCt4");

var $zOoy2 = parcelRequire("zOoy2");

var $5iJeL = parcelRequire("5iJeL");

const $711aadf76714c8f0$var$isNumeric = (num)=>num.length > 0 && !Number.isNaN(Number(num));
const $711aadf76714c8f0$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $bjCt4.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $711aadf76714c8f0$var$appendTimeUnitIfMissing = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = $711aadf76714c8f0$var$isNumeric(trimmedValue.replaceAll(',', '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $5iJeL.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $711aadf76714c8f0$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$var$appendTimeUnitIfMissing(config)(value);
        return timeString === '' || (0, $1CwHR.default)(timeString);
    };
const $711aadf76714c8f0$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$var$appendTimeUnitIfMissing(config)(value);
        if (!$711aadf76714c8f0$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $zOoy2.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("1CwHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $719ef9dc390c2db4$export$2e2bcd8739ae039);

var $eRPqr = parcelRequire("eRPqr");

var $zOoy2 = parcelRequire("zOoy2");
const $719ef9dc390c2db4$var$isTimeStringValid = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $zOoy2.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($eRPqr)))(result);
};
var $719ef9dc390c2db4$export$2e2bcd8739ae039 = $719ef9dc390c2db4$var$isTimeStringValid;

});
parcelRegister("eRPqr", function(module, exports) {

var $NROo8 = parcelRequire("NROo8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad2de7eeaba7a4ae$var$nativeIsFinite = $NROo8.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $ad2de7eeaba7a4ae$var$isFinite(value) {
    return typeof value == 'number' && $ad2de7eeaba7a4ae$var$nativeIsFinite(value);
}
module.exports = $ad2de7eeaba7a4ae$var$isFinite;

});

parcelRegister("zOoy2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ff316664bfdacf2$export$2e2bcd8739ae039);
const $5ff316664bfdacf2$var$MINUTES_PER_HOUR = 60;
const $5ff316664bfdacf2$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $5ff316664bfdacf2$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $5ff316664bfdacf2$var$convertToUnitQuantity = (rawString)=>{
    const matches = $5ff316664bfdacf2$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replaceAll(',', '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $5ff316664bfdacf2$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $5ff316664bfdacf2$var$MINUTES_PER_HOUR * $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $5ff316664bfdacf2$var$MINUTES_PER_HOUR * $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $5ff316664bfdacf2$var$MINUTES_PER_HOUR * $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $5ff316664bfdacf2$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($5ff316664bfdacf2$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $5ff316664bfdacf2$export$2e2bcd8739ae039 = $5ff316664bfdacf2$var$timeStringToSeconds;

});


parcelRegister("bjCt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b110ba771aff996$export$2e2bcd8739ae039);
const $1b110ba771aff996$var$MINUTES_PER_HOUR = 60;
const $1b110ba771aff996$var$SECONDS_PER_MINUTE = 60;
const $1b110ba771aff996$var$secondsToTimeString = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $1b110ba771aff996$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};
var $1b110ba771aff996$export$2e2bcd8739ae039 = $1b110ba771aff996$var$secondsToTimeString;

});

parcelRegister("5iJeL", function(module, exports) {
$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $4a595c55416867fe$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $4a595c55416867fe$export$2b38dfc7401492ba = (serverDefaultUnit)=>$4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});



parcelRegister("gc7nM", function(module, exports) {
$parcel$export(module.exports, "useOriginalEstimateValidator", () => $dff13978bd5b469e$export$339bd53893728f75);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $8T4lL = parcelRequire("8T4lL");

var $9EIWa = parcelRequire("9EIWa");
const $dff13978bd5b469e$export$339bd53893728f75 = (settingsInput)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const validate = (0, $8T4lL.useValidateTimeString)(settingsInput);
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (!validate(value)) return {
            type: 'error',
            message: formatMessage((0, $9EIWa.default).invalidInput)
        };
        return null;
    }, [
        formatMessage,
        validate
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("9EIWa", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8f021f33e8707aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f8f021f33e8707aa$var$messages = (0, $7qGN1.defineMessages)({
    invalidInput: {
        "id": "issue-field-original-estimate-inline-edit-full.original-estimate.invalid-input",
        "defaultMessage": "Your estimate must be in the format 2w 4d 6h 45m"
    }
});
var $f8f021f33e8707aa$export$2e2bcd8739ae039 = $f8f021f33e8707aa$var$messages;

});




parcelRegister("8lV7c", function(module, exports) {
$parcel$export(module.exports, "ParentCell", () => $4e88c77e2d329c18$export$d5a4cc78f8c5a2cd);

var $kGrk2 = parcelRequire("kGrk2");

var $dJpvM = parcelRequire("dJpvM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $11Y63 = parcelRequire("11Y63");

var $kDaaB = parcelRequire("kDaaB");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $e0p2q = parcelRequire("e0p2q");
const $4e88c77e2d329c18$export$d5a4cc78f8c5a2cd = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, fieldType: fieldType = '', isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $dJpvM.default), fieldRef);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    /**
   * As part of the initiative to remove "Epic Link" and "Parent Link" fields from Jira,
   * we're rendering a "Replaced by Parent field" deprecation message in the "Parent Link" cell.
   * At the time of writing this comment, "Parent Link" is still used in ~1% of issue tables, and
   * we hope this message will help these users migrate and use the "Parent" field from now on.
   */ if (// eslint-disable-next-line jira/ff/no-preconditioning
    fieldType === 'com.atlassian.jpo:jpo-custom-field-parent' && (0, $4cTDP.fg)('replace-epic-parent-link-by-depreca-message-in-nin') && !(0, $4cTDP.fg)('jsc_fix_parent_cell_hooks_violation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $e0p2q.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const inlineEditData = (0, $j4oe4.useFragment)((0, $kGrk2.default), data);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in inlineEditData && isInlineEditingExtendedFieldSupportEnabled ? inlineEditData.lazyIsEditableInIssueView : false;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eqbO4.useLazyLoadEditability)(inlineEditData.id, isEditable);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11Y63.ParentInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: inlineEditData,
        isTruncated: !isDensityFull || isSingleLineRowHeightEnabled,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        // Render an empty string when there is no parent and experiment is off to mimic FG off state
        emptyText: isInlineEditingExtendedFieldSupportEnabled ? undefined : '',
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled && !isReadOnlyWithoutHoverPopover
    });
});

});
parcelRegister("kGrk2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a1937cc92a0701d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c1ff37455ed7e6adaa0c227f659e8d9f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8a1937cc92a0701d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ParentCell_inlineEdit",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraParentIssueField"
};
$8a1937cc92a0701d$var$node.hash = "ecb8ee006ef4291f9ce69e0f497da89c";
var $8a1937cc92a0701d$export$2e2bcd8739ae039 = $8a1937cc92a0701d$var$node;

});

parcelRegister("dJpvM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7cc824274ac4d21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa36fd9f05080dd53ed68b0e6a9e400e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f7cc824274ac4d21$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "ParentCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ParentCell_inlineEdit"
        }
    ],
    "type": "JiraParentIssueField"
};
$f7cc824274ac4d21$var$node.hash = "8db06abab86f044a74a0380e75e7b907";
var $f7cc824274ac4d21$export$2e2bcd8739ae039 = $f7cc824274ac4d21$var$node;

});

parcelRegister("11Y63", function(module, exports) {
$parcel$export(module.exports, "ParentInlineEditViewIsEditable", () => $088da67924e4d7a9$export$ed7c5b45ec99cbc3);
$parcel$export(module.exports, "ParentInlineEditView", () => $088da67924e4d7a9$export$536c9a0501611e73);

var $iFZ5b = parcelRequire("iFZ5b");

var $2vLh0 = parcelRequire("2vLh0");

var $bUnL2 = parcelRequire("bUnL2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6i8k = parcelRequire("h6i8k");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $d2AGn = parcelRequire("d2AGn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $8MKsY = parcelRequire("8MKsY");

var $bARvQ = parcelRequire("bARvQ");

var $dSKax = parcelRequire("dSKax");

var $hbF3h = parcelRequire("hbF3h");

var $fkc6h = parcelRequire("fkc6h");

var $4cTDP = parcelRequire("4cTDP");

var $kev0f = parcelRequire("kev0f");
const $088da67924e4d7a9$var$isEqualParent = (a, b)=>a?.value === b?.value;
const $088da67924e4d7a9$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-parent-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $088da67924e4d7a9$export$7358e6ab68a1bc5c = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('thor-parent-field-use-monitoring-wrapper'), (0, $fkc6h.useIssueExperienceMonitoring), ()=>({
        enrichCommitWithIssueExperienceMonitoring: (mutationArgs)=>mutationArgs
    }));
const $088da67924e4d7a9$export$ed7c5b45ec99cbc3 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, isTruncated: isTruncated, spacing: spacing = 'compact', emptyText: emptyText, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $bUnL2.default), fragmentRef);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = $088da67924e4d7a9$export$7358e6ab68a1bc5c();
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name } = data;
    const fieldName = overriding.overrideLabel(name);
    const isFieldEditable = overriding?.overrideIsEditable(isEditable);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $2vLh0.default));
    // #endregion
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (data?.parentIssue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $bARvQ.transformParentNode)(data.parentIssue);
        return null;
    }, [
        data.parentIssue
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        if ((0, $4cTDP.fg)('thor-parent-field-use-monitoring-wrapper')) (0, $h6i8k.default)('issue.field.parent.edit');
        onSubmit?.((0, $kev0f.transformOptionToAgg)(option));
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value?.toString() || null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateParentField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateParentField: {
                        success: true,
                        errors: [],
                        field: (0, $kev0f.transformOptionToOptimisticFieldResponse)(data, option?.aggValue)
                    }
                }
            }
        }, 'parent_issueFieldParent_ParentField_Mutation', {
            sendUFOEvent: true
        }, ()=>(0, $4cTDP.fg)('thor-parent-field-use-monitoring-wrapper')));
    }, [
        onSubmit,
        commit,
        uniqueFieldId,
        data,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((option)=>{
        onSubmitSucceeded?.((0, $kev0f.transformOptionToAgg)(option));
    }, [
        onSubmitSucceeded
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        if (initialValue !== value) {
            const oldValId = initialValue?.issueId;
            const newValId = value?.issueId || null;
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, oldValId, newValId);
        }
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $088da67924e4d7a9$var$isEqualParent,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        setAnalyticsAttributes: setAnalyticsAttributes,
        clipboardComponentType: 'parent'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($088da67924e4d7a9$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dSKax.ParentReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            emptyText: emptyText,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled
        })), [
        data,
        isTruncated,
        emptyText,
        isSingleLineRowHeightEnabled
    ]);
    const getEditViewProps = (0, $eJOHy.useCallback)((fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            menuIsOpen: true,
            spacing: spacing
        }), [
        fieldName,
        handleChangeAndConfirm,
        menuPosition,
        menuPortalTarget,
        uniqueFieldId,
        updatedValue,
        spacing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $8MKsY.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
};
const $088da67924e4d7a9$export$536c9a0501611e73 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $iFZ5b.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($088da67924e4d7a9$export$ed7c5b45ec99cbc3, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("iFZ5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $5109f35be6f33862$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d698883de3c28ee2d0fd655b48eeea5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5109f35be6f33862$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$5109f35be6f33862$var$node.hash = "935d17179ef6e93f2b74d57828fd1128";
var $5109f35be6f33862$export$2e2bcd8739ae039 = $5109f35be6f33862$var$node;

});

parcelRegister("2vLh0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd558d5ed2d3a369$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b90688151183c96d2e90f7b13ec9793e>>
 * @relayHash 84d315b6355716bff013d1faca7a35f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c3507f60fd7cc902480ed8bc9a1f24c67a527dd7825518c1979ca92e72e3745

var $hRj2m = parcelRequire("hRj2m");
const $bd558d5ed2d3a369$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "text"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v10 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraParentFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateParentField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraParentIssueField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "concreteType": "JiraColorField",
                                                    "kind": "LinkedField",
                                                    "name": "issueColorField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "color",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "issuetype",
                                                                        "project",
                                                                        "summary",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v4 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                v6 /*: any*/ ,
                                                                                                v5 /*: any*/ ,
                                                                                                v10 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v4 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v4 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c3507f60fd7cc902480ed8bc9a1f24c67a527dd7825518c1979ca92e72e3745",
            "metadata": {},
            "name": "parent_issueFieldParent_ParentField_Mutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default)
            }
        }
    };
}();
$bd558d5ed2d3a369$var$node.hash = "8b384097fdc3b65908abb3c6f1e54624";
var $bd558d5ed2d3a369$export$2e2bcd8739ae039 = $bd558d5ed2d3a369$var$node;

});

parcelRegister("bUnL2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d7502dde3003ce6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391e063db361cd447925786d6a4fe224>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d7502dde3003ce6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "text"
    }, v4 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v6 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "parent_issueFieldParentReadviewFull_ParentReadView"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v2 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "issueId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "project",
                                            "summary",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            v3 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v4 /*: any*/ ,
                                                                    v2 /*: any*/ ,
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v1 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v0 /*: any*/ ,
                                                                            v7 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v5 /*: any*/ ,
                                            v6 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraSingleLineTextField",
                                "kind": "LinkedField",
                                "name": "summaryField",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                    v7 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    };
}();
$2d7502dde3003ce6$var$node.hash = "885477189b93e8b7aa9fa91adde92c64";
var $2d7502dde3003ce6$export$2e2bcd8739ae039 = $2d7502dde3003ce6$var$node;

});

parcelRegister("8MKsY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6254ede357cd9891$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6254ede357cd9891$var$ParentEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bRPQL")), {
        moduleId: "c1f15ee7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $6254ede357cd9891$export$2e2bcd8739ae039 = $6254ede357cd9891$var$ParentEditViewEntryPoint;

});
parcelRegister("bRPQL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dzONu").then(()=>parcelRequire('kTqjh'));

});


parcelRegister("bARvQ", function(module, exports) {
$parcel$export(module.exports, "transformParentNode", () => $346ef850ba3728ec$export$1b622b80a5cf731f);
$parcel$export(module.exports, "transformToSuggestions", () => $346ef850ba3728ec$export$6cffaaeb4c7c0c18);

var $jx0Vw = parcelRequire("jx0Vw");

var $8URAw = parcelRequire("8URAw");

var $4cTDP = parcelRequire("4cTDP");
const $346ef850ba3728ec$var$transformParentNodeOld = (edgeNode)=>{
    const fieldsEdges = edgeNode?.fieldsById?.edges || [];
    const summaryField = fieldsEdges.find((field)=>field?.node?.fieldId === 'summary');
    const issueTypeField = fieldsEdges.find((field)=>field?.node?.fieldId === 'issuetype');
    const statusField = fieldsEdges.find((field)=>field?.node?.fieldId === 'status');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $jx0Vw).StatusCategoryIds[(0, $jx0Vw).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.node?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        issueId: edgeNode?.issueId || undefined,
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        webUrl: edgeNode?.webUrl || undefined,
        fields: {
            issuetype: {
                id: issueTypeField?.node?.issueType?.issueTypeId || '',
                name: issueTypeField?.node?.issueType?.name || '',
                iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.node?.text || ''
        },
        color: colorKey in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
        isDone: isDone,
        aggValue: edgeNode
    };
};
const $346ef850ba3728ec$export$1b622b80a5cf731f = (edgeNode)=>{
    if (!(0, $4cTDP.fg)('dfo_remove_fields_by_id')) return $346ef850ba3728ec$var$transformParentNodeOld(edgeNode);
    const summaryField = edgeNode?.summaryField;
    const issueTypeField = edgeNode?.issueTypeField;
    const statusField = edgeNode?.statusField;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $jx0Vw).StatusCategoryIds[(0, $jx0Vw).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        issueId: edgeNode?.issueId || undefined,
        // @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
        webUrl: edgeNode?.webUrl || undefined,
        fields: {
            issuetype: {
                id: issueTypeField?.issueType?.issueTypeId || '',
                name: issueTypeField?.issueType?.name || '',
                iconUrl: issueTypeField?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.text || ''
        },
        color: colorKey in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.text || ''}`,
        isDone: isDone,
        aggValue: edgeNode
    };
};
const $346ef850ba3728ec$export$6cffaaeb4c7c0c18 = (fieldOptionsData)=>(fieldOptionsData?.edges || [])?.filter((edge)=>edge?.node).map((edge)=>$346ef850ba3728ec$export$1b622b80a5cf731f(edge?.node));

});

parcelRegister("dSKax", function(module, exports) {
$parcel$export(module.exports, "ParentReadView", () => $257192e729b39853$export$72990b9b43fe6c69);

var $fnhET = parcelRequire("fnhET");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");

var $coXKe = parcelRequire("coXKe");

var $3OT15 = parcelRequire("3OT15");

var $ajyMI = parcelRequire("ajyMI");

var $5Cerh = parcelRequire("5Cerh");
const $257192e729b39853$export$72990b9b43fe6c69 = ({ fragmentRef: fragmentRef, disableClickAction: disableClickAction, emptyText: emptyText, onClick: onClick, isTruncated: isTruncated = true, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled })=>{
    const data = (0, $j4oe4.useFragment)((0, $fnhET.default), fragmentRef);
    const { parentIssue: parentIssue } = data;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const noValueTextExperiment = formatMessage((0, $ajyMI.default).noValueTextExperiment);
    const issueType = parentIssue?.issueTypeField?.issueType;
    const label = `${parentIssue?.key} ${parentIssue?.summaryField?.text ?? ''}`;
    const iconUrl = issueType?.avatar?.xsmall;
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: label
    });
    if (!parentIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: isExperimentEnabled ? noValueTextExperiment : emptyText
    });
    if (!isSingleLineRowHeightEnabled) {
        const maybeTruncatedWithTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            alignBlock: "center",
            space: "space.100",
            xcss: [
                isTruncated && $257192e729b39853$var$containerStyles,
                isWideViewLayout && $257192e729b39853$var$wideLayoutMaxWidth
            ]
        }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
            src: iconUrl,
            alt: formatMessage((0, $ajyMI.default).icon, {
                issueType: issueType?.name ?? ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
            disableClickAction: disableClickAction,
            issueKey: parentIssue.key,
            label: label,
            colorKey: parentIssue.issueColorField?.color?.colorKey,
            onClick: onClick,
            isTruncated: isTruncated
        })));
        return (0, $4cTDP.fg)('jira-issues--truncate-parent-field-overflow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $257192e729b39853$var$maxWidth100
        }, maybeTruncatedWithTooltip) : maybeTruncatedWithTooltip;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $257192e729b39853$var$containerStyles
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($257192e729b39853$var$Icon, {
        src: iconUrl,
        alt: formatMessage((0, $ajyMI.default).icon, {
            issueType: issueType?.name ?? ''
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Cerh.Summary), {
        disableClickAction: disableClickAction,
        issueKey: parentIssue?.key || '',
        label: label,
        colorKey: parentIssue?.issueColorField?.color?.colorKey,
        onClick: onClick,
        isTruncated: isTruncated,
        contentRef: hoverPopoverRef
    }));
};
const $257192e729b39853$var$containerStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $257192e729b39853$var$wideLayoutMaxWidth = (0, $1DXK0.xcss)({
    maxWidth: '240px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $257192e729b39853$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
});
const $257192e729b39853$var$maxWidth100 = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("fnhET", function(module, exports) {
$parcel$export(module.exports, "default", () => $17cca88dc2caac89$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0018f1696c12dc89489c683d60edc1be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $17cca88dc2caac89$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "parent_issueFieldParentReadviewFull_ParentReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "parentIssue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraColorField",
                    "kind": "LinkedField",
                    "name": "issueColorField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "color",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "colorKey"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueTypeField",
                    "kind": "LinkedField",
                    "name": "issueTypeField",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraSingleLineTextField",
                    "kind": "LinkedField",
                    "name": "summaryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "text"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraParentIssueField"
};
$17cca88dc2caac89$var$node.hash = "fc9fe20d1bac42ec7b82f622deb0a6d2";
var $17cca88dc2caac89$export$2e2bcd8739ae039 = $17cca88dc2caac89$var$node;

});

parcelRegister("coXKe", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $cxKOj = parcelRequire("cxKOj");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $1M2hR = parcelRequire("1M2hR");


var $bNexr = parcelRequire("bNexr");

var $4cTDP = parcelRequire("4cTDP");

var $FhXEJ = parcelRequire("FhXEJ");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$var$Tabs = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $3b984a26137eed7b$var$defaultActiveTab = $3b984a26137eed7b$var$Tabs.Description;
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ]);
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $1M2hR.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate') && !(0, $4cTDP.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $e8c5fe022e7e442a$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $4cTDP.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $cxKOj.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $cxKOj.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $4cTDP.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = $3b984a26137eed7b$var$defaultActiveTab, ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Description),
            setWorkItemsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Integrations),
            setResourcesAsActive: ()=>setActiveTab($3b984a26137eed7b$var$Tabs.Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {
$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {
$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {
$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {
$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {
$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $6PplZ = parcelRequire("6PplZ");

var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2],
                [(0, $7f80bdb4337734ff$export$e10d4d251d909c59)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$e10d4d251d909c59]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $6PplZ.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("6PplZ", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $520d86b9433cc3c6$export$4027d961191df7c3);

var $eGOwo = parcelRequire("eGOwo");
function $520d86b9433cc3c6$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('ditto_uim_new_attributes_for_uim_use_submit') && fieldsChanges && lastProcessedChange?.changeId === changeId) {
        const fid = lastProcessedChange?.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("81O8J", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);

var $eGOwo = parcelRequire("eGOwo");
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if ((0, $eGOwo.fg)('ditto_uim_error_cb_screen_tabs')) screenTabsFromApp.forEach((tab)=>{
        if (!$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("lpEwy", function(module, exports) {
$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
// this is a global state
const $e029db5d7fe89f63$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$var$store, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {
$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {
$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("ajyMI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7febdbb69aed227c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7febdbb69aed227c$var$messages = (0, $7qGN1.defineMessages)({
    icon: {
        "id": "issue-field-parent-readview-full.parent.icon",
        "defaultMessage": "{issueType} icon"
    },
    noValueTextExperiment: {
        "id": "issue-field-parent.no-value-text-experiment",
        "defaultMessage": "Add parent"
    }
});
var $7febdbb69aed227c$export$2e2bcd8739ae039 = $7febdbb69aed227c$var$messages;

});

parcelRegister("5Cerh", function(module, exports) {
$parcel$export(module.exports, "Summary", () => $76aa50f6a6036032$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $1wTTU = parcelRequire("1wTTU");

var $bVyuq = parcelRequire("bVyuq");
const $76aa50f6a6036032$export$46453a0401d6cd1a = ({ disableClickAction: disableClickAction, onClick: onClick, label: label, colorKey: colorKey, issueKey: issueKey, isTruncated: isTruncated, contentRef: contentRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const lozengeTheme = (0, $eJOHy.useMemo)(()=>colorKey ? (0, $1wTTU.getLozengeThemeByColor)((0, $1wTTU.asColor)(colorKey)) : undefined, [
        colorKey
    ]);
    if (disableClickAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76aa50f6a6036032$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76aa50f6a6036032$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        testId: "issue-field-parent.ui.view-link",
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $bVyuq.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme,
        xcss: [
            $76aa50f6a6036032$var$linkTextStylesBase,
            isTruncated ? $76aa50f6a6036032$var$linkTextStylesTruncated : $76aa50f6a6036032$var$linkTextStylesNonTruncated
        ],
        ref: contentRef
    }, label);
};
const $76aa50f6a6036032$var$linkTextStylesBase = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $76aa50f6a6036032$var$linkTextStylesNonTruncated = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});
const $76aa50f6a6036032$var$linkTextStylesTruncated = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76aa50f6a6036032$var$ButtonText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _19itglyw _11q7glyw _11c82smr _12ji1r31 _1qu21kw7 _12y31o36 _2rkofajl _1bto1l2s _o5721q9c _syaz1kw7 _vwz47vkz _80omtlke _4t3igktf _p12f1osq _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $76aa50f6a6036032$var$WrapperNoClick = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c82smr _2rkofajl _1bto1l2s _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVyuq", function(module, exports) {
$parcel$export(module.exports, "default", () => $66722d678b1a697a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $66722d678b1a697a$var$messages = (0, $7qGN1.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent-readview-full.parent.summary.parent-title",
        "defaultMessage": "Click to visit {label}"
    }
});
var $66722d678b1a697a$export$2e2bcd8739ae039 = $66722d678b1a697a$var$messages;

});



parcelRegister("kev0f", function(module, exports) {
$parcel$export(module.exports, "transformOptionToAgg", () => $d2228ef4a598cc4e$export$4e115b8a3d13d179);
$parcel$export(module.exports, "transformOptionToOptimisticFieldResponse", () => $d2228ef4a598cc4e$export$728251e8d8f6eacb);

var $4cTDP = parcelRequire("4cTDP");
const $d2228ef4a598cc4e$export$4e115b8a3d13d179 = (option)=>{
    if (!option) return null;
    return {
        id: String(option?.id) || '',
        issueId: option?.issueId || '',
        webUrl: option?.webUrl || '',
        key: option?.key,
        issueColorField: {
            color: {
                colorKey: option?.color || ''
            }
        },
        issueTypeField: {
            issueType: {
                avatar: {
                    xsmall: option?.fields?.issuetype?.iconUrl || ''
                },
                name: option?.fields?.issuetype?.name || ''
            }
        },
        summaryField: {
            text: option?.fields.summary || ''
        }
    };
};
const $d2228ef4a598cc4e$export$728251e8d8f6eacb = (field, aggValue)=>{
    if ((0, $4cTDP.fg)('dfo_remove_fields_by_id')) {
        const summaryField = aggValue?.summaryField;
        const issueTypeField = aggValue?.issueTypeField;
        const statusField = aggValue?.statusField;
        return {
            id: field?.id,
            fieldId: field?.fieldId,
            type: field?.type,
            name: field?.name,
            parentIssue: aggValue ? {
                id: aggValue?.id,
                issueId: aggValue?.issueId,
                webUrl: aggValue?.webUrl,
                key: aggValue?.key,
                issueColorField: aggValue?.issueColorField,
                summaryField: {
                    id: summaryField?.id || '',
                    fieldId: summaryField?.fieldId || '',
                    text: summaryField?.text || ''
                },
                issueTypeField: {
                    id: issueTypeField?.id || '',
                    fieldId: issueTypeField?.fieldId || '',
                    issueType: {
                        id: issueTypeField?.issueType?.id || '',
                        avatar: {
                            xsmall: issueTypeField?.issueType?.avatar?.xsmall || ''
                        },
                        hierarchy: {
                            level: issueTypeField?.issueType?.hierarchy?.level || 0
                        },
                        issueTypeId: issueTypeField?.issueType?.issueTypeId || '',
                        name: issueTypeField?.issueType?.name || ''
                    }
                },
                statusField: {
                    id: statusField?.id || '',
                    fieldId: statusField?.fieldId || '',
                    status: {
                        id: statusField?.status?.id || '',
                        statusCategory: {
                            id: statusField?.status?.statusCategory?.id || '',
                            statusCategoryId: statusField?.status?.statusCategory?.statusCategoryId || ''
                        }
                    }
                }
            } : null
        };
    }
    const summaryField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraSingleLineTextField');
    const issueTypeField = aggValue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraIssueTypeField');
    return {
        id: field?.id,
        fieldId: field?.fieldId,
        type: field?.type,
        name: field?.name,
        parentIssue: aggValue ? {
            id: aggValue?.id,
            issueId: aggValue?.issueId,
            webUrl: aggValue?.webUrl,
            key: aggValue?.key,
            issueColorField: aggValue?.issueColorField,
            fieldsById: aggValue?.fieldsById,
            summaryField: {
                id: summaryField?.node?.id || '',
                text: summaryField?.node?.text || '',
                fieldId: summaryField?.node?.fieldId || ''
            },
            issueTypeField: {
                id: issueTypeField?.node?.id || '',
                fieldId: issueTypeField?.node?.fieldId || '',
                issueType: {
                    id: issueTypeField?.node?.issueType?.id || '',
                    avatar: {
                        xsmall: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
                    },
                    // Added to keep types in sync with new code path
                    hierarchy: {
                        level: issueTypeField?.node?.issueType?.hierarchy?.level || 0
                    },
                    issueTypeId: issueTypeField?.node?.issueType?.issueTypeId || '',
                    name: issueTypeField?.node?.issueType?.name || ''
                }
            }
        } : null
    };
};

});


parcelRegister("e0p2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1108666f999df9c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1108666f999df9c8$var$messages = (0, $7qGN1.defineMessages)({
    replacedByParentField: {
        "id": "native-issue-table.common.issue-cells.parent.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});
var $1108666f999df9c8$export$2e2bcd8739ae039 = $1108666f999df9c8$var$messages;

});


parcelRegister("iCclW", function(module, exports) {
$parcel$export(module.exports, "PlainTextCell", () => $2995e0c8eb6a06ef$export$4e4b42df80bf4dce);

var $iTj2o = parcelRequire("iTj2o");

var $lrV6l = parcelRequire("lrV6l");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9t1Xl = parcelRequire("9t1Xl");

var $d9T1A = parcelRequire("d9T1A");

var $9Mapt = parcelRequire("9Mapt");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $8mV8n = parcelRequire("8mV8n");

var $34oCh = parcelRequire("34oCh");

var $eqbO4 = parcelRequire("eqbO4");

var $8jOO7 = parcelRequire("8jOO7");
// Attributes for inline editing track events
const $2995e0c8eb6a06ef$var$attributes = {
    // If the update was made inline (and not via the issue view)
    isInlineEditing: true
};
const $2995e0c8eb6a06ef$export$4e4b42df80bf4dce = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $lrV6l.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isDensityCompact = !(0, $34oCh.useIsDensityFull)();
    const contentRef = (0, $eJOHy.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const renderCustomReadView = (0, $eJOHy.useCallback)((text)=>{
        if (!text) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
        if (isSingleLineRowHeightEnabled) {
            if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) {
                let hoverPopoverRef = null;
                hoverPopoverRef = hoverPopoverRefFactory({
                    content: text
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    ref: hoverPopoverRef,
                    maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
                    testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
                }, text);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: text,
                contentRef: contentRef
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
                    maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
                    testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
                }, text));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            maxLines: isDensityCompact ? 2 : undefined
        }, text);
    }, [
        isDensityCompact,
        isSingleLineRowHeightEnabled,
        hoverPopoverRefFactory
    ]);
    if (!isInlineEditingExtendedFieldSupportEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2995e0c8eb6a06ef$export$8361effa71bec5d8, {
        fieldRef: data
    });
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $2995e0c8eb6a06ef$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $2995e0c8eb6a06ef$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: isFirstField ? renderCustomReadView : undefined,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled && isFirstField
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9t1Xl.SingleLineTextInlineEditViewWithIsEditable), {
        attributes: $2995e0c8eb6a06ef$var$attributes,
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        maxLength: 255,
        readViewFitContainerHeight: true,
        renderCustomReadView: renderCustomReadView,
        hideEditButton: true,
        hasReadViewTruncateDisabled: isSingleLineRowHeightEnabled
    });
});
const $2995e0c8eb6a06ef$export$8361effa71bec5d8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const data = (0, $j4oe4.useFragment)((0, $iTj2o.default), fieldRef);
    const { text: text } = data;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const contentRef = (0, $eJOHy.useRef)(null);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory && (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) hoverPopoverRef = hoverPopoverRefFactory({
        content: text
    });
    if (isSingleLineRowHeightEnabled) return (0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        ref: hoverPopoverRef,
        maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
        testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
    }, text)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
        content: text,
        contentRef: contentRef
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingBlock: "space.050",
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            ref: (0, $bzbsd.mergeRefs)(contentRef, ref),
            maxLines: (0, $8jOO7.MAX_LINE_WRAP_NEW),
            testId: "native-issue-table.common.ui.issue-cells.plain-text.text"
        }, text)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mV8n.TruncatedTextWithPopup), {
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, text),
        triggerText: text ?? null
    });
});
const $2995e0c8eb6a06ef$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $2995e0c8eb6a06ef$var$customTargetStyles : $2995e0c8eb6a06ef$var$customTargetStylesOld,
        ref: ref
    });
});
const $2995e0c8eb6a06ef$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $2995e0c8eb6a06ef$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("iTj2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $a940a81b86dc0694$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a7d1c876b733b2ac680fe9f5899ea20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a940a81b86dc0694$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PlainTextCellOld_PlainTextCellOld",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$a940a81b86dc0694$var$node.hash = "21ef2273331f78548bbf59a012bb6b51";
var $a940a81b86dc0694$export$2e2bcd8739ae039 = $a940a81b86dc0694$var$node;

});

parcelRegister("lrV6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $89986807ceb90997$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0373734ffe77dec06c81d05fa1bec1ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $89986807ceb90997$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "PlainTextCellOld",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PlainTextCellOld_PlainTextCellOld"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$89986807ceb90997$var$node.hash = "d9bf0805b04b32210f14fe02304844b2";
var $89986807ceb90997$export$2e2bcd8739ae039 = $89986807ceb90997$var$node;

});

parcelRegister("8mV8n", function(module, exports) {
$parcel$export(module.exports, "TruncatedTextWithPopup", () => $c45d5d8603d7c463$export$a81ef5b6e801751b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $4B7rn = parcelRequire("4B7rn");

var $8nMzv = parcelRequire("8nMzv");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $eS29z = parcelRequire("eS29z");

var $8jOO7 = parcelRequire("8jOO7");

var $lvbmo = parcelRequire("lvbmo");
const $c45d5d8603d7c463$export$a81ef5b6e801751b = /*#__PURE__*/ (0, $eJOHy.memo)(({ triggerText: triggerText, content: content, triggerRefCallback: triggerRefCallback, onSetIsOpen: onSetIsOpen, isOpen: isOpen, maxLength: maxLength = (0, $8jOO7.MAX_LINE_WRAP_OLD) })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!triggerText) return null;
    const onClick = ()=>{
        onSetIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'truncatedTextWithPopupButton');
    };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c45d5d8603d7c463$var$TruncatedTextContainer, {
            onClick: onClick,
            ...triggerProps,
            ref: (element)=>{
                triggerRefCallback && triggerRefCallback(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c45d5d8603d7c463$var$TruncatedText, {
            maxLength: maxLength
        }, triggerText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>onSetIsOpen(false),
        messageId: "native-issue-table.common.ui.truncated-text-cell-with-popup.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
                sourceName: "TruncatedTextPopUpContent",
                sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
            }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null)),
        trigger: trigger,
        placement: "bottom",
        popupComponent: (0, $lvbmo.PopupContainer)
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45d5d8603d7c463$var$TruncatedTextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7glyw _19itglyw _11c82smr _1rjc1b66 _18zru2gc _80omtlke _1e0c1ule _vchhusvi _syaz1fxt _4t3i1osq _1bsb1osq _6sshglyw _1oex4v9p _nt751r31 _49pcglyw _1hvw1o36 _7ehi64oc _irr3166n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45d5d8603d7c463$var$TruncatedText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_jz2kj3": (0, $awdRS.default)(__cmplp.maxLength)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _y3gn1e5h _1e0ccj1k _1bto1l2s _sudp1e54 _1yyjpeh7 _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lvbmo", function(module, exports) {
$parcel$export(module.exports, "PopupContainer", () => $8fff991d977513ff$export$cca08eed9de89ba9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $8fff991d977513ff$var$layerValue = (0, $IW7jS.layers).layer;
/**
 * Styling the container itself removes the need for an additional nested `<div>`,
 * containing our custom styles, in the Popup content. Having an extra `<div>`
 * introduces problems with autofocus when popup is opened.
 *
 * Unfortunately the base PopupContainer styles are not exported from atlaskit,
 * so they had to be copy + pasted and extended with our custom styles.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fff991d977513ff$var$StyledPopupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rkofajl _1reo1wug _18m91wug _189edkaa _1dqonqa1 _1h6d1p6i _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _1bsbdgin _c71l1kdj _1tke12am _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $8fff991d977513ff$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8fff991d977513ff$var$StyledPopupContainer, {
        ...props,
        ref: ref
    }));

});



parcelRegister("fr65p", function(module, exports) {
$parcel$export(module.exports, "PriorityCell", () => $0a0ad7e9fcb5014b$export$b526cf238a0a0ab3);

var $9phQK = parcelRequire("9phQK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8sJ8t = parcelRequire("8sJ8t");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");
const $0a0ad7e9fcb5014b$export$b526cf238a0a0ab3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $9phQK.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    let isEditable = false;
    if ('isEditableInIssueView' in data) isEditable = data.isEditableInIssueView;
    else if ('lazyIsEditableInIssueView' in data) isEditable = data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8sJ8t.PriorityInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
});

});
parcelRegister("9phQK", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b8d8b32b17235db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3d6bfe11c8f936ac1ad55108b801dc5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9b8d8b32b17235db$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "PriorityCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraPriorityField"
};
$9b8d8b32b17235db$var$node.hash = "3d9028ea969ee9e86affcf87707b2616";
var $9b8d8b32b17235db$export$2e2bcd8739ae039 = $9b8d8b32b17235db$var$node;

});

parcelRegister("8sJ8t", function(module, exports) {
$parcel$export(module.exports, "PriorityInlineEditViewIsEditable", () => $1e7fc42b27c29889$export$90b66d052260aa39);
$parcel$export(module.exports, "PriorityInlineEditView", () => $1e7fc42b27c29889$export$934d144304ae7d88);

var $35cth = parcelRequire("35cth");

var $5tW5L = parcelRequire("5tW5L");

var $74Y5d = parcelRequire("74Y5d");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1IiSl = parcelRequire("1IiSl");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $d2AGn = parcelRequire("d2AGn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $i0tCo = parcelRequire("i0tCo");

var $faRrL = parcelRequire("faRrL");

var $3OT15 = parcelRequire("3OT15");

var $gwLYs = parcelRequire("gwLYs");
const $1e7fc42b27c29889$var$isEqualPriority = (a, b)=>a?.value === b?.value;
const $1e7fc42b27c29889$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-priority-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $1e7fc42b27c29889$export$90b66d052260aa39 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, isCompact: isCompact, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $74Y5d.default), fragmentRef);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, priority: priority } = data;
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: data.priority?.name
    });
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding?.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding?.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overriding?.overrideFieldOptionsFilter(null), [
        overriding
    ]);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $5tW5L.default));
    // #endregion
    const initialValue = (0, $eJOHy.useMemo)(()=>priority ? {
            label: priority.name ?? '',
            value: priority.id,
            iconUrl: priority.iconUrl ?? ''
        } : null, [
        priority
    ]);
    // #region Common state
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const aggValue = (0, $gwLYs.transformOptionToAgg)(option);
        onSubmit?.(aggValue);
        if (option?.value != null) commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updatePriorityField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updatePriorityField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            priority: aggValue
                        }
                    }
                }
            }
        });
    }, [
        onSubmit,
        commit,
        uniqueFieldId
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.((0, $gwLYs.transformOptionToAgg)(value));
    }, [
        onSubmitSucceeded
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, (0, $1IiSl.getPriorityIdFromAri)(initialValue?.value), (0, $1IiSl.getPriorityIdFromAri)(value?.value));
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $1e7fc42b27c29889$var$isEqualPriority,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        clipboardComponentType: 'priority',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const readViewContentRef = (0, $eJOHy.useRef)(null);
    const renderReadView = (0, $eJOHy.useCallback)((ref = null)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e7fc42b27c29889$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $faRrL.PriorityReadView), {
                fragmentRef: data,
                isCompact: isCompact,
                contentRef: readViewContentRef,
                ref: ref
            })), [
        data,
        isCompact
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            openMenuOnFocus: true,
            menuPosition: menuPosition,
            filterOptionsById: filterOptionsById
        });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
            editViewPopup: editViewPopup,
            editViewPopupAlignBlock: editViewPopupAlignBlock,
            editViewPopupMinWidth: "small",
            editViewEntryPoint: (0, $i0tCo.default),
            editViewEntryPointParams: {},
            getEditViewProps: getEditViewProps,
            fieldName: fieldName,
            hasUnsubmittedChanges: hasServerValidationError,
            invalidMessage: invalidMessage,
            isEditing: isEditing,
            isEditable: isFieldEditable,
            onCancel: handleCancel,
            onConfirm: handleConfirm,
            onEdit: handleEdit,
            onCopy: handleCopy,
            onCut: handleCut,
            onPaste: handlePaste,
            readViewFitContainerHeight: readViewFitContainerHeight,
            readView: ref ? renderReadView(ref) : renderReadView(),
            hideActionButtons: true
        });
    if (!shouldRenderHoverPopover) return content();
    return content(hoverPopoverRef);
};
const $1e7fc42b27c29889$export$934d144304ae7d88 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $35cth.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e7fc42b27c29889$export$90b66d052260aa39, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("35cth", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b9f8fc58164f39c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa62d4fc64bc2c74e04363ef91ec33f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b9f8fc58164f39c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$8b9f8fc58164f39c$var$node.hash = "a5f9582db120fe1c7d1ede5d19fc0614";
var $8b9f8fc58164f39c$export$2e2bcd8739ae039 = $8b9f8fc58164f39c$var$node;

});

parcelRegister("5tW5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0f610aad8a2e449$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb32ad0218f1234eb10ceea6afef44da>>
 * @relayHash afc6cf650d76ec77ae6c4e967b74c46b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa
const $d0f610aad8a2e449$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPriorityFieldPayload",
                            "kind": "LinkedField",
                            "name": "updatePriorityField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa",
            "metadata": {},
            "name": "priority_issueFieldPriority_PriorityField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d0f610aad8a2e449$var$node.hash = "e0f2a7894e2dd7cf045761e8324c5c39";
var $d0f610aad8a2e449$export$2e2bcd8739ae039 = $d0f610aad8a2e449$var$node;

});

parcelRegister("74Y5d", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8aeb6c10c6b6e97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a915f86f984bf0d357677c111ce3d858>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8aeb6c10c6b6e97$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
}();
$a8aeb6c10c6b6e97$var$node.hash = "d2dd68625b79ae7cbb16126a5aa64c95";
var $a8aeb6c10c6b6e97$export$2e2bcd8739ae039 = $a8aeb6c10c6b6e97$var$node;

});

parcelRegister("i0tCo", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d00e9330fb89b3$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $09d00e9330fb89b3$var$PriorityEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("h2I6y")), {
        moduleId: "079c16d8",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $09d00e9330fb89b3$export$2e2bcd8739ae039 = $09d00e9330fb89b3$var$PriorityEditViewEntryPoint;

});
parcelRegister("h2I6y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5lDnH").then(()=>parcelRequire('hryia'));

});


parcelRegister("faRrL", function(module, exports) {
$parcel$export(module.exports, "PriorityReadView", () => $df35b4b66c4dd438$export$9ff40693dcfb2eb3);

var $jqSCd = parcelRequire("jqSCd");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bQyn2 = parcelRequire("bQyn2");

var $d9T1A = parcelRequire("d9T1A");
const $df35b4b66c4dd438$export$9ff40693dcfb2eb3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ fragmentRef: fragmentRef, isCompact: isCompact, contentRef: contentRef }, ref)=>{
    const data = (0, $j4oe4.useFragment)((0, $jqSCd.default), fragmentRef);
    const value = data.priority;
    if (isCompact && (!value?.name || !value?.iconUrl)) return null;
    if (!value?.name || !value?.iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df35b4b66c4dd438$var$Wrapper, {
        "data-testid": "issue-field-priority-readview-full.ui.priority.wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        url: value.iconUrl,
        alt: isCompact ? value.name : undefined
    }), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df35b4b66c4dd438$var$Text, {
        ref: contentRef
    }, value.name));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df35b4b66c4dd438$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3igktf _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $df35b4b66c4dd438$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jqSCd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e96663eba06261c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac973913f9060bb519739c5dc997ac7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e96663eba06261c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_issueFieldPriorityReadviewFull_PriorityReadView",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$3e96663eba06261c$var$node.hash = "332bda8ea012bca1bc3e1ad5426cb13a";
var $3e96663eba06261c$export$2e2bcd8739ae039 = $3e96663eba06261c$var$node;

});

parcelRegister("bQyn2", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $69a57831c94bcd51$var$defaultIconSize = 16;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});


parcelRegister("gwLYs", function(module, exports) {
$parcel$export(module.exports, "transformOptionToAgg", () => $f837a33cb89a6ac6$export$4e115b8a3d13d179);

var $1IiSl = parcelRequire("1IiSl");
const $f837a33cb89a6ac6$export$4e115b8a3d13d179 = (option)=>option ? {
        id: option.value,
        iconUrl: option.iconUrl,
        name: option.label,
        priorityId: (0, $1IiSl.getPriorityIdFromAri)(option.value)
    } : option;

});



parcelRegister("5U6Sf", function(module, exports) {
$parcel$export(module.exports, "ProjectCell", () => $2a05dff50778879d$export$a0acc7707bde1d3);

var $kdJEA = parcelRequire("kdJEA");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $11SWN = parcelRequire("11SWN");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $86BUM = parcelRequire("86BUM");
const $2a05dff50778879d$export$a0acc7707bde1d3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isRequired: isRequired, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.useFragment)((0, $kdJEA.default), fieldRef);
    const { project: project } = data;
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!isRequired && project == null) return null;
    if (project == null || project.name == null || project.key == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "project",
        reason: "Missing required fields"
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: project.name
    });
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a05dff50778879d$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a05dff50778879d$var$AlignmentFix, {
        hasAvatar: Boolean(project.avatar?.large)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $11SWN.ProjectReadView), {
        value: {
            key: project.key,
            name: project.name,
            avatarUrls: {
                '48x48': project.avatar?.large ?? ''
            }
        },
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'tableIssueLink');
        },
        isTruncated: !isDensityFull,
        contentRef: hoverPopoverRef
    }));
});
// The Project component has a 4px padding plus the avatar inside has a 2px invisible border that we have to account for
// Refer to: src/packages/issue/fields/project/src/ui/view/main.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a05dff50778879d$var$AlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasAvatar: hasAvatar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ogwtze3t _6tinze3t _1cezze3t _m3zkze3t",
            __cmplp.hasAvatar ? "_ahbq1i6y" : "_ahbqze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kdJEA", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcc7504b84d7a6af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74bd2c4f1dc5f0bbf77e81d505b4c61a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcc7504b84d7a6af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "large"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProjectField"
};
$dcc7504b84d7a6af$var$node.hash = "0010a81c0e94e4208da7772b6cf27cdc";
var $dcc7504b84d7a6af$export$2e2bcd8739ae039 = $dcc7504b84d7a6af$var$node;

});

parcelRegister("11SWN", function(module, exports) {
$parcel$export(module.exports, "ProjectReadView", () => $cd6933b72e61d231$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $cd6933b72e61d231$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick, isTruncated: isTruncated = true, contentRef: contentRef })=>{
    const onClickLink = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd6933b72e61d231$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd6933b72e61d231$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd6933b72e61d231$var$labelContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        testId: "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyUp: stopPropagation,
        onKeyDown: stopPropagation,
        href: `/projects/${value.key}`,
        xcss: [
            $cd6933b72e61d231$var$labelLinkStylesBase,
            isTruncated ? $cd6933b72e61d231$var$labelLinkStylesTruncated : $cd6933b72e61d231$var$labelLinkStylesNonTruncated
        ],
        ref: contentRef
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd6933b72e61d231$var$EmptyValue = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$emptyValueContainerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd6933b72e61d231$var$AvatarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $cd6933b72e61d231$var$labelContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    minWidth: '0',
    marginRight: 'space.100'
});
const $cd6933b72e61d231$var$labelLinkStylesBase = (0, $1DXK0.xcss)({
    display: 'inline-block',
    maxWidth: '100%',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $cd6933b72e61d231$var$labelLinkStylesTruncated = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $cd6933b72e61d231$var$labelLinkStylesNonTruncated = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});

});


parcelRegister("36qKB", function(module, exports) {
$parcel$export(module.exports, "RadioSelectCell", () => $5e07189557c50d9d$export$fca29406b7991f70);

var $bcIbd = parcelRequire("bcIbd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cVtVW = parcelRequire("cVtVW");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $5e07189557c50d9d$export$fca29406b7991f70 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $bcIbd.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVtVW.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $5e07189557c50d9d$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVtVW.RadioSelectInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        maxLines: 1,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $5e07189557c50d9d$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $5e07189557c50d9d$var$customTargetStyles : $5e07189557c50d9d$var$customTargetStylesOld,
        ref: ref
    });
});
const $5e07189557c50d9d$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $5e07189557c50d9d$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("bcIbd", function(module, exports) {
$parcel$export(module.exports, "default", () => $22198bcc00dca4c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f28de48f4a4579a29fd8bd377fb7a27>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22198bcc00dca4c9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RadioSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraRadioSelectField"
};
$22198bcc00dca4c9$var$node.hash = "a98ece099fb9c41b83161d791f1cb1c1";
var $22198bcc00dca4c9$export$2e2bcd8739ae039 = $22198bcc00dca4c9$var$node;

});

parcelRegister("cVtVW", function(module, exports) {
$parcel$export(module.exports, "RadioSelectInlineEditViewWithIsEditable", () => $b6983db111adbe70$export$75b30b2e24d95c5b);

var $931At = parcelRequire("931At");

var $fNju7 = parcelRequire("fNju7");

var $e5obU = parcelRequire("e5obU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $jF5pp = parcelRequire("jF5pp");

var $G3oln = parcelRequire("G3oln");

var $auNLL = parcelRequire("auNLL");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $b6983db111adbe70$var$isEqualOption = (a, b)=>a?.value === b?.value;
const $b6983db111adbe70$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-radio-select-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b6983db111adbe70$export$75b30b2e24d95c5b = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, isEditable: isEditable, isEditing: startWithEditViewOpen = false, maxLines: maxLines, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $e5obU.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $fNju7.default));
    const { id: uniqueFieldId, name: name, selectedOption: selectedOption, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOption?.label) return null;
        return {
            value: selectedOption?.value ?? '',
            label: selectedOption?.label ?? ''
        };
    }, [
        selectedOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(option);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateRadioSelectField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateRadioSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedOption: {
                                id: option?.value ?? '',
                                label: option?.label ?? '',
                                value: option?.value ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $b6983db111adbe70$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'radioSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6983db111adbe70$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $G3oln.RadioSelectReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        maxLines,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $jF5pp.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $b6983db111adbe70$export$2fe0a2918d206b4f = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $931At.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6983db111adbe70$export$75b30b2e24d95c5b, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("931At", function(module, exports) {
$parcel$export(module.exports, "default", () => $d77c6c685a91bfb9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a9b2d76f8b35cc5bb4a87c0769a312f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d77c6c685a91bfb9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$d77c6c685a91bfb9$var$node.hash = "dd081df58866af7dd0bb2712ac60b258";
var $d77c6c685a91bfb9$export$2e2bcd8739ae039 = $d77c6c685a91bfb9$var$node;

});

parcelRegister("fNju7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c790734486a3c741$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09a77006108849a239b50899d995715a>>
 * @relayHash 0a9076c42b3eff02943fe0ca4c26d03d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a4bbe113bd046949ec9cd2e64f8e06f2200fcba03e659c207511757b491ce066
const $c790734486a3c741$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRadioSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateRadioSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraRadioSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": "value",
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a4bbe113bd046949ec9cd2e64f8e06f2200fcba03e659c207511757b491ce066",
            "metadata": {},
            "name": "radioSelect_issueFieldRadioSelect_RadioSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c790734486a3c741$var$node.hash = "c21145b09e3422aaf4c5cef7684d37b2";
var $c790734486a3c741$export$2e2bcd8739ae039 = $c790734486a3c741$var$node;

});

parcelRegister("e5obU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b431b445dc777ef4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59c263de72de7e78a494bb2126d6f5c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b431b445dc777ef4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectInlineEditFull_RadioSelectInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "value",
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$b431b445dc777ef4$var$node.hash = "e7794cc18631c54a9305078af2e6b52a";
var $b431b445dc777ef4$export$2e2bcd8739ae039 = $b431b445dc777ef4$var$node;

});

parcelRegister("jF5pp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f9c80b6cdc9f62d$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5f9c80b6cdc9f62d$var$RadioSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4ZzeW")), {
        moduleId: "d70243cc",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $5f9c80b6cdc9f62d$export$2e2bcd8739ae039 = $5f9c80b6cdc9f62d$var$RadioSelectEditViewEntryPoint;

});
parcelRegister("4ZzeW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jKXeZ").then(()=>parcelRequire('6OxSZ'));

});


parcelRegister("G3oln", function(module, exports) {
$parcel$export(module.exports, "RadioSelectReadView", () => $e7c58c6de3805c49$export$6455a2bb536ab8db);

var $ipQig = parcelRequire("ipQig");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $3OT15 = parcelRequire("3OT15");
const $e7c58c6de3805c49$export$6455a2bb536ab8db = ({ fragmentRef: fragmentRef, maxLines: maxLines, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $ipQig.default), fragmentRef);
    const { selectedOption: selectedOption } = data;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!selectedOption?.label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: selectedOption?.label
    });
    if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines,
        ref: hoverPopoverRef
    }, selectedOption?.label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines,
        ref: contentRef
    }, selectedOption?.label);
};

});
parcelRegister("ipQig", function(module, exports) {
$parcel$export(module.exports, "default", () => $1793aab392779be5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d71d2b7baf0cb219c867813927a678df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1793aab392779be5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "selectedOption",
            "plural": false,
            "selections": [
                {
                    "alias": "label",
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ],
    "type": "JiraRadioSelectField"
};
$1793aab392779be5$var$node.hash = "b7cbd05b4ede163325935a84f69fdb87";
var $1793aab392779be5$export$2e2bcd8739ae039 = $1793aab392779be5$var$node;

});




parcelRegister("j5nH8", function(module, exports) {
$parcel$export(module.exports, "RequestTypeCell", () => $36b3f5de090b8472$export$f5707174b12c16a9);

var $19SNR = parcelRequire("19SNR");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $3OT15 = parcelRequire("3OT15");

var $86BUM = parcelRequire("86BUM");

var $34oCh = parcelRequire("34oCh");
const $36b3f5de090b8472$var$REQUEST_TYPE_IMAGE_SIZE = 16;
const $36b3f5de090b8472$export$f5707174b12c16a9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $19SNR.default), fieldRef);
    const { requestType: requestType } = data;
    const hoverPopoverEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = hoverPopoverEnabled ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!requestType) return null;
    if (!requestType.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: "requestType",
        reason: "Missing required fields"
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: requestType.name
    });
    const content = (ref = null)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            alignBlock: "center",
            space: "space.100",
            ref: ref
        }, requestType?.avatar?.xsmall && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $36b3f5de090b8472$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: requestType.avatar.xsmall,
            width: $36b3f5de090b8472$var$REQUEST_TYPE_IMAGE_SIZE,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: hoverPopoverEnabled ? $36b3f5de090b8472$var$textEllipsesStyles : $36b3f5de090b8472$var$textOverflowStyles,
            ref: contentRef
        }, requestType.name));
    if (hoverPopoverEnabled) return content(hoverPopoverRef);
    return content();
});
const $36b3f5de090b8472$var$imageContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline',
    height: `${$36b3f5de090b8472$var$REQUEST_TYPE_IMAGE_SIZE}px`
});
const $36b3f5de090b8472$var$textOverflowStyles = (0, $1DXK0.xcss)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word'
});
const $36b3f5de090b8472$var$textEllipsesStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word'
});

});
parcelRegister("19SNR", function(module, exports) {
$parcel$export(module.exports, "default", () => $da371f1d740793ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7849ca920a13f704e862bf49c3ec6adf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da371f1d740793ac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RequestTypeCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraServiceManagementRequestType",
            "kind": "LinkedField",
            "name": "requestType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "xsmall"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraServiceManagementRequestTypeField"
};
$da371f1d740793ac$var$node.hash = "45180e31ad2753123d699f3c255083f3";
var $da371f1d740793ac$export$2e2bcd8739ae039 = $da371f1d740793ac$var$node;

});


parcelRegister("fAn1n", function(module, exports) {
$parcel$export(module.exports, "ResolutionCell", () => $40f067083f8f391c$export$8b67413bfec99fe);

var $kYufY = parcelRequire("kYufY");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $3OT15 = parcelRequire("3OT15");

var $34oCh = parcelRequire("34oCh");

var $iOUbG = parcelRequire("iOUbG");
const $40f067083f8f391c$export$8b67413bfec99fe = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $kYufY.default), fieldRef);
    const { resolution: resolution } = data;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    const hoverPopoverRefFactory = isSingleLineRowHeightEnabled ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    const text = resolution?.name ?? formatMessage((0, $iOUbG.default).unresolved);
    if (!isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40f067083f8f391c$var$Cell, {
        "data-vc": "native-issue-table-ui-resolution-cell"
    }, text);
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: text
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40f067083f8f391c$var$Cell, {
        "data-vc": "native-issue-table-ui-resolution-cell",
        ref: hoverPopoverRef
    }, text);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40f067083f8f391c$var$Cell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kYufY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a6d4ac5536b18ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aeab19412c3a97981e1a0c8d007b9ef0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a6d4ac5536b18ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ResolutionCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraResolution",
            "kind": "LinkedField",
            "name": "resolution",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraResolutionField"
};
$7a6d4ac5536b18ff$var$node.hash = "4449f0b7b9830682d20e8224a7da5b31";
var $7a6d4ac5536b18ff$export$2e2bcd8739ae039 = $7a6d4ac5536b18ff$var$node;

});

parcelRegister("iOUbG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d76f5b91cdad1216$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d76f5b91cdad1216$var$messages = (0, $7qGN1.defineMessages)({
    unresolved: {
        "id": "native-issue-table.common.issue-cells.resolution.unresolved",
        "defaultMessage": "Unresolved"
    }
});
var $d76f5b91cdad1216$export$2e2bcd8739ae039 = $d76f5b91cdad1216$var$messages;

});


parcelRegister("gfFaI", function(module, exports) {
$parcel$export(module.exports, "RichTextCell", () => $d830ff7abe2ae704$export$b77590c339790c17);

var $6Fvlm = parcelRequire("6Fvlm");

var $5wfJq = parcelRequire("5wfJq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $3cMgR = parcelRequire("3cMgR");

var $dk7W5 = parcelRequire("dk7W5");

var $cHtIB = parcelRequire("cHtIB");

var $iWvkh = parcelRequire("iWvkh");

var $9Mapt = parcelRequire("9Mapt");

var $cBavF = parcelRequire("cBavF");

var $ibVOD = parcelRequire("ibVOD");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $5Rrfi = parcelRequire("5Rrfi");

var $8ia30 = parcelRequire("8ia30");

var $9Ubc3 = parcelRequire("9Ubc3");

var $g2AHA = parcelRequire("g2AHA");
const $d830ff7abe2ae704$export$b77590c339790c17 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, fieldRef: fieldRef, issueRef: issueRef, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isFirstField: isFirstField })=>{
    const { richText: richText, fieldId: fieldId } = (0, $j4oe4.useFragment)((0, $5wfJq.default), fieldRef);
    const issueData = (0, $j4oe4.useFragment)((0, $6Fvlm.default), issueRef || null);
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $9Ubc3.richTextPopUpContentEntryPoint), entryPointParams);
    if (isSingleLineRowHeightEnabled && !isDensityFull) {
        const previewText = richText?.adfValue?.convertedPlainText?.plainText;
        if (!isFirstField) return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
            xcss: $d830ff7abe2ae704$var$readOnlyNoPopoverStyles
        }, /*#__PURE__*/ $eJOHy.createElement((0, $3cMgR.default), {
            maxLines: 1
        }, previewText));
        return /*#__PURE__*/ $eJOHy.createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ $eJOHy.createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: previewText && /*#__PURE__*/ $eJOHy.createElement((0, $cBavF.JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    id: "rich-text-popup-content",
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    errorFallback: ()=>/*#__PURE__*/ $eJOHy.createElement((0, $g2AHA.ErrorState), null),
                    fallback: /*#__PURE__*/ $eJOHy.createElement((0, $7ep4S.default), {
                        size: "medium"
                    }),
                    runtimeProps: {}
                }),
                entryPointActions: entryPointActions,
                isInteractive: true // Applying a fixed width when the content contains media (e.g images) to prevent the popover from collapsing
                ,
                // when the popup only contains a single image or an image with a small amount of text
                isFixedWidth: previewText?.includes('[media]'),
                analyticsAttributes: {
                    cellType: 'rich-text'
                }
            }, ({ ref: ref })=>/*#__PURE__*/ $eJOHy.createElement((0, $bQP4O.default), {
                    xcss: $d830ff7abe2ae704$var$richTextCellWrapperStyles,
                    ref: ref,
                    ...props
                }, previewText))));
    }
    if (isDensityFull) return /*#__PURE__*/ $eJOHy.createElement((0, $8ia30.RichTextCellFull), {
        issueKey: issueKey,
        richText: richText?.adfValue?.json || (0, $dk7W5.emptyAdfObject),
        canBeExported: issueData?.canBeExported
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $5Rrfi.RichTextCellCompact), {
        fieldId: fieldId,
        plainText: richText?.adfValue?.convertedPlainText?.plainText || '',
        issueKey: issueKey,
        shouldOpenOnFirstRender: shouldOpenOnFirstRender
    });
});
const $d830ff7abe2ae704$var$richTextCellWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: 'border.width.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});
const $d830ff7abe2ae704$var$readOnlyNoPopoverStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    display: 'block',
    backgroundColor: 'color.background.neutral.subtle',
    boxSizing: 'border-box',
    height: '100%',
    font: 'font.body',
    width: '100%',
    textAlign: 'left',
    borderWidth: 'border.width.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    // @ts-expect-error Transparent is not valid but should be
    borderColor: 'transparent',
    ':focus': {
        borderColor: 'color.border.focused',
        outline: 'none'
    }
});

});
parcelRegister("6Fvlm", function(module, exports) {
$parcel$export(module.exports, "default", () => $100709c9add3cd83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f044573e2242b448613b0f9ebd46dad3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $100709c9add3cd83$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "RichTextCell_issue",
    "selections": [
        {
            "condition": "isDensityFull",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canBeExported"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$100709c9add3cd83$var$node.hash = "738c991e06df9ecde7051ba2a1a384c0";
var $100709c9add3cd83$export$2e2bcd8739ae039 = $100709c9add3cd83$var$node;

});

parcelRegister("5wfJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $91686246f7a102c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8081e5694135a10cc62137e48c7fc6e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $91686246f7a102c0$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        }
    ],
    "kind": "Fragment",
    "name": "RichTextCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "richText",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "adfValue",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isDensityFull",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraRichTextField"
};
$91686246f7a102c0$var$node.hash = "6f3718a989b4562bd8841af8ae1ead93";
var $91686246f7a102c0$export$2e2bcd8739ae039 = $91686246f7a102c0$var$node;

});

parcelRegister("dk7W5", function(module, exports) {
$parcel$export(module.exports, "emptyAdfObject", () => $330901af3cc572d4$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $330901af3cc572d4$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $330901af3cc572d4$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $330901af3cc572d4$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $330901af3cc572d4$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $330901af3cc572d4$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $330901af3cc572d4$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $330901af3cc572d4$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $330901af3cc572d4$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $330901af3cc572d4$export$80a6e90c7b29d88c);

var $fpoq4 = parcelRequire("fpoq4");
var $0mclG = parcelRequire("0mclG");

var $eSnSE = parcelRequire("eSnSE");
const $330901af3cc572d4$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $330901af3cc572d4$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($330901af3cc572d4$export$9e9311e676291037)
    };
    return adf;
};
const $330901af3cc572d4$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $330901af3cc572d4$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $330901af3cc572d4$export$9e9311e676291037(adf);
};
const $330901af3cc572d4$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $330901af3cc572d4$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $330901af3cc572d4$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $330901af3cc572d4$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $330901af3cc572d4$export$def86d25f0c7f0bc = (adf)=>$330901af3cc572d4$export$cf4bde415465976c(adf) ? $330901af3cc572d4$export$202742e99f678c60 : adf;
const $330901af3cc572d4$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $0mclG.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $330901af3cc572d4$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $0mclG.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $330901af3cc572d4$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $0mclG.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $0mclG.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $330901af3cc572d4$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $fpoq4.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $330901af3cc572d4$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("8DB98")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await Promise.resolve((parcelRequire("dmYzn")));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("lovmf")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("fpoq4", function(module, exports) {
$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});


parcelRegister("5Rrfi", function(module, exports) {
$parcel$export(module.exports, "RichTextCellCompact", () => $d1b17c4c3bf914ca$export$367da69f6099f447);

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $cHtIB = parcelRequire("cHtIB");

var $8jOO7 = parcelRequire("8jOO7");

var $8mV8n = parcelRequire("8mV8n");

var $g2AHA = parcelRequire("g2AHA");

var $9Ubc3 = parcelRequire("9Ubc3");
const $d1b17c4c3bf914ca$var$runtimeProps = {};
const $d1b17c4c3bf914ca$export$367da69f6099f447 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, fieldId: fieldId, plainText: plainText, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            fieldId: fieldId,
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        fieldId,
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $9Ubc3.richTextPopUpContentEntryPoint), entryPointParams);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const triggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mV8n.TruncatedTextWithPopup), {
        triggerText: plainText,
        triggerRefCallback: triggerRef,
        isOpen: isOpen,
        onSetIsOpen: setIsOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "rich-text-popup-content",
            packageName: (0, $8jOO7.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g2AHA.ErrorState), null),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            }),
            runtimeProps: $d1b17c4c3bf914ca$var$runtimeProps
        })
    });
});

});
parcelRegister("g2AHA", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $96069305cd4df334$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $91wBH = parcelRequire("91wBH");

var $BE68B = parcelRequire("BE68B");
const $96069305cd4df334$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96069305cd4df334$var$StyledBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $BE68B.StyledText), null, formatMessage((0, $91wBH.default).errorMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96069305cd4df334$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1tkeqkoa _1bah1h6o _19pkutpp _2hwx1ejb _otyrpxbi _18u01ejb _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("91wBH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab34034d18cfc120$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ab34034d18cfc120$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "native-issue-table.common.issue-cells.rich-text.error-state.error-message",
        "defaultMessage": "Something went wrong. Close and re-open this modal to try again."
    }
});
var $ab34034d18cfc120$export$2e2bcd8739ae039 = $ab34034d18cfc120$var$messages;

});

parcelRegister("BE68B", function(module, exports) {
$parcel$export(module.exports, "StyledText", () => $363421016b666d27$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $363421016b666d27$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $363421016b666d27$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($363421016b666d27$var$StyledTextComponent, props));

});


parcelRegister("9Ubc3", function(module, exports) {
$parcel$export(module.exports, "richTextPopUpContentEntryPoint", () => $bc94eab26320dc93$export$6c4574991456a42);

var $luejK = parcelRequire("luejK");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $bc94eab26320dc93$export$6c4574991456a42 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("h6ReS")), {
        moduleId: "81e41861",
        moduleName: "RichTextPopUpContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, fieldId: fieldId, cloudId: cloudId })=>({
            queries: {
                richTextContent: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $luejK.default,
                    variables: {
                        issueKey: issueKey,
                        fieldId: fieldId,
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                issueKey: issueKey
            }
        })
});

});
parcelRegister("luejK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0030b39ed9173d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caf203e6d50a85931ae87b988e667ad9>>
 * @relayHash 9766437351d45e8f988f1b9517f8d95d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc6f224a2d810f0aa1a2e6a2edece177fe4fa2839dd95a4fd3010d3ce09f146c
const $c0030b39ed9173d1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fc6f224a2d810f0aa1a2e6a2edece177fe4fa2839dd95a4fd3010d3ce09f146c",
        "metadata": {},
        "name": "RichTextPopUpContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c0030b39ed9173d1$export$2e2bcd8739ae039 = $c0030b39ed9173d1$var$node;

});

parcelRegister("h6ReS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ukIY").then(()=>parcelRequire('PEC4K'));

});



parcelRegister("8ia30", function(module, exports) {
$parcel$export(module.exports, "RichTextCellFull", () => $78462eb2a4e30a43$export$e41920e4ba1d08f2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $jZFgr = parcelRequire("jZFgr");

var $JHcTN = parcelRequire("JHcTN");
const $78462eb2a4e30a43$export$e41920e4ba1d08f2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ richText: richText, issueKey: issueKey, canBeExported: canBeExported })=>{
    const viewContext = (0, $jZFgr.useLazyMediaViewContext)(issueKey);
    const disableMediaDownload = canBeExported === false && (0, $4cTDP.fg)('block_attachment_download_on_data_export_dsp_rule');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $78462eb2a4e30a43$var$richTextCellWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $JHcTN.AsyncRichTextRenderer), {
        mediaContext: {
            viewContext: viewContext,
            uploadContext: null,
            userAuth: null
        },
        adfDocument: richText,
        disableMediaDownload: disableMediaDownload
    }));
});
const $78462eb2a4e30a43$var$richTextCellWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100'
});

});
parcelRegister("JHcTN", function(module, exports) {
$parcel$export(module.exports, "AsyncRichTextRenderer", () => $2b5fe3805c761c54$export$7e19ac09148aecfa);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $2b5fe3805c761c54$var$LazyRichTextRenderer = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jreQK")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/common/ui/issue-cells/rich-text/rich-text-renderer/main.tsx"
});
const $2b5fe3805c761c54$export$7e19ac09148aecfa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-rich-text-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b5fe3805c761c54$var$LazyRichTextRenderer, props));

});
parcelRegister("jreQK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2mJlZ").then(()=>parcelRequire('1H71o'));

});




parcelRegister("48WLd", function(module, exports) {
$parcel$export(module.exports, "SingleSelectCell", () => $1bf4e72dcfd00f2d$export$2574fb9bde9d7289);

var $1SjXS = parcelRequire("1SjXS");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k89l2 = parcelRequire("k89l2");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $1bf4e72dcfd00f2d$export$2574fb9bde9d7289 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $1SjXS.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k89l2.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $1bf4e72dcfd00f2d$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        shouldShowPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k89l2.SingleSelectInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        shouldShowPopover: isSingleLineRowHeightEnabled
    });
};
const $1bf4e72dcfd00f2d$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $1bf4e72dcfd00f2d$var$customTargetStyles : $1bf4e72dcfd00f2d$var$customTargetStylesOld,
        ref: ref
    });
});
const $1bf4e72dcfd00f2d$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $1bf4e72dcfd00f2d$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("1SjXS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1525508a555e4751$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dd129c9d299987d365a3a5e652a15dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1525508a555e4751$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "SingleSelectCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectField"
};
$1525508a555e4751$var$node.hash = "282a9c597323dd65c2d74f5aba75a7ad";
var $1525508a555e4751$export$2e2bcd8739ae039 = $1525508a555e4751$var$node;

});

parcelRegister("k89l2", function(module, exports) {
$parcel$export(module.exports, "SingleSelectInlineEditView", () => $0cdfb48f3eeb9c25$export$dd40a625fe2da362);
$parcel$export(module.exports, "SingleSelectInlineEditViewIsEditable", () => $0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4);

var $1ooYc = parcelRequire("1ooYc");

var $5ZzWp = parcelRequire("5ZzWp");

var $j3aZM = parcelRequire("j3aZM");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6i8k = parcelRequire("h6i8k");

var $4EKqI = parcelRequire("4EKqI");

var $3edXJ = parcelRequire("3edXJ");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $auNLL = parcelRequire("auNLL");

var $fmLhX = parcelRequire("fmLhX");

var $hbF3h = parcelRequire("hbF3h");

var $fkc6h = parcelRequire("fkc6h");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");
const $0cdfb48f3eeb9c25$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-select-lite-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $0cdfb48f3eeb9c25$export$7358e6ab68a1bc5c = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('thor-select-field-use-monitoring-wrapper'), (0, $fkc6h.useIssueExperienceMonitoring), ()=>({
        enrichCommitWithIssueExperienceMonitoring: (mutationArgs)=>mutationArgs
    }));
/** Check if the new selected value is equal to the old value */ const $0cdfb48f3eeb9c25$var$isEqualSelection = (a, b)=>a?.value === b?.value;
const $0cdfb48f3eeb9c25$export$dd40a625fe2da362 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $j3aZM.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};
const $0cdfb48f3eeb9c25$export$abac8bafb7f6b6d4 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupWidth: editViewPopupWidth, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, spacing: spacing = 'compact', menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, shouldShowPopover: shouldShowPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $5ZzWp.default), fragmentRef);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = $0cdfb48f3eeb9c25$export$7358e6ab68a1bc5c();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $1ooYc.default));
    const { id: uniqueFieldId, name: name, fieldOption: fieldOption, fieldId: fieldId, type: fieldType } = data;
    // #endregion Relay
    // #region State
    const initialValue = (0, $eJOHy.useMemo)(()=>fieldOption ? {
            label: fieldOption.value ?? '',
            value: fieldOption.id ?? '',
            optionId: fieldOption.optionId ?? ''
        } : null, [
        fieldOption
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion State
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((newOption, { onSuccess: onSuccess, onFail: onFail })=>{
        if ((0, $4cTDP.fg)('thor-select-field-use-monitoring-wrapper')) (0, $h6i8k.default)('issue.field.select.edit');
        onSubmit?.(newOption);
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newOption?.value ?? null
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateSingleSelectField?.success) onSuccess();
                else {
                    const errorMessage = response.jira?.updateSingleSelectField?.errors?.[0]?.message ?? undefined;
                    errorMessage ? onFail(new Error(`Relay error encountered while updating single select field - ${errorMessage}`), errorMessage) : onFail();
                }
            },
            onError: (error)=>onFail(error, error.message),
            optimisticResponse: {
                jira: {
                    updateSingleSelectField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: name,
                            fieldId: fieldId,
                            type: fieldType,
                            fieldOption: newOption ? {
                                id: newOption.value,
                                optionId: newOption.optionId,
                                value: newOption.label,
                                color: newOption.color ? {
                                    colorKey: newOption.color.colorKey,
                                    id: null
                                } : null
                            } : null
                        }
                    }
                }
            }
        }, 'lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation', {
            sendUFOEvent: true
        }, ()=>(0, $4cTDP.fg)('thor-select-field-use-monitoring-wrapper')));
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        updatedValue: updatedValue,
        isValueEqual: $0cdfb48f3eeb9c25$var$isEqualSelection,
        clipboardComponentType: 'singleSelect'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0cdfb48f3eeb9c25$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmLhX.SingleSelectReadView), {
            fieldType: fieldType,
            fragmentRef: data,
            shouldShowPopover: shouldShowPopover
        })), [
        data,
        fieldType,
        shouldShowPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            filterOptionsById: filterOptionsById,
            spacing: spacing,
            openMenuOnFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $3edXJ.default),
        editViewEntryPointParams: {
            id: uniqueFieldId,
            filterById: filterOptionsById
        },
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: shouldShowPopover
    });
// #endregion View
};

});
parcelRegister("1ooYc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f67695e52ea8b70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5c7d0d88301d21f5ef6ef214f9bf88b>>
 * @relayHash 3b13ce5a1ead386852d30e6220d696ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351e8ed663fceca6c76060046675d36c2ba86b6cbb1bd318c7ce386827de46fd
const $3f67695e52ea8b70$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "concreteType": "JiraColor",
                                                    "kind": "LinkedField",
                                                    "name": "color",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "colorKey"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "optionId"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "351e8ed663fceca6c76060046675d36c2ba86b6cbb1bd318c7ce386827de46fd",
            "metadata": {},
            "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3f67695e52ea8b70$var$node.hash = "4efc8e08a4925bceb3af2c617ed6d9ee";
var $3f67695e52ea8b70$export$2e2bcd8739ae039 = $3f67695e52ea8b70$var$node;

});

parcelRegister("5ZzWp", function(module, exports) {
$parcel$export(module.exports, "default", () => $03103f20675c4079$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf08ad1c8fb2273d225a10ddb1a04bd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03103f20675c4079$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView"
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "optionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
}();
$03103f20675c4079$var$node.hash = "28f321ab534b072c7deae95a3905b5dd";
var $03103f20675c4079$export$2e2bcd8739ae039 = $03103f20675c4079$var$node;

});

parcelRegister("j3aZM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce4d75d1ae344d6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<608f4af1a5cabdbfcda4b6156bf47821>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ce4d75d1ae344d6f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$ce4d75d1ae344d6f$var$node.hash = "91dade2591d1180af31cf3ea5a906996";
var $ce4d75d1ae344d6f$export$2e2bcd8739ae039 = $ce4d75d1ae344d6f$var$node;

});

parcelRegister("3edXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d63ec91007e0fb8$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4cTDP = parcelRequire("4cTDP");

var $1Yyty = parcelRequire("1Yyty");

const $7d63ec91007e0fb8$var$SingleSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("kfaV9"))), {
        moduleId: "2f9b0ca9",
        priority: "interaction"
    }),
    getPreloadProps: ({ id: id, filterById: filterById })=>(0, $4cTDP.fg)('jsc_single_select_preload_on_hover') ? {
            queries: {
                singleSelectEditViewData: {
                    parameters: $1Yyty.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    variables: {
                        id: id,
                        filterById: filterById
                    }
                }
            }
        } : {}
});
var $7d63ec91007e0fb8$export$2e2bcd8739ae039 = $7d63ec91007e0fb8$var$SingleSelectEditViewEntryPoint;

});
parcelRegister("1Yyty", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e17643d8e3fc807$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06b742fb19a2e6529885cdf09f5c8710>>
 * @relayHash 37af781a1179426a4b376a2a0406fd5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2635dc65a51b8a59f0fbc9315844d072aac9ee6d4f9812cc638ef68b06c69d9b

var $an5hi = parcelRequire("an5hi");
const $3e17643d8e3fc807$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v3 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "singleSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "singleSelect_issueSelectableFieldQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ 
                    ],
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ],
                            "type": "JiraIssueField",
                            "abstractKey": "__isJiraIssueField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraFieldOperation",
                                    "kind": "LinkedField",
                                    "name": "fieldOperations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEdit"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableGroupKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "selectableIconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDisabled"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ],
                                                            "type": "JiraOption"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ],
                                                            "type": "JiraVersion"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "searchBy",
                                        "filterById"
                                    ],
                                    "handle": "connection",
                                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                                    "kind": "LinkedHandle",
                                    "name": "selectableValueOptions"
                                }
                            ],
                            "type": "JiraHasSelectableValueOptions",
                            "abstractKey": "__isJiraHasSelectableValueOptions"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2635dc65a51b8a59f0fbc9315844d072aac9ee6d4f9812cc638ef68b06c69d9b",
            "metadata": {},
            "name": "singleSelect_issueSelectableFieldQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $an5hi.default)
            }
        }
    };
}();
$3e17643d8e3fc807$var$node.hash = "bbde42dda5618f7ad8e7a90fbd9941ed";
var $3e17643d8e3fc807$export$2e2bcd8739ae039 = $3e17643d8e3fc807$var$node;

});
parcelRegister("an5hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0b1137c52b8d888$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $b0b1137c52b8d888$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('thor_colourful_single_select_milestone2_gate');
    }
};

});



parcelRegister("fmLhX", function(module, exports) {
$parcel$export(module.exports, "SingleSelectReadView", () => $18bf8c7160e24e99$export$68bfa072e694358d);

var $8gAft = parcelRequire("8gAft");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");

var $cxKOj = parcelRequire("cxKOj");

var $d9T1A = parcelRequire("d9T1A");

var $kp5kj = parcelRequire("kp5kj");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $k6Nau = parcelRequire("k6Nau");

var $d4GL0 = parcelRequire("d4GL0");

var $3Lkm9 = parcelRequire("3Lkm9");

var $3OT15 = parcelRequire("3OT15");
const $18bf8c7160e24e99$export$68bfa072e694358d = (props)=>{
    const { fragmentRef: fragmentRef, fieldType: fieldType, shouldShowPopover: shouldShowPopover } = props;
    const isJsmIssue = (0, $d4GL0.useIsJsmIssue)();
    const data = (0, $j4oe4.useFragment)((0, $8gAft.default), fragmentRef);
    const hoverPopoverRefFactory = shouldShowPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: data.fieldOption?.value
    });
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!data.fieldOption?.value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenSingleSelectPlaceholderEmptyFieldText
    });
    const isCategoryAndListExperimentON = props.fieldType === (0, $3mZMJ.CATEGORY_TYPE);
    // Separate checks to assure exposure
    const isSingleSelectAndColourfulExperimentOn = fieldType === (0, $3mZMJ.SELECT_CF_TYPE) && (0, $cxKOj.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false);
    if (isSingleSelectAndColourfulExperimentOn || isCategoryAndListExperimentON) {
        if (shouldShowPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: data.fieldOption?.value ?? '',
            color: data.fieldOption?.color?.colorKey ?? null,
            ref: hoverPopoverRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: data.fieldOption.value,
            color: data?.fieldOption?.color?.colorKey ?? null,
            showTooltip: (0, $4cTDP.fg)('add_tooltip_to_single_select_options') || !isJsmIssue && (0, $cxKOj.expVal)('single_select_with_tooltips', 'enabled', false)
        });
    }
    return shouldShowPopover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        ref: hoverPopoverRef
    }, data.fieldOption?.value ?? '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.fieldOption?.value ?? '');
};

});
parcelRegister("8gAft", function(module, exports) {
$parcel$export(module.exports, "default", () => $979e9f61b251491b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04ea739d1f4c36cb215a8176fe56e3cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $979e9f61b251491b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "fieldOption",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSingleSelectField"
};
$979e9f61b251491b$var$node.hash = "1276308a1838194b7b78528c304458c7";
var $979e9f61b251491b$export$2e2bcd8739ae039 = $979e9f61b251491b$var$node;

});

parcelRegister("d4GL0", function(module, exports) {
$parcel$export(module.exports, "useIsJsmIssue", () => $c232e8d882e0b631$export$5f53c98aa7c9de5);
$parcel$export(module.exports, "useIsSoftwareIssue", () => $c232e8d882e0b631$export$ed33ecaf885020f8);
$parcel$export(module.exports, "useIsBusinessIssue", () => $c232e8d882e0b631$export$c4a50ee3a409d3b);

var $FhXEJ = parcelRequire("FhXEJ");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");
const $c232e8d882e0b631$export$6362f1ad6af51d2e = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    return (0, $bNexr.useProjectType)(projectKey);
};
const $c232e8d882e0b631$export$5f53c98aa7c9de5 = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
};
const $c232e8d882e0b631$export$ed33ecaf885020f8 = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
};
const $c232e8d882e0b631$export$c4a50ee3a409d3b = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.CORE_PROJECT);
};

});




parcelRegister("aqqsA", function(module, exports) {
$parcel$export(module.exports, "SprintCell", () => $1d390bfb6b1daa80$export$a092d4418bd765b8);

var $YbJDC = parcelRequire("YbJDC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $cMwFX = parcelRequire("cMwFX");

var $jJI50 = parcelRequire("jJI50");

var $eqbO4 = parcelRequire("eqbO4");

var $P01So = parcelRequire("P01So");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");
/**
 * Expected JQL Output: `${jqlTerm} = ${sprintId}`
 */ const $1d390bfb6b1daa80$var$getSprintJql = (jqlTerm, sprintId)=>{
    const jast = (0, $f26C8.default).jast((0, $f26C8.default).query((0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $P01So.escapeBackslashes)(jqlTerm)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).valueOperand(String(sprintId)))));
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });
};
const $1d390bfb6b1daa80$export$a092d4418bd765b8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, projectKey: projectKey, issueSearchBaseUrl: issueSearchBaseUrl, jqlTerm: jqlTerm, isReadOnlyWithoutHoverPopover: isReadOnlyWithoutHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $YbJDC.default), fieldRef);
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const [restrictSprints, { onRestrictSprints: onRestrictSprints }] = (0, $jJI50.useRestrictSprints)();
    const getUrl = (0, $eJOHy.useCallback)((sprintId)=>{
        const jql = $1d390bfb6b1daa80$var$getSprintJql(jqlTerm, sprintId);
        return `${issueSearchBaseUrl}?jql=${encodeURIComponent(jql)}`;
    }, [
        issueSearchBaseUrl,
        jqlTerm
    ]);
    const shouldTruncate = (0, $34oCh.useIsSingleLineRowHeightEnabled)() && !isReadOnlyWithoutHoverPopover;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cMwFX.SprintInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        getUrl: getUrl,
        isEditable: (isEditable && !isReadOnlyWithoutHoverPopover) ?? false,
        menuPosition: "fixed",
        onRestrictSprints: onRestrictSprints,
        projectKey: projectKey,
        readViewFitContainerHeight: true,
        restrictSprints: restrictSprints,
        isTruncated: shouldTruncate
    });
});

});
parcelRegister("YbJDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e460e48a2f2912a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc5d300657ae425f3250fd7b2c6d7b37>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e460e48a2f2912a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "SprintCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSprintField"
};
$1e460e48a2f2912a$var$node.hash = "afc7608d5e2caf73131c9fa1d441d4a2";
var $1e460e48a2f2912a$export$2e2bcd8739ae039 = $1e460e48a2f2912a$var$node;

});

parcelRegister("cMwFX", function(module, exports) {
$parcel$export(module.exports, "SprintInlineEditViewIsEditable", () => $fa6beaf7f70924f1$export$e7a88b03161da897);
$parcel$export(module.exports, "SprintInlineEditView", () => $fa6beaf7f70924f1$export$c035f6dfde6d5d50);

var $37A4u = parcelRequire("37A4u");

var $6p71y = parcelRequire("6p71y");

var $6zBPl = parcelRequire("6zBPl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6i8k = parcelRequire("h6i8k");

var $d2AGn = parcelRequire("d2AGn");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $4DuQo = parcelRequire("4DuQo");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $iy7qP = parcelRequire("iy7qP");

var $9G6SK = parcelRequire("9G6SK");

var $ibVOD = parcelRequire("ibVOD");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $fkc6h = parcelRequire("fkc6h");

var $fk01k = parcelRequire("fk01k");
const $fa6beaf7f70924f1$var$isEqualSprint = (a, b)=>a?.value === b?.value;
const $fa6beaf7f70924f1$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-sprint-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $fa6beaf7f70924f1$export$7358e6ab68a1bc5c = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('thor-sprint-field-use-monitoring-wrapper'), (0, $fkc6h.useIssueExperienceMonitoring), ()=>({
        enrichCommitWithIssueExperienceMonitoring: (mutationArgs)=>mutationArgs
    }));
const $fa6beaf7f70924f1$export$e7a88b03161da897 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, fragmentRef: fragmentRef, getUrl: getUrl, isEditable: isFieldEditable, isEditing: startWithEditViewOpen, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onRestrictSprints: onRestrictSprints, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, projectKey: projectKey, readViewFitContainerHeight: readViewFitContainerHeight, restrictSprints: restrictSprints, isTruncated: isTruncated })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $6zBPl.default), fragmentRef);
    const { enrichCommitWithIssueExperienceMonitoring: enrichCommitWithIssueExperienceMonitoring } = $fa6beaf7f70924f1$export$7358e6ab68a1bc5c();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: fieldName, selectedSprintsConnection: selectedSprintsConnection } = data;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $6p71y.default));
    const sprintEdges = (0, $eJOHy.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const sprintNodes = sprintEdges.map(({ node: node })=>node).filter(Boolean);
        const currentSprint = (0, $iy7qP.findActiveOrFutureSprint)(sprintNodes);
        return currentSprint && (0, $iy7qP.isObjectWithSprintState)(currentSprint) ? {
            value: currentSprint.id,
            label: currentSprint.name ?? '',
            state: currentSprint.state,
            sprintId: currentSprint.sprintId
        } : null;
    }, [
        sprintEdges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        if ((0, $4cTDP.fg)('thor-sprint-field-use-monitoring-wrapper')) (0, $h6i8k.default)('issue.field.sprint.edit');
        onSubmit?.((0, $fk01k.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], option));
        commit(enrichCommitWithIssueExperienceMonitoring({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: option?.value ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSprintField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: (0, $fk01k.toOptimisticResponse)(uniqueFieldId, option, sprintEdges)
        }, 'sprint_issueFieldSprint_SprintField_Mutation', {
            sendUFOEvent: true
        }, ()=>(0, $4cTDP.fg)('thor-sprint-field-use-monitoring-wrapper')));
    }, [
        commit,
        onSubmit,
        selectedSprintsConnection?.edges,
        sprintEdges,
        uniqueFieldId,
        enrichCommitWithIssueExperienceMonitoring
    ]);
    const handleSubmitSucceeded = (0, $eJOHy.useCallback)((value)=>{
        onSubmitSucceeded?.((0, $fk01k.transformOptionToAgg)(selectedSprintsConnection?.edges ?? [], value));
    }, [
        onSubmitSucceeded,
        selectedSprintsConnection?.edges
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.sprintId, value?.sprintId || null);
    }, [
        fieldId,
        initialValue
    ]);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $fa6beaf7f70924f1$var$isEqualSprint,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: handleSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'sprint',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa6beaf7f70924f1$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9G6SK.SprintReadView), {
            fragmentRef: data,
            getUrl: getUrl,
            isTruncated: isTruncated
        }))), [
        data,
        getUrl,
        isTruncated
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            spacing: spacing,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            projectKey: projectKey,
            onRestrictSprints: onRestrictSprints,
            restrictSprints: restrictSprints,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $4DuQo.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hasReadViewTruncateDisabled: isTruncated,
        hideActionButtons: true
    });
};
const $fa6beaf7f70924f1$export$c035f6dfde6d5d50 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $37A4u.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa6beaf7f70924f1$export$e7a88b03161da897, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("37A4u", function(module, exports) {
$parcel$export(module.exports, "default", () => $501657d6da7e919b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37eab354ffef704063d36bf755f8ce5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $501657d6da7e919b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$501657d6da7e919b$var$node.hash = "aba26260bac1c5d276c6291d7046e952";
var $501657d6da7e919b$export$2e2bcd8739ae039 = $501657d6da7e919b$var$node;

});

parcelRegister("6p71y", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5263f31c70ddd02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d38c11cbcc28d051d2caaff8b2100e27>>
 * @relayHash fe046116013b2c3336c51bcbbb0fadff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7
const $a5263f31c70ddd02$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSprintFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSprintField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSprintField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "sprintId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endDate"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41bae81fc0a3022641c80d39ea76c8cb98023eb98fecc3699abf8ef4138c4e7",
            "metadata": {},
            "name": "sprint_issueFieldSprint_SprintField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a5263f31c70ddd02$var$node.hash = "10015ae363c37285aaa230e388ba466f";
var $a5263f31c70ddd02$export$2e2bcd8739ae039 = $a5263f31c70ddd02$var$node;

});

parcelRegister("6zBPl", function(module, exports) {
$parcel$export(module.exports, "default", () => $706729d2dadf5cd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac88ab127ac9ae040b14fea73c66a12b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $706729d2dadf5cd6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "sprint_issueFieldSprintReadviewFull_SprintReadView"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSprintField"
    };
}();
$706729d2dadf5cd6$var$node.hash = "52958eeea1ec618ec650c65098329a2d";
var $706729d2dadf5cd6$export$2e2bcd8739ae039 = $706729d2dadf5cd6$var$node;

});

parcelRegister("4DuQo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b10e4eaf75093e1$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b10e4eaf75093e1$var$SprintEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8X51a")), {
        moduleId: "8d561192",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $7b10e4eaf75093e1$export$2e2bcd8739ae039 = $7b10e4eaf75093e1$var$SprintEditViewEntryPoint;

});
parcelRegister("8X51a", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iMnjN").then(()=>parcelRequire('jqyo2'));

});


parcelRegister("iy7qP", function(module, exports) {
$parcel$export(module.exports, "getRapidViewUrl", () => $e14a9757607507d9$export$e6c9132cef5ee76f);
$parcel$export(module.exports, "findActiveOrFutureSprint", () => $e14a9757607507d9$export$d53a51166e1544ba);
$parcel$export(module.exports, "isClosedSprint", () => $e14a9757607507d9$export$7494fd835c1a1b3);
$parcel$export(module.exports, "filterClosedSprints", () => $e14a9757607507d9$export$af48278faaf4e92d);
$parcel$export(module.exports, "isObjectWithSprintState", () => $e14a9757607507d9$export$9ba6a679066a1e8c);

var $cJktn = parcelRequire("cJktn");
const $e14a9757607507d9$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $e14a9757607507d9$var$hasState = (state)=>(sprint)=>sprint.state != null && sprint.state.toUpperCase() === state.toUpperCase();
const $e14a9757607507d9$var$findSprintWithState = (sprints, state)=>sprints.find($e14a9757607507d9$var$hasState(state));
const $e14a9757607507d9$export$d53a51166e1544ba = (value)=>{
    const activeSprint = $e14a9757607507d9$var$findSprintWithState(value, (0, $cJktn.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = $e14a9757607507d9$var$findSprintWithState(value, (0, $cJktn.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $e14a9757607507d9$export$7494fd835c1a1b3 = $e14a9757607507d9$var$hasState((0, $cJktn.CLOSED_SPRINT_STATE));
const $e14a9757607507d9$export$af48278faaf4e92d = (value)=>value.filter($e14a9757607507d9$export$7494fd835c1a1b3);
const $e14a9757607507d9$export$9ba6a679066a1e8c = (val)=>val.state ? val.state in (0, $cJktn.SPRINT_STATES) : false;

});
parcelRegister("cJktn", function(module, exports) {
$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $f86aa4c60e4f732e$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $f86aa4c60e4f732e$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $f86aa4c60e4f732e$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $f86aa4c60e4f732e$export$73a0206a4dc59760);
const $f86aa4c60e4f732e$export$3ebc9911a79d714f = 'ACTIVE';
const $f86aa4c60e4f732e$export$863e42082c6bde5 = 'FUTURE';
const $f86aa4c60e4f732e$export$86cdef09a89e8c4b = 'CLOSED';
const $f86aa4c60e4f732e$export$73a0206a4dc59760 = {
    ACTIVE: $f86aa4c60e4f732e$export$3ebc9911a79d714f,
    CLOSED: $f86aa4c60e4f732e$export$86cdef09a89e8c4b,
    FUTURE: $f86aa4c60e4f732e$export$863e42082c6bde5
};

});


parcelRegister("9G6SK", function(module, exports) {
$parcel$export(module.exports, "SprintReadView", () => $e0780739f49c9cfa$export$ea735e24cb7dd13);

var $6SUEP = parcelRequire("6SUEP");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jFHCE = parcelRequire("jFHCE");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3Lkm9 = parcelRequire("3Lkm9");

var $9Mapt = parcelRequire("9Mapt");

var $ibVOD = parcelRequire("ibVOD");

var $bzbsd = parcelRequire("bzbsd");

var $iy7qP = parcelRequire("iy7qP");

var $jON6X = parcelRequire("jON6X");

var $fLyz2 = parcelRequire("fLyz2");
const $e0780739f49c9cfa$export$ea735e24cb7dd13 = ({ fragmentRef: fragmentRef, shouldHideSprintLink: shouldHideSprintLink = false, shouldHideClosedSprintsLinks: shouldHideClosedSprintsLinks = false, placeholder: placeholder, onSprintClick: onSprintClick, getUrl: getUrl = (0, $iy7qP.getRapidViewUrl), isTruncated: isTruncated })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const placeholderMessage = placeholder || formatMessage((0, $3Lkm9.default).emptyFieldText);
    const { selectedSprintsConnection: selectedSprintsConnection } = (0, $j4oe4.useFragment)((0, $6SUEP.default), fragmentRef);
    const sprints = (0, $eJOHy.useMemo)(()=>selectedSprintsConnection?.edges?.filter(Boolean).map(({ node: node })=>node).filter(Boolean).filter((0, $iy7qP.isObjectWithSprintState)).map((node)=>({
                id: node.id,
                sprintId: parseInt(node.sprintId, 10),
                name: node.name,
                state: node.state,
                endDate: node.endDate ?? undefined
            })) ?? [], [
        selectedSprintsConnection?.edges
    ]);
    const value = (0, $eJOHy.useMemo)(()=>{
        const currentSprint = (0, $iy7qP.findActiveOrFutureSprint)(sprints);
        if (!currentSprint) return null;
        const sprintOption = {
            label: currentSprint.name,
            value: currentSprint.id,
            href: getUrl(currentSprint.sprintId),
            state: currentSprint.state
        }; // If in backlog, use onSprintClick instead of href
        return onSprintClick ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(sprintOption, 'href') : sprintOption;
    }, [
        getUrl,
        onSprintClick,
        sprints
    ]);
    const closedSprints = (0, $eJOHy.useMemo)(()=>(0, $iy7qP.filterClosedSprints)(sprints)?.map((closedSprint)=>({
                id: closedSprint.sprintId,
                name: closedSprint.name,
                href: getUrl(closedSprint.sprintId),
                endDate: formatDate(closedSprint.endDate, {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
            })), [
        formatDate,
        getUrl,
        sprints
    ]);
    const sprintContentRef = (0, $eJOHy.useRef)(null);
    const renderClosedSprints = (0, $eJOHy.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, closedSprints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jON6X.default), props));
    }, [
        closedSprints
    ]);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: !isTruncated,
        xcss: $e0780739f49c9cfa$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: value?.label,
            contentRef: sprintContentRef,
            shouldGetParentRef: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLyz2.default), {
                value: value,
                shouldHideSprintLink: shouldHideSprintLink,
                placeholder: placeholderMessage,
                onClick: onSprintClick,
                sprintContentRef: (0, $bzbsd.mergeRefs)(ref, sprintContentRef),
                hoverAttributes: props
            }))), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks,
        isTruncated: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e0780739f49c9cfa$var$ReadWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLyz2.default), {
        value: value,
        shouldHideSprintLink: shouldHideSprintLink,
        placeholder: placeholderMessage,
        onClick: onSprintClick
    }), renderClosedSprints({
        closedSprints: closedSprints,
        shouldHideLinks: shouldHideClosedSprintsLinks
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0780739f49c9cfa$var$ReadWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bsb1osq _1n261g80",
            __cmplp.className
        ])
    });
});
const $e0780739f49c9cfa$var$inlineStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});

});
parcelRegister("6SUEP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6578e83530060f66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ee21c1a385c649c86345ac0a88a0470>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6578e83530060f66$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "sprint_issueFieldSprintReadviewFull_SprintReadView",
    "selections": [
        {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    "action": "THROW",
                                    "path": "selectedSprintsConnection.edges.node.state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSprintField"
};
$6578e83530060f66$var$node.hash = "94ae9fbf007cadd0e44b60b0777f74f2";
var $6578e83530060f66$export$2e2bcd8739ae039 = $6578e83530060f66$var$node;

});

parcelRegister("jON6X", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed002d22c6a98a04$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $3cMgR = parcelRequire("3cMgR");

var $6joHJ = parcelRequire("6joHJ");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $9Mapt = parcelRequire("9Mapt");

var $5vUQ3 = parcelRequire("5vUQ3");
const $ed002d22c6a98a04$var$ClosedSprintsView = (props)=>{
    const { shouldHideLinks: shouldHideLinks = false, closedSprints: closedSprints, isTruncated: isTruncated } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isDialogOpen, setIsDialogOpen] = (0, $eJOHy.useState)(false);
    const handleButtonClick = (0, $eJOHy.useCallback)((e)=>{
        setIsDialogOpen(!isDialogOpen);
        e.stopPropagation();
    }, [
        isDialogOpen
    ]);
    const handleDialogClose = (0, $eJOHy.useCallback)((data)=>{
        setIsDialogOpen(data.isOpen);
    }, []);
    const handleDialogClick = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const handleDialogMouseDown = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const closedSprintsLabel = (0, $eJOHy.useMemo)(()=>{
        const numberOfClosedSprints = closedSprints.length;
        return numberOfClosedSprints > 0 ? formatMessage((0, $5vUQ3.default).closedSprintsLabel, {
            count: numberOfClosedSprints
        }) : null;
    }, [
        closedSprints,
        formatMessage
    ]);
    const renderInlineDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.closed-sprints.view-closed-sprint-inline-dialog-content-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium"
        }, closedSprintsLabel), closedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ItemContainer, {
                key: sprint.name,
                "data-testid": `issue-field-sprint-readview-full.ui.sprint.closed-sprints.closed-sprint-item-${sprint.id}`
            }, shouldHideLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NameSpan, null, sprint.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NameLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
                href: sprint.href
            }, sprint.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$NoWrapDate, null, sprint.endDate))));
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (hoverProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
            content: renderInlineDialogContent(),
            isInteractive: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                spacing: "none",
                ref: ref,
                testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
                ...hoverProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ClosedSprintsCount, null, `+${closedSprints.length}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$Container, {
        onClick: handleDialogClick,
        onMouseDown: handleDialogMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
        content: renderInlineDialogContent(),
        isOpen: isDialogOpen,
        onClose: handleDialogClose,
        placement: "bottom",
        messageId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: handleButtonClick,
        spacing: "none",
        isSelected: isDialogOpen,
        testId: "issue-field-sprint-readview-full.ui.sprint.closed-sprints.button",
        "aria-expanded": isDialogOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed002d22c6a98a04$var$ClosedSprintsCount, null, `+${closedSprints.length}`))));
};
var $ed002d22c6a98a04$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $ed002d22c6a98a04$var$ClosedSprintsView;
const $ed002d22c6a98a04$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$ClosedSprintsCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$ItemContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4 _p12f1mjv",
            __cmplp.className
        ])
    });
});
const $ed002d22c6a98a04$var$nameStyles = `
    margin-right: ${"var(--ds-space-300, 24px)"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ed002d22c6a98a04$var$NameLinkContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ed002d22c6a98a04$var$NameSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2hwx1ejb _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed002d22c6a98a04$var$NoWrapDate = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("5vUQ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a3bdce371919139$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3a3bdce371919139$var$messages = (0, $7qGN1.defineMessages)({
    closedSprintsLabel: {
        "id": "issue-field-sprint-readview-full.sprint.closed-sprints.closed-sprints-label",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    }
});
var $3a3bdce371919139$export$2e2bcd8739ae039 = $3a3bdce371919139$var$messages;

});


parcelRegister("fLyz2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd3a63dfa9d33df6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $jvd21 = parcelRequire("jvd21");

var $tYLUh = parcelRequire("tYLUh");

var $c9uTK = parcelRequire("c9uTK");

var $3qWdv = parcelRequire("3qWdv");
const $bd3a63dfa9d33df6$var$SprintContent = (props)=>{
    const { value: value, onClick: onClick, placeholder: placeholder, shouldHideSprintLink: shouldHideSprintLink = false, sprintContentRef: sprintContentRef, hoverAttributes: hoverAttributes } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const noValueTextExperiment = formatMessage((0, $3qWdv.default).noValueTextExperiment);
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const renderSprintContent = ()=>{
        if (shouldHideSprintLink) return value && value.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
            "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content-link",
            href: value?.href,
            onClick: onClick,
            ref: sprintContentRef,
            ...hoverAttributes
        }, value && value.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd3a63dfa9d33df6$var$Ellipsis, {
        "data-testid": "issue-field-sprint-readview-full.ui.sprint.sprint-content.view-sprint-content"
    }, value ? renderSprintContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvd21.default), null, isExperimentEnabled ? noValueTextExperiment : placeholder));
};
var $bd3a63dfa9d33df6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bd3a63dfa9d33df6$var$SprintContent;
const $bd3a63dfa9d33df6$var$Ellipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvd21", function(module, exports) {
$parcel$export(module.exports, "default", () => $d76fa90793402a52$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d76fa90793402a52$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3qWdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $81f1641e160db5ad$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $81f1641e160db5ad$var$messages = (0, $7qGN1.defineMessages)({
    noValueTextExperiment: {
        "id": "issue-field-sprint-readview-full.sprint.no-value-text-experiment",
        "defaultMessage": "Add sprint"
    }
});
var $81f1641e160db5ad$export$2e2bcd8739ae039 = $81f1641e160db5ad$var$messages;

});



parcelRegister("fk01k", function(module, exports) {
$parcel$export(module.exports, "toOptimisticResponse", () => $ab0accbcd13a5bc9$export$79353fa5e28d43d8);
$parcel$export(module.exports, "transformOptionToAgg", () => $ab0accbcd13a5bc9$export$4e115b8a3d13d179);

var $iy7qP = parcelRequire("iy7qP");
const $ab0accbcd13a5bc9$export$79353fa5e28d43d8 = (fieldId, option, previousEdges)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = previousEdges.filter((edge)=>edge?.node && (0, $iy7qP.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        jira: {
            updateSprintField: {
                success: true,
                errors: null,
                field: {
                    id: fieldId,
                    selectedSprintsConnection: {
                        edges: selectedSprints
                    }
                }
            }
        }
    };
};
const $ab0accbcd13a5bc9$export$4e115b8a3d13d179 = (currentEdges, option)=>{
    // Previously closed sprints should still be displayed for the updated field
    const selectedSprints = currentEdges.filter((edge)=>edge?.node && (0, $iy7qP.isClosedSprint)(edge.node));
    if (option) selectedSprints.unshift({
        node: {
            id: option.value,
            name: option.label,
            state: option.state,
            sprintId: option.sprintId,
            endDate: null
        }
    });
    return {
        selectedSprintsConnection: {
            edges: selectedSprints
        }
    };
};

});


parcelRegister("jJI50", function(module, exports) {
$parcel$export(module.exports, "useRestrictSprints", () => $1d7048aa3f6edc98$export$8fafa660b00d922);

var $4JBcj = parcelRequire("4JBcj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $1d7048aa3f6edc98$var$initialState = {
    restrictSprints: (0, $4JBcj.getSharedRestrictSprintsValueFromLocalStorage)()
};
const $1d7048aa3f6edc98$var$actions = {
    onRestrictSprints: (restrictSprints)=>({ setState: setState })=>{
            (0, $4JBcj.setSharedRestrictSprintsValueInLocalStorage)(restrictSprints);
            setState({
                restrictSprints: restrictSprints
            });
        }
};
const $1d7048aa3f6edc98$var$RestrictSprintsStore = (0, $GtRbT.createStore)({
    initialState: $1d7048aa3f6edc98$var$initialState,
    actions: $1d7048aa3f6edc98$var$actions
});
const $1d7048aa3f6edc98$export$8fafa660b00d922 = (0, $iJq0l.createHook)($1d7048aa3f6edc98$var$RestrictSprintsStore, {
    selector: (state)=>state.restrictSprints
});

});
parcelRegister("4JBcj", function(module, exports) {
$parcel$export(module.exports, "getSharedRestrictSprintsValueFromLocalStorage", () => $f5002babcd0c3294$export$7186d1e916f1211c);
$parcel$export(module.exports, "setSharedRestrictSprintsValueInLocalStorage", () => $f5002babcd0c3294$export$4e2f56cec9369837);

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
// Helper functions to get the checkbox value in sprint edit component from local storage
const $f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY = 'edit_sprint_cache_value';
const $f5002babcd0c3294$var$storageProvider = (0, $3hRxq.createLocalStorageProvider)('', false);
const $f5002babcd0c3294$var$getRestrictSprintsValueFromLocalStorage = (key)=>{
    // SSR should not try to retrieve local storage values, so return default value
    if (false) return true;
    let value;
    try {
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) value = $f5002babcd0c3294$var$storageProvider.get(key);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        value = window.localStorage?.getItem(key);
        return value ? JSON.parse(value) : true;
    } catch  {
        return true;
    }
};
const $f5002babcd0c3294$var$setRestrictSprintsValueInLocalStorage = (key, value)=>{
    try {
        const valueToStore = String(value);
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) $f5002babcd0c3294$var$storageProvider.set(key, valueToStore);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.localStorage.setItem(key, valueToStore);
    } catch  {
    // do nothing
    }
};
const $f5002babcd0c3294$export$7186d1e916f1211c = ()=>$f5002babcd0c3294$var$getRestrictSprintsValueFromLocalStorage($f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY);
const $f5002babcd0c3294$export$4e2f56cec9369837 = (value)=>$f5002babcd0c3294$var$setRestrictSprintsValueInLocalStorage($f5002babcd0c3294$var$SHARED_RESTRICT_SPRINTS_CACHE_KEY, value);

});



parcelRegister("fj3ot", function(module, exports) {
$parcel$export(module.exports, "TeamCell", () => $4640eab72db9f5d4$export$2ea8e60ef5e5f6ad);

var $85ovA = parcelRequire("85ovA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2dtFa = parcelRequire("2dtFa");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $4640eab72db9f5d4$export$2ea8e60ef5e5f6ad = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const data = (0, $j4oe4.useFragment)((0, $85ovA.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dtFa.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $4640eab72db9f5d4$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dtFa.TeamInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        sessionId: sessionId.current,
        maxLines: isSingleLineRowHeightEnabled ? 1 : 2
    });
};
const $4640eab72db9f5d4$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $4640eab72db9f5d4$var$customTargetStyles : $4640eab72db9f5d4$var$customTargetStylesOld,
        ref: ref
    });
});
const $4640eab72db9f5d4$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $4640eab72db9f5d4$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("85ovA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba24ace8d7d4f6a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cddd286a4f083996a72d34795de9cca2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba24ace8d7d4f6a3$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "TeamCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraTeamViewField"
};
$ba24ace8d7d4f6a3$var$node.hash = "ebd36d00384a18703786e3ff2edd2e21";
var $ba24ace8d7d4f6a3$export$2e2bcd8739ae039 = $ba24ace8d7d4f6a3$var$node;

});

parcelRegister("2dtFa", function(module, exports) {
$parcel$export(module.exports, "TeamInlineEditViewWithIsEditable", () => $f82f0d90cc8d59f5$export$810a8205b15f6ef5);

var $gtPRb = parcelRequire("gtPRb");

var $25NwS = parcelRequire("25NwS");

var $65yaB = parcelRequire("65yaB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $luwvO = parcelRequire("luwvO");

var $gbhyT = parcelRequire("gbhyT");

var $8BFAJ = parcelRequire("8BFAJ");

var $auNLL = parcelRequire("auNLL");

var $b1dAu = parcelRequire("b1dAu");
const $f82f0d90cc8d59f5$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-team-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $f82f0d90cc8d59f5$var$isEqualOption = (a, b)=>a?.id === b?.id;
const $f82f0d90cc8d59f5$export$810a8205b15f6ef5 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', sessionId: sessionId, maxLines: maxLines })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $65yaB.default), fragmentRef);
    // Team will not always be available in Jira when is recently created,
    // at least not right away, due to eventual consistency. We are retrying
    // to give time to Jira to receive the newly team and accepts the given
    // team ARI as a valid team
    const retryCommit = (0, $b1dAu.useMutationWithRetriesCommit)((0, $eJOHy.useMemo)(()=>({
            retries: 3,
            isValidOnCompleted: (response)=>Boolean(response.jira?.updateTeamField?.success)
        }), []));
    const [commit] = (0, $j4oe4.useMutation)((0, $25NwS.default), retryCommit);
    // #endregion
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedTeam: selectedTeam, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedTeam) return null;
        return {
            id: selectedTeam.jiraSuppliedId,
            name: selectedTeam.jiraSuppliedName ?? ''
        };
    }, [
        selectedTeam
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onFail: onFail, onSuccess: onSuccess })=>{
        onSubmit?.(value);
        const id = (0, $luwvO.isRecentlyCreatedTeam)(value) ? value.teamAri : value?.id ?? null;
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: id
                    }
                }
            },
            onCompleted (response) {
                if (response.jira?.updateTeamField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateTeamField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedTeam: value && {
                                jiraSuppliedId: id ?? '',
                                jiraSuppliedName: value?.name ?? ''
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $f82f0d90cc8d59f5$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'team'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f82f0d90cc8d59f5$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BFAJ.TeamReadView), {
            fragmentRef: data,
            maxLines: maxLines,
            triggerLinkType: isFieldEditable ? 'none' : 'link'
        })), [
        data,
        maxLines,
        isFieldEditable
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            sessionId: sessionId
        });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewEntryPoint: (0, $gbhyT.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true
    });
};
const $f82f0d90cc8d59f5$export$d6fa94a3a6e2c653 = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $gtPRb.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f82f0d90cc8d59f5$export$810a8205b15f6ef5, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("gtPRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $102994d922aa2430$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65a0c0d2951c8f6f84c344c3564c0df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $102994d922aa2430$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$102994d922aa2430$var$node.hash = "10546ea9458e9373d43b23a6a4446d16";
var $102994d922aa2430$export$2e2bcd8739ae039 = $102994d922aa2430$var$node;

});

parcelRegister("25NwS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fa234e0048e4ba1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f20c59dab77492604598897b506d3fd>>
 * @relayHash ead4aeaad9bf490eb7d3435ec219e3a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc
const $2fa234e0048e4ba1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTeamFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraTeamViewField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c49ad7e0999f23413665b12454770bad160b1b9af9354368998b9abe8369bcc",
            "metadata": {},
            "name": "team_issueFieldTeam_TeamField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2fa234e0048e4ba1$var$node.hash = "f3f61da99e07b74cee3d1344c1a154d1";
var $2fa234e0048e4ba1$export$2e2bcd8739ae039 = $2fa234e0048e4ba1$var$node;

});

parcelRegister("65yaB", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ec8e9b1b339220$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7807a89c68ac9a44db6c3316858f4987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72ec8e9b1b339220$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "team_issueFieldTeamReadviewFull_TeamReadView"
        },
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$72ec8e9b1b339220$var$node.hash = "b9fb955ce9530b3f35116dcc41a56241";
var $72ec8e9b1b339220$export$2e2bcd8739ae039 = $72ec8e9b1b339220$var$node;

});

parcelRegister("luwvO", function(module, exports) {
$parcel$export(module.exports, "isRecentlyCreatedTeam", () => $bfc9862a1d9200d8$export$695c72729cb9130e);
const $bfc9862a1d9200d8$export$695c72729cb9130e = (team)=>{
    return team != null && Object.hasOwn(team, 'isRecentlyCreated');
};

});

parcelRegister("gbhyT", function(module, exports) {
$parcel$export(module.exports, "default", () => $0815c43a3970e724$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0815c43a3970e724$var$MultiUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("33Ayl"))), {
        moduleId: "47e554b4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0815c43a3970e724$export$2e2bcd8739ae039 = $0815c43a3970e724$var$MultiUserPickerEditViewEntryPoint;

});

parcelRegister("8BFAJ", function(module, exports) {
$parcel$export(module.exports, "TeamReadView", () => $ede7f5ac143c4eec$export$87458045213a5f61);

var $gSMCv = parcelRequire("gSMCv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");

var $kgwPr = parcelRequire("kgwPr");

var $4cTDP = parcelRequire("4cTDP");

var $aVor1 = parcelRequire("aVor1");

var $eWzpp = parcelRequire("eWzpp");

var $FhXEJ = parcelRequire("FhXEJ");
const $ede7f5ac143c4eec$export$87458045213a5f61 = ({ fragmentRef: fragmentRef, maxLines: maxLines, triggerLinkType: triggerLinkType })=>{
    const { selectedTeam: selectedTeam } = (0, $j4oe4.useFragment)((0, $gSMCv.default), fragmentRef);
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const isJSMOrJPDProject = projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT);
    if (!selectedTeam?.jiraSuppliedName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jira-preview-panel-team-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel') && ((0, $4cTDP.fg)('jsm_enable_preview_panel') || !isJSMOrJPDProject)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aVor1.TeamReadViewWithGpp), {
        teamName: selectedTeam?.jiraSuppliedName,
        ariId: selectedTeam?.jiraSuppliedId,
        maxLines: maxLines,
        showTeamPreview: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kgwPr.default), {
        teamId: selectedTeam.jiraSuppliedId,
        trigger: "hover-click",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, selectedTeam.jiraSuppliedName));
};

});
parcelRegister("gSMCv", function(module, exports) {
$parcel$export(module.exports, "default", () => $be46d963dd0a06cb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2eecf37369c6c8c0d95dae02e8db59b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be46d963dd0a06cb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "team_issueFieldTeamReadviewFull_TeamReadView",
    "selections": [
        {
            "concreteType": "JiraTeamView",
            "kind": "LinkedField",
            "name": "selectedTeam",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedId"
                },
                {
                    "kind": "ScalarField",
                    "name": "jiraSuppliedName"
                }
            ]
        }
    ],
    "type": "JiraTeamViewField"
};
$be46d963dd0a06cb$var$node.hash = "69af0ce99580e256b8a8c95839ad6bd2";
var $be46d963dd0a06cb$export$2e2bcd8739ae039 = $be46d963dd0a06cb$var$node;

});

parcelRegister("kgwPr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6f47cd7ff49890ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $kh7bJ = parcelRequire("kh7bJ");

var $83DiZ = parcelRequire("83DiZ");

var $bJscI = parcelRequire("bJscI");

var $5vQ2T = parcelRequire("5vQ2T");

var $4LBQr = parcelRequire("4LBQr");


var $iy37d = parcelRequire("iy37d");
const $6f47cd7ff49890ce$var$ConditionalErrorBoundary = (0, $bJscI.componentWithFG)('empanada_profilecard_sync_trigger_import_final', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "team-profilecard",
        packageName: (0, $9122f643e6cb5228$export$9345d7360ffe0722),
        fallback: "flag"
    }, children), (0, $eJOHy.Fragment));
const $6f47cd7ff49890ce$var$TeamProfileCardNext = (props)=>{
    const { children: children, teamId: teamId } = props;
    const userId = (0, $e6YEs.useAccountId)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!teamId || isAnonymous || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6f47cd7ff49890ce$var$ConditionalErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4LBQr.ProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iy37d.TeamProfileCardInner), {
        ...props,
        userId: userId,
        onRedirect: push
    })));
};
var $6f47cd7ff49890ce$export$2e2bcd8739ae039 = $6f47cd7ff49890ce$var$TeamProfileCardNext;

});
parcelRegister("4LBQr", function(module, exports) {
$parcel$export(module.exports, "ProfileCardWrapper", () => $a6c333f8f16da456$export$59abd6feb7dc8540);

var $eJOHy = parcelRequire("eJOHy");

var $cHtIB = parcelRequire("cHtIB");

var $e6YEs = parcelRequire("e6YEs");

var $cGMXY = parcelRequire("cGMXY");

var $2sKkz = parcelRequire("2sKkz");

var $7t8WA = parcelRequire("7t8WA");
const $a6c333f8f16da456$export$59abd6feb7dc8540 = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const fabricPfDirUrl = (0, $2sKkz.useFabricProfileDirectoryUrl)();
    const orgId = (0, $cGMXY.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7t8WA.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};

});
parcelRegister("cGMXY", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $42be11c449d1c554$export$52a03a3207af3687);

var $koAZ4 = parcelRequire("koAZ4");
const $42be11c449d1c554$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("2sKkz", function(module, exports) {
$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $af60317985c62746$export$cb9379d435214a54);

var $koAZ4 = parcelRequire("koAZ4");
const $af60317985c62746$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("7t8WA", function(module, exports) {
$parcel$export(module.exports, "createUserProfileCardClient", () => $fb0c29c9969e62d5$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $fb0c29c9969e62d5$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $fb0c29c9969e62d5$export$d43dc22a8337ee9f);

var $d5fwz = parcelRequire("d5fwz");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $ki24N = parcelRequire("ki24N");
const $fb0c29c9969e62d5$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $fb0c29c9969e62d5$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $ki24N.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $d5fwz.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $fb0c29c9969e62d5$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $fb0c29c9969e62d5$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $fb0c29c9969e62d5$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $fb0c29c9969e62d5$export$d816ba2709570028 = (0, $6E16M.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $fb0c29c9969e62d5$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $fb0c29c9969e62d5$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'ProfileClientStore',
    initialState: $fb0c29c9969e62d5$export$d4c72bab9d6cc13a,
    actions: $fb0c29c9969e62d5$export$e324594224ef24da,
    containedBy: $fb0c29c9969e62d5$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($fb0c29c9969e62d5$export$e324594224ef24da.bootstrap())
    }
});
const $fb0c29c9969e62d5$export$d43dc22a8337ee9f = (0, $iJq0l.createStateHook)($fb0c29c9969e62d5$export$6f57813fe9f31bf9);

});
parcelRegister("d5fwz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f71266daf2e15d5$export$2e2bcd8739ae039);


var $9PyvN = parcelRequire("9PyvN");


var $9uvjI = parcelRequire("9uvjI");
var $5f71266daf2e15d5$export$2e2bcd8739ae039 = (0, $9PyvN.default);

});
parcelRegister("9PyvN", function(module, exports) {
$parcel$export(module.exports, "default", () => $495edb629a854866$export$2e2bcd8739ae039);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $bRjww = parcelRequire("bRjww");

var $49UfM = parcelRequire("49UfM");

var $52RFj = parcelRequire("52RFj");

var $9uvjI = parcelRequire("9uvjI");
const $495edb629a854866$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $495edb629a854866$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$495edb629a854866$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $495edb629a854866$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $9uvjI.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $52RFj.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $bRjww.default)(withDefaultConfig);
        this.tcClient = $495edb629a854866$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics, analyticsNext) {
        return this.userClient.getProfile(cloudId, userId, analytics, analyticsNext);
    }
    getTeamProfile(teamId, orgId, analytics, analyticsNext) {
        return this.teamClient.getProfile(teamId, orgId, analytics, analyticsNext);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $8RHPx.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $8RHPx.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics, analyticsNext) {
        return this.rovoAgentClient?.getProfile(id, analytics, analyticsNext);
    }
    getRovoAgentPermissions(id, fireAnalytics, analyticsNext) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics, analyticsNext);
    }
    deleteAgent(id, analytics, analyticsNext) {
        return this.rovoAgentClient?.deleteAgent(id, analytics, analyticsNext);
    }
    setFavouriteAgent(id, isFavourite, analytics, analyticsNext) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics, analyticsNext);
    }
}
function $495edb629a854866$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $lopBx.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $49UfM.default)({
        ...config
    }) : undefined;
}
var $495edb629a854866$export$2e2bcd8739ae039 = $495edb629a854866$var$ProfileCardClient;

});
parcelRegister("bRjww", function(module, exports) {
$parcel$export(module.exports, "default", () => $05e8b6328c708954$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $4qbZy = parcelRequire("4qbZy");
const $05e8b6328c708954$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $05e8b6328c708954$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $05e8b6328c708954$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($identityAccountId: ID!, $cloudId: ID!) {
			agentStudio_agentByIdentityAccountId(identityAccountId: $identityAccountId, cloudId: $cloudId) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            identityAccountId: identityAccountId,
            cloudId: cloudId
        }
    });
const $05e8b6328c708954$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $05e8b6328c708954$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $eGOwo.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $4qbZy.AGGQuery)('/gateway/api/graphql', $05e8b6328c708954$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $4qbZy.AGGQuery)('/gateway/api/graphql', $05e8b6328c708954$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $4qbZy.AGGQuery)('/gateway/api/graphql', $05e8b6328c708954$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analyticsNext) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        if (!(0, $eGOwo.fg)('agent_studio_permissions_settings_m3_profiles')) return restPromise.then((restData)=>({
                restData: restData,
                aggData: null
            }));
        const aggStartTime = (0, $kNQN4.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $2stUb.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $kNQN4.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                ...(0, $2EPX4.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
	 * This function will call both REST and AGG endpoints to get the agent profile
	 * There are some data that is only available in the AGG endpoint, so we need to call both
	 * For any new fields, please only add them to the AGG endpoint
	 *
	 * @TODO migrate everything to AGG endpoint
	 */ getProfile(id, analytics, analyticsNext) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.triggered.request', {
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
            } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, analyticsNext).then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.succeeded.request', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.failed.request', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        ...(0, $2stUb.getErrorAttributes)(error),
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.DEPRECATED_getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics, analyticsNext) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.triggered.request', {
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
            } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.rovoAgentProfilecard.failed.deleteAgent', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        ...(0, $2stUb.getErrorAttributes)(error),
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.DEPRECATED_getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics, analyticsNext) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                if (analyticsNext) analyticsNext(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
            } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        ...(0, $2stUb.getErrorAttributes)(error),
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.DEPRECATED_getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics, fireAnalyticsNext) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                if (fireAnalyticsNext) fireAnalyticsNext('operational.rovoAgentProfilecard.triggered.request', {
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
            } else if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (fireAnalyticsNext) fireAnalyticsNext('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (fireAnalyticsNext) fireAnalyticsNext('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        ...(0, $2stUb.getErrorAttributes)(error),
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.DEPRECATED_getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2EPX4", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_META_DATA", () => $7d8a130fd15a8bb5$export$849551cf61929d4f);
$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "getActionSubject", () => $7d8a130fd15a8bb5$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$export$849551cf61929d4f = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$export$6f40cdf6d42c018d(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {
$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


parcelRegister("fqVaP", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc90275f52a03ea7$export$2e2bcd8739ae039);

var $7xkt0 = parcelRequire("7xkt0");
class $cc90275f52a03ea7$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $7xkt0.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("2stUb", function(module, exports) {
$parcel$export(module.exports, "DEPRECATED_getErrorAttributes", () => $3d31a5950b175c26$export$9a1d43b0f4ac4572);
$parcel$export(module.exports, "getErrorAttributes", () => $3d31a5950b175c26$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $3d31a5950b175c26$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $3d31a5950b175c26$export$d9ad65d422ee3f8c);

var $as7HK = parcelRequire("as7HK");
const $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $3d31a5950b175c26$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return !!error && $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $as7HK.AGGError)) return !!error.errorType && $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $3d31a5950b175c26$export$9a1d43b0f4ac4572 = (error)=>{
    if (error instanceof (0, $as7HK.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$9a1d43b0f4ac4572),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $as7HK.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$9a1d43b0f4ac4572),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $as7HK.DirectoryGraphQLErrors) || causeError instanceof (0, $as7HK.AGGErrors)) return $3d31a5950b175c26$export$9a1d43b0f4ac4572(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $3d31a5950b175c26$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null
    };
    if (error instanceof (0, $as7HK.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $as7HK.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $as7HK.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $as7HK.DirectoryGraphQLErrors) || causeError instanceof (0, $as7HK.AGGErrors)) return $3d31a5950b175c26$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $3d31a5950b175c26$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $as7HK.DirectoryGraphQLErrors)(errors, traceId);
};
const $3d31a5950b175c26$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $as7HK.AGGErrors)(errors, traceId);
};

});
parcelRegister("as7HK", function(module, exports) {
$parcel$export(module.exports, "HttpError", () => $e980080011a8d765$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $e980080011a8d765$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $e980080011a8d765$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $e980080011a8d765$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $e980080011a8d765$export$60d8267243755b9c);
class $e980080011a8d765$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $e980080011a8d765$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $e980080011a8d765$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});


parcelRegister("4qbZy", function(module, exports) {
$parcel$export(module.exports, "directoryGraphqlQuery", () => $79a99a18e51eddf3$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $79a99a18e51eddf3$export$a14afb5f82fe705);

var $as7HK = parcelRequire("as7HK");

var $2stUb = parcelRequire("2stUb");
const $79a99a18e51eddf3$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $79a99a18e51eddf3$var$id = (headers)=>headers;
async function $79a99a18e51eddf3$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleDirectoryGraphQLErrors));
}
async function $79a99a18e51eddf3$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleAGGErrors));
}
async function $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id, handleErrors) {
    const headers = processHeaders($79a99a18e51eddf3$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $as7HK.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});


parcelRegister("49UfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b519ebe8bdd19c29$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $fqVaP = parcelRequire("fqVaP");

var $jjeHq = parcelRequire("jjeHq");

var $4qbZy = parcelRequire("4qbZy");
const $b519ebe8bdd19c29$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b519ebe8bdd19c29$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b519ebe8bdd19c29$var$orgIdPromiseCache = new Map();
const $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache = new Map();
class $b519ebe8bdd19c29$var$TeamCentralCardClient extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b519ebe8bdd19c29$export$1862ef0c3880ca8d(userId);
        const response = await (0, $4qbZy.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b519ebe8bdd19c29$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b519ebe8bdd19c29$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $jjeHq.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b519ebe8bdd19c29$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b519ebe8bdd19c29$export$2e2bcd8739ae039 = $b519ebe8bdd19c29$var$TeamCentralCardClient;

});
parcelRegister("jjeHq", function(module, exports) {
$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $a1fbf8b2b4930fa8$export$d38a536fd806c68f);

var $4qbZy = parcelRequire("4qbZy");
const $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $a1fbf8b2b4930fa8$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $a1fbf8b2b4930fa8$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $4qbZy.AGGQuery)(url, query, $a1fbf8b2b4930fa8$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});


parcelRegister("52RFj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8330ec0bc030b200$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $7jwft = parcelRequire("7jwft");
class $8330ec0bc030b200$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $7jwft.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics, analyticsNext) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                if (analyticsNext) analyticsNext('operational.teamProfileCard.triggered.request', {
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
            } else if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.teamProfileCard.succeeded.request', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.teamProfileCard.failed.request', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        ...(0, $2stUb.getErrorAttributes)(error),
                        gateway: true,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.DEPRECATED_getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("7jwft", function(module, exports) {
$parcel$export(module.exports, "extractIdFromAri", () => $34e7bc800a4991e6$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $34e7bc800a4991e6$export$26a8aad0c7182dd6);
/// <reference types="node" />
// for typing `process`

var $4qbZy = parcelRequire("4qbZy");
const $34e7bc800a4991e6$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $34e7bc800a4991e6$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $34e7bc800a4991e6$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $34e7bc800a4991e6$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($34e7bc800a4991e6$var$ARI_PREFIX) ? teamIdOrTeamAri : $34e7bc800a4991e6$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $34e7bc800a4991e6$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $34e7bc800a4991e6$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $34e7bc800a4991e6$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $34e7bc800a4991e6$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$34e7bc800a4991e6$var$TEAM_FRAGMENT}
    }
  }
}`;
const $34e7bc800a4991e6$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $34e7bc800a4991e6$export$4968f4e0119a5d9c,
        variables: {
            teamId: $34e7bc800a4991e6$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $34e7bc800a4991e6$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $34e7bc800a4991e6$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $34e7bc800a4991e6$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $4qbZy.AGGQuery)(url, query, $34e7bc800a4991e6$export$1229c72526c01df2);
    return $34e7bc800a4991e6$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("9uvjI", function(module, exports) {
$parcel$export(module.exports, "default", () => $467a485168b1cd0d$export$2e2bcd8739ae039);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $hX5cm = parcelRequire("hX5cm");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $4qbZy = parcelRequire("4qbZy");
const $467a485168b1cd0d$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $467a485168b1cd0d$var$aggUserQuery = (0, $kuAvn.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $467a485168b1cd0d$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $467a485168b1cd0d$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $eGOwo.fg)('platform_agg_user_query_doc_change') ? (0, $6NFTG.print)($467a485168b1cd0d$var$aggUserQuery) : $467a485168b1cd0d$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $467a485168b1cd0d$var$queryAGGUser = async (url, userId)=>{
    const query = $467a485168b1cd0d$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $4qbZy.AGGQuery)(url, query);
    return user;
};
class $467a485168b1cd0d$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $467a485168b1cd0d$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = 'h:mmaaa';
        if (user.zoneinfo) {
            if ((0, $hX5cm.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $hX5cm.localTime)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $hX5cm.localTime)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics, analyticsNext) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                if (analyticsNext) analyticsNext('operational.profilecard.triggered.request', {
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
            } else if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.profilecard.succeeded.request', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) {
                    if (analyticsNext) analyticsNext('operational.profilecard.failed.request', {
                        duration: (0, $kNQN4.getPageTime)() - startTime,
                        ...(0, $2stUb.getErrorAttributes)(error),
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                } else if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.DEPRECATED_getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("hX5cm", function(module, exports) {
$parcel$export(module.exports, "localTime", () => $98ebf9c8b6385a65$export$f0dfd716e7b023cd);
parcelRequire("7XJii");
var $iLEEy = parcelRequire("iLEEy");
const $98ebf9c8b6385a65$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $iLEEy.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7XJii", function(module, exports) {
$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iLEEy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iLEEy = parcelRequire("iLEEy");





});
parcelRegister("iLEEy", function(module, exports) {
$parcel$export(module.exports, "default", () => $da9c26a946bf047b$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $a4wuW = parcelRequire("a4wuW");

var $iEVvn = parcelRequire("iEVvn");
function $da9c26a946bf047b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $a4wuW.default)((0, $iEVvn.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("a4wuW", function(module, exports) {
$parcel$export(module.exports, "default", () => $75537c87aa32bbea$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $jn1Yb = parcelRequire("jn1Yb");

var $bWiNt = parcelRequire("bWiNt");
var $75537c87aa32bbea$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $75537c87aa32bbea$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($75537c87aa32bbea$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bWiNt.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $jn1Yb.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("jn1Yb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1a1b16befdfb889$export$2e2bcd8739ae039);

var $emmbH = parcelRequire("emmbH");

var $a2zuC = parcelRequire("a2zuC");
var $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE = 60000;
var $e1a1b16befdfb889$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $emmbH.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $emmbH.default)('long', date, options);
        }
    }
};
function $e1a1b16befdfb889$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a2zuC.default)(timeZone, originalDate, true) / $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e1a1b16befdfb889$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e1a1b16befdfb889$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter);
}
function $e1a1b16befdfb889$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e1a1b16befdfb889$var$addLeadingZeros(minutes, 2);
}
var $e1a1b16befdfb889$export$2e2bcd8739ae039 = $e1a1b16befdfb889$var$formatters;

});
parcelRegister("emmbH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a74454c810e10efc$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a74454c810e10efc$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a74454c810e10efc$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a74454c810e10efc$var$partsTimeZone(dtf, date) : $a74454c810e10efc$var$hackyTimeZone(dtf, date);
}
function $a74454c810e10efc$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a74454c810e10efc$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a74454c810e10efc$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a2zuC", function(module, exports) {
$parcel$export(module.exports, "default", () => $74f59f73042f5ea2$export$2e2bcd8739ae039);

var $iKmlv = parcelRequire("iKmlv");

var $eMjjs = parcelRequire("eMjjs");
var $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR = 3600000;
var $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE = 60000;
var $74f59f73042f5ea2$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $74f59f73042f5ea2$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $74f59f73042f5ea2$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $74f59f73042f5ea2$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours)) return NaN;
        return -(hours * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $74f59f73042f5ea2$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR + minutes * $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($74f59f73042f5ea2$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $74f59f73042f5ea2$var$toUtcDate(date);
        var offset = $74f59f73042f5ea2$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $74f59f73042f5ea2$var$toUtcDate(date) {
    return (0, $eMjjs.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $74f59f73042f5ea2$var$calcOffset(date, timezoneString) {
    var tokens = (0, $iKmlv.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eMjjs.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $74f59f73042f5ea2$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $74f59f73042f5ea2$var$validIANATimezoneCache = {};
function $74f59f73042f5ea2$var$isValidTimezoneIANAString(timeZoneString) {
    if ($74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("iKmlv", function(module, exports) {
$parcel$export(module.exports, "default", () => $da5ddb5213ce8f83$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $da5ddb5213ce8f83$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $da5ddb5213ce8f83$var$partsOffset(dtf, date) : $da5ddb5213ce8f83$var$hackyOffset(dtf, date);
}
var $da5ddb5213ce8f83$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $da5ddb5213ce8f83$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $da5ddb5213ce8f83$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $da5ddb5213ce8f83$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $da5ddb5213ce8f83$var$dtfCache = {};
function $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone) {
    if (!$da5ddb5213ce8f83$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $da5ddb5213ce8f83$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $da5ddb5213ce8f83$var$dtfCache[timeZone];
}

});

parcelRegister("eMjjs", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac2487857a682a48$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ac2487857a682a48$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bWiNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b13b1308e9ec166$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a2zuC = parcelRequire("a2zuC");

var $cIjNZ = parcelRequire("cIjNZ");
var $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR = 3600000;
var $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE = 60000;
var $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8b13b1308e9ec166$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cIjNZ.default)
};
function $8b13b1308e9ec166$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8b13b1308e9ec166$var$splitDateString(argument);
    var parseYearResult = $8b13b1308e9ec166$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8b13b1308e9ec166$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8b13b1308e9ec166$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a2zuC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8b13b1308e9ec166$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8b13b1308e9ec166$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8b13b1308e9ec166$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8b13b1308e9ec166$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8b13b1308e9ec166$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8b13b1308e9ec166$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8b13b1308e9ec166$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8b13b1308e9ec166$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8b13b1308e9ec166$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8b13b1308e9ec166$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8b13b1308e9ec166$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8b13b1308e9ec166$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8b13b1308e9ec166$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8b13b1308e9ec166$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8b13b1308e9ec166$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8b13b1308e9ec166$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8b13b1308e9ec166$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8b13b1308e9ec166$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8b13b1308e9ec166$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8b13b1308e9ec166$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8b13b1308e9ec166$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8b13b1308e9ec166$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8b13b1308e9ec166$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8b13b1308e9ec166$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cIjNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9418f4fd702d1312$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9418f4fd702d1312$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9418f4fd702d1312$export$2e2bcd8739ae039 = $9418f4fd702d1312$var$tzPattern;

});



parcelRegister("iEVvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $d95891bc4ee0ba6d$export$2e2bcd8739ae039);

var $a2zuC = parcelRequire("a2zuC");

var $bWiNt = parcelRequire("bWiNt");
function $d95891bc4ee0ba6d$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bWiNt.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a2zuC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("ki24N", function(module, exports) {
$parcel$export(module.exports, "CustomUserProfileClient", () => $cb11a1ab876afdf4$export$4b2a86afb64f42f1);

var $9uvjI = parcelRequire("9uvjI");

var $hgi0g = parcelRequire("hgi0g");

var $cVBK8 = parcelRequire("cVBK8");
class $cb11a1ab876afdf4$export$4b2a86afb64f42f1 extends (0, $9uvjI.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $cVBK8.isCustomerAccount)(userId)) {
                    const response = await (0, $hgi0g.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $cVBK8.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("cVBK8", function(module, exports) {
$parcel$export(module.exports, "generateUserLink", () => $af7a028094d71a13$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $af7a028094d71a13$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $af7a028094d71a13$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $af7a028094d71a13$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $af7a028094d71a13$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $af7a028094d71a13$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $af7a028094d71a13$export$518f47d656cb4e1a);
$parcel$export(module.exports, "getSpaActionsWithRouterPush", () => $af7a028094d71a13$export$96e0a21dc8f6c225);

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");

var $a62R3 = parcelRequire("a62R3");

var $kEnfd = parcelRequire("kEnfd");

const $af7a028094d71a13$export$f4673d7e11341514 = (userId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${userId}`;
};
const $af7a028094d71a13$export$b163ce931504dcff = (teamId)=>{
    const teamProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    return (0, $a62R3.isTeamsAppEnabled)() ? teamProfile.href : `/jira/people/team/${teamId}`;
};
const $af7a028094d71a13$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $af7a028094d71a13$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $af7a028094d71a13$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($af7a028094d71a13$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $kRgKj.fireScreenAnalytics)(analyticsEvent);
    }
};
const $af7a028094d71a13$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $af7a028094d71a13$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $af7a028094d71a13$export$f38de51a346a7b1 = (intl, accountId)=>{
    const userProfile = (0, $a62R3.getNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: accountId
        }
    });
    return {
        label: intl && intl.formatMessage((0, $kEnfd.profileCardMessages).viewProfile),
        id: 'view-profile',
        link: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.href : `/jira/people/${accountId}`,
        callback: (0, $a62R3.isTeamsAppEnabled)() ? userProfile.onNavigate : undefined,
        shouldRender: (data)=>/*
     * Those without @atlassian.com accounts do not have viewable profiles
     */ data?.accountType !== 'customer'
    };
};
const $af7a028094d71a13$var$getSpaViewProfileActionWithRouterPush = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $kEnfd.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $af7a028094d71a13$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $kEnfd.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $kEnfd.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $af7a028094d71a13$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $kEnfd.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $kEnfd.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $af7a028094d71a13$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $kEnfd.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $af7a028094d71a13$export$518f47d656cb4e1a = (accountId, intl, actions)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $9122f643e6cb5228$export$23cedd3261bd8015:
                return $af7a028094d71a13$export$f38de51a346a7b1(intl, accountId);
            case 0, $9122f643e6cb5228$export$6bef782d14a92db8:
                return $af7a028094d71a13$var$getAssignedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$6b36f20db7a18a86:
                return $af7a028094d71a13$var$getReportedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$56da0dd0b0aa67b9:
                return $af7a028094d71a13$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $af7a028094d71a13$export$f38de51a346a7b1(intl, accountId)
    ];
};
const $af7a028094d71a13$export$96e0a21dc8f6c225 = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $9122f643e6cb5228$export$23cedd3261bd8015:
                return $af7a028094d71a13$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup);
            case 0, $9122f643e6cb5228$export$6bef782d14a92db8:
                return $af7a028094d71a13$var$getAssignedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$6b36f20db7a18a86:
                return $af7a028094d71a13$var$getReportedIssuesAction(intl, accountId);
            case 0, $9122f643e6cb5228$export$56da0dd0b0aa67b9:
                return $af7a028094d71a13$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $af7a028094d71a13$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("a62R3", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => $4bdb55387d231b38$export$520a42ab062954ec);
$parcel$export(module.exports, "getNavigateToTeamsApp", () => $4bdb55387d231b38$export$cfadab73fb247145);
$parcel$export(module.exports, "useTransformToTeamsAppUrl", () => $4bdb55387d231b38$export$dc7e633fb6368a43);
$parcel$export(module.exports, "toTeamsAppURL", () => $4bdb55387d231b38$export$196b2cec97b1c87c);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $4bdb55387d231b38$export$5921b2a93a401547);

var $fvpPO = parcelRequire("fvpPO");

var $j19W0 = parcelRequire("j19W0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $83DiZ = parcelRequire("83DiZ");

var $6zXPf = parcelRequire("6zXPf");

var $hWeHP = parcelRequire("hWeHP");
const $4bdb55387d231b38$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    if (!orgId && !cloudId) throw new Error('Org ID or Cloud ID is required to navigate to Teams App');
    return (0, $j19W0.navigateToTeamsApp)({
        push: push,
        hostProduct: 'jira',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$cfadab73fb247145 = (navActionPayload, shouldOpenInSameTab)=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.navigateToTeamsApp)({
        hostProduct: 'jira',
        orgId: orgId || '',
        cloudId: cloudId || undefined,
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)(),
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
const $4bdb55387d231b38$export$dc7e633fb6368a43 = (path, search = '')=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId,
        cloudId: cloudId
    });
};
const $4bdb55387d231b38$export$196b2cec97b1c87c = (path, search = '')=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
    return (0, $j19W0.toTeamsAppURL)(path, search, {
        orgId: orgId ?? '',
        cloudId: cloudId ?? ''
    });
};
const $4bdb55387d231b38$export$5921b2a93a401547 = ()=>{
    return (0, $fvpPO.isTeamsAppEnabled)({
        hostProduct: 'jira',
        userHasNav4Enabled: (0, $6zXPf.getWillShowNav4)()
    });
};

});
parcelRegister("fvpPO", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    //  Hard kill switch for isolated cloud until Standalone directory is deployed
    if ((0, $7pw1V.isIsolatedCloud)()) return false;
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});

parcelRegister("j19W0", function(module, exports) {
$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("0FujR", function(module, exports) {
$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $eGOwo = parcelRequire("eGOwo");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            if ((0, $eGOwo.fg)('enable_teams_app_breadcrumb_respect_directories')) return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_PEOPLE'
                })
            };
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {
$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});




parcelRegister("kEnfd", function(module, exports) {
$parcel$export(module.exports, "profileCardMessages", () => $4e049bd416c46183$export$49f2d2ccb123fddf);

var $7qGN1 = parcelRequire("7qGN1");
const $4e049bd416c46183$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $4e049bd416c46183$export$49f2d2ccb123fddf = (0, $7qGN1.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});

const $9122f643e6cb5228$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $9122f643e6cb5228$export$81319ffa9c0d18d7 = 'profileCardNext';
const $9122f643e6cb5228$export$50632e21ea714398 = 'profileCardNextLegacy';
const $9122f643e6cb5228$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $9122f643e6cb5228$export$23cedd3261bd8015 = 'viewProfile';
const $9122f643e6cb5228$export$6bef782d14a92db8 = 'assignedIssues';
const $9122f643e6cb5228$export$6b36f20db7a18a86 = 'reportedIssues';
const $9122f643e6cb5228$export$56da0dd0b0aa67b9 = 'viewFilters';





parcelRegister("iy37d", function(module, exports) {
$parcel$export(module.exports, "TeamProfileCardInner", () => $53ee96d70731dc27$export$25379cf72e576e0e);

var $eJOHy = parcelRequire("eJOHy");

var $3VLQJ = parcelRequire("3VLQJ");

var $ymEZt = parcelRequire("ymEZt");
var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a62R3 = parcelRequire("a62R3");

var $4cTDP = parcelRequire("4cTDP");

var $cVBK8 = parcelRequire("cVBK8");

var $7t8WA = parcelRequire("7t8WA");
const $53ee96d70731dc27$export$25379cf72e576e0e = ({ children: children, onRedirect: onRedirect, position: position, shouldRenderToParent: shouldRenderToParent, teamId: teamId, trigger: trigger, triggerLinkType: triggerLinkType, userId: userId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const onUserClick = (0, $eJOHy.useCallback)((accountId)=>onRedirect((0, $cVBK8.generateUserLink)(accountId)), [
        onRedirect
    ]);
    const { href: href, onNavigate: onNavigate } = (0, $a62R3.useNavigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    });
    const teamProfileUrl = (0, $4cTDP.fg)('jira-adopt-teams-nav-config') ? href : `/jira/people/team/${teamId}`;
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { profileClient: profileClient } = (0, $7t8WA.useProfileClient)();
    if (!profileClient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VLQJ.default), {
        teamId: teamId,
        orgId: orgId,
        viewingUserId: userId,
        resourceClient: profileClient,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: teamProfileUrl,
        viewProfileOnClick: ()=>(0, $4cTDP.fg)('jira-adopt-teams-nav-config') ? onNavigate() : onRedirect(teamProfileUrl),
        generateUserLink: (0, $cVBK8.generateUserLink),
        onUserClick: onUserClick,
        position: position,
        shouldRenderToParent: shouldRenderToParent,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- FYI: Typed as "any" in platform component
        addFlag: (flag)=>{
            const flagId = (0, $jn1Cb.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ymEZt.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        messageId: `profilecard-next.ui.team-profilecard.ak-flag.${flagId}`,
                        messageType: "transactional",
                        ...flagProps
                    })
            });
        }
    }, children);
};

});
parcelRegister("3VLQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $211b7e44240e97e1$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $zgYE5 = parcelRequire("zgYE5");
var $211b7e44240e97e1$export$2e2bcd8739ae039 = (0, $zgYE5.default);

});
parcelRegister("zgYE5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecd450f82eec537e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");

var $4J0ad = parcelRequire("4J0ad");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kioCn = parcelRequire("kioCn");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $g06PH = parcelRequire("g06PH");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $2L2e5 = parcelRequire("2L2e5");

var $2EPX4 = parcelRequire("2EPX4");

var $g5TmB = parcelRequire("g5TmB");


var $kNQN4 = parcelRequire("kNQN4");

var $74i65 = parcelRequire("74i65");

var $aci2z = parcelRequire("aci2z");

var $8ZI1l = parcelRequire("8ZI1l");
class $ecd450f82eec537e$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link',
            shouldRenderToParent: true
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $gh6xW.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $2L2e5.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $74i65.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $IW7jS.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $2EPX4.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.fireAnalyticsNext = (eventKey, ...attributes)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.fireEvent) this.props.fireEvent(eventKey, ...attributes);
        }, this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $kNQN4.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        }, this.fireAnalyticsWithDurationNext = (eventKey, generator)=>{
            const duration = (0, $kNQN4.getPageTime)() - this.openTime;
            const attributes = generator(duration);
            this.fireAnalyticsNext(eventKey, attributes);
        }, this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        }, this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $kNQN4.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        }, this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $g5TmB.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) {
                    if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                        method: 'click',
                        ...(0, $2EPX4.PACKAGE_META_DATA),
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        teamId: this.props.teamId
                    });
                    else this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'click', this.props.teamId));
                }
            }
        }, this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                    method: 'hover',
                    ...(0, $2EPX4.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    teamId: this.props.teamId
                });
                else this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'hover', this.props.teamId));
            }
            this.showProfilecard((0, $776ef75d5b01ad48$export$5b956b542f1bc1b3));
        }, this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $776ef75d5b01ad48$export$89a9f35a94d7f196));
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) {
                    if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                        method: 'click',
                        firedAt: Math.round((0, $kNQN4.getPageTime)()),
                        teamId: this.props.teamId,
                        ...(0, $2EPX4.PACKAGE_META_DATA)
                    });
                    else this.fireAnalytics((0, $2EPX4.cardTriggered)('team', 'click', this.props.teamId));
                }
            }
        }, this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        }, this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $776ef75d5b01ad48$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        }, this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        }, this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        }, this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        }, this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const fireAnalyticsNext = (eventKey, ...attributes)=>{
                    this.fireAnalyticsNext(eventKey, ...attributes);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent, fireAnalyticsNext),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.onErrorBoundary = ()=>{
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) this.fireAnalyticsNext('ui.teamProfileCard.rendered.errorBoundary', {
                ...(0, $2EPX4.PACKAGE_META_DATA),
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                duration: 0
            });
            else this.fireAnalytics((0, $2EPX4.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        }, this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                analyticsNext: this.fireAnalyticsWithDurationNext,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ZI1l.default), {
                        analytics: this.fireAnalyticsWithDuration,
                        analyticsNext: this.fireAnalyticsWithDurationNext
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aci2z.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        }, this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        }, this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2L2e5.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
const $ecd450f82eec537e$var$TeamProfileCardTriggerWithAnalytics = (props)=>{
    const { fireEvent: fireEvent } = (0, $g06PH.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ecd450f82eec537e$export$f811dc569217c959, {
        ...props,
        fireEvent: fireEvent
    });
};
var $ecd450f82eec537e$export$2e2bcd8739ae039 = (0, $kioCn.componentWithFG)('ptc-enable-profile-card-analytics-refactor', (0, $6YFG2.default)($ecd450f82eec537e$var$TeamProfileCardTriggerWithAnalytics), (0, $4J0ad.default)()((0, $6YFG2.default)($ecd450f82eec537e$export$f811dc569217c959)));

});
parcelRegister("7m76n", function(module, exports) {
$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cZiA6")));

});
parcelRegister("cZiA6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {
$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("kioCn", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $ba8f17f638620588$export$cf56d0f54cfcce4);

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");
const $ba8f17f638620588$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $AIyOt.componentWithCondition)(()=>(0, $eGOwo.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("AIyOt", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $12a0a78415ce5192$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $12a0a78415ce5192$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("gh6xW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("2L2e5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0136d5b4c5e5df89$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0136d5b4c5e5df89$var$messages = (0, $7qGN1.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreIconLabelWithName: {
        id: 'pt.profile-card.more-icon-label-with-name',
        defaultMessage: 'More actions for {fullName}',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $0136d5b4c5e5df89$export$2e2bcd8739ae039 = $0136d5b4c5e5df89$var$messages;

});

parcelRegister("g5TmB", function(module, exports) {
$parcel$export(module.exports, "isBasicClick", () => $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991);
const $d966bd6e0cdd5a4c$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("74i65", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $c1e0a551e3d32906$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $c1e0a551e3d32906$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $c1e0a551e3d32906$export$2e2bcd8739ae039 = $c1e0a551e3d32906$export$e926676385687eaf;

});

parcelRegister("aci2z", function(module, exports) {
$parcel$export(module.exports, "TeamProfileCardLazy", () => $0341a64f783b98dd$export$82a49d896f41ca78);

var $eJOHy = parcelRequire("eJOHy");

const $0341a64f783b98dd$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("efLsN")));

});
parcelRegister("efLsN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("azqRW").then(()=>parcelRequire('gVW5o'));

});


parcelRegister("8ZI1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $46bb11efbe40b76f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $84DsM = parcelRequire("84DsM");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");
var $46bb11efbe40b76f$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics, analyticsNext: analyticsNext } = props;
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) analyticsNext('ui.teamProfileCard.rendered.spinner', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                ...(0, $2EPX4.PACKAGE_META_DATA)
            }));
        else analytics((duration)=>(0, $2EPX4.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics,
        analyticsNext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $84DsM.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.CardContent), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84DsM.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
                })
            })
        ]
    });
};

});
parcelRegister("84DsM", function(module, exports) {
$parcel$export(module.exports, "CardWrapper", () => $a368743025da7b9f$export$6aa22a823032b784);
$parcel$export(module.exports, "CardHeader", () => $a368743025da7b9f$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $a368743025da7b9f$export$64ef9b8c11710c47);
$parcel$export(module.exports, "LoadingWrapper", () => $a368743025da7b9f$export$43a792a870d28db2);
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");

var $gVqtd = parcelRequire("gVqtd");
const $a368743025da7b9f$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw"
};
const $a368743025da7b9f$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardtriggerwrapper)
    });
const $a368743025da7b9f$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $a368743025da7b9f$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>isLoading || !image ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gVqtd.CoverImage), {
        alt: label || '',
        src: image
    });
const $a368743025da7b9f$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.cardcontent),
        ...props
    });
const $a368743025da7b9f$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($a368743025da7b9f$var$styles.loadingwrapper),
        ...props
    });

});
parcelRegister("gVqtd", function(module, exports) {
$parcel$export(module.exports, "CoverImage", () => $2e76209cd6ae11d8$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $2e76209cd6ae11d8$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13li12b0 _qrwq12b0 _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug",
    imageNext: "_4t3i1osq _5ral1dfr"
};
const $2e76209cd6ae11d8$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const imgRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        ref: containerRef,
        xcss: $2e76209cd6ae11d8$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: (0, $eGOwo.fg)('cover-header-image-team-profilecard') ? $2e76209cd6ae11d8$var$styles.imageNext : $2e76209cd6ae11d8$var$styles.image
        })
    });
};

});







parcelRegister("aVor1", function(module, exports) {
$parcel$export(module.exports, "TeamReadViewWithGpp", () => $deb0ebcb9ca82ac4$export$ad83489c3f151e9e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lL4G9 = parcelRequire("lL4G9");
var $1DXK0 = parcelRequire("1DXK0");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $6qS8z = parcelRequire("6qS8z");

var $6bLlX = parcelRequire("6bLlX");

var $bmoS1 = parcelRequire("bmoS1");

var $lRq8t = parcelRequire("lRq8t");

var $48BVs = parcelRequire("48BVs");

var $kgwPr = parcelRequire("kgwPr");

var $4cTDP = parcelRequire("4cTDP");

var $lO5gq = parcelRequire("lO5gq");
const $deb0ebcb9ca82ac4$export$ad83489c3f151e9e = ({ teamName: teamName, teamId: teamId, ariId: ariId, maxLines: maxLines, triggerLinkType: triggerLinkType = 'link', showTeamPreview: showTeamPreview = false })=>{
    const isPreviewPanelContextAvailable = (0, $eJOHy.useContext)((0, $6bLlX.JiraPreviewPanelsContext));
    let isPreviewPanelAvailable = !!isPreviewPanelContextAvailable;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resolvedTeamId = teamId || (ariId ? (0, $48BVs.getIdFromAri)(ariId) : '');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const teamUrl = `${window.location.origin}/jira/people/team/${resolvedTeamId}`;
    let openPreviewPanelWithTeamData = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (event)=>{}, []);
    if (isPreviewPanelAvailable) {
        const { openPreviewPanel: openPreviewPanel, isPreviewPanelAvailable: isPreviewPanelAvailableInContext } = // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6bLlX.useGlobalObjectPreviewPanels)();
        isPreviewPanelAvailable = isPreviewPanelAvailable && isPreviewPanelAvailableInContext({
            ari: ariId || ''
        });
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        openPreviewPanelWithTeamData = (0, $eJOHy.useCallback)((event)=>{
            // For keyboard events, only respond to Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                ari: ariId,
                url: teamUrl,
                name: 'identity-team'
            });
        }, [
            ariId,
            openPreviewPanel,
            teamUrl
        ]);
    }
    const handleLinkClick = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    const ariaLabel = formatMessage((0, $lO5gq.default).teamPreviewLabel, {
        teamName: teamName
    });
    const isModal = (0, $bmoS1.useIsModal)();
    const canShowPreview = !isModal && isPreviewPanelAvailable;
    const teamNameContent = canShowPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb0ebcb9ca82ac4$var$TeamNameWrapper, {
        onClick: openPreviewPanelWithTeamData,
        onKeyDown: openPreviewPanelWithTeamData,
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, teamName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: teamUrl,
        target: "_blank",
        onClick: handleLinkClick,
        xcss: $deb0ebcb9ca82ac4$var$teamLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: maxLines
    }, teamName));
    const gppContent = (0, $4cTDP.fg)('avatar_for_jira_team_field') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qS8z.default), {
        size: "small",
        teamId: teamId
    }), teamNameContent) : teamNameContent;
    if (showTeamPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kgwPr.default), {
        teamId: ariId,
        trigger: "hover",
        position: "left-start",
        triggerLinkType: triggerLinkType
    }, gppContent);
    return gppContent;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $deb0ebcb9ca82ac4$var$TeamNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $deb0ebcb9ca82ac4$var$teamLinkStyles = (0, $1DXK0.xcss)({
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'color.text',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.text'
    },
    ':visited': {
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    }
});

});
parcelRegister("48BVs", function(module, exports) {
$parcel$export(module.exports, "getColorForProgress", () => $de59d015c44f2268$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $de59d015c44f2268$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $de59d015c44f2268$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $de59d015c44f2268$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $de59d015c44f2268$export$79640a85913af5aa);


var $9CuM6 = parcelRequire("9CuM6");
const $de59d015c44f2268$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $de59d015c44f2268$var$COLOR_RANGES = [
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.FAILING,
        end: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $7bb4c1736002a04a$exports).R300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING - 1,
        color: (0, $7bb4c1736002a04a$exports).Y300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        color: (0, $7bb4c1736002a04a$exports).G300
    }
];
const $de59d015c44f2268$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $de59d015c44f2268$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $7bb4c1736002a04a$exports).R300;
};
const $de59d015c44f2268$export$921f23fa0f13f23e = 90;
const $de59d015c44f2268$export$69a1d9a35c04a358 = 50;
const $de59d015c44f2268$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $de59d015c44f2268$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $de59d015c44f2268$export$69a1d9a35c04a358 && totalScore < $de59d015c44f2268$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $de59d015c44f2268$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $9CuM6.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $9CuM6.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $de59d015c44f2268$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $de59d015c44f2268$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
parcelRegister("9CuM6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3693706a70d8818b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3693706a70d8818b$var$messages = (0, $7qGN1.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});
var $3693706a70d8818b$export$2e2bcd8739ae039 = $3693706a70d8818b$var$messages;

});


parcelRegister("lO5gq", function(module, exports) {
$parcel$export(module.exports, "default", () => $fadc8f0700e23504$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fadc8f0700e23504$var$messages = (0, $7qGN1.defineMessages)({
    teamPreviewLabel: {
        "id": "issue-field-team-readview-with-gpp.team.preview-label",
        "defaultMessage": "Click to view {teamName} team details"
    }
});
var $fadc8f0700e23504$export$2e2bcd8739ae039 = $fadc8f0700e23504$var$messages;

});



parcelRegister("b1dAu", function(module, exports) {
$parcel$export(module.exports, "useMutationWithRetriesCommit", () => $8dfcccfd6d6324ba$export$aaa0248df1ccb7fc);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $8dfcccfd6d6324ba$export$aaa0248df1ccb7fc = ({ retries: retries, isValidOnCompleted: isValidOnCompleted })=>{
    return (0, $eJOHy.useCallback)((environment, config)=>{
        let disposable;
        let optimisticDisposable = null;
        const handleCommitWithRetries = ({ retriesLeft: retriesLeft })=>{
            disposable = (0, $j4oe4.commitMutation)(environment, {
                ...config,
                onCompleted: (response, errors)=>{
                    if (isValidOnCompleted(response, errors)) {
                        config.onCompleted?.(response, errors);
                        return;
                    }
                    if (retriesLeft > 0) {
                        optimisticDisposable = (0, $j4oe4.applyOptimisticMutation)(environment, config);
                        // Wait 100ms before retrying
                        const timeout = setTimeout(()=>{
                            optimisticDisposable?.dispose();
                            handleCommitWithRetries({
                                retriesLeft: retriesLeft - 1
                            });
                        }, 100);
                        disposable = {
                            dispose: ()=>{
                                optimisticDisposable?.dispose();
                                clearTimeout(timeout);
                            }
                        };
                        return;
                    }
                    // Last retry needs to call onComplete
                    config.onCompleted?.(response, errors);
                }
            });
        };
        handleCommitWithRetries({
            retriesLeft: retries
        });
        // Return a new disposable that cleans up the optimistic AND committed operations
        return {
            dispose: ()=>{
                disposable?.dispose();
            }
        };
    }, [
        isValidOnCompleted,
        retries
    ]);
};

});



parcelRegister("g6JiP", function(module, exports) {
$parcel$export(module.exports, "UserCell", () => $54354a9b04f5dfc5$export$dc0ef711c0db7c30);

var $6pPN6 = parcelRequire("6pPN6");

var $Dk8Q3 = parcelRequire("Dk8Q3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $lpMrC = parcelRequire("lpMrC");

var $lRq8t = parcelRequire("lRq8t");

var $6AqNd = parcelRequire("6AqNd");

var $krQQZ = parcelRequire("krQQZ");

var $iZVkR = parcelRequire("iZVkR");

var $2QZBX = parcelRequire("2QZBX");

var $eqbO4 = parcelRequire("eqbO4");

var $4vHFI = parcelRequire("4vHFI");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");

var $jpLGv = parcelRequire("jpLGv");
const $54354a9b04f5dfc5$export$dc0ef711c0db7c30 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, projectKey: projectKey, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $Dk8Q3.default), fieldRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54354a9b04f5dfc5$export$df3d80016052952c, {
        fieldRef: data,
        projectKey: projectKey,
        menuPortalTarget: // Portal the menu outside of the scroll container, i.e., table body
        // to prevent clipping in Safari (see https://bugs.webkit.org/show_bug.cgi?id=160953#c20)
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        (0, $lpMrC.isSafari)() ? document.body : undefined,
        isFirstField: isFirstField,
        hasDuplicates: hasDuplicates
    });
});
const $54354a9b04f5dfc5$export$df3d80016052952c = ({ fieldRef: fieldRef, projectKey: projectKey, menuPortalTarget: menuPortalTarget, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $6pPN6.default), fieldRef);
    const isAssigneeReporter = data.fieldId === 'assignee' || data.fieldId === 'reporter';
    const isCreatorField = data.fieldId === 'creator';
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isInlineEditingSupported = isAssigneeReporter || isInlineEditingExtendedFieldSupportEnabled;
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    // We can also disable editability of the creator field as it is never editable.
    let isEditable;
    if ('isEditableInIssueView' in data) isEditable = data.isEditableInIssueView;
    else isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingSupported && !isCreatorField ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const shouldRenderHoverPopover = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && shouldRenderHoverPopover) switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AqNd.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "start",
                editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
                editViewPopupTarget: isFirstField ? $54354a9b04f5dfc5$var$CustomTarget : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: isFirstField ? 'fixed' : 'absolute',
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: (0, $2QZBX.toProjectKey)(projectKey),
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krQQZ.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "start",
                editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
                editViewPopupTarget: isFirstField ? $54354a9b04f5dfc5$var$CustomTarget : undefined,
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: isFirstField ? 'fixed' : 'absolute',
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $jpLGv.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "start",
                    editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
                    // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
                    editViewPopupTarget: isFirstField ? $54354a9b04f5dfc5$var$CustomTarget : undefined,
                    fragmentRef: data,
                    isEditable: isEditable ?? false,
                    menuPosition: isFirstField ? 'fixed' : 'absolute',
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover
                });
            }
    }
    switch(data.fieldId){
        case 'assignee':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6AqNd.AssigneeInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                projectKey: (0, $2QZBX.toProjectKey)(projectKey),
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        case 'reporter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krQQZ.ReporterInlineEditViewWithIsEditable), {
                attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                spacing: "default",
                editViewPopup: true,
                editViewPopupAlignBlock: "center",
                fragmentRef: data,
                isEditable: isEditable ?? false,
                menuPosition: "fixed",
                portalElement: menuPortalTarget,
                readViewFitContainerHeight: true,
                shouldRenderHoverPopover: shouldRenderHoverPopover
            });
        default:
            {
                const noneOptionLabel = isCreatorField ? formatMessage((0, $jpLGv.default).anonymous) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
                    attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
                    spacing: "default",
                    editViewPopup: true,
                    editViewPopupAlignBlock: "center",
                    fragmentRef: data,
                    menuPosition: "fixed",
                    isEditable: isEditable ?? false,
                    portalElement: menuPortalTarget,
                    readViewFitContainerHeight: true,
                    noneOptionLabel: noneOptionLabel,
                    shouldRenderHoverPopover: shouldRenderHoverPopover
                });
            }
    }
};
const $54354a9b04f5dfc5$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $54354a9b04f5dfc5$var$customTargetStyles : $54354a9b04f5dfc5$var$customTargetStylesOld,
        ref: ref
    });
});
const $54354a9b04f5dfc5$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $54354a9b04f5dfc5$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("6pPN6", function(module, exports) {
$parcel$export(module.exports, "default", () => $77999187c22b154a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<561f3c0cf0f18cedb74f8c5220acb78f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77999187c22b154a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "UserCellInternal_UserCellInternal",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$77999187c22b154a$var$node.hash = "b46332f2b35b377120e45dd1115efebd";
var $77999187c22b154a$export$2e2bcd8739ae039 = $77999187c22b154a$var$node;

});

parcelRegister("Dk8Q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $607c85a2dd0dfeac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d074d8358322ecb5e2b5b6bd912136>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $607c85a2dd0dfeac$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "UserCellInternal",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "UserCellInternal_UserCellInternal"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$607c85a2dd0dfeac$var$node.hash = "222a689111ce0aec54903a0d814d0501";
var $607c85a2dd0dfeac$export$2e2bcd8739ae039 = $607c85a2dd0dfeac$var$node;

});

parcelRegister("6AqNd", function(module, exports) {
$parcel$export(module.exports, "AssigneeInlineEditViewWithIsEditable", () => $324f37a604262e80$export$e07ee235d4f5b512);
$parcel$export(module.exports, "AssigneeInlineEditView", () => $324f37a604262e80$export$9f32fa927ad908e5);

var $8ILq5 = parcelRequire("8ILq5");

var $e6ErP = parcelRequire("e6ErP");

var $7f399 = parcelRequire("7f399");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $41wNq = parcelRequire("41wNq");

var $lRq8t = parcelRequire("lRq8t");

var $d2AGn = parcelRequire("d2AGn");

var $ftZVn = parcelRequire("ftZVn");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $fsoQR = parcelRequire("fsoQR");


var $14RSn = parcelRequire("14RSn");

var $jHI6h = parcelRequire("jHI6h");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $9RttA = parcelRequire("9RttA");

var $RPb3k = parcelRequire("RPb3k");

var $9vs2V = parcelRequire("9vs2V");
const $324f37a604262e80$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $324f37a604262e80$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-assignee-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $324f37a604262e80$export$e07ee235d4f5b512 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, portalElement: portalElement, onCancel: onCancel, onEdit: onEdit, isDisabledTooltipShown: isDisabledTooltipShown = false, projectKey: projectKey, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, shouldRenderHoverPopover: shouldRenderHoverPopover, position: position })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable || false), [
        isEditable,
        overriding
    ]);
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $7f399.default), fragmentRef);
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldRequired = fieldConfig?.isRequired ?? false;
    // Node: Change the MUTATION_NAME whenever the mutation name is also being changed
    const MUTATION_NAME = 'assignee_issueFieldAssignee_AssigneeField_Mutation';
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $e6ErP.default));
    // #endregion
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { humanSupervisor: humanSupervisor } = (0, $9vs2V.useSupervisorWithFg)(user, updatedValue);
    const handleSubmit = (0, $eJOHy.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        (0, $jHI6h.startCapturingTraceIds)(MUTATION_NAME);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) {
                    (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
                    onSuccess();
                } else {
                    const traceIds = (0, $jHI6h.getTraceIds)(MUTATION_NAME);
                    (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
                    const gqlError = mutationData.jira?.updateSingleSelectUserPickerField?.errors?.[0];
                    onFail(new (0, $14RSn.default)(gqlError?.extensions?.statusCode || 0, gqlError?.message || undefined, traceIds[0]));
                }
            },
            onError (error) {
                onFail(error);
                (0, $jHI6h.stopCapturingTraceIds)(MUTATION_NAME);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, initialValue?.accountId, value?.accountId || null);
    }, [
        fieldId,
        initialValue
    ]);
    const validator = (0, $RPb3k.useAssigneeValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $324f37a604262e80$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'singleUser',
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($324f37a604262e80$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsoQR.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: formatMessage((0, $9RttA.default).unassignedOption),
            profileCardAction: (0, $9122f643e6cb5228$export$6bef782d14a92db8),
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            position: position,
            fieldId: fieldId,
            humanSupervisor: humanSupervisor
        })), [
        data,
        formatMessage,
        shouldRenderHoverPopover,
        fieldId,
        position,
        humanSupervisor
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue,
            onChange: handleChangeAndConfirm,
            spacing: spacing,
            projectKey: projectKey,
            fetchSuggestionsOnMount: false,
            portalElement: portalElement,
            enablePeopleInvite: true,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            label: fieldName,
            isInvalid: !!invalidMessage
        });
    const editButtonLabel = formatMessage((0, $41wNq.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? formatMessage((0, $9RttA.default).unassignedOption),
        fieldName: fieldName
    });
    const inlineEditElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $ftZVn.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight,
        disableReadViewAppearanceOnHoverOnly: true
    });
    return isDisabledTooltipShown && !isFieldEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $41wNq.default).disabledReporterTooltip, {
            fieldName: fieldName
        }),
        position: "mouse"
    }, inlineEditElement) : inlineEditElement;
};
const $324f37a604262e80$export$9f32fa927ad908e5 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $8ILq5.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($324f37a604262e80$export$e07ee235d4f5b512, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8ILq5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d27229231115a401$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9ea929c7ab7c075bed623095bf805b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d27229231115a401$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$d27229231115a401$var$node.hash = "93c1d9e2338da6a23190803216172e69";
var $d27229231115a401$export$2e2bcd8739ae039 = $d27229231115a401$var$node;

});

parcelRegister("e6ErP", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6fe3eeeba7024b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e918e00b96147ea6bf09ae576e90430e>>
 * @relayHash edf533ecdfe81145f0d5ed0486a7d74c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301
const $3f6fe3eeeba7024b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d872673080e443d67f3c30873225e21fdfd2b89e010b0cfb4f1f1c7f8da5f301",
            "metadata": {},
            "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3f6fe3eeeba7024b$var$node.hash = "6c6c314bdc60901e8c03415b7add3145";
var $3f6fe3eeeba7024b$export$2e2bcd8739ae039 = $3f6fe3eeeba7024b$var$node;

});

parcelRegister("7f399", function(module, exports) {
$parcel$export(module.exports, "default", () => $3547e8de8d654203$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9ca77a6f603659f7fdc3d2edcbe581c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3547e8de8d654203$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "appType"
                                    }
                                ]
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$3547e8de8d654203$var$node.hash = "ecb910fd877010e293fbf3b99bdb2988";
var $3547e8de8d654203$export$2e2bcd8739ae039 = $3547e8de8d654203$var$node;

});

parcelRegister("41wNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $68be5f461eda860e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $68be5f461eda860e$var$messages = (0, $7qGN1.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    },
    columnTitleAriaLabel: {
        "id": "inline-edit.column-title-aria-label",
        "defaultMessage": "Add column name"
    }
});
var $68be5f461eda860e$export$2e2bcd8739ae039 = $68be5f461eda860e$var$messages;

});

parcelRegister("ftZVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad0c1b7ae89be577$export$2e2bcd8739ae039);

var $l4y7H = parcelRequire("l4y7H");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ad0c1b7ae89be577$var$AssigneeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3x5cn")), {
        moduleId: "3f5ced6e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({
            queries: {
                rootData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $l4y7H.default,
                    variables: {}
                }
            }
        })
});
var $ad0c1b7ae89be577$export$2e2bcd8739ae039 = $ad0c1b7ae89be577$var$AssigneeEditViewEntryPoint;

});
parcelRegister("l4y7H", function(module, exports) {
$parcel$export(module.exports, "default", () => $57f9257373f6ce88$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c3533b181da4fe930f227b215516895>>
 * @relayHash c0a99e60ca7db3e867b3bb2039798d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0
const $57f9257373f6ce88$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "06cc27c43b93217b220d59a67c5b60e54cc82db33ba6e684ea3f67b1f62fb4a0",
        "metadata": {},
        "name": "assigneeEditView_rootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $57f9257373f6ce88$export$2e2bcd8739ae039 = $57f9257373f6ce88$var$node;

});

parcelRegister("3x5cn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cwtwt").then(()=>parcelRequire('dWIha'));

});


parcelRegister("fsoQR", function(module, exports) {
$parcel$export(module.exports, "SingleUserPickerWithProfileCardReadView", () => $a7294ab276327711$export$2f1ab379ffebbded);

var $6GnQ8 = parcelRequire("6GnQ8");

var $cG6qg = parcelRequire("cG6qg");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $gqBnP = parcelRequire("gqBnP");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $tYLUh = parcelRequire("tYLUh");


var $kaujN = parcelRequire("kaujN");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");

var $3OT15 = parcelRequire("3OT15");

var $ckebs = parcelRequire("ckebs");
const $a7294ab276327711$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', (0, $eJOHy.Fragment), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-user-picker-read-view",
        mode: "list"
    }, children)); /**
                   * The SingleUserPickerReadView will show a read only view of SingleUserPicker field.
                   * @param props [SingleUserPickerReadViewProps](./types.tsx)
                   */ 
const $a7294ab276327711$export$65db1532781bc51 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel = null, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId, humanSupervisor: humanSupervisor })=>{
    const data = (0, $j4oe4.useFragment)((0, $cG6qg.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isExperimentEnabled: isExperimentEnabled } = (0, $tYLUh.useBespokeEmptyFieldTextExperiment)();
    const { name: name = emptyUserLabel ?? formatMessage((0, $ckebs.default).anonymousOption), picture: picture, accountStatus: accountStatus } = data?.user || {};
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    if (!data?.user && fieldId !== 'assignee' && fieldId !== 'reporter' && isExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), {
        emptyText: formatMessage((0, $ckebs.default).noValueTextExperiment)
    });
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: name
    });
    if (shouldRenderHoverPopover && data?.user === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        ref: hoverPopoverRef
    }, name));
     // TODO: to be either cleaned up in CRCS-3113 or replaced with a unified solution
    if (humanSupervisor && (0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        appearance: "stack",
        data: [
            {
                name: name,
                src: picture
            },
            {
                name: name,
                src: humanSupervisor?.avatarUrls.large
            }
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-label": "human supervisor"
    }, name, " with ", humanSupervisor?.displayName), data?.user && accountStatus !== 'active' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$UserStatus, null, `(${formatMessage((0, $ckebs.default).deactivated)})`)));
    return(// We use our own container element rather than an AvatarItem as we've observed hydration bugs with SSR+Emotion
    // when this component is wrapped in an async profile card, and this approach is the path of least friction.
    // Further context here https://atlassian.slack.com/archives/C060GTVV988/p1712624943348969.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        as: $a7294ab276327711$var$AvatarAlignmentFix,
        src: picture,
        name: name,
        size: "small",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, name), data?.user && accountStatus !== 'active' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$UserStatus, null, `(${formatMessage((0, $ckebs.default).deactivated)})`))));
});
const $a7294ab276327711$export$2f1ab379ffebbded = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentRef: fragmentRef, emptyUserLabel: emptyUserLabel, profileCardAction: profileCardAction, position: position, shouldRenderHoverPopover: shouldRenderHoverPopover, fieldId: fieldId, humanSupervisor: humanSupervisor })=>{
    const data = (0, $j4oe4.useFragment)((0, $6GnQ8.default), fragmentRef);
    const accountId = data?.user?.accountId || null;
    const actions = (0, $eJOHy.useMemo)(()=>profileCardAction ? [
            (0, $9122f643e6cb5228$export$23cedd3261bd8015),
            profileCardAction
        ] : [
            (0, $9122f643e6cb5228$export$23cedd3261bd8015)
        ], [
        profileCardAction
    ]);
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaujN.default), {
        prepopulatedData: {
            fullName: data?.user?.name
        },
        accountId: accountId,
        actions: actions,
        position: position
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId,
        humanSupervisor: humanSupervisor
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a7294ab276327711$export$65db1532781bc51, {
        fragmentRef: data,
        emptyUserLabel: emptyUserLabel,
        shouldRenderHoverPopover: shouldRenderHoverPopover,
        fieldId: fieldId
    }));
}); /**
     * Component to pass for "as" prop of Avatar. It reverses the 2px margin added in the Avatar
     * component when a transparent border is used.
     *
     * Done using div + css because styled components are not compatible with Avatar's types.
     */ 
const $a7294ab276327711$var$AvatarAlignmentFix = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y"
        ])
    }));
const $a7294ab276327711$var$avatarAlignmentStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7294ab276327711$var$UserStatus = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6GnQ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $46308aa31193a051$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75c9f0edae87b35dae025f46e4be4e99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46308aa31193a051$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$46308aa31193a051$var$node.hash = "c59dbeffeee9029f50284e101470f0fa";
var $46308aa31193a051$export$2e2bcd8739ae039 = $46308aa31193a051$var$node;

});

parcelRegister("cG6qg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fb534729e4e04ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b0d8d0120926503a740c570f8bf4fe5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fb534729e4e04ed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$5fb534729e4e04ed$var$node.hash = "59739a86b6a34ae1b3e960c72938c561";
var $5fb534729e4e04ed$export$2e2bcd8739ae039 = $5fb534729e4e04ed$var$node;

});

parcelRegister("kaujN", function(module, exports) {
$parcel$export(module.exports, "ProfileCard", () => $a91fed983bc1d05e$export$bed540ccfa8743c4);
$parcel$export(module.exports, "default", () => $a91fed983bc1d05e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");

var $kGj4V = parcelRequire("kGj4V");

var $lcB5K = parcelRequire("lcB5K");

var $lRq8t = parcelRequire("lRq8t");

var $e6YEs = parcelRequire("e6YEs");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $5vQ2T = parcelRequire("5vQ2T");

var $a62R3 = parcelRequire("a62R3");


var $4LBQr = parcelRequire("4LBQr");

var $cVBK8 = parcelRequire("cVBK8");

var $l69E3 = parcelRequire("l69E3");
const $a91fed983bc1d05e$var$ConditionalErrorBoundary = (0, $bJscI.componentWithFG)('empanada_profilecard_sync_trigger_import_final', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "profilecard",
        packageName: (0, $9122f643e6cb5228$export$9345d7360ffe0722),
        fallback: "flag"
    }, children), (0, $eJOHy.Fragment));
const $a91fed983bc1d05e$export$bed540ccfa8743c4 = ({ externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment = false, shouldTruncate: shouldTruncate = false, showDelay: showDelay, hideDelay: hideDelay, isVisible: isVisible, hideAgentMoreActions: hideAgentMoreActions })=>{
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const currentUserAccountId = (0, $e6YEs.useAccountId)();
    const toTeamsAppUserProfile = (userId)=>(0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            }
        }).onNavigate();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a91fed983bc1d05e$var$ConditionalErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: (0, $9122f643e6cb5228$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4LBQr.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l69E3.ProfileCardView), {
            accountId: accountId,
            actions: (0, $4cTDP.fg)('jsc_nin_smart_link_fast_follows') ? (0, $cVBK8.getSpaActions)(accountId, intl, actions) : (0, $cVBK8.getSpaActionsWithRouterPush)(accountId, intl, push, actions),
            position: position,
            onProfileClick: (profileAccountId)=>(0, $a62R3.isTeamsAppEnabled)() ? toTeamsAppUserProfile(profileAccountId) : push(`/jira/people/${profileAccountId}`),
            addFlag: showFlag,
            dismissFlag: dismissFlag,
            testId: testId,
            trigger: trigger,
            prepopulatedData: prepopulatedData,
            ariaHideProfileTrigger: ariaHideProfileTrigger,
            isChildComment: isChildComment,
            shouldTruncate: shouldTruncate,
            showDelay: showDelay,
            hideDelay: hideDelay,
            isVisible: isVisible,
            hideAgentMoreActions: hideAgentMoreActions
        }, children)) : children)));
};
var $a91fed983bc1d05e$export$2e2bcd8739ae039 = $a91fed983bc1d05e$export$bed540ccfa8743c4;

});
parcelRegister("l69E3", function(module, exports) {
$parcel$export(module.exports, "ProfileCardView", () => $724fce4f5df4705a$export$da5098f02f405a40);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $caeqU = parcelRequire("caeqU");

var $ymEZt = parcelRequire("ymEZt");
var $jn1Cb = parcelRequire("jn1Cb");

var $c3tJH = parcelRequire("c3tJH");

var $6XJko = parcelRequire("6XJko");

var $e6YEs = parcelRequire("e6YEs");

var $cHtIB = parcelRequire("cHtIB");

var $a62R3 = parcelRequire("a62R3");

var $7t8WA = parcelRequire("7t8WA");

const $724fce4f5df4705a$var$PEOPLE_PROFILE_PATH = '/people/';
const $724fce4f5df4705a$var$ProfileCardTriggerWithAnalytics = (0, $c3tJH.AnalyticsEventToProps)((0, $1f42fe6c39d9ca34$export$a1455360a24a2234), {
    analytics: ''
})((0, $caeqU.default));
const $724fce4f5df4705a$export$da5098f02f405a40 = ({ children: children, position: position = 'top-start', trigger: trigger = 'hover', accountId: accountId, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment, shouldTruncate: shouldTruncate, showDelay: showDelay, hideDelay: hideDelay, isVisible: isVisible, hideAgentMoreActions: hideAgentMoreActions })=>{
    const profileCardWrapperRef = (0, $eJOHy.useRef)(null);
    const cloudId = (0, $cHtIB.useCloudId)();
    const viewingUserId = (0, $e6YEs.useAccountId)();
    const { profileClient: profileClient } = (0, $7t8WA.useProfileClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724fce4f5df4705a$var$Wrapper, {
        ref: profileCardWrapperRef,
        onClick: (event)=>{
            if (profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            !profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
        },
        "data-vc": `profilecard-wrapper${false ? '-ssr' : ''}`,
        isVisualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        className: (0, $hcewu.default)([
            isChildComment && "_kqswh2mm _1hjgt94y _1pty1eak _161e1v33 _ft5qdlk8 _2wzdc71f _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l21pz7 _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            isChildComment && "_p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            shouldTruncate && "_1reo15vq _18m915vq _1o9zidpf _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724fce4f5df4705a$var$ProfileCardTriggerWithAnalytics, {
        cloudId: cloudId,
        userId: accountId,
        resourceClient: profileClient,
        position: position,
        trigger: trigger,
        testId: testId,
        actions: actions,
        reportingLinesProfileUrl: $724fce4f5df4705a$var$PEOPLE_PROFILE_PATH,
        prepopulatedData: prepopulatedData,
        showDelay: showDelay,
        hideDelay: hideDelay,
        hideAgentMoreActions: hideAgentMoreActions,
        onReportingLinesClick: onProfileClick ? // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
        (user)=>{
            onProfileClick(user.accountIdentifier);
            if ((0, $a62R3.isTeamsAppEnabled)()) return false;
        } : null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $jn1Cb.toFlagId)(flag.id);
            addFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ymEZt.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        },
        viewingUserId: viewingUserId,
        ariaHideProfileTrigger: ariaHideProfileTrigger,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger",
        className: (0, $hcewu.default)([
            shouldTruncate && "_1e0c1nu9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $724fce4f5df4705a$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.isVisualRefresh && "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $724fce4f5df4705a$var$profileCardStyles = null;
const $724fce4f5df4705a$var$replyProfileCardStyles = null;
const $724fce4f5df4705a$var$truncatedProfileCardStyles = null;
const $724fce4f5df4705a$var$truncatedProfileCardInnerStyles = null;
$724fce4f5df4705a$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("caeqU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});
parcelRegister("1GAK3", function(module, exports) {
$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2mJ6Y")));

});
parcelRegister("2mJ6Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("39Fdj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);
/* ProfileCardTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $g06PH = parcelRequire("g06PH");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $kNQN4 = parcelRequire("kNQN4");

var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
const $9a556daa2b306b37$var$styles = {
    profileCardTrigger: "_m5ny16oo"
};
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag, hideAgentMoreActions: hideAgentMoreActions }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: trigger,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag,
        hideMoreActions: (0, $eGOwo.fg)('jira_ai_profilecard_hide_agent_actions') && !!hideAgentMoreActions
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, hideAgentMoreActions: hideAgentMoreActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId, showDelay: customShowDelay, hideDelay: customHideDelay }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const isExternalControl = propsIsVisible !== undefined && propsIsVisible !== visible;
    const showDelay = trigger === 'click' || isExternalControl && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : customShowDelay ?? (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || isExternalControl && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : customHideDelay ?? (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    const { fireEvent: fireEventNext } = (0, $g06PH.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    // Create a wrapper function that has the same interface as fireEventNext but includes isMounted check
    const fireAnalyticsNext = (0, $eJOHy.useCallback)((eventKey, ...attributes)=>{
        if (!isMounted.current) return;
        fireEventNext(eventKey, ...attributes);
    }, [
        fireEventNext
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics, fireAnalyticsNext),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        fireAnalyticsNext,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) {
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) fireAnalyticsNext('ui.profilecard.triggered', {
                method: 'click',
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                ...(0, $2EPX4.PACKAGE_META_DATA)
            });
            else fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        fireAnalyticsNext,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) {
            if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) fireAnalyticsNext('ui.profilecard.triggered', {
                method: 'hover',
                firedAt: Math.round((0, $kNQN4.getPageTime)()),
                ...(0, $2EPX4.PACKAGE_META_DATA)
            });
            else fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
        }
    }, [
        fireAnalytics,
        fireAnalyticsNext,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) {
                if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) fireAnalyticsNext('ui.profilecard.triggered', {
                    method: 'click',
                    firedAt: Math.round((0, $kNQN4.getPageTime)()),
                    ...(0, $2EPX4.PACKAGE_META_DATA)
                });
                else fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
            }
        }
    }, [
        fireAnalytics,
        fireAnalyticsNext,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = ssrPlaceholderId ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    if ((0, $eGOwo.fg)('enable_absolute_positioning_profile_card')) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $9a556daa2b306b37$var$styles.profileCardTrigger,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                    isOpen: !!visible,
                    onClose: (event)=>{
                        hideProfilecard();
                        handleKeyboardClose(event);
                    },
                    placement: position,
                    offset: offset ?? [
                        0,
                        8
                    ],
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ...wrapperProps,
                            children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                                fireAnalytics: fireAnalytics,
                                fireAnalyticsNext: fireAnalyticsNext
                            }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                                profilecardProps: profilecardProps,
                                isAgent: !!data?.isAgent,
                                userId: userId,
                                cloudId: cloudId,
                                resourceClient: resourceClient,
                                viewingUserId: viewingUserId,
                                trigger: trigger,
                                product: product,
                                profileCardAction: filterActions(),
                                errorType: error,
                                hasError: hasError,
                                agentActions: agentActions,
                                addFlag: addFlag,
                                hideAgentMoreActions: hideAgentMoreActions
                            })
                        }),
                    trigger: (triggerProps)=>{
                        const { ref: callbackRef, ...innerProps } = triggerProps;
                        const ref = (element)=>{
                            triggerRef.current = element;
                            if (typeof callbackRef === 'function') callbackRef(element);
                        };
                        const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            ...disabledAriaAttributes ? restInnerProps : triggerProps,
                            ...containerListeners,
                            ref: ref,
                            "data-testid": testId,
                            ...!ariaHideProfileTrigger && {
                                'aria-labelledby': ariaLabelledBy
                            },
                            ...disabledAriaAttributes ? {} : {
                                role: 'button',
                                //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                                tabIndex: ariaHideProfileTrigger ? -1 : 0,
                                'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                            },
                            ...ariaHideProfileTrigger && {
                                'aria-hidden': 'true'
                            },
                            ...ssrPlaceholderProp,
                            children: children
                        });
                    },
                    zIndex: (0, $IW7jS.layers).modal(),
                    shouldUseCaptureOnOutsideClick: true,
                    autoFocus: autoFocus ?? trigger === 'click',
                    shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') || (0, $eGOwo.fg)('enable_absolute_positioning_profile_card'),
                    shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') || (0, $eGOwo.fg)('enable_absolute_positioning_profile_card'),
                    strategy: "absolute",
                    id: "profile-card-trigger-popup-wrapper"
                })
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics,
                            fireAnalyticsNext: fireAnalyticsNext
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag,
                            hideAgentMoreActions: hideAgentMoreActions
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics, fireAnalyticsNext: fireAnalyticsNext })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics,
            fireAnalyticsNext: fireAnalyticsNext
        })
    });

});
parcelRegister("8WJ7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("b4A0H", function(module, exports) {
$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rko12b0 _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

parcelRegister("bQmsU", function(module, exports) {
$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $g06PH = parcelRequire("g06PH");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEventNext } = (0, $g06PH.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    /**
	 * @TODO replace with `getAgentCreator` from `@atlassian/rovo-agent-components`
	 * @deprecated use `getAgentCreator` from `@atlassian/rovo-agent-components`
	 */ const getCreator = (0, $eJOHy.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    if (authoringTeam && (0, $eGOwo.fg)('agent_studio_permissions_settings_m3_profiles')) return {
                        type: 'CUSTOMER',
                        name: authoringTeam.displayName ?? '',
                        profileLink: authoringTeam.profileUrl ?? ''
                    };
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics, fireEventNext);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        fireEventNext,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics, fireEventNext);
            const profileData = profileResult.restData;
            const agentCreatorInfo = await getCreator({
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            });
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        fireEventNext,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{},
            fireAnalyticsNext: fireEventNext
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions
        })
    });
};

});
parcelRegister("46Rs7", function(module, exports) {
$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("dWlMJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $eGOwo = parcelRequire("eGOwo");

var $3cMgR = parcelRequire("3cMgR");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, fireAnalyticsNext: fireAnalyticsNext, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) fireAnalyticsNext('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $2EPX4.PACKAGE_META_DATA)
        });
        else fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        fireAnalyticsNext,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {
$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f4fe046f369d0d86$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            color: "color.text",
            children: props.children
        })
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("kKboJ", function(module, exports) {
$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);
/* AgentProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $d15bd5f3ea87f8ed$var$styles = {
    wrapper: "_1bsb1gwv"
};
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles.wrapper,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {
$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dxaGw")));

});
parcelRegister("dxaGw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("5H2ec", function(module, exports) {
$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics, fireAnalyticsNext: fireAnalyticsNext })=>{
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('ptc-enable-profile-card-analytics-refactor')) fireAnalyticsNext('ui.profilecard.rendered.spinner', {
            firedAt: Math.round((0, $kNQN4.getPageTime)()),
            ...(0, $2EPX4.PACKAGE_META_DATA)
        });
        else fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics,
        fireAnalyticsNext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});



const $1f42fe6c39d9ca34$export$a1455360a24a2234 = 'profileCardNextView';



parcelRegister("ckebs", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a464ef5085b9801$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3a464ef5085b9801$var$messages = (0, $7qGN1.defineMessages)({
    deactivated: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.deactivated",
        "defaultMessage": "Deactivated"
    },
    anonymousOption: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.anonymous-option",
        "defaultMessage": "Anonymous"
    },
    noValueTextExperiment: {
        "id": "issue-field-single-user-picker-readview-full.single-user-picker.no-value-text-experiment",
        "defaultMessage": "Add user"
    }
});
var $3a464ef5085b9801$export$2e2bcd8739ae039 = $3a464ef5085b9801$var$messages;

});


parcelRegister("9RttA", function(module, exports) {
$parcel$export(module.exports, "default", () => $baff1950d7ccac9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $baff1950d7ccac9c$var$messages = (0, $7qGN1.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee-inline-edit-full.assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "issue-field-assignee-inline-edit-full.assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    requiredErrorMessage: {
        "id": "issue-field-assignee-inline-edit-full.assignee.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});
var $baff1950d7ccac9c$export$2e2bcd8739ae039 = $baff1950d7ccac9c$var$messages;

});

parcelRegister("RPb3k", function(module, exports) {
$parcel$export(module.exports, "useAssigneeValidator", () => $02dcb8981a357561$export$37df2b94c6c5d4a3);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9RttA = parcelRequire("9RttA");
const $02dcb8981a357561$export$37df2b94c6c5d4a3 = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $9RttA.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});

parcelRegister("9vs2V", function(module, exports) {
$parcel$export(module.exports, "useSupervisorWithFg", () => $e02131b26eaa3db7$export$fca3d223ba9f0bef);
/**
 * This is a temporary solution to show the human supervisor avatar in the assignee field for Team EU 25.
 * To be cleaned up in https://jplat.atlassian.net/browse/CRCS-3113 once we settle and move to a long term solution.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $3MbOI = parcelRequire("3MbOI");

var $fq2RT = parcelRequire("fq2RT");

var $6rzJr = parcelRequire("6rzJr");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $6d9QY = parcelRequire("6d9QY");
const $e02131b26eaa3db7$var$IssueHistoryQuery = `
	query IssueHistoryQuery($issueKey: String!, $startAt: Long, $maxResults: Int, $orderBy: String) {
		viewIssue(issueKey: $issueKey) {
			history(orderBy: $orderBy, startAt: $startAt, maxResults: $maxResults) {
				isLast
				totalCount
				startIndex
				nodes {
					fieldId
					actor {
						avatarUrls {
							large
						}
						displayName
						accountId
					}
					to {
						... on AssigneeFieldValue {
							displayValue
							value
							avatarUrl
						}
					}
				}
			}
		}
	}
`;
const $e02131b26eaa3db7$var$useSupervisor = (user, updatedValue)=>{
    const [humanSupervisor, setHumanSupervisor] = (0, $eJOHy.useState)(null);
    const issueKey = (0, $bmoS1.useIssueKey)();
    const prevUpdatedValue = (0, $6d9QY.usePrevious)(updatedValue);
    const hasInitialDataLoadedRef = (0, $eJOHy.useRef)(false);
    const { data: { user: currentUser } } = (0, $3MbOI.useCurrentUser)();
    // For agent assignee, load human supervisor from issue history, when issue or user changes
    (0, $eJOHy.useEffect)(()=>{
        if (!issueKey) return;
        if (user?.appType !== 'agent') {
            hasInitialDataLoadedRef.current = true;
            setHumanSupervisor(null);
            return;
        }
        const history = (0, $6rzJr.getClient)('fields/platform/user/assignee/inline-edit-full/src/ui/assignee/index').query({
            query: $e02131b26eaa3db7$var$IssueHistoryQuery,
            variables: {
                issueKey: issueKey,
                startAt: 0,
                maxResults: 5,
                orderBy: '-created'
            }
        });
        history.then((result)=>{
            const issueHistoryNodes = result?.data?.viewIssue?.history?.nodes;
            const mostRecentAgentAssignmentRecord = issueHistoryNodes?.find((node)=>node.fieldId === 'assignee' && node.to?.displayValue === user?.name);
            if (mostRecentAgentAssignmentRecord) setHumanSupervisor({
                ...mostRecentAgentAssignmentRecord.actor,
                displayName: currentUser.accountId === mostRecentAgentAssignmentRecord.actor.accountId ? 'You' : mostRecentAgentAssignmentRecord.actor.displayName
            });
            hasInitialDataLoadedRef.current = true;
        });
    // TODO: error handling
    }, [
        issueKey,
        user?.accountId,
        user?.name,
        user?.appType,
        currentUser.accountId
    ]); // accountId here to protect again identical agent names
    // Optimistic update: set supervisor to current user when assignee **changed** from client side
    (0, $eJOHy.useEffect)(()=>{
        // skip when assignee didn't really change, or before initial data is loaded
        if (!hasInitialDataLoadedRef.current || prevUpdatedValue?.id === updatedValue?.id) return;
        if (updatedValue?.appType !== 'agent') {
            setHumanSupervisor(null);
            return;
        }
        setHumanSupervisor({
            accountId: currentUser.accountId ?? '',
            displayName: 'You',
            avatarUrls: {
                large: (0, $fq2RT.isDataExtra)(currentUser) ? currentUser.avatarUrls['48x48'] : ''
            }
        });
    }, [
        updatedValue,
        prevUpdatedValue,
        currentUser
    ]);
    return {
        humanSupervisor: humanSupervisor
    };
};
const $e02131b26eaa3db7$export$fca3d223ba9f0bef = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_ai_show_human_supervisor_avatar'), $e02131b26eaa3db7$var$useSupervisor, ()=>({
        humanSupervisor: null
    }));

});
parcelRegister("fq2RT", function(module, exports) {
$parcel$export(module.exports, "isDataExtra", () => $a3b2f2c11205ea94$export$ba78a24d4b61cf6b);
function $a3b2f2c11205ea94$export$ba78a24d4b61cf6b(data) {
    return data ? 'avatarUrls' in data : false;
}

});

parcelRegister("6rzJr", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $dc2f954dac87a9b3$export$6bb76d6eba7e258c);

var $4mEPL = parcelRequire("4mEPL");
const $dc2f954dac87a9b3$var$appendOperationQuery = (operation)=>operation ? `?operation=${operation}` : '';
const $dc2f954dac87a9b3$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${$dc2f954dac87a9b3$var$appendOperationQuery(operation)}`;
const $dc2f954dac87a9b3$var$makeFetchClient = (path)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $4mEPL.default)($dc2f954dac87a9b3$export$aefb19023b2eda55(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            }, path)
    });
let $dc2f954dac87a9b3$var$client;
const $dc2f954dac87a9b3$export$6bb76d6eba7e258c = (path)=>{
    if (!$dc2f954dac87a9b3$var$client) $dc2f954dac87a9b3$var$client = $dc2f954dac87a9b3$var$makeFetchClient(path);
    return $dc2f954dac87a9b3$var$client;
};

});



parcelRegister("krQQZ", function(module, exports) {
$parcel$export(module.exports, "ReporterInlineEditViewWithIsEditable", () => $fb2bd4b71c691326$export$f3ca6190158a888f);
$parcel$export(module.exports, "ReporterInlineEditView", () => $fb2bd4b71c691326$export$981d7f2f0ffb0beb);

var $fcqIi = parcelRequire("fcqIi");

var $4IsaQ = parcelRequire("4IsaQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $iZVkR = parcelRequire("iZVkR");


var $9qZqK = parcelRequire("9qZqK");
const $fb2bd4b71c691326$export$f3ca6190158a888f = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $4IsaQ.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditViewWithIsEditable), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9qZqK.default).anonymous),
        profileCardAction: (0, $9122f643e6cb5228$export$6b36f20db7a18a86)
    });
};
const $fb2bd4b71c691326$export$981d7f2f0ffb0beb = ({ fragmentRef: fragmentRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $fcqIi.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZVkR.SingleUserPickerInlineEditView), {
        ...props,
        fragmentRef: data,
        noneOptionLabel: formatMessage((0, $9qZqK.default).anonymous),
        profileCardAction: (0, $9122f643e6cb5228$export$6b36f20db7a18a86)
    });
};

});
parcelRegister("fcqIi", function(module, exports) {
$parcel$export(module.exports, "default", () => $8616de44b9538b35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e444162d4db31fe2d8cf9ce3d49c500a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8616de44b9538b35$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$8616de44b9538b35$var$node.hash = "bd02fa384b206ea57830ba99674f24b9";
var $8616de44b9538b35$export$2e2bcd8739ae039 = $8616de44b9538b35$var$node;

});

parcelRegister("4IsaQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $75f182f97b30c803$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb86f10febd7873bf5fcf89f85958c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $75f182f97b30c803$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporter_issueFieldReporterInlineEditFull_ReporterInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$75f182f97b30c803$var$node.hash = "75550b2f1743d8a0b6176f6ded3b5c91";
var $75f182f97b30c803$export$2e2bcd8739ae039 = $75f182f97b30c803$var$node;

});

parcelRegister("iZVkR", function(module, exports) {
$parcel$export(module.exports, "SingleUserPickerInlineEditViewWithIsEditable", () => $18a4c20873122153$export$c143582b21f1a708);
$parcel$export(module.exports, "SingleUserPickerInlineEditView", () => $18a4c20873122153$export$f182346570197b8);

var $7cnPn = parcelRequire("7cnPn");

var $3Xx7G = parcelRequire("3Xx7G");

var $9LSxy = parcelRequire("9LSxy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $41wNq = parcelRequire("41wNq");

var $lRq8t = parcelRequire("lRq8t");

var $auNLL = parcelRequire("auNLL");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $fsoQR = parcelRequire("fsoQR");

var $1LCPi = parcelRequire("1LCPi");

var $22FmW = parcelRequire("22FmW");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $3vB7G = parcelRequire("3vB7G");

var $iqAIM = parcelRequire("iqAIM");
const $18a4c20873122153$var$isEqualUser = (a, b)=>a?.id === b?.id;
const $18a4c20873122153$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-single-user-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $18a4c20873122153$export$c143582b21f1a708 = ({ attributes: attributes, spacing: spacing = 'compact', editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, editViewPopupTarget: editViewPopupTarget, fragmentRef: fragmentRef, isEditing: startWithEditViewOpen = false, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, onCancel: onCancel, onEdit: onEdit, isEditable: isEditable, readViewFitContainerHeight: readViewFitContainerHeight, noneOptionLabel: noneOptionLabel, profileCardAction: profileCardAction, portalElement: portalElement, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $9LSxy.default), fragmentRef);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { id: uniqueFieldId, fieldId: fieldId, type: type, name: name, user: user, fieldConfig: fieldConfig } = data;
    const isFieldRequired = (0, $eJOHy.useMemo)(()=>fieldConfig?.isRequired ?? false, [
        fieldConfig?.isRequired
    ]);
    const fieldName = (0, $eJOHy.useMemo)(()=>overriding.overrideLabel(name), [
        name,
        overriding
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(isEditable), [
        isEditable,
        overriding
    ]);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $3Xx7G.default));
    const initialValue = user ?? null;
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const handleSubmit = (0, $eJOHy.useCallback)((newUser, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(newUser);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        id: newUser?.id ?? null
                    }
                }
            },
            onCompleted: (mutationData)=>{
                if (mutationData.jira?.updateSingleSelectUserPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateSingleSelectUserPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            user: newUser ? {
                                id: newUser.id,
                                accountId: newUser.accountId,
                                accountStatus: newUser.accountStatus,
                                name: newUser.name,
                                picture: newUser.picture,
                                __typename: 'AtlassianAccountUser'
                            } : null
                        }
                    }
                }
            }
        });
    }, [
        commit,
        uniqueFieldId,
        onSubmit
    ]);
    const validator = (0, $iqAIM.useSingleUserPickerValidator)(fieldName, isFieldRequired);
    const { handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, hasServerValidationError: hasServerValidationError, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: type,
        initialValue: initialValue,
        isValueEqual: $18a4c20873122153$var$isEqualUser,
        onCancel: onCancel,
        onEdit: onEdit,
        onSubmit: handleSubmit,
        onSubmitSucceeded: onSubmitSucceeded,
        onSubmitFailed: onSubmitFailed,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        validator: validator,
        clipboardComponentType: 'singleUser'
    });
    // #region Read view
    const finalNoneOptionLabel = noneOptionLabel ?? formatMessage((0, $3vB7G.default).noneOption);
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18a4c20873122153$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fsoQR.SingleUserPickerWithProfileCardReadView), {
            fragmentRef: data,
            emptyUserLabel: finalNoneOptionLabel,
            profileCardAction: profileCardAction,
            shouldRenderHoverPopover: shouldRenderHoverPopover,
            fieldId: fieldId
        })), [
        data,
        finalNoneOptionLabel,
        profileCardAction,
        shouldRenderHoverPopover,
        fieldId
    ]);
    // #endregion
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            fieldId: uniqueFieldId,
            autoFocus: true,
            value: updatedValue ? (0, $22FmW.transformAggToUserOption)(updatedValue) : null,
            onChange: handleChangeAndConfirm,
            onClear: ()=>handleChangeAndConfirm(null),
            spacing: spacing,
            noneOptionLabel: finalNoneOptionLabel,
            includeNoneOption: !isFieldRequired,
            isClearable: !isFieldRequired,
            menuPosition: menuPosition,
            portalElement: portalElement,
            ariaLabel: fieldName,
            isInvalid: !!invalidMessage
        });
    const editButtonLabel = formatMessage((0, $41wNq.default).extendedEditButtonLabel, {
        inputFieldValue: initialValue?.name ?? finalNoneOptionLabel,
        fieldName: fieldName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupTarget: editViewPopupTarget,
        editViewEntryPoint: (0, $1LCPi.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readView: renderReadView,
        hideActionButtons: true,
        editButtonLabel: editButtonLabel,
        readViewFitContainerHeight: readViewFitContainerHeight,
        disableReadViewAppearanceOnHoverOnly: fieldId === 'reporter'
    });
};
const $18a4c20873122153$export$f182346570197b8 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $7cnPn.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18a4c20873122153$export$c143582b21f1a708, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("7cnPn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7157192006c857f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ece559cc75651d75622d9b47e5f4a4ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7157192006c857f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$7157192006c857f6$var$node.hash = "d6afe351b35e0beb2951194f3010ad16";
var $7157192006c857f6$export$2e2bcd8739ae039 = $7157192006c857f6$var$node;

});

parcelRegister("3Xx7G", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ea5cd096fec5cac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08007f396db418a9d13cbce15739952a>>
 * @relayHash b249572b29f7cf45d6d7890c57510aed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd
const $9ea5cd096fec5cac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectUserPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8768a3b7a61167cb3f57c1ea183973ef7e13af793cc24d86f169fda9c41a20dd",
            "metadata": {},
            "name": "singleUserPicker_issueFieldSingleUser_SingleUserPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9ea5cd096fec5cac$var$node.hash = "bd06a0600bf6d9530e408c77f4b2739a";
var $9ea5cd096fec5cac$export$2e2bcd8739ae039 = $9ea5cd096fec5cac$var$node;

});

parcelRegister("9LSxy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a0c510e0ae74d8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13beec71928bfcdc44a62173d9c393a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6a0c510e0ae74d8b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleUserPicker_issueFieldSingleUserPickerInlineEditFull_SingleUserPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerWithProfileCardReadView_fragmentRef"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraFieldConfig",
                "kind": "LinkedField",
                "name": "fieldConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
}();
$6a0c510e0ae74d8b$var$node.hash = "aebeab1812e893081e79766395b9288b";
var $6a0c510e0ae74d8b$export$2e2bcd8739ae039 = $6a0c510e0ae74d8b$var$node;

});

parcelRegister("1LCPi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a534d5cb9d0b17f$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $2a534d5cb9d0b17f$var$SingleUserPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gQ0Bj")), {
        moduleId: "9f05df27",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $2a534d5cb9d0b17f$export$2e2bcd8739ae039 = $2a534d5cb9d0b17f$var$SingleUserPickerEditViewEntryPoint;

});
parcelRegister("gQ0Bj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9PLvk").then(()=>parcelRequire('hlQGS'));

});


parcelRegister("3vB7G", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e730141fc6dc9ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3e730141fc6dc9ec$var$messages = (0, $7qGN1.defineMessages)({
    noneOption: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.none-option",
        "defaultMessage": "None"
    },
    requiredErrorMessage: {
        "id": "issue-field-single-user-picker-inline-edit-full.single-user-picker.required-error-message",
        "defaultMessage": "{fieldName} is required"
    }
});
var $3e730141fc6dc9ec$export$2e2bcd8739ae039 = $3e730141fc6dc9ec$var$messages;

});

parcelRegister("iqAIM", function(module, exports) {
$parcel$export(module.exports, "useSingleUserPickerValidator", () => $b59aeb64ee7301b0$export$fb9026d1d46dfabe);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3vB7G = parcelRequire("3vB7G");
const $b59aeb64ee7301b0$export$fb9026d1d46dfabe = (fieldName, isRequired)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const submit = (0, $eJOHy.useCallback)((value)=>{
        if (isRequired && value === null) return {
            type: 'error',
            message: formatMessage((0, $3vB7G.default).requiredErrorMessage, {
                fieldName: fieldName
            })
        };
        return null;
    }, [
        fieldName,
        formatMessage,
        isRequired
    ]);
    return {
        submit: submit
    };
};

});


parcelRegister("9qZqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b148334e47965f96$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b148334e47965f96$var$messages = (0, $7qGN1.defineMessages)({
    anonymous: {
        "id": "issue-field-reporter-inline-edit-full.reporter.anonymous",
        "defaultMessage": "Anonymous"
    }
});
var $b148334e47965f96$export$2e2bcd8739ae039 = $b148334e47965f96$var$messages;

});


parcelRegister("jpLGv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cd21ab76f02e18a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5cd21ab76f02e18a$var$messages = (0, $7qGN1.defineMessages)({
    anonymous: {
        "id": "native-issue-table.common.issue-cells.user.anonymous",
        "defaultMessage": "Anonymous"
    }
});
var $5cd21ab76f02e18a$export$2e2bcd8739ae039 = $5cd21ab76f02e18a$var$messages;

});


parcelRegister("9wlkB", function(module, exports) {
$parcel$export(module.exports, "CommentSummaryCell", () => $a1e94c8eb5a5484f$export$ec9db7e6afbd918a);

var $81QDT = parcelRequire("81QDT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $gDKBr = parcelRequire("gDKBr");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $jiTA8 = parcelRequire("jiTA8");

var $34oCh = parcelRequire("34oCh");

var $bFwiO = parcelRequire("bFwiO");
const $a1e94c8eb5a5484f$export$ec9db7e6afbd918a = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueKey: issueKey, onIssueLinkSelected: onIssueLinkSelected })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const data = (0, $j4oe4.useFragment)((0, $81QDT.default), fieldRef);
    const canAddComment = data?.commentSummary?.canAddComment;
    const totalCount = data?.commentSummary?.totalCount;
    const renderedCommentCount = (0, $eJOHy.useMemo)(()=>{
        // No comments, add comment
        if (!totalCount) return formatMessage((0, $bFwiO.default).addComment);
        // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $bFwiO.default).commentsCount, {
            commentCount: totalCount
        });
        // More than 99 comments, show 99+
        return formatMessage((0, $bFwiO.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Use default browser event handling when a modifier key is pressed during the click event
        const isModifierKeyUsed = e.ctrlKey || e.shiftKey || e.metaKey;
        const handled = !isEmbedMode && !isModifierKeyUsed && onIssueLinkSelected !== undefined && onIssueLinkSelected(issueKey, true);
        if (handled) e.preventDefault();
    }, [
        isEmbedMode,
        issueKey,
        onIssueLinkSelected
    ]);
    const hoverPopoverEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (!totalCount && !canAddComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: `/browse/${issueKey}`,
        xcss: [
            $a1e94c8eb5a5484f$var$buttonStyles,
            !totalCount && $a1e94c8eb5a5484f$var$emptyStyles
        ],
        onClick: handleClick,
        backgroundColor: "color.background.neutral.subtle",
        paddingInline: "space.075",
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
        color: "currentColor",
        label: formatMessage((0, $bFwiO.default).comments)
    }), hoverPopoverEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, renderedCommentCount) : renderedCommentCount);
});
const $a1e94c8eb5a5484f$var$buttonStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    borderRadius: 'radius.small',
    borderWidth: 'border.width.focused',
    borderStyle: 'solid',
    // borderColor doesn't allow transparent as a value so we use inline/block which has looser typing
    borderInlineColor: 'transparent',
    borderBlockColor: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minHeight: '100%',
    maxWidth: '100%',
    textDecoration: 'none',
    ':focus': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0,
        color: 'color.text',
        textDecoration: 'none'
    },
    ':focus-visible': {
        borderInlineColor: 'color.border.focused',
        borderBlockColor: 'color.border.focused',
        outline: 0
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1e94c8eb5a5484f$var$emptyStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    ':focus': {
        color: 'color.text.subtlest'
    },
    ':hover': {
        color: 'color.text.subtlest'
    }
});

});
parcelRegister("81QDT", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a715696eea52bb8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa60ed574f3d1189e97a9eaa3b8c340>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a715696eea52bb8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CommentSummaryCell",
    "selections": [
        {
            "concreteType": "JiraCommentSummary",
            "kind": "LinkedField",
            "name": "commentSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAddComment"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ],
    "type": "JiraCommentSummaryField"
};
$3a715696eea52bb8$var$node.hash = "4704a2d7c0c9a0c38b8dab59696c6807";
var $3a715696eea52bb8$export$2e2bcd8739ae039 = $3a715696eea52bb8$var$node;

});

parcelRegister("bFwiO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9772c4bb281d361c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9772c4bb281d361c$var$messages = (0, $7qGN1.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});
var $9772c4bb281d361c$export$2e2bcd8739ae039 = $9772c4bb281d361c$var$messages;

});


parcelRegister("4UEvW", function(module, exports) {
$parcel$export(module.exports, "UrlCell", () => $a2b5e1bc1ee659e3$export$110272e30ac53e5);

var $gxf3b = parcelRequire("gxf3b");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $57mJt = parcelRequire("57mJt");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $a2b5e1bc1ee659e3$export$110272e30ac53e5 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $gxf3b.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mJt.UrlInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $a2b5e1bc1ee659e3$var$CustomTarget : undefined,
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mJt.UrlInlineEditViewIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        readViewFitContainerHeight: true,
        isSimpleInlineSmartLinkEnabled: true,
        shouldRenderHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $a2b5e1bc1ee659e3$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $a2b5e1bc1ee659e3$var$customTargetStyles : $a2b5e1bc1ee659e3$var$customTargetStylesOld,
        ref: ref
    });
});
const $a2b5e1bc1ee659e3$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $a2b5e1bc1ee659e3$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("gxf3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $a20e797b9b3d1228$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7be4c4e943900dfca31bc10ad8f1ef7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a20e797b9b3d1228$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "UrlCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        }
    ],
    "type": "JiraUrlField"
};
$a20e797b9b3d1228$var$node.hash = "a091578da8f9acb46861f2691520469b";
var $a20e797b9b3d1228$export$2e2bcd8739ae039 = $a20e797b9b3d1228$var$node;

});

parcelRegister("57mJt", function(module, exports) {
$parcel$export(module.exports, "UrlInlineEditViewIsEditable", () => $d5b0aa8cf071a4d2$export$b805891365234836);
$parcel$export(module.exports, "UrlInlineEditView", () => $d5b0aa8cf071a4d2$export$9c96a1eab7a0bc87);

var $aMl5R = parcelRequire("aMl5R");

var $2bvy9 = parcelRequire("2bvy9");

var $5xql6 = parcelRequire("5xql6");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $auNLL = parcelRequire("auNLL");

var $77rtG = parcelRequire("77rtG");

var $1yqND = parcelRequire("1yqND");

var $bJscI = parcelRequire("bJscI");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $4EKqI = parcelRequire("4EKqI");

var $6GBsJ = parcelRequire("6GBsJ");

var $entKp = parcelRequire("entKp");
const $d5b0aa8cf071a4d2$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-url-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $d5b0aa8cf071a4d2$export$b805891365234836 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, spacing: spacing = 'compact', readViewFitContainerHeight: readViewFitContainerHeight, isEditable: isEditable, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, onSubmit: onSubmit, onSubmitSucceeded: onSubmitSucceeded, onSubmitFailed: onSubmitFailed, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $5xql6.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $2bvy9.default));
    const { id: uniqueFieldId, name: name, fieldId: fieldId, type: fieldType } = data;
    // #endregion Relay
    // #region State
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const uri = data.uri ?? '';
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(uri);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    // #endregion State
    // #region Action
    const handleSubmit = (0, $eJOHy.useCallback)((value, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(value);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operation: {
                        operation: 'SET',
                        uri: value
                    }
                }
            },
            onCompleted: (response)=>{
                if (response.jira?.updateUrlField?.success) onSuccess();
                else onFail();
            },
            onError: (error)=>{
                onFail(error, error.message);
            },
            optimisticResponse: {
                jira: {
                    updateUrlField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            fieldId: fieldId,
                            type: fieldType,
                            name: name,
                            uri: value
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldType,
        name,
        onSubmit,
        uniqueFieldId
    ]);
    const validator = (0, $eJOHy.useMemo)(()=>{
        const change = (value)=>{
            if (!(0, $entKp.isAllowed)(value)) return {
                type: 'error',
                message: formatMessage((0, $6GBsJ.default).validUrl)
            };
            return null;
        };
        return {
            change: change
        };
    }, [
        formatMessage
    ]);
    const actions = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: uri,
        updatedValue: updatedValue,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        validator: validator,
        clipboardComponentType: 'url'
    });
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, invalidMessage: invalidMessage, isEditing: isEditing } = actions;
    const onChange = (0, $eJOHy.useCallback)(({ target: target })=>{
        handleChange(target.value);
    }, [
        handleChange
    ]);
    // #endregion Action
    // #region View
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1yqND.UrlReadView), {
            fragmentRef: data,
            isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled,
            shouldRenderHoverPopover: shouldRenderHoverPopover
        })), [
        data,
        isSimpleInlineSmartLinkEnabled,
        shouldRenderHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            value: updatedValue,
            spacing: spacing,
            onChange: onChange,
            type: 'url',
            isInvalid: Boolean(invalidMessage),
            ariaLabel: fieldName
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupWidth: editViewPopupWidth,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $77rtG.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView
    });
};
const $d5b0aa8cf071a4d2$export$9c96a1eab7a0bc87 = ({ fragmentRef: fragmentRef, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $aMl5R.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5b0aa8cf071a4d2$export$b805891365234836, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("aMl5R", function(module, exports) {
$parcel$export(module.exports, "default", () => $c41258146ba196b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37b313f79c6a03c4fa93aaac275bdf29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c41258146ba196b6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraUrlField"
};
$c41258146ba196b6$var$node.hash = "5aed5e7bdc192a64e4e820aace0e3608";
var $c41258146ba196b6$export$2e2bcd8739ae039 = $c41258146ba196b6$var$node;

});

parcelRegister("2bvy9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dcc9349bce2e9d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<413ccd688c8790d22dc7a1baf17763da>>
 * @relayHash 9cf7383e10e7a7f292242fc29022a01d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 448dd3bf9d4c082dc9e838d4055dc8989cf72c0256f51f4b2e10c0d31d8253b6
const $0dcc9349bce2e9d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUrlFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateUrlField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraUrlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "448dd3bf9d4c082dc9e838d4055dc8989cf72c0256f51f4b2e10c0d31d8253b6",
            "metadata": {},
            "name": "url_issueFieldUrl_UrlField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0dcc9349bce2e9d4$var$node.hash = "60222c1fb24270ee0c27b8d3bfc763a4";
var $0dcc9349bce2e9d4$export$2e2bcd8739ae039 = $0dcc9349bce2e9d4$var$node;

});

parcelRegister("5xql6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3c02e703621646$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63b14e199759744cdf583eb0c109846a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2f3c02e703621646$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        },
        {
            "kind": "FragmentSpread",
            "name": "url_issueFieldUrlReadviewFull_UrlReadView"
        }
    ],
    "type": "JiraUrlField"
};
$2f3c02e703621646$var$node.hash = "f560c76a2ba024cc2bd7b741c47d14d9";
var $2f3c02e703621646$export$2e2bcd8739ae039 = $2f3c02e703621646$var$node;

});

parcelRegister("1yqND", function(module, exports) {
$parcel$export(module.exports, "UrlReadView", () => $d24b7315cb4e95ba$export$7e9a6aefd9dafa88);

var $g95Vy = parcelRequire("g95Vy");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $d9T1A = parcelRequire("d9T1A");

var $8CGjN = parcelRequire("8CGjN");

var $gg9AF = parcelRequire("gg9AF");

var $3PRLs = parcelRequire("3PRLs");

var $3OT15 = parcelRequire("3OT15");

var $3Lkm9 = parcelRequire("3Lkm9");

var $k6Nau = parcelRequire("k6Nau");

var $8fZi6 = parcelRequire("8fZi6");
// eslint-disable-next-line no-script-url
const $d24b7315cb4e95ba$var$forbiddenScheme = 'javascript:';
const $d24b7315cb4e95ba$export$7e9a6aefd9dafa88 = ({ fragmentRef: fragmentRef, isSimpleInlineSmartLinkEnabled: isSimpleInlineSmartLinkEnabled, shouldRenderHoverPopover: shouldRenderHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $g95Vy.default), fragmentRef);
    const { uri: value } = data;
    const [isUrlErrorState, setIsUrlErrorState] = (0, $eJOHy.useState)(false);
    const contentRef = (0, $eJOHy.useRef)(null);
    const hoverPopoverRefFactory = shouldRenderHoverPopover ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $3OT15.useHoverPopoverContentRef)(data.id) : null;
    let hoverPopoverRef = null;
    if (hoverPopoverRefFactory) hoverPopoverRef = hoverPopoverRefFactory({
        content: value
    });
    const handleSmartLinkError = ()=>{
        setIsUrlErrorState(true);
    };
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (value == null || value === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenUrlPlaceholderEmptyFieldText
    });
    if (isSimpleInlineSmartLinkEnabled) {
        if (value.startsWith($d24b7315cb4e95ba$var$forbiddenScheme)) {
            if (shouldRenderHoverPopover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                maxLines: 1,
                ref: hoverPopoverRef
            }, value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $d24b7315cb4e95ba$var$truncatedStyles,
                ref: contentRef
            }, value);
        }
        let renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: (0, $gg9AF.default)(value, '//'),
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if ((0, $8CGjN.default)(value)) renderContent = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PRLs.SimpleInlineSmartLink), {
                anchorTarget: "_blank",
                url: `mailto:${value}`,
                text: value,
                anchorRef: ref,
                onError: shouldRenderHoverPopover ? handleSmartLinkError : undefined
            });
        if (shouldRenderHoverPopover && isUrlErrorState) return renderContent(hoverPopoverRef);
        return renderContent(undefined);
    }
    const lDisplayValue = (0, $8fZi6.formatReadValue)(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d24b7315cb4e95ba$var$Ellipsis, {
        title: value
    }, lDisplayValue);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d24b7315cb4e95ba$var$Ellipsis = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $d24b7315cb4e95ba$var$truncatedStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("g95Vy", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee2dc4b6c6c15dfc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92147b16395451d8bfecdd9df74b8c13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee2dc4b6c6c15dfc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "url_issueFieldUrlReadviewFull_UrlReadView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "uri"
        }
    ],
    "type": "JiraUrlField"
};
$ee2dc4b6c6c15dfc$var$node.hash = "6f1b369836bf61ff873cf37f18025e6a";
var $ee2dc4b6c6c15dfc$export$2e2bcd8739ae039 = $ee2dc4b6c6c15dfc$var$node;

});

parcelRegister("8CGjN", function(module, exports) {
$parcel$export(module.exports, "default", () => $1859a6867727826b$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1859a6867727826b$var$isValidEmailAddress = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};
var $1859a6867727826b$export$2e2bcd8739ae039 = $1859a6867727826b$var$isValidEmailAddress;

});

parcelRegister("gg9AF", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa271c6a6316ebe8$export$2e2bcd8739ae039);

var $eNS8S = parcelRequire("eNS8S");
/**
 * Absolute URL regex
 */ const $fa271c6a6316ebe8$var$AbsoluteURLRegex = new RegExp(/^[a-z][a-z\d+.-]*:/);
/**
 * Prefix url if it is url, return what we got if not
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fa271c6a6316ebe8$var$prefixUrl = (string, prefix)=>{
    // The same line is in isUrl, but flow requires it here too
    if (typeof string !== 'string' || !prefix) return string;
    // Exit early
    if (!(0, $eNS8S.default)(string)) return string;
    // Double slash urls are absolute too, relative to the schema used in current window
    if (string.substring(0, 2) === '//') return string;
    // If it's an absolute URL, return it, no need to prefix
    if ($fa271c6a6316ebe8$var$AbsoluteURLRegex.test(string)) return string;
    // If it's a relative URL, prefix it with prefix
    return prefix + string;
};
var $fa271c6a6316ebe8$export$2e2bcd8739ae039 = $fa271c6a6316ebe8$var$prefixUrl;

});

parcelRegister("8fZi6", function(module, exports) {
$parcel$export(module.exports, "formatReadValue", () => $b989a4aaa09f3a35$export$7ff86f9bff10df25);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $4cTDP = parcelRequire("4cTDP");

var $8CGjN = parcelRequire("8CGjN");

var $gg9AF = parcelRequire("gg9AF");

var $cxKOj = parcelRequire("cxKOj");

var $ix81O = parcelRequire("ix81O");
// eslint-disable-next-line no-script-url
const $b989a4aaa09f3a35$var$forbiddenScheme = 'javascript:';
const $b989a4aaa09f3a35$export$7ff86f9bff10df25 = (value)=>{
    if (value.toString().startsWith($b989a4aaa09f3a35$var$forbiddenScheme)) return value;
    if ((0, $8CGjN.default)(value)) {
        if ((0, $cxKOj.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix81O.LazySingleLineSmartLink), {
            anchorTarget: "_blank",
            url: `mailto:${value}`,
            text: value,
            fieldType: "url"
        });
        return (0, $4cTDP.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: `mailto:${value}`
        }, value) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: `mailto:${value}`
        }, value);
    }
    if ((0, $cxKOj.expValEquals)('jsw_perf_format-links-in-custom-fields', 'issue-view', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix81O.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: (0, $gg9AF.default)(value, '//'),
        fieldType: "url"
    });
    return (0, $4cTDP.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: (0, $gg9AF.default)(value, '//'),
        target: "_blank"
    }, value) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: (0, $gg9AF.default)(value, '//'),
        target: "_blank"
    }, value);
};

});
parcelRegister("ix81O", function(module, exports) {
$parcel$export(module.exports, "LazySingleLineSmartLink", () => $77b5c4612dd0593c$export$80092fcb07ccc4b4);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $8kVp5 = parcelRequire("8kVp5");
const $77b5c4612dd0593c$var$entryPointParams = {};
const $77b5c4612dd0593c$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $8kVp5.SingleLineSmartLinkEntryPoint), $77b5c4612dd0593c$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("8kVp5", function(module, exports) {
$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $9db257858ff44ec9$export$e236c9b35543c8d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9db257858ff44ec9$export$e236c9b35543c8d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4roVB")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4roVB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("lxHfr")
]).then(()=>parcelRequire('cNXTd'));

});





parcelRegister("6GBsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $479b929ad3b0e6bc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $479b929ad3b0e6bc$var$messages = (0, $7qGN1.defineMessages)({
    validUrl: {
        "id": "issue-field-url-inline-edit-full.url.valid-url",
        "defaultMessage": "Please enter a valid URL."
    }
});
var $479b929ad3b0e6bc$export$2e2bcd8739ae039 = $479b929ad3b0e6bc$var$messages;

});

parcelRegister("entKp", function(module, exports) {
$parcel$export(module.exports, "isAllowed", () => $ba8c953f4fc4bb00$export$f023ae853add2e3e);

var $eNS8S = parcelRequire("eNS8S");
const $ba8c953f4fc4bb00$export$5c13dfcb31dfce7a = 'javascript:';
const $ba8c953f4fc4bb00$export$f023ae853add2e3e = (value)=>{
    if (value === '' || value === null) return true;
    if ((0, $eNS8S.default)(value)) return true;
    if (!value.startsWith($ba8c953f4fc4bb00$export$5c13dfcb31dfce7a)) return true;
    return false;
};

});



parcelRegister("81JsW", function(module, exports) {
$parcel$export(module.exports, "MultiVersionPickerCell", () => $bc7b294e5d9897f8$export$5ca120a08ed26914);

var $ka5rk = parcelRequire("ka5rk");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $MUcBt = parcelRequire("MUcBt");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $bc7b294e5d9897f8$export$5ca120a08ed26914 = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $ka5rk.default), fieldRef);
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data && isInlineEditingExtendedFieldSupportEnabled ? data.lazyIsEditableInIssueView : false;
    (0, $eqbO4.useLazyLoadEditability)(data.id, isEditable);
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MUcBt.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $bc7b294e5d9897f8$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MUcBt.MultiVersionPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $bc7b294e5d9897f8$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $bc7b294e5d9897f8$var$customTargetStyles : $bc7b294e5d9897f8$var$customTargetStylesOld,
        ref: ref
    });
});
const $bc7b294e5d9897f8$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $bc7b294e5d9897f8$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("ka5rk", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a033af7f7590744$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e8e2603676f5c65049348206c684002>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8a033af7f7590744$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiVersionPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$8a033af7f7590744$var$node.hash = "57df00bf3570b866d064b3658b63c53f";
var $8a033af7f7590744$export$2e2bcd8739ae039 = $8a033af7f7590744$var$node;

});

parcelRegister("MUcBt", function(module, exports) {
$parcel$export(module.exports, "MultiVersionPickerInlineEditViewWithIsEditable", () => $1d553014db36a9f7$export$f431495591c5e674);
$parcel$export(module.exports, "MultiVersionPickerInlineEditView", () => $1d553014db36a9f7$export$39b0857e7fc9fc58);

var $8wM8I = parcelRequire("8wM8I");

var $40YZ2 = parcelRequire("40YZ2");

var $90IpJ = parcelRequire("90IpJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $dzwt3 = parcelRequire("dzwt3");

var $lI4O9 = parcelRequire("lI4O9");

var $auNLL = parcelRequire("auNLL");

var $bJscI = parcelRequire("bJscI");
const $1d553014db36a9f7$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-version-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $1d553014db36a9f7$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.value));
    return b.every((option)=>aIdSet.has(option.value));
};
const $1d553014db36a9f7$export$f431495591c5e674 = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, spacing: spacing = 'compact', isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $90IpJ.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $40YZ2.default));
    const { id: uniqueFieldId, name: name, selectedVersionsConnection: selectedOptions, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedOptions?.edges) return null;
        return selectedOptions.edges.map((edge)=>({
                id: edge?.node?.value ?? '',
                optionId: edge?.node?.versionId ?? '',
                value: edge?.node?.label ?? '',
                selectableLabel: edge?.node?.label ?? '',
                selectableGroupKey: null,
                selectableIconUrl: null
            }));
    }, [
        selectedOptions?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleVersionPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleVersionPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedVersionsConnection: {
                                edges: values?.map((edge)=>({
                                        node: {
                                            id: edge.id ?? '',
                                            name: edge.selectableLabel ?? '',
                                            label: edge.selectableLabel ?? '',
                                            value: edge.id ?? '',
                                            versionId: edge.optionId ?? ''
                                        }
                                    })) ?? []
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste, handleConfirm: handleConfirm, handleChange: handleChange } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $1d553014db36a9f7$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiVersionSelect'
    });
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d553014db36a9f7$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lI4O9.MultiVersionPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            fieldName: fieldName,
            value: updatedValue,
            menuPosition: menuPosition,
            menuPortalTarget: menuPortalTarget,
            onChange: handleChange,
            spacing: spacing
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $dzwt3.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $1d553014db36a9f7$export$39b0857e7fc9fc58 = ({ fragmentRef: fragmentRef, ...props })=>{
    /**
   * This fragment should spread the inner InlineEditViewWithIsEditable fragment and read the isEditable flag from the
   * fieldConfig.
   */ const data = (0, $j4oe4.useFragment)((0, $8wM8I.default), fragmentRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d553014db36a9f7$export$f431495591c5e674, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("8wM8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b0d5bfb68c5a165$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bc41e79d78b8f6ab7ab8377a87047ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b0d5bfb68c5a165$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$8b0d5bfb68c5a165$var$node.hash = "f3cd0ae179a2d6df739a19203f713cf5";
var $8b0d5bfb68c5a165$export$2e2bcd8739ae039 = $8b0d5bfb68c5a165$var$node;

});

parcelRegister("40YZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f165013c1955f2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8342c4e836b7ec8b7c2b0ddfa6134252>>
 * @relayHash d19489d06d268f2aa2afd983864117f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007
const $0f165013c1955f2d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleVersionPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleVersionPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleVersionPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "alias": "value",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "alias": "label",
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "versionId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "221728ae5b3c6aa07ca8d90d92a49ae0c66a238ebcf155f78b4ee1fc1d21e007",
            "metadata": {},
            "name": "multiVersionPicker_issueFieldMultiVersionPicker_MultiVersionPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0f165013c1955f2d$var$node.hash = "c18481704920c57572e95641cfc0676b";
var $0f165013c1955f2d$export$2e2bcd8739ae039 = $0f165013c1955f2d$var$node;

});

parcelRegister("90IpJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $014b7e1963761a50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64112bc4a30b3469275bdfcb6eadd44c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $014b7e1963761a50$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerInlineEditFull_MultiVersionPickerInlineEditViewWithIsEditable_fragmentRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "FragmentSpread",
            "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "value",
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "alias": "label",
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$014b7e1963761a50$var$node.hash = "f3af5be7640f993ae73c44b61cc0fcb5";
var $014b7e1963761a50$export$2e2bcd8739ae039 = $014b7e1963761a50$var$node;

});

parcelRegister("dzwt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d87a6dba00e0e973$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d87a6dba00e0e973$var$MultiVersionPickerEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3mp2i")), {
        moduleId: "e516a23c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $d87a6dba00e0e973$export$2e2bcd8739ae039 = $d87a6dba00e0e973$var$MultiVersionPickerEditViewEntryPoint;

});
parcelRegister("3mp2i", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ppIg").then(()=>parcelRequire('83cMO'));

});


parcelRegister("lI4O9", function(module, exports) {
$parcel$export(module.exports, "MultiVersionPickerReadView", () => $d8943f78bceb81f0$export$555d899a217b3354);

var $cZu1Q = parcelRequire("cZu1Q");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ewOxf = parcelRequire("ewOxf");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $2j0d2 = parcelRequire("2j0d2");

var $1tX0c = parcelRequire("1tX0c");

var $1z178 = parcelRequire("1z178");
const $d8943f78bceb81f0$export$555d899a217b3354 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const data = (0, $j4oe4.useFragment)((0, $cZu1Q.default), fragmentRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const selectedOptions = data?.selectedVersionsConnection?.edges?.filter((edge)=>Boolean(edge?.node?.name)).map((edge)=>({
            name: edge?.node?.name || '',
            key: edge?.node?.id || ''
        })) || [];
    if (!selectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        xcss: isTruncatedWithHoverPopover && $d8943f78bceb81f0$var$containerWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: selectedOptions,
        ItemComponent: (0, $1tX0c.TagItem),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $1z178.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d8943f78bceb81f0$var$containerWithNegativeMarginOffset
    }, selectedOptions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            key: item.key,
            text: item.name
        })));
};
const $d8943f78bceb81f0$var$containerWithNegativeMarginOffset = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    // Tag has a built-in margin of 4px, so we use a negative side margin to allow tags to align with their parent.
    marginTop: 'space.0',
    marginRight: 'space.negative.050',
    marginBottom: 'space.0',
    marginLeft: 'space.negative.050'
});
const $d8943f78bceb81f0$var$containerWidthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("cZu1Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $22dfda99a3914cb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c210e8b6e67913f30c2d1a9eedbd636>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22dfda99a3914cb7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "selectedVersionsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "selectedVersionsConnection(first:1000)"
        }
    ],
    "type": "JiraMultipleVersionPickerField"
};
$22dfda99a3914cb7$var$node.hash = "7940aec048cb5cd7c9f0feb1ad306f48";
var $22dfda99a3914cb7$export$2e2bcd8739ae039 = $22dfda99a3914cb7$var$node;

});

parcelRegister("1z178", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d340ee67f462666$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0d340ee67f462666$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-version-picker-readview-full.multi-version-picker.truncated.show-more-tooltip",
        "defaultMessage": "See more items"
    }
});
var $0d340ee67f462666$export$2e2bcd8739ae039 = $0d340ee67f462666$var$messages;

});




parcelRegister("100iH", function(module, exports) {
$parcel$export(module.exports, "MultiGroupPickerCell", () => $7d58a69deed2c53f$export$73d843f1843865aa);

var $gblCl = parcelRequire("gblCl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $20P47 = parcelRequire("20P47");

var $4cTDP = parcelRequire("4cTDP");

var $4vHFI = parcelRequire("4vHFI");

var $eqbO4 = parcelRequire("eqbO4");

var $34oCh = parcelRequire("34oCh");

var $8jOO7 = parcelRequire("8jOO7");
const $7d58a69deed2c53f$export$73d843f1843865aa = ({ fieldRef: fieldRef, isFirstField: isFirstField, hasDuplicates: hasDuplicates })=>{
    const data = (0, $j4oe4.useFragment)((0, $gblCl.default), fieldRef);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    // If the property does not exist in fragment data then we know it has been conditionally excluded because inline
    // editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
    const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
    const fieldId = typeof data.id === 'string' ? data.id : '';
    (0, $eqbO4.useLazyLoadEditability)(fieldId, isEditable);
    // In edit mode, use the MultiGroupPickerEditView
    if (hasDuplicates && isSingleLineRowHeightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20P47.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "start",
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        editViewPopupTarget: isFirstField ? $7d58a69deed2c53f$var$CustomTarget : undefined,
        editViewPopupWidth: (0, $8jOO7.DUPLICATE_FIELD_EDIT_WIDTH),
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: isFirstField ? 'fixed' : 'absolute',
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isFirstField && isSingleLineRowHeightEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20P47.MultiGroupPickerInlineEditViewWithIsEditable), {
        attributes: (0, $4vHFI.INLINE_EDIT_ANALYTICS_ATTRIBUTES),
        spacing: "default",
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        fragmentRef: data,
        isEditable: isEditable ?? false,
        menuPosition: "fixed",
        readViewFitContainerHeight: true,
        isTruncated: true,
        isTruncatedWithHoverPopover: isSingleLineRowHeightEnabled
    });
};
const $7d58a69deed2c53f$var$CustomTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $4cTDP.fg)('nin_issue_table_rtl_fix') ? $7d58a69deed2c53f$var$customTargetStyles : $7d58a69deed2c53f$var$customTargetStylesOld,
        ref: ref
    });
});
const $7d58a69deed2c53f$var$customTargetStylesOld = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: 'space.0'
});
const $7d58a69deed2c53f$var$customTargetStyles = (0, $1DXK0.xcss)({
    width: 'space.0',
    position: 'absolute',
    insetBlockStart: 'space.0'
});

});
parcelRegister("gblCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4dcd61bf59b6768$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d027801fa5d2267ebebe5770bf4e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4dcd61bf59b6768$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "MultiGroupPickerCell",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$f4dcd61bf59b6768$var$node.hash = "af5d3f55e3c502f94bcda205556783dd";
var $f4dcd61bf59b6768$export$2e2bcd8739ae039 = $f4dcd61bf59b6768$var$node;

});

parcelRegister("20P47", function(module, exports) {
$parcel$export(module.exports, "MultiGroupPickerInlineEditViewWithIsEditable", () => $41255fd266381b8b$export$7acb84464848fc0e);

var $1mWD4 = parcelRequire("1mWD4");

var $5MpJH = parcelRequire("5MpJH");

var $fkKi0 = parcelRequire("fkKi0");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $4s7iN = parcelRequire("4s7iN");

var $99gun = parcelRequire("99gun");

var $auNLL = parcelRequire("auNLL");

var $g9mk1 = parcelRequire("g9mk1");

var $jW4Yt = parcelRequire("jW4Yt");
/** Determine if the updated edit view value is equal to our original value before submitting a mutation. */ const $41255fd266381b8b$var$isEqualOption = (a, b)=>{
    if (a === null || b === null) return a === b;
    if (a.length !== b.length) return false;
    const aIdSet = new Set(a.map((option)=>option.id));
    return b.every((option)=>aIdSet.has(option.id));
};
const $41255fd266381b8b$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-field-multi-group-picker-read-view",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $41255fd266381b8b$export$7acb84464848fc0e = ({ attributes: attributes, editViewPopup: editViewPopup, editViewPopupAlignBlock: editViewPopupAlignBlock, editViewPopupTarget: editViewPopupTarget, editViewPopupWidth: editViewPopupWidth, fragmentRef: fragmentRef, isEditable: isEditable, isEditing: startWithEditViewOpen = false, isTruncated: isTruncated, menuPosition: menuPosition, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onSubmitSucceeded: onSubmitSucceeded, readViewFitContainerHeight: readViewFitContainerHeight, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $fkKi0.default), fragmentRef);
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $5MpJH.default));
    // #endregion Relay
    // #region Common state
    const { id: uniqueFieldId, name: name, selectedGroupsConnection: selectedGroupsConnection, fieldId: fieldId, type: fieldType } = data;
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        if (!selectedGroupsConnection?.edges) return null;
        return selectedGroupsConnection.edges.map((edge)=>({
                id: edge?.node?.id ?? '',
                groupId: edge?.node?.groupId ?? '',
                name: edge?.node?.name ?? '',
                type: 'group'
            }));
    }, [
        selectedGroupsConnection?.edges
    ]);
    const [updatedValue, setUpdatedValue] = (0, $eJOHy.useState)(initialValue);
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const { overrideLabel: overrideLabel, overrideIsEditable: overrideIsEditable, overrideFieldOptionsFilter: overrideFieldOptionsFilter } = overriding;
    const fieldName = (0, $eJOHy.useMemo)(()=>overrideLabel(name), [
        overrideLabel,
        name
    ]);
    const isFieldEditable = (0, $eJOHy.useMemo)(()=>overrideIsEditable(isEditable), [
        overrideIsEditable,
        isEditable
    ]);
    const filterOptionsById = (0, $eJOHy.useMemo)(()=>overrideFieldOptionsFilter(null), [
        overrideFieldOptionsFilter
    ]);
    // #endregion Common state
    // #region Actions
    const handleSubmit = (0, $eJOHy.useCallback)((values, { onSuccess: onSuccess, onFail: onFail })=>{
        onSubmit?.(values);
        commit({
            variables: {
                input: {
                    id: uniqueFieldId,
                    operations: [
                        {
                            operation: 'SET',
                            ids: values?.map((selection)=>selection.id) ?? []
                        }
                    ]
                }
            },
            onCompleted (response) {
                if (response.jira?.updateMultipleGroupPickerField?.success) onSuccess();
                else onFail();
            },
            onError (error) {
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateMultipleGroupPickerField: {
                        success: true,
                        errors: null,
                        field: {
                            id: uniqueFieldId,
                            name: fieldName,
                            fieldId: fieldId,
                            type: fieldType,
                            selectedGroupsConnection: {
                                edges: values?.map((selection)=>({
                                        node: {
                                            id: selection.id,
                                            groupId: selection.groupId ?? '',
                                            name: selection.name
                                        }
                                    }))
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        fieldId,
        fieldName,
        fieldType,
        onSubmit,
        uniqueFieldId
    ]);
    const { invalidMessage: invalidMessage, isEditing: isEditing, hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleEdit: handleEdit, handleConfirm: handleConfirm, handleChange: handleChange, handleCopy: handleCopy, handleCut: handleCut, handlePaste: handlePaste } = (0, $4s7iN.useFieldInlineEditActions)({
        attributes: attributes,
        fieldId: fieldId,
        fieldName: fieldName,
        fieldType: fieldType,
        initialValue: initialValue,
        isValueEqual: $41255fd266381b8b$var$isEqualOption,
        onSubmit: handleSubmit,
        onSubmitFailed: onSubmitFailed,
        onSubmitSucceeded: onSubmitSucceeded,
        onUpdateValue: setUpdatedValue,
        startWithEditViewOpen: startWithEditViewOpen,
        updatedValue: updatedValue,
        clipboardComponentType: 'multiGroupPicker'
    });
    // #endregion Actions
    // #region Read view
    const renderReadView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41255fd266381b8b$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jW4Yt.MultiGroupPickerReadView), {
            fragmentRef: data,
            isTruncated: isTruncated,
            isTruncatedWithHoverPopover: isTruncatedWithHoverPopover
        })), [
        data,
        isTruncated,
        isTruncatedWithHoverPopover
    ]);
    // #endregion
    // #region Edit view
    const getEditViewProps = (fieldProps)=>({
            ...fieldProps,
            autoFocus: true,
            fieldId: uniqueFieldId,
            value: updatedValue,
            menuPosition: menuPosition,
            onChange: handleChange,
            filterOptionsById: filterOptionsById,
            isMulti: true
        });
    // #endregion Edit view
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: editViewPopup,
        editViewPopupAlignBlock: editViewPopupAlignBlock,
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $g9mk1.default),
        editViewPopupTarget: editViewPopupTarget,
        editViewPopupWidth: editViewPopupWidth,
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: fieldName,
        hasUnsubmittedChanges: hasServerValidationError,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        isEditable: isFieldEditable,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        onEdit: handleEdit,
        onCopy: handleCopy,
        onCut: handleCut,
        onPaste: handlePaste,
        readViewFitContainerHeight: readViewFitContainerHeight,
        readView: renderReadView,
        hideActionButtons: true,
        hasReadViewTruncateDisabled: isTruncatedWithHoverPopover
    });
};
const $41255fd266381b8b$export$4caaf52d4af1250c = ({ fragmentRef: fragmentRef, ...props })=>{
    // #region Relay
    const data = (0, $j4oe4.useFragment)((0, $1mWD4.default), fragmentRef);
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41255fd266381b8b$export$7acb84464848fc0e, {
        ...props,
        fragmentRef: data,
        isEditable: data.fieldConfig?.isEditable ?? false
    });
};

});
parcelRegister("1mWD4", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c78f0df18697b45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5623bc30488e88f1d3982f57e69c5eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8c78f0df18697b45$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditView_fragmentRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
        },
        {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$8c78f0df18697b45$var$node.hash = "2b6dc2f7fb34ef75b6db441fb9ae7810";
var $8c78f0df18697b45$export$2e2bcd8739ae039 = $8c78f0df18697b45$var$node;

});

parcelRegister("5MpJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $146fd6e8d16c8b52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02595abe4be4750a238e67d255544203>>
 * @relayHash cf7363cfea249c0b2da1cf11c7c42d39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540
const $146fd6e8d16c8b52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraMultipleGroupPickerFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateMultipleGroupPickerField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraMultipleGroupPickerField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGroupsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "groupId"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540",
            "metadata": {},
            "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$146fd6e8d16c8b52$var$node.hash = "23b63517ce9fe10047fcdf0eced5f652";
var $146fd6e8d16c8b52$export$2e2bcd8739ae039 = $146fd6e8d16c8b52$var$node;

});

parcelRegister("fkKi0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e0d416752510825$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ab669355cea1b866d173b253a3cfa88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e0d416752510825$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView"
            },
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "groupId"
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleGroupPickerField"
    };
}();
$6e0d416752510825$var$node.hash = "8432d03e246ec4da1c38b93c6858f003";
var $6e0d416752510825$export$2e2bcd8739ae039 = $6e0d416752510825$var$node;

});

parcelRegister("g9mk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d7b6bc74037ca57$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4d7b6bc74037ca57$var$MultiSelectEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("g8Kt0")), {
        moduleId: "5031be7a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $4d7b6bc74037ca57$export$2e2bcd8739ae039 = $4d7b6bc74037ca57$var$MultiSelectEditViewEntryPoint;

});
parcelRegister("g8Kt0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("rFPjj").then(()=>parcelRequire('juA5l'));

});


parcelRegister("jW4Yt", function(module, exports) {
$parcel$export(module.exports, "MultiGroupPickerReadView", () => $f48eaf993afb193e$export$247ad3b7069fda16);

var $bnjRi = parcelRequire("bnjRi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $d9T1A = parcelRequire("d9T1A");

var $3Lkm9 = parcelRequire("3Lkm9");

var $kp5kj = parcelRequire("kp5kj");

var $1tX0c = parcelRequire("1tX0c");

var $2j0d2 = parcelRequire("2j0d2");

var $k6Nau = parcelRequire("k6Nau");

var $9HfjG = parcelRequire("9HfjG");
const $f48eaf993afb193e$export$247ad3b7069fda16 = ({ fragmentRef: fragmentRef, isTruncated: isTruncated, isTruncatedWithHoverPopover: isTruncatedWithHoverPopover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $bnjRi.default), fragmentRef);
    const transformedSelectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!data?.selectedGroupsConnection?.edges) return null;
        const selectedOptions = data.selectedGroupsConnection.edges.map((edge)=>edge?.node).filter((node)=>!!node);
        return selectedOptions.map((node)=>({
                key: node.id,
                name: node.name,
                color: null,
                isInteractive: false
            }));
    }, [
        data?.selectedGroupsConnection?.edges
    ]);
    const isBespokeEmptyFieldTextGA = (0, $k6Nau.useBespokeEmptyFieldTextGA)();
    if (!transformedSelectedOptions?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), isBespokeEmptyFieldTextGA && {
        placeholderText: (0, $3Lkm9.default).bespokenMultiGroupPickerPlaceholderEmptyFieldText
    });
    if (isTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        xcss: isTruncatedWithHoverPopover && $f48eaf993afb193e$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j0d2.default), {
        items: transformedSelectedOptions,
        ItemComponent: isTruncatedWithHoverPopover ? (0, $1tX0c.TagItem) : (0, $kp5kj.OptionTag),
        PopupContentWrapper: (0, $1tX0c.TagItemPopupContentWrapper),
        showMoreTooltip: formatMessage((0, $9HfjG.default).showMoreTooltip),
        isHoverPopoverEnabled: isTruncatedWithHoverPopover
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        role: "group",
        shouldWrap: true
    }, transformedSelectedOptions.map(({ key: key, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            key: key,
            ...restProps
        })));
};
const $f48eaf993afb193e$var$inlineStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("bnjRi", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aea312b73b1a9b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e4a0b4f914cbdbb0312a353542384d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5aea312b73b1a9b9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView",
    "selections": [
        {
            "concreteType": "JiraGroupConnection",
            "kind": "LinkedField",
            "name": "selectedGroupsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraMultipleGroupPickerField"
};
$5aea312b73b1a9b9$var$node.hash = "e7a12645b4d832047ab02c9f7b91d410";
var $5aea312b73b1a9b9$export$2e2bcd8739ae039 = $5aea312b73b1a9b9$var$node;

});

parcelRegister("9HfjG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b04cc2321b0b85f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0b04cc2321b0b85f$var$messages = (0, $7qGN1.defineMessages)({
    showMoreTooltip: {
        "id": "issue-field-multi-group-picker-readview-full.multi-group-picker.compact.show-more-tooltip",
        "defaultMessage": "See more selected options"
    }
});
var $0b04cc2321b0b85f$export$2e2bcd8739ae039 = $0b04cc2321b0b85f$var$messages;

});




parcelRegister("01wyE", function(module, exports) {
$parcel$export(module.exports, "TimelineCellRenderer", () => $809beec470e16000$export$ad6d59b978eafde7);

var $e0WGW = parcelRequire("e0WGW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9r0oq = parcelRequire("9r0oq");
const $809beec470e16000$export$ad6d59b978eafde7 = ({ depth: depth, groupId: groupId, fieldRef: fieldRef })=>{
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const data = (0, $j4oe4.useFragment)((0, $e0WGW.default), fieldRef);
    return timelineCustomComponents?.Cell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.Cell, {
        depth: depth,
        groupId: groupId,
        fieldRef: data
    });
};

});
parcelRegister("e0WGW", function(module, exports) {
$parcel$export(module.exports, "default", () => $91965cd6172da765$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd61021e972c8bad9a6a1b78c1e184bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $91965cd6172da765$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "TimelineCellRenderer",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TimelineCell"
                }
            ]
        }
    ],
    "type": "JiraIssueField",
    "abstractKey": "__isJiraIssueField"
};
$91965cd6172da765$var$node.hash = "6ad56faa45034ffc35668f1612648f21";
var $91965cd6172da765$export$2e2bcd8739ae039 = $91965cd6172da765$var$node;

});


parcelRegister("9FoLd", function(module, exports) {
$parcel$export(module.exports, "WatchersCell", () => $53e330b40da2f7af$export$1e71e15ea9d46d5d);

var $axvYJ = parcelRequire("axvYJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8IeH1 = parcelRequire("8IeH1");
const $53e330b40da2f7af$var$styles = {
    watchesCell: "_1reo15vq _18m915vq _1rjc1b66 _p12f1osq _1bto1l2s"
};
const $53e330b40da2f7af$export$1e71e15ea9d46d5d = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $axvYJ.default), fieldRef);
    const countValue = (0, $eJOHy.useMemo)(()=>{
        return data?.watch?.count;
    }, [
        data?.watch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $53e330b40da2f7af$var$styles.watchesCell
    }, countValue);
});

});
parcelRegister("axvYJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9f441ffa5970a36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5101f8bb18a86a59b2e9be60de468eac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a9f441ffa5970a36$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "WatchersCell",
    "selections": [
        {
            "concreteType": "JiraWatch",
            "kind": "LinkedField",
            "name": "watch",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "isWatching"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "JiraWatchesField"
};
$a9f441ffa5970a36$var$node.hash = "4d470f783113ad6813aa2ebd466222c4";
var $a9f441ffa5970a36$export$2e2bcd8739ae039 = $a9f441ffa5970a36$var$node;

});


parcelRegister("ajiOP", function(module, exports) {
$parcel$export(module.exports, "LinkRelationshipTypeCell", () => $236b5c948089bc7e$export$d9d4a0e66ee82c3f);

var $uPZw1 = parcelRequire("uPZw1");

var $cSemv = parcelRequire("cSemv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5WzNk = parcelRequire("5WzNk");

var $auNLL = parcelRequire("auNLL");

var $eqbO4 = parcelRequire("eqbO4");
const $236b5c948089bc7e$export$d9d4a0e66ee82c3f = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, onIssueUnlink: onIssueUnlink, issueStoreId: issueStoreId, itemsConnectionId: itemsConnectionId })=>{
    const { overriding: overriding } = (0, $auNLL.useInlineEditFieldInjections)();
    const issueData = (0, $j4oe4.useFragment)((0, $cSemv.default), issueRef);
    const data = (0, $j4oe4.useFragment)((0, $uPZw1.default), fieldRef);
    let baseIsEditable = false;
    if ('isEditableInIssueView' in data) baseIsEditable = data.isEditableInIssueView;
    else if ('lazyIsEditableInIssueView' in data) baseIsEditable = data.lazyIsEditableInIssueView;
    (0, $eqbO4.useLazyLoadEditability)(data.id, baseIsEditable);
    const isEditable = (0, $eJOHy.useMemo)(()=>overriding.overrideIsEditable(Boolean(baseIsEditable)), [
        baseIsEditable,
        overriding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5WzNk.LinkRelationshipInlineEditView), {
        fieldRef: data,
        issueRef: issueData,
        isEditable: isEditable ?? false,
        issueStoreId: issueStoreId,
        itemsConnectionId: itemsConnectionId,
        onIssueUnlink: onIssueUnlink
    }));
});

});
parcelRegister("uPZw1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d6da71225dc7d94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98f17c2f802ffc2b779e63bb5a3c39c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3d6da71225dc7d94$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "LinkRelationshipTypeCell_fieldRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isEditableSyncLoaded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditableInIssueView"
                }
            ]
        },
        {
            "condition": "isInlineEditingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "lazyIsEditableInIssueView"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef"
        }
    ],
    "type": "JiraIssueLinkRelationshipTypeField"
};
$3d6da71225dc7d94$var$node.hash = "6e86b25020acd81a9ac5426b8f69e24b";
var $3d6da71225dc7d94$export$2e2bcd8739ae039 = $3d6da71225dc7d94$var$node;

});

parcelRegister("cSemv", function(module, exports) {
$parcel$export(module.exports, "default", () => $09a99a0ac5eb7311$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11d18e7e368bab9a1845fbe1c7c3b712>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $09a99a0ac5eb7311$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LinkRelationshipTypeCell_issueRef",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef"
        }
    ],
    "type": "JiraIssue"
};
$09a99a0ac5eb7311$var$node.hash = "24d8dd2e4859e1fdbaadfd853328b22a";
var $09a99a0ac5eb7311$export$2e2bcd8739ae039 = $09a99a0ac5eb7311$var$node;

});

parcelRegister("5WzNk", function(module, exports) {
$parcel$export(module.exports, "LinkRelationshipInlineEditView", () => $ed193198e4107b6f$export$cdf1201d8417a5e2);

var $bQB8a = parcelRequire("bQB8a");

var $94lrB = parcelRequire("94lrB");

var $lWQI8 = parcelRequire("lWQI8");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iCRih = parcelRequire("iCRih");

var $hi2yk = parcelRequire("hi2yk");

var $956it = parcelRequire("956it");

var $jn1Cb = parcelRequire("jn1Cb");
var $cSXp8 = parcelRequire("cSXp8");

var $99gun = parcelRequire("99gun");

var $4s7iN = parcelRequire("4s7iN");

var $d2AGn = parcelRequire("d2AGn");

var $4SjAP = parcelRequire("4SjAP");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $14RSn = parcelRequire("14RSn");

var $kRgKj = parcelRequire("kRgKj");

var $ftN6c = parcelRequire("ftN6c");

var $8gALd = parcelRequire("8gALd");

var $jYDsp = parcelRequire("jYDsp");

var $gomlP = parcelRequire("gomlP");
const $ed193198e4107b6f$var$isMutationErrorPayload = (error)=>typeof error === 'object' && error !== null && 'extensions' in error && Boolean(error.extensions);
const $ed193198e4107b6f$var$isEqualValue = (a, b)=>a?.id === b?.id;
const $ed193198e4107b6f$export$cdf1201d8417a5e2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef, issueRef: issueRef, onIssueUnlink: onIssueUnlink, issueStoreId: issueStoreId, itemsConnectionId: itemsConnectionId, isEditable: isEditable })=>{
    const [showUnlinkConfirmation, setShowUnlinkConfirmation] = (0, $eJOHy.useState)(false);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const issueData = (0, $j4oe4.useFragment)((0, $lWQI8.default), issueRef);
    const data = (0, $j4oe4.useFragment)((0, $94lrB.default), fieldRef);
    const initialValue = (0, $eJOHy.useMemo)(()=>{
        const issueLinkData = {
            issueLinkTypeARI: data?.issueLink?.type?.id ?? '',
            relationName: data?.issueLink?.relationName ?? '',
            direction: data?.issueLink?.direction ?? 'INWARD'
        };
        return (0, $8gALd.createSelectedOptionFromFieldData)(issueLinkData);
    }, [
        data?.issueLink
    ]);
    const [selectedOption, setSelectedOption] = (0, $eJOHy.useState)(initialValue);
    const [commit] = (0, $j4oe4.useMutation)((0, $bQB8a.default));
    const issueId = issueData?.issueId ?? '';
    const issueKey = issueData?.key ?? '';
    const workType = issueData?.issueType?.name ?? '';
    const currentIssueFieldARI = data?.id || '';
    const currentIssueLinkARI = data?.issueLink?.id || '';
    const handleSubmit = (0, $eJOHy.useCallback)((option, { onSuccess: onSuccess, onFail: onFail })=>{
        const nextDirection = option?.direction;
        const nextRelationName = option?.label;
        const nextIssueLinkTypeARI = option?.value;
        if (!nextIssueLinkTypeARI) {
            onFail(new Error('No issue link type id provided'));
            return;
        }
        commit({
            variables: {
                input: {
                    id: currentIssueFieldARI,
                    operation: {
                        operation: 'SET',
                        update: {
                            issueLinkId: currentIssueLinkARI,
                            issueLinkTypeId: nextIssueLinkTypeARI,
                            direction: nextDirection
                        }
                    }
                }
            },
            onCompleted: (mutationData)=>{
                const mutationResponse = mutationData.jira?.updateIssueLinkRelationshipTypeField;
                if (mutationResponse?.success) {
                    onSuccess();
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                        task: 'linkRelationshipTypeUpdate',
                        linkedWorkItemId: issueId
                    });
                } else {
                    const mutationError = mutationResponse?.errors?.[0];
                    const message = mutationError?.message ?? 'Failed to update issue link relationship type field';
                    const statusCode = mutationError?.extensions?.statusCode ?? 0;
                    if (statusCode >= 400 && statusCode < 500) onFail(new (0, $14RSn.ValidationError)(message, [], statusCode));
                    else onFail(new (0, $4SjAP.MutationError)(mutationError ?? {
                        message: message
                    }));
                    (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                        task: 'linkRelationshipTypeUpdate',
                        errorMessage: message,
                        errorType: mutationError?.extensions?.errorType,
                        statusCode: statusCode,
                        linkedWorkItemId: issueId
                    });
                }
            },
            onError (error) {
                (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                    task: 'linkRelationshipTypeUpdate',
                    errorMessage: error?.message ?? 'Failed to update issue link relationship type field',
                    linkedWorkItemId: issueId
                });
                onFail(error);
            },
            optimisticResponse: {
                jira: {
                    updateIssueLinkRelationshipTypeField: {
                        success: true,
                        errors: null,
                        field: {
                            id: currentIssueFieldARI,
                            issueLink: {
                                id: currentIssueLinkARI,
                                direction: nextDirection,
                                relationName: nextRelationName,
                                type: {
                                    id: nextIssueLinkTypeARI
                                }
                            }
                        }
                    }
                }
            }
        });
    }, [
        commit,
        currentIssueFieldARI,
        currentIssueLinkARI,
        createAnalyticsEvent,
        issueId
    ]);
    const fieldId = data?.fieldId;
    const setAnalyticsAttributes = (0, $eJOHy.useCallback)((value)=>{
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes(fieldId, `${initialValue?.value}_${initialValue?.direction}`, `${value?.value}_${value?.direction}`);
    }, [
        fieldId,
        initialValue
    ]);
    const { hasServerValidationError: hasServerValidationError, handleCancel: handleCancel, handleConfirm: handleConfirm, handleChangeAndConfirm: handleChangeAndConfirm, handleEdit: handleEdit, invalidMessage: invalidMessage, isEditing: isEditing } = (0, $4s7iN.useFieldInlineEditActions)({
        fieldId: data?.fieldId,
        fieldName: data?.name,
        fieldType: data?.type,
        initialValue: initialValue,
        updatedValue: selectedOption,
        isValueEqual: $ed193198e4107b6f$var$isEqualValue,
        clipboardComponentType: undefined,
        onSubmit: handleSubmit,
        onUpdateValue: setSelectedOption,
        setAnalyticsAttributes: setAnalyticsAttributes
    });
    const handleUnlinkSuccess = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        showFlag({
            id: (0, $jn1Cb.toFlagId)('unlink-success'),
            type: 'success',
            messageId: 'issue-field-link-relationship-inline-edit-full.ui.show-flag.success.issue-cells.link-relationship-type.show-flag.success.unlink-success',
            messageType: 'transactional',
            title: formatMessage((0, $jYDsp.default).unlinkSuccessTitle, {
                workType: workType,
                issueKey: issueKey
            }),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage((0, $jYDsp.default).viewCta),
                    href: issueData?.isRemoteIssue ? issueData?.webUrl ?? '' : `/browse/${issueKey}`,
                    target: issueData?.isRemoteIssue ? '_blank' : undefined
                }
            ]
        });
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(data?.type, {
            analytics: analyticsEvent,
            attributes: {
                fieldType: data?.type,
                actionTaken: 'remove',
                issueId: issueId
            }
        }, false);
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
            task: 'linkRelationshipTypeUnlink',
            linkedWorkItemId: issueId
        });
        onIssueUnlink?.(issueKey);
    }, [
        issueKey,
        showFlag,
        formatMessage,
        onIssueUnlink,
        data?.type,
        issueId,
        issueData?.isRemoteIssue,
        issueData?.webUrl,
        workType
    ]);
    const handleUnlinkError = (0, $eJOHy.useCallback)((error, analyticsEvent)=>{
        showFlag({
            id: (0, $jn1Cb.toFlagId)('unlink-error'),
            type: 'error',
            messageId: 'issue-field-link-relationship-inline-edit-full.ui.show-flag.error.issue-cells.link-relationship-type.show-flag.error.unlink-error',
            messageType: 'transactional',
            title: formatMessage((0, $jYDsp.default).unlinkErrorTitle, {
                workType: workType.toLowerCase(),
                issueKey: issueKey
            }),
            description: formatMessage((0, $jYDsp.default).unlinkErrorDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage((0, $jYDsp.default).refreshCta),
                    onClick: ()=>globalThis.location.reload()
                }
            ]
        });
        let attributes = {
            errorMessage: error?.message ?? 'Failed to unlink work item',
            linkedWorkItemId: issueId
        };
        if ($ed193198e4107b6f$var$isMutationErrorPayload(error)) attributes = {
            ...attributes,
            statusCode: error.extensions?.statusCode,
            errorType: error.extensions?.errorType
        };
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
            task: 'linkRelationshipTypeUnlink',
            ...attributes
        });
    }, [
        showFlag,
        formatMessage,
        workType,
        issueKey,
        issueId
    ]);
    const handleUnlinkSubmit = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        setShowUnlinkConfirmation(false);
        commit({
            variables: {
                input: {
                    id: currentIssueFieldARI,
                    operation: {
                        operation: 'SET',
                        update: {
                            issueLinkId: currentIssueLinkARI,
                            issueLinkTypeId: null
                        }
                    }
                }
            },
            optimisticUpdater: (store)=>{
                // Optimistically remove the issue row from the table using ConnectionHandler
                // This follows the same pattern as the hide done functionality
                if (itemsConnectionId && issueStoreId) {
                    const connectionRecord = store.get(itemsConnectionId);
                    if (connectionRecord) (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, issueStoreId);
                }
            },
            updater: (store)=>{
                // Ensure the row stays removed after the server response
                // This prevents the server response from re-adding the row
                if (itemsConnectionId && issueStoreId) {
                    const connectionRecord = store.get(itemsConnectionId);
                    if (connectionRecord) {
                        // Check if the node still exists in the connection
                        const edges = connectionRecord.getLinkedRecords('edges');
                        const nodeExists = edges?.some((edge)=>{
                            const node = edge?.getLinkedRecord('node');
                            return node?.getDataID() === issueStoreId;
                        });
                        // If the node was re-added by the server response, remove it again
                        if (nodeExists) (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, issueStoreId);
                    }
                }
            },
            onCompleted: (mutationData)=>{
                const mutationResponse = mutationData?.jira?.updateIssueLinkRelationshipTypeField;
                if (mutationResponse?.success) handleUnlinkSuccess(analyticsEvent);
                else {
                    const mutationError = mutationResponse?.errors?.[0];
                    handleUnlinkError(mutationError, analyticsEvent);
                }
            },
            onError: (error)=>handleUnlinkError(error, analyticsEvent)
        });
    }, [
        commit,
        currentIssueFieldARI,
        currentIssueLinkARI,
        handleUnlinkSuccess,
        handleUnlinkError,
        issueStoreId,
        itemsConnectionId
    ]);
    const handleUnlinkCancel = (0, $eJOHy.useCallback)(()=>{
        setShowUnlinkConfirmation(false);
    }, []);
    const handleUnlink = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        handleCancel(analyticsEvent);
        setShowUnlinkConfirmation(true);
    }, [
        handleCancel
    ]);
    const getEditViewProps = (0, $eJOHy.useCallback)((fieldProps)=>({
            ...fieldProps,
            selectedOption: selectedOption,
            isDisabled: !isEditable,
            onChange: (value)=>{
                handleChangeAndConfirm(value);
            },
            onUnlink: handleUnlink
        }), [
        handleChangeAndConfirm,
        handleUnlink,
        isEditable,
        selectedOption
    ]);
    const readView = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hi2yk.LinkRelationshipTypeReadView), {
            fieldRef: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99gun.FieldInlineEditLiteWithEntryPoint), {
        editViewPopup: true,
        editViewPopupAlignBlock: "center",
        editViewPopupMinWidth: "small",
        editViewEntryPoint: (0, $iCRih.default),
        editViewEntryPointParams: {},
        getEditViewProps: getEditViewProps,
        fieldName: data?.name,
        isEditable: isEditable,
        readView: readView,
        invalidMessage: invalidMessage,
        isEditing: isEditing,
        hasUnsubmittedChanges: hasServerValidationError,
        onEdit: handleEdit,
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        readViewFitContainerHeight: true,
        hideActionButtons: true
    }), showUnlinkConfirmation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gomlP.default), {
        issueKey: issueKey,
        issueId: issueId,
        workType: workType,
        onUnlinkCancel: handleUnlinkCancel,
        onUnlinkSubmit: handleUnlinkSubmit
    }))));
});

});
parcelRegister("bQB8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $710b96e5f4d57926$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45b13792c2a67860a1a3f255ca096a9c>>
 * @relayHash 7d884945e43cd762b79a25b956abcba1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29
const $710b96e5f4d57926$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraIssueLinkRelationshipTypeField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "JiraIssueLink",
                "kind": "LinkedField",
                "name": "issueLink",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "direction"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "relationName"
                    },
                    {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": v7 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueLinkRelationshipTypeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueLinkRelationshipTypeField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v7 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29",
            "metadata": {},
            "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$710b96e5f4d57926$var$node.hash = "2f0a2d2138cd528cd40ded3dce91df75";
var $710b96e5f4d57926$export$2e2bcd8739ae039 = $710b96e5f4d57926$var$node;

});

parcelRegister("94lrB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c37abf4132d12a52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39890d294c755583b46f2182f49c048e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c37abf4132d12a52$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraIssueLink",
                "kind": "LinkedField",
                "name": "issueLink",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "direction"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "relationName"
                    },
                    {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView"
            }
        ],
        "type": "JiraIssueLinkRelationshipTypeField"
    };
}();
$c37abf4132d12a52$var$node.hash = "9cfdc8201ada4d220c4623a0703ec8fb";
var $c37abf4132d12a52$export$2e2bcd8739ae039 = $c37abf4132d12a52$var$node;

});

parcelRegister("lWQI8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1026982704ef25c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a9aec33ad138a8cebd529d62e2a01eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1026982704ef25c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "issueId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isRemoteIssue"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$f1026982704ef25c$var$node.hash = "5ff93c29f4e7ae110de337bc54ea1e6e";
var $f1026982704ef25c$export$2e2bcd8739ae039 = $f1026982704ef25c$var$node;

});

parcelRegister("iCRih", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b0df9380b4d471a$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0b0df9380b4d471a$var$RelationshipTypeEditViewEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("88Ck3")), {
        moduleId: "dd9f033e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0b0df9380b4d471a$export$2e2bcd8739ae039 = $0b0df9380b4d471a$var$RelationshipTypeEditViewEntryPoint;

});
parcelRegister("88Ck3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5Wleb").then(()=>parcelRequire('b7081'));

});


parcelRegister("hi2yk", function(module, exports) {
$parcel$export(module.exports, "LinkRelationshipTypeReadView", () => $c60daa2bf4da7ff9$export$2a5ee9588693f44d);

var $iOx0z = parcelRequire("iOx0z");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $d9T1A = parcelRequire("d9T1A");
const $c60daa2bf4da7ff9$export$2a5ee9588693f44d = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldRef: fieldRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $iOx0z.default), fieldRef);
    const relationName = data?.issueLink?.relationName;
    if (!relationName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9T1A.EmptyFieldText), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        testId: "issue-field-link-relationship-readview-full.ui.text"
    }, relationName);
});

});
parcelRegister("iOx0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $15b55fdd4b8ddde2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<acf7e55b7b68ea87267b36d7a8a42c0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $15b55fdd4b8ddde2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView",
    "selections": [
        {
            "concreteType": "JiraIssueLink",
            "kind": "LinkedField",
            "name": "issueLink",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "relationName"
                }
            ]
        }
    ],
    "type": "JiraIssueLinkRelationshipTypeField"
};
$15b55fdd4b8ddde2$var$node.hash = "99eeee1e19009209c4cbc431eef50271";
var $15b55fdd4b8ddde2$export$2e2bcd8739ae039 = $15b55fdd4b8ddde2$var$node;

});


parcelRegister("8gALd", function(module, exports) {
$parcel$export(module.exports, "createSelectedOptionFromFieldData", () => $867b869f881dd328$export$48295089bb76e387);
const $867b869f881dd328$export$48295089bb76e387 = (issueLinkData)=>{
    const { issueLinkTypeARI: issueLinkTypeARI, relationName: relationName, direction: direction } = issueLinkData || {};
    if (!issueLinkTypeARI || !relationName || !direction) return null;
    return {
        id: `${issueLinkTypeARI}_${direction}`,
        value: issueLinkTypeARI,
        label: relationName,
        direction: direction
    };
};

});

parcelRegister("jYDsp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a44f012b27cbb718$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a44f012b27cbb718$var$messages = (0, $7qGN1.defineMessages)({
    unlinkConfirmationModalTitle: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-confirmation-modal-title",
        "defaultMessage": "Unlink {workType} {issueKey} from this work item."
    },
    unlinkConfirmationCancelButton: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-confirmation-cancel-button",
        "defaultMessage": "Cancel"
    },
    unlinkConfirmationConfirmButton: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-confirmation-confirm-button",
        "defaultMessage": "Unlink"
    },
    unlinkSuccessTitle: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-success-title",
        "defaultMessage": "{workType} {issueKey} has been unlinked from this work item."
    },
    viewCta: {
        "id": "issue-field-link-relationship-inline-edit-full.view-cta",
        "defaultMessage": "View"
    },
    unlinkErrorTitle: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-error-title",
        "defaultMessage": "We can't unlink {workType} {issueKey}"
    },
    unlinkErrorDescription: {
        "id": "issue-field-link-relationship-inline-edit-full.unlink-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshCta: {
        "id": "issue-field-link-relationship-inline-edit-full.refresh-cta",
        "defaultMessage": "Refresh"
    }
});
var $a44f012b27cbb718$export$2e2bcd8739ae039 = $a44f012b27cbb718$var$messages;

});

parcelRegister("gomlP", function(module, exports) {
$parcel$export(module.exports, "default", () => $21038cce3e13c989$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $lJKII = parcelRequire("lJKII");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $jYDsp = parcelRequire("jYDsp");
const $21038cce3e13c989$var$ConfirmationDialog = ({ issueKey: issueKey, issueId: issueId, workType: workType, onUnlinkCancel: onUnlinkCancel, onUnlinkSubmit: onUnlinkSubmit })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleUnlinkSubmit = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'unlinkConfirmation', {
            issueId: issueId
        });
        onUnlinkSubmit(analyticsEvent);
    }, [
        onUnlinkSubmit,
        issueId
    ]);
    const handleUnlinkCancel = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'unlinkCancel', {
            issueId: issueId
        });
        onUnlinkCancel();
    }, [
        onUnlinkCancel,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "removeLinkedIssue",
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "issue-field-link-relationship-inline-edit-full.ui.confirmation-dialog.modal-dialog.unlink-confirmation.modal-dialog",
        messageType: "transactional",
        onClose: onUnlinkCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationModalTitle, {
        issueKey: issueKey,
        workType: workType.toLowerCase()
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: handleUnlinkCancel
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "warning",
        onClick: handleUnlinkSubmit
    }, formatMessage((0, $jYDsp.default).unlinkConfirmationConfirmButton))))));
};
var $21038cce3e13c989$export$2e2bcd8739ae039 = $21038cce3e13c989$var$ConfirmationDialog;

});



parcelRegister("jQO5F", function(module, exports) {
$parcel$export(module.exports, "useCellsConditionalFormatting", () => $f44df94406f27c19$export$22d9e69227bc5741);

var $8tlli = parcelRequire("8tlli");

var $gPamA = parcelRequire("gPamA");

var $i6iZs = parcelRequire("i6iZs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kQ82p = parcelRequire("kQ82p");

var $5d1YD = parcelRequire("5d1YD");

var $4cTDP = parcelRequire("4cTDP");

var $jUTKf = parcelRequire("jUTKf");

var $34oCh = parcelRequire("34oCh");
const $f44df94406f27c19$var$emptyObject = {};
const $f44df94406f27c19$export$22d9e69227bc5741 = (project, fieldSets, savedViewFormattingRules)=>{
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSavedViewConditionalFormattingEnabled = (0, $4cTDP.fg)('saved_list_view_technical_changes') && isConditionalFormattingEnabled;
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const fields = (0, $j4oe4.useFragment)((0, $i6iZs.default), isConditionalFormattingEnabled ? fieldSets : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesOld = (0, $j4oe4.useFragment)((0, $gPamA.default), isConditionalFormattingEnabled ? project ?? null : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesNew = (0, $j4oe4.useFragment)((0, $8tlli.default), isSavedViewConditionalFormattingEnabled ? savedViewFormattingRules : null);
    const rules = isSavedViewConditionalFormattingEnabled ? rulesNew : rulesOld?.conditionalFormattingRules;
    const valuesByFieldId = (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled) return null;
        if (rules?.edges == null || rules?.edges.length === 0) return null;
        if (fields?.edges == null || fields?.edges?.length === 0) return null;
        const localMap = new Map();
        fields.edges.forEach((fieldSet)=>fieldSet?.node?.fields?.edges?.forEach((fieldEdge)=>{
                const field = fieldEdge?.node;
                switch(field?.__typename){
                    case 'JiraSingleLineTextField':
                        localMap.set(field.fieldId, field.text);
                        break;
                    case 'JiraLabelsField':
                        {
                            const names = field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>name != null) ?? [];
                            localMap.set(field.fieldId, names);
                            break;
                        }
                    case 'JiraComponentsField':
                        {
                            const ids = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.componentId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectUserPickerField':
                        localMap.set(field.fieldId, field.user?.accountId ?? 'UNASSIGNED');
                        break;
                    case 'JiraDatePickerField':
                        {
                            const parsedDate = field.date ? (0, $kQ82p.default)(field.date) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraDateTimePickerField':
                        {
                            const parsedDate = field.dateTime ? (0, $kQ82p.default)(field.dateTime) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraNumberField':
                        localMap.set(field.fieldId, field.number);
                        break;
                    case 'JiraPriorityField':
                        localMap.set(field.fieldId, field.priority?.priorityId);
                        break;
                    case 'JiraProjectField':
                        localMap.set(field.fieldId, field.project?.projectId);
                        break;
                    case 'JiraSingleVersionPickerField':
                        localMap.set(field.fieldId, field.version?.versionId);
                        break;
                    case 'JiraIssueTypeField':
                        localMap.set(field.fieldId, field.issueType?.issueTypeId);
                        break;
                    case 'JiraStatusField':
                        localMap.set(field.fieldId, field.status?.statusId);
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        {
                            const ids = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.accountId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSprintField':
                        {
                            const ids = field.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>sprintId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraMultipleVersionPickerField':
                        {
                            const ids = field.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>versionId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectField':
                        localMap.set(field.fieldId, field.selectedValue?.id);
                        break;
                    case 'JiraMultipleSelectField':
                        {
                            const ids = field.selectedValues?.edges?.map((edge)=>edge?.node?.id).filter((selectedValueId)=>selectedValueId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraRadioSelectField':
                        localMap.set(field.fieldId, field.selectedOption?.label);
                        break;
                    // TODO: Add all supported types value mapping
                    default:
                        break;
                }
            }));
        return localMap;
    }, [
        fields,
        isConditionalFormattingEnabled,
        rules
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled) return $f44df94406f27c19$var$emptyObject;
        /*
    	Evaluate all rules.
    	Get all rules before first row rule that's active.
    	groupBy fieldId first rule that is active for that fieldId.  {[fieldId]: {value, hoverValue}}
    */ const formattingRules = rules?.edges;
        if (!formattingRules || formattingRules.length === 0 || fields?.edges == null || fields?.edges.length === 0) return $f44df94406f27c19$var$emptyObject;
        if (valuesByFieldId == null) return $f44df94406f27c19$var$emptyObject;
        let hasActiveRowRule = false;
        const fieldWithActiveRule = new Set();
        const evaluatedRules = Object.fromEntries(formattingRules.map((rule, index)=>{
            if (hasActiveRowRule) // We dont want to evaluate more rules when
            // an active Row rule exists
            return null;
            const expression = rule?.node?.expression;
            const fieldId = expression?.fieldId;
            const value = expression?.value ?? expression?.values;
            const formattingArea = rule?.node?.formattingArea;
            const operator = expression?.noValueOperator ?? expression?.singleValueOperator ?? expression?.multipleValueOperator;
            if (!fieldId || !operator || formattingArea === 'CELL' && fieldWithActiveRule.has(fieldId)) // FieldId and Operator are mandatory for evaluation
            // First rule per fieldId will be used anything else should not be evaluated
            return null;
            const fieldValue = valuesByFieldId.get(fieldId);
            const active = (0, $5d1YD.evaluateRule)(operator, fieldValue, value);
            if (!active) return null;
            if (formattingArea === 'ROW') {
                hasActiveRowRule = true;
                return null;
            }
            fieldWithActiveRule.add(fieldId);
            return [
                fieldId,
                {
                    index: index,
                    id: fieldId,
                    color: (0, $jUTKf.formattingColors)[rule?.node?.formattingColor?.colorKey ?? ''],
                    type: 'CELL'
                }
            ];
        }).filter((maybeRule)=>maybeRule != null));
        return Object.fromEntries(fields.edges.map((fieldSetEdge)=>{
            const fieldSet = fieldSetEdge?.node;
            if (fieldSet?.fieldSetId == null) return null;
            let rule;
            fieldSet.fields?.edges?.forEach((fieldEdge)=>{
                if (fieldEdge?.node == null) return;
                const maybeRule = evaluatedRules[fieldEdge.node.fieldId];
                if (maybeRule != null && maybeRule.index < (rule?.index ?? Infinity)) rule = maybeRule;
                return null;
            });
            if (rule?.color == null) return null;
            return [
                fieldSet.fieldSetId,
                {
                    ...rule.color,
                    index: rule.index
                }
            ];
        }).filter((maybeRule)=>maybeRule != null));
    }, [
        isConditionalFormattingEnabled,
        rules,
        fields,
        valuesByFieldId
    ]);
};

});
parcelRegister("8tlli", function(module, exports) {
$parcel$export(module.exports, "default", () => $5453a3c5ee4ca9ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<647de14796a034c2309ff08d7ed0b996>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5453a3c5ee4ca9ab$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting_savedView_rules",
        "selections": [
            {
                "concreteType": "JiraFormattingRuleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "singleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "value"
                                            }
                                        ],
                                        "type": "JiraFormattingSingleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "multipleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "values"
                                            }
                                        ],
                                        "type": "JiraFormattingMultipleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "noValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            }
                                        ],
                                        "type": "JiraFormattingNoValueOperand"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formattingArea"
                            },
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "formattingColor",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraFormattingRuleConnection"
    };
}();
$5453a3c5ee4ca9ab$var$node.hash = "579376b5624a74e7adccc6df7f4fbfe4";
var $5453a3c5ee4ca9ab$export$2e2bcd8739ae039 = $5453a3c5ee4ca9ab$var$node;

});

parcelRegister("gPamA", function(module, exports) {
$parcel$export(module.exports, "default", () => $463901b3fe7d9d91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff32447f6f6a3d7dbbd91560065dad22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $463901b3fe7d9d91$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting_rules",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "conditionalFormattingRules(first:20)"
            }
        ],
        "type": "JiraProject"
    };
}();
$463901b3fe7d9d91$var$node.hash = "4ad11db40961c16bb414c671329a0ed5";
var $463901b3fe7d9d91$export$2e2bcd8739ae039 = $463901b3fe7d9d91$var$node;

});

parcelRegister("i6iZs", function(module, exports) {
$parcel$export(module.exports, "default", () => $01f58d9b64bbc1c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fea2d740ce5705e2b312a4fcfe696611>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01f58d9b64bbc1c6$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "versionId"
        }
    ], v4 = [
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useCellsConditionalFormatting",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldSetId"
                            },
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "componentId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            }
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "number"
                                                            }
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "priorityId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "projectId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "version",
                                                                "plural": false,
                                                                "selections": v3 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v3 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "selectedValue",
                                                                "plural": false,
                                                                "selections": v4 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSelectableValueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedValues",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v4 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": "label",
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRadioSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$01f58d9b64bbc1c6$var$node.hash = "2151ef0116104b28f71c46bfce531ce1";
var $01f58d9b64bbc1c6$export$2e2bcd8739ae039 = $01f58d9b64bbc1c6$var$node;

});

parcelRegister("5d1YD", function(module, exports) {
$parcel$export(module.exports, "evaluateRule", () => $8e832ab75969f901$export$6b882d50951f579a);

var $dGJCK = parcelRequire("dGJCK");
var $cNTKl = parcelRequire("cNTKl");
var $3bI3H = parcelRequire("3bI3H");
var $ibLUB = parcelRequire("ibLUB");
var $bf0oy = parcelRequire("bf0oy");
var $lncFc = parcelRequire("lncFc");
var $37UhW = parcelRequire("37UhW");
var $bODPS = parcelRequire("bODPS");
var $i6NVB = parcelRequire("i6NVB");
var $dBLX0 = parcelRequire("dBLX0");
var $dSLL3 = parcelRequire("dSLL3");
var $kQ82p = parcelRequire("kQ82p");
var $lTtQZ = parcelRequire("lTtQZ");
var $hwbrf = parcelRequire("hwbrf");
var $dy6Fq = parcelRequire("dy6Fq");

var $9iBuw = parcelRequire("9iBuw");
const $8e832ab75969f901$var$evaluateRuleNoValue = (operator, fieldValue)=>{
    if (Array.isArray(fieldValue)) switch(operator){
        case 'IS_EMPTY':
            return fieldValue.length === 0;
        case 'IS_NOT_EMPTY':
            return fieldValue.length > 0;
        default:
            return false;
    }
    switch(operator){
        case 'IS_EMPTY':
            return fieldValue === 0 ? false : !fieldValue;
        case 'IS_NOT_EMPTY':
            return fieldValue === 0 ? true : Boolean(fieldValue);
        default:
            return false;
    }
};
const $8e832ab75969f901$var$ruleSingleValueStringOperations = {
    CONTAINS: (fieldValue, ruleValue)=>{
        if (Array.isArray(fieldValue)) return fieldValue.some((value)=>{
            if (value == null) return false;
            if ((0, $9iBuw.isNumber)(value)) return value === Number(ruleValue);
            if ((0, $9iBuw.isString)(value)) return value.includes(ruleValue);
            return false;
        });
        return fieldValue.includes(ruleValue);
    }
};
const $8e832ab75969f901$var$ruleSingleValueOperations = {
    EQUALS: (fieldValue, ruleValue)=>{
        return Boolean(fieldValue && String(fieldValue) === ruleValue);
    }
};
const $8e832ab75969f901$var$ruleSingleValueNumberOperations = {
    GREATER_THAN: (fieldValue, ruleValue)=>{
        return fieldValue > Number(ruleValue);
    }
};
const $8e832ab75969f901$var$dateRuleValueEvaluators = {
    IS: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $bODPS.default)(fieldValue);
            case 'TOMORROW':
                return (0, $i6NVB.default)(fieldValue);
            case 'YESTERDAY':
                return (0, $dSLL3.default)(fieldValue);
            case 'THIS_WEEK':
                return (0, $37UhW.default)(fieldValue);
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) === -1;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) === 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === -1;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) === 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === -1;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) === 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $lncFc.default)(dateValue, fieldValue);
                    return false;
                }
        }
    },
    IS_AFTER: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $ibLUB.default)(fieldValue, (0, $lTtQZ.default)());
            case 'TOMORROW':
                return (0, $ibLUB.default)(fieldValue, (0, $hwbrf.default)());
            case 'YESTERDAY':
                return (0, $ibLUB.default)(fieldValue, (0, $dy6Fq.default)());
            case 'THIS_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) > 0;
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) > 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) > 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) > 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) > 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) >= 0;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) > 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $ibLUB.default)(fieldValue, dateValue);
                    return false;
                }
        }
    },
    IS_BEFORE: (fieldValue, ruleValue)=>{
        switch(ruleValue){
            case 'TODAY':
                return (0, $bf0oy.default)(fieldValue, (0, $lTtQZ.default)());
            case 'TOMORROW':
                return (0, $bf0oy.default)(fieldValue, (0, $hwbrf.default)());
            case 'YESTERDAY':
                return (0, $bf0oy.default)(fieldValue, (0, $dy6Fq.default)());
            case 'THIS_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < 0;
            case 'LAST_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < -1;
            case 'NEXT_WEEK':
                return (0, $cNTKl.default)(fieldValue, new Date()) < 1;
            case 'THIS_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < 0;
            case 'LAST_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < -1;
            case 'NEXT_QUARTER':
                return (0, $dGJCK.default)(fieldValue, new Date()) < 1;
            case 'THIS_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < 0;
            case 'LAST_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < -1;
            case 'NEXT_YEAR':
                return (0, $3bI3H.default)(fieldValue, new Date()) < 1;
            default:
                {
                    const dateValue = (0, $kQ82p.default)(ruleValue);
                    if ((0, $dBLX0.default)(dateValue)) return (0, $bf0oy.default)(fieldValue, dateValue);
                    return false;
                }
        }
    },
    IS_NOT: (field, value)=>!$8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value),
    IS_ON_OR_AFTER: (field, value)=>Boolean($8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value) || $8e832ab75969f901$var$dateRuleValueEvaluators.IS_AFTER?.(field, value)),
    IS_ON_OR_BEFORE: (field, value)=>Boolean($8e832ab75969f901$var$dateRuleValueEvaluators.IS?.(field, value) || $8e832ab75969f901$var$dateRuleValueEvaluators.IS_BEFORE?.(field, value))
};
const $8e832ab75969f901$var$evaluateRuleSingleValue = (operator, fieldValue, ruleValue)=>{
    if ((0, $9iBuw.isDateRuleOnlyOperator)(operator) && fieldValue instanceof Date) return $8e832ab75969f901$var$dateRuleValueEvaluators[operator](fieldValue, ruleValue) ?? false;
    // Operators that apply to all field value types
    switch(operator){
        case 'EQUALS':
            return $8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue);
        case 'DOES_NOT_EQUAL':
            return !$8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue);
        case 'IS':
            return fieldValue === ruleValue;
        case 'IS_NOT':
            return fieldValue !== ruleValue;
        default:
            break;
    }
    if (fieldValue == null) // All single value rule requires the field value to exist
    return false;
    if ((0, $9iBuw.isString)(fieldValue) || Array.isArray(fieldValue)) // Operators that does not apply to number or nullish fields
    switch(operator){
        case 'CONTAINS':
            return $8e832ab75969f901$var$ruleSingleValueStringOperations.CONTAINS(fieldValue, ruleValue);
        case 'DOES_NOT_CONTAIN':
            return !$8e832ab75969f901$var$ruleSingleValueStringOperations.CONTAINS(fieldValue, ruleValue);
        default:
            return false;
    }
    if ((0, $9iBuw.isNumber)(fieldValue)) switch(operator){
        // Only applies to number
        case 'GREATER_THAN':
            return $8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? false;
        case 'LESS_THAN':
            return !($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? true) && !($8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue) ?? true);
        case 'GREATER_THAN_OR_EQUALS':
            return ($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? false) || ($8e832ab75969f901$var$ruleSingleValueOperations.EQUALS(fieldValue, ruleValue) ?? false);
        case 'LESS_THAN_OR_EQUALS':
            return !($8e832ab75969f901$var$ruleSingleValueNumberOperations.GREATER_THAN(fieldValue, ruleValue) ?? true);
        default:
            break;
    }
    return false;
};
const $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators = {
    HAS_ANY_OF: (fieldValue, ruleValue)=>{
        if (fieldValue == null) return false;
        return ruleValue.includes(String(fieldValue));
    },
    // No valid rule single field value contains a multiple rule value
    CONTAINS: ()=>false,
    DOES_NOT_CONTAIN: ()=>false,
    // eslint-disable-next-line @atlassian/relay/no-future-added-value
    '%future added value': ()=>false
};
const $8e832ab75969f901$var$multipleValueOperatorEvaluators = {
    CONTAINS: (fieldValue, ruleValue)=>{
        return fieldValue.filter((fval)=>{
            return ruleValue.includes(String(fval));
        }).length === ruleValue.length;
    },
    DOES_NOT_CONTAIN: (...args)=>!$8e832ab75969f901$var$multipleValueOperatorEvaluators.CONTAINS(...args),
    HAS_ANY_OF: (fieldValue, ruleValue)=>{
        return fieldValue.some((fval)=>{
            return $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators.HAS_ANY_OF(fval, ruleValue);
        });
    },
    // eslint-disable-next-line @atlassian/relay/no-future-added-value
    '%future added value': ()=>false
};
const $8e832ab75969f901$var$evaluateRuleMultipleValue = (operator, fieldValue, ruleValue)=>{
    if (Array.isArray(fieldValue)) return $8e832ab75969f901$var$multipleValueOperatorEvaluators[operator](fieldValue, ruleValue);
    return $8e832ab75969f901$var$multipleValueOperatorSingleFieldValueEvaluators[operator](fieldValue, ruleValue);
};
const $8e832ab75969f901$export$6b882d50951f579a = (operator, fieldValue, ruleValue)=>{
    if (ruleValue === undefined) {
        if ((0, $9iBuw.isNoValueOperator)(operator)) return $8e832ab75969f901$var$evaluateRuleNoValue(operator, fieldValue);
        return false;
    }
    if (Array.isArray(ruleValue) && (0, $9iBuw.isMultipleValueOperator)(operator)) return $8e832ab75969f901$var$evaluateRuleMultipleValue(operator, fieldValue, ruleValue);
    if ((0, $9iBuw.isSingleValueOperator)(operator) && typeof ruleValue === 'string') return $8e832ab75969f901$var$evaluateRuleSingleValue(operator, fieldValue, ruleValue);
// We will need to handle this in the hook, and sent analytics event when missing.
// throw new Error('Unhandled format rule'); https://jbusiness.atlassian.net/browse/JSC-2764 Uncomment when error is properly handled
};

});
parcelRegister("9iBuw", function(module, exports) {
$parcel$export(module.exports, "isNoValueOperator", () => $04d6240c5de8c6c9$export$88b85e57ca1e3f4a);
$parcel$export(module.exports, "isSingleValueOperator", () => $04d6240c5de8c6c9$export$99197f1cc2c9c086);
$parcel$export(module.exports, "isDateRuleOnlyOperator", () => $04d6240c5de8c6c9$export$f0a7020d8f55379d);
$parcel$export(module.exports, "isMultipleValueOperator", () => $04d6240c5de8c6c9$export$71082e7c2ba7f454);
$parcel$export(module.exports, "isString", () => $04d6240c5de8c6c9$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $04d6240c5de8c6c9$export$7e4aa119212bc614);
const $04d6240c5de8c6c9$var$dateRuleValue = new Set([
    'EXACT_DATE',
    'LAST_QUARTER',
    'LAST_WEEK',
    'LAST_YEAR',
    'NEXT_QUARTER',
    'NEXT_WEEK',
    'NEXT_YEAR',
    'THIS_QUARTER',
    'THIS_WEEK',
    'THIS_YEAR',
    'TODAY',
    'TOMORROW',
    'YESTERDAY'
]);
const $04d6240c5de8c6c9$export$7a93007e84f4988d = (value)=>{
    return $04d6240c5de8c6c9$var$dateRuleValue.has(value);
};
const $04d6240c5de8c6c9$var$noValueOperators = new Set([
    'IS_EMPTY',
    'IS_NOT_EMPTY'
]);
const $04d6240c5de8c6c9$export$88b85e57ca1e3f4a = (operator)=>{
    return $04d6240c5de8c6c9$var$noValueOperators.has(operator);
};
const $04d6240c5de8c6c9$var$singleValueOperators = new Set([
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'DOES_NOT_EQUAL',
    'EQUALS',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUALS',
    'IS',
    'IS_AFTER',
    'IS_BEFORE',
    'IS_NOT',
    'IS_ON_OR_AFTER',
    'IS_ON_OR_BEFORE',
    'LESS_THAN',
    'LESS_THAN_OR_EQUALS'
]);
const $04d6240c5de8c6c9$export$99197f1cc2c9c086 = (operator)=>{
    return $04d6240c5de8c6c9$var$singleValueOperators.has(operator);
};
const $04d6240c5de8c6c9$var$dateRuleOnlyOperator = new Set([
    'IS',
    'IS_AFTER',
    'IS_BEFORE',
    'IS_NOT',
    'IS_ON_OR_AFTER',
    'IS_ON_OR_BEFORE'
]);
const $04d6240c5de8c6c9$export$f0a7020d8f55379d = (operator)=>{
    return $04d6240c5de8c6c9$var$dateRuleOnlyOperator.has(operator);
};
const $04d6240c5de8c6c9$var$multipleValueOperators = new Set([
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'HAS_ANY_OF',
    'IS_BETWEEN'
]);
const $04d6240c5de8c6c9$export$71082e7c2ba7f454 = (operator)=>{
    return $04d6240c5de8c6c9$var$multipleValueOperators.has(operator);
};
const $04d6240c5de8c6c9$export$844ec244b1367d54 = (maybeString)=>{
    return typeof maybeString === 'string';
};
const $04d6240c5de8c6c9$export$7e4aa119212bc614 = (maybeNumber)=>{
    return typeof maybeNumber === 'number';
};

});


parcelRegister("jUTKf", function(module, exports) {
$parcel$export(module.exports, "formattingColors", () => $c30971d2a738910c$export$2fedf4ac4eb04087);

var $LFmXM = parcelRequire("LFmXM");

var $5zzUt = parcelRequire("5zzUt");
const $c30971d2a738910c$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $5zzUt.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)"
    },
    lightBlue: {
        label: (0, $5zzUt.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    },
    lightGreen: {
        label: (0, $5zzUt.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $5zzUt.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $5zzUt.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)"
    },
    lightRed: {
        label: (0, $5zzUt.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $5zzUt.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
    },
    purple: {
        label: (0, $5zzUt.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #B8ACF6)"
    },
    blue: {
        label: (0, $5zzUt.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)"
    },
    green: {
        label: (0, $5zzUt.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #7EE2B8)"
    },
    teal: {
        label: (0, $5zzUt.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)"
    },
    yellow: {
        label: (0, $5zzUt.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    },
    red: {
        label: (0, $5zzUt.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FD9891)"
    },
    gray: {
        label: (0, $5zzUt.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)"
    }
};
const $c30971d2a738910c$export$ae7e938b8bdf2df5 = (0, $LFmXM.default)((value)=>{
    const selectedColor = Object.entries($c30971d2a738910c$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("5zzUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $37202181219e5e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $37202181219e5e4d$var$messages = (0, $7qGN1.defineMessages)({
    lightPurple: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "issue-table-conditional-formatting.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});
var $37202181219e5e4d$export$2e2bcd8739ae039 = $37202181219e5e4d$var$messages;

});



parcelRegister("cOqgG", function(module, exports) {
$parcel$export(module.exports, "default", () => $11224fa3afbf416f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $kGj4V = parcelRequire("kGj4V");

var $8jOO7 = parcelRequire("8jOO7");

var $86BUM = parcelRequire("86BUM");

var $bKlUQ = parcelRequire("bKlUQ");

var $dvCjO = parcelRequire("dvCjO");
const $11224fa3afbf416f$var$DefaultFallbackComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
const $11224fa3afbf416f$var$IssueRowCellErrorFallback = ({ type: type, border: border, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        border: border
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86BUM.default), {
        cellType: type,
        reason: (0, $4cTDP.fg)('empanada_error_cell_logging') ? error : 'Unhandled error'
    }));
const $11224fa3afbf416f$var$IssueRowCell = ({ type: type, beforeElement: beforeElement, cellElement: cellElement, border: border, spacing: spacing, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment, FallbackComponent: FallbackComponent = $11224fa3afbf416f$var$DefaultFallbackComponent, formatting: formatting, style: style, isColumnResizing: isColumnResizing, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, hasRightShadow: hasRightShadow, fieldId: fieldId, onFocusHandler: onFocusHandler, onBlurHandler: onBlurHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            fieldType: type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: (0, $8jOO7.PACKAGE_NAME),
        teamName: (0, $8jOO7.TEAM_NAME),
        id: "issueRowCellUnhandled",
        sendToPrivacyUnsafeSplunk: true,
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($11224fa3afbf416f$var$IssueRowCellErrorFallback, {
                type: type,
                border: border,
                error: error
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), {
        spacing: spacing,
        border: border,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isColumnSticky: isColumnSticky,
            stickyOffsets: stickyOffsets,
            isColumnResizing: isColumnResizing,
            hasRightShadow: hasRightShadow
        },
        formatting: formatting,
        fieldId: fieldId,
        ...onFocusHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onFocusHandler: onFocusHandler
        } : {},
        ...onBlurHandler && (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onBlurHandler: onBlurHandler
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeElement, Array.isArray(cellElement) && cellElement.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dvCjO.MultipleCellElements), {
        cellElements: cellElement,
        type: type,
        multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment
    }) : cellElement ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FallbackComponent, null)))));
var $11224fa3afbf416f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($11224fa3afbf416f$var$IssueRowCell);

});
parcelRegister("dvCjO", function(module, exports) {
$parcel$export(module.exports, "MultipleCellElements", () => $0dfcc569f582c593$export$4b5a1f36c48df9b0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5PQOA = parcelRequire("5PQOA");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $2R0ne = parcelRequire("2R0ne");

var $Ay1uj = parcelRequire("Ay1uj");

var $lL4G9 = parcelRequire("lL4G9");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $ibVOD = parcelRequire("ibVOD");

var $9Mapt = parcelRequire("9Mapt");

var $34oCh = parcelRequire("34oCh");

var $9LCGj = parcelRequire("9LCGj");
const $0dfcc569f582c593$export$1d1457a281374128 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((fieldType, numberOfElements, createAnalyticsEvent)=>{
    (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'tableCell multipleElementsRendered', {
        fieldType: fieldType,
        numberOfElements: numberOfElements
    });
});
const $0dfcc569f582c593$var$MoreFieldsContent = ({ elements: elements })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$moreFieldsHeaderRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $9LCGj.default).duplicateFieldsHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$moreFieldsDescriptionStyles
    }, formatMessage((0, $9LCGj.default).duplicateFieldsContent, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                href: "/jira/settings/issues/fields",
                target: "_blank"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("hr", {
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$fieldsContainerStyles
    }, elements.map((element, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $0dfcc569f582c593$var$fieldStyles,
            key: idx
        }, element))));
};
const $0dfcc569f582c593$export$4b5a1f36c48df9b0 = ({ cellElements: cellElements, multipleFieldLayoutAdjustment: multipleFieldLayoutAdjustment = false, type: type })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    $0dfcc569f582c593$export$1d1457a281374128(type, cellElements.length, createAnalyticsEvent);
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    if (multipleFieldLayoutAdjustment && cellElements.length > 0 && isSingleLineRowHeightEnabled) {
        const firstElement = cellElements[0];
        const rest = cellElements.slice(1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $0dfcc569f582c593$var$rowStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ...props,
                className: (0, $hcewu.default)([
                    "_1reo15vq _18m915vq _1bto1l2s",
                    "_4t3i1osq",
                    "_1bsb1osq"
                ])
            }, firstElement))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibVOD.CellHoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.CellHoverRenderer), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Mapt.HoverPopoverWithContext), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0dfcc569f582c593$var$MoreFieldsContent, {
                    elements: rest
                }),
                isInteractive: true,
                isFixedWidth: true,
                analyticsAttributes: {
                    duplicateField: true
                }
            }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    ref: ref,
                    className: (0, $hcewu.default)([
                        "_2hwx1b66"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                    label: "",
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                            ...iconProps,
                            color: "var(--ds-icon-information, #1D7AFC)"
                        }),
                    testId: "native-issue-table.ui.row.issue-row.cell.multiple-cell-elements.issue-table",
                    ...props
                }))))));
    }
    return multipleFieldLayoutAdjustment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0dfcc569f582c593$var$containerStyles
    }, cellElements.map((cellElement, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: index,
            xcss: $0dfcc569f582c593$var$elementContainerStyles
        }, cellElement))) : cellElements;
};
const $0dfcc569f582c593$var$rowStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'space.050',
    height: '100%'
});
const $0dfcc569f582c593$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.050'
});
const $0dfcc569f582c593$var$elementContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '32px'
});
const $0dfcc569f582c593$var$moreFieldsHeaderRowStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.050'
});
const $0dfcc569f582c593$var$moreFieldsDescriptionStyles = (0, $1DXK0.xcss)({
    font: 'font.body.medium'
});
const $0dfcc569f582c593$var$fieldsContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 'space.050',
    width: '100%',
    height: '100%'
});
const $0dfcc569f582c593$var$fieldStyles = (0, $1DXK0.xcss)({
    height: '40px',
    width: '100%'
});
const $0dfcc569f582c593$var$contentStyles = null;
const $0dfcc569f582c593$var$buttonStyle = null;
const $0dfcc569f582c593$var$fillHeight = null;
const $0dfcc569f582c593$var$fillWidth = null;

});
parcelRegister("9LCGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce16bf62d775f359$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ce16bf62d775f359$var$messages = (0, $7qGN1.defineMessages)({
    duplicateFieldsHeader: {
        "id": "native-issue-table.duplicate-fields-header",
        "defaultMessage": "Duplicate fields"
    },
    duplicateFieldsContent: {
        "id": "native-issue-table.duplicate-fields-content",
        "defaultMessage": "<link>Configure fields</link> to remove duplicates"
    }
});
var $ce16bf62d775f359$export$2e2bcd8739ae039 = $ce16bf62d775f359$var$messages;

});



parcelRegister("gToWi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b244ccc87c9091fc$export$2e2bcd8739ae039);

var $eaHPI = parcelRequire("eaHPI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2XtSM = parcelRequire("2XtSM");

var $4EKqI = parcelRequire("4EKqI");

var $bJscI = parcelRequire("bJscI");

var $34oCh = parcelRequire("34oCh");

var $jNv5I = parcelRequire("jNv5I");
const $b244ccc87c9091fc$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "first-column-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
/**
 * @deprecated should be removed when jira_list_merged_column_gate is cleaned up
 */ const $b244ccc87c9091fc$var$FirstColumnCell = ({ isRowHoveredOrSelected: isRowHoveredOrSelected, itemsConnectionId: itemsConnectionId, depth: depth, issueRef: issueRef, triggerProps: triggerProps, isFormVisible: isFormVisible })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $eaHPI.default), issueRef);
    const { hasChildren: hasChildren, canHaveChildIssues: canHaveChildIssues } = issueData;
    const { issueId: issueId } = issueData.node ?? {};
    const { groupId: groupId } = (0, $jNv5I.useRowContext)();
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const showCreateChildButton = isChildIssueCreateEnabled && isRowHoveredOrSelected && Boolean(canHaveChildIssues);
    return issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b244ccc87c9091fc$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButtonWithCreateChildButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth,
        hasChildren: Boolean(hasChildren),
        showCreateChildButton: showCreateChildButton,
        isRowHoveredOrSelected: isRowHoveredOrSelected,
        isCreateChildFormVisible: isFormVisible,
        createChildTriggerProps: triggerProps,
        groupId: groupId
    }));
};
var $b244ccc87c9091fc$export$2e2bcd8739ae039 = $b244ccc87c9091fc$var$FirstColumnCell;

});
parcelRegister("eaHPI", function(module, exports) {
$parcel$export(module.exports, "default", () => $6486e1beed41699b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1bf3401344813a938315cca7608ff8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6486e1beed41699b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "FirstColumnCell",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$6486e1beed41699b$var$node.hash = "3cdfef30b98027986ca5f2832216e2e7";
var $6486e1beed41699b$export$2e2bcd8739ae039 = $6486e1beed41699b$var$node;

});


parcelRegister("4XMye", function(module, exports) {
$parcel$export(module.exports, "MergedCell", () => $b082cfc5b9e74dcc$export$91a9bd0bc931a6e5);

var $hAuys = parcelRequire("hAuys");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dcLzM = parcelRequire("dcLzM");

var $2XtSM = parcelRequire("2XtSM");

var $bJscI = parcelRequire("bJscI");

var $4EKqI = parcelRequire("4EKqI");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $9r0oq = parcelRequire("9r0oq");
const $b082cfc5b9e74dcc$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "merged-cell",
        mode: "list"
    }, children), (0, $eJOHy.Fragment));
const $b082cfc5b9e74dcc$var$CELL_PADDING = 8;
const $b082cfc5b9e74dcc$var$HIERARCHY_LEVEL_PADDING = 12;
const $b082cfc5b9e74dcc$var$EXPAND_ICON_WIDTH = 24;
const $b082cfc5b9e74dcc$export$91a9bd0bc931a6e5 = ({ issueRef: issueRef, itemsConnectionId: itemsConnectionId, depth: depth, isRowHoveredOrSelected: isRowHoveredOrSelected, createChildTriggerProps: createChildTriggerProps, isCreateChildFormVisible: isCreateChildFormVisible, groupId: groupId, renderContent: renderContent, isHierarchyEnabled: isHierarchyEnabled, isFocused: isFocused })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $hAuys.default), issueRef);
    const hasChildren = Boolean(issueData?.hasChildren);
    const canHaveChildIssues = Boolean(issueData?.canHaveChildIssues);
    const issueId = issueData?.node?.issueId;
    const isChildIssueCreateEnabled = (0, $34oCh.useIsChildIssueCreateEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    // State for managing hover
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const isMergedCellFocusedOrHovered = (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? isFocused || isHovered : Boolean(isRowHoveredOrSelected);
    let showCreateChildButton;
    if ((0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) showCreateChildButton = isGridNavigationEnabled ? isChildIssueCreateEnabled && isMergedCellFocusedOrHovered && canHaveChildIssues : isChildIssueCreateEnabled && canHaveChildIssues;
    else showCreateChildButton = isChildIssueCreateEnabled && isMergedCellFocusedOrHovered && canHaveChildIssues;
    const createChildButton = showCreateChildButton && issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.CreateChildButtonWithExpandToggle), {
        depth: depth,
        itemId: issueId,
        groupId: groupId,
        itemsConnectionId: itemsConnectionId,
        createChildTriggerProps: createChildTriggerProps,
        isCreateChildFormVisible: isCreateChildFormVisible,
        renderIcon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                ...iconProps,
                color: "var(--ds-icon)",
                size: "small"
            })
    });
    let childCreateButton;
    if ((0, $4cTDP.fg)('jira_list_merged_column_inline_create_icon_style')) childCreateButton = !isGridNavigationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell.child-create-button-wrap",
        xcss: $b082cfc5b9e74dcc$var$actionButtonDisplayVariableStyle
    }, createChildButton) : createChildButton;
    else childCreateButton = createChildButton;
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const contextualItemMenu = ((0, $4cTDP.fg)('refactor_issue_table_for_timline') || isTimelineEnabled) && timelineCustomComponents?.ContextualItemMenu && issueData?.node?.id && isMergedCellFocusedOrHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.ContextualItemMenu, {
        id: issueData.node.id
    }) : null;
    const onMouseLeaveHandler = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const onMouseEnterHandler = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, childCreateButton, contextualItemMenu);
    let shouldShowExpandButton = hasChildren;
    if (isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates')) shouldShowExpandButton = isHierarchyEnabled && shouldShowExpandButton;
    if (shouldShowExpandButton && issueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b082cfc5b9e74dcc$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell",
        xcss: $b082cfc5b9e74dcc$var$cellStyles,
        tabIndex: isGridNavigationEnabled ? undefined : 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${$b082cfc5b9e74dcc$var$HIERARCHY_LEVEL_PADDING * depth + $b082cfc5b9e74dcc$var$CELL_PADDING}px`
        },
        "data-vc": "merged-cell",
        ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onMouseEnter: onMouseEnterHandler,
            onMouseLeave: onMouseLeaveHandler
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b082cfc5b9e74dcc$var$expandButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2XtSM.ExpandButton), {
        itemId: issueId,
        itemsConnectionId: itemsConnectionId,
        depth: depth
    })), renderContent({
        actionButtons: actionButtons,
        isMergedCellFocusedOrHovered: (0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? isMergedCellFocusedOrHovered : undefined
    })));
    const cellPadding = isHierarchyEnabled ? $b082cfc5b9e74dcc$var$EXPAND_ICON_WIDTH + $b082cfc5b9e74dcc$var$HIERARCHY_LEVEL_PADDING * depth + $b082cfc5b9e74dcc$var$CELL_PADDING : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b082cfc5b9e74dcc$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "native-issue-table.ui.row.issue-row.merged-cell",
        xcss: $b082cfc5b9e74dcc$var$cellStyles,
        tabIndex: isGridNavigationEnabled ? undefined : 0,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            paddingLeft: `${cellPadding}px`
        },
        "data-vc": "merged-cell",
        ...(0, $4cTDP.fg)('jira_list_merged_cell_action_buttons_visibility') ? {
            onMouseEnter: onMouseEnterHandler,
            onMouseLeave: onMouseLeaveHandler
        } : {}
    }, renderContent({
        actionButtons: actionButtons,
        isMergedCellFocusedOrHovered: isMergedCellFocusedOrHovered
    })));
};
const $b082cfc5b9e74dcc$var$cellStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: ' 100%',
    position: 'relative',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $b082cfc5b9e74dcc$var$expandButtonStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $b082cfc5b9e74dcc$var$actionButtonDisplayVariableStyle = (0, $1DXK0.xcss)({
    display: 'var(--action-button-display, "flex")'
});

});
parcelRegister("hAuys", function(module, exports) {
$parcel$export(module.exports, "default", () => $44813bfedd3d1d2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c6395281e13821d5d028f0321900902>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $44813bfedd3d1d2d$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "MergedCell",
    "selections": [
        {
            "condition": "shouldQueryHasChildren",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "hasChildren"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canHaveChildIssues"
                }
            ]
        },
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ]
        }
    ],
    "type": "JiraIssueEdge"
};
$44813bfedd3d1d2d$var$node.hash = "5ab28427c1039e081714dcbb034b2728";
var $44813bfedd3d1d2d$export$2e2bcd8739ae039 = $44813bfedd3d1d2d$var$node;

});


parcelRegister("69bTC", function(module, exports) {
$parcel$export(module.exports, "getMergedFields", () => $9857920eda2307ec$export$dd9429df1dba0f03);

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");
const $9857920eda2307ec$export$dd9429df1dba0f03 = (fieldSetsData)=>{
    const nodes = fieldSetsData?.edges?.flatMap((edgeData)=>edgeData?.node?.fields?.edges?.map((edge)=>edge?.node) ?? []);
    let issueTypeField;
    let issueKeyField;
    let summaryField;
    let fieldId;
    nodes?.forEach((node)=>{
        if (node?.__typename === 'JiraIssueTypeField') issueTypeField = node;
        else if (node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).ISSUE_KEY) issueKeyField = node;
        else if (node?.__typename === 'JiraSingleLineTextField' && node?.type === (0, $j8Km1.KNOWN_COLUMN_TYPES).SUMMARY) {
            summaryField = node;
            if ((0, $4cTDP.fg)('issue_table_single_line_row_height_event_delegator')) fieldId = node?.id;
        }
    });
    return {
        issueTypeField: issueTypeField,
        issueKeyField: issueKeyField,
        summaryField: summaryField,
        fieldId: fieldId
    };
};

});


parcelRegister("8zNZc", function(module, exports) {
$parcel$export(module.exports, "useRowColor", () => $1d5c36051e2adc81$export$b08eff1e3a7a6523);

var $6NQWj = parcelRequire("6NQWj");

var $e8bbU = parcelRequire("e8bbU");

var $5ADnz = parcelRequire("5ADnz");

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $j4oe4 = parcelRequire("j4oe4");

var $5d1YD = parcelRequire("5d1YD");

var $4cTDP = parcelRequire("4cTDP");

var $jUTKf = parcelRequire("jUTKf");

var $34oCh = parcelRequire("34oCh");
const $1d5c36051e2adc81$export$b08eff1e3a7a6523 = (fieldSets, project, formattingRules)=>{
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const isSavedViewConditionalFormattingEnabled = (0, $4cTDP.fg)('saved_list_view_technical_changes') && isConditionalFormattingEnabled;
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const fields = (0, $j4oe4.useFragment)((0, $5ADnz.default), isConditionalFormattingEnabled ? fieldSets : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesOld = (0, $j4oe4.useFragment)((0, $e8bbU.default), isConditionalFormattingEnabled ? project ?? null : null);
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks
    const rulesNew = (0, $j4oe4.useFragment)((0, $6NQWj.default), isSavedViewConditionalFormattingEnabled ? formattingRules : null);
    const rules = isSavedViewConditionalFormattingEnabled ? rulesNew : rulesOld?.conditionalFormattingRules;
    const valuesByFieldId = (0, $eJOHy.useMemo)(()=>{
        if (!isConditionalFormattingEnabled || rules?.edges == null || rules?.edges.length === 0 || fields?.edges == null || fields?.edges?.length === 0) return null;
        const localMap = new Map();
        fields.edges.forEach((fieldSet)=>fieldSet?.node?.fields?.edges?.forEach((fieldEdge)=>{
                const field = fieldEdge?.node;
                switch(field?.__typename){
                    case 'JiraSingleLineTextField':
                        localMap.set(field.fieldId, field.text);
                        break;
                    case 'JiraLabelsField':
                        {
                            const names = field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name).filter((name)=>name != null) ?? [];
                            localMap.set(field.fieldId, names);
                            break;
                        }
                    case 'JiraComponentsField':
                        {
                            const ids = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.componentId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectUserPickerField':
                        localMap.set(field.fieldId, field.user?.accountId ?? 'UNASSIGNED');
                        break;
                    case 'JiraDatePickerField':
                        {
                            const parsedDate = field.date ? (0, $kQ82p.default)(field.date) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraDateTimePickerField':
                        {
                            const parsedDate = field.dateTime ? (0, $kQ82p.default)(field.dateTime) : undefined;
                            localMap.set(field.fieldId, parsedDate);
                            break;
                        }
                    case 'JiraNumberField':
                        localMap.set(field.fieldId, field.number);
                        break;
                    case 'JiraPriorityField':
                        localMap.set(field.fieldId, field.priority?.priorityId);
                        break;
                    case 'JiraProjectField':
                        localMap.set(field.fieldId, field.project?.projectId);
                        break;
                    case 'JiraSingleVersionPickerField':
                        localMap.set(field.fieldId, field.version?.versionId);
                        break;
                    case 'JiraIssueTypeField':
                        localMap.set(field.fieldId, field.issueType?.issueTypeId);
                        break;
                    case 'JiraStatusField':
                        localMap.set(field.fieldId, field.status?.statusId);
                        break;
                    case 'JiraMultipleSelectUserPickerField':
                        {
                            const ids = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node?.accountId).filter((componentId)=>componentId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSprintField':
                        {
                            const ids = field.selectedSprintsConnection?.edges?.map((edge)=>edge?.node?.sprintId).filter((sprintId)=>sprintId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraMultipleVersionPickerField':
                        {
                            const ids = field.selectedVersionsConnection?.edges?.map((edge)=>edge?.node?.versionId).filter((versionId)=>versionId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraSingleSelectField':
                        localMap.set(field.fieldId, field.selectedValue?.id);
                        break;
                    case 'JiraMultipleSelectField':
                        {
                            const ids = field.selectedValues?.edges?.map((edge)=>edge?.node?.id).filter((selectedValueId)=>selectedValueId != null) ?? [];
                            localMap.set(field.fieldId, ids);
                            break;
                        }
                    case 'JiraRadioSelectField':
                        localMap.set(field.fieldId, field.selectedOption?.label);
                        break;
                    // TODO: Add all supported types value mapping
                    default:
                        break;
                }
            }));
        return localMap;
    }, [
        fields,
        isConditionalFormattingEnabled,
        rules
    ]);
    const formatRule = (0, $eJOHy.useMemo)(()=>{
        const formattingRulesEdges = rules?.edges;
        if (formattingRulesEdges == null || formattingRulesEdges.length === 0 || !isConditionalFormattingEnabled || valuesByFieldId == null) return null;
        for (const rule of formattingRulesEdges){
            const isRowRule = rule?.node?.formattingArea === 'ROW';
            const expression = rule?.node?.expression;
            const fieldId = expression?.fieldId;
            const value = expression?.value ?? expression?.values;
            const operator = expression?.noValueOperator ?? expression?.singleValueOperator ?? expression?.multipleValueOperator;
            if (fieldId && operator && isRowRule) {
                const fieldValue = valuesByFieldId.get(fieldId);
                const ruleResult = (0, $5d1YD.evaluateRule)(operator, fieldValue, value);
                if (ruleResult) return rule;
            }
        }
        return null;
    }, [
        valuesByFieldId,
        rules,
        isConditionalFormattingEnabled
    ]);
    const key = formatRule?.node?.formattingColor?.colorKey;
    if (!key) return null;
    return (0, $jUTKf.formattingColors)[key];
};

});
parcelRegister("6NQWj", function(module, exports) {
$parcel$export(module.exports, "default", () => $30930b5555c0c3c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e318d100a45089dcaa0c24955654187>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $30930b5555c0c3c5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor_savedView_rules",
        "selections": [
            {
                "concreteType": "JiraFormattingRuleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "singleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "value"
                                            }
                                        ],
                                        "type": "JiraFormattingSingleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "multipleValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "values"
                                            }
                                        ],
                                        "type": "JiraFormattingMultipleValueOperand"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "alias": "noValueOperator",
                                                "kind": "ScalarField",
                                                "name": "operator"
                                            }
                                        ],
                                        "type": "JiraFormattingNoValueOperand"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "formattingArea"
                            },
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "formattingColor",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraFormattingRuleConnection"
    };
}();
$30930b5555c0c3c5$var$node.hash = "7c7d190a153839738109032a75510a88";
var $30930b5555c0c3c5$export$2e2bcd8739ae039 = $30930b5555c0c3c5$var$node;

});

parcelRegister("e8bbU", function(module, exports) {
$parcel$export(module.exports, "default", () => $82f4bf3392747b6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3d97f71041d11de8c9cd397ded5bf12>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82f4bf3392747b6f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor_rules",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "conditionalFormattingRules(first:20)"
            }
        ],
        "type": "JiraProject"
    };
}();
$82f4bf3392747b6f$var$node.hash = "8b3aacb9e958c242bd940634ade5587f";
var $82f4bf3392747b6f$export$2e2bcd8739ae039 = $82f4bf3392747b6f$var$node;

});

parcelRegister("5ADnz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7aa3a594a10f6dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94579dfd4800f7632c62705d9e723d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7aa3a594a10f6dc$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "versionId"
        }
    ], v4 = [
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useRowColor",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraComponentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedComponentsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraComponentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponent",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "componentId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraComponentsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraLabelConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedLabelsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraLabelEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraLabel",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraUserConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedUsersConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "date"
                                                            }
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "dateTime"
                                                            }
                                                        ],
                                                        "type": "JiraDateTimePickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "number"
                                                            }
                                                        ],
                                                        "type": "JiraNumberField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraPriority",
                                                                "kind": "LinkedField",
                                                                "name": "priority",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "priorityId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "projectId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraProjectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSprintConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedSprintsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprintEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSprint",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "sprintId"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "version",
                                                                "plural": false,
                                                                "selections": v3 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": v0 /*: any*/ ,
                                                                "concreteType": "JiraVersionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedVersionsConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v3 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                                            }
                                                        ],
                                                        "type": "JiraMultipleVersionPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "selectedValue",
                                                                "plural": false,
                                                                "selections": v4 /*: any*/ 
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraSelectableValueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedValues",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": v4 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraMultipleSelectField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": "label",
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraRadioSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$b7aa3a594a10f6dc$var$node.hash = "ee73292706be38f260a2451ef8fc0bc2";
var $b7aa3a594a10f6dc$export$2e2bcd8739ae039 = $b7aa3a594a10f6dc$var$node;

});



parcelRegister("f9D6R", function(module, exports) {
$parcel$export(module.exports, "RowsAdditionalContentRenderer", () => $a2123f66dc9ec48b$export$62e57fc2b6b904bc);

var $1vhxx = parcelRequire("1vhxx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9r0oq = parcelRequire("9r0oq");
const $a2123f66dc9ec48b$export$62e57fc2b6b904bc = ({ depth: depth, groupId: groupId, issues: issues })=>{
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    const issuesData = (0, $j4oe4.useFragment)((0, $1vhxx.default), issues);
    return timelineCustomComponents?.RowsAdditionalContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.RowsAdditionalContent, {
        depth: depth,
        groupId: groupId,
        issues: issuesData
    });
};

});
parcelRegister("1vhxx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a3a0d5d8521a953$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b6f75448a7ba7acd2e2baf149013c32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a3a0d5d8521a953$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RowsAdditionalContentRenderer",
    "selections": [
        {
            "condition": "isTimelineEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TimelineRowsContent"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$4a3a0d5d8521a953$var$node.hash = "fa60dcc2c4e7e90daa4d28978abe34b9";
var $4a3a0d5d8521a953$export$2e2bcd8739ae039 = $4a3a0d5d8521a953$var$node;

});


parcelRegister("km3XC", function(module, exports) {
$parcel$export(module.exports, "VirtualizedRows", () => $ec1352550c791a56$export$bfdb633a3745996);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("gMNDC");
var $8GBQp = parcelRequire("8GBQp");

var $Kdcei = parcelRequire("Kdcei");

var $34oCh = parcelRequire("34oCh");
const $ec1352550c791a56$export$bfdb633a3745996 = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, children: children })=>{
    const virtualizer = (0, $Kdcei.useVirtualization)();
    if (virtualizer == null) return children();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec1352550c791a56$var$VirtualizedRowsInner, {
        hasSpacers: hasSpacers,
        columnsCount: columnsCount,
        virtualizer: virtualizer
    }, children);
};
const $ec1352550c791a56$var$VirtualizedRowsInner = ({ hasSpacers: hasSpacers, columnsCount: columnsCount, virtualizer: virtualizer, children: children })=>{
    const virtualItemsMap = (0, $Kdcei.useVirtualItemsMap)();
    const virtualItemsMapRef = (0, $eJOHy.useRef)(virtualItemsMap);
    virtualItemsMapRef.current = virtualItemsMap;
    const isItemVirtual = (0, $eJOHy.useCallback)((key)=>Boolean(virtualItemsMapRef.current[key]), []);
    const items = virtualizer.getVirtualItems();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    // Calculates the height (top and bottom) of the non rendered portion of table
    const [before, after] = items.length > 0 ? [
        (0, $8GBQp.notUndefined)(items[0]).start - virtualizer.options.scrollMargin,
        virtualizer.getTotalSize() - (0, $8GBQp.notUndefined)(items.at(-1)).end
    ] : [
        0,
        0
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasSpacers && before > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        ...isGridNavigationEnabled && {
            'aria-hidden': true
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-top-spacer-height': `${before}px`
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1m6g"
        ])
    })), children(isItemVirtual, virtualizer.measureElement), hasSpacers && after > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", {
        ...isGridNavigationEnabled && {
            'aria-hidden': true
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("td", {
        colSpan: columnsCount,
        // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
        style: {
            '--local-row-bottom-spacer-height': `${after}px`
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3ibvba"
        ])
    })));
};
const $ec1352550c791a56$var$virtualRowStyles = null;
const $ec1352550c791a56$var$virtualTopSpacerStyles = null;
const $ec1352550c791a56$var$virtualBottomSpacerStyles = null;

});



parcelRegister("d2QWN", function(module, exports) {
$parcel$export(module.exports, "Header", () => $c31e1dc5d3cdffb4$export$8b251419efc915eb);

var $gV312 = parcelRequire("gV312");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $exQoy = parcelRequire("exQoy");

var $3nrCN = parcelRequire("3nrCN");

var $1l4lS = parcelRequire("1l4lS");

var $bGx3v = parcelRequire("bGx3v");

var $isfFo = parcelRequire("isfFo");

var $EzBXZ = parcelRequire("EzBXZ");

var $j8Km1 = parcelRequire("j8Km1");

var $9cbmy = parcelRequire("9cbmy");

var $bJscI = parcelRequire("bJscI");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $jE8Tu = parcelRequire("jE8Tu");

var $f2JN3 = parcelRequire("f2JN3");

var $ac9c5 = parcelRequire("ac9c5");

var $cgCO4 = parcelRequire("cgCO4");

var $8FfYE = parcelRequire("8FfYE");

var $8jOO7 = parcelRequire("8jOO7");

var $johMb = parcelRequire("johMb");

var $9r0oq = parcelRequire("9r0oq");

var $kbYhH = parcelRequire("kbYhH");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $c4xBS = parcelRequire("c4xBS");

var $6UQ01 = parcelRequire("6UQ01");

var $3utN3 = parcelRequire("3utN3");
const $c31e1dc5d3cdffb4$var$BORDER_WIDTH = '1px';
const $c31e1dc5d3cdffb4$var$RESIZE_HANDLE_Z_INDEX = 1;
const $c31e1dc5d3cdffb4$var$MaybeInlineFieldCreateOnboardingProvider = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), (0, $c4xBS.InlineFieldCreateOnboardingProvider), ({ children: children })=>children);
const $c31e1dc5d3cdffb4$var$baseHeaderContainerCellStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-radius-large, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-radius-large, 8px)",
        borderRightWidth: 0
    }
};
const $c31e1dc5d3cdffb4$var$baseHeaderContainerCellKeyboardStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $c31e1dc5d3cdffb4$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-radius-large, 8px)",
        '&:focus::before': {
            left: '-1px',
            width: 'calc(100% + 3px)',
            height: 'calc(100% + 4px)',
            borderTopLeftRadius: "var(--ds-radius-large, 8px)"
        }
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-radius-large, 8px)",
        borderRightWidth: 0,
        '&:focus::before': {
            borderTopRightRadius: "var(--ds-radius-large, 8px)"
        }
    },
    '&:focus': {
        outline: 'unset',
        '&:before': {
            content: ' ',
            boxSizing: 'border-box',
            display: 'block',
            position: 'absolute',
            height: 'calc(100% + 4px)',
            width: 'calc(100% + 5px)',
            inset: '0px',
            left: '-3px',
            top: '-2px',
            border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }
};
const $c31e1dc5d3cdffb4$var$HEADER_HEIGHT = 40;
const $c31e1dc5d3cdffb4$var$STICKY_CELL_Z_INDEX = $c31e1dc5d3cdffb4$var$RESIZE_HANDLE_Z_INDEX + 1; // exported for testing purposes
const $c31e1dc5d3cdffb4$var$triggerColumnFlash = (table, index)=>{
    const columnCellsSelector = `th:nth-of-type(${index + 1}), td:nth-of-type(${index + 1})`;
    Array.from(table.querySelectorAll(columnCellsSelector)).filter((element)=>element instanceof HTMLElement).forEach((element)=>(0, $exQoy.triggerPostMoveFlash)(element));
};
const $c31e1dc5d3cdffb4$export$8b251419efc915eb = /*#__PURE__*/ (0, $eJOHy.memo)(({ view: view, columnPickerProps: columnPickerProps, columns: columns, canViewColumnConfiguration: canViewColumnConfiguration, canEditColumnConfiguration: canEditColumnConfiguration, isCompactColumnEnabled: isCompactColumnEnabled = false, resizeHandleType: resizeHandleType, onColumnsChange: onColumnsChange, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, tableRef: tableRef, tableBorderRadius: tableBorderRadius, showNoColumns: showNoColumns, resizingColumnIndex: resizingColumnIndex, setResizingColumnIndex: setResizingColumnIndex, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const timelineCustomComponents = (0, $9r0oq.useTimelineCustomComponents)();
    let isStickyColumnsVisible = false;
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    } else {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const viewData = (0, $j4oe4.useFragment)((0, $gV312.default), view ?? null); // Unique identifier for the header of this particular issue table instance
    const [instanceId] = (0, $eJOHy.useState)(()=>Symbol('pdnd-issue-table-header'));
    const [lastReorderOperation, setLastReorderOperation] = (0, $eJOHy.useState)(null);
    const [screenReaderMessage, setScreenReaderMessage] = (0, $eJOHy.useState)('');
    const reorderColumn = (0, $eJOHy.useCallback)(({ startIndex: startIndex, indexOfTarget: indexOfTarget, closestEdgeOfTarget: closestEdgeOfTarget = null, analyticsAttributes: analyticsAttributes = {} })=>{
        const finishIndex = (0, $1l4lS.getReorderDestinationIndex)({
            axis: 'horizontal',
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: closestEdgeOfTarget
        });
        if (startIndex === finishIndex) return;
        const newColumns = (0, $isfFo.reorder)({
            list: columns,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        onColumnsChange?.(newColumns);
        setLastReorderOperation({
            finishIndex: finishIndex
        });
        setScreenReaderMessage(formatMessage((0, $3utN3.default).movedColumn, {
            column: columns[startIndex]?.title,
            previousPosition: startIndex + 1,
            position: finishIndex + 1,
            // TODO: EM-7165 update to columns.length when excluding column picker
            total: columns.length - 1
        }));
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'reordered',
            actionSubject: 'columns'
        }), 'issueTable', analyticsAttributes);
    }, [
        columns,
        createAnalyticsEvent,
        formatMessage,
        onColumnsChange
    ]);
    const stickyColumnsWidth = (0, $4cTDP.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $8FfYE.calculateStickyColumnsWidth)(columns), [
        columns
    ]) : 0; // Calculate the amount of moveable columns in the table
    const totalMoveableColumns = (0, $eJOHy.useMemo)(()=>{
        if (!columns.length) return 0;
        const nonMovableColumnIds = [
            (0, $8jOO7.COLUMN_ID_TIMELINE),
            (0, $8jOO7.COLUMN_ID_CHECKBOX),
            (0, $j8Km1.COLUMN_ID_MERGED_COLUMN),
            (0, $8jOO7.COLUMN_ID_MEATBALL_MENU)
        ]; // Count how many of these non-movable columns actually exist in the current column set
        const nonMovableCount = columns.filter((column)=>nonMovableColumnIds.includes(column.id)).length;
        return columns.length - nonMovableCount;
    }, [
        columns
    ]); // We use an object for lastReorderOperation so we can trigger the column flash
    // if the finish index is the same as the previous reorder operation.
    (0, $eJOHy.useEffect)(()=>{
        const table = tableRef?.current;
        if (table && lastReorderOperation !== null) $c31e1dc5d3cdffb4$var$triggerColumnFlash(table, lastReorderOperation.finishIndex);
    }, [
        lastReorderOperation,
        tableRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!canEditColumnConfiguration) return;
        return (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const startIndex = columns.findIndex((column)=>column.id === source.data.id);
                if (startIndex === -1) return;
                const indexOfTarget = columns.findIndex((column)=>column.id === destination.data.id);
                if (indexOfTarget === -1) return;
                const closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                reorderColumn({
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    analyticsAttributes: {
                        operation: 'drop'
                    }
                });
            }
        });
    }, [
        columns,
        canEditColumnConfiguration,
        instanceId,
        reorderColumn,
        tableRef
    ]);
    const onMoveColumn = (index, position)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) switch(position){
            case 0, $8jOO7.MOVE_COLUMN_FIRST:
                if (index > 0) {
                    let indexOfTarget = 0;
                    const allowMergedColumnReordering = enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate');
                    if (!allowMergedColumnReordering && (0, $4cTDP.fg)('jira_list_merged_column_move_first')) indexOfTarget = columns.findIndex((column)=>column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) + 1;
                    reorderColumn({
                        startIndex: index,
                        indexOfTarget: indexOfTarget,
                        closestEdgeOfTarget: 'left',
                        analyticsAttributes: {
                            operation: 'move-first'
                        }
                    });
                }
                break;
            case 0, $8jOO7.MOVE_COLUMN_LEFT:
                if (index > 0) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index - 1,
                    closestEdgeOfTarget: 'left',
                    analyticsAttributes: {
                        operation: 'move-left'
                    }
                });
                break;
            case 0, $8jOO7.MOVE_COLUMN_RIGHT:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    indexOfTarget: index + 1,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-right'
                    }
                });
                break;
            case 0, $8jOO7.MOVE_COLUMN_LAST:
                // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                if (index < columns.length - 2) reorderColumn({
                    startIndex: index,
                    // TODO: EM-7165 change this to `columns.length - 1` when excluding column picker
                    indexOfTarget: columns.length - 2,
                    closestEdgeOfTarget: 'right',
                    analyticsAttributes: {
                        operation: 'move-last'
                    }
                });
                break;
            default:
                throw new Error(`Unexpected target column position ${position}`);
        }
    };
    const onRemoveColumn = (index)=>{
        if (canEditColumnConfiguration && onColumnsChange !== undefined) {
            const newColumns = [
                ...columns
            ];
            newColumns.splice(index, 1);
            onColumnsChange(newColumns);
        }
    };
    const tableWidth = (0, $kbYhH.useElementSizeSelector)((size)=>size.width);
    const { hasShadowBottom: hasShadowBottom, hasShadowLeft: hasShadowLeft } = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft, width: containerWidth } = scrollState;
        return {
            hasShadowBottom: scrollTop > 0,
            // Scroll measurements are fractional, while width measurements are integer, so we need to round before comparing
            hasShadowLeft: containerWidth < tableWidth && Math.round(scrollLeft) < tableWidth - containerWidth
        };
    });
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const visibleDepth = (0, $jE8Tu.useVisibleDepth)();
    let isChildIssuesTableVisualUpliftEnabled = false;
    if ((0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const handleDropdownStateChange = (isOpen)=>{
        setIsDropdownOpen(isOpen);
    };
    const hasMeatball = columns.some((column)=>column.type === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU));
    const hasTimeline = columns.some((column)=>column.id === (0, $8jOO7.COLUMN_ID_TIMELINE));
    let lastDataColumnIndex = columns.length - 1; // Count fixed-position columns from the end
    if (hasMeatball) lastDataColumnIndex--;
    if (hasTimeline) lastDataColumnIndex--;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tr", null, columns.map((column, index)=>{
        const { isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets } = column;
        const isExpandColumn = column.id === (0, $j8Km1.COLUMN_ID_EXPAND_BUTTON);
        const isMergedColumn = column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_column_gate');
        const isMeatballMenu = column.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU);
        const defaultColumnWidth = column.customWidth ?? column.defaultWidth;
        const columnWidth = isExpandColumn || isMergedColumn ? (0, $johMb.getExpandColumnWidth)(visibleDepth) : defaultColumnWidth;
        let hasShadow = isExpandColumn ? false : canViewColumnConfiguration && hasShadowLeft;
        if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) hasShadow = isMeatballMenu && canViewColumnConfiguration && hasShadowLeft;
        let customHeader = column.customHeader;
        let isStickyHeaderContainer = canViewColumnConfiguration;
        if (((0, $4cTDP.fg)('refactor_issue_table_for_timline') || isTimelineEnabled) && timelineCustomComponents?.ColumnHeader && column.id === (0, $8jOO7.COLUMN_ID_TIMELINE)) {
            customHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(timelineCustomComponents.ColumnHeader, null);
            isStickyHeaderContainer = false;
        }
        let isLast = !hasMeatball && (0, $4cTDP.fg)('jracloud-95753_fix_scrollbar_in_chin') ? index === columns.length - 1 : index === columns.length - 2;
        let shouldShowResizeHandle = !(!hasMeatball && isLast); // will override isLast logic above when fg is enabled
        if ((0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) {
            isLast = index === lastDataColumnIndex;
            const isFixedPositionColumn = (0, $8jOO7.FIXED_POSITION_COLUMN_TYPES).includes(column.type); // Show resize handle when: NOT a fixed-position column AND (timeline exists OR meatball exists OR not last)
            shouldShowResizeHandle = !isFixedPositionColumn && (hasTimeline || hasMeatball || !isLast);
        }
        return(// TODO: EM-7165 – refactor column picker logic, separating it from regular columns
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: column.id
        }, // Empty cell to fill remaining space if configured columns are not wide enough to fill the table
        isFixedTableLayoutEnabled && column.id === (0, $8jOO7.COLUMN_ID_MEATBALL_MENU) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c31e1dc5d3cdffb4$var$EmptyHeaderCell, {
            "aria-hidden": true
        }), customHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c31e1dc5d3cdffb4$export$429fd509d8532e18, {
            scope: "col",
            columnWidth: columnWidth,
            // read as the column title when a user is navigating between columns in the table content.
            "aria-label": column.title,
            isSticky: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? isStickyHeaderContainer : canViewColumnConfiguration,
            hasShadow: hasShadow,
            visualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
            isCompactColumnEnabled: isCompactColumnEnabled,
            tableBorderRadius: tableBorderRadius,
            ...(0, $4cTDP.fg)('nin-grid-keyboard-navigation') && {
                tabIndex: index === 0 ? 0 : -1
            },
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isColumnSticky: isColumnSticky,
                stickyOffsets: stickyOffsets
            },
            ...isStickyColumnsVisible && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && {
                isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
            },
            isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isTimelineEnabled: isTimelineEnabled
        }, customHeader) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UQ01.HeaderCell), {
            column: column,
            hasColumnConfiguration: canEditColumnConfiguration,
            instanceId: instanceId,
            isCompactColumnEnabled: isCompactColumnEnabled,
            isFirst: index === 0,
            isLast: isLast,
            ...(0, $4cTDP.fg)('jracloud-95753_fix_scrollbar_in_chin') && {
                shouldHaveResizeHandle: shouldShowResizeHandle
            },
            previousColumn: index === 0 ? undefined : columns[index - 1],
            resizeHandleType: resizeHandleType,
            tableRef: tableRef,
            tableBorderRadius: tableBorderRadius,
            onMoveColumn: (position)=>onMoveColumn(index, position),
            onDropdownStateChange: handleDropdownStateChange,
            onRemoveColumn: ()=>onRemoveColumn(index),
            onResizeColumn: onResizeColumn,
            onFreezeColumn: onFreezeColumn,
            index: index,
            enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isStickyColumnsVisible: isStickyColumnsVisible,
                stickyColumnsWidth: stickyColumnsWidth,
                resizingColumnIndex: resizingColumnIndex,
                setResizingColumnIndex: setResizingColumnIndex
            },
            ...(0, $4cTDP.fg)('nin-grid-keyboard-navigation') && {
                tabIndex: index === 0 ? 0 : -1
            },
            mergedColumnMinWidth: mergedColumnMinWidth,
            ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
                totalMoveableColumns: totalMoveableColumns
            }
        })));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EzBXZ.RenderOnClient), {
        fg: "jfp-magma-nin-hydration-fixes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c31e1dc5d3cdffb4$var$MaybeInlineFieldCreateOnboardingProvider, null, isInBetweenColumnPickerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ac9c5.InsertColumnButton), {
        columns: columns,
        columnPickerProps: columnPickerProps,
        view: viewData,
        isStickyColumnsVisible: isStickyColumnsVisible,
        mergedColumnMinWidth: mergedColumnMinWidth
    }), (isInlineFieldConfigEnabled || isInBetweenColumnPickerEnabled) && !showNoColumns && (0, $4cTDP.fg)('jira_inline_field_config_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4xBS.InlineFieldCreateOnboarding), null))), (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_targeting') ? screenReaderMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderCaption), {
        "aria-live": "assertive",
        "data-testid": "native-issue-table.ui.issue-table.header.screen-reader-caption"
    }, screenReaderMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("thead", {
        className: (0, $hcewu.default)([
            isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') ? "_kqsw1if8 _154iidpf _1pby1406" : "_kqsw1if8 _154iidpf _1pbycs5v",
            isDropdownOpen && "_1pbyjwwv",
            hasShadowBottom && (0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') && "_16qs9g9j",
            hasShadowBottom && !(0, $4cTDP.fg)('reduce_size_of_scroll_container_shadow') && "_16qs1fgp"
        ])
    }, content));
});
const $c31e1dc5d3cdffb4$var$baseStickyHeaderStylesOld = null; // When a column is frozen, the table cell has z-index: 7. The header must have a higher z-index(8) to avoid being visually covered by the cell during vertical scrolling.
const $c31e1dc5d3cdffb4$var$baseStickyHeaderStyles = null;
const $c31e1dc5d3cdffb4$var$increasedZIndexStyles = null; // remove when cleaning up reduce_size_of_scroll_container_shadow
const $c31e1dc5d3cdffb4$var$shadowStylesOld = null;
const $c31e1dc5d3cdffb4$var$shadowStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c31e1dc5d3cdffb4$var$HeaderCellContainerStyledCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isTimelineEnabled: isTimelineEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $awdRS.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcd1mok _4x861mok _1nd4idpf _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && __cmplp.isColumnSticky && "_z115qete _16sigrf3",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isTimelineEnabled && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c31e1dc5d3cdffb4$var$HeaderCellContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isGridNavigationEnabled: isGridNavigationEnabled, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isTimelineEnabled: isTimelineEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_1vpctke": (0, $awdRS.default)(__cmplp.stickyOffsets, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1rjcze3t _18zru2gc _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isGridNavigationEnabled ? "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcd1mok _1av71n1a _jrfr1p7v _1vhm1pbc _cdln1mok _4x861mok _1nd4idpf _1obq1mok _nt751r31 _49pcn7od _1hvw1o36 _2qv9idpf _qzh6ugt7 _x7uvf705 _6i55usvi _1j5l1ule _1qtkstnw _1w0p1pbc _1814iopo _p0vij39m _1cl912gs" : "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcd1mok _4x861mok _1nd4idpf",
            __cmplp.isGridNavigationEnabled && "_nt751r31 _49pcn7od _1hvw1o36 _858upm4j _1ya5nqa1 _1mb8dkaa",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv1l64",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && __cmplp.isColumnSticky && "_z115qete _16sigrf3",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isTimelineEnabled && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // Exported for testing
const $c31e1dc5d3cdffb4$export$429fd509d8532e18 = (0, $bJscI.componentWithFG)('nin-grid-keyboard-navigation', $c31e1dc5d3cdffb4$var$HeaderCellContainerNew, $c31e1dc5d3cdffb4$var$HeaderCellContainerStyledCell); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c31e1dc5d3cdffb4$var$EmptyHeaderCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jidpf _1rcd1mok _4x861mok _1nd4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gV312", function(module, exports) {
$parcel$export(module.exports, "default", () => $07a1e40735fb6af1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2242e7128755b781c99f2ad1c8164ba1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07a1e40735fb6af1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HeaderCellContainer",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "InsertColumnButton"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$07a1e40735fb6af1$var$node.hash = "8c7ed6259e396b6167d470ec77da7fd5";
var $07a1e40735fb6af1$export$2e2bcd8739ae039 = $07a1e40735fb6af1$var$node;

});

parcelRegister("ac9c5", function(module, exports) {
$parcel$export(module.exports, "InsertColumnButton", () => $fb42fc247ec374bd$export$ce61804b1701b38c);

var $fQn57 = parcelRequire("fQn57");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $PETi0 = parcelRequire("PETi0");

var $jE8Tu = parcelRequire("jE8Tu");

var $88wTt = parcelRequire("88wTt");

var $9NBLG = parcelRequire("9NBLG");

var $j8Km1 = parcelRequire("j8Km1");

var $f2JN3 = parcelRequire("f2JN3");

var $c4xBS = parcelRequire("c4xBS");

var $johMb = parcelRequire("johMb");

var $6KVf0 = parcelRequire("6KVf0");

var $7n9BS = parcelRequire("7n9BS");


var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $7XD6x = parcelRequire("7XD6x");
// Height/width of the popup button
const $fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE = 24;
// Height/width of the reference element the popup button is anchored to
const $fb42fc247ec374bd$var$REFERENCE_SIZE = 1;
const $fb42fc247ec374bd$var$constantModifiers = [
    {
        name: 'flip',
        enabled: false
    }
];
const $fb42fc247ec374bd$export$582d36594507a709 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns'), (0, $9NBLG.default), (0, $88wTt.default));
const $fb42fc247ec374bd$export$96c0bbf49f7c219f = ({ view: view, columns: columns, columnPickerProps: columnPickerProps, isStickyColumnsVisible: isStickyColumnsVisible, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const [{ index: columnIndex }] = (0, $6KVf0.useInlineFieldCreateActiveIndex)();
    const [{ isOpen: isOpen }, { close: close }] = (0, $PETi0.useColumnPickerOpenState)();
    const { lockIndex: lockIndex, clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex, setIsHovered: setIsHovered, clearIsHovered: clearIsHovered } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding } = (0, $c4xBS.useInlineFieldCreateOnboardingContext)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isInBetweenStickyColumnPickerEnabled = (0, $34oCh.useIsInBetweenStickyColumnPickerEnabled)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const projectContext = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $34oCh.useProjectContext)() : undefined;
    const viewData = (0, $j4oe4.useFragment)((0, $fQn57.default), view);
    const visibleDepth = (0, $jE8Tu.useVisibleDepth)();
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const firstFieldColumnIndex = (0, $eJOHy.useMemo)(()=>{
        return columns.findIndex((column)=>!column.id.startsWith((0, $8jOO7.COLUMN_ID_INTERNAL_COLUMN))) - 1;
    }, [
        columns
    ]);
    const hasShownOnboarding = (0, $eJOHy.useRef)(false);
    const shouldShowOnboarding = showInlineFieldCreateOnboarding && !hasShownOnboarding.current;
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    if (shouldShowOnboarding) {
        setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), firstFieldColumnIndex);
        lockIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        hasShownOnboarding.current = true;
    }
    const columnsWidth = (0, $eJOHy.useMemo)(()=>columns.map((column)=>{
            if (column.id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON)) return (0, $johMb.getExpandColumnWidth)(visibleDepth);
            if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && column.mergedColumns && column.mergedColumns.length > 1) {
                if ((0, $4cTDP.fg)('refactor_issue_table_for_timline')) return Math.max(mergedColumnMinWidth ?? (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
                return Math.max(isTimelineEnabled ? (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH_TIMELINE) : (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
            }
            return column.customWidth ?? column.defaultWidth;
        }), [
        columns,
        isTimelineEnabled,
        mergedColumnMinWidth,
        visibleDepth
    ]);
    const fixedColumnCount = (0, $eJOHy.useMemo)(()=>columns.filter((column)=>column.id === (0, $8jOO7.COLUMN_ID_EXPAND_BUTTON) || column.id === (0, $8jOO7.COLUMN_ID_CHECKBOX) || column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) || isStickyColumnsVisible && column.isColumnSticky && (!(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') || !isInBetweenStickyColumnPickerEnabled) && (0, $4cTDP.fg)('issue_table_frozen_columns')).length, [
        columns,
        isStickyColumnsVisible,
        isInBetweenStickyColumnPickerEnabled
    ]);
    const mergedColumnsCount = isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? (columns.find((column)=>column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN))?.mergedColumns ?? []).length : 0;
    const isEmptyColumnExist = columnsWidth.length - columns.length === 1;
    const isStickyInsertButtonApplied = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? isInBetweenStickyColumnPickerEnabled && isStickyColumnsVisible && columnIndex != null && columns[columnIndex]?.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') : false;
    let scrollElement = null;
    if ((0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    scrollElement = (0, $7n9BS.useScrollStateSelector)((state)=>state.scrollElement);
    const referenceRef = (0, $eJOHy.useRef)(null);
    const insertButtonXOffset = (0, $eJOHy.useMemo)(()=>{
        if (columnIndex != null && columnsWidth.length > 0) return columnsWidth.slice(0, columnIndex + 1).reduce((acc, width)=>acc + width, -$fb42fc247ec374bd$var$REFERENCE_SIZE);
        return 0;
    }, [
        columnIndex,
        columnsWidth
    ]);
    // Update position of + button on sticky columns using CSS variable on scroll - this will not trigger re renders
    (0, $eJOHy.useEffect)(()=>{
        if (!isStickyInsertButtonApplied || !scrollElement || !referenceRef.current) return;
        const updatePosition = ()=>{
            if (referenceRef.current && scrollElement) // Update CSS variable directly - this will not trigger a re-render
            referenceRef.current.style.setProperty('--scroll-offset', `${scrollElement.scrollLeft}px`);
        };
        updatePosition();
        scrollElement.addEventListener('scroll', updatePosition, {
            passive: true
        });
        return ()=>{
            scrollElement.removeEventListener('scroll', updatePosition);
        };
    }, [
        isStickyInsertButtonApplied,
        scrollElement
    ]);
    const finalOffset = (0, $eJOHy.useMemo)(()=>// Negatively offset the popup by the button + reference size to center the button on the secondary axis
        [
            insertButtonXOffset,
            (0, $8jOO7.INSERT_COLUMN_BUTTON_Y_OFFSET) - ($fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE + $fb42fc247ec374bd$var$REFERENCE_SIZE) / 2
        ], [
        insertButtonXOffset
    ]);
    const modifiers = (0, $eJOHy.useMemo)(()=>{
        // Adjust the overflow calculation for the primary axis so it is relative to the center of the button.
        const alongCenterOffset = -($fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE / 2);
        // Retain the provided offset for the secondary axis
        const padding = {
            top: finalOffset[1],
            left: alongCenterOffset,
            right: alongCenterOffset
        };
        return [
            ...$fb42fc247ec374bd$var$constantModifiers,
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    altAxis: true,
                    padding: padding,
                    altBoundary: true,
                    rootBoundary: 'viewport',
                    tether: false
                }
            },
            {
                name: 'eventListeners',
                options: {
                    // Only recompute position on scroll/resize events while the button is focused to reduce CPU load
                    scroll: isOpen,
                    resize: isOpen
                }
            }
        ];
    }, [
        finalOffset,
        isOpen
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        lockIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        lockIndex
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        !isOpen && clearIndexAfterDelay((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isOpen
    ]);
    const handlePickerMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        setIsHovered
    ]);
    const handlePickerMouseLeave = (0, $eJOHy.useCallback)(()=>{
        clearIsHovered((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIsHovered
    ]);
    const shouldNotShowInsertButton = (0, $eJOHy.useMemo)(()=>columnIndex == null || isEmptyColumnExist && columnIndex >= columnsWidth.length - 3 || // If an empty column exists, prevent inserting in the last two columns.
        !((0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && isStickyInsertButtonApplied) && columnIndex >= columnsWidth.length - 2 || // Prevent inserting on the left or right of the last column unless isStickyInsertButtonApplied.
        columnIndex < fixedColumnCount - 1, [
        columnIndex,
        columnsWidth.length,
        fixedColumnCount,
        isEmptyColumnExist,
        isStickyInsertButtonApplied
    ]);
    if (shouldNotShowInsertButton) {
        if (!shouldShowOnboarding) {
            clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            close();
        }
    }
    if (columnPickerProps) {
        const { components: components, ...props } = columnPickerProps;
        const emptyFooter = (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? {} : {
            Footer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6G5P1.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $azjc1.Reference), null, ({ ref: ref })=>{
            const handleRef = (node)=>{
                if (typeof ref === 'function') ref(node);
                if (isStickyInsertButtonApplied) referenceRef.current = node;
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: [
                    $fb42fc247ec374bd$var$referenceStyles,
                    $fb42fc247ec374bd$var$visuallyHiddenStyles,
                    ...isStickyInsertButtonApplied ? [
                        $fb42fc247ec374bd$var$stickyStyles
                    ] : []
                ],
                ref: (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? handleRef : ref
            });
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), {
            placement: "bottom",
            offset: finalOffset,
            modifiers: modifiers
        }, ({ ref: ref, style: style })=>{
            const styleProps = {
                style: style
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: ref,
                ...styleProps,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: [
                    $fb42fc247ec374bd$var$buttonStyles,
                    shouldNotShowInsertButton && $fb42fc247ec374bd$var$hideStyles,
                    ...isStickyInsertButtonApplied ? [
                        $fb42fc247ec374bd$var$stickyPopperStyles
                    ] : []
                ],
                backgroundColor: "color.background.input",
                testId: `native-issue-table.ui.issue-table.insert-column-button.popper${shouldNotShowInsertButton ? '-hidden' : ''}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb42fc247ec374bd$export$582d36594507a709, {
                ...props,
                view: viewData,
                components: {
                    ...components,
                    ...isInlineFieldConfigEnabled ? {
                        Footer: (0, $7XD6x.IFCFooter)
                    } : emptyFooter
                },
                columnInsertIndex: columnIndex != null ? columnIndex - fixedColumnCount + mergedColumnsCount + 1 : undefined,
                isInBetweenColumnPickerEnabled: true,
                showInlineFieldCreateOnboarding: columnIndex === firstFieldColumnIndex && showInlineFieldCreateOnboarding,
                onPickerMouseEnter: handlePickerMouseEnter,
                onPickerMouseLeave: handlePickerMouseLeave,
                isMergedColumnEnabled: isMergedColumnEnabled,
                isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
                projectContext: projectContext !== null && (0, $4cTDP.fg)('jira_inline_field_config_gate') ? projectContext : undefined
            }));
        }));
    }
    return null;
};
const $fb42fc247ec374bd$export$ce61804b1701b38c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $PETi0.ColumnPickerContainer), {
        scope: (0, $8jOO7.COLUMN_PICKER_ADD_COLUMN_CONTAINER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb42fc247ec374bd$export$96c0bbf49f7c219f, props));
};
const $fb42fc247ec374bd$var$buttonStyles = (0, $1DXK0.xcss)({
    zIndex: 'dialog'
});
const $fb42fc247ec374bd$var$referenceStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    top: `${$fb42fc247ec374bd$var$DEFAULT_BUTTON_SIZE / 2 + 2}px`
});
const $fb42fc247ec374bd$var$hideStyles = (0, $1DXK0.xcss)({
    display: 'none'
});
const $fb42fc247ec374bd$var$stickyStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    left: "var(--ds-space-0, 0px)",
    transform: 'translateX(var(--scroll-offset, 0px))',
    willChange: 'transform'
});
const $fb42fc247ec374bd$var$stickyPopperStyles = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $fb42fc247ec374bd$var$visuallyHiddenStyles = (0, $1DXK0.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clipPath: 'rect(1px 1px 1px 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("fQn57", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8f0a722660891ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea1d68cbf02643e2ccf6c2858ea4f944>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c8f0a722660891ca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "InsertColumnButton",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer_savedViewId"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$c8f0a722660891ca$var$node.hash = "6ab7fc38f11e427975f678187d262f14";
var $c8f0a722660891ca$export$2e2bcd8739ae039 = $c8f0a722660891ca$var$node;

});

parcelRegister("c4xBS", function(module, exports) {
$parcel$export(module.exports, "InlineFieldCreateOnboardingProvider", () => $b87aababb5e9070a$export$de078953583b045f);
$parcel$export(module.exports, "useInlineFieldCreateOnboardingContext", () => $b87aababb5e9070a$export$9649d04db063d324);
$parcel$export(module.exports, "InlineFieldCreateOnboarding", () => $b87aababb5e9070a$export$f07afb14f98859fd);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $3cMgR = parcelRequire("3cMgR");

var $d2s5v = parcelRequire("d2s5v");

var $58yRG = parcelRequire("58yRG");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $iC2Fk = parcelRequire("iC2Fk");

var $9zZj0 = parcelRequire("9zZj0");

var $6zxfT = parcelRequire("6zxfT");

var $kAwwe = parcelRequire("kAwwe");

var $2aY2d = parcelRequire("2aY2d");

var $6KVf0 = parcelRequire("6KVf0");


var $cKKo4 = parcelRequire("cKKo4");

var $i7jEw = parcelRequire("i7jEw");

var $lCPZ7 = parcelRequire("lCPZ7");

var $bgZld = parcelRequire("bgZld");

var $lXTaV = parcelRequire("lXTaV");
const $b87aababb5e9070a$var$useIsProjectAdmin = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};
const $b87aababb5e9070a$export$7749a74b05b28c3e = 'issue-navigator-inline-field-create';
const $b87aababb5e9070a$var$STARGATE_URL = '/gateway/api';
const $b87aababb5e9070a$var$InlineFieldCreateOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $b87aababb5e9070a$export$de078953583b045f = ({ children: children })=>{
    const [showInlineFieldCreateOnboarding, setShowInlineFieldCreateOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showInlineFieldCreateOnboarding: showInlineFieldCreateOnboarding,
            setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding
        }), [
        showInlineFieldCreateOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$InlineFieldCreateOnboardingContext.Provider, {
        value: value
    }, children);
};
const $b87aababb5e9070a$export$9649d04db063d324 = ()=>{
    const inlineFieldCreateOnboardingContext = (0, $eJOHy.useContext)($b87aababb5e9070a$var$InlineFieldCreateOnboardingContext);
    if (!inlineFieldCreateOnboardingContext) throw new Error('useInlineFieldCreateOnboardingContext must be used within a InlineFieldCreateOnboardingProvider');
    return inlineFieldCreateOnboardingContext;
};
const $b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight, isTMPAdmin: isTMPAdmin })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    const actions = isTMPAdmin ? [
        {
            text: formatMessage((0, $lXTaV.default).nextButtonText),
            onClick: ()=>{
                setActiveSpotlight(1);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        },
        {
            text: formatMessage((0, $lXTaV.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        }
    ] : [
        {
            text: formatMessage((0, $lXTaV.default).createFieldDismiss),
            onClick: ()=>{
                setActiveSpotlight(null);
                setShowInlineFieldCreateOnboarding(false);
                clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.in-between",
        messageType: "engagement",
        actions: actions,
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.in-between",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bgZld))) : (0, (/*@__PURE__*/$parcel$interopDefault($lCPZ7))),
        actionsBeforeElement: isTMPAdmin ? '1/2' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $lXTaV.default).inlineColumnCreateBody, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                weight: "bold"
            }, chunks)
    })));
};
const $b87aababb5e9070a$var$InlineFieldCreateOnboardingComponent = ({ setActiveSpotlight: setActiveSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { clearIndex: clearIndex } = (0, $6KVf0.useInlineCreateActiveIndexActions)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    if (!colorMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        pulse: true,
        messageId: "native-issue-table.ui.inline-field-create-onboarding.jira-spotlight.inline-field-create-onboarding-column-picker-button.default",
        messageType: "engagement",
        actions: [
            {
                text: formatMessage((0, $lXTaV.default).createFieldDismiss),
                onClick: ()=>{
                    setActiveSpotlight(null);
                    setShowInlineFieldCreateOnboarding(false);
                    clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
                }
            }
        ],
        dialogPlacement: "bottom right",
        dialogWidth: 320,
        target: "inline-field-create-onboarding-column-picker-button.default",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($i7jEw))) : (0, (/*@__PURE__*/$parcel$interopDefault($cKKo4))),
        actionsBeforeElement: "2/2"
    }, formatMessage((0, $lXTaV.default).createFieldBody));
};
const $b87aababb5e9070a$export$f07afb14f98859fd = ()=>{
    const { setShowInlineFieldCreateOnboarding: setShowInlineFieldCreateOnboarding } = $b87aababb5e9070a$export$9649d04db063d324();
    const cloudId = (0, $cHtIB.useCloudId)();
    const [activeSpotlight, setActiveSpotlight] = (0, $eJOHy.useState)(null);
    const isSiteAdmin = (0, $kAwwe.useIsAdmin)();
    const isProjectAdmin = $b87aababb5e9070a$var$useIsProjectAdmin();
    const isTMP = (0, $2aY2d.useIsSimplifiedProject)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const isTMPAdmin = isAdmin && isTMP;
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $b87aababb5e9070a$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, $b87aababb5e9070a$export$7749a74b05b28c3e);
    const hasShownOnboarding = (0, $eJOHy.useRef)(false);
    if (isEnrolled && !hasShownOnboarding.current) {
        setShowInlineFieldCreateOnboarding(true);
        stopEnrolment(false);
        setActiveSpotlight(0);
        hasShownOnboarding.current = true;
    }
    const renderActiveSpotlight = ()=>{
        const spotlights = isTMPAdmin ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight,
                isTMPAdmin: true
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$InlineFieldCreateOnboardingComponent, {
                key: "inline-field-create",
                setActiveSpotlight: setActiveSpotlight
            })
        ] : [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b87aababb5e9070a$var$ConfigureFieldsOnboardingComponent, {
                key: "configure-fields",
                setActiveSpotlight: setActiveSpotlight
            })
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zxfT.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isEnrolled && activeSpotlight !== null && renderActiveSpotlight()));
};

});
parcelRegister("cKKo4", function(module, exports) {
module.exports = new URL("configure-fields-light.fd3f907d.png", import.meta.url).toString();

});

parcelRegister("i7jEw", function(module, exports) {
module.exports = new URL("configure-fields-dark.cda4df1f.png", import.meta.url).toString();

});

parcelRegister("lCPZ7", function(module, exports) {
module.exports = new URL("inline-column-create-light.25926891.png", import.meta.url).toString();

});

parcelRegister("bgZld", function(module, exports) {
module.exports = new URL("inline-column-create-dark.7d2ee1ec.png", import.meta.url).toString();

});

parcelRegister("lXTaV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b198919880e512f2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b198919880e512f2$var$messages = (0, $7qGN1.defineMessages)({
    createFieldBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-body",
        "defaultMessage": "Create and configure fields without leaving your view."
    },
    createFieldDismiss: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.create-field-dismiss",
        "defaultMessage": "Dismiss"
    },
    inlineColumnCreateBody: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.inline-column-create-body",
        "defaultMessage": "Select <b>+</b> to quickly add columns exactly where you want them."
    },
    nextButtonText: {
        "id": "native-issue-table.ui.inline-field-create-onboarding.next-button-text",
        "defaultMessage": "Next"
    }
});
var $b198919880e512f2$export$2e2bcd8739ae039 = $b198919880e512f2$var$messages;

});



parcelRegister("6UQ01", function(module, exports) {
$parcel$export(module.exports, "HeaderCell", () => $16f432ebf3f5233a$export$efcbfab786023e1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $aQK2r = parcelRequire("aQK2r");

var $6DCNy = parcelRequire("6DCNy");

var $12DRg = parcelRequire("12DRg");

var $3nrCN = parcelRequire("3nrCN");

var $igtYB = parcelRequire("igtYB");

var $dROq6 = parcelRequire("dROq6");

var $bGx3v = parcelRequire("bGx3v");

var $92EV7 = parcelRequire("92EV7");

var $aHiGM = parcelRequire("aHiGM");

var $ltpqI = parcelRequire("ltpqI");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $guChT = parcelRequire("guChT");

var $j8Km1 = parcelRequire("j8Km1");

var $4cTDP = parcelRequire("4cTDP");

var $6d9QY = parcelRequire("6d9QY");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $bJscI = parcelRequire("bJscI");


var $6KVf0 = parcelRequire("6KVf0");

var $8jOO7 = parcelRequire("8jOO7");

var $k1Whm = parcelRequire("k1Whm");

var $34oCh = parcelRequire("34oCh");

var $7n9BS = parcelRequire("7n9BS");

var $johMb = parcelRequire("johMb");

var $2cK5s = parcelRequire("2cK5s");

var $4G6Vc = parcelRequire("4G6Vc");

var $3R7ZX = parcelRequire("3R7ZX");
const $16f432ebf3f5233a$var$DRAG_PREVIEW_MAX_WIDTH = 260;
const $16f432ebf3f5233a$var$BORDER_WIDTH = '1px';
const $16f432ebf3f5233a$var$HEADER_HEIGHT = 40;
const $16f432ebf3f5233a$export$10fece0d97415ebc = 60; // ensure that the resize handle displays above subsequent header cells, but that a sticky cell will display above the
// resize handle. Improper z-index may cause the resize handle to render _above_ the column picker.
const $16f432ebf3f5233a$var$RESIZE_HANDLE_Z_INDEX = 1;
const $16f432ebf3f5233a$var$STICKY_CELL_Z_INDEX = $16f432ebf3f5233a$var$RESIZE_HANDLE_Z_INDEX + 1;
const $16f432ebf3f5233a$var$BOUNDARY = 70;
const $16f432ebf3f5233a$var$MOUSE_MOVE_THROTTLE = 16;
const $16f432ebf3f5233a$var$SpotlightWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.spotlight-wrapper",
        className: (0, $hcewu.default)([
            "_11c81vhk _2rkolb4i _18zru2gc _bfhkqbzx _4t3i1osq _1e0c1txw _4cvr1h6o _syaz1gjq _1bsbnau3"
        ])
    }, children);
};
const $16f432ebf3f5233a$export$efcbfab786023e1a = ({ column: column, hasColumnConfiguration: hasColumnConfiguration, instanceId: instanceId, isCompactColumnEnabled: isCompactColumnEnabled = false, isFirst: isFirst, isLast: isLast, previousColumn: previousColumn, resizeHandleType: resizeHandleType = (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT), shouldHaveResizeHandle: shouldHaveResizeHandle = true, tableRef: tableRef, onMoveColumn: onMoveColumnProp, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumnProp, onFreezeColumn: onFreezeColumnProp, index: index, tableBorderRadius: tableBorderRadius, onDropdownStateChange: onDropdownStateChange, stickyColumnsWidth: stickyColumnsWidth = 0, resizingColumnIndex: resizingColumnIndex, setResizingColumnIndex: setResizingColumnIndex, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, isStickyColumnsVisible: isStickyColumnsVisible, mergedColumnMinWidth: mergedColumnMinWidth, totalMoveableColumns: totalMoveableColumns })=>{
    const headerCellContainerRef = (0, $eJOHy.useRef)(null);
    const headerCellActionsTriggerRef = (0, $eJOHy.useRef)(null);
    const resizeHandleRef = (0, $eJOHy.useRef)(null);
    const isColumnResizingEnabled = (0, $34oCh.useIsColumnResizingEnabled)();
    const isInBetweenColumnPickerEnabled = (0, $34oCh.useIsInBetweenColumnPickerEnabled)();
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const isInBetweenStickyColumnPickerEnabled = (0, $34oCh.useIsInBetweenStickyColumnPickerEnabled)();
    let isAutoUnstickyOnSmallScreenEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    let isChildIssuesTableVisualUpliftEnabled = false;
    if ((0, $4cTDP.fg)('fg_visual_uplift_for_child_issues_table')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isChildIssuesTableVisualUpliftEnabled = (0, $34oCh.useIsChildIssuesTableVisualUpliftEnabled)();
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const handleDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setIsDropdownOpen(isOpen);
        if (onDropdownStateChange) onDropdownStateChange(isOpen);
    }, [
        onDropdownStateChange
    ]);
    const [state, setState] = (0, $eJOHy.useState)({
        type: 'idle'
    });
    const [dropEdge, setDropEdge] = (0, $eJOHy.useState)(null);
    let clearIndex = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let setIndex = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let clearIndexAfterDelay = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let columnIndex;
    let isInlineFieldCreateHovered;
    if (isInBetweenColumnPickerEnabled) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ clearIndex: clearIndex, setIndex: setIndex, clearIndexAfterDelay: clearIndexAfterDelay } = (0, $6KVf0.useInlineCreateActiveIndexActions)());
        [{ index: columnIndex, isHovered: isInlineFieldCreateHovered }] = // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6KVf0.useInlineFieldCreateActiveIndex)();
    }
    const height = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    let scrollElement;
    let scrollLeft = 0;
    let isScrolling = false;
    let hasScrolled = false;
    let tableWidth = 0;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const scrollState = (0, $7n9BS.useScrollStateSelector)((s)=>({
                scrollLeft: s.scrollLeft,
                isScrolling: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? s.isScrolling && s.hasScrolled : s.isScrolling,
                width: (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? 0 : s.width,
                hasScrolled: s.hasScrolled,
                scrollElement: s.scrollElement
            }));
        scrollLeft = scrollState.scrollLeft ?? 0;
        isScrolling = scrollState.isScrolling ?? false;
        hasScrolled = scrollState.hasScrolled ?? false;
        scrollElement = scrollState.scrollElement;
        tableWidth = scrollState.width ?? 0;
    }
    tableWidth = (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') ? scrollElement?.clientWidth ?? 0 : tableWidth;
    if (isStickyColumnsVisible && isScrolling && isDropdownOpen && !column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
        const scrollElementToLeft = scrollElement?.getBoundingClientRect().left ?? 0;
        const triggerOffsetFromLeft = headerCellActionsTriggerRef.current?.getBoundingClientRect().left;
        if (triggerOffsetFromLeft !== undefined && triggerOffsetFromLeft - scrollElementToLeft < stickyColumnsWidth) setIsDropdownOpen(false);
    }
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            fieldType: column.type
        }), [
        column.type
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isStickyColumn = (0, $eJOHy.useMemo)(()=>column.isColumnSticky && isInBetweenStickyColumnPickerEnabled && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns'), [
        column.isColumnSticky,
        isInBetweenStickyColumnPickerEnabled
    ]);
    const throttledHandler = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((event)=>{
            if (!event.currentTarget) return;
            const scrollElementToLeft = scrollElement?.getBoundingClientRect().left ?? 0;
            const stickyBoundary = scrollElementToLeft + stickyColumnsWidth;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const width = rect.right - rect.left; // For sticky columns, allow insert button on both sides
            // For non-sticky columns, only allow on the right side if they're past the sticky boundary
            if (x < width / 2 && x <= $16f432ebf3f5233a$var$BOUNDARY) {
                // Left side: allow for sticky columns, or non-sticky columns past the boundary
                if (isStickyColumn || rect.left >= stickyBoundary) setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), index - 1);
                else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
            } else if (x >= width / 2 && x >= width - $16f432ebf3f5233a$var$BOUNDARY) // Right side: always allow
            setIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74), index);
            else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
        }, $16f432ebf3f5233a$var$MOUSE_MOVE_THROTTLE), [
        scrollElement,
        stickyColumnsWidth,
        setIndex,
        index,
        clearIndex,
        isStickyColumn
    ]);
    const calculateColumnIndex = (0, $eJOHy.useCallback)(throttledHandler, [
        throttledHandler
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)((event)=>{
        if (event.target === resizeHandleRef.current) // prevent showing "hovered" state when only the resize handle is hovered
        return;
        setIsHovered(true);
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
        if (isInBetweenColumnPickerEnabled) clearIndexAfterDelay((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isInBetweenColumnPickerEnabled
    ]);
    const handleMouseMove = (0, $eJOHy.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (headerCellContainerRef.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    const handleMouseClick = (0, $eJOHy.useCallback)((event)=>{
        if (event.target instanceof HTMLElement && headerCellContainerRef.current?.contains(event.target.closest('button'))) clearIndex((0, $7423e9894c2b8b23$export$d6f887e0c1be1b74));
    }, [
        clearIndex
    ]); // #region Column reordering
    const onMoveColumn = (0, $eJOHy.useCallback)((position)=>{
        onMoveColumnProp(position);
        setIsHovered(false);
    }, [
        onMoveColumnProp
    ]);
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    const isMergedColumn = isMergedColumnEnabled && column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_column_gate');
    const isHiddenByFrozenColumn = (0, $eJOHy.useMemo)(()=>{
        if (isStickyColumnsVisible && resizeHandleRef && resizeHandleRef.current && hasScrolled && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
            if (isMergedColumn && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) return false;
            const scrollElementToLeft = scrollElement?.getBoundingClientRect().left ?? 0;
            const stickyBoundary = scrollElementToLeft + stickyColumnsWidth;
            return resizeHandleRef.current.getBoundingClientRect().left < stickyBoundary || isScrolling;
        }
        return false;
    }, [
        isMergedColumn,
        isStickyColumnsVisible,
        hasScrolled,
        scrollElement,
        stickyColumnsWidth,
        isScrolling
    ]);
    const isMultiColumnMergedCell = isMergedColumn && column.mergedColumns && column.mergedColumns.length > 1;
    (0, $eJOHy.useEffect)(()=>{
        const headerCellContainer = headerCellContainerRef.current;
        const allowMergedColumnReordering = (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate') ? enableDynamicOrderForMergedColumn : false;
        if (!hasColumnConfiguration || !headerCellContainer || isMergedColumn && !allowMergedColumnReordering) return;
        return (0, $dROq6.combine)((0, $bGx3v.draggable)({
            element: headerCellContainer,
            getInitialData () {
                if (isStickyColumnsVisible) return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId,
                    isColumnSticky: column.isColumnSticky
                };
                return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_REORDER),
                    id: column.id,
                    instanceId: instanceId
                };
            },
            onDragStart () {
                setState({
                    type: 'reordering'
                });
            },
            onDrop () {
                setState({
                    type: 'idle'
                });
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                const headerCellWidth = headerCellContainer.getBoundingClientRect().width;
                (0, $aHiGM.setCustomNativeDragPreview)({
                    getOffset () {
                        return {
                            x: 20,
                            y: 20
                        };
                    },
                    render ({ container: container }) {
                        // Cause a React re-render to create portal synchronously
                        setState({
                            type: 'preview',
                            container: container,
                            previewWidth: Math.min(headerCellWidth, $16f432ebf3f5233a$var$DRAG_PREVIEW_MAX_WIDTH)
                        }); // Cause a React re-render to remove portal on cleanup
                        return ()=>setState({
                                type: 'reordering'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $bGx3v.dropTargetForElements)({
            element: headerCellContainer,
            canDrop ({ source: source }) {
                if (isStickyColumnsVisible) // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId && // Only allow columns to be dropped within their original section:
                // frozen columns into the frozen section, and unfrozen columns into the unfrozen section
                column.isColumnSticky === source.data.isColumnSticky;
                 // Only allow drops from the same instance id
                // (i.e. prevent dropping entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: column.id,
                    instanceId: instanceId
                };
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ self: self }) {
                const closestEdge = (0, $3nrCN.extractClosestEdge)(self.data);
                if (!closestEdge) return;
                setDropEdge(closestEdge);
            },
            onDragLeave () {
                setDropEdge(null);
            },
            onDrop () {
                setDropEdge(null);
            }
        }), (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                // Only monitor this particular instance id
                // (i.e. prevent monitoring entities that are not headers, or headers from another issue table)
                return source.data.instanceId === instanceId;
            },
            onDrag () {
                // Close the dropdown menu when a drag starts on any column
                setIsDropdownOpen(false);
            }
        }));
    }, [
        column.id,
        column.isColumnSticky,
        hasColumnConfiguration,
        instanceId,
        isMergedColumn,
        isStickyColumnsVisible,
        enableDynamicOrderForMergedColumn
    ]); // #endregion
    // #region Column resizing
    const mergedColumnWidth = Math.max(mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH), column.customWidth ?? column.defaultWidth);
    const maxFrozenMergedColumnWidth = isMergedColumn && column.isColumnSticky && tableWidth > 0 ? tableWidth - stickyColumnsWidth + mergedColumnWidth - $16f432ebf3f5233a$export$10fece0d97415ebc : mergedColumnWidth; // eslint-disable-next-line no-nested-ternary
    const columnWidth = isMultiColumnMergedCell ? (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min(mergedColumnWidth, maxFrozenMergedColumnWidth) : mergedColumnWidth : column.customWidth ?? column.defaultWidth; // eslint-disable-next-line no-nested-ternary
    const prevColumnCustomWidth = isMultiColumnMergedCell ? (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min(columnWidth, maxFrozenMergedColumnWidth) : columnWidth : column.customWidth;
    const [componentColumnWidth, setComponentColumnWidth] = (0, $eJOHy.useState)(columnWidth);
    const prevColumnConfigCustomWidth = (0, $6d9QY.usePreviousWithInitial)(prevColumnCustomWidth);
    const [isResizePopupOpen, setIsResizePopupOpen] = (0, $eJOHy.useState)(false);
    const ariaSortDirection = (sortOrder)=>{
        switch(sortOrder){
            case 0, $8jOO7.SORT_ASC:
                return 'ascending';
            case 0, $8jOO7.SORT_DESC:
                return 'descending';
            default:
                return 'none';
        }
    };
    const onResizeColumn = (0, $eJOHy.useCallback)((width, resizeMethod)=>{
        if (width === componentColumnWidth) // Skip state updates if column width has not changed
        return;
        setComponentColumnWidth(width);
        const resizeColumnId = column.resizeColumnId ?? column.id;
        onResizeColumnProp && onResizeColumnProp(resizeColumnId, width === column.defaultWidth ? undefined : width);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'column'
        }), 'issueTable', {
            ...analyticsAttributes,
            resizeMethod: resizeMethod,
            columnWidth: width
        });
    }, [
        componentColumnWidth,
        onResizeColumnProp,
        column.id,
        column.defaultWidth,
        column.resizeColumnId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    const onFreezeColumn = (0, $eJOHy.useCallback)(()=>{
        if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) onFreezeColumnProp?.((0, $j8Km1.MERGED_COLUMN_TYPES).map((fieldSetId)=>({
                fieldSetId: fieldSetId,
                isFrozen: true
            })));
        else onFreezeColumnProp?.([
            {
                fieldSetId: column.id,
                isFrozen: true
            }
        ]);
    }, [
        column.id,
        onFreezeColumnProp
    ]);
    const onUnfreezeColumn = (0, $eJOHy.useCallback)(()=>{
        if (column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN)) onFreezeColumnProp?.((0, $j8Km1.MERGED_COLUMN_TYPES).map((fieldSetId)=>({
                fieldSetId: fieldSetId,
                isFrozen: false
            })));
        else onFreezeColumnProp?.([
            {
                fieldSetId: column.id,
                isFrozen: false
            }
        ]);
    }, [
        column.id,
        onFreezeColumnProp
    ]); // Header actions callbacks
    const onResizeColumnAction = (0, $eJOHy.useCallback)(()=>{
        setIsResizePopupOpen(true);
    }, []);
    const onResetColumnWidthAction = (0, $eJOHy.useCallback)(()=>{
        onResizeColumn(column.defaultWidth, 'reset');
    }, [
        onResizeColumn,
        column.defaultWidth
    ]); // Resize popup callbacks
    const onChangeResizePopup = (0, $eJOHy.useCallback)((width)=>{
        (0, $3R7ZX.setCssResizingWidth)(headerCellContainerRef.current, width);
    }, []);
    const onCloseResizePopup = (0, $eJOHy.useCallback)((event, overrideKeyboardCheck)=>{
        setIsResizePopupOpen(false);
        (0, $3R7ZX.clearCssResizingWidth)(headerCellContainerRef.current); // Focus header cell actions trigger if the resize popup was closed by keyboard
        // navigation or an override was requested
        //
        // `event.detail` docs: https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
        // (click count is 0 when using keyboard to activate a button)
        if (overrideKeyboardCheck === true || event && event.detail === 0) requestAnimationFrame(()=>headerCellActionsTriggerRef.current?.focus());
    }, []);
    const onSubmitResizePopup = (0, $eJOHy.useCallback)((width)=>{
        onResizeColumn(width, 'popup'); // No event available from form submission. We will re-focus the actions
        // trigger because submit can't be triggerd by clicking outside of popup,
        // so don't have to worry about stealing focus from what the user clicked
        onCloseResizePopup(undefined, true);
    }, [
        onResizeColumn,
        onCloseResizePopup
    ]); // Resize handle callbacks
    const onMouseEnterResizeHandle = (0, $eJOHy.useCallback)((event)=>{
        // prevent showing the drag & drop/reorder hover effect when resizing
        setIsHovered(false);
        event.stopPropagation();
    }, []);
    const onMouseLeaveResizeHandle = (0, $eJOHy.useCallback)((event)=>{
        // restore header hover state if mouse exits into the header element
        if (state.type !== 'resizing' && (event.relatedTarget === headerCellContainerRef.current || event.relatedTarget instanceof Node && headerCellContainerRef.current?.contains(event.relatedTarget))) setIsHovered(true);
    }, [
        state.type
    ]); // Update column width state if a change is made in the column config
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('restore-default-width-in-issue-table')) {
            // Consider if `customWidth` doesn't exist, e.g., restore default columns is triggered
            // In this case, use the `defaultWidth` instead
            const nextColumnWidth = isMultiColumnMergedCell ? columnWidth : column.customWidth ?? column.defaultWidth;
            if (prevColumnConfigCustomWidth !== prevColumnCustomWidth && componentColumnWidth !== prevColumnCustomWidth && nextColumnWidth != null) {
                // Update merged cell width state if a change is made in the column config
                if (isMultiColumnMergedCell) setComponentColumnWidth(columnWidth);
                else setComponentColumnWidth(nextColumnWidth);
            }
        } else if (prevColumnConfigCustomWidth !== column.customWidth && componentColumnWidth !== column.customWidth && column.customWidth != null) // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setComponentColumnWidth(column.customWidth);
    }, [
        column.customWidth,
        column.defaultWidth,
        prevColumnCustomWidth,
        componentColumnWidth,
        isMultiColumnMergedCell,
        columnWidth,
        prevColumnConfigCustomWidth
    ]);
    const setFocusNone = ()=>{
        /*
    	If drag ends, setFocusNone.
    	if drag never starts but mouse down then back up, setFocusNone.
    	Focus should be yielded back when dragging ends.
    */ if ((0, $4cTDP.fg)('nin-grid-keyboard-navigation')) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const focused = document.activeElement;
            if (!(focused instanceof HTMLElement)) return;
            focused.blur();
        }
    }; // Creates draggable resize handle
    (0, $eJOHy.useEffect)(()=>{
        const resizeHandle = resizeHandleRef.current;
        if (!resizeHandle || isResizePopupOpen) return;
        return (0, $bGx3v.draggable)({
            element: resizeHandle,
            getInitialData () {
                return {
                    operation: (0, $8jOO7.COLUMN_OPERATION_RESIZE),
                    id: column.id
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // we will be moving the line to indicate a drag
                // we can disable the native drag preview
                (0, $92EV7.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // we don't want any native drop animation for when the user
                // does not drop on a drop target. we want the drag to finish immediately
                (0, $ltpqI.preventUnhandled).start();
            },
            onDragStart () {
                setState({
                    type: 'resizing'
                });
                if (column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) setResizingColumnIndex?.(index);
                 // Disable pointer events on the table while dragging in order to prevent buggy hover states in chrome
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $3R7ZX.disableCssPointerEvents)(tableRef?.current);
            },
            onDrag ({ location: location }) {
                //  stickyColumnsWidth - componentColumnWidth + proposedWidth  < tableWidth
                const proposedWidth = isMergedColumn && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min((0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell,
                    mergedColumnMinWidth: mergedColumnMinWidth
                }), tableWidth - stickyColumnsWidth + componentColumnWidth - $16f432ebf3f5233a$export$10fece0d97415ebc) : (0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell,
                    mergedColumnMinWidth: mergedColumnMinWidth
                });
                if (tableRef && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
                    const diffX = location.current.input.clientX - location.initial.input.clientX;
                    (0, $3R7ZX.setCssResizingOffset)(tableRef.current, Math.max(proposedWidth - componentColumnWidth, diffX));
                }
                (0, $3R7ZX.setCssResizingWidth)(headerCellContainerRef.current, proposedWidth);
            },
            onDrop ({ location: location }) {
                const proposedWidth = (0, $3R7ZX.getProposedWidth)({
                    initialWidth: componentColumnWidth,
                    location: location,
                    isCompactColumnEnabled: isCompactColumnEnabled,
                    isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
                    isMultiColumnMergedCell: isMultiColumnMergedCell,
                    mergedColumnMinWidth: mergedColumnMinWidth
                });
                (0, $ltpqI.preventUnhandled).stop();
                setState({
                    type: 'idle'
                });
                if (tableRef && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns')) {
                    setResizingColumnIndex?.(undefined);
                    (0, $3R7ZX.clearCssResizingOffset)(tableRef.current);
                }
                onResizeColumn(isMergedColumn && column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns') ? Math.min(proposedWidth, tableWidth - stickyColumnsWidth + componentColumnWidth - $16f432ebf3f5233a$export$10fece0d97415ebc) : proposedWidth, 'drag-and-drop'); // Re-enable pointer events to restore normal behaviour
                // https://issues.chromium.org/issues/41129937#comment43
                (0, $3R7ZX.enableCssPointerEvents)(tableRef?.current);
                (0, $3R7ZX.clearCssResizingWidth)(headerCellContainerRef.current);
                setFocusNone();
            }
        });
    }, [
        isResizePopupOpen,
        column.id,
        componentColumnWidth,
        tableRef,
        onResizeColumn,
        isCompactColumnEnabled,
        column.type,
        isSingleLineRowHeightEnabled,
        index,
        column.isColumnSticky,
        setResizingColumnIndex,
        isMultiColumnMergedCell,
        stickyColumnsWidth,
        isMergedColumn,
        mergedColumnMinWidth,
        tableWidth
    ]);
    const MaybeSpotlightWrapper = (0, $eJOHy.useCallback)(({ children: children })=>{
        if (isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$SpotlightWrapper, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    }, [
        isMergedColumn,
        isStickyColumnsEnabled
    ]); // #endregion
    // #region Render
    const headerCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$export$429fd509d8532e18, {
        ref: headerCellContainerRef,
        scope: "col",
        columnWidth: componentColumnWidth,
        minColumnWidth: !isColumnResizingEnabled ? column.customWidth : undefined,
        isDraggable: isMergedColumn ? (enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) ?? false : hasColumnConfiguration,
        isHovered: isHovered,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        isFirst: isFirst,
        isLast: isLast,
        index: index,
        ...isInBetweenColumnPickerEnabled && (isInBetweenStickyColumnPickerEnabled && (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') || !(column.isColumnSticky && (0, $4cTDP.fg)('issue_table_frozen_columns'))) && {
            onMouseMove: handleMouseMove
        },
        ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
            onClick: handleMouseClick
        },
        // read as the column title when a user is navigating between columns in the table content.
        "aria-label": column.title,
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        isCompactColumnEnabled: isCompactColumnEnabled,
        tableBorderRadius: tableBorderRadius,
        ...(0, $4cTDP.fg)('nin-grid-keyboard-navigation') && {
            tabIndex: index === 0 ? 0 : -1,
            isResizing: state.type === 'resizing'
        },
        ...isStickyColumnsVisible && (0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isColumnSticky: column.isColumnSticky,
            stickyOffsets: column.stickyOffsets,
            hasRightShadow: column.isLastStickyColumn && scrollLeft > 0,
            isColumnResizing: column.isColumnSticky && (resizingColumnIndex ?? 0) < index
        },
        ...isStickyColumnsVisible && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && {
            isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled
        },
        "aria-sort": (0, $4cTDP.fg)('nin-grid-keyboard-navigation') ? ariaSortDirection(column.currentSorting) : undefined,
        isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isFrozenColumnsSpotlightVisible: isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MaybeSpotlightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: [
            state.type === 'reordering' && $16f432ebf3f5233a$var$reorderingStyles,
            isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding') && $16f432ebf3f5233a$var$spotlightInnerStyles
        ],
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-container-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $16f432ebf3f5233a$var$overflowHiddenStyles
    }, column.warningText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k1Whm.default), {
        tooltip: column.warningText
    }), (0, $4cTDP.fg)('jira_list_merged_column_gate') && column.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$Title, null, column.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cK5s.HeaderCellActions), {
        column: column,
        previousColumn: previousColumn,
        currentColumnWidth: componentColumnWidth,
        hasColumnConfiguration: isMergedColumn ? (enableDynamicOrderForMergedColumn && (0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) ?? false : hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isHeaderCellHovered: isHovered,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isDropdownOpen,
        triggerRef: headerCellActionsTriggerRef,
        isMergedColumn: isMergedColumn,
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        onMoveColumn: onMoveColumn,
        onOpenChange: handleDropdownOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumnAction,
        onResetColumnWidth: onResetColumnWidthAction,
        onFreezeColumn: onFreezeColumnProp ? onFreezeColumn : undefined,
        onUnfreezeColumn: onFreezeColumnProp ? onUnfreezeColumn : undefined,
        mergedColumnMinWidth: mergedColumnMinWidth,
        ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
            totalMoveableColumns: totalMoveableColumns
        }
    }))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4G6Vc.ResizePopup), {
        columnTitle: column.title,
        initialWidth: componentColumnWidth,
        placement: "bottom-start",
        isOpen: isResizePopupOpen,
        isCompactColumnEnabled: isCompactColumnEnabled,
        isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
        trigger: $16f432ebf3f5233a$var$resizePopupTarget,
        onChange: onChangeResizePopup,
        onCancel: onCloseResizePopup,
        onSubmit: onSubmitResizePopup,
        isMultiColumnMergedCell: isMultiColumnMergedCell
    }), !isResizePopupOpen && (0, $4cTDP.fg)('use_native_css_to_set_column_resize_handle_height') && (()=>{
        const commonProps = {
            ref: resizeHandleRef,
            isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $4cTDP.fg)('jira_inline_field_config_gate'),
            ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
                isHiddenByFrozenColumn: isHiddenByFrozenColumn
            },
            onMouseEnter: onMouseEnterResizeHandle,
            onMouseLeave: onMouseLeaveResizeHandle,
            onDoubleClick: onResetColumnWidthAction,
            onMouseDown: ()=>{
                if ((0, $4cTDP.fg)('nin-grid-keyboard-navigation')) setState({
                    type: 'resizing'
                });
            },
            onMouseUp: ()=>{
                if ((0, $4cTDP.fg)('nin-grid-keyboard-navigation')) {
                    setFocusNone();
                    setState({
                        type: 'idle'
                    });
                }
            },
            'data-testid': 'native-issue-table.ui.issue-table.header.header-cell.resize-handle',
            'data-vc': 'native-issue-table-ui-resize-handle',
            ...isInBetweenColumnPickerEnabled && {
                onMouseMove: (e)=>e.stopPropagation()
            }
        };
        if (!shouldHaveResizeHandle) return;
        return resizeHandleType === (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleFullHeight, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleHeaderOnly, commonProps);
    })(), !isResizePopupOpen && shouldHaveResizeHandle && !(0, $4cTDP.fg)('use_native_css_to_set_column_resize_handle_height') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizeHandleOld, {
        ref: resizeHandleRef,
        height: resizeHandleType === (0, $8jOO7.COLUMN_RESIZE_HANDLE_FULL_HEIGHT) ? height : undefined,
        isActive: state.type === 'resizing' || columnIndex === index && isInlineFieldCreateHovered && (0, $4cTDP.fg)('jira_inline_field_config_gate'),
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isHiddenByFrozenColumn: isHiddenByFrozenColumn
        },
        onMouseEnter: onMouseEnterResizeHandle,
        onMouseLeave: onMouseLeaveResizeHandle,
        onMouseDown: ()=>{
            if ((0, $4cTDP.fg)('nin-grid-keyboard-navigation')) setState({
                type: 'resizing'
            });
        },
        onMouseUp: ()=>{
            if ((0, $4cTDP.fg)('nin-grid-keyboard-navigation')) {
                setFocusNone();
                setState({
                    type: 'idle'
                });
            }
        },
        onDoubleClick: onResetColumnWidthAction,
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.resize-handle",
        "data-vc": "native-issue-table-ui-resize-handle" /*
                                                                                                                                                                                    * Consumers may currently update non-visual styles dynamically based off height prop.
                                                                                                                                                                                    * Here we allow consumers to exclude the update of height styles from VC calculation.
                                                                                                                                                                                    * Learn more about why this has been introduced https://jplat.atlassian.net/browse/EM-9208
                                                                                                                                                                                    */ ,
        "data-vc-nvs": (0, $4cTDP.fg)('ignore_column_resize_handle'),
        ...isInBetweenColumnPickerEnabled && {
            onMouseMove: (e)=>e.stopPropagation()
        }
    })), dropEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$DropTarget, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drop-target",
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $igtYB.DropIndicator), {
        edge: dropEdge,
        gap: $16f432ebf3f5233a$var$BORDER_WIDTH,
        type: "no-terminal"
    })), state.type === 'preview' && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$DragPreview, {
        "data-testid": "native-issue-table.ui.issue-table.header.header-cell.drag-preview",
        height: height,
        width: state.previewWidth
    }), state.container)));
    if (isMergedColumn && isStickyColumnsEnabled && (0, $4cTDP.fg)('frozen_columns_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "frozen-columns-onboarding-spotlight"
    }, headerCell);
    return headerCell; // #endregion
};
// #region Styles
/**
 * Invisible element to attach resizing popup to - the intermediate component is required to allow
 * passing the ref while blocking the other props from being passed to the underlying div.
 *
 * This is because the other props are intended for a trigger button, but we are only using this
 * for positioning pourposes.
 */ const $16f432ebf3f5233a$var$resizePopupTarget = ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f432ebf3f5233a$var$ResizePopupTargetDiv, {
        ref: ref
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $16f432ebf3f5233a$var$ResizePopupTargetDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw _1ltvidpf _94n517m2",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$var$reorderingStyles = (0, $1DXK0.xcss)({
    opacity: 0.4
}); // Add overflow: hidden to the inline div so that the title can collapse its width if needed
// and give space to the right-hand side icons (sort/actions)
const $16f432ebf3f5233a$var$overflowHiddenStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $16f432ebf3f5233a$var$baseHeaderContainerCellStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    '&:first-of-type': {
        borderTopLeftRadius: "var(--ds-radius-large, 8px)"
    },
    '&:last-of-type': {
        borderTopRightRadius: "var(--ds-radius-large, 8px)",
        borderRightWidth: 0
    }
};
const $16f432ebf3f5233a$var$baseHeaderContainerCellKeyboardStyles = {
    backgroundColor: "var(--ds-surface-sunken, #F7F8F9)",
    borderColor: "var(--ds-border, #091E4224)",
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderBottomWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    borderLeftWidth: 0,
    borderRightWidth: $16f432ebf3f5233a$var$BORDER_WIDTH,
    '&:focus': {
        outline: 'unset',
        borderRight: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
        boxShadow: `inset 0 2px 0 0 ${"var(--ds-border-focused, #388BFF)"}`,
        '&:before': {
            content: ' ',
            display: 'block',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: '-3px',
            left: '-1px',
            right: '-1px',
            bottom: '-1px',
            border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }
}; // TODO: some stopgaps have been introduced to facilitate landing column config which should be addressed in EM-7165
const $16f432ebf3f5233a$export$9042168979f79508 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, hasRightShadow: hasRightShadow, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isFrozenColumnsSpotlightVisible: isFrozenColumnsSpotlightVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_hmx90c": (0, $awdRS.default)((0, $johMb.getColumnOffset)(__cmplp.stickyOffsets ?? 0, !!__cmplp.isColumnResizing))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1h6dmuej _1dqonqa1 _1rjcze3t _18zru2gc _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcd1mok _4x861mok _1nd4idpf _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv5eq1",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && __cmplp.isColumnSticky && "_z115qete _16sigrf3",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && "_1mhxgrf3",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && "_qc5o6vh0 _1qdg1osq _z0ai1y44 _aetrb3bt _1peq105o _3p6m1vpr _18postnw _32rx1lpd _15l2ze3t",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isFrozenColumnsSpotlightVisible && "_18zridpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
const $16f432ebf3f5233a$export$9e6d1f7c4a75832 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isGridNavigationEnabled: isGridNavigationEnabled, isResizing: isResizing, isFirst: isFirst, index: index, tableBorderRadius: tableBorderRadius, columnWidth: columnWidth, minColumnWidth: minColumnWidth, isCompactColumnEnabled: isCompactColumnEnabled, isDraggable: isDraggable, isHovered: isHovered, isSticky: isSticky, isColumnSticky: isColumnSticky, stickyOffsets: stickyOffsets, isColumnResizing: isColumnResizing, isAutoUnstickyOnSmallScreenEnabled: isAutoUnstickyOnSmallScreenEnabled, hasRightShadow: hasRightShadow, hasShadow: hasShadow, visualRefresh: visualRefresh, isChildIssuesTableVisualUpliftEnabled: isChildIssuesTableVisualUpliftEnabled, isFrozenColumnsSpotlightVisible: isFrozenColumnsSpotlightVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2x37x7": (0, $awdRS.default)(__cmplp.tableBorderRadius ?? "var(--ds-space-100, 8px)"),
            "--_1so474g": (0, $awdRS.default)(__cmplp.columnWidth != null ? `${__cmplp.columnWidth}px` : 'auto'),
            "--_19bvh75": (0, $awdRS.default)(__cmplp.minColumnWidth != null ? `${__cmplp.minColumnWidth}px` : 'auto'),
            "--_sj363t": (0, $awdRS.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isCompactColumnEnabled && __cmplp.columnWidth && __cmplp.columnWidth < 40 ? '0px' : "var(--ds-space-100, 8px)"),
            "--_hmx90c": (0, $awdRS.default)((0, $johMb.getColumnOffset)(__cmplp.stickyOffsets ?? 0, !!__cmplp.isColumnResizing))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1rjcze3t _18zru2gc _kqswh2mm _vchhusvi _4t3i1ylp _c71l1ylp _1tke1ylp _s7n4nkob _o5721q9c _1276baal _1bsbdva2 _142idise _1ul9qagj _1rcdhxdp _1lhcu2gc _4x86hxdp _1o59u2gc _1lhcwb8e _1o59wb8e",
            __cmplp.isGridNavigationEnabled ? "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _nt751r31 _49pcn7od _1hvw1o36 _qzh6ugt7 _x7uvf705 _1j5l1ule _1qtkstnw _1w0p1osq _18141osq _1cl9j39m _p0vi1n1a _t0aw1n1a _eahy1n1a _7u4sugt7 _7ehi14bn" : "_1h6dmuej _1dqonqa1 _bfhkqbzx _uwhkidpf _1doct94y _t6vdidpf _hr4jt94y _1rcd1mok _4x861mok _1nd4idpf",
            __cmplp.isResizing && __cmplp.isGridNavigationEnabled && "_qzh6n7od _7u4sn7od _7ehin7od",
            __cmplp.isFirst && __cmplp.isGridNavigationEnabled && "_13li1mok _qnecidpf",
            __cmplp.index === 2 && __cmplp.isGridNavigationEnabled && "_1n9didpf _12s81n1a _1hw81n1a _zzeu1n1a _1qc71hup",
            __cmplp.isDraggable && __cmplp.isHovered && "_d0al1qgj _irr3108i",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && "_kqsw1if8 _1pbycs5v",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isSticky && "_1xi2idpf",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isColumnSticky && "_1ltv5eq1",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && __cmplp.isColumnSticky && "_z115qete _16sigrf3",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && __cmplp.isAutoUnstickyOnSmallScreenEnabled && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && "_1mhxgrf3",
            (__cmplp.isSticky || __cmplp.isColumnSticky) && __cmplp.hasRightShadow && "_qc5o6vh0 _1qdg1osq _z0ai1y44 _aetrb3bt _1peq105o _3p6m1vpr _18postnw _32rx1lpd _15l2ze3t",
            __cmplp.hasShadow && "_16qs1paq _t6vd1aa3",
            __cmplp.visualRefresh ? "_11c81vhk _syaz1gjq" : "_syaz1dyx _k48p1wq8",
            __cmplp.isChildIssuesTableVisualUpliftEnabled && "_bfhkglyw _hr4jidpf",
            __cmplp.isFrozenColumnsSpotlightVisible && "_18zridpf",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$export$429fd509d8532e18 = (0, $bJscI.componentWithFG)('nin-grid-keyboard-navigation', $16f432ebf3f5233a$export$9e6d1f7c4a75832, $16f432ebf3f5233a$export$9042168979f79508); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleFullHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isHiddenByFrozenColumn: isHiddenByFrozenColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1kxc _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            !__cmplp.isActive && !__cmplp.isHiddenByFrozenColumn && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleHeaderOnly = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isHiddenByFrozenColumn: isHiddenByFrozenColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _4t3i1osq _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            !__cmplp.isActive && !__cmplp.isHiddenByFrozenColumn && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f432ebf3f5233a$var$ResizeHandleOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isHiddenByFrozenColumn: isHiddenByFrozenColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18zr1b66 _1y1m1ntv _1bsbyh40 _kqswstnw _154ize3t _1xi213c4 _80omuf7j _1pbykb7n",
            __cmplp.isActive ? "_bfhk1yqz" : "_bfhk18uv",
            __cmplp.height != null ? "_4t3it1jn" : "_4t3i1osq",
            !__cmplp.isActive && !__cmplp.isHiddenByFrozenColumn && "_irr37jlr",
            __cmplp.className
        ])
    });
}); // Invisible box surrounding the full column for the `DropIndicator` to attach to
const $16f432ebf3f5233a$var$DropTarget = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ize3t _1ltvze3t _4t3i2nrh _1bsb1osq",
            __cmplp.className
        ])
    });
}); // Custom drag preview that looks like a ghost blue column
const $16f432ebf3f5233a$var$DragPreview = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1h6d1p6i _1dqonqa1 _189edkaa _4t3i2nrh _c71l1kxc _1bsb1hdq _bfhk7wq0",
            __cmplp.className
        ])
    });
});
const $16f432ebf3f5233a$var$spotlightWrapperStyles = null;
const $16f432ebf3f5233a$var$spotlightInnerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("k1Whm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d54147c849a5eab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $d8UFE = parcelRequire("d8UFE");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $i2rto = parcelRequire("i2rto");
const $0d54147c849a5eab$var$WarningIndicator = ({ tooltip: tooltip })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d54147c849a5eab$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        label: formatMessage((0, $i2rto.default).warningLabel),
        color: "var(--ds-icon-warning, #E56910)"
    })));
};
var $0d54147c849a5eab$export$2e2bcd8739ae039 = $0d54147c849a5eab$var$WarningIndicator;
const $0d54147c849a5eab$var$HEADER_CELL_HEIGHT = 28; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0d54147c849a5eab$var$WarningIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxv77o _4t3i1f4h _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2rto", function(module, exports) {
$parcel$export(module.exports, "default", () => $072fd65944448136$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $072fd65944448136$var$messages = (0, $7qGN1.defineMessages)({
    warningLabel: {
        "id": "native-issue-table.common.warning-indicator.warning-label",
        "defaultMessage": "Warning"
    }
});
var $072fd65944448136$export$2e2bcd8739ae039 = $072fd65944448136$var$messages;

});


parcelRegister("2cK5s", function(module, exports) {
$parcel$export(module.exports, "HeaderCellActions", () => $5f46d7781007ccd9$export$1d48fcee1df11ffa);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $5V25X = parcelRequire("5V25X");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $czQLf = parcelRequire("czQLf");

var $ieul7 = parcelRequire("ieul7");
const $5f46d7781007ccd9$export$1d48fcee1df11ffa = ({ column: column, previousColumn: previousColumn, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isCompactColumnEnabled: isCompactColumnEnabled = false, isHeaderCellHovered: isHeaderCellHovered, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, isMergedColumn: isMergedColumn = false, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn = false, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn, onResetColumnWidth: onResetColumnWidth, mergedColumnMinWidth: mergedColumnMinWidth, totalMoveableColumns: totalMoveableColumns })=>{
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused(true);
    }, []);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused(false);
    }, []);
    const isSortable = column.onSortOrderChanged !== undefined && column.isSortable;
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    // Header actions width must be static when fixed table layout is disabled to prevent column
    // widths shifting as the user hovers the table header
    const isStaticWidth = !isFixedTableLayoutEnabled;
    const isSingleLineRowHeightEnabled = (0, $34oCh.useIsSingleLineRowHeightEnabled)();
    const isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    const { isActive: isSpotlightVisible } = (0, $4cTDP.fg)('frozen_columns_onboarding') ? (0, $5V25X.useTrigger)(isMergedColumn && isStickyColumnsEnabled ? 'frozen-columns-onboarding-is-spotlight-visible' : undefined) : {
        isActive: false
    };
    let minimumColumnWidth;
    if (isMergedColumn && column.mergedColumns && column.mergedColumns.length > 1) minimumColumnWidth = mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    if (!isSortable && !hasColumnConfiguration && !isColumnResizingEnabled) return null;
    const isMoreActionsVisible = isHeaderCellHovered || isOpen || isFocused || isSpotlightVisible;
    const isSorted = column.currentSorting === (0, $8jOO7.SORT_ASC) || column.currentSorting === (0, $8jOO7.SORT_DESC);
    const isSortVisible = isMoreActionsVisible || isSorted;
    const isSortOnlyAction = isSortable && !hasColumnConfiguration && !isColumnResizingEnabled;
    const sortButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5f46d7781007ccd9$var$baseStyles,
            !isSortVisible && $5f46d7781007ccd9$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ieul7.SortButton), {
        column: column,
        onFocus: onFocus,
        onBlur: onBlur
    }));
    const moreActionsButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5f46d7781007ccd9$var$baseStyles,
            !isMoreActionsVisible && $5f46d7781007ccd9$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $czQLf.MoreActions), {
        column: column,
        previousColumn: previousColumn,
        currentColumnWidth: currentColumnWidth,
        hasColumnConfiguration: hasColumnConfiguration,
        isColumnResizingEnabled: isColumnResizingEnabled,
        isFirst: isFirst,
        isLast: isLast,
        isOpen: isOpen,
        triggerRef: triggerRef,
        isMergedColumn: isMergedColumn,
        enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn,
        onMoveColumn: onMoveColumn,
        onOpenChange: onOpenChange,
        onRemoveColumn: onRemoveColumn,
        onResizeColumn: onResizeColumn,
        onFreezeColumn: onFreezeColumn,
        onUnfreezeColumn: onUnfreezeColumn,
        onResetColumnWidth: onResetColumnWidth,
        onFocus: onFocus,
        onBlur: onBlur,
        ...(0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') && {
            totalMoveableColumns: totalMoveableColumns
        }
    }));
    if (isSortOnlyAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
        ]
    }, sortButton);
    if (!isSortable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
        ]
    }, moreActionsButton);
    if (isCompactColumnEnabled && currentColumnWidth < minimumColumnWidth) {
        if (column.currentSorting !== (0, $8jOO7.SORT_NONE) && !isHeaderCellHovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: [
                $5f46d7781007ccd9$var$containerStyles,
                isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
            ]
        }, sortButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            xcss: [
                $5f46d7781007ccd9$var$containerStyles,
                isStaticWidth && $5f46d7781007ccd9$var$singleButtonWidth
            ]
        }, moreActionsButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: isStaticWidth ? 'end' : undefined,
        xcss: [
            $5f46d7781007ccd9$var$containerStyles,
            // Animate between single and all button width when sorted (only when in a dynamic layout)
            !isStaticWidth && isSorted && $5f46d7781007ccd9$var$singleButtonWidth,
            (isStaticWidth || isMoreActionsVisible) && $5f46d7781007ccd9$var$allButtonsWidth
        ]
    }, sortButton, moreActionsButton);
};
const $5f46d7781007ccd9$var$containerStyles = (0, $1DXK0.xcss)({
    gap: 'space.050',
    transition: 'width .25s'
});
const $5f46d7781007ccd9$var$singleButtonWidth = (0, $1DXK0.xcss)({
    width: '24px'
});
const $5f46d7781007ccd9$var$allButtonsWidth = (0, $1DXK0.xcss)({
    width: '52px'
});
const $5f46d7781007ccd9$var$baseStyles = (0, $1DXK0.xcss)({
    transition: 'opacity .25s'
});
const $5f46d7781007ccd9$var$hiddenStyles = (0, $1DXK0.xcss)({
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: 'space.negative.025',
    overflow: 'hidden',
    padding: 'space.0',
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none'
});

});
parcelRegister("czQLf", function(module, exports) {
$parcel$export(module.exports, "MoreActions", () => $356971f4066577c6$export$f2f44eb5b71ba65f);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $NByNW = parcelRequire("NByNW");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $8Y8kU = parcelRequire("8Y8kU");
var $880Uc = parcelRequire("880Uc");

var $xEGV6 = parcelRequire("xEGV6");

var $cQxBL = parcelRequire("cQxBL");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4B7rn = parcelRequire("4B7rn");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $lpMrC = parcelRequire("lpMrC");

var $j8Km1 = parcelRequire("j8Km1");

var $3mZMJ = parcelRequire("3mZMJ");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $pZqvR = parcelRequire("pZqvR");

var $cEWre = parcelRequire("cEWre");

var $cgCO4 = parcelRequire("cgCO4");

var $fn6we = parcelRequire("fn6we");

var $9sCxj = parcelRequire("9sCxj");
const $356971f4066577c6$var$NestedSortingDropdown = ({ column: column, customMessage: customMessage, onOpenChange: onOpenChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const sortAsc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_ASC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
        onOpenChange(false);
    }, [
        column,
        onOpenChange
    ]);
    const sortDesc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_DESC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
        onOpenChange(false);
    }, [
        column,
        onOpenChange
    ]);
    let title = column.title;
    if (column.currentSorting === (0, $8jOO7.SORT_ASC) && column.ascText) title = `${column.title}: ${formatMessage((0, $9sCxj.default).sortDirection, {
        sortDescription: column.ascText
    })}`;
    else if (column.currentSorting === (0, $8jOO7.SORT_DESC) && column.descText) title = `${column.title}: ${formatMessage((0, $9sCxj.default).sortDirection, {
        sortDescription: column.descText
    })}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        placement: "right-start",
        // We should also enable shouldRenderToParent only in Chrome nested dropdown menu.
        // Mismatched `shouldRenderToParent` settings between parent and nested dropdowns
        // can break the nested menu behavior.
        shouldRenderToParent: (0, $lpMrC.isChrome)(),
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
                ...triggerProps,
                ref: triggerRef,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                    size: "small",
                    spacing: "spacious",
                    label: ""
                })
            }, title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc,
        isSelected: column.currentSorting === (0, $8jOO7.SORT_ASC),
        fieldType: column.type
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $9sCxj.default).sortAsc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc,
        isSelected: column.currentSorting === (0, $8jOO7.SORT_DESC),
        fieldType: column.type
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $9sCxj.default).sortDesc))));
};
const $356971f4066577c6$var$FreezeColumnOption = ({ isColumnSticky: isColumnSticky, isSortable: isSortable, hasColumnConfiguration: hasColumnConfiguration, shouldShowNestedSorting: shouldShowNestedSorting, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAutoUnstickyOnSmallScreenEnabled = (0, $34oCh.useIsAutoUnstickyOnSmallScreenEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isAutoUnstickyOnSmallScreenEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        below: "md",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "freezeColumn",
        onClick: onFreezeColumn,
        isDisabled: true
    }, formatMessage((0, $9sCxj.default).freezeColumn))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Y8kU.Hide), {
        below: "md",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn)));
};
const $356971f4066577c6$export$f2f44eb5b71ba65f = ({ column: column, previousColumn: previousColumn, currentColumnWidth: currentColumnWidth, hasColumnConfiguration: hasColumnConfiguration, isColumnResizingEnabled: isColumnResizingEnabled, isMergedColumn: isMergedColumn, enableDynamicOrderForMergedColumn: enableDynamicOrderForMergedColumn, isFirst: isFirst, isLast: isLast, isOpen: isOpen, triggerRef: triggerRef = null, onMoveColumn: onMoveColumn, onOpenChange: onOpenChange, onRemoveColumn: onRemoveColumn, onResizeColumn: onResizeColumn, onFreezeColumn: onFreezeColumn, onUnfreezeColumn: onUnfreezeColumn, onResetColumnWidth: onResetColumnWidth, onFocus: onFocus, onBlur: onBlur, totalMoveableColumns: totalMoveableColumns })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isRemoveColumnEnabled = (0, $4cTDP.fg)('jira_issue_table_remove_column_check') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsRemoveColumnEnabled)() : true;
    const { ifcConfig: ifcConfig } = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $pZqvR.useIFCConfigContext)() : {
        ifcConfig: null
    };
    const editField = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cEWre.useIFCEditField)() : undefined;
    const sortAsc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_ASC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column
    ]);
    const sortDesc = (0, $eJOHy.useCallback)(()=>{
        column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_DESC), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column
    ]);
    const clearSorting = (0, $eJOHy.useCallback)(()=>{
        if (isMergedColumn) column.mergedColumns?.forEach((mergedColumn)=>{
            if (mergedColumn.currentSorting && mergedColumn.currentSorting !== (0, $8jOO7.SORT_NONE)) mergedColumn.onSortOrderChanged?.(mergedColumn.jqlTerm, (0, $8jOO7.SORT_NONE), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? mergedColumn.aliases : undefined);
        });
        else column.onSortOrderChanged?.(column.jqlTerm, (0, $8jOO7.SORT_NONE), (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column,
        isMergedColumn
    ]);
    const handleOnOpenChange = (0, $eJOHy.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueTableHeaderActions');
        onOpenChange(newIsOpen);
    }, [
        createAnalyticsEvent,
        onOpenChange
    ]);
    const mergedColumns = column.mergedColumns ?? [];
    const shouldShowNestedSorting = isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? Boolean(isMergedColumn && mergedColumns.length > 1) && // Ensure that merged columns are sortable before showing the dropdown item group
    mergedColumns.some((mergedCol)=>mergedCol.isSortable && mergedCol.onSortOrderChanged) : Boolean(isMergedColumn && mergedColumns.length > 1);
    const fieldType = Boolean(isMergedColumn) && mergedColumns.length === 1 && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? mergedColumns[0]?.type : undefined;
    const isColumnSortable = (0, $eJOHy.useCallback)((col)=>Boolean(!!col.onSortOrderChanged && col.isSortable), []);
    let isSortable = isColumnSortable(column);
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) isSortable = isColumnSortable(column) || Boolean(isMergedColumn && !shouldShowNestedSorting && column.mergedColumns?.some(isColumnSortable));
    let isMergedColumnEnabled = false;
    if ((0, $4cTDP.fg)('jira_list_merged_column_gate')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isMergedColumnEnabled = (0, $34oCh.useIsMergedColumnEnabled)();
    let isStickyColumnsEnabled = false;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
    let isSmallScreen = false;
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('issue_table_frozen_columns') && !(0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isSmallScreen: smallScreen } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isSmallScreen = smallScreen;
    }
    let canMoveColumnLeft = true;
    if (isMergedColumnEnabled && previousColumn) {
        if ((0, $4cTDP.fg)('jira-linked-work-items-targeting-gate')) canMoveColumnLeft = enableDynamicOrderForMergedColumn ? true : previousColumn?.id !== (0, $j8Km1.COLUMN_ID_MERGED_COLUMN);
        else canMoveColumnLeft = previousColumn?.id !== (0, $j8Km1.COLUMN_ID_MERGED_COLUMN);
    }
    const triggerLabel = formatMessage((0, $9sCxj.default).columnActions, {
        column: column.title
    });
    // Ensure a stable ref function is passed through to the trigger button
    const memoizedMergeRefs = (0, $eJOHy.useMemo)(()=>(0, $LFmXM.default)((0, $bzbsd.mergeRefs)), []);
    const customMessage = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $9sCxj.default).sortCustomNew : (0, $9sCxj.default).sortCustom;
    const shouldShowRemoveColumnOption = (0, $4cTDP.fg)('jira_issue_table_remove_column_check') ? hasColumnConfiguration && isRemoveColumnEnabled : hasColumnConfiguration;
    const isCategoryField = column.type === (0, $3mZMJ.CATEGORY_TYPE);
    /*
  	The JWM category field is a bit of a snowflake as it can be used in CMP projects but doesn't support configuration
  	in global admin.
  	We include this exception here to allow the category field to be updated through inline field configuration as an
  	intermediate measure as category will be decommissioned and replaced with the single select custom field type (at
  	which point this condition can be removed).
  	This is supported in IFC as we call bespoke APIs for updating the category field that support
  	CMP projects.
   */ const isIfcConfigEnabledNew = ifcConfig?.isEnabledForProject || ifcConfig?.isEnabledForCategoryField && isCategoryField;
    const isIfcConfigEnabled = (0, $4cTDP.fg)('jsc_list_category_editing_in_nin') ? isIfcConfigEnabledNew : ifcConfig?.IFCTriggerRef;
    // Action dropdown only displays Move column to the last position and Move Column to the first position for 3 or more columns
    const hasMoveToFirstAndLastOptions = (0, $4cTDP.fg)('jira_timeline_sticky_assignee_status_columns') ? totalMoveableColumns && totalMoveableColumns > 2 : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.more-actions.dropdown-menu",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        placement: "bottom-start",
        trigger: ({ triggerRef: dropdownTriggerRef, ...triggerProps })=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: triggerLabel,
                onFocus: onFocus,
                onBlur: onBlur,
                isTooltipDisabled: false,
                spacing: "compact",
                appearance: "subtle",
                testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.more-actions.icon-button"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: triggerLabel,
                delay: 0,
                ignoreTooltipPointerEvents: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $356971f4066577c6$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                ref: memoizedMergeRefs(dropdownTriggerRef, triggerRef),
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($xEGV6))), {
                    label: triggerLabel
                }),
                onFocus: onFocus,
                onBlur: onBlur
            }))),
        // We should only enable shouldRenderToParent in Chrome.
        // Safari and Firefox can clip elements inside a `position: sticky` container if the container isn’t tall enough.
        // This affects dropdowns rendered inside sticky table headers.
        shouldRenderToParent: (0, $lpMrC.isChrome)()
    }, isSortable && !shouldShowNestedSorting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, column.currentSorting !== (0, $8jOO7.SORT_ASC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortAsc",
        onClick: sortAsc,
        fieldType: fieldType
    }, column.ascText ?? false ? formatMessage(customMessage, {
        sortDescription: column.ascText
    }) : formatMessage((0, $9sCxj.default).sortAsc)), column.currentSorting !== (0, $8jOO7.SORT_DESC) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "sortDesc",
        onClick: sortDesc,
        fieldType: fieldType
    }, column.descText ?? false ? formatMessage(customMessage, {
        sortDescription: column.descText
    }) : formatMessage((0, $9sCxj.default).sortDesc)), column.currentSorting !== (0, $8jOO7.SORT_NONE) && (0, $4cTDP.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting,
        fieldType: fieldType
    }, formatMessage((0, $9sCxj.default).clearSorting))), shouldShowNestedSorting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        title: formatMessage((0, $9sCxj.default).sortByColumns)
    }, mergedColumns.map((mergedColumn)=>isTimelineEnabled || (0, $4cTDP.fg)('jira_timeline_harmonisation_m1_issue_table_updates') ? // Ensure that the column is sortable
        mergedColumn.isSortable && mergedColumn.onSortOrderChanged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$NestedSortingDropdown, {
            key: mergedColumn.id,
            column: mergedColumn,
            customMessage: customMessage,
            onOpenChange: onOpenChange
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$NestedSortingDropdown, {
            key: mergedColumn.id,
            column: mergedColumn,
            customMessage: customMessage,
            onOpenChange: onOpenChange
        })), mergedColumns.some((col)=>col.currentSorting && col.currentSorting !== (0, $8jOO7.SORT_NONE)) && (0, $4cTDP.fg)('jsc_list_reranking_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "clearSorting",
        onClick: clearSorting
    }, formatMessage((0, $9sCxj.default).clearSorting))), hasColumnConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable
    }, !isFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (!isMergedColumnEnabled || canMoveColumnLeft && (0, $4cTDP.fg)('jira_list_merged_column_move_first')) && hasMoveToFirstAndLastOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnFirst",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_FIRST))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveFirstNew) : formatMessage((0, $9sCxj.default).moveFirst)), canMoveColumnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnLeft",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_LEFT))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveLeftNew) : formatMessage((0, $9sCxj.default).moveLeft))), !isLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnRight",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_RIGHT))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveRightNew) : formatMessage((0, $9sCxj.default).moveRight)), hasMoveToFirstAndLastOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "moveColumnLast",
        onClick: ()=>onMoveColumn((0, $8jOO7.MOVE_COLUMN_LAST))
    }, (0, $4cTDP.fg)('jira_inline_field_config_gate') ? formatMessage((0, $9sCxj.default).moveLastNew) : formatMessage((0, $9sCxj.default).moveLast))), shouldShowRemoveColumnOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "removeColumn",
        onClick: onRemoveColumn
    }, formatMessage((0, $9sCxj.default).removeColumn))), // eslint-disable-next-line jira/ff/no-preconditioning
    isStickyColumnsEnabled && isMergedColumn && onUnfreezeColumn && onFreezeColumn && (0, $4cTDP.fg)('issue_table_frozen_columns') && (0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($356971f4066577c6$var$FreezeColumnOption, {
        onFreezeColumn: onFreezeColumn,
        onUnfreezeColumn: onUnfreezeColumn,
        isColumnSticky: column.isColumnSticky,
        isSortable: isSortable,
        hasColumnConfiguration: hasColumnConfiguration,
        shouldShowNestedSorting: shouldShowNestedSorting
    }), // eslint-disable-next-line jira/ff/no-preconditioning
    isStickyColumnsEnabled && isMergedColumn && onUnfreezeColumn && onFreezeColumn && (0, $4cTDP.fg)('issue_table_frozen_columns') && !(0, $4cTDP.fg)('jira_list_frozen_column_bugfix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isSmallScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "freezeColumn",
        onClick: onFreezeColumn,
        isDisabled: true
    }, formatMessage((0, $9sCxj.default).freezeColumn)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: column.isColumnSticky ? 'unfreezeColumn' : 'freezeColumn',
        onClick: column.isColumnSticky ? onUnfreezeColumn : onFreezeColumn
    }, formatMessage(column.isColumnSticky ? (0, $9sCxj.default).unfreezeColumn : (0, $9sCxj.default).freezeColumn))), isColumnResizingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: isMergedColumn && (0, $4cTDP.fg)('issue_table_frozen_columns') ? false : isSortable || hasColumnConfiguration || shouldShowNestedSorting
    }, isMergedColumn && (0, $4cTDP.fg)('issue_table_frozen_columns'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "resizeColumn",
        onClick: onResizeColumn
    }, formatMessage((0, $9sCxj.default).resizeColumn)), currentColumnWidth != null && currentColumnWidth !== column.defaultWidth && !isMergedColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
        actionType: "resetColumnWidth",
        onClick: onResetColumnWidth
    }, formatMessage((0, $9sCxj.default).resetColumnWidth))), isInlineFieldConfigEnabled && column.configureableFieldId && ifcConfig && isIfcConfigEnabled && editField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ifcConfig.IFCTriggerRef, null, ({ triggerRef: ifcTriggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fn6we.ActionItem), {
            ref: ifcTriggerRef,
            actionType: "editField",
            onClick: ()=>{
                if (column.configureableFieldId) editField(column.configureableFieldId, column.id);
            }
        }, formatMessage((0, $9sCxj.default).editField)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
const $356971f4066577c6$var$triggerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '24px',
    width: '24px'
});

});
parcelRegister("8Y8kU", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $ac5f46d65a30da5a$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
const $ac5f46d65a30da5a$var$hideAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $ac5f46d65a30da5a$var$hideBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $ac5f46d65a30da5a$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $ac5f46d65a30da5a$var$hideAboveQueries[above],
            below && $ac5f46d65a30da5a$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});
parcelRegister("j14qM", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $58139abb853d4481$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $58139abb853d4481$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fvncH = parcelRequire("fvncH");

var $6efFi = parcelRequire("6efFi");
const $58139abb853d4481$export$918f8818cfbbeb2c = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $58139abb853d4481$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("fvncH", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5a3422a08c082ecc$export$2d293d9871c38e91);
const $5a3422a08c082ecc$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5a3422a08c082ecc$export$2d293d9871c38e91 = Object.keys($5a3422a08c082ecc$export$e5ee4fe8b989fd09);
const $5a3422a08c082ecc$export$b7ed752a57b4177b = $5a3422a08c082ecc$export$2d293d9871c38e91[0];

});



parcelRegister("880Uc", function(module, exports) {
$parcel$export(module.exports, "Show", () => $f800bab042621a59$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
function $f800bab042621a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f800bab042621a59$var$showAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$showBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f800bab042621a59$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f800bab042621a59$var$defaultHiddenStyles,
            above && $f800bab042621a59$var$showAboveQueries[above],
            below && $f800bab042621a59$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});

parcelRegister("xEGV6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c71f464f0a68ac13cf34d8bdc60b231>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0652a59e631f32d8$var$_react = $0652a59e631f32d8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0652a59e631f32d8$var$_baseNew = $0652a59e631f32d8$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0652a59e631f32d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0652a59e631f32d8$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $0652a59e631f32d8$var$_react.default.createElement($0652a59e631f32d8$var$_baseNew.default, Object.assign({
        name: "ShowMoreVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$0652a59e631f32d8$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $0652a59e631f32d8$var$_default = module.exports.default = $0652a59e631f32d8$var$ShowMoreVerticalIcon;

});

parcelRegister("fn6we", function(module, exports) {
$parcel$export(module.exports, "ActionItem", () => $b29831993dcd24a9$export$ac06cb4ab481cfab);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");
const $b29831993dcd24a9$export$841c406d190a3baa = ({ actionType: actionType, fieldType: fieldType, children: children, isSelected: isSelected = false, isDisabled: isDisabled = false, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType,
            fieldType: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? fieldType : undefined
        });
        onClick();
    }, [
        actionType,
        fieldType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleOnClick,
        isSelected: isSelected,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isDisabled: isDisabled
        }
    }, children);
};
const $b29831993dcd24a9$export$ec2208c4baf896f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ actionType: actionType, fieldType: fieldType, children: children, isSelected: isSelected = false, isDisabled: isDisabled = false, onClick: onClick }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'issueTableHeaderActions', {
            actionType: actionType,
            fieldType: (0, $4cTDP.fg)('jira_list_merged_column_gate') ? fieldType : undefined
        });
        onClick();
    }, [
        actionType,
        fieldType,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        ref: ref,
        onClick: handleOnClick,
        isSelected: isSelected,
        ...(0, $4cTDP.fg)('issue_table_frozen_columns') && {
            isDisabled: isDisabled
        }
    }, children);
});
const $b29831993dcd24a9$export$ac06cb4ab481cfab = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_inline_field_config_gate'), $b29831993dcd24a9$export$ec2208c4baf896f0, $b29831993dcd24a9$export$841c406d190a3baa);

});

parcelRegister("9sCxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cda8b0f41e72a74$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6cda8b0f41e72a74$var$messages = (0, $7qGN1.defineMessages)({
    columnActions: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.column-actions",
        "defaultMessage": "More actions for {column}"
    },
    sortAsc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-asc",
        "defaultMessage": "Sort in ascending order"
    },
    sortDesc: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-desc",
        "defaultMessage": "Sort in descending order"
    },
    sortCustom: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortCustomNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortDirection: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-direction",
        "defaultMessage": "{sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    clearSorting: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.clear-sorting",
        "defaultMessage": "Clear sorting"
    },
    sortByColumns: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-by-columns",
        "defaultMessage": "Sort by columns"
    },
    moveFirst: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first",
        "defaultMessage": "Move column to the first position"
    },
    moveLeft: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left",
        "defaultMessage": "Move column to the left"
    },
    moveRight: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right",
        "defaultMessage": "Move column to the right"
    },
    moveLast: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last",
        "defaultMessage": "Move column to the last position"
    },
    moveFirstNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first-new",
        "defaultMessage": "Move column to first position"
    },
    moveLeftNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left-new",
        "defaultMessage": "Move column to left"
    },
    moveRightNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right-new",
        "defaultMessage": "Move column to right"
    },
    moveLastNew: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last-new",
        "defaultMessage": "Move column to last position"
    },
    removeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.remove-column",
        "defaultMessage": "Remove column"
    },
    resizeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.resize-column",
        "defaultMessage": "Resize column"
    },
    resetColumnWidth: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.reset-column-width",
        "defaultMessage": "Reset column width"
    },
    editField: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.edit-field",
        "defaultMessage": "Edit field"
    },
    freezeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.freeze-column",
        "defaultMessage": "Freeze column"
    },
    unfreezeColumn: {
        "id": "native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.unfreeze-column",
        "defaultMessage": "Unfreeze column"
    }
});
var $6cda8b0f41e72a74$export$2e2bcd8739ae039 = $6cda8b0f41e72a74$var$messages;

});


parcelRegister("ieul7", function(module, exports) {
$parcel$export(module.exports, "SortButton", () => $dc75ba32cd925e8e$export$e464399b18ba2124);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $j8Km1 = parcelRequire("j8Km1");

var $8jOO7 = parcelRequire("8jOO7");

var $dIts6 = parcelRequire("dIts6");
const $dc75ba32cd925e8e$var$ConditionalIconContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $dc75ba32cd925e8e$var$iconContainerStyles
    }, children, " ");
    return children;
};
const $dc75ba32cd925e8e$var$useAccessibleLabel = ({ ascText: ascText, currentSorting: currentSorting, descText: descText, title: title })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const labelSuffix = (0, $eJOHy.useMemo)(()=>{
        const sortedTooltipMessage = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $dIts6.default).sortedTooltipNew : (0, $dIts6.default).sortedTooltip;
        const sortPromptTooltipMessage = (0, $4cTDP.fg)('jira_inline_field_config_gate') ? (0, $dIts6.default).sortPromptTooltipNew : (0, $dIts6.default).sortPromptTooltip;
        switch(currentSorting){
            case 0, $8jOO7.SORT_ASC:
                return ascText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $dIts6.default).sortedDefaultAscendingTooltip);
            case 0, $8jOO7.SORT_DESC:
                return descText ?? false ? formatMessage(sortedTooltipMessage, {
                    sortDescription: descText
                }) : formatMessage((0, $dIts6.default).sortedDefaultDescendingTooltip);
            default:
                return ascText ?? false ? formatMessage(sortPromptTooltipMessage, {
                    sortDescription: ascText
                }) : formatMessage((0, $dIts6.default).sortPromptDefaultTooltip);
        }
    }, [
        ascText,
        currentSorting,
        descText,
        formatMessage
    ]);
    return (0, $eJOHy.useMemo)(()=>`${title} \u{2022} ${labelSuffix}`, [
        labelSuffix,
        title
    ]);
};
const $dc75ba32cd925e8e$export$e464399b18ba2124 = ({ column: column, onFocus: onFocus, onBlur: onBlur })=>{
    const label = $dc75ba32cd925e8e$var$useAccessibleLabel(column);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        let nextDirection = (0, $8jOO7.SORT_ASC);
        if (column.currentSorting === (0, $8jOO7.SORT_ASC)) nextDirection = (0, $8jOO7.SORT_DESC);
        else if (column.currentSorting === (0, $8jOO7.SORT_DESC)) nextDirection = (0, $4cTDP.fg)('jsc_list_reranking_gate') ? (0, $8jOO7.SORT_NONE) : (0, $8jOO7.SORT_ASC);
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const fieldType = column.id === (0, $j8Km1.COLUMN_ID_MERGED_COLUMN) && (0, $4cTDP.fg)('jira_list_merged_column_gate') ? column.mergedColumns?.[0]?.type ?? column.type : column.type;
        const attributes = {
            fieldType: fieldType,
            sortOrder: nextDirection
        };
        (0, $kRgKj.fireUIAnalytics)(event, 'sortOrderChange', attributes);
        column.onSortOrderChanged?.(column.jqlTerm, nextDirection, (0, $4cTDP.fg)('jsc_list_reranking_ast_refactor') ? column.aliases : undefined);
    }, [
        column,
        createAnalyticsEvent
    ]);
    const Icon = column.currentSorting === (0, $8jOO7.SORT_DESC) ? (0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDbql)));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>column.currentSorting === (0, $8jOO7.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                ...iconProps,
                size: "small"
            }),
        label: label,
        spacing: "compact",
        appearance: "subtle",
        isTooltipDisabled: false,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        testId: "native-issue-table.ui.issue-table.header.header-cell.header-cell-actions.sort-button.icon-button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label,
        delay: 0,
        ignoreTooltipPointerEvents: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dc75ba32cd925e8e$var$ConditionalIconContainer, null, column.currentSorting === (0, $8jOO7.SORT_DESC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: label,
            color: "currentColor",
            size: "small"
        })),
        isSelected: column.currentSorting !== (0, $8jOO7.SORT_NONE),
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }));
};
const $dc75ba32cd925e8e$var$iconContainerStyles = (0, $1DXK0.xcss)({
    margin: 'space.025'
});

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});

parcelRegister("dIts6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b92c373f114cd793$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b92c373f114cd793$var$messages = (0, $7qGN1.defineMessages)({
    sortedTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip",
        "defaultMessage": "Sorted {sortDescription}"
    },
    sortedTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-tooltip-new",
        "defaultMessage": "Sorted {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip",
        "defaultMessage": "Sort {sortDescription}"
    },
    sortPromptTooltipNew: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip-new",
        "defaultMessage": "Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}"
    },
    sortPromptDefaultTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sort-prompt-default-tooltip",
        "defaultMessage": "Sort in ascending order"
    },
    sortedDefaultAscendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-ascending-tooltip",
        "defaultMessage": "Sorted in ascending order"
    },
    sortedDefaultDescendingTooltip: {
        "id": "native-issue-table.table-header-row.sort-headers.sorted-default-descending-tooltip",
        "defaultMessage": "Sorted in descending order"
    }
});
var $b92c373f114cd793$export$2e2bcd8739ae039 = $b92c373f114cd793$var$messages;

});



parcelRegister("4G6Vc", function(module, exports) {
$parcel$export(module.exports, "ResizePopup", () => $75984c1816247788$export$8ddf8c84a74a26df);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $3L3Os = parcelRequire("3L3Os");
var $dNvCk = parcelRequire("dNvCk");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $MevUn = parcelRequire("MevUn");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $8jOO7 = parcelRequire("8jOO7");

var $3R7ZX = parcelRequire("3R7ZX");

var $eEBCh = parcelRequire("eEBCh");
const $75984c1816247788$var$ResizePopupContent = ({ columnTitle: columnTitle, initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, onChange: onChange, onCancel: onCancel, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef, isMultiColumnMergedCell: isMultiColumnMergedCell, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleDragOrTouchStart = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    let minimumColumnWidth;
    if (isMultiColumnMergedCell) minimumColumnWidth = mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minimumColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    const defaultMinWidth = isCompactColumnEnabled ? (0, $8jOO7.MINIMUM_COLUMN_WIDTH_COMPACT) : minimumColumnWidth;
    const minWidth = minimumWidth || defaultMinWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.200",
        xcss: $75984c1816247788$var$PopupContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: ({ width: width })=>onSubmit((0, $3R7ZX.ensureWidthWithinLimits)(width, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell, mergedColumnMinWidth))
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dNvCk.default), {
            label: formatMessage((0, $eEBCh.default).columnWidthLabel, {
                columnTitle: columnTitle
            }),
            name: "width",
            defaultValue: initialWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MevUn.default), {
                ...fieldProps,
                ref: setInitialFocusRef,
                min: minWidth,
                max: (0, $8jOO7.MAXIMUM_COLUMN_WIDTH),
                step: 5,
                onChange: (value)=>{
                    onChange(value);
                    fieldProps.onChange(value);
                },
                draggable: true,
                onDragStart: handleDragOrTouchStart,
                onTouchStart: handleDragOrTouchStart
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            space: "space.100",
            alignInline: "end",
            xcss: $75984c1816247788$var$FormFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $eEBCh.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            type: "submit",
            appearance: "primary"
        }, formatMessage((0, $eEBCh.default).save))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
const $75984c1816247788$export$8ddf8c84a74a26df = ({ columnTitle: columnTitle, initialWidth: initialWidth, placement: placement, isOpen: isOpen, isCompactColumnEnabled: isCompactColumnEnabled = false, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, minimumWidth: minimumWidth, trigger: trigger, onChange: onChange, onCancel: onCancelProp, onSubmit: onSubmit, isMultiColumnMergedCell: isMultiColumnMergedCell, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onCancel = (0, $eJOHy.useCallback)((event, analyticsEventParam)=>{
        const analyticsEvent = analyticsEventParam ?? createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'cancelColumnResize');
        onCancelProp(event);
    }, [
        onCancelProp,
        createAnalyticsEvent
    ]);
    const PopupContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($75984c1816247788$var$ResizePopupContent, {
            columnTitle: columnTitle,
            initialWidth: initialWidth,
            isCompactColumnEnabled: isCompactColumnEnabled,
            minimumWidth: minimumWidth,
            onChange: onChange,
            onCancel: onCancel,
            onSubmit: onSubmit,
            setInitialFocusRef: setInitialFocusRef,
            isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled,
            isMultiColumnMergedCell: isMultiColumnMergedCell,
            mergedColumnMinWidth: mergedColumnMinWidth
        }), [
        columnTitle,
        initialWidth,
        isCompactColumnEnabled,
        minimumWidth,
        onChange,
        onCancel,
        onSubmit,
        isSingleLineRowHeightEnabled,
        isMultiColumnMergedCell,
        mergedColumnMinWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        testId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.resize-popup",
        placement: placement,
        isOpen: isOpen,
        onClose: onCancel,
        trigger: trigger,
        content: PopupContent,
        shouldRenderToParent: true,
        messageId: "native-issue-table.ui.issue-table.header.header-cell.resize-popup.popup",
        messageType: "transactional",
        ...(0, $4cTDP.fg)('nin-grid-keyboard-navigation') && {
            role: 'dialog',
            label: columnTitle
        }
    });
};
const $75984c1816247788$var$PopupContentStyles = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    marginBlock: 'space.200',
    whiteSpace: 'normal'
});
const $75984c1816247788$var$FormFooterStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginTop: 'space.100'
});

});
parcelRegister("dNvCk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bc12428617c0200$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Range field__
 *
 * A range field is where a user can submit a range input as a part of a form.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#rangefield-reference)
 */ const $4bc12428617c0200$var$RangeField = ({ children: children, defaultValue: defaultValue, id: id, isDisabled: isDisabled, label: label, name: name })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        defaultValue: defaultValue,
        id: id,
        isDisabled: isDisabled,
        label: label,
        name: name,
        transform: Number,
        children: ({ fieldProps: { isInvalid: isInvalid, isRequired: isRequired, ...fieldProps }, ...rest })=>// isInvalid and isRequired are specifically invalid for range inputs
            children({
                fieldProps: fieldProps,
                ...rest
            })
    });
var $4bc12428617c0200$export$2e2bcd8739ae039 = $4bc12428617c0200$var$RangeField;

});

parcelRegister("MevUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0f57dfc7b1472c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dbgh6 = parcelRequire("dbgh6");
const $9c0f57dfc7b1472c$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $9c0f57dfc7b1472c$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $9c0f57dfc7b1472c$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $9c0f57dfc7b1472c$var$noop = (0, $3Vuhz.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $9c0f57dfc7b1472c$var$Range = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $9c0f57dfc7b1472c$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $9c0f57dfc7b1472c$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbgh6.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $9c0f57dfc7b1472c$export$2e2bcd8739ae039 = $9c0f57dfc7b1472c$var$Range;

});
parcelRegister("dbgh6", function(module, exports) {
$parcel$export(module.exports, "Input", () => $b65ac72e66820907$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b65ac72e66820907$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $b65ac72e66820907$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $b65ac72e66820907$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $b65ac72e66820907$var$webkitStyles = null;
const $b65ac72e66820907$var$firefoxStyles = null;
const $b65ac72e66820907$var$baseStyles = null;
const $b65ac72e66820907$var$themeStyles = null;
const $b65ac72e66820907$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1qll _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfk1b6k _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $b65ac72e66820907$var$rangeA11yStyles = null;
const $b65ac72e66820907$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1qll _m8f8bpmo _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf5udg _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdlb4i _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1qll _1rf3bpmo _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el5udg _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywlb4i _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvolb4i _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11kge _15dp1yrq _18lxyvsn _jxar1eo5 _ydqghkel _1jhc1eo5 _1ruc16ss _164c194a",
            "_1drq1b6k _15dp1vck _18lx1b6k _g6tdfajl _168li2wt _37ywfajl _1kd2i2wt _1sdc1lpd _ydqgmpja"
        ])
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b65ac72e66820907$var$trackStyles.root,
            strippedProps.disabled && $b65ac72e66820907$var$trackStyles.disabled
        ]),
        children: input
    });
});
$b65ac72e66820907$export$f5b8910cec6cf069.displayName = 'InputRange';

});


parcelRegister("3R7ZX", function(module, exports) {
$parcel$export(module.exports, "setCssResizingOffset", () => $89884b47ae19eb85$export$1799580b35bc0fce);
$parcel$export(module.exports, "clearCssResizingOffset", () => $89884b47ae19eb85$export$4a29049b3e1cea2c);
$parcel$export(module.exports, "setCssResizingWidth", () => $89884b47ae19eb85$export$7bda7a969edeaaf9);
$parcel$export(module.exports, "clearCssResizingWidth", () => $89884b47ae19eb85$export$c418ab97f3e5c176);
$parcel$export(module.exports, "disableCssPointerEvents", () => $89884b47ae19eb85$export$b0074a660e898e0);
$parcel$export(module.exports, "enableCssPointerEvents", () => $89884b47ae19eb85$export$1b5de7c0486b5e41);
$parcel$export(module.exports, "ensureWidthWithinLimits", () => $89884b47ae19eb85$export$3a38b06f96ddcc2d);
$parcel$export(module.exports, "getProposedWidth", () => $89884b47ae19eb85$export$39e6ff87d188b0e6);

var $8jOO7 = parcelRequire("8jOO7");
const $89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';
const $89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY = '--local-resizing-offset';
const $89884b47ae19eb85$export$1799580b35bc0fce = (container, width)=>{
    container?.style.setProperty($89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY, `${width}px`);
};
const $89884b47ae19eb85$export$4a29049b3e1cea2c = (container)=>{
    container?.style.removeProperty($89884b47ae19eb85$var$CSS_RESIZING_OFFSETX_PROPERTY);
};
const $89884b47ae19eb85$export$7bda7a969edeaaf9 = (container, width)=>{
    container?.style.setProperty($89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
const $89884b47ae19eb85$export$c418ab97f3e5c176 = (container)=>{
    container?.style.removeProperty($89884b47ae19eb85$var$CSS_RESIZING_WIDTH_PROPERTY);
};
const $89884b47ae19eb85$export$b0074a660e898e0 = (container)=>{
    container?.style.setProperty('pointer-events', 'none');
};
const $89884b47ae19eb85$export$1b5de7c0486b5e41 = (container)=>{
    container?.style.removeProperty('pointer-events');
};
const $89884b47ae19eb85$export$3a38b06f96ddcc2d = (width, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell, mergedColumnMinWidth)=>{
    let minColumnWidth;
    if (isMultiColumnMergedCell) minColumnWidth = mergedColumnMinWidth || (0, $8jOO7.MINIMUM_MERGED_CELL_COLUMN_WIDTH);
    else minColumnWidth = isSingleLineRowHeightEnabled ? (0, $8jOO7.SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH) : (0, $8jOO7.MINIMUM_COLUMN_WIDTH);
    return Math.min(Math.max(isCompactColumnEnabled ? (0, $8jOO7.MINIMUM_COLUMN_WIDTH_COMPACT) : minColumnWidth, width), (0, $8jOO7.MAXIMUM_COLUMN_WIDTH));
};
const $89884b47ae19eb85$export$39e6ff87d188b0e6 = ({ initialWidth: initialWidth, isCompactColumnEnabled: isCompactColumnEnabled, location: location, isSingleLineRowHeightEnabled: isSingleLineRowHeightEnabled, isMultiColumnMergedCell: isMultiColumnMergedCell, mergedColumnMinWidth: mergedColumnMinWidth })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    const proposedWidth = initialWidth + diffX;
    // ensure we don't go below the min allowed width
    return $89884b47ae19eb85$export$3a38b06f96ddcc2d(proposedWidth, isCompactColumnEnabled, isSingleLineRowHeightEnabled, isMultiColumnMergedCell, mergedColumnMinWidth);
};

});

parcelRegister("eEBCh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff6be754c5e1a549$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ff6be754c5e1a549$var$messages = (0, $7qGN1.defineMessages)({
    columnWidthLabel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.column-width-label",
        "defaultMessage": "Column width - {columnTitle}"
    },
    cancel: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.cancel",
        "defaultMessage": "Cancel"
    },
    save: {
        "id": "native-issue-table.issue-table.header.header-cell.resize-popup.save",
        "defaultMessage": "Save"
    }
});
var $ff6be754c5e1a549$export$2e2bcd8739ae039 = $ff6be754c5e1a549$var$messages;

});



parcelRegister("3utN3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3771e5fb7245c307$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3771e5fb7245c307$var$messages = (0, $7qGN1.defineMessages)({
    movedColumn: {
        "id": "native-issue-table.issue-table.header.moved-column",
        "defaultMessage": "You\u2019ve moved {column} from {previousPosition} to {position} of {total}."
    }
});
var $3771e5fb7245c307$export$2e2bcd8739ae039 = $3771e5fb7245c307$var$messages;

});


parcelRegister("eI4dM", function(module, exports) {
$parcel$export(module.exports, "default", () => $65dc4e4263660c62$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $65dc4e4263660c62$var$messages = (0, $7qGN1.defineMessages)({
    issuesTableLabel: {
        "id": "native-issue-table.issue-table.issues-table-label",
        "defaultMessage": "Issues"
    },
    issuesTableLabelIssueTermRefresh: {
        "id": "native-issue-table.issue-table.issues-table-label-issue-term-refresh",
        "defaultMessage": "Work"
    }
});
var $65dc4e4263660c62$export$2e2bcd8739ae039 = $65dc4e4263660c62$var$messages;

});

parcelRegister("l00LF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e01c1501c2df9d15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $3xT3U = parcelRequire("3xT3U");

var $eS29z = parcelRequire("eS29z");

var $dK9Sm = parcelRequire("dK9Sm");

var $hnyyS = parcelRequire("hnyyS");
const $e01c1501c2df9d15$var$NoColumnsRenderer = ({ NoColumns: NoColumns = (0, $dK9Sm.NoColumns), hasColumnConfiguration: hasColumnConfiguration, isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e01c1501c2df9d15$var$NoColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoColumns, {
        defaultNoColumnsGlyph: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $e01c1501c2df9d15$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3xT3U.default), {
            alt: ""
        })),
        hasColumnConfiguration: hasColumnConfiguration
    }), isLoading && ((0, $4cTDP.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
        interactionName: "issue-table-no-columns-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoColumns"
    }));
var $e01c1501c2df9d15$export$2e2bcd8739ae039 = $e01c1501c2df9d15$var$NoColumnsRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e01c1501c2df9d15$var$NoColumnsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf",
            __cmplp.className
        ])
    });
});
const $e01c1501c2df9d15$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.300'
});

});
parcelRegister("3xT3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e8HDz")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aiB9q")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $aiB9q = parcelRequire("aiB9q");

var $e8HDz = parcelRequire("e8HDz");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e8HDz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aiB9q))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("aiB9q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("e8HDz", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});


parcelRegister("dK9Sm", function(module, exports) {
$parcel$export(module.exports, "NoColumns", () => $edb4c92fc13b3452$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $kRgKj = parcelRequire("kRgKj");

var $5F0C9 = parcelRequire("5F0C9");
const $edb4c92fc13b3452$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isOpen: isOpen }, actions] = (0, $PETi0.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $5F0C9.default).noColumnsHeaderText),
        description: formatMessage((0, $5F0C9.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $5F0C9.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("5F0C9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eacbcb43f37199f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eacbcb43f37199f6$var$messages = (0, $7qGN1.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});
var $eacbcb43f37199f6$export$2e2bcd8739ae039 = $eacbcb43f37199f6$var$messages;

});



parcelRegister("kaSuB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8f0c91843002930$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $7uL8m = parcelRequire("7uL8m");

var $kKCMK = parcelRequire("kKCMK");

var $eS29z = parcelRequire("eS29z");

var $6XJko = parcelRequire("6XJko");

var $hnyyS = parcelRequire("hnyyS");

var $eu3ki = parcelRequire("eu3ki");
const $c8f0c91843002930$var$NoIssuesRenderer = ({ NoIssues: NoIssues = (0, $eu3ki.NoIssues), isLoading: isLoading = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8f0c91843002930$var$EmptyIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoIssues, {
        defaultNoIssuesGlyph: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c8f0c91843002930$var$ImageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
            alt: ""
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c8f0c91843002930$var$ImageWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
            alt: ""
        }))
    }), isLoading && ((0, $4cTDP.fg)('add_nin_press_interactions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.Overlay), {
        interactionName: "issue-table-no-issues-renderer-overlay"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hnyyS.OverlayOld), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "nativeIssueTableNoResults"
    }));
var $c8f0c91843002930$export$2e2bcd8739ae039 = $c8f0c91843002930$var$NoIssuesRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8f0c91843002930$var$EmptyIssuesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvidpf _mezj18pt",
            __cmplp.className
        ])
    });
});
const $c8f0c91843002930$var$ImageWrapperStylesOld = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.300'
});
const $c8f0c91843002930$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginBottom: 'space.300'
});

});
parcelRegister("7uL8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a8498e45c2fcae9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $lGiXj = parcelRequire("lGiXj");

var $dIBgP = parcelRequire("dIBgP");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $8a8498e45c2fcae9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dIBgP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lGiXj))
});
var $8a8498e45c2fcae9$export$2e2bcd8739ae039 = $8a8498e45c2fcae9$var$Illustration;
// for advanced use only
const $8a8498e45c2fcae9$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("lGiXj", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("dIBgP", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("kKCMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaae219acd4147f1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $js5cg = parcelRequire("js5cg");

var $hj82Y = parcelRequire("hj82Y");
const $aaae219acd4147f1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hj82Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($js5cg))
});
var $aaae219acd4147f1$export$2e2bcd8739ae039 = $aaae219acd4147f1$var$Illustration;
// for advanced use only
const $aaae219acd4147f1$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("js5cg", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("eu3ki", function(module, exports) {
$parcel$export(module.exports, "NoIssues", () => $ab49ca26ec37a201$export$a7a61a727a1d891b);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $fjV4E = parcelRequire("fjV4E");
const $ab49ca26ec37a201$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fjV4E.default).emptyIssuesIssueTermRefresh : (0, $fjV4E.default).emptyIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "native-issue-table.ui.issue-table.no-issues-renderer.no-issues.empty-state"
    }));
};

});
parcelRegister("fjV4E", function(module, exports) {
$parcel$export(module.exports, "default", () => $386c8ad01edb0ce6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $386c8ad01edb0ce6$var$messages = (0, $7qGN1.defineMessages)({
    emptyIssues: {
        "id": "native-issue-table.issue-table.empty-issues.empty-issues",
        "defaultMessage": "There are no issues"
    },
    emptyIssuesIssueTermRefresh: {
        "id": "native-issue-table.issue-table.no-issues-renderer.no-issues.empty-issues-issue-term-refresh",
        "defaultMessage": "There are no work items"
    }
});
var $386c8ad01edb0ce6$export$2e2bcd8739ae039 = $386c8ad01edb0ce6$var$messages;

});



parcelRegister("l7U99", function(module, exports) {
$parcel$export(module.exports, "default", () => $3954d1d23379332f$export$2e2bcd8739ae039);

var $4yX3z = parcelRequire("4yX3z");

var $exZUf = parcelRequire("exZUf");

var $kjySA = parcelRequire("kjySA");

var $7syZR = parcelRequire("7syZR");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $bJscI = parcelRequire("bJscI");

var $1q3Q0 = parcelRequire("1q3Q0");

var $jNv5I = parcelRequire("jNv5I");

var $8Ckd4 = parcelRequire("8Ckd4");
const $3954d1d23379332f$var$TableBodyNonMemoized = ({ issueResults: issueResults, project: project, rankField: rankField, isGroupingSupported: isGroupingSupported, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isDraggingRowFaded: isDraggingRowFaded, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, topLevelIssueCreateConfig: topLevelIssueCreateConfig, initialPopulateConnectionArgs: initialPopulateConnectionArgs, ...tableBodyProps })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $7syZR.default), issueResults);
    const projectData = (0, $j4oe4.useFragment)((0, $kjySA.default), project);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $exZUf.default), formattingRules);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $4yX3z.default), rankField);
    const renderChildRows = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Ckd4.RenderChildRowsComp), {
            project: projectData,
            projectKey: projectData?.key,
            columns: tableBodyProps.columns,
            isGroupingSupported: isGroupingSupported,
            rankField: rankFieldData ?? null,
            formattingRules: formattingRulesData,
            rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
            ...props
        }), [
        projectData,
        tableBodyProps.columns,
        isGroupingSupported,
        rankFieldData,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3954d1d23379332f$var$StyledTableBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNv5I.RowContextProvider), {
        ...tableBodyProps,
        renderChildRows: renderChildRows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
        issueResults: issueResultsData,
        parentItemId: "root",
        itemsConnectionId: issueResultsData.__id,
        project: projectData,
        rankFieldId: rankFieldData?.fieldId,
        isDraggingRowFaded: isDraggingRowFaded,
        formattingRules: formattingRulesData,
        rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
        topLevelIssueCreateConfig: topLevelIssueCreateConfig,
        ...(0, $4cTDP.fg)('jsc_list_reparenting') ? {
            projectKey: projectData?.key
        } : {},
        initialPopulateConnectionArgs: initialPopulateConnectionArgs
    })));
};
const $3954d1d23379332f$var$TableBody = (0, $bJscI.componentWithFG)('initialise_virtualiser_state_from_relay_store', /*#__PURE__*/ (0, $eJOHy.memo)($3954d1d23379332f$var$TableBodyNonMemoized), $3954d1d23379332f$var$TableBodyNonMemoized);
var $3954d1d23379332f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3954d1d23379332f$var$TableBody;
const $3954d1d23379332f$var$StyledTableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlglyw _1reo15vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4yX3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d9baf284aa9b3d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16e19713d9f0bff2841d815c12afe04a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d9baf284aa9b3d4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TableBody_rankField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "FragmentSpread",
            "name": "RenderChildRowsComp_rank"
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$5d9baf284aa9b3d4$var$node.hash = "3b686d9f0dadcc2230fcc1b560e63dd1";
var $5d9baf284aa9b3d4$export$2e2bcd8739ae039 = $5d9baf284aa9b3d4$var$node;

});

parcelRegister("exZUf", function(module, exports) {
$parcel$export(module.exports, "default", () => $708b88f983daec46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e1ad2d5389fd1a44a3c0fa95125a714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $708b88f983daec46$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TableBody_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Rows_rules"
        },
        {
            "kind": "FragmentSpread",
            "name": "RenderChildRowsComp_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$708b88f983daec46$var$node.hash = "f8bf89a7757ce2f426b62f58f32de215";
var $708b88f983daec46$export$2e2bcd8739ae039 = $708b88f983daec46$var$node;

});

parcelRegister("kjySA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7754642f40c1e6ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8defb12120a37aaf18eb712863faea6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7754642f40c1e6ff$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "TableBody_project",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "Rows_project"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "RenderChildRowsComp"
            }
        ],
        "type": "JiraProject"
    };
}();
$7754642f40c1e6ff$var$node.hash = "b3eb4cabe24774b041888ec784130720";
var $7754642f40c1e6ff$export$2e2bcd8739ae039 = $7754642f40c1e6ff$var$node;

});

parcelRegister("7syZR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cb05e998f3b34a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db2e90eea340443c8f60868a63b6c50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4cb05e998f3b34a5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDensityFull"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEditableSyncLoaded"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isInlineEditingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isLinkRelationshipFieldEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isRemoteLinkedIssuesEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isReparentingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTimelineEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "TableBodyTableBody",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                },
                {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                },
                {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isRemoteLinkedIssuesEnabled",
                    "variableName": "isRemoteLinkedIssuesEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "isReparentingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$4cb05e998f3b34a5$var$node.hash = "c3eb6bdb6dddda37a06dbda438791d22";
var $4cb05e998f3b34a5$export$2e2bcd8739ae039 = $4cb05e998f3b34a5$var$node;

});

parcelRegister("8Ckd4", function(module, exports) {
$parcel$export(module.exports, "RenderChildRowsComp", () => $8e9548743b291663$export$c65f147e25ffd0e6);

var $hVMlo = parcelRequire("hVMlo");

var $FxVPX = parcelRequire("FxVPX");

var $1p1IT = parcelRequire("1p1IT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cNwIG = parcelRequire("cNwIG");

var $l6qXI = parcelRequire("l6qXI");

var $4cTDP = parcelRequire("4cTDP");

var $1q3Q0 = parcelRequire("1q3Q0");

var $8jOO7 = parcelRequire("8jOO7");

var $cgCO4 = parcelRequire("cgCO4");

var $34oCh = parcelRequire("34oCh");

var $bKlUQ = parcelRequire("bKlUQ");

var $7n9BS = parcelRequire("7n9BS");

var $aNnbk = parcelRequire("aNnbk");

var $kfIml = parcelRequire("kfIml");

var $9r0oq = parcelRequire("9r0oq");
const $8e9548743b291663$var$renderDraggableWrapper = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kfIml.DraggableRowsContainer), {
        issueConnectionId: props.issueConnectionId,
        instanceId: props.instanceId
    }, props.children);
};
const $8e9548743b291663$export$c65f147e25ffd0e6 = ({ project: project, projectKey: projectKey, isGroupingSupported: isGroupingSupported, columns: columns, rankField: rankField, formattingRules: formattingRules, rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields, ...childRowsProps })=>{
    const ChildIssueCreateRowComponent = (0, $9r0oq.useTimelineCustomComponents)()?.ChildIssueCreateRow;
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('jira_list_frozen_column_bugfix')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    else {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isStickyColumnsVisible: isStickyColumnsVisibleOld } = (0, $cgCO4.useShouldApplyFrozenColumns)();
        isStickyColumnsVisible = isStickyColumnsVisibleOld;
    }
    const renderTableCell = (tableCellProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bKlUQ.TableCell), tableCellProps);
    const projectRef = (0, $j4oe4.useFragment)((0, $1p1IT.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $FxVPX.default), rankField);
    const formattingRulesData = (0, $j4oe4.useFragment)((0, $hVMlo.default), formattingRules);
    /**
   * Passing those values down to ChildRowsLoader as props to avoid direct imports
   */ const jql = (0, $34oCh.useJql)();
    const sortField = (0, $34oCh.useSortField)();
    const sortDirection = (0, $34oCh.useSortDirection)();
    const isReparentingEnabled = (0, $34oCh.useIsReparentingEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isFixedTableLayoutEnabled = (0, $34oCh.useIsFixedTableLayoutEnabled)();
    const width = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.width);
    const isIssueRankDescending = (0, $34oCh.useIsIssueRankDescending)();
    const isInlineFieldConfigEnabled = (0, $34oCh.useIsInlineFieldConfigEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isRemoteLinkedIssuesEnabled = (0, $34oCh.useIsRemoteLinkedIssuesEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const cellBorderStyle = (0, $34oCh.useCellBorderStyle)();
    const isInlineEditingEnabled = (0, $4cTDP.fg)('jira_timeline_disable_child_inline_editing') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $34oCh.useIsInlineEditingEnabled)() : true;
    const isConditionalFormattingEnabled = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4cTDP.fg)('jira_list_conditional_formatting') && (0, $34oCh.useIsConditionalFormattingEnabled)();
    const rankFieldTerms = (0, $eJOHy.useMemo)(()=>({
            jqlTerm: rankFieldData?.jqlTerm ?? null,
            aliases: rankFieldData?.aliases ? Array.from(rankFieldData.aliases) : null
        }), [
        rankFieldData
    ]);
    const renderCreateIssueController = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNnbk.CreateIssueController), {
            ...props,
            jql: jql,
            rankFieldTerms: rankFieldTerms
        }), [
        jql,
        rankFieldTerms
    ]);
    const renderChildRowsLoader = (0, $eJOHy.useCallback)((childRowsLoaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l6qXI.ChildRowsLoader), {
            ...childRowsLoaderProps,
            jql: jql,
            width: width,
            sortField: sortField,
            sortDirection: sortDirection,
            columns: columns,
            amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
            actionColumns: (0, $8jOO7.ACTION_COLUMNS),
            pageSize: (0, $8jOO7.CHILD_QUERY_PAGE_SIZE),
            isReparentingEnabled: isReparentingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isIssueRankDescending: isIssueRankDescending,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            isFixedTableLayoutEnabled: isFixedTableLayoutEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            rankFieldId: rankFieldData?.fieldId,
            renderRows: (rowProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q3Q0.default), {
                    project: projectRef,
                    formattingRules: formattingRulesData,
                    rowInlineCreateCanShowAdditionalFields: rowInlineCreateCanShowAdditionalFields,
                    ...rowProps
                }),
            renderDraggableWrapper: $8e9548743b291663$var$renderDraggableWrapper,
            renderTableCell: renderTableCell,
            isStickyColumnsVisible: isStickyColumnsVisible,
            renderCreateIssueController: renderCreateIssueController,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            ChildIssueCreateRowComponent: ChildIssueCreateRowComponent,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isRemoteLinkedIssuesEnabled: isRemoteLinkedIssuesEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded,
            cellBorderStyle: cellBorderStyle,
            isInlineEditingEnabled: isInlineEditingEnabled
        }), [
        jql,
        width,
        sortField,
        sortDirection,
        columns,
        isReparentingEnabled,
        isTimelineEnabled,
        isIssueRankDescending,
        isHideDoneItemsEnabled,
        isFixedTableLayoutEnabled,
        isConditionalFormattingEnabled,
        rankFieldData?.fieldId,
        isStickyColumnsVisible,
        renderCreateIssueController,
        isInlineFieldConfigEnabled,
        ChildIssueCreateRowComponent,
        isLinkRelationshipFieldEnabled,
        isRemoteLinkedIssuesEnabled,
        isEditableSyncLoaded,
        cellBorderStyle,
        isInlineEditingEnabled,
        projectRef,
        formattingRulesData,
        rowInlineCreateCanShowAdditionalFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNwIG.ChildRows), {
        ...childRowsProps,
        projectKey: projectKey,
        isGroupingSupported: isGroupingSupported,
        childItemsExperience: (0, $8jOO7.CHILD_ITEMS_EXPERIENCE),
        childItemsLoadMoreExperience: (0, $8jOO7.CHILD_ITEMS_LOAD_MORE_EXPERIENCE),
        analyticsSource: (0, $8jOO7.ANALYTICS_SOURCE),
        renderChildRowsLoader: renderChildRowsLoader
    });
};

});
parcelRegister("hVMlo", function(module, exports) {
$parcel$export(module.exports, "default", () => $931f54187dc17b92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7052991347d47bc90cc91bb7b32bbf89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $931f54187dc17b92$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RenderChildRowsComp_rules",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Rows_rules"
        }
    ],
    "type": "JiraFormattingRuleConnection"
};
$931f54187dc17b92$var$node.hash = "c7d2d776221c63e40579cb004a5363d9";
var $931f54187dc17b92$export$2e2bcd8739ae039 = $931f54187dc17b92$var$node;

});

parcelRegister("FxVPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $20a3279043610e35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa6a155db23a8bab5e2a76e41692e658>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20a3279043610e35$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "RenderChildRowsComp_rank",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "jqlTerm"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "aliases"
                }
            ]
        }
    ],
    "type": "JiraJqlFieldWithAliases"
};
$20a3279043610e35$var$node.hash = "f7566d909ef8ff6dbcaf39bc2e7997a7";
var $20a3279043610e35$export$2e2bcd8739ae039 = $20a3279043610e35$var$node;

});

parcelRegister("1p1IT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6659c8cd1c8f5f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26953e9dec78044a229ec6efe64b64d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c6659c8cd1c8f5f1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "RenderChildRowsComp",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Rows_project"
        }
    ],
    "type": "JiraProject"
};
$c6659c8cd1c8f5f1$var$node.hash = "b22d740a214bd50022d2b05cb96bd804";
var $c6659c8cd1c8f5f1$export$2e2bcd8739ae039 = $c6659c8cd1c8f5f1$var$node;

});



parcelRegister("7WpdI", function(module, exports) {
$parcel$export(module.exports, "InitializeVirtualizer", () => $771cea3dfdc61397$export$de49fec4748def14);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $6d9QY = parcelRequire("6d9QY");

var $4cTDP = parcelRequire("4cTDP");

var $fsisP = parcelRequire("fsisP");

var $8jOO7 = parcelRequire("8jOO7");

var $7n9BS = parcelRequire("7n9BS");

var $4jaZO = parcelRequire("4jaZO");

var $Kdcei = parcelRequire("Kdcei");
const $771cea3dfdc61397$var$estimateSize = ()=>(0, $8jOO7.ROW_HEIGHT) + 1; // include border
const $771cea3dfdc61397$var$InitializeVirtualizerInner = ({ rows: rows = 0, getItemKey: getItemKey, totalSizeRef: totalSizeRef, options: virtualizerOptions })=>{
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const { setVirtualizer: setVirtualizer, setVirtualItemsMap: setVirtualItemsMap } = (0, $Kdcei.useVirtualizationActions)();
    const options = (0, $eJOHy.useMemo)(()=>({
            count: rows,
            getScrollElement: ()=>scrollElement,
            estimateSize: $771cea3dfdc61397$var$estimateSize,
            getItemKey: getItemKey,
            overscan: 10,
            ...(0, $4cTDP.fg)('jira_spreadsheet_timeline_image_export') && virtualizerOptions
        }), [
        getItemKey,
        rows,
        scrollElement,
        virtualizerOptions
    ]);
    const virtualizer = (0, $4jaZO.useSSRSafeVirtualizer)(options);
    const totalSize = virtualizer?.getTotalSize();
    const items = virtualizer?.getVirtualItems();
    // eslint-disable-next-line no-param-reassign, react-hooks/react-compiler
    totalSizeRef.current = totalSize ?? 0;
    const prevVirtualizer = (0, $6d9QY.usePrevious)(virtualizer);
    const prevItems = (0, $6d9QY.usePrevious)(items);
    if (!(0, $fsisP.isShallowEqual)(prevVirtualizer, virtualizer)) setVirtualizer(virtualizer);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevItems, items)) {
        const virtualItemsMap = items?.reduce((acc, item)=>{
            acc[String(item.key)] = true;
            return acc;
        }, {});
        setVirtualItemsMap(virtualItemsMap);
    }
    return null;
};
const $771cea3dfdc61397$export$de49fec4748def14 = (props)=>{
    // Skip any attempts to perform virtualization in SSR
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($771cea3dfdc61397$var$InitializeVirtualizerInner, props);
};

});

parcelRegister("kmVLU", function(module, exports) {
$parcel$export(module.exports, "InitializeVirtualizer", () => $c926824b20470c00$export$de49fec4748def14);

var $4eh91 = parcelRequire("4eh91");

var $XSiqJ = parcelRequire("XSiqJ");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $6d9QY = parcelRequire("6d9QY");

var $4cTDP = parcelRequire("4cTDP");

var $fsisP = parcelRequire("fsisP");

var $jE8Tu = parcelRequire("jE8Tu");

var $jBNts = parcelRequire("jBNts");

var $8jOO7 = parcelRequire("8jOO7");

var $7n9BS = parcelRequire("7n9BS");

var $4jaZO = parcelRequire("4jaZO");

var $Kdcei = parcelRequire("Kdcei");
const $c926824b20470c00$var$estimateSize = ()=>(0, $8jOO7.ROW_HEIGHT) + 1; // include border
const $c926824b20470c00$var$InitializeVirtualizerInner = ({ options: virtualizerOptions, issueResults: issueResults, groupResults: groupResults })=>{
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const flatList = (0, $jE8Tu.useFlatList)();
    const { setVirtualizer: setVirtualizer, setVirtualItemsMap: setVirtualItemsMap } = (0, $Kdcei.useVirtualizationActions)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $XSiqJ.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $4eh91.default), groupResults);
    // initialFlatList is currently only guaranteed to keep virtualiser props stable while flatList is empty
    // If flatList is no longer empty, initialFlatList should be ignored
    const initialFlatList = (0, $eJOHy.useMemo)(()=>{
        if (!(flatList?.length <= 0 && (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store'))) return [];
        if (issueResultsData && issueResultsData.edges) return issueResultsData.edges.map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                itemId: issueId
            }));
        if (groupResultsData && groupResultsData.firstGroup && groupResultsData?.firstGroup?.id) {
            const firstGroupId = groupResultsData.firstGroup.id;
            return [
                (0, $jBNts.getFlatListKey)({
                    itemId: firstGroupId,
                    groupId: firstGroupId
                }),
                ...(groupResultsData.firstGroup.issues?.edges ?? []).map((edge)=>edge?.node?.issueId).filter(Boolean).map((issueId)=>(0, $jBNts.getFlatListKey)({
                        itemId: issueId,
                        groupId: firstGroupId
                    })),
                ...groupResultsData.firstGroup.issues?.pageInfo?.hasNextPage ? [
                    (0, $jBNts.getFlatListKey)({
                        itemId: (0, $jE8Tu.getShowMoreItemKey)(firstGroupId),
                        groupId: firstGroupId
                    })
                ] : [],
                ...(groupResultsData.edges ?? []).map((edge)=>edge?.node?.id).filter((id)=>id !== firstGroupId).filter(Boolean).map((id)=>(0, $jBNts.getFlatListKey)({
                        itemId: id,
                        groupId: id
                    }))
            ];
        }
        return [];
    }, [
        flatList?.length,
        groupResultsData,
        issueResultsData
    ]);
    // Represents a stable list of item keys between first render (i.e. flat list is empty) and after flat list has been initialised in RSS.
    const readyFlatList = flatList?.length === 0 && (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? initialFlatList : flatList;
    const getItemKey = (0, $eJOHy.useCallback)((index)=>readyFlatList[index] ?? index, [
        readyFlatList
    ]);
    // eslint-disable-next-line no-nested-ternary
    const rowsCount = (0, $4cTDP.fg)('initialise_virtualiser_state_from_relay_store') ? readyFlatList.length : flatList?.length > 0 ? flatList?.length : issueResultsData?.edges?.length;
    const options = (0, $eJOHy.useMemo)(()=>({
            count: rowsCount ?? 0,
            getScrollElement: ()=>scrollElement,
            estimateSize: $c926824b20470c00$var$estimateSize,
            getItemKey: getItemKey,
            overscan: 10,
            ...(0, $4cTDP.fg)('jira_spreadsheet_timeline_image_export') && virtualizerOptions
        }), [
        getItemKey,
        rowsCount,
        scrollElement,
        virtualizerOptions
    ]);
    const virtualizer = (0, $4jaZO.useSSRSafeVirtualizer)(options);
    const items = virtualizer?.getVirtualItems();
    const prevVirtualizer = (0, $6d9QY.usePrevious)(virtualizer);
    const prevItems = (0, $6d9QY.usePrevious)(items);
    if (!(0, $fsisP.isShallowEqual)(prevVirtualizer, virtualizer)) setVirtualizer(virtualizer);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevItems, items)) {
        const virtualItemsMap = items?.reduce((acc, item)=>{
            acc[String(item.key)] = true;
            return acc;
        }, {});
        setVirtualItemsMap(virtualItemsMap);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c926824b20470c00$export$7615e534b4b87b24, {
        getItemKey: getItemKey,
        rows: rowsCount ?? 0
    });
};
const $c926824b20470c00$export$de49fec4748def14 = (props)=>{
    // Skip any attempts to perform virtualization in SSR
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c926824b20470c00$var$InitializeVirtualizerInner, props);
};
const $c926824b20470c00$export$7615e534b4b87b24 = ()=>{
    return null;
};

});
parcelRegister("4eh91", function(module, exports) {
$parcel$export(module.exports, "default", () => $45fd073d2b43c74f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f1becf6d7c934b8d6b192b36388f97f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45fd073d2b43c74f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "name": "InitializeVirtualizer_groupResults",
        "selections": [
            {
                "concreteType": "JiraSpreadsheetGroupEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "isPaginating",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "fieldSetsInput",
                                                "variableName": "fieldSetsInput"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 50
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "scope",
                                                "variableName": "fieldSetsScope"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "settings",
                                                "variableName": "settings"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "viewConfigInput",
                                                "variableName": "viewConfigInput"
                                            }
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSpreadsheetGroupConnection"
    };
}();
$45fd073d2b43c74f$var$node.hash = "b08840fcecbc3746016e883b2a2f8f75";
var $45fd073d2b43c74f$export$2e2bcd8739ae039 = $45fd073d2b43c74f$var$node;

});

parcelRegister("XSiqJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $546d74ca528d7fb5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<497bbcfce8667f649dde42a4d193a193>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $546d74ca528d7fb5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "InitializeVirtualizer_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$546d74ca528d7fb5$var$node.hash = "e2ef750f586d3a504b812ff1d64e52a4";
var $546d74ca528d7fb5$export$2e2bcd8739ae039 = $546d74ca528d7fb5$var$node;

});



parcelRegister("12O1M", function(module, exports) {
$parcel$export(module.exports, "default", () => $b411531270e205ba$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fo3wk = parcelRequire("fo3wk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $83DiZ = parcelRequire("83DiZ");

var $jE8Tu = parcelRequire("jE8Tu");

var $34oCh = parcelRequire("34oCh");
const $b411531270e205ba$var$KeyboardShortcuts = ({ onIssueLinkSelected: onIssueLinkSelected })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const isGridNavigationEnabled = (0, $34oCh.useIsGridNavigationEnabled)();
    const [selectedRowIndex, { selectNextRow: selectNextRow, selectPrevRow: selectPrevRow }] = (0, $jE8Tu.useSelectedRow)();
    const [selectedIssueKey] = (0, $jE8Tu.useSelectedIssueKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const keyMap = (0, $eJOHy.useMemo)(()=>{
        const navigateToIssue = (issueKey)=>{
            push(`/browse/${issueKey}`);
        };
        return {
            arrowup: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    if (isGridNavigationEnabled) return;
                    selectPrevRow();
                }
            },
            arrowdown: {
                callback: (e)=>{
                    // Prevent native browser scrolling as we provide auto-scroll functionality via scrollIntoView
                    e?.preventDefault();
                    if (isGridNavigationEnabled) return;
                    selectNextRow();
                }
            },
            k: {
                callback: ()=>{
                    if (isGridNavigationEnabled) return;
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowUp', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'k'
                    });
                    selectPrevRow();
                }
            },
            j: {
                callback: ()=>{
                    if (isGridNavigationEnabled) return;
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'rowItem pressed', 'navigateRowDown', {
                        rowIndex: selectedRowIndex,
                        keyPressed: 'j'
                    });
                    selectNextRow();
                }
            },
            o: {
                callback: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'o',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                        const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                        if (!handled) navigateToIssue(selectedIssueKey);
                    }
                }
            },
            z: {
                callback: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'tableIssueLink', {
                        fieldType: 'unknown',
                        keyPressed: 'z',
                        tableRowNumber: selectedRowIndex,
                        keyboardShortcut: true
                    });
                    if (typeof selectedIssueKey === 'string' && selectedIssueKey.length > 0) {
                        const handled = onIssueLinkSelected !== undefined && onIssueLinkSelected(selectedIssueKey);
                        if (!handled) navigateToIssue(selectedIssueKey);
                    }
                }
            }
        };
    }, [
        push,
        selectPrevRow,
        selectNextRow,
        createAnalyticsEvent,
        selectedRowIndex,
        selectedIssueKey,
        onIssueLinkSelected,
        isGridNavigationEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: keyMap
    });
};
var $b411531270e205ba$export$2e2bcd8739ae039 = $b411531270e205ba$var$KeyboardShortcuts;

});
parcelRegister("fo3wk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4454c8bb14df47ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hrKgE = parcelRequire("hrKgE");

var $9ltuT = parcelRequire("9ltuT");

var $lObif = parcelRequire("lObif");

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");

var $4B7rn = parcelRequire("4B7rn");

var $8gJRB = parcelRequire("8gJRB");
let $4454c8bb14df47ef$var$shortcutsCount = 0;
let $4454c8bb14df47ef$var$subscription = null;
const $4454c8bb14df47ef$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $4B7rn.ShortcutRegistryContext)) || (0, $d94A4.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $8gJRB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $4454c8bb14df47ef$var$shortcutsCount -= 1;
            if ($4454c8bb14df47ef$var$subscription && $4454c8bb14df47ef$var$shortcutsCount === 0) {
                $4454c8bb14df47ef$var$subscription.unsubscribe();
                $4454c8bb14df47ef$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$subscription = $4454c8bb14df47ef$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5R5jr.default)().subscribe((0, $lObif.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $4454c8bb14df47ef$var$Shortcuts = ({ useKeyboardShortcutsToggle: // eslint-disable-next-line react-hooks/react-compiler
useKeyboardShortcutsToggle = (0, $9ltuT.useKeyboardShortcutsToggle), ...unstableProps })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, true);
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4454c8bb14df47ef$var$ShortcutsSubscriber, props) : null;
};
var $4454c8bb14df47ef$export$2e2bcd8739ae039 = $4454c8bb14df47ef$var$Shortcuts;

});
parcelRegister("9ltuT", function(module, exports) {
$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $08e42e851d357ae1$export$a33a81f1fc5458ad);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $08e42e851d357ae1$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $08e42e851d357ae1$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$08e42e851d357ae1$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $3ugTQ.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $08e42e851d357ae1$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $08e42e851d357ae1$export$b62f67be35e65859
    }
});
const $08e42e851d357ae1$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($08e42e851d357ae1$var$Store);

});

parcelRegister("lObif", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6eea6b4ddedc8b9$export$2e2bcd8739ae039);

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");
const $f6eea6b4ddedc8b9$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $f6eea6b4ddedc8b9$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $d94A4.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $5R5jr.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f6eea6b4ddedc8b9$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $5R5jr.flush)();
    }
};
var $f6eea6b4ddedc8b9$export$2e2bcd8739ae039 = $f6eea6b4ddedc8b9$var$handler;

});
parcelRegister("5R5jr", function(module, exports) {
$parcel$export(module.exports, "flush", () => $6bc56ab68fad194d$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $6bc56ab68fad194d$export$2e2bcd8739ae039);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $gPrdS = parcelRequire("gPrdS");
const $6bc56ab68fad194d$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $6bc56ab68fad194d$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$6bc56ab68fad194d$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$6bc56ab68fad194d$var$isEditable(e.target) && !$6bc56ab68fad194d$var$ignoredKeys[e.key]);
const $6bc56ab68fad194d$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $6bc56ab68fad194d$var$key$;
const $6bc56ab68fad194d$var$flush$ = new (0, $6WhQS.Subject)();
const $6bc56ab68fad194d$var$createSequences = ()=>{
    if (!$6bc56ab68fad194d$var$key$) {
        $6bc56ab68fad194d$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($6bc56ab68fad194d$var$isRelevantKeyEvent).filter($6bc56ab68fad194d$export$25d1b8252b4c49b7).map((0, $gPrdS.toKeyWithModifiers));
        const sequence$ = $6bc56ab68fad194d$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $6bc56ab68fad194d$var$key$ = $6bc56ab68fad194d$var$key$.debounceTime(1000).startWith(null).merge($6bc56ab68fad194d$var$flush$).switchMapTo(sequence$);
    }
    return $6bc56ab68fad194d$var$key$;
};
const $6bc56ab68fad194d$export$4909b86c8034bf73 = ()=>{
    $6bc56ab68fad194d$var$flush$.next();
};
var $6bc56ab68fad194d$export$2e2bcd8739ae039 = $6bc56ab68fad194d$var$createSequences;

});


parcelRegister("8gJRB", function(module, exports) {
$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $91e416a701a8c178$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");
const $91e416a701a8c178$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4cTDP.fg)('log-hotkey-analytics')) (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $91e416a701a8c178$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $91e416a701a8c178$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});



parcelRegister("clZvH", function(module, exports) {
$parcel$export(module.exports, "default", () => $19be9f81dd7817e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $19be9f81dd7817e6$var$messages = (0, $7qGN1.defineMessages)({
    columnHeaderIssueType: {
        "id": "native-issue-table.column-header-issue-type",
        "defaultMessage": "Type"
    },
    columnHeaderIssueKey: {
        "id": "native-issue-table.column-header-issue-key",
        "defaultMessage": "Key"
    },
    columnHeaderIssueSummary: {
        "id": "native-issue-table.column-header-issue-summary",
        "defaultMessage": "Summary"
    },
    columnHeaderIssueAssignee: {
        "id": "native-issue-table.column-header-issue-assignee",
        "defaultMessage": "Assignee"
    },
    columnHeaderIssueReporter: {
        "id": "native-issue-table.column-header-issue-reporter",
        "defaultMessage": "Reporter"
    },
    columnHeaderIssuePriority: {
        "id": "native-issue-table.column-header-issue-priority",
        "defaultMessage": "P"
    },
    columnHeaderIssueStatus: {
        "id": "native-issue-table.column-header-issue-status",
        "defaultMessage": "Status"
    },
    columnHeaderIssueResolution: {
        "id": "native-issue-table.column-header-issue-resolution",
        "defaultMessage": "Resolution"
    },
    columnHeaderIssueCreatedDate: {
        "id": "native-issue-table.column-header-issue-created-date",
        "defaultMessage": "Created"
    },
    columnHeaderIssueUpdatedDate: {
        "id": "native-issue-table.column-header-issue-updated-date",
        "defaultMessage": "Updated"
    },
    columnHeaderIssueDueDate: {
        "id": "native-issue-table.column-header-issue-due-date",
        "defaultMessage": "Due"
    },
    columnHeaderIssueActions: {
        "id": "native-issue-table.column-header-issue-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "native-issue-table.a-to-z-order",
        "defaultMessage": "A \u279E Z"
    },
    zToAOrder: {
        "id": "native-issue-table.z-to-a-order",
        "defaultMessage": "Z \u279E A"
    },
    oldestToNewestOrder: {
        "id": "native-issue-table.oldest-to-newest-order",
        "defaultMessage": "oldest \u279E newest"
    },
    newestToOldestOrder: {
        "id": "native-issue-table.newest-to-oldest-order",
        "defaultMessage": "newest \u279E oldest"
    },
    reorderColumnsErrorTitle: {
        "id": "native-issue-table.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    reorderColumnsErrorDescription: {
        "id": "native-issue-table.reorder-columns-error-description",
        "defaultMessage": "Refresh and try again."
    },
    deprecatedParentLinkMessage: {
        "id": "native-issue-table.deprecated-parent-link-message",
        "defaultMessage": "<strong>Parent Link</strong> is replaced by <strong>Parent</strong>."
    }
});
var $19be9f81dd7817e6$export$2e2bcd8739ae039 = $19be9f81dd7817e6$var$messages;

});

parcelRegister("dawqX", function(module, exports) {
$parcel$export(module.exports, "RealtimeUpdater", () => $7be537e3f199cb8b$export$baf32da5b0b92d2b);

var $kg3ul = parcelRequire("kg3ul");

var $f5dCG = parcelRequire("f5dCG");

var $3fLho = parcelRequire("3fLho");

var $8tclj = parcelRequire("8tclj");

var $h8jUt = parcelRequire("h8jUt");

var $8TVgO = parcelRequire("8TVgO");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cHtIB = parcelRequire("cHtIB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8oKDI = parcelRequire("8oKDI");

var $dnCkQ = parcelRequire("dnCkQ");

var $8jOO7 = parcelRequire("8jOO7");

var $lWbOe = parcelRequire("lWbOe");
const $7be537e3f199cb8b$var$REAL_TIME_EVENT_TYPE_KEY = 'realTimeEventType';
const $7be537e3f199cb8b$var$CREATE_ERROR_ID = 'realTimeIssueCreate';
const $7be537e3f199cb8b$var$UPDATE_ERROR_ID = 'realTimeIssueUpdate';
const $7be537e3f199cb8b$var$DELETE_ERROR_ID = 'realTimeIssueDelete';
const $7be537e3f199cb8b$export$d3ea91bf4184016b = 100;
const $7be537e3f199cb8b$export$2c7ede6e55079caa = 3000;
const $7be537e3f199cb8b$var$throttledFireTrackAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((0, $kRgKj.fireTrackAnalytics), 1000);
const $7be537e3f199cb8b$var$issueCreatedSubscription = (0, $8TVgO.default);
const $7be537e3f199cb8b$var$issueUpdatedSubscription = (0, $h8jUt.default);
const $7be537e3f199cb8b$var$issueDeletedSubscription = (0, $8tclj.default);
const $7be537e3f199cb8b$export$baf32da5b0b92d2b = ({ project: project, issues: issues, groups: groups, isHierarchyEnabled: isHierarchyEnabled, isStatusTrackingEnabled: isStatusTrackingEnabled, onRefetch: onRefetch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const hasExceededMaxQueueSizeRef = (0, $eJOHy.useRef)(false);
    const showRealtimeUpdateExceededMaxFlag = (0, $lWbOe.useRealtimeUpdateExceededMaxFlag)();
    const realtimeUpdatesForIssues = (0, $lWbOe.useRealtimeUpdatesForIssues)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueConnection = (0, $j4oe4.useFragment)((0, $3fLho.default), issues ?? null);
    const groupConnection = (0, $j4oe4.useFragment)((0, $f5dCG.default), groups ?? null);
    const { projectId: projectId, key: projectKey } = (0, $j4oe4.useFragment)((0, $kg3ul.default), project);
    const { issueDeleteUpdater: issueDeleteUpdater } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const issueDeleteUpdaterRef = (0, $eJOHy.useRef)(issueDeleteUpdater);
    (0, $eJOHy.useEffect)(()=>{
        issueDeleteUpdaterRef.current = issueDeleteUpdater;
    }, [
        issueDeleteUpdater
    ]);
    const variables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectId: projectId
        }), [
        cloudId,
        projectId
    ]);
    const queueRef = (0, $eJOHy.useRef)(new Map());
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const processQueue = (0, $eJOHy.useCallback)(()=>{
        if (queueRef.current.size === 0 || hasExceededMaxQueueSizeRef.current) return;
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventQueueProcessing started', {
            queueSize: queueRef.current.size
        });
        if (queueRef.current.size > $7be537e3f199cb8b$export$d3ea91bf4184016b) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsExceededMaxFlag shown', {
                queueSize: queueRef.current.size
            });
            hasExceededMaxQueueSizeRef.current = true;
            showRealtimeUpdateExceededMaxFlag({
                onRefresh: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsExceededMaxRefresh clicked');
                    hasExceededMaxQueueSizeRef.current = false;
                    queueRef.current = new Map();
                    onRefetch?.();
                }
            });
        } else realtimeUpdatesForIssues({
            issues: Array.from(queueRef.current.values()),
            isHierarchyEnabled: isHierarchyEnabled ?? false,
            jql: issueConnection?.jql || groupConnection?.jql || '',
            groupByFieldId: groupConnection?.groupByField || undefined,
            groupConnectionId: groupConnection?.__id,
            numGroupsLoaded: groupConnection?.edges?.length ?? 0,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled ?? false
        });
        queueRef.current = new Map();
    }, [
        createAnalyticsEvent,
        showRealtimeUpdateExceededMaxFlag,
        onRefetch,
        realtimeUpdatesForIssues,
        isHierarchyEnabled,
        issueConnection?.jql,
        groupConnection?.jql,
        groupConnection?.groupByField,
        groupConnection?.__id,
        groupConnection?.edges?.length,
        projectKey,
        isStatusTrackingEnabled
    ]);
    const triggerDelayedProcessingOfQueue = (0, $eJOHy.useCallback)(()=>{
        // Existing timeout exists, so we don't need to create a new one
        if (timeoutRef.current) return;
        timeoutRef.current = setTimeout(()=>{
            processQueue();
            timeoutRef.current = null;
        }, $7be537e3f199cb8b$export$2c7ede6e55079caa);
    }, [
        processQueue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleCreateOrUpdateEvent = (0, $eJOHy.useCallback)((issueAri, issueId)=>{
        queueRef.current.set(issueAri, {
            issueAri: issueAri,
            issueId: issueId
        });
        triggerDelayedProcessingOfQueue();
    }, [
        triggerDelayedProcessingOfQueue
    ]);
    const handleCreateOrUpdateEventRef = (0, $eJOHy.useRef)(handleCreateOrUpdateEvent);
    (0, $eJOHy.useEffect)(()=>{
        handleCreateOrUpdateEventRef.current = handleCreateOrUpdateEvent;
    }, [
        handleCreateOrUpdateEvent
    ]);
    const createConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $7be537e3f199cb8b$var$issueCreatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueCreatedByProjectNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $7be537e3f199cb8b$var$CREATE_ERROR_ID,
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $7be537e3f199cb8b$var$CREATE_ERROR_ID,
                        packageName: (0, $8jOO7.PACKAGE_NAME),
                        teamName: (0, $8jOO7.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const updateConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $7be537e3f199cb8b$var$issueUpdatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueUpdatedByProjectNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $7be537e3f199cb8b$var$UPDATE_ERROR_ID,
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $7be537e3f199cb8b$var$UPDATE_ERROR_ID,
                        packageName: (0, $8jOO7.PACKAGE_NAME),
                        teamName: (0, $8jOO7.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const deleteConfig = (0, $eJOHy.useMemo)(()=>{
        return {
            variables: variables,
            subscription: $7be537e3f199cb8b$var$issueDeletedSubscription,
            updater: (store, response)=>{
                try {
                    if (response?.jira?.onIssueDeletedByProject?.resource) {
                        const wasDeleted = issueDeleteUpdaterRef.current({
                            store: store,
                            issueResourceId: response.jira.onIssueDeletedByProject.resource,
                            groupConnectionId: groupConnection?.__id,
                            projectKey: projectKey
                        });
                        wasDeleted && $7be537e3f199cb8b$var$throttledFireTrackAnalytics(createAnalyticsEvent({}), 'issueTableRealTimeEvent processed', {
                            [$7be537e3f199cb8b$var$REAL_TIME_EVENT_TYPE_KEY]: 'delete'
                        });
                    }
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $7be537e3f199cb8b$var$DELETE_ERROR_ID,
                            packageName: (0, $8jOO7.PACKAGE_NAME),
                            teamName: (0, $8jOO7.TEAM_NAME)
                        },
                        attributes: {
                            logLocation: 'updater'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $7be537e3f199cb8b$var$DELETE_ERROR_ID,
                        packageName: (0, $8jOO7.PACKAGE_NAME),
                        teamName: (0, $8jOO7.TEAM_NAME)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }, [
        variables,
        groupConnection?.__id,
        projectKey,
        createAnalyticsEvent
    ]);
    (0, $j4oe4.useSubscription)(createConfig);
    (0, $j4oe4.useSubscription)(updateConfig);
    (0, $j4oe4.useSubscription)(deleteConfig);
    return null;
};

});
parcelRegister("kg3ul", function(module, exports) {
$parcel$export(module.exports, "default", () => $40238a396e08cbf4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef8fa2fe09f27e97bcbf14525e6d8724>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $40238a396e08cbf4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RealtimeUpdater_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$40238a396e08cbf4$var$node.hash = "b0d8698d2c8ea976e6f8b130d07d96e7";
var $40238a396e08cbf4$export$2e2bcd8739ae039 = $40238a396e08cbf4$var$node;

});

parcelRegister("f5dCG", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0e28aa0b69841f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53660147a5ef6080228d87ec9a80e50c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4f0e28aa0b69841f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RealtimeUpdater_spreadsheetGroupConnection",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$4f0e28aa0b69841f$var$node.hash = "a088a6707b1a84934780d0472b065205";
var $4f0e28aa0b69841f$export$2e2bcd8739ae039 = $4f0e28aa0b69841f$var$node;

});

parcelRegister("3fLho", function(module, exports) {
$parcel$export(module.exports, "default", () => $0744736c652a5be4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4ff112b0d11a6d805621f39e5e471d6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0744736c652a5be4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RealtimeUpdater",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$0744736c652a5be4$var$node.hash = "c613fad9321458fdf612ef2fdd60046b";
var $0744736c652a5be4$export$2e2bcd8739ae039 = $0744736c652a5be4$var$node;

});

parcelRegister("8tclj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ad01090dc27919b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<299378e135d26ad191cc4ef4e6daa1e5>>
 * @relayHash ad67d5c638a8acc9d4003765d0397a6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 516eb1b00ced578ccb8d76a05a78f14c226100c34ec3f6ed6f857e097f2c3089
const $0ad01090dc27919b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueDeletedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueDeletedByProject",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RealtimeUpdater_issueDeletedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RealtimeUpdater_issueDeletedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "516eb1b00ced578ccb8d76a05a78f14c226100c34ec3f6ed6f857e097f2c3089",
            "metadata": {},
            "name": "RealtimeUpdater_issueDeletedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$0ad01090dc27919b$var$node.hash = "90663a45b8a3ab86b08b962bd7ce7670";
var $0ad01090dc27919b$export$2e2bcd8739ae039 = $0ad01090dc27919b$var$node;

});

parcelRegister("h8jUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee9b13454b65dde9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5df967629d987a07af1f7b034ee8b10e>>
 * @relayHash cfdc8d83aaf78e53f31b2e46829f1db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d20e54ccde5595dcf75e6a4048b2bfd01d66c0ce3eb0ec861fdabab93510ddfc
const $ee9b13454b65dde9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueUpdatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueUpdatedByProjectNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RealtimeUpdater_issueUpdatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RealtimeUpdater_issueUpdatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d20e54ccde5595dcf75e6a4048b2bfd01d66c0ce3eb0ec861fdabab93510ddfc",
            "metadata": {},
            "name": "RealtimeUpdater_issueUpdatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$ee9b13454b65dde9$var$node.hash = "61bf429e6647cbf9bcb096e742aec037";
var $ee9b13454b65dde9$export$2e2bcd8739ae039 = $ee9b13454b65dde9$var$node;

});

parcelRegister("8TVgO", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b61ae46989e8ed4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<313b1bb73f32f3e2d38df763aa88ddea>>
 * @relayHash 366847248cd4a01ae6a8945575cd18ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 27a44bd1f4c6877dc27abb326be096c0ddf76dfce1c45442ea9feffe0c51ddc9
const $4b61ae46989e8ed4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectId",
                            "variableName": "projectId"
                        }
                    ],
                    "concreteType": "JiraIssueCreatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueCreatedByProjectNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RealtimeUpdater_issueCreatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RealtimeUpdater_issueCreatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "27a44bd1f4c6877dc27abb326be096c0ddf76dfce1c45442ea9feffe0c51ddc9",
            "metadata": {},
            "name": "RealtimeUpdater_issueCreatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$4b61ae46989e8ed4$var$node.hash = "6e926f24087740e3638f3d31f6dd4a2c";
var $4b61ae46989e8ed4$export$2e2bcd8739ae039 = $4b61ae46989e8ed4$var$node;

});

parcelRegister("dnCkQ", function(module, exports) {
$parcel$export(module.exports, "useIssueRealtimeUpdater", () => $9930494e7ca458a9$export$bf267694965fe0e3);

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");
const $9930494e7ca458a9$var$JIRA_ISSUE_TYPENAME = 'JiraIssue';
const $9930494e7ca458a9$export$6d61b264f874da2c = ({ store: store, connectionRecord: connectionRecord, fieldSetsRecordId: fieldSetsRecordId, issueRecordId: issueRecordId, position: position, projectKey: projectKey })=>{
    const issueRecord = store.get(issueRecordId);
    const fieldSetsRecord = fieldSetsRecordId ? store.get(fieldSetsRecordId) : undefined;
    if (!issueRecord || !fieldSetsRecord) return;
    const edge = (0, $37Ewn.ConnectionHandler).createEdge(store, connectionRecord, issueRecord, 'JiraIssueEdge');
    const fieldSets = edge.getOrCreateLinkedRecord('fieldSets', 'JiraIssueFieldSetEdge', {
        first: 500
    });
    fieldSets.copyFieldsFrom(fieldSetsRecord);
    const updateArgs = projectKey ? {
        projectKey: projectKey
    } : undefined;
    const canHaveChildIssues = issueRecord.getValue('canHaveChildIssues', updateArgs);
    if (canHaveChildIssues) edge.setValue(true, 'canHaveChildIssues', updateArgs);
    // no before or after implies an empty connection, verify then create the edges list
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES);
    if (!edges || position === -1 || position == null) return;
    const nextEdges = edges.slice(0, position).concat(edge).concat(edges.slice(position));
    connectionRecord.setLinkedRecords(nextEdges, EDGES);
};
const $9930494e7ca458a9$export$bf267694965fe0e3 = ()=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    const updateIssuesOnConnection = (0, $eJOHy.useCallback)(({ store: store, connection: connection, searchViewContexts: searchViewContexts, updatedIssues: updatedIssues, groupConnectionId: groupConnectionId, projectKey: projectKey, hasAccurateGroupCounts: hasAccurateGroupCounts })=>{
        const issuesProcessedAnalytics = {
            issuesUnmoved: new Set(),
            issuesMoved: new Set(),
            issuesRemoved: new Set(),
            issuesUnrelated: new Set()
        };
        const connectionRecord = store.get(connection.connectionId);
        if (!connectionRecord) return issuesProcessedAnalytics;
        const issuesWithContext = new Set(searchViewContexts?.flatMap((context)=>context?.sourceIssueId).filter(Boolean));
        const startingIssuesInConnection = new Set(connectionRecord.getLinkedRecords('edges')?.map((edge)=>edge?.getLinkedRecord('node')?.getDataID()));
        let changeInIssueCount = 0;
        updatedIssues.forEach((issue)=>{
            if (!issuesWithContext.has(issue.issueId)) {
                if (startingIssuesInConnection.has(issue.issueRecordId)) {
                    (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issue.issueRecordId);
                    changeInIssueCount -= 1;
                    issuesProcessedAnalytics.issuesRemoved.add(issue.issueId);
                } else issuesProcessedAnalytics.issuesUnrelated.add(issue.issueId);
            }
        });
        searchViewContexts?.forEach((context)=>{
            const currentIssues = connectionRecord.getLinkedRecords('edges');
            const issueForContext = updatedIssues.get(context.sourceIssueId);
            if (!currentIssues || !issueForContext) return;
            const positionForIssue = (0, $57Nys.getIssueIndexInConnection)({
                issues: currentIssues,
                issuesWithContext: issuesWithContext,
                context: context
            });
            const issueAtPosition = currentIssues[positionForIssue];
            if (issueAtPosition && issueAtPosition.getLinkedRecord('node')?.getDataID() !== issueForContext.issueRecordId || context.position === currentIssues.length // the item would be the next loaded issue, insert in case the last page is loaded to ensure it appears in all cases
            ) {
                if (startingIssuesInConnection.has(issueForContext.issueRecordId)) (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                else changeInIssueCount += 1;
                $9930494e7ca458a9$export$6d61b264f874da2c({
                    store: store,
                    connectionRecord: connectionRecord,
                    fieldSetsRecordId: issueForContext.fieldSetsRecordId,
                    issueRecordId: issueForContext.issueRecordId,
                    position: positionForIssue,
                    projectKey: projectKey
                });
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
            } else if (issueAtPosition != null) issuesProcessedAnalytics.issuesUnmoved.add(issueForContext.issueId);
            else if (positionForIssue > currentIssues.length && startingIssuesInConnection.has(issueForContext.issueRecordId)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, issueForContext.issueRecordId);
                issuesProcessedAnalytics.issuesMoved.add(issueForContext.issueId);
                changeInIssueCount -= 1;
            } else issuesProcessedAnalytics.issuesUnrelated.add(issueForContext.issueId);
            // the issue has been handled, pop it so we can know its place in the list is trustworthy and will not be moved for relative positioning purposes
            issuesWithContext.delete(context.sourceIssueId);
        });
        updateConnectionDetails({
            store: store,
            connection: connection,
            netChangeInIssueCount: changeInIssueCount,
            remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
            groupConnectionId: groupConnectionId,
            projectKey: projectKey,
            hasAccurateGroupCounts: hasAccurateGroupCounts
        });
        return issuesProcessedAnalytics;
    }, [
        updateConnectionDetails
    ]);
    const updateNewParentsOnConnection = (0, $eJOHy.useCallback)(({ store: store, connection: connection, updatedParents: updatedParents, projectKey: projectKey })=>{
        const connectionRecord = store.get(connection.connectionId);
        const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
        const edges = connectionRecord?.getLinkedRecords(EDGES);
        edges?.forEach((edge)=>{
            const parentIssueRecordId = edge?.getLinkedRecord('node')?.getDataID();
            if (parentIssueRecordId && updatedParents.has(parentIssueRecordId)) (0, $57Nys.updateParentHasChildren)({
                store: store,
                parentIssueEdgeRecordId: edge?.getDataID(),
                // this refers the the children connection of the parent, where this update is designed to work on parents where no connection can exist now
                connectionId: undefined,
                hasChildren: true,
                projectKey: projectKey
            });
        });
    }, []);
    const issueDeleteUpdater = (0, $eJOHy.useCallback)(({ store: store, issueResourceId: issueResourceId, groupConnectionId: groupConnectionId, projectKey: projectKey })=>{
        const id = (0, $kqd31.default)({
            id: issueResourceId
        }, $9930494e7ca458a9$var$JIRA_ISSUE_TYPENAME);
        let wasDeleted = false;
        if (!id) return wasDeleted;
        Object.values(connections).forEach((connection)=>{
            const connectionRecord = store.get(connection.connectionId);
            if (!connectionRecord) return;
            // check if the issue is in the connection
            if (connectionRecord.getLinkedRecords('edges')?.some((edge)=>edge?.getLinkedRecord('node')?.getDataID() === id)) {
                (0, $37Ewn.ConnectionHandler).deleteNode(connectionRecord, id);
                updateConnectionDetails({
                    store: store,
                    connection: connection,
                    netChangeInIssueCount: -1,
                    remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey
                });
                wasDeleted = true;
            }
        });
        return wasDeleted;
    }, [
        connections,
        updateConnectionDetails
    ]);
    const groupsForIssueUpdater = (0, $eJOHy.useCallback)(({ store: store, groupConnectionId: groupConnectionId, groupsForIssue: groupsForIssue })=>{
        let wasUpdated = false;
        if (!groupConnectionId) return wasUpdated;
        const groupsConnection = store.get(groupConnectionId);
        if (!groupsConnection) return wasUpdated;
        let groupEdges = groupsConnection.getLinkedRecords('edges') || [];
        const existingGroupIds = new Set(groupEdges?.map((edge)=>edge?.getLinkedRecord('node')?.getValue('id')));
        groupsForIssue.forEach((group)=>{
            const newGroup = store.get(group.__id);
            if (!existingGroupIds.has(group.id) && newGroup) {
                groupEdges = (0, $57Nys.insertNewGroupInGroupsConnection)({
                    store: store,
                    groupsConnection: groupsConnection,
                    newGroup: newGroup,
                    groupEdges: groupEdges,
                    afterGroupId: group.afterGroupId
                });
                wasUpdated = true;
            }
        });
        groupsConnection.setLinkedRecords(groupEdges, 'edges');
        return wasUpdated;
    }, []);
    return {
        issueDeleteUpdater: issueDeleteUpdater,
        groupsForIssueUpdater: groupsForIssueUpdater,
        updateIssuesOnConnection: updateIssuesOnConnection,
        updateNewParentsOnConnection: updateNewParentsOnConnection
    };
};

});

parcelRegister("lWbOe", function(module, exports) {
$parcel$export(module.exports, "useRealtimeUpdatesForIssues", () => $05a38ba5fed39443$export$9688da58398f9e26);
$parcel$export(module.exports, "useRealtimeUpdateExceededMaxFlag", () => $05a38ba5fed39443$export$b8dd0666e1c54372);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2R0ne = parcelRequire("2R0ne");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");

var $dLXgn = parcelRequire("dLXgn");

var $cSXp8 = parcelRequire("cSXp8");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $5NEjg = parcelRequire("5NEjg");

var $dnCkQ = parcelRequire("dnCkQ");

var $fes1G = parcelRequire("fes1G");

var $lEvni = parcelRequire("lEvni");

var $651sM = parcelRequire("651sM");
const $05a38ba5fed39443$export$cb618b52025e9ed0 = ({ connections: connections, isGroupingEnabled: isGroupingEnabled, groupedByFieldId: groupedByFieldId })=>{
    const expandedParents = [];
    const groups = [];
    let topLevelItemsLoaded = 0;
    Object.values(connections).forEach((connection)=>{
        if (connection.type === 'PARENT_CHILDREN') expandedParents.push({
            parentIssueId: connection.parentId,
            first: connection.first
        });
        else if (connection.type === 'GROUP_CHILDREN') groups.push({
            jql: connection.jql,
            fieldValue: connection.fieldValue,
            first: connection.first
        });
        else if (connection.type === 'ROOT_ISSUES') topLevelItemsLoaded = connection.first;
    });
    if (isGroupingEnabled && groupedByFieldId) return {
        expandedGroups: {
            groupedByFieldId: groupedByFieldId,
            groups: groups
        }
    };
    return {
        expandedParents: expandedParents,
        topLevelItemsLoaded: topLevelItemsLoaded
    };
};
const $05a38ba5fed39443$export$9688da58398f9e26 = ()=>{
    const environment = (0, $7zZ4w.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getGroupsForIssues = (0, $lEvni.useGetGroupsForIssues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getRealtimeIssueDetails = (0, $fes1G.useGetRealtimeIssueDetails)();
    const { updateIssuesOnConnection: updateIssuesOnConnection, groupsForIssueUpdater: groupsForIssueUpdater, updateNewParentsOnConnection: updateNewParentsOnConnection } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)(async ({ issues: issues, jql: jql, groupByFieldId: groupByFieldId, numGroupsLoaded: numGroupsLoaded, groupConnectionId: groupConnectionId, isHierarchyEnabled: isHierarchyEnabled, projectKey: projectKey, isStatusTrackingEnabled: isStatusTrackingEnabled })=>{
        const isGroupingEnabled = !!groupByFieldId;
        const searchViewContextInput = $05a38ba5fed39443$export$cb618b52025e9ed0({
            connections: connections,
            isGroupingEnabled: isGroupingEnabled,
            groupedByFieldId: groupByFieldId
        });
        const { issues: updatedIssues, searchViewContexts: searchViewContexts } = await getRealtimeIssueDetails({
            issues: issues,
            cloudId: cloudId,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isHierarchyEnabled: isHierarchyEnabled,
            isGroupingEnabled: isGroupingEnabled,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            issueSearchInput: {
                jql: jql
            },
            searchViewContextInput: searchViewContextInput,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded
        });
        let groupsToInsert;
        if (isGroupingEnabled && groupByFieldId) {
            const issueKeysWithContext = new Set(searchViewContexts?.flatMap((connection)=>{
                return connection.contexts?.map((context)=>context?.sourceIssueId);
            }).filter(Boolean));
            const issueChangesWithoutContext = (0, $4cTDP.fg)('group_by_any_field') ? updatedIssues?.map((issue)=>({
                    issueId: issue.issueId
                })) : updatedIssues?.reduce((acc, issue)=>{
                if (issue && !issueKeysWithContext.has(issue.issueId ?? '')) acc.push({
                    issueId: issue.issueId
                });
                return acc;
            }, []);
            groupsToInsert = await getGroupsForIssues({
                issueChanges: issueChangesWithoutContext,
                fieldId: groupByFieldId,
                numGroupsLoaded: numGroupsLoaded,
                issueSearchInput: {
                    jql: jql
                },
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            });
        }
        const eventDetails = {
            issuesUnmoved: new Set(),
            issuesUnrelated: new Set(),
            issuesUpdated: new Set()
        };
        const updatedIssuesMap = new Map(updatedIssues?.map(({ issueId: issueId, issueRecordId: issueRecordId, fieldSetsRecordId: fieldSetsRecordId })=>[
                issueId,
                {
                    issueId: issueId,
                    issueRecordId: issueRecordId,
                    fieldSetsRecordId: fieldSetsRecordId
                }
            ]));
        const updatedParents = new Set(updatedIssues.map((issue)=>issue.parentIssueRecordId).filter(Boolean));
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            Object.values(connections).forEach((connection)=>{
                updateNewParentsOnConnection({
                    store: store,
                    connection: connection,
                    updatedParents: updatedParents,
                    projectKey: projectKey
                });
                const matchingContext = searchViewContexts?.find((context)=>{
                    if (connection.type === 'PARENT_CHILDREN') return context?.parentIssueId === connection.parentId;
                    if (connection.type === 'GROUP_CHILDREN') return context?.jql === connection.jql;
                    return context?.jql == null && context?.parentIssueId == null;
                });
                const updatedDetails = updateIssuesOnConnection({
                    store: store,
                    connection: connection,
                    searchViewContexts: matchingContext?.contexts ?? [],
                    updatedIssues: updatedIssuesMap,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey,
                    hasAccurateGroupCounts: (0, $4cTDP.fg)('group_by_any_field') ? connection.type === 'GROUP_CHILDREN' && groupsToInsert?.some((group)=>group.id === connection.groupId) : undefined
                });
                updatedDetails.issuesMoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
                updatedDetails.issuesUnmoved.forEach(eventDetails.issuesUnmoved.add, eventDetails.issuesUnmoved);
                updatedDetails.issuesUnrelated.forEach(eventDetails.issuesUnrelated.add, eventDetails.issuesUnrelated);
                updatedDetails.issuesRemoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
            });
            if (groupsToInsert && groupsToInsert.length > 0) groupsForIssueUpdater({
                store: store,
                groupConnectionId: groupConnectionId,
                groupsForIssue: groupsToInsert
            });
        });
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsIssueDetails Processed', {
            issuesInSamePosition: eventDetails.issuesUnmoved.size,
            issuesInNewPosition: eventDetails.issuesUpdated.size,
            issuesNotImpactingList: Array.from(eventDetails.issuesUnrelated).reduce((acc, issueId)=>eventDetails.issuesUpdated.has(issueId) || eventDetails.issuesUnmoved.has(issueId) ? acc : acc + 1, 0)
        });
    }, [
        connections,
        getRealtimeIssueDetails,
        cloudId,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isHideDoneItemsEnabled,
        environment,
        createAnalyticsEvent,
        getGroupsForIssues,
        updateNewParentsOnConnection,
        updateIssuesOnConnection,
        groupsForIssueUpdater,
        isConditionalFormattingEnabled,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isEditableSyncLoaded
    ]);
};
const $05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID = 'native-issue-table.ui.realtime-updater.flag.info.native-issue-table.ui.realtime-update-exceeded-max-flag';
const $05a38ba5fed39443$export$b8dd0666e1c54372 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const environment = (0, $7zZ4w.default)();
    return (0, $eJOHy.useCallback)(({ onRefresh: onRefresh })=>{
        if (!hasFlag?.($05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID)) showFlag({
            type: 'info',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-information, #1D7AFC)"
            }),
            title: (0, $651sM.default).realtimeUpdateExceededMaxHeader,
            description: (0, $651sM.default).realtimeUpdateExceededMaxDescription,
            messageId: $05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            id: $05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            messageType: 'transactional',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $651sM.default).realtimeUpdateExceededMaxRefreshButton,
                    onClick: ()=>{
                        // This will reload all expanded parents/groups
                        environment.commitUpdate((store)=>{
                            Object.values(connections).forEach((connection)=>{
                                const connectionToInvalidate = store.get(connection.connectionId);
                                if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
                            });
                        });
                        dismissFlag($05a38ba5fed39443$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID);
                        onRefresh();
                    }
                }
            ]
        });
    }, [
        connections,
        dismissFlag,
        environment,
        hasFlag,
        showFlag
    ]);
};

});
parcelRegister("fes1G", function(module, exports) {
$parcel$export(module.exports, "useGetRealtimeIssueDetails", () => $f73212fb4bd676d3$export$d36444b54640c2df);

var $eZspa = parcelRequire("eZspa");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $7zZ4w = parcelRequire("7zZ4w");

var $8jOO7 = parcelRequire("8jOO7");
const $f73212fb4bd676d3$export$d36444b54640c2df = ()=>{
    return (0, $eJOHy.useCallback)(async ({ issues: issues, cloudId: cloudId, fieldSetIds: fieldSetIds, isInlineEditingEnabled: isInlineEditingEnabled, isDensityFull: isDensityFull, isHierarchyEnabled: isHierarchyEnabled, isGroupingEnabled: isGroupingEnabled, isHideDoneItemsEnabled: isHideDoneItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, issueSearchInput: issueSearchInput, searchViewContextInput: searchViewContextInput, projectKey: projectKey, isTimelineEnabled: isTimelineEnabled, isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled, isEditableSyncLoaded: isEditableSyncLoaded })=>{
        const environment = (0, $7zZ4w.default)();
        try {
            // if the issue is in a loaded context, the issue is visible so we need to fetch the fields for display
            const result = await (0, $j4oe4.fetchQuery)(environment, (0, $eZspa.default), {
                issueAris: issues.map((issue)=>issue.issueAri),
                cloudId: cloudId,
                fieldSetIds: fieldSetIds,
                isInlineEditingEnabled: isInlineEditingEnabled,
                isDensityFull: isDensityFull,
                issueSearchInput: issueSearchInput,
                searchViewContextInput: searchViewContextInput,
                isHierarchyEnabled: isHierarchyEnabled ?? false,
                projectKey: projectKey,
                issueChanges: issues.map((issue)=>({
                        issueId: issue.issueId
                    })),
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                },
                isTimelineEnabled: isTimelineEnabled,
                isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
                isEditableSyncLoaded: isEditableSyncLoaded
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return {
                issues: result?.jira_issuesByIds?.filter(Boolean)?.map((issue)=>({
                        issueId: issue.issueId,
                        issueRecordId: issue.__id,
                        fieldSetsRecordId: issue.fieldSetsById?.__id,
                        parentIssueRecordId: issue.parentIssueField?.parentIssue?.__id
                    })) ?? [],
                searchViewContexts: result?.jira?.searchViewContexts?.edges?.map((edge)=>{
                    if (!edge?.node) return undefined;
                    return {
                        parentIssueId: edge.node.parentIssueId ?? undefined,
                        jql: edge.node.jql ?? undefined,
                        contexts: edge?.node?.contexts?.map((context)=>({
                                position: context.position,
                                sourceIssueId: context.sourceIssueId,
                                beforeIssueId: context.beforeIssueId,
                                afterIssueId: context.afterIssueId
                            })) ?? []
                    };
                }).filter(Boolean) ?? []
            };
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'realTimeFetchIssueFieldSetConnection',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return Promise.resolve({
                issues: [],
                searchViewContexts: []
            });
        }
    }, []);
};

});
parcelRegister("eZspa", function(module, exports) {
$parcel$export(module.exports, "default", () => $29ae328d92206d0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96e6afb33da8d2ba423ab2e1c005e6ef>>
 * @relayHash fb3881f1c9238c630623c2bdadf76568
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39f7717c23a9feb78fe7a471aaddeb1c21d536b5a65efc1ff4aef5b4bf238d6f

var $3Bt2F = parcelRequire("3Bt2F");

var $3jVIX = parcelRequire("3jVIX");

var $hRj2m = parcelRequire("hRj2m");

var $1PjiU = parcelRequire("1PjiU");

var $jvWSl = parcelRequire("jvWSl");

var $ePJhs = parcelRequire("ePJhs");

var $bU8Sj = parcelRequire("bU8Sj");

var $g29oX = parcelRequire("g29oX");

var $FU9UR = parcelRequire("FU9UR");
const $29ae328d92206d0f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDensityFull"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isEditableSyncLoaded"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInlineEditingEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkRelationshipFieldEnabled"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchViewContextInput"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "issueAris"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v22 = {
        "args": [
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "canHaveChildIssues"
    }, v23 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "searchViewContextInput",
            "variableName": "searchViewContextInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "parentIssueId"
            }
        ],
        "type": "JiraIssueSearchBulkViewParentContexts"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jql"
            }
        ],
        "type": "JiraIssueSearchBulkViewGroupContexts"
    }, v26 = {
        "kind": "ScalarField",
        "name": "sourceIssueId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "position"
    }, v28 = {
        "kind": "ScalarField",
        "name": "beforeIssueId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "afterIssueId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "type"
    }, v31 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v32 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v33 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v34 = {
        "kind": "ScalarField",
        "name": "name"
    }, v35 = {
        "kind": "ScalarField",
        "name": "value"
    }, v36 = [
        v35 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v37 = {
        "condition": "isInlineEditingEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lazyIsEditableInIssueView"
                    }
                ]
            }
        ]
    }, v38 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v39 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v40 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v41 = {
        "kind": "ScalarField",
        "name": "date"
    }, v42 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "text"
    }, v44 = {
        "condition": "isEditableSyncLoaded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditableInIssueView"
            }
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v46 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v47 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v20 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v50 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v51 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v54 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v55 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v56 = {
        "kind": "ScalarField",
        "name": "relationName"
    }, v57 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v58 = {
        "concreteType": "JiraEstimate",
        "kind": "LinkedField",
        "name": "originalEstimate",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeInSeconds"
            }
        ]
    }, v59 = {
        "concreteType": "JiraTimeTrackingSettings",
        "kind": "LinkedField",
        "name": "timeTrackingSettings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "workingHoursPerDay"
            },
            {
                "kind": "ScalarField",
                "name": "workingDaysPerWeek"
            },
            {
                "kind": "ScalarField",
                "name": "defaultFormat"
            },
            {
                "kind": "ScalarField",
                "name": "defaultUnit"
            }
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v61 = [
        v20 /*: any*/ 
    ], v62 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": v61 /*: any*/ 
    }, v63 = {
        "kind": "ScalarField",
        "name": "href"
    }, v64 = {
        "concreteType": "JiraStatusField",
        "kind": "LinkedField",
        "name": "statusField",
        "plural": false,
        "selections": [
            v51 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v65 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v66 = [
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v41 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v20 /*: any*/ 
    ], v67 = [
        v32 /*: any*/ ,
        v20 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useGetRealtimeIssueDetailsQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "isConditionalFormattingEnabled",
                                            "variableName": "isConditionalFormattingEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isDensityFull",
                                            "variableName": "isDensityFull"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isEditableSyncLoaded",
                                            "variableName": "isEditableSyncLoaded"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isInlineEditingEnabled",
                                            "variableName": "isInlineEditingEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isLinkRelationshipFieldEnabled",
                                            "variableName": "isLinkRelationshipFieldEnabled"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "isTimelineEnabled",
                                            "variableName": "isTimelineEnabled"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "IssueRow_fieldSets"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v19 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
                        },
                        v17 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v26 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v27 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                                                        },
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v14 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useGetRealtimeIssueDetailsQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "parentIssue",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "serviceId"
                                                                                                        },
                                                                                                        v34 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraAffectedServicesField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraCascadingOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cascadingOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "parentOptionValue",
                                                                                            "plural": false,
                                                                                            "selections": v36 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraOption",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "childOptionValue",
                                                                                            "plural": false,
                                                                                            "selections": v36 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraCascadingSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "objectId"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "label"
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "mediaClientConfig",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "clientId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "fileId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "mediaJwtToken"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "url48"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "QueryError",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "errors",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "message"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCMDBField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraComponentConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedComponentsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraComponentEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v39 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraComponentsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v42 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDatePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "dateTime"
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraDateTimePickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraEpic",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "epic",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "summary"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "color"
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraEpicLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "renderedFieldHtml"
                                                                                }
                                                                            ],
                                                                            "type": "JiraFallbackField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v43 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatusCategory",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "statusCategory",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "statusId"
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraStatusField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v34 /*: any*/ ,
                                                                                                        v47 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraLabelsField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "small"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "parentIssue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraColorField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueColorField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v47 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueTypeField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v48 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v20 /*: any*/ ,
                                                                                        v16 /*: any*/ ,
                                                                                        v49 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ids",
                                                                                                            "value": [
                                                                                                                "issuetype",
                                                                                                                "project",
                                                                                                                "summary",
                                                                                                                "status"
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsById",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                v43 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                        v48 /*: any*/ ,
                                                                                                                                        v21 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v33 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "status",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "statusCategory",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v20 /*: any*/ ,
                                                                                                                                                v45 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v33 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v50 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v33 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraStatusField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v51 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraParentIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraPriorityField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraProject",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "project",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v19 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "large"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraProjectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraResolution",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "resolution",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraResolutionField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraSprintConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedSprintsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSprintEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "state"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "endDate"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSprintField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v54 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "appType"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "AppUser"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v42 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraRichText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "richText",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraADF",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "adfValue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "convertedPlainText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "plainText"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isDensityFull",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "json"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraRichTextField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "requestType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 1
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueLinkConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v49 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": [
                                                                                                                        {
                                                                                                                            "kind": "Literal",
                                                                                                                            "name": "ids",
                                                                                                                            "value": [
                                                                                                                                "statusCategory"
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldsById",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v32 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                v46 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                        },
                                                                                                                                        v20 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v55 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v56 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueLinkField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isStoryPointField"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "number"
                                                                                },
                                                                                v34 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraNumberFieldFormatConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "formatConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "formatStyle"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "formatUnit"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraCommentSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commentSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "canAddComment"
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCommentSummaryField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "uri"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraUrlField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v57 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraSingleSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOptionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOptionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v35 /*: any*/ ,
                                                                                                        v57 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOptionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOptionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraCheckboxesField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraUserConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedUsersConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraUserEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v32 /*: any*/ ,
                                                                                                        v54 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "email"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "AtlassianAccountUser"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraTeamView",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedTeam",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jiraSuppliedId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jiraSuppliedName"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraTeamViewField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "timeTrackingField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v58 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v30 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "timeTrackingField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v58 /*: any*/ ,
                                                                                                        v59 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v30 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": "label",
                                                                                            "kind": "ScalarField",
                                                                                            "name": "value"
                                                                                        },
                                                                                        v20 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraRadioSelectField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraVersionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedVersionsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v60 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleVersionPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                v62 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraGoalConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedGoals",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGoalEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGoal",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "status"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraGoalsField"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v62 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isLinkEditable"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraTownsquareProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "alias": "atlasProjectName",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "name"
                                                                                                },
                                                                                                {
                                                                                                    "alias": "atlasProjectKey",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "key"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "privateProject"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "hasPermission"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isWorkspaceActive"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraTownsquareProjectField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "args": v38 /*: any*/ ,
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v63 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "pageContent",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v63 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraGroupConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedGroupsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroupEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "groupId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraMultipleGroupPickerField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFlag",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "flag",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isFlagged"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraFlagField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraWatch",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "watch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "count"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isWatching"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraWatchesField"
                                                                        },
                                                                        {
                                                                            "condition": "isLinkRelationshipFieldEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueLink",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueLink",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "direction"
                                                                                                },
                                                                                                v56 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueLinkType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "type",
                                                                                                    "plural": false,
                                                                                                    "selections": v61 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v44 /*: any*/ ,
                                                                                        v37 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraIssueLinkRelationshipTypeField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "isTimelineEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issue",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v34 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraParentIssueField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "parentIssueField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                v64 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "assigneeField",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v32 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "args": v65 /*: any*/ ,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "startDateViewField",
                                                                                                    "plural": false,
                                                                                                    "selections": v66 /*: any*/ ,
                                                                                                    "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                },
                                                                                                {
                                                                                                    "args": v65 /*: any*/ ,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "endDateViewField",
                                                                                                    "plural": false,
                                                                                                    "selections": v66 /*: any*/ ,
                                                                                                    "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraTimelineField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isConditionalFormattingEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v38 /*: any*/ ,
                                                                                            "concreteType": "JiraComponentConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedComponentsConnection",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponent",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "componentId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraComponentsField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "priorityId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraProject",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "project",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "projectId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraVersion",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "version",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v60 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleVersionPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v50 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedValue",
                                                                                            "plural": false,
                                                                                            "selections": v67 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraSelectableValueConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedValues",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSelectableValueEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": v67 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraMultipleSelectField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "condition": "isHierarchyEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v55 /*: any*/ ,
                                v64 /*: any*/ 
                            ]
                        },
                        v17 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
                            "kind": "LinkedField",
                            "name": "searchViewContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchBulkViewContextMapping",
                                                    "kind": "LinkedField",
                                                    "name": "contexts",
                                                    "plural": true,
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "39f7717c23a9feb78fe7a471aaddeb1c21d536b5a65efc1ff4aef5b4bf238d6f",
            "metadata": {},
            "name": "useGetRealtimeIssueDetailsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": (0, $3Bt2F.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": (0, $g29oX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": (0, $1PjiU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": (0, $FU9UR.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": (0, $3jVIX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $ePJhs.default)
            }
        }
    };
}();
$29ae328d92206d0f$var$node.hash = "2a2eeea788a2e6bf9581e08300a2d126";
var $29ae328d92206d0f$export$2e2bcd8739ae039 = $29ae328d92206d0f$var$node;

});


parcelRegister("lEvni", function(module, exports) {
$parcel$export(module.exports, "useGetGroupsForIssues", () => $32c874d5ac433567$export$c756ae1e1c570081);

var $lKxax = parcelRequire("lKxax");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");

var $8jOO7 = parcelRequire("8jOO7");
const $32c874d5ac433567$export$c756ae1e1c570081 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    return (0, $eJOHy.useCallback)(async ({ issueChanges: issueChanges, staticViewInput: staticViewInput, fieldId: fieldId, issueSearchInput: issueSearchInput, numGroupsLoaded: numGroupsLoaded })=>{
        const environment = (0, $7zZ4w.default)();
        try {
            const data = await (0, $j4oe4.fetchQuery)(environment, (0, $lKxax.default), {
                cloudId: cloudId,
                issueChanges: issueChanges,
                issueSearchInput: issueSearchInput,
                fieldId: fieldId,
                // Needs to be connection length + 1 to ensure a potentially new group at the end of the
                // currently loaded connection is included
                firstNGroupsToSearch: numGroupsLoaded + 1,
                staticViewInput: staticViewInput
            }, {
                fetchPolicy: 'network-only'
            }).toPromise();
            return data?.jira?.groupsForIssues?.edges?.map((edge)=>edge?.node ? {
                    __id: edge.node.__id,
                    id: edge.node.id,
                    afterGroupId: edge.node.afterGroupId
                } : undefined)?.filter(Boolean) ?? [];
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'realTimeFetchGroupsForIssue',
                    packageName: (0, $8jOO7.PACKAGE_NAME),
                    teamName: (0, $8jOO7.TEAM_NAME)
                },
                error: error instanceof Error ? error : undefined,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
    }, [
        cloudId
    ]);
};

});
parcelRegister("lKxax", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf72dcadd08e39e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8cd1cc209b4cae9559baa4959aa3707d>>
 * @relayHash cd686ce5eb7807096f8ca0f17a2f7068
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83f5a2e8f22c36abcc606662a86707b2447c73ffa2db6e444f8e23c823165ae1

var $4GS9O = parcelRequire("4GS9O");
const $bf72dcadd08e39e7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "firstNGroupsToSearch"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueChanges"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldId",
            "variableName": "fieldId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "firstNGroupsToSearch",
            "variableName": "firstNGroupsToSearch"
        },
        {
            "kind": "Variable",
            "name": "issueChanges",
            "variableName": "issueChanges"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "afterGroupId"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v14 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v7 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useGetGroupsForIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "FirstGroupRow_GroupRow"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useGetGroupsForIssuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupConnection",
                            "kind": "LinkedField",
                            "name": "groupsForIssues",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fieldValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jqlTerm"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "number"
                                                                }
                                                            ],
                                                            "type": "JiraJqlNumberFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "option",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlOptionFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "sprintId"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabel",
                                                                    "kind": "LinkedField",
                                                                    "name": "label",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlLabelFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "group",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "groupId"
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlGroupFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "version",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "versionId"
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ],
                                                            "type": "JiraJqlVersionFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        },
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlGoalsFieldValue"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTownsquareProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "project",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "key"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "privateProject"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "hasPermission"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraJqlTownsquareProjectFieldValue"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                            "kind": "LinkedField",
                                                                            "name": "hierarchy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "level"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraResolution",
                                                                    "kind": "LinkedField",
                                                                    "name": "resolution",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlResolutionFieldValue"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueCount"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "83f5a2e8f22c36abcc606662a86707b2447c73ffa2db6e444f8e23c823165ae1",
            "metadata": {},
            "name": "useGetGroupsForIssuesQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyprojectsrelayprovider": (0, $4GS9O.default)
            }
        }
    };
}();
$bf72dcadd08e39e7$var$node.hash = "f80b5893a2d3beef812b43f19aafcbbe";
var $bf72dcadd08e39e7$export$2e2bcd8739ae039 = $bf72dcadd08e39e7$var$node;

});
parcelRegister("4GS9O", function(module, exports) {
$parcel$export(module.exports, "default", () => $00c181c86ac97317$export$2e2bcd8739ae039);

var $4cTDP = parcelRequire("4cTDP");
var $00c181c86ac97317$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4cTDP.fg)('group_by_projects');
    }
};

});



parcelRegister("651sM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4986dc48c066a26$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f4986dc48c066a26$var$messages = (0, $7qGN1.defineMessages)({
    realtimeUpdateExceededMaxHeader: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-header",
        "defaultMessage": "Updating those work items"
    },
    realtimeUpdateExceededMaxDescription: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-description",
        "defaultMessage": "Refresh the page to see the updates"
    },
    realtimeUpdateExceededMaxRefreshButton: {
        "id": "native-issue-table.ui.realtime-updater.realtime-update-exceeded-max-refresh-button",
        "defaultMessage": "Refresh"
    }
});
var $f4986dc48c066a26$export$2e2bcd8739ae039 = $f4986dc48c066a26$var$messages;

});



parcelRegister("9VBAD", function(module, exports) {
$parcel$export(module.exports, "ScrollContainer", () => $ba39e90ae3fa936c$export$2631a3ab3cdd158d);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aIjmF = parcelRequire("aIjmF");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bzbsd = parcelRequire("bzbsd");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bmoS1 = parcelRequire("bmoS1");

var $4cTDP = parcelRequire("4cTDP");

var $hbF3h = parcelRequire("hbF3h");

var $aVTEC = parcelRequire("aVTEC");

var $8jOO7 = parcelRequire("8jOO7");

var $34oCh = parcelRequire("34oCh");

var $7khpH = parcelRequire("7khpH");

var $7n9BS = parcelRequire("7n9BS");

var $4NiKr = parcelRequire("4NiKr");

var $3F6xT = parcelRequire("3F6xT");

var $hGS9u = parcelRequire("hGS9u");
const $ba39e90ae3fa936c$export$afb5fd3c74e214f9 = ({ loading: loading, resetScroll: resetScroll })=>{
    const prevLoading = (0, $6d9QY.usePrevious)(loading);
    // Reseting the scroll when the connection id change will cover any variable change
    (0, $eJOHy.useEffect)(()=>{
        if (prevLoading !== loading && prevLoading === true) resetScroll();
    });
};
const $ba39e90ae3fa936c$export$2631a3ab3cdd158d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ Layout: Layout = $ba39e90ae3fa936c$var$ScrollContainerLayout, children: children, footer: footer, loading: loading, isGrouping: isGrouping, isChildIssuesTable: isChildIssuesTable = false, onScroll: externalOnScroll, columnCount: columnCount, ...infiniteScrollProps }, ref)=>{
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const siblingIssueCreateOnScroll = (0, $4NiKr.useSiblingIssueCreateOnScroll)();
    const isInfiniteScrollEnabled = (0, $34oCh.useIsInfiniteScrollEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isFullPageIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const previousScrollLeftRef = (0, $eJOHy.useRef)(0);
    const totalScrollableWidthRef = (0, $eJOHy.useRef)(0);
    const resetScroll = (0, $eJOHy.useCallback)(()=>{
        if (scrollContainerRef.current != null && isInfiniteScrollEnabled) scrollContainerRef.current.scrollTop = 0;
    }, [
        isInfiniteScrollEnabled
    ]);
    $ba39e90ae3fa936c$export$afb5fd3c74e214f9({
        loading: loading,
        resetScroll: resetScroll
    });
    const { onLoadingThresholdCheck: onLoadingThresholdCheck, onScroll: infiniteScrollOnScroll } = (0, $7khpH.useInfiniteScrollHandler)(infiniteScrollProps);
    let sendAnalyticsEventDebounced;
    if (isChildIssuesTable && (0, $4cTDP.fg)('ken-2879_is_child_issue_table')) {
        const ANALYTICS_EVENT_DEBOUNCE_DELAY = 1000;
        sendAnalyticsEventDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'childIssuesTable scrolled');
        }, ANALYTICS_EVENT_DEBOUNCE_DELAY);
    }
    // Horizontal scroll analytics function
    const useHorizontalScrollAnalytics = ()=>{
        // TODO: update to avoid violating the rules of hooks
        // See https://jbusiness.atlassian.net/browse/JSC-3369
        // eslint-disable-next-line react-hooks/react-compiler
        const fireDebouncedAnalyticsForHorizontalScroll = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((currentScroll, totalScrollableWidth)=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueView horizontalScroll', {
                    actionSubjectId: 'issueView',
                    scrollLeft: currentScroll,
                    totalScrollableWidth: totalScrollableWidth,
                    section: 'childIssueTable',
                    columnCount: columnCount
                });
            }, 400), []);
        return fireDebouncedAnalyticsForHorizontalScroll;
    };
    // Wrapped with feature gate
    const useHorizontalScrollAnalyticsWithFF = (0, $hbF3h.functionUnionWithCondition)(()=>(0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate'), useHorizontalScrollAnalytics, ()=>undefined);
    // TODO: update to avoid violating the rules of hooks
    // See https://jbusiness.atlassian.net/browse/JSC-3369
    // eslint-disable-next-line react-hooks/react-compiler
    const fireDebouncedAnalyticsForHorizontalScroll = useHorizontalScrollAnalyticsWithFF();
    const fireHorizontalScrollDirectionChangeAnalytics = (0, $aVTEC.useHorizontalScrollDirectionChangeAnalytics)();
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        if (isChildIssuesTable && typeof sendAnalyticsEventDebounced === 'function' && (0, $4cTDP.fg)('ken-2879_is_child_issue_table')) sendAnalyticsEventDebounced();
        siblingIssueCreateOnScroll?.(event);
        if (isInfiniteScrollEnabled) infiniteScrollOnScroll(event);
        externalOnScroll?.(event);
        if (event.currentTarget instanceof HTMLElement) fireHorizontalScrollDirectionChangeAnalytics(event.currentTarget);
        if (event.target instanceof HTMLElement && (0, $4cTDP.fg)('issue_view_layout_experiment_feature_gate')) {
            const target = event.target;
            const currentScroll = Math.round(target.scrollLeft);
            if (totalScrollableWidthRef.current === 0) totalScrollableWidthRef.current = Math.round(target.scrollWidth - target.clientWidth);
            // Send horizontal scroll analytics when scrolling right for child issue table
            const isScrollingRight = currentScroll > previousScrollLeftRef.current;
            if (isScrollingRight && isChildIssuesTable && isFullPageIssueView && fireDebouncedAnalyticsForHorizontalScroll) fireDebouncedAnalyticsForHorizontalScroll(currentScroll, totalScrollableWidthRef.current);
            previousScrollLeftRef.current = currentScroll;
        }
    }, [
        siblingIssueCreateOnScroll,
        isInfiniteScrollEnabled,
        infiniteScrollOnScroll,
        sendAnalyticsEventDebounced,
        isChildIssuesTable,
        externalOnScroll,
        fireDebouncedAnalyticsForHorizontalScroll,
        isFullPageIssueView,
        fireHorizontalScrollDirectionChangeAnalytics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Handle auto-scrolling for pragmatic dnd operations like column resizing
        const scrollableElement = scrollContainerRef.current;
        let cleanup;
        if (scrollableElement) cleanup = (0, $aIjmF.autoScrollForElements)({
            element: scrollableElement,
            canScroll: ({ source: source })=>source.data.operation !== (0, $8jOO7.COLUMN_OPERATION_RESIZE)
        });
        return ()=>{
            cleanup?.();
            fireDebouncedAnalyticsForHorizontalScroll?.cancel();
        };
    }, [
        fireDebouncedAnalyticsForHorizontalScroll
    ]);
    const intersectionObsRef = (0, $3F6xT.useIntersectionObserver)();
    const mergedRefs = (0, $bzbsd.default)(ref, intersectionObsRef, scrollContainerRef);
    const loadingManager = isInfiniteScrollEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hGS9u.LoadingManager), {
        isLoadingPrevious: infiniteScrollProps.isLoadingPrevious,
        isLoadingNext: infiniteScrollProps.isLoadingNext,
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        isGrouping: isGrouping
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7n9BS.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Layout, {
        containerRef: mergedRefs,
        footer: footer,
        loadingManager: loadingManager,
        onScroll: onScroll
    }, children));
});
const $ba39e90ae3fa936c$var$ScrollContainerLayout = ({ containerRef: containerRef, children: children, footer: footer, loadingManager: loadingManager, onScroll: onScroll })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ba39e90ae3fa936c$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ba39e90ae3fa936c$var$scrollContainerStyles,
        ref: containerRef,
        onScroll: onScroll,
        testId: "native-issue-table.ui.scroll-container.scroll-container"
    }, children), loadingManager), footer);
const $ba39e90ae3fa936c$var$HEADER_HEIGHT = 40;
const $ba39e90ae3fa936c$var$scrollContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'relative',
    flexFlow: 'column nowrap',
    overflow: 'auto',
    // Since header is sticky, we need to specify a scroll padding that matches its height so that auto-scrolling
    // functionality accounts for this element in its calculations, otherwise header can overlap the selected row.
    scrollPaddingTop: `${$ba39e90ae3fa936c$var$HEADER_HEIGHT}px`
});
const $ba39e90ae3fa936c$var$loadingIndicatorContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexFlow: 'column nowrap',
    position: 'relative',
    overflow: 'hidden'
});

});
parcelRegister("aVTEC", function(module, exports) {
$parcel$export(module.exports, "useHorizontalScrollDirectionChangeAnalytics", () => $066f2008dcdea2eb$export$7f82c6c9c621dfa1);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");
const $066f2008dcdea2eb$export$7f82c6c9c621dfa1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const lastScrollLeft = (0, $eJOHy.useRef)(0);
    const lastDirection = (0, $eJOHy.useRef)(null);
    let isStickyColumnsEnabled = false;
    let isStickyColumnsVisible = false;
    if ((0, $4cTDP.fg)('issue_table_frozen_columns')) {
        // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
        isStickyColumnsEnabled = (0, $34oCh.useIsStickyColumnsEnabled)();
        // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
        isStickyColumnsVisible = (0, $34oCh.useIsStickyColumnsVisible)();
    }
    return (0, $eJOHy.useCallback)((target)=>{
        const currentScrollLeft = target.scrollLeft;
        let direction = null;
        if (currentScrollLeft > lastScrollLeft.current) direction = 'right';
        else if (currentScrollLeft < lastScrollLeft.current) direction = 'left';
        // Only fire event if direction changed and it's not the first scroll
        if (direction && lastDirection.current && direction !== lastDirection.current) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'issueView horizontalScrollChanged', {
            actionSubjectId: 'issueView',
            direction: direction,
            isStickyColumnsEnabled: isStickyColumnsEnabled,
            isStickyColumnsVisible: isStickyColumnsVisible
        });
        if (direction) lastDirection.current = direction;
        lastScrollLeft.current = currentScrollLeft;
    }, [
        createAnalyticsEvent,
        isStickyColumnsEnabled,
        isStickyColumnsVisible
    ]);
};

});

parcelRegister("7khpH", function(module, exports) {
$parcel$export(module.exports, "useInfiniteScrollHandler", () => $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d);

var $eJOHy = parcelRequire("eJOHy");

var $8jOO7 = parcelRequire("8jOO7");

var $5M8i8 = parcelRequire("5M8i8");
const $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $8jOO7.ROW_HEIGHT);
const $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $eJOHy.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $5M8i8.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $5M8i8.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $eJOHy.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("5M8i8", function(module, exports) {
$parcel$export(module.exports, "useThrottle", () => $47c0698a2db18423$export$8b7b9481d6186f21);

var $eJOHy = parcelRequire("eJOHy");
const $47c0698a2db18423$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $eJOHy.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $eJOHy.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $eJOHy.useRef)(undefined);
    const throttled = (0, $eJOHy.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("hGS9u", function(module, exports) {
$parcel$export(module.exports, "LoadingManager", () => $96783ac5fc2dbf3b$export$99cc795e99919eed);

var $eJOHy = parcelRequire("eJOHy");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $cxKOj = parcelRequire("cxKOj");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");

var $2HFPH = parcelRequire("2HFPH");

var $5ik33 = parcelRequire("5ik33");
const $96783ac5fc2dbf3b$var$getLoadingA11YMessage = ({ isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasFinishedLoadingNext: hasFinishedLoadingNext, hasFinishedLoadingPrevious: hasFinishedLoadingPrevious, isGrouping: isGrouping })=>{
    if (isGrouping) {
        if (isLoadingPrevious) return (0, $5ik33.default).loadStartA11YMessageTopWithGrouping;
        if (hasFinishedLoadingPrevious) return (0, $5ik33.default).loadEndA11YMessageTopWithGrouping;
        if (isLoadingNext) return (0, $5ik33.default).loadStartA11YMessageBottomWithGrouping;
        if (hasFinishedLoadingNext) return (0, $5ik33.default).loadEndA11YMessageBottomWithGrouping;
    }
    if (isLoadingPrevious) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadStartA11YMessageTopIssueTermRefresh : (0, $5ik33.default).loadStartA11YMessageTop;
    if (hasFinishedLoadingPrevious) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadEndA11YMessageTopIssueTermRefresh : (0, $5ik33.default).loadEndA11YMessageTop;
    if (isLoadingNext) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $5ik33.default).loadStartA11YMessageBottom;
    if (hasFinishedLoadingNext) return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ik33.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $5ik33.default).loadEndA11YMessageBottom;
    return undefined;
};
const $96783ac5fc2dbf3b$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, isGrouping: isGrouping, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Table has height 0 during first render due to virtualization. Some checks need to wait for the table to have a height.
    const hasTableHeight = (0, $kbYhH.useElementSizeSelector)((tableState)=>Boolean(tableState.height));
    const scrollElement = (0, $7n9BS.useScrollElement)();
    const height = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasTableHeight && !isLoadingPrevious && !isLoadingNext && height) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onLoadingThresholdCheck(scrollElement);
    }, [
        hasTableHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement,
        height
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $6d9QY.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $eJOHy.useRef)(0);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $6d9QY.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $eJOHy.useRef)(undefined);
    loadingCompleteLiveMessage.current = $96783ac5fc2dbf3b$var$getLoadingA11YMessage({
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasFinishedLoadingNext: hasFinishedLoadingNext,
        hasFinishedLoadingPrevious: hasFinishedLoadingPrevious,
        isGrouping: isGrouping
    });
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2HFPH.LoadingIndicator), {
        position: "top",
        isGrouping: isGrouping
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2HFPH.LoadingIndicator), {
        position: "bottom",
        isGrouping: isGrouping
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("2HFPH", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $b6040ad16371eb3a$export$7c20be4c1d342248);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");

var $etVWf = parcelRequire("etVWf");
const $b6040ad16371eb3a$export$7c20be4c1d342248 = ({ position: position, isGrouping: isGrouping })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getLoadingMessage = ()=>{
        if (isGrouping) return (0, $etVWf.default).loadingMessageWithGrouping;
        return (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $etVWf.default).loadingMessageIssueTermRefresh : (0, $etVWf.default).loadingMessage;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "center",
        xcss: [
            (0, $4cTDP.fg)('issue_table_frozen_columns') ? $b6040ad16371eb3a$var$containerStyles : $b6040ad16371eb3a$var$containerOldStyles,
            position === 'top' ? $b6040ad16371eb3a$var$positionTopStyles : $b6040ad16371eb3a$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $b6040ad16371eb3a$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $4cTDP.fg)('add_nin_press_interactions') ? 'issue-table-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.inverse"
    }, formatMessage(getLoadingMessage()))));
};
// Account for the sticky header row height
const $b6040ad16371eb3a$var$HEADER_HEIGHT = 40;
// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
const $b6040ad16371eb3a$var$positionTopStyles = (0, $1DXK0.xcss)({
    top: `${$b6040ad16371eb3a$var$HEADER_HEIGHT}px`
});
// eslint-disable-next-line @atlaskit/design-system/no-physical-properties
const $b6040ad16371eb3a$var$positionBottomStyles = (0, $1DXK0.xcss)({
    bottom: 'space.0'
});
const $b6040ad16371eb3a$var$loadingIndicatorStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $b6040ad16371eb3a$var$containerOldStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%'
});
const $b6040ad16371eb3a$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%',
    // TODO update this value to 7 when migrating styles to compiled
    // using 7 here because CHART_PREVIEW_BAR_Z_INDEX has a z-index of
    zIndex: 'card'
});

});
parcelRegister("etVWf", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa7af19b14864c77$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fa7af19b14864c77$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more"
    },
    loadingMessageWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.loading-indicator.loading-message-with-grouping",
        "defaultMessage": "Loading more groups"
    }
});
var $fa7af19b14864c77$export$2e2bcd8739ae039 = $fa7af19b14864c77$var$messages;

});


parcelRegister("5ik33", function(module, exports) {
$parcel$export(module.exports, "default", () => $42222096832b96bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $42222096832b96bf$var$messages = (0, $7qGN1.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the table."
    },
    loadEndA11YMessageTop: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the table."
    },
    loadStartA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the table."
    },
    loadEndA11YMessageBottom: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the table."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the table."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the table."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the table."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the table."
    },
    loadStartA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-top-with-grouping",
        "defaultMessage": "Loading more groups at the top of the table."
    },
    loadEndA11YMessageTopWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-top-with-grouping",
        "defaultMessage": "Finished loading more groups at the top of the table."
    },
    loadStartA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-start-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Loading more groups at the bottom of the table."
    },
    loadEndA11YMessageBottomWithGrouping: {
        "id": "native-issue-table.scroll-container.loading-manager.load-end-a-11-y-message-bottom-with-grouping",
        "defaultMessage": "Finished loading more groups at the bottom of the table."
    }
});
var $42222096832b96bf$export$2e2bcd8739ae039 = $42222096832b96bf$var$messages;

});



parcelRegister("eiAn5", function(module, exports) {
$parcel$export(module.exports, "MainContainer", () => $14f0d3bdd18b09ef$export$d653589df987fd93);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $14f0d3bdd18b09ef$export$d653589df987fd93 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14f0d3bdd18b09ef$var$StyledMainContainer, props, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14f0d3bdd18b09ef$var$StyledMainContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { tableBorderWidth: tableBorderWidth, tableBorderRadius: tableBorderRadius, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rg2d25": (0, $awdRS.default)(__cmplp.tableBorderWidth)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx21bp4 _1n261q9c _1reo15vq _18m915vq _1h6dmuej _1dqonqa1 _189e1ht6 _1e0c1txw _kqswpfqs",
            __cmplp.tableBorderRadius ?? "_2rko1mok",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bUOjV", function(module, exports) {
$parcel$export(module.exports, "IssueTableSelectedIssuesProvider", () => $7234e6cdb0c3bc3b$export$8560e956e1937d5);

var $eJOHy = parcelRequire("eJOHy");

var $3TtKq = parcelRequire("3TtKq");
const $7234e6cdb0c3bc3b$export$8560e956e1937d5 = (Component)=>{
    const SelectedIssuesWrapperComponent = (props)=>{
        if (props.enableMultiSelect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3TtKq.IssueTableSelectedIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
    };
    return SelectedIssuesWrapperComponent;
};

});

parcelRegister("cyJHb", function(module, exports) {
$parcel$export(module.exports, "CopyPasteContainer", () => $3d37cc73a680e8e4$export$f22393f54af5c587);

var $eJOHy = parcelRequire("eJOHy");

var $kjtxW = parcelRequire("kjtxW");

var $34oCh = parcelRequire("34oCh");
const $3d37cc73a680e8e4$export$f22393f54af5c587 = ({ children: children })=>{
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isInlineEditingExtendedFieldSupportEnabled = (0, $34oCh.useIsInlineEditingExtendedFieldSupportEnabled)();
    return isInlineEditingEnabled && isInlineEditingExtendedFieldSupportEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kjtxW.CopyPasteContextProvider), null, children) : children;
};

});

parcelRegister("1GzaA", function(module, exports) {
$parcel$export(module.exports, "ConnectionsSubscriberContainer", () => $1dfdcf001ed824dc$export$dca2df00a75a6b37);

var $eJOHy = parcelRequire("eJOHy");

var $dLXgn = parcelRequire("dLXgn");

var $57Nys = parcelRequire("57Nys");
const $1dfdcf001ed824dc$export$dca2df00a75a6b37 = ({ ConnectionsSubscriber: ConnectionsSubscriber })=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const updateConnectionDetails = (0, $57Nys.useUpdateConnectionDetails)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConnectionsSubscriber, {
        connections: connections,
        updateConnectionDetails: updateConnectionDetails
    });
};

});

parcelRegister("5CeML", function(module, exports) {
$parcel$export(module.exports, "RootConnectionRegister", () => $681bba3551e30191$export$f2eeecab3dd535b2);

var $4FHEO = parcelRequire("4FHEO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dLXgn = parcelRequire("dLXgn");
const $681bba3551e30191$export$f2eeecab3dd535b2 = ({ issues: issues })=>{
    const issueConnection = (0, $j4oe4.useFragment)((0, $4FHEO.default), issues ?? null);
    const rootConnectionDetails = (0, $eJOHy.useMemo)(()=>{
        if (issueConnection && issueConnection.__id) return {
            type: 'ROOT_ISSUES',
            connectionId: issueConnection.__id,
            first: issueConnection?.edges?.length ?? 0
        };
        return undefined;
    }, [
        issueConnection
    ]);
    (0, $dLXgn.useRegisterConnection)(rootConnectionDetails);
    return null;
};

});
parcelRegister("4FHEO", function(module, exports) {
$parcel$export(module.exports, "default", () => $524602618bc87912$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec5d1429b6bc8aa29206c4a7f0299f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $524602618bc87912$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RootConnectionRegister",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$524602618bc87912$var$node.hash = "2b16ecb2b05570b21f8d4dc859600431";
var $524602618bc87912$export$2e2bcd8739ae039 = $524602618bc87912$var$node;

});


parcelRegister("1PY5i", function(module, exports) {
$parcel$export(module.exports, "IssueRealtimeUpdater", () => $ecbc742375e79e61$export$d456d8c8edd7984c);

var $kVjR2 = parcelRequire("kVjR2");

var $dKEMx = parcelRequire("dKEMx");

var $gGMnO = parcelRequire("gGMnO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eruNJ = parcelRequire("eruNJ");

var $dnCkQ = parcelRequire("dnCkQ");

var $8U0rJ = parcelRequire("8U0rJ");
const $ecbc742375e79e61$export$d456d8c8edd7984c = ({ project: project, issues: issues, groups: groups, isHierarchyEnabled: isHierarchyEnabled, isStatusTrackingEnabled: isStatusTrackingEnabled, onRefetch: onRefetchProp })=>{
    const realtimeUpdatesForIssues = (0, $8U0rJ.useRealtimeUpdatesForIssues)();
    const onRefetch = (0, $8U0rJ.useRealtimeUpdateOnRefresh)(onRefetchProp);
    const issueConnection = (0, $j4oe4.useFragment)((0, $gGMnO.default), issues ?? null);
    const groupConnection = (0, $j4oe4.useFragment)((0, $dKEMx.default), groups ?? null);
    const { projectId: projectId, key: projectKey } = (0, $j4oe4.useFragment)((0, $kVjR2.default), project);
    const { issueDeleteUpdater: issueDeleteUpdater } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const onDelete = (0, $eJOHy.useCallback)((store, issueAri)=>{
        return issueDeleteUpdater({
            store: store,
            issueResourceId: issueAri,
            groupConnectionId: groupConnection?.__id,
            projectKey: projectKey
        });
    }, [
        groupConnection?.__id,
        projectKey,
        issueDeleteUpdater
    ]);
    const onIssuesCreatedUpdated = (0, $eJOHy.useCallback)((issuesCreatedUpdated)=>{
        realtimeUpdatesForIssues({
            issues: issuesCreatedUpdated,
            isHierarchyEnabled: isHierarchyEnabled ?? false,
            jql: issueConnection?.jql || groupConnection?.jql || '',
            groupByFieldId: groupConnection?.groupByField || undefined,
            groupConnectionId: groupConnection?.__id,
            numGroupsLoaded: groupConnection?.edges?.length ?? 0,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled ?? false
        });
    }, [
        realtimeUpdatesForIssues,
        isHierarchyEnabled,
        issueConnection?.jql,
        groupConnection?.jql,
        groupConnection?.groupByField,
        groupConnection?.__id,
        groupConnection?.edges?.length,
        projectKey,
        isStatusTrackingEnabled
    ]);
    const projectIds = (0, $eJOHy.useMemo)(()=>[
            projectId
        ], [
        projectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eruNJ.IssueRealtimeUpdates), {
        projectIds: projectIds,
        onIssuesCreatedUpdated: onIssuesCreatedUpdated,
        onDelete: onDelete,
        onRefetch: onRefetch
    });
};

});
parcelRegister("kVjR2", function(module, exports) {
$parcel$export(module.exports, "default", () => $305cbae02ef7bf11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9be28c345f906c80c49959c9ee530754>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $305cbae02ef7bf11$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueRealtimeUpdater_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$305cbae02ef7bf11$var$node.hash = "a5539e715af10148bab39eda849e59a5";
var $305cbae02ef7bf11$export$2e2bcd8739ae039 = $305cbae02ef7bf11$var$node;

});

parcelRegister("dKEMx", function(module, exports) {
$parcel$export(module.exports, "default", () => $55c991eaea90b35a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8c99835fbb7a7a86f36fab01de2f9e84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55c991eaea90b35a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueRealtimeUpdater_spreadsheetGroupConnection",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "groupByField"
        },
        {
            "concreteType": "JiraSpreadsheetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$55c991eaea90b35a$var$node.hash = "f4c9f9679d436f8fef9fddc4aaf7fa66";
var $55c991eaea90b35a$export$2e2bcd8739ae039 = $55c991eaea90b35a$var$node;

});

parcelRegister("gGMnO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1a7e4e938a40141$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3ad345667cc1a204b05076252805c01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1a7e4e938a40141$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueRealtimeUpdater",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$c1a7e4e938a40141$var$node.hash = "0dd12505590cf3a645eeeccd268004c4";
var $c1a7e4e938a40141$export$2e2bcd8739ae039 = $c1a7e4e938a40141$var$node;

});

parcelRegister("eruNJ", function(module, exports) {
$parcel$export(module.exports, "IssueRealtimeUpdates", () => $ee613b2478cf200b$export$14b03bca5fb897a7);

var $lrcDM = parcelRequire("lrcDM");

var $8wOwu = parcelRequire("8wOwu");

var $iwKe5 = parcelRequire("iwKe5");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cHtIB = parcelRequire("cHtIB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8oKDI = parcelRequire("8oKDI");


var $CxwzV = parcelRequire("CxwzV");
const $ee613b2478cf200b$var$REAL_TIME_EVENT_TYPE_KEY = 'realTimeEventType';
const $ee613b2478cf200b$var$CREATE_ERROR_ID = 'realTimeIssueCreate';
const $ee613b2478cf200b$var$UPDATE_ERROR_ID = 'realTimeIssueUpdate';
const $ee613b2478cf200b$var$DELETE_ERROR_ID = 'realTimeIssueDelete';
const $ee613b2478cf200b$var$issueCreatedSubscription = (0, $iwKe5.default);
const $ee613b2478cf200b$var$issueUpdatedSubscription = (0, $8wOwu.default);
const $ee613b2478cf200b$var$issueDeletedSubscription = (0, $lrcDM.default);
const $ee613b2478cf200b$export$14b03bca5fb897a7 = ({ projectIds: projectIds, onIssuesCreatedUpdated: onIssuesCreatedUpdated, onDelete: onDelete, onRefetch: onRefetch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const throttledFireTrackAnalytics = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((0, $kRgKj.fireTrackAnalytics), 1000), []);
    const hasExceededMaxQueueSizeRef = (0, $eJOHy.useRef)(false);
    const showRealtimeUpdateExceededMaxFlag = (0, $CxwzV.useRealtimeUpdateExceededMaxFlag)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const variables = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectIds: projectIds
        }), [
        cloudId,
        projectIds
    ]);
    const queueRef = (0, $eJOHy.useRef)(new Map());
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const processQueue = (0, $eJOHy.useCallback)(()=>{
        if (queueRef.current.size === 0 || hasExceededMaxQueueSizeRef.current) return;
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'realTimeEventQueueProcessing started', {
            queueSize: queueRef.current.size
        });
        if (queueRef.current.size > (0, $b567b8b0cf775133$export$d3ea91bf4184016b)) {
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'realTimeEventsExceededMaxFlag shown', {
                queueSize: queueRef.current.size
            });
            hasExceededMaxQueueSizeRef.current = true;
            showRealtimeUpdateExceededMaxFlag({
                onRefresh: ()=>{
                    (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'realTimeEventsExceededMaxRefresh clicked');
                    hasExceededMaxQueueSizeRef.current = false;
                    queueRef.current = new Map();
                    onRefetch?.();
                }
            });
        } else onIssuesCreatedUpdated(Array.from(queueRef.current.values()));
        queueRef.current = new Map();
    }, [
        createAnalyticsEvent,
        showRealtimeUpdateExceededMaxFlag,
        onRefetch,
        onIssuesCreatedUpdated
    ]);
    const triggerDelayedProcessingOfQueue = (0, $eJOHy.useCallback)(()=>{
        // Existing timeout exists, so we don't need to create a new one
        if (timeoutRef.current) return;
        timeoutRef.current = setTimeout(()=>{
            processQueue();
            timeoutRef.current = null;
        }, (0, $b567b8b0cf775133$export$2c7ede6e55079caa));
    }, [
        processQueue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleCreateOrUpdateEvent = (0, $eJOHy.useCallback)((issueAri, issueId)=>{
        queueRef.current.set(issueAri, {
            issueAri: issueAri,
            issueId: issueId
        });
        triggerDelayedProcessingOfQueue();
    }, [
        triggerDelayedProcessingOfQueue
    ]);
    const handleCreateOrUpdateEventRef = (0, $eJOHy.useRef)(handleCreateOrUpdateEvent);
    if (handleCreateOrUpdateEventRef.current !== handleCreateOrUpdateEvent) handleCreateOrUpdateEventRef.current = handleCreateOrUpdateEvent;
    const createConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $ee613b2478cf200b$var$issueCreatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueCreatedByProjectsNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $ee613b2478cf200b$var$CREATE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $ee613b2478cf200b$var$CREATE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const updateConfig = (0, $eJOHy.useMemo)(()=>({
            variables: variables,
            subscription: $ee613b2478cf200b$var$issueUpdatedSubscription,
            onNext: async (response)=>{
                try {
                    const resourceId = response?.jira?.onIssueUpdatedByProjectsNoEnrichment?.resource;
                    if (resourceId && (0, $8oKDI.isAri)(resourceId)) handleCreateOrUpdateEventRef.current(resourceId, (0, $8oKDI.getAriConfig)(resourceId).resourceId);
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $ee613b2478cf200b$var$UPDATE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'onNext'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $ee613b2478cf200b$var$UPDATE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }), [
        variables
    ]);
    const onDeleteRef = (0, $eJOHy.useRef)(onDelete);
    if (onDeleteRef.current !== onDelete) onDeleteRef.current = onDelete;
    const deleteConfig = (0, $eJOHy.useMemo)(()=>{
        return {
            variables: variables,
            subscription: $ee613b2478cf200b$var$issueDeletedSubscription,
            updater: (store, response)=>{
                try {
                    if (response?.jira?.onIssueDeletedByProjectsNoEnrichment?.resource) {
                        const wasDeleted = onDeleteRef.current(store, response.jira.onIssueDeletedByProjectsNoEnrichment.resource);
                        wasDeleted && throttledFireTrackAnalytics(createAnalyticsEvent({}), 'realTimeEvent processed', {
                            [$ee613b2478cf200b$var$REAL_TIME_EVENT_TYPE_KEY]: 'delete'
                        });
                    }
                } catch (error) {
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: $ee613b2478cf200b$var$DELETE_ERROR_ID,
                            packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                            teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                        },
                        attributes: {
                            logLocation: 'updater'
                        },
                        error: error instanceof Error ? error : undefined,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError: (error)=>{
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: $ee613b2478cf200b$var$DELETE_ERROR_ID,
                        packageName: (0, $b567b8b0cf775133$export$b8b9d90f9e5bd72b),
                        teamName: (0, $b567b8b0cf775133$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        logLocation: 'onError'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }, [
        variables,
        createAnalyticsEvent,
        throttledFireTrackAnalytics
    ]);
    (0, $j4oe4.useSubscription)(createConfig);
    (0, $j4oe4.useSubscription)(updateConfig);
    (0, $j4oe4.useSubscription)(deleteConfig);
    return null;
};

});
parcelRegister("lrcDM", function(module, exports) {
$parcel$export(module.exports, "default", () => $241a6f47c87d5291$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9df70edaddea023fb75b680d1bd93e19>>
 * @relayHash c43476813693f586ef9f76e460fc0950
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 395efed32643d87420942d85e2ce2f4be85783ffdcf9511e200d754b49abb420
const $241a6f47c87d5291$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueDeletedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueDeletedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueRealtimeUpdates_issueDeletedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueRealtimeUpdates_issueDeletedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "395efed32643d87420942d85e2ce2f4be85783ffdcf9511e200d754b49abb420",
            "metadata": {},
            "name": "IssueRealtimeUpdates_issueDeletedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$241a6f47c87d5291$var$node.hash = "fa81f223fcea7547f6cc63c2d4607b6c";
var $241a6f47c87d5291$export$2e2bcd8739ae039 = $241a6f47c87d5291$var$node;

});

parcelRegister("8wOwu", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ca1eb2308210230$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9ef6afdadb31a5d8937ac70bb682f8d0>>
 * @relayHash 8c9084e93a5e559b96f2efb00da0cb4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01ed243a7e68d2de39a092502b0706ce640250e648161d3c80d535b0a8b8b012
const $3ca1eb2308210230$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueUpdatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueUpdatedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueRealtimeUpdates_issueUpdatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueRealtimeUpdates_issueUpdatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "01ed243a7e68d2de39a092502b0706ce640250e648161d3c80d535b0a8b8b012",
            "metadata": {},
            "name": "IssueRealtimeUpdates_issueUpdatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$3ca1eb2308210230$var$node.hash = "a0472302cd79ec86834d4c2547eb2127";
var $3ca1eb2308210230$export$2e2bcd8739ae039 = $3ca1eb2308210230$var$node;

});

parcelRegister("iwKe5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3eebcd9c1d217121$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd7b8d06d7b9f5d8a1ffd6f2e0292f57>>
 * @relayHash 9986605f713d931aa38dd02c77c28489
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ff11c087e2ea9f108d0c49fc4d8a6b2d7e53e9799f8446434ce6963ebf9fdaf
const $3eebcd9c1d217121$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraIssueCreatedStreamHubPayload",
                    "kind": "LinkedField",
                    "name": "onIssueCreatedByProjectsNoEnrichment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IssueRealtimeUpdates_issueCreatedSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IssueRealtimeUpdates_issueCreatedSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6ff11c087e2ea9f108d0c49fc4d8a6b2d7e53e9799f8446434ce6963ebf9fdaf",
            "metadata": {},
            "name": "IssueRealtimeUpdates_issueCreatedSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$3eebcd9c1d217121$var$node.hash = "d3ea308909ff91b6b90f93ecf0f41c6e";
var $3eebcd9c1d217121$export$2e2bcd8739ae039 = $3eebcd9c1d217121$var$node;

});

const $b567b8b0cf775133$export$b8b9d90f9e5bd72b = 'jiraIssueRealtimeUpdates';
const $b567b8b0cf775133$export$d57b6b390e78d90f = 'jira-yurree';
const $b567b8b0cf775133$export$d3ea91bf4184016b = 100;
const $b567b8b0cf775133$export$2c7ede6e55079caa = 3000;

parcelRegister("CxwzV", function(module, exports) {
$parcel$export(module.exports, "useRealtimeUpdateExceededMaxFlag", () => $998a3d12bee9ba4c$export$b8dd0666e1c54372);

var $eJOHy = parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $cSXp8 = parcelRequire("cSXp8");

var $8N38Y = parcelRequire("8N38Y");
const $998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID = 'jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-flag';
const $998a3d12bee9ba4c$export$b8dd0666e1c54372 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    return (0, $eJOHy.useCallback)(({ onRefresh: onRefresh })=>{
        if (!hasFlag?.($998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID)) showFlag({
            type: 'info',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-information, #1D7AFC)"
            }),
            title: (0, $8N38Y.default).realtimeUpdateExceededMaxHeader,
            description: (0, $8N38Y.default).realtimeUpdateExceededMaxDescription,
            messageId: $998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            id: $998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID,
            messageType: 'transactional',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $8N38Y.default).realtimeUpdateExceededMaxRefreshButton,
                    onClick: ()=>{
                        dismissFlag($998a3d12bee9ba4c$var$REALTIME_UPDATE_EXCEEDED_MAX_FLAG_ID);
                        onRefresh();
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        hasFlag,
        showFlag
    ]);
};

});
parcelRegister("8N38Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea8de0a5e97e5e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bea8de0a5e97e5e4$var$messages = (0, $7qGN1.defineMessages)({
    realtimeUpdateExceededMaxHeader: {
        "id": "jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-header",
        "defaultMessage": "Updating those work items"
    },
    realtimeUpdateExceededMaxDescription: {
        "id": "jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-description",
        "defaultMessage": "Refresh the page to see the updates"
    },
    realtimeUpdateExceededMaxRefreshButton: {
        "id": "jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-refresh-button",
        "defaultMessage": "Refresh"
    }
});
var $bea8de0a5e97e5e4$export$2e2bcd8739ae039 = $bea8de0a5e97e5e4$var$messages;

});



parcelRegister("8U0rJ", function(module, exports) {
$parcel$export(module.exports, "useRealtimeUpdatesForIssues", () => $71c3c0a590161895$export$9688da58398f9e26);
$parcel$export(module.exports, "useRealtimeUpdateOnRefresh", () => $71c3c0a590161895$export$dd28753b70cf6515);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");

var $dLXgn = parcelRequire("dLXgn");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $34oCh = parcelRequire("34oCh");

var $5NEjg = parcelRequire("5NEjg");

var $dnCkQ = parcelRequire("dnCkQ");

var $fes1G = parcelRequire("fes1G");

var $lEvni = parcelRequire("lEvni");
const $71c3c0a590161895$export$cb618b52025e9ed0 = ({ connections: connections, isGroupingEnabled: isGroupingEnabled, groupedByFieldId: groupedByFieldId })=>{
    const expandedParents = [];
    const groups = [];
    let topLevelItemsLoaded = 0;
    Object.values(connections).forEach((connection)=>{
        if (connection.type === 'PARENT_CHILDREN') expandedParents.push({
            parentIssueId: connection.parentId,
            first: connection.first
        });
        else if (connection.type === 'GROUP_CHILDREN') groups.push({
            jql: connection.jql,
            fieldValue: connection.fieldValue,
            first: connection.first
        });
        else if (connection.type === 'ROOT_ISSUES') topLevelItemsLoaded = connection.first;
    });
    if (isGroupingEnabled && groupedByFieldId) return {
        expandedGroups: {
            groupedByFieldId: groupedByFieldId,
            groups: groups
        }
    };
    return {
        expandedParents: expandedParents,
        topLevelItemsLoaded: topLevelItemsLoaded
    };
};
const $71c3c0a590161895$export$9688da58398f9e26 = ()=>{
    const environment = (0, $7zZ4w.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { fieldSetIds: fieldSetIds } = (0, $5NEjg.useIssueFetchQueryVariables)();
    const isDensityFull = (0, $34oCh.useIsDensityFull)();
    const isInlineEditingEnabled = (0, $34oCh.useIsInlineEditingEnabled)();
    const isHideDoneItemsEnabled = (0, $34oCh.useIsHideDoneItemsEnabled)();
    const isTimelineEnabled = (0, $34oCh.useIsTimelineEnabled)();
    const isLinkRelationshipFieldEnabled = (0, $34oCh.useIsRelationshipFieldEnabled)();
    const isEditableSyncLoaded = (0, $34oCh.useIsEditableSyncLoaded)();
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const getGroupsForIssues = (0, $lEvni.useGetGroupsForIssues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getRealtimeIssueDetails = (0, $fes1G.useGetRealtimeIssueDetails)();
    const { updateIssuesOnConnection: updateIssuesOnConnection, groupsForIssueUpdater: groupsForIssueUpdater, updateNewParentsOnConnection: updateNewParentsOnConnection } = (0, $dnCkQ.useIssueRealtimeUpdater)();
    const isConditionalFormattingEnabled = (0, $4cTDP.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $34oCh.useIsConditionalFormattingEnabled)();
    return (0, $eJOHy.useCallback)(async ({ issues: issues, jql: jql, groupByFieldId: groupByFieldId, numGroupsLoaded: numGroupsLoaded, groupConnectionId: groupConnectionId, isHierarchyEnabled: isHierarchyEnabled, projectKey: projectKey, isStatusTrackingEnabled: isStatusTrackingEnabled })=>{
        const isGroupingEnabled = !!groupByFieldId;
        const searchViewContextInput = $71c3c0a590161895$export$cb618b52025e9ed0({
            connections: connections,
            isGroupingEnabled: isGroupingEnabled,
            groupedByFieldId: groupByFieldId
        });
        const { issues: updatedIssues, searchViewContexts: searchViewContexts } = await getRealtimeIssueDetails({
            issues: issues,
            cloudId: cloudId,
            fieldSetIds: fieldSetIds,
            isInlineEditingEnabled: isInlineEditingEnabled,
            isDensityFull: isDensityFull,
            isHierarchyEnabled: isHierarchyEnabled,
            isGroupingEnabled: isGroupingEnabled,
            isHideDoneItemsEnabled: isHideDoneItemsEnabled,
            issueSearchInput: {
                jql: jql
            },
            searchViewContextInput: searchViewContextInput,
            projectKey: projectKey,
            isStatusTrackingEnabled: isStatusTrackingEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isTimelineEnabled: isTimelineEnabled,
            isLinkRelationshipFieldEnabled: isLinkRelationshipFieldEnabled,
            isEditableSyncLoaded: isEditableSyncLoaded
        });
        let groupsToInsert;
        const shouldQueryGroupsForIssues = isGroupingEnabled && !!groupByFieldId;
        if (shouldQueryGroupsForIssues) {
            const issueKeysWithContext = new Set(searchViewContexts?.flatMap((connection)=>{
                return connection.contexts?.map((context)=>context?.sourceIssueId);
            }).filter(Boolean));
            const issueChangesWithoutContext = (0, $4cTDP.fg)('group_by_any_field') ? updatedIssues?.map((issue)=>({
                    issueId: issue.issueId
                })) : updatedIssues?.reduce((acc, issue)=>{
                if (issue && !issueKeysWithContext.has(issue.issueId ?? '')) acc.push({
                    issueId: issue.issueId
                });
                return acc;
            }, []);
            groupsToInsert = await getGroupsForIssues({
                issueChanges: issueChangesWithoutContext,
                fieldId: groupByFieldId,
                numGroupsLoaded: numGroupsLoaded,
                issueSearchInput: {
                    jql: jql
                },
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: isGroupingEnabled,
                    isHideDoneEnabled: isHideDoneItemsEnabled
                }
            });
        }
        const eventDetails = {
            issuesUnmoved: new Set(),
            issuesUnrelated: new Set(),
            issuesUpdated: new Set()
        };
        const updatedIssuesMap = new Map(updatedIssues?.map(({ issueId: issueId, issueRecordId: issueRecordId, fieldSetsRecordId: fieldSetsRecordId })=>[
                issueId,
                {
                    issueId: issueId,
                    issueRecordId: issueRecordId,
                    fieldSetsRecordId: fieldSetsRecordId
                }
            ]));
        const updatedParents = new Set(updatedIssues.map((issue)=>issue.parentIssueRecordId).filter(Boolean));
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            Object.values(connections).forEach((connection)=>{
                updateNewParentsOnConnection({
                    store: store,
                    connection: connection,
                    updatedParents: updatedParents,
                    projectKey: projectKey
                });
                const matchingContext = searchViewContexts?.find((context)=>{
                    if (connection.type === 'PARENT_CHILDREN') return context?.parentIssueId === connection.parentId;
                    if (connection.type === 'GROUP_CHILDREN') return context?.jql === connection.jql;
                    return context?.jql == null && context?.parentIssueId == null;
                });
                const updatedDetails = updateIssuesOnConnection({
                    store: store,
                    connection: connection,
                    searchViewContexts: matchingContext?.contexts ?? [],
                    updatedIssues: updatedIssuesMap,
                    groupConnectionId: groupConnectionId,
                    projectKey: projectKey,
                    hasAccurateGroupCounts: (0, $4cTDP.fg)('group_by_any_field') ? connection.type === 'GROUP_CHILDREN' && groupsToInsert?.some((group)=>group.id === connection.groupId) : undefined
                });
                updatedDetails.issuesMoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
                updatedDetails.issuesUnmoved.forEach(eventDetails.issuesUnmoved.add, eventDetails.issuesUnmoved);
                updatedDetails.issuesUnrelated.forEach(eventDetails.issuesUnrelated.add, eventDetails.issuesUnrelated);
                updatedDetails.issuesRemoved.forEach(eventDetails.issuesUpdated.add, eventDetails.issuesUpdated);
            });
            if (groupsToInsert && groupsToInsert.length > 0) groupsForIssueUpdater({
                store: store,
                groupConnectionId: groupConnectionId,
                groupsForIssue: groupsToInsert
            });
        });
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueTableRealTimeEventsIssueDetails Processed', {
            issuesInSamePosition: eventDetails.issuesUnmoved.size,
            issuesInNewPosition: eventDetails.issuesUpdated.size,
            issuesNotImpactingList: Array.from(eventDetails.issuesUnrelated).reduce((acc, issueId)=>eventDetails.issuesUpdated.has(issueId) || eventDetails.issuesUnmoved.has(issueId) ? acc : acc + 1, 0)
        });
    }, [
        connections,
        getRealtimeIssueDetails,
        cloudId,
        fieldSetIds,
        isInlineEditingEnabled,
        isDensityFull,
        isHideDoneItemsEnabled,
        environment,
        createAnalyticsEvent,
        getGroupsForIssues,
        updateNewParentsOnConnection,
        updateIssuesOnConnection,
        groupsForIssueUpdater,
        isConditionalFormattingEnabled,
        isTimelineEnabled,
        isLinkRelationshipFieldEnabled,
        isEditableSyncLoaded
    ]);
};
const $71c3c0a590161895$export$dd28753b70cf6515 = (onRefresh)=>{
    const { connections: connections } = (0, $dLXgn.useConnectionsList)();
    const environment = (0, $7zZ4w.default)();
    return (0, $eJOHy.useCallback)(()=>{
        // This will reload all expanded parents/groups
        environment.commitUpdate((store)=>{
            Object.values(connections).forEach((connection)=>{
                const connectionToInvalidate = store.get(connection.connectionId);
                if (connectionToInvalidate) connectionToInvalidate.invalidateRecord();
            });
        });
        onRefresh?.();
    }, [
        connections,
        environment,
        onRefresh
    ]);
};

});


parcelRegister("jyos0", function(module, exports) {
$parcel$export(module.exports, "FlatListUpdateHandler", () => $c5d3771d2cf8f18c$export$a86357b97b9cc5c5);

var $eJOHy = parcelRequire("eJOHy");

var $jE8Tu = parcelRequire("jE8Tu");

var $cxKOj = parcelRequire("cxKOj");
const $c5d3771d2cf8f18c$var$EMPTY_ARRAY = [];
const $c5d3771d2cf8f18c$export$a86357b97b9cc5c5 = ({ onIssueFlatListUpdated: onIssueFlatListUpdated })=>{
    const flatList = (0, $jE8Tu.useFlatList)();
    const flatListIssueKeys = (0, $jE8Tu.useFlatListIssueKeys)();
    const flatListIssueIds = (0, $jE8Tu.useIssueIds)();
    const flatListChildIssueIds = (0, $cxKOj.expVal)('bulk_ops_select_all_beyond_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jE8Tu.useChildIssueIds)() : $c5d3771d2cf8f18c$var$EMPTY_ARRAY;
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onIssueFlatListUpdated?.(flatListIssueKeys.filter(Boolean), flatListIssueIds, flatListChildIssueIds);
    }, [
        flatList,
        flatListIssueIds,
        flatListIssueKeys,
        onIssueFlatListUpdated,
        flatListChildIssueIds
    ]);
    return null;
};

});


parcelRegister("kNAZ7", function(module, exports) {
$parcel$export(module.exports, "useColumnLoader", () => $a3cf718ab100d836$export$6dc2ac601f90aafc);

var $eN3Th = parcelRequire("eN3Th");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $d8Dow = parcelRequire("d8Dow");

var $4cTDP = parcelRequire("4cTDP");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");
const $a3cf718ab100d836$var$mapColumnPickerOptions = (data)=>{
    const fieldSets = data?.jira?.fieldSetViewQueryByProject?.fieldSets;
    // Error
    if (!fieldSets) return {
        options: [],
        totalCount: 0
    };
    const options = fieldSets?.edges?.map((edge)=>({
            optionType: 'option',
            cursor: edge?.cursor,
            value: edge?.node?.fieldSetId || '',
            label: edge?.node?.displayName || '',
            ...(0, $4cTDP.fg)('jira_inline_field_config_gate') && {
                type: edge?.node?.type || ''
            }
        })) || [];
    return {
        options: options,
        totalCount: fieldSets?.totalCount || null,
        endCursor: fieldSets?.pageInfo.endCursor || undefined
    };
};
const $a3cf718ab100d836$var$fetchColumnOptions = async ({ issueKey: issueKey, cloudId: cloudId, search: search, endCursor: endCursor })=>{
    const environment = (0, $7zZ4w.default)();
    const cursor = endCursor;
    try {
        const data = await (0, $j4oe4.fetchQuery)(environment, (0, $eN3Th.default), {
            cloudId: cloudId,
            first: 25,
            after: cursor,
            issueKey: issueKey,
            filter: {
                searchString: search,
                fieldSetSelectedState: 'ALL'
            }
        }).toPromise();
        return $a3cf718ab100d836$var$mapColumnPickerOptions(data);
    } catch (error) {
        const optionsResponse = {
            options: [
                {
                    optionType: 'error',
                    error: new Error(`Error fetching field set view: ${error}`),
                    onRetry: ()=>undefined
                }
            ],
            totalCount: 0
        };
        return optionsResponse;
    }
};
const $a3cf718ab100d836$export$6dc2ac601f90aafc = ({ issueKey: issueKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const loadOptionsCallback = (0, $eJOHy.useCallback)(async (search, enableFullList, endCursor)=>{
        return $a3cf718ab100d836$var$fetchColumnOptions({
            issueKey: issueKey,
            cloudId: cloudId,
            search: search,
            enableFullList: enableFullList,
            endCursor: endCursor
        });
    }, [
        cloudId,
        issueKey
    ]);
    return (0, $d8Dow.createDebouncedColumnLoader)(loadOptionsCallback);
};

});
parcelRegister("eN3Th", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b14d67a7632c0a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2a44a9173a88026640dbd0769e67e4f>>
 * @relayHash 9256fa5b0ec219beb35ba6a309cb6c3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6088baad78d018a6b6a01de8d3faac993a85cc7964a34f4f381724df595e8e64
const $4b14d67a7632c0a1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "after",
                        "variableName": "after"
                    },
                    {
                        "kind": "Variable",
                        "name": "filter",
                        "variableName": "filter"
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    v7 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "type"
                                    },
                                    {
                                        "concreteType": "JiraFieldType",
                                        "kind": "LinkedField",
                                        "name": "fieldType",
                                        "plural": false,
                                        "selections": [
                                            v7 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraFieldSetView"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useColumnLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "fieldSetViewQueryByProject",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useColumnLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "fieldSetViewQueryByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6088baad78d018a6b6a01de8d3faac993a85cc7964a34f4f381724df595e8e64",
            "metadata": {},
            "name": "useColumnLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4b14d67a7632c0a1$var$node.hash = "f6649e11b515173540fc95e306fa3718";
var $4b14d67a7632c0a1$export$2e2bcd8739ae039 = $4b14d67a7632c0a1$var$node;

});


parcelRegister("6o2hR", function(module, exports) {
$parcel$export(module.exports, "useColumnResize", () => $fe46b0f47b57002d$export$739cb4ab803317ca);

var $c0zFq = parcelRequire("c0zFq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cHtIB = parcelRequire("cHtIB");

var $cSXp8 = parcelRequire("cSXp8");

var $4cTDP = parcelRequire("4cTDP");

var $bmoS1 = parcelRequire("bmoS1");

var $5l078 = parcelRequire("5l078");

var $iJ4Pk = parcelRequire("iJ4Pk");
const $fe46b0f47b57002d$export$739cb4ab803317ca = ({ fieldSetsId: fieldSetsId, onCompleted: onCompleted })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [updateFieldSetPreferences, isInFlight] = (0, $j4oe4.useMutation)((0, $c0zFq.default));
    const updateColumnWidth = (0, $5l078.useColumnWidthUpdater)(fieldSetsId);
    /**
   * onColumnResize is invoked when users resize columns on the table. For optimistic updates the
   * optimisticUpdater gets called and we see the expected change then mutation happens,
   * optimisticUpdater gets reverted as a result of mutation then updater gets called to persist the optimistic update view.
   */ const onColumnResize = (0, $eJOHy.useCallback)((columnId, width)=>{
        const context = {
            issueContext: {
                issueKey: issueKey
            }
        };
        const input = {
            fieldSetId: columnId,
            width: width ?? null
        };
        updateFieldSetPreferences({
            variables: {
                cloudId: cloudId,
                namespace: 'CHILD_ISSUE_PANEL',
                input: {
                    nodes: [
                        input
                    ]
                },
                context: context
            },
            optimisticUpdater (store) {
                updateColumnWidth(store, columnId, width);
            },
            updater (store) {
                updateColumnWidth(store, columnId, width);
            },
            onCompleted (data) {
                const success = data.jira?.updateUserFieldSetPreferences?.success === true;
                (0, $4cTDP.fg)('issue-jiv-20390-column-picker-disappearing-fix') && onCompleted?.(success, input);
                if (!success) {
                    showFlag((0, $iJ4Pk.onChildIssueResizeErrorFlag));
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'commitUpdateIssueViewFieldSetPreferencesMutationUnsuccessful',
                            packageName: 'jiraIssueViewCommonViews',
                            teamName: 'bento'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                showFlag((0, $iJ4Pk.onChildIssueResizeErrorFlag));
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'commitUpdateIssueViewFieldSetPreferencesMutationError',
                        packageName: 'jiraIssueViewCommonViews',
                        teamName: 'bento'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        cloudId,
        issueKey,
        onCompleted,
        showFlag,
        updateColumnWidth,
        updateFieldSetPreferences
    ]);
    return [
        onColumnResize,
        isInFlight
    ];
};

});
parcelRegister("c0zFq", function(module, exports) {
$parcel$export(module.exports, "default", () => $12c94ee21f406eff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9928f591864877c273141de92ddaa1a4>>
 * @relayHash 3b8737cdba63e71ae2d8fab24a11ce0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d009907cb1c5004323b0c4dbcd71ab2ffde3ac679fb5d8a5b290eb6a6342cca1
const $12c94ee21f406eff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v4 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        },
                        {
                            "kind": "Variable",
                            "name": "namespace",
                            "variableName": "namespace"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useColumnResize_updateIssueViewFieldSetPreferencesMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useColumnResize_updateIssueViewFieldSetPreferencesMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "d009907cb1c5004323b0c4dbcd71ab2ffde3ac679fb5d8a5b290eb6a6342cca1",
            "metadata": {},
            "name": "useColumnResize_updateIssueViewFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$12c94ee21f406eff$var$node.hash = "8becd8b07d916c92d44530797f55182f";
var $12c94ee21f406eff$export$2e2bcd8739ae039 = $12c94ee21f406eff$var$node;

});

parcelRegister("5l078", function(module, exports) {
$parcel$export(module.exports, "useColumnWidthUpdater", () => $a4a7f9e4321c575c$export$e54397ae25183faf);

var $eJOHy = parcelRequire("eJOHy");
const $a4a7f9e4321c575c$export$e54397ae25183faf = (connectionId)=>{
    return (0, $eJOHy.useCallback)((store, columnId, width)=>{
        const connection = store.get(connectionId);
        const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
        const fieldSetEdge = fieldSetEdges.find((edge)=>{
            const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
            return columnId === fieldSetId;
        });
        if (!fieldSetEdge) return;
        const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
        if (!fieldSetNode) return;
        if (width == null) {
            fieldSetNode.setValue(null, 'fieldSetPreferences');
            return;
        }
        const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
        fieldSetPreferences.setValue(width, 'width');
    }, [
        connectionId
    ]);
};

});

parcelRegister("iJ4Pk", function(module, exports) {
$parcel$export(module.exports, "onColumnsChangeErrorFlag", () => $066ff9e5e747ce74$export$e87bc2c94ad8aa3d);
$parcel$export(module.exports, "onChildIssueResizeErrorFlag", () => $066ff9e5e747ce74$export$6272f90d592217eb);

var $eRJQL = parcelRequire("eRJQL");
const $066ff9e5e747ce74$export$e87bc2c94ad8aa3d = {
    type: 'error',
    title: (0, $eRJQL.default).configureColumnsErrorTitle,
    description: (0, $eRJQL.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-view-child-issues-panel.common.flags.on-columns-change-error-flag.error',
    messageType: 'transactional'
};
const $066ff9e5e747ce74$export$6272f90d592217eb = {
    type: 'error',
    title: (0, $eRJQL.default).columnResizeMutationErrorTitle,
    description: (0, $eRJQL.default).columnResizeMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-view-child-issues-panel.common.flags.on-child-issue-resize-error-flag.error',
    messageType: 'transactional'
};

});
parcelRegister("eRJQL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec335e5b834e5c2f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ec335e5b834e5c2f$var$messages = (0, $7qGN1.defineMessages)({
    configureColumnsErrorTitle: {
        "id": "issue-view-child-issues-panel.common.flags.configure-columns-error-title",
        "defaultMessage": "We couldn't configure the columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-view-child-issues-panel.common.flags.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    },
    columnResizeMutationErrorTitle: {
        "id": "issue-view-child-issues-panel.common.flags.column-resize-mutation-error-title",
        "defaultMessage": "We couldn't resize the column"
    },
    columnResizeMutationErrorDescription: {
        "id": "issue-view-child-issues-panel.common.flags.column-resize-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    },
    reorderErrorTitle: {
        "id": "issue-view-child-issues-panel.common.flags.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "issue-view-child-issues-panel.common.flags.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    reorderErrorTitleIssueTermRefresh: {
        "id": "issue-view-child-issues-panel.common.flags.reorder-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't reorder those work items"
    }
});
var $ec335e5b834e5c2f$export$2e2bcd8739ae039 = $ec335e5b834e5c2f$var$messages;

});



parcelRegister("3sRyW", function(module, exports) {
$parcel$export(module.exports, "useColumnsChange", () => $5538d8a3c34b5c5b$export$12e5d1104e906517);

var $86Odv = parcelRequire("86Odv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $8jOO7 = parcelRequire("8jOO7");

var $bmoS1 = parcelRequire("bmoS1");

var $iJ4Pk = parcelRequire("iJ4Pk");

var $f5PuN = parcelRequire("f5PuN");
const $5538d8a3c34b5c5b$export$12e5d1104e906517 = ({ fieldSetViewId: fieldSetViewId, fieldSetsConnectionId: fieldSetsConnectionId, onCompleted: onCompleted, onError: onError })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [replaceListViewFieldSets, isInFlight] = (0, $j4oe4.useMutation)((0, $86Odv.default));
    /**
   * When the the mutation is unsuccessful then return an error flag and fire off error analytics
   * otherwise modify the columns with the new fieldset
   */ const replaceIssueSearchViewFieldSetOnComplete = (0, $eJOHy.useCallback)((changeType, success, columnIds)=>{
        onCompleted?.(changeType, success, columnIds);
        if (!success) {
            showFlag((0, $iJ4Pk.onColumnsChangeErrorFlag));
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'commitReplaceJiraIssueCommonViewsFieldSetsMutationUnsuccessful',
                    packageName: 'jiraIssueViewCommonViews',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        onCompleted,
        showFlag
    ]);
    /**
   * When the the mutation is unsuccessful then return an error flag and fire off error analytics
   */ const replaceIssueSearchViewFieldSetOnError = (0, $eJOHy.useCallback)((error)=>{
        onError?.(error);
        showFlag((0, $iJ4Pk.onColumnsChangeErrorFlag));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'commitReplaceJiraIssueCommonViewsSetsMutationError',
                packageName: 'jiraIssueViewCommonViews',
                teamName: 'bento'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onError,
        showFlag
    ]);
    const updateColumns = (0, $f5PuN.useColumnsUpdater)(fieldSetsConnectionId);
    /**
   * onColumnsChange is invoked when there is a change in the list of visible columns.
   * For optimistic updates the optimisticUpdater gets called
   * and we see the expected change then mutation happens, optimisticUpdater gets
   * reverted as a result of mutation then updater gets called to persist the optimistic update view.
   */ const onColumnsChange = (0, $eJOHy.useCallback)((columnIds, changeType, optimisticFieldSets)=>{
        const context = {
            issueContext: {
                issueKey: issueKey
            }
        };
        replaceListViewFieldSets({
            variables: {
                // the id passed into the hook is a dummy id
                // so we need to hand craft our own ID for now
                id: fieldSetViewId || '',
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                includeView: changeType === (0, $8jOO7.REORDER_COLUMNS),
                fieldSetsInput: {
                    replaceFieldSetsInput: {
                        nodes: columnIds,
                        context: context
                    }
                }
            },
            optimisticUpdater (store) {
                updateColumns(store, changeType, optimisticFieldSets);
            },
            updater (store) {
                updateColumns(store, changeType, optimisticFieldSets);
            },
            onCompleted (columnData) {
                replaceIssueSearchViewFieldSetOnComplete(changeType, columnData.jira?.updateFieldSetsView?.success, columnIds);
            },
            onError (error) {
                replaceIssueSearchViewFieldSetOnError(error);
            }
        });
    }, [
        issueKey,
        replaceIssueSearchViewFieldSetOnComplete,
        replaceIssueSearchViewFieldSetOnError,
        replaceListViewFieldSets,
        updateColumns,
        fieldSetViewId
    ]);
    return [
        onColumnsChange,
        isInFlight
    ];
};

});
parcelRegister("86Odv", function(module, exports) {
$parcel$export(module.exports, "default", () => $668511e2de96501f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0be3dd67db1a4db9e1881932d2833699>>
 * @relayHash 51e088666fc4b50e17138a591472e5ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d34c2a20c363123725ac7bfeea53df49d4651338d4bf1433d0a086990751801b

var $2Z4v6 = parcelRequire("2Z4v6");

var $8Qoc7 = parcelRequire("8Qoc7");
const $668511e2de96501f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "success"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useColumnsChangeMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraFieldSetsViewPayload",
                            "kind": "LinkedField",
                            "name": "updateFieldSetsView",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "amountOfColumns",
                                                            "variableName": "amountOfColumns"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useColumnsChangeMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraFieldSetsViewPayload",
                            "kind": "LinkedField",
                            "name": "updateFieldSetsView",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": {
                                                                        "fieldSetSelectedState": "SELECTED"
                                                                    }
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "first",
                                                                    "variableName": "amountOfColumns"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldSetId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "type"
                                                                                },
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "jqlTerm"
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "aliases"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isSortable"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSetPreferences",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "width"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsMetadata",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "canBeConfigured"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isPlaceHolderField"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraFieldType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v8 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraFieldSetView"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d34c2a20c363123725ac7bfeea53df49d4651338d4bf1433d0a086990751801b",
            "metadata": {},
            "name": "useColumnsChangeMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$668511e2de96501f$var$node.hash = "23b7e8d0614dabcbd35090d188ce875b";
var $668511e2de96501f$export$2e2bcd8739ae039 = $668511e2de96501f$var$node;

});

parcelRegister("f5PuN", function(module, exports) {
$parcel$export(module.exports, "useColumnsUpdater", () => $5b3fa0cf2f48547d$export$2add11f4107660eb);

var $eJOHy = parcelRequire("eJOHy");

var $8jOO7 = parcelRequire("8jOO7");
const $5b3fa0cf2f48547d$export$2add11f4107660eb = (connectionId)=>{
    return (0, $eJOHy.useCallback)((store, changeType, optimisticFieldSets)=>{
        if (changeType !== (0, $8jOO7.REORDER_COLUMNS) || !optimisticFieldSets) return;
        const fieldSetsConnection = store.get(connectionId);
        if (!fieldSetsConnection) return;
        let edges = fieldSetsConnection.getLinkedRecords('edges');
        if (!edges) return;
        const findIndexOfOptimisticEdge = (edge)=>{
            if (!edge) return -1;
            return optimisticFieldSets.edges.findIndex((optimisticEdge)=>optimisticEdge.node.fieldSetId === edge?.getLinkedRecord('node')?.getValue('fieldSetId'));
        };
        const totalCount = fieldSetsConnection.getValue('totalCount');
        if (totalCount !== optimisticFieldSets.totalCount) fieldSetsConnection.setValue(optimisticFieldSets.totalCount, 'totalCount');
        // if columns were removed, remove the edges
        if (optimisticFieldSets.edges.length < edges.length) edges = edges?.filter((edge)=>findIndexOfOptimisticEdge(edge) !== -1);
        // then sort edges
        edges.sort((a, b)=>findIndexOfOptimisticEdge(a) - findIndexOfOptimisticEdge(b));
        fieldSetsConnection.setLinkedRecords(edges, 'edges');
    }, [
        connectionId
    ]);
};

});


parcelRegister("4j9Ge", function(module, exports) {
$parcel$export(module.exports, "useColumnReset", () => $759a0fe64604eac9$export$9b29e8ddb652217);

var $3tqNT = parcelRequire("3tqNT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $iJ4Pk = parcelRequire("iJ4Pk");
const $759a0fe64604eac9$export$9b29e8ddb652217 = ({ fieldSetViewId: fieldSetViewId, onSuccess: onSuccess, onError: onError })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [replaceListViewFieldSets] = (0, $j4oe4.useMutation)((0, $3tqNT.default));
    /**
   * When the the mutation is unsuccessful then return an error flag and fire off error analytics
   * otherwise modify the columns with the new fieldset
   */ const replaceIssueSearchViewFieldSetOnComplete = (0, $eJOHy.useCallback)((success)=>{
        onSuccess?.(success);
        if (!success) {
            showFlag((0, $iJ4Pk.onColumnsChangeErrorFlag));
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'commitReplaceJiraIssueCommonViewsFieldSetsMutationUnsuccessful',
                    packageName: 'jiraIssueViewCommonViews',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        onSuccess,
        showFlag
    ]);
    /**
   * When the the mutation is unsuccessful then return an error flag and fire off error analytics
   */ const replaceIssueSearchViewFieldSetOnError = (0, $eJOHy.useCallback)((error)=>{
        onError?.(error);
        showFlag((0, $iJ4Pk.onColumnsChangeErrorFlag));
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'commitReplaceJiraIssueCommonViewsSetsMutationError',
                packageName: 'jiraIssueViewCommonViews',
                teamName: 'bento'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onError,
        showFlag
    ]);
    /**
   * onColumnsChange is invoked when there is a change in the list of visible columns.
   * For optimistic updates the optimisticUpdater gets called
   * and we see the expected change then mutation happens, optimisticUpdater gets
   * reverted as a result of mutation then updater gets called to persist the optimistic update view.
   */ const onColumnsReset = (0, $eJOHy.useCallback)(()=>{
        replaceListViewFieldSets({
            variables: {
                id: fieldSetViewId || '',
                fieldSetsInput: {
                    resetToDefaultFieldSets: true
                }
            },
            onCompleted (columnData) {
                replaceIssueSearchViewFieldSetOnComplete(columnData.jira?.updateFieldSetsView?.success);
            },
            onError (error) {
                replaceIssueSearchViewFieldSetOnError(error);
            }
        });
    }, [
        replaceIssueSearchViewFieldSetOnComplete,
        replaceIssueSearchViewFieldSetOnError,
        replaceListViewFieldSets,
        fieldSetViewId
    ]);
    return onColumnsReset;
};

});
parcelRegister("3tqNT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a665fbf77fc6c693$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67438166c1ea80979332370dcd121ccd>>
 * @relayHash 6fb550e4917f3d83053710ef8061a8d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c9c6383770c3a29ea72db2a6e03f9418b0a424999bd5a3b88f28941cf53dadf
const $a665fbf77fc6c693$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useColumnResetMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraFieldSetsViewPayload",
                            "kind": "LinkedField",
                            "name": "updateFieldSetsView",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useColumnResetMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraFieldSetsViewPayload",
                            "kind": "LinkedField",
                            "name": "updateFieldSetsView",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c9c6383770c3a29ea72db2a6e03f9418b0a424999bd5a3b88f28941cf53dadf",
            "metadata": {},
            "name": "useColumnResetMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a665fbf77fc6c693$var$node.hash = "827cdf8b9668f442c7bcb19508ad0e31";
var $a665fbf77fc6c693$export$2e2bcd8739ae039 = $a665fbf77fc6c693$var$node;

});


parcelRegister("iYP2H", function(module, exports) {
$parcel$export(module.exports, "useIssuesRanker", () => $27adef7dbd13a781$export$40f5e450e8552c78);

var $bDrub = parcelRequire("bDrub");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $isfFo = parcelRequire("isfFo");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $eRJQL = parcelRequire("eRJQL");
const $27adef7dbd13a781$var$getRankMutationEdge = (edge)=>{
    switch(edge){
        case 'top':
            return 'TOP';
        case 'bottom':
            return 'BOTTOM';
        default:
            // Unsupported edge
            return null;
    }
};
const $27adef7dbd13a781$export$40f5e450e8552c78 = (issueConnectionId)=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [rankIssuesMutation] = (0, $j4oe4.useMutation)((0, $bDrub.default));
    const showErrorFlag = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eRJQL.default).reorderErrorTitleIssueTermRefresh : (0, $eRJQL.default).reorderErrorTitle,
            description: (0, $eRJQL.default).reorderErrorDescription,
            isAutoDismiss: true,
            messageId: 'issue-view-child-issues-panel.services.use-issues-ranker.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const reorderIssuesUpdater = (0, $eJOHy.useCallback)((store, startIndex, finishIndex)=>{
        const issueConnection = store.get(issueConnectionId);
        if (!issueConnection) return;
        const edges = issueConnection.getLinkedRecords('edges');
        if (!edges) return;
        const reorderedEdges = (0, $isfFo.reorder)({
            list: edges,
            startIndex: startIndex,
            finishIndex: finishIndex
        });
        issueConnection.setLinkedRecords(reorderedEdges, 'edges');
    }, [
        issueConnectionId
    ]);
    const rankIssues = (0, $eJOHy.useCallback)((payload)=>{
        const { source: source, destination: destination, edge: edge } = payload;
        const rankMutationEdge = $27adef7dbd13a781$var$getRankMutationEdge(edge);
        if (rankMutationEdge == null) {
            showErrorFlag();
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'commitRankIssuesError',
                    packageName: 'jiraIssueViewCommonViews',
                    teamName: 'bento'
                },
                error: new Error(`Edge "${edge}" is unsupported in JiraMutation.rankIssues`),
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        rankIssuesMutation({
            variables: {
                rankInput: {
                    issues: source.issueIds,
                    relativeToIssue: destination.relativeToIssueId,
                    edge: rankMutationEdge
                }
            },
            optimisticUpdater (store) {
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            updater (store, data) {
                // Rollback update if mutation fails
                if (!data?.jira?.rankIssues?.success) return;
                reorderIssuesUpdater(store, source.rowIndex, destination.rowIndex);
            },
            onCompleted (data) {
                if (!data.jira?.rankIssues?.success) {
                    showErrorFlag();
                    (0, $9pTd3.fireErrorAnalytics)({
                        meta: {
                            id: 'commitRankIssuesMutationUnsuccessful',
                            packageName: 'jiraIssueViewCommonViews',
                            teamName: 'bento'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                showErrorFlag();
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'commitRankIssuesMutationError',
                        packageName: 'jiraIssueViewCommonViews',
                        teamName: 'bento'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        rankIssuesMutation,
        reorderIssuesUpdater,
        showErrorFlag
    ]);
    return rankIssues;
};

});
parcelRegister("bDrub", function(module, exports) {
$parcel$export(module.exports, "default", () => $0251445e2932ab9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a61abcff0584cd4fd11bee6aaca12e55>>
 * @relayHash 8a45d7e99df7abd28743c297cb4e2ab5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2097d0cdf7382dc3ff14d6f4221cca6679714319f9242ed09793fe4a20c8e5c
const $0251445e2932ab9d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rankInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "rankInput",
                            "variableName": "rankInput"
                        }
                    ],
                    "concreteType": "JiraRankMutationPayload",
                    "kind": "LinkedField",
                    "name": "rankIssues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIssuesRanker_rankIssuesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIssuesRanker_rankIssuesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f2097d0cdf7382dc3ff14d6f4221cca6679714319f9242ed09793fe4a20c8e5c",
            "metadata": {},
            "name": "useIssuesRanker_rankIssuesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0251445e2932ab9d$var$node.hash = "807e857adafd2bfe0c31d05b225fd312";
var $0251445e2932ab9d$export$2e2bcd8739ae039 = $0251445e2932ab9d$var$node;

});


parcelRegister("20xMJ", function(module, exports) {
$parcel$export(module.exports, "ColumnPicker", () => $e14ba1120ef53dc9$export$582d36594507a709);

var $8dVvO = parcelRequire("8dVvO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iiRWr = parcelRequire("iiRWr");

var $4cTDP = parcelRequire("4cTDP");

var $PETi0 = parcelRequire("PETi0");

var $88wTt = parcelRequire("88wTt");

var $8jOO7 = parcelRequire("8jOO7");
const $e14ba1120ef53dc9$export$582d36594507a709 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, columnPickerRef)=>{
    const { columns: columns, isLoading: isLoading = false, isMergedColumnEnabled: isMergedColumnEnabled, onColumnsChange: onColumnsChange, onRestoreDefaultColumns: onRestoreDefaultColumns, useColumnLoaderProp: useColumnLoaderProp } = props;
    const [, { close: close }] = (0, $PETi0.useColumnPickerOpenState)();
    (0, $eJOHy.useImperativeHandle)(columnPickerRef, ()=>({
            close: close
        }), [
        close
    ]);
    const columnsData = (0, $j4oe4.useFragment)((0, $8dVvO.default), columns);
    // on cleanup of fg('jira_inline_field_config_gate'), param type should just be { columnIds: string[] }
    const onColumnPickerChange = (0, $eJOHy.useCallback)((columnIds)=>{
        if (onColumnsChange && columnIds != null && 'columnIds' in columnIds && (0, $4cTDP.fg)('jira_inline_field_config_gate')) onColumnsChange(columnIds.columnIds, (0, $8jOO7.MODIFY_COLUMNS));
        else if (onColumnsChange && columnIds && Array.isArray(columnIds)) onColumnsChange(columnIds, (0, $8jOO7.MODIFY_COLUMNS));
    }, [
        onColumnsChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88wTt.default), {
        columns: columnsData,
        components: (0, $4cTDP.fg)('slv-117-nin-column-picker-style-updates') ? undefined : {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iiRWr)))
        },
        isLoading: isLoading,
        onChange: onColumnPickerChange,
        onRestoreDefaultColumns: onRestoreDefaultColumns,
        useColumnLoader: useColumnLoaderProp,
        isMergedColumnEnabled: isMergedColumnEnabled && (0, $4cTDP.fg)('jira_list_merged_column_gate')
    });
});

});
parcelRegister("8dVvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $43709b4f3633367b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7957fd83beac4fdc66a6be0ddaf171a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43709b4f3633367b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "columnPicker_issueViewChildIssuesPanel",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ColumnConfigWithContainer"
        }
    ],
    "type": "JiraIssueSearchFieldSetConnection"
};
$43709b4f3633367b$var$node.hash = "5c5a84aea3906448b229d6db61207ff4";
var $43709b4f3633367b$export$2e2bcd8739ae039 = $43709b4f3633367b$var$node;

});


parcelRegister("9huH6", function(module, exports) {
$parcel$export(module.exports, "useRefetchWithoutSuspend", () => $db69d5e0e0b0eefe$export$9629967e4b6b1249);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");
const $db69d5e0e0b0eefe$export$9629967e4b6b1249 = ({ defaultVariables: defaultVariables, refetch: refetch, query: query, onError: onError })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const refetchWithoutSuspending = (0, $eJOHy.useCallback)((overrideVariables)=>{
        setIsLoading(true);
        let disposable = {
            dispose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
        const combinedVariables = {
            ...defaultVariables,
            ...overrideVariables
        };
        (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), query, combinedVariables).subscribe({
            complete: ()=>{
                setIsLoading(false);
                disposable = refetch(combinedVariables, {
                    fetchPolicy: 'store-only'
                });
            },
            error: (e)=>{
                onError?.(e);
                setIsLoading(false);
            }
        });
        return disposable;
    }, [
        defaultVariables,
        query,
        refetch,
        onError
    ]);
    return {
        isLoading: isLoading,
        refetchWithoutSuspending: refetchWithoutSuspending
    };
};

});

parcelRegister("1ekG6", function(module, exports) {
$parcel$export(module.exports, "useEventHandlers", () => $5453651007c12084$export$8ce912bc34d0dbea);

var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $4X4Xr = parcelRequire("4X4Xr");

var $dyOHn = parcelRequire("dyOHn");

var $hbF3h = parcelRequire("hbF3h");

var $4cTDP = parcelRequire("4cTDP");

var $4U53A = parcelRequire("4U53A");
const $5453651007c12084$var$useEventHandlersOriginal = (currentIssueKey)=>{
    const onIssueKeyChanged = (0, $bmoS1.useOnIssueKeyChange)();
    const onIssueLinkSelected = (0, $eJOHy.useCallback)((issueKey)=>{
        onIssueKeyChanged && onIssueKeyChanged({
            fromIssueKey: currentIssueKey,
            toIssueKey: issueKey
        });
        return !!onIssueKeyChanged;
    }, [
        currentIssueKey,
        onIssueKeyChanged
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueLinkSelected
    ]);
};
const $5453651007c12084$var$useEventHandlersWithOnUpdateCache = (currentIssueKey)=>{
    const onIssueKeyChanged = (0, $bmoS1.useOnIssueKeyChange)();
    const onChange = (0, $dyOHn.useSelector)((0, $4U53A.getOnChangeCallback));
    const onIssueLinkSelected = (0, $eJOHy.useCallback)((issueKey)=>{
        onIssueKeyChanged && onIssueKeyChanged({
            fromIssueKey: currentIssueKey,
            toIssueKey: issueKey
        });
        return !!onIssueKeyChanged;
    }, [
        currentIssueKey,
        onIssueKeyChanged
    ]);
    const onUpdateCache = (0, $eJOHy.useCallback)((issueKey, fieldName)=>{
        if (fieldName === 'status' && onChange) onChange({
            type: (0, $4X4Xr.CHANGE_EVENT_TYPES).CHILD_ISSUE_STATUS_UPDATED,
            meta: {}
        });
    }, [
        onChange
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onIssueLinkSelected: onIssueLinkSelected,
            onUpdateCache: onUpdateCache
        }), [
        onIssueLinkSelected,
        onUpdateCache
    ]);
};
const $5453651007c12084$export$8ce912bc34d0dbea = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('relay_migration_children_issues_section'), $5453651007c12084$var$useEventHandlersWithOnUpdateCache, $5453651007c12084$var$useEventHandlersOriginal);

});

parcelRegister("fdPuf", function(module, exports) {
$parcel$export(module.exports, "useTableColumnSortConfigsFromLS", () => $c08c81b605774c5e$export$2b5c96835a39def6);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");
const $c08c81b605774c5e$var$COLUMN_SORT_CONFIGS_LS_KEY = 'COLUMN_SORT_CONFIG';
const $c08c81b605774c5e$export$2b5c96835a39def6 = (STORAGE_PREFIX)=>{
    const localStorageProvider = (0, $3hRxq.createLocalStorageProvider)(STORAGE_PREFIX);
    const setSortConfig = (0, $eJOHy.useCallback)((field, sortDirection)=>{
        localStorageProvider.remove($c08c81b605774c5e$var$COLUMN_SORT_CONFIGS_LS_KEY);
        // Don't set in LS if sorting is cleared
        if (sortDirection === 'NONE') return;
        localStorageProvider.set($c08c81b605774c5e$var$COLUMN_SORT_CONFIGS_LS_KEY, `${field}=${sortDirection}`);
    }, [
        localStorageProvider
    ]);
    const getSortConfig = (0, $eJOHy.useCallback)(()=>{
        const localStorageKey = localStorageProvider.get($c08c81b605774c5e$var$COLUMN_SORT_CONFIGS_LS_KEY);
        if (!localStorageKey) return {
            sortColumnFromLS: null,
            sortDirectionFromLS: null
        };
        const [sortColumn, sortDirection] = localStorageKey?.split('=');
        return {
            sortColumnFromLS: sortColumn,
            sortDirectionFromLS: sortDirection
        };
    }, [
        localStorageProvider
    ]);
    return {
        setSortConfig: setSortConfig,
        getSortConfig: getSortConfig
    };
};

});

const $c32bc4329b87a2e9$export$bea1131dd3bdbd86 = 'CHILD_WORK_ITEM_TABLE';



$parcel$global.rlb("jBlQT")
//# sourceMappingURL=async-configurable-child-issues-panel.c860ae4d.js.map
